// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"e9qDg":[function(require,module,exports,__globalThis) {
require("c137a149a0a6f332").register(require("d146b8c9555adf77").getBundleURL('9U9Lq'), JSON.parse("[\"9U9Lq\",\"index.eb157454.js\",\"h549a\",\"fp.esm.db03c7ac.js\",\"3JJRT\",\"dist.223ee95f.js\",\"3Fvrf\",\"404.e7c2e2d4.js\",\"7WJAg\",\"Account.e0efc311.js\",\"6xQSK\",\"Account.2339ee2c.css\",\"9U5o7\",\"AboutUs.9fabef32.js\",\"IlTi6\",\"AboutUs.05cf3855.js\",\"5RA2i\",\"HowToPlay.3bd0f62c.js\",\"8Q4iq\",\"Compliance.f4284ff7.js\",\"bBg8X\",\"FacebookDataDeletionStatus.2834c152.js\",\"1rmf8\",\"Contact.29d48f84.js\",\"evLCa\",\"Games.2244fa1f.js\",\"kLPVl\",\"homepage-signup-banner-bg.81be1f7c.png\",\"jdQxZ\",\"HomepageSections.f15a7eec.js\",\"cEEh7\",\"HomepageSections.1bd0e063.js\",\"bF1S6\",\"HomepageSections.1ac176cf.js\",\"bFWwa\",\"HomepageSections.6c7d4354.js\",\"50WiO\",\"HomepageSections.691019d6.js\",\"dwtZp\",\"Spinner.052fde0e.js\",\"zaTzk\",\"Games.105fcae2.js\",\"2Zxu2\",\"Layout.f5e6d7a9.js\",\"18aVi\",\"Footer.038b8830.js\",\"2yTRz\",\"Header.94754e25.js\",\"4xsNa\",\"QuickfireDrawer.0e461503.js\",\"6ekQ7\",\"SpinDrawer.0d8e21c2.js\",\"4cLhF\",\"BullionGameDetailModal.0e6bba02.js\",\"6uHCl\",\"LeagueBullionPicksModal.021c2e7a.js\",\"fjfdE\",\"BullionGameDetailModal.4c9652b6.js\",\"19Acq\",\"Layout.358bcf9b.js\",\"lQrcL\",\"Layout.684f7d3c.js\",\"1Fc9F\",\"Layout.6708e67e.js\",\"hRdS6\",\"Header.7c1636ac.js\",\"1nNNI\",\"es.c2d82647.js\",\"7zA45\",\"LeagueBullionPicksModal.d559703f.js\",\"dUnev\",\"Header.d8ce88f8.js\",\"hMhuS\",\"Header.c3d07c56.js\",\"hodz5\",\"Header.768a181f.js\",\"azET0\",\"LeagueSquaresOverSummaryModal.1e2d5d41.js\",\"2NikL\",\"Header.09403927.js\",\"799Tx\",\"LeagueTraderTradesSummaryModal.3abe979b.js\",\"2or5O\",\"SixesGameSummaryModal.25ce8243.js\",\"1Lhnr\",\"Header.970c0317.js\",\"iSndf\",\"Header.c65f6d6e.js\",\"6VRsE\",\"Header.ca1854c0.js\",\"F0jhH\",\"Charts.deb97adc.js\",\"ebHU4\",\"Manhattan.b133ee31.js\",\"eU6N4\",\"Manhattan.59617a22.js\",\"5IbyJ\",\"WinProbability.60588e61.js\",\"3lUnS\",\"Worm.7b4544be.js\",\"2eZaA\",\"Header.d5a2a9e2.js\",\"GmIEL\",\"Header.3360ab06.js\",\"didjk\",\"commentary.4d70a502.js\",\"hJI6q\",\"FirstVisitPlayGameCtaHost.9495f3fa.js\",\"3cFCC\",\"FirstVisitPlayGameModal.440d0ca3.js\",\"egz4d\",\"NewAccountGoogle.e4ff2950.js\",\"jEPgp\",\"NewAccountOtp.a8599b3e.js\",\"lNXf2\",\"Privacy.12a49ac2.js\",\"hMyWk\",\"Signup.3ced5656.js\",\"3IVII\",\"GoogleSignInButton.caaa1acf.js\",\"41t7U\",\"Terms.e3cfe0c2.js\",\"gfRQ5\",\"Sitemap.215e48fe.js\",\"fsBnZ\",\"Trader.8f3c41a7.js\",\"i3AZQ\",\"match-play.edc10033.js\",\"fdsB2\",\"Trader.02e34648.js\",\"2ztyD\",\"match-play.3a82ff98.js\",\"fXz9C\",\"match-play.7bd376a2.js\",\"cPYuC\",\"Horses.9ce1172f.js\",\"6GkiA\",\"Trader.78df7ab0.js\",\"4CpQf\",\"Tennis.dc685fac.js\",\"exNnS\",\"Trader.a9cffede.js\",\"4PGNR\",\"Tennis.33d3bce5.js\",\"4UE0S\",\"Football.048e5f00.js\",\"7y3t5\",\"Trader.4fee490a.js\",\"4ynOl\",\"Trader.809962c1.js\",\"cBSd4\",\"SettlementRules.fda62f4c.js\",\"pmXJl\",\"Squares.010ff666.js\",\"bjkIv\",\"Bullion.c68dfbe6.js\",\"3SMED\",\"BullionMatchLanding.b57f52ab.js\",\"i0tBM\",\"BullionLeaderboardAnimationDemoPage.6cc7d0d2.js\",\"4InIQ\",\"BullionDemoFlowPage.cc8137b1.js\",\"Hqz3K\",\"Sixes.9346e384.js\",\"KfX98\",\"ShopPaymentReturn.87a5f47b.js\",\"dMTnK\",\"ProfileRoute.e29647ea.js\",\"7dgdp\",\"ProfileEditRoute.28bd21ad.js\",\"27bOy\",\"MyZone.3413b38a.js\",\"fSNkU\",\"XpLeaderboardPage.c18e7ef4.js\",\"49DXe\",\"Matches.fbdbdc43.js\",\"1Yll4\",\"MatchDetailView.22cb930a.js\",\"faTDX\",\"Leagues.1cdb8082.js\",\"3QmJp\",\"Leagues.2f941fd3.js\",\"fl9uQ\",\"LeagueDetailRoute.fb208345.js\",\"h361M\",\"LeagueJoinRoute.eba6d521.js\",\"9nHCs\",\"LeagueResultsShareRoute.c75c4912.js\",\"cIYTI\",\"LeaguesDemoProvider.8c26194a.js\"]"));

},{"c137a149a0a6f332":"fyJL2","d146b8c9555adf77":"c7Tr5"}],"fyJL2":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"4zTVb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _app = require("./App");
var _useGamesEnabled = require("./hooks/useGamesEnabled");
var _deviceSignals = require("./utils/deviceSignals");
var _authHeaders = require("./utils/authHeaders");
var _overlayDismissGuard = require("./utils/overlayDismissGuard");
var _respectDeviceSilentSwitch = require("./utils/respectDeviceSilentSwitch");
// Restore the auth cookie mirror from durable localStorage before anything reads it.
// Privacy browsers (Firefox ETP, DuckDuckGo) purge first-party cookies; localStorage survives.
(0, _authHeaders.hydrateAuthStorage)();
(0, _respectDeviceSilentSwitch.respectDeviceSilentSwitch)();
(0, _overlayDismissGuard.installOverlayDismissGuard)();
(0, _deviceSignals.preloadDeviceFingerprint)();
(0, _useGamesEnabled.prefetchGamesEnabled)();
// Injected at runtime: a `<link rel="manifest">` in index.html would need Parcel's webmanifest transformer.
const manifestLink = document.createElement("link");
manifestLink.rel = "manifest";
manifestLink.href = "/site.webmanifest";
document.head.appendChild(manifestLink);
const app = document.getElementById("app");
const root = (0, _clientDefault.default).createRoot(app);
// Prefetch only above-the-fold chunks for "/" to avoid competing with main bundle and LCP image
require("29224726135a8d5c");
require("66bf3b99af3e6549");
require("b825b3a55018e6e4");
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _app.App), {}));

},{"react/jsx-runtime":"gaGEj","react-dom/client":"5ccwt","./App":"dXcTy","./hooks/useGamesEnabled":"ex0m1","./utils/deviceSignals":"e518A","./utils/authHeaders":"5Rczo","./utils/overlayDismissGuard":"dH7w8","./utils/respectDeviceSilentSwitch":"f0Qz7","29224726135a8d5c":"3WfaG","66bf3b99af3e6549":"1WxWM","b825b3a55018e6e4":"gJOPk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"6uln9":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"5ccwt":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"b8T3j"}],"b8T3j":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"dXcTy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "App", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _cookieConsentModal = require("./components/CookieConsentModal");
var _cookieScripts = require("./components/CookieScripts");
var _analyticsConsent = require("./utils/analyticsConsent");
var _leagueGamePlayUrl = require("./components/Leagues/lib/leagueGamePlayUrl");
var _leagueResultsShare = require("./components/Leagues/lib/leagueResultsShare");
var _leagueModeStore = require("./components/Leagues/lib/leagueModeStore");
var _traderDataFetcherContext = require("./Data/TraderDataFetcherContext");
var _decimalSocketContext = require("./Data/DecimalSocketContext");
var _userContext = require("./Data/UserContext");
var _authenticatedRoute = require("./components/AuthenticatedRoute");
var _authenticatedRouteDefault = parcelHelpers.interopDefault(_authenticatedRoute);
var _preferencesRedirect = require("./components/Account/PreferencesRedirect");
var _shopBtn = require("./components/Shop/ShopBtn");
var _shopBtnDefault = parcelHelpers.interopDefault(_shopBtn);
var _refund = require("./components/Support/Refund");
var _refundDefault = parcelHelpers.interopDefault(_refund);
var _refundPolicy = require("./components/Support/RefundPolicy");
var _refundPolicyDefault = parcelHelpers.interopDefault(_refundPolicy);
var _analyticsEnv = require("./utils/analyticsEnv");
var _authHeaders = require("./utils/authHeaders");
var _gtm = require("./utils/gtm");
var _gtmEvents = require("./utils/gtmEvents");
var _framerMotion = require("framer-motion");
var _authBackPath = require("./utils/authBackPath");
var _devEmailAccess = require("./utils/devEmailAccess");
var _welcomeBonus = require("./utils/welcomeBonus");
var _retryLazyImport = require("./utils/retryLazyImport");
var _useGamesEnabled = require("./hooks/useGamesEnabled");
var _usePlatformFeatureFlags = require("./hooks/usePlatformFeatureFlags");
var _appLoadingSkeleton = require("./components/AppLoadingSkeleton");
var _modalCloseIcon = require("./components/ModalCloseIcon");
var _matchesHubNavigation = require("./components/Matches/matchesHubNavigation");
var _adminDevProxyReload = require("./components/AdminDevProxyReload");
// Apply retry logic to all lazy-loaded components, especially critical ones like Games (homepage) and Layout
const NotFound = (0, _retryLazyImport.retryLazyImport)(()=>require("c248716081772307"));
const Account = (0, _retryLazyImport.retryLazyImport)(()=>require("1f779bd030b0b91b"));
const AboutUs = (0, _retryLazyImport.retryLazyImport)(()=>require("70d17096968b1ec"));
const HowToPlay = (0, _retryLazyImport.retryLazyImport)(()=>require("b29e616165d47828"));
const Compliance = (0, _retryLazyImport.retryLazyImport)(()=>require("e778903aa6fe1b8f"));
const FacebookDataDeletionStatus = (0, _retryLazyImport.retryLazyImport)(()=>require("59f2890674169295"));
const Contact = (0, _retryLazyImport.retryLazyImport)(()=>require("d6264e05cf9c2066"));
const Games = (0, _retryLazyImport.retryLazyImport)(()=>require("7153fb87303082f1"));
const Layout = (0, _retryLazyImport.retryLazyImport)(()=>require("657cfc8b22f1049d"));
const GoogleNewSignup = (0, _retryLazyImport.retryLazyImport)(()=>require("8cb831016915c223"));
const OtpNewSignup = (0, _retryLazyImport.retryLazyImport)(()=>require("bad137550fc13e9e"));
const Privacy = (0, _retryLazyImport.retryLazyImport)(()=>require("b242c3ed232cde94"));
const Signup = (0, _retryLazyImport.retryLazyImport)(()=>require("a1f813eed866a5cb"));
const Terms = (0, _retryLazyImport.retryLazyImport)(()=>require("175af6387fe4f43"));
const Sitemap = (0, _retryLazyImport.retryLazyImport)(()=>require("e93603a61518673"));
const Trader = (0, _retryLazyImport.retryLazyImport)(()=>require("c494f1a876b6f235"));
const SettlementRules = (0, _retryLazyImport.retryLazyImport)(()=>require("5bf2faac1f8d2008"));
const Squares = (0, _retryLazyImport.retryLazyImport)(()=>require("ce7db320a7b5d610"));
const Bullion = (0, _retryLazyImport.retryLazyImport)(()=>require("7fd765c5b2bdd977"));
const Sixes = (0, _retryLazyImport.retryLazyImport)(()=>require("6339e4288428c1c"));
const ShopPaymentReturn = (0, _retryLazyImport.retryLazyImport)(()=>require("feb37a9af2621e0b"));
const ProfileRoute = (0, _retryLazyImport.retryLazyImport)(()=>require("5567ed3ae18fa88c"));
const ProfileEditRoute = (0, _retryLazyImport.retryLazyImport)(()=>require("dcda43879c485cbb"));
const MyZonePage = (0, _retryLazyImport.retryLazyImport)(()=>require("5745fbbcba034da4"));
const XpLeaderboardPage = (0, _retryLazyImport.retryLazyImport)(()=>require("f0b854aca2ec7031"));
const Matches = (0, _retryLazyImport.retryLazyImport)(()=>require("9096de3b3d86da8a"));
const LeaguesHub = (0, _retryLazyImport.retryLazyImport)(()=>require("e9f06ec1c651a58b"));
const LeagueDetail = (0, _retryLazyImport.retryLazyImport)(()=>require("9b48ec9202fa635f"));
const LeagueJoin = (0, _retryLazyImport.retryLazyImport)(()=>require("60af4137c3e8e5df"));
const loadLeagueResultsShare = ()=>require("74bb34ba5fe45bbd");
const LeagueResultsShare = (0, _retryLazyImport.retryLazyImport)(loadLeagueResultsShare);
const LeaguesDemoProvider = (0, _retryLazyImport.retryLazyImport)(()=>require("b7453f6104718114"));
// Prefetch share chunk on hard-load `/leagues?r=` so Suspense resolves faster.
if (typeof window !== "undefined" && /(?:\?|&)r=/.test(window.location.search)) loadLeagueResultsShare();
const gtmId = "GTM-55Z82SD4";
const isShopEnabled = true;
/** League in-mode play deep-links must reach the game even when it is hidden from the main nav. */ function useLeaguePlayRouteAllowed() {
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    return Boolean(searchParams.get((0, _leagueGamePlayUrl.LEAGUE_ID_QUERY))?.trim() || (0, _leagueModeStore.peekActiveLeagueId)());
}
/**
 * The single `/leagues` (and `/leaguesdemo`) entry point. Surfaces live on
 * one single-segment path — dispatched by query param — so nginx's SPA fallback serves
 * hard loads/refresh without any per-route rewrite:
 *   - `?id=`   → league detail
 *   - `?code=` → join landing
 *   - `?r=`    → finished-league results share card
 *   - neither  → hub
 */ function LeaguesHubJoinOrDetail() {
    const { isLeaguesEnvEnabled, loading: flagsLoading } = (0, _usePlatformFeatureFlags.usePlatformFeatureFlags)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const search = searchParams.toString();
    // Public results shares: render immediately (don't wait on feature flags).
    if ((0, _leagueResultsShare.readLeagueResultsShareTokenFromSearch)(search)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeagueResultsShare, {});
    if (flagsLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appLoadingSkeleton.AppLoadingSkeleton), {});
    if (!isLeaguesEnvEnabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: "/",
        replace: true
    });
    if ((0, _leagueGamePlayUrl.readLeagueDetailIdFromSearch)(search)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeagueDetail, {});
    return (0, _leagueGamePlayUrl.readLeagueJoinCodeFromSearch)(search) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeagueJoin, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeaguesHub, {});
}
/** Old `/leagues/join/:code` → `/leagues?code=` (and demo equivalent). */ function LeagueJoinPathRedirect() {
    const { code } = (0, _reactRouterDom.useParams)();
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const basePath = pathname.startsWith((0, _leagueGamePlayUrl.LEAGUES_DEMO_PATH)) ? (0, _leagueGamePlayUrl.LEAGUES_DEMO_PATH) : "/leagues";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: (0, _leagueGamePlayUrl.leagueJoinPath)(code ?? "", basePath),
        replace: true
    });
}
/** Old `/leagues/:leagueId` → `/leagues?id=` (and demo equivalent) so already-shared links keep working. */ function LeagueDetailPathRedirect() {
    const { leagueId } = (0, _reactRouterDom.useParams)();
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const basePath = pathname.startsWith((0, _leagueGamePlayUrl.LEAGUES_DEMO_PATH)) ? (0, _leagueGamePlayUrl.LEAGUES_DEMO_PATH) : "/leagues";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: (0, _leagueGamePlayUrl.leagueDetailPath)(leagueId ?? "", basePath),
        replace: true
    });
}
function BullionRoute() {
    const { isBullionVisible, loading } = (0, _useGamesEnabled.useGamesEnabled)();
    const leaguePlay = useLeaguePlayRouteAllowed();
    if (!loading && !isBullionVisible && !leaguePlay) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Bullion, {});
}
function SixesRoute() {
    const { isSixesVisible, loading } = (0, _useGamesEnabled.useGamesEnabled)();
    const leaguePlay = useLeaguePlayRouteAllowed();
    if (!loading && !isSixesVisible && !leaguePlay) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Sixes, {});
}
function SquaresRoute() {
    const { isSquaresVisible, loading } = (0, _useGamesEnabled.useGamesEnabled)();
    const leaguePlay = useLeaguePlayRouteAllowed();
    if (!loading && !isSquaresVisible && !leaguePlay) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Squares, {});
}
function TraderRoute() {
    const { isTraderVisible, loading } = (0, _useGamesEnabled.useGamesEnabled)();
    const leaguePlay = useLeaguePlayRouteAllowed();
    if (!loading && !isTraderVisible && !leaguePlay) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Trader, {});
}
const EMAIL_LINK_PARAM = "bfe";
const LayoutWithConsent = /*#__PURE__*/ (0, _react.memo)(({ children })=>{
    const [hasAccepted, setHasAccepted] = (0, _react.useState)(()=>(0, _analyticsConsent.hasAnalyticsCookieConsent)());
    const [showConsentModal, setShowConsentModal] = (0, _react.useState)(()=>!(0, _analyticsConsent.hasCookieConsentDecision)());
    const [showEmailLinkBonusAlready, setShowEmailLinkBonusAlready] = (0, _react.useState)(false);
    const [showBfeLoggedOutModal, setShowBfeLoggedOutModal] = (0, _react.useState)(true);
    const emailLinkBonusClaimAttempted = (0, _react.useRef)(false);
    const location = (0, _reactRouterDom.useLocation)();
    const { user, loading, setUser } = (0, _userContext.useUser)();
    const handleCookieDecision = (prefs)=>{
        (0, _analyticsConsent.writeCookieConsentPrefs)(prefs);
        setHasAccepted(prefs.analytics === true);
        setShowConsentModal(false);
        (0, _analyticsConsent.syncAnalyticsConsentToServer)(prefs.analytics === true);
    };
    // Dev environment access gate - restrict to allowed email domain when configured
    const envValue = (0, _react.useMemo)(()=>"prod".toLowerCase(), []);
    const isDevByEnvVar = (0, _react.useMemo)(()=>envValue === "dev" || envValue === "development", [
        envValue
    ]);
    const allowedDomain = (0, _react.useMemo)(()=>"".toLowerCase(), []);
    const allowedEmailsRaw = (0, _react.useMemo)(()=>"", []);
    const restrictionActive = (0, _react.useMemo)(()=>isDevByEnvVar && !!allowedDomain, [
        isDevByEnvVar,
        allowedDomain
    ]);
    const currentPath = location.pathname || "/";
    const userEmailAllowed = (0, _react.useMemo)(()=>(0, _devEmailAccess.isEmailAllowedForDevGate)(user?.email, allowedDomain, allowedEmailsRaw), [
        user?.email,
        allowedDomain,
        allowedEmailsRaw
    ]);
    const onAuthPages = (0, _react.useMemo)(()=>new Set([
            "/login",
            "/signup"
        ]).has(currentPath), [
        currentPath
    ]);
    // Routes that require authentication (logged-in users only)
    const authenticatedRoutes = (0, _react.useMemo)(()=>new Set([
            "/shop",
            "/refund",
            "/refundpolicy"
        ]), []);
    const isPublicPage = (0, _react.useMemo)(()=>{
        // Check if current path is an auth page (login/signup)
        if (onAuthPages) return true;
        // Check if current path requires authentication
        if (authenticatedRoutes.has(currentPath)) return false;
        // Check if current path starts with an authenticated route prefix
        for (const route of authenticatedRoutes){
            if (currentPath.startsWith(route + "/")) return false;
        }
        // All other routes are public
        return true;
    }, [
        currentPath,
        authenticatedRoutes,
        onAuthPages
    ]);
    (0, _react.useEffect)(()=>{
        if (hasAccepted && gtmId && !(0, _analyticsEnv.isDevEnv)() && !(0, _analyticsEnv.isAnalyticsPathExcluded)(location.pathname)) {
            if (user?.userId) (0, _gtmEvents.trackPageView)({
                user_id: user.userId,
                page_path: location.pathname
            });
            else (0, _gtmEvents.trackPageView)({
                user_id: "VISITOR",
                page_path: location.pathname
            });
        }
    }, [
        location.pathname,
        hasAccepted,
        user?.userId
    ]);
    (0, _react.useEffect)(()=>{
        if (hasAccepted && gtmId && !(0, _analyticsEnv.isDevEnv)() && !(0, _analyticsEnv.isAnalyticsPathExcluded)(location.pathname)) {
            // Sticky user_status must exist on dataLayer before GTM/GA4 native hits.
            (0, _gtm.seedAnalyticsIdentityBeforeGtm)(user?.userId ?? null);
            (0, _gtm.initializeGtm)({
                gtmId,
                events: {
                    userdata: "userdata"
                }
            });
        }
    // Re-check when leaving excluded paths (e.g. /match → /matches) so GTM can start.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- identity updates handled elsewhere
    }, [
        hasAccepted,
        location.pathname
    ]);
    // When user has bfe=1 in URL but is not logged in, remember so we can add bfe=1 to redirect after login.
    (0, _react.useEffect)(()=>{
        const params = new URLSearchParams(location.search);
        if (!loading && !user && params.get(EMAIL_LINK_PARAM) === "1") (0, _welcomeBonus.setBfePending)();
    }, [
        location.search,
        user,
        loading
    ]);
    // One-time welcome bonus when user opens site from email link (?bfe=1). Claim only once per account (backend enforces).
    (0, _react.useEffect)(()=>{
        const params = new URLSearchParams(location.search);
        const fromEmail = params.get(EMAIL_LINK_PARAM);
        if (loading || !user || fromEmail !== "1" || emailLinkBonusClaimAttempted.current) return;
        emailLinkBonusClaimAttempted.current = true;
        (async ()=>{
            try {
                const apiUrl = "https://cricket8.com/api";
                const res = await fetch(`${apiUrl}/welcome-bonus/claim`, {
                    method: "POST",
                    headers: (0, _authHeaders.getAuthHeaders)()
                });
                const data = await res.json().catch(()=>({}));
                params.delete(EMAIL_LINK_PARAM);
                const newSearch = params.toString();
                const newPath = location.pathname + (newSearch ? `?${newSearch}` : "");
                window.history.replaceState({}, "", newPath);
                if (data.applied === true) {
                    try {
                        sessionStorage.setItem("c8_check_welcome_notification", "1");
                        sessionStorage.setItem("c8_animate_wallet_on_open", "1");
                    } catch  {
                    /* ignore */ }
                    if (data.wallet && user) {
                        setUser({
                            ...user,
                            wallet: data.wallet
                        });
                        window.dispatchEvent(new CustomEvent("walletUpdate"));
                    }
                    window.dispatchEvent(new CustomEvent("c8-notifications-updated"));
                } else if (data.alreadyClaimed === true) setShowEmailLinkBonusAlready(true);
            } catch  {
                params.delete(EMAIL_LINK_PARAM);
                const newSearch = params.toString();
                window.history.replaceState({}, "", location.pathname + (newSearch ? `?${newSearch}` : ""));
            }
        })();
    }, [
        location.search,
        location.pathname,
        user,
        loading,
        setUser
    ]);
    // Session check does not block the homepage
    if (restrictionActive) {
        if (loading) return null;
        // Allow public pages, auth pages, and homepage for logged-out users
        if (!user && !onAuthPages && !isPublicPage) {
            const bfe = new URLSearchParams(location.search).get(EMAIL_LINK_PARAM) === "1" ? "?bfe=1" : "";
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                to: `/login${bfe}`,
                replace: true
            });
        }
        // Phone/SMS accounts have no email — don't treat empty domain as a mismatch.
        if (user && !userEmailAllowed) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "fixed inset-0 flex items-center justify-center font-anton text-lime bg-main text-[24px] px-6 text-center",
            children: [
                "Access restricted on dev. Only ",
                allowedDomain,
                " accounts are allowed."
            ]
        });
    }
    if (onAuthPages && loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "app-loading-shell",
        "aria-hidden": "true"
    });
    if (user && !user.is_guest && onAuthPages) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: (0, _authBackPath.authPageRedirectTarget)(location.search),
        replace: true
    });
    const hasBfeParam = !loading && new URLSearchParams(location.search).get(EMAIL_LINK_PARAM) === "1";
    const showLoggedOutBfeModal = hasBfeParam && !user && showBfeLoggedOutModal && !onAuthPages;
    const closeEmailBonusAlreadyModal = ()=>setShowEmailLinkBonusAlready(false);
    const modalCloseButtonClass = "absolute top-2 right-2 min-h-11 min-w-11 flex items-center justify-center bg-white/10 hover:bg-white/20 text-white font-bold text-lg leading-none transition-colors";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            showEmailLinkBonusAlready && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
                    className: "relative border-2 border-[#D2FF00] bg-[#2a1a3d] shadow-xl p-6 md:p-8 max-w-md w-full",
                    initial: {
                        opacity: 0,
                        scale: 0.85,
                        y: 20
                    },
                    animate: {
                        opacity: 1,
                        scale: 1,
                        y: 0
                    },
                    transition: {
                        type: "spring",
                        stiffness: 280,
                        damping: 22
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: closeEmailBonusAlreadyModal,
                            className: modalCloseButtonClass,
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseIcon), {
                                width: 28,
                                height: 28,
                                fill: "currentColor",
                                className: "shrink-0"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-white font-chakra text-[14px] md:text-[16px] normal-case pr-10",
                            children: "You've already received your welcome bonus. Enjoy the site!"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-col gap-3 mt-6",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: closeEmailBonusAlreadyModal,
                                className: "w-full py-3 bg-[#D2FF00] text-[#1B062F] font-anton text-[16px] uppercase hover:bg-[#B8E600] transition-colors",
                                children: "Got it"
                            })
                        })
                    ]
                })
            }),
            showLoggedOutBfeModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
                    className: "relative border-2 border-[#D2FF00] bg-[#2a1a3d] shadow-xl p-6 md:p-8 max-w-md w-full",
                    initial: {
                        opacity: 0,
                        scale: 0.85,
                        y: 20
                    },
                    animate: {
                        opacity: 1,
                        scale: 1,
                        y: 0
                    },
                    transition: {
                        type: "spring",
                        stiffness: 280,
                        damping: 22
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: ()=>setShowBfeLoggedOutModal(false),
                            className: modalCloseButtonClass,
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseIcon), {
                                width: 28,
                                height: 28,
                                fill: "currentColor",
                                className: "shrink-0"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-2xl",
                            "aria-hidden": true,
                            children: "\uD83C\uDF89"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "text-[#D2FF00] font-anton text-[18px] md:text-[22px] uppercase mb-2 pr-8",
                            children: "Welcome bonus"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "text-white font-chakra text-[14px] md:text-[16px] normal-case mb-6",
                            children: [
                                "Login or sign up to claim ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "1 Ruby"
                                }),
                                " and ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "1000 Coins"
                                }),
                                " added to your wallet."
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "/login?bfe=1",
                                className: "px-6 py-3 bg-[#D2FF00] text-[#1B062F] font-anton text-[16px] uppercase hover:bg-[#B8E600] transition-colors inline-block",
                                children: "Login to claim"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Layout, {
                children: [
                    children,
                    showConsentModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cookieConsentModal.CookieConsentModal), {
                        onDecision: handleCookieDecision
                    }) : null
                ]
            }),
            hasAccepted && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cookieScripts.CookieScripts), {})
        ]
    });
});
const LegacyMatchParamRedirect = ()=>{
    const { match_id } = (0, _reactRouterDom.useParams)();
    const destination = match_id ? `/matches?id=${encodeURIComponent(match_id)}&${(0, _matchesHubNavigation.matchesHubSportSearchParam)("CRICKET")}` : (0, _matchesHubNavigation.buildMatchesListHref)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: destination,
        replace: true
    });
};
const LegacyMatchPathRedirect = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: `/matches${location.search}${location.hash}`,
        replace: true
    });
};
// Build routes array with conditional shop route
const routes = [
    // ========== PUBLIC ROUTES ==========
    {
        path: "/",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Games, {})
        })
    },
    {
        path: "/all-games",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Games, {})
        })
    },
    {
        path: "/about",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AboutUs, {})
        })
    },
    {
        path: "/how-to-play",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HowToPlay, {})
        })
    },
    {
        path: "/compliance",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Compliance, {})
        })
    },
    {
        path: "/facebook-data-deletion",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FacebookDataDeletionStatus, {})
        })
    },
    {
        path: "/account_google_newsignup",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GoogleNewSignup, {})
        })
    },
    {
        path: "/account_facebook_newsignup",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GoogleNewSignup, {})
        })
    },
    {
        path: "/account_otp_newsignup",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OtpNewSignup, {})
        })
    },
    {
        path: "/matches",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Matches, {})
        })
    },
    {
        path: "/match",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LegacyMatchPathRedirect, {})
    },
    {
        path: "/match/:match_id",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LegacyMatchParamRedirect, {})
        })
    },
    {
        path: "/matchdetail",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LegacyMatchPathRedirect, {})
    },
    {
        path: "/login",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Signup, {})
        })
    },
    {
        path: "/signup",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Signup, {})
        })
    },
    {
        path: "/terms",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Terms, {})
        })
    },
    {
        path: "/privacy",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Privacy, {})
        })
    },
    {
        path: "/contact",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Contact, {})
        })
    },
    {
        path: "/support",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
            to: "/about",
            replace: true
        })
    },
    {
        path: "/settlement-rules",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettlementRules, {})
        })
    },
    {
        path: "/sitemap",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Sitemap, {})
        })
    },
    {
        path: "/trader",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TraderRoute, {})
        })
    },
    {
        path: "/results",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LegacyMatchPathRedirect, {})
    },
    {
        path: "/squares",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SquaresRoute, {})
        })
    },
    {
        path: "/bullion",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BullionRoute, {})
        })
    },
    {
        path: "/sixes",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SixesRoute, {})
        })
    },
    {
        path: "/my-games",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
            to: "/my-zone?tab=my-games",
            replace: true
        })
    },
    // ========== LEAGUES (real API data) ==========
    {
        path: "/leagues",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeaguesHubJoinOrDetail, {})
        })
    },
    {
        path: "/leagues/join/:code",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeagueJoinPathRedirect, {})
    },
    // ========== LEAGUES DEMO (always-on client-side prototype) ==========
    // Nested under a provider that swaps the data source to the prototype.
    // Single-segment path so nginx SPA fallback serves a hard load.
    {
        path: (0, _leagueGamePlayUrl.LEAGUES_DEMO_PATH),
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeaguesDemoProvider, {}),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeaguesHubJoinOrDetail, {})
                })
            },
            {
                path: "join/:code",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeagueJoinPathRedirect, {})
            },
            {
                path: ":leagueId",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeagueDetailPathRedirect, {})
            }
        ]
    },
    {
        path: "/leagues/:leagueId",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeagueDetailPathRedirect, {})
    },
    // ========== AUTHENTICATED ROUTES (Require Login) ==========
    {
        path: "/edit-profile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileEditRoute, {})
            })
        })
    },
    {
        path: "/profile",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileRoute, {})
        })
    },
    {
        path: "/xp-leaderboard",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(XpLeaderboardPage, {})
        })
    },
    {
        path: "/my-zone",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MyZonePage, {})
            })
        })
    },
    {
        path: "/account",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Account, {})
            })
        })
    },
    {
        path: "/opt-in",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _preferencesRedirect.PreferencesRedirect), {})
        })
    },
    ...isShopEnabled ? [
        {
            path: "/shop",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shopBtnDefault.default), {})
                })
            })
        },
        {
            path: "/shop-payment-return",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShopPaymentReturn, {})
                })
            })
        }
    ] : [],
    // Always register so Stripe redirect after payment is handled (server must serve index.html for this path)
    {
        path: "/shop-payment-return",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShopPaymentReturn, {})
            })
        })
    },
    {
        path: "/refund",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _refundDefault.default), {})
            })
        })
    },
    {
        path: "/refund/:id",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _refundDefault.default), {})
            })
        })
    },
    {
        path: "/refundpolicy",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _refundPolicyDefault.default), {})
            })
        })
    },
    {
        path: "/refundpolicy/:id",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _refundPolicyDefault.default), {})
            })
        })
    },
    {
        path: "*",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutWithConsent, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotFound, {})
        })
    }
];
const router = (0, _reactRouterDom.createBrowserRouter)(routes);
const App = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
        fallback: /* Matches index.html .app-loading-skeleton so there’s no flash when React takes over */ /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appLoadingSkeleton.AppLoadingSkeleton), {}),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userContext.UserProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _decimalSocketContext.DecimalSocketProvider), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _traderDataFetcherContext.TraderDataFetcherProvider), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.RouterProvider), {
                        router: router
                    })
                })
            })
        })
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","./components/CookieConsentModal":"jCrZk","./components/CookieScripts":"iTbPI","./utils/analyticsConsent":"eiihB","./components/Leagues/lib/leagueGamePlayUrl":"5EJnb","./components/Leagues/lib/leagueResultsShare":"4vA9D","./components/Leagues/lib/leagueModeStore":"kZgkv","./Data/TraderDataFetcherContext":"1bLlx","./Data/DecimalSocketContext":"2iFcv","./Data/UserContext":"aqd8b","./components/AuthenticatedRoute":"hm9Eh","./components/Account/PreferencesRedirect":"iGma2","./components/Shop/ShopBtn":"2rJVc","./components/Support/Refund":"9s8Yc","./components/Support/RefundPolicy":"bZTyw","./utils/analyticsEnv":"4mdbs","./utils/authHeaders":"5Rczo","./utils/gtm":"dO5RN","./utils/gtmEvents":"kxMC4","framer-motion":"fI0Q4","./utils/authBackPath":"2oqPm","./utils/devEmailAccess":"d3tQO","./utils/welcomeBonus":"daFbR","./utils/retryLazyImport":"lajMf","./hooks/useGamesEnabled":"ex0m1","./hooks/usePlatformFeatureFlags":"Ruxh7","./components/AppLoadingSkeleton":"jZjp4","./components/ModalCloseIcon":"aricC","./components/Matches/matchesHubNavigation":"cJbjg","./components/AdminDevProxyReload":"lC2rN","c248716081772307":"k8w2i","1f779bd030b0b91b":"1MA4K","70d17096968b1ec":"8xodj","b29e616165d47828":"69FDC","e778903aa6fe1b8f":"33vSW","59f2890674169295":"dopEU","d6264e05cf9c2066":"aYw3M","7153fb87303082f1":"1WxWM","657cfc8b22f1049d":"3WfaG","8cb831016915c223":"ien4R","bad137550fc13e9e":"1KuRp","b242c3ed232cde94":"7EwsK","a1f813eed866a5cb":"kXeTg","175af6387fe4f43":"jJplv","e93603a61518673":"fE99G","c494f1a876b6f235":"a2nm2","5bf2faac1f8d2008":"7wbjD","ce7db320a7b5d610":"6glxD","7fd765c5b2bdd977":"39yEE","6339e4288428c1c":"cdlgV","feb37a9af2621e0b":"f7Rg5","5567ed3ae18fa88c":"3QSzp","dcda43879c485cbb":"hRziw","5745fbbcba034da4":"j7VaE","f0b854aca2ec7031":"lpBtb","9096de3b3d86da8a":"jJv2E","e9f06ec1c651a58b":"kBEv9","9b48ec9202fa635f":"dYtgX","60af4137c3e8e5df":"i7G8q","74bb34ba5fe45bbd":"j3pva","b7453f6104718114":"lAUi4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l6ORY":[function(require,module,exports,__globalThis) {
/**
 * React Router DOM v6.29.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _reactRouter.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = _react.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"6uln9","react-dom":"b8T3j","react-router":"kbGcH","@remix-run/router":"aNWKZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbGcH":[function(require,module,exports,__globalThis) {
/**
 * React Router v6.29.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "replace", ()=>(0, _router.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_logV6DeprecationWarnings", ()=>logV6DeprecationWarnings);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator, static: isStatic } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned$1 = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned$1[key]) alreadyWarned$1[key] = true;
}
const alreadyWarned = {};
function warnOnce(key, message) {}
const logDeprecation = (flag, msg, link)=>warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function logV6DeprecationWarnings(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

},{"react":"6uln9","@remix-run/router":"aNWKZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aNWKZ":[function(require,module,exports,__globalThis) {
/**
 * @remix-run/router v1.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_decodePath", ()=>decodePath);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDataWithResponseInit", ()=>isDataWithResponseInit);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches: updatedMatches || matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData
                } : {}), {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            matches,
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset
        });
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission, fetcherSubmission, preventScrollReset, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal,
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext, dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function defaultDataStrategy(_ref4) {
    let { matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: ResultType.data,
                result: undefined
            });
        };
        return _extends({}, match, {
            shouldLoad,
            resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) {
        if (isDataWithResponseInit(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: ResultType.error,
                error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: ResultType.error,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : undefined
        };
    }
    if (isDeferredData(result)) {
        var _result$init5, _result$init6;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if (isDataWithResponseInit(result)) {
        var _result$init7, _result$init8;
        return {
            type: ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type, message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, routeId, controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if (isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"jCrZk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CookieConsentModal", ()=>CookieConsentModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _framerMotion = require("framer-motion");
var _consentCheckbox = require("./Account/ConsentCheckbox");
function CookieConsentModal({ onDecision }) {
    const [analytics, setAnalytics] = (0, _react.useState)(true);
    const [marketing, setMarketing] = (0, _react.useState)(true);
    const acceptAll = ()=>onDecision({
            analytics: true,
            marketing: true
        });
    const rejectAll = ()=>onDecision({
            analytics: false,
            marketing: false
        });
    const saveChoices = ()=>onDecision({
            analytics,
            marketing
        });
    // Mixed selection → Accept selected; both on or both off → Accept All.
    const hasMixedSelection = analytics !== marketing;
    const primaryLabel = hasMixedSelection ? "Accept selected" : "Accept All";
    const primaryAction = hasMixedSelection ? saveChoices : acceptAll;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "cookie-consent-title",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
            className: "relative border-2 border-[#D2FF00] bg-[#2a1a3d] shadow-xl p-6 md:p-8 max-w-md w-full",
            initial: {
                opacity: 0,
                scale: 0.85,
                y: 20
            },
            animate: {
                opacity: 1,
                scale: 1,
                y: 0
            },
            transition: {
                type: "spring",
                stiffness: 280,
                damping: 22
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    id: "cookie-consent-title",
                    className: "text-[#D2FF00] font-anton text-[18px] md:text-[22px] uppercase mb-2",
                    children: "Your privacy matters"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-white font-chakra text-[14px] md:text-[16px] normal-case mb-6",
                    children: "We use essential cookies to keep Cricket8 secure and your games running smoothly. With your permission, we'd also like to use optional cookies to understand how players use Cricket8 and improve their experience."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    className: "flex flex-col border border-white/15 divide-y divide-white/15",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            className: "flex items-center justify-between gap-3 px-3 py-3 sm:px-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "font-chakra text-[14px] font-semibold normal-case text-white",
                                            children: "Essential Cookies"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "font-chakra text-[12px] font-normal normal-case text-white/65",
                                            children: "Required for security, login and gameplay."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "shrink-0 bg-[#32F78D]/15 px-2 py-1 font-chakra text-[11px] font-semibold normal-case text-[#32F78D]",
                                    children: "Always active"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "flex w-full items-center justify-between gap-3 px-3 py-3 text-left sm:px-4 hover:bg-white/5",
                                "aria-pressed": analytics,
                                onClick: ()=>setAnalytics((v)=>!v),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "font-chakra text-[14px] font-semibold normal-case text-white",
                                                children: "Analytics Cookies"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "font-chakra text-[12px] font-normal normal-case text-white/65",
                                                children: "Help us understand and improve Cricket8."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consentCheckbox.ConsentCheckboxBox), {
                                        checked: analytics
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "flex w-full items-center justify-between gap-3 px-3 py-3 text-left sm:px-4 hover:bg-white/5",
                                "aria-pressed": marketing,
                                onClick: ()=>setMarketing((v)=>!v),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "font-chakra text-[14px] font-semibold normal-case text-white",
                                                children: "Marketing Cookies"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "font-chakra text-[12px] font-normal normal-case text-white/65",
                                                children: "Help us understand which campaigns work."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consentCheckbox.ConsentCheckboxBox), {
                                        checked: marketing
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: rejectAll,
                            className: "min-h-11 px-2 font-chakra text-[14px] font-semibold normal-case text-white/80 hover:text-white transition-colors",
                            children: "Reject All"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: primaryAction,
                            className: "w-full sm:min-w-[200px] sm:w-auto py-3 px-8 bg-[#D2FF00] text-[#1B062F] font-anton text-[16px] uppercase hover:bg-[#B8E600] transition-colors",
                            children: primaryLabel
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","framer-motion":"fI0Q4","./Account/ConsentCheckbox":"duaSo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fI0Q4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimatePresence", ()=>(0, _indexMjs.AnimatePresence));
parcelHelpers.export(exports, "LayoutGroup", ()=>(0, _indexMjs1.LayoutGroup));
parcelHelpers.export(exports, "LazyMotion", ()=>(0, _indexMjs2.LazyMotion));
parcelHelpers.export(exports, "MotionConfig", ()=>(0, _indexMjs3.MotionConfig));
parcelHelpers.export(exports, "m", ()=>(0, _proxyMjs.m));
parcelHelpers.export(exports, "motion", ()=>(0, _proxyMjs1.motion));
parcelHelpers.export(exports, "addPointerEvent", ()=>(0, _addPointerEventMjs.addPointerEvent));
parcelHelpers.export(exports, "addPointerInfo", ()=>(0, _eventInfoMjs.addPointerInfo));
parcelHelpers.export(exports, "animations", ()=>(0, _animationsMjs.animations));
parcelHelpers.export(exports, "makeUseVisualState", ()=>(0, _useVisualStateMjs.makeUseVisualState));
parcelHelpers.export(exports, "calcLength", ()=>(0, _deltaCalcMjs.calcLength));
parcelHelpers.export(exports, "createBox", ()=>(0, _modelsMjs.createBox));
parcelHelpers.export(exports, "filterProps", ()=>(0, _filterPropsMjs.filterProps));
parcelHelpers.export(exports, "isBrowser", ()=>(0, _isBrowserMjs.isBrowser));
parcelHelpers.export(exports, "useForceUpdate", ()=>(0, _useForceUpdateMjs.useForceUpdate));
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>(0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect));
parcelHelpers.export(exports, "useUnmountEffect", ()=>(0, _useUnmountEffectMjs.useUnmountEffect));
parcelHelpers.export(exports, "isMotionValue", ()=>(0, _isMotionValueMjs.isMotionValue));
parcelHelpers.export(exports, "domAnimation", ()=>(0, _featuresAnimationMjs.domAnimation));
parcelHelpers.export(exports, "domMax", ()=>(0, _featuresMaxMjs.domMax));
parcelHelpers.export(exports, "domMin", ()=>(0, _featuresMinMjs.domMin));
parcelHelpers.export(exports, "useMotionValueEvent", ()=>(0, _useMotionValueEventMjs.useMotionValueEvent));
parcelHelpers.export(exports, "useElementScroll", ()=>(0, _useElementScrollMjs.useElementScroll));
parcelHelpers.export(exports, "useViewportScroll", ()=>(0, _useViewportScrollMjs.useViewportScroll));
parcelHelpers.export(exports, "useMotionTemplate", ()=>(0, _useMotionTemplateMjs.useMotionTemplate));
parcelHelpers.export(exports, "useMotionValue", ()=>(0, _useMotionValueMjs.useMotionValue));
parcelHelpers.export(exports, "useScroll", ()=>(0, _useScrollMjs.useScroll));
parcelHelpers.export(exports, "useSpring", ()=>(0, _useSpringMjs.useSpring));
parcelHelpers.export(exports, "useTime", ()=>(0, _useTimeMjs.useTime));
parcelHelpers.export(exports, "useTransform", ()=>(0, _useTransformMjs.useTransform));
parcelHelpers.export(exports, "useVelocity", ()=>(0, _useVelocityMjs.useVelocity));
parcelHelpers.export(exports, "useWillChange", ()=>(0, _indexMjs4.useWillChange));
parcelHelpers.export(exports, "resolveMotionValue", ()=>(0, _resolveMotionValueMjs.resolveMotionValue));
parcelHelpers.export(exports, "useReducedMotion", ()=>(0, _useReducedMotionMjs.useReducedMotion));
parcelHelpers.export(exports, "useReducedMotionConfig", ()=>(0, _useReducedMotionConfigMjs.useReducedMotionConfig));
parcelHelpers.export(exports, "MotionGlobalConfig", ()=>(0, _motionUtils.MotionGlobalConfig));
parcelHelpers.export(exports, "invariant", ()=>(0, _motionUtils.invariant));
parcelHelpers.export(exports, "noop", ()=>(0, _motionUtils.noop));
parcelHelpers.export(exports, "progress", ()=>(0, _motionUtils.progress));
parcelHelpers.export(exports, "AcceleratedAnimation", ()=>(0, _acceleratedAnimationMjs.AcceleratedAnimation));
parcelHelpers.export(exports, "animateValue", ()=>(0, _mainThreadAnimationMjs.animateValue));
parcelHelpers.export(exports, "animationControls", ()=>(0, _animationControlsMjs.animationControls));
parcelHelpers.export(exports, "useAnimate", ()=>(0, _useAnimateMjs.useAnimate));
parcelHelpers.export(exports, "useAnimateMini", ()=>(0, _useAnimateStyleMjs.useAnimateMini));
parcelHelpers.export(exports, "useAnimation", ()=>(0, _useAnimationMjs.useAnimation));
parcelHelpers.export(exports, "useAnimationControls", ()=>(0, _useAnimationMjs.useAnimationControls));
parcelHelpers.export(exports, "animateVisualElement", ()=>(0, _visualElementMjs.animateVisualElement));
parcelHelpers.export(exports, "useIsPresent", ()=>(0, _usePresenceMjs.useIsPresent));
parcelHelpers.export(exports, "usePresence", ()=>(0, _usePresenceMjs.usePresence));
parcelHelpers.export(exports, "usePresenceData", ()=>(0, _usePresenceDataMjs.usePresenceData));
parcelHelpers.export(exports, "useDomEvent", ()=>(0, _useDomEventMjs.useDomEvent));
parcelHelpers.export(exports, "DragControls", ()=>(0, _useDragControlsMjs.DragControls));
parcelHelpers.export(exports, "useDragControls", ()=>(0, _useDragControlsMjs.useDragControls));
parcelHelpers.export(exports, "createRendererMotionComponent", ()=>(0, _indexMjs5.createRendererMotionComponent));
parcelHelpers.export(exports, "isMotionComponent", ()=>(0, _isMotionComponentMjs.isMotionComponent));
parcelHelpers.export(exports, "unwrapMotionComponent", ()=>(0, _unwrapMotionComponentMjs.unwrapMotionComponent));
parcelHelpers.export(exports, "isValidMotionProp", ()=>(0, _validPropMjs.isValidMotionProp));
parcelHelpers.export(exports, "addScaleCorrector", ()=>(0, _scaleCorrectionMjs.addScaleCorrector));
parcelHelpers.export(exports, "useInstantLayoutTransition", ()=>(0, _useInstantLayoutTransitionMjs.useInstantLayoutTransition));
parcelHelpers.export(exports, "useResetProjection", ()=>(0, _useResetProjectionMjs.useResetProjection));
parcelHelpers.export(exports, "buildTransform", ()=>(0, _buildTransformMjs.buildTransform));
parcelHelpers.export(exports, "visualElementStore", ()=>(0, _storeMjs.visualElementStore));
parcelHelpers.export(exports, "VisualElement", ()=>(0, _visualElementMjs1.VisualElement));
parcelHelpers.export(exports, "useAnimationFrame", ()=>(0, _useAnimationFrameMjs.useAnimationFrame));
parcelHelpers.export(exports, "useCycle", ()=>(0, _useCycleMjs.useCycle));
parcelHelpers.export(exports, "useInView", ()=>(0, _useInViewMjs.useInView));
parcelHelpers.export(exports, "disableInstantTransitions", ()=>(0, _useInstantTransitionMjs.disableInstantTransitions));
parcelHelpers.export(exports, "useInstantTransition", ()=>(0, _useInstantTransitionMjs.useInstantTransition));
parcelHelpers.export(exports, "color", ()=>(0, _indexMjs6.color));
parcelHelpers.export(exports, "complex", ()=>(0, _indexMjs7.complex));
parcelHelpers.export(exports, "px", ()=>(0, _unitsMjs.px));
parcelHelpers.export(exports, "spring", ()=>(0, _indexMjs8.spring));
parcelHelpers.export(exports, "findSpring", ()=>(0, _findMjs.findSpring));
parcelHelpers.export(exports, "optimizedAppearDataAttribute", ()=>(0, _dataIdMjs.optimizedAppearDataAttribute));
parcelHelpers.export(exports, "startOptimizedAppearAnimation", ()=>(0, _startMjs.startOptimizedAppearAnimation));
parcelHelpers.export(exports, "LayoutGroupContext", ()=>(0, _layoutGroupContextMjs.LayoutGroupContext));
parcelHelpers.export(exports, "MotionConfigContext", ()=>(0, _motionConfigContextMjs.MotionConfigContext));
parcelHelpers.export(exports, "MotionContext", ()=>(0, _indexMjs9.MotionContext));
parcelHelpers.export(exports, "PresenceContext", ()=>(0, _presenceContextMjs.PresenceContext));
parcelHelpers.export(exports, "SwitchLayoutGroupContext", ()=>(0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext));
parcelHelpers.export(exports, "FlatTree", ()=>(0, _flatTreeMjs.FlatTree));
parcelHelpers.export(exports, "useDeprecatedAnimatedState", ()=>(0, _useAnimatedStateMjs.useAnimatedState));
parcelHelpers.export(exports, "AnimateSharedLayout", ()=>(0, _animateSharedLayoutMjs.AnimateSharedLayout));
parcelHelpers.export(exports, "DeprecatedLayoutGroupContext", ()=>(0, _deprecatedLayoutGroupContextMjs.DeprecatedLayoutGroupContext));
parcelHelpers.export(exports, "useDeprecatedInvertedScale", ()=>(0, _useInvertedScaleMjs.useInvertedScale));
parcelHelpers.export(exports, "delay", ()=>(0, _delayMjs.delay));
parcelHelpers.export(exports, "MotionValue", ()=>(0, _motionDom.MotionValue));
parcelHelpers.export(exports, "cancelFrame", ()=>(0, _motionDom.cancelFrame));
parcelHelpers.export(exports, "frame", ()=>(0, _motionDom.frame));
parcelHelpers.export(exports, "frameData", ()=>(0, _motionDom.frameData));
parcelHelpers.export(exports, "hover", ()=>(0, _motionDom.hover));
parcelHelpers.export(exports, "isDragActive", ()=>(0, _motionDom.isDragActive));
parcelHelpers.export(exports, "motionValue", ()=>(0, _motionDom.motionValue));
parcelHelpers.export(exports, "press", ()=>(0, _motionDom.press));
parcelHelpers.export(exports, "time", ()=>(0, _motionDom.time));
parcelHelpers.export(exports, "animate", ()=>(0, _indexMjs10.animate));
parcelHelpers.export(exports, "createScopedAnimate", ()=>(0, _indexMjs10.createScopedAnimate));
parcelHelpers.export(exports, "animateMini", ()=>(0, _animateStyleMjs.animateMini));
parcelHelpers.export(exports, "scroll", ()=>(0, _indexMjs11.scroll));
parcelHelpers.export(exports, "scrollInfo", ()=>(0, _trackMjs.scrollInfo));
parcelHelpers.export(exports, "inView", ()=>(0, _indexMjs12.inView));
parcelHelpers.export(exports, "inertia", ()=>(0, _inertiaMjs.inertia));
parcelHelpers.export(exports, "keyframes", ()=>(0, _keyframesMjs.keyframes));
parcelHelpers.export(exports, "stagger", ()=>(0, _staggerMjs.stagger));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampMjs.clamp));
parcelHelpers.export(exports, "mix", ()=>(0, _indexMjs13.mix));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipeMjs.pipe));
parcelHelpers.export(exports, "transform", ()=>(0, _transformMjs.transform));
parcelHelpers.export(exports, "wrap", ()=>(0, _wrapMjs.wrap));
parcelHelpers.export(exports, "anticipate", ()=>(0, _anticipateMjs.anticipate));
parcelHelpers.export(exports, "backIn", ()=>(0, _backMjs.backIn));
parcelHelpers.export(exports, "backInOut", ()=>(0, _backMjs.backInOut));
parcelHelpers.export(exports, "backOut", ()=>(0, _backMjs.backOut));
parcelHelpers.export(exports, "circIn", ()=>(0, _circMjs.circIn));
parcelHelpers.export(exports, "circInOut", ()=>(0, _circMjs.circInOut));
parcelHelpers.export(exports, "circOut", ()=>(0, _circMjs.circOut));
parcelHelpers.export(exports, "cubicBezier", ()=>(0, _cubicBezierMjs.cubicBezier));
parcelHelpers.export(exports, "easeIn", ()=>(0, _easeMjs.easeIn));
parcelHelpers.export(exports, "easeInOut", ()=>(0, _easeMjs.easeInOut));
parcelHelpers.export(exports, "easeOut", ()=>(0, _easeMjs.easeOut));
parcelHelpers.export(exports, "mirrorEasing", ()=>(0, _mirrorMjs.mirrorEasing));
parcelHelpers.export(exports, "reverseEasing", ()=>(0, _reverseMjs.reverseEasing));
parcelHelpers.export(exports, "steps", ()=>(0, _stepsMjs.steps));
parcelHelpers.export(exports, "distance", ()=>(0, _distanceMjs.distance));
parcelHelpers.export(exports, "distance2D", ()=>(0, _distanceMjs.distance2D));
parcelHelpers.export(exports, "interpolate", ()=>(0, _interpolateMjs.interpolate));
parcelHelpers.export(exports, "Reorder", ()=>_namespaceMjs);
var _indexMjs = require("./components/AnimatePresence/index.mjs");
var _indexMjs1 = require("./components/LayoutGroup/index.mjs");
var _indexMjs2 = require("./components/LazyMotion/index.mjs");
var _indexMjs3 = require("./components/MotionConfig/index.mjs");
var _proxyMjs = require("./render/components/m/proxy.mjs");
var _proxyMjs1 = require("./render/components/motion/proxy.mjs");
var _addPointerEventMjs = require("./events/add-pointer-event.mjs");
var _eventInfoMjs = require("./events/event-info.mjs");
var _animationsMjs = require("./motion/features/animations.mjs");
var _useVisualStateMjs = require("./motion/utils/use-visual-state.mjs");
var _deltaCalcMjs = require("./projection/geometry/delta-calc.mjs");
var _modelsMjs = require("./projection/geometry/models.mjs");
var _filterPropsMjs = require("./render/dom/utils/filter-props.mjs");
var _isBrowserMjs = require("./utils/is-browser.mjs");
var _useForceUpdateMjs = require("./utils/use-force-update.mjs");
var _useIsomorphicEffectMjs = require("./utils/use-isomorphic-effect.mjs");
var _useUnmountEffectMjs = require("./utils/use-unmount-effect.mjs");
var _isMotionValueMjs = require("./value/utils/is-motion-value.mjs");
var _featuresAnimationMjs = require("./render/dom/features-animation.mjs");
var _featuresMaxMjs = require("./render/dom/features-max.mjs");
var _featuresMinMjs = require("./render/dom/features-min.mjs");
var _useMotionValueEventMjs = require("./utils/use-motion-value-event.mjs");
var _useElementScrollMjs = require("./value/scroll/use-element-scroll.mjs");
var _useViewportScrollMjs = require("./value/scroll/use-viewport-scroll.mjs");
var _useMotionTemplateMjs = require("./value/use-motion-template.mjs");
var _useMotionValueMjs = require("./value/use-motion-value.mjs");
var _useScrollMjs = require("./value/use-scroll.mjs");
var _useSpringMjs = require("./value/use-spring.mjs");
var _useTimeMjs = require("./value/use-time.mjs");
var _useTransformMjs = require("./value/use-transform.mjs");
var _useVelocityMjs = require("./value/use-velocity.mjs");
var _indexMjs4 = require("./value/use-will-change/index.mjs");
var _resolveMotionValueMjs = require("./value/utils/resolve-motion-value.mjs");
var _useReducedMotionMjs = require("./utils/reduced-motion/use-reduced-motion.mjs");
var _useReducedMotionConfigMjs = require("./utils/reduced-motion/use-reduced-motion-config.mjs");
var _motionUtils = require("motion-utils");
var _acceleratedAnimationMjs = require("./animation/animators/AcceleratedAnimation.mjs");
var _mainThreadAnimationMjs = require("./animation/animators/MainThreadAnimation.mjs");
var _animationControlsMjs = require("./animation/hooks/animation-controls.mjs");
var _useAnimateMjs = require("./animation/hooks/use-animate.mjs");
var _useAnimateStyleMjs = require("./animation/hooks/use-animate-style.mjs");
var _useAnimationMjs = require("./animation/hooks/use-animation.mjs");
var _visualElementMjs = require("./animation/interfaces/visual-element.mjs");
var _usePresenceMjs = require("./components/AnimatePresence/use-presence.mjs");
var _usePresenceDataMjs = require("./components/AnimatePresence/use-presence-data.mjs");
var _useDomEventMjs = require("./events/use-dom-event.mjs");
var _useDragControlsMjs = require("./gestures/drag/use-drag-controls.mjs");
var _indexMjs5 = require("./motion/index.mjs");
var _isMotionComponentMjs = require("./motion/utils/is-motion-component.mjs");
var _unwrapMotionComponentMjs = require("./motion/utils/unwrap-motion-component.mjs");
var _validPropMjs = require("./motion/utils/valid-prop.mjs");
var _scaleCorrectionMjs = require("./projection/styles/scale-correction.mjs");
var _useInstantLayoutTransitionMjs = require("./projection/use-instant-layout-transition.mjs");
var _useResetProjectionMjs = require("./projection/use-reset-projection.mjs");
var _buildTransformMjs = require("./render/html/utils/build-transform.mjs");
var _storeMjs = require("./render/store.mjs");
var _visualElementMjs1 = require("./render/VisualElement.mjs");
var _useAnimationFrameMjs = require("./utils/use-animation-frame.mjs");
var _useCycleMjs = require("./utils/use-cycle.mjs");
var _useInViewMjs = require("./utils/use-in-view.mjs");
var _useInstantTransitionMjs = require("./utils/use-instant-transition.mjs");
var _indexMjs6 = require("./value/types/color/index.mjs");
var _indexMjs7 = require("./value/types/complex/index.mjs");
var _unitsMjs = require("./value/types/numbers/units.mjs");
var _indexMjs8 = require("./animation/generators/spring/index.mjs");
var _findMjs = require("./animation/generators/spring/find.mjs");
var _dataIdMjs = require("./animation/optimized-appear/data-id.mjs");
var _startMjs = require("./animation/optimized-appear/start.mjs");
var _layoutGroupContextMjs = require("./context/LayoutGroupContext.mjs");
var _motionConfigContextMjs = require("./context/MotionConfigContext.mjs");
var _indexMjs9 = require("./context/MotionContext/index.mjs");
var _presenceContextMjs = require("./context/PresenceContext.mjs");
var _switchLayoutGroupContextMjs = require("./context/SwitchLayoutGroupContext.mjs");
var _flatTreeMjs = require("./render/utils/flat-tree.mjs");
var _useAnimatedStateMjs = require("./animation/hooks/use-animated-state.mjs");
var _animateSharedLayoutMjs = require("./components/AnimateSharedLayout.mjs");
var _deprecatedLayoutGroupContextMjs = require("./context/DeprecatedLayoutGroupContext.mjs");
var _useInvertedScaleMjs = require("./value/use-inverted-scale.mjs");
var _delayMjs = require("./utils/delay.mjs");
var _namespaceMjs = require("./components/Reorder/namespace.mjs");
var _motionDom = require("motion-dom");
var _indexMjs10 = require("./animation/animate/index.mjs");
var _animateStyleMjs = require("./animation/animators/waapi/animate-style.mjs");
var _indexMjs11 = require("./render/dom/scroll/index.mjs");
var _trackMjs = require("./render/dom/scroll/track.mjs");
var _indexMjs12 = require("./render/dom/viewport/index.mjs");
var _inertiaMjs = require("./animation/generators/inertia.mjs");
var _keyframesMjs = require("./animation/generators/keyframes.mjs");
var _staggerMjs = require("./animation/utils/stagger.mjs");
var _clampMjs = require("./utils/clamp.mjs");
var _indexMjs13 = require("./utils/mix/index.mjs");
var _pipeMjs = require("./utils/pipe.mjs");
var _transformMjs = require("./utils/transform.mjs");
var _wrapMjs = require("./utils/wrap.mjs");
var _anticipateMjs = require("./easing/anticipate.mjs");
var _backMjs = require("./easing/back.mjs");
var _circMjs = require("./easing/circ.mjs");
var _cubicBezierMjs = require("./easing/cubic-bezier.mjs");
var _easeMjs = require("./easing/ease.mjs");
var _mirrorMjs = require("./easing/modifiers/mirror.mjs");
var _reverseMjs = require("./easing/modifiers/reverse.mjs");
var _stepsMjs = require("./easing/steps.mjs");
var _distanceMjs = require("./utils/distance.mjs");
var _interpolateMjs = require("./utils/interpolate.mjs");
"use client";

},{"./components/AnimatePresence/index.mjs":"h1Vur","./components/LayoutGroup/index.mjs":"68sIB","./components/LazyMotion/index.mjs":false,"./components/MotionConfig/index.mjs":false,"./render/components/m/proxy.mjs":false,"./render/components/motion/proxy.mjs":"NzqXO","./events/add-pointer-event.mjs":false,"./events/event-info.mjs":false,"./motion/features/animations.mjs":false,"./motion/utils/use-visual-state.mjs":false,"./projection/geometry/delta-calc.mjs":false,"./projection/geometry/models.mjs":false,"./render/dom/utils/filter-props.mjs":false,"./utils/is-browser.mjs":false,"./utils/use-force-update.mjs":false,"./utils/use-isomorphic-effect.mjs":false,"./utils/use-unmount-effect.mjs":false,"./value/utils/is-motion-value.mjs":false,"./render/dom/features-animation.mjs":false,"./render/dom/features-max.mjs":false,"./render/dom/features-min.mjs":false,"./utils/use-motion-value-event.mjs":false,"./value/scroll/use-element-scroll.mjs":false,"./value/scroll/use-viewport-scroll.mjs":false,"./value/use-motion-template.mjs":false,"./value/use-motion-value.mjs":false,"./value/use-scroll.mjs":false,"./value/use-spring.mjs":false,"./value/use-time.mjs":false,"./value/use-transform.mjs":false,"./value/use-velocity.mjs":false,"./value/use-will-change/index.mjs":false,"./value/utils/resolve-motion-value.mjs":false,"./utils/reduced-motion/use-reduced-motion.mjs":"jUxsS","./utils/reduced-motion/use-reduced-motion-config.mjs":false,"motion-utils":"h8hZz","./animation/animators/AcceleratedAnimation.mjs":false,"./animation/animators/MainThreadAnimation.mjs":false,"./animation/hooks/animation-controls.mjs":false,"./animation/hooks/use-animate.mjs":false,"./animation/hooks/use-animate-style.mjs":false,"./animation/hooks/use-animation.mjs":false,"./animation/interfaces/visual-element.mjs":false,"./components/AnimatePresence/use-presence.mjs":false,"./components/AnimatePresence/use-presence-data.mjs":false,"./events/use-dom-event.mjs":false,"./gestures/drag/use-drag-controls.mjs":false,"./motion/index.mjs":false,"./motion/utils/is-motion-component.mjs":false,"./motion/utils/unwrap-motion-component.mjs":false,"./motion/utils/valid-prop.mjs":false,"./projection/styles/scale-correction.mjs":false,"./projection/use-instant-layout-transition.mjs":false,"./projection/use-reset-projection.mjs":false,"./render/html/utils/build-transform.mjs":false,"./render/store.mjs":false,"./render/VisualElement.mjs":false,"./utils/use-animation-frame.mjs":false,"./utils/use-cycle.mjs":false,"./utils/use-in-view.mjs":false,"./utils/use-instant-transition.mjs":false,"./value/types/color/index.mjs":false,"./value/types/complex/index.mjs":false,"./value/types/numbers/units.mjs":false,"./animation/generators/spring/index.mjs":false,"./animation/generators/spring/find.mjs":false,"./animation/optimized-appear/data-id.mjs":false,"./animation/optimized-appear/start.mjs":false,"./context/LayoutGroupContext.mjs":false,"./context/MotionConfigContext.mjs":false,"./context/MotionContext/index.mjs":false,"./context/PresenceContext.mjs":false,"./context/SwitchLayoutGroupContext.mjs":false,"./render/utils/flat-tree.mjs":false,"./animation/hooks/use-animated-state.mjs":false,"./components/AnimateSharedLayout.mjs":false,"./context/DeprecatedLayoutGroupContext.mjs":false,"./value/use-inverted-scale.mjs":false,"./utils/delay.mjs":false,"./components/Reorder/namespace.mjs":false,"motion-dom":"7u9qw","./animation/animate/index.mjs":"3FjWp","./animation/animators/waapi/animate-style.mjs":false,"./render/dom/scroll/index.mjs":false,"./render/dom/scroll/track.mjs":false,"./render/dom/viewport/index.mjs":false,"./animation/generators/inertia.mjs":false,"./animation/generators/keyframes.mjs":false,"./animation/utils/stagger.mjs":false,"./utils/clamp.mjs":false,"./utils/mix/index.mjs":false,"./utils/pipe.mjs":false,"./utils/transform.mjs":false,"./utils/wrap.mjs":false,"./easing/anticipate.mjs":false,"./easing/back.mjs":false,"./easing/circ.mjs":false,"./easing/cubic-bezier.mjs":false,"./easing/ease.mjs":false,"./easing/modifiers/mirror.mjs":false,"./easing/modifiers/reverse.mjs":false,"./easing/steps.mjs":false,"./utils/distance.mjs":false,"./utils/interpolate.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h1Vur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimatePresence", ()=>AnimatePresence);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _layoutGroupContextMjs = require("../../context/LayoutGroupContext.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
var _useIsomorphicEffectMjs = require("../../utils/use-isomorphic-effect.mjs");
var _presenceChildMjs = require("./PresenceChild.mjs");
var _usePresenceMjs = require("./use-presence.mjs");
var _utilsMjs = require("./utils.mjs");
"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const AnimatePresence = ({ children, custom, initial = true, onExitComplete, presenceAffectsLayout = true, mode = "sync", propagate = false, anchorX = "left" })=>{
    const [isParentPresent, safeToRemove] = (0, _usePresenceMjs.usePresence)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, _react.useMemo)(()=>(0, _utilsMjs.onlyElements)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, _utilsMjs.getChildKey));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, _react.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, _react.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, _useConstantMjs.useConstant)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, _react.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, _react.useState)(presentChildren);
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, _utilsMjs.getChildKey)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, _utilsMjs.getChildKey)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, _utilsMjs.onlyElements)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender } = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext));
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, _utilsMjs.getChildKey)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && (safeToRemove === null || safeToRemove === void 0 || safeToRemove());
                    onExitComplete && onExitComplete();
                }
            };
            return (0, _jsxRuntime.jsx)((0, _presenceChildMjs.PresenceChild), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                children: child
            }, key);
        })
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../context/LayoutGroupContext.mjs":"5CkZ6","../../utils/use-constant.mjs":"7bpoo","../../utils/use-isomorphic-effect.mjs":"6Pcpq","./PresenceChild.mjs":"dULF5","./use-presence.mjs":"7TWAj","./utils.mjs":"diQLe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5CkZ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutGroupContext", ()=>LayoutGroupContext);
var _react = require("react");
"use client";
const LayoutGroupContext = (0, _react.createContext)({});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7bpoo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useConstant", ()=>useConstant);
var _react = require("react");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function useConstant(init) {
    const ref = (0, _react.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Pcpq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
var _isBrowserMjs = require("./is-browser.mjs");
const useIsomorphicLayoutEffect = (0, _isBrowserMjs.isBrowser) ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"6uln9","./is-browser.mjs":"9ew4K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ew4K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
const isBrowser = typeof window !== "undefined";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dULF5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresenceChild", ()=>PresenceChild);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
var _popChildMjs = require("./PopChild.mjs");
"use client";
const PresenceChild = ({ children, initial, isPresent, onExitComplete, custom, presenceAffectsLayout, mode, anchorX })=>{
    const presenceChildren = (0, _useConstantMjs.useConstant)(newChildrenMap);
    const id = (0, _react.useId)();
    const memoizedOnExitComplete = (0, _react.useCallback)((childId)=>{
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()){
            if (!isComplete) return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [
        presenceChildren,
        onExitComplete
    ]);
    const context = (0, _react.useMemo)(()=>({
            id,
            initial,
            isPresent,
            custom,
            onExitComplete: memoizedOnExitComplete,
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random(),
        memoizedOnExitComplete
    ] : [
        isPresent,
        memoizedOnExitComplete
    ]);
    (0, _react.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ _react.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, _jsxRuntime.jsx)((0, _popChildMjs.PopChild), {
        isPresent: isPresent,
        anchorX: anchorX,
        children: children
    });
    return (0, _jsxRuntime.jsx)((0, _presenceContextMjs.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function newChildrenMap() {
    return new Map();
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../context/PresenceContext.mjs":"dcXf9","../../utils/use-constant.mjs":"7bpoo","./PopChild.mjs":"cxGVW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dcXf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresenceContext", ()=>PresenceContext);
var _react = require("react");
"use client";
/**
 * @public
 */ const PresenceContext = /* @__PURE__ */ (0, _react.createContext)(null);

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cxGVW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopChild", ()=>PopChild);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _motionConfigContextMjs = require("../../context/MotionConfigContext.mjs");
"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class PopChildMeasure extends _react.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const parent = element.offsetParent;
            const parentWidth = parent instanceof HTMLElement ? parent.offsetWidth || 0 : 0;
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function PopChild({ children, isPresent, anchorX }) {
    const id = (0, _react.useId)();
    const ref = (0, _react.useRef)(null);
    const size = (0, _react.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0
    });
    const { nonce } = (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, _react.useInsertionEffect)(()=>{
        const { width, height, top, left, right } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            top: ${top}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, _jsxRuntime.jsx)(PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: _react.cloneElement(children, {
            ref
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../context/MotionConfigContext.mjs":"92LC9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92LC9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionConfigContext", ()=>MotionConfigContext);
var _react = require("react");
"use client";
/**
 * @public
 */ const MotionConfigContext = (0, _react.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7TWAj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPresent", ()=>isPresent);
parcelHelpers.export(exports, "useIsPresent", ()=>useIsPresent);
parcelHelpers.export(exports, "usePresence", ()=>usePresence);
var _react = require("react");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function usePresence(subscribe = true) {
    const context = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent, onExitComplete, register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, _react.useId)();
    (0, _react.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, _react.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function useIsPresent() {
    return isPresent((0, _react.useContext)((0, _presenceContextMjs.PresenceContext)));
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}

},{"react":"6uln9","../../context/PresenceContext.mjs":"dcXf9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"diQLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChildKey", ()=>getChildKey);
parcelHelpers.export(exports, "onlyElements", ()=>onlyElements);
var _react = require("react");
const getChildKey = (child)=>child.key || "";
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, _react.Children).forEach(children, (child)=>{
        if ((0, _react.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"68sIB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutGroup", ()=>LayoutGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _layoutGroupContextMjs = require("../../context/LayoutGroupContext.mjs");
var _deprecatedLayoutGroupContextMjs = require("../../context/DeprecatedLayoutGroupContext.mjs");
var _useForceUpdateMjs = require("../../utils/use-force-update.mjs");
var _groupMjs = require("../../projection/node/group.mjs");
"use client";
const shouldInheritGroup = (inherit)=>inherit === true;
const shouldInheritId = (inherit)=>shouldInheritGroup(inherit === true) || inherit === "id";
const LayoutGroup = ({ children, id, inherit = true })=>{
    const layoutGroupContext = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext));
    const deprecatedLayoutGroupContext = (0, _react.useContext)((0, _deprecatedLayoutGroupContextMjs.DeprecatedLayoutGroupContext));
    const [forceRender, key] = (0, _useForceUpdateMjs.useForceUpdate)();
    const context = (0, _react.useRef)(null);
    const upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;
    if (context.current === null) {
        if (shouldInheritId(inherit) && upstreamId) id = id ? upstreamId + "-" + id : upstreamId;
        context.current = {
            id,
            group: shouldInheritGroup(inherit) ? layoutGroupContext.group || (0, _groupMjs.nodeGroup)() : (0, _groupMjs.nodeGroup)()
        };
    }
    const memoizedContext = (0, _react.useMemo)(()=>({
            ...context.current,
            forceRender
        }), [
        key
    ]);
    return (0, _jsxRuntime.jsx)((0, _layoutGroupContextMjs.LayoutGroupContext).Provider, {
        value: memoizedContext,
        children: children
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../context/LayoutGroupContext.mjs":"5CkZ6","../../context/DeprecatedLayoutGroupContext.mjs":"5UdAk","../../utils/use-force-update.mjs":"eMN5J","../../projection/node/group.mjs":"4VHFR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5UdAk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeprecatedLayoutGroupContext", ()=>DeprecatedLayoutGroupContext);
var _react = require("react");
/**
 * Note: Still used by components generated by old versions of Framer
 *
 * @deprecated
 */ const DeprecatedLayoutGroupContext = (0, _react.createContext)(null);

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eMN5J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useForceUpdate", ()=>useForceUpdate);
var _motionDom = require("motion-dom");
var _react = require("react");
var _useIsMountedMjs = require("./use-is-mounted.mjs");
function useForceUpdate() {
    const isMounted = (0, _useIsMountedMjs.useIsMounted)();
    const [forcedRenderCount, setForcedRenderCount] = (0, _react.useState)(0);
    const forceRender = (0, _react.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, _react.useCallback)(()=>(0, _motionDom.frame).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}

},{"motion-dom":"7u9qw","react":"6uln9","./use-is-mounted.mjs":"3ra9B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7u9qw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupPlaybackControls", ()=>(0, _groupMjs.GroupPlaybackControls));
parcelHelpers.export(exports, "getValueTransition", ()=>(0, _getValueTransitionMjs.getValueTransition));
parcelHelpers.export(exports, "calcGeneratorDuration", ()=>(0, _calcDurationMjs.calcGeneratorDuration));
parcelHelpers.export(exports, "maxGeneratorDuration", ()=>(0, _calcDurationMjs.maxGeneratorDuration));
parcelHelpers.export(exports, "createGeneratorEasing", ()=>(0, _createGeneratorEasingMjs.createGeneratorEasing));
parcelHelpers.export(exports, "isGenerator", ()=>(0, _isGeneratorMjs.isGenerator));
parcelHelpers.export(exports, "NativeAnimationControls", ()=>(0, _nativeAnimationControlsMjs.NativeAnimationControls));
parcelHelpers.export(exports, "attachTimeline", ()=>(0, _attachTimelineMjs.attachTimeline));
parcelHelpers.export(exports, "cubicBezierAsString", ()=>(0, _easingMjs.cubicBezierAsString));
parcelHelpers.export(exports, "isWaapiSupportedEasing", ()=>(0, _easingMjs.isWaapiSupportedEasing));
parcelHelpers.export(exports, "mapEasingToNativeEasing", ()=>(0, _easingMjs.mapEasingToNativeEasing));
parcelHelpers.export(exports, "supportedWaapiEasing", ()=>(0, _easingMjs.supportedWaapiEasing));
parcelHelpers.export(exports, "generateLinearEasing", ()=>(0, _linearMjs.generateLinearEasing));
parcelHelpers.export(exports, "cancelFrame", ()=>(0, _frameMjs.cancelFrame));
parcelHelpers.export(exports, "frame", ()=>(0, _frameMjs.frame));
parcelHelpers.export(exports, "frameData", ()=>(0, _frameMjs.frameData));
parcelHelpers.export(exports, "frameSteps", ()=>(0, _frameMjs.frameSteps));
parcelHelpers.export(exports, "createRenderBatcher", ()=>(0, _batcherMjs.createRenderBatcher));
parcelHelpers.export(exports, "cancelMicrotask", ()=>(0, _microtaskMjs.cancelMicrotask));
parcelHelpers.export(exports, "microtask", ()=>(0, _microtaskMjs.microtask));
parcelHelpers.export(exports, "time", ()=>(0, _syncTimeMjs.time));
parcelHelpers.export(exports, "isDragActive", ()=>(0, _isActiveMjs.isDragActive));
parcelHelpers.export(exports, "isDragging", ()=>(0, _isActiveMjs.isDragging));
parcelHelpers.export(exports, "setDragLock", ()=>(0, _setActiveMjs.setDragLock));
parcelHelpers.export(exports, "hover", ()=>(0, _hoverMjs.hover));
parcelHelpers.export(exports, "press", ()=>(0, _indexMjs.press));
parcelHelpers.export(exports, "capturePointer", ()=>(0, _capturePointerMjs.capturePointer));
parcelHelpers.export(exports, "isNodeOrChild", ()=>(0, _isNodeOrChildMjs.isNodeOrChild));
parcelHelpers.export(exports, "isPrimaryPointer", ()=>(0, _isPrimaryPointerMjs.isPrimaryPointer));
parcelHelpers.export(exports, "recordStats", ()=>(0, _indexMjs1.recordStats));
parcelHelpers.export(exports, "activeAnimations", ()=>(0, _animationCountMjs.activeAnimations));
parcelHelpers.export(exports, "statsBuffer", ()=>(0, _bufferMjs.statsBuffer));
parcelHelpers.export(exports, "isBezierDefinition", ()=>(0, _isBezierDefinitionMjs.isBezierDefinition));
parcelHelpers.export(exports, "resolveElements", ()=>(0, _resolveElementsMjs.resolveElements));
parcelHelpers.export(exports, "supportsFlags", ()=>(0, _flagsMjs.supportsFlags));
parcelHelpers.export(exports, "supportsLinearEasing", ()=>(0, _linearEasingMjs.supportsLinearEasing));
parcelHelpers.export(exports, "supportsScrollTimeline", ()=>(0, _scrollTimelineMjs.supportsScrollTimeline));
parcelHelpers.export(exports, "MotionValue", ()=>(0, _indexMjs2.MotionValue));
parcelHelpers.export(exports, "collectMotionValues", ()=>(0, _indexMjs2.collectMotionValues));
parcelHelpers.export(exports, "motionValue", ()=>(0, _indexMjs2.motionValue));
parcelHelpers.export(exports, "ViewTransitionBuilder", ()=>(0, _indexMjs3.ViewTransitionBuilder));
parcelHelpers.export(exports, "view", ()=>(0, _indexMjs3.view));
var _groupMjs = require("./animation/controls/Group.mjs");
var _getValueTransitionMjs = require("./animation/utils/get-value-transition.mjs");
var _calcDurationMjs = require("./animation/generators/utils/calc-duration.mjs");
var _createGeneratorEasingMjs = require("./animation/generators/utils/create-generator-easing.mjs");
var _isGeneratorMjs = require("./animation/generators/utils/is-generator.mjs");
var _nativeAnimationControlsMjs = require("./animation/waapi/NativeAnimationControls.mjs");
var _attachTimelineMjs = require("./animation/waapi/utils/attach-timeline.mjs");
var _easingMjs = require("./animation/waapi/utils/easing.mjs");
var _linearMjs = require("./animation/waapi/utils/linear.mjs");
var _frameMjs = require("./frameloop/frame.mjs");
var _batcherMjs = require("./frameloop/batcher.mjs");
var _microtaskMjs = require("./frameloop/microtask.mjs");
var _syncTimeMjs = require("./frameloop/sync-time.mjs");
var _isActiveMjs = require("./gestures/drag/state/is-active.mjs");
var _setActiveMjs = require("./gestures/drag/state/set-active.mjs");
var _hoverMjs = require("./gestures/hover.mjs");
var _indexMjs = require("./gestures/press/index.mjs");
var _capturePointerMjs = require("./gestures/utils/capture-pointer.mjs");
var _isNodeOrChildMjs = require("./gestures/utils/is-node-or-child.mjs");
var _isPrimaryPointerMjs = require("./gestures/utils/is-primary-pointer.mjs");
var _indexMjs1 = require("./stats/index.mjs");
var _animationCountMjs = require("./stats/animation-count.mjs");
var _bufferMjs = require("./stats/buffer.mjs");
var _isBezierDefinitionMjs = require("./utils/is-bezier-definition.mjs");
var _resolveElementsMjs = require("./utils/resolve-elements.mjs");
var _flagsMjs = require("./utils/supports/flags.mjs");
var _linearEasingMjs = require("./utils/supports/linear-easing.mjs");
var _scrollTimelineMjs = require("./utils/supports/scroll-timeline.mjs");
var _indexMjs2 = require("./value/index.mjs");
var _indexMjs3 = require("./view/index.mjs");

},{"./animation/controls/Group.mjs":"aLJUg","./animation/utils/get-value-transition.mjs":"h70VN","./animation/generators/utils/calc-duration.mjs":"4IrXw","./animation/generators/utils/create-generator-easing.mjs":"5D2SN","./animation/generators/utils/is-generator.mjs":"3F4rz","./animation/waapi/NativeAnimationControls.mjs":"kpJmR","./animation/waapi/utils/attach-timeline.mjs":"7TLhX","./animation/waapi/utils/easing.mjs":"khqut","./animation/waapi/utils/linear.mjs":"8Mlsa","./frameloop/frame.mjs":"9XvCv","./frameloop/batcher.mjs":"gOF1L","./frameloop/microtask.mjs":"eew5N","./frameloop/sync-time.mjs":"1jSL5","./gestures/drag/state/is-active.mjs":"7lHUJ","./gestures/drag/state/set-active.mjs":"5I3Qu","./gestures/hover.mjs":"dpkzD","./gestures/press/index.mjs":"c7goC","./gestures/utils/capture-pointer.mjs":"k8GbW","./gestures/utils/is-node-or-child.mjs":"i4mUl","./gestures/utils/is-primary-pointer.mjs":"4yl88","./stats/index.mjs":"atp7u","./stats/animation-count.mjs":"8aIu0","./stats/buffer.mjs":"8NbFL","./utils/is-bezier-definition.mjs":"8oAQn","./utils/resolve-elements.mjs":"2fxZl","./utils/supports/flags.mjs":"2Re61","./utils/supports/linear-easing.mjs":"geC6g","./utils/supports/scroll-timeline.mjs":"8XqJh","./value/index.mjs":"dPYEZ","./view/index.mjs":"4Wpfs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aLJUg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupPlaybackControls", ()=>GroupPlaybackControls);
var _baseGroupMjs = require("./BaseGroup.mjs");
/**
 * TODO: This is a temporary class to support the legacy
 * thennable API
 */ class GroupPlaybackControls extends (0, _baseGroupMjs.BaseGroupPlaybackControls) {
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
}

},{"./BaseGroup.mjs":"kmgaZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kmgaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseGroupPlaybackControls", ()=>BaseGroupPlaybackControls);
var _scrollTimelineMjs = require("../../utils/supports/scroll-timeline.mjs");
class BaseGroupPlaybackControls {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        // Support for new finished Promise and legacy thennable API
        return Promise.all(this.animations.map((animation)=>"finished" in animation ? animation.finished : animation));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, _scrollTimelineMjs.supportsScrollTimeline)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else if (typeof fallback === "function") return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}

},{"../../utils/supports/scroll-timeline.mjs":"8XqJh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8XqJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsScrollTimeline", ()=>supportsScrollTimeline);
var _motionUtils = require("motion-utils");
const supportsScrollTimeline = /* @__PURE__ */ (0, _motionUtils.memo)(()=>window.ScrollTimeline !== undefined);

},{"motion-utils":"h8hZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h8hZz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUniqueItem", ()=>(0, _arrayMjs.addUniqueItem));
parcelHelpers.export(exports, "moveItem", ()=>(0, _arrayMjs.moveItem));
parcelHelpers.export(exports, "removeItem", ()=>(0, _arrayMjs.removeItem));
parcelHelpers.export(exports, "invariant", ()=>(0, _errorsMjs.invariant));
parcelHelpers.export(exports, "warning", ()=>(0, _errorsMjs.warning));
parcelHelpers.export(exports, "MotionGlobalConfig", ()=>(0, _globalConfigMjs.MotionGlobalConfig));
parcelHelpers.export(exports, "memo", ()=>(0, _memoMjs.memo));
parcelHelpers.export(exports, "noop", ()=>(0, _noopMjs.noop));
parcelHelpers.export(exports, "progress", ()=>(0, _progressMjs.progress));
parcelHelpers.export(exports, "SubscriptionManager", ()=>(0, _subscriptionManagerMjs.SubscriptionManager));
parcelHelpers.export(exports, "millisecondsToSeconds", ()=>(0, _timeConversionMjs.millisecondsToSeconds));
parcelHelpers.export(exports, "secondsToMilliseconds", ()=>(0, _timeConversionMjs.secondsToMilliseconds));
parcelHelpers.export(exports, "velocityPerSecond", ()=>(0, _velocityPerSecondMjs.velocityPerSecond));
parcelHelpers.export(exports, "hasWarned", ()=>(0, _warnOnceMjs.hasWarned));
parcelHelpers.export(exports, "warnOnce", ()=>(0, _warnOnceMjs.warnOnce));
var _arrayMjs = require("./array.mjs");
var _errorsMjs = require("./errors.mjs");
var _globalConfigMjs = require("./global-config.mjs");
var _memoMjs = require("./memo.mjs");
var _noopMjs = require("./noop.mjs");
var _progressMjs = require("./progress.mjs");
var _subscriptionManagerMjs = require("./subscription-manager.mjs");
var _timeConversionMjs = require("./time-conversion.mjs");
var _velocityPerSecondMjs = require("./velocity-per-second.mjs");
var _warnOnceMjs = require("./warn-once.mjs");

},{"./array.mjs":"4WdvQ","./errors.mjs":"6XjQ4","./global-config.mjs":"99lq1","./memo.mjs":"OFLSK","./noop.mjs":"5PFcl","./progress.mjs":"4zFH9","./subscription-manager.mjs":"iOOXA","./time-conversion.mjs":"3Nzf2","./velocity-per-second.mjs":"fk9BE","./warn-once.mjs":"3ScPG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4WdvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUniqueItem", ()=>addUniqueItem);
parcelHelpers.export(exports, "moveItem", ()=>moveItem);
parcelHelpers.export(exports, "removeItem", ()=>removeItem);
function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function moveItem([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6XjQ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "warning", ()=>warning);
var _noopMjs = require("./noop.mjs");
let warning = (0, _noopMjs.noop);
let invariant = (0, _noopMjs.noop);
var check, message, check1, message1;

},{"./noop.mjs":"5PFcl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5PFcl":[function(require,module,exports,__globalThis) {
/*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
const noop = (any)=>any;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"99lq1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionGlobalConfig", ()=>MotionGlobalConfig);
const MotionGlobalConfig = {
    skipAnimations: false,
    useManualTiming: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"OFLSK":[function(require,module,exports,__globalThis) {
/*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memo", ()=>memo);
function memo(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4zFH9":[function(require,module,exports,__globalThis) {
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progress", ()=>progress);
const progress = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iOOXA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscriptionManager", ()=>SubscriptionManager);
var _arrayMjs = require("./array.mjs");
class SubscriptionManager {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, _arrayMjs.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, _arrayMjs.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

},{"./array.mjs":"4WdvQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Nzf2":[function(require,module,exports,__globalThis) {
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecondsToSeconds", ()=>millisecondsToSeconds);
parcelHelpers.export(exports, "secondsToMilliseconds", ()=>secondsToMilliseconds);
const secondsToMilliseconds = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const millisecondsToSeconds = (milliseconds)=>milliseconds / 1000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fk9BE":[function(require,module,exports,__globalThis) {
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "velocityPerSecond", ()=>velocityPerSecond);
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ScPG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasWarned", ()=>hasWarned);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
const warned = new Set();
function hasWarned(message) {
    return warned.has(message);
}
function warnOnce(condition, message, element) {
    if (condition || warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    warned.add(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h70VN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueTransition", ()=>getValueTransition);
function getValueTransition(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4IrXw":[function(require,module,exports,__globalThis) {
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcGeneratorDuration", ()=>calcGeneratorDuration);
parcelHelpers.export(exports, "maxGeneratorDuration", ()=>maxGeneratorDuration);
const maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < maxGeneratorDuration){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= maxGeneratorDuration ? Infinity : duration;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5D2SN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGeneratorEasing", ()=>createGeneratorEasing);
var _motionUtils = require("motion-utils");
var _calcDurationMjs = require("./calc-duration.mjs");
/**
 * Create a progress => progress easing function from a generator.
 */ function createGeneratorEasing(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, _calcDurationMjs.calcGeneratorDuration)(generator), (0, _calcDurationMjs.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, _motionUtils.millisecondsToSeconds)(duration)
    };
}

},{"motion-utils":"h8hZz","./calc-duration.mjs":"4IrXw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3F4rz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isGenerator", ()=>isGenerator);
function isGenerator(type) {
    return typeof type === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kpJmR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeAnimationControls", ()=>NativeAnimationControls);
var _motionUtils = require("motion-utils");
var _attachTimelineMjs = require("./utils/attach-timeline.mjs");
class NativeAnimationControls {
    constructor(animation){
        this.animation = animation;
    }
    get duration() {
        var _a, _b, _c;
        const durationInMs = ((_b = (_a = this.animation) === null || _a === void 0 ? void 0 : _a.effect) === null || _b === void 0 ? void 0 : _b.getComputedTiming().duration) || ((_c = this.options) === null || _c === void 0 ? void 0 : _c.duration) || 300;
        return (0, _motionUtils.millisecondsToSeconds)(Number(durationInMs));
    }
    get time() {
        var _a;
        if (this.animation) return (0, _motionUtils.millisecondsToSeconds)(((_a = this.animation) === null || _a === void 0 ? void 0 : _a.currentTime) || 0);
        return 0;
    }
    set time(newTime) {
        if (this.animation) this.animation.currentTime = (0, _motionUtils.secondsToMilliseconds)(newTime);
    }
    get speed() {
        return this.animation ? this.animation.playbackRate : 1;
    }
    set speed(newSpeed) {
        if (this.animation) this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.animation ? this.animation.playState : "finished";
    }
    get startTime() {
        return this.animation ? this.animation.startTime : null;
    }
    get finished() {
        return this.animation ? this.animation.finished : Promise.resolve();
    }
    play() {
        this.animation && this.animation.play();
    }
    pause() {
        this.animation && this.animation.pause();
    }
    stop() {
        if (!this.animation || this.state === "idle" || this.state === "finished") return;
        if (this.animation.commitStyles) this.animation.commitStyles();
        this.cancel();
    }
    flatten() {
        var _a, _b;
        if (!this.animation || !((_a = this.options) === null || _a === void 0 ? void 0 : _a.allowFlatten)) return;
        (_b = this.animation.effect) === null || _b === void 0 || _b.updateTiming({
            easing: "linear"
        });
    }
    attachTimeline(timeline) {
        if (this.animation) (0, _attachTimelineMjs.attachTimeline)(this.animation, timeline);
        return 0, _motionUtils.noop;
    }
    complete() {
        this.animation && this.animation.finish();
    }
    cancel() {
        try {
            this.animation && this.animation.cancel();
        } catch (e) {}
    }
}

},{"motion-utils":"h8hZz","./utils/attach-timeline.mjs":"7TLhX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7TLhX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachTimeline", ()=>attachTimeline);
function attachTimeline(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"khqut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezierAsString", ()=>cubicBezierAsString);
parcelHelpers.export(exports, "isWaapiSupportedEasing", ()=>isWaapiSupportedEasing);
parcelHelpers.export(exports, "mapEasingToNativeEasing", ()=>mapEasingToNativeEasing);
parcelHelpers.export(exports, "supportedWaapiEasing", ()=>supportedWaapiEasing);
var _isBezierDefinitionMjs = require("../../../utils/is-bezier-definition.mjs");
var _linearEasingMjs = require("../../../utils/supports/linear-easing.mjs");
var _linearMjs = require("./linear.mjs");
function isWaapiSupportedEasing(easing) {
    return Boolean(typeof easing === "function" && (0, _linearEasingMjs.supportsLinearEasing)() || !easing || typeof easing === "string" && (easing in supportedWaapiEasing || (0, _linearEasingMjs.supportsLinearEasing)()) || (0, _isBezierDefinitionMjs.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}
const cubicBezierAsString = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ cubicBezierAsString([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ cubicBezierAsString([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ cubicBezierAsString([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ cubicBezierAsString([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function mapEasingToNativeEasing(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, _linearEasingMjs.supportsLinearEasing)()) return (0, _linearMjs.generateLinearEasing)(easing, duration);
    else if ((0, _isBezierDefinitionMjs.isBezierDefinition)(easing)) return cubicBezierAsString(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>mapEasingToNativeEasing(segmentEasing, duration) || supportedWaapiEasing.easeOut);
    else return supportedWaapiEasing[easing];
}

},{"../../../utils/is-bezier-definition.mjs":"8oAQn","../../../utils/supports/linear-easing.mjs":"geC6g","./linear.mjs":"8Mlsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8oAQn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBezierDefinition", ()=>isBezierDefinition);
const isBezierDefinition = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"geC6g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsLinearEasing", ()=>supportsLinearEasing);
var _memoMjs = require("./memo.mjs");
const supportsLinearEasing = /*@__PURE__*/ (0, _memoMjs.memoSupports)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

},{"./memo.mjs":"6XJwk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6XJwk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoSupports", ()=>memoSupports);
var _motionUtils = require("motion-utils");
var _flagsMjs = require("./flags.mjs");
function memoSupports(callback, supportsFlag) {
    const memoized = (0, _motionUtils.memo)(callback);
    return ()=>{
        var _a;
        return (_a = (0, _flagsMjs.supportsFlags)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}

},{"motion-utils":"h8hZz","./flags.mjs":"2Re61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Re61":[function(require,module,exports,__globalThis) {
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsFlags", ()=>supportsFlags);
const supportsFlags = {
    linearEasing: undefined
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Mlsa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateLinearEasing", ()=>generateLinearEasing);
var _motionUtils = require("motion-utils");
const generateLinearEasing = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, _motionUtils.progress)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};

},{"motion-utils":"h8hZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9XvCv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cancelFrame", ()=>cancelFrame);
parcelHelpers.export(exports, "frame", ()=>frame);
parcelHelpers.export(exports, "frameData", ()=>frameData);
parcelHelpers.export(exports, "frameSteps", ()=>frameSteps);
var _motionUtils = require("motion-utils");
var _batcherMjs = require("./batcher.mjs");
const { schedule: frame, cancel: cancelFrame, state: frameData, steps: frameSteps } = /* @__PURE__ */ (0, _batcherMjs.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, _motionUtils.noop), true);

},{"motion-utils":"h8hZz","./batcher.mjs":"gOF1L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOF1L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRenderBatcher", ()=>createRenderBatcher);
var _motionUtils = require("motion-utils");
var _orderMjs = require("./order.mjs");
var _renderStepMjs = require("./render-step.mjs");
const maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, _orderMjs.stepsOrder).reduce((acc, key)=>{
        acc[key] = (0, _renderStepMjs.createRenderStep)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { read, resolveKeyframes, update, preRender, render, postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, _motionUtils.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, _motionUtils.MotionGlobalConfig).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, _orderMjs.stepsOrder).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, _orderMjs.stepsOrder).length; i++)steps[(0, _orderMjs.stepsOrder)[i]].cancel(process);
    };
    return {
        schedule,
        cancel,
        state,
        steps
    };
}

},{"motion-utils":"h8hZz","./order.mjs":"kYFEK","./render-step.mjs":"b1DPF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kYFEK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stepsOrder", ()=>stepsOrder);
const stepsOrder = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b1DPF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRenderStep", ()=>createRenderStep);
var _bufferMjs = require("../stats/buffer.mjs");
function createRenderStep(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, _bufferMjs.statsBuffer).value) (0, _bufferMjs.statsBuffer).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

},{"../stats/buffer.mjs":"8NbFL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8NbFL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "statsBuffer", ()=>statsBuffer);
const statsBuffer = {
    value: null,
    addProjectionMetrics: null
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eew5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cancelMicrotask", ()=>cancelMicrotask);
parcelHelpers.export(exports, "microtask", ()=>microtask);
var _batcherMjs = require("./batcher.mjs");
const { schedule: microtask, cancel: cancelMicrotask } = /* @__PURE__ */ (0, _batcherMjs.createRenderBatcher)(queueMicrotask, false);

},{"./batcher.mjs":"gOF1L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1jSL5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "time", ()=>time);
var _motionUtils = require("motion-utils");
var _frameMjs = require("./frame.mjs");
let now;
function clearTime() {
    now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const time = {
    now: ()=>{
        if (now === undefined) time.set((0, _frameMjs.frameData).isProcessing || (0, _motionUtils.MotionGlobalConfig).useManualTiming ? (0, _frameMjs.frameData).timestamp : performance.now());
        return now;
    },
    set: (newTime)=>{
        now = newTime;
        queueMicrotask(clearTime);
    }
};

},{"motion-utils":"h8hZz","./frame.mjs":"9XvCv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7lHUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDragActive", ()=>isDragActive);
parcelHelpers.export(exports, "isDragging", ()=>isDragging);
const isDragging = {
    x: false,
    y: false
};
function isDragActive() {
    return isDragging.x || isDragging.y;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5I3Qu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setDragLock", ()=>setDragLock);
var _isActiveMjs = require("./is-active.mjs");
function setDragLock(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, _isActiveMjs.isDragging)[axis]) return null;
        else {
            (0, _isActiveMjs.isDragging)[axis] = true;
            return ()=>{
                (0, _isActiveMjs.isDragging)[axis] = false;
            };
        }
    } else {
        if ((0, _isActiveMjs.isDragging).x || (0, _isActiveMjs.isDragging).y) return null;
        else {
            (0, _isActiveMjs.isDragging).x = (0, _isActiveMjs.isDragging).y = true;
            return ()=>{
                (0, _isActiveMjs.isDragging).x = (0, _isActiveMjs.isDragging).y = false;
            };
        }
    }
}

},{"./is-active.mjs":"7lHUJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dpkzD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hover", ()=>hover);
var _isActiveMjs = require("./drag/state/is-active.mjs");
var _setupMjs = require("./utils/setup.mjs");
function isValidHover(event) {
    return !(event.pointerType === "touch" || (0, _isActiveMjs.isDragActive)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function hover(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, _setupMjs.setupGesture)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!isValidHover(enterEvent)) return;
        const { target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}

},{"./drag/state/is-active.mjs":"7lHUJ","./utils/setup.mjs":"jlkTl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlkTl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setupGesture", ()=>setupGesture);
var _resolveElementsMjs = require("../../utils/resolve-elements.mjs");
function setupGesture(elementOrSelector, options) {
    const elements = (0, _resolveElementsMjs.resolveElements)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}

},{"../../utils/resolve-elements.mjs":"2fxZl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2fxZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveElements", ()=>resolveElements);
function resolveElements(elementOrSelector, scope, selectorCache) {
    var _a;
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) // TODO: Refactor to utils package
        // invariant(
        //     Boolean(scope.current),
        //     "Scope provided, but no element detected."
        // )
        root = scope.current;
        const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c7goC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "press", ()=>press);
var _isActiveMjs = require("../drag/state/is-active.mjs");
var _capturePointerMjs = require("../utils/capture-pointer.mjs");
var _isNodeOrChildMjs = require("../utils/is-node-or-child.mjs");
var _isPrimaryPointerMjs = require("../utils/is-primary-pointer.mjs");
var _setupMjs = require("../utils/setup.mjs");
var _isKeyboardAccessibleMjs = require("./utils/is-keyboard-accessible.mjs");
var _keyboardMjs = require("./utils/keyboard.mjs");
var _stateMjs = require("./utils/state.mjs");
/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function isValidPressEvent(event) {
    return (0, _isPrimaryPointerMjs.isPrimaryPointer)(event) && !(0, _isActiveMjs.isDragActive)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function press(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, _setupMjs.setupGesture)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!target || !isValidPressEvent(startEvent) || (0, _stateMjs.isPressing).has(target)) return;
        (0, _stateMjs.isPressing).add(target);
        (0, _capturePointerMjs.capturePointer)(startEvent, "set");
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            target.removeEventListener("pointerup", onPointerUp);
            target.removeEventListener("pointercancel", onPointerCancel);
            (0, _capturePointerMjs.capturePointer)(endEvent, "release");
            if (!isValidPressEvent(endEvent) || !(0, _stateMjs.isPressing).has(target)) return;
            (0, _stateMjs.isPressing).delete(target);
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success
            });
        };
        const onPointerUp = (upEvent)=>{
            const isOutside = !upEvent.isTrusted ? false : checkOutside(upEvent, target instanceof Element ? target.getBoundingClientRect() : {
                left: 0,
                top: 0,
                right: window.innerWidth,
                bottom: window.innerHeight
            });
            if (isOutside) onPointerEnd(upEvent, false);
            else onPointerEnd(upEvent, !(target instanceof Element) || (0, _isNodeOrChildMjs.isNodeOrChild)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        target.addEventListener("pointerup", onPointerUp, eventOptions);
        target.addEventListener("pointercancel", onPointerCancel, eventOptions);
        target.addEventListener("lostpointercapture", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        target = options.useGlobalTarget ? window : target;
        let canAddKeyboardAccessibility = false;
        if (target instanceof HTMLElement) {
            canAddKeyboardAccessibility = true;
            if (!(0, _isKeyboardAccessibleMjs.isElementKeyboardAccessible)(target) && target.getAttribute("tabindex") === null) target.tabIndex = 0;
        }
        target.addEventListener("pointerdown", startPress, eventOptions);
        if (canAddKeyboardAccessibility) target.addEventListener("focus", (event)=>(0, _keyboardMjs.enableKeyboardPress)(event, eventOptions), eventOptions);
    });
    return cancelEvents;
}
function checkOutside(event, rect) {
    return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
}

},{"../drag/state/is-active.mjs":"7lHUJ","../utils/capture-pointer.mjs":"k8GbW","../utils/is-node-or-child.mjs":"i4mUl","../utils/is-primary-pointer.mjs":"4yl88","../utils/setup.mjs":"jlkTl","./utils/is-keyboard-accessible.mjs":"7z1AN","./utils/keyboard.mjs":"1y803","./utils/state.mjs":"jcuCZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k8GbW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "capturePointer", ()=>capturePointer);
function capturePointer(event, action) {
    const actionName = `${action}PointerCapture`;
    if (event.target instanceof Element && actionName in event.target && event.pointerId !== undefined) try {
        event.target[actionName](event.pointerId);
    } catch (e) {}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i4mUl":[function(require,module,exports,__globalThis) {
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeOrChild", ()=>isNodeOrChild);
const isNodeOrChild = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return isNodeOrChild(parent, child.parentElement);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4yl88":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPrimaryPointer", ()=>isPrimaryPointer);
const isPrimaryPointer = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7z1AN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElementKeyboardAccessible", ()=>isElementKeyboardAccessible);
const focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function isElementKeyboardAccessible(element) {
    return focusableElements.has(element.tagName) || element.tabIndex !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1y803":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enableKeyboardPress", ()=>enableKeyboardPress);
var _stateMjs = require("./state.mjs");
/**
 * Filter out events that are not "Enter" keys.
 */ function filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const enableKeyboardPress = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = filterEvents(()=>{
        if ((0, _stateMjs.isPressing).has(element)) return;
        firePointerEvent(element, "down");
        const handleKeyup = filterEvents(()=>{
            firePointerEvent(element, "up");
        });
        const handleBlur = ()=>firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};

},{"./state.mjs":"jcuCZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jcuCZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPressing", ()=>isPressing);
const isPressing = new WeakSet();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"atp7u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recordStats", ()=>recordStats);
var _frameMjs = require("../frameloop/frame.mjs");
var _animationCountMjs = require("./animation-count.mjs");
var _bufferMjs = require("./buffer.mjs");
function record() {
    const { value } = (0, _bufferMjs.statsBuffer);
    if (value === null) {
        (0, _frameMjs.cancelFrame)(record);
        return;
    }
    value.frameloop.rate.push((0, _frameMjs.frameData).delta);
    value.animations.mainThread.push((0, _animationCountMjs.activeAnimations).mainThread);
    value.animations.waapi.push((0, _animationCountMjs.activeAnimations).waapi);
    value.animations.layout.push((0, _animationCountMjs.activeAnimations).layout);
}
function mean(values) {
    return values.reduce((acc, value)=>acc + value, 0) / values.length;
}
function summarise(values, calcAverage = mean) {
    if (values.length === 0) return {
        min: 0,
        max: 0,
        avg: 0
    };
    return {
        min: Math.min(...values),
        max: Math.max(...values),
        avg: calcAverage(values)
    };
}
const msToFps = (ms)=>Math.round(1000 / ms);
function clearStatsBuffer() {
    (0, _bufferMjs.statsBuffer).value = null;
    (0, _bufferMjs.statsBuffer).addProjectionMetrics = null;
}
function reportStats() {
    const { value } = (0, _bufferMjs.statsBuffer);
    if (!value) throw new Error("Stats are not being measured");
    clearStatsBuffer();
    (0, _frameMjs.cancelFrame)(record);
    const summary = {
        frameloop: {
            rate: summarise(value.frameloop.rate),
            read: summarise(value.frameloop.read),
            resolveKeyframes: summarise(value.frameloop.resolveKeyframes),
            update: summarise(value.frameloop.update),
            preRender: summarise(value.frameloop.preRender),
            render: summarise(value.frameloop.render),
            postRender: summarise(value.frameloop.postRender)
        },
        animations: {
            mainThread: summarise(value.animations.mainThread),
            waapi: summarise(value.animations.waapi),
            layout: summarise(value.animations.layout)
        },
        layoutProjection: {
            nodes: summarise(value.layoutProjection.nodes),
            calculatedTargetDeltas: summarise(value.layoutProjection.calculatedTargetDeltas),
            calculatedProjections: summarise(value.layoutProjection.calculatedProjections)
        }
    };
    /**
     * Convert the rate to FPS
     */ const { rate } = summary.frameloop;
    rate.min = msToFps(rate.min);
    rate.max = msToFps(rate.max);
    rate.avg = msToFps(rate.avg);
    [rate.min, rate.max] = [
        rate.max,
        rate.min
    ];
    return summary;
}
function recordStats() {
    if ((0, _bufferMjs.statsBuffer).value) {
        clearStatsBuffer();
        throw new Error("Stats are already being measured");
    }
    const newStatsBuffer = (0, _bufferMjs.statsBuffer);
    newStatsBuffer.value = {
        frameloop: {
            rate: [],
            read: [],
            resolveKeyframes: [],
            update: [],
            preRender: [],
            render: [],
            postRender: []
        },
        animations: {
            mainThread: [],
            waapi: [],
            layout: []
        },
        layoutProjection: {
            nodes: [],
            calculatedTargetDeltas: [],
            calculatedProjections: []
        }
    };
    newStatsBuffer.addProjectionMetrics = (metrics)=>{
        const { layoutProjection } = newStatsBuffer.value;
        layoutProjection.nodes.push(metrics.nodes);
        layoutProjection.calculatedTargetDeltas.push(metrics.calculatedTargetDeltas);
        layoutProjection.calculatedProjections.push(metrics.calculatedProjections);
    };
    (0, _frameMjs.frame).postRender(record, true);
    return reportStats;
}

},{"../frameloop/frame.mjs":"9XvCv","./animation-count.mjs":"8aIu0","./buffer.mjs":"8NbFL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8aIu0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "activeAnimations", ()=>activeAnimations);
const activeAnimations = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dPYEZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionValue", ()=>MotionValue);
parcelHelpers.export(exports, "collectMotionValues", ()=>collectMotionValues);
parcelHelpers.export(exports, "motionValue", ()=>motionValue);
var _motionUtils = require("motion-utils");
var _frameMjs = require("../frameloop/frame.mjs");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const MAX_VELOCITY_DELTA = 30;
const isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const collectMotionValues = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "12.5.0";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, _syncTimeMjs.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, _syncTimeMjs.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, _motionUtils.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, _frameMjs.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if (collectMotionValues.current) collectMotionValues.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, _syncTimeMjs.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, _motionUtils.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function motionValue(init, options) {
    return new MotionValue(init, options);
}

},{"motion-utils":"h8hZz","../frameloop/frame.mjs":"9XvCv","../frameloop/sync-time.mjs":"1jSL5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Wpfs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewTransitionBuilder", ()=>ViewTransitionBuilder);
parcelHelpers.export(exports, "view", ()=>view);
var _motionUtils = require("motion-utils");
var _startMjs = require("./start.mjs");
/**
 * TODO:
 * - Create view transition on next tick
 * - Replace animations with Motion animations
 * - Return GroupAnimation on next tick
 */ class ViewTransitionBuilder {
    constructor(update, options = {}){
        this.currentTarget = "root";
        this.targets = new Map();
        this.notifyReady = (0, _motionUtils.noop);
        this.readyPromise = new Promise((resolve)=>{
            this.notifyReady = resolve;
        });
        queueMicrotask(()=>{
            (0, _startMjs.startViewAnimation)(update, options, this.targets).then((animation)=>this.notifyReady(animation));
        });
    }
    get(selector) {
        this.currentTarget = selector;
        return this;
    }
    layout(keyframes, options) {
        this.updateTarget("layout", keyframes, options);
        return this;
    }
    new(keyframes, options) {
        this.updateTarget("new", keyframes, options);
        return this;
    }
    old(keyframes, options) {
        this.updateTarget("old", keyframes, options);
        return this;
    }
    enter(keyframes, options) {
        this.updateTarget("enter", keyframes, options);
        return this;
    }
    exit(keyframes, options) {
        this.updateTarget("exit", keyframes, options);
        return this;
    }
    crossfade(options) {
        this.updateTarget("enter", {
            opacity: 1
        }, options);
        this.updateTarget("exit", {
            opacity: 0
        }, options);
        return this;
    }
    updateTarget(target, keyframes, options = {}) {
        const { currentTarget, targets } = this;
        if (!targets.has(currentTarget)) targets.set(currentTarget, {});
        const targetData = targets.get(currentTarget);
        targetData[target] = {
            keyframes,
            options
        };
    }
    then(resolve, reject) {
        return this.readyPromise.then(resolve, reject);
    }
}
function view(update, defaultOptions = {}) {
    return new ViewTransitionBuilder(update, defaultOptions);
}

},{"motion-utils":"h8hZz","./start.mjs":"3D1sy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3D1sy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startViewAnimation", ()=>startViewAnimation);
var _motionUtils = require("motion-utils");
var _baseGroupMjs = require("../animation/controls/BaseGroup.mjs");
var _getValueTransitionMjs = require("../animation/utils/get-value-transition.mjs");
var _nativeAnimationControlsMjs = require("../animation/waapi/NativeAnimationControls.mjs");
var _pseudoAnimationMjs = require("../animation/waapi/PseudoAnimation.mjs");
var _convertOptionsMjs = require("../animation/waapi/utils/convert-options.mjs");
var _easingMjs = require("../animation/waapi/utils/easing.mjs");
var _chooseLayerTypeMjs = require("./utils/choose-layer-type.mjs");
var _cssMjs = require("./utils/css.mjs");
var _getLayerNameMjs = require("./utils/get-layer-name.mjs");
var _getViewAnimationsMjs = require("./utils/get-view-animations.mjs");
var _hasTargetMjs = require("./utils/has-target.mjs");
const definitionNames = [
    "layout",
    "enter",
    "exit",
    "new",
    "old"
];
function startViewAnimation(update, defaultOptions, targets) {
    if (!document.startViewTransition) return new Promise(async (resolve)=>{
        await update();
        resolve(new (0, _baseGroupMjs.BaseGroupPlaybackControls)([]));
    });
    // TODO: Go over existing targets and ensure they all have ids
    /**
     * If we don't have any animations defined for the root target,
     * remove it from being captured.
     */ if (!(0, _hasTargetMjs.hasTarget)("root", targets)) (0, _cssMjs.css).set(":root", {
        "view-transition-name": "none"
    });
    /**
     * Set the timing curve to linear for all view transition layers.
     * This gets baked into the keyframes, which can't be changed
     * without breaking the generated animation.
     *
     * This allows us to set easing via updateTiming - which can be changed.
     */ (0, _cssMjs.css).set("::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)", {
        "animation-timing-function": "linear !important"
    });
    (0, _cssMjs.css).commit(); // Write
    const transition = document.startViewTransition(async ()=>{
        await update();
    // TODO: Go over new targets and ensure they all have ids
    });
    transition.finished.finally(()=>{
        (0, _cssMjs.css).remove(); // Write
    });
    return new Promise((resolve)=>{
        transition.ready.then(()=>{
            var _a;
            const generatedViewAnimations = (0, _getViewAnimationsMjs.getViewAnimations)();
            const animations = [];
            /**
             * Create animations for our definitions
             */ targets.forEach((definition, target)=>{
                // TODO: If target is not "root", resolve elements
                // and iterate over each
                for (const key of definitionNames){
                    if (!definition[key]) continue;
                    const { keyframes, options } = definition[key];
                    for (let [valueName, valueKeyframes] of Object.entries(keyframes)){
                        if (!valueKeyframes) continue;
                        const valueOptions = {
                            ...(0, _getValueTransitionMjs.getValueTransition)(defaultOptions, valueName),
                            ...(0, _getValueTransitionMjs.getValueTransition)(options, valueName)
                        };
                        const type = (0, _chooseLayerTypeMjs.chooseLayerType)(key);
                        /**
                         * If this is an opacity animation, and keyframes are not an array,
                         * we need to convert them into an array and set an initial value.
                         */ if (valueName === "opacity" && !Array.isArray(valueKeyframes)) {
                            const initialValue = type === "new" ? 0 : 1;
                            valueKeyframes = [
                                initialValue,
                                valueKeyframes
                            ];
                        }
                        /**
                         * Resolve stagger function if provided.
                         */ if (typeof valueOptions.delay === "function") valueOptions.delay = valueOptions.delay(0, 1);
                        const animation = new (0, _pseudoAnimationMjs.PseudoAnimation)(document.documentElement, `::view-transition-${type}(${target})`, valueName, valueKeyframes, valueOptions);
                        animations.push(animation);
                    }
                }
            });
            /**
             * Handle browser generated animations
             */ for (const animation of generatedViewAnimations){
                if (animation.playState === "finished") continue;
                const { effect } = animation;
                if (!effect || !(effect instanceof KeyframeEffect)) continue;
                const { pseudoElement } = effect;
                if (!pseudoElement) continue;
                const name = (0, _getLayerNameMjs.getLayerName)(pseudoElement);
                if (!name) continue;
                const targetDefinition = targets.get(name.layer);
                if (!targetDefinition) {
                    /**
                     * If transition name is group then update the timing of the animation
                     * whereas if it's old or new then we could possibly replace it using
                     * the above method.
                     */ const transitionName = name.type === "group" ? "layout" : "";
                    const animationTransition = {
                        ...(0, _getValueTransitionMjs.getValueTransition)(defaultOptions, transitionName)
                    };
                    (0, _convertOptionsMjs.applyGeneratorOptions)(animationTransition);
                    const easing = (0, _easingMjs.mapEasingToNativeEasing)(animationTransition.ease, animationTransition.duration);
                    effect.updateTiming({
                        delay: (0, _motionUtils.secondsToMilliseconds)((_a = animationTransition.delay) !== null && _a !== void 0 ? _a : 0),
                        duration: animationTransition.duration,
                        easing
                    });
                    animations.push(new (0, _nativeAnimationControlsMjs.NativeAnimationControls)(animation));
                } else if (hasOpacity(targetDefinition, "enter") && hasOpacity(targetDefinition, "exit") && effect.getKeyframes().some((keyframe)=>keyframe.mixBlendMode)) animations.push(new (0, _nativeAnimationControlsMjs.NativeAnimationControls)(animation));
                else animation.cancel();
            }
            resolve(new (0, _baseGroupMjs.BaseGroupPlaybackControls)(animations));
        });
    });
}
function hasOpacity(target, key) {
    var _a;
    return (_a = target === null || target === void 0 ? void 0 : target[key]) === null || _a === void 0 ? void 0 : _a.keyframes.opacity;
}

},{"motion-utils":"h8hZz","../animation/controls/BaseGroup.mjs":"kmgaZ","../animation/utils/get-value-transition.mjs":"h70VN","../animation/waapi/NativeAnimationControls.mjs":"kpJmR","../animation/waapi/PseudoAnimation.mjs":"d4aBI","../animation/waapi/utils/convert-options.mjs":"4yvTg","../animation/waapi/utils/easing.mjs":"khqut","./utils/choose-layer-type.mjs":"cwc6G","./utils/css.mjs":"5DicX","./utils/get-layer-name.mjs":"iuKPB","./utils/get-view-animations.mjs":"7Ws2d","./utils/has-target.mjs":"9c2Ip","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d4aBI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PseudoAnimation", ()=>PseudoAnimation);
var _nativeAnimationControlsMjs = require("./NativeAnimationControls.mjs");
var _convertOptionsMjs = require("./utils/convert-options.mjs");
class PseudoAnimation extends (0, _nativeAnimationControlsMjs.NativeAnimationControls) {
    constructor(target, pseudoElement, valueName, keyframes, options){
        const animationOptions = (0, _convertOptionsMjs.convertMotionOptionsToNative)(valueName, keyframes, options);
        const animation = target.animate(animationOptions.keyframes, {
            pseudoElement,
            ...animationOptions.options
        });
        super(animation);
    }
}

},{"./NativeAnimationControls.mjs":"kpJmR","./utils/convert-options.mjs":"4yvTg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4yvTg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyGeneratorOptions", ()=>applyGeneratorOptions);
parcelHelpers.export(exports, "convertMotionOptionsToNative", ()=>convertMotionOptionsToNative);
var _motionUtils = require("motion-utils");
var _linearEasingMjs = require("../../../utils/supports/linear-easing.mjs");
var _createGeneratorEasingMjs = require("../../generators/utils/create-generator-easing.mjs");
var _isGeneratorMjs = require("../../generators/utils/is-generator.mjs");
var _easingMjs = require("./easing.mjs");
const defaultEasing = "easeOut";
function applyGeneratorOptions(options) {
    var _a;
    if ((0, _isGeneratorMjs.isGenerator)(options.type)) {
        const generatorOptions = (0, _createGeneratorEasingMjs.createGeneratorEasing)(options, 100, options.type);
        options.ease = (0, _linearEasingMjs.supportsLinearEasing)() ? generatorOptions.ease : defaultEasing;
        options.duration = (0, _motionUtils.secondsToMilliseconds)(generatorOptions.duration);
        options.type = "keyframes";
    } else {
        options.duration = (0, _motionUtils.secondsToMilliseconds)((_a = options.duration) !== null && _a !== void 0 ? _a : 0.3);
        options.ease = options.ease || defaultEasing;
    }
}
// TODO: Reuse for NativeAnimation
function convertMotionOptionsToNative(valueName, keyframes, options) {
    var _a;
    const nativeKeyframes = {};
    const nativeOptions = {
        fill: "both",
        easing: "linear",
        composite: "replace"
    };
    nativeOptions.delay = (0, _motionUtils.secondsToMilliseconds)((_a = options.delay) !== null && _a !== void 0 ? _a : 0);
    applyGeneratorOptions(options);
    nativeOptions.duration = options.duration;
    const { ease, times } = options;
    if (times) nativeKeyframes.offset = times;
    nativeKeyframes[valueName] = keyframes;
    const easing = (0, _easingMjs.mapEasingToNativeEasing)(ease, options.duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) nativeKeyframes.easing = easing;
    else nativeOptions.easing = easing;
    return {
        keyframes: nativeKeyframes,
        options: nativeOptions
    };
}

},{"motion-utils":"h8hZz","../../../utils/supports/linear-easing.mjs":"geC6g","../../generators/utils/create-generator-easing.mjs":"5D2SN","../../generators/utils/is-generator.mjs":"3F4rz","./easing.mjs":"khqut","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cwc6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chooseLayerType", ()=>chooseLayerType);
function chooseLayerType(valueName) {
    if (valueName === "layout") return "group";
    if (valueName === "enter" || valueName === "new") return "new";
    if (valueName === "exit" || valueName === "old") return "old";
    return "group";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5DicX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>css);
let pendingRules = {};
let style = null;
const css = {
    set: (selector, values)=>{
        pendingRules[selector] = values;
    },
    commit: ()=>{
        if (!style) {
            style = document.createElement("style");
            style.id = "motion-view";
        }
        let cssText = "";
        for(const selector in pendingRules){
            const rule = pendingRules[selector];
            cssText += `${selector} {\n`;
            for (const [property, value] of Object.entries(rule))cssText += `  ${property}: ${value};\n`;
            cssText += "}\n";
        }
        style.textContent = cssText;
        document.head.appendChild(style);
        pendingRules = {};
    },
    remove: ()=>{
        if (style && style.parentElement) style.parentElement.removeChild(style);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iuKPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLayerName", ()=>getLayerName);
function getLayerName(pseudoElement) {
    const match = pseudoElement.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
    if (!match) return null;
    return {
        layer: match[2],
        type: match[1]
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Ws2d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getViewAnimations", ()=>getViewAnimations);
function filterViewAnimations(animation) {
    var _a;
    const { effect } = animation;
    if (!effect) return false;
    return effect.target === document.documentElement && ((_a = effect.pseudoElement) === null || _a === void 0 ? void 0 : _a.startsWith("::view-transition"));
}
function getViewAnimations() {
    return document.getAnimations().filter(filterViewAnimations);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9c2Ip":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasTarget", ()=>hasTarget);
function hasTarget(target, targets) {
    return targets.has(target) && Object.keys(targets.get(target)).length > 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ra9B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMounted", ()=>useIsMounted);
var _react = require("react");
var _useIsomorphicEffectMjs = require("./use-isomorphic-effect.mjs");
function useIsMounted() {
    const isMounted = (0, _react.useRef)(false);
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

},{"react":"6uln9","./use-isomorphic-effect.mjs":"6Pcpq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4VHFR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodeGroup", ()=>nodeGroup);
const notify = (node)=>!node.isLayoutDirty && node.willUpdate(false);
function nodeGroup() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = ()=>nodes.forEach(notify);
    return {
        add: (node)=>{
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node)=>{
            nodes.delete(node);
            const unsubscribe = subscriptions.get(node);
            if (unsubscribe) {
                unsubscribe();
                subscriptions.delete(node);
            }
            dirtyAll();
        },
        dirty: dirtyAll
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"NzqXO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "motion", ()=>motion);
var _createProxyMjs = require("../create-proxy.mjs");
var _createMjs = require("./create.mjs");
const motion = /*@__PURE__*/ (0, _createProxyMjs.createDOMMotionComponentProxy)((0, _createMjs.createMotionComponent));

},{"../create-proxy.mjs":"7LQXy","./create.mjs":"73M23","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7LQXy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDOMMotionComponentProxy", ()=>createDOMMotionComponentProxy);
var _motionUtils = require("motion-utils");
function createDOMMotionComponentProxy(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}

},{"motion-utils":"h8hZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73M23":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMotionComponent", ()=>createMotionComponent);
var _animationsMjs = require("../../../motion/features/animations.mjs");
var _dragMjs = require("../../../motion/features/drag.mjs");
var _gesturesMjs = require("../../../motion/features/gestures.mjs");
var _layoutMjs = require("../../../motion/features/layout.mjs");
var _createFactoryMjs = require("../create-factory.mjs");
var _createVisualElementMjs = require("../../dom/create-visual-element.mjs");
const createMotionComponent = /*@__PURE__*/ (0, _createFactoryMjs.createMotionComponentFactory)({
    ...(0, _animationsMjs.animations),
    ...(0, _gesturesMjs.gestureAnimations),
    ...(0, _dragMjs.drag),
    ...(0, _layoutMjs.layout)
}, (0, _createVisualElementMjs.createDomVisualElement));

},{"../../../motion/features/animations.mjs":"Rvk5C","../../../motion/features/drag.mjs":"89DRL","../../../motion/features/gestures.mjs":"7BuHh","../../../motion/features/layout.mjs":"81FkM","../create-factory.mjs":"iMlVh","../../dom/create-visual-element.mjs":"7HD63","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Rvk5C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animations", ()=>animations);
var _indexMjs = require("./animation/index.mjs");
var _exitMjs = require("./animation/exit.mjs");
const animations = {
    animation: {
        Feature: (0, _indexMjs.AnimationFeature)
    },
    exit: {
        Feature: (0, _exitMjs.ExitAnimationFeature)
    }
};

},{"./animation/index.mjs":"6J9oh","./animation/exit.mjs":"evYau","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6J9oh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFeature", ()=>AnimationFeature);
var _isAnimationControlsMjs = require("../../../animation/utils/is-animation-controls.mjs");
var _animationStateMjs = require("../../../render/utils/animation-state.mjs");
var _featureMjs = require("../Feature.mjs");
class AnimationFeature extends (0, _featureMjs.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, _animationStateMjs.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate } = this.node.getProps();
        if ((0, _isAnimationControlsMjs.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}

},{"../../../animation/utils/is-animation-controls.mjs":"fDSp3","../../../render/utils/animation-state.mjs":"jfRti","../Feature.mjs":"9q59Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fDSp3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnimationControls", ()=>isAnimationControls);
function isAnimationControls(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfRti":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkVariantsDidChange", ()=>checkVariantsDidChange);
parcelHelpers.export(exports, "createAnimationState", ()=>createAnimationState);
var _visualElementMjs = require("../../animation/interfaces/visual-element.mjs");
var _isAnimationControlsMjs = require("../../animation/utils/is-animation-controls.mjs");
var _isKeyframesTargetMjs = require("../../animation/utils/is-keyframes-target.mjs");
var _shallowCompareMjs = require("../../utils/shallow-compare.mjs");
var _getVariantContextMjs = require("./get-variant-context.mjs");
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _resolveDynamicVariantsMjs = require("./resolve-dynamic-variants.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
const reversePriorityOrder = [
    ...(0, _variantPropsMjs.variantPriorityOrder)
].reverse();
const numAnimationTypes = (0, _variantPropsMjs.variantPriorityOrder).length;
function animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation, options })=>(0, _visualElementMjs.animateVisualElement)(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
    let animate = animateList(visualElement);
    let state = createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition, transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props } = visualElement;
        const context = (0, _getVariantContextMjs.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < numAnimationTypes; i++){
            const type = reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, _isVariantLabelMjs.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, _isAnimationControlsMjs.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, _isKeyframesTargetMjs.isKeyframesTarget)(next) && (0, _isKeyframesTargetMjs.isKeyframesTarget)(prev)) valueHasChanged = !(0, _shallowCompareMjs.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges,
        setActive,
        setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = createState();
            isInitialRender = true;
        }
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, _shallowCompareMjs.shallowCompare)(next, prev);
    return false;
}
function createTypeState(isActive = false) {
    return {
        isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function createState() {
    return {
        animate: createTypeState(true),
        whileInView: createTypeState(),
        whileHover: createTypeState(),
        whileTap: createTypeState(),
        whileDrag: createTypeState(),
        whileFocus: createTypeState(),
        exit: createTypeState()
    };
}

},{"../../animation/interfaces/visual-element.mjs":"iC4fb","../../animation/utils/is-animation-controls.mjs":"fDSp3","../../animation/utils/is-keyframes-target.mjs":"b9ZPA","../../utils/shallow-compare.mjs":"5YaEU","./get-variant-context.mjs":"mqqVY","./is-variant-label.mjs":"hGXyz","./resolve-dynamic-variants.mjs":"4tXnT","./variant-props.mjs":"8wQuM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iC4fb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateVisualElement", ()=>animateVisualElement);
var _resolveDynamicVariantsMjs = require("../../render/utils/resolve-dynamic-variants.mjs");
var _visualElementTargetMjs = require("./visual-element-target.mjs");
var _visualElementVariantMjs = require("./visual-element-variant.mjs");
function animateVisualElement(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, _visualElementVariantMjs.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, _visualElementVariantMjs.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, _visualElementTargetMjs.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}

},{"../../render/utils/resolve-dynamic-variants.mjs":"4tXnT","./visual-element-target.mjs":"j8sQ3","./visual-element-variant.mjs":"6BoKt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4tXnT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveVariant", ()=>resolveVariant);
var _resolveVariantsMjs = require("./resolve-variants.mjs");
function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, _resolveVariantsMjs.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

},{"./resolve-variants.mjs":"iR2sd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iR2sd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveVariantFromProps", ()=>resolveVariantFromProps);
function getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function resolveVariantFromProps(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j8sQ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateTarget", ()=>animateTarget);
var _motionDom = require("motion-dom");
var _keysPositionMjs = require("../../render/html/utils/keys-position.mjs");
var _settersMjs = require("../../render/utils/setters.mjs");
var _addWillChangeMjs = require("../../value/use-will-change/add-will-change.mjs");
var _getAppearIdMjs = require("../optimized-appear/get-appear-id.mjs");
var _motionValueMjs = require("./motion-value.mjs");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition, { delay = 0, transitionOverride, type } = {}) {
    var _a;
    let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay,
            ...(0, _motionDom.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, _getAppearIdMjs.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, _motionDom.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, _addWillChangeMjs.addValueToWillChange)(visualElement, key);
        value.start((0, _motionValueMjs.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, _keysPositionMjs.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, _motionDom.frame).update(()=>{
            transitionEnd && (0, _settersMjs.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

},{"motion-dom":"7u9qw","../../render/html/utils/keys-position.mjs":"dye1m","../../render/utils/setters.mjs":"jlhrk","../../value/use-will-change/add-will-change.mjs":"hEJzz","../optimized-appear/get-appear-id.mjs":"bvIte","./motion-value.mjs":"lumbS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dye1m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "positionalKeys", ()=>positionalKeys);
var _keysTransformMjs = require("./keys-transform.mjs");
const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, _keysTransformMjs.transformPropOrder)
]);

},{"./keys-transform.mjs":"b4poF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b4poF":[function(require,module,exports,__globalThis) {
/**
 * Generate a list of every possible transform key.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformPropOrder", ()=>transformPropOrder);
parcelHelpers.export(exports, "transformProps", ()=>transformProps);
const transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const transformProps = new Set(transformPropOrder);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlhrk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setTarget", ()=>setTarget);
var _motionDom = require("motion-dom");
var _resolveValueMjs = require("../../utils/resolve-value.mjs");
var _resolveDynamicVariantsMjs = require("./resolve-dynamic-variants.mjs");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, _motionDom.motionValue)(value));
}
function setTarget(visualElement, definition) {
    const resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition);
    let { transitionEnd = {}, transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, _resolveValueMjs.resolveFinalValueInKeyframes)(target[key]);
        setMotionValue(visualElement, key, value);
    }
}

},{"motion-dom":"7u9qw","../../utils/resolve-value.mjs":"b1tRE","./resolve-dynamic-variants.mjs":"4tXnT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b1tRE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCustomValue", ()=>isCustomValue);
parcelHelpers.export(exports, "resolveFinalValueInKeyframes", ()=>resolveFinalValueInKeyframes);
var _isKeyframesTargetMjs = require("../animation/utils/is-keyframes-target.mjs");
const isCustomValue = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, _isKeyframesTargetMjs.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

},{"../animation/utils/is-keyframes-target.mjs":"b9ZPA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9ZPA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isKeyframesTarget", ()=>isKeyframesTarget);
const isKeyframesTarget = (v)=>{
    return Array.isArray(v);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hEJzz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addValueToWillChange", ()=>addValueToWillChange);
var _isMjs = require("./is.mjs");
function addValueToWillChange(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, _isMjs.isWillChangeMotionValue)(willChange)) return willChange.add(key);
}

},{"./is.mjs":"cLEeP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cLEeP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWillChangeMotionValue", ()=>isWillChangeMotionValue);
var _isMotionValueMjs = require("../utils/is-motion-value.mjs");
function isWillChangeMotionValue(value) {
    return Boolean((0, _isMotionValueMjs.isMotionValue)(value) && value.add);
}

},{"../utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2kZP7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMotionValue", ()=>isMotionValue);
const isMotionValue = (value)=>Boolean(value && value.getVelocity);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bvIte":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptimisedAppearId", ()=>getOptimisedAppearId);
var _dataIdMjs = require("./data-id.mjs");
function getOptimisedAppearId(visualElement) {
    return visualElement.props[0, _dataIdMjs.optimizedAppearDataAttribute];
}

},{"./data-id.mjs":"jLjpN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jLjpN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optimizedAppearDataAttribute", ()=>optimizedAppearDataAttribute);
parcelHelpers.export(exports, "optimizedAppearDataId", ()=>optimizedAppearDataId);
var _camelToDashMjs = require("../../render/dom/utils/camel-to-dash.mjs");
const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + (0, _camelToDashMjs.camelToDash)(optimizedAppearDataId);

},{"../../render/dom/utils/camel-to-dash.mjs":"kNuZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kNuZz":[function(require,module,exports,__globalThis) {
/**
 * Convert camelCase to dash-case properties.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelToDash", ()=>camelToDash);
const camelToDash = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lumbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateMotionValue", ()=>animateMotionValue);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _useInstantTransitionStateMjs = require("../../utils/use-instant-transition-state.mjs");
var _acceleratedAnimationMjs = require("../animators/AcceleratedAnimation.mjs");
var _mainThreadAnimationMjs = require("../animators/MainThreadAnimation.mjs");
var _getFinalKeyframeMjs = require("../animators/waapi/utils/get-final-keyframe.mjs");
var _defaultTransitionsMjs = require("../utils/default-transitions.mjs");
var _isTransitionDefinedMjs = require("../utils/is-transition-defined.mjs");
const animateMotionValue = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, _motionDom.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed = 0 } = transition;
        elapsed = elapsed - (0, _motionUtils.secondsToMilliseconds)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, _isTransitionDefinedMjs.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, _defaultTransitionsMjs.getDefaultTransition)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, _motionUtils.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, _motionUtils.secondsToMilliseconds)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, _useInstantTransitionStateMjs.instantAnimationState).current || (0, _motionUtils.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, _getFinalKeyframeMjs.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, _motionDom.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, _motionDom.GroupPlaybackControls)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, _acceleratedAnimationMjs.AcceleratedAnimation).supports(options)) return new (0, _acceleratedAnimationMjs.AcceleratedAnimation)(options);
        else return new (0, _mainThreadAnimationMjs.MainThreadAnimation)(options);
    };

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../utils/use-instant-transition-state.mjs":"91bNg","../animators/AcceleratedAnimation.mjs":"1kcLB","../animators/MainThreadAnimation.mjs":"7fjnK","../animators/waapi/utils/get-final-keyframe.mjs":"94snX","../utils/default-transitions.mjs":"1j1Wa","../utils/is-transition-defined.mjs":"afONc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"91bNg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instantAnimationState", ()=>instantAnimationState);
const instantAnimationState = {
    current: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1kcLB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AcceleratedAnimation", ()=>AcceleratedAnimation);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _anticipateMjs = require("../../easing/anticipate.mjs");
var _backMjs = require("../../easing/back.mjs");
var _circMjs = require("../../easing/circ.mjs");
var _domkeyframesResolverMjs = require("../../render/dom/DOMKeyframesResolver.mjs");
var _baseAnimationMjs = require("./BaseAnimation.mjs");
var _mainThreadAnimationMjs = require("./MainThreadAnimation.mjs");
var _acceleratedValuesMjs = require("./utils/accelerated-values.mjs");
var _indexMjs = require("./waapi/index.mjs");
var _getFinalKeyframeMjs = require("./waapi/utils/get-final-keyframe.mjs");
var _supportsWaapiMjs = require("./waapi/utils/supports-waapi.mjs");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function requiresPregeneratedKeyframes(options) {
    return (0, _motionDom.isGenerator)(options.type) || options.type === "spring" || !(0, _motionDom.isWaapiSupportedEasing)(options.ease);
}
function pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, _mainThreadAnimationMjs.MainThreadAnimation)({
        ...options,
        keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - sampleDelta,
        ease: "linear"
    };
}
const unsupportedEasingFunctions = {
    anticipate: (0, _anticipateMjs.anticipate),
    backInOut: (0, _backMjs.backInOut),
    circInOut: (0, _circMjs.circInOut)
};
function isUnsupportedEase(key) {
    return key in unsupportedEasingFunctions;
}
class AcceleratedAnimation extends (0, _baseAnimationMjs.BaseAnimation) {
    constructor(options){
        super(options);
        const { name, motionValue, element, keyframes } = this.options;
        this.resolver = new (0, _domkeyframesResolverMjs.DOMKeyframesResolver)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        let { duration = 300, times, ease, type, motionValue, name, startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!motionValue.owner || !motionValue.owner.current) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, _motionDom.supportsLinearEasing)() && isUnsupportedEase(ease)) ease = unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if (requiresPregeneratedKeyframes(this.options)) {
            const { onComplete, onUpdate, motionValue, element, ...options } = this.options;
            const pregeneratedAnimation = pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, _indexMjs.startWaapiAnimation)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration,
            times,
            ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, _motionDom.attachTimeline)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete } = this.options;
            motionValue.set((0, _getFinalKeyframeMjs.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation,
            duration,
            times,
            type,
            ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved } = this;
        if (!resolved) return 0;
        const { duration } = resolved;
        return (0, _motionUtils.millisecondsToSeconds)(duration);
    }
    get time() {
        const { resolved } = this;
        if (!resolved) return 0;
        const { animation } = resolved;
        return (0, _motionUtils.millisecondsToSeconds)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved } = this;
        if (!resolved) return;
        const { animation } = resolved;
        animation.currentTime = (0, _motionUtils.secondsToMilliseconds)(newTime);
    }
    get speed() {
        const { resolved } = this;
        if (!resolved) return 1;
        const { animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved } = this;
        if (!resolved) return;
        const { animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved } = this;
        if (!resolved) return "idle";
        const { animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved } = this;
        if (!resolved) return null;
        const { animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved } = this;
            if (!resolved) return 0, _motionUtils.noop;
            const { animation } = resolved;
            (0, _motionDom.attachTimeline)(animation, timeline);
        }
        return 0, _motionUtils.noop;
    }
    play() {
        if (this.isStopped) return;
        const { resolved } = this;
        if (!resolved) return;
        const { animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved } = this;
        if (!resolved) return;
        const { animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved } = this;
        if (!resolved) return;
        const { animation, keyframes, duration, type, ease, times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue, onUpdate, onComplete, element, ...options } = this.options;
            const sampleAnimation = new (0, _mainThreadAnimationMjs.MainThreadAnimation)({
                ...options,
                keyframes,
                duration,
                type,
                ease,
                times,
                isGenerator: true
            });
            const sampleTime = (0, _motionUtils.secondsToMilliseconds)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - sampleDelta).value, sampleAnimation.sample(sampleTime).value, sampleDelta);
        }
        const { onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue, name, repeatDelay, repeatType, damping, type } = options;
        if (!motionValue || !motionValue.owner || !(motionValue.owner.current instanceof HTMLElement)) return false;
        const { onUpdate, transformTemplate } = motionValue.owner.getProps();
        return (0, _supportsWaapiMjs.supportsWaapi)() && name && (0, _acceleratedValuesMjs.acceleratedValues).has(name) && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !onUpdate && !transformTemplate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../easing/anticipate.mjs":"dNYZe","../../easing/back.mjs":"ltXlp","../../easing/circ.mjs":"do4I6","../../render/dom/DOMKeyframesResolver.mjs":"7XPYj","./BaseAnimation.mjs":"ebVyf","./MainThreadAnimation.mjs":"7fjnK","./utils/accelerated-values.mjs":"1SuWp","./waapi/index.mjs":"evYrX","./waapi/utils/get-final-keyframe.mjs":"94snX","./waapi/utils/supports-waapi.mjs":"947uV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dNYZe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "anticipate", ()=>anticipate);
var _backMjs = require("./back.mjs");
const anticipate = (p)=>(p *= 2) < 1 ? 0.5 * (0, _backMjs.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

},{"./back.mjs":"ltXlp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ltXlp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backIn", ()=>backIn);
parcelHelpers.export(exports, "backInOut", ()=>backInOut);
parcelHelpers.export(exports, "backOut", ()=>backOut);
var _cubicBezierMjs = require("./cubic-bezier.mjs");
var _mirrorMjs = require("./modifiers/mirror.mjs");
var _reverseMjs = require("./modifiers/reverse.mjs");
const backOut = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const backIn = /*@__PURE__*/ (0, _reverseMjs.reverseEasing)(backOut);
const backInOut = /*@__PURE__*/ (0, _mirrorMjs.mirrorEasing)(backIn);

},{"./cubic-bezier.mjs":"kosBT","./modifiers/mirror.mjs":"gCkJC","./modifiers/reverse.mjs":"gWJrc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kosBT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezier", ()=>cubicBezier);
var _motionUtils = require("motion-utils");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, _motionUtils.noop;
    const getTForX = (aX)=>binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

},{"motion-utils":"h8hZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gCkJC":[function(require,module,exports,__globalThis) {
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mirrorEasing", ()=>mirrorEasing);
const mirrorEasing = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWJrc":[function(require,module,exports,__globalThis) {
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reverseEasing", ()=>reverseEasing);
const reverseEasing = (easing)=>(p)=>1 - easing(1 - p);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"do4I6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "circIn", ()=>circIn);
parcelHelpers.export(exports, "circInOut", ()=>circInOut);
parcelHelpers.export(exports, "circOut", ()=>circOut);
var _mirrorMjs = require("./modifiers/mirror.mjs");
var _reverseMjs = require("./modifiers/reverse.mjs");
const circIn = (p)=>1 - Math.sin(Math.acos(p));
const circOut = (0, _reverseMjs.reverseEasing)(circIn);
const circInOut = (0, _mirrorMjs.mirrorEasing)(circIn);

},{"./modifiers/mirror.mjs":"gCkJC","./modifiers/reverse.mjs":"gWJrc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7XPYj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMKeyframesResolver", ()=>DOMKeyframesResolver);
var _isNoneMjs = require("../../animation/utils/is-none.mjs");
var _keysPositionMjs = require("../html/utils/keys-position.mjs");
var _makeNoneAnimatableMjs = require("../html/utils/make-none-animatable.mjs");
var _keyframesResolverMjs = require("../utils/KeyframesResolver.mjs");
var _cssVariablesConversionMjs = require("./utils/css-variables-conversion.mjs");
var _isCssVariableMjs = require("./utils/is-css-variable.mjs");
var _unitConversionMjs = require("./utils/unit-conversion.mjs");
var _dimensionsMjs = require("./value-types/dimensions.mjs");
class DOMKeyframesResolver extends (0, _keyframesResolverMjs.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes, element, name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, _isCssVariableMjs.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, _cssVariablesConversionMjs.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, _keysPositionMjs.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, _dimensionsMjs.findDimensionValueType)(origin);
        const targetType = (0, _dimensionsMjs.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, _unitConversionMjs.isNumOrPxType)(originType) && (0, _unitConversionMjs.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes, name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, _isNoneMjs.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, _makeNoneAnimatableMjs.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element, unresolvedKeyframes, name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, _unitConversionMjs.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element, name, unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, _unitConversionMjs.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

},{"../../animation/utils/is-none.mjs":"cckdv","../html/utils/keys-position.mjs":"dye1m","../html/utils/make-none-animatable.mjs":"9wm1O","../utils/KeyframesResolver.mjs":"02uFt","./utils/css-variables-conversion.mjs":"7QWs3","./utils/is-css-variable.mjs":"58wqN","./utils/unit-conversion.mjs":"eYlAT","./value-types/dimensions.mjs":"8qh9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cckdv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNone", ()=>isNone);
var _isZeroValueStringMjs = require("../../utils/is-zero-value-string.mjs");
function isNone(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, _isZeroValueStringMjs.isZeroValueString)(value);
    else return true;
}

},{"../../utils/is-zero-value-string.mjs":"2ZdX2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ZdX2":[function(require,module,exports,__globalThis) {
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isZeroValueString", ()=>isZeroValueString);
const isZeroValueString = (v)=>/^0[^.\s]+$/u.test(v);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9wm1O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeNoneKeyframesAnimatable", ()=>makeNoneKeyframesAnimatable);
var _indexMjs = require("../../../value/types/complex/index.mjs");
var _animatableNoneMjs = require("../../dom/value-types/animatable-none.mjs");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !invalidTemplates.has(keyframe) && (0, _indexMjs.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, _animatableNoneMjs.getAnimatableNone)(name, animatableTemplate);
}

},{"../../../value/types/complex/index.mjs":"7EbqM","../../dom/value-types/animatable-none.mjs":"6j7Wd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7EbqM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "analyseComplexValue", ()=>analyseComplexValue);
parcelHelpers.export(exports, "complex", ()=>complex);
var _indexMjs = require("../color/index.mjs");
var _colorRegexMjs = require("../utils/color-regex.mjs");
var _floatRegexMjs = require("../utils/float-regex.mjs");
var _sanitizeMjs = require("../utils/sanitize.mjs");
function test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, _floatRegexMjs.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, _colorRegexMjs.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const NUMBER_TOKEN = "number";
const COLOR_TOKEN = "color";
const VAR_TOKEN = "var";
const VAR_FUNCTION_TOKEN = "var(";
const SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function analyseComplexValue(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace(complexRegex, (parsedValue)=>{
        if ((0, _indexMjs.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push(COLOR_TOKEN);
            values.push((0, _indexMjs.color).parse(parsedValue));
        } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push(VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push(NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return SPLIT_TOKEN;
    });
    const split = tokenised.split(SPLIT_TOKEN);
    return {
        values,
        split,
        indexes,
        types
    };
}
function parseComplexValue(v) {
    return analyseComplexValue(v).values;
}
function createTransformer(source) {
    const { split, types } = analyseComplexValue(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === NUMBER_TOKEN) output += (0, _sanitizeMjs.sanitize)(v[i]);
                else if (type === COLOR_TOKEN) output += (0, _indexMjs.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function getAnimatableNone(v) {
    const parsed = parseComplexValue(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = {
    test,
    parse: parseComplexValue,
    createTransformer,
    getAnimatableNone
};

},{"../color/index.mjs":"aGDwe","../utils/color-regex.mjs":"avKoQ","../utils/float-regex.mjs":"cLVa3","../utils/sanitize.mjs":"8E7l7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aGDwe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>color);
var _hexMjs = require("./hex.mjs");
var _hslaMjs = require("./hsla.mjs");
var _rgbaMjs = require("./rgba.mjs");
const color = {
    test: (v)=>(0, _rgbaMjs.rgba).test(v) || (0, _hexMjs.hex).test(v) || (0, _hslaMjs.hsla).test(v),
    parse: (v)=>{
        if ((0, _rgbaMjs.rgba).test(v)) return (0, _rgbaMjs.rgba).parse(v);
        else if ((0, _hslaMjs.hsla).test(v)) return (0, _hslaMjs.hsla).parse(v);
        else return (0, _hexMjs.hex).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, _rgbaMjs.rgba).transform(v) : (0, _hslaMjs.hsla).transform(v);
    }
};

},{"./hex.mjs":"g5QYb","./hsla.mjs":"fk7hg","./rgba.mjs":"5TA5M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g5QYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hex", ()=>hex);
var _rgbaMjs = require("./rgba.mjs");
var _utilsMjs = require("./utils.mjs");
function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const hex = {
    test: /*@__PURE__*/ (0, _utilsMjs.isColorString)("#"),
    parse: parseHex,
    transform: (0, _rgbaMjs.rgba).transform
};

},{"./rgba.mjs":"5TA5M","./utils.mjs":"98EVl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5TA5M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbUnit", ()=>rgbUnit);
parcelHelpers.export(exports, "rgba", ()=>rgba);
var _clampMjs = require("../../../utils/clamp.mjs");
var _indexMjs = require("../numbers/index.mjs");
var _sanitizeMjs = require("../utils/sanitize.mjs");
var _utilsMjs = require("./utils.mjs");
const clampRgbUnit = (v)=>(0, _clampMjs.clamp)(0, 255, v);
const rgbUnit = {
    ...(0, _indexMjs.number),
    transform: (v)=>Math.round(clampRgbUnit(v))
};
const rgba = {
    test: /*@__PURE__*/ (0, _utilsMjs.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, _utilsMjs.splitColor)("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 })=>"rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + (0, _sanitizeMjs.sanitize)((0, _indexMjs.alpha).transform(alpha$1)) + ")"
};

},{"../../../utils/clamp.mjs":"5mu0r","../numbers/index.mjs":"bcOBd","../utils/sanitize.mjs":"8E7l7","./utils.mjs":"98EVl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5mu0r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
const clamp = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bcOBd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alpha", ()=>alpha);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "scale", ()=>scale);
var _clampMjs = require("../../../utils/clamp.mjs");
const number = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const alpha = {
    ...number,
    transform: (v)=>(0, _clampMjs.clamp)(0, 1, v)
};
const scale = {
    ...number,
    default: 1
};

},{"../../../utils/clamp.mjs":"5mu0r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8E7l7":[function(require,module,exports,__globalThis) {
// If this number is a decimal, make it just five decimal places
// to avoid exponents
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitize", ()=>sanitize);
const sanitize = (v)=>Math.round(v * 100000) / 100000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98EVl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isColorString", ()=>isColorString);
parcelHelpers.export(exports, "splitColor", ()=>splitColor);
var _floatRegexMjs = require("../utils/float-regex.mjs");
var _isNullishMjs = require("../utils/is-nullish.mjs");
var _singleColorRegexMjs = require("../utils/single-color-regex.mjs");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const isColorString = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, _singleColorRegexMjs.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, _isNullishMjs.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const splitColor = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, _floatRegexMjs.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

},{"../utils/float-regex.mjs":"cLVa3","../utils/is-nullish.mjs":"6YtqB","../utils/single-color-regex.mjs":"63zAp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cLVa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "floatRegex", ()=>floatRegex);
const floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6YtqB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNullish", ()=>isNullish);
function isNullish(v) {
    return v == null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"63zAp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "singleColorRegex", ()=>singleColorRegex);
const singleColorRegex = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fk7hg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hsla", ()=>hsla);
var _indexMjs = require("../numbers/index.mjs");
var _unitsMjs = require("../numbers/units.mjs");
var _sanitizeMjs = require("../utils/sanitize.mjs");
var _utilsMjs = require("./utils.mjs");
const hsla = {
    test: /*@__PURE__*/ (0, _utilsMjs.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, _utilsMjs.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, _unitsMjs.percent).transform((0, _sanitizeMjs.sanitize)(saturation)) + ", " + (0, _unitsMjs.percent).transform((0, _sanitizeMjs.sanitize)(lightness)) + ", " + (0, _sanitizeMjs.sanitize)((0, _indexMjs.alpha).transform(alpha$1)) + ")";
    }
};

},{"../numbers/index.mjs":"bcOBd","../numbers/units.mjs":"hGtBr","../utils/sanitize.mjs":"8E7l7","./utils.mjs":"98EVl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGtBr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "percent", ()=>percent);
parcelHelpers.export(exports, "progressPercentage", ()=>progressPercentage);
parcelHelpers.export(exports, "px", ()=>px);
parcelHelpers.export(exports, "vh", ()=>vh);
parcelHelpers.export(exports, "vw", ()=>vw);
const createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const degrees = /*@__PURE__*/ createUnitType("deg");
const percent = /*@__PURE__*/ createUnitType("%");
const px = /*@__PURE__*/ createUnitType("px");
const vh = /*@__PURE__*/ createUnitType("vh");
const vw = /*@__PURE__*/ createUnitType("vw");
const progressPercentage = {
    ...percent,
    parse: (v)=>percent.parse(v) / 100,
    transform: (v)=>percent.transform(v * 100)
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avKoQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorRegex", ()=>colorRegex);
const colorRegex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6j7Wd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnimatableNone", ()=>getAnimatableNone);
var _indexMjs = require("../../../value/types/complex/index.mjs");
var _filterMjs = require("../../../value/types/complex/filter.mjs");
var _defaultsMjs = require("./defaults.mjs");
function getAnimatableNone(key, value) {
    let defaultValueType = (0, _defaultsMjs.getDefaultValueType)(key);
    if (defaultValueType !== (0, _filterMjs.filter)) defaultValueType = (0, _indexMjs.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

},{"../../../value/types/complex/index.mjs":"7EbqM","../../../value/types/complex/filter.mjs":"a7Mfy","./defaults.mjs":"5j9jO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a7Mfy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _indexMjs = require("./index.mjs");
var _floatRegexMjs = require("../utils/float-regex.mjs");
/**
 * Properties that should default to 1 or 100%
 */ const maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, _floatRegexMjs.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const filter = {
    ...(0, _indexMjs.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    }
};

},{"./index.mjs":"7EbqM","../utils/float-regex.mjs":"cLVa3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5j9jO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultValueTypes", ()=>defaultValueTypes);
parcelHelpers.export(exports, "getDefaultValueType", ()=>getDefaultValueType);
var _indexMjs = require("../../../value/types/color/index.mjs");
var _filterMjs = require("../../../value/types/complex/filter.mjs");
var _numberMjs = require("./number.mjs");
/**
 * A map of default value types for common values
 */ const defaultValueTypes = {
    ...(0, _numberMjs.numberValueTypes),
    color: // Color props
    (0, _indexMjs.color),
    backgroundColor: (0, _indexMjs.color),
    outlineColor: (0, _indexMjs.color),
    fill: (0, _indexMjs.color),
    stroke: (0, _indexMjs.color),
    // Border props
    borderColor: (0, _indexMjs.color),
    borderTopColor: (0, _indexMjs.color),
    borderRightColor: (0, _indexMjs.color),
    borderBottomColor: (0, _indexMjs.color),
    borderLeftColor: (0, _indexMjs.color),
    filter: (0, _filterMjs.filter),
    WebkitFilter: (0, _filterMjs.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const getDefaultValueType = (key)=>defaultValueTypes[key];

},{"../../../value/types/color/index.mjs":"aGDwe","../../../value/types/complex/filter.mjs":"a7Mfy","./number.mjs":"fQqUe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fQqUe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numberValueTypes", ()=>numberValueTypes);
var _indexMjs = require("../../../value/types/numbers/index.mjs");
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
var _numberBrowserMjs = require("./number-browser.mjs");
var _transformMjs = require("./transform.mjs");
var _typeIntMjs = require("./type-int.mjs");
const numberValueTypes = {
    ...(0, _numberBrowserMjs.browserNumberValueTypes),
    ...(0, _transformMjs.transformValueTypes),
    zIndex: (0, _typeIntMjs.int),
    size: (0, _unitsMjs.px),
    // SVG
    fillOpacity: (0, _indexMjs.alpha),
    strokeOpacity: (0, _indexMjs.alpha),
    numOctaves: (0, _typeIntMjs.int)
};

},{"../../../value/types/numbers/index.mjs":"bcOBd","../../../value/types/numbers/units.mjs":"hGtBr","./number-browser.mjs":"16Zae","./transform.mjs":"jnth9","./type-int.mjs":"gyTzS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"16Zae":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "browserNumberValueTypes", ()=>browserNumberValueTypes);
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
const browserNumberValueTypes = {
    // Border props
    borderWidth: (0, _unitsMjs.px),
    borderTopWidth: (0, _unitsMjs.px),
    borderRightWidth: (0, _unitsMjs.px),
    borderBottomWidth: (0, _unitsMjs.px),
    borderLeftWidth: (0, _unitsMjs.px),
    borderRadius: (0, _unitsMjs.px),
    radius: (0, _unitsMjs.px),
    borderTopLeftRadius: (0, _unitsMjs.px),
    borderTopRightRadius: (0, _unitsMjs.px),
    borderBottomRightRadius: (0, _unitsMjs.px),
    borderBottomLeftRadius: (0, _unitsMjs.px),
    // Positioning props
    width: (0, _unitsMjs.px),
    maxWidth: (0, _unitsMjs.px),
    height: (0, _unitsMjs.px),
    maxHeight: (0, _unitsMjs.px),
    top: (0, _unitsMjs.px),
    right: (0, _unitsMjs.px),
    bottom: (0, _unitsMjs.px),
    left: (0, _unitsMjs.px),
    // Spacing props
    padding: (0, _unitsMjs.px),
    paddingTop: (0, _unitsMjs.px),
    paddingRight: (0, _unitsMjs.px),
    paddingBottom: (0, _unitsMjs.px),
    paddingLeft: (0, _unitsMjs.px),
    margin: (0, _unitsMjs.px),
    marginTop: (0, _unitsMjs.px),
    marginRight: (0, _unitsMjs.px),
    marginBottom: (0, _unitsMjs.px),
    marginLeft: (0, _unitsMjs.px),
    // Misc
    backgroundPositionX: (0, _unitsMjs.px),
    backgroundPositionY: (0, _unitsMjs.px)
};

},{"../../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jnth9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformValueTypes", ()=>transformValueTypes);
var _indexMjs = require("../../../value/types/numbers/index.mjs");
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
const transformValueTypes = {
    rotate: (0, _unitsMjs.degrees),
    rotateX: (0, _unitsMjs.degrees),
    rotateY: (0, _unitsMjs.degrees),
    rotateZ: (0, _unitsMjs.degrees),
    scale: (0, _indexMjs.scale),
    scaleX: (0, _indexMjs.scale),
    scaleY: (0, _indexMjs.scale),
    scaleZ: (0, _indexMjs.scale),
    skew: (0, _unitsMjs.degrees),
    skewX: (0, _unitsMjs.degrees),
    skewY: (0, _unitsMjs.degrees),
    distance: (0, _unitsMjs.px),
    translateX: (0, _unitsMjs.px),
    translateY: (0, _unitsMjs.px),
    translateZ: (0, _unitsMjs.px),
    x: (0, _unitsMjs.px),
    y: (0, _unitsMjs.px),
    z: (0, _unitsMjs.px),
    perspective: (0, _unitsMjs.px),
    transformPerspective: (0, _unitsMjs.px),
    opacity: (0, _indexMjs.alpha),
    originX: (0, _unitsMjs.progressPercentage),
    originY: (0, _unitsMjs.progressPercentage),
    originZ: (0, _unitsMjs.px)
};

},{"../../../value/types/numbers/index.mjs":"bcOBd","../../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyTzS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "int", ()=>int);
var _indexMjs = require("../../../value/types/numbers/index.mjs");
const int = {
    ...(0, _indexMjs.number),
    transform: Math.round
};

},{"../../../value/types/numbers/index.mjs":"bcOBd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"02uFt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyframeResolver", ()=>KeyframeResolver);
parcelHelpers.export(exports, "flushKeyframeResolvers", ()=>flushKeyframeResolvers);
var _motionDom = require("motion-dom");
var _unitConversionMjs = require("../dom/utils/unit-conversion.mjs");
const toResolve = new Set();
let isScheduled = false;
let anyNeedsMeasurement = false;
function measureAllKeyframes() {
    if (anyNeedsMeasurement) {
        const resolversToMeasure = Array.from(toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, _unitConversionMjs.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    anyNeedsMeasurement = false;
    isScheduled = false;
    toResolve.forEach((resolver)=>resolver.complete());
    toResolve.clear();
}
function readAllKeyframes() {
    toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) anyNeedsMeasurement = true;
    });
}
function flushKeyframeResolvers() {
    readAllKeyframes();
    measureAllKeyframes();
}
class KeyframeResolver {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            toResolve.add(this);
            if (!isScheduled) {
                isScheduled = true;
                (0, _motionDom.frame).read(readAllKeyframes);
                (0, _motionDom.frame).resolveKeyframes(measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes, name, element, motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}

},{"motion-dom":"7u9qw","../dom/utils/unit-conversion.mjs":"eYlAT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eYlAT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumOrPxType", ()=>isNumOrPxType);
parcelHelpers.export(exports, "positionalValues", ()=>positionalValues);
parcelHelpers.export(exports, "removeNonTranslationalTransform", ()=>removeNonTranslationalTransform);
var _indexMjs = require("../../../value/types/numbers/index.mjs");
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
var _keysTransformMjs = require("../../html/utils/keys-transform.mjs");
var _parseTransformMjs = require("../../html/utils/parse-transform.mjs");
const isNumOrPxType = (v)=>v === (0, _indexMjs.number) || v === (0, _unitsMjs.px);
const transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const nonTranslationalTransformKeys = (0, _keysTransformMjs.transformPropOrder).filter((key)=>!transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const positionalValues = {
    // Dimensions
    width: ({ x }, { paddingLeft = "0", paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y }, { paddingTop = "0", paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top })=>parseFloat(top),
    left: (_bbox, { left })=>parseFloat(left),
    bottom: ({ y }, { top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x }, { left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform })=>(0, _parseTransformMjs.parseValueFromTransform)(transform, "x"),
    y: (_bbox, { transform })=>(0, _parseTransformMjs.parseValueFromTransform)(transform, "y")
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;

},{"../../../value/types/numbers/index.mjs":"bcOBd","../../../value/types/numbers/units.mjs":"hGtBr","../../html/utils/keys-transform.mjs":"b4poF","../../html/utils/parse-transform.mjs":"kopgt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kopgt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseValueFromTransform", ()=>parseValueFromTransform);
parcelHelpers.export(exports, "readTransformValue", ()=>readTransformValue);
const radToDeg = (rad)=>rad * 180 / Math.PI;
const rotate = (v)=>{
    const angle = radToDeg(Math.atan2(v[1], v[0]));
    return rebaseAngle(angle);
};
const matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate,
    rotateZ: rotate,
    skewX: (v)=>radToDeg(Math.atan(v[1])),
    skewY: (v)=>radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const rotateZ = rotate;
const scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX,
    scaleY,
    scale: (v)=>(scaleX(v) + scaleY(v)) / 2,
    rotateX: (v)=>rebaseAngle(radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>rebaseAngle(radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ,
    rotate: rotateZ,
    skewX: (v)=>radToDeg(Math.atan(v[4])),
    skewY: (v)=>radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function defaultTransformValue(name) {
    return name.includes("scale") ? 1 : 0;
}
function parseValueFromTransform(transform, name) {
    if (!transform || transform === "none") return defaultTransformValue(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return defaultTransformValue(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map(convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const readTransformValue = (instance, name)=>{
    const { transform = "none" } = getComputedStyle(instance);
    return parseValueFromTransform(transform, name);
};
function convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7QWs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVariableValue", ()=>getVariableValue);
parcelHelpers.export(exports, "parseCSSVariable", ()=>parseCSSVariable);
var _motionUtils = require("motion-utils");
var _isNumericalStringMjs = require("../../../utils/is-numerical-string.mjs");
var _isCssVariableMjs = require("./is-css-variable.mjs");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function parseCSSVariable(current) {
    const match = splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
    (0, _motionUtils.invariant)(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = parseCSSVariable(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, _isNumericalStringMjs.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, _isCssVariableMjs.isCSSVariableToken)(fallback) ? getVariableValue(fallback, element, depth + 1) : fallback;
}

},{"motion-utils":"h8hZz","../../../utils/is-numerical-string.mjs":"4HKEF","./is-css-variable.mjs":"58wqN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4HKEF":[function(require,module,exports,__globalThis) {
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumericalString", ()=>isNumericalString);
const isNumericalString = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58wqN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCSSVariableName", ()=>isCSSVariableName);
parcelHelpers.export(exports, "isCSSVariableToken", ()=>isCSSVariableToken);
const checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const isCSSVariableName = /*@__PURE__*/ checkStringStartsWith("--");
const startsAsVariableToken = /*@__PURE__*/ checkStringStartsWith("var(--");
const isCSSVariableToken = (value)=>{
    const startsWithToken = startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8qh9y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dimensionValueTypes", ()=>dimensionValueTypes);
parcelHelpers.export(exports, "findDimensionValueType", ()=>findDimensionValueType);
var _indexMjs = require("../../../value/types/numbers/index.mjs");
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
var _testMjs = require("./test.mjs");
var _typeAutoMjs = require("./type-auto.mjs");
/**
 * A list of value types commonly used for dimensions
 */ const dimensionValueTypes = [
    (0, _indexMjs.number),
    (0, _unitsMjs.px),
    (0, _unitsMjs.percent),
    (0, _unitsMjs.degrees),
    (0, _unitsMjs.vw),
    (0, _unitsMjs.vh),
    (0, _typeAutoMjs.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const findDimensionValueType = (v)=>dimensionValueTypes.find((0, _testMjs.testValueType)(v));

},{"../../../value/types/numbers/index.mjs":"bcOBd","../../../value/types/numbers/units.mjs":"hGtBr","./test.mjs":"3Alhf","./type-auto.mjs":"gqTyb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Alhf":[function(require,module,exports,__globalThis) {
/**
 * Tests a provided value against a ValueType
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "testValueType", ()=>testValueType);
const testValueType = (v)=>(type)=>type.test(v);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gqTyb":[function(require,module,exports,__globalThis) {
/**
 * ValueType for "auto"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auto", ()=>auto);
const auto = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ebVyf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseAnimation", ()=>BaseAnimation);
var _motionDom = require("motion-dom");
var _keyframesResolverMjs = require("../../render/utils/KeyframesResolver.mjs");
var _useInstantTransitionStateMjs = require("../../utils/use-instant-transition-state.mjs");
var _canAnimateMjs = require("./utils/can-animate.mjs");
var _getFinalKeyframeMjs = require("./waapi/utils/get-final-keyframe.mjs");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const MAX_RESOLVE_DELAY = 40;
class BaseAnimation {
    constructor({ autoplay = true, delay = 0, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, _motionDom.time).now();
        this.options = {
            autoplay,
            delay,
            type,
            repeat,
            repeatDelay,
            repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, _keyframesResolverMjs.flushKeyframeResolvers)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, _motionDom.time).now();
        this.hasAttemptedResolve = true;
        const { name, type, velocity, delay, onComplete, onUpdate, isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, _canAnimateMjs.canAnimate)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, _useInstantTransitionStateMjs.instantAnimationState).current || !delay) {
                onUpdate && onUpdate((0, _getFinalKeyframeMjs.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
                onComplete && onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes,
            finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        if (!this.options.allowFlatten) return;
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}

},{"motion-dom":"7u9qw","../../render/utils/KeyframesResolver.mjs":"02uFt","../../utils/use-instant-transition-state.mjs":"91bNg","./utils/can-animate.mjs":"fXx0b","./waapi/utils/get-final-keyframe.mjs":"94snX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fXx0b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canAnimate", ()=>canAnimate);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _isAnimatableMjs = require("../../utils/is-animatable.mjs");
function hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function canAnimate(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, _isAnimatableMjs.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, _isAnimatableMjs.isAnimatable)(targetKeyframe, name);
    (0, _motionUtils.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return hasKeyframesChanged(keyframes) || (type === "spring" || (0, _motionDom.isGenerator)(type)) && velocity;
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../utils/is-animatable.mjs":"8Qgk1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Qgk1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnimatable", ()=>isAnimatable);
var _indexMjs = require("../../value/types/complex/index.mjs");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const isAnimatable = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, _indexMjs.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

},{"../../value/types/complex/index.mjs":"7EbqM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"94snX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFinalKeyframe", ()=>getFinalKeyframe);
const isNotNull = (value)=>value !== null;
function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter(isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7fjnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MainThreadAnimation", ()=>MainThreadAnimation);
parcelHelpers.export(exports, "animateValue", ()=>animateValue);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _keyframesResolverMjs = require("../../render/utils/KeyframesResolver.mjs");
var _clampMjs = require("../../utils/clamp.mjs");
var _indexMjs = require("../../utils/mix/index.mjs");
var _pipeMjs = require("../../utils/pipe.mjs");
var _inertiaMjs = require("../generators/inertia.mjs");
var _keyframesMjs = require("../generators/keyframes.mjs");
var _indexMjs1 = require("../generators/spring/index.mjs");
var _baseAnimationMjs = require("./BaseAnimation.mjs");
var _driverFrameloopMjs = require("./drivers/driver-frameloop.mjs");
var _getFinalKeyframeMjs = require("./waapi/utils/get-final-keyframe.mjs");
const generators = {
    decay: (0, _inertiaMjs.inertia),
    inertia: (0, _inertiaMjs.inertia),
    tween: (0, _keyframesMjs.keyframes),
    keyframes: (0, _keyframesMjs.keyframes),
    spring: (0, _indexMjs1.spring)
};
const percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class MainThreadAnimation extends (0, _baseAnimationMjs.BaseAnimation) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop } = this.options;
            onStop && onStop();
        };
        const { name, motionValue, element, keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, _keyframesResolverMjs.KeyframeResolver);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type = "keyframes", repeat = 0, repeatDelay = 0, repeatType, velocity = 0 } = this.options;
        const generatorFactory = (0, _motionDom.isGenerator)(type) ? type : generators[type] || (0, _keyframesMjs.keyframes);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, _keyframesMjs.keyframes) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, _pipeMjs.pipe)(percentToProgress, (0, _indexMjs.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, _motionDom.calcGeneratorDuration)(generator);
        const { calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator,
            mirroredGenerator,
            mapPercentToKeyframes,
            calculatedDuration,
            resolvedDuration,
            totalDuration
        };
    }
    onPostResolved() {
        const { autoplay = true } = this.options;
        (0, _motionDom.activeAnimations).mainThread++;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe, generator, mirroredGenerator, mapPercentToKeyframes, keyframes, calculatedDuration, totalDuration, resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay, repeat, repeatType, repeatDelay, onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, _clampMjs.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, _getFinalKeyframeMjs.getFinalKeyframe)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved } = this;
        return resolved ? (0, _motionUtils.millisecondsToSeconds)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, _motionUtils.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, _motionUtils.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, _motionUtils.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver = (0, _driverFrameloopMjs.frameloopDriver), onPlay, startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
        (0, _motionDom.activeAnimations).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function animateValue(options) {
    return new MainThreadAnimation(options);
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../render/utils/KeyframesResolver.mjs":"02uFt","../../utils/clamp.mjs":"5mu0r","../../utils/mix/index.mjs":"dda31","../../utils/pipe.mjs":"jSVi0","../generators/inertia.mjs":"hNMyk","../generators/keyframes.mjs":"aMfwc","../generators/spring/index.mjs":"iksp4","./BaseAnimation.mjs":"ebVyf","./drivers/driver-frameloop.mjs":"hUK7g","./waapi/utils/get-final-keyframe.mjs":"94snX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dda31":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mix", ()=>mix);
var _complexMjs = require("./complex.mjs");
var _numberMjs = require("./number.mjs");
function mix(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, _numberMjs.mixNumber)(from, to, p);
    const mixer = (0, _complexMjs.getMixer)(from);
    return mixer(from, to);
}

},{"./complex.mjs":"epEbe","./number.mjs":"e62GY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"epEbe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMixer", ()=>getMixer);
parcelHelpers.export(exports, "mixArray", ()=>mixArray);
parcelHelpers.export(exports, "mixComplex", ()=>mixComplex);
parcelHelpers.export(exports, "mixObject", ()=>mixObject);
var _numberMjs = require("./number.mjs");
var _colorMjs = require("./color.mjs");
var _pipeMjs = require("../pipe.mjs");
var _motionUtils = require("motion-utils");
var _indexMjs = require("../../value/types/color/index.mjs");
var _indexMjs1 = require("../../value/types/complex/index.mjs");
var _isCssVariableMjs = require("../../render/dom/utils/is-css-variable.mjs");
var _visibilityMjs = require("./visibility.mjs");
var _immediateMjs = require("./immediate.mjs");
function mixNumber(a, b) {
    return (p)=>(0, _numberMjs.mixNumber)(a, b, p);
}
function getMixer(a) {
    if (typeof a === "number") return mixNumber;
    else if (typeof a === "string") return (0, _isCssVariableMjs.isCSSVariableToken)(a) ? (0, _immediateMjs.mixImmediate) : (0, _indexMjs.color).test(a) ? (0, _colorMjs.mixColor) : mixComplex;
    else if (Array.isArray(a)) return mixArray;
    else if (typeof a === "object") return (0, _indexMjs.color).test(a) ? (0, _colorMjs.mixColor) : mixObject;
    return 0, _immediateMjs.mixImmediate;
}
function mixArray(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>getMixer(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function mixObject(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = getMixer(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const mixComplex = (origin, target)=>{
    const template = (0, _indexMjs1.complex).createTransformer(target);
    const originStats = (0, _indexMjs1.analyseComplexValue)(origin);
    const targetStats = (0, _indexMjs1.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, _visibilityMjs.invisibleValues).has(origin) && !targetStats.values.length || (0, _visibilityMjs.invisibleValues).has(target) && !originStats.values.length) return (0, _visibilityMjs.mixVisibility)(origin, target);
        return (0, _pipeMjs.pipe)(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, _motionUtils.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, _immediateMjs.mixImmediate)(origin, target);
    }
};

},{"./number.mjs":"e62GY","./color.mjs":"7YLxI","../pipe.mjs":"jSVi0","motion-utils":"h8hZz","../../value/types/color/index.mjs":"aGDwe","../../value/types/complex/index.mjs":"7EbqM","../../render/dom/utils/is-css-variable.mjs":"58wqN","./visibility.mjs":"frZJC","./immediate.mjs":"cPk5W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e62GY":[function(require,module,exports,__globalThis) {
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixNumber", ()=>mixNumber);
const mixNumber = (from, to, progress)=>{
    return from + (to - from) * progress;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7YLxI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixColor", ()=>mixColor);
parcelHelpers.export(exports, "mixLinearColor", ()=>mixLinearColor);
var _numberMjs = require("./number.mjs");
var _motionUtils = require("motion-utils");
var _hslaToRgbaMjs = require("../hsla-to-rgba.mjs");
var _hexMjs = require("../../value/types/color/hex.mjs");
var _rgbaMjs = require("../../value/types/color/rgba.mjs");
var _hslaMjs = require("../../value/types/color/hsla.mjs");
var _immediateMjs = require("./immediate.mjs");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const colorTypes = [
    (0, _hexMjs.hex),
    (0, _rgbaMjs.rgba),
    (0, _hslaMjs.hsla)
];
const getColorType = (v)=>colorTypes.find((type)=>type.test(v));
function asRGBA(color) {
    const type = getColorType(color);
    (0, _motionUtils.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, _hslaMjs.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, _hslaToRgbaMjs.hslaToRgba)(model);
    return model;
}
const mixColor = (from, to)=>{
    const fromRGBA = asRGBA(from);
    const toRGBA = asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, _immediateMjs.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, _numberMjs.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, _rgbaMjs.rgba).transform(blended);
    };
};

},{"./number.mjs":"e62GY","motion-utils":"h8hZz","../hsla-to-rgba.mjs":"8MEIz","../../value/types/color/hex.mjs":"g5QYb","../../value/types/color/rgba.mjs":"5TA5M","../../value/types/color/hsla.mjs":"fk7hg","./immediate.mjs":"cPk5W","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8MEIz":[function(require,module,exports,__globalThis) {
// Adapted from https://gist.github.com/mjackson/5311256
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslaToRgba", ()=>hslaToRgba);
function hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cPk5W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixImmediate", ()=>mixImmediate);
function mixImmediate(a, b) {
    return (p)=>p > 0 ? b : a;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jSVi0":[function(require,module,exports,__globalThis) {
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
const combineFunctions = (a, b)=>(v)=>b(a(v));
const pipe = (...transformers)=>transformers.reduce(combineFunctions);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"frZJC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invisibleValues", ()=>invisibleValues);
parcelHelpers.export(exports, "mixVisibility", ()=>mixVisibility);
const invisibleValues = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function mixVisibility(origin, target) {
    if (invisibleValues.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNMyk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inertia", ()=>inertia);
var _indexMjs = require("./spring/index.mjs");
var _velocityMjs = require("./utils/velocity.mjs");
function inertia({ keyframes, velocity = 0.0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, _indexMjs.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, _velocityMjs.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta,
            restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

},{"./spring/index.mjs":"iksp4","./utils/velocity.mjs":"89aws","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iksp4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spring", ()=>spring);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _clampMjs = require("../../../utils/clamp.mjs");
var _velocityMjs = require("../utils/velocity.mjs");
var _defaultsMjs = require("./defaults.mjs");
var _findMjs = require("./find.mjs");
const durationKeys = [
    "duration",
    "bounce"
];
const physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = {
        velocity: (0, _defaultsMjs.springDefaults).velocity,
        stiffness: (0, _defaultsMjs.springDefaults).stiffness,
        damping: (0, _defaultsMjs.springDefaults).damping,
        mass: (0, _defaultsMjs.springDefaults).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, _clampMjs.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, _defaultsMjs.springDefaults).mass,
                stiffness,
                damping
            };
        } else {
            const derived = (0, _findMjs.findSpring)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, _defaultsMjs.springDefaults).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function spring(optionsOrVisualDuration = (0, _defaultsMjs.springDefaults).visualDuration, bounce = (0, _defaultsMjs.springDefaults).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce
    } : optionsOrVisualDuration;
    let { restSpeed, restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness, damping, mass, duration, velocity, isResolvedFromDuration } = getSpringOptions({
        ...options,
        velocity: -(0, _motionUtils.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, _motionUtils.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, _defaultsMjs.springDefaults).restSpeed.granular : (0, _defaultsMjs.springDefaults).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, _defaultsMjs.springDefaults).restDelta.granular : (0, _defaultsMjs.springDefaults).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, _findMjs.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, _motionUtils.secondsToMilliseconds)(initialVelocity) : (0, _velocityMjs.calcGeneratorVelocity)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, _motionDom.calcGeneratorDuration)(generator), (0, _motionDom.maxGeneratorDuration));
            const easing = (0, _motionDom.generateLinearEasing)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../../utils/clamp.mjs":"5mu0r","../utils/velocity.mjs":"89aws","./defaults.mjs":"8N4mA","./find.mjs":"fAssx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"89aws":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcGeneratorVelocity", ()=>calcGeneratorVelocity);
var _motionUtils = require("motion-utils");
const velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - velocitySampleDuration, 0);
    return (0, _motionUtils.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

},{"motion-utils":"h8hZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8N4mA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "springDefaults", ()=>springDefaults);
const springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fAssx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcAngularFreq", ()=>calcAngularFreq);
parcelHelpers.export(exports, "findSpring", ()=>findSpring);
var _motionUtils = require("motion-utils");
var _clampMjs = require("../../../utils/clamp.mjs");
var _defaultsMjs = require("./defaults.mjs");
const safeMin = 0.001;
function findSpring({ duration = (0, _defaultsMjs.springDefaults).duration, bounce = (0, _defaultsMjs.springDefaults).bounce, velocity = (0, _defaultsMjs.springDefaults).velocity, mass = (0, _defaultsMjs.springDefaults).mass }) {
    let envelope;
    let derivative;
    (0, _motionUtils.warning)(duration <= (0, _motionUtils.secondsToMilliseconds)((0, _defaultsMjs.springDefaults).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, _clampMjs.clamp)((0, _defaultsMjs.springDefaults).minDamping, (0, _defaultsMjs.springDefaults).maxDamping, dampingRatio);
    duration = (0, _clampMjs.clamp)((0, _defaultsMjs.springDefaults).minDuration, (0, _defaultsMjs.springDefaults).maxDuration, (0, _motionUtils.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = (0, _motionUtils.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, _defaultsMjs.springDefaults).stiffness,
        damping: (0, _defaultsMjs.springDefaults).damping,
        duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

},{"motion-utils":"h8hZz","../../../utils/clamp.mjs":"5mu0r","./defaults.mjs":"8N4mA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMfwc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEasing", ()=>defaultEasing);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _easeMjs = require("../../easing/ease.mjs");
var _isEasingArrayMjs = require("../../easing/utils/is-easing-array.mjs");
var _mapMjs = require("../../easing/utils/map.mjs");
var _interpolateMjs = require("../../utils/interpolate.mjs");
var _defaultMjs = require("../../utils/offsets/default.mjs");
var _timeMjs = require("../../utils/offsets/time.mjs");
function defaultEasing(values, easing) {
    return values.map(()=>easing || (0, _easeMjs.easeInOut)).splice(0, values.length - 1);
}
function keyframes({ duration = 300, keyframes: keyframeValues, times, ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, _isEasingArrayMjs.isEasingArray)(ease) ? ease.map((0, _mapMjs.easingDefinitionToFunction)) : (0, _mapMjs.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, _timeMjs.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, _defaultMjs.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, _interpolateMjs.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

},{"../../easing/ease.mjs":"jzDFo","../../easing/utils/is-easing-array.mjs":"4Txnl","../../easing/utils/map.mjs":"hxClO","../../utils/interpolate.mjs":"jAMAj","../../utils/offsets/default.mjs":"9XN04","../../utils/offsets/time.mjs":"d7nmm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jzDFo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeIn", ()=>easeIn);
parcelHelpers.export(exports, "easeInOut", ()=>easeInOut);
parcelHelpers.export(exports, "easeOut", ()=>easeOut);
var _cubicBezierMjs = require("./cubic-bezier.mjs");
const easeIn = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0.42, 0, 1, 1);
const easeOut = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0, 0, 0.58, 1);
const easeInOut = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0.42, 0, 0.58, 1);

},{"./cubic-bezier.mjs":"kosBT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Txnl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEasingArray", ()=>isEasingArray);
const isEasingArray = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hxClO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easingDefinitionToFunction", ()=>easingDefinitionToFunction);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _anticipateMjs = require("../anticipate.mjs");
var _backMjs = require("../back.mjs");
var _circMjs = require("../circ.mjs");
var _cubicBezierMjs = require("../cubic-bezier.mjs");
var _easeMjs = require("../ease.mjs");
const easingLookup = {
    linear: (0, _motionUtils.noop),
    easeIn: (0, _easeMjs.easeIn),
    easeInOut: (0, _easeMjs.easeInOut),
    easeOut: (0, _easeMjs.easeOut),
    circIn: (0, _circMjs.circIn),
    circInOut: (0, _circMjs.circInOut),
    circOut: (0, _circMjs.circOut),
    backIn: (0, _backMjs.backIn),
    backInOut: (0, _backMjs.backInOut),
    backOut: (0, _backMjs.backOut),
    anticipate: (0, _anticipateMjs.anticipate)
};
const easingDefinitionToFunction = (definition)=>{
    if ((0, _motionDom.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, _motionUtils.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, _cubicBezierMjs.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, _motionUtils.invariant)(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return easingLookup[definition];
    }
    return definition;
};

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../anticipate.mjs":"dNYZe","../back.mjs":"ltXlp","../circ.mjs":"do4I6","../cubic-bezier.mjs":"kosBT","../ease.mjs":"jzDFo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jAMAj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
var _motionUtils = require("motion-utils");
var _clampMjs = require("./clamp.mjs");
var _indexMjs = require("./mix/index.mjs");
var _pipeMjs = require("./pipe.mjs");
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, _indexMjs.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, _motionUtils.noop) : ease;
            mixer = (0, _pipeMjs.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    (0, _motionUtils.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, _motionUtils.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, _clampMjs.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

},{"motion-utils":"h8hZz","./clamp.mjs":"5mu0r","./mix/index.mjs":"dda31","./pipe.mjs":"jSVi0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9XN04":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultOffset", ()=>defaultOffset);
var _fillMjs = require("./fill.mjs");
function defaultOffset(arr) {
    const offset = [
        0
    ];
    (0, _fillMjs.fillOffset)(offset, arr.length - 1);
    return offset;
}

},{"./fill.mjs":"ikoC0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ikoC0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillOffset", ()=>fillOffset);
var _motionUtils = require("motion-utils");
var _numberMjs = require("../mix/number.mjs");
function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, _motionUtils.progress)(0, remaining, i);
        offset.push((0, _numberMjs.mixNumber)(min, 1, offsetProgress));
    }
}

},{"motion-utils":"h8hZz","../mix/number.mjs":"e62GY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7nmm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertOffsetToTimes", ()=>convertOffsetToTimes);
function convertOffsetToTimes(offset, duration) {
    return offset.map((o)=>o * duration);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUK7g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "frameloopDriver", ()=>frameloopDriver);
var _motionDom = require("motion-dom");
const frameloopDriver = (update)=>{
    const passTimestamp = ({ timestamp })=>update(timestamp);
    return {
        start: ()=>(0, _motionDom.frame).update(passTimestamp, true),
        stop: ()=>(0, _motionDom.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, _motionDom.frameData).isProcessing ? (0, _motionDom.frameData).timestamp : (0, _motionDom.time).now()
    };
};

},{"motion-dom":"7u9qw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1SuWp":[function(require,module,exports,__globalThis) {
/**
 * A list of values that can be hardware-accelerated.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "acceleratedValues", ()=>acceleratedValues);
const acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"evYrX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startWaapiAnimation", ()=>startWaapiAnimation);
var _motionDom = require("motion-dom");
function startWaapiAnimation(element, valueName, keyframes, { delay = 0, duration = 300, repeat = 0, repeatType = "loop", ease = "easeInOut", times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, _motionDom.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, _motionDom.statsBuffer).value) (0, _motionDom.activeAnimations).waapi++;
    const animation = element.animate(keyframeOptions, {
        delay,
        duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
    if ((0, _motionDom.statsBuffer).value) animation.finished.finally(()=>{
        (0, _motionDom.activeAnimations).waapi--;
    });
    return animation;
}

},{"motion-dom":"7u9qw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"947uV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsWaapi", ()=>supportsWaapi);
var _motionUtils = require("motion-utils");
const supportsWaapi = /*@__PURE__*/ (0, _motionUtils.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));

},{"motion-utils":"h8hZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1j1Wa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultTransition", ()=>getDefaultTransition);
var _keysTransformMjs = require("../../render/html/utils/keys-transform.mjs");
const underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const getDefaultTransition = (valueKey, { keyframes })=>{
    if (keyframes.length > 2) return keyframesTransition;
    else if ((0, _keysTransformMjs.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes[1]) : underDampedSpring;
    return ease;
};

},{"../../render/html/utils/keys-transform.mjs":"b4poF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"afONc":[function(require,module,exports,__globalThis) {
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTransitionDefined", ()=>isTransitionDefined);
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6BoKt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateVariant", ()=>animateVariant);
parcelHelpers.export(exports, "sortByTreeOrder", ()=>sortByTreeOrder);
var _resolveDynamicVariantsMjs = require("../../render/utils/resolve-dynamic-variants.mjs");
var _visualElementTargetMjs = require("./visual-element-target.mjs");
function animateVariant(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, _visualElementTargetMjs.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren = 0, staggerChildren, staggerDirection } = transition;
        return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push(animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}

},{"../../render/utils/resolve-dynamic-variants.mjs":"4tXnT","./visual-element-target.mjs":"j8sQ3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5YaEU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowCompare", ()=>shallowCompare);
function shallowCompare(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"mqqVY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVariantContext", ()=>getVariantContext);
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
const numVariantProps = (0, _variantPropsMjs.variantProps).length;
function getVariantContext(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? getVariantContext(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < numVariantProps; i++){
        const name = (0, _variantPropsMjs.variantProps)[i];
        const prop = visualElement.props[name];
        if ((0, _isVariantLabelMjs.isVariantLabel)(prop) || prop === false) context[name] = prop;
    }
    return context;
}

},{"./is-variant-label.mjs":"hGXyz","./variant-props.mjs":"8wQuM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGXyz":[function(require,module,exports,__globalThis) {
/**
 * Decides if the supplied variable is variant label
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isVariantLabel", ()=>isVariantLabel);
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8wQuM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "variantPriorityOrder", ()=>variantPriorityOrder);
parcelHelpers.export(exports, "variantProps", ()=>variantProps);
const variantPriorityOrder = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const variantProps = [
    "initial",
    ...variantPriorityOrder
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9q59Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Feature", ()=>Feature);
class Feature {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"evYau":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExitAnimationFeature", ()=>ExitAnimationFeature);
var _featureMjs = require("../Feature.mjs");
let id = 0;
class ExitAnimationFeature extends (0, _featureMjs.Feature) {
    constructor(){
        super(...arguments);
        this.id = id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent, onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register, onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

},{"../Feature.mjs":"9q59Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"89DRL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>drag);
var _indexMjs = require("../../gestures/drag/index.mjs");
var _indexMjs1 = require("../../gestures/pan/index.mjs");
var _measureLayoutMjs = require("./layout/MeasureLayout.mjs");
var _htmlprojectionNodeMjs = require("../../projection/node/HTMLProjectionNode.mjs");
const drag = {
    pan: {
        Feature: (0, _indexMjs1.PanGesture)
    },
    drag: {
        Feature: (0, _indexMjs.DragGesture),
        ProjectionNode: (0, _htmlprojectionNodeMjs.HTMLProjectionNode),
        MeasureLayout: (0, _measureLayoutMjs.MeasureLayout)
    }
};

},{"../../gestures/drag/index.mjs":"8nmhj","../../gestures/pan/index.mjs":"9LeGk","./layout/MeasureLayout.mjs":"bwaXs","../../projection/node/HTMLProjectionNode.mjs":"eJQj5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8nmhj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragGesture", ()=>DragGesture);
var _featureMjs = require("../../motion/features/Feature.mjs");
var _motionUtils = require("motion-utils");
var _visualElementDragControlsMjs = require("./VisualElementDragControls.mjs");
class DragGesture extends (0, _featureMjs.Feature) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, _motionUtils.noop);
        this.removeListeners = (0, _motionUtils.noop);
        this.controls = new (0, _visualElementDragControlsMjs.VisualElementDragControls)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, _motionUtils.noop);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

},{"../../motion/features/Feature.mjs":"9q59Z","motion-utils":"h8hZz","./VisualElementDragControls.mjs":"6UZzM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6UZzM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisualElementDragControls", ()=>VisualElementDragControls);
parcelHelpers.export(exports, "elementDragControls", ()=>elementDragControls);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _motionValueMjs = require("../../animation/interfaces/motion-value.mjs");
var _addDomEventMjs = require("../../events/add-dom-event.mjs");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _eventInfoMjs = require("../../events/event-info.mjs");
var _conversionMjs = require("../../projection/geometry/conversion.mjs");
var _deltaCalcMjs = require("../../projection/geometry/delta-calc.mjs");
var _modelsMjs = require("../../projection/geometry/models.mjs");
var _eachAxisMjs = require("../../projection/utils/each-axis.mjs");
var _measureMjs = require("../../projection/utils/measure.mjs");
var _getContextWindowMjs = require("../../utils/get-context-window.mjs");
var _isRefObjectMjs = require("../../utils/is-ref-object.mjs");
var _numberMjs = require("../../utils/mix/number.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
var _addWillChangeMjs = require("../../value/use-will-change/add-will-change.mjs");
var _panSessionMjs = require("../pan/PanSession.mjs");
var _constraintsMjs = require("./utils/constraints.mjs");
const elementDragControls = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class VisualElementDragControls {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, _modelsMjs.createBox)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, _eventInfoMjs.extractEventInfo)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag, dragPropagation, onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, _motionDom.setDragLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, _eachAxisMjs.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, _unitsMjs.percent).test(current)) {
                    const { projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, _deltaCalcMjs.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, _motionDom.frame).postRender(()=>onDragStart(event, info));
            (0, _addWillChangeMjs.addValueToWillChange)(this.visualElement, "transform");
            const { animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, _eachAxisMjs.eachAxis)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, _panSessionMjs.PanSession)(originEvent, {
            onSessionStart,
            onStart,
            onMove,
            onSessionEnd,
            resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin,
            contextWindow: (0, _getContextWindowMjs.getContextWindow)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd } = this.getProps();
        if (onDragEnd) (0, _motionDom.frame).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection, animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, _constraintsMjs.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints, dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, _isRefObjectMjs.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, _constraintsMjs.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, _constraintsMjs.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, _eachAxisMjs.eachAxis)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, _constraintsMjs.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, _isRefObjectMjs.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, _motionUtils.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, _measureMjs.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, _constraintsMjs.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, _conversionMjs.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, _conversionMjs.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, _eachAxisMjs.eachAxis)((axis)=>{
            if (!shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness,
                bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, _addWillChangeMjs.addValueToWillChange)(this.visualElement, axis);
        return axisValue.start((0, _motionValueMjs.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, _eachAxisMjs.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, _eachAxisMjs.eachAxis)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, _eachAxisMjs.eachAxis)((axis)=>{
            const { drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min, max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, _numberMjs.mixNumber)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag, dragConstraints } = this.getProps();
        const { projection } = this.visualElement;
        if (!(0, _isRefObjectMjs.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, _eachAxisMjs.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, _constraintsMjs.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, _eachAxisMjs.eachAxis)((axis)=>{
            if (!shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min, max } = this.constraints[axis];
            axisValue.set((0, _numberMjs.mixNumber)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        elementDragControls.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, _addPointerEventMjs.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag, dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints } = this.getProps();
            if ((0, _isRefObjectMjs.isRefObject)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, _motionDom.frame).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, _addDomEventMjs.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta, hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, _eachAxisMjs.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = (0, _constraintsMjs.defaultElastic), dragMomentum = true } = props;
        return {
            ...props,
            drag,
            dragDirectionLock,
            dragPropagation,
            dragConstraints,
            dragElastic,
            dragMomentum
        };
    }
}
function shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../animation/interfaces/motion-value.mjs":"lumbS","../../events/add-dom-event.mjs":"82u3S","../../events/add-pointer-event.mjs":"k9O8P","../../events/event-info.mjs":"8dFDB","../../projection/geometry/conversion.mjs":"4G46A","../../projection/geometry/delta-calc.mjs":"lmUuI","../../projection/geometry/models.mjs":"huYV1","../../projection/utils/each-axis.mjs":"dZLv7","../../projection/utils/measure.mjs":"afNeE","../../utils/get-context-window.mjs":"ckiwi","../../utils/is-ref-object.mjs":"gluK5","../../utils/mix/number.mjs":"e62GY","../../value/types/numbers/units.mjs":"hGtBr","../../value/use-will-change/add-will-change.mjs":"hEJzz","../pan/PanSession.mjs":"ghaRp","./utils/constraints.mjs":"1iIuG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"82u3S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addDomEvent", ()=>addDomEvent);
function addDomEvent(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k9O8P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPointerEvent", ()=>addPointerEvent);
var _addDomEventMjs = require("./add-dom-event.mjs");
var _eventInfoMjs = require("./event-info.mjs");
function addPointerEvent(target, eventName, handler, options) {
    return (0, _addDomEventMjs.addDomEvent)(target, eventName, (0, _eventInfoMjs.addPointerInfo)(handler), options);
}

},{"./add-dom-event.mjs":"82u3S","./event-info.mjs":"8dFDB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8dFDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPointerInfo", ()=>addPointerInfo);
parcelHelpers.export(exports, "extractEventInfo", ()=>extractEventInfo);
var _motionDom = require("motion-dom");
function extractEventInfo(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const addPointerInfo = (handler)=>{
    return (event)=>(0, _motionDom.isPrimaryPointer)(event) && handler(event, extractEventInfo(event));
};

},{"motion-dom":"7u9qw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4G46A":[function(require,module,exports,__globalThis) {
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertBoundingBoxToBox", ()=>convertBoundingBoxToBox);
parcelHelpers.export(exports, "convertBoxToBoundingBox", ()=>convertBoxToBoundingBox);
parcelHelpers.export(exports, "transformBoxPoints", ()=>transformBoxPoints);
function convertBoundingBoxToBox({ top, left, right, bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function convertBoxToBoundingBox({ x, y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function transformBoxPoints(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lmUuI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcAxisDelta", ()=>calcAxisDelta);
parcelHelpers.export(exports, "calcBoxDelta", ()=>calcBoxDelta);
parcelHelpers.export(exports, "calcLength", ()=>calcLength);
parcelHelpers.export(exports, "calcRelativeAxis", ()=>calcRelativeAxis);
parcelHelpers.export(exports, "calcRelativeAxisPosition", ()=>calcRelativeAxisPosition);
parcelHelpers.export(exports, "calcRelativeBox", ()=>calcRelativeBox);
parcelHelpers.export(exports, "calcRelativePosition", ()=>calcRelativePosition);
parcelHelpers.export(exports, "isNear", ()=>isNear);
var _numberMjs = require("../../utils/mix/number.mjs");
const SCALE_PRECISION = 0.0001;
const SCALE_MIN = 1 - SCALE_PRECISION;
const SCALE_MAX = 1 + SCALE_PRECISION;
const TRANSLATE_PRECISION = 0.01;
const TRANSLATE_MIN = 0 - TRANSLATE_PRECISION;
const TRANSLATE_MAX = 0 + TRANSLATE_PRECISION;
function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, _numberMjs.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    delta.translate = (0, _numberMjs.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= SCALE_MIN && delta.scale <= SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= TRANSLATE_MIN && delta.translate <= TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

},{"../../utils/mix/number.mjs":"e62GY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"huYV1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAxis", ()=>createAxis);
parcelHelpers.export(exports, "createAxisDelta", ()=>createAxisDelta);
parcelHelpers.export(exports, "createBox", ()=>createBox);
parcelHelpers.export(exports, "createDelta", ()=>createDelta);
const createAxisDelta = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const createDelta = ()=>({
        x: createAxisDelta(),
        y: createAxisDelta()
    });
const createAxis = ()=>({
        min: 0,
        max: 0
    });
const createBox = ()=>({
        x: createAxis(),
        y: createAxis()
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZLv7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eachAxis", ()=>eachAxis);
function eachAxis(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"afNeE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "measurePageBox", ()=>measurePageBox);
parcelHelpers.export(exports, "measureViewportBox", ()=>measureViewportBox);
var _conversionMjs = require("../geometry/conversion.mjs");
var _deltaApplyMjs = require("../geometry/delta-apply.mjs");
function measureViewportBox(instance, transformPoint) {
    return (0, _conversionMjs.convertBoundingBoxToBox)((0, _conversionMjs.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = measureViewportBox(element, transformPagePoint);
    const { scroll } = rootProjectionNode;
    if (scroll) {
        (0, _deltaApplyMjs.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, _deltaApplyMjs.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

},{"../geometry/conversion.mjs":"4G46A","../geometry/delta-apply.mjs":"36VRX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"36VRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAxisDelta", ()=>applyAxisDelta);
parcelHelpers.export(exports, "applyBoxDelta", ()=>applyBoxDelta);
parcelHelpers.export(exports, "applyPointDelta", ()=>applyPointDelta);
parcelHelpers.export(exports, "applyTreeDeltas", ()=>applyTreeDeltas);
parcelHelpers.export(exports, "scalePoint", ()=>scalePoint);
parcelHelpers.export(exports, "transformAxis", ()=>transformAxis);
parcelHelpers.export(exports, "transformBox", ()=>transformBox);
parcelHelpers.export(exports, "translateAxis", ()=>translateAxis);
var _numberMjs = require("../../utils/mix/number.mjs");
var _hasTransformMjs = require("../utils/has-transform.mjs");
/**
 * Scales a point based on a factor and an originPoint
 */ function scalePoint(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = scalePoint(point, boxScale, originPoint);
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function applyBoxDelta(box, { x, y }) {
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
const TREE_SCALE_SNAP_MIN = 0.999999999999;
const TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) transformBox(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && (0, _hasTransformMjs.hasTransform)(node.latestValues)) transformBox(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < TREE_SCALE_SNAP_MAX && treeScale.x > TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < TREE_SCALE_SNAP_MAX && treeScale.y > TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function transformAxis(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, _numberMjs.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function transformBox(box, transform) {
    transformAxis(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    transformAxis(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}

},{"../../utils/mix/number.mjs":"e62GY","../utils/has-transform.mjs":"7hVzp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7hVzp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "has2DTranslate", ()=>has2DTranslate);
parcelHelpers.export(exports, "hasScale", ()=>hasScale);
parcelHelpers.export(exports, "hasTransform", ()=>hasTransform);
function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale({ scale, scaleX, scaleY }) {
    return !isIdentityScale(scale) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
    return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ckiwi":[function(require,module,exports,__globalThis) {
// Fixes https://github.com/motiondivision/motion/issues/2270
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContextWindow", ()=>getContextWindow);
const getContextWindow = ({ current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gluK5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRefObject", ()=>isRefObject);
function isRefObject(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ghaRp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanSession", ()=>PanSession);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _eventInfoMjs = require("../../events/event-info.mjs");
var _distanceMjs = require("../../utils/distance.mjs");
var _pipeMjs = require("../../utils/pipe.mjs");
/**
 * @internal
 */ class PanSession {
    constructor(event, handlers, { transformPagePoint, contextWindow, dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, _distanceMjs.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point } = info;
            const { timestamp } = (0, _motionDom.frameData);
            this.history.push({
                ...point,
                timestamp
            });
            const { onStart, onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, _motionDom.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, _motionDom.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, _eventInfoMjs.extractEventInfo)(event);
        const initialInfo = transformPoint(info, this.transformPagePoint);
        const { point } = initialInfo;
        const { timestamp } = (0, _motionDom.frameData);
        this.history = [
            {
                ...point,
                timestamp
            }
        ];
        const { onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, _pipeMjs.pipe)((0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, _motionDom.cancelFrame)(this.updatePoint);
    }
}
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function getPanInfo({ point }, history) {
    return {
        point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1)
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, _motionUtils.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, _motionUtils.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../events/add-pointer-event.mjs":"k9O8P","../../events/event-info.mjs":"8dFDB","../../utils/distance.mjs":"hZ7yn","../../utils/pipe.mjs":"jSVi0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hZ7yn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distance", ()=>distance);
parcelHelpers.export(exports, "distance2D", ()=>distance2D);
const distance = (a, b)=>Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1iIuG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyConstraints", ()=>applyConstraints);
parcelHelpers.export(exports, "calcOrigin", ()=>calcOrigin);
parcelHelpers.export(exports, "calcRelativeAxisConstraints", ()=>calcRelativeAxisConstraints);
parcelHelpers.export(exports, "calcRelativeConstraints", ()=>calcRelativeConstraints);
parcelHelpers.export(exports, "calcViewportAxisConstraints", ()=>calcViewportAxisConstraints);
parcelHelpers.export(exports, "calcViewportConstraints", ()=>calcViewportConstraints);
parcelHelpers.export(exports, "defaultElastic", ()=>defaultElastic);
parcelHelpers.export(exports, "rebaseAxisConstraints", ()=>rebaseAxisConstraints);
parcelHelpers.export(exports, "resolveAxisElastic", ()=>resolveAxisElastic);
parcelHelpers.export(exports, "resolveDragElastic", ()=>resolveDragElastic);
parcelHelpers.export(exports, "resolvePointElastic", ()=>resolvePointElastic);
var _motionUtils = require("motion-utils");
var _deltaCalcMjs = require("../../../projection/geometry/delta-calc.mjs");
var _clampMjs = require("../../../utils/clamp.mjs");
var _numberMjs = require("../../../utils/mix/number.mjs");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function applyConstraints(point, { min, max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, _numberMjs.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, _numberMjs.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min,
        max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function calcOrigin(source, target) {
    let origin = 0.5;
    const sourceLength = (0, _deltaCalcMjs.calcLength)(source);
    const targetLength = (0, _deltaCalcMjs.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, _motionUtils.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, _motionUtils.progress)(source.min, source.max - targetLength, target.min);
    return (0, _clampMjs.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function rebaseAxisConstraints(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function resolveDragElastic(dragElastic = defaultElastic) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = defaultElastic;
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom")
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel)
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

},{"motion-utils":"h8hZz","../../../projection/geometry/delta-calc.mjs":"lmUuI","../../../utils/clamp.mjs":"5mu0r","../../../utils/mix/number.mjs":"e62GY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9LeGk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanGesture", ()=>PanGesture);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _featureMjs = require("../../motion/features/Feature.mjs");
var _getContextWindowMjs = require("../../utils/get-context-window.mjs");
var _panSessionMjs = require("./PanSession.mjs");
const asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, _motionDom.frame).postRender(()=>handler(event, info));
    };
class PanGesture extends (0, _featureMjs.Feature) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, _motionUtils.noop);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, _panSessionMjs.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, _getContextWindowMjs.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
        return {
            onSessionStart: asyncHandler(onPanSessionStart),
            onStart: asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, _motionDom.frame).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, _addPointerEventMjs.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../events/add-pointer-event.mjs":"k9O8P","../../motion/features/Feature.mjs":"9q59Z","../../utils/get-context-window.mjs":"ckiwi","./PanSession.mjs":"ghaRp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwaXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeasureLayout", ()=>MeasureLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _motionDom = require("motion-dom");
var _react = require("react");
var _usePresenceMjs = require("../../../components/AnimatePresence/use-presence.mjs");
var _layoutGroupContextMjs = require("../../../context/LayoutGroupContext.mjs");
var _switchLayoutGroupContextMjs = require("../../../context/SwitchLayoutGroupContext.mjs");
var _stateMjs = require("../../../projection/node/state.mjs");
var _scaleBorderRadiusMjs = require("../../../projection/styles/scale-border-radius.mjs");
var _scaleBoxShadowMjs = require("../../../projection/styles/scale-box-shadow.mjs");
var _scaleCorrectionMjs = require("../../../projection/styles/scale-correction.mjs");
"use client";
class MeasureLayoutWithContext extends (0, _react.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
        const { projection } = visualElement;
        (0, _scaleCorrectionMjs.addScaleCorrector)(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, _stateMjs.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency, visualElement, drag, isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, _motionDom.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, _motionDom.microtask).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement, layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function MeasureLayout(props) {
    const [isPresent, safeToRemove] = (0, _usePresenceMjs.usePresence)();
    const layoutGroup = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext));
    return (0, _jsxRuntime.jsx)(MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, _react.useContext)((0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const defaultScaleCorrectors = {
    borderRadius: {
        ...(0, _scaleBorderRadiusMjs.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderTopRightRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderBottomLeftRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderBottomRightRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    boxShadow: (0, _scaleBoxShadowMjs.correctBoxShadow)
};

},{"react/jsx-runtime":"gaGEj","motion-dom":"7u9qw","react":"6uln9","../../../components/AnimatePresence/use-presence.mjs":"7TWAj","../../../context/LayoutGroupContext.mjs":"5CkZ6","../../../context/SwitchLayoutGroupContext.mjs":"6krc6","../../../projection/node/state.mjs":"5xBUr","../../../projection/styles/scale-border-radius.mjs":"f0J1M","../../../projection/styles/scale-box-shadow.mjs":"a9KkN","../../../projection/styles/scale-correction.mjs":"4bQbP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6krc6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchLayoutGroupContext", ()=>SwitchLayoutGroupContext);
var _react = require("react");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const SwitchLayoutGroupContext = (0, _react.createContext)({});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5xBUr":[function(require,module,exports,__globalThis) {
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalProjectionState", ()=>globalProjectionState);
const globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f0J1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctBorderRadius", ()=>correctBorderRadius);
parcelHelpers.export(exports, "pixelsToPercent", ()=>pixelsToPercent);
var _unitsMjs = require("../../value/types/numbers/units.mjs");
function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const correctBorderRadius = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, _unitsMjs.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = pixelsToPercent(latest, node.target.x);
        const y = pixelsToPercent(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

},{"../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a9KkN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctBoxShadow", ()=>correctBoxShadow);
var _numberMjs = require("../../utils/mix/number.mjs");
var _indexMjs = require("../../value/types/complex/index.mjs");
const correctBoxShadow = {
    correct: (latest, { treeScale, projectionDelta })=>{
        const original = latest;
        const shadow = (0, _indexMjs.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, _indexMjs.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, _numberMjs.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

},{"../../utils/mix/number.mjs":"e62GY","../../value/types/complex/index.mjs":"7EbqM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4bQbP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addScaleCorrector", ()=>addScaleCorrector);
parcelHelpers.export(exports, "scaleCorrectors", ()=>scaleCorrectors);
var _isCssVariableMjs = require("../../render/dom/utils/is-css-variable.mjs");
const scaleCorrectors = {};
function addScaleCorrector(correctors) {
    for(const key in correctors){
        scaleCorrectors[key] = correctors[key];
        if ((0, _isCssVariableMjs.isCSSVariableName)(key)) scaleCorrectors[key].isCSSVariable = true;
    }
}

},{"../../render/dom/utils/is-css-variable.mjs":"58wqN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJQj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLProjectionNode", ()=>HTMLProjectionNode);
parcelHelpers.export(exports, "rootProjectionNode", ()=>rootProjectionNode);
var _createProjectionNodeMjs = require("./create-projection-node.mjs");
var _documentProjectionNodeMjs = require("./DocumentProjectionNode.mjs");
const rootProjectionNode = {
    current: undefined
};
const HTMLProjectionNode = (0, _createProjectionNodeMjs.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!rootProjectionNode.current) {
            const documentNode = new (0, _documentProjectionNodeMjs.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

},{"./create-projection-node.mjs":"2osmA","./DocumentProjectionNode.mjs":"2Tecc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2osmA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanDirtyNodes", ()=>cleanDirtyNodes);
parcelHelpers.export(exports, "createProjectionNode", ()=>createProjectionNode);
parcelHelpers.export(exports, "mixAxis", ()=>mixAxis);
parcelHelpers.export(exports, "mixAxisDelta", ()=>mixAxisDelta);
parcelHelpers.export(exports, "mixBox", ()=>mixBox);
parcelHelpers.export(exports, "propagateDirtyNodes", ()=>propagateDirtyNodes);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _singleValueMjs = require("../../animation/animate/single-value.mjs");
var _getAppearIdMjs = require("../../animation/optimized-appear/get-appear-id.mjs");
var _isSvgElementMjs = require("../../render/dom/utils/is-svg-element.mjs");
var _flatTreeMjs = require("../../render/utils/flat-tree.mjs");
var _clampMjs = require("../../utils/clamp.mjs");
var _delayMjs = require("../../utils/delay.mjs");
var _numberMjs = require("../../utils/mix/number.mjs");
var _resolveMotionValueMjs = require("../../value/utils/resolve-motion-value.mjs");
var _mixValuesMjs = require("../animation/mix-values.mjs");
var _copyMjs = require("../geometry/copy.mjs");
var _deltaApplyMjs = require("../geometry/delta-apply.mjs");
var _deltaCalcMjs = require("../geometry/delta-calc.mjs");
var _deltaRemoveMjs = require("../geometry/delta-remove.mjs");
var _modelsMjs = require("../geometry/models.mjs");
var _utilsMjs = require("../geometry/utils.mjs");
var _stackMjs = require("../shared/stack.mjs");
var _scaleCorrectionMjs = require("../styles/scale-correction.mjs");
var _transformMjs = require("../styles/transform.mjs");
var _eachAxisMjs = require("../utils/each-axis.mjs");
var _hasTransformMjs = require("../utils/has-transform.mjs");
var _stateMjs = require("./state.mjs");
const metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const animationTarget = 1000;
let id = 0;
function resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, _getAppearIdMjs.getOptimisedAppearId)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout, layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, _motionDom.frame), !(layout || layoutId));
    }
    const { parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) cancelTreeOptimisedTransformAnimations(parent);
}
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, _motionDom.statsBuffer).value) metrics.nodes = metrics.calculatedTargetDeltas = metrics.calculatedProjections = 0;
                this.nodes.forEach(propagateDirtyNodes);
                this.nodes.forEach(resolveTargetDelta);
                this.nodes.forEach(calcProjection);
                this.nodes.forEach(cleanDirtyNodes);
                if ((0, _motionDom.statsBuffer).addProjectionMetrics) (0, _motionDom.statsBuffer).addProjectionMetrics(metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, _flatTreeMjs.FlatTree)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, _motionUtils.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, _isSvgElementMjs.isSVGElement)(instance);
            this.instance = instance;
            const { layoutId, layout, visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, _delayMjs.delay)(resizeUnblockUpdate, 250);
                    if ((0, _stateMjs.globalProjectionState).hasAnimatedSinceResize) {
                        (0, _stateMjs.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
                const { onLayoutAnimationStart, onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, _utilsMjs.boxEqualsRounded)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, _motionDom.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, _motionDom.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach(resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId, layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach(clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach(resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach(updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, _motionDom.time).now();
            (0, _motionDom.frameData).delta = (0, _clampMjs.clamp)(0, 1000 / 60, now - (0, _motionDom.frameData).timestamp);
            (0, _motionDom.frameData).timestamp = now;
            (0, _motionDom.frameData).isProcessing = true;
            (0, _motionDom.frameSteps).update.process((0, _motionDom.frameData));
            (0, _motionDom.frameSteps).preRender.process((0, _motionDom.frameData));
            (0, _motionDom.frameSteps).render.process((0, _motionDom.frameData));
            (0, _motionDom.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, _motionDom.microtask).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, _motionDom.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, _motionDom.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, _deltaCalcMjs.calcLength)(this.snapshot.measuredBox.x) && !(0, _deltaCalcMjs.calcLength)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, _modelsMjs.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase,
                    isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, _utilsMjs.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, _hasTransformMjs.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement } = this.options;
            if (!visualElement) return (0, _modelsMjs.createBox)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some(checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll } = this.root;
                if (scroll) {
                    (0, _deltaApplyMjs.translateAxis)(box.x, scroll.offset.x);
                    (0, _deltaApplyMjs.translateAxis)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, _modelsMjs.createBox)();
            (0, _copyMjs.copyBoxInto)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll, options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, _copyMjs.copyBoxInto)(boxWithoutScroll, box);
                    (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, _modelsMjs.createBox)();
            (0, _copyMjs.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, _deltaApplyMjs.transformBox)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, _hasTransformMjs.hasTransform)(node.latestValues)) continue;
                (0, _deltaApplyMjs.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, _hasTransformMjs.hasTransform)(this.latestValues)) (0, _deltaApplyMjs.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, _modelsMjs.createBox)();
            (0, _copyMjs.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, _hasTransformMjs.hasTransform)(node.latestValues)) continue;
                (0, _hasTransformMjs.hasScale)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, _modelsMjs.createBox)();
                const nodeBox = node.measurePageBox();
                (0, _copyMjs.copyBoxInto)(sourceBox, nodeBox);
                (0, _deltaRemoveMjs.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, _hasTransformMjs.hasTransform)(this.latestValues)) (0, _deltaRemoveMjs.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, _motionDom.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout, layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, _motionDom.frameData).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, _modelsMjs.createBox)();
                    this.relativeTargetOrigin = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, _copyMjs.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, _modelsMjs.createBox)();
                this.targetWithTransforms = (0, _modelsMjs.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, _deltaCalcMjs.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, _copyMjs.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, _deltaApplyMjs.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, _copyMjs.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, _modelsMjs.createBox)();
                    this.relativeTargetOrigin = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, _copyMjs.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, _motionDom.statsBuffer).value) metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, _hasTransformMjs.hasScale)(this.parent.latestValues) || (0, _hasTransformMjs.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, _motionDom.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout, layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, _copyMjs.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, _deltaApplyMjs.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, _modelsMjs.createBox)();
            }
            const { target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, _copyMjs.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, _copyMjs.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, _deltaCalcMjs.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, _utilsMjs.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, _utilsMjs.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, _motionDom.statsBuffer).value) metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, _modelsMjs.createDelta)();
            this.projectionDelta = (0, _modelsMjs.createDelta)();
            this.projectionDeltaWithTransform = (0, _modelsMjs.createDelta)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, _modelsMjs.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, _modelsMjs.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, _utilsMjs.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, _modelsMjs.createBox)();
                    (0, _copyMjs.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, _mixValuesMjs.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, _motionDom.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, _motionDom.frame).update(()=>{
                (0, _stateMjs.globalProjectionState).hasAnimatedSinceResize = true;
                (0, _motionDom.activeAnimations).layout++;
                this.currentAnimation = (0, _singleValueMjs.animateSingleValue)(0, animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, _motionDom.activeAnimations).layout--;
                    },
                    onComplete: ()=>{
                        (0, _motionDom.activeAnimations).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta(animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms, target, layout, latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, _modelsMjs.createBox)();
                const xLength = (0, _deltaCalcMjs.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, _deltaCalcMjs.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, _copyMjs.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, _deltaApplyMjs.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, _deltaCalcMjs.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, _stackMjs.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset, transition, preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < transformAxes.length; i++){
                resetDistortingTransform(`rotate${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                resetDistortingTransform(`skew${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, _hasTransformMjs.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, _transformMjs.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x, y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, _scaleCorrectionMjs.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct, applyTo, isCSSVariable } = (0, _scaleCorrectionMjs.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, _eachAxisMjs.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, _deltaCalcMjs.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, _eachAxisMjs.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, _deltaCalcMjs.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, _modelsMjs.createDelta)();
        (0, _deltaCalcMjs.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, _modelsMjs.createDelta)();
        if (isShared) (0, _deltaCalcMjs.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, _deltaCalcMjs.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, _utilsMjs.isDeltaZero)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, _utilsMjs.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout,
            snapshot,
            delta: visualDelta,
            layoutDelta,
            hasLayoutChanged,
            hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, _motionDom.statsBuffer).value) metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function cleanDirtyNodes(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function resetTransformStyle(node) {
    const { visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = (0, _numberMjs.mixNumber)(delta.translate, 0, p);
    output.scale = (0, _numberMjs.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = (0, _numberMjs.mixNumber)(from.min, to.min, p);
    output.max = (0, _numberMjs.mixNumber)(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : (0, _motionUtils.noop);
function roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = roundPoint(axis.min);
    axis.max = roundPoint(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, _deltaCalcMjs.isNear)((0, _utilsMjs.aspectRatio)(snapshot), (0, _utilsMjs.aspectRatio)(layout), 0.2);
}
function checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../animation/animate/single-value.mjs":"gKtfq","../../animation/optimized-appear/get-appear-id.mjs":"bvIte","../../render/dom/utils/is-svg-element.mjs":"ytKOV","../../render/utils/flat-tree.mjs":"5W1eO","../../utils/clamp.mjs":"5mu0r","../../utils/delay.mjs":"jfaIw","../../utils/mix/number.mjs":"e62GY","../../value/utils/resolve-motion-value.mjs":"3pwN1","../animation/mix-values.mjs":"j7By7","../geometry/copy.mjs":"8tF3L","../geometry/delta-apply.mjs":"36VRX","../geometry/delta-calc.mjs":"lmUuI","../geometry/delta-remove.mjs":"1BpAZ","../geometry/models.mjs":"huYV1","../geometry/utils.mjs":"DjrUU","../shared/stack.mjs":"hHhUs","../styles/scale-correction.mjs":"4bQbP","../styles/transform.mjs":"eJIA7","../utils/each-axis.mjs":"dZLv7","../utils/has-transform.mjs":"7hVzp","./state.mjs":"5xBUr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKtfq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateSingleValue", ()=>animateSingleValue);
var _motionDom = require("motion-dom");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
var _motionValueMjs = require("../interfaces/motion-value.mjs");
function animateSingleValue(value, keyframes, options) {
    const motionValue$1 = (0, _isMotionValueMjs.isMotionValue)(value) ? value : (0, _motionDom.motionValue)(value);
    motionValue$1.start((0, _motionValueMjs.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

},{"motion-dom":"7u9qw","../../value/utils/is-motion-value.mjs":"2kZP7","../interfaces/motion-value.mjs":"lumbS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ytKOV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGElement", ()=>isSVGElement);
function isSVGElement(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5W1eO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlatTree", ()=>FlatTree);
var _motionUtils = require("motion-utils");
var _compareByDepthMjs = require("./compare-by-depth.mjs");
class FlatTree {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, _motionUtils.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, _motionUtils.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, _compareByDepthMjs.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

},{"motion-utils":"h8hZz","./compare-by-depth.mjs":"7rffJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7rffJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareByDepth", ()=>compareByDepth);
const compareByDepth = (a, b)=>a.depth - b.depth;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfaIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
parcelHelpers.export(exports, "delayInSeconds", ()=>delayInSeconds);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
/**
 * Timeout defined in ms
 */ function delay(callback, timeout) {
    const start = (0, _motionDom.time).now();
    const checkElapsed = ({ timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, _motionDom.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, _motionDom.frame).read(checkElapsed, true);
    return ()=>(0, _motionDom.cancelFrame)(checkElapsed);
}
function delayInSeconds(callback, timeout) {
    return delay(callback, (0, _motionUtils.secondsToMilliseconds)(timeout));
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3pwN1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveMotionValue", ()=>resolveMotionValue);
var _resolveValueMjs = require("../../utils/resolve-value.mjs");
var _isMotionValueMjs = require("./is-motion-value.mjs");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function resolveMotionValue(value) {
    const unwrappedValue = (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value;
    return (0, _resolveValueMjs.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

},{"../../utils/resolve-value.mjs":"b1tRE","./is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j7By7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixValues", ()=>mixValues);
var _motionUtils = require("motion-utils");
var _circMjs = require("../../easing/circ.mjs");
var _numberMjs = require("../../utils/mix/number.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
const borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const numBorders = borders.length;
const asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const isPx = (value)=>typeof value === "number" || (0, _unitsMjs.px).test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, _numberMjs.mixNumber)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
        target.opacityExit = (0, _numberMjs.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, _numberMjs.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < numBorders; i++){
        const borderLabel = `border${borders[i]}Radius`;
        let followRadius = getRadius(follow, borderLabel);
        let leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, _numberMjs.mixNumber)(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if ((0, _unitsMjs.percent).test(leadRadius) || (0, _unitsMjs.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, _numberMjs.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const easeCrossfadeIn = /*@__PURE__*/ compress(0, 0.5, (0, _circMjs.circOut));
const easeCrossfadeOut = /*@__PURE__*/ compress(0.5, 0.95, (0, _motionUtils.noop));
function compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, _motionUtils.progress)(min, max, p));
    };
}

},{"motion-utils":"h8hZz","../../easing/circ.mjs":"do4I6","../../utils/mix/number.mjs":"e62GY","../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8tF3L":[function(require,module,exports,__globalThis) {
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyAxisDeltaInto", ()=>copyAxisDeltaInto);
parcelHelpers.export(exports, "copyAxisInto", ()=>copyAxisInto);
parcelHelpers.export(exports, "copyBoxInto", ()=>copyBoxInto);
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function copyAxisDeltaInto(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1BpAZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeAxisDelta", ()=>removeAxisDelta);
parcelHelpers.export(exports, "removeAxisTransforms", ()=>removeAxisTransforms);
parcelHelpers.export(exports, "removeBoxTransforms", ()=>removeBoxTransforms);
parcelHelpers.export(exports, "removePointDelta", ()=>removePointDelta);
var _numberMjs = require("../../utils/mix/number.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
var _deltaApplyMjs = require("./delta-apply.mjs");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, _deltaApplyMjs.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, _deltaApplyMjs.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, _unitsMjs.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, _numberMjs.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, _numberMjs.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const xKeys = [
    "x",
    "scaleX",
    "originX"
];
const yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

},{"../../utils/mix/number.mjs":"e62GY","../../value/types/numbers/units.mjs":"hGtBr","./delta-apply.mjs":"36VRX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"DjrUU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aspectRatio", ()=>aspectRatio);
parcelHelpers.export(exports, "axisDeltaEquals", ()=>axisDeltaEquals);
parcelHelpers.export(exports, "axisEquals", ()=>axisEquals);
parcelHelpers.export(exports, "axisEqualsRounded", ()=>axisEqualsRounded);
parcelHelpers.export(exports, "boxEquals", ()=>boxEquals);
parcelHelpers.export(exports, "boxEqualsRounded", ()=>boxEqualsRounded);
parcelHelpers.export(exports, "isDeltaZero", ()=>isDeltaZero);
var _deltaCalcMjs = require("./delta-calc.mjs");
function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function axisEquals(a, b) {
    return a.min === b.min && a.max === b.max;
}
function boxEquals(a, b) {
    return axisEquals(a.x, b.x) && axisEquals(a.y, b.y);
}
function axisEqualsRounded(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function boxEqualsRounded(a, b) {
    return axisEqualsRounded(a.x, b.x) && axisEqualsRounded(a.y, b.y);
}
function aspectRatio(box) {
    return (0, _deltaCalcMjs.calcLength)(box.x) / (0, _deltaCalcMjs.calcLength)(box.y);
}
function axisDeltaEquals(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

},{"./delta-calc.mjs":"lmUuI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hHhUs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeStack", ()=>NodeStack);
var _motionUtils = require("motion-utils");
class NodeStack {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, _motionUtils.addUniqueItem)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, _motionUtils.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options, resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}

},{"motion-utils":"h8hZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJIA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildProjectionTransform", ()=>buildProjectionTransform);
function buildProjectionTransform(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective, rotate, rotateX, rotateY, skewX, skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Tecc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentProjectionNode", ()=>DocumentProjectionNode);
var _createProjectionNodeMjs = require("./create-projection-node.mjs");
var _addDomEventMjs = require("../../events/add-dom-event.mjs");
const DocumentProjectionNode = (0, _createProjectionNodeMjs.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, _addDomEventMjs.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});

},{"./create-projection-node.mjs":"2osmA","../../events/add-dom-event.mjs":"82u3S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7BuHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gestureAnimations", ()=>gestureAnimations);
var _hoverMjs = require("../../gestures/hover.mjs");
var _focusMjs = require("../../gestures/focus.mjs");
var _pressMjs = require("../../gestures/press.mjs");
var _indexMjs = require("./viewport/index.mjs");
const gestureAnimations = {
    inView: {
        Feature: (0, _indexMjs.InViewFeature)
    },
    tap: {
        Feature: (0, _pressMjs.PressGesture)
    },
    focus: {
        Feature: (0, _focusMjs.FocusGesture)
    },
    hover: {
        Feature: (0, _hoverMjs.HoverGesture)
    }
};

},{"../../gestures/hover.mjs":"lRuoN","../../gestures/focus.mjs":"9SVEI","../../gestures/press.mjs":"aEl6F","./viewport/index.mjs":"b9A3a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lRuoN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverGesture", ()=>HoverGesture);
var _motionDom = require("motion-dom");
var _eventInfoMjs = require("../events/event-info.mjs");
var _featureMjs = require("../motion/features/Feature.mjs");
function handleHoverEvent(node, event, lifecycle) {
    const { props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, _motionDom.frame).postRender(()=>callback(event, (0, _eventInfoMjs.extractEventInfo)(event)));
}
class HoverGesture extends (0, _featureMjs.Feature) {
    mount() {
        const { current } = this.node;
        if (!current) return;
        this.unmount = (0, _motionDom.hover)(current, (_element, startEvent)=>{
            handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}

},{"motion-dom":"7u9qw","../events/event-info.mjs":"8dFDB","../motion/features/Feature.mjs":"9q59Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SVEI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusGesture", ()=>FocusGesture);
var _addDomEventMjs = require("../events/add-dom-event.mjs");
var _featureMjs = require("../motion/features/Feature.mjs");
var _pipeMjs = require("../utils/pipe.mjs");
class FocusGesture extends (0, _featureMjs.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, _pipeMjs.pipe)((0, _addDomEventMjs.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, _addDomEventMjs.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

},{"../events/add-dom-event.mjs":"82u3S","../motion/features/Feature.mjs":"9q59Z","../utils/pipe.mjs":"jSVi0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aEl6F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PressGesture", ()=>PressGesture);
var _motionDom = require("motion-dom");
var _eventInfoMjs = require("../events/event-info.mjs");
var _featureMjs = require("../motion/features/Feature.mjs");
function handlePressEvent(node, event, lifecycle) {
    const { props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, _motionDom.frame).postRender(()=>callback(event, (0, _eventInfoMjs.extractEventInfo)(event)));
}
class PressGesture extends (0, _featureMjs.Feature) {
    mount() {
        const { current } = this.node;
        if (!current) return;
        this.unmount = (0, _motionDom.press)(current, (_element, startEvent)=>{
            handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success })=>handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}

},{"motion-dom":"7u9qw","../events/event-info.mjs":"8dFDB","../motion/features/Feature.mjs":"9q59Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9A3a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InViewFeature", ()=>InViewFeature);
var _featureMjs = require("../Feature.mjs");
var _observersMjs = require("./observers.mjs");
const thresholdNames = {
    some: 0,
    all: 1
};
class InViewFeature extends (0, _featureMjs.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport = {} } = this.node.getProps();
        const { root, margin: rootMargin, amount = "some", once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter, onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, _observersMjs.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props, prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some(hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

},{"../Feature.mjs":"9q59Z","./observers.mjs":"j5r65","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j5r65":[function(require,module,exports,__globalThis) {
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeIntersection", ()=>observeIntersection);
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const observers = new WeakMap();
const fireObserverCallback = (entry)=>{
    const callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const fireAllObserverCallbacks = (entries)=>{
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!observers.has(lookupRoot)) observers.set(lookupRoot, {});
    const rootObservers = observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, {
        root,
        ...options
    });
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    const rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"81FkM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "layout", ()=>layout);
var _htmlprojectionNodeMjs = require("../../projection/node/HTMLProjectionNode.mjs");
var _measureLayoutMjs = require("./layout/MeasureLayout.mjs");
const layout = {
    layout: {
        ProjectionNode: (0, _htmlprojectionNodeMjs.HTMLProjectionNode),
        MeasureLayout: (0, _measureLayoutMjs.MeasureLayout)
    }
};

},{"../../projection/node/HTMLProjectionNode.mjs":"eJQj5","./layout/MeasureLayout.mjs":"bwaXs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iMlVh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMotionComponentFactory", ()=>createMotionComponentFactory);
var _indexMjs = require("../../motion/index.mjs");
var _useRenderMjs = require("../dom/use-render.mjs");
var _isSvgComponentMjs = require("../dom/utils/is-svg-component.mjs");
var _configMotionMjs = require("../html/config-motion.mjs");
var _configMotionMjs1 = require("../svg/config-motion.mjs");
function createMotionComponentFactory(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, _isSvgComponentMjs.isSVGComponent)(Component) ? (0, _configMotionMjs1.svgMotionConfig) : (0, _configMotionMjs.htmlMotionConfig);
        const config = {
            ...baseConfig,
            preloadedFeatures,
            useRender: (0, _useRenderMjs.createUseRender)(forwardMotionProps),
            createVisualElement,
            Component
        };
        return (0, _indexMjs.createRendererMotionComponent)(config);
    };
}

},{"../../motion/index.mjs":"4SUx6","../dom/use-render.mjs":"g2NMN","../dom/utils/is-svg-component.mjs":"2Ozjv","../html/config-motion.mjs":"3omuU","../svg/config-motion.mjs":"5XVUv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4SUx6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRendererMotionComponent", ()=>createRendererMotionComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _motionUtils = require("motion-utils");
var _react = require("react");
var _layoutGroupContextMjs = require("../context/LayoutGroupContext.mjs");
var _lazyContextMjs = require("../context/LazyContext.mjs");
var _motionConfigContextMjs = require("../context/MotionConfigContext.mjs");
var _indexMjs = require("../context/MotionContext/index.mjs");
var _createMjs = require("../context/MotionContext/create.mjs");
var _isBrowserMjs = require("../utils/is-browser.mjs");
var _definitionsMjs = require("./features/definitions.mjs");
var _loadFeaturesMjs = require("./features/load-features.mjs");
var _symbolMjs = require("./utils/symbol.mjs");
var _useMotionRefMjs = require("./utils/use-motion-ref.mjs");
var _useVisualElementMjs = require("./utils/use-visual-element.mjs");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function createRendererMotionComponent({ preloadedFeatures, createVisualElement, useRender, useVisualState, Component }) {
    var _a, _b;
    preloadedFeatures && (0, _loadFeaturesMjs.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext)),
            ...props,
            layoutId: useLayoutId(props)
        };
        const { isStatic } = configAndProps;
        const context = (0, _createMjs.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, _isBrowserMjs.isBrowser)) {
            useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, _useVisualElementMjs.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, _jsxRuntime.jsxs)((0, _indexMjs.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, _jsxRuntime.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, _useMotionRefMjs.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    MotionComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${(_b = (_a = Component.displayName) !== null && _a !== void 0 ? _a : Component.name) !== null && _b !== void 0 ? _b : ""})`}`;
    const ForwardRefMotionComponent = (0, _react.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, _symbolMjs.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function useLayoutId({ layoutId }) {
    const layoutGroupId = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, _react.useContext)((0, _lazyContextMjs.LazyContext)).strict;
}
function getProjectionFunctionality(props) {
    const { drag, layout } = (0, _definitionsMjs.featureDefinitions);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

},{"react/jsx-runtime":"gaGEj","motion-utils":"h8hZz","react":"6uln9","../context/LayoutGroupContext.mjs":"5CkZ6","../context/LazyContext.mjs":"3Vzns","../context/MotionConfigContext.mjs":"92LC9","../context/MotionContext/index.mjs":"7Mlzo","../context/MotionContext/create.mjs":"lMScg","../utils/is-browser.mjs":"9ew4K","./features/definitions.mjs":"hJfDG","./features/load-features.mjs":"hKPEi","./utils/symbol.mjs":"7WA7h","./utils/use-motion-ref.mjs":"2OEvp","./utils/use-visual-element.mjs":"iCjOe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Vzns":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LazyContext", ()=>LazyContext);
var _react = require("react");
"use client";
const LazyContext = (0, _react.createContext)({
    strict: false
});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Mlzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionContext", ()=>MotionContext);
var _react = require("react");
"use client";
const MotionContext = /* @__PURE__ */ (0, _react.createContext)({});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lMScg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreateMotionContext", ()=>useCreateMotionContext);
var _react = require("react");
var _indexMjs = require("./index.mjs");
var _utilsMjs = require("./utils.mjs");
function useCreateMotionContext(props) {
    const { initial, animate } = (0, _utilsMjs.getCurrentTreeVariants)(props, (0, _react.useContext)((0, _indexMjs.MotionContext)));
    return (0, _react.useMemo)(()=>({
            initial,
            animate
        }), [
        variantLabelsAsDependency(initial),
        variantLabelsAsDependency(animate)
    ]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

},{"react":"6uln9","./index.mjs":"7Mlzo","./utils.mjs":"jOm5Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOm5Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCurrentTreeVariants", ()=>getCurrentTreeVariants);
var _isControllingVariantsMjs = require("../../render/utils/is-controlling-variants.mjs");
var _isVariantLabelMjs = require("../../render/utils/is-variant-label.mjs");
function getCurrentTreeVariants(props, context) {
    if ((0, _isControllingVariantsMjs.isControllingVariants)(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || (0, _isVariantLabelMjs.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, _isVariantLabelMjs.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

},{"../../render/utils/is-controlling-variants.mjs":"tz7Ig","../../render/utils/is-variant-label.mjs":"hGXyz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"tz7Ig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isControllingVariants", ()=>isControllingVariants);
parcelHelpers.export(exports, "isVariantNode", ()=>isVariantNode);
var _isAnimationControlsMjs = require("../../animation/utils/is-animation-controls.mjs");
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
function isControllingVariants(props) {
    return (0, _isAnimationControlsMjs.isAnimationControls)(props.animate) || (0, _variantPropsMjs.variantProps).some((name)=>(0, _isVariantLabelMjs.isVariantLabel)(props[name]));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

},{"../../animation/utils/is-animation-controls.mjs":"fDSp3","./is-variant-label.mjs":"hGXyz","./variant-props.mjs":"8wQuM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hJfDG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "featureDefinitions", ()=>featureDefinitions);
const featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const featureDefinitions = {};
for(const key in featureProps)featureDefinitions[key] = {
    isEnabled: (props)=>featureProps[key].some((name)=>!!props[name])
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hKPEi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadFeatures", ()=>loadFeatures);
var _definitionsMjs = require("./definitions.mjs");
function loadFeatures(features) {
    for(const key in features)(0, _definitionsMjs.featureDefinitions)[key] = {
        ...(0, _definitionsMjs.featureDefinitions)[key],
        ...features[key]
    };
}

},{"./definitions.mjs":"hJfDG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7WA7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "motionComponentSymbol", ()=>motionComponentSymbol);
const motionComponentSymbol = Symbol.for("motionComponentSymbol");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2OEvp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMotionRef", ()=>useMotionRef);
var _react = require("react");
var _isRefObjectMjs = require("../../utils/is-ref-object.mjs");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function useMotionRef(visualState, visualElement, externalRef) {
    return (0, _react.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, _isRefObjectMjs.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

},{"react":"6uln9","../../utils/is-ref-object.mjs":"gluK5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iCjOe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVisualElement", ()=>useVisualElement);
var _motionDom = require("motion-dom");
var _react = require("react");
var _dataIdMjs = require("../../animation/optimized-appear/data-id.mjs");
var _lazyContextMjs = require("../../context/LazyContext.mjs");
var _motionConfigContextMjs = require("../../context/MotionConfigContext.mjs");
var _indexMjs = require("../../context/MotionContext/index.mjs");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _switchLayoutGroupContextMjs = require("../../context/SwitchLayoutGroupContext.mjs");
var _isRefObjectMjs = require("../../utils/is-ref-object.mjs");
var _useIsomorphicEffectMjs = require("../../utils/use-isomorphic-effect.mjs");
function useVisualElement(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = (0, _react.useContext)((0, _indexMjs.MotionContext));
    const lazyContext = (0, _react.useContext)((0, _lazyContextMjs.LazyContext));
    const presenceContext = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
    const reducedMotionConfig = (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, _react.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState,
        parent,
        props,
        presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, _react.useContext)((0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, _react.useRef)(false);
    (0, _react.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, _dataIdMjs.optimizedAppearDataAttribute];
    const wantsHandoff = (0, _react.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, _motionDom.microtask).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, _react.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId, layout, drag, dragConstraints, layoutScroll, layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId,
        layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, _isRefObjectMjs.isRefObject)(dragConstraints),
        visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig,
        layoutScroll,
        layoutRoot
    });
}
function getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : getClosestProjectingNode(visualElement.parent);
}

},{"motion-dom":"7u9qw","react":"6uln9","../../animation/optimized-appear/data-id.mjs":"jLjpN","../../context/LazyContext.mjs":"3Vzns","../../context/MotionConfigContext.mjs":"92LC9","../../context/MotionContext/index.mjs":"7Mlzo","../../context/PresenceContext.mjs":"dcXf9","../../context/SwitchLayoutGroupContext.mjs":"6krc6","../../utils/is-ref-object.mjs":"gluK5","../../utils/use-isomorphic-effect.mjs":"6Pcpq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g2NMN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUseRender", ()=>createUseRender);
var _react = require("react");
var _usePropsMjs = require("../html/use-props.mjs");
var _filterPropsMjs = require("./utils/filter-props.mjs");
var _isSvgComponentMjs = require("./utils/is-svg-component.mjs");
var _usePropsMjs1 = require("../svg/use-props.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
function createUseRender(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues }, isStatic)=>{
        const useVisualProps = (0, _isSvgComponentMjs.isSVGComponent)(Component) ? (0, _usePropsMjs1.useSVGProps) : (0, _usePropsMjs.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, _filterPropsMjs.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, _react.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children } = props;
        const renderedChildren = (0, _react.useMemo)(()=>(0, _isMotionValueMjs.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, _react.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

},{"react":"6uln9","../html/use-props.mjs":"eKir9","./utils/filter-props.mjs":"aziKV","./utils/is-svg-component.mjs":"2Ozjv","../svg/use-props.mjs":"7mOnz","../../value/utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eKir9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyRawValuesOnly", ()=>copyRawValuesOnly);
parcelHelpers.export(exports, "useHTMLProps", ()=>useHTMLProps);
var _react = require("react");
var _isForcedMotionValueMjs = require("../../motion/utils/is-forced-motion-value.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
var _buildStylesMjs = require("./utils/build-styles.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
function copyRawValuesOnly(target, source, props) {
    for(const key in source)if (!(0, _isMotionValueMjs.isMotionValue)(source[key]) && !(0, _isForcedMotionValueMjs.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function useInitialMotionValues({ transformTemplate }, visualState) {
    return (0, _react.useMemo)(()=>{
        const state = (0, _createRenderStateMjs.createHtmlRenderState)();
        (0, _buildStylesMjs.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState));
    return style;
}
function useHTMLProps(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

},{"react":"6uln9","../../motion/utils/is-forced-motion-value.mjs":"c7w2E","../../value/utils/is-motion-value.mjs":"2kZP7","./utils/build-styles.mjs":"3JcOY","./utils/create-render-state.mjs":"cXDm8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c7w2E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isForcedMotionValue", ()=>isForcedMotionValue);
var _scaleCorrectionMjs = require("../../projection/styles/scale-correction.mjs");
var _keysTransformMjs = require("../../render/html/utils/keys-transform.mjs");
function isForcedMotionValue(key, { layout, layoutId }) {
    return (0, _keysTransformMjs.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, _scaleCorrectionMjs.scaleCorrectors)[key] || key === "opacity");
}

},{"../../projection/styles/scale-correction.mjs":"4bQbP","../../render/html/utils/keys-transform.mjs":"b4poF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3JcOY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildHTMLStyles", ()=>buildHTMLStyles);
var _isCssVariableMjs = require("../../dom/utils/is-css-variable.mjs");
var _getAsTypeMjs = require("../../dom/value-types/get-as-type.mjs");
var _numberMjs = require("../../dom/value-types/number.mjs");
var _buildTransformMjs = require("./build-transform.mjs");
var _keysTransformMjs = require("./keys-transform.mjs");
function buildHTMLStyles(state, latestValues, transformTemplate) {
    const { style, vars, transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, _keysTransformMjs.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, _isCssVariableMjs.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, _getAsTypeMjs.getValueAsType)(value, (0, _numberMjs.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, _buildTransformMjs.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

},{"../../dom/utils/is-css-variable.mjs":"58wqN","../../dom/value-types/get-as-type.mjs":"9zJP1","../../dom/value-types/number.mjs":"fQqUe","./build-transform.mjs":"jHo4I","./keys-transform.mjs":"b4poF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9zJP1":[function(require,module,exports,__globalThis) {
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueAsType", ()=>getValueAsType);
const getValueAsType = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jHo4I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildTransform", ()=>buildTransform);
var _getAsTypeMjs = require("../../dom/value-types/get-as-type.mjs");
var _numberMjs = require("../../dom/value-types/number.mjs");
var _keysTransformMjs = require("./keys-transform.mjs");
const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const numTransforms = (0, _keysTransformMjs.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function buildTransform(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < numTransforms; i++){
        const key = (0, _keysTransformMjs.transformPropOrder)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, _getAsTypeMjs.getValueAsType)(value, (0, _numberMjs.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

},{"../../dom/value-types/get-as-type.mjs":"9zJP1","../../dom/value-types/number.mjs":"fQqUe","./keys-transform.mjs":"b4poF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cXDm8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHtmlRenderState", ()=>createHtmlRenderState);
const createHtmlRenderState = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aziKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "loadExternalIsValidProp", ()=>loadExternalIsValidProp);
var _validPropMjs = require("../../../motion/utils/valid-prop.mjs");
let shouldForward = (key)=>!(0, _validPropMjs.isValidMotionProp)(key);
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    shouldForward = (key)=>key.startsWith("on") ? !(0, _validPropMjs.isValidMotionProp)(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ loadExternalIsValidProp(require("125f13913be7321c").default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if (shouldForward(key) || forwardMotionProps === true && (0, _validPropMjs.isValidMotionProp)(key) || !isDom && !(0, _validPropMjs.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

},{"../../../motion/utils/valid-prop.mjs":"9BUQz","125f13913be7321c":"8Sfn2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9BUQz":[function(require,module,exports,__globalThis) {
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidMotionProp", ()=>isValidMotionProp);
const validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function isValidMotionProp(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Sfn2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"dMybP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMybP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Ozjv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGComponent", ()=>isSVGComponent);
var _lowercaseElementsMjs = require("../../svg/lowercase-elements.mjs");
function isSVGComponent(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, _lowercaseElementsMjs.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

},{"../../svg/lowercase-elements.mjs":"4TUrb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4TUrb":[function(require,module,exports,__globalThis) {
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lowercaseSVGElements", ()=>lowercaseSVGElements);
const lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7mOnz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSVGProps", ()=>useSVGProps);
var _react = require("react");
var _usePropsMjs = require("../html/use-props.mjs");
var _buildAttrsMjs = require("./utils/build-attrs.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
var _isSvgTagMjs = require("./utils/is-svg-tag.mjs");
function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = (0, _react.useMemo)(()=>{
        const state = (0, _createRenderStateMjs.createSvgRenderState)();
        (0, _buildAttrsMjs.buildSVGAttrs)(state, visualState, (0, _isSvgTagMjs.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, _usePropsMjs.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

},{"react":"6uln9","../html/use-props.mjs":"eKir9","./utils/build-attrs.mjs":"bzDqj","./utils/create-render-state.mjs":"jgAzj","./utils/is-svg-tag.mjs":"7qIqE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzDqj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSVGAttrs", ()=>buildSVGAttrs);
var _buildStylesMjs = require("../../html/utils/build-styles.mjs");
var _pathMjs = require("./path.mjs");
var _transformOriginMjs = require("./transform-origin.mjs");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function buildSVGAttrs(state, { attrX, attrY, attrScale, originX, originY, pathLength, pathSpacing = 1, pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, _buildStylesMjs.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs, style, dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, _transformOriginMjs.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, _pathMjs.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

},{"../../html/utils/build-styles.mjs":"3JcOY","./path.mjs":"6lBpV","./transform-origin.mjs":"lwbn8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6lBpV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSVGPath", ()=>buildSVGPath);
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
const dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, _unitsMjs.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, _unitsMjs.px).transform(length);
    const pathSpacing = (0, _unitsMjs.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

},{"../../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lwbn8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcSVGTransformOrigin", ()=>calcSVGTransformOrigin);
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
function calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, _unitsMjs.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function calcSVGTransformOrigin(dimensions, originX, originY) {
    const pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

},{"../../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgAzj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSvgRenderState", ()=>createSvgRenderState);
var _createRenderStateMjs = require("../../html/utils/create-render-state.mjs");
const createSvgRenderState = ()=>({
        ...(0, _createRenderStateMjs.createHtmlRenderState)(),
        attrs: {}
    });

},{"../../html/utils/create-render-state.mjs":"cXDm8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7qIqE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGTag", ()=>isSVGTag);
const isSVGTag = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3omuU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "htmlMotionConfig", ()=>htmlMotionConfig);
var _useVisualStateMjs = require("../../motion/utils/use-visual-state.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
const htmlMotionConfig = {
    useVisualState: (0, _useVisualStateMjs.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps),
        createRenderState: (0, _createRenderStateMjs.createHtmlRenderState)
    })
};

},{"../../motion/utils/use-visual-state.mjs":"5FgNd","./utils/scrape-motion-values.mjs":"irGuL","./utils/create-render-state.mjs":"cXDm8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5FgNd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeUseVisualState", ()=>makeUseVisualState);
var _react = require("react");
var _isAnimationControlsMjs = require("../../animation/utils/is-animation-controls.mjs");
var _indexMjs = require("../../context/MotionContext/index.mjs");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _isControllingVariantsMjs = require("../../render/utils/is-controlling-variants.mjs");
var _resolveVariantsMjs = require("../../render/utils/resolve-variants.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
var _resolveMotionValueMjs = require("../../value/utils/resolve-motion-value.mjs");
function makeState({ scrapeMotionValuesFromProps, createRenderState, onUpdate }, props, context, presenceContext) {
    const state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onUpdate) {
        /**
         * onMount works without the VisualElement because it could be
         * called before the VisualElement payload has been hydrated.
         * (e.g. if someone is using m components <m.circle />)
         */ state.onMount = (instance)=>onUpdate({
                props,
                current: instance,
                ...state
            });
        state.onUpdate = (visualElement)=>onUpdate(visualElement);
    }
    return state;
}
const makeUseVisualState = (config)=>(props, isStatic)=>{
        const context = (0, _react.useContext)((0, _indexMjs.MotionContext));
        const presenceContext = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
        const make = ()=>makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, _useConstantMjs.useConstant)(make);
    };
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, _resolveMotionValueMjs.resolveMotionValue)(motionValues[key]);
    let { initial, animate } = props;
    const isControllingVariants$1 = (0, _isControllingVariantsMjs.isControllingVariants)(props);
    const isVariantNode$1 = (0, _isControllingVariantsMjs.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, _isAnimationControlsMjs.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, _resolveVariantsMjs.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                const { transitionEnd, transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}

},{"react":"6uln9","../../animation/utils/is-animation-controls.mjs":"fDSp3","../../context/MotionContext/index.mjs":"7Mlzo","../../context/PresenceContext.mjs":"dcXf9","../../render/utils/is-controlling-variants.mjs":"tz7Ig","../../render/utils/resolve-variants.mjs":"iR2sd","../../utils/use-constant.mjs":"7bpoo","../../value/utils/resolve-motion-value.mjs":"3pwN1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"irGuL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrapeMotionValuesFromProps", ()=>scrapeMotionValuesFromProps);
var _isForcedMotionValueMjs = require("../../../motion/utils/is-forced-motion-value.mjs");
var _isMotionValueMjs = require("../../../value/utils/is-motion-value.mjs");
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    var _a;
    const { style } = props;
    const newValues = {};
    for(const key in style)if ((0, _isMotionValueMjs.isMotionValue)(style[key]) || prevProps.style && (0, _isMotionValueMjs.isMotionValue)(prevProps.style[key]) || (0, _isForcedMotionValueMjs.isForcedMotionValue)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

},{"../../../motion/utils/is-forced-motion-value.mjs":"c7w2E","../../../value/utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5XVUv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "svgMotionConfig", ()=>svgMotionConfig);
var _motionDom = require("motion-dom");
var _useVisualStateMjs = require("../../motion/utils/use-visual-state.mjs");
var _keysTransformMjs = require("../html/utils/keys-transform.mjs");
var _buildAttrsMjs = require("./utils/build-attrs.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
var _isSvgTagMjs = require("./utils/is-svg-tag.mjs");
var _measureMjs = require("./utils/measure.mjs");
var _renderMjs = require("./utils/render.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
const layoutProps = [
    "x",
    "y",
    "width",
    "height",
    "cx",
    "cy",
    "r"
];
const svgMotionConfig = {
    useVisualState: (0, _useVisualStateMjs.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps),
        createRenderState: (0, _createRenderStateMjs.createSvgRenderState),
        onUpdate: ({ props, prevProps, current, renderState, latestValues })=>{
            if (!current) return;
            let hasTransform = !!props.drag;
            if (!hasTransform) {
                for(const key in latestValues)if ((0, _keysTransformMjs.transformProps).has(key)) {
                    hasTransform = true;
                    break;
                }
            }
            if (!hasTransform) return;
            let needsMeasure = !prevProps;
            if (prevProps) /**
                 * Check the layout props for changes, if any are found we need to
                 * measure the element again.
                 */ for(let i = 0; i < layoutProps.length; i++){
                const key = layoutProps[i];
                if (props[key] !== prevProps[key]) needsMeasure = true;
            }
            if (!needsMeasure) return;
            (0, _motionDom.frame).read(()=>{
                (0, _measureMjs.updateSVGDimensions)(current, renderState);
                (0, _motionDom.frame).render(()=>{
                    (0, _buildAttrsMjs.buildSVGAttrs)(renderState, latestValues, (0, _isSvgTagMjs.isSVGTag)(current.tagName), props.transformTemplate);
                    (0, _renderMjs.renderSVG)(current, renderState);
                });
            });
        }
    })
};

},{"motion-dom":"7u9qw","../../motion/utils/use-visual-state.mjs":"5FgNd","../html/utils/keys-transform.mjs":"b4poF","./utils/build-attrs.mjs":"bzDqj","./utils/create-render-state.mjs":"jgAzj","./utils/is-svg-tag.mjs":"7qIqE","./utils/measure.mjs":"iaqrh","./utils/render.mjs":"7rQiG","./utils/scrape-motion-values.mjs":"7vKCJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iaqrh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateSVGDimensions", ()=>updateSVGDimensions);
function updateSVGDimensions(instance, renderState) {
    try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
    } catch (e) {
        // Most likely trying to measure an unrendered element under Firefox
        renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7rQiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderSVG", ()=>renderSVG);
var _camelToDashMjs = require("../../dom/utils/camel-to-dash.mjs");
var _renderMjs = require("../../html/utils/render.mjs");
var _camelCaseAttrsMjs = require("./camel-case-attrs.mjs");
function renderSVG(element, renderState, _styleProp, projection) {
    (0, _renderMjs.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, _camelCaseAttrsMjs.camelCaseAttributes).has(key) ? (0, _camelToDashMjs.camelToDash)(key) : key, renderState.attrs[key]);
}

},{"../../dom/utils/camel-to-dash.mjs":"kNuZz","../../html/utils/render.mjs":"6SuGI","./camel-case-attrs.mjs":"jpeUe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6SuGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderHTML", ()=>renderHTML);
function renderHTML(element, { style, vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpeUe":[function(require,module,exports,__globalThis) {
/**
 * A set of attribute names that are always read/written as camel case.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelCaseAttributes", ()=>camelCaseAttributes);
const camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7vKCJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrapeMotionValuesFromProps", ()=>scrapeMotionValuesFromProps);
var _isMotionValueMjs = require("../../../value/utils/is-motion-value.mjs");
var _keysTransformMjs = require("../../html/utils/keys-transform.mjs");
var _scrapeMotionValuesMjs = require("../../html/utils/scrape-motion-values.mjs");
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    const newValues = (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, _isMotionValueMjs.isMotionValue)(props[key]) || (0, _isMotionValueMjs.isMotionValue)(prevProps[key])) {
        const targetKey = (0, _keysTransformMjs.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

},{"../../../value/utils/is-motion-value.mjs":"2kZP7","../../html/utils/keys-transform.mjs":"b4poF","../../html/utils/scrape-motion-values.mjs":"irGuL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7HD63":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDomVisualElement", ()=>createDomVisualElement);
var _react = require("react");
var _htmlvisualElementMjs = require("../html/HTMLVisualElement.mjs");
var _svgvisualElementMjs = require("../svg/SVGVisualElement.mjs");
var _isSvgComponentMjs = require("./utils/is-svg-component.mjs");
const createDomVisualElement = (Component, options)=>{
    return (0, _isSvgComponentMjs.isSVGComponent)(Component) ? new (0, _svgvisualElementMjs.SVGVisualElement)(options) : new (0, _htmlvisualElementMjs.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, _react.Fragment)
    });
};

},{"react":"6uln9","../html/HTMLVisualElement.mjs":"gjlh5","../svg/SVGVisualElement.mjs":"ivZT5","./utils/is-svg-component.mjs":"2Ozjv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gjlh5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLVisualElement", ()=>HTMLVisualElement);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
var _measureMjs = require("../../projection/utils/measure.mjs");
var _domvisualElementMjs = require("../dom/DOMVisualElement.mjs");
var _isCssVariableMjs = require("../dom/utils/is-css-variable.mjs");
var _buildStylesMjs = require("./utils/build-styles.mjs");
var _keysTransformMjs = require("./utils/keys-transform.mjs");
var _parseTransformMjs = require("./utils/parse-transform.mjs");
var _renderMjs = require("./utils/render.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
function getComputedStyle(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends (0, _domvisualElementMjs.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, _renderMjs.renderHTML);
    }
    readValueFromInstance(instance, key) {
        if ((0, _keysTransformMjs.transformProps).has(key)) return (0, _parseTransformMjs.readTransformValue)(instance, key);
        else {
            const computedStyle = getComputedStyle(instance);
            const value = ((0, _isCssVariableMjs.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return (0, _measureMjs.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, _buildStylesMjs.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
}

},{"../../projection/utils/measure.mjs":"afNeE","../dom/DOMVisualElement.mjs":"9nP1G","../dom/utils/is-css-variable.mjs":"58wqN","./utils/build-styles.mjs":"3JcOY","./utils/keys-transform.mjs":"b4poF","./utils/parse-transform.mjs":"kopgt","./utils/render.mjs":"6SuGI","./utils/scrape-motion-values.mjs":"irGuL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9nP1G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMVisualElement", ()=>DOMVisualElement);
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
var _visualElementMjs = require("../VisualElement.mjs");
var _domkeyframesResolverMjs = require("./DOMKeyframesResolver.mjs");
class DOMVisualElement extends (0, _visualElementMjs.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, _domkeyframesResolverMjs.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children } = this.props;
        if ((0, _isMotionValueMjs.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}

},{"../../value/utils/is-motion-value.mjs":"2kZP7","../VisualElement.mjs":"dQr4l","./DOMKeyframesResolver.mjs":"7XPYj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dQr4l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisualElement", ()=>VisualElement);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _definitionsMjs = require("../motion/features/definitions.mjs");
var _modelsMjs = require("../projection/geometry/models.mjs");
var _isNumericalStringMjs = require("../utils/is-numerical-string.mjs");
var _isZeroValueStringMjs = require("../utils/is-zero-value-string.mjs");
var _indexMjs = require("../utils/reduced-motion/index.mjs");
var _stateMjs = require("../utils/reduced-motion/state.mjs");
var _indexMjs1 = require("../value/types/complex/index.mjs");
var _isMotionValueMjs = require("../value/utils/is-motion-value.mjs");
var _animatableNoneMjs = require("./dom/value-types/animatable-none.mjs");
var _findMjs = require("./dom/value-types/find.mjs");
var _keysTransformMjs = require("./html/utils/keys-transform.mjs");
var _storeMjs = require("./store.mjs");
var _isControllingVariantsMjs = require("./utils/is-controlling-variants.mjs");
var _keyframesResolverMjs = require("./utils/KeyframesResolver.mjs");
var _motionValuesMjs = require("./utils/motion-values.mjs");
var _resolveVariantsMjs = require("./utils/resolve-variants.mjs");
const propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class VisualElement {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent, props, presenceContext, reducedMotionConfig, blockInitialAnimation, visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, _keyframesResolverMjs.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, _motionDom.time).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, _motionDom.frame).render(this.render, false, true);
            }
        };
        const { latestValues, renderState, onUpdate } = visualState;
        this.onUpdate = onUpdate;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, _isControllingVariantsMjs.isControllingVariants)(props);
        this.isVariantNode = (0, _isControllingVariantsMjs.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, _isMotionValueMjs.isMotionValue)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, _storeMjs.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, _stateMjs.hasReducedMotionListener).current) (0, _indexMjs.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, _stateMjs.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, _motionDom.cancelFrame)(this.notifyUpdate);
        (0, _motionDom.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, _keysTransformMjs.transformProps).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, _motionDom.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, _definitionsMjs.featureDefinitions){
            const featureDefinition = (0, _definitionsMjs.featureDefinitions)[key];
            if (!featureDefinition) continue;
            const { isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, _modelsMjs.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < propEventHandlers.length; i++){
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, _motionValuesMjs.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
        this.onUpdate && this.onUpdate(this);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, _motionDom.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, _isNumericalStringMjs.isNumericalString)(value) || (0, _isZeroValueStringMjs.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, _findMjs.findValueType)(value) && (0, _indexMjs1.complex).test(target)) value = (0, _animatableNoneMjs.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value);
        }
        return (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, _resolveVariantsMjs.resolveVariantFromProps)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, _isMotionValueMjs.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, _motionUtils.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../motion/features/definitions.mjs":"hJfDG","../projection/geometry/models.mjs":"huYV1","../utils/is-numerical-string.mjs":"4HKEF","../utils/is-zero-value-string.mjs":"2ZdX2","../utils/reduced-motion/index.mjs":"kzOiA","../utils/reduced-motion/state.mjs":"9UZ9X","../value/types/complex/index.mjs":"7EbqM","../value/utils/is-motion-value.mjs":"2kZP7","./dom/value-types/animatable-none.mjs":"6j7Wd","./dom/value-types/find.mjs":"jGIxI","./html/utils/keys-transform.mjs":"b4poF","./store.mjs":"gKOe8","./utils/is-controlling-variants.mjs":"tz7Ig","./utils/KeyframesResolver.mjs":"02uFt","./utils/motion-values.mjs":"5DmCs","./utils/resolve-variants.mjs":"iR2sd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kzOiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initPrefersReducedMotion", ()=>initPrefersReducedMotion);
var _isBrowserMjs = require("../is-browser.mjs");
var _stateMjs = require("./state.mjs");
function initPrefersReducedMotion() {
    (0, _stateMjs.hasReducedMotionListener).current = true;
    if (!(0, _isBrowserMjs.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, _stateMjs.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, _stateMjs.prefersReducedMotion).current = false;
}

},{"../is-browser.mjs":"9ew4K","./state.mjs":"9UZ9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9UZ9X":[function(require,module,exports,__globalThis) {
// Does this device prefer reduced motion? Returns `null` server-side.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasReducedMotionListener", ()=>hasReducedMotionListener);
parcelHelpers.export(exports, "prefersReducedMotion", ()=>prefersReducedMotion);
const prefersReducedMotion = {
    current: null
};
const hasReducedMotionListener = {
    current: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jGIxI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findValueType", ()=>findValueType);
var _indexMjs = require("../../../value/types/color/index.mjs");
var _indexMjs1 = require("../../../value/types/complex/index.mjs");
var _dimensionsMjs = require("./dimensions.mjs");
var _testMjs = require("./test.mjs");
/**
 * A list of all ValueTypes
 */ const valueTypes = [
    ...(0, _dimensionsMjs.dimensionValueTypes),
    (0, _indexMjs.color),
    (0, _indexMjs1.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const findValueType = (v)=>valueTypes.find((0, _testMjs.testValueType)(v));

},{"../../../value/types/color/index.mjs":"aGDwe","../../../value/types/complex/index.mjs":"7EbqM","./dimensions.mjs":"8qh9y","./test.mjs":"3Alhf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKOe8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "visualElementStore", ()=>visualElementStore);
const visualElementStore = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5DmCs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateMotionValuesFromProps", ()=>updateMotionValuesFromProps);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
function updateMotionValuesFromProps(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, _isMotionValueMjs.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, _isMotionValueMjs.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, _motionDom.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, _motionDom.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../value/utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ivZT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SVGVisualElement", ()=>SVGVisualElement);
var _motionDom = require("motion-dom");
var _modelsMjs = require("../../projection/geometry/models.mjs");
var _domvisualElementMjs = require("../dom/DOMVisualElement.mjs");
var _camelToDashMjs = require("../dom/utils/camel-to-dash.mjs");
var _defaultsMjs = require("../dom/value-types/defaults.mjs");
var _keysTransformMjs = require("../html/utils/keys-transform.mjs");
var _buildAttrsMjs = require("./utils/build-attrs.mjs");
var _camelCaseAttrsMjs = require("./utils/camel-case-attrs.mjs");
var _isSvgTagMjs = require("./utils/is-svg-tag.mjs");
var _measureMjs = require("./utils/measure.mjs");
var _renderMjs = require("./utils/render.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
class SVGVisualElement extends (0, _domvisualElementMjs.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, _modelsMjs.createBox);
        this.updateDimensions = ()=>{
            if (this.current && !this.renderState.dimensions) (0, _measureMjs.updateSVGDimensions)(this.current, this.renderState);
        };
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, _keysTransformMjs.transformProps).has(key)) {
            const defaultType = (0, _defaultsMjs.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, _camelCaseAttrsMjs.camelCaseAttributes).has(key) ? (0, _camelToDashMjs.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    onBindTransform() {
        if (this.current && !this.renderState.dimensions) (0, _motionDom.frame).postRender(this.updateDimensions);
    }
    build(renderState, latestValues, props) {
        (0, _buildAttrsMjs.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, _renderMjs.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, _isSvgTagMjs.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

},{"motion-dom":"7u9qw","../../projection/geometry/models.mjs":"huYV1","../dom/DOMVisualElement.mjs":"9nP1G","../dom/utils/camel-to-dash.mjs":"kNuZz","../dom/value-types/defaults.mjs":"5j9jO","../html/utils/keys-transform.mjs":"b4poF","./utils/build-attrs.mjs":"bzDqj","./utils/camel-case-attrs.mjs":"jpeUe","./utils/is-svg-tag.mjs":"7qIqE","./utils/measure.mjs":"iaqrh","./utils/render.mjs":"7rQiG","./utils/scrape-motion-values.mjs":"7vKCJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jUxsS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useReducedMotion", ()=>useReducedMotion);
var _motionUtils = require("motion-utils");
var _react = require("react");
var _indexMjs = require("./index.mjs");
var _stateMjs = require("./state.mjs");
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function useReducedMotion() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !(0, _stateMjs.hasReducedMotionListener).current && (0, _indexMjs.initPrefersReducedMotion)();
    const [shouldReduceMotion] = (0, _react.useState)((0, _stateMjs.prefersReducedMotion).current);
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}

},{"motion-utils":"h8hZz","react":"6uln9","./index.mjs":"kzOiA","./state.mjs":"9UZ9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3FjWp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animate", ()=>animate);
parcelHelpers.export(exports, "createScopedAnimate", ()=>createScopedAnimate);
var _motionDom = require("motion-dom");
var _sequenceMjs = require("./sequence.mjs");
var _subjectMjs = require("./subject.mjs");
function isSequence(value) {
    return Array.isArray(value) && value.some(Array.isArray);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */ function createScopedAnimate(scope) {
    /**
     * Implementation
     */ function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
        let animations = [];
        if (isSequence(subjectOrSequence)) animations = (0, _sequenceMjs.animateSequence)(subjectOrSequence, optionsOrKeyframes, scope);
        else animations = (0, _subjectMjs.animateSubject)(subjectOrSequence, optionsOrKeyframes, options, scope);
        const animation = new (0, _motionDom.GroupPlaybackControls)(animations);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
}
const animate = createScopedAnimate();

},{"motion-dom":"7u9qw","./sequence.mjs":"eQqSD","./subject.mjs":"4MlF2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eQqSD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateSequence", ()=>animateSequence);
var _indexMjs = require("../generators/spring/index.mjs");
var _createMjs = require("../sequence/create.mjs");
var _subjectMjs = require("./subject.mjs");
function animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, _createMjs.createAnimationsFromSequence)(sequence, options, scope, {
        spring: (0, _indexMjs.spring)
    });
    animationDefinitions.forEach(({ keyframes, transition }, subject)=>{
        animations.push(...(0, _subjectMjs.animateSubject)(subject, keyframes, transition));
    });
    return animations;
}

},{"../generators/spring/index.mjs":"iksp4","../sequence/create.mjs":"huAJT","./subject.mjs":"4MlF2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"huAJT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAnimationsFromSequence", ()=>createAnimationsFromSequence);
parcelHelpers.export(exports, "getValueTransition", ()=>getValueTransition);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _getEasingForSegmentMjs = require("../../easing/utils/get-easing-for-segment.mjs");
var _defaultMjs = require("../../utils/offsets/default.mjs");
var _fillMjs = require("../../utils/offsets/fill.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
var _resolveSubjectsMjs = require("../animate/resolve-subjects.mjs");
var _calcRepeatDurationMjs = require("./utils/calc-repeat-duration.mjs");
var _calcTimeMjs = require("./utils/calc-time.mjs");
var _editMjs = require("./utils/edit.mjs");
var _normalizeTimesMjs = require("./utils/normalize-times.mjs");
var _sortMjs = require("./utils/sort.mjs");
const defaultSegmentEasing = "easeInOut";
const MAX_REPEAT = 20;
function createAnimationsFromSequence(sequence, { defaultTransition = {}, ...sequenceTransition } = {}, scope, generators) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, _calcTimeMjs.calcNextTime)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, _calcTimeMjs.calcNextTime)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numSubjects = 0)=>{
            const valueKeyframesAsList = keyframesAsList(valueKeyframes);
            const { delay = 0, times = (0, _defaultMjs.defaultOffset)(valueKeyframesAsList), type = "keyframes", repeat, repeatType, repeatDelay = 0, ...remainingTransition } = valueTransition;
            let { ease = defaultTransition.ease || "easeOut", duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            const createGenerator = (0, _motionDom.isGenerator)(type) ? type : generators === null || generators === void 0 ? void 0 : generators[type];
            if (numKeyframes <= 2 && createGenerator) {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, _motionUtils.secondsToMilliseconds)(duration);
                const springEasing = (0, _motionDom.createGeneratorEasing)(springTransition, absoluteDelta, createGenerator);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, _fillMjs.fillOffset)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Handle repeat options
             */ if (repeat) {
                (0, _motionUtils.invariant)(repeat < MAX_REPEAT, "Repeat count too high, must be less than 20");
                duration = (0, _calcRepeatDurationMjs.calculateRepeatDuration)(duration, repeat);
                const originalKeyframes = [
                    ...valueKeyframesAsList
                ];
                const originalTimes = [
                    ...times
                ];
                ease = Array.isArray(ease) ? [
                    ...ease
                ] : [
                    ease
                ];
                const originalEase = [
                    ...ease
                ];
                for(let repeatIndex = 0; repeatIndex < repeat; repeatIndex++){
                    valueKeyframesAsList.push(...originalKeyframes);
                    for(let keyframeIndex = 0; keyframeIndex < originalKeyframes.length; keyframeIndex++){
                        times.push(originalTimes[keyframeIndex] + (repeatIndex + 1));
                        ease.push(keyframeIndex === 0 ? "linear" : (0, _getEasingForSegmentMjs.getEasingForSegment)(originalEase, keyframeIndex - 1));
                    }
                }
                (0, _normalizeTimesMjs.normalizeTimes)(times, repeat);
            }
            const targetTime = startTime + duration;
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, _editMjs.addKeyframes)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, _isMotionValueMjs.isMotionValue)(subject)) {
            const subjectSequence = getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, getValueSequence("default", subjectSequence));
        } else {
            const subjects = (0, _resolveSubjectsMjs.resolveSubjects)(subject, keyframes, scope, elementCache);
            const numSubjects = subjects.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const thisSubject = subjects[subjectIndex];
                const subjectSequence = getSubjectSequence(thisSubject, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], getValueTransition(transition, key), getValueSequence(key, subjectSequence), subjectIndex, numSubjects);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, _sortMjs.compareByTime));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at, value, easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, _motionUtils.progress)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift(defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function getValueTransition(transition, key) {
    return transition && transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const isNumber = (keyframe)=>typeof keyframe === "number";
const isNumberKeyframesArray = (keyframes)=>keyframes.every(isNumber);

},{"motion-dom":"7u9qw","motion-utils":"h8hZz","../../easing/utils/get-easing-for-segment.mjs":"fnGEm","../../utils/offsets/default.mjs":"9XN04","../../utils/offsets/fill.mjs":"ikoC0","../../value/utils/is-motion-value.mjs":"2kZP7","../animate/resolve-subjects.mjs":"loqlu","./utils/calc-repeat-duration.mjs":"e0JcS","./utils/calc-time.mjs":"gcWc4","./utils/edit.mjs":"8VU28","./utils/normalize-times.mjs":"dq9JF","./utils/sort.mjs":"jMjHD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fnGEm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEasingForSegment", ()=>getEasingForSegment);
var _wrapMjs = require("../../utils/wrap.mjs");
var _isEasingArrayMjs = require("./is-easing-array.mjs");
function getEasingForSegment(easing, i) {
    return (0, _isEasingArrayMjs.isEasingArray)(easing) ? easing[(0, _wrapMjs.wrap)(0, easing.length, i)] : easing;
}

},{"../../utils/wrap.mjs":"kVB8t","./is-easing-array.mjs":"4Txnl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kVB8t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrap", ()=>wrap);
const wrap = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"loqlu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveSubjects", ()=>resolveSubjects);
var _motionDom = require("motion-dom");
var _isDomKeyframesMjs = require("../utils/is-dom-keyframes.mjs");
function resolveSubjects(subject, keyframes, scope, selectorCache) {
    if (typeof subject === "string" && (0, _isDomKeyframesMjs.isDOMKeyframes)(keyframes)) return (0, _motionDom.resolveElements)(subject, scope, selectorCache);
    else if (subject instanceof NodeList) return Array.from(subject);
    else if (Array.isArray(subject)) return subject;
    else return [
        subject
    ];
}

},{"motion-dom":"7u9qw","../utils/is-dom-keyframes.mjs":"cFhMz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFhMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOMKeyframes", ()=>isDOMKeyframes);
function isDOMKeyframes(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e0JcS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateRepeatDuration", ()=>calculateRepeatDuration);
function calculateRepeatDuration(duration, repeat, _repeatDelay) {
    return duration * (repeat + 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gcWc4":[function(require,module,exports,__globalThis) {
/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcNextTime", ()=>calcNextTime);
function calcNextTime(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8VU28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addKeyframes", ()=>addKeyframes);
parcelHelpers.export(exports, "eraseKeyframes", ()=>eraseKeyframes);
var _motionUtils = require("motion-utils");
var _getEasingForSegmentMjs = require("../../../easing/utils/get-easing-for-segment.mjs");
var _numberMjs = require("../../../utils/mix/number.mjs");
function eraseKeyframes(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, _motionUtils.removeItem)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function addKeyframes(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ eraseKeyframes(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, _numberMjs.mixNumber)(startTime, endTime, offset[i]),
        easing: (0, _getEasingForSegmentMjs.getEasingForSegment)(easing, i)
    });
}

},{"motion-utils":"h8hZz","../../../easing/utils/get-easing-for-segment.mjs":"fnGEm","../../../utils/mix/number.mjs":"e62GY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dq9JF":[function(require,module,exports,__globalThis) {
/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeTimes", ()=>normalizeTimes);
function normalizeTimes(times, repeat) {
    for(let i = 0; i < times.length; i++)times[i] = times[i] / (repeat + 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jMjHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareByTime", ()=>compareByTime);
function compareByTime(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4MlF2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateSubject", ()=>animateSubject);
var _motionUtils = require("motion-utils");
var _storeMjs = require("../../render/store.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
var _visualElementTargetMjs = require("../interfaces/visual-element-target.mjs");
var _createVisualElementMjs = require("../utils/create-visual-element.mjs");
var _isDomKeyframesMjs = require("../utils/is-dom-keyframes.mjs");
var _resolveSubjectsMjs = require("./resolve-subjects.mjs");
var _singleValueMjs = require("./single-value.mjs");
function isSingleValue(subject, keyframes) {
    return (0, _isMotionValueMjs.isMotionValue)(subject) || typeof subject === "number" || typeof subject === "string" && !(0, _isDomKeyframesMjs.isDOMKeyframes)(keyframes);
}
/**
 * Implementation
 */ function animateSubject(subject, keyframes, options, scope) {
    const animations = [];
    if (isSingleValue(subject, keyframes)) animations.push((0, _singleValueMjs.animateSingleValue)(subject, (0, _isDomKeyframesMjs.isDOMKeyframes)(keyframes) ? keyframes.default || keyframes : keyframes, options ? options.default || options : options));
    else {
        const subjects = (0, _resolveSubjectsMjs.resolveSubjects)(subject, keyframes, scope);
        const numSubjects = subjects.length;
        (0, _motionUtils.invariant)(Boolean(numSubjects), "No valid elements provided.");
        for(let i = 0; i < numSubjects; i++){
            const thisSubject = subjects[i];
            const createVisualElement = thisSubject instanceof Element ? (0, _createVisualElementMjs.createDOMVisualElement) : (0, _createVisualElementMjs.createObjectVisualElement);
            if (!(0, _storeMjs.visualElementStore).has(thisSubject)) createVisualElement(thisSubject);
            const visualElement = (0, _storeMjs.visualElementStore).get(thisSubject);
            const transition = {
                ...options
            };
            /**
             * Resolve stagger function if provided.
             */ if ("delay" in transition && typeof transition.delay === "function") transition.delay = transition.delay(i, numSubjects);
            animations.push(...(0, _visualElementTargetMjs.animateTarget)(visualElement, {
                ...keyframes,
                transition
            }, {}));
        }
    }
    return animations;
}

},{"motion-utils":"h8hZz","../../render/store.mjs":"gKOe8","../../value/utils/is-motion-value.mjs":"2kZP7","../interfaces/visual-element-target.mjs":"j8sQ3","../utils/create-visual-element.mjs":"43sjp","../utils/is-dom-keyframes.mjs":"cFhMz","./resolve-subjects.mjs":"loqlu","./single-value.mjs":"gKtfq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"43sjp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDOMVisualElement", ()=>createDOMVisualElement);
parcelHelpers.export(exports, "createObjectVisualElement", ()=>createObjectVisualElement);
var _isSvgElementMjs = require("../../render/dom/utils/is-svg-element.mjs");
var _svgvisualElementMjs = require("../../render/svg/SVGVisualElement.mjs");
var _htmlvisualElementMjs = require("../../render/html/HTMLVisualElement.mjs");
var _storeMjs = require("../../render/store.mjs");
var _objectVisualElementMjs = require("../../render/object/ObjectVisualElement.mjs");
function createDOMVisualElement(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, _isSvgElementMjs.isSVGElement)(element) ? new (0, _svgvisualElementMjs.SVGVisualElement)(options) : new (0, _htmlvisualElementMjs.HTMLVisualElement)(options);
    node.mount(element);
    (0, _storeMjs.visualElementStore).set(element, node);
}
function createObjectVisualElement(subject) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                output: {}
            },
            latestValues: {}
        }
    };
    const node = new (0, _objectVisualElementMjs.ObjectVisualElement)(options);
    node.mount(subject);
    (0, _storeMjs.visualElementStore).set(subject, node);
}

},{"../../render/dom/utils/is-svg-element.mjs":"ytKOV","../../render/svg/SVGVisualElement.mjs":"ivZT5","../../render/html/HTMLVisualElement.mjs":"gjlh5","../../render/store.mjs":"gKOe8","../../render/object/ObjectVisualElement.mjs":"4iXeV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iXeV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectVisualElement", ()=>ObjectVisualElement);
var _modelsMjs = require("../../projection/geometry/models.mjs");
var _visualElementMjs = require("../VisualElement.mjs");
function isObjectKey(key, object) {
    return key in object;
}
class ObjectVisualElement extends (0, _visualElementMjs.VisualElement) {
    constructor(){
        super(...arguments);
        this.type = "object";
    }
    readValueFromInstance(instance, key) {
        if (isObjectKey(key, instance)) {
            const value = instance[key];
            if (typeof value === "string" || typeof value === "number") return value;
        }
        return undefined;
    }
    getBaseTargetFromProps() {
        return undefined;
    }
    removeValueFromRenderState(key, renderState) {
        delete renderState.output[key];
    }
    measureInstanceViewportBox() {
        return (0, _modelsMjs.createBox)();
    }
    build(renderState, latestValues) {
        Object.assign(renderState.output, latestValues);
    }
    renderInstance(instance, { output }) {
        Object.assign(instance, output);
    }
    sortInstanceNodePosition() {
        return 0;
    }
}

},{"../../projection/geometry/models.mjs":"huYV1","../VisualElement.mjs":"dQr4l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"duaSo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Same checkmark as signup / account consent UI */ parcelHelpers.export(exports, "ConsentCheckmarkSvg", ()=>ConsentCheckmarkSvg);
/** Hollow green outline when unchecked; filled green + check when checked (signup style). */ parcelHelpers.export(exports, "ConsentCheckboxBox", ()=>ConsentCheckboxBox);
/** Animated marketing opt-in frame from signup (flash, glitter headline, sparkles). */ parcelHelpers.export(exports, "MarketingConsentFlash", ()=>MarketingConsentFlash);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function ConsentCheckmarkSvg() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12.5598 4.24727L5.55977 11.2473C5.51914 11.288 5.47089 11.3202 5.41778 11.3422C5.36467 11.3643 5.30774 11.3756 5.25024 11.3756C5.19275 11.3756 5.13582 11.3643 5.08271 11.3422C5.0296 11.3202 4.98134 11.288 4.94071 11.2473L1.87821 8.18477C1.79612 8.10268 1.75 7.99134 1.75 7.87524C1.75 7.75915 1.79612 7.6478 1.87821 7.56571C1.9603 7.48362 2.07165 7.4375 2.18774 7.4375C2.30384 7.4375 2.41518 7.48362 2.49727 7.56571L5.25024 10.3192L11.9407 3.62821C12.0228 3.54612 12.1341 3.5 12.2502 3.5C12.3663 3.5 12.4777 3.54612 12.5598 3.62821C12.6419 3.7103 12.688 3.82165 12.688 3.93774C12.688 4.05384 12.6419 4.16518 12.5598 4.24727Z",
            fill: "#1B062F"
        })
    });
}
function ConsentCheckboxBox({ checked }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "mt-0.5 flex h-[20px] w-[20px] flex-shrink-0 items-center justify-center pointer-events-none transition-[background-color,box-shadow] duration-200",
        style: checked ? {
            backgroundColor: "#32F78D"
        } : {
            boxShadow: "inset 0 0 0 2px #32F78D"
        },
        "aria-hidden": true,
        children: checked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsentCheckmarkSvg, {}) : null
    });
}
function MarketingConsentFlash({ children, className = "mt-6", animate = true }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `signup-marketing-flash ${animate ? "" : "signup-marketing-flash--static"} ${className}`.trim(),
        children: [
            animate ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "signup-marketing-sparkle",
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "signup-marketing-sparkle",
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "signup-marketing-sparkle",
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "signup-marketing-sparkle",
                        "aria-hidden": true
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-2 flex items-center gap-1.5 font-anton text-[13px] uppercase leading-tight tracking-wide",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "signup-marketing-headline",
                    children: "Don't miss our bonuses and new releases"
                })
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iTbPI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CookieScripts", ()=>CookieScripts);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHelmet = require("react-helmet");
var _reactRouterDom = require("react-router-dom");
var _userContext = require("../Data/UserContext");
var _gtm = require("../utils/gtm");
var _authHeaders = require("../utils/authHeaders");
var _analyticsEnv = require("../utils/analyticsEnv");
const gtmId = "GTM-55Z82SD4";
const analyticsEnabled = !(0, _analyticsEnv.isDevEnv)();
const CookieScripts = ()=>{
    const { user } = (0, _userContext.useUser)();
    const location = (0, _reactRouterDom.useLocation)();
    const pathExcluded = (0, _analyticsEnv.isAnalyticsPathExcluded)(location.pathname);
    // Seed sticky user_status before GTM script (Helmet) injects / fires gtm.js.
    (0, _react.useLayoutEffect)(()=>{
        if (!analyticsEnabled || !gtmId || pathExcluded) return;
        (0, _gtm.seedAnalyticsIdentityBeforeGtm)(user?.userId ?? null);
    // Mount / path change seed when leaving excluded routes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathExcluded
    ]);
    (0, _react.useEffect)(()=>{
        if (!analyticsEnabled || !gtmId || pathExcluded) return;
        if (user?.userId) {
            (0, _gtm.syncAnalyticsIdentityToDataLayer)(String(user.userId));
            if (!(0, _authHeaders.getUserId)()) (0, _authHeaders.setUserId)(user.userId);
            return;
        }
        const stillHasAuth = Boolean((0, _authHeaders.getJwt)()) || Boolean((0, _authHeaders.getSessionToken)()) || Boolean((0, _authHeaders.getUserId)());
        if (!stillHasAuth) (0, _gtm.syncAnalyticsIdentityToDataLayer)(null);
    }, [
        user,
        pathExcluded
    ]);
    // Don't render anything if no tracking IDs are configured, analytics disabled, or path excluded
    if (!analyticsEnabled || !gtmId || pathExcluded) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmet.Helmet), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("script", {
                children: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${String(gtmId)}');
        `
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("noscript", {
                children: `<iframe
          title='googletagmanager'
          src='https://www.googletagmanager.com/ns.html?id=${String(gtmId)}'
          height='0'
          width='0'
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>`
            })
        ]
    });
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-helmet":"5cEyM","react-router-dom":"l6ORY","../Data/UserContext":"aqd8b","../utils/gtm":"dO5RN","../utils/authHeaders":"5Rczo","../utils/analyticsEnv":"4mdbs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cEyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Helmet", ()=>HelmetExport);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSideEffect = require("react-side-effect");
var _reactSideEffectDefault = parcelHelpers.interopDefault(_reactSideEffect);
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _objectAssign = require("object-assign");
var _objectAssignDefault = parcelHelpers.interopDefault(_objectAssign);
var global = arguments[3];
var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function(name) {
    return TAG_NAMES[name];
});
var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function(obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var SELF_CLOSING_TAGS = [
    TAG_NAMES.NOSCRIPT,
    TAG_NAMES.SCRIPT,
    TAG_NAMES.STYLE
];
var HELMET_ATTRIBUTE = "data-react-helmet";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};
var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssignDefault.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([
            TAG_PROPERTIES.HREF,
            TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [
            TAG_PROPERTIES.REL,
            TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [
            TAG_PROPERTIES.NAME,
            TAG_PROPERTIES.CHARSET,
            TAG_PROPERTIES.HTTPEQUIV,
            TAG_PROPERTIES.PROPERTY,
            TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [
            TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [
            TAG_PROPERTIES.SRC,
            TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [
            TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            rafPolyfill(callback);
        }, 0);
    };
}();
var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var _helmetCallback = null;
var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) cancelAnimationFrame(_helmetCallback);
    if (newState.defer) _helmetCallback = requestAnimationFrame(function() {
        commitTagChanges(newState, function() {
            _helmetCallback = null;
        });
    });
    else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};
var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);
    updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = flattenArray(title);
    updateAttributes(TAG_NAMES.TITLE, attributes);
};
var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute(HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute(HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, _reactDefault.default).createElement(TAG_NAMES.TITLE, props, title)
    ];
};
var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, _reactDefault.default).createElement(type, mappedTag);
    });
};
var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompareDefault.default)(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                _extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));
                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });
                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }
            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, _reactDefault.default).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = _extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, _reactDefault.default).createElement(Component, newProps);
        };
        createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, _reactDefault.default).Component), _class.propTypes = {
        base: (0, _propTypesDefault.default).object,
        bodyAttributes: (0, _propTypesDefault.default).object,
        children: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
            (0, _propTypesDefault.default).node
        ]),
        defaultTitle: (0, _propTypesDefault.default).string,
        defer: (0, _propTypesDefault.default).bool,
        encodeSpecialCharacters: (0, _propTypesDefault.default).bool,
        htmlAttributes: (0, _propTypesDefault.default).object,
        link: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        meta: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        noscript: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        onChangeClientState: (0, _propTypesDefault.default).func,
        script: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        style: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        title: (0, _propTypesDefault.default).string,
        titleAttributes: (0, _propTypesDefault.default).object,
        titleTemplate: (0, _propTypesDefault.default).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var NullComponent = function NullComponent() {
    return null;
};
var HelmetSideEffects = (0, _reactSideEffectDefault.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;
exports.default = HelmetExport;

},{"prop-types":"6FKs7","react-side-effect":"kPK3Q","react-fast-compare":"7oSaD","react":"6uln9","object-assign":"hdgcG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6FKs7":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"7ziwC"}],"7ziwC":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"4Cml4"}],"4Cml4":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"kPK3Q":[function(require,module,exports,__globalThis) {
'use strict';
function _interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require("85d8b04033ce6109");
var React__default = _interopDefault(React);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            _inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }(React.PureComponent);
        _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        _defineProperty(SideEffect, "canUseDOM", canUseDOM);
        return SideEffect;
    };
}
module.exports = withSideEffect;

},{"85d8b04033ce6109":"6uln9"}],"7oSaD":[function(require,module,exports,__globalThis) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"hdgcG":[function(require,module,exports,__globalThis) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"aqd8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserContext", ()=>UserContext);
/**
 * Merge favourites into the cached user (session cache) so optimistic changes survive a
 * full-page reload before the next `verifysession` refresh. No-op if there's no cache.
 */ parcelHelpers.export(exports, "patchCachedUserFavourites", ()=>patchCachedUserFavourites);
parcelHelpers.export(exports, "UserProvider", ()=>UserProvider);
parcelHelpers.export(exports, "useUser", ()=>useUser);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _gtm = require("../utils/gtm");
var _frontendTrackingEvents = require("../utils/frontendTrackingEvents");
var _authHeaders = require("../utils/authHeaders");
var _sessionUser = require("../utils/sessionUser");
var _bullionPrivateContestInvite = require("../utils/bullionPrivateContestInvite");
var _squaresLinkInvite = require("../utils/squaresLinkInvite");
var _pendingFavouriteTeam = require("../utils/pendingFavouriteTeam");
const UserContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
const USER_CACHE_KEY = 'c8_user_cache';
const USER_CACHE_TTL_MS = 300000; // 5 minutes
const PRESENCE_HEARTBEAT_MS = 25000;
const PRESENCE_TABS_KEY = 'c8_presence_tabs_v1';
const PRESENCE_TAB_STALE_MS = (()=>{
    const raw = Number.parseInt(String("70000" ?? ''), 10);
    return Number.isFinite(raw) && raw > 0 ? raw : 70000;
})();
function generatePresenceTabId() {
    return `tab_${Math.random().toString(36).slice(2)}_${Date.now()}`;
}
function readPresenceTabs() {
    try {
        const raw = localStorage.getItem(PRESENCE_TABS_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return {};
        return parsed;
    } catch  {
        return {};
    }
}
function writePresenceTabs(next) {
    try {
        localStorage.setItem(PRESENCE_TABS_KEY, JSON.stringify(next));
    } catch  {
    // ignore
    }
}
function prunePresenceTabs(tabs, now = Date.now()) {
    const pruned = {};
    for (const [tabId, ts] of Object.entries(tabs))if (typeof ts === 'number' && Number.isFinite(ts) && now - ts <= PRESENCE_TAB_STALE_MS) pruned[tabId] = ts;
    return pruned;
}
function touchPresenceTab(tabId) {
    const now = Date.now();
    const tabs = prunePresenceTabs(readPresenceTabs(), now);
    tabs[tabId] = now;
    writePresenceTabs(tabs);
    return Object.keys(tabs).length;
}
function sendPresenceHeartbeat() {
    return fetch(`${"https://cricket8.com/api"}/account/presence/heartbeat`, {
        method: 'POST',
        headers: (0, _authHeaders.getAuthHeaders)()
    });
}
function getCachedUser() {
    try {
        const raw = sessionStorage.getItem(USER_CACHE_KEY);
        if (!raw) return null;
        const { user: cached, ts } = JSON.parse(raw);
        if (!cached || !ts || Date.now() - ts > USER_CACHE_TTL_MS) return null;
        return (0, _sessionUser.normalizeSessionPayload)(cached);
    } catch  {
        return null;
    }
}
function setCachedUser(user) {
    try {
        if (!user) {
            sessionStorage.removeItem(USER_CACHE_KEY);
            return;
        }
        sessionStorage.setItem(USER_CACHE_KEY, JSON.stringify({
            user,
            ts: Date.now()
        }));
    } catch  {
    // ignore
    }
}
function patchCachedUserFavourites(favourites) {
    try {
        const raw = sessionStorage.getItem(USER_CACHE_KEY);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        if (!parsed?.user) return;
        parsed.user = {
            ...parsed.user,
            favourites: {
                ...parsed.user.favourites ?? {},
                ...favourites
            }
        };
        parsed.ts = Date.now();
        sessionStorage.setItem(USER_CACHE_KEY, JSON.stringify(parsed));
    } catch  {
    // ignore
    }
}
const UserProvider = ({ children })=>{
    const [user, setUser] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const presenceTabId = (0, _react.useMemo)(()=>generatePresenceTabId(), []);
    const session_token = (0, _authHeaders.getSessionToken)();
    const jwt = (0, _authHeaders.getJwt)();
    // Revalidate when auth appears/disappears, not on JWT sliding refresh (new token string).
    const hasJwt = Boolean(jwt);
    (0, _react.useEffect)(()=>{
        const clearLocalAuthState = ()=>{
            (0, _authHeaders.clearAllClientAuth)();
            setUser(null);
            setCachedUser(null);
        };
        if (!session_token && !jwt) {
            setUser(null);
            setLoading(false);
            setCachedUser(null);
            return;
        }
        const cached = getCachedUser();
        if (cached) {
            setUser((0, _sessionUser.normalizeSessionPayload)(cached));
            // Show cached profile immediately, but always revalidate against the server.
            setLoading(false);
        }
        // Treat 401/403 as definitive auth rejection; everything else (network, 5xx, CORS, ad blocker) is transient.
        // Transient failures must NOT clear cookies — the session is still valid and will revalidate next page load.
        const isDefinitiveAuthRejection = (status)=>status === 401 || status === 403;
        const applySessionPayload = (userData)=>{
            if ((0, _authHeaders.isLogoutInProgress)()) return;
            (0, _authHeaders.applyRefreshedJwtFromResponse)(userData);
            const normalized = (0, _sessionUser.normalizeSessionPayload)((0, _authHeaders.stripJwtFromSessionPayload)(userData));
            setUser(normalized);
            setCachedUser(normalized);
            (0, _gtm.syncAnalyticsIdentityToDataLayer)(userData.userId != null ? String(userData.userId) : null);
            if (userData.userId != null) (0, _authHeaders.setUserId)(userData.userId);
        };
        const fetchVerify = async (url, headers)=>{
            // One short retry for transient failures (network blip, 5xx) before giving up for this page load.
            const RETRY_DELAYS_MS = [
                600
            ];
            let lastError = null;
            for(let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt += 1){
                try {
                    const response = await fetch(url, {
                        method: 'GET',
                        headers
                    });
                    if (response.ok || isDefinitiveAuthRejection(response.status)) return {
                        ok: true,
                        response
                    };
                    lastError = new Error(`verifysession returned ${response.status}`);
                } catch (err) {
                    lastError = err;
                }
                const delay = RETRY_DELAYS_MS[attempt];
                if (delay != null) await new Promise((resolve)=>setTimeout(resolve, delay));
            }
            return {
                ok: false,
                error: lastError
            };
        };
        const checkSession = async (background = false)=>{
            if (!background && !cached) setLoading(true);
            try {
                const url = (0, _authHeaders.getVerifySessionUrl)();
                if (!url) {
                    // No usable cookies at all — user is genuinely signed out.
                    clearLocalAuthState();
                    return;
                }
                const result = await fetchVerify(url, (0, _authHeaders.getAuthHeaders)());
                if (!result.ok) return;
                const { response } = result;
                if (response.ok) {
                    const userData = await response.json();
                    applySessionPayload(userData);
                    return;
                }
                if (await (0, _authHeaders.consumeAccountDeletedIfPresent)(response)) {
                    // Account was deleted server-side — definitive logout.
                    clearLocalAuthState();
                    return;
                }
                // 401/403 on JWT-first: try the legacy session-path fallback before giving up.
                if (jwt && session_token && response.status === 401 && "https://cricket8.com/api") {
                    const sessionUrl = `${"https://cricket8.com/api"}/verifysession/${encodeURIComponent(session_token)}`;
                    const fallback = await fetchVerify(sessionUrl, {
                        'Content-Type': 'application/json'
                    });
                    if (!fallback.ok) // Fallback hit a transient failure — keep cookies and try again next page load.
                    return;
                    if (fallback.response.ok) {
                        const userData = await fallback.response.json();
                        applySessionPayload(userData);
                        return;
                    }
                    if (await (0, _authHeaders.consumeAccountDeletedIfPresent)(fallback.response)) {
                        clearLocalAuthState();
                        return;
                    }
                    if (isDefinitiveAuthRejection(fallback.response.status)) // Both JWT-first and session-fallback returned definitive auth rejection — really signed out.
                    clearLocalAuthState();
                    return;
                }
                // Definitive 401/403 on the only path we have (no fallback available) — signed out.
                clearLocalAuthState();
            } catch (err) {} finally{
                if (!background || !cached) setLoading(false);
            }
        };
        checkSession(Boolean(cached));
    }, [
        session_token,
        hasJwt
    ]);
    (0, _react.useEffect)(()=>{
        const onForceLogout = ()=>{
            setUser(null);
            setCachedUser(null);
        };
        // Cross-tab logout: when auth is cleared in another tab (localStorage removal fires a
        // `storage` event only in *other* tabs), drop the in-memory user here too.
        const onStorage = (event)=>{
            if (event.key !== null && event.key !== 'c8_session_token' && event.key !== 'c8_jwt') return;
            if (!(0, _authHeaders.getSessionToken)() && !(0, _authHeaders.getJwt)()) {
                setUser(null);
                setCachedUser(null);
            }
        };
        window.addEventListener((0, _authHeaders.ACCOUNT_DELETED_LOGOUT_EVENT), onForceLogout);
        window.addEventListener('storage', onStorage);
        return ()=>{
            window.removeEventListener((0, _authHeaders.ACCOUNT_DELETED_LOGOUT_EVENT), onForceLogout);
            window.removeEventListener('storage', onStorage);
        };
    }, []);
    const setUserAndCache = (0, _react.useCallback)((value)=>{
        setUser((prev)=>{
            const next = typeof value === 'function' ? value(prev) : value;
            setCachedUser(next);
            return next;
        });
    }, []);
    const contextValue = (0, _react.useMemo)(()=>({
            user,
            setUser: setUserAndCache,
            loading
        }), [
        user,
        loading,
        setUserAndCache
    ]);
    const contextLoadedFiredRef = (0, _reactDefault.default).useRef(null);
    (0, _react.useEffect)(()=>{
        if (user?.userId != null && String(user.userId) !== '') {
            const uid = String(user.userId);
            (0, _gtm.syncAnalyticsIdentityToDataLayer)(uid);
            if (contextLoadedFiredRef.current !== uid) {
                contextLoadedFiredRef.current = uid;
                (0, _frontendTrackingEvents.trackUserContextLoaded)({
                    user_id: uid
                });
            }
            return;
        }
        contextLoadedFiredRef.current = null;
        // Do not push guest while session verify may still confirm a cookie-backed login.
        // (seedAnalyticsIdentityBeforeGtm already set logged_in from auth cookies.)
        const stillHasAuth = Boolean((0, _authHeaders.getJwt)()) || Boolean((0, _authHeaders.getSessionToken)()) || Boolean((0, _authHeaders.getUserId)());
        if (!stillHasAuth) (0, _gtm.syncAnalyticsIdentityToDataLayer)(null);
    }, [
        user
    ]);
    (0, _react.useEffect)(()=>{
        if (user?.userId == null || String(user.userId) === '') return;
        if (!session_token && !jwt) return;
        (0, _squaresLinkInvite.tryClaimSquaresLinkInviteFromStorage)(user.userId);
        (0, _bullionPrivateContestInvite.tryClaimBullionLinkInviteFromStorage)(user.userId);
        (0, _pendingFavouriteTeam.tryClaimPendingFavouriteTeamFromStorage)().then((favs)=>{
            if (!favs) return;
            setUserAndCache((prev)=>{
                if (!prev) return prev;
                return {
                    ...prev,
                    favourites: {
                        ...prev.favourites ?? {},
                        ...favs
                    }
                };
            });
        });
    }, [
        user?.userId,
        session_token,
        jwt,
        setUserAndCache
    ]);
    (0, _react.useEffect)(()=>{
        if (!user?.userId) return;
        const heartbeat = ()=>{
            touchPresenceTab(presenceTabId);
            sendPresenceHeartbeat().then((res)=>{
                if (!res.ok) return;
                setUserAndCache((prev)=>{
                    if (!prev || !(0, _sessionUser.allowsOnlinePresenceShare)(prev.activity_share)) return prev;
                    if (prev.is_online === true) return prev;
                    return {
                        ...prev,
                        is_online: true
                    };
                });
            }).catch(()=>{});
        };
        heartbeat();
        const heartbeatId = window.setInterval(()=>{
            heartbeat();
        }, PRESENCE_HEARTBEAT_MS);
        const handleVisibility = ()=>{
            if (document.visibilityState === 'visible') heartbeat();
        };
        document.addEventListener('visibilitychange', handleVisibility);
        return ()=>{
            window.clearInterval(heartbeatId);
            document.removeEventListener('visibilitychange', handleVisibility);
        };
    }, [
        user?.userId,
        presenceTabId,
        setUserAndCache
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserContext.Provider, {
        value: contextValue,
        children: children
    });
};
const useUser = ()=>{
    const context = (0, _react.useContext)(UserContext);
    if (!context) throw new Error('useUser must be used within a UserProvider');
    return context;
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../utils/gtm":"dO5RN","../utils/frontendTrackingEvents":"4Y90p","../utils/authHeaders":"5Rczo","../utils/sessionUser":"4xtMD","../utils/bullionPrivateContestInvite":"gnzQv","../utils/squaresLinkInvite":"eHIe3","../utils/pendingFavouriteTeam":"ibsbk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dO5RN":[function(require,module,exports,__globalThis) {
/**
 * Lazy-loads react-gtm-module so it's not in the initial bundle.
 * GTM is only needed after cookie consent or when pushing user data.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Seed `user_status` (and user_id when known) on the dataLayer before GTM/GA4 starts.
 * Call once when cookie consent is granted, before `initializeGtm` / GTM script inject.
 */ parcelHelpers.export(exports, "seedAnalyticsIdentityBeforeGtm", ()=>seedAnalyticsIdentityBeforeGtm);
/**
 * Keep sticky dataLayer `user_status` / `user_id` in sync after login or logout.
 * Always pass the current user id (or `null` for guest). Pushes without an `event` key
 * so it does not fire GTM event tags.
 */ parcelHelpers.export(exports, "syncAnalyticsIdentityToDataLayer", ()=>syncAnalyticsIdentityToDataLayer);
/**
 * Push stored first-party UTMs / click-ids into dataLayer for GA4 attribution.
 * Not gated on analytics consent — acquisition is treated as always-on first-party context.
 * (GTM still only loads when analytics is accepted; without GTM this only fills local dataLayer.)
 */ parcelHelpers.export(exports, "pushStoredAcquisitionToDataLayer", ()=>pushStoredAcquisitionToDataLayer);
parcelHelpers.export(exports, "initializeGtm", ()=>initializeGtm);
parcelHelpers.export(exports, "pushToDataLayer", ()=>pushToDataLayer);
var _analyticsConsent = require("./analyticsConsent");
var _authHeaders = require("./authHeaders");
var _analyticsEnv = require("./analyticsEnv");
var _analyticsIdentity = require("./analyticsIdentity");
var _utmTracking = require("./utmTracking");
function isMissingUserId(value) {
    if (value == null) return true;
    if (typeof value === "string" && value.trim() === "") return true;
    return false;
}
function getTagManager(mod) {
    return mod.default ?? mod;
}
let gtmPromise = null;
function getGtm() {
    if (!gtmPromise) gtmPromise = require("33ac7d3dda890121");
    return gtmPromise;
}
/** Synchronous sticky push so GTM/GA4 can read identity on native events. */ function pushStickyIdentitySync(payload) {
    if (typeof window === "undefined" || (0, _analyticsEnv.isDevEnv)() || (0, _analyticsEnv.isAnalyticsPathExcluded)()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
}
function seedAnalyticsIdentityBeforeGtm(knownUserId) {
    if ((0, _analyticsEnv.isDevEnv)() || (0, _analyticsEnv.isAnalyticsPathExcluded)() || !(0, _analyticsConsent.hasAnalyticsCookieConsent)()) return;
    if (knownUserId != null && String(knownUserId) !== "") (0, _analyticsIdentity.applyAnalyticsIdentity)(knownUserId);
    else if ((0, _analyticsIdentity.getAnalyticsUserId)()) (0, _analyticsIdentity.setAnalyticsUserStatus)("logged_in");
    else {
        const cookieUid = (0, _authHeaders.getUserId)();
        if (cookieUid) (0, _analyticsIdentity.applyAnalyticsIdentity)(cookieUid);
        else // Session/JWT without cr8_userId — status only until UserContext confirms.
        (0, _analyticsIdentity.setAnalyticsUserStatus)((0, _analyticsIdentity.inferAnalyticsUserStatusFromCookies)());
    }
    pushStickyIdentitySync({
        user_status: (0, _analyticsIdentity.getAnalyticsUserStatus)(),
        user_id: (0, _analyticsIdentity.getAnalyticsUserId)()
    });
}
function syncAnalyticsIdentityToDataLayer(userId) {
    if ((0, _analyticsEnv.isDevEnv)() || (0, _analyticsEnv.isAnalyticsPathExcluded)() || !(0, _analyticsConsent.hasAnalyticsCookieConsent)()) return;
    (0, _analyticsIdentity.applyAnalyticsIdentity)(userId);
    pushStickyIdentitySync({
        user_status: (0, _analyticsIdentity.getAnalyticsUserStatus)(),
        user_id: (0, _analyticsIdentity.getAnalyticsUserId)()
    });
}
function pushStoredAcquisitionToDataLayer() {
    if (typeof window === "undefined" || (0, _analyticsEnv.isDevEnv)() || (0, _analyticsEnv.isAnalyticsPathExcluded)()) return;
    const firstTouch = (0, _utmTracking.getSessionFirstTouchContext)();
    const payload = {
        event: "acquisition_context",
        ...(0, _utmTracking.getSessionUtmPayloadWithNulls)(),
        ...(0, _utmTracking.getSessionClickIdPayloadWithNulls)(),
        referrer_host: firstTouch.referrer_host ?? null,
        landing_path: firstTouch.landing_path ?? null,
        in_app_browser: firstTouch.in_app_browser !== undefined ? firstTouch.in_app_browser : (0, _utmTracking.detectInAppBrowser)()
    };
    // Prefer consented GTM path; otherwise keep attribution on local dataLayer for later accept.
    if ((0, _analyticsConsent.hasAnalyticsCookieConsent)()) {
        pushToDataLayer({
            dataLayer: payload
        });
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
}
function initializeGtm(options) {
    if ((0, _analyticsEnv.isAnalyticsPathExcluded)() || !(0, _analyticsConsent.hasAnalyticsCookieConsent)()) return Promise.resolve();
    return getGtm().then((mod)=>{
        getTagManager(mod).initialize(options);
        pushStoredAcquisitionToDataLayer();
    });
}
function pushToDataLayer(data) {
    if ((0, _analyticsEnv.isAnalyticsPathExcluded)() || !(0, _analyticsConsent.hasAnalyticsCookieConsent)()) return Promise.resolve();
    const layer = {
        ...data.dataLayer
    };
    const globalId = (0, _analyticsIdentity.getAnalyticsUserId)();
    if (isMissingUserId(layer.user_id) && globalId != null && globalId !== "") layer.user_id = globalId;
    // Sticky identity for native GA4 — fill when caller omitted user_status.
    if (!("user_status" in layer)) layer.user_status = (0, _analyticsIdentity.getAnalyticsUserStatus)();
    return getGtm().then((mod)=>{
        getTagManager(mod).dataLayer({
            dataLayer: layer
        });
    });
}

},{"./analyticsConsent":"eiihB","./authHeaders":"5Rczo","./analyticsEnv":"4mdbs","./analyticsIdentity":"10oOL","./utmTracking":"kFyP8","33ac7d3dda890121":"8RZNT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eiihB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COOKIE_CONSENT_NAME", ()=>COOKIE_CONSENT_NAME);
parcelHelpers.export(exports, "COOKIE_PREFS_NAME", ()=>COOKIE_PREFS_NAME);
parcelHelpers.export(exports, "COOKIE_CONSENT_CHANGED_EVENT", ()=>COOKIE_CONSENT_CHANGED_EVENT);
/** True when the visitor has already chosen Accept All / Reject All / Accept selected (mixed). */ parcelHelpers.export(exports, "hasCookieConsentDecision", ()=>hasCookieConsentDecision);
/** Stored optional cookie prefs when present; otherwise infer from legacy `cookieConsent`. */ parcelHelpers.export(exports, "readCookieConsentPrefs", ()=>readCookieConsentPrefs);
/**
 * Persist cookie-banner choice.
 * `cookieConsent` remains the analytics/GTM gate for existing call sites.
 * `marketing` here is marketing *cookies* only (ads / campaign measurement) — not email.
 */ parcelHelpers.export(exports, "writeCookieConsentPrefs", ()=>writeCookieConsentPrefs);
/** True when the user accepted analytics cookies (`cookieConsent`). */ parcelHelpers.export(exports, "hasAnalyticsCookieConsent", ()=>hasAnalyticsCookieConsent);
/** True when marketing cookies (ads / campaign measurement) were accepted. */ parcelHelpers.export(exports, "hasMarketingCookieConsent", ()=>hasMarketingCookieConsent);
/** Always include on auth/signup so the server can persist analytics consent for GA4 MP. */ parcelHelpers.export(exports, "analyticsConsentAuthField", ()=>analyticsConsentAuthField);
/** Persist analytics consent to the account when the user is already logged in. */ parcelHelpers.export(exports, "syncAnalyticsConsentToServer", ()=>syncAnalyticsConsentToServer);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _reactCookieConsent = require("react-cookie-consent");
const COOKIE_CONSENT_NAME = "cookieConsent";
const COOKIE_PREFS_NAME = "c8_cookie_prefs";
const COOKIE_CONSENT_CHANGED_EVENT = "c8-cookie-consent-changed";
const CONSENT_COOKIE_OPTS = {
    expires: 365,
    path: "/",
    sameSite: "Lax"
};
function onHttps() {
    return typeof window !== "undefined" && window.location.protocol === "https:";
}
function consentCookieOpts() {
    return {
        ...CONSENT_COOKIE_OPTS,
        ...onHttps() ? {
            secure: true
        } : {}
    };
}
function hasCookieConsentDecision() {
    const value = (0, _reactCookieConsent.getCookieConsentValue)(COOKIE_CONSENT_NAME);
    return value === "true" || value === "false";
}
function readCookieConsentPrefs() {
    if (typeof window === "undefined") return {
        analytics: false,
        marketing: false
    };
    try {
        const raw = (0, _jsCookieDefault.default).get(COOKIE_PREFS_NAME);
        if (raw) {
            const parsed = JSON.parse(raw);
            return {
                analytics: parsed.analytics === true,
                marketing: parsed.marketing === true
            };
        }
    } catch  {
    /* ignore */ }
    const accepted = (0, _reactCookieConsent.getCookieConsentValue)(COOKIE_CONSENT_NAME) === "true";
    return {
        analytics: accepted,
        marketing: accepted
    };
}
function writeCookieConsentPrefs(prefs) {
    const analytics = prefs.analytics === true;
    const marketing = prefs.marketing === true;
    const opts = consentCookieOpts();
    (0, _jsCookieDefault.default).set(COOKIE_CONSENT_NAME, analytics ? "true" : "false", opts);
    (0, _jsCookieDefault.default).set(COOKIE_PREFS_NAME, JSON.stringify({
        analytics,
        marketing
    }), opts);
    if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_CHANGED_EVENT, {
        detail: {
            analytics,
            marketing
        }
    }));
}
function hasAnalyticsCookieConsent() {
    return (0, _reactCookieConsent.getCookieConsentValue)(COOKIE_CONSENT_NAME) === "true";
}
function hasMarketingCookieConsent() {
    return readCookieConsentPrefs().marketing === true;
}
function analyticsConsentAuthField() {
    return {
        analytics_consent: hasAnalyticsCookieConsent()
    };
}
function syncAnalyticsConsentToServer(analytics) {
    if (typeof window === "undefined") return;
    const apiUrl = "https://cricket8.com/api";
    if (!apiUrl) return;
    try {
        // Lazy import avoids circular deps with authHeaders in some bundles.
        require("8ec715ae30bfe37a").then(({ getAuthHeaders, getSessionToken, getJwt })=>{
            if (!getSessionToken() && !getJwt()) return;
            fetch(`${apiUrl}/account/analytics-consent`, {
                method: "POST",
                headers: {
                    ...getAuthHeaders(),
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    analytics_consent: analytics === true
                })
            }).catch(()=>{
            /* ignore — consent is still stored client-side */ });
        });
    } catch  {
    /* ignore */ }
}

},{"js-cookie":"2P5RE","react-cookie-consent":"6Zq2u","8ec715ae30bfe37a":"buawe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2P5RE":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set,
            get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});

},{}],"6Zq2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cookies", ()=>(0, _jsCookieDefault.default));
parcelHelpers.export(exports, "ConditionalWrapper", ()=>ConditionalWrapper);
parcelHelpers.export(exports, "CookieConsent", ()=>CookieConsent);
parcelHelpers.export(exports, "OPTIONS", ()=>POSITION_OPTIONS);
parcelHelpers.export(exports, "POSITION_OPTIONS", ()=>POSITION_OPTIONS);
parcelHelpers.export(exports, "SAME_SITE_OPTIONS", ()=>SAME_SITE_OPTIONS);
parcelHelpers.export(exports, "VISIBILITY_OPTIONS", ()=>VISIBILITY_OPTIONS);
parcelHelpers.export(exports, "VISIBLE_OPTIONS", ()=>VISIBILITY_OPTIONS);
parcelHelpers.export(exports, "defaultCookieConsentName", ()=>defaultCookieConsentName);
parcelHelpers.export(exports, "getCookieConsentValue", ()=>getCookieConsentValue);
parcelHelpers.export(exports, "getLegacyCookieName", ()=>getLegacyCookieName);
parcelHelpers.export(exports, "resetCookieConsentValue", ()=>resetCookieConsentValue);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * A function to wrap elements with a "wrapper" on a condition
 * @param {object} wrappingOptions
 *  condition == boolean condition, when to wrap
 *  wrapper == style to wrap. e.g <div>{children}</div>
 *  children == react passes whatever is between tags as children. Don't supply this yourself.
 */ var ConditionalWrapper = function ConditionalWrapper(_ref) {
    var condition = _ref.condition, wrapper = _ref.wrapper, children = _ref.children;
    return condition ? wrapper(children) : children;
};
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var POSITION_OPTIONS = {
    TOP: "top",
    BOTTOM: "bottom",
    NONE: "none"
};
var SAME_SITE_OPTIONS;
(function(SAME_SITE_OPTIONS) {
    SAME_SITE_OPTIONS["STRICT"] = "strict";
    SAME_SITE_OPTIONS["LAX"] = "lax";
    SAME_SITE_OPTIONS["NONE"] = "none";
})(SAME_SITE_OPTIONS || (SAME_SITE_OPTIONS = {}));
var VISIBILITY_OPTIONS = {
    HIDDEN: "hidden",
    SHOW: "show",
    BY_COOKIE_VALUE: "byCookieValue"
};
var defaultCookieConsentName = "CookieConsent";
var _excluded = [
    "children"
];
var DefaultButtonComponent = function DefaultButtonComponent(_ref) {
    var children = _ref.children, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return (0, _reactDefault.default).createElement("button", Object.assign({}, props), children);
};
var defaultCookieConsentProps = {
    disableStyles: false,
    hideOnAccept: true,
    hideOnDecline: true,
    location: POSITION_OPTIONS.BOTTOM,
    visible: VISIBILITY_OPTIONS.BY_COOKIE_VALUE,
    onAccept: function onAccept(_acceptedByScrolling) {},
    onDecline: function onDecline() {},
    cookieName: defaultCookieConsentName,
    cookieValue: "true",
    declineCookieValue: "false",
    setDeclineCookie: true,
    buttonText: "I understand",
    declineButtonText: "I decline",
    debug: false,
    expires: 365,
    containerClasses: "CookieConsent",
    contentClasses: "",
    buttonClasses: "",
    buttonWrapperClasses: "",
    declineButtonClasses: "",
    buttonId: "rcc-confirm-button",
    declineButtonId: "rcc-decline-button",
    extraCookieOptions: {},
    disableButtonStyles: false,
    enableDeclineButton: false,
    flipButtons: false,
    sameSite: SAME_SITE_OPTIONS.LAX,
    ButtonComponent: DefaultButtonComponent,
    overlay: false,
    overlayClasses: "",
    onOverlayClick: function onOverlayClick() {},
    acceptOnOverlayClick: false,
    ariaAcceptLabel: "Accept cookies",
    ariaDeclineLabel: "Decline cookies",
    acceptOnScroll: false,
    acceptOnScrollPercentage: 25,
    customContentAttributes: {},
    customContainerAttributes: {},
    customButtonProps: {},
    customDeclineButtonProps: {},
    customButtonWrapperAttributes: {},
    style: {},
    buttonStyle: {},
    declineButtonStyle: {},
    contentStyle: {},
    overlayStyle: {}
};
var defaultState = {
    visible: false,
    style: {
        alignItems: "baseline",
        background: "#353535",
        color: "white",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        left: "0",
        position: "fixed",
        width: "100%",
        zIndex: "999"
    },
    buttonStyle: {
        background: "#ffd42d",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "black",
        cursor: "pointer",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
    },
    declineButtonStyle: {
        background: "#c12a2a",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "#e5e5e5",
        cursor: "pointer",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
    },
    contentStyle: {
        flex: "1 0 300px",
        margin: "15px"
    },
    overlayStyle: {
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: "999",
        backgroundColor: "rgba(0,0,0,0.3)"
    }
};
/**
 * Returns the value of the consent cookie
 * Retrieves the regular value first and if not found the legacy one according
 * to: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
 * @param {*} name optional name of the cookie
 */ var getCookieConsentValue = function getCookieConsentValue(name) {
    if (name === void 0) name = defaultCookieConsentName;
    var cookieValue = (0, _jsCookieDefault.default).get(name);
    // if the cookieValue is undefined check for the legacy cookie
    if (cookieValue === undefined) return (0, _jsCookieDefault.default).get(getLegacyCookieName(name));
    return cookieValue;
};
/**
 * Reset the consent cookie
 * Remove the cookie on browser in order to allow user to change their consent
 * @param {*} name optional name of the cookie
 */ var resetCookieConsentValue = function resetCookieConsentValue(name) {
    if (name === void 0) name = defaultCookieConsentName;
    (0, _jsCookieDefault.default).remove(name);
};
/**
 * Get the legacy cookie name by the regular cookie name
 * @param {string} name of cookie to get
 */ var getLegacyCookieName = function getLegacyCookieName(name) {
    return name + "-legacy";
};
var CookieConsent = /*#__PURE__*/ function(_Component) {
    _inheritsLoose(CookieConsent, _Component);
    function CookieConsent() {
        var _this;
        _this = _Component.apply(this, arguments) || this;
        _this.state = defaultState;
        /**
     * checks whether scroll has exceeded set amount and fire accept if so.
     */ _this.handleScroll = function() {
            var _defaultCookieConsent = _extends({}, defaultCookieConsentProps, _this.props), acceptOnScrollPercentage = _defaultCookieConsent.acceptOnScrollPercentage;
            // (top / height) - height * 100
            var rootNode = document.documentElement;
            var body = document.body;
            var top = "scrollTop";
            var height = "scrollHeight";
            var percentage = (rootNode[top] || body[top]) / ((rootNode[height] || body[height]) - rootNode.clientHeight) * 100;
            if (percentage > acceptOnScrollPercentage) _this.accept(true);
        };
        _this.removeScrollListener = function() {
            var acceptOnScroll = _this.props.acceptOnScroll;
            if (acceptOnScroll) window.removeEventListener("scroll", _this.handleScroll);
        };
        return _this;
    }
    var _proto = CookieConsent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var debug = this.props.debug;
        // if cookie undefined or debug
        if (this.getCookieValue() === undefined || debug) {
            this.setState({
                visible: true
            });
            // if acceptOnScroll is set to true and (cookie is undefined or debug is set to true), add a listener.
            if (this.props.acceptOnScroll) window.addEventListener("scroll", this.handleScroll, {
                passive: true
            });
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // remove listener if still set
        this.removeScrollListener();
    } /**
   * Set a persistent accept cookie
   */ ;
    _proto.accept = function accept(acceptedByScrolling) {
        var _acceptedByScrolling;
        if (acceptedByScrolling === void 0) acceptedByScrolling = false;
        var _defaultCookieConsent2 = _extends({}, defaultCookieConsentProps, this.props), cookieName = _defaultCookieConsent2.cookieName, cookieValue = _defaultCookieConsent2.cookieValue, hideOnAccept = _defaultCookieConsent2.hideOnAccept, onAccept = _defaultCookieConsent2.onAccept;
        this.setCookie(cookieName, cookieValue);
        onAccept((_acceptedByScrolling = acceptedByScrolling) != null ? _acceptedByScrolling : false);
        if (hideOnAccept) {
            this.setState({
                visible: false
            });
            this.removeScrollListener();
        }
    } /**
   * Handle a click on the overlay
   */ ;
    _proto.overlayClick = function overlayClick() {
        var _defaultCookieConsent3 = _extends({}, defaultCookieConsentProps, this.props), acceptOnOverlayClick = _defaultCookieConsent3.acceptOnOverlayClick, onOverlayClick = _defaultCookieConsent3.onOverlayClick;
        if (acceptOnOverlayClick) this.accept();
        onOverlayClick();
    } /**
   * Set a persistent decline cookie
   */ ;
    _proto.decline = function decline() {
        var _defaultCookieConsent4 = _extends({}, defaultCookieConsentProps, this.props), cookieName = _defaultCookieConsent4.cookieName, declineCookieValue = _defaultCookieConsent4.declineCookieValue, hideOnDecline = _defaultCookieConsent4.hideOnDecline, onDecline = _defaultCookieConsent4.onDecline, setDeclineCookie = _defaultCookieConsent4.setDeclineCookie;
        if (setDeclineCookie) this.setCookie(cookieName, declineCookieValue);
        onDecline();
        if (hideOnDecline) this.setState({
            visible: false
        });
    } /**
   * Function to set the consent cookie based on the provided variables
   * Sets two cookies to handle incompatible browsers, more details:
   * https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
   */ ;
    _proto.setCookie = function setCookie(cookieName, cookieValue) {
        var _this$props = this.props, extraCookieOptions = _this$props.extraCookieOptions, expires = _this$props.expires, sameSite = _this$props.sameSite;
        var cookieSecurity = this.props.cookieSecurity;
        if (cookieSecurity === undefined) cookieSecurity = window.location ? window.location.protocol === "https:" : true;
        var cookieOptions = _extends({
            expires: expires
        }, extraCookieOptions, {
            sameSite: sameSite,
            secure: cookieSecurity
        });
        // Fallback for older browsers where can not set SameSite=None,
        // SEE: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
        if (sameSite === SAME_SITE_OPTIONS.NONE) (0, _jsCookieDefault.default).set(getLegacyCookieName(cookieName), cookieValue, cookieOptions);
        // set the regular cookie
        (0, _jsCookieDefault.default).set(cookieName, cookieValue, cookieOptions);
    } /**
   * Returns the value of the consent cookie
   * Retrieves the regular value first and if not found the legacy one according
   * to: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
   */ ;
    _proto.getCookieValue = function getCookieValue() {
        var cookieName = this.props.cookieName;
        return getCookieConsentValue(cookieName);
    };
    _proto.render = function render() {
        var _this2 = this;
        // If the bar shouldn't be visible don't render anything.
        switch(this.props.visible){
            case VISIBILITY_OPTIONS.HIDDEN:
                return null;
            case VISIBILITY_OPTIONS.BY_COOKIE_VALUE:
                if (!this.state.visible) return null;
                break;
        }
        var _this$props2 = this.props, location = _this$props2.location, style = _this$props2.style, buttonStyle = _this$props2.buttonStyle, declineButtonStyle = _this$props2.declineButtonStyle, contentStyle = _this$props2.contentStyle, disableStyles = _this$props2.disableStyles, buttonText = _this$props2.buttonText, declineButtonText = _this$props2.declineButtonText, containerClasses = _this$props2.containerClasses, contentClasses = _this$props2.contentClasses, buttonClasses = _this$props2.buttonClasses, buttonWrapperClasses = _this$props2.buttonWrapperClasses, declineButtonClasses = _this$props2.declineButtonClasses, buttonId = _this$props2.buttonId, declineButtonId = _this$props2.declineButtonId, disableButtonStyles = _this$props2.disableButtonStyles, enableDeclineButton = _this$props2.enableDeclineButton, flipButtons = _this$props2.flipButtons, ButtonComponent = _this$props2.ButtonComponent, overlay = _this$props2.overlay, overlayClasses = _this$props2.overlayClasses, overlayStyle = _this$props2.overlayStyle, ariaAcceptLabel = _this$props2.ariaAcceptLabel, ariaDeclineLabel = _this$props2.ariaDeclineLabel, customContainerAttributes = _this$props2.customContainerAttributes, customContentAttributes = _this$props2.customContentAttributes, customButtonProps = _this$props2.customButtonProps, customDeclineButtonProps = _this$props2.customDeclineButtonProps, customButtonWrapperAttributes = _this$props2.customButtonWrapperAttributes;
        var myStyle = {};
        var myButtonStyle = {};
        var myDeclineButtonStyle = {};
        var myContentStyle = {};
        var myOverlayStyle = {};
        if (disableStyles) {
            // if styles are disabled use the provided styles (or none)
            myStyle = Object.assign({}, style);
            myButtonStyle = Object.assign({}, buttonStyle);
            myDeclineButtonStyle = Object.assign({}, declineButtonStyle);
            myContentStyle = Object.assign({}, contentStyle);
            myOverlayStyle = Object.assign({}, overlayStyle);
        } else {
            // if styles aren't disabled merge them with the styles that are provided (or use default styles)
            myStyle = Object.assign({}, _extends({}, this.state.style, style));
            myContentStyle = Object.assign({}, _extends({}, this.state.contentStyle, contentStyle));
            myOverlayStyle = Object.assign({}, _extends({}, this.state.overlayStyle, overlayStyle));
            // switch to disable JUST the button styles
            if (disableButtonStyles) {
                myButtonStyle = Object.assign({}, buttonStyle);
                myDeclineButtonStyle = Object.assign({}, declineButtonStyle);
            } else {
                myButtonStyle = Object.assign({}, _extends({}, this.state.buttonStyle, buttonStyle));
                myDeclineButtonStyle = Object.assign({}, _extends({}, this.state.declineButtonStyle, declineButtonStyle));
            }
        }
        // syntactic sugar to enable user to easily select top / bottom
        switch(location){
            case POSITION_OPTIONS.TOP:
                myStyle.top = "0";
                break;
            case POSITION_OPTIONS.BOTTOM:
                myStyle.bottom = "0";
                break;
        }
        var buttonsToRender = [];
        // add decline button
        enableDeclineButton && buttonsToRender.push((0, _reactDefault.default).createElement(ButtonComponent, Object.assign({
            key: "declineButton",
            style: myDeclineButtonStyle,
            className: declineButtonClasses,
            id: declineButtonId,
            "aria-label": ariaDeclineLabel,
            onClick: function onClick() {
                _this2.decline();
            }
        }, customDeclineButtonProps), declineButtonText));
        // add accept button
        buttonsToRender.push((0, _reactDefault.default).createElement(ButtonComponent, Object.assign({
            key: "acceptButton",
            style: myButtonStyle,
            className: buttonClasses,
            id: buttonId,
            "aria-label": ariaAcceptLabel,
            onClick: function onClick() {
                _this2.accept();
            }
        }, customButtonProps), buttonText));
        if (flipButtons) buttonsToRender.reverse();
        return (0, _reactDefault.default).createElement(ConditionalWrapper, {
            condition: overlay,
            wrapper: function wrapper(children) {
                return (0, _reactDefault.default).createElement("div", {
                    style: myOverlayStyle,
                    className: overlayClasses,
                    onClick: function onClick() {
                        _this2.overlayClick();
                    }
                }, children);
            }
        }, (0, _reactDefault.default).createElement("div", Object.assign({
            className: "" + containerClasses,
            style: myStyle
        }, customContainerAttributes), (0, _reactDefault.default).createElement("div", Object.assign({
            style: myContentStyle,
            className: contentClasses
        }, customContentAttributes), this.props.children), (0, _reactDefault.default).createElement("div", Object.assign({
            className: "" + buttonWrapperClasses
        }, customButtonWrapperAttributes), buttonsToRender.map(function(button) {
            return button;
        }))));
    };
    return CookieConsent;
}((0, _react.Component));
CookieConsent.defaultProps = defaultCookieConsentProps;
exports.default = CookieConsent;

},{"js-cookie":"eP3j1","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eP3j1":[function(require,module,exports,__globalThis) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

},{}],"buawe":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("5Rczo"));

},{}],"5Rczo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Cookie options for session/JWT tokens.
 *
 * SameSite=Lax (not Strict) is intentional: these cookies are read by JS via document.cookie
 * and the API authenticates with Authorization: Bearer (CORS credentials: false), so Strict
 * provides no security benefit but causes Chrome to drop/evict the cookie more aggressively
 * (and can also cause the cookie to be missing on the initial top-level cross-site navigation,
 * e.g. clicks from Google search, email, or social links). Lax keeps the cookie available on
 * top-level GET navigations while still blocking it on cross-site subresource sends.
 *
 * Safari on HTTPS requires Secure when SameSite is set, so Secure is set automatically on HTTPS.
 */ parcelHelpers.export(exports, "getAuthCookieOptions", ()=>getAuthCookieOptions);
/**
 * Reconcile cookie <-> localStorage auth on app boot.
 *
 * - Restores the cookie mirror from durable localStorage (privacy browsers purge cookies but keep
 *   localStorage), so the many call sites that read c8_session_token directly keep working.
 * - Back-fills localStorage from an existing cookie (already-logged-in users upgrading to this build).
 *
 * Safe to call multiple times; must run before the first component reads auth cookies.
 */ parcelHelpers.export(exports, "hydrateAuthStorage", ()=>hydrateAuthStorage);
/**
 * Session check URL — JWT-first when a valid c8_jwt exists, otherwise legacy session token.
 * Stale/expired JWTs are pruned before this runs so they never block a good session cookie.
 */ parcelHelpers.export(exports, "getVerifySessionUrl", ()=>getVerifySessionUrl);
/** Clear cookies, localStorage mirror, and client session cache used for auth / profile bootstrap. */ parcelHelpers.export(exports, "clearAllClientAuth", ()=>clearAllClientAuth);
/** True once the user chose to log out on this page; cleared by the reload that follows. */ parcelHelpers.export(exports, "isLogoutInProgress", ()=>isLogoutInProgress);
/**
 * User-initiated logout: clear auth and block any in-flight response (e.g. verifysession's
 * refreshed JWT) from writing tokens back before the page navigates away.
 */ parcelHelpers.export(exports, "beginLogout", ()=>beginLogout);
parcelHelpers.export(exports, "ACCOUNT_DELETED_LOGOUT_EVENT", ()=>ACCOUNT_DELETED_LOGOUT_EVENT);
/** Call when API returns 401 with error account_deleted (or equivalent). */ parcelHelpers.export(exports, "applyAccountDeletedLogout", ()=>applyAccountDeletedLogout);
/** If response is 401 with body.error === account_deleted or login_blocked, clear auth and notify app. */ parcelHelpers.export(exports, "consumeAccountDeletedIfPresent", ()=>consumeAccountDeletedIfPresent);
/** Get JWT (localStorage-first, cookie fallback) if present and still valid for the current session. */ parcelHelpers.export(exports, "getJwt", ()=>getJwt);
/** Get the session token (localStorage-first, cookie fallback). */ parcelHelpers.export(exports, "getSessionToken", ()=>getSessionToken);
/** Get the cached user id (localStorage-first, cookie fallback). */ parcelHelpers.export(exports, "getUserId", ()=>getUserId);
/** Store the user id durably (localStorage + cookie). */ parcelHelpers.export(exports, "setUserId", ()=>setUserId);
/** Headers for API calls: includes Authorization Bearer when JWT exists. */ parcelHelpers.export(exports, "getAuthHeaders", ()=>getAuthHeaders);
/** Remove JWT from durable storage (call on logout or when stale). */ parcelHelpers.export(exports, "clearJwt", ()=>clearJwt);
/** Store JWT durably (call after login when backend returns data.jwt). Same options as session token. */ parcelHelpers.export(exports, "setJwt", ()=>setJwt);
/** Store session token durably (call after login when backend returns data.token). */ parcelHelpers.export(exports, "setSessionToken", ()=>setSessionToken);
/**
 * Replace auth tokens atomically: clear legacy/stale values first, then write the new session.
 * Call on every successful login (Google, Facebook, phone OTP).
 */ parcelHelpers.export(exports, "storeAuthTokens", ()=>storeAuthTokens);
/** Store a refreshed JWT from an auth API response (e.g. session-path verifysession). */ parcelHelpers.export(exports, "applyRefreshedJwtFromResponse", ()=>applyRefreshedJwtFromResponse);
/** Remove jwt from a verifysession payload before normalizing into User state. */ parcelHelpers.export(exports, "stripJwtFromSessionPayload", ()=>stripJwtFromSessionPayload);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _deviceSignals = require("./deviceSignals");
const JWT_COOKIE = 'c8_jwt';
const SESSION_COOKIE = 'c8_session_token';
const USER_ID_COOKIE = 'cr8_userId';
const USER_CACHE_KEY = 'c8_user_cache';
/**
 * Auth values mirrored into localStorage for durable first-party persistence.
 *
 * Privacy-hardened browsers (Firefox ETP, DuckDuckGo) purge first-party cookies, and Safari ITP
 * caps script-set (document.cookie) cookies to ~7 days — which silently logs users out. localStorage
 * for the site the user is actually visiting is not subject to those policies, so we treat it as the
 * source of truth and keep the cookie as a mirror (many call sites still read the cookie directly).
 */ const DURABLE_AUTH_KEYS = [
    SESSION_COOKIE,
    JWT_COOKIE,
    USER_ID_COOKIE
];
function getAuthCookieOptions(overrides) {
    const onHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
    return {
        expires: overrides?.expires ?? 365,
        secure: overrides?.secure ?? onHttps,
        sameSite: overrides?.sameSite ?? 'lax'
    };
}
/** localStorage is disabled/unavailable in some privacy modes — probe once and degrade gracefully. */ const LOCAL_STORAGE_AVAILABLE = (()=>{
    try {
        if (typeof window === 'undefined' || !window.localStorage) return false;
        const probe = '__c8_ls_probe__';
        window.localStorage.setItem(probe, '1');
        window.localStorage.removeItem(probe);
        return true;
    } catch  {
        return false;
    }
})();
function lsGet(key) {
    if (!LOCAL_STORAGE_AVAILABLE) return undefined;
    try {
        const value = window.localStorage.getItem(key);
        return value == null || value === '' ? undefined : value;
    } catch  {
        return undefined;
    }
}
function lsSet(key, value) {
    if (!LOCAL_STORAGE_AVAILABLE) return;
    try {
        window.localStorage.setItem(key, value);
    } catch  {
    // ignore (quota / disabled)
    }
}
function lsRemove(key) {
    if (!LOCAL_STORAGE_AVAILABLE) return;
    try {
        window.localStorage.removeItem(key);
    } catch  {
    // ignore
    }
}
/**
 * Read a durable auth value: localStorage first (survives cookie purging), cookie as fallback.
 * When only one store has the value, back-fill the other so both stay in sync (this also upgrades
 * already-logged-in users on first load after this build ships).
 */ function readDurable(name) {
    const fromLs = lsGet(name);
    if (fromLs) {
        if (!(0, _jsCookieDefault.default).get(name)) // Keep the cookie mirror alive for the many call sites that read cookies directly.
        (0, _jsCookieDefault.default).set(name, fromLs, getAuthCookieOptions());
        return fromLs;
    }
    const fromCookie = (0, _jsCookieDefault.default).get(name);
    if (fromCookie) {
        lsSet(name, fromCookie);
        return fromCookie;
    }
    return undefined;
}
/** Write a durable auth value to both localStorage (durable) and cookie (mirror). */ function writeDurable(name, value, options) {
    lsSet(name, value);
    (0, _jsCookieDefault.default).set(name, value, getAuthCookieOptions(options));
}
/** Remove a cookie across attribute variants (legacy secure/http + SameSite combos). */ function removeCookieEverywhere(name) {
    const path = '/';
    const variants = [
        {
            path
        },
        {
            path,
            secure: true
        },
        {
            path,
            secure: false
        },
        {
            path,
            secure: true,
            sameSite: 'strict'
        },
        {
            path,
            secure: true,
            sameSite: 'lax'
        },
        {
            path,
            secure: false,
            sameSite: 'strict'
        },
        {
            path,
            secure: false,
            sameSite: 'lax'
        }
    ];
    for (const opts of variants)(0, _jsCookieDefault.default).remove(name, opts);
    (0, _jsCookieDefault.default).remove(name);
}
/** Remove a durable auth value from both localStorage and cookie. */ function removeDurable(name) {
    lsRemove(name);
    removeCookieEverywhere(name);
}
function hydrateAuthStorage() {
    for (const key of DURABLE_AUTH_KEYS){
        const fromLs = lsGet(key);
        const fromCookie = (0, _jsCookieDefault.default).get(key);
        if (fromLs && !fromCookie) (0, _jsCookieDefault.default).set(key, fromLs, getAuthCookieOptions());
        else if (!fromLs && fromCookie) lsSet(key, fromCookie);
    }
}
function decodeJwtPayload(token) {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return null;
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const json = atob(base64);
        const payload = JSON.parse(json);
        return payload && typeof payload === 'object' ? payload : null;
    } catch  {
        return null;
    }
}
function isJwtExpired(token) {
    const payload = decodeJwtPayload(token);
    if (!payload || typeof payload.exp !== 'number') return true;
    return payload.exp * 1000 <= Date.now();
}
function jwtMatchesSession(token, sessionToken) {
    const payload = decodeJwtPayload(token);
    if (!payload || typeof payload.sessionid !== 'string') return false;
    return payload.sessionid === sessionToken;
}
function pruneStaleJwt() {
    const token = readDurable(JWT_COOKIE);
    if (!token) return;
    const sessionToken = readDurable(SESSION_COOKIE);
    if (isJwtExpired(token) || sessionToken && !jwtMatchesSession(token, sessionToken)) removeDurable(JWT_COOKIE);
}
function getVerifySessionUrl() {
    pruneStaleJwt();
    const base = "https://cricket8.com/api";
    if (!base) return null;
    const jwt = getJwt();
    if (jwt) return `${base}/verifysession`;
    const session_token = getSessionToken();
    if (session_token) return `${base}/verifysession/${session_token}`;
    return null;
}
function clearAllClientAuth() {
    removeDurable(SESSION_COOKIE);
    removeDurable(USER_ID_COOKIE);
    removeDurable(JWT_COOKIE);
    try {
        sessionStorage.removeItem(USER_CACHE_KEY);
    } catch  {
    // ignore
    }
}
const LOGOUT_FLAG = '__c8LogoutInProgress';
function isLogoutInProgress() {
    return typeof window !== 'undefined' && window[LOGOUT_FLAG] === true;
}
function beginLogout() {
    if (typeof window !== 'undefined') window[LOGOUT_FLAG] = true;
    clearAllClientAuth();
}
const ACCOUNT_DELETED_LOGOUT_EVENT = 'c8-auth-force-logout';
function applyAccountDeletedLogout() {
    clearAllClientAuth();
    if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(ACCOUNT_DELETED_LOGOUT_EVENT));
}
async function consumeAccountDeletedIfPresent(response) {
    if (response.status !== 401) return false;
    try {
        const data = await response.clone().json();
        if (data?.error === 'account_deleted' || data?.error === 'login_blocked') {
            applyAccountDeletedLogout();
            return true;
        }
    } catch  {
    // ignore
    }
    return false;
}
function getJwt() {
    pruneStaleJwt();
    return readDurable(JWT_COOKIE);
}
function getSessionToken() {
    return readDurable(SESSION_COOKIE);
}
function getUserId() {
    return readDurable(USER_ID_COOKIE);
}
function setUserId(userId) {
    const value = String(userId ?? '').trim();
    if (!value || isLogoutInProgress()) return;
    writeDurable(USER_ID_COOKIE, value);
}
function getAuthHeaders() {
    const jwt = getJwt();
    const headers = {
        'Content-Type': 'application/json',
        ...(0, _deviceSignals.getDeviceHeaders)()
    };
    if (jwt) headers['Authorization'] = `Bearer ${jwt}`;
    return headers;
}
function clearJwt() {
    removeDurable(JWT_COOKIE);
}
function setJwt(jwt, options) {
    if (isLogoutInProgress()) return;
    writeDurable(JWT_COOKIE, jwt, options);
}
function setSessionToken(token, options) {
    if (isLogoutInProgress()) return;
    writeDurable(SESSION_COOKIE, token, options);
}
function storeAuthTokens(sessionToken, jwt) {
    clearAllClientAuth();
    setSessionToken(sessionToken);
    if (jwt) setJwt(jwt);
}
function applyRefreshedJwtFromResponse(data) {
    if (typeof data.jwt === 'string' && data.jwt.length > 0 && data.jwt !== getJwt()) setJwt(data.jwt);
}
function stripJwtFromSessionPayload(data) {
    const { jwt: _jwt, ...rest } = data;
    return rest;
}

},{"js-cookie":"2P5RE","./deviceSignals":"e518A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e518A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOrCreateClientKey", ()=>getOrCreateClientKey);
/** Warm FingerprintJS in the background so auth calls can include visitorId. */ parcelHelpers.export(exports, "preloadDeviceFingerprint", ()=>preloadDeviceFingerprint);
parcelHelpers.export(exports, "getFingerprintJsVisitorId", ()=>getFingerprintJsVisitorId);
parcelHelpers.export(exports, "getDeviceAuthPayload", ()=>getDeviceAuthPayload);
/** Sync headers for authenticated API calls (verifysession, etc.). */ parcelHelpers.export(exports, "getDeviceHeaders", ()=>getDeviceHeaders);
/** Prefer for spin start/claim so FingerprintJS is included when available. */ parcelHelpers.export(exports, "getDeviceHeadersAsync", ()=>getDeviceHeadersAsync);
const CLIENT_KEY_STORAGE = 'c8_device_key';
let cachedVisitorId;
let visitorIdPromise = null;
function getOrCreateClientKey() {
    if (typeof window === 'undefined') return '';
    try {
        let key = localStorage.getItem(CLIENT_KEY_STORAGE);
        if (!key) {
            key = crypto.randomUUID();
            localStorage.setItem(CLIENT_KEY_STORAGE, key);
        }
        return key;
    } catch  {
        return '';
    }
}
function preloadDeviceFingerprint() {
    if (typeof window === 'undefined') return;
    getFingerprintJsVisitorId();
}
async function getFingerprintJsVisitorId() {
    if (cachedVisitorId !== undefined) return cachedVisitorId;
    if (!visitorIdPromise) visitorIdPromise = (async ()=>{
        try {
            const FingerprintJS = await require("75f83d4ebd932b14");
            const agent = await FingerprintJS.load();
            const result = await agent.get();
            cachedVisitorId = result.visitorId || null;
            return cachedVisitorId;
        } catch  {
            cachedVisitorId = null;
            return null;
        }
    })();
    return visitorIdPromise;
}
async function getDeviceAuthPayload() {
    const clientKey = getOrCreateClientKey();
    if (!clientKey) return null;
    const visitorId = await getFingerprintJsVisitorId();
    return {
        clientKey,
        ...visitorId ? {
            visitorId
        } : {},
        platform: 'web'
    };
}
function getDeviceHeaders() {
    const headers = {};
    const clientKey = getOrCreateClientKey();
    if (clientKey) headers['X-C8-Client-Key'] = clientKey;
    if (cachedVisitorId) headers['X-C8-Visitor-Id'] = cachedVisitorId;
    return headers;
}
async function getDeviceHeadersAsync() {
    const headers = {};
    const clientKey = getOrCreateClientKey();
    if (clientKey) headers['X-C8-Client-Key'] = clientKey;
    const visitorId = await getFingerprintJsVisitorId();
    if (visitorId) headers['X-C8-Visitor-Id'] = visitorId;
    return headers;
}

},{"75f83d4ebd932b14":"fBe6c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fBe6c":[function(require,module,exports,__globalThis) {
module.exports = require("2d4bd5d3b88ce257")(require("8f5ae9d6ac684d51").resolve("h549a")).then(()=>module.bundle.root('1K4Q7'));

},{"2d4bd5d3b88ce257":"hpx0h","8f5ae9d6ac684d51":"fyJL2"}],"hpx0h":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"4mdbs":[function(require,module,exports,__globalThis) {
/**
 * True when running in a non-production environment (local, dev, test, staging).
 * When true, GTM and other analytics should not be loaded or sent.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDevEnv", ()=>isDevEnv);
/**
 * Paths that must not send anything to GTM/GA4.
 * - Legacy `/match` + `/match/:id` redirects (not `/matches`)
 * - Legacy `/matchdetail` redirect
 * - `/admin` (admin app / stub)
 */ parcelHelpers.export(exports, "isAnalyticsPathExcluded", ()=>isAnalyticsPathExcluded);
const NON_PROD_ENVS = [
    "dev",
    "development",
    "test",
    "stag",
    "staging",
    "local"
];
function isDevEnv() {
    const env = "prod".toLowerCase();
    if (env && NON_PROD_ENVS.includes(env)) return true;
    return false;
}
function isAnalyticsPathExcluded(pathname) {
    const raw = pathname != null && String(pathname) !== "" ? String(pathname) : typeof window !== "undefined" ? window.location.pathname : "";
    const path = raw.toLowerCase();
    if (!path) return false;
    if (path === "/admin" || path.startsWith("/admin/")) return true;
    // Exact `/match` or `/match/...` — must not match `/matches`.
    if (path === "/match" || path.startsWith("/match/")) return true;
    if (path === "/matchdetail" || path.startsWith("/matchdetail/")) return true;
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"10oOL":[function(require,module,exports,__globalThis) {
/**
 * In-memory analytics identity for GTM/dataLayer.
 * Set from UserProvider when session is known; cleared on logout.
 * `user_status` is also seeded from auth cookies before GTM starts so native
 * GA4 events (page_view, session_start) can read it as a user property.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setAnalyticsUserId", ()=>setAnalyticsUserId);
parcelHelpers.export(exports, "clearAnalyticsUserId", ()=>clearAnalyticsUserId);
/** Non-null when a logged-in user is active (synced from UserContext). */ parcelHelpers.export(exports, "getAnalyticsUserId", ()=>getAnalyticsUserId);
parcelHelpers.export(exports, "setAnalyticsUserStatus", ()=>setAnalyticsUserStatus);
parcelHelpers.export(exports, "getAnalyticsUserStatus", ()=>getAnalyticsUserStatus);
/**
 * Best-effort status before session verify completes.
 * Auth cookies / stored user id imply the user was logged in on the previous page.
 */ parcelHelpers.export(exports, "inferAnalyticsUserStatusFromCookies", ()=>inferAnalyticsUserStatusFromCookies);
/**
 * Apply logged-in / guest identity in memory (does not push to dataLayer).
 * Pass a user id for logged_in; null/undefined clears to guest.
 */ parcelHelpers.export(exports, "applyAnalyticsIdentity", ()=>applyAnalyticsIdentity);
var _authHeaders = require("./authHeaders");
let analyticsUserId = null;
let analyticsUserStatus = "guest";
function setAnalyticsUserId(userId) {
    if (userId == null || userId === "") {
        analyticsUserId = null;
        return;
    }
    analyticsUserId = String(userId);
}
function clearAnalyticsUserId() {
    analyticsUserId = null;
}
function getAnalyticsUserId() {
    return analyticsUserId;
}
function setAnalyticsUserStatus(status) {
    analyticsUserStatus = status === "logged_in" ? "logged_in" : "guest";
}
function getAnalyticsUserStatus() {
    return analyticsUserStatus;
}
function inferAnalyticsUserStatusFromCookies() {
    if (typeof window === "undefined") return "guest";
    try {
        if ((0, _authHeaders.getJwt)() || (0, _authHeaders.getSessionToken)() || (0, _authHeaders.getUserId)()) return "logged_in";
    } catch  {
    /* ignore */ }
    return "guest";
}
function applyAnalyticsIdentity(userId) {
    if (userId != null && String(userId) !== "") {
        setAnalyticsUserId(userId);
        setAnalyticsUserStatus("logged_in");
    } else {
        clearAnalyticsUserId();
        setAnalyticsUserStatus("guest");
    }
}

},{"./authHeaders":"5Rczo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kFyP8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Detect common in-app browsers that often strip document.referrer. */ parcelHelpers.export(exports, "detectInAppBrowser", ()=>detectInAppBrowser);
/** Persist UTM + click-id params for the tab session when present in the URL. */ parcelHelpers.export(exports, "captureUtmFromSearch", ()=>captureUtmFromSearch);
/**
 * Capture first landing path + external referrer host once per tab session.
 * Later navigations (e.g. /signup) must not overwrite the original touch.
 */ parcelHelpers.export(exports, "captureFirstTouchContext", ()=>captureFirstTouchContext);
/** Capture UTMs/click ids from the current route and from `back=` on login/signup. */ parcelHelpers.export(exports, "tryCaptureUtmFromRouter", ()=>tryCaptureUtmFromRouter);
parcelHelpers.export(exports, "getSessionUtmParams", ()=>getSessionUtmParams);
parcelHelpers.export(exports, "getSessionClickIdParams", ()=>getSessionClickIdParams);
parcelHelpers.export(exports, "getSessionFirstTouchContext", ()=>getSessionFirstTouchContext);
/** Remember a full reload for this tab. Sign up links do not count — only a browser refresh. */ parcelHelpers.export(exports, "noteDocumentReload", ()=>noteDocumentReload);
parcelHelpers.export(exports, "wasDocumentReloaded", ()=>wasDocumentReloaded);
/** All five UTM keys for acquisition events (`null` when not captured). */ parcelHelpers.export(exports, "getSessionUtmPayloadWithNulls", ()=>getSessionUtmPayloadWithNulls);
parcelHelpers.export(exports, "getSessionClickIdPayloadWithNulls", ()=>getSessionClickIdPayloadWithNulls);
const UTM_STORAGE_KEY = "c8_utm_params";
const FIRST_TOUCH_STORAGE_KEY = "c8_acquisition_first_touch";
const REFRESH_FLAG_KEY = "c8_acquisition_page_refreshed";
const UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term"
];
const CLICK_ID_KEYS = [
    "gclid",
    "fbclid",
    "li_fat_id",
    "msclkid"
];
function detectInAppBrowser(userAgent = "") {
    const ua = userAgent || (typeof navigator !== "undefined" ? navigator.userAgent : "") || "";
    return /FBAN|FBAV|Instagram|LinkedInApp|Line\/|Twitter|MicroMessenger|Snapchat|Pinterest|TikTok|BytedanceWebview|GSA\//i.test(ua);
}
function parseSearchParams(search) {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    return new URLSearchParams(raw);
}
function parseUtmFromSearch(search) {
    const params = parseSearchParams(search);
    const out = {};
    for (const key of UTM_KEYS){
        const value = params.get(key)?.trim();
        if (value) out[key] = value;
    }
    return out;
}
function parseClickIdsFromSearch(search) {
    const params = parseSearchParams(search);
    const out = {};
    for (const key of CLICK_ID_KEYS){
        const value = params.get(key)?.trim();
        if (value) out[key] = value;
    }
    return out;
}
function hasAnyUtm(params) {
    return UTM_KEYS.some((key)=>Boolean(params[key]));
}
function hasAnyClickId(params) {
    return CLICK_ID_KEYS.some((key)=>Boolean(params[key]));
}
function readStoredAcquisitionBlob() {
    if (typeof window === "undefined") return {};
    try {
        const raw = sessionStorage.getItem(UTM_STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        const out = {};
        for (const [key, value] of Object.entries(parsed || {}))if (value != null && String(value).trim() !== "") out[key] = String(value).trim();
        return out;
    } catch  {
        return {};
    }
}
function writeStoredAcquisitionBlob(next) {
    if (typeof window === "undefined") return;
    try {
        sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(next));
    } catch  {
    /* ignore */ }
}
function captureUtmFromSearch(search) {
    if (typeof window === "undefined") return;
    const incomingUtm = parseUtmFromSearch(search);
    const incomingClick = parseClickIdsFromSearch(search);
    if (!hasAnyUtm(incomingUtm) && !hasAnyClickId(incomingClick)) return;
    const existing = readStoredAcquisitionBlob();
    // First-touch: keep existing keys, fill blanks from the new URL.
    const next = {
        ...existing
    };
    for (const key of UTM_KEYS)if (!next[key] && incomingUtm[key]) next[key] = incomingUtm[key];
    for (const key of CLICK_ID_KEYS)if (!next[key] && incomingClick[key]) next[key] = incomingClick[key];
    writeStoredAcquisitionBlob(next);
}
function decodeBackParam(back) {
    let decoded = back.trim();
    if (!decoded) return null;
    try {
        decoded = decodeURIComponent(decoded);
    } catch  {
    /* use raw */ }
    return decoded;
}
function hostFromReferrer(referrer) {
    const raw = String(referrer || "").trim();
    if (!raw) return null;
    try {
        const url = new URL(raw);
        if (typeof window !== "undefined" && url.origin === window.location.origin) return null;
        const host = url.hostname.toLowerCase().replace(/\.$/, "");
        if (!host || host === "localhost" || host.endsWith(".local")) return null;
        return host;
    } catch  {
        return null;
    }
}
function readFirstTouch() {
    if (typeof window === "undefined") return {};
    try {
        const raw = sessionStorage.getItem(FIRST_TOUCH_STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        const out = {};
        if (parsed?.referrer_host != null && String(parsed.referrer_host).trim()) out.referrer_host = String(parsed.referrer_host).trim();
        if (parsed?.landing_path != null && String(parsed.landing_path).trim()) out.landing_path = String(parsed.landing_path).trim();
        if (parsed?.in_app_browser === true || parsed?.in_app_browser === false) out.in_app_browser = Boolean(parsed.in_app_browser);
        return out;
    } catch  {
        return {};
    }
}
function writeFirstTouch(next) {
    if (typeof window === "undefined") return;
    try {
        sessionStorage.setItem(FIRST_TOUCH_STORAGE_KEY, JSON.stringify(next));
    } catch  {
    /* ignore */ }
}
function captureFirstTouchContext({ pathname, referrer }) {
    if (typeof window === "undefined") return;
    const existing = readFirstTouch();
    const next = {
        ...existing
    };
    if (!next.landing_path) {
        const path = String(pathname || "").trim() || "/";
        next.landing_path = path.startsWith("/") ? path : `/${path}`;
    }
    if (!next.referrer_host) {
        const host = hostFromReferrer(referrer ?? (typeof document !== "undefined" ? document.referrer : ""));
        if (host) next.referrer_host = host;
    }
    if (next.in_app_browser === undefined) next.in_app_browser = detectInAppBrowser();
    noteDocumentReload();
    if (next.landing_path !== existing.landing_path || next.referrer_host !== existing.referrer_host || next.in_app_browser !== existing.in_app_browser) writeFirstTouch(next);
}
function tryCaptureUtmFromRouter({ pathname, search }) {
    captureUtmFromSearch(search);
    captureFirstTouchContext({
        pathname,
        referrer: typeof document !== "undefined" ? document.referrer : ""
    });
    const back = parseSearchParams(search).get("back");
    if (!back) return;
    const decoded = decodeBackParam(back);
    if (!decoded) return;
    const qIndex = decoded.indexOf("?");
    if (qIndex === -1) return;
    captureUtmFromSearch(decoded.slice(qIndex));
}
function getSessionUtmParams() {
    const blob = readStoredAcquisitionBlob();
    const out = {};
    for (const key of UTM_KEYS)if (blob[key]) out[key] = blob[key];
    return out;
}
function getSessionClickIdParams() {
    const blob = readStoredAcquisitionBlob();
    const out = {};
    for (const key of CLICK_ID_KEYS)if (blob[key]) out[key] = blob[key];
    return out;
}
function getSessionFirstTouchContext() {
    return readFirstTouch();
}
function noteDocumentReload() {
    if (typeof window === "undefined") return;
    try {
        const nav = performance.getEntriesByType("navigation")[0];
        if (nav?.type === "reload") sessionStorage.setItem(REFRESH_FLAG_KEY, "1");
    } catch  {
    /* ignore */ }
}
function wasDocumentReloaded() {
    if (typeof window === "undefined") return false;
    try {
        return sessionStorage.getItem(REFRESH_FLAG_KEY) === "1";
    } catch  {
        return false;
    }
}
function getSessionUtmPayloadWithNulls() {
    const utm = getSessionUtmParams();
    return {
        utm_source: utm.utm_source ?? null,
        utm_medium: utm.utm_medium ?? null,
        utm_campaign: utm.utm_campaign ?? null,
        utm_content: utm.utm_content ?? null,
        utm_term: utm.utm_term ?? null
    };
}
function getSessionClickIdPayloadWithNulls() {
    const ids = getSessionClickIdParams();
    return {
        gclid: ids.gclid ?? null,
        fbclid: ids.fbclid ?? null,
        li_fat_id: ids.li_fat_id ?? null,
        msclkid: ids.msclkid ?? null
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8RZNT":[function(require,module,exports,__globalThis) {
module.exports = require("861fad1a181e4cf8")(require("dffe21049f6f9013").resolve("3JJRT")).then(()=>module.bundle.root('6jJmW'));

},{"861fad1a181e4cf8":"hpx0h","dffe21049f6f9013":"fyJL2"}],"4Y90p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENTRY_POINT_GUEST_SPIN", ()=>ENTRY_POINT_GUEST_SPIN);
parcelHelpers.export(exports, "ENTRY_POINT_CHALLENGE", ()=>ENTRY_POINT_CHALLENGE);
/** ISO-8601 week string, e.g. `2026-W22`, for `user_cohort` on signup. */ parcelHelpers.export(exports, "getCurrentISOWeek", ()=>getCurrentISOWeek);
parcelHelpers.export(exports, "inferEntryPoint", ()=>inferEntryPoint);
parcelHelpers.export(exports, "ENTRY_POINT_MATCH_CENTRE", ()=>ENTRY_POINT_MATCH_CENTRE);
parcelHelpers.export(exports, "ENTRY_POINT_MATCH_DETAIL", ()=>ENTRY_POINT_MATCH_DETAIL);
parcelHelpers.export(exports, "ENTRY_POINT_TRADER_LOBBY", ()=>ENTRY_POINT_TRADER_LOBBY);
parcelHelpers.export(exports, "ENTRY_POINT_SQUARES_LOBBY", ()=>ENTRY_POINT_SQUARES_LOBBY);
parcelHelpers.export(exports, "ENTRY_POINT_BULLION_LOBBY", ()=>ENTRY_POINT_BULLION_LOBBY);
parcelHelpers.export(exports, "ENTRY_POINT_SIXES_LOBBY", ()=>ENTRY_POINT_SIXES_LOBBY);
parcelHelpers.export(exports, "ENTRY_POINT_PROFILE_INVITE", ()=>ENTRY_POINT_PROFILE_INVITE);
parcelHelpers.export(exports, "ENTRY_POINT_DIRECT_LINK", ()=>ENTRY_POINT_DIRECT_LINK);
parcelHelpers.export(exports, "ENTRY_POINT_LEAGUE", ()=>ENTRY_POINT_LEAGUE);
/**
 * Map match-card / lobby `cta_location` to spec `entry_point`.
 */ parcelHelpers.export(exports, "entryPointFromCtaLocation", ()=>entryPointFromCtaLocation);
/** Normalize display / legacy labels to controlled `game_type` values. */ parcelHelpers.export(exports, "normalizeGameType", ()=>normalizeGameType);
/** Remember acquisition path for the current game session (cleared on mismatch). */ parcelHelpers.export(exports, "persistGameEntryPoint", ()=>persistGameEntryPoint);
/** Mark the current game session as entered from a Cricket8 League. */ parcelHelpers.export(exports, "persistLeagueGameEntryPoint", ()=>persistLeagueGameEntryPoint);
/** Clear persisted game entry when the user leaves that fixture/game context. */ parcelHelpers.export(exports, "clearGameEntryPoint", ()=>clearGameEntryPoint);
/** Last persisted `entry_point` when fixture/game still match (e.g. game_started after card click). */ parcelHelpers.export(exports, "resolveGameEntryPoint", ()=>resolveGameEntryPoint);
/**
 * Best-effort entry when session storage is empty: URL param → same-origin referrer →
 * current path lobby → `direct_link` (gameplay events only).
 */ parcelHelpers.export(exports, "inferGameplayEntryPointFallback", ()=>inferGameplayEntryPointFallback);
/** Persist last active sport (spec value) so monetisation events can attribute by sport. */ parcelHelpers.export(exports, "persistLastSport", ()=>persistLastSport);
/** Last active sport for monetisation attribution; null when no context yet. */ parcelHelpers.export(exports, "getLastSport", ()=>getLastSport);
/** Map provider currency codes to spec values (INR, COINS, RUBIES). */ parcelHelpers.export(exports, "normalizeShopCurrency", ()=>normalizeShopCurrency);
/**
 * Push `user_context_loaded` once authenticated lifecycle context is available
 * (`window.__C8__`). Should fire before other behavioural events on a page load.
 */ parcelHelpers.export(exports, "trackUserContextLoaded", ()=>trackUserContextLoaded);
/** Persist profile-link sender for signup attribution (`referral_source: friend_invite`). */ parcelHelpers.export(exports, "persistProfileReferralForSignup", ()=>persistProfileReferralForSignup);
/** Referral controlled values from the URL; null when no referral context is present. */ parcelHelpers.export(exports, "readReferralFromUrl", ()=>readReferralFromUrl);
/**
 * Signup `entry_point`: friend-invite / profile-link paths use `profile_invite`;
 * otherwise fall back to URL/referrer inference.
 */ parcelHelpers.export(exports, "resolveSignupEntryPoint", ()=>resolveSignupEntryPoint);
parcelHelpers.export(exports, "trackSignupStarted", ()=>trackSignupStarted);
parcelHelpers.export(exports, "trackSignupCompleted", ()=>trackSignupCompleted);
parcelHelpers.export(exports, "trackLoginSuccess", ()=>trackLoginSuccess);
parcelHelpers.export(exports, "setPendingShopPurchase", ()=>setPendingShopPurchase);
parcelHelpers.export(exports, "takePendingShopPurchase", ()=>takePendingShopPurchase);
parcelHelpers.export(exports, "clearPendingShopPurchase", ()=>clearPendingShopPurchase);
parcelHelpers.export(exports, "trackShopView", ()=>trackShopView);
parcelHelpers.export(exports, "trackProductSelected", ()=>trackProductSelected);
/** Shop purchase completed. Prefer server Measurement Protocol; client helper kept for tests/docs. */ parcelHelpers.export(exports, "trackPurchaseSuccess", ()=>trackPurchaseSuccess);
parcelHelpers.export(exports, "trackPurchaseFailed", ()=>trackPurchaseFailed);
/** Authenticated account route view — includes coin/ruby balance and XP state for segmentation. */ parcelHelpers.export(exports, "trackAccountView", ()=>trackAccountView);
/** User responded to account deletion confirmation (FE intent only, not server outcome). */ parcelHelpers.export(exports, "trackAccountDeleteResponse", ()=>trackAccountDeleteResponse);
/** Marketing email consent persisted (compliance). */ parcelHelpers.export(exports, "trackMarketingConsentUpdate", ()=>trackMarketingConsentUpdate);
/** Catalog avatar saved on account (e.g. key `giraffe-orange`). */ parcelHelpers.export(exports, "trackAvatarSelected", ()=>trackAvatarSelected);
// --- Trader (GTM) — discovery & gameplay funnel ---
parcelHelpers.export(exports, "normalizeTraderSport", ()=>normalizeTraderSport);
/** Best-effort prediction / trade / play id from a place-trade or squares submit response. */ parcelHelpers.export(exports, "resolvePredictionIdFromSubmitResponse", ()=>resolvePredictionIdFromSubmitResponse);
/** Retention: My Games drawer or full page opened. */ parcelHelpers.export(exports, "trackMyGamesView", ()=>trackMyGamesView);
/** Rules / how-to-play drawer opened. */ parcelHelpers.export(exports, "trackHowToPlayView", ()=>trackHowToPlayView);
parcelHelpers.export(exports, "trackSpinStarted", ()=>trackSpinStarted);
parcelHelpers.export(exports, "trackWheelTriviaStarted", ()=>trackWheelTriviaStarted);
parcelHelpers.export(exports, "trackQuickfireStarted", ()=>trackQuickfireStarted);
/** Shown when a game has no playable session (supply gap / schedule). */ parcelHelpers.export(exports, "trackGameUnavailableView", ()=>trackGameUnavailableView);
/**
 * Guest spin funnel: signup nudge shown after spin (auto-redirect or collect CTA).
 * Fires once per tab session per game session + prompt_type (see guestSpinRegistrationPromptTracking.ts).
 */ parcelHelpers.export(exports, "trackRegistrationPromptShown", ()=>trackRegistrationPromptShown);
/** Daily wheel: prize credited via collectwinnings (logged-in only). */ parcelHelpers.export(exports, "trackSpinComplete", ()=>trackSpinComplete);
/** Wheel trivia multiplier: bonus credited via triviaendgame. */ parcelHelpers.export(exports, "trackWheelTriviaComplete", ()=>trackWheelTriviaComplete);
/**
 * Quickfire: one event per successful quickfireendgame (each GAME_DONE).
 * Users who pause and resume get multiple events; reward_amount is coins from that batch only.
 * session_complete === true when today's question set is finished (answered >= total).
 */ parcelHelpers.export(exports, "trackQuickfireComplete", ()=>trackQuickfireComplete);
parcelHelpers.export(exports, "trackTraderSportSelected", ()=>trackTraderSportSelected);
parcelHelpers.export(exports, "trackTraderLeagueSelected", ()=>trackTraderLeagueSelected);
parcelHelpers.export(exports, "trackTraderMatchSelected", ()=>trackTraderMatchSelected);
/** Squares: same `match_selected` as Trader list; sport is always cricket. */ parcelHelpers.export(exports, "trackSquaresMatchSelected", ()=>trackSquaresMatchSelected);
/** Bullion: same `match_selected` event as Trader/Squares; sport is always cricket. */ parcelHelpers.export(exports, "trackBullionMatchSelected", ()=>trackBullionMatchSelected);
/** Sixes: same `match_selected` event as Trader/Squares; sport is always cricket. */ parcelHelpers.export(exports, "trackSixesMatchSelected", ()=>trackSixesMatchSelected);
/** Squares match play: share / invite CTA (header or mobile bottom bar). */ parcelHelpers.export(exports, "trackPlayWithFriendClicked", ()=>trackPlayWithFriendClicked);
parcelHelpers.export(exports, "trackGameStarted", ()=>trackGameStarted);
parcelHelpers.export(exports, "trackTraderGameEntryClicked", ()=>trackTraderGameEntryClicked);
/** Same data layer event as Trader; use `game_type` to segment (e.g. trader | squares). */ parcelHelpers.export(exports, "trackGameLobbyView", ()=>trackGameLobbyView);
parcelHelpers.export(exports, "trackTraderGameLobbyView", ()=>trackTraderGameLobbyView);
parcelHelpers.export(exports, "trackTraderMarketGroupSelected", ()=>trackTraderMarketGroupSelected);
parcelHelpers.export(exports, "trackTraderOutcomeSelected", ()=>trackTraderOutcomeSelected);
parcelHelpers.export(exports, "trackTraderStakeSelected", ()=>trackTraderStakeSelected);
parcelHelpers.export(exports, "trackTraderPredictionSubmitted", ()=>trackTraderPredictionSubmitted);
/**
 * Squares grid prediction confirmed by the backend. Shared `prediction_submitted`
 * event with `submission_type: "squares_prediction"`.
 */ parcelHelpers.export(exports, "trackSquaresPredictionSubmitted", ()=>trackSquaresPredictionSubmitted);
/**
 * User exited/cancelled a prediction flow before submission.
 * `last_step`: `none` (no selection), `outcome` (selected, no stake), `stake` (stake set, not submitted).
 */ parcelHelpers.export(exports, "trackPredictionCancelled", ()=>trackPredictionCancelled);
/**
 * Intermediary gameplay interaction not covered by a more specific v1 event.
 * `interaction_type`: chip_placed | lucky_dip_clicked | gold_bullion_bar_placed |
 * grid_cell_selected | private_battle_link_shared | public_game_link_shared
 */ parcelHelpers.export(exports, "trackGameInteraction", ()=>trackGameInteraction);
/**
 * Bullion entry confirmed by the backend. Shared `prediction_submitted` event with
 * `submission_type: "bullion_entry"`. `visibility`: public | private.
 */ parcelHelpers.export(exports, "trackBullionEntrySubmitted", ()=>trackBullionEntrySubmitted);
/** Sixes card shown to the user for the first time (after backend confirmation). */ parcelHelpers.export(exports, "trackSixesCardRevealed", ()=>trackSixesCardRevealed);
/**
 * Sixes cheer/multiplier player became active.
 * `sixes_multiplier_selection_type`: assigned (default on reveal) | switched (user changed).
 */ parcelHelpers.export(exports, "trackSixesMultiplierSelected", ()=>trackSixesMultiplierSelected);
/**
 * Sixes card submitted/locked after backend confirmation. Shared `prediction_submitted`
 * event with `submission_type: "sixes_card"`.
 */ parcelHelpers.export(exports, "trackSixesCardSubmitted", ()=>trackSixesCardSubmitted);
/** Sixes card settled (card-level outcome). Prefer server Measurement Protocol; client helper kept for tests/docs. `sixes_outcome`: settled | cancelled. */ parcelHelpers.export(exports, "trackSixesCardSettled", ()=>trackSixesCardSettled);
/** Sixes match board or completed board viewed. `sixes_card_status`: active | settled | cancelled. */ parcelHelpers.export(exports, "trackSixesBoardViewed", ()=>trackSixesBoardViewed);
// --- Friends & invites (GTM / GA4 custom events) ---
/** Invite UI opened or native share sheet invoked — funnel before `friend_invite_sent`. */ parcelHelpers.export(exports, "trackInviteFlowOpened", ()=>trackInviteFlowOpened);
/** Own profile link copied or shared from Profile / My Zone. */ parcelHelpers.export(exports, "trackProfileLinkShared", ()=>trackProfileLinkShared);
/** Recipient opened someone else's shareable `/profile` URL. */ parcelHelpers.export(exports, "trackProfileLinkJoined", ()=>trackProfileLinkJoined);
/** Game invite link copied or native share succeeded (not profile links — use profile_link_shared). */ parcelHelpers.export(exports, "trackFriendInviteSent", ()=>trackFriendInviteSent);
/** Outgoing friend request successfully created (e.g. ADD TO FRIENDS on public profile). */ parcelHelpers.export(exports, "trackFriendRequestSent", ()=>trackFriendRequestSent);
/** Sender cancelled / withdrew a pending outgoing friend request. */ parcelHelpers.export(exports, "trackFriendRequestCancelled", ()=>trackFriendRequestCancelled);
/**
 * Recipient opened a match-specific game invite link (before auth or join).
 * Fires once per tab session per unique invite URL (see inviteLinkTracking.ts).
 */ parcelHelpers.export(exports, "trackInviteLinkClicked", ()=>trackInviteLinkClicked);
/** Logged-in user completed invite-from-link claim (Squares, Bullion, etc.). */ parcelHelpers.export(exports, "trackFriendJoinedFromInvite", ()=>trackFriendJoinedFromInvite);
/**
 * Incoming friend request accepted or declined.
 * `friend_request_sender_user_id` = requester; `friend_request_receiver_user_id` = responder (current user).
 */ parcelHelpers.export(exports, "trackFriendRequestResponse", ()=>trackFriendRequestResponse);
/**
 * In-app “challenge a friend” picker/modal opened (e.g. after CHALLENGE).
 * Use `game_type` to segment (e.g. squares, trader); `entry_point` for UI source.
 */ parcelHelpers.export(exports, "trackGameChallengeFlowOpened", ()=>trackGameChallengeFlowOpened);
/** Friends / profile: user clicked CHALLENGE next to a friend. */ parcelHelpers.export(exports, "trackChallengeFriendClicked", ()=>trackChallengeFriendClicked);
parcelHelpers.export(exports, "CTA_NAME_INVITE_FRIENDS", ()=>CTA_NAME_INVITE_FRIENDS);
parcelHelpers.export(exports, "LEAGUE_INVITE_CTA_LOCATION", ()=>LEAGUE_INVITE_CTA_LOCATION);
/**
 * League detail Invite / Invite friends CTA — opens InviteFriendsModal.
 * Distinguish surfaces via `cta_location` (`league_header` | `league_dock` | `league_tutorial`).
 */ parcelHelpers.export(exports, "trackLeagueInviteFriendsClicked", ()=>trackLeagueInviteFriendsClicked);
parcelHelpers.export(exports, "LEAGUE_RESULTS_SHARE_CTA_NAME", ()=>LEAGUE_RESULTS_SHARE_CTA_NAME);
parcelHelpers.export(exports, "LEAGUE_RESULTS_SHARE_CTA_LOCATION", ()=>LEAGUE_RESULTS_SHARE_CTA_LOCATION);
/**
 * Finished-league results sharing. `target_url` is the minted `/leagues?r=CODE` link when known,
 * so shares can be joined to the visits they bring in.
 * @param {{ user_id?: string | number | null, cta_name: string, cta_location: string, target_url?: string, pathname?: string }} args
 */ parcelHelpers.export(exports, "trackLeagueResultsShareClicked", ()=>trackLeagueResultsShareClicked);
/**
 * SELECT GAME popover: user chose Squares, Bullion, or Leagues before the challenge flow opens.
 * (`game_challenge_flow_opened` still fires when Squares/Bullion modals mount.)
 */ parcelHelpers.export(exports, "trackChallengeGameSelected", ()=>trackChallengeGameSelected);
/**
 * In-app game challenge successfully sent to a friend.
 * `challenge_target_id` — game-specific context (e.g. Squares `match_id`, future: trader `fixture_id`).
 */ parcelHelpers.export(exports, "trackGameChallengeSent", ()=>trackGameChallengeSent);
parcelHelpers.export(exports, "CTA_NAME_SPIN_THE_WHEEL", ()=>CTA_NAME_SPIN_THE_WHEEL);
parcelHelpers.export(exports, "SPIN_THE_WHEEL_CTA_LOCATION", ()=>SPIN_THE_WHEEL_CTA_LOCATION);
/**
 * Spin-the-wheel entry: burger, footer, floating corner, games-home headline, My Games next step.
 * Always uses `cta_name=spin_the_wheel`; distinguish surfaces via `cta_location`.
 */ parcelHelpers.export(exports, "trackSpinTheWheelCtaClicked", ()=>trackSpinTheWheelCtaClicked);
/**
 * Major CTA click across marketing, gameplay discovery, modal, profile, shop, or invite flows.
 * Use controlled `cta_name` / `cta_location` values from the tracking spec.
 */ parcelHelpers.export(exports, "trackCtaClicked", ()=>trackCtaClicked);
/** Lime MATCH / RACE on match cards — opens match detail (not a game lobby). */ parcelHelpers.export(exports, "trackOpenMatchDetailClicked", ()=>trackOpenMatchDetailClicked);
/**
 * WATCH LIVE button clicks.
 * `cta_location` examples: homepage_match_centre | matches_page | match_detail |
 * trader_match_play | squares_match_play | bullion_match_play | sixes_match_play |
 * plus lobby locations (trader_lobby, squares_lobby, …)
 */ parcelHelpers.export(exports, "trackWatchLiveClicked", ()=>trackWatchLiveClicked);
/** Match-card / lobby game chip — same `cta_name` pattern as games-home tiles (`open_*`). */ parcelHelpers.export(exports, "trackMatchCardGameCtaClicked", ()=>trackMatchCardGameCtaClicked);
/**
 * Full match-card game entry funnel: `match_selected` + `game_entry_clicked` + `cta_clicked`,
 * with `entry_point` persisted for `game_started` / `prediction_submitted`.
 */ parcelHelpers.export(exports, "trackMatchCardGameEntry", ()=>trackMatchCardGameEntry);
/** Profile customisation saved successfully. Send counts, not full preference lists. */ parcelHelpers.export(exports, "trackProfileUpdated", ()=>trackProfileUpdated);
/** Privacy / visibility / social setting changed successfully (not marketing consent). */ parcelHelpers.export(exports, "trackUserPreferenceChanged", ()=>trackUserPreferenceChanged);
/**
 * XP leaderboard reached or filter changed (after rank/period data has loaded).
 * `leaderboard_period`: week | all_time. `leaderboard_scope`: all_players | my_friends.
 */ parcelHelpers.export(exports, "trackXpLeaderboardView", ()=>trackXpLeaderboardView);
/**
 * Backend-confirmed XP grant. Prefer server Measurement Protocol; client helper kept for tests/docs.
 */ parcelHelpers.export(exports, "trackXpEarned", ()=>trackXpEarned);
/**
 * Login streak incremented. Prefer server Measurement Protocol; client helper kept for tests/docs.
 */ parcelHelpers.export(exports, "trackLoginStreakUpdated", ()=>trackLoginStreakUpdated);
/**
 * Wheel multiplier streak updated. Prefer server Measurement Protocol; client helper kept for tests/docs.
 */ parcelHelpers.export(exports, "trackWheelMultiplierStreakUpdated", ()=>trackWheelMultiplierStreakUpdated);
/** Daily trader leaderboard tab opened or sport tab switched. */ parcelHelpers.export(exports, "trackTraderLeaderboardView", ()=>trackTraderLeaderboardView);
var _analyticsConsent = require("./analyticsConsent");
var _analyticsEnv = require("./analyticsEnv");
var _gtm = require("./gtm");
var _utmTracking = require("./utmTracking");
const ENTRY_POINT_VALUES = {
    HOMEPAGE: "homepage",
    /** Arrived from another website (Google, LinkedIn, etc.). */ EXTERNAL: "external",
    /** Navigated from another page on cricket8 (not homepage). */ INTERNAL: "internal",
    PROMO: "promo",
    REFERRAL: "referral",
    GUEST_SPIN: "guest_spin"
};
const ENTRY_POINT_GUEST_SPIN = ENTRY_POINT_VALUES.GUEST_SPIN;
const ENTRY_POINT_CHALLENGE = "challenge";
const PAGE_NAME_MAP = {
    "/": "homepage",
    "/signup": "signup",
    "/login": "login",
    "/shop": "shop",
    "/my-games": "my_games",
    "/my-zone": "my_zone",
    "/account": "account",
    "/trader": "trader",
    "/squares": "squares",
    "/bullion": "bullion"
};
function getDeviceType() {
    if (typeof window === "undefined") return "desktop";
    const width = window.innerWidth || 1280;
    if (width < 768) return "mobile";
    if (width < 1024) return "tablet";
    return "desktop";
}
function getCurrentISOWeek(date = new Date()) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    return `${d.getUTCFullYear()}-W${String(weekNo).padStart(2, "0")}`;
}
function getPageName(pathname) {
    if (!pathname) return "unknown";
    if (pathname === "/matches" && typeof window !== "undefined") {
        const matchId = new URLSearchParams(window.location.search).get("id");
        if (matchId != null && String(matchId).trim() !== "") return "match_detail";
        return "match_centre";
    }
    if (PAGE_NAME_MAP[pathname]) return PAGE_NAME_MAP[pathname];
    return pathname.replace(/^\//, "").replace(/-/g, "_") || "homepage";
}
function getSessionId() {
    if (typeof window === "undefined") return undefined;
    try {
        return sessionStorage.getItem("c8_session_id") || localStorage.getItem("c8_session_id") || undefined;
    } catch (_) {
        return undefined;
    }
}
/**
 * Authenticated lifecycle context injected by the backend on page load
 * (`window.__C8__`). Returns nulls when unavailable so the keys are still
 * sent on every event (per tracking spec: send key with `null`, do not omit).
 */ function getLifecycleContext() {
    if (typeof window === "undefined") return {
        user_id: null,
        days_since_registration: null,
        user_cohort: null
    };
    const c8 = window.__C8__ || {};
    return {
        user_id: c8.user_id != null && c8.user_id !== "" ? String(c8.user_id) : null,
        days_since_registration: c8.days_since_registration != null && !Number.isNaN(Number(c8.days_since_registration)) ? Number(c8.days_since_registration) : null,
        user_cohort: c8.user_cohort != null && String(c8.user_cohort) !== "" ? String(c8.user_cohort) : null
    };
}
function inferEntryPoint(search = "", referrer = "") {
    if (typeof window === "undefined") return ENTRY_POINT_VALUES.HOMEPAGE;
    const params = new URLSearchParams(search);
    const game = (params.get("game") || "").trim().toLowerCase();
    const gamesession = (params.get("gamesession") || "").trim();
    if (game === "wheel-spin" && gamesession) return ENTRY_POINT_VALUES.GUEST_SPIN;
    const hasReferral = params.has("ref") || params.has("referral") || params.has("invite");
    if (hasReferral) return ENTRY_POINT_VALUES.REFERRAL;
    const promoSource = params.get("promo") || params.get("offer") || params.get("utm_campaign") || "";
    if (promoSource && /(promo|offer|campaign|bonus|welcome)/i.test(promoSource)) return ENTRY_POINT_VALUES.PROMO;
    if (referrer) try {
        const refUrl = new URL(referrer);
        if (refUrl.origin !== window.location.origin) return ENTRY_POINT_VALUES.EXTERNAL;
        if (refUrl.pathname === "/" || refUrl.pathname === "") return ENTRY_POINT_VALUES.HOMEPAGE;
        return ENTRY_POINT_VALUES.INTERNAL;
    } catch (_) {
        return ENTRY_POINT_VALUES.EXTERNAL;
    }
    return ENTRY_POINT_VALUES.HOMEPAGE;
}
function stripNilFields(obj) {
    const out = {
        ...obj
    };
    Object.keys(out).forEach((k)=>{
        if (out[k] === undefined || out[k] === null) delete out[k];
    });
    return out;
}
/**
 * GTM dataLayer last-value variables retain prior keys when a later push omits them.
 * Explicit `null` clears those keys so stale `game_type` / `entry_point` / etc. cannot leak.
 */ const DATA_LAYER_CLEAR_KEYS = [
    "game_type",
    "entry_point",
    "sport",
    "submission_type",
    "prediction_id",
    "market_name",
    "selection_value",
    "fixture_id",
    "competition_name",
    "cta_name",
    "cta_location",
    "source_page",
    "play_mode",
    "league_id",
    "is_league_play"
];
const C8_GAME_ENTRY_KEY = "c8_game_entry";
const ENTRY_POINT_MATCH_CENTRE = "match_centre";
const ENTRY_POINT_MATCH_DETAIL = "match_detail";
const ENTRY_POINT_TRADER_LOBBY = "trader_lobby";
const ENTRY_POINT_SQUARES_LOBBY = "squares_lobby";
const ENTRY_POINT_BULLION_LOBBY = "bullion_lobby";
const ENTRY_POINT_SIXES_LOBBY = "sixes_lobby";
const ENTRY_POINT_PROFILE_INVITE = "profile_invite";
const ENTRY_POINT_DIRECT_LINK = "direct_link";
const ENTRY_POINT_LEAGUE = "league";
const LOBBY_ENTRY_BY_GAME_TYPE = {
    trader: ENTRY_POINT_TRADER_LOBBY,
    squares: ENTRY_POINT_SQUARES_LOBBY,
    bullion: ENTRY_POINT_BULLION_LOBBY,
    sixes: ENTRY_POINT_SIXES_LOBBY
};
function entryPointFromCtaLocation(cta_location) {
    if (cta_location == null || cta_location === "") return undefined;
    if (cta_location === ENTRY_POINT_MATCH_DETAIL) return ENTRY_POINT_MATCH_DETAIL;
    if (cta_location === "homepage_match_centre" || cta_location === "matches_page" || cta_location === "match_card") return ENTRY_POINT_MATCH_CENTRE;
    if (cta_location === "trader_lobby" || cta_location === "match_card_header") return ENTRY_POINT_TRADER_LOBBY;
    if (cta_location === "squares_lobby") return ENTRY_POINT_SQUARES_LOBBY;
    if (cta_location === "bullion_lobby" || cta_location === "bullion_match_landing") return ENTRY_POINT_BULLION_LOBBY;
    if (cta_location === "sixes_lobby") return ENTRY_POINT_SIXES_LOBBY;
    if (cta_location === "games_home") return "games_home";
    if (cta_location === ENTRY_POINT_LEAGUE || cta_location === "leagues") return ENTRY_POINT_LEAGUE;
    return undefined;
}
function normalizeGameType(raw) {
    if (raw == null || String(raw).trim() === "") return undefined;
    const s = String(raw).trim().toLowerCase().replace(/_/g, "-").replace(/\s+/g, "-");
    if (s === "wheel-spin" || s === "wheelspin" || s === "spinner" || s === "spin") return "wheel-spin";
    return s;
}
function persistGameEntryPoint({ entry_point, fixture_id, game_type }) {
    if (!entry_point || typeof window === "undefined") return;
    try {
        sessionStorage.setItem(C8_GAME_ENTRY_KEY, JSON.stringify({
            entry_point: String(entry_point),
            fixture_id: fixture_id != null ? String(fixture_id) : null,
            game_type: game_type != null ? String(game_type) : null
        }));
    } catch (_) {
    /* ignore */ }
}
function persistLeagueGameEntryPoint({ fixture_id, game_type } = {}) {
    persistGameEntryPoint({
        entry_point: ENTRY_POINT_LEAGUE,
        fixture_id,
        game_type
    });
}
const PLAY_MODE_LEAGUE = "league";
const PLAY_MODE_ORIGINAL = "original";
/** Game events that should always carry play_mode / is_league_play for report splits. */ const PLAY_SURFACE_EVENTS = new Set([
    "game_lobby_view",
    "match_selected",
    "game_started",
    "game_interaction",
    "prediction_submitted",
    "prediction_cancelled",
    "game_entry_clicked",
    "how_to_play_view",
    "sixes_card_revealed",
    "sixes_multiplier_selected",
    "sixes_card_settled",
    "sixes_board_viewed"
]);
function leagueIdFromSearch(search) {
    try {
        const qs = search != null ? search : typeof window !== "undefined" ? window.location.search || "" : "";
        const params = new URLSearchParams(qs.startsWith("?") ? qs.slice(1) : qs);
        const id = params.get("leagueId");
        return id != null && String(id).trim() !== "" ? String(id).trim() : undefined;
    } catch (_) {
        return undefined;
    }
}
/**
 * Report split: same event names / game_type, explicit league vs original.
 * `league_id` is null on original so sticky GTM vars cannot leak a prior league.
 */ function playSurfaceFields({ play_mode, league_id, search } = {}) {
    const explicitId = league_id != null && String(league_id).trim() !== "" ? String(league_id).trim() : undefined;
    const inferredId = leagueIdFromSearch(search);
    const isLeague = play_mode === PLAY_MODE_LEAGUE || play_mode === true || Boolean(explicitId || inferredId);
    return {
        play_mode: isLeague ? PLAY_MODE_LEAGUE : PLAY_MODE_ORIGINAL,
        is_league_play: isLeague,
        league_id: isLeague ? explicitId || inferredId || null : null
    };
}
/** Extra GTM params so league plays roll into original `game_type` but stay filterable. */ function withLeaguePlayMode(params, extras = {}) {
    return {
        ...params,
        ...playSurfaceFields(extras)
    };
}
function clearGameEntryPoint() {
    if (typeof window === "undefined") return;
    try {
        sessionStorage.removeItem(C8_GAME_ENTRY_KEY);
    } catch (_) {
    /* ignore */ }
}
function resolveGameEntryPoint({ fixture_id, game_type } = {}) {
    if (typeof window === "undefined") return undefined;
    try {
        const raw = sessionStorage.getItem(C8_GAME_ENTRY_KEY);
        if (!raw) return undefined;
        const parsed = JSON.parse(raw);
        if (!parsed?.entry_point) return undefined;
        if (fixture_id != null && parsed.fixture_id != null && String(parsed.fixture_id) !== String(fixture_id)) {
            clearGameEntryPoint();
            return undefined;
        }
        if (game_type != null && parsed.game_type != null && String(parsed.game_type) !== String(game_type)) {
            clearGameEntryPoint();
            return undefined;
        }
        return String(parsed.entry_point);
    } catch (_) {
        return undefined;
    }
}
function inferGameplayEntryPointFallback({ game_type, pathname, search } = {}) {
    if (typeof window === "undefined") return undefined;
    const path = pathname || window.location.pathname || "";
    const qs = search != null ? search : window.location.search || "";
    try {
        const params = new URLSearchParams(qs.startsWith("?") ? qs.slice(1) : qs);
        const fromParam = params.get("entry_point") || params.get("entry") || params.get("from") || "";
        if (fromParam.trim()) {
            const normalized = String(fromParam).trim().toLowerCase().replace(/\s+/g, "_");
            if (normalized) return normalized;
        }
        if (params.get("leagueId")?.trim()) return ENTRY_POINT_LEAGUE;
    } catch (_) {
    /* ignore */ }
    try {
        if (document.referrer) {
            const refUrl = new URL(document.referrer);
            if (refUrl.origin === window.location.origin) {
                const refPath = refUrl.pathname || "";
                if (refPath === "/" || refPath === "") return ENTRY_POINT_VALUES.HOMEPAGE;
                if (refPath.startsWith("/leagues")) return ENTRY_POINT_LEAGUE;
                if (refPath === "/matches") return ENTRY_POINT_MATCH_CENTRE;
                if (refPath.startsWith("/trader")) return ENTRY_POINT_TRADER_LOBBY;
                if (refPath.startsWith("/squares")) return ENTRY_POINT_SQUARES_LOBBY;
                if (refPath.startsWith("/bullion")) return ENTRY_POINT_BULLION_LOBBY;
                if (refPath.startsWith("/sixes")) return ENTRY_POINT_SIXES_LOBBY;
                if (refPath.startsWith("/my-games") || refPath.startsWith("/my-zone")) return "my_games";
                if (refPath.startsWith("/profile")) return ENTRY_POINT_PROFILE_INVITE;
            }
        }
    } catch (_) {
    /* ignore */ }
    // On a game route: lobby list vs in-match deep link / refresh.
    try {
        const params = new URLSearchParams(qs.startsWith("?") ? qs.slice(1) : qs);
        if (params.get("leagueId")?.trim()) return ENTRY_POINT_LEAGUE;
        const hasMatchContext = Boolean(params.get("matchId") || params.get("raceId") || params.get("match")) || Boolean(params.get("room") || params.get("gameId"));
        if (path.startsWith("/trader")) return hasMatchContext ? ENTRY_POINT_DIRECT_LINK : ENTRY_POINT_TRADER_LOBBY;
        if (path.startsWith("/squares")) return hasMatchContext ? ENTRY_POINT_DIRECT_LINK : ENTRY_POINT_SQUARES_LOBBY;
        if (path.startsWith("/bullion")) return hasMatchContext ? ENTRY_POINT_DIRECT_LINK : ENTRY_POINT_BULLION_LOBBY;
        if (path.startsWith("/sixes")) return hasMatchContext ? ENTRY_POINT_DIRECT_LINK : ENTRY_POINT_SIXES_LOBBY;
    } catch (_) {
        if (path.startsWith("/trader")) return ENTRY_POINT_TRADER_LOBBY;
        if (path.startsWith("/squares")) return ENTRY_POINT_SQUARES_LOBBY;
        if (path.startsWith("/bullion")) return ENTRY_POINT_BULLION_LOBBY;
        if (path.startsWith("/sixes")) return ENTRY_POINT_SIXES_LOBBY;
    }
    const lobbyDefault = game_type != null ? LOBBY_ENTRY_BY_GAME_TYPE[String(game_type)] : undefined;
    if (lobbyDefault) return lobbyDefault;
    return ENTRY_POINT_DIRECT_LINK;
}
/**
 * Resolve gameplay `entry_point`: explicit → session → URL/referrer/path → optional fallback.
 * Pass `fallback: true` on funnel events that should rarely be null (game_started, prediction, etc.).
 */ function withResolvedEntryPoint(explicit, context = {}, { fallback = false } = {}) {
    if (explicit != null && String(explicit) !== "") return String(explicit);
    const fromSession = resolveGameEntryPoint(context);
    if (fromSession) return fromSession;
    if (!fallback) return undefined;
    return inferGameplayEntryPointFallback({
        game_type: context.game_type,
        pathname: context.pathname
    });
}
const C8_LAST_SPORT_KEY = "c8_sport";
function persistLastSport(sport) {
    if (typeof window === "undefined") return;
    const s = sport != null && String(sport).trim() !== "" ? String(sport) : null;
    if (!s) return;
    try {
        sessionStorage.setItem(C8_LAST_SPORT_KEY, s);
    } catch (_) {
    /* ignore */ }
}
function getLastSport() {
    if (typeof window === "undefined") return null;
    try {
        const v = sessionStorage.getItem(C8_LAST_SPORT_KEY);
        return v != null && v !== "" ? v : null;
    } catch (_) {
        return null;
    }
}
function normalizeShopCurrency(currency) {
    if (currency == null || currency === "") return "INR";
    const s = String(currency).toLowerCase();
    if (s === "inr") return "INR";
    if (s === "cr8_rby" || s === "rubies" || s === "ruby") return "RUBIES";
    if (s === "cr8_coin" || s === "coins" || s === "coin") return "COINS";
    return String(currency).toUpperCase();
}
function pushEvent(eventName, eventParams = {}, context = {}) {
    if ((0, _analyticsEnv.isDevEnv)()) return;
    if (!(0, _analyticsConsent.hasAnalyticsCookieConsent)()) return;
    const pathname = context.pathname || (typeof window !== "undefined" ? window.location.pathname : "");
    if ((0, _analyticsEnv.isAnalyticsPathExcluded)(pathname)) return;
    const sessionId = getSessionId();
    const lifecycle = getLifecycleContext();
    const payload = stripNilFields({
        event: eventName,
        page_name: getPageName(pathname),
        user_status: context.userStatus || "guest",
        platform: "web",
        device_type: getDeviceType(),
        ...stripNilFields(eventParams)
    });
    if (sessionId) payload.session_id = sessionId;
    // Lifecycle context: always present (null when unavailable) per spec.
    // Explicit event params take precedence over the global window.__C8__ values.
    if (!("days_since_registration" in payload)) payload.days_since_registration = lifecycle.days_since_registration;
    if (!("user_cohort" in payload)) payload.user_cohort = lifecycle.user_cohort;
    if (context.userId != null && context.userId !== "") payload.user_id = String(context.userId);
    else if (payload.user_id == null && lifecycle.user_id != null) payload.user_id = lifecycle.user_id;
    else if (payload.user_id == null) payload.user_id = null;
    if (PLAY_SURFACE_EVENTS.has(eventName) || payload.game_type) {
        const surface = playSurfaceFields({
            play_mode: payload.play_mode,
            league_id: payload.league_id,
            search: typeof window !== "undefined" ? window.location.search : undefined
        });
        payload.play_mode = surface.play_mode;
        payload.is_league_play = surface.is_league_play;
        payload.league_id = surface.league_id;
    }
    // Reset sticky GTM vars when this event does not set them (prevents cross-game leakage).
    for (const key of DATA_LAYER_CLEAR_KEYS)if (!(key in payload)) payload[key] = null;
    (0, _gtm.pushToDataLayer)({
        dataLayer: payload
    }).catch(()=>{
        if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    });
}
function trackUserContextLoaded({ user_id, pathname, userStatus } = {}) {
    pushEvent("user_context_loaded", {}, {
        pathname,
        userStatus: userStatus || (user_id != null && user_id !== "" ? "logged_in" : "guest"),
        userId: user_id
    });
}
const C8_REFERRAL_KEY = "c8_referral";
const C8_PROFILE_REFERRAL_KEY = "c8_profile_referral";
function persistProfileReferralForSignup(sender_user_id) {
    if (sender_user_id == null || String(sender_user_id).trim() === "") return;
    try {
        sessionStorage.setItem(C8_PROFILE_REFERRAL_KEY, JSON.stringify({
            referral_code: String(sender_user_id).trim(),
            referral_source: "friend_invite"
        }));
    } catch (_) {
    /* ignore */ }
}
function readReferralFromUrl(search) {
    let qs = search;
    if (qs == null) qs = typeof window !== "undefined" ? window.location.search : "";
    try {
        const params = new URLSearchParams(qs.startsWith("?") ? qs.slice(1) : qs);
        const code = params.get("ref") || params.get("referral") || params.get("invite") || params.get("invitedBy") || null;
        if (!code) return {
            referral_code: null,
            referral_source: null
        };
        let source = "promo";
        if (params.has("invite") || params.has("invitedBy") || params.has("referral")) source = "friend_invite";
        else if (params.has("ref")) source = "affiliate";
        return {
            referral_code: String(code),
            referral_source: source
        };
    } catch (_) {
        return {
            referral_code: null,
            referral_source: null
        };
    }
}
/** Resolve referral from the URL, falling back to a value persisted at signup start. */ function resolveReferral() {
    const fromUrl = readReferralFromUrl();
    if (fromUrl.referral_code) {
        try {
            sessionStorage.setItem(C8_REFERRAL_KEY, JSON.stringify(fromUrl));
        } catch (_) {
        /* ignore */ }
        return fromUrl;
    }
    try {
        const raw = sessionStorage.getItem(C8_REFERRAL_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && parsed.referral_code) return parsed;
        }
    } catch (_) {
    /* ignore */ }
    try {
        const rawProfile = sessionStorage.getItem(C8_PROFILE_REFERRAL_KEY);
        if (rawProfile) {
            const parsed = JSON.parse(rawProfile);
            if (parsed && parsed.referral_code) return parsed;
        }
    } catch (_) {
    /* ignore */ }
    return {
        referral_code: null,
        referral_source: null
    };
}
function resolveSignupEntryPoint(search = "", referrer = "", explicit) {
    if (explicit != null && String(explicit).trim() !== "") return String(explicit).trim();
    const ref = resolveReferral();
    if (ref.referral_source === "friend_invite") return ENTRY_POINT_PROFILE_INVITE;
    return inferEntryPoint(search, referrer);
}
function trackSignupStarted({ signup_method, entry_point, referral_code, referral_source, pathname }) {
    const ref = referral_code !== undefined || referral_source !== undefined ? {
        referral_code: referral_code ?? null,
        referral_source: referral_source ?? null
    } : resolveReferral();
    // Friend-invite / profile-link always wins over URL/referrer inference (e.g. external).
    const resolvedEntry = ref.referral_source === "friend_invite" ? ENTRY_POINT_PROFILE_INVITE : entry_point != null && String(entry_point).trim() !== "" ? String(entry_point) : undefined;
    pushEvent("signup_started", {
        ...(0, _utmTracking.getSessionUtmPayloadWithNulls)(),
        ...stripNilFields({
            signup_method,
            entry_point: resolvedEntry,
            referral_code: ref.referral_code,
            referral_source: ref.referral_source
        })
    }, {
        pathname,
        userStatus: "guest"
    });
}
function trackSignupCompleted({ user_id, signup_method, entry_point, referral_code, referral_source, user_cohort, pathname }) {
    const ref = referral_code !== undefined || referral_source !== undefined ? {
        referral_code: referral_code ?? null,
        referral_source: referral_source ?? null
    } : resolveReferral();
    const resolvedEntry = ref.referral_source === "friend_invite" ? ENTRY_POINT_PROFILE_INVITE : entry_point != null && String(entry_point).trim() !== "" ? String(entry_point) : undefined;
    const uid = user_id != null && String(user_id).trim() !== "" ? String(user_id) : null;
    pushEvent("signup_completed", {
        ...(0, _utmTracking.getSessionUtmPayloadWithNulls)(),
        ...stripNilFields({
            user_id: uid,
            signup_method,
            entry_point: resolvedEntry,
            referral_code: ref.referral_code,
            referral_source: ref.referral_source,
            days_since_registration: 0,
            user_cohort: user_cohort ?? getCurrentISOWeek(),
            // Matches server Measurement Protocol `sign_up` for GA4 client/server dedupe.
            event_id: uid ? `sign_up:${uid}` : undefined
        })
    }, {
        pathname,
        userStatus: "logged_in",
        userId: uid
    });
}
function trackLoginSuccess({ user_id, login_method, pathname }) {
    pushEvent("login_success", {
        user_id,
        login_method
    }, {
        pathname,
        userStatus: "logged_in"
    });
}
const C8_SHOP_PENDING_PURCHASE_KEY = "c8_shop_pending_purchase";
function setPendingShopPurchase(payload) {
    if (typeof window === "undefined") return;
    try {
        sessionStorage.setItem(C8_SHOP_PENDING_PURCHASE_KEY, JSON.stringify(payload));
    } catch (_) {
    /* ignore */ }
}
function takePendingShopPurchase() {
    if (typeof window === "undefined") return null;
    try {
        const raw = sessionStorage.getItem(C8_SHOP_PENDING_PURCHASE_KEY);
        sessionStorage.removeItem(C8_SHOP_PENDING_PURCHASE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (_) {
        return null;
    }
}
function clearPendingShopPurchase() {
    if (typeof window === "undefined") return;
    try {
        sessionStorage.removeItem(C8_SHOP_PENDING_PURCHASE_KEY);
    } catch (_) {
    /* ignore */ }
}
function trackShopView({ user_id, sport, pathname }) {
    const loggedIn = user_id != null && user_id !== "";
    pushEvent("shop_view", {
        sport: sport !== undefined ? sport : getLastSport()
    }, {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/shop"),
        userStatus: loggedIn ? "logged_in" : "guest",
        userId: user_id
    });
}
function trackProductSelected({ user_id, product_id, product_type, product_name, price, original_price, discount_pct, currency, sport, pathname }) {
    pushEvent("product_selected", stripNilFields({
        product_id: product_id != null ? String(product_id) : undefined,
        product_type,
        product_name,
        price,
        original_price,
        discount_pct,
        currency: normalizeShopCurrency(currency),
        sport: sport !== undefined ? sport : getLastSport()
    }), {
        pathname,
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackPurchaseSuccess({ user_id, transaction_id, amount, currency, payment_method, product_id, product_type, sport, pathname }) {
    pushEvent("purchase_success", stripNilFields({
        transaction_id,
        amount,
        currency: currency != null ? normalizeShopCurrency(currency) : undefined,
        payment_method,
        product_id: product_id != null ? String(product_id) : undefined,
        product_type,
        sport: sport !== undefined ? sport : getLastSport()
    }), {
        pathname,
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackPurchaseFailed({ user_id, product_id, product_type, amount, currency, payment_method, error_type, sport, pathname }) {
    pushEvent("purchase_failed", stripNilFields({
        product_id: product_id != null ? String(product_id) : undefined,
        product_type,
        amount,
        currency: currency != null ? normalizeShopCurrency(currency) : undefined,
        payment_method,
        error_type,
        sport: sport !== undefined ? sport : getLastSport()
    }), {
        pathname,
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackAccountView({ user_id, coin_balance, ruby_balance, xp_crown, xp_rank, xp_value, login_streak_current, pathname }) {
    const num = (v)=>v != null && !Number.isNaN(Number(v)) ? Number(v) : undefined;
    pushEvent("account_view", stripNilFields({
        coin_balance: num(coin_balance),
        ruby_balance: num(ruby_balance),
        xp_crown: xp_crown != null && String(xp_crown).trim() !== "" ? String(xp_crown).trim().toLowerCase() : undefined,
        xp_rank: num(xp_rank),
        xp_value: num(xp_value),
        login_streak_current: num(login_streak_current)
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/account"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackAccountDeleteResponse({ user_id, delete_response, pathname }) {
    const response = delete_response === "confirmed" || delete_response === "cancelled" ? delete_response : undefined;
    pushEvent("account_delete_response", stripNilFields({
        delete_response: response
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/account"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackMarketingConsentUpdate({ user_id, previous_status, new_status, pathname }) {
    pushEvent("marketing_consent_update", {
        previous_status: Boolean(previous_status),
        new_status: Boolean(new_status)
    }, {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/account"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackAvatarSelected({ user_id, avatar_id, pathname }) {
    pushEvent("avatar_selected", {
        avatar_id
    }, {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/account"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function normalizeTraderSport(raw) {
    if (raw == null || String(raw).trim() === "") return undefined;
    const s = String(raw).toLowerCase().trim();
    // Never invent a fake controlled value — omit so sticky clear can null the key.
    if (s === "unknown") return undefined;
    if (s.includes("horse")) return "horses";
    if (s.includes("cricket")) return "cricket";
    if (s.includes("foot") || s.includes("soccer")) return "football";
    if (s.includes("tennis")) return "tennis";
    return s;
}
function resolvePredictionIdFromSubmitResponse(payload) {
    if (payload == null || typeof payload !== "object") return undefined;
    const data = payload.data != null && typeof payload.data === "object" ? payload.data : null;
    const candidates = [
        data?.tradeId,
        data?.playId,
        data?.prediction_id,
        data?.id,
        payload.tradeId,
        payload.playId,
        payload.prediction_id
    ];
    for (const c of candidates){
        if (c != null && String(c).trim() !== "") return String(c);
    }
    return undefined;
}
function traderPushContext(user_id, pathname) {
    const loggedIn = user_id != null && user_id !== "";
    return {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/trader"),
        userStatus: loggedIn ? "logged_in" : "guest",
        userId: user_id
    };
}
function trackMyGamesView({ user_id, active_games_count, pathname }) {
    const n = active_games_count != null && !Number.isNaN(Number(active_games_count)) ? Number(active_games_count) : undefined;
    pushEvent("my_games_view", stripNilFields({
        active_games_count: n
    }), traderPushContext(user_id, pathname));
}
function trackHowToPlayView({ user_id, game_type, entry_point, pathname }) {
    pushEvent("how_to_play_view", stripNilFields({
        game_type: game_type != null && String(game_type) !== "" ? String(game_type) : undefined,
        entry_point: entry_point != null && String(entry_point) !== "" ? String(entry_point) : undefined
    }), traderPushContext(user_id, pathname));
}
function trackSpinStarted({ user_id, pathname }) {
    pushEvent("spin_started", {
        game_type: "wheel-spin"
    }, traderPushContext(user_id, pathname));
}
function trackWheelTriviaStarted({ user_id, pathname }) {
    pushEvent("wheel_trivia_started", {
        game_type: "wheel-spin"
    }, traderPushContext(user_id, pathname));
}
function trackQuickfireStarted({ user_id, pathname }) {
    pushEvent("quickfire_started", {
        game_type: "quickfire"
    }, traderPushContext(user_id, pathname));
}
function trackGameUnavailableView({ user_id, game_type, unavailable_reason, fixture_id, competition_name, sport, match_status, opens_in_minutes, pathname }) {
    const gt = game_type != null && String(game_type).trim() !== "" ? String(game_type).trim().toLowerCase() : undefined;
    const ur = unavailable_reason != null && String(unavailable_reason).trim() !== "" ? String(unavailable_reason).trim().toLowerCase() : undefined;
    const opens = opens_in_minutes != null && !Number.isNaN(Number(opens_in_minutes)) ? Number(opens_in_minutes) : undefined;
    pushEvent("game_unavailable_view", stripNilFields({
        game_type: gt,
        unavailable_reason: ur,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        competition_name: competition_name != null && String(competition_name) !== "" ? String(competition_name) : undefined,
        sport: sport != null ? normalizeTraderSport(sport) : undefined,
        match_status: match_status != null && String(match_status).trim() !== "" ? String(match_status).trim().toLowerCase() : undefined,
        opens_in_minutes: opens
    }), traderPushContext(user_id, pathname));
}
function trackRegistrationPromptShown({ user_id, prompt_type, game_session_id, reward_amount, currency, source_page, pathname }) {
    const pt = prompt_type != null && String(prompt_type).trim() !== "" ? String(prompt_type).trim().toLowerCase() : undefined;
    const reward = reward_amount != null && !Number.isNaN(Number(reward_amount)) ? Number(reward_amount) : undefined;
    const c = currency != null && String(currency).trim() !== "" ? normalizeShopCurrency(currency) : undefined;
    pushEvent("registration_prompt_shown", stripNilFields({
        prompt_type: pt === "collect_cta" ? "collect_cta" : pt === "auto_redirect" ? "auto_redirect" : undefined,
        game_session_id: game_session_id != null ? String(game_session_id) : undefined,
        game_type: "wheel-spin",
        reward_amount: reward,
        currency: c,
        source_page: source_page != null && String(source_page).trim() !== "" ? String(source_page).trim().toLowerCase() : undefined
    }), traderPushContext(user_id, pathname));
}
function trackSpinComplete({ user_id, reward_amount, currency, reward_type, spin_result, daily_bonus_streak_current, pathname }) {
    const n = reward_amount != null && !Number.isNaN(Number(reward_amount)) ? Number(reward_amount) : undefined;
    const c = currency != null && String(currency).trim() !== "" ? normalizeShopCurrency(currency) : "COINS";
    // Derive reward_type from currency when not explicitly provided.
    let rt = reward_type;
    if (rt == null) {
        if (c === "RUBIES") rt = "rubies";
        else if (c === "COINS") rt = "coins";
    }
    const streak = daily_bonus_streak_current != null && !Number.isNaN(Number(daily_bonus_streak_current)) ? Number(daily_bonus_streak_current) : undefined;
    pushEvent("spin_complete", stripNilFields({
        reward_amount: n,
        currency: c,
        reward_type: rt,
        spin_result: spin_result != null && String(spin_result).trim() !== "" ? String(spin_result) : undefined,
        daily_bonus_streak_current: streak
    }), traderPushContext(user_id, pathname));
}
function trackWheelTriviaComplete({ user_id, reward_amount, currency, pathname }) {
    const n = reward_amount != null && !Number.isNaN(Number(reward_amount)) ? Number(reward_amount) : undefined;
    const c = currency != null && String(currency).trim() !== "" ? normalizeShopCurrency(currency) : "COINS";
    pushEvent("wheel_trivia_complete", stripNilFields({
        reward_amount: n,
        currency: c
    }), traderPushContext(user_id, pathname));
}
function trackQuickfireComplete({ user_id, reward_amount, currency, questions_answered, questions_total, questions_correct, questions_incorrect, pathname }) {
    const n = reward_amount != null && !Number.isNaN(Number(reward_amount)) ? Number(reward_amount) : undefined;
    const c = currency != null && String(currency).trim() !== "" ? normalizeShopCurrency(currency) : "COINS";
    const answered = questions_answered != null && !Number.isNaN(Number(questions_answered)) ? Number(questions_answered) : undefined;
    const total = questions_total != null && !Number.isNaN(Number(questions_total)) ? Number(questions_total) : undefined;
    const correct = questions_correct != null && !Number.isNaN(Number(questions_correct)) ? Number(questions_correct) : undefined;
    const incorrect = questions_incorrect != null && !Number.isNaN(Number(questions_incorrect)) ? Number(questions_incorrect) : undefined;
    let session_complete;
    if (answered !== undefined && total !== undefined && total > 0) session_complete = answered >= total;
    pushEvent("quickfire_complete", stripNilFields({
        reward_amount: n,
        currency: c,
        questions_answered: answered,
        questions_total: total,
        questions_correct: correct,
        questions_incorrect: incorrect,
        session_complete
    }), traderPushContext(user_id, pathname));
}
function trackTraderSportSelected({ user_id, sport, pathname }) {
    const normalized = normalizeTraderSport(sport);
    persistLastSport(normalized);
    pushEvent("sport_selected", {
        sport: normalized
    }, traderPushContext(user_id, pathname));
}
function trackTraderLeagueSelected({ user_id, sport, competition_name, pathname }) {
    pushEvent("league_selected", stripNilFields({
        sport: normalizeTraderSport(sport),
        competition_name: competition_name != null ? String(competition_name) : undefined
    }), traderPushContext(user_id, pathname));
}
function trackTraderMatchSelected({ user_id, fixture_id, sport, competition_name, entry_point, game_type = "trader", pathname }) {
    const gt = normalizeGameType(game_type) || "trader";
    if (entry_point) persistGameEntryPoint({
        entry_point,
        fixture_id,
        game_type: gt
    });
    const resolvedEntryPoint = withResolvedEntryPoint(entry_point, {
        fixture_id,
        game_type: gt
    });
    pushEvent("match_selected", stripNilFields({
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_type: gt,
        sport: normalizeTraderSport(sport),
        competition_name: competition_name != null && String(competition_name) !== "" ? String(competition_name) : undefined,
        entry_point: resolvedEntryPoint
    }), traderPushContext(user_id, pathname));
}
function trackSquaresMatchSelected({ user_id, fixture_id, competition_name, entry_point, pathname }) {
    trackTraderMatchSelected({
        user_id,
        fixture_id,
        sport: "cricket",
        competition_name,
        entry_point,
        game_type: "squares",
        pathname
    });
}
function trackBullionMatchSelected({ user_id, fixture_id, competition_name, entry_point, pathname }) {
    trackTraderMatchSelected({
        user_id,
        fixture_id,
        sport: "cricket",
        competition_name,
        entry_point,
        game_type: "bullion",
        pathname
    });
}
function trackSixesMatchSelected({ user_id, fixture_id, competition_name, entry_point, pathname }) {
    trackTraderMatchSelected({
        user_id,
        fixture_id,
        sport: "cricket",
        competition_name,
        entry_point,
        game_type: "sixes",
        pathname
    });
}
function trackPlayWithFriendClicked({ user_id, cta_name, cta_location, fixture_id, game_type, visibility, pathname }) {
    const loggedIn = user_id != null && user_id !== "";
    pushEvent("play_with_friend_clicked", stripNilFields({
        cta_name: cta_name != null && String(cta_name) !== "" ? String(cta_name) : undefined,
        cta_location: cta_location != null && String(cta_location) !== "" ? String(cta_location) : undefined,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_type: game_type != null && String(game_type).trim() !== "" ? String(game_type).trim().toLowerCase() : undefined,
        visibility: visibility === "private" || visibility === "public" ? visibility : undefined
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/squares"),
        userStatus: loggedIn ? "logged_in" : "guest",
        userId: loggedIn ? user_id : undefined
    });
}
function trackGameStarted({ user_id, fixture_id, game_type, sport, competition_name, is_multiplayer, players_count, entry_point, pathname, play_mode, league_id }) {
    const gt = normalizeGameType(game_type);
    // Squares / Bullion / Sixes are cricket-only products.
    const resolvedSport = gt === "squares" || gt === "bullion" || gt === "sixes" ? "cricket" : normalizeTraderSport(sport);
    const resolvedEntry = withResolvedEntryPoint(entry_point, {
        fixture_id,
        game_type: gt,
        pathname
    }, {
        fallback: true
    });
    // Remember for later funnel steps in this match (stake / prediction).
    if (resolvedEntry) persistGameEntryPoint({
        entry_point: resolvedEntry,
        fixture_id,
        game_type: gt
    });
    pushEvent("game_started", withLeaguePlayMode(stripNilFields({
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_type: gt,
        sport: resolvedSport,
        competition_name: competition_name != null && String(competition_name) !== "" ? String(competition_name) : undefined,
        is_multiplayer: typeof is_multiplayer === "boolean" ? is_multiplayer : undefined,
        players_count: players_count != null && !Number.isNaN(Number(players_count)) ? Number(players_count) : undefined,
        entry_point: resolvedEntry
    }), {
        play_mode,
        league_id
    }), traderPushContext(user_id, pathname));
}
function trackTraderGameEntryClicked({ user_id, fixture_id, game_type, sport, entry_point, pathname }) {
    const gt = normalizeGameType(game_type) || "trader";
    if (entry_point) persistGameEntryPoint({
        entry_point,
        fixture_id,
        game_type: gt
    });
    const resolvedSport = gt === "squares" || gt === "bullion" || gt === "sixes" ? "cricket" : normalizeTraderSport(sport);
    pushEvent("game_entry_clicked", stripNilFields({
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_type: gt,
        sport: resolvedSport,
        entry_point: withResolvedEntryPoint(entry_point, {
            fixture_id,
            game_type: gt,
            pathname
        }, {
            fallback: true
        })
    }), traderPushContext(user_id, pathname));
}
function trackGameLobbyView({ user_id, fixture_id, game_type, sport, competition_name, entry_point, source_page, match_status, available_match_count, not_open_match_count, in_play_match_count, pathname }) {
    const count = (v)=>v != null && !Number.isNaN(Number(v)) ? Number(v) : undefined;
    const gt = normalizeGameType(game_type);
    const resolvedEntry = entry_point != null && String(entry_point) !== "" ? String(entry_point) : withResolvedEntryPoint(undefined, {
        fixture_id,
        game_type: gt,
        pathname
    }, {
        fallback: true
    });
    // Lobby view seeds session so match play / submit can attribute without a card click.
    if (resolvedEntry && gt) persistGameEntryPoint({
        entry_point: resolvedEntry,
        fixture_id: fixture_id ?? null,
        game_type: gt
    });
    // Squares / Bullion / Sixes are cricket-only — never emit unknown/missing sport.
    const resolvedSport = gt === "squares" || gt === "bullion" || gt === "sixes" ? "cricket" : normalizeTraderSport(sport);
    pushEvent("game_lobby_view", stripNilFields({
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_type: gt,
        sport: resolvedSport,
        competition_name: competition_name != null && String(competition_name) !== "" ? String(competition_name) : undefined,
        entry_point: resolvedEntry,
        source_page: source_page != null && String(source_page) !== "" ? String(source_page) : undefined,
        match_status: match_status != null && String(match_status).trim() !== "" ? String(match_status).trim().toLowerCase() : undefined,
        available_match_count: count(available_match_count),
        not_open_match_count: count(not_open_match_count),
        in_play_match_count: count(in_play_match_count)
    }), traderPushContext(user_id, pathname));
}
function trackTraderGameLobbyView(params) {
    return trackGameLobbyView({
        ...params,
        game_type: params?.game_type ?? "trader"
    });
}
function trackTraderMarketGroupSelected({ user_id, sport, market_group, previous_market_group, fixture_id, competition_name, entry_point, pathname }) {
    pushEvent("market_group_selected", stripNilFields({
        game_type: "trader",
        sport: normalizeTraderSport(sport),
        market_group: market_group != null ? String(market_group) : undefined,
        previous_market_group: previous_market_group != null ? String(previous_market_group) : undefined,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        competition_name: competition_name != null && String(competition_name) !== "" ? String(competition_name) : undefined,
        entry_point: withResolvedEntryPoint(entry_point, {
            fixture_id,
            game_type: "trader",
            pathname
        }, {
            fallback: true
        })
    }), traderPushContext(user_id, pathname));
}
function trackTraderOutcomeSelected({ user_id, sport, market_name, selection_value, odds, competition_name, fixture_id, is_multiplayer, players_count, market_group, market_status, odds_available, entry_point, pathname }) {
    const o = odds != null && !Number.isNaN(Number(odds)) ? Number(odds) : undefined;
    const pc = players_count != null && !Number.isNaN(Number(players_count)) ? Number(players_count) : undefined;
    pushEvent("outcome_selected", stripNilFields({
        game_type: "trader",
        sport: normalizeTraderSport(sport),
        market_name: market_name != null ? String(market_name) : undefined,
        selection_value: selection_value != null ? String(selection_value) : undefined,
        odds: o,
        competition_name: competition_name != null && String(competition_name) !== "" ? String(competition_name) : undefined,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        is_multiplayer: typeof is_multiplayer === "boolean" ? is_multiplayer : undefined,
        players_count: pc,
        market_group: market_group != null && String(market_group) !== "" ? String(market_group) : undefined,
        market_status: market_status != null && String(market_status).trim() !== "" ? String(market_status).trim().toLowerCase() : undefined,
        odds_available: typeof odds_available === "boolean" ? odds_available : undefined,
        entry_point: withResolvedEntryPoint(entry_point, {
            fixture_id,
            game_type: "trader",
            pathname
        }, {
            fallback: true
        })
    }), traderPushContext(user_id, pathname));
}
function trackTraderStakeSelected({ user_id, sport, stake_amount, currency, competition_name, fixture_id, is_multiplayer, players_count, stake_source, entry_point, pathname }) {
    const n = stake_amount != null && !Number.isNaN(Number(stake_amount)) ? Number(stake_amount) : undefined;
    const pc = players_count != null && !Number.isNaN(Number(players_count)) ? Number(players_count) : undefined;
    pushEvent("stake_selected", stripNilFields({
        game_type: "trader",
        sport: normalizeTraderSport(sport),
        stake_amount: n,
        currency: currency != null ? normalizeShopCurrency(currency) : "COINS",
        competition_name: competition_name != null && String(competition_name) !== "" ? String(competition_name) : undefined,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        is_multiplayer: typeof is_multiplayer === "boolean" ? is_multiplayer : undefined,
        players_count: pc,
        stake_source: stake_source != null && String(stake_source).trim() !== "" ? String(stake_source).trim().toLowerCase() : undefined,
        entry_point: withResolvedEntryPoint(entry_point, {
            fixture_id,
            game_type: "trader",
            pathname
        }, {
            fallback: true
        })
    }), traderPushContext(user_id, pathname));
}
function trackTraderPredictionSubmitted({ user_id, sport, stake_amount, odds, prediction_id, market_name, selection_value, competition_name, fixture_id, is_multiplayer, players_count, entry_point, pathname, play_mode, league_id }) {
    const stake = stake_amount != null && !Number.isNaN(Number(stake_amount)) ? Number(stake_amount) : undefined;
    const o = odds != null && !Number.isNaN(Number(odds)) ? Number(odds) : undefined;
    const pc = players_count != null && !Number.isNaN(Number(players_count)) ? Number(players_count) : undefined;
    pushEvent("prediction_submitted", withLeaguePlayMode(stripNilFields({
        game_type: "trader",
        submission_type: "trader_prediction",
        sport: sport != null && String(sport).trim() !== "" ? normalizeTraderSport(sport) : undefined,
        stake_amount: stake,
        odds: o,
        prediction_id: prediction_id != null && String(prediction_id).trim() !== "" ? String(prediction_id) : undefined,
        market_name: market_name != null ? String(market_name) : undefined,
        selection_value: selection_value != null ? String(selection_value) : undefined,
        competition_name: competition_name != null && String(competition_name) !== "" ? String(competition_name) : undefined,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        is_multiplayer: typeof is_multiplayer === "boolean" ? is_multiplayer : undefined,
        players_count: pc,
        entry_point: withResolvedEntryPoint(entry_point, {
            fixture_id,
            game_type: "trader",
            pathname
        }, {
            fallback: true
        })
    }), {
        play_mode,
        league_id
    }), traderPushContext(user_id, pathname));
}
function trackSquaresPredictionSubmitted({ user_id, fixture_id, competition_name, prediction_id, stake_amount, is_multiplayer, players_count, entry_point, pathname, play_mode, league_id }) {
    pushEvent("prediction_submitted", withLeaguePlayMode(stripNilFields({
        game_type: "squares",
        submission_type: "squares_prediction",
        sport: "cricket",
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        competition_name: asStr(competition_name),
        prediction_id: prediction_id != null && String(prediction_id).trim() !== "" ? String(prediction_id) : undefined,
        stake_amount: asNum(stake_amount),
        is_multiplayer: asBool(is_multiplayer),
        players_count: asNum(players_count),
        entry_point: withResolvedEntryPoint(entry_point, {
            fixture_id,
            game_type: "squares",
            pathname
        }, {
            fallback: true
        })
    }), {
        play_mode,
        league_id
    }), traderPushContext(user_id, pathname));
}
function trackPredictionCancelled({ user_id, game_type, sport, fixture_id, competition_name, last_step, market_name, selection_value, stake_amount, pathname }) {
    const stake = stake_amount != null && !Number.isNaN(Number(stake_amount)) ? Number(stake_amount) : undefined;
    const step = last_step === "outcome" || last_step === "stake" || last_step === "none" ? last_step : undefined;
    pushEvent("prediction_cancelled", stripNilFields({
        game_type: game_type != null && String(game_type) !== "" ? String(game_type) : undefined,
        sport: sport != null ? normalizeTraderSport(sport) : undefined,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        competition_name: competition_name != null && String(competition_name) !== "" ? String(competition_name) : undefined,
        last_step: step,
        market_name: market_name != null && String(market_name) !== "" ? String(market_name) : undefined,
        selection_value: selection_value != null && String(selection_value) !== "" ? String(selection_value) : undefined,
        stake_amount: stake
    }), traderPushContext(user_id, pathname));
}
// --- New game modes: Bullion & Sixes (GTM / GA4 custom events) ---
function asNum(v) {
    return v != null && !Number.isNaN(Number(v)) ? Number(v) : undefined;
}
function asStr(v) {
    return v != null && String(v) !== "" ? String(v) : undefined;
}
function asLowerStr(v) {
    return v != null && String(v).trim() !== "" ? String(v).trim().toLowerCase() : undefined;
}
function asBool(v) {
    return typeof v === "boolean" ? v : undefined;
}
function trackGameInteraction({ user_id, interaction_type, interaction_value, game_type, fixture_id, game_id, sport, competition_name, is_multiplayer, players_count, pathname }) {
    pushEvent("game_interaction", stripNilFields({
        interaction_type: asStr(interaction_type),
        interaction_value: asStr(interaction_value),
        game_type: asStr(game_type),
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_id: game_id != null ? String(game_id) : undefined,
        sport: asLowerStr(sport),
        competition_name: asStr(competition_name),
        is_multiplayer: asBool(is_multiplayer),
        players_count: asNum(players_count)
    }), traderPushContext(user_id, pathname));
}
function trackBullionEntrySubmitted({ user_id, sport, fixture_id, game_id, competition_name, entry_stake, is_multiplayer, players_count, visibility, is_update, entry_point, pathname, play_mode, league_id }) {
    const vis = visibility === "public" || visibility === "private" ? visibility : undefined;
    pushEvent("prediction_submitted", withLeaguePlayMode(stripNilFields({
        game_type: "bullion",
        submission_type: "bullion_entry",
        sport: "cricket",
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_id: game_id != null ? String(game_id) : undefined,
        competition_name: asStr(competition_name),
        entry_stake: asNum(entry_stake),
        is_multiplayer: asBool(is_multiplayer),
        players_count: asNum(players_count),
        visibility: vis,
        is_update: asBool(is_update),
        entry_point: withResolvedEntryPoint(entry_point, {
            fixture_id,
            game_type: "bullion",
            pathname
        }, {
            fallback: true
        })
    }), {
        play_mode,
        league_id
    }), traderPushContext(user_id, pathname));
}
function trackSixesCardRevealed({ user_id, fixture_id, competition_name, sport, sixes_card_id, sixes_match_id, sixes_competition, sixes_sport, sixes_total_cells, sixes_card_date, pathname }) {
    pushEvent("sixes_card_revealed", stripNilFields({
        game_type: "sixes",
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        competition_name: asStr(competition_name),
        sport: asLowerStr(sport),
        sixes_card_id: sixes_card_id != null ? String(sixes_card_id) : undefined,
        sixes_match_id: sixes_match_id != null ? String(sixes_match_id) : undefined,
        sixes_competition: asStr(sixes_competition),
        sixes_sport: asLowerStr(sixes_sport),
        sixes_total_cells: asNum(sixes_total_cells),
        sixes_card_date: asStr(sixes_card_date)
    }), traderPushContext(user_id, pathname));
}
function trackSixesMultiplierSelected({ user_id, fixture_id, competition_name, sport, sixes_card_id, sixes_multiplier_selection_type, sixes_multiplier_player_name, sixes_multiplier_team_name, sixes_multiplier_market_id, ruby_cost, ruby_balance_before, ruby_balance_after, pathname }) {
    const selType = sixes_multiplier_selection_type === "assigned" || sixes_multiplier_selection_type === "switched" ? sixes_multiplier_selection_type : undefined;
    pushEvent("sixes_multiplier_selected", stripNilFields({
        game_type: "sixes",
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        competition_name: asStr(competition_name),
        sport: asLowerStr(sport),
        sixes_card_id: sixes_card_id != null ? String(sixes_card_id) : undefined,
        sixes_multiplier_selection_type: selType,
        sixes_multiplier_player_name: asStr(sixes_multiplier_player_name),
        sixes_multiplier_team_name: asStr(sixes_multiplier_team_name),
        sixes_multiplier_market_id: asStr(sixes_multiplier_market_id),
        ruby_cost: asNum(ruby_cost),
        ruby_balance_before: asNum(ruby_balance_before),
        ruby_balance_after: asNum(ruby_balance_after)
    }), traderPushContext(user_id, pathname));
}
function trackSixesCardSubmitted({ user_id, fixture_id, competition_name, sport, is_multiplayer, players_count, sixes_card_id, sixes_match_id, sixes_competition, sixes_sport, sixes_multiplier_selected, sixes_multiplier_selection_type, sixes_multiplier_player_name, sixes_total_cells, sixes_card_date, entry_point, pathname, play_mode, league_id }) {
    const selType = sixes_multiplier_selection_type === "assigned" || sixes_multiplier_selection_type === "switched" ? sixes_multiplier_selection_type : undefined;
    pushEvent("prediction_submitted", withLeaguePlayMode(stripNilFields({
        game_type: "sixes",
        submission_type: "sixes_card",
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        competition_name: asStr(competition_name),
        sport: "cricket",
        is_multiplayer: asBool(is_multiplayer),
        players_count: asNum(players_count),
        sixes_card_id: sixes_card_id != null ? String(sixes_card_id) : undefined,
        sixes_match_id: sixes_match_id != null ? String(sixes_match_id) : undefined,
        sixes_competition: asStr(sixes_competition),
        sixes_sport: asLowerStr(sixes_sport) ?? "cricket",
        sixes_multiplier_selected: asBool(sixes_multiplier_selected),
        sixes_multiplier_selection_type: selType,
        sixes_multiplier_player_name: asStr(sixes_multiplier_player_name),
        sixes_total_cells: asNum(sixes_total_cells),
        sixes_card_date: asStr(sixes_card_date),
        entry_point: withResolvedEntryPoint(entry_point, {
            fixture_id,
            game_type: "sixes",
            pathname
        }, {
            fallback: true
        })
    }), {
        play_mode,
        league_id
    }), traderPushContext(user_id, pathname));
}
function trackSixesCardSettled({ user_id, fixture_id, competition_name, sport, sixes_card_id, sixes_total_coins_earned, sixes_wins_count, sixes_sets_count, sixes_settled_cells, sixes_total_cells, sixes_multiplier_sixes, sixes_outcome, pathname }) {
    const outcome = sixes_outcome === "settled" || sixes_outcome === "cancelled" ? sixes_outcome : undefined;
    pushEvent("sixes_card_settled", stripNilFields({
        game_type: "sixes",
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        competition_name: asStr(competition_name),
        sport: asLowerStr(sport),
        sixes_card_id: sixes_card_id != null ? String(sixes_card_id) : undefined,
        sixes_total_coins_earned: asNum(sixes_total_coins_earned),
        sixes_wins_count: asNum(sixes_wins_count),
        sixes_sets_count: asNum(sixes_sets_count),
        sixes_settled_cells: asNum(sixes_settled_cells),
        sixes_total_cells: asNum(sixes_total_cells),
        sixes_multiplier_sixes: asNum(sixes_multiplier_sixes),
        sixes_outcome: outcome
    }), traderPushContext(user_id, pathname));
}
function trackSixesBoardViewed({ user_id, fixture_id, competition_name, sport, sixes_match_id, sixes_board_complete, sixes_card_id, sixes_card_status, sixes_settled_cells, pathname }) {
    const status = sixes_card_status === "active" || sixes_card_status === "settled" || sixes_card_status === "cancelled" ? sixes_card_status : undefined;
    pushEvent("sixes_board_viewed", stripNilFields({
        game_type: "sixes",
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        competition_name: asStr(competition_name),
        sport: asLowerStr(sport),
        sixes_match_id: sixes_match_id != null ? String(sixes_match_id) : undefined,
        sixes_board_complete: asBool(sixes_board_complete),
        sixes_card_id: sixes_card_id != null ? String(sixes_card_id) : undefined,
        sixes_card_status: status,
        sixes_settled_cells: asNum(sixes_settled_cells)
    }), traderPushContext(user_id, pathname));
}
function trackInviteFlowOpened({ user_id, entry_point, fixture_id, game_type, visibility, pathname }) {
    const loggedIn = user_id != null && user_id !== "";
    pushEvent("invite_flow_opened", stripNilFields({
        entry_point: entry_point != null && String(entry_point) !== "" ? String(entry_point) : undefined,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_type: game_type != null && String(game_type).trim() !== "" ? String(game_type).trim().toLowerCase() : undefined,
        visibility: visibility === "private" || visibility === "public" ? visibility : undefined
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/"),
        userStatus: loggedIn ? "logged_in" : "guest",
        userId: loggedIn ? user_id : undefined
    });
}
function trackProfileLinkShared({ user_id, invite_method, sender_user_id, pathname }) {
    pushEvent("profile_link_shared", stripNilFields({
        invite_method: invite_method === "share_sheet" ? "share_sheet" : invite_method === "link" ? "link" : invite_method != null && String(invite_method).trim() !== "" ? String(invite_method).trim().toLowerCase() : "link",
        sender_user_id: sender_user_id != null && String(sender_user_id).trim() !== "" ? String(sender_user_id).trim() : undefined
    }), traderPushContext(user_id, pathname));
}
function trackProfileLinkJoined({ user_id, sender_user_id, invite_method, pathname }) {
    pushEvent("profile_link_joined", stripNilFields({
        sender_user_id: sender_user_id != null && String(sender_user_id).trim() !== "" ? String(sender_user_id).trim() : undefined,
        invite_method: invite_method != null && String(invite_method).trim() !== "" ? String(invite_method).trim().toLowerCase() : "link"
    }), traderPushContext(user_id, pathname));
}
function trackFriendInviteSent({ user_id, invite_method, fixture_id, game_type, visibility, pathname }) {
    const loggedIn = user_id != null && user_id !== "";
    pushEvent("friend_invite_sent", stripNilFields({
        invite_method: invite_method != null && String(invite_method) !== "" ? String(invite_method) : undefined,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_type: game_type != null && String(game_type).trim() !== "" ? String(game_type).trim().toLowerCase() : undefined,
        visibility: visibility === "private" || visibility === "public" ? visibility : undefined
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/"),
        userStatus: loggedIn ? "logged_in" : "guest",
        userId: loggedIn ? user_id : undefined
    });
}
function trackFriendRequestSent({ user_id, sender_user_id, receiver_user_id, pathname }) {
    pushEvent("friend_request_sent", stripNilFields({
        sender_user_id: sender_user_id != null ? String(sender_user_id) : undefined,
        receiver_user_id: receiver_user_id != null ? String(receiver_user_id) : undefined
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/profile"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackFriendRequestCancelled({ user_id, sender_user_id, receiver_user_id, pathname }) {
    pushEvent("friend_request_cancelled", stripNilFields({
        sender_user_id: sender_user_id != null ? String(sender_user_id) : undefined,
        receiver_user_id: receiver_user_id != null ? String(receiver_user_id) : undefined
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/profile"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackInviteLinkClicked({ user_id, invite_method, fixture_id, game_type, visibility, pathname }) {
    pushEvent("invite_link_clicked", stripNilFields({
        invite_method: invite_method != null && String(invite_method).trim() !== "" ? String(invite_method).trim().toLowerCase() : "link",
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_type: game_type != null && String(game_type).trim() !== "" ? String(game_type).trim().toLowerCase() : undefined,
        visibility: visibility === "private" ? "private" : visibility === "public" ? "public" : undefined
    }), traderPushContext(user_id, pathname));
}
function trackFriendJoinedFromInvite({ user_id, invite_method, fixture_id, game_type, visibility, entry_point, pathname }) {
    pushEvent("friend_joined_from_invite", stripNilFields({
        invite_method: invite_method != null && String(invite_method) !== "" ? String(invite_method) : undefined,
        fixture_id: fixture_id != null ? String(fixture_id) : undefined,
        game_type: game_type != null && String(game_type) !== "" ? String(game_type) : undefined,
        visibility: visibility === "private" || visibility === "public" ? visibility : undefined,
        entry_point: entry_point != null && String(entry_point) !== "" ? String(entry_point) : undefined
    }), traderPushContext(user_id, pathname));
}
function trackFriendRequestResponse({ user_id, response, friend_request_sender_user_id, friend_request_receiver_user_id, pathname }) {
    const r = response === "accepted" || response === "rejected" ? response : response != null && String(response) !== "" ? String(response) : undefined;
    pushEvent("friend_request_response", stripNilFields({
        response: r,
        friend_request_sender_user_id: friend_request_sender_user_id != null ? String(friend_request_sender_user_id) : undefined,
        friend_request_receiver_user_id: friend_request_receiver_user_id != null ? String(friend_request_receiver_user_id) : undefined
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/my-zone"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackGameChallengeFlowOpened({ user_id, game_type, entry_point, pathname }) {
    const gt = game_type != null && String(game_type).trim() !== "" ? String(game_type).trim().toLowerCase() : undefined;
    pushEvent("game_challenge_flow_opened", stripNilFields({
        game_type: gt,
        entry_point: entry_point != null && String(entry_point) !== "" ? String(entry_point) : undefined
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/my-zone"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackChallengeFriendClicked({ user_id, cta_location, pathname }) {
    const path = pathname || (typeof window !== "undefined" ? window.location.pathname : "/my-zone");
    trackCtaClicked({
        user_id,
        cta_name: "challenge_friend",
        cta_location: cta_location != null && String(cta_location).trim() !== "" ? String(cta_location).trim() : "my_zone_friends",
        pathname: path,
        source_page: path
    });
}
const CTA_NAME_INVITE_FRIENDS = "invite_friends";
const LEAGUE_INVITE_CTA_LOCATION = Object.freeze({
    HEADER: "league_header",
    DOCK: "league_dock",
    TUTORIAL: "league_tutorial"
});
function trackLeagueInviteFriendsClicked({ user_id, cta_location, fixture_id, pathname }) {
    trackCtaClicked({
        user_id,
        cta_name: CTA_NAME_INVITE_FRIENDS,
        cta_location,
        fixture_id,
        source_page: pathname,
        pathname
    });
}
const LEAGUE_RESULTS_SHARE_CTA_NAME = Object.freeze({
    /** Podium SHARE buttons — open the share modal. */ OPEN: "share_league_results",
    /** Modal primary button (native share sheet, or copy where unsupported). */ SHARE: "share_league_results_send",
    /** Modal secondary COPY LINK button. */ COPY_LINK: "copy_league_results_link"
});
const LEAGUE_RESULTS_SHARE_CTA_LOCATION = Object.freeze({
    /** SHARE pill next to "League finished!". */ HEADER: "league_finished_header",
    /** Icon button on the "You finished …" row under the podium. */ FINISH_ROW: "league_finished_you_row",
    MODAL: "league_results_share_modal"
});
function trackLeagueResultsShareClicked({ user_id, cta_name, cta_location, target_url, pathname }) {
    const path = pathname || (typeof window !== "undefined" ? window.location.pathname : "/leagues");
    trackCtaClicked({
        user_id,
        cta_name,
        cta_location,
        target_url,
        pathname: path,
        source_page: path
    });
}
function trackChallengeGameSelected({ user_id, game_type, cta_location, pathname }) {
    const gt = game_type != null && String(game_type).trim() !== "" ? String(game_type).trim().toLowerCase() : "";
    const path = pathname || (typeof window !== "undefined" ? window.location.pathname : "/my-zone");
    const cta_name = gt === "bullion" ? "challenge_select_bullion" : gt === "leagues" ? "challenge_select_leagues" : "challenge_select_squares";
    trackCtaClicked({
        user_id,
        cta_name,
        cta_location: cta_location != null && String(cta_location).trim() !== "" ? String(cta_location).trim() : "my_zone_friends",
        pathname: path,
        source_page: path
    });
}
function trackGameChallengeSent({ user_id, game_type, entry_point, challenged_friend_user_id, challenge_target_id, pathname }) {
    const gt = game_type != null && String(game_type).trim() !== "" ? String(game_type).trim().toLowerCase() : undefined;
    pushEvent("game_challenge_sent", stripNilFields({
        game_type: gt,
        entry_point: entry_point != null && String(entry_point) !== "" ? String(entry_point) : undefined,
        challenged_friend_user_id: challenged_friend_user_id != null ? String(challenged_friend_user_id) : undefined,
        challenge_target_id: challenge_target_id != null && String(challenge_target_id).trim() !== "" ? String(challenge_target_id).trim() : undefined
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/my-zone"),
        userStatus: "logged_in",
        userId: user_id
    });
}
const CTA_NAME_SPIN_THE_WHEEL = "spin_the_wheel";
const SPIN_THE_WHEEL_CTA_LOCATION = {
    BURGER_MENU: "burger_menu",
    FOOTER: "footer",
    CORNER: "daily_free_coins_corner",
    GAMES_HOME_HEADLINE: "games_home_headline",
    MY_GAMES: "my_games"
};
function trackSpinTheWheelCtaClicked({ user_id, cta_location, pathname, source_page }) {
    trackCtaClicked({
        user_id,
        cta_name: CTA_NAME_SPIN_THE_WHEEL,
        cta_location,
        pathname,
        source_page: source_page ?? pathname ?? (typeof window !== "undefined" ? window.location.pathname : undefined)
    });
}
function trackCtaClicked({ user_id, cta_name, cta_location, target_url, source_page, pathname, userStatus, fixture_id }) {
    const loggedIn = user_id != null && user_id !== "";
    pushEvent("cta_clicked", {
        ...(0, _utmTracking.getSessionUtmPayloadWithNulls)(),
        ...stripNilFields({
            cta_name: cta_name != null && String(cta_name) !== "" ? String(cta_name) : undefined,
            cta_location: cta_location != null && String(cta_location) !== "" ? String(cta_location) : undefined,
            target_url: target_url != null && String(target_url) !== "" ? String(target_url) : undefined,
            source_page: source_page != null && String(source_page) !== "" ? String(source_page) : undefined,
            fixture_id: fixture_id != null && String(fixture_id).trim() !== "" ? String(fixture_id).trim() : undefined
        })
    }, {
        pathname,
        userStatus: userStatus || (loggedIn ? "logged_in" : "guest"),
        userId: loggedIn ? user_id : undefined
    });
}
function trackOpenMatchDetailClicked({ user_id, cta_location, fixture_id, target_url, pathname }) {
    const path = pathname || (typeof window !== "undefined" ? window.location.pathname : undefined);
    trackCtaClicked({
        user_id,
        cta_name: "open_match_detail",
        cta_location,
        fixture_id,
        target_url,
        pathname: path,
        source_page: path
    });
}
function trackWatchLiveClicked({ user_id, cta_location, fixture_id, pathname }) {
    const path = pathname || (typeof window !== "undefined" ? window.location.pathname : undefined);
    trackCtaClicked({
        user_id,
        cta_name: "watch_live",
        cta_location,
        fixture_id,
        pathname: path,
        source_page: path
    });
}
function trackMatchCardGameCtaClicked({ user_id, game_type, target_url, cta_location, pathname, source_page }) {
    const ctaByGame = {
        trader: "open_trader",
        squares: "open_squares",
        bullion: "open_bullion",
        sixes: "open_sixes"
    };
    const cta_name = ctaByGame[game_type];
    if (!cta_name) return;
    trackCtaClicked({
        user_id,
        cta_name,
        cta_location,
        target_url,
        source_page: source_page ?? pathname,
        pathname
    });
}
function trackMatchCardGameEntry({ user_id, game_type, fixture_id, sport, competition_name, cta_location, target_url, pathname, source_page }) {
    const entry_point = entryPointFromCtaLocation(cta_location);
    const path = pathname || (typeof window !== "undefined" ? window.location.pathname : undefined);
    const source = source_page ?? path;
    if (game_type === "trader") trackTraderMatchSelected({
        user_id,
        fixture_id,
        sport,
        competition_name,
        entry_point,
        pathname: path
    });
    else if (game_type === "squares") trackSquaresMatchSelected({
        user_id,
        fixture_id,
        competition_name,
        entry_point,
        pathname: path
    });
    else if (game_type === "bullion") trackBullionMatchSelected({
        user_id,
        fixture_id,
        competition_name,
        entry_point,
        pathname: path
    });
    else if (game_type === "sixes") trackSixesMatchSelected({
        user_id,
        fixture_id,
        competition_name,
        entry_point,
        pathname: path
    });
    trackTraderGameEntryClicked({
        user_id,
        fixture_id,
        game_type,
        sport: game_type === "trader" ? sport : "cricket",
        entry_point,
        pathname: path
    });
    trackMatchCardGameCtaClicked({
        user_id,
        game_type,
        target_url,
        cta_location,
        pathname: path,
        source_page: source
    });
}
/** Short codes so `updated_fields` stays under GA4's 100-char parameter limit. */ const PROFILE_UPDATED_FIELD_CODES = {
    country: "c",
    favorite_sports: "fs",
    favorite_cricket_players: "fcp",
    favorite_cricket_teams: "fct",
    favorite_football_teams: "fft",
    avatar_id: "a",
    username: "u",
    player_name: "pn"
};
function compactProfileUpdatedFields(updated_fields) {
    const list = Array.isArray(updated_fields) ? updated_fields : updated_fields != null && String(updated_fields) !== "" ? String(updated_fields).split(",") : [];
    const codes = list.map((f)=>String(f || "").trim()).filter(Boolean).map((f)=>PROFILE_UPDATED_FIELD_CODES[f] || f);
    if (codes.length === 0) return undefined;
    return codes.join(",");
}
function trackProfileUpdated({ user_id, updated_fields, country, favorite_sports_count, favorite_cricket_players_count, favorite_teams_count, pathname }) {
    const count = (v)=>v != null && !Number.isNaN(Number(v)) ? Number(v) : undefined;
    const fields = compactProfileUpdatedFields(updated_fields);
    if (!fields) return;
    // Soft client dedupe: identical field set within 5s (retry / remount).
    if (typeof window !== "undefined" && user_id != null) try {
        const dedupeKey = `c8_profile_updated:${user_id}:${fields}`;
        const prev = sessionStorage.getItem(dedupeKey);
        const now = Date.now();
        if (prev && now - Number(prev) < 5000) return;
        sessionStorage.setItem(dedupeKey, String(now));
    } catch (_) {
    /* ignore */ }
    pushEvent("profile_updated", stripNilFields({
        updated_fields: fields,
        country: country != null && String(country).trim() !== "" ? String(country).trim() : undefined,
        favorite_sports_count: count(favorite_sports_count),
        favorite_cricket_players_count: count(favorite_cricket_players_count),
        favorite_teams_count: count(favorite_teams_count)
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/profile"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackUserPreferenceChanged({ user_id, setting_name, settings_group, previous_value, new_value, pathname }) {
    const val = (v)=>{
        if (typeof v === "boolean") return v;
        if (v != null && String(v) !== "") return String(v);
        return undefined;
    };
    pushEvent("user_preference_changed", stripNilFields({
        setting_name: setting_name != null && String(setting_name) !== "" ? String(setting_name) : undefined,
        settings_group: settings_group != null && String(settings_group) !== "" ? String(settings_group) : undefined,
        previous_value: val(previous_value),
        new_value: val(new_value)
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/my-zone"),
        userStatus: "logged_in",
        userId: user_id
    });
}
function trackXpLeaderboardView({ user_id, xp_rank, xp_value, xp_period_id, xp_period_days_remaining, xp_crown, leaderboard_entrant_count, leaderboard_period, leaderboard_scope, source_page, pathname }) {
    const num = (v)=>v != null && !Number.isNaN(Number(v)) ? Number(v) : undefined;
    let resolvedSource = source_page != null && String(source_page).trim() !== "" ? String(source_page).trim() : undefined;
    if (!resolvedSource && typeof document !== "undefined" && document.referrer) try {
        const refUrl = new URL(document.referrer);
        if (typeof window !== "undefined" && refUrl.origin === window.location.origin) resolvedSource = getPageName(refUrl.pathname);
    } catch (_) {
    /* ignore */ }
    pushEvent("xp_leaderboard_view", stripNilFields({
        xp_rank: num(xp_rank),
        xp_value: num(xp_value),
        xp_period_id: num(xp_period_id),
        xp_period_days_remaining: num(xp_period_days_remaining),
        xp_crown: xp_crown != null && String(xp_crown).trim() !== "" ? String(xp_crown).trim().toLowerCase() : undefined,
        leaderboard_entrant_count: num(leaderboard_entrant_count),
        leaderboard_period: leaderboard_period != null && String(leaderboard_period) !== "" ? String(leaderboard_period) : undefined,
        leaderboard_scope: leaderboard_scope != null && String(leaderboard_scope) !== "" ? String(leaderboard_scope) : undefined,
        source_page: resolvedSource
    }), {
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/xp-leaderboard"),
        userStatus: "logged_in",
        userId: user_id
    });
}
/** Best-effort `game_type` from an XP `reason` string (controlled values only). */ function gameTypeFromXpReason(reason) {
    const r = reason != null ? String(reason).toLowerCase() : "";
    if (!r) return undefined;
    if (r.startsWith("wheel_multiplier") || r.startsWith("spin")) return "wheel-spin";
    if (r.startsWith("quickfire")) return "quickfire";
    if (r.startsWith("trader")) return "trader";
    if (r.startsWith("squares")) return "squares";
    if (r.startsWith("bullion")) return "bullion";
    if (r.startsWith("sixes")) return "sixes";
    return undefined;
}
function trackXpEarned({ user_id, xp_amount, xp_reason, xp_total_after, xp_dedupe_key, game_type, pathname }) {
    const amount = asNum(xp_amount);
    if (amount == null || amount <= 0) return;
    const dedupe = asStr(xp_dedupe_key);
    // Persist across Header remounts so the same grant is not double-pushed.
    if (typeof window !== "undefined" && dedupe) try {
        const key = `c8_xp_earned:${dedupe}`;
        if (sessionStorage.getItem(key)) return;
        sessionStorage.setItem(key, "1");
    } catch (_) {
    /* ignore */ }
    pushEvent("xp_earned", stripNilFields({
        xp_amount: amount,
        xp_reason: asStr(xp_reason),
        xp_total_after: asNum(xp_total_after),
        xp_dedupe_key: dedupe,
        game_type: normalizeGameType(game_type) ?? gameTypeFromXpReason(xp_reason)
    }), traderPushContext(user_id, pathname));
}
function trackLoginStreakUpdated({ user_id, login_streak_current, login_streak_is_new_record, xp_earned_from_streak, pathname }) {
    const current = asNum(login_streak_current);
    if (current == null) return;
    pushEvent("login_streak_updated", stripNilFields({
        login_streak_current: current,
        login_streak_is_new_record: asBool(login_streak_is_new_record),
        xp_earned_from_streak: asNum(xp_earned_from_streak)
    }), traderPushContext(user_id, pathname));
}
function trackWheelMultiplierStreakUpdated({ user_id, wheel_multiplier_streak_current, wheel_multiplier_streak_broken, reward_amount, currency, pathname }) {
    const current = asNum(wheel_multiplier_streak_current);
    if (current == null) return;
    pushEvent("wheel_multiplier_streak_updated", stripNilFields({
        wheel_multiplier_streak_current: current,
        wheel_multiplier_streak_broken: asBool(wheel_multiplier_streak_broken),
        reward_amount: asNum(reward_amount),
        currency: asStr(currency)
    }), traderPushContext(user_id, pathname));
}
function trackTraderLeaderboardView({ user_id, leaderboard_sport, trader_leaderboard_day_key, user_daily_rank, user_daily_profit, user_daily_trades_count, pathname }) {
    const num = (v)=>v != null && !Number.isNaN(Number(v)) ? Number(v) : undefined;
    pushEvent("trader_leaderboard_view", stripNilFields({
        leaderboard_sport: leaderboard_sport != null ? normalizeTraderSport(leaderboard_sport) : undefined,
        trader_leaderboard_day_key: trader_leaderboard_day_key != null && String(trader_leaderboard_day_key) !== "" ? String(trader_leaderboard_day_key) : undefined,
        user_daily_rank: num(user_daily_rank),
        user_daily_profit: num(user_daily_profit),
        user_daily_trades_count: num(user_daily_trades_count)
    }), traderPushContext(user_id, pathname));
}

},{"./analyticsConsent":"eiihB","./analyticsEnv":"4mdbs","./gtm":"dO5RN","./utmTracking":"kFyP8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4xtMD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Maps API session/account payloads (`profile_pic` / `original_profile_pic`)
 * to frontend `avatar` / `original_avatar`. Responses may use either shape.
 */ parcelHelpers.export(exports, "normalizeSessionPayload", ()=>normalizeSessionPayload);
/** Match backend `accountSharesOnlinePresence` for JSONB / client state. */ parcelHelpers.export(exports, "allowsOnlinePresenceShare", ()=>allowsOnlinePresenceShare);
/**
 * Own profile “online” dot: only when you allow others to see presence and the session says you’re
 * recently active (`is_online` from API, refreshed after successful presence heartbeats).
 */ parcelHelpers.export(exports, "showOnlineOnOwnProfile", ()=>showOnlineOnOwnProfile);
/** Display URL for any row/object that may expose `avatar`, `avatar_url`, or legacy `profile_pic`. */ parcelHelpers.export(exports, "resolveAvatarUrl", ()=>resolveAvatarUrl);
parcelHelpers.export(exports, "MISSING_AVATAR_PLACEHOLDER_PATH", ()=>MISSING_AVATAR_PLACEHOLDER_PATH);
/** True when the URL is non-empty and not the legacy missing placeholder path. */ parcelHelpers.export(exports, "isUsableAvatarUrl", ()=>isUsableAvatarUrl);
/** Bot S3 catalogue defaults to 64px thumbs; swap to 128px for the profile modal hero. */ parcelHelpers.export(exports, "toProfileHeroAvatarUrl", ()=>toProfileHeroAvatarUrl);
var _favouriteTeams = require("./favouriteTeams");
function normalizeAllowPlayerNameEditFlag(value) {
    if (value === true) return true;
    if (value === 1) return true;
    if (value === "1") return true;
    if (typeof value === "string" && value.trim().toLowerCase() === "true") return true;
    return false;
}
function normalizeSessionPayload(raw) {
    const profilePic = raw['profile_pic'];
    const avatarUrlField = raw['avatar_url'];
    const avatarRaw = raw['avatar'];
    const nonEmpty = (v)=>typeof v === 'string' && String(v).trim() !== '' ? String(v).trim() : '';
    // Same precedence as the backend (`COALESCE(avatar_url, profile_pic)`): a chosen or admin-uploaded
    // avatar beats the sign-in provider photo.
    const avatar = nonEmpty(avatarRaw) || nonEmpty(avatarUrlField) || nonEmpty(profilePic) || '';
    const orig = raw['original_avatar'] ?? raw['original_profile_pic'];
    const original_avatar = typeof orig === 'string' && String(orig).trim() !== '' ? orig : null;
    const allow_player_name_edit = normalizeAllowPlayerNameEditFlag(raw['allow_player_name_edit']);
    const { profile_pic: _pp, original_profile_pic: _opp, ...rest } = raw;
    const normalized = {
        ...rest,
        avatar,
        original_avatar,
        allow_player_name_edit
    };
    // Map legacy favourite keys (favipl/favcricketint/favteams/…) to the current shape.
    if ('favourites' in raw && raw['favourites'] && typeof raw['favourites'] === 'object') normalized.favourites = (0, _favouriteTeams.normalizeFavourites)(raw['favourites']);
    return normalized;
}
function allowsOnlinePresenceShare(activity_share) {
    const a = activity_share && typeof activity_share === "object" ? activity_share : {};
    if (a.online_presence === false) return false;
    if (a.presence === false) return false;
    return true;
}
function coerceOnlineFlag(value) {
    if (value === true || value === 1) return true;
    if (typeof value === "string" && value.trim().toLowerCase() === "true") return true;
    return false;
}
function showOnlineOnOwnProfile(user) {
    if (!allowsOnlinePresenceShare(user.activity_share)) return false;
    return coerceOnlineFlag(user.is_online);
}
function resolveAvatarUrl(source) {
    const u = source?.avatar ?? source?.avatar_url ?? source?.profile_pic;
    return typeof u === 'string' && u.trim() !== '' ? u : null;
}
const MISSING_AVATAR_PLACEHOLDER_PATH = '/img/public/avatar.png';
function isUsableAvatarUrl(url) {
    const u = url == null ? '' : String(url).trim();
    return u !== '' && u !== MISSING_AVATAR_PLACEHOLDER_PATH;
}
function toProfileHeroAvatarUrl(url) {
    const u = url == null ? '' : String(url).trim();
    if (!isUsableAvatarUrl(u)) return '';
    if (u.includes('/avatars/thumbs/64/')) return u.replace('/avatars/thumbs/64/', '/avatars/thumbs/128/');
    return u;
}

},{"./favouriteTeams":"fwQD0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fwQD0":[function(require,module,exports,__globalThis) {
/**
 * Favourite-team helpers shared by the match-card/scoreboard star and the profile.
 *
 * Teams live in three `accounts.favourites` stores that together form one favourite set:
 *   - `faviplteams`           curated IPL picker (slugs)
 *   - `favnationalteams`      curated national picker (slugs)
 *   - `favcustomcricketteams` free-form cricket teams starred from matches (display names)
 *
 * Membership is compared by canonical slug (see {@link cricketTeamCanonical}) so a team
 * favourited in any store fills the star everywhere. Also normalises the legacy key names
 * (`favipl`, `favcricketint`, `favfootball`, `favsport`, `favteams`, `favteam1/2`, `favtour`).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Canonical key for a team name (comparison/dedup). Mirrors backend `slugifyTeamName`. */ parcelHelpers.export(exports, "slugifyTeamName", ()=>slugifyTeamName);
/** Split a stored comma-separated string into trimmed, non-empty entries. */ parcelHelpers.export(exports, "parseCommaList", ()=>parseCommaList);
/** Parse `favcustomcricketteams` into ordered display names, deduped by canonical slug. */ parcelHelpers.export(exports, "parseFavTeamsFromStorage", ()=>parseFavTeamsFromStorage);
parcelHelpers.export(exports, "serializeFavTeamsToStorage", ()=>serializeFavTeamsToStorage);
/**
 * Map any favourites object (legacy or current keys) to the canonical current shape.
 * Legacy single-team fields (`favteam1/2`) and `favteams` fold into `favcustomcricketteams`;
 * `favtour` is dropped.
 */ parcelHelpers.export(exports, "normalizeFavourites", ()=>normalizeFavourites);
/** Union of canonical slugs across all three team stores. */ parcelHelpers.export(exports, "favouriteTeamSlugSet", ()=>favouriteTeamSlugSet);
/** Is this team a favourite in any store (IPL picker / national picker / custom)? */ parcelHelpers.export(exports, "isFavouriteTeam", ()=>isFavouriteTeam);
/**
 * Compute the single-source-of-truth toggle for a team:
 *  - if favourited anywhere, remove it from every store it appears in;
 *  - otherwise add it to its canonical category (IPL / national / custom).
 * Returns the backend ops plus the optimistic next favourites subset.
 */ parcelHelpers.export(exports, "buildFavouriteTeamToggle", ()=>buildFavouriteTeamToggle);
var _cricketTeamLogoUrl = require("./cricketTeamLogoUrl");
var _cricketTeamCanonical = require("./cricketTeamCanonical");
function slugifyTeamName(name) {
    return (0, _cricketTeamLogoUrl.slugifyCricketTeamName)(name);
}
function parseCommaList(raw) {
    if (!raw || typeof raw !== "string" || !raw.trim()) return [];
    return raw.split(/,\s*/).map((s)=>s.trim()).filter(Boolean);
}
function parseFavTeamsFromStorage(raw) {
    const seen = new Set();
    const out = [];
    for (const name of parseCommaList(raw)){
        const slug = (0, _cricketTeamCanonical.canonicalTeamSlug)(name);
        if (!slug || seen.has(slug)) continue;
        seen.add(slug);
        out.push(name);
    }
    return out;
}
function serializeFavTeamsToStorage(names) {
    return parseFavTeamsFromStorage(names.join(", ")).join(", ");
}
function normalizeFavourites(raw) {
    if (!raw || typeof raw !== "object") return {};
    const src = raw;
    const str = (k)=>typeof src[k] === "string" && src[k] !== "" ? src[k] : undefined;
    const favsports = str("favsports") ?? str("favsport");
    const favcricketers = str("favcricketers");
    const faviplteams = str("faviplteams") ?? str("favipl");
    const favnationalteams = str("favnationalteams") ?? str("favcricketint");
    const favfootballteams = str("favfootballteams") ?? str("favfootball");
    const customParts = [
        str("favcustomcricketteams"),
        str("favcustomteams"),
        str("favteams"),
        str("favteam1"),
        str("favteam2")
    ].filter((s)=>!!s).flatMap((s)=>parseCommaList(s));
    const favcustomcricketteams = serializeFavTeamsToStorage(customParts);
    const out = {};
    if (favsports) out.favsports = favsports;
    if (favcricketers) out.favcricketers = favcricketers;
    if (faviplteams) out.faviplteams = faviplteams;
    if (favnationalteams) out.favnationalteams = favnationalteams;
    if (favfootballteams) out.favfootballteams = favfootballteams;
    if (favcustomcricketteams) out.favcustomcricketteams = favcustomcricketteams;
    return out;
}
const TEAM_STORE_KEYS = [
    "faviplteams",
    "favnationalteams",
    "favcustomcricketteams"
];
function favouriteTeamSlugSet(f) {
    const set = new Set();
    if (!f) return set;
    for (const key of TEAM_STORE_KEYS)for (const entry of parseCommaList(f[key])){
        const slug = (0, _cricketTeamCanonical.canonicalTeamSlug)(entry);
        if (slug) set.add(slug);
    }
    return set;
}
function isFavouriteTeam(f, teamName) {
    const slug = (0, _cricketTeamCanonical.canonicalTeamSlug)(teamName);
    if (!slug) return false;
    return favouriteTeamSlugSet(f).has(slug);
}
function removeBySlug(raw, slug) {
    const kept = parseCommaList(raw).filter((v)=>(0, _cricketTeamCanonical.canonicalTeamSlug)(v) !== slug);
    return kept.length ? kept.join(", ") : undefined;
}
function addValue(raw, value) {
    const list = parseCommaList(raw);
    const slug = (0, _cricketTeamCanonical.canonicalTeamSlug)(value);
    if (!list.some((v)=>(0, _cricketTeamCanonical.canonicalTeamSlug)(v) === slug)) list.push(value);
    return list.join(", ");
}
function buildFavouriteTeamToggle(f, teamName) {
    const { slug, category } = (0, _cricketTeamCanonical.resolveCanonicalTeam)(teamName);
    if (!slug) return null;
    const next = {
        ...f ?? {}
    };
    const contains = (raw)=>parseCommaList(raw).some((v)=>(0, _cricketTeamCanonical.canonicalTeamSlug)(v) === slug);
    const present = TEAM_STORE_KEYS.filter((k)=>contains(next[k]));
    if (present.length > 0) {
        const ops = present.map((key)=>{
            next[key] = removeBySlug(next[key], slug);
            return {
                key,
                action: "remove",
                value: slug
            };
        });
        return {
            ops,
            next,
            favourited: false
        };
    }
    const key = (0, _cricketTeamCanonical.FAV_TEAM_CATEGORY_KEY)[category];
    const value = category === "custom" ? teamName.trim() : slug;
    next[key] = addValue(next[key], value);
    return {
        ops: [
            {
                key,
                action: "add",
                value
            }
        ],
        next,
        favourited: true
    };
}

},{"./cricketTeamLogoUrl":"901Ku","./cricketTeamCanonical":"3aPXR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"901Ku":[function(require,module,exports,__globalThis) {
/**
 * Cricket team crests at `Cricket/Team Logos/{slug}.png`
 * (CloudFront → cricket8-web-content; same flat pattern as Football/Team Logos).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CRICKET_TEAM_LOGO_S3_BASE", ()=>CRICKET_TEAM_LOGO_S3_BASE);
parcelHelpers.export(exports, "CRICKET_TEAM_LOGO_DEFAULT_S3_FOLDER", ()=>CRICKET_TEAM_LOGO_DEFAULT_S3_FOLDER);
parcelHelpers.export(exports, "slugifyCricketTeamName", ()=>slugifyCricketTeamName);
/** Default shield when no team crest is found. */ parcelHelpers.export(exports, "resolveCricketDefaultShieldUrl", ()=>resolveCricketDefaultShieldUrl);
parcelHelpers.export(exports, "cricketTeamLogoS3Url", ()=>cricketTeamLogoS3Url);
/**
 * Ordered URLs to try for a team (flat S3 first, then legacy CDN), deduped.
 * Includes U19-normalized, parent, and Women suffix variants (aligned with backend lookup).
 */ parcelHelpers.export(exports, "getOrderedCricketTeamLogoUrls", ()=>getOrderedCricketTeamLogoUrls);
var _sportImageCdn = require("./sportImageCdn");
const DEFAULT_CRICKET_TEAM_LOGO_S3_PREFIX = "Cricket/Team Logos";
/** Legacy CloudFront layout: `IPL+Team+Images/{Team}/{Team_Name}.png` */ const LEGACY_CDN_PREFIX = "IPL+Team+Images";
const CRICKET_TEAM_LOGO_S3_BASE = (0, _sportImageCdn.sportImagePublicBase)(DEFAULT_CRICKET_TEAM_LOGO_S3_PREFIX, undefined);
const CRICKET_TEAM_LOGO_DEFAULT_S3_FOLDER = "default";
function slugifyCricketTeamName(name) {
    return String(name || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80);
}
function resolveCricketDefaultShieldUrl(fallbackOverride = "false") {
    let file = "shield.png";
    if (fallbackOverride && fallbackOverride !== "false") file = fallbackOverride === "white" ? "shield_white.png" : "shield_subtle_grey.png";
    return `${CRICKET_TEAM_LOGO_S3_BASE}${CRICKET_TEAM_LOGO_DEFAULT_S3_FOLDER}/${file}`;
}
function legacyCdnLogoUrl(teamName) {
    const name = String(teamName || "").trim();
    if (!name) return "";
    const folderSlug = name.replace(/\//g, " ").replace(/ /g, "+");
    const fileBase = name.replace(/\//g, "_").replace(/ /g, "_");
    const cdn = "https://dyatkw7msrzcb.cloudfront.net".replace(/\/$/, "");
    if (!folderSlug || !fileBase) return "";
    return `${cdn}/${LEGACY_CDN_PREFIX}/${folderSlug}/${fileBase}.png`;
}
function cricketTeamLogoS3Url(teamName) {
    const slug = slugifyCricketTeamName(teamName);
    if (!slug) return "";
    return `${CRICKET_TEAM_LOGO_S3_BASE}${slug}.png`;
}
function getOrderedCricketTeamLogoUrls(teamName) {
    const raw = String(teamName || "").trim();
    if (!raw) return [];
    const u19Normalized = raw.replace(/\s+under[- ]?19s?\s*/gi, " U19 ").replace(/\s+/g, " ").trim() || raw;
    const fullyNormalized = u19Normalized.replace(/\s*(?:women'?s?|u19|u-19)\s*$/i, "").replace(/\s*(?:women'?s?|u19|u-19)\s+/gi, " ").replace(/\s+/g, " ").trim() || u19Normalized;
    const withWomen = fullyNormalized && !/\bwomen'?s?\b/i.test(fullyNormalized) ? `${fullyNormalized} Women` : "";
    const names = [
        raw,
        u19Normalized,
        fullyNormalized,
        withWomen
    ].filter(Boolean);
    const urls = [];
    const seen = new Set();
    const push = (url)=>{
        if (!url || seen.has(url)) return;
        seen.add(url);
        urls.push(url);
    };
    for (const name of names)push(cricketTeamLogoS3Url(name));
    for (const name of names)push(legacyCdnLogoUrl(name));
    return urls;
}

},{"./sportImageCdn":"9gRYS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9gRYS":[function(require,module,exports,__globalThis) {
/** CloudFront in front of `cricket8-web-content` (same distribution as `CDN_ENDPOINT`). */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SPORT_IMAGES_CDN", ()=>DEFAULT_SPORT_IMAGES_CDN);
/**
 * Public base URL for a sport-image S3 prefix (`Football/Team Logos`, …).
 * Prefers an explicit env override, else `CDN_ENDPOINT`, else the production CDN.
 */ parcelHelpers.export(exports, "sportImagePublicBase", ()=>sportImagePublicBase);
const DEFAULT_SPORT_IMAGES_CDN = "https://dyatkw7msrzcb.cloudfront.net";
function sportImagePublicBase(s3Prefix, envOverride) {
    const trimmedOverride = String(envOverride || "").trim();
    if (trimmedOverride) return trimmedOverride.replace(/\/?$/, "/");
    const cdn = String("https://dyatkw7msrzcb.cloudfront.net").trim().replace(/\/$/, "");
    const encodedPrefix = s3Prefix.replace(/^\/+|\/+$/g, "").split("/").map(encodeURIComponent).join("/");
    return `${cdn}/${encodedPrefix}/`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3aPXR":[function(require,module,exports,__globalThis) {
/**
 * Canonical identity for cricket teams so a favourite can be recognised across every store:
 * the curated IPL picker (`faviplteams`), the national picker (`favnationalteams`), and
 * free-form cricket teams starred from matches (`favcustomcricketteams`).
 *
 * A fixture team name (e.g. "Royal Challengers Bengaluru", "RCB") resolves to the same
 * canonical slug as the profile picker (`royal-challengers-bangalore`) via an alias table,
 * so the star fills regardless of where the team was favourited.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FAV_TEAM_CATEGORY_KEY", ()=>FAV_TEAM_CATEGORY_KEY);
/** Resolve a team name (or a stored slug) to its canonical slug + category. */ parcelHelpers.export(exports, "resolveCanonicalTeam", ()=>resolveCanonicalTeam);
/** Canonical slug for a team name/slug (empty string when unresolvable). */ parcelHelpers.export(exports, "canonicalTeamSlug", ()=>canonicalTeamSlug);
parcelHelpers.export(exports, "isIplSlug", ()=>isIplSlug);
parcelHelpers.export(exports, "isNationalSlug", ()=>isNationalSlug);
var _cricketTeamLogoUrl = require("./cricketTeamLogoUrl");
var _profileFavIplTeams = require("../components/Profile/profileFavIplTeams");
var _profileFavCricketIntTeams = require("../components/Profile/profileFavCricketIntTeams");
const FAV_TEAM_CATEGORY_KEY = {
    ipl: "faviplteams",
    national: "favnationalteams",
    custom: "favcustomcricketteams"
};
const IPL_SLUGS = new Set((0, _profileFavIplTeams.PROFILE_FAV_IPL_TEAM_OPTIONS).map((t)=>t.slug));
/** Profile International picker slugs. */ const PROFILE_NATIONAL_SLUGS = new Set((0, _profileFavCricketIntTeams.PROFILE_FAV_CRICKET_INT_OPTIONS).map((t)=>t.slug));
/**
 * Extra national / associate sides recognised when starring from matches so they
 * route into `favnationalteams` (and the International section) even when they
 * are not in the curated profile picker.
 */ const EXTRA_NATIONAL_SLUGS = new Set([
    "singapore",
    "usa",
    "united-states",
    "canada",
    "namibia",
    "oman",
    "hong-kong",
    "papua-new-guinea",
    "png",
    "malaysia",
    "kenya",
    "uganda",
    "nigeria",
    "tanzania",
    "jersey",
    "guernsey",
    "cayman-islands",
    "bermuda",
    "thailand",
    "japan",
    "china",
    "vanuatu",
    "fiji",
    "samoa",
    "qatar",
    "saudi-arabia",
    "kuwait",
    "bahrain",
    "maldives",
    "indonesia",
    "philippines",
    "gibraltar"
]);
const NATIONAL_SLUGS = new Set([
    ...PROFILE_NATIONAL_SLUGS,
    ...EXTRA_NATIONAL_SLUGS
]);
/** Alternate names/abbreviations → canonical slug (for name drift the raw slug misses). */ const ALIAS_TO_SLUG = {};
function addAlias(alias, slug) {
    const key = (0, _cricketTeamLogoUrl.slugifyCricketTeamName)(alias);
    if (key) ALIAS_TO_SLUG[key] = slug;
}
// IPL franchises: renamings + common abbreviations.
addAlias("Royal Challengers Bengaluru", "royal-challengers-bangalore");
addAlias("RCB", "royal-challengers-bangalore");
addAlias("Kings XI Punjab", "punjab-kings");
addAlias("PBKS", "punjab-kings");
addAlias("Delhi Daredevils", "delhi-capitals");
addAlias("DC", "delhi-capitals");
addAlias("CSK", "chennai-super-kings");
addAlias("MI", "mumbai-indians");
addAlias("KKR", "kolkata-knight-riders");
addAlias("SRH", "sunrisers-hyderabad");
addAlias("RR", "rajasthan-royals");
addAlias("GT", "gujarat-titans");
addAlias("LSG", "lucknow-super-giants");
// National sides where the slug differs from the common name.
addAlias("United Arab Emirates", "uae");
addAlias("United States", "usa");
addAlias("United States of America", "usa");
addAlias("US", "usa");
addAlias("PNG", "papua-new-guinea");
function resolveCanonicalTeam(value) {
    const raw = String(value ?? "").trim();
    const baseSlug = (0, _cricketTeamLogoUrl.slugifyCricketTeamName)(raw);
    const slug = ALIAS_TO_SLUG[baseSlug] ?? baseSlug;
    let category = "custom";
    if (IPL_SLUGS.has(slug)) category = "ipl";
    else if (NATIONAL_SLUGS.has(slug)) category = "national";
    return {
        slug,
        category,
        name: raw
    };
}
function canonicalTeamSlug(value) {
    return resolveCanonicalTeam(value).slug;
}
function isIplSlug(slug) {
    return IPL_SLUGS.has(slug);
}
function isNationalSlug(slug) {
    return NATIONAL_SLUGS.has(slug);
}

},{"./cricketTeamLogoUrl":"901Ku","../components/Profile/profileFavIplTeams":"f7o1p","../components/Profile/profileFavCricketIntTeams":"7D1sc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7o1p":[function(require,module,exports,__globalThis) {
/**
 * Favourite IPL franchise picks for profile grid. Logos live at
 * `favs/cricket_teams/{slug}.png` on cricket8-web-content.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROFILE_FAV_IPL_LOGO_BASE", ()=>PROFILE_FAV_IPL_LOGO_BASE);
parcelHelpers.export(exports, "PROFILE_FAV_IPL_TEAM_OPTIONS", ()=>PROFILE_FAV_IPL_TEAM_OPTIONS);
parcelHelpers.export(exports, "iplTeamLogoUrl", ()=>iplTeamLogoUrl);
parcelHelpers.export(exports, "iplLogoUsesWhiteTile", ()=>iplLogoUsesWhiteTile);
parcelHelpers.export(exports, "parseFavIplFromStorage", ()=>parseFavIplFromStorage);
parcelHelpers.export(exports, "serializeFavIplToStorage", ()=>serializeFavIplToStorage);
parcelHelpers.export(exports, "favIplLabel", ()=>favIplLabel);
parcelHelpers.export(exports, "favIplLongLabel", ()=>favIplLongLabel);
const PROFILE_FAV_IPL_LOGO_BASE = "https://cricket8-web-content.s3.us-east-1.amazonaws.com/favs/cricket_teams/";
const PROFILE_FAV_IPL_TEAM_OPTIONS = [
    {
        slug: "chennai-super-kings",
        label: "CSK"
    },
    {
        slug: "delhi-capitals",
        label: "DC"
    },
    {
        slug: "gujarat-titans",
        label: "GT"
    },
    {
        slug: "kolkata-knight-riders",
        label: "KKR"
    },
    {
        slug: "lucknow-super-giants",
        label: "LSG"
    },
    {
        slug: "mumbai-indians",
        label: "MI"
    },
    {
        slug: "punjab-kings",
        label: "PBKS"
    },
    {
        slug: "rajasthan-royals",
        label: "RR"
    },
    {
        slug: "royal-challengers-bangalore",
        label: "RCB"
    },
    {
        slug: "sunrisers-hyderabad",
        label: "SRH"
    }
];
const OPTION_SLUGS = PROFILE_FAV_IPL_TEAM_OPTIONS.map((t)=>t.slug);
const SLUG_SET = new Set(OPTION_SLUGS);
const SLUG_TO_LABEL = Object.fromEntries(PROFILE_FAV_IPL_TEAM_OPTIONS.map((t)=>[
        t.slug,
        t.label
    ]));
/** Full franchise names for expanded favourites / tooltips (grid tiles use short `label`). */ const SLUG_TO_LONG_LABEL = {
    "chennai-super-kings": "Chennai Super Kings",
    "delhi-capitals": "Delhi Capitals",
    "gujarat-titans": "Gujarat Titans",
    "kolkata-knight-riders": "Kolkata Knight Riders",
    "lucknow-super-giants": "Lucknow Super Giants",
    "mumbai-indians": "Mumbai Indians",
    "punjab-kings": "Punjab Kings",
    "rajasthan-royals": "Rajasthan Royals",
    "royal-challengers-bangalore": "Royal Challengers Bangalore",
    "sunrisers-hyderabad": "Sunrisers Hyderabad"
};
function iplTeamLogoUrl(slug) {
    return `${PROFILE_FAV_IPL_LOGO_BASE}${encodeURIComponent(slug)}.png`;
}
/** IPL logos that need a white tile for legibility on purple backgrounds. */ const IPL_WHITE_TILE_SLUGS = new Set([
    "chennai-super-kings"
]);
function iplLogoUsesWhiteTile(slug) {
    return IPL_WHITE_TILE_SLUGS.has(slug);
}
function parseFavIplFromStorage(raw) {
    if (!raw?.trim()) return [];
    const parts = raw.split(/,\s*/).map((s)=>s.trim()).filter(Boolean);
    const ordered = [];
    for (const slug of OPTION_SLUGS)if (parts.includes(slug)) ordered.push(slug);
    for (const p of parts)if (!SLUG_SET.has(p) && !ordered.includes(p)) ordered.push(p);
    return ordered;
}
function serializeFavIplToStorage(selected) {
    if (selected.length === 0) return "";
    const set = new Set(selected);
    const known = OPTION_SLUGS.filter((s)=>set.has(s));
    const unknown = selected.filter((s)=>!SLUG_SET.has(s));
    return [
        ...known,
        ...unknown
    ].join(", ");
}
function favIplLabel(slug) {
    return SLUG_TO_LABEL[slug] ?? slug.replace(/-/g, " ");
}
function favIplLongLabel(slug) {
    return SLUG_TO_LONG_LABEL[slug] ?? favIplLabel(slug);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7D1sc":[function(require,module,exports,__globalThis) {
/**
 * Favourite international cricket teams (profile grid). Logos at
 * `favs/cricket_int_teams/{slug}.png` on cricket8-web-content.
 * Add matching PNGs for any new slug (same pixel style as existing tiles).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROFILE_FAV_CRICKET_INT_LOGO_BASE", ()=>PROFILE_FAV_CRICKET_INT_LOGO_BASE);
parcelHelpers.export(exports, "PROFILE_FAV_CRICKET_INT_OPTIONS", ()=>PROFILE_FAV_CRICKET_INT_OPTIONS);
parcelHelpers.export(exports, "cricketIntTeamLogoUrl", ()=>cricketIntTeamLogoUrl);
/** Light crest on transparent PNG — use a white tile so it reads on purple UI. */ parcelHelpers.export(exports, "cricketIntLogoUsesWhiteTile", ()=>cricketIntLogoUsesWhiteTile);
parcelHelpers.export(exports, "parseFavCricketIntFromStorage", ()=>parseFavCricketIntFromStorage);
parcelHelpers.export(exports, "serializeFavCricketIntToStorage", ()=>serializeFavCricketIntToStorage);
parcelHelpers.export(exports, "favCricketIntLabel", ()=>favCricketIntLabel);
const PROFILE_FAV_CRICKET_INT_LOGO_BASE = "https://cricket8-web-content.s3.us-east-1.amazonaws.com/favs/cricket_int_teams/";
const PROFILE_FAV_CRICKET_INT_OPTIONS = [
    {
        slug: "afghanistan",
        label: "Afghanistan"
    },
    {
        slug: "australia",
        label: "Australia"
    },
    {
        slug: "bangladesh",
        label: "Bangladesh"
    },
    {
        slug: "england",
        label: "England"
    },
    {
        slug: "india",
        label: "India"
    },
    {
        slug: "ireland",
        label: "Ireland"
    },
    {
        slug: "nepal",
        label: "Nepal"
    },
    {
        slug: "netherlands",
        label: "Netherlands"
    },
    {
        slug: "new-zealand",
        label: "New Zealand"
    },
    {
        slug: "pakistan",
        label: "Pakistan"
    },
    {
        slug: "scotland",
        label: "Scotland"
    },
    {
        slug: "south-africa",
        label: "South Africa"
    },
    {
        slug: "sri-lanka",
        label: "Sri Lanka"
    },
    {
        slug: "uae",
        label: "UAE"
    },
    {
        slug: "west-indies",
        label: "West Indies"
    },
    {
        slug: "zimbabwe",
        label: "Zimbabwe"
    }
];
const OPTION_SLUGS = PROFILE_FAV_CRICKET_INT_OPTIONS.map((t)=>t.slug);
const SLUG_SET = new Set(OPTION_SLUGS);
const SLUG_TO_LABEL = Object.fromEntries(PROFILE_FAV_CRICKET_INT_OPTIONS.map((t)=>[
        t.slug,
        t.label
    ]));
function cricketIntTeamLogoUrl(slug) {
    return `${PROFILE_FAV_CRICKET_INT_LOGO_BASE}${encodeURIComponent(slug)}.png`;
}
function cricketIntLogoUsesWhiteTile(slug) {
    return slug === "england" || slug === "new-zealand" || slug === "scotland" || slug === "pakistan" || slug === "nepal";
}
function parseFavCricketIntFromStorage(raw) {
    if (!raw?.trim()) return [];
    const parts = raw.split(/,\s*/).map((s)=>s.trim()).filter(Boolean);
    const ordered = [];
    for (const slug of OPTION_SLUGS)if (parts.includes(slug)) ordered.push(slug);
    for (const p of parts)if (!SLUG_SET.has(p) && !ordered.includes(p)) ordered.push(p);
    return ordered;
}
function serializeFavCricketIntToStorage(selected) {
    if (selected.length === 0) return "";
    const set = new Set(selected);
    const known = OPTION_SLUGS.filter((s)=>set.has(s));
    const unknown = selected.filter((s)=>!SLUG_SET.has(s));
    return [
        ...known,
        ...unknown
    ].join(", ");
}
function favCricketIntLabel(slug) {
    return SLUG_TO_LABEL[slug] ?? slug.replace(/-/g, " ");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gnzQv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearBullionPendingInviteFromStorage", ()=>clearBullionPendingInviteFromStorage);
/** Decode `back=/bullion?match=&game=&invite=` from login/signup query and persist. */ parcelHelpers.export(exports, "persistBullionPrivateInviteFromBackParam", ()=>persistBullionPrivateInviteFromBackParam);
parcelHelpers.export(exports, "persistBullionPrivateInviteFromSearch", ()=>persistBullionPrivateInviteFromSearch);
/** Match landing share: `/bullion?match=…&invitedBy=…` (no `game`) — parity with Squares invite persistence. */ parcelHelpers.export(exports, "persistBullionMatchLandingInviteFromSearch", ()=>persistBullionMatchLandingInviteFromSearch);
parcelHelpers.export(exports, "persistBullionPrivateInviteFromRouterSearch", ()=>persistBullionPrivateInviteFromRouterSearch);
parcelHelpers.export(exports, "buildBullionPrivateContestShareUrl", ()=>buildBullionPrivateContestShareUrl);
/** Public match lobby (`/bullion?match=…`) — optional `game` + `invitedBy` for a concrete contest invite. */ parcelHelpers.export(exports, "buildBullionMatchLandingShareUrl", ()=>buildBullionMatchLandingShareUrl);
/**
 * Share / copy invite link for a private BULLION contest (Squares-style native share → clipboard fallback).
 */ parcelHelpers.export(exports, "shareBullionPrivateContestInvite", ()=>shareBullionPrivateContestInvite);
/**
 * Share / copy link to this fixture’s BULLION match landing (`/bullion?match=…`).
 */ parcelHelpers.export(exports, "shareBullionMatchLandingInvite", ()=>shareBullionMatchLandingInvite);
parcelHelpers.export(exports, "readBullionPendingPrivateInviteFromStorage", ()=>readBullionPendingPrivateInviteFromStorage);
/**
 * Invite token for `/bullion/open-game` after URL cleanup strips `invite=` (persisted on first landing).
 */ parcelHelpers.export(exports, "readBullionPendingPrivateInviteCode", ()=>readBullionPendingPrivateInviteCode);
/**
 * After login (or while already logged in), create `bullion_match_challenge` from a stored BULLION share URL.
 * Clears session keys on success; on definitive 400s clears so the user is not stuck retrying.
 */ parcelHelpers.export(exports, "tryClaimBullionLinkInviteFromStorage", ()=>tryClaimBullionLinkInviteFromStorage);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _analyticsIdentity = require("./analyticsIdentity");
var _authHeaders = require("./authHeaders");
var _frontendTrackingEvents = require("./frontendTrackingEvents");
var _nativeShare = require("./nativeShare");
var _shareInviteCopy = require("./shareInviteCopy");
const STORAGE_KEY = "c8_bullion_pending_private_invite";
const MATCH_INVITE_STORAGE_KEY = "c8_bullion_pending_match_invite";
function clearBullionPendingInviteFromStorage() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(MATCH_INVITE_STORAGE_KEY);
    } catch  {
    /* ignore */ }
}
function persistBullionPrivateInviteFromBackParam(back) {
    if (!back || typeof back !== "string") return;
    const trimmed = back.trim();
    if (!trimmed) return;
    const withSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
    if (!withSlash.startsWith("/bullion")) return;
    const qIndex = withSlash.indexOf("?");
    if (qIndex === -1) return;
    persistBullionPrivateInviteFromRouterSearch(withSlash.slice(qIndex));
}
function persistBullionPrivateInviteFromSearch(search) {
    try {
        const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
        const match = params.get("match") || params.get("matchId");
        const game = params.get("game") || params.get("gameId");
        if (!match?.trim() || !game?.trim()) return;
        const matchTrim = match.trim();
        const gameTrim = game.trim();
        const inviteFromUrl = params.get("invite")?.trim() || "";
        const invitedByFromUrl = params.get("invitedBy") || params.get("invited_by");
        const existing = readBullionPendingWithGame();
        const sameContest = existing && String(existing.matchId).trim() === matchTrim && String(existing.gameId).trim() === gameTrim;
        const inviteCode = inviteFromUrl || (sameContest && existing?.inviteCode ? String(existing.inviteCode).trim() : "");
        const inviterPlayerId = invitedByFromUrl?.trim() || (sameContest && existing?.inviterPlayerId ? String(existing.inviterPlayerId).trim() : "");
        const payload = {
            matchId: matchTrim,
            gameId: gameTrim,
            ...inviteCode ? {
                inviteCode
            } : {},
            ...inviterPlayerId ? {
                inviterPlayerId
            } : {}
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch  {
    /* ignore */ }
}
function persistBullionMatchLandingInviteFromSearch(search) {
    try {
        const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
        const match = params.get("match") || params.get("matchId");
        const game = params.get("game") || params.get("gameId");
        const invitedBy = params.get("invitedBy") || params.get("invited_by");
        if (!match?.trim() || !invitedBy?.trim()) return;
        if (game?.trim()) return;
        const payload = {
            matchId: match.trim(),
            inviterPlayerId: invitedBy.trim()
        };
        sessionStorage.setItem(MATCH_INVITE_STORAGE_KEY, JSON.stringify(payload));
    } catch  {
    /* ignore */ }
}
function persistBullionPrivateInviteFromRouterSearch(search) {
    persistBullionPrivateInviteFromSearch(search);
    persistBullionMatchLandingInviteFromSearch(search);
    try {
        const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
        persistBullionPrivateInviteFromBackParam(params.get("back"));
    } catch  {
    /* ignore */ }
}
function buildBullionPrivateContestShareUrl(args) {
    const base = typeof window !== "undefined" ? window.location.origin : "";
    const params = new URLSearchParams();
    params.set("match", args.matchId.trim());
    params.set("game", String(args.gameId));
    const invite = args.inviteCode.trim();
    if (invite) params.set("invite", invite);
    const pid = args.inviterPlayerId != null ? String(args.inviterPlayerId).trim() : "";
    if (pid) params.set("invitedBy", pid);
    return `${base}/bullion?${params.toString()}`;
}
function buildBullionMatchLandingShareUrl(args) {
    const base = typeof window !== "undefined" ? window.location.origin : "";
    const params = new URLSearchParams();
    params.set("match", args.matchId.trim());
    const gidRaw = args.gameId;
    const gidNum = gidRaw != null && gidRaw !== "" ? Number(gidRaw) : NaN;
    if (Number.isFinite(gidNum) && gidNum > 0) params.set("game", String(gidNum));
    const pid = args.inviterPlayerId != null ? String(args.inviterPlayerId).trim() : "";
    if (pid) params.set("invitedBy", pid);
    return `${base}/bullion?${params.toString()}`;
}
function shareBullionPrivateContestInvite(args) {
    const { matchId, gameId, inviteCode, inviterPlayerId, userId, cta_location, shareFeedbackTimeoutRef, setShareFeedback } = args;
    const pathname = typeof window !== "undefined" ? window.location.pathname : "/bullion";
    (0, _frontendTrackingEvents.trackPlayWithFriendClicked)({
        user_id: userId ?? undefined,
        cta_name: "bullion_private_contest_invite",
        cta_location: cta_location ?? "bullion",
        fixture_id: matchId,
        game_type: "bullion",
        visibility: "private",
        pathname
    });
    (0, _frontendTrackingEvents.trackInviteFlowOpened)({
        user_id: userId ?? undefined,
        entry_point: "bullion_private_contest_share",
        fixture_id: matchId,
        game_type: "bullion",
        visibility: "private",
        pathname
    });
    const url = buildBullionPrivateContestShareUrl({
        matchId,
        gameId,
        inviteCode,
        inviterPlayerId
    });
    const message = (0, _shareInviteCopy.buildBullionPrivateContestInviteMessage)({
        teams: args.teams,
        matchTitle: args.matchTitle,
        matchName: args.matchName,
        tournament: args.tournament,
        contestName: args.contestName,
        contestKind: args.contestKind ?? "battle"
    });
    const textWithLink = `${message}\n${url}`;
    const trackPrivateBattleShared = (method)=>{
        (0, _frontendTrackingEvents.trackGameInteraction)({
            user_id: userId ?? undefined,
            interaction_type: "private_battle_link_shared",
            interaction_value: method,
            game_type: "bullion",
            fixture_id: matchId,
            game_id: gameId,
            pathname
        });
    };
    if (shareFeedbackTimeoutRef.current != null) window.clearTimeout(shareFeedbackTimeoutRef.current);
    const showCopied = ()=>{
        setShareFeedback("copied");
        shareFeedbackTimeoutRef.current = window.setTimeout(()=>setShareFeedback(null), 2500);
    };
    const copyUrl = ()=>{
        if (typeof navigator === "undefined" || !navigator.clipboard) return;
        navigator.clipboard.writeText(textWithLink).then(()=>{
            (0, _frontendTrackingEvents.trackFriendInviteSent)({
                user_id: userId ?? undefined,
                invite_method: "clipboard",
                fixture_id: matchId,
                game_type: "bullion",
                visibility: "private",
                pathname
            });
            trackPrivateBattleShared("clipboard");
            showCopied();
        }, ()=>setShareFeedback(null));
    };
    if (typeof navigator !== "undefined" && navigator.share) navigator.share((0, _nativeShare.nativeShareData)(message, url)).then(()=>{
        (0, _frontendTrackingEvents.trackFriendInviteSent)({
            user_id: userId ?? undefined,
            invite_method: "native_share",
            fixture_id: matchId,
            game_type: "bullion",
            visibility: "private",
            pathname
        });
        trackPrivateBattleShared("native_share");
        setShareFeedback("shared");
        shareFeedbackTimeoutRef.current = window.setTimeout(()=>setShareFeedback(null), 2500);
    }).catch((error)=>{
        if (!(0, _nativeShare.isShareCancelled)(error)) copyUrl();
    });
    else copyUrl();
}
function shareBullionMatchLandingInvite(args) {
    const { matchId, inviterPlayerId, gameId, userId, cta_location, shareFeedbackTimeoutRef, setShareFeedback } = args;
    const mid = matchId.trim();
    if (!mid) return;
    const pathname = typeof window !== "undefined" ? window.location.pathname : "/bullion";
    const inviteContext = {
        fixture_id: mid,
        game_type: "bullion",
        visibility: "public"
    };
    (0, _frontendTrackingEvents.trackPlayWithFriendClicked)({
        user_id: userId ?? undefined,
        cta_name: "bullion_match_landing_invite",
        cta_location: cta_location ?? "bullion_match_landing",
        pathname,
        ...inviteContext
    });
    (0, _frontendTrackingEvents.trackInviteFlowOpened)({
        user_id: userId ?? undefined,
        entry_point: "bullion_match_landing_share",
        pathname,
        ...inviteContext
    });
    const url = buildBullionMatchLandingShareUrl({
        matchId: mid,
        inviterPlayerId,
        gameId
    });
    const message = (0, _shareInviteCopy.buildBullionMatchLandingInviteMessage)({
        teams: args.teams,
        matchTitle: args.matchTitle,
        matchName: args.matchName,
        tournament: args.tournament,
        contestName: args.contestName,
        contestKind: args.contestKind ?? (args.gameId ? "arena" : null)
    });
    const textWithLink = `${message}\n${url}`;
    if (shareFeedbackTimeoutRef.current != null) window.clearTimeout(shareFeedbackTimeoutRef.current);
    const showCopied = ()=>{
        setShareFeedback("copied");
        shareFeedbackTimeoutRef.current = window.setTimeout(()=>setShareFeedback(null), 2500);
    };
    const copyUrl = ()=>{
        if (typeof navigator === "undefined" || !navigator.clipboard) return;
        navigator.clipboard.writeText(textWithLink).then(()=>{
            (0, _frontendTrackingEvents.trackFriendInviteSent)({
                user_id: userId ?? undefined,
                invite_method: "clipboard",
                pathname,
                ...inviteContext
            });
            showCopied();
        }, ()=>setShareFeedback(null));
    };
    if (typeof navigator !== "undefined" && navigator.share) navigator.share((0, _nativeShare.nativeShareData)(message, url)).then(()=>{
        (0, _frontendTrackingEvents.trackFriendInviteSent)({
            user_id: userId ?? undefined,
            invite_method: "native_share",
            pathname,
            ...inviteContext
        });
        setShareFeedback("shared");
        shareFeedbackTimeoutRef.current = window.setTimeout(()=>setShareFeedback(null), 2500);
    }).catch((error)=>{
        if (!(0, _nativeShare.isShareCancelled)(error)) copyUrl();
    });
    else copyUrl();
}
function readBullionPendingPrivateInviteFromStorage() {
    return readBullionPendingWithGame();
}
function readBullionPendingPrivateInviteCode(matchId, gameId) {
    const pending = readBullionPendingWithGame();
    if (!pending?.inviteCode) return "";
    const code = String(pending.inviteCode).trim();
    if (!code) return "";
    const mid = matchId != null ? String(matchId).trim() : "";
    if (mid && pending.matchId !== mid) return "";
    if (gameId != null && Number.isFinite(gameId) && gameId > 0) {
        const pendingGid = parseInt(String(pending.gameId), 10);
        if (Number.isFinite(pendingGid) && pendingGid !== gameId) return "";
    }
    return code;
}
function readBullionPendingWithGame() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const o = JSON.parse(raw);
        if (!o?.matchId?.trim() || !o?.gameId?.trim()) return null;
        return {
            matchId: String(o.matchId).trim(),
            gameId: String(o.gameId).trim(),
            ...o.inviteCode != null && String(o.inviteCode).trim() !== "" ? {
                inviteCode: String(o.inviteCode).trim()
            } : {},
            ...o.inviterPlayerId != null && String(o.inviterPlayerId).trim() !== "" ? {
                inviterPlayerId: String(o.inviterPlayerId).trim()
            } : {}
        };
    } catch  {
        return null;
    }
}
function readBullionPendingMatchOnly() {
    try {
        const raw = sessionStorage.getItem(MATCH_INVITE_STORAGE_KEY);
        if (!raw) return null;
        const o = JSON.parse(raw);
        if (!o?.matchId?.trim() || !o?.inviterPlayerId?.trim()) return null;
        return {
            matchId: String(o.matchId).trim(),
            inviterPlayerId: String(o.inviterPlayerId).trim()
        };
    } catch  {
        return null;
    }
}
async function tryClaimBullionLinkInviteFromStorage(analyticsUserIdHint) {
    const withGame = readBullionPendingWithGame();
    const matchOnly = withGame ? null : readBullionPendingMatchOnly();
    if (!withGame && !matchOnly) return;
    if (!(0, _jsCookieDefault.default).get("c8_session_token") && !(0, _authHeaders.getJwt)()) return;
    const inviterPid = (withGame?.inviterPlayerId || matchOnly?.inviterPlayerId || "").trim();
    if (!inviterPid) return;
    const body = {
        match_id: withGame ? withGame.matchId : matchOnly.matchId,
        inviter_player_id: inviterPid
    };
    if (withGame) {
        const gid = parseInt(withGame.gameId, 10);
        if (Number.isFinite(gid) && gid > 0) body.game_id = gid;
        const inv = withGame.inviteCode?.trim();
        if (inv) body.invite_code = inv;
    }
    const clearPending = ()=>{
        clearBullionPendingInviteFromStorage();
    };
    try {
        const res = await fetch(`${"https://cricket8.com/api"}/account/bullion-invite-from-link/claim`, {
            method: "POST",
            headers: (0, _authHeaders.getAuthHeaders)(),
            body: JSON.stringify(body)
        });
        if (res.ok) {
            clearPending();
            const uid = analyticsUserIdHint ?? (0, _analyticsIdentity.getAnalyticsUserId)();
            (0, _frontendTrackingEvents.trackFriendJoinedFromInvite)({
                user_id: uid != null && String(uid).trim() !== "" ? uid : undefined,
                invite_method: "link",
                fixture_id: withGame ? withGame.matchId : matchOnly.matchId,
                game_type: "bullion",
                visibility: withGame ? "private" : "public",
                entry_point: withGame ? "bullion_private_contest_link" : "bullion_match_landing_link",
                pathname: typeof window !== "undefined" ? window.location.pathname : "/bullion"
            });
            return;
        }
        if (res.status === 400) {
            const j = await res.json().catch(()=>({}));
            const err = j?.error;
            if (err === "inviter_not_found" || err === "self" || err === "game_match_mismatch" || err === "game_not_found" || err === "invite_required" || err === "contest_not_open" || err === "no_open_public_game") clearPending();
        }
    } catch  {
    /* keep pending for retry */ }
}

},{"js-cookie":"2P5RE","./analyticsIdentity":"10oOL","./authHeaders":"5Rczo","./frontendTrackingEvents":"4Y90p","./nativeShare":"c9hr7","./shareInviteCopy":"jCSkR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c9hr7":[function(require,module,exports,__globalThis) {
/**
 * `navigator.share` payload with the link in both `text` and `url`.
 *
 * Decision (2026-10): prefer Copy + Facebook/LinkedIn reliability over a clean WhatsApp body.
 *
 * | Target                         | Link only in `url`     | Link only in `text`       | Link in `text` + `url` (chosen) |
 * |--------------------------------|------------------------|---------------------------|----------------------------------|
 * | iOS/Android share-sheet Copy   | drops link             | includes link             | includes link                    |
 * | WhatsApp / similar (join both) | link once              | link once (linkified)     | link often twice                 |
 * | Facebook / LinkedIn            | ok (need `url`)        | may drop link             | ok                               |
 * | iMessage / Mail / Messages     | usually ok             | usually ok                | usually ok                       |
 *
 * We cannot hide system share-sheet Copy. In-app Copy still uses `copyShareText` (message + link).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nativeShareData", ()=>nativeShareData);
/** User dismissed the share sheet — not a failure, so don't fall back to copying. */ parcelHelpers.export(exports, "isShareCancelled", ()=>isShareCancelled);
parcelHelpers.export(exports, "canNativeShare", ()=>canNativeShare);
/** Copies message + link; resolves false when the clipboard is unavailable or denied. */ parcelHelpers.export(exports, "copyShareText", ()=>copyShareText);
function nativeShareData(message, url, title) {
    const link = url.trim();
    const text = [
        message.trim(),
        link
    ].filter(Boolean).join("\n");
    return {
        ...title ? {
            title
        } : {},
        ...text ? {
            text
        } : {},
        ...link ? {
            url: link
        } : {}
    };
}
function isShareCancelled(error) {
    return error?.name === "AbortError";
}
function canNativeShare() {
    return typeof navigator !== "undefined" && typeof navigator.share === "function";
}
function copyShareText(message, url) {
    const text = [
        message.trim(),
        url.trim()
    ].filter(Boolean).join("\n");
    if (!text || typeof navigator === "undefined" || !navigator.clipboard) return Promise.resolve(false);
    return navigator.clipboard.writeText(text).then(()=>true, ()=>false);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jCSkR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSquaresMatchInviteMessage", ()=>buildSquaresMatchInviteMessage);
parcelHelpers.export(exports, "buildLobbyInviteMessage", ()=>buildLobbyInviteMessage);
parcelHelpers.export(exports, "buildBullionPrivateContestInviteMessage", ()=>buildBullionPrivateContestInviteMessage);
parcelHelpers.export(exports, "buildBullionMatchLandingInviteMessage", ()=>buildBullionMatchLandingInviteMessage);
parcelHelpers.export(exports, "buildLeagueTableInviteMessage", ()=>buildLeagueTableInviteMessage);
var _shareCopy = require("./shareCopy");
var _sharePageMeta = require("./sharePageMeta");
function pickRandom(messages) {
    return messages[Math.floor(Math.random() * messages.length)];
}
function buildSquaresMatchInviteMessage(args) {
    const match = (0, _sharePageMeta.resolveMatchLabel)(args);
    const comp = String(args.tournament ?? "").trim();
    const compBit = comp ? ` in ${comp}` : "";
    if (match) return pickRandom([
        `Join me in Squares for ${match}${compBit} on Cricket8 \u{2014} pick runs on every ball of the live over: `,
        `Think you can beat my Squares picks for ${match}? Play here: `,
        `Squares on Cricket8 for ${match}${compBit} \u{2014} same over, same drama. Join me: `,
        `I'm playing Squares for ${match} \u{2014} take on all six balls here: `
    ]);
    return pickRandom((0, _shareCopy.SQUARES_MATCH_PLAY_INVITE_MESSAGES));
}
function buildLobbyInviteMessage(kind, args = {}) {
    const match = (0, _sharePageMeta.resolveMatchLabel)(args);
    const sportLabel = (0, _sharePageMeta.resolveTraderSportLabel)(args.sport);
    if (kind === "leagues") return pickRandom((0, _shareCopy.LOBBY_INVITE_MESSAGES).leagues);
    if (kind === "squares") {
        if (match) return pickRandom([
            `Join me for Squares on Cricket8 for ${match}: `,
            `I'm playing Squares for ${match} on Cricket8 \u{2014} pick every ball of the live over: `,
            `Squares on Cricket8 \u{2014} ${match}. Play with me here: `
        ]);
        return pickRandom((0, _shareCopy.LOBBY_INVITE_MESSAGES).squares);
    }
    if (kind === "bullion") {
        if (match) return pickRandom([
            `Join me for Bullion on Cricket8 for ${match} \u{2014} pick team, innings, player and match: `,
            `I'm playing Bullion for ${match} on Cricket8 \u{2014} open the lobby and jump in: `,
            `Cricket8 Bullion for ${match} \u{2014} public arenas and private battles. Come play: `
        ]);
        return pickRandom((0, _shareCopy.LOBBY_INVITE_MESSAGES).bullion);
    }
    if (kind === "sixes") {
        if (match) return pickRandom([
            `Join me for Sixes on Cricket8 for ${match} \u{2014} live match cricket cards: `,
            `I'm playing Sixes for ${match} on Cricket8 \u{2014} build sets and climb the board: `,
            `Cricket8 Sixes for ${match} \u{2014} come play Sixes with me: `
        ]);
        return pickRandom((0, _shareCopy.LOBBY_INVITE_MESSAGES).sixes);
    }
    if (match) return pickRandom([
        `Join me on Cricket8 Trader for ${match} \u{2014} live ${sportLabel} games: `,
        `Play live ${sportLabel} with me on Cricket8 for ${match}: `,
        `I'm on Cricket8 Trader for ${match} \u{2014} come compete: `
    ]);
    return pickRandom([
        `Join me on Cricket8 Trader \u{2014} live ${sportLabel} games: `,
        `Play live ${sportLabel} games with me on Cricket8 \u{2014} here's the lobby: `,
        `I'm on Cricket8 Trader \u{2014} come compete: `
    ]);
}
function buildBullionPrivateContestInviteMessage(args) {
    const match = (0, _sharePageMeta.resolveMatchLabel)(args);
    const contestName = String(args.contestName ?? "").trim();
    const matchBit = match ? ` for ${match}` : "";
    if (contestName) return pickRandom([
        `Join my private Bullion battle "${contestName}"${matchBit} on Cricket8 \u{2014} pick team, innings, player and match: `,
        `Think you can beat my Bullion lineup in "${contestName}"${matchBit}? Jump in: `,
        `I'm running a private Bullion pool "${contestName}"${matchBit} \u{2014} join here: `,
        `Come play Bullion with me in "${contestName}"${matchBit}: `
    ]);
    if (match) return pickRandom([
        `Join my private Bullion battle for ${match} on Cricket8 \u{2014} pick team, innings, player and match: `,
        `Think you can beat my Bullion picks for ${match}? Jump into my private battle: `,
        `Private Bullion battle for ${match} \u{2014} join here: `
    ]);
    return pickRandom((0, _shareCopy.BULLION_PRIVATE_CONTEST_INVITE_MESSAGES));
}
function buildBullionMatchLandingInviteMessage(args) {
    const match = (0, _sharePageMeta.resolveMatchLabel)(args);
    const contestName = String(args.contestName ?? "").trim();
    const kindLabel = args.contestKind === "battle" ? "Bullion battle" : "Bullion arena";
    if (contestName) {
        const matchBit = match ? ` for ${match}` : "";
        return pickRandom([
            `Join "${contestName}"${matchBit} on Cricket8 ${kindLabel} \u{2014} pick your board and compete with friends: `,
            `I'm in "${contestName}"${matchBit} on Cricket8 Bullion \u{2014} come play: `,
            `Think you can beat my picks in "${contestName}"${matchBit}? Join here: `
        ]);
    }
    const arenaCount = Number(args.publicArenas) || 0;
    if (match && arenaCount > 0) {
        const arenas = `${arenaCount} public ${arenaCount === 1 ? "arena" : "arenas"}`;
        return pickRandom([
            `Bullion for ${match} on Cricket8 \u{2014} ${arenas} to battle in. Pick your board and join me: `,
            `${arenas} open for ${match} on Cricket8 Bullion \u{2014} pick team, innings, player and match: `,
            `Think you can beat me at Bullion for ${match}? ${arenas} to battle in: `
        ]);
    }
    if (match) return pickRandom([
        `Join me for Bullion on Cricket8 for ${match} \u{2014} pick team, innings, player and match: `,
        `I'm playing Bullion for ${match} \u{2014} open the lobby and jump in: `,
        `Bullion arena lobby for ${match} \u{2014} come play on Cricket8: `,
        `Cricket8 Bullion for ${match} \u{2014} public arenas and private battles: `
    ]);
    return pickRandom((0, _shareCopy.BULLION_MATCH_LANDING_INVITE_MESSAGES));
}
function buildLeagueTableInviteMessage(args = {}) {
    const listing = args.listing === "public" ? "public" : "private";
    const name = String(args.leagueName ?? args.contestName ?? "").trim();
    const match = (0, _sharePageMeta.resolveLeagueInviteMatchLabel)(args);
    const anonymousLabel = listing === "public" ? "the Cricket8 League" : "my private Cricket8 League";
    const leagueLabel = name ? `"${name}"` : anonymousLabel;
    if (args.matchLive) {
        const catchUp = (args.catchUpGames ?? []).map((game)=>game === "bullion" ? "a Bullion Lucky Dip" : "a Sixes card scored from the start");
        if (match) {
            if (catchUp.length > 0) return `Match is live \u{2014}
${match}
Still time \u{2014} catch up with ${catchUp.join(" and ")}`;
            return pickRandom([
                `Match is live \u{2014}
${match}\nStill time to join ${leagueLabel}`,
                `Late entry open for\n${match}\nCatch up in ${leagueLabel}`
            ]);
        }
        if (catchUp.length > 0) return `Match is live \u{2014} still time to join ${leagueLabel}. Catch up with ${catchUp.join(" and ")}`;
        return `Match is live \u{2014} still time to join ${leagueLabel}`;
    }
    if (match) return listing === "public" ? `Join the Cricket8 League for ${match}` : `Join my private Cricket8 League for ${match}`;
    return (0, _shareCopy.leagueTableInviteFallbackMessage)(listing);
}

},{"./shareCopy":"9P9zX","./sharePageMeta":"i3OZv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9P9zX":[function(require,module,exports,__globalThis) {
/** Canonical share / OG copy — keep in sync with `frontend/index.html` meta tags. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SITE_OG_TITLE", ()=>SITE_OG_TITLE);
parcelHelpers.export(exports, "SITE_OG_DESCRIPTION", ()=>SITE_OG_DESCRIPTION);
parcelHelpers.export(exports, "OG_IMAGE_ALT", ()=>OG_IMAGE_ALT);
parcelHelpers.export(exports, "GAMES_PAGE_OG_TITLE", ()=>GAMES_PAGE_OG_TITLE);
parcelHelpers.export(exports, "GAMES_PAGE_OG_DESCRIPTION", ()=>GAMES_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "ABOUT_PAGE_OG_TITLE", ()=>ABOUT_PAGE_OG_TITLE);
parcelHelpers.export(exports, "ABOUT_PAGE_OG_DESCRIPTION", ()=>ABOUT_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "HOW_TO_PLAY_PAGE_OG_TITLE", ()=>HOW_TO_PLAY_PAGE_OG_TITLE);
parcelHelpers.export(exports, "HOW_TO_PLAY_PAGE_OG_DESCRIPTION", ()=>HOW_TO_PLAY_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "CONTACT_PAGE_OG_TITLE", ()=>CONTACT_PAGE_OG_TITLE);
parcelHelpers.export(exports, "CONTACT_PAGE_OG_DESCRIPTION", ()=>CONTACT_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "XP_LEADERBOARD_PAGE_OG_TITLE", ()=>XP_LEADERBOARD_PAGE_OG_TITLE);
parcelHelpers.export(exports, "XP_LEADERBOARD_PAGE_OG_DESCRIPTION", ()=>XP_LEADERBOARD_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "MATCHES_PAGE_OG_TITLE", ()=>MATCHES_PAGE_OG_TITLE);
parcelHelpers.export(exports, "MATCHES_PAGE_OG_DESCRIPTION", ()=>MATCHES_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "RESULTS_PAGE_OG_TITLE", ()=>RESULTS_PAGE_OG_TITLE);
parcelHelpers.export(exports, "RESULTS_PAGE_OG_DESCRIPTION", ()=>RESULTS_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "SQUARES_PAGE_OG_TITLE", ()=>SQUARES_PAGE_OG_TITLE);
parcelHelpers.export(exports, "SQUARES_PAGE_OG_DESCRIPTION", ()=>SQUARES_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "SQUARES_MATCH_PLAY_OG_TITLE", ()=>SQUARES_MATCH_PLAY_OG_TITLE);
parcelHelpers.export(exports, "SIXES_PAGE_OG_TITLE", ()=>SIXES_PAGE_OG_TITLE);
parcelHelpers.export(exports, "SIXES_PAGE_OG_DESCRIPTION", ()=>SIXES_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "BULLION_PAGE_OG_TITLE", ()=>BULLION_PAGE_OG_TITLE);
parcelHelpers.export(exports, "BULLION_PAGE_OG_DESCRIPTION", ()=>BULLION_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "TRADER_PAGE_OG_TITLE", ()=>TRADER_PAGE_OG_TITLE);
parcelHelpers.export(exports, "TRADER_PAGE_OG_DESCRIPTION", ()=>TRADER_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "LEAGUES_PAGE_OG_TITLE", ()=>LEAGUES_PAGE_OG_TITLE);
parcelHelpers.export(exports, "LEAGUES_PAGE_OG_DESCRIPTION", ()=>LEAGUES_PAGE_OG_DESCRIPTION);
parcelHelpers.export(exports, "SQUARES_RULES_OG_TITLE", ()=>SQUARES_RULES_OG_TITLE);
parcelHelpers.export(exports, "SQUARES_RULES_OG_DESCRIPTION", ()=>SQUARES_RULES_OG_DESCRIPTION);
parcelHelpers.export(exports, "PROFILE_INVITE_SHARE_TITLE", ()=>PROFILE_INVITE_SHARE_TITLE);
parcelHelpers.export(exports, "PROFILE_INVITE_SHARE_TEXT", ()=>PROFILE_INVITE_SHARE_TEXT);
parcelHelpers.export(exports, "PROFILE_OG_TITLE", ()=>PROFILE_OG_TITLE);
parcelHelpers.export(exports, "PROFILE_OG_DESCRIPTION", ()=>PROFILE_OG_DESCRIPTION);
parcelHelpers.export(exports, "PROFILE_OG_IMAGE_ALT", ()=>PROFILE_OG_IMAGE_ALT);
parcelHelpers.export(exports, "buildProfileInviteShareTitle", ()=>buildProfileInviteShareTitle);
parcelHelpers.export(exports, "buildProfileInviteShareText", ()=>buildProfileInviteShareText);
parcelHelpers.export(exports, "buildProfileOgDescription", ()=>buildProfileOgDescription);
parcelHelpers.export(exports, "LOBBY_INVITE_MESSAGES", ()=>LOBBY_INVITE_MESSAGES);
/** Per-league join link (`/leagues?code=`) — not the Leagues lobby. Fallback when no fixture. */ parcelHelpers.export(exports, "leagueTableInviteFallbackMessage", ()=>leagueTableInviteFallbackMessage);
parcelHelpers.export(exports, "BULLION_PRIVATE_CONTEST_INVITE_MESSAGES", ()=>BULLION_PRIVATE_CONTEST_INVITE_MESSAGES);
parcelHelpers.export(exports, "BULLION_MATCH_LANDING_INVITE_MESSAGES", ()=>BULLION_MATCH_LANDING_INVITE_MESSAGES);
parcelHelpers.export(exports, "SQUARES_MATCH_PLAY_INVITE_MESSAGES", ()=>SQUARES_MATCH_PLAY_INVITE_MESSAGES);
const SITE_OG_TITLE = "Cricket8 | Free Social Cricket Games";
const SITE_OG_DESCRIPTION = "Play live cricket challenges with friends. Earn virtual Coins and XP. Free to play \u2014 no cash prizes.";
const OG_IMAGE_ALT = "Cricket8 - Don't just watch the match. Battle your friends.";
const GAMES_PAGE_OG_TITLE = "All Games | Cricket8";
const GAMES_PAGE_OG_DESCRIPTION = "Play free social cricket games on Cricket8 \u2014 Squares, Sixes, Bullion, Trader and Leagues. Compete with friends for Coins and XP.";
const ABOUT_PAGE_OG_TITLE = "About Cricket8 | Free Social Cricket Games";
const ABOUT_PAGE_OG_DESCRIPTION = "Cricket8 is free-to-play social cricket gaming \u2014 no real money, no cash prizes. Play with friends, earn virtual Coins and XP.";
const HOW_TO_PLAY_PAGE_OG_TITLE = "How to Play | Cricket8";
const HOW_TO_PLAY_PAGE_OG_DESCRIPTION = "Learn how to play Cricket8 \u2014 sign up, claim free Coins, and jump into Squares, Sixes, Bullion, Trader and Leagues.";
const CONTACT_PAGE_OG_TITLE = "Contact Us | Cricket8";
const CONTACT_PAGE_OG_DESCRIPTION = "Get in touch with the Cricket8 team \u2014 questions, feedback and support for our free social cricket games.";
const XP_LEADERBOARD_PAGE_OG_TITLE = "XP Leaderboard | Cricket8";
const XP_LEADERBOARD_PAGE_OG_DESCRIPTION = "See who is climbing the Cricket8 XP leaderboard \u2014 compete with friends and the community for weekly crowns.";
const MATCHES_PAGE_OG_TITLE = "Live & Upcoming Cricket Matches | Cricket8";
const MATCHES_PAGE_OG_DESCRIPTION = "Browse live and upcoming cricket matches on Cricket8 \u2014 fixtures, scores, and quick links to play Squares, Sixes, Bullion and Trader.";
const RESULTS_PAGE_OG_TITLE = "Cricket Results & Scores | Cricket8";
const RESULTS_PAGE_OG_DESCRIPTION = "Explore cricket match results and scorecards on Cricket8 \u2014 final scores, innings summaries and match outcomes.";
const SQUARES_PAGE_OG_TITLE = "Squares | Cricket8";
const SQUARES_PAGE_OG_DESCRIPTION = "Play Squares on Cricket8 \u2014 live overs, compete with friends, and climb the match leaderboard.";
const SQUARES_MATCH_PLAY_OG_TITLE = "Squares Match Play | Cricket8";
const SIXES_PAGE_OG_TITLE = "Sixes | Cricket8";
const SIXES_PAGE_OG_DESCRIPTION = "Play Sixes on Cricket8 \u2014 live match cricket cards, cheer for match events, and compete for points.";
const BULLION_PAGE_OG_TITLE = "Bullion on Cricket8";
const BULLION_PAGE_OG_DESCRIPTION = "Play Bullion on Cricket8 \u2014 public arenas and private battles. Pick your board and compete with friends.";
const TRADER_PAGE_OG_TITLE = "Live sport games on Cricket8";
const TRADER_PAGE_OG_DESCRIPTION = "Play live sport games on Cricket8 Trader \u2014 cricket, football, tennis and more. Free to play.";
const LEAGUES_PAGE_OG_TITLE = "Leagues | Cricket8";
const LEAGUES_PAGE_OG_DESCRIPTION = "Play Leagues on Cricket8 \u2014 private tables with friends, pick which games to play, and battle for the leaderboard.";
const SQUARES_RULES_OG_TITLE = "Squares Rules | Cricket8";
const SQUARES_RULES_OG_DESCRIPTION = "How to play Squares \u2014 live cricket ball-by-ball challenges on Cricket8.";
const PROFILE_INVITE_SHARE_TITLE = "Play with friends on Cricket8";
const PROFILE_INVITE_SHARE_TEXT = "Join me on Cricket8 \u2014 play live cricket games together.";
const PROFILE_OG_TITLE = PROFILE_INVITE_SHARE_TITLE;
const PROFILE_OG_DESCRIPTION = "Play live cricket games with friends on Cricket8 \u2014 test your cricket knowledge and compete together.";
const PROFILE_OG_IMAGE_ALT = "Play with friends on Cricket8";
function buildProfileInviteShareTitle(displayName) {
    const name = String(displayName ?? "").trim();
    return name ? `${name} invited you to play on Cricket8` : PROFILE_INVITE_SHARE_TITLE;
}
function buildProfileInviteShareText(displayName) {
    const name = String(displayName ?? "").trim();
    return name ? `Join ${name} on Cricket8 \u{2014} play live cricket games together.` : PROFILE_INVITE_SHARE_TEXT;
}
function buildProfileOgDescription(displayName) {
    return buildProfileInviteShareText(displayName);
}
const LOBBY_INVITE_MESSAGES = {
    bullion: [
        "Join me for Bullion on Cricket8 \u2014 public arenas and private battles: ",
        "I'm playing Bullion on Cricket8 \u2014 come pick your board for the same match: ",
        "Think you can beat my Bullion picks? Jump in here: "
    ],
    squares: [
        "Join me for Squares on Cricket8 \u2014 pick runs on every ball of a live over: ",
        "Squares on Cricket8 \u2014 same over, same drama. Play here: ",
        "I'm playing Squares \u2014 take on all six balls here: "
    ],
    trader: [
        "Join me on Cricket8 Trader \u2014 live sport games: ",
        "Play live sport games with me on Cricket8 \u2014 here's the lobby: ",
        "I'm on Cricket8 Trader \u2014 come compete: "
    ],
    sixes: [
        "Join me for Sixes on Cricket8 \u2014 live match cricket cards: ",
        "I'm playing Sixes on Cricket8 \u2014 cheer for match events and climb the board: ",
        "Think you can beat my Sixes card? Play here: "
    ],
    leagues: [
        "Join me on Cricket8 Leagues \u2014 private tables with friends, ranked on profit: ",
        "I'm playing Leagues on Cricket8 \u2014 come join a private table: ",
        "Come play a Cricket8 league with me \u2014 private table, ranked on profit: ",
        "Cricket8 Leagues \u2014 private tables for friends. Come play: "
    ]
};
function leagueTableInviteFallbackMessage(listing = "private") {
    return listing === "public" ? "Join the Cricket8 League" : "Join my private Cricket8 League";
}
const BULLION_PRIVATE_CONTEST_INVITE_MESSAGES = [
    "Join my private Bullion battle on Cricket8 \u2014 pick team, innings, player and match. ",
    "Think you can beat my Bullion lineup? Jump into my private battle: ",
    "I'm running a private Bullion pool for this match \u2014 join here: ",
    "Come play Bullion with me \u2014 private battle, same match: ",
    "Bullion private battle \u2014 entry link: ",
    "Compete with me in this private Bullion battle: "
];
const BULLION_MATCH_LANDING_INVITE_MESSAGES = [
    "Join me for Bullion on Cricket8 \u2014 pick team, innings, player and match for this fixture: ",
    "I'm playing Bullion for this match \u2014 open the lobby and jump in: ",
    "Bullion arena lobby for this match \u2014 come play: ",
    "Think you can beat my picks? Bullion for this match is here: ",
    "Cricket8 Bullion \u2014 same match, public arenas and private battles: "
];
const SQUARES_MATCH_PLAY_INVITE_MESSAGES = [
    "Join me in Squares \u2014 pick the runs for every ball and see who scores the most points! ",
    "Think you can beat my Squares picks? ",
    "Can you beat me in this match? ",
    "Can you beat my Squares score for this match? ",
    "Let's play Squares! Pick runs on every ball and see who scores the most points. ",
    "Join me in Squares! Pick runs on every ball and compete with friends. Let's play here: "
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i3OZv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchSeoKeywords", ()=>buildMatchSeoKeywords);
parcelHelpers.export(exports, "formatTeamsVs", ()=>formatTeamsVs);
/** Cricket-style share label: `INDIA v WEST INDIES`. */ parcelHelpers.export(exports, "formatTeamsVUpper", ()=>formatTeamsVUpper);
parcelHelpers.export(exports, "resolveMatchLabel", ()=>resolveMatchLabel);
/** Uppercase cricket `v` label for invite share text (teams preferred, else title/name). */ parcelHelpers.export(exports, "resolveLeagueInviteMatchLabel", ()=>resolveLeagueInviteMatchLabel);
parcelHelpers.export(exports, "resolveTraderSportLabel", ()=>resolveTraderSportLabel);
parcelHelpers.export(exports, "buildSquaresMatchShareMeta", ()=>buildSquaresMatchShareMeta);
parcelHelpers.export(exports, "buildTraderMatchShareMeta", ()=>buildTraderMatchShareMeta);
parcelHelpers.export(exports, "buildBullionContestShareMeta", ()=>buildBullionContestShareMeta);
parcelHelpers.export(exports, "buildProfileShareMeta", ()=>buildProfileShareMeta);
parcelHelpers.export(exports, "buildSquaresLobbyShareMeta", ()=>buildSquaresLobbyShareMeta);
parcelHelpers.export(exports, "buildBullionLobbyShareMeta", ()=>buildBullionLobbyShareMeta);
parcelHelpers.export(exports, "buildTraderLobbyShareMeta", ()=>buildTraderLobbyShareMeta);
parcelHelpers.export(exports, "buildSixesLobbyShareMeta", ()=>buildSixesLobbyShareMeta);
parcelHelpers.export(exports, "buildAllGamesShareMeta", ()=>buildAllGamesShareMeta);
parcelHelpers.export(exports, "buildAboutShareMeta", ()=>buildAboutShareMeta);
parcelHelpers.export(exports, "buildHowToPlayShareMeta", ()=>buildHowToPlayShareMeta);
parcelHelpers.export(exports, "buildContactShareMeta", ()=>buildContactShareMeta);
parcelHelpers.export(exports, "buildXpLeaderboardShareMeta", ()=>buildXpLeaderboardShareMeta);
parcelHelpers.export(exports, "buildMatchesLobbyShareMeta", ()=>buildMatchesLobbyShareMeta);
parcelHelpers.export(exports, "buildResultsLobbyShareMeta", ()=>buildResultsLobbyShareMeta);
parcelHelpers.export(exports, "buildSquaresRulesShareMeta", ()=>buildSquaresRulesShareMeta);
parcelHelpers.export(exports, "buildSixesMatchShareMeta", ()=>buildSixesMatchShareMeta);
parcelHelpers.export(exports, "buildLeaguesLobbyShareMeta", ()=>buildLeaguesLobbyShareMeta);
/** Join / detail share meta for `/leagues?code=` and `/leagues?id=` links. */ parcelHelpers.export(exports, "buildLeagueInviteShareMeta", ()=>buildLeagueInviteShareMeta);
/** Finished-league results card (`/leagues?r=`). */ parcelHelpers.export(exports, "buildLeagueResultsShareMeta", ()=>buildLeagueResultsShareMeta);
var _shareCopy = require("./shareCopy");
var _leagueResultsShare = require("../components/Leagues/lib/leagueResultsShare");
function buildMatchSeoKeywords(matchLabel, game) {
    const label = String(matchLabel ?? "").trim();
    const parts = [
        "cricket8",
        "cricket",
        "live cricket",
        game
    ];
    if (!label) return parts.join(", ");
    parts.push(label);
    const vs = label.split(/\s+v\s+/i);
    if (vs.length >= 2) {
        const a = vs[0].trim();
        const b = vs[1].trim();
        if (a) parts.push(a, `${a} cricket`);
        if (b) parts.push(b, `${b} cricket`);
        if (a && b) parts.push(`${a} vs ${b}`, `${a} v ${b}`);
    }
    return [
        ...new Set(parts.map((p)=>p.trim()).filter(Boolean))
    ].join(", ");
}
function formatTeamsVs(teams) {
    const a = String(teams?.[0] ?? "").trim();
    const b = String(teams?.[1] ?? "").trim();
    if (a && b) return `${a} vs ${b}`;
    return "";
}
function formatTeamsVUpper(teams) {
    const a = String(teams?.[0] ?? "").trim();
    const b = String(teams?.[1] ?? "").trim();
    if (a && b) return `${a} v ${b}`.toUpperCase();
    return "";
}
function resolveMatchLabel(args) {
    const vs = formatTeamsVs(args.teams);
    if (vs) return vs;
    return String(args.matchTitle ?? args.matchName ?? "").trim();
}
function resolveLeagueInviteMatchLabel(args) {
    const fromTeams = formatTeamsVUpper(args.teams);
    if (fromTeams) return fromTeams;
    const raw = String(args.matchTitle ?? args.matchName ?? "").trim();
    if (!raw) return "";
    return raw.replace(/\s+vs\.?\s+/i, " v ").toUpperCase();
}
function resolveTraderSportLabel(sport) {
    const sportRaw = String(sport ?? "cricket").trim().toLowerCase();
    if (sportRaw === "cricket") return "cricket";
    if (sportRaw === "football") return "football";
    if (sportRaw === "tennis") return "tennis";
    if (sportRaw === "horses") return "horse racing";
    return sportRaw;
}
function buildSquaresMatchShareMeta(args) {
    const match = resolveMatchLabel(args);
    const comp = String(args.tournament ?? "").trim();
    const title = match ? `${match} | Squares on Cricket8` : "Squares Match Play | Cricket8";
    const compBit = comp ? ` in ${comp}` : "";
    const description = match ? `Play Squares on Cricket8 for ${match}${compBit}. Pick runs on every ball of the live over and compete with friends.` : (0, _shareCopy.SITE_OG_DESCRIPTION);
    return {
        title,
        description,
        imageAlt: match ? `Cricket8 Squares \u{2014} ${match}` : (0, _shareCopy.OG_IMAGE_ALT),
        ogGame: "squares",
        keywords: buildMatchSeoKeywords(match, "squares"),
        jsonLdMatchName: match || undefined
    };
}
function buildTraderMatchShareMeta(args) {
    const match = resolveMatchLabel(args);
    const sportLabel = resolveTraderSportLabel(args.sport);
    const title = match ? `${match} | Live ${sportLabel} games on Cricket8` : (0, _shareCopy.TRADER_PAGE_OG_TITLE);
    const comp = String(args.tournament ?? "").trim();
    const compBit = comp ? ` in ${comp}` : "";
    const description = match ? `Follow ${match}${compBit} on Cricket8 \u{2014} live ${sportLabel} games.` : (0, _shareCopy.SITE_OG_DESCRIPTION);
    return {
        title,
        description,
        imageAlt: match ? `Cricket8 \u{2014} ${match}` : (0, _shareCopy.OG_IMAGE_ALT),
        ogGame: "trader",
        keywords: buildMatchSeoKeywords(match, "trader"),
        jsonLdMatchName: match || undefined
    };
}
function buildBullionContestShareMeta(args) {
    const match = resolveMatchLabel({
        teams: args.teams,
        matchTitle: args.matchTitle,
        matchName: args.matchName
    });
    const contestName = String(args.contestName ?? "").trim();
    if (contestName) {
        const kindLabel = args.contestKind === "battle" ? "Bullion Battle" : "Bullion Arena";
        const title = `${contestName} | ${kindLabel} on Cricket8`;
        const matchBit = match ? ` for ${match}` : "";
        const description = `Join ${contestName}${matchBit} on Cricket8 Bullion \u{2014} pick team, innings, player and match and compete with friends.`;
        return {
            title,
            description,
            imageAlt: `Cricket8 Bullion \u{2014} ${contestName}`,
            ogGame: "bullion",
            keywords: buildMatchSeoKeywords(match || contestName, "bullion"),
            jsonLdMatchName: match || contestName
        };
    }
    const title = match ? `${match} | Cricket8 Bullion` : "Bullion on Cricket8";
    const description = match ? `Play Bullion on Cricket8 for ${match} \u{2014} public arenas and private battles. Pick your board and compete with friends.` : (0, _shareCopy.SITE_OG_DESCRIPTION);
    return {
        title,
        description,
        imageAlt: match ? `Cricket8 Bullion \u{2014} ${match}` : (0, _shareCopy.OG_IMAGE_ALT),
        ogGame: "bullion",
        keywords: buildMatchSeoKeywords(match, "bullion"),
        jsonLdMatchName: match || undefined
    };
}
function buildProfileShareMeta(args = {}) {
    const name = String(args.displayName ?? "").trim();
    const title = (0, _shareCopy.buildProfileInviteShareTitle)(name || null);
    const description = (0, _shareCopy.buildProfileOgDescription)(name || null);
    return {
        title,
        description,
        imageAlt: name ? `${name} on Cricket8` : (0, _shareCopy.PROFILE_OG_IMAGE_ALT),
        ogGame: "site"
    };
}
function buildGameLobbyApplication(name, description, path) {
    return {
        name,
        description,
        url: `https://cricket8.com${path}`
    };
}
function buildSquaresLobbyShareMeta(args = {}) {
    return {
        title: (0, _shareCopy.SQUARES_PAGE_OG_TITLE),
        description: (0, _shareCopy.SQUARES_PAGE_OG_DESCRIPTION),
        imageAlt: "Cricket8 Squares",
        ogGame: "squares",
        jsonLdApplication: buildGameLobbyApplication("Cricket8 Squares", (0, _shareCopy.SQUARES_PAGE_OG_DESCRIPTION), "/squares"),
        ...args.jsonLdFaq?.length ? {
            jsonLdFaq: args.jsonLdFaq
        } : {}
    };
}
function buildBullionLobbyShareMeta() {
    return {
        title: (0, _shareCopy.BULLION_PAGE_OG_TITLE),
        description: (0, _shareCopy.BULLION_PAGE_OG_DESCRIPTION),
        imageAlt: "Cricket8 Bullion",
        ogGame: "bullion",
        jsonLdApplication: buildGameLobbyApplication("Cricket8 Bullion", (0, _shareCopy.BULLION_PAGE_OG_DESCRIPTION), "/bullion")
    };
}
function buildTraderLobbyShareMeta() {
    return {
        title: (0, _shareCopy.TRADER_PAGE_OG_TITLE),
        description: (0, _shareCopy.TRADER_PAGE_OG_DESCRIPTION),
        imageAlt: (0, _shareCopy.OG_IMAGE_ALT),
        ogGame: "trader",
        jsonLdApplication: buildGameLobbyApplication("Cricket8 Trader", (0, _shareCopy.TRADER_PAGE_OG_DESCRIPTION), "/trader")
    };
}
function buildSixesLobbyShareMeta() {
    return {
        title: (0, _shareCopy.SIXES_PAGE_OG_TITLE),
        description: (0, _shareCopy.SIXES_PAGE_OG_DESCRIPTION),
        imageAlt: "Cricket8 Sixes",
        ogGame: "sixes",
        jsonLdApplication: buildGameLobbyApplication("Cricket8 Sixes", (0, _shareCopy.SIXES_PAGE_OG_DESCRIPTION), "/sixes")
    };
}
function buildAllGamesShareMeta() {
    return {
        title: (0, _shareCopy.GAMES_PAGE_OG_TITLE),
        description: (0, _shareCopy.GAMES_PAGE_OG_DESCRIPTION),
        imageAlt: (0, _shareCopy.OG_IMAGE_ALT),
        ogGame: "site",
        jsonLdApplication: buildGameLobbyApplication("Cricket8 Games", (0, _shareCopy.GAMES_PAGE_OG_DESCRIPTION), "/all-games")
    };
}
function buildAboutShareMeta(args = {}) {
    return {
        title: (0, _shareCopy.ABOUT_PAGE_OG_TITLE),
        description: (0, _shareCopy.ABOUT_PAGE_OG_DESCRIPTION),
        imageAlt: (0, _shareCopy.OG_IMAGE_ALT),
        ogGame: "site",
        ...args.jsonLdFaq?.length ? {
            jsonLdFaq: args.jsonLdFaq
        } : {}
    };
}
function buildHowToPlayShareMeta() {
    return {
        title: (0, _shareCopy.HOW_TO_PLAY_PAGE_OG_TITLE),
        description: (0, _shareCopy.HOW_TO_PLAY_PAGE_OG_DESCRIPTION),
        imageAlt: (0, _shareCopy.OG_IMAGE_ALT),
        ogGame: "site"
    };
}
function buildContactShareMeta() {
    return {
        title: (0, _shareCopy.CONTACT_PAGE_OG_TITLE),
        description: (0, _shareCopy.CONTACT_PAGE_OG_DESCRIPTION),
        imageAlt: (0, _shareCopy.OG_IMAGE_ALT),
        ogGame: "site"
    };
}
function buildXpLeaderboardShareMeta() {
    return {
        title: (0, _shareCopy.XP_LEADERBOARD_PAGE_OG_TITLE),
        description: (0, _shareCopy.XP_LEADERBOARD_PAGE_OG_DESCRIPTION),
        imageAlt: (0, _shareCopy.OG_IMAGE_ALT),
        ogGame: "site"
    };
}
function buildMatchesLobbyShareMeta() {
    return {
        title: (0, _shareCopy.MATCHES_PAGE_OG_TITLE),
        description: (0, _shareCopy.MATCHES_PAGE_OG_DESCRIPTION),
        imageAlt: "Cricket8 matches, fixtures and live scores",
        ogGame: "results"
    };
}
function buildResultsLobbyShareMeta() {
    return {
        title: (0, _shareCopy.RESULTS_PAGE_OG_TITLE),
        description: (0, _shareCopy.RESULTS_PAGE_OG_DESCRIPTION),
        imageAlt: "Cricket8 cricket results, scores and match outcomes",
        ogGame: "results"
    };
}
function buildSquaresRulesShareMeta(args = {}) {
    return {
        title: (0, _shareCopy.SQUARES_RULES_OG_TITLE),
        description: (0, _shareCopy.SQUARES_RULES_OG_DESCRIPTION),
        imageAlt: "Cricket8 Squares rules",
        ogGame: "squares",
        ...args.jsonLdFaq?.length ? {
            jsonLdFaq: args.jsonLdFaq
        } : {}
    };
}
function buildSixesMatchShareMeta(args) {
    const match = resolveMatchLabel(args);
    const title = match ? `${match} | Sixes on Cricket8` : "Sixes Match | Cricket8";
    const description = match ? `Play Sixes on Cricket8 for ${match} \u{2014} live match cricket cards and multiply coins.` : (0, _shareCopy.SIXES_PAGE_OG_DESCRIPTION);
    return {
        title,
        description,
        imageAlt: match ? `Cricket8 Sixes \u{2014} ${match}` : "Cricket8 Sixes",
        ogGame: "sixes",
        keywords: buildMatchSeoKeywords(match, "sixes"),
        jsonLdMatchName: match || undefined
    };
}
function buildLeaguesLobbyShareMeta(args = {}) {
    return {
        title: (0, _shareCopy.LEAGUES_PAGE_OG_TITLE),
        description: (0, _shareCopy.LEAGUES_PAGE_OG_DESCRIPTION),
        imageAlt: "Cricket8 Leagues",
        ogGame: "leagues",
        jsonLdApplication: buildGameLobbyApplication("Cricket8 Leagues", (0, _shareCopy.LEAGUES_PAGE_OG_DESCRIPTION), "/leagues"),
        ...args.jsonLdFaq?.length ? {
            jsonLdFaq: args.jsonLdFaq
        } : {}
    };
}
function buildLeagueInviteShareMeta(args = {}) {
    const leagueName = String(args.leagueName ?? "").trim();
    const match = resolveMatchLabel(args);
    const inviter = String(args.inviterName ?? "").trim();
    const leagueLabel = leagueName ? `"${leagueName}"` : "a Cricket8 league";
    if (inviter) {
        const matchBit = match ? ` for ${match}` : "";
        return {
            title: `${inviter} invited you to ${leagueLabel}`,
            description: `Join ${inviter} in ${leagueLabel}${matchBit} on Cricket8 Leagues \u{2014} play the match against friends.`,
            imageAlt: `${inviter} \u{2014} Cricket8 Leagues`,
            ogGame: "leagues",
            keywords: buildMatchSeoKeywords(match || leagueName, "leagues"),
            jsonLdMatchName: match || undefined
        };
    }
    if (leagueName && match) return {
        title: `${leagueName} | ${match} | Leagues on Cricket8`,
        description: `Join "${leagueName}" for ${match} on Cricket8 Leagues \u{2014} private tables with friends, ranked on the leaderboard.`,
        imageAlt: `Cricket8 Leagues \u{2014} ${leagueName}`,
        ogGame: "leagues",
        keywords: buildMatchSeoKeywords(match, "leagues"),
        jsonLdMatchName: match
    };
    if (leagueName) return {
        title: `${leagueName} | Leagues on Cricket8`,
        description: `Join "${leagueName}" on Cricket8 Leagues \u{2014} private tables with friends, pick which games to play, and battle for the leaderboard.`,
        imageAlt: `Cricket8 Leagues \u{2014} ${leagueName}`,
        ogGame: "leagues",
        keywords: buildMatchSeoKeywords(leagueName, "leagues")
    };
    if (match) return {
        title: `${match} | Leagues on Cricket8`,
        description: `Play Leagues on Cricket8 for ${match} \u{2014} private tables with friends, ranked on the leaderboard.`,
        imageAlt: `Cricket8 Leagues \u{2014} ${match}`,
        ogGame: "leagues",
        keywords: buildMatchSeoKeywords(match, "leagues"),
        jsonLdMatchName: match
    };
    return buildLeaguesLobbyShareMeta();
}
function buildLeagueResultsShareMeta(snapshot, args = {}) {
    const title = (0, _leagueResultsShare.buildLeagueResultsShareTitle)(snapshot);
    const description = (0, _leagueResultsShare.buildLeagueResultsOgDescription)(snapshot);
    return {
        title,
        description,
        imageAlt: title,
        ogGame: "leagues",
        ...args.imageUrl ? {
            imageUrl: args.imageUrl
        } : {},
        ...args.url ? {
            canonicalUrl: args.url
        } : {},
        keywords: buildMatchSeoKeywords(snapshot.matchLabel || snapshot.leagueName, "leagues"),
        jsonLdMatchName: snapshot.matchLabel || undefined
    };
}

},{"./shareCopy":"9P9zX","../components/Leagues/lib/leagueResultsShare":"4vA9D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4vA9D":[function(require,module,exports,__globalThis) {
/**
 * Finished-league results share — compact URL snapshot (`/leagues?r=`).
 * Public card shows podium + roast awards only (no wallets / full table).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEAGUE_RESULTS_SHARE_QUERY", ()=>LEAGUE_RESULTS_SHARE_QUERY);
parcelHelpers.export(exports, "LEAGUE_RESULTS_SHARE_CODE_RE", ()=>LEAGUE_RESULTS_SHARE_CODE_RE);
parcelHelpers.export(exports, "isLeagueResultsShareCode", ()=>isLeagueResultsShareCode);
/**
 * Avatar URL for the in-app share card (full URL ok — not put in the query string when using short codes).
 */ parcelHelpers.export(exports, "clipShareAvatarUrl", ()=>clipShareAvatarUrl);
/** Frame artwork URL for short-code snapshots (absolute https only; legacy inline tokens omit frames). */ parcelHelpers.export(exports, "clipShareFrameUrl", ()=>clipShareFrameUrl);
/** Build a public snapshot from a finished league for the current viewer. */ parcelHelpers.export(exports, "buildLeagueResultsShareSnapshot", ()=>buildLeagueResultsShareSnapshot);
parcelHelpers.export(exports, "encodeLeagueResultsShareToken", ()=>encodeLeagueResultsShareToken);
parcelHelpers.export(exports, "decodeLeagueResultsShareToken", ()=>decodeLeagueResultsShareToken);
parcelHelpers.export(exports, "leagueResultsSharePath", ()=>leagueResultsSharePath);
parcelHelpers.export(exports, "readLeagueResultsShareTokenFromSearch", ()=>readLeagueResultsShareTokenFromSearch);
/** Podium finish line — share uses I/name; in-app member view keeps "You". */ parcelHelpers.export(exports, "formatLeagueResultsFinishLine", ()=>formatLeagueResultsFinishLine);
/** "League name · Match" line under "League finished!". */ parcelHelpers.export(exports, "leagueResultsShareSubtitle", ()=>leagueResultsShareSubtitle);
parcelHelpers.export(exports, "LEAGUE_RESULTS_SHARE_TEXTS", ()=>LEAGUE_RESULTS_SHARE_TEXTS);
parcelHelpers.export(exports, "buildLeagueResultsShareText", ()=>buildLeagueResultsShareText);
parcelHelpers.export(exports, "buildLeagueResultsShareTitle", ()=>buildLeagueResultsShareTitle);
parcelHelpers.export(exports, "LEAGUE_RESULTS_OG_DESCRIPTION", ()=>LEAGUE_RESULTS_OG_DESCRIPTION);
parcelHelpers.export(exports, "buildLeagueResultsOgDescription", ()=>buildLeagueResultsOgDescription);
var _sessionUser = require("../../../utils/sessionUser");
var _leagueFormat = require("./leagueFormat");
var _leagueXp = require("./leagueXp");
var _leagueReactionStats = require("./leagueReactionStats");
var _leagueReactions = require("./leagueReactions");
var Buffer = require("cb4aea6f4d04df3").Buffer;
const LEAGUE_RESULTS_SHARE_QUERY = "r";
const LEAGUE_RESULTS_SHARE_CODE_RE = /^[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{8}$/i;
const MAX_NAME = 24;
const MAX_LEAGUE = 40;
const MAX_MATCH = 48;
/**
 * Short-code shares store avatars in DB JSON — allow long Google / upload URLs.
 * (Legacy inline `?r=` tokens still omit non-catalog URLs via `compactAvatarForWire`.)
 */ const MAX_AVATAR_URL = 2000;
const AVATAR_CDN_BASE = "https://cricket8-web-content.s3.amazonaws.com/avatars";
function isLeagueResultsShareCode(value) {
    return LEAGUE_RESULTS_SHARE_CODE_RE.test(String(value ?? "").trim());
}
const AWARD_LABEL = {
    poop: "Most roasted",
    rofl: "Most laughed at",
    rocket: "Most hyped",
    fire: "Most on fire",
    clap: "Most respected",
    cry: "Most salt"
};
function clip(value, max) {
    const s = String(value ?? "").trim().replace(/\s+/g, " ");
    if (s.length <= max) return s;
    return `${s.slice(0, Math.max(1, max - 1))}\u{2026}`;
}
function clipShareAvatarUrl(raw) {
    const resolved = (0, _sessionUser.resolveAvatarUrl)({
        avatar: raw
    });
    if (!(0, _sessionUser.isUsableAvatarUrl)(resolved)) return undefined;
    let url = String(resolved).trim();
    if (url.startsWith("//")) url = `https:${url}`;
    else if (url.startsWith("/") && typeof window !== "undefined" && window.location?.origin) url = `${window.location.origin}${url}`;
    // Prefer full catalog PNG — WebP thumbs 403 as .png and don't paint in OG resvg.
    const catalog = url.match(/\/avatars\/(?:thumbs\/(?:\d+\/)?)?([a-z0-9-]+)\.(?:webp|png|jpe?g)(?:\?|$)/i);
    if (catalog?.[1]) url = `${AVATAR_CDN_BASE}/${catalog[1].toLowerCase()}.png`;
    const okAbsolute = /^https?:\/\//i.test(url);
    const okRelative = url.startsWith("/");
    if (!okAbsolute && !okRelative) return undefined;
    if (url.length > MAX_AVATAR_URL) return undefined;
    return url;
}
function clipShareFrameUrl(raw) {
    const url = String(raw ?? "").trim();
    if (!/^https:\/\//i.test(url) || url.length > MAX_AVATAR_URL) return undefined;
    return url;
}
/** Catalog key for legacy inline tokens — `giraffe-orange` instead of a full CDN URL. */ function compactAvatarForWire(url) {
    if (!url) return undefined;
    const m = String(url).match(/\/avatars\/(?:thumbs\/(?:\d+\/)?)?([a-z0-9-]+)\.(?:png|webp|jpe?g)(?:\?|$)/i);
    if (m?.[1]) return m[1].toLowerCase();
    return undefined;
}
function expandAvatarFromWire(raw) {
    const value = String(raw ?? "").trim();
    if (!value) return undefined;
    if (/^https?:\/\//i.test(value) || value.startsWith("/")) return clipShareAvatarUrl(value);
    if (/^[a-z0-9-]+$/i.test(value)) return `${AVATAR_CDN_BASE}/${value.toLowerCase()}.png`;
    return undefined;
}
function matchLabelFromLeague(league) {
    const raw = String(league.fixture?.name ?? "").trim();
    if (!raw) return "";
    return clip(raw.split(",")[0].trim() || raw, MAX_MATCH);
}
function buildLeagueResultsShareSnapshot(league, viewerUserId) {
    if (league.status !== "ended") return null;
    const rows = (0, _leagueFormat.leagueTableRows)(league);
    if (rows.length === 0) return null;
    const prizes = (0, _leagueFormat.leaguePrizeSplit)(league);
    const viewerId = viewerUserId != null ? Number(viewerUserId) : NaN;
    const me = (Number.isFinite(viewerId) ? rows.find((row)=>row.userId === viewerId) : null) ?? rows.find((row)=>row.isViewer) ?? rows[0];
    const podium = rows.slice(0, 3).map((row)=>{
        const prize = row.rank >= 1 && row.rank <= prizes.length ? prizes[row.rank - 1] : undefined;
        const seat = {
            name: clip(row.playerName, MAX_NAME),
            rank: row.rank
        };
        const points = Math.round(Number(row.wonPoints) || 0);
        if (points > 0) seat.points = points;
        if (prize != null && prize > 0) seat.prize = Math.round(prize);
        const avatar = clipShareAvatarUrl(row.avatar);
        if (avatar) seat.avatar = avatar;
        const frame = clipShareFrameUrl(row.avatarFrameUrl);
        if (frame) seat.frame = frame;
        return seat;
    });
    const awards = (0, _leagueReactionStats.leagueReactionCallouts)(league).slice(0, (0, _leagueReactionStats.LEAGUE_REACTION_AWARD_CAP)).map((callout)=>{
        const award = {
            emoji: callout.emoji,
            label: callout.label,
            name: clip(callout.member.playerName, MAX_NAME),
            count: callout.count
        };
        const avatar = clipShareAvatarUrl(callout.member.avatar);
        if (avatar) award.avatar = avatar;
        return award;
    });
    const sharerPrize = me.rank >= 1 && me.rank <= prizes.length ? prizes[me.rank - 1] : undefined;
    const sharerXp = (0, _leagueXp.leagueXpForRow)(league, me);
    const sharerAvatar = clipShareAvatarUrl(me.avatar);
    const sharerFrame = clipShareFrameUrl(me.avatarFrameUrl);
    const snap = {
        v: 1,
        leagueName: clip(league.name || "Cricket8 League", MAX_LEAGUE),
        matchLabel: matchLabelFromLeague(league),
        sharerName: clip(me.playerName, MAX_NAME),
        sharerRank: me.rank,
        podium,
        awards
    };
    if (sharerPrize != null && sharerPrize > 0) snap.sharerPrize = Math.round(sharerPrize);
    if (sharerXp > 0) snap.sharerXp = Math.round(sharerXp);
    if (sharerAvatar) snap.sharerAvatar = sharerAvatar;
    if (sharerFrame) snap.sharerFrame = sharerFrame;
    return snap;
}
function toWire(snap) {
    const wire = {
        v: 1,
        ln: snap.leagueName,
        sn: snap.sharerName,
        sr: snap.sharerRank,
        t: snap.podium.map((seat)=>{
            const row = {
                n: seat.name,
                rk: seat.rank
            };
            if (seat.points != null && seat.points > 0) row.pts = seat.points;
            if (seat.prize != null && seat.prize > 0) row.p = seat.prize;
            const av = compactAvatarForWire(seat.avatar);
            if (av) row.av = av;
            return row;
        })
    };
    if (snap.matchLabel) wire.m = snap.matchLabel;
    if (snap.sharerPrize != null && snap.sharerPrize > 0) wire.sp = snap.sharerPrize;
    if (snap.sharerXp != null && snap.sharerXp > 0) wire.sx = snap.sharerXp;
    const sav = compactAvatarForWire(snap.sharerAvatar);
    if (sav) wire.sav = sav;
    if (snap.awards.length > 0) wire.a = snap.awards.map((a)=>{
        const row = {
            e: a.emoji,
            n: a.name,
            c: a.count
        };
        const av = compactAvatarForWire(a.avatar);
        if (av) row.av = av;
        return row;
    });
    return wire;
}
function fromWire(raw) {
    if (!raw || typeof raw !== "object") return null;
    const o = raw;
    if (Number(o.v) !== 1) return null;
    const leagueName = clip(String(o.ln ?? ""), MAX_LEAGUE);
    const sharerName = clip(String(o.sn ?? ""), MAX_NAME);
    const sharerRank = Math.max(0, Math.floor(Number(o.sr) || 0));
    if (!leagueName || !sharerName || sharerRank < 1) return null;
    const top = Array.isArray(o.t) ? o.t : [];
    const podium = [];
    for (const item of top.slice(0, 3)){
        if (!item || typeof item !== "object") continue;
        const row = item;
        const name = clip(String(row.n ?? ""), MAX_NAME);
        const rank = Math.max(0, Math.floor(Number(row.rk) || 0));
        if (!name || rank < 1) continue;
        const seat = {
            name,
            rank
        };
        const points = Math.floor(Number(row.pts) || 0);
        if (points > 0) seat.points = points;
        const prize = Math.floor(Number(row.p) || 0);
        if (prize > 0) seat.prize = prize;
        const avatar = expandAvatarFromWire(typeof row.av === "string" ? row.av : undefined);
        if (avatar) seat.avatar = avatar;
        podium.push(seat);
    }
    if (podium.length === 0) return null;
    const awards = [];
    if (Array.isArray(o.a)) for (const item of o.a.slice(0, (0, _leagueReactionStats.LEAGUE_REACTION_AWARD_CAP))){
        if (!item || typeof item !== "object") continue;
        const row = item;
        const emoji = row.e;
        if (!(0, _leagueReactions.isLeagueReactionEmoji)(emoji)) continue;
        const name = clip(String(row.n ?? ""), MAX_NAME);
        const count = Math.max(0, Math.floor(Number(row.c) || 0));
        if (!name || count < 1) continue;
        const award = {
            emoji,
            label: AWARD_LABEL[emoji],
            name,
            count
        };
        const avatar = expandAvatarFromWire(typeof row.av === "string" ? row.av : undefined);
        if (avatar) award.avatar = avatar;
        awards.push(award);
    }
    const snap = {
        v: 1,
        leagueName,
        matchLabel: clip(String(o.m ?? ""), MAX_MATCH),
        sharerName,
        sharerRank,
        podium,
        awards
    };
    const sp = Math.floor(Number(o.sp) || 0);
    const sx = Math.floor(Number(o.sx) || 0);
    if (sp > 0) snap.sharerPrize = sp;
    if (sx > 0) snap.sharerXp = sx;
    const sharerAvatar = expandAvatarFromWire(typeof o.sav === "string" ? o.sav : undefined);
    if (sharerAvatar) snap.sharerAvatar = sharerAvatar;
    return snap;
}
function bytesToBase64Url(bytes) {
    let bin = "";
    for(let i = 0; i < bytes.length; i++)bin += String.fromCharCode(bytes[i]);
    const b64 = typeof btoa === "function" ? btoa(bin) : Buffer.from(bytes).toString("base64");
    return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}
function base64UrlToBytes(token) {
    const padded = token.replace(/-/g, "+").replace(/_/g, "/");
    const pad = padded.length % 4 === 0 ? "" : "=".repeat(4 - padded.length % 4);
    try {
        if (typeof atob === "function") {
            const bin = atob(padded + pad);
            const out = new Uint8Array(bin.length);
            for(let i = 0; i < bin.length; i++)out[i] = bin.charCodeAt(i);
            return out;
        }
        return new Uint8Array(Buffer.from(padded + pad, "base64"));
    } catch  {
        return null;
    }
}
function encodeLeagueResultsShareToken(snapshot) {
    const json = JSON.stringify(toWire(snapshot));
    if (typeof TextEncoder !== "undefined") return bytesToBase64Url(new TextEncoder().encode(json));
    return bytesToBase64Url(Uint8Array.from(Buffer.from(json, "utf8")));
}
function decodeLeagueResultsShareToken(token) {
    const raw = String(token ?? "").trim();
    if (!raw || raw.length > 6000) return null;
    const bytes = base64UrlToBytes(raw);
    if (!bytes || bytes.length === 0) return null;
    try {
        const json = typeof TextDecoder !== "undefined" ? new TextDecoder().decode(bytes) : Buffer.from(bytes).toString("utf8");
        return fromWire(JSON.parse(json));
    } catch  {
        return null;
    }
}
function leagueResultsSharePath(token, basePath = "/leagues") {
    const trimmed = String(token ?? "").trim();
    if (!trimmed) return basePath;
    const params = new URLSearchParams();
    params.set(LEAGUE_RESULTS_SHARE_QUERY, trimmed);
    return `${basePath}?${params}`;
}
function readLeagueResultsShareTokenFromSearch(search) {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    const value = new URLSearchParams(raw).get(LEAGUE_RESULTS_SHARE_QUERY);
    return value?.trim() ? value.trim() : null;
}
function formatLeagueResultsFinishLine(snapshot, voice) {
    const rank = (0, _leagueFormat.formatLeagueRankLabel)(snapshot.sharerRank).toLowerCase();
    const who = voice === "I" ? "I" : voice === "you" ? "You" : clip(snapshot.sharerName, MAX_NAME) || "They";
    const won = snapshot.sharerPrize != null && snapshot.sharerPrize > 0 ? ` and won ${Math.round(snapshot.sharerPrize).toLocaleString()} coins` : "";
    return `${who} finished ${rank}${won}!`;
}
/** Leagues are often named after their fixture — don't repeat it. */ function distinctMatchLabel(snapshot) {
    const match = String(snapshot.matchLabel ?? "").trim();
    if (!match) return "";
    return match.toLowerCase() === String(snapshot.leagueName ?? "").trim().toLowerCase() ? "" : match;
}
function leagueResultsShareSubtitle(snapshot) {
    return [
        snapshot.leagueName,
        distinctMatchLabel(snapshot)
    ].filter(Boolean).join(" \xb7 ");
}
const LEAGUE_RESULTS_SHARE_TEXTS = {
    winner: [
        "Top of the podium \uD83D\uDC51 Who's taking my crown?",
        "Champion \uD83C\uDFC6 Come and have a go if you think you're good enough.",
        "Won it \uD83E\uDD47 Fancy a rematch?",
        "Undefeated \uD83D\uDE0E Next match, you and me?"
    ],
    podium: [
        "Think you can beat me? \uD83C\uDFCF",
        "So close to the top \uD83D\uDE24 Rematch, anyone?",
        "Podium finish \uD83D\uDD25 Your move.",
        "Next time that crown's mine \uD83D\uDC51 Who's in?"
    ],
    rest: [
        "Think you can beat me? \uD83C\uDFCF",
        "I'll get you next time \uD83D\uDE24 Who's up for a rematch?",
        "Not my day\u2026 fancy a rematch? \uD83D\uDE05",
        "Bring it on next match \uD83C\uDFCF Who's in?"
    ]
};
function buildLeagueResultsShareText(snapshot, random = Math.random) {
    const rank = snapshot.sharerRank;
    const pool = rank === 1 ? LEAGUE_RESULTS_SHARE_TEXTS.winner : rank === 2 || rank === 3 ? LEAGUE_RESULTS_SHARE_TEXTS.podium : LEAGUE_RESULTS_SHARE_TEXTS.rest;
    return pool[Math.min(pool.length - 1, Math.floor(random() * pool.length))];
}
function buildLeagueResultsShareTitle(snapshot) {
    const rank = (0, _leagueFormat.formatLeagueRankLabel)(snapshot.sharerRank).toLowerCase();
    const league = snapshot.leagueName || "a Cricket8 league";
    return `${snapshot.sharerName} finished ${rank} in ${league}`;
}
const LEAGUE_RESULTS_OG_DESCRIPTION = "Create a league and battle your friends on every match.";
function buildLeagueResultsOgDescription(_snapshot) {
    return LEAGUE_RESULTS_OG_DESCRIPTION;
}

},{"cb4aea6f4d04df3":"l5Twm","../../../utils/sessionUser":"4xtMD","./leagueFormat":"jKCIi","./leagueXp":"6plTO","./leagueReactionStats":"8M1NW","./leagueReactions":"eP1Fb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l5Twm":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"6Pb1S":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"6ifNR":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"jKCIi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Spendable chips that count toward the seat top-up threshold. Open Squares,
 * Trader, and other holds are excluded until they settle (or are edited down).
 */ parcelHelpers.export(exports, "seatChipsCountingTowardTopUp", ()=>seatChipsCountingTowardTopUp);
parcelHelpers.export(exports, "formatCoins", ()=>formatCoins);
/** Match format overs for seat sizing (null → default T20 rate). */ parcelHelpers.export(exports, "leagueFormatOvers", ()=>leagueFormatOvers);
/** Chips credited for one seat top-up pack (format-aware). */ parcelHelpers.export(exports, "seatTopUpChips", ()=>seatTopUpChips);
/** Prize-pot coins added for one seat top-up pack. */ parcelHelpers.export(exports, "seatTopUpPrizeCoins", ()=>seatTopUpPrizeCoins);
parcelHelpers.export(exports, "memberSeatTopups", ()=>memberSeatTopups);
parcelHelpers.export(exports, "memberSeatTopupsRemaining", ()=>memberSeatTopupsRemaining);
/**
 * True when a match-scoped league's cricket fixture is finished (or stamped finished)
 * even if the league is still `live` while plays settle / results publish.
 */ parcelHelpers.export(exports, "leagueFixtureIsFinishedForTopUp", ()=>leagueFixtureIsFinishedForTopUp);
/**
 * Match finished, league still live — plays grading / prize not paid yet.
 * Player-facing status: "RESULTS SOON" (not FINISHED / Ended).
 */ parcelHelpers.export(exports, "leagueIsAwaitingFinalResults", ()=>leagueIsAwaitingFinalResults);
/** True when the viewer may open the seat top-up modal (joined, league still active). */ parcelHelpers.export(exports, "canOpenLeagueSeatTopUp", ()=>canOpenLeagueSeatTopUp);
/**
 * Top-up opens once spendable chips are at or below
 * {@link SEAT_TOPUP_AVAILABLE_AT_OR_BELOW}. 0 when every included game is free —
 * nothing to top up for. Mirrors `seatTopUpAvailableAtOrBelow` on the backend.
 */ parcelHelpers.export(exports, "leagueSeatTopUpAvailableAtOrBelow", ()=>leagueSeatTopUpAvailableAtOrBelow);
/**
 * True when the viewer can complete a seat top-up purchase: under the pack cap and
 * spendable chips at or below the restock threshold. Open Squares stakes (including
 * overs that have not started) do not count — same as Trader holds.
 */ parcelHelpers.export(exports, "canPurchaseLeagueSeatTopUp", ()=>canPurchaseLeagueSeatTopUp);
/** @deprecated Prefer {@link canPurchaseLeagueSeatTopUp}. */ parcelHelpers.export(exports, "canTopUpLeagueSeat", ()=>canTopUpLeagueSeat);
/** Roster line: paid seats, e.g. "1 joined". */ parcelHelpers.export(exports, "formatJoinedCountLabel", ()=>formatJoinedCountLabel);
/** Unsettled stakes across the league — not a people count. */ parcelHelpers.export(exports, "formatOpenPlaysCountLabel", ()=>formatOpenPlaysCountLabel);
parcelHelpers.export(exports, "OPEN_PLAYS_COUNT_HINT", ()=>OPEN_PLAYS_COUNT_HINT);
/**
 * The first league the viewer hosts or joined for a given fixture, if any.
 * Pure over any `leagues` array so it works with both the prototype and the API snapshot.
 */ parcelHelpers.export(exports, "findViewerLeagueForFixture", ()=>findViewerLeagueForFixture);
/** Signed coin P/L, e.g. "+1,250" / "-400" / "0". */ parcelHelpers.export(exports, "formatPl", ()=>formatPl);
/** Non-negative WON points for standings chrome, e.g. "3,349". */ parcelHelpers.export(exports, "formatWonPoints", ()=>formatWonPoints);
/** Uppercase ordinal for activity / podium chrome, e.g. "1ST" / "2ND" / "3RD". */ parcelHelpers.export(exports, "formatLeagueRankLabel", ()=>formatLeagueRankLabel);
parcelHelpers.export(exports, "plTextClass", ()=>plTextClass);
/** WON points accent — same green as the leaderboard WON column. */ parcelHelpers.export(exports, "wonPointsTextClass", ()=>wonPointsTextClass);
/**
 * Seat chips on create/join. Fixed per match format — does not scale with entry fee.
 * `entryFeeRubies` is kept for call-site compatibility; prize pot still uses the fee.
 */ parcelHelpers.export(exports, "startingCoinsFor", ()=>startingCoinsFor);
parcelHelpers.export(exports, "leaguePrizePotCoinsForSeats", ()=>leaguePrizePotCoinsForSeats);
/**
 * Coin prize pot for display / payouts.
 * Prefer the stored pot (entries + seat top-ups from the API); fall back to
 * entry×seats when older prototype rows omit `prizePotCoins`.
 */ parcelHelpers.export(exports, "leaguePrizePotCoins", ()=>leaguePrizePotCoins);
/** Prize pot after this viewer pays the same entry as everyone else. */ parcelHelpers.export(exports, "leaguePrizePotCoinsAfterJoin", ()=>leaguePrizePotCoinsAfterJoin);
parcelHelpers.export(exports, "memberPl", ()=>memberPl);
parcelHelpers.export(exports, "memberTotals", ()=>memberTotals);
/**
 * Games this fixture can actually host.
 * Omitted/`undefined` = all four (legacy prototype fixtures). Explicit `[]` = none available.
 */ parcelHelpers.export(exports, "fixtureAvailableGames", ()=>fixtureAvailableGames);
/** Games that count in this league. Older saved leagues without the field default to all four. Always canonical order. */ parcelHelpers.export(exports, "leagueIncludedGames", ()=>leagueIncludedGames);
/** Short label for cards and the create review step, e.g. "Sixes & Bullion" or "All games". */ parcelHelpers.export(exports, "formatIncludedGamesLabel", ()=>formatIncludedGamesLabel);
/**
 * Compact season line for League Mode chrome, e.g. "RUBY RUMBLE - R4".
 * Uses the last two words of the league name when long, plus a round from elapsed time.
 */ parcelHelpers.export(exports, "leagueModeSeasonLabel", ()=>leagueModeSeasonLabel);
parcelHelpers.export(exports, "leagueStatus", ()=>leagueStatus);
/**
 * Card/header countdown. Live match leagues omit an end time — cricket finish is
 * unknown, and `endsAt` is only a durationHours estimate (extended while in play).
 */ parcelHelpers.export(exports, "leagueTimingLabel", ()=>leagueTimingLabel);
parcelHelpers.export(exports, "leagueStatusLabel", ()=>leagueStatusLabel);
/**
 * Hub-card header. Match leagues stay `live` while plays settle (endsAt is pushed forward).
 * A finished fixture while the league is still live reads RESULTS SOON; true end → FINISHED.
 */ parcelHelpers.export(exports, "leagueHubCardStatus", ()=>leagueHubCardStatus);
/**
 * Match centre strip (white games scorecard + sticky detail tabs). Shown for every non-refunded
 * match league — prematch renders the same scorecard with a countdown so upcoming and live match.
 */ parcelHelpers.export(exports, "leagueShowsMatchCentre", ()=>leagueShowsMatchCentre);
/** Lobby card + match strip status — respects league ended and finished cricket fixtures. */ parcelHelpers.export(exports, "leagueFixtureDisplayStatus", ()=>leagueFixtureDisplayStatus);
/** Players who paid to join, excluding the host, who seeds the league. */ parcelHelpers.export(exports, "leagueRealJoiners", ()=>leagueRealJoiners);
/** How many more real joiners are needed before the league can lock in and pay out. */ parcelHelpers.export(exports, "leagueJoinersNeeded", ()=>leagueJoinersNeeded);
/** Server already cancelled this league (kickoff under-fill or admin). */ parcelHelpers.export(exports, "isLeagueCancelled", ()=>isLeagueCancelled);
/**
 * Non-member opening a finished public league — show the public podium instead of join-closed.
 * Requires a server settle (`settledAt` / status ended). Cancelled leagues keep refund copy.
 */ parcelHelpers.export(exports, "isPublicLeagueSpectatorResults", ()=>isPublicLeagueSpectatorResults);
/**
 * A match league that reaches kickoff without the minimum real joiners is
 * cancelled: no play happens, no XP is granted, and every ruby debit (create
 * fee + entries) is reversed. Prefer `cancelledAt` from the API when present.
 */ parcelHelpers.export(exports, "isLeagueRefunded", ()=>isLeagueRefunded);
/**
 * My Games drawer PAST tab: same “today only” rule as settled games — show an ended /
 * cancelled league when pot settle, match finish, scheduled end, or cancel falls on the
 * local calendar day. Full My Zone history still lists every past league.
 */ parcelHelpers.export(exports, "isEndedLeagueForMyGamesDrawer", ()=>isEndedLeagueForMyGamesDrawer);
/**
 * XP only becomes claimable once the league has started and cleared the
 * minimum-joiner bar (so it can never be refunded). Before that, nothing is
 * awarded — this is the anti-farm guard.
 */ parcelHelpers.export(exports, "isLeagueXpLive", ()=>isLeagueXpLive);
/**
 * Final podium rows once the league has settled. Eligible = at least one settled play
 * (same gate as prize coins / XP). All-games filter only — not game-specific.
 */ parcelHelpers.export(exports, "leaguePlacementPastMembers", ()=>leaguePlacementPastMembers);
/** Distinct settled games for a member (activity / stats helpers). */ parcelHelpers.export(exports, "leagueDistinctSettledGames", ()=>leagueDistinctSettledGames);
parcelHelpers.export(exports, "leagueTableRows", ()=>leagueTableRows);
/**
 * True once anyone has WON points, a settled play, or a live Bullion slip score.
 * Open 0-score Sixes/Bullion cards issued before toss do not count — toss-settled
 * scores do, even while the league is still `upcoming` (kickoff has not happened yet).
 * Open Bullion if-now place bonus does not count (that is not Overall until settle).
 * Live pick scores do count toward Overall.
 */ parcelHelpers.export(exports, "leagueLeaderboardHasScores", ()=>leagueLeaderboardHasScores);
/**
 * Whether activity ranks / leaderboard bars are meaningful yet.
 */ parcelHelpers.export(exports, "leagueActivityRanksReady", ()=>leagueActivityRanksReady);
/** Coin payout per finishing position from the ruby-funded pot. */ parcelHelpers.export(exports, "leaguePrizeSplit", ()=>leaguePrizeSplit);
parcelHelpers.export(exports, "viewerRow", ()=>viewerRow);
/** "2d 4h", "4h 12m", "38s" — coarse countdown for cards and headers. */ parcelHelpers.export(exports, "formatCountdown", ()=>formatCountdown);
parcelHelpers.export(exports, "formatDateTime", ()=>formatDateTime);
parcelHelpers.export(exports, "formatTimeAgo", ()=>formatTimeAgo);
/** "1 day", "3 days", "1 week 2 days" — human summary of a league window. */ parcelHelpers.export(exports, "formatDurationBetween", ()=>formatDurationBetween);
parcelHelpers.export(exports, "combineDateAndTime", ()=>combineDateAndTime);
/** Local `YYYY-MM-DD` for date-only inputs. */ parcelHelpers.export(exports, "toDateInputValue", ()=>toDateInputValue);
/** "Today", "Tomorrow", or "Wed 13 Aug" — groups fixture lists in the create flow. */ parcelHelpers.export(exports, "formatFixtureDayHeading", ()=>formatFixtureDayHeading);
/** "In 1h 20m" when close; otherwise "Today · 14:30" / "Tomorrow · …" / "Starts in …". */ parcelHelpers.export(exports, "formatFixtureStartLabel", ()=>formatFixtureStartLabel);
/** Status line + colour for compact match-card headers in the league fixture picker. */ parcelHelpers.export(exports, "leagueFixtureCardStatus", ()=>leagueFixtureCardStatus);
/** End timestamp for a duration preset card (18:00 local, bumped if too soon). */ parcelHelpers.export(exports, "presetEndPreviewIso", ()=>presetEndPreviewIso);
/** Shorter date for preset cards, e.g. "Wed 13 Aug · 18:00". */ parcelHelpers.export(exports, "formatEndPreview", ()=>formatEndPreview);
parcelHelpers.export(exports, "LEAGUE_END_TIME_OPTIONS", ()=>LEAGUE_END_TIME_OPTIONS);
parcelHelpers.export(exports, "memberInitial", ()=>memberInitial);
var _constants = require("./constants");
var _matchUtils = require("../../Games/matchUtils");
var _leagueLiveFixtures = require("./leagueLiveFixtures");
var _leagueLeaderboardBar = require("./leagueLeaderboardBar");
function openStakeOnPlay(play) {
    return Math.max(0, Math.floor(Number(play.stake) || 0));
}
/** Open stakes already committed to plays — they do not block a seat top-up. */ function committedOpenStakeForTopUp(league, viewerUserId) {
    return (league.plays || []).filter((play)=>play.status === "open" && play.userId === viewerUserId).reduce((total, play)=>total + openStakeOnPlay(play), 0);
}
function seatChipsCountingTowardTopUp(league, viewerUserId) {
    const member = league.members.find((row)=>row.userId === viewerUserId);
    if (!member) return 0;
    const coins = Math.max(0, Math.floor(Number(member.coins) || 0));
    return Math.max(0, coins - committedOpenStakeForTopUp(league, viewerUserId));
}
function formatCoins(value) {
    return Math.round(value).toLocaleString();
}
function leagueFormatOvers(league) {
    const raw = league?.fixture?.formatOvers;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
}
function seatTopUpChips(formatOvers) {
    return (0, _constants.SEAT_TOPUP_RUBIES) * (0, _constants.chipsPerRubyForFormat)(formatOvers);
}
function seatTopUpPrizeCoins() {
    return (0, _constants.SEAT_TOPUP_RUBIES) * (0, _constants.PRIZE_COINS_PER_RUBY);
}
function memberSeatTopups(member) {
    return Math.max(0, Math.floor(Number(member?.seatTopups) || 0));
}
function memberSeatTopupsRemaining(member, formatOvers) {
    return Math.max(0, (0, _constants.seatTopUpMax)(formatOvers) - memberSeatTopups(member));
}
function leagueFixtureIsFinishedForTopUp(league, opts) {
    if (league.scope !== "match") return false;
    return Boolean(opts?.fixtureFinished) || Boolean(league.matchFinishedAt);
}
function leagueIsAwaitingFinalResults(league, now = Date.now(), opts) {
    if (isLeagueRefunded(league, now)) return false;
    if (leagueStatus(league, now) !== "live") return false;
    return leagueFixtureIsFinishedForTopUp(league, opts);
}
function canOpenLeagueSeatTopUp(league, viewerUserId, now = Date.now(), opts) {
    if (isLeagueRefunded(league, now)) return false;
    const status = leagueStatus(league, now);
    if (status === "ended") return false;
    // Match finished / settling — no more top-ups while results may still be unpublished.
    if (leagueFixtureIsFinishedForTopUp(league, opts)) return false;
    if (league.membership !== "host" && league.membership !== "member") return false;
    return Boolean(league.members.find((row)=>row.userId === viewerUserId));
}
function leagueSeatTopUpAvailableAtOrBelow(league) {
    const largestMin = leagueIncludedGames(league).reduce((max, game)=>Math.max(max, (0, _constants.LEAGUE_GAME_MIN_STAKE)[game]), 0);
    if (largestMin <= 0) return 0;
    return 0, _constants.SEAT_TOPUP_AVAILABLE_AT_OR_BELOW;
}
function canPurchaseLeagueSeatTopUp(league, viewerUserId, now = Date.now(), opts) {
    if (!canOpenLeagueSeatTopUp(league, viewerUserId, now, opts)) return false;
    const member = league.members.find((row)=>row.userId === viewerUserId);
    if (!member || memberSeatTopupsRemaining(member, leagueFormatOvers(league)) <= 0) return false;
    const atOrBelow = leagueSeatTopUpAvailableAtOrBelow(league);
    if (atOrBelow <= 0) return false;
    return seatChipsCountingTowardTopUp(league, viewerUserId) <= atOrBelow;
}
function canTopUpLeagueSeat(league, viewerUserId, now = Date.now()) {
    return canPurchaseLeagueSeatTopUp(league, viewerUserId, now);
}
function formatJoinedCountLabel(count) {
    return `${count} joined`;
}
function formatOpenPlaysCountLabel(count) {
    return count === 1 ? "1 play open" : `${count} plays open`;
}
const OPEN_PLAYS_COUNT_HINT = "Unsettled Sixes, Bullion, Trader or Squares+ plays \u2014 balls are locked until they settle.";
function findViewerLeagueForFixture(leagues, fixtureId, excludeLeagueId) {
    if (!fixtureId) return null;
    return leagues.find((league)=>league.id !== excludeLeagueId && (league.membership === "host" || league.membership === "member") && league.fixture?.id === fixtureId) ?? null;
}
function formatPl(value) {
    const rounded = Math.round(value);
    if (rounded === 0) return "0";
    return `${rounded > 0 ? "+" : "\u2212"}${Math.abs(rounded).toLocaleString()}`;
}
function formatWonPoints(value) {
    return Math.max(0, Math.round(value)).toLocaleString();
}
function formatLeagueRankLabel(rank) {
    const n = Math.max(0, Math.round(rank));
    if (n <= 0) return "";
    const mod100 = n % 100;
    let suffix = "TH";
    if (mod100 < 11 || mod100 > 13) {
        const mod10 = n % 10;
        if (mod10 === 1) suffix = "ST";
        else if (mod10 === 2) suffix = "ND";
        else if (mod10 === 3) suffix = "RD";
    }
    return `${n}${suffix}`;
}
function plTextClass(value) {
    if (value > 0) return "text-[#32F78C]";
    if (value < 0) return "text-[#F73261]";
    return "text-white/70";
}
function wonPointsTextClass(value) {
    return value > 0 ? "text-[#32F78C]" : "text-white/50";
}
function startingCoinsFor(_entryFeeRubies, formatOvers) {
    return (0, _constants.chipsPerRubyForFormat)(formatOvers);
}
function leaguePrizePotCoinsForSeats(entryFeeRubies, seats) {
    return Math.max(0, Math.round(entryFeeRubies)) * Math.max(0, seats) * (0, _constants.PRIZE_COINS_PER_RUBY);
}
function leaguePrizePotCoins(league) {
    const stored = league.prizePotCoins;
    if (stored != null && Number.isFinite(Number(stored))) return Math.max(0, Math.round(Number(stored)));
    return leaguePrizePotCoinsForSeats(league.entryFeeRubies, league.members.length);
}
function leaguePrizePotCoinsAfterJoin(league) {
    const entryBump = Math.max(0, Math.round(league.entryFeeRubies)) * (0, _constants.PRIZE_COINS_PER_RUBY);
    return leaguePrizePotCoins(league) + entryBump;
}
function memberPl(member) {
    return member.coins - member.startingCoins;
}
function memberTotals(member, games = (0, _constants.LEAGUE_GAME_KEYS)) {
    return games.reduce((acc, key)=>{
        const stats = member.byGame[key];
        if (!stats) return acc;
        acc.wins += stats.wins;
        acc.losses += stats.losses;
        acc.played += stats.played;
        return acc;
    }, {
        wins: 0,
        losses: 0,
        played: 0
    });
}
function fixtureAvailableGames(fixture) {
    if (fixture == null) return [];
    const listed = fixture.availableGames;
    if (listed == null) return [
        ...(0, _constants.LEAGUE_GAME_KEYS)
    ];
    return (0, _constants.LEAGUE_GAME_KEYS).filter((game)=>listed.includes(game));
}
function leagueIncludedGames(league) {
    const games = league.includedGames;
    const picked = !games || games.length === 0 ? [
        ...(0, _constants.LEAGUE_GAME_KEYS)
    ] : games.filter((game)=>(0, _constants.LEAGUE_GAME_KEYS).includes(game));
    return (0, _constants.LEAGUE_GAME_KEYS).filter((game)=>picked.includes(game));
}
function formatIncludedGamesLabel(league) {
    const games = leagueIncludedGames(league);
    if (games.length === (0, _constants.LEAGUE_GAME_KEYS).length) return "All games";
    if (games.length === 0) return "No games";
    if (games.length === 1) return `${(0, _constants.LEAGUE_GAME_META)[games[0]].label} only`;
    const labels = games.map((game)=>(0, _constants.LEAGUE_GAME_META)[game].label);
    if (labels.length === 2) return `${labels[0]} & ${labels[1]}`;
    return `${labels.slice(0, -1).join(", ")} & ${labels[labels.length - 1]}`;
}
function leagueModeSeasonLabel(league, now = Date.now()) {
    const words = league.name.trim().split(/\s+/).filter(Boolean);
    const short = words.length >= 3 ? words.slice(-2).join(" ") : words.length > 0 ? words.join(" ") : "League";
    const start = new Date(league.startsAt).getTime();
    const elapsed = Number.isFinite(start) ? Math.max(0, now - start) : 0;
    const round = Math.max(1, Math.floor(elapsed / 21600000) + 1);
    return `${short.toUpperCase()} - R${round}`;
}
function leagueStatus(league, now = Date.now()) {
    if (isLeagueCancelled(league) || isLeagueRefunded(league, now)) return "ended";
    if (league.settledAt || league.status === "ended") return "ended";
    const start = new Date(league.startsAt).getTime();
    const end = new Date(league.endsAt).getTime();
    if (Number.isFinite(end) && now >= end) return "ended";
    if (Number.isFinite(start) && now < start) return "upcoming";
    return "live";
}
function leagueTimingLabel(league, now) {
    if (isLeagueRefunded(league, now)) return "Cancelled \xb7 Rubies refunded";
    const status = leagueStatus(league, now);
    if (status === "live") {
        if (league.scope === "match") return "";
        return `Ends in ${formatCountdown(league.endsAt, now)}`;
    }
    if (status === "upcoming") return `Match in ${formatCountdown(league.startsAt, now)}`;
    return `Ended ${formatDateTime(league.endsAt)}`;
}
function leagueStatusLabel(status) {
    if (status === "live") return "Live";
    if (status === "upcoming") return "Prematch";
    return "Ended";
}
function leagueHubCardStatus(league, now, opts) {
    if (isLeagueRefunded(league, now)) return {
        label: "CANCELLED",
        className: "text-[#F73261]"
    };
    if (leagueIsAwaitingFinalResults(league, now, opts)) return {
        label: "RESULTS SOON",
        className: "text-[#FFC72C]"
    };
    const status = leagueStatus(league, now);
    if (status === "live" && opts?.breakLabel) return {
        label: opts.breakLabel,
        className: "text-[#a855f7]"
    };
    if (status === "live") return {
        label: "IN PLAY",
        className: "text-[#32F78D]"
    };
    if (status === "upcoming") return {
        label: `STARTS IN ${formatCountdown(league.startsAt, now).toUpperCase()}`,
        className: "text-white/85"
    };
    return {
        label: "FINISHED",
        className: "text-white/60"
    };
}
function leagueShowsMatchCentre(status) {
    return status === "live" || status === "ended" || status === "upcoming";
}
function leagueFixtureDisplayStatus(fixture, now, leagueStatus, liveMatch) {
    if (leagueStatus === "ended" || liveMatch && (0, _leagueLiveFixtures.isCricketMatchFinished)(liveMatch)) return {
        label: "FINISHED",
        live: false,
        finished: true
    };
    if (liveMatch) {
        const list = (0, _matchUtils.getMatchStatus)({
            ...liveMatch,
            sport: liveMatch.sport || "cricket"
        });
        if ((0, _matchUtils.isCricketBreakInPlayMatchStatus)(list)) {
            const upper = list.text.toUpperCase();
            const label = /RAIN|WEATHER|TOSS DELAYED|WET OUTFIELD|COVERS/.test(upper) ? "RAIN DELAY" : list.text.replace(/^Break in Play\s*-?\s*/i, "MATCH BREAK").trim() || "MATCH BREAK";
            return {
                label,
                live: false,
                finished: false
            };
        }
        if (list.text === "IN-PLAY" || list.text.toUpperCase().includes("SUPER OVER")) return {
            label: "IN-PLAY",
            live: true,
            finished: false
        };
        if (list.text.startsWith("STARTS IN ") || /^in\s+/i.test(list.text)) return {
            label: list.text.toUpperCase().startsWith("STARTS IN") ? list.text.toUpperCase() : `STARTS IN ${list.text.replace(/^in\s+/i, "").toUpperCase()}`,
            live: false,
            finished: false
        };
        if (list.text && list.text !== "IN-PLAY") return {
            label: list.text,
            live: false,
            finished: false
        };
    }
    const start = new Date(fixture.start).getTime();
    if (!Number.isFinite(start)) return {
        label: "SCHEDULED",
        live: false,
        finished: false
    };
    if (start <= now) // Kickoff passed but no liveMatch / break status — keep scheduled until the feed confirms play.
    return {
        label: "SCHEDULED",
        live: false,
        finished: false
    };
    return {
        label: `STARTS IN ${formatCountdown(fixture.start, now).toUpperCase()}`,
        live: false,
        finished: false
    };
}
function leagueRealJoiners(league) {
    return league.members.filter((member)=>!member.isHost).length;
}
function leagueJoinersNeeded(league) {
    const min = league.minRealJoiners ?? (0, _constants.LEAGUE_MIN_REAL_JOINERS);
    return Math.max(0, min - leagueRealJoiners(league));
}
function isLeagueCancelled(league) {
    if (league.cancelledAt) return true;
    return league.status === "cancelled";
}
function isPublicLeagueSpectatorResults(league) {
    if (league.listing !== "public") return false;
    if (league.membership === "host" || league.membership === "member") return false;
    if (isLeagueCancelled(league)) return false;
    return Boolean(league.settledAt) || league.status === "ended";
}
function isLeagueRefunded(league, now = Date.now()) {
    if (isLeagueCancelled(league)) return true;
    if (league.scope !== "match") return false;
    const start = new Date(league.startsAt).getTime();
    if (!Number.isFinite(start) || now < start) return false;
    const min = league.minRealJoiners ?? (0, _constants.LEAGUE_MIN_REAL_JOINERS);
    return leagueRealJoiners(league) < min;
}
function isIsoOnLocalCalendarDay(dateStr, day = new Date()) {
    if (!dateStr?.trim()) return false;
    const t = new Date(dateStr).getTime();
    if (!Number.isFinite(t)) return false;
    const dayStart = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 0, 0, 0, 0).getTime();
    const dayEnd = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 23, 59, 59, 999).getTime();
    return t >= dayStart && t <= dayEnd;
}
function isEndedLeagueForMyGamesDrawer(league, day = new Date()) {
    return isIsoOnLocalCalendarDay(league.settledAt, day) || isIsoOnLocalCalendarDay(league.matchFinishedAt, day) || isIsoOnLocalCalendarDay(league.endsAt, day) || isIsoOnLocalCalendarDay(league.cancelledAt, day);
}
function isLeagueXpLive(league, now = Date.now()) {
    if (isLeagueRefunded(league, now)) return false;
    return leagueStatus(league, now) !== "upcoming";
}
function leaguePlacementPastMembers(league, opts = {}) {
    const scope = opts.scope ?? "all";
    const gameFilter = opts.gameFilter ?? "all";
    if (gameFilter !== "all") return [];
    const at = league.settledAt?.trim();
    if (!at) return [];
    const settledPlaysByUser = new Map();
    for (const play of league.plays){
        if (play.status !== "settled") continue;
        settledPlaysByUser.set(play.userId, (settledPlaysByUser.get(play.userId) ?? 0) + 1);
    }
    const podiumSize = (0, _constants.LEAGUE_XP_PLACEMENT_BONUS).length;
    // Standings order among members with ≥1 settled play (same gate as prize / XP).
    const eligible = leagueTableRows(league).filter((row)=>(settledPlaysByUser.get(row.userId) ?? 0) > 0);
    const podium = [];
    for(let i = 0; i < eligible.length && i < podiumSize; i += 1){
        const row = eligible[i];
        if (scope === "mine" && opts.viewerUserId != null && row.userId !== opts.viewerUserId) continue;
        podium.push({
            userId: row.userId,
            place: i + 1,
            at,
            member: row
        });
    }
    return podium;
}
function leagueDistinctSettledGames(league, userId) {
    const games = new Set();
    for (const play of league.plays)if (play.userId === userId && play.status === "settled") games.add(play.game);
    return games.size;
}
/**
 * Rank by WON points descending; ties share a rank and fall back to pot, then name,
 * so the table order stays stable between realtime updates.
 */ function recentMovement(previousRank, movedAt, rank) {
    if (previousRank == null || movedAt == null) return 0;
    const age = Date.now() - new Date(movedAt).getTime();
    if (!Number.isFinite(age) || age > (0, _constants.LEAGUE_MOVEMENT_TTL_MS)) return 0;
    return previousRank - rank;
}
function leagueTableRows(league) {
    const enriched = league.members.map((member)=>{
        const totals = memberTotals(member, leagueIncludedGames(league));
        const open = league.plays.filter((play)=>play.status === "open" && play.userId === member.userId);
        const openStake = open.reduce((total, play)=>total + play.stake, 0);
        const bar = (0, _leagueLeaderboardBar.leagueLeaderboardBarStatsForMember)(league, member.userId);
        return {
            ...member,
            ...totals,
            pl: memberPl(member),
            wonPoints: bar.wonPoints,
            potPoints: bar.potPoints,
            rank: 0,
            openPlays: open.length,
            openStake,
            availableCoins: Math.max(0, member.coins - openStake),
            movement: 0
        };
    });
    enriched.sort((a, b)=>{
        if (b.wonPoints !== a.wonPoints) return b.wonPoints - a.wonPoints;
        if (b.potPoints !== a.potPoints) return b.potPoints - a.potPoints;
        if (b.pl !== a.pl) return b.pl - a.pl;
        return a.playerName.localeCompare(b.playerName);
    });
    let lastWon = null;
    let lastRank = 0;
    enriched.forEach((row, index)=>{
        if (lastWon != null && row.wonPoints === lastWon) row.rank = lastRank;
        else {
            row.rank = index + 1;
            lastRank = row.rank;
            lastWon = row.wonPoints;
        }
        row.movement = recentMovement(row.previousRank, row.rankMovedAt, row.rank);
    });
    return enriched;
}
function leagueLeaderboardHasScores(league) {
    if (leagueTableRows(league).some((row)=>row.wonPoints > 0 || row.played > 0)) return true;
    return league.plays.some((play)=>{
        if (play.game !== "bullion" || play.status !== "open") return false;
        const settlement = play.marketDetails?.settlement;
        const slip = settlement?.slipScore != null && Number.isFinite(Number(settlement.slipScore)) ? Number(settlement.slipScore) : Number(settlement?.points);
        return Number.isFinite(slip) && slip > 0;
    });
}
function leagueActivityRanksReady(league, now = Date.now()) {
    if (isLeagueRefunded(league, now)) return false;
    return leagueLeaderboardHasScores(league);
}
function leaguePrizeSplit(league) {
    const pot = leaguePrizePotCoins(league);
    const shares = (0, _constants.LEAGUE_PRIZE_SPLITS)[league.members.length] ?? (0, _constants.LEAGUE_PRIZE_SPLIT_DEFAULT);
    return shares.map((share)=>Math.round(pot * share));
}
function viewerRow(league) {
    return leagueTableRows(league).find((row)=>row.isViewer) ?? null;
}
function pluralise(value, unit) {
    return `${value} ${unit}${value === 1 ? "" : "s"}`;
}
function formatCountdown(targetIso, now = Date.now()) {
    const target = new Date(targetIso).getTime();
    if (!Number.isFinite(target)) return "";
    const ms = target - now;
    if (ms <= 0) return "0m";
    const totalMinutes = Math.floor(ms / 60000);
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor(totalMinutes % 1440 / 60);
    const minutes = totalMinutes % 60;
    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    if (totalMinutes > 0) return `${totalMinutes}m`;
    return `${Math.max(1, Math.floor(ms / 1000))}s`;
}
function formatDateTime(iso) {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleString(undefined, {
        weekday: "short",
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit"
    });
}
function formatTimeAgo(iso, now = Date.now()) {
    const at = new Date(iso).getTime();
    if (!Number.isFinite(at)) return "";
    const seconds = Math.max(0, Math.floor((now - at) / 1000));
    if (seconds < 10) return "just now";
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    return `${Math.floor(hours / 24)}d ago`;
}
function formatDurationBetween(startIso, endIso) {
    const start = new Date(startIso).getTime();
    const end = new Date(endIso).getTime();
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return "";
    const hours = Math.round((end - start) / 3600000);
    if (hours < 24) return pluralise(hours, "hour");
    const days = Math.round(hours / 24);
    if (days % 7 === 0) return pluralise(days / 7, "week");
    return pluralise(days, "day");
}
function combineDateAndTime(date, time) {
    return new Date(`${date}T${time}`);
}
function toDateInputValue(date) {
    const pad = (n)=>String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
function formatFixtureDayHeading(iso, now = Date.now()) {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "";
    const startOfToday = new Date(now);
    startOfToday.setHours(0, 0, 0, 0);
    const startOfTarget = new Date(date);
    startOfTarget.setHours(0, 0, 0, 0);
    const dayDiff = Math.round((startOfTarget.getTime() - startOfToday.getTime()) / 86400000);
    if (dayDiff === 0) return "Today";
    if (dayDiff === 1) return "Tomorrow";
    return date.toLocaleDateString(undefined, {
        weekday: "short",
        day: "numeric",
        month: "short"
    });
}
function formatFixtureStartLabel(iso, now = Date.now()) {
    const at = new Date(iso).getTime();
    if (!Number.isFinite(at)) return "";
    const ms = at - now;
    if (ms <= 0) return "Under way";
    const countdown = formatCountdown(iso, now);
    // Near kickoff: countdown beats clock time so urgency is obvious in the picker.
    if (ms <= 21600000) return `In ${countdown}`;
    const startOfToday = new Date(now);
    startOfToday.setHours(0, 0, 0, 0);
    const startOfTarget = new Date(at);
    startOfTarget.setHours(0, 0, 0, 0);
    const dayDiff = Math.round((startOfTarget.getTime() - startOfToday.getTime()) / 86400000);
    if (dayDiff <= 1) {
        const time = new Date(iso).toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit"
        });
        return dayDiff === 0 ? `Today \xb7 ${time}` : `Tomorrow \xb7 ${time}`;
    }
    return `Starts in ${countdown}`;
}
function leagueFixtureCardStatus(fixture, now = Date.now()) {
    const startMs = new Date(fixture.start).getTime();
    if (Number.isFinite(startMs) && startMs <= now) return {
        text: "IN-PLAY",
        color: "text-pink"
    };
    const label = formatFixtureStartLabel(fixture.start, now);
    if (label.startsWith("In ")) return {
        text: `IN ${label.slice(3).toUpperCase()}`,
        color: "text-[#32F78D]"
    };
    if (label.startsWith("Starts in ")) return {
        text: `STARTS IN ${label.slice(10).toUpperCase()}`,
        color: "text-[#32F78D]"
    };
    return {
        text: label,
        color: "text-white/75"
    };
}
const DAY_MS = 86400000;
const MIN_LEAGUE_LEAD_MS = DAY_MS + 60000;
function presetEndPreviewIso(days, now = Date.now()) {
    const end = new Date(now + days * DAY_MS);
    end.setHours(18, 0, 0, 0);
    if (end.getTime() - now <= MIN_LEAGUE_LEAD_MS) end.setDate(end.getDate() + 1);
    return end.toISOString();
}
function formatEndPreview(iso) {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "";
    const day = date.toLocaleDateString(undefined, {
        weekday: "short",
        day: "numeric",
        month: "short"
    });
    const time = date.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit"
    });
    return `${day} \xb7 ${time}`;
}
const LEAGUE_END_TIME_OPTIONS = [
    "12:00",
    "15:00",
    "18:00",
    "20:00",
    "21:00"
];
function memberInitial(name) {
    return (name.trim().charAt(0) || "?").toUpperCase();
}

},{"./constants":"dZVub","../../Games/matchUtils":"9QY2j","./leagueLiveFixtures":"7FEAE","./leagueLeaderboardBar":"4qS7j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZVub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHIPS_PER_RUBY", ()=>CHIPS_PER_RUBY);
parcelHelpers.export(exports, "CHIPS_PER_RUBY_T10", ()=>CHIPS_PER_RUBY_T10);
parcelHelpers.export(exports, "CHIPS_PER_RUBY_T50", ()=>CHIPS_PER_RUBY_T50);
parcelHelpers.export(exports, "PRIZE_COINS_PER_RUBY", ()=>PRIZE_COINS_PER_RUBY);
parcelHelpers.export(exports, "SEAT_TOPUP_RUBIES", ()=>SEAT_TOPUP_RUBIES);
parcelHelpers.export(exports, "SEAT_TOPUP_MAX", ()=>SEAT_TOPUP_MAX);
parcelHelpers.export(exports, "SEAT_TOPUP_MAX_T50", ()=>SEAT_TOPUP_MAX_T50);
parcelHelpers.export(exports, "SEAT_TOPUP_AVAILABLE_AT_OR_BELOW", ()=>SEAT_TOPUP_AVAILABLE_AT_OR_BELOW);
/** Chips credited per ruby for a match format (overs code: 10 / 20 / 50 / 100). */ parcelHelpers.export(exports, "chipsPerRubyForFormat", ()=>chipsPerRubyForFormat);
/** Max seat top-up packs for a match format (overs code: 10 / 20 / 50 / 100). */ parcelHelpers.export(exports, "seatTopUpMax", ()=>seatTopUpMax);
parcelHelpers.export(exports, "LEAGUE_ENTRY_FEE_PRESETS", ()=>LEAGUE_ENTRY_FEE_PRESETS);
parcelHelpers.export(exports, "LEAGUE_ENTRY_FEE_MIN", ()=>LEAGUE_ENTRY_FEE_MIN);
parcelHelpers.export(exports, "LEAGUE_ENTRY_FEE_MAX", ()=>LEAGUE_ENTRY_FEE_MAX);
parcelHelpers.export(exports, "LEAGUE_MIN_REAL_JOINERS", ()=>LEAGUE_MIN_REAL_JOINERS);
parcelHelpers.export(exports, "LEAGUE_DEFAULT_DURATION_DAYS", ()=>LEAGUE_DEFAULT_DURATION_DAYS);
parcelHelpers.export(exports, "LEAGUE_DURATION_PRESETS", ()=>LEAGUE_DURATION_PRESETS);
parcelHelpers.export(exports, "LEAGUE_NAME_MAX_LENGTH", ()=>LEAGUE_NAME_MAX_LENGTH);
parcelHelpers.export(exports, "LEAGUE_VIEWER_USER_ID", ()=>LEAGUE_VIEWER_USER_ID);
parcelHelpers.export(exports, "LEAGUE_GAME_KEYS", ()=>LEAGUE_GAME_KEYS);
parcelHelpers.export(exports, "LEAGUE_CREATE_MATCH_WINDOW_HOURS", ()=>LEAGUE_CREATE_MATCH_WINDOW_HOURS);
parcelHelpers.export(exports, "LEAGUE_CREATE_MATCH_WINDOW_MS", ()=>LEAGUE_CREATE_MATCH_WINDOW_MS);
parcelHelpers.export(exports, "LEAGUE_CREATE_SOON_MS", ()=>LEAGUE_CREATE_SOON_MS);
parcelHelpers.export(exports, "LEAGUE_CREATE_NEAR_START_WARN_MS", ()=>LEAGUE_CREATE_NEAR_START_WARN_MS);
parcelHelpers.export(exports, "LEAGUE_GAME_META", ()=>LEAGUE_GAME_META);
parcelHelpers.export(exports, "LEAGUE_GAME_BAR_COLORS", ()=>LEAGUE_GAME_BAR_COLORS);
parcelHelpers.export(exports, "LEAGUE_GAME_BAR_BULLION_SOLID", ()=>LEAGUE_GAME_BAR_BULLION_SOLID);
parcelHelpers.export(exports, "leagueGameBarFillStyle", ()=>leagueGameBarFillStyle);
parcelHelpers.export(exports, "LEAGUE_LB_POT_BAR_COLOR", ()=>LEAGUE_LB_POT_BAR_COLOR);
parcelHelpers.export(exports, "LEAGUE_LB_PRED_BAR_BG", ()=>LEAGUE_LB_PRED_BAR_BG);
parcelHelpers.export(exports, "LEAGUE_LB_ROW_BG_CLASS", ()=>LEAGUE_LB_ROW_BG_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_ROW_BG_VIEWER_CLASS", ()=>LEAGUE_LB_ROW_BG_VIEWER_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_ROW_BG_TV_CLASS", ()=>LEAGUE_LB_ROW_BG_TV_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_PRED_BAR_HEIGHT_CLASS", ()=>LEAGUE_LB_PRED_BAR_HEIGHT_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_RANK_BADGE_CLASS", ()=>LEAGUE_LB_RANK_BADGE_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_USERNAME_CLASS", ()=>LEAGUE_LB_USERNAME_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_USERNAME_TV_CLASS", ()=>LEAGUE_LB_USERNAME_TV_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_TABLE_GRID_CLASS", ()=>LEAGUE_LB_TABLE_GRID_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_STAT_PTS_COL_CLASS", ()=>LEAGUE_LB_STAT_PTS_COL_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_STAT_IFNOW_COL_CLASS", ()=>LEAGUE_LB_STAT_IFNOW_COL_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_BULLION_IF_NOW_HINT", ()=>LEAGUE_LB_BULLION_IF_NOW_HINT);
parcelHelpers.export(exports, "LEAGUE_LB_TABLE_GRID_BULLION_IFNOW_CLASS", ()=>LEAGUE_LB_TABLE_GRID_BULLION_IFNOW_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_CHEVRON_COL_CLASS", ()=>LEAGUE_LB_CHEVRON_COL_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_CHIPS_POINTS_CLASS", ()=>LEAGUE_LB_CHIPS_POINTS_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_POT_POINTS_CLASS", ()=>LEAGUE_LB_POT_POINTS_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_WON_POINTS_CLASS", ()=>LEAGUE_LB_WON_POINTS_CLASS);
parcelHelpers.export(exports, "LEAGUE_LB_PTS_HEADER_CLASS", ()=>LEAGUE_LB_PTS_HEADER_CLASS);
parcelHelpers.export(exports, "RUBY_ICON_SRC", ()=>RUBY_ICON_SRC);
parcelHelpers.export(exports, "COIN_ICON_SRC", ()=>COIN_ICON_SRC);
parcelHelpers.export(exports, "CHIP_ICON_SRC", ()=>CHIP_ICON_SRC);
parcelHelpers.export(exports, "LEAGUE_ICON_SRC", ()=>LEAGUE_ICON_SRC);
parcelHelpers.export(exports, "LEAGUE_MODE_ICON_SRC", ()=>LEAGUE_MODE_ICON_SRC);
parcelHelpers.export(exports, "LEAGUE_MYZONE_PRIVATE_ICON_SRC", ()=>LEAGUE_MYZONE_PRIVATE_ICON_SRC);
parcelHelpers.export(exports, "LEAGUE_MYZONE_PUBLIC_ICON_SRC", ()=>LEAGUE_MYZONE_PUBLIC_ICON_SRC);
/** Header / tray mark for a league’s public vs private listing. */ parcelHelpers.export(exports, "leagueListingIconSrc", ()=>leagueListingIconSrc);
parcelHelpers.export(exports, "LEAGUE_GAME_PLAY_BACK_LABEL", ()=>LEAGUE_GAME_PLAY_BACK_LABEL);
parcelHelpers.export(exports, "LEAGUE_GAME_PLAY_BACK_ARIA_LABEL", ()=>LEAGUE_GAME_PLAY_BACK_ARIA_LABEL);
parcelHelpers.export(exports, "LEAGUE_EXIT_BACK_LABEL", ()=>LEAGUE_EXIT_BACK_LABEL);
parcelHelpers.export(exports, "LEAGUE_EXIT_BACK_ARIA_LABEL", ()=>LEAGUE_EXIT_BACK_ARIA_LABEL);
parcelHelpers.export(exports, "LEAGUE_SIMULATION_TICK_MS", ()=>LEAGUE_SIMULATION_TICK_MS);
parcelHelpers.export(exports, "LEAGUE_PLAY_SETTLE_DELAY_MS", ()=>LEAGUE_PLAY_SETTLE_DELAY_MS);
parcelHelpers.export(exports, "LEAGUE_BOT_PLAY_SETTLE_MIN_MS", ()=>LEAGUE_BOT_PLAY_SETTLE_MIN_MS);
parcelHelpers.export(exports, "LEAGUE_BOT_PLAY_SETTLE_MAX_MS", ()=>LEAGUE_BOT_PLAY_SETTLE_MAX_MS);
parcelHelpers.export(exports, "LEAGUE_BOT_PLAY_CHANCE", ()=>LEAGUE_BOT_PLAY_CHANCE);
parcelHelpers.export(exports, "LEAGUE_MAX_OPEN_BOT_PLAYS", ()=>LEAGUE_MAX_OPEN_BOT_PLAYS);
parcelHelpers.export(exports, "LEAGUE_MOVEMENT_TTL_MS", ()=>LEAGUE_MOVEMENT_TTL_MS);
parcelHelpers.export(exports, "LEAGUE_STANDINGS_DESKTOP_SCROLL_AT", ()=>LEAGUE_STANDINGS_DESKTOP_SCROLL_AT);
parcelHelpers.export(exports, "LEAGUE_PLAY_STAKE_PRESETS", ()=>LEAGUE_PLAY_STAKE_PRESETS);
parcelHelpers.export(exports, "LEAGUE_PLAY_STAKE_MIN", ()=>LEAGUE_PLAY_STAKE_MIN);
parcelHelpers.export(exports, "LEAGUE_SIXES_CARD_STAKE", ()=>LEAGUE_SIXES_CARD_STAKE);
parcelHelpers.export(exports, "LEAGUE_BULLION_BATTLE_STAKE", ()=>LEAGUE_BULLION_BATTLE_STAKE);
parcelHelpers.export(exports, "LEAGUE_SQUARES_MIN_STAKE", ()=>LEAGUE_SQUARES_MIN_STAKE);
parcelHelpers.export(exports, "LEAGUE_SQUARES_MAX_STAKE", ()=>LEAGUE_SQUARES_MAX_STAKE);
parcelHelpers.export(exports, "LEAGUE_TRADER_MIN_STAKE", ()=>LEAGUE_TRADER_MIN_STAKE);
parcelHelpers.export(exports, "LEAGUE_GAME_MIN_STAKE", ()=>LEAGUE_GAME_MIN_STAKE);
parcelHelpers.export(exports, "LEAGUE_XP_POINTS_PCT", ()=>LEAGUE_XP_POINTS_PCT);
parcelHelpers.export(exports, "LEAGUE_XP_POINTS_CAP", ()=>LEAGUE_XP_POINTS_CAP);
parcelHelpers.export(exports, "LEAGUE_XP_GAME_WIN", ()=>LEAGUE_XP_GAME_WIN);
parcelHelpers.export(exports, "LEAGUE_XP_PLACEMENT_BONUS", ()=>LEAGUE_XP_PLACEMENT_BONUS);
parcelHelpers.export(exports, "LEAGUE_PRIZE_SPLITS", ()=>LEAGUE_PRIZE_SPLITS);
parcelHelpers.export(exports, "LEAGUE_PRIZE_SPLIT_DEFAULT", ()=>LEAGUE_PRIZE_SPLIT_DEFAULT);
parcelHelpers.export(exports, "LEAGUE_CARD_GRADIENT", ()=>LEAGUE_CARD_GRADIENT);
parcelHelpers.export(exports, "LEAGUE_CARD_GRADIENT_MUTED", ()=>LEAGUE_CARD_GRADIENT_MUTED);
parcelHelpers.export(exports, "LEAGUE_HEADING_CLASS", ()=>LEAGUE_HEADING_CLASS);
parcelHelpers.export(exports, "LEAGUE_GAME_TAB_LABEL_CLASS", ()=>LEAGUE_GAME_TAB_LABEL_CLASS);
parcelHelpers.export(exports, "LEAGUE_BODY_CLASS", ()=>LEAGUE_BODY_CLASS);
parcelHelpers.export(exports, "LEAGUE_PRIMARY_BUTTON_CLASS", ()=>LEAGUE_PRIMARY_BUTTON_CLASS);
parcelHelpers.export(exports, "LEAGUE_SECONDARY_BUTTON_CLASS", ()=>LEAGUE_SECONDARY_BUTTON_CLASS);
parcelHelpers.export(exports, "LEAGUE_DETAIL_WALLET_GAP_ROW_CLASS", ()=>LEAGUE_DETAIL_WALLET_GAP_ROW_CLASS);
parcelHelpers.export(exports, "LEAGUE_WALLET_LABEL_CLASS", ()=>LEAGUE_WALLET_LABEL_CLASS);
parcelHelpers.export(exports, "LEAGUE_WALLET_CHIP_ICON_CLASS", ()=>LEAGUE_WALLET_CHIP_ICON_CLASS);
parcelHelpers.export(exports, "LEAGUE_WALLET_BALANCE_CLASS", ()=>LEAGUE_WALLET_BALANCE_CLASS);
parcelHelpers.export(exports, "LEAGUE_WALLET_TOPUP_PLUS_CLASS", ()=>LEAGUE_WALLET_TOPUP_PLUS_CLASS);
parcelHelpers.export(exports, "LEAGUE_HEADER_EXIT_ICON_CLASS", ()=>LEAGUE_HEADER_EXIT_ICON_CLASS);
parcelHelpers.export(exports, "LEAGUE_HEADER_EXIT_LABEL_CLASS", ()=>LEAGUE_HEADER_EXIT_LABEL_CLASS);
parcelHelpers.export(exports, "LEAGUE_HEADER_WALLET_CHROME_CLASS", ()=>LEAGUE_HEADER_WALLET_CHROME_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_HEADER_CTA_CLASS", ()=>LEAGUE_LOBBY_HEADER_CTA_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_HEADER_CTA_GHOST_CLASS", ()=>LEAGUE_LOBBY_HEADER_CTA_GHOST_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_FULL_WIDTH_CTA_CLASS", ()=>LEAGUE_LOBBY_FULL_WIDTH_CTA_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_FOOTER_CTA_CLASS", ()=>LEAGUE_LOBBY_FOOTER_CTA_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_FOOTER_CTA_MUTED_CLASS", ()=>LEAGUE_LOBBY_FOOTER_CTA_MUTED_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_STATUS_PILL_CLASS", ()=>LEAGUE_LOBBY_STATUS_PILL_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_CARD_SURFACE_CLASS", ()=>LEAGUE_LOBBY_CARD_SURFACE_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_CARD_BODY_CLASS", ()=>LEAGUE_LOBBY_CARD_BODY_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_CARD_NESTED_CLASS", ()=>LEAGUE_LOBBY_CARD_NESTED_CLASS);
parcelHelpers.export(exports, "LEAGUE_LOBBY_CARD_TOOLBAR_CLASS", ()=>LEAGUE_LOBBY_CARD_TOOLBAR_CLASS);
parcelHelpers.export(exports, "LEAGUE_HEADER_RADIAL_GRADIENT", ()=>LEAGUE_HEADER_RADIAL_GRADIENT);
parcelHelpers.export(exports, "LEAGUE_DETAIL_GUTTER_X_CLASS", ()=>LEAGUE_DETAIL_GUTTER_X_CLASS);
parcelHelpers.export(exports, "LEAGUE_MODE_HEADER_SHELL_ROW_CLASS", ()=>LEAGUE_MODE_HEADER_SHELL_ROW_CLASS);
parcelHelpers.export(exports, "LEAGUE_DETAIL_GUTTER_LG_CLASS", ()=>LEAGUE_DETAIL_GUTTER_LG_CLASS);
parcelHelpers.export(exports, "LEAGUE_DETAIL_MOBILE_BLEED_SHELL_CLASS", ()=>LEAGUE_DETAIL_MOBILE_BLEED_SHELL_CLASS);
parcelHelpers.export(exports, "LEAGUE_DETAIL_SHELL_INSET_CLASS", ()=>LEAGUE_DETAIL_SHELL_INSET_CLASS);
parcelHelpers.export(exports, "LEAGUE_DETAIL_PAGE_SHELL_CLASS", ()=>LEAGUE_DETAIL_PAGE_SHELL_CLASS);
parcelHelpers.export(exports, "LEAGUE_MODE_GOLD", ()=>LEAGUE_MODE_GOLD);
parcelHelpers.export(exports, "LEAGUE_MODE_GOLD_DEEP", ()=>LEAGUE_MODE_GOLD_DEEP);
parcelHelpers.export(exports, "LEAGUE_MODE_CARD_BG", ()=>LEAGUE_MODE_CARD_BG);
parcelHelpers.export(exports, "LEAGUE_MODE_CARD_BG_SOFT", ()=>LEAGUE_MODE_CARD_BG_SOFT);
parcelHelpers.export(exports, "LEAGUE_DESKTOP_COLUMN_BG", ()=>LEAGUE_DESKTOP_COLUMN_BG);
parcelHelpers.export(exports, "LEAGUE_DESKTOP_COLUMN_TITLE_CLASS", ()=>LEAGUE_DESKTOP_COLUMN_TITLE_CLASS);
parcelHelpers.export(exports, "LEAGUE_DESKTOP_COLUMN_INSET_X_CLASS", ()=>LEAGUE_DESKTOP_COLUMN_INSET_X_CLASS);
parcelHelpers.export(exports, "LEAGUE_DESKTOP_COLUMN_TITLE_GAP_CLASS", ()=>LEAGUE_DESKTOP_COLUMN_TITLE_GAP_CLASS);
parcelHelpers.export(exports, "LEAGUE_DESKTOP_COLUMN_TITLE_ROW_CLASS", ()=>LEAGUE_DESKTOP_COLUMN_TITLE_ROW_CLASS);
parcelHelpers.export(exports, "LEAGUE_BOARD_TAB_CYCLE_MS", ()=>LEAGUE_BOARD_TAB_CYCLE_MS);
parcelHelpers.export(exports, "LEAGUE_BOARD_TAB_CYCLE_RESUME_MS", ()=>LEAGUE_BOARD_TAB_CYCLE_RESUME_MS);
parcelHelpers.export(exports, "LEAGUE_MODE_GOLD_BORDER_CLASS", ()=>LEAGUE_MODE_GOLD_BORDER_CLASS);
parcelHelpers.export(exports, "LEAGUE_MODE_GOLD_BORDER_THIN_CLASS", ()=>LEAGUE_MODE_GOLD_BORDER_THIN_CLASS);
parcelHelpers.export(exports, "LEAGUE_ACTIVITY_CTA_PILL_CLASS", ()=>LEAGUE_ACTIVITY_CTA_PILL_CLASS);
parcelHelpers.export(exports, "LEAGUE_ACTIVITY_ROW_CLASS", ()=>LEAGUE_ACTIVITY_ROW_CLASS);
parcelHelpers.export(exports, "LEAGUE_ACTIVITY_NAME_LINE_CLASS", ()=>LEAGUE_ACTIVITY_NAME_LINE_CLASS);
parcelHelpers.export(exports, "LEAGUE_ACTIVITY_BODY_LINE_CLASS", ()=>LEAGUE_ACTIVITY_BODY_LINE_CLASS);
parcelHelpers.export(exports, "LEAGUE_ACTIVITY_TIME_CLASS", ()=>LEAGUE_ACTIVITY_TIME_CLASS);
parcelHelpers.export(exports, "LEAGUE_ACTIVITY_GAME_LABEL", ()=>LEAGUE_ACTIVITY_GAME_LABEL);
parcelHelpers.export(exports, "LEAGUE_ACTIVITY_PAGE_SIZE", ()=>LEAGUE_ACTIVITY_PAGE_SIZE);
const CHIPS_PER_RUBY = 2000;
const CHIPS_PER_RUBY_T10 = 1000;
const CHIPS_PER_RUBY_T50 = 3000;
const PRIZE_COINS_PER_RUBY = 1000;
const SEAT_TOPUP_RUBIES = 1;
const SEAT_TOPUP_MAX = 3;
const SEAT_TOPUP_MAX_T50 = 4;
const SEAT_TOPUP_AVAILABLE_AT_OR_BELOW = 100;
function chipsPerRubyForFormat(formatOvers) {
    const n = Number(formatOvers);
    if (Number.isFinite(n) && n === 10) return CHIPS_PER_RUBY_T10;
    if (Number.isFinite(n) && n === 50) return CHIPS_PER_RUBY_T50;
    return CHIPS_PER_RUBY;
}
function seatTopUpMax(formatOvers) {
    const n = Number(formatOvers);
    if (Number.isFinite(n) && n === 50) return SEAT_TOPUP_MAX_T50;
    return SEAT_TOPUP_MAX;
}
const LEAGUE_ENTRY_FEE_PRESETS = [
    1,
    2,
    5,
    10,
    25
];
const LEAGUE_ENTRY_FEE_MIN = 1;
const LEAGUE_ENTRY_FEE_MAX = 100;
const LEAGUE_MIN_REAL_JOINERS = 1;
const LEAGUE_DEFAULT_DURATION_DAYS = 1;
const LEAGUE_DURATION_PRESETS = [
    {
        label: "1 day",
        days: 1
    },
    {
        label: "3 days",
        days: 3
    },
    {
        label: "1 week",
        days: 7
    },
    {
        label: "2 weeks",
        days: 14
    }
];
const LEAGUE_NAME_MAX_LENGTH = 40;
const LEAGUE_VIEWER_USER_ID = 1;
const LEAGUE_GAME_KEYS = [
    "squares",
    "sixes",
    "bullion",
    "trader"
];
const LEAGUE_CREATE_MATCH_WINDOW_HOURS = 72;
const LEAGUE_CREATE_MATCH_WINDOW_MS = LEAGUE_CREATE_MATCH_WINDOW_HOURS * 3600000;
const LEAGUE_CREATE_SOON_MS = 10800000;
const LEAGUE_CREATE_NEAR_START_WARN_MS = LEAGUE_CREATE_SOON_MS;
const LEAGUE_GAME_META = {
    trader: {
        label: "Trader",
        icon: "/assets/trader.png",
        path: "/trader"
    },
    bullion: {
        label: "Bullion+",
        icon: "/assets/bullion.png",
        path: "/bullion"
    },
    sixes: {
        label: "Sixes",
        icon: "/assets/sixes.png",
        path: "/sixes"
    },
    squares: {
        label: "Squares+",
        icon: "/assets/squares.png",
        path: "/squares"
    }
};
const LEAGUE_GAME_BAR_COLORS = {
    trader: "#F9D849",
    squares: "#AF2EF6",
    sixes: "#32F78D",
    bullion: "linear-gradient(107.25deg, #F9FBC7 17.65%, #E6C878 24.64%, #FBF0A8 32.44%, #7B5E2C 72.7%, #AE8E53 82.15%, #AE8E53 89.54%, #7C582D 103.1%)"
};
const LEAGUE_GAME_BAR_BULLION_SOLID = "#AE8E53";
function leagueGameBarFillStyle(fill) {
    if (fill.startsWith("linear-gradient")) return {
        background: fill
    };
    return {
        backgroundColor: fill
    };
}
const LEAGUE_LB_POT_BAR_COLOR = "rgba(255, 255, 255, 0.28)";
const LEAGUE_LB_PRED_BAR_BG = "rgba(27, 6, 47, 0.3)";
const LEAGUE_LB_ROW_BG_CLASS = "bg-[#1B062F]/30";
const LEAGUE_LB_ROW_BG_VIEWER_CLASS = "bg-[#FC51BB]/30";
const LEAGUE_LB_ROW_BG_TV_CLASS = "bg-[#4E2188]";
const LEAGUE_LB_PRED_BAR_HEIGHT_CLASS = "h-[10px]";
const LEAGUE_LB_RANK_BADGE_CLASS = "ml-1.5 flex h-[20px] w-[20px] shrink-0 items-center justify-center bg-white font-anton text-[10px] font-normal leading-none text-main sm:ml-2";
const LEAGUE_LB_USERNAME_CLASS = "align-middle font-anton text-[12px] font-normal uppercase leading-[22px] tracking-[0] text-white [leading-trim:none]";
const LEAGUE_LB_USERNAME_TV_CLASS = "align-middle font-anton text-[16px] font-normal uppercase leading-[22px] tracking-[0] text-white [leading-trim:none]";
const LEAGUE_LB_TABLE_GRID_CLASS = "grid-cols-[20px_12px_30px_minmax(0,1fr)_3.25rem_2rem]";
const LEAGUE_LB_STAT_PTS_COL_CLASS = "flex w-full min-w-0 items-center justify-center";
const LEAGUE_LB_STAT_IFNOW_COL_CLASS = "flex w-full items-center justify-center";
const LEAGUE_LB_BULLION_IF_NOW_HINT = "If it ended now \u2014 pick score plus place bonus from current rank.";
const LEAGUE_LB_TABLE_GRID_BULLION_IFNOW_CLASS = "grid-cols-[20px_12px_30px_minmax(0,1fr)_3.25rem_2.75rem_2rem]";
const LEAGUE_LB_CHEVRON_COL_CLASS = "h-8 w-8 justify-self-end";
const LEAGUE_LB_CHIPS_POINTS_CLASS = "text-center font-anton text-[12px] font-normal uppercase leading-none tracking-[0] tabular-nums text-white/50 [leading-trim:none]";
const LEAGUE_LB_POT_POINTS_CLASS = LEAGUE_LB_CHIPS_POINTS_CLASS;
const LEAGUE_LB_WON_POINTS_CLASS = "whitespace-nowrap text-center font-anton text-[12px] font-normal uppercase leading-none tracking-[0] tabular-nums text-white [leading-trim:none]";
const LEAGUE_LB_PTS_HEADER_CLASS = "text-center font-anton text-[12px] font-normal uppercase leading-none tracking-[0] text-white/50 [leading-trim:none]";
const RUBY_ICON_SRC = "/img/rubin_sm.png";
const COIN_ICON_SRC = "/img/coin_sm.png";
const CHIP_ICON_SRC = "/assets/red-ball.png";
const LEAGUE_ICON_SRC = "/assets/league-trophy.png";
const LEAGUE_MODE_ICON_SRC = LEAGUE_ICON_SRC;
const LEAGUE_MYZONE_PRIVATE_ICON_SRC = "/assets/league-myzone-private.png?v=5";
const LEAGUE_MYZONE_PUBLIC_ICON_SRC = "/assets/league-myzone-public.png?v=5";
function leagueListingIconSrc(listing) {
    return listing === "public" ? LEAGUE_MYZONE_PUBLIC_ICON_SRC : LEAGUE_MYZONE_PRIVATE_ICON_SRC;
}
const LEAGUE_GAME_PLAY_BACK_LABEL = "LEAGUE";
const LEAGUE_GAME_PLAY_BACK_ARIA_LABEL = "Back to league";
const LEAGUE_EXIT_BACK_LABEL = "EXIT";
const LEAGUE_EXIT_BACK_ARIA_LABEL = "Exit league";
const LEAGUE_SIMULATION_TICK_MS = 2000;
const LEAGUE_PLAY_SETTLE_DELAY_MS = 9000;
const LEAGUE_BOT_PLAY_SETTLE_MIN_MS = 4000;
const LEAGUE_BOT_PLAY_SETTLE_MAX_MS = 16000;
const LEAGUE_BOT_PLAY_CHANCE = 0.62;
const LEAGUE_MAX_OPEN_BOT_PLAYS = 6;
const LEAGUE_MOVEMENT_TTL_MS = 90000;
const LEAGUE_STANDINGS_DESKTOP_SCROLL_AT = 20;
const LEAGUE_PLAY_STAKE_PRESETS = [
    100,
    250,
    500,
    1000
];
const LEAGUE_PLAY_STAKE_MIN = 50;
const LEAGUE_SIXES_CARD_STAKE = 0;
const LEAGUE_BULLION_BATTLE_STAKE = 0;
const LEAGUE_SQUARES_MIN_STAKE = 10;
const LEAGUE_SQUARES_MAX_STAKE = 200;
const LEAGUE_TRADER_MIN_STAKE = 10;
const LEAGUE_GAME_MIN_STAKE = {
    trader: LEAGUE_TRADER_MIN_STAKE,
    squares: LEAGUE_SQUARES_MIN_STAKE,
    sixes: LEAGUE_SIXES_CARD_STAKE,
    bullion: LEAGUE_BULLION_BATTLE_STAKE
};
const LEAGUE_XP_POINTS_PCT = 5;
const LEAGUE_XP_POINTS_CAP = 500;
const LEAGUE_XP_GAME_WIN = 50;
const LEAGUE_XP_PLACEMENT_BONUS = [
    150,
    90,
    50
];
const LEAGUE_PRIZE_SPLITS = {
    1: [
        1
    ],
    2: [
        0.7,
        0.3
    ]
};
const LEAGUE_PRIZE_SPLIT_DEFAULT = [
    0.5,
    0.3,
    0.2
];
const LEAGUE_CARD_GRADIENT = "bg-[linear-gradient(to_right,#623998,#652DAF)]";
const LEAGUE_CARD_GRADIENT_MUTED = "bg-[linear-gradient(to_right,rgba(98,57,152,0.5),rgba(101,45,175,0.5))]";
const LEAGUE_HEADING_CLASS = "font-anton font-normal not-italic uppercase leading-snug tracking-[0%] text-white [leading-trim:none]";
const LEAGUE_GAME_TAB_LABEL_CLASS = "align-middle font-anton text-[clamp(11px,4cqi,16px)] font-normal uppercase not-italic leading-none tracking-[0%] text-white [leading-trim:none]";
const LEAGUE_BODY_CLASS = "font-chakra font-normal not-italic normal-case tracking-[0%] [leading-trim:none]";
const LEAGUE_PRIMARY_BUTTON_CLASS = "inline-flex items-center justify-center gap-2 border-0 bg-lime px-4 font-anton text-[14px] font-normal uppercase leading-none text-main transition-colors hover:bg-limehover disabled:cursor-not-allowed disabled:opacity-50";
const LEAGUE_SECONDARY_BUTTON_CLASS = "inline-flex items-center justify-center gap-2 border border-solid border-white/35 bg-transparent px-4 font-anton text-[14px] font-normal uppercase leading-none text-white transition-colors hover:border-white/60 hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-50";
const LEAGUE_DETAIL_WALLET_GAP_ROW_CLASS = "py-1.5 transition-[padding] duration-[750ms] ease-[cubic-bezier(0.4,0,0.2,1)] [&:has([data-delivery-active])]:py-3";
const LEAGUE_WALLET_LABEL_CLASS = "text-right font-anton text-[10px] font-normal uppercase leading-[100%] tracking-[0] text-white [leading-trim:none] lg:text-[16px]";
const LEAGUE_WALLET_CHIP_ICON_CLASS = "h-6 w-6 shrink-0 object-contain drop-shadow-[0_3px_4px_rgba(0,0,0,0.325)] lg:h-7 lg:w-7";
const LEAGUE_WALLET_BALANCE_CLASS = "font-anton text-[16px] font-normal uppercase leading-[100%] tracking-[0] tabular-nums text-white [leading-trim:none] phone-sm:text-[17px] sm:text-[18px] lg:text-[22px]";
const LEAGUE_WALLET_TOPUP_PLUS_CLASS = "inline-flex h-5 w-5 shrink-0 items-center justify-center border-0 bg-[#F47AA8] p-0 transition-colors hover:bg-[#F890B6]";
const LEAGUE_HEADER_EXIT_ICON_CLASS = "h-5 w-5 shrink-0 text-white sm:h-6 sm:w-6 lg:h-[30px] lg:w-[30px]";
const LEAGUE_HEADER_EXIT_LABEL_CLASS = "font-anton text-[13px] font-normal uppercase leading-[100%] tracking-[0.04em] text-center align-middle text-white [leading-trim:none] phone-sm:text-[14px] sm:text-[16px] lg:text-[24px] lg:tracking-[0]";
const LEAGUE_HEADER_WALLET_CHROME_CLASS = "box-border inline-flex h-[34px] shrink-0 items-center justify-center gap-1.5 border-0 bg-white/20 px-2 py-0 font-anton uppercase text-white shadow-none sm:gap-2 sm:px-2.5 lg:h-auto lg:min-h-[40px] lg:gap-2.5 lg:px-4 lg:py-2";
const LEAGUE_LOBBY_HEADER_CTA_CLASS = "inline-flex h-[26px] shrink-0 items-center border-0 bg-lime px-2.5 font-anton text-[11px] uppercase leading-none text-main transition-colors hover:bg-limehover disabled:cursor-not-allowed disabled:bg-white/15 disabled:text-white/40";
const LEAGUE_LOBBY_HEADER_CTA_GHOST_CLASS = "inline-flex h-[26px] shrink-0 items-center border border-solid border-lime bg-transparent px-2 font-anton text-[11px] uppercase leading-none text-lime transition-colors hover:bg-lime/15 disabled:cursor-not-allowed disabled:border-white/20 disabled:bg-transparent disabled:text-white/40";
const LEAGUE_LOBBY_FULL_WIDTH_CTA_CLASS = "flex h-[40px] w-full items-center justify-center border-0 bg-lime text-center font-anton text-[16px] font-normal uppercase leading-none tracking-normal text-main transition-colors hover:bg-limehover disabled:cursor-not-allowed disabled:bg-white/15 disabled:text-white/60";
const LEAGUE_LOBBY_FOOTER_CTA_CLASS = "inline-flex h-[30px] shrink-0 items-center justify-center border-0 bg-lime px-2.5 font-anton text-[11px] uppercase leading-none text-main transition-colors hover:bg-limehover disabled:cursor-not-allowed disabled:bg-white/15 disabled:text-white/60 lg:px-3 lg:text-[12px]";
const LEAGUE_LOBBY_FOOTER_CTA_MUTED_CLASS = "inline-flex h-[30px] shrink-0 items-center justify-center border-0 bg-white px-2.5 font-anton text-[11px] uppercase leading-none text-main transition-colors hover:bg-white/90 disabled:cursor-not-allowed disabled:bg-white/15 disabled:text-white/60 lg:px-3 lg:text-[12px]";
const LEAGUE_LOBBY_STATUS_PILL_CLASS = "shrink-0 bg-lime px-1.5 py-0.5 font-anton text-[10px] uppercase leading-none text-main";
const LEAGUE_LOBBY_CARD_SURFACE_CLASS = "min-w-0 overflow-hidden bg-[linear-gradient(to_right,#4e2384,#4d287a)]";
const LEAGUE_LOBBY_CARD_BODY_CLASS = "bg-[#5B2A9A]";
const LEAGUE_LOBBY_CARD_NESTED_CLASS = "bg-[#6B35B0] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.08)] hover:bg-[#7640BC]";
const LEAGUE_LOBBY_CARD_TOOLBAR_CLASS = "flex items-center gap-2 border-0 border-b border-solid border-white/10 bg-[#2E135B]/45 px-2 py-1.5";
const LEAGUE_HEADER_RADIAL_GRADIENT = "radial-gradient(50% 50% at 50% 50%, #652DAF 0%, #7C26EC 100%)";
const LEAGUE_DETAIL_GUTTER_X_CLASS = "px-2 phone-sm:px-2.5 md:px-3 lg:px-5 2xl:px-0";
const LEAGUE_MODE_HEADER_SHELL_ROW_CLASS = `c8-shell ${LEAGUE_DETAIL_GUTTER_X_CLASS}`;
const LEAGUE_DETAIL_GUTTER_LG_CLASS = "lg:px-5 2xl:px-0";
const LEAGUE_DETAIL_MOBILE_BLEED_SHELL_CLASS = `w-full max-w-none px-0 max-lg:c8-bleed lg:c8-shell ${LEAGUE_DETAIL_GUTTER_LG_CLASS}`;
const LEAGUE_DETAIL_SHELL_INSET_CLASS = LEAGUE_DETAIL_MOBILE_BLEED_SHELL_CLASS;
const LEAGUE_DETAIL_PAGE_SHELL_CLASS = `flex min-h-[600px] flex-col pb-6 ${LEAGUE_DETAIL_MOBILE_BLEED_SHELL_CLASS}`;
const LEAGUE_MODE_GOLD = "#FFC72C";
const LEAGUE_MODE_GOLD_DEEP = "#D4AF37";
const LEAGUE_MODE_CARD_BG = "#2E135B";
const LEAGUE_MODE_CARD_BG_SOFT = "#3A196E";
const LEAGUE_DESKTOP_COLUMN_BG = "#652DAF";
const LEAGUE_DESKTOP_COLUMN_TITLE_CLASS = "align-middle font-anton text-[20px] font-normal not-italic uppercase leading-[100%] tracking-[0] !text-white [leading-trim:none]";
const LEAGUE_DESKTOP_COLUMN_INSET_X_CLASS = "px-3 lg:px-4";
const LEAGUE_DESKTOP_COLUMN_TITLE_GAP_CLASS = "mb-2 lg:mb-3";
const LEAGUE_DESKTOP_COLUMN_TITLE_ROW_CLASS = `flex min-h-[30px] min-w-0 items-center gap-2 ${LEAGUE_DESKTOP_COLUMN_TITLE_GAP_CLASS}`;
const LEAGUE_BOARD_TAB_CYCLE_MS = 14000;
const LEAGUE_BOARD_TAB_CYCLE_RESUME_MS = 40000;
const LEAGUE_MODE_GOLD_BORDER_CLASS = "border-2 border-solid border-[#FFC72C]";
const LEAGUE_MODE_GOLD_BORDER_THIN_CLASS = "border border-solid border-[#FFC72C]";
const LEAGUE_ACTIVITY_CTA_PILL_CLASS = "inline-flex h-[22px] min-w-[4rem] w-[4rem] max-h-[22px] shrink-0 items-center justify-center whitespace-nowrap rounded-none border-0 bg-white px-1.5 py-0 text-center font-anton text-[9px] font-normal uppercase leading-none tracking-wide text-black transition-opacity hover:opacity-90 sm:min-w-[5.25rem] sm:w-[5.25rem] sm:px-2 sm:text-[10px]";
const LEAGUE_ACTIVITY_ROW_CLASS = "relative flex h-[60px] min-h-[60px] max-h-[60px] w-full min-w-0 items-center gap-2.5 overflow-hidden bg-[#1B062F]/30 px-2.5";
const LEAGUE_ACTIVITY_NAME_LINE_CLASS = "m-0 flex min-w-0 items-center gap-1.5 overflow-hidden font-anton text-[14px] font-normal not-italic uppercase leading-[22px] tracking-[0%] [leading-trim:none]";
const LEAGUE_ACTIVITY_BODY_LINE_CLASS = "m-0 flex min-w-0 items-center gap-1 overflow-hidden font-anton text-[16px] font-normal not-italic uppercase leading-[22px] tracking-[0%] text-white [leading-trim:none]";
const LEAGUE_ACTIVITY_TIME_CLASS = "shrink-0 self-start pt-0.5 font-chakra text-[11px] font-normal leading-[16px] text-white/45";
const LEAGUE_ACTIVITY_GAME_LABEL = {
    trader: "TRADER",
    squares: "SQUARES+",
    bullion: "BULLION+",
    sixes: "SIXES"
};
const LEAGUE_ACTIVITY_PAGE_SIZE = 20;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QY2j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isImminentCountdownStatus", ()=>(0, _matchCountdown.isImminentCountdownStatus));
parcelHelpers.export(exports, "isStreamingFixtureLive", ()=>isStreamingFixtureLive);
parcelHelpers.export(exports, "streamDataIndicatesCricketInPlay", ()=>streamDataIndicatesCricketInPlay);
/** Rain / weather stoppage, including pre-toss "Toss Delayed due to bad weather". */ parcelHelpers.export(exports, "cricketFeedTextIndicatesWeatherDelay", ()=>cricketFeedTextIndicatesWeatherDelay);
/** True when the current innings has actually started bowling — not just scoreboard inns 2 / 0.0. */ parcelHelpers.export(exports, "cricketNewInningsPlayIsUnderway", ()=>cricketNewInningsPlayIsUnderway);
parcelHelpers.export(exports, "cricketStreamCurrentInningsNumber", ()=>cricketStreamCurrentInningsNumber);
parcelHelpers.export(exports, "cricketStreamIndicatesNewInningsPlayUnderway", ()=>cricketStreamIndicatesNewInningsPlayUnderway);
parcelHelpers.export(exports, "advanceCricketInningsBreakLatch", ()=>advanceCricketInningsBreakLatch);
/**
 * Between innings with no break flag: Decimal sends BREAK_IN_PLAY ("Change of Innings") only briefly,
 * then drops back to MATCH_STABLE ("Play to Restart Shortly") or even MATCH_SCHEDULED (0)
 * until the next innings' first ball. Pretoss `curBall` (-3) must not hide that window.
 */ parcelHelpers.export(exports, "cricketStreamIndicatesInningsBreak", ()=>cricketStreamIndicatesInningsBreak);
/** Player-facing break line shared by the league card, Squares, Sixes, Bullion, and Trader. */ parcelHelpers.export(exports, "cricketPublicBreakLabel", ()=>cricketPublicBreakLabel);
/**
 * Break label to show while Decimal is not calling a live delivery.
 * A ball in progress wins over a stale "Rain Delay" line. MATCH_STABLE does not:
 * the scoreboard keeps "Break in Play - Rain Delay" through status 7 and 1.
 */ parcelHelpers.export(exports, "cricketDisplayedBreakLabel", ()=>cricketDisplayedBreakLabel);
/** "Break in Play" contains "in play" and must not read as the match being live. */ parcelHelpers.export(exports, "cricketPhaseSaysMatchInPlay", ()=>cricketPhaseSaysMatchInPlay);
/** True when internal list status text is a break (not ball-in-play). */ parcelHelpers.export(exports, "isCricketBreakInPlayMatchStatus", ()=>isCricketBreakInPlayMatchStatus);
/**
 * Break from fixture/list API fields when stream event_status has not caught up.
 */ parcelHelpers.export(exports, "getCricketBreakStatusFromMatch", ()=>getCricketBreakStatusFromMatch);
parcelHelpers.export(exports, "getCricketStatusFromStream", ()=>getCricketStatusFromStream);
/**
 * Cricket match cards on /matches and Trader: merge stream + fixture status.
 * Break must win over the generic stream IN-PLAY fallback (scorecard alone is not enough).
 * When a stream snapshot exists and reports no break, do not keep a stale list
 * "Toss Delayed / Rain Delay" label (same bug the league hub card had).
 */ parcelHelpers.export(exports, "resolveCricketMatchListStatus", ()=>resolveCricketMatchListStatus);
parcelHelpers.export(exports, "formatCountdown", ()=>formatCountdown);
parcelHelpers.export(exports, "getMatchStatus", ()=>getMatchStatus);
parcelHelpers.export(exports, "parseCricketMatchName", ()=>parseCricketMatchName);
parcelHelpers.export(exports, "extractHorseVenueName", ()=>extractHorseVenueName);
parcelHelpers.export(exports, "parseFootballTennisMatchData", ()=>parseFootballTennisMatchData);
parcelHelpers.export(exports, "extractMatchWinnerOdds", ()=>extractMatchWinnerOdds);
parcelHelpers.export(exports, "hasFootballLiveScoreValues", ()=>hasFootballLiveScoreValues);
parcelHelpers.export(exports, "shouldShowSportLiveScore", ()=>shouldShowSportLiveScore);
var _bullionPlayedMatchDetails = require("../Bullion/lib/bullionPlayedMatchDetails");
var _decimalEventStatus = require("../Trader/Cricket/decimalEventStatus");
var _matchCountdown = require("../../utils/matchCountdown");
var _matchTimeHorizon = require("../../utils/matchTimeHorizon");
var _marketUtils = require("./utils/marketUtils");
const isStreamingFixtureLive = (status)=>{
    const s = (status || "").toUpperCase();
    if (s.includes("MATCH COMPLETE") || s.includes("FINISHED") || s.includes("FULL TIME") || s.includes("EVENT CLOSED") || s === "EVENT_FULL_RESULT") return false;
    return s.includes("MATCH IN PROGRESS") || s.includes("IN-PLAY") || s.includes("IN PLAY") || // e.g. "Started In Play"
    s.includes("LIVE") || s.includes("BREAK IN PLAY") || s.includes("INNINGS COMPLETE") || s.includes("PLAY TO RESTART") || // Chase target ("Play to 150") — not pre-match "Play to Start Shortly"
    /\bPLAY TO \d/.test(s);
};
const streamDataIndicatesCricketInPlay = (streamData)=>{
    if (!streamData) return false;
    const gp = streamData?.event?.scoreboard?.find((e)=>e?.name === "game_phase")?.value;
    if (gp && isStreamingFixtureLive(gp)) return true;
    const es = streamData?.market_update?.event_status;
    if (es != null && (0, _decimalEventStatus.isBreakInPlayStatus)(es)) return true;
    if (es != null && (es === 1 || es === 2 || es === "1" || es === "2" || String(es).toUpperCase() === "MATCH_STABLE" || String(es).toUpperCase() === "BALL_IN_PROGRESS")) return true;
    const sc = streamData?.scorecard;
    if (sc && (Number(sc.inns_now) > 0 || sc.inns1 && Number(sc.inns1.runs) > 0)) return true;
    return false;
};
const CRICKET_BREAK_IN_PLAY_COLOR = "text-[#a855f7]";
function cricketStreamScoreboard(streamData) {
    const board = streamData?.event?.scoreboard ?? streamData?.event?.event?.scoreboard;
    return Array.isArray(board) ? board : [];
}
function cricketStreamScoreboardValues(streamData, names) {
    const scoreboard = cricketStreamScoreboard(streamData);
    if (scoreboard.length === 0) return [];
    const values = [];
    for (const name of names){
        const entry = scoreboard.find((e)=>e?.name === name);
        const value = entry?.value;
        if (value != null && String(value).trim() !== "") values.push(value);
    }
    return values;
}
function cricketStreamBreakStatusSources(streamData) {
    const eventStatus = streamData?.market_update?.event_status ?? streamData?.event?.event_status ?? streamData?.scorecard?.event_status;
    const scorecardEventStatus = streamData?.scorecard?.event_status;
    const scoreboardTexts = cricketStreamScoreboardValues(streamData, [
        "game_phase",
        "status"
    ]);
    return [
        eventStatus,
        scorecardEventStatus,
        ...scoreboardTexts
    ];
}
function cricketFeedTextIndicatesWeatherDelay(raw) {
    const upper = String(raw ?? "").toUpperCase();
    if (!upper.trim()) return false;
    return upper.includes("RAIN DELAY") || upper.includes("WET OUTFIELD") || upper.includes("BAD WEATHER") || upper.includes("WEATHER DELAY") || upper.includes("TOSS DELAYED") || /DELAYED DUE TO (BAD )?WEATHER/.test(upper) || /COVERS? (ARE )?ON/.test(upper);
}
function cricketFeedTextIndicatesBreakInPlay(raw) {
    if (raw == null || raw === "") return false;
    if ((0, _decimalEventStatus.isBreakInPlayStatus)(raw)) return true;
    if ((0, _bullionPlayedMatchDetails.getEventStatusDisplayLabel)(raw) === "BREAK IN PLAY") return true;
    const upper = String(raw).toUpperCase();
    return upper.includes("BREAK IN PLAY") || cricketFeedTextIndicatesWeatherDelay(raw) || upper.includes("PLAY TO RESTART") || /\bDRINKS\b/.test(upper);
}
function cricketStreamScoreboardRow(streamData, name) {
    const board = cricketStreamScoreboard(streamData);
    if (board.length === 0) return "";
    const value = board.find((e)=>e?.name === name)?.value;
    return value == null ? "" : String(value).trim();
}
function cricketScoreboardCount(raw) {
    const n = Number(raw);
    if (!Number.isFinite(n) || n < 0) return 0;
    return n;
}
function cricketEventStatusIndicatesLiveDelivery(status) {
    if ((0, _decimalEventStatus.isBallInProgressStatus)(status)) return true;
    const n = (0, _decimalEventStatus.eventStatusToNumber)(status);
    return n === (0, _decimalEventStatus.EVENT_STATUS).UNKNOWN_EVENT || n === (0, _decimalEventStatus.EVENT_STATUS).RUNS_LIKELY || n === (0, _decimalEventStatus.EVENT_STATUS).POSSIBLE_WICKET || n === (0, _decimalEventStatus.EVENT_STATUS).UMPIRE_REVIEW;
}
/**
 * Decimal is calling the match in play (stable, ball in progress, review, super over).
 * Scorecard / game_phase can keep an old "Rain Delay" or "Break in Play" line while
 * overs and commentary continue — Squares and Trader follow this status, not that copy.
 */ function cricketEventStatusIndicatesActivePlay(status) {
    if (status == null || String(status).trim() === "") return false;
    if ((0, _decimalEventStatus.isBreakInPlayStatus)(status) || cricketFeedTextIndicatesBreakInPlay(status)) return false;
    if ((0, _decimalEventStatus.isBallInProgressOrMatchStable)(status) || cricketEventStatusIndicatesLiveDelivery(status)) return true;
    const n = (0, _decimalEventStatus.eventStatusToNumber)(status);
    if (n === (0, _decimalEventStatus.EVENT_STATUS).SUPER_OVER || n === (0, _decimalEventStatus.EVENT_STATUS).DATA_ASSEMBLY_ISSUE) return true;
    const upper = String(status).toUpperCase();
    return upper.includes("MATCH IN PROGRESS") || upper.includes("BALL IN PROGRESS") || /\bIN[-\s]?PLAY\b/.test(upper);
}
function cricketFeedTextIndicatesInningsRestartGap(raw) {
    const upper = String(raw ?? "").toUpperCase();
    if (!upper.trim()) return false;
    return upper.includes("PLAY TO RESTART") || upper.includes("CHANGE OF INNINGS") || upper.includes("INNINGS COMPLETE") || upper.includes("INNINGS BREAK") || /END OF (THE )?INNINGS/.test(upper);
}
function cricketOverDeliveryHasBalls(overDelivery) {
    return Array.isArray(overDelivery) && overDelivery.some((ball)=>ball != null && String(ball).trim() !== "");
}
function cricketScoregridInnsRows(streamData, inns) {
    const raw = streamData?.scoregrid;
    const wrapped = Array.isArray(raw) ? raw[0]?.msg_data ?? raw[0] : raw;
    const list = wrapped?.overs?.[`inns${inns}`] ?? wrapped?.scoregrid?.overs?.[`inns${inns}`];
    return Array.isArray(list) ? list : null;
}
function cricketScoregridInnsHasBall(streamData, inns) {
    const list = cricketScoregridInnsRows(streamData, inns);
    if (!list) return false;
    for (const row of list)for(let b = 1; b <= 12; b += 1){
        const cell = row?.[`b${b}`];
        if (cell != null && String(cell).trim() !== "") return true;
    }
    return false;
}
/** Highest scoregrid over index for an innings (e.g. 20 after a completed T20). */ function cricketScoregridInnsMaxOver(streamData, inns) {
    const list = cricketScoregridInnsRows(streamData, inns);
    if (!list) return 0;
    let maxOv = 0;
    for (const row of list){
        const ov = Math.floor(Number(row?.ov));
        if (Number.isFinite(ov) && ov > maxOv) maxOv = ov;
    }
    return maxOv;
}
function cricketNewInningsPlayIsUnderway(input) {
    if (cricketEventStatusIndicatesLiveDelivery(input.eventStatus)) return true;
    if ((input.partOvers ?? 0) > 0 || (input.delv ?? 0) > 0) return true;
    if ((input.completedOvers ?? 0) > 0) return true;
    return cricketOverDeliveryHasBalls(input.overDelivery);
}
function cricketStreamCurrentInningsNumber(streamData) {
    const fromBoard = cricketScoreboardCount(cricketStreamScoreboardRow(streamData, "Current Innings"));
    const fromSc = Math.floor(Number(streamData?.scorecard?.inns_now));
    const inns = Math.max(fromBoard, Number.isFinite(fromSc) && fromSc > 0 ? fromSc : 0);
    return inns >= 1 ? inns : 1;
}
function cricketStreamIndicatesNewInningsPlayUnderway(streamData) {
    if (!streamData) return false;
    const status = streamData?.market_update?.event_status ?? streamData?.event?.event_status;
    const part = cricketScoreboardCount(cricketStreamScoreboardRow(streamData, "Current Innings Part Overs"));
    const delv = cricketScoreboardCount(cricketStreamScoreboardRow(streamData, "current.delv"));
    const completedOvers = cricketScoreboardCount(cricketStreamScoreboardRow(streamData, "Current Innings Overs"));
    if (cricketNewInningsPlayIsUnderway({
        eventStatus: status,
        partOvers: part,
        delv,
        completedOvers
    })) return true;
    const inns = cricketStreamCurrentInningsNumber(streamData);
    const innsBlock = streamData?.scorecard?.[`inns${inns}`];
    const batting = Array.isArray(innsBlock?.batting) ? innsBlock.batting : [];
    if (batting.some((b)=>Number(b?.balls) > 0)) return true;
    return cricketScoregridInnsHasBall(streamData, inns);
}
function advanceCricketInningsBreakLatch(prev, next) {
    if (!prev || prev.matchKey !== next.matchKey || prev.inns !== next.inns) return {
        matchKey: next.matchKey,
        inns: next.inns,
        dismissed: Boolean(next.playUnderway)
    };
    return {
        matchKey: prev.matchKey,
        inns: prev.inns,
        dismissed: prev.dismissed || Boolean(next.playUnderway)
    };
}
function cricketStreamIndicatesInningsBreak(streamData, opts) {
    if (!streamData) return false;
    const status = streamData?.market_update?.event_status ?? streamData?.event?.event_status;
    if (!(0, _decimalEventStatus.cricketEventStatusAllowsInningsBreakInference)(status)) return false;
    if ((0, _decimalEventStatus.isBallInProgressStatus)(status)) return false;
    const row = (name)=>cricketStreamScoreboardRow(streamData, name);
    const winner = row("winner");
    if (winner && winner !== "NA") return false;
    const oversRaw = row("Current Innings Overs");
    if (oversRaw === "") return false;
    const inns = cricketScoreboardCount(row("Current Innings"));
    const overs = cricketScoreboardCount(oversRaw);
    const part = cricketScoreboardCount(row("Current Innings Part Overs"));
    const delv = cricketScoreboardCount(row("current.delv"));
    if (inns >= 2 && overs === 0 && part === 0 && delv === 0) return !opts?.dismissZeroOverInningsBreak;
    // Only innings 1 and 3 have a following innings in every format.
    if (inns !== 1 && inns !== 3) return false;
    if ((Number(row(`overs.${inns + 1}`)) || 0) > 0) return false;
    const max = Number(row("Max Overs")) || Number(row(`max.${inns}`)) || 0;
    const wktsBoard = Number(row(`wkts.${inns}`)) || 0;
    const cardInns = streamData?.scorecard?.[`inns${inns}`];
    const wktsCard = Number(cardInns?.wkts) || 0;
    const wkts = Math.max(wktsBoard, wktsCard);
    if (max > 0 && overs >= max && part === 0 || wkts >= 10) return true;
    // CurPos / board often reset to 0.0 while still keyed to inns 1/3. Live overs then miss
    // `overs >= max` (e.g. 9 wickets after a full T20) — fall back to scorecard + scoregrid.
    if (overs === 0 && part === 0 && delv === 0) {
        if (opts?.dismissZeroOverInningsBreak) return false;
        const cardOvers = parseFloat(String(cardInns?.overs ?? "").trim());
        if (max > 0 && Number.isFinite(cardOvers) && cardOvers >= max) return true;
        if (max > 0 && cricketScoregridInnsMaxOver(streamData, inns) >= max) return true;
    }
    return false;
}
function cricketBreakInPlayLabelFromFeedText(raw) {
    const text = String(raw ?? "").trim();
    if (!text) return "Break in Play";
    const withoutParen = text.replace(/\s*\([^)]*\)\s*/g, " ").replace(/\s+/g, " ").trim();
    if (/break in play/i.test(withoutParen)) {
        const parts = withoutParen.split(/\s*-\s*/);
        const tail = parts.slice(1).join(" - ").trim();
        return tail ? `Break in Play - ${tail}` : "Break in Play";
    }
    if (/rain delay/i.test(text) || cricketFeedTextIndicatesWeatherDelay(text)) return "Break in Play - Rain Delay";
    if (/\bdrinks\b/i.test(text)) return "Break in Play - Drinks";
    return "Break in Play";
}
function cricketBreakStatusFromFeedText(raw) {
    return {
        text: cricketBreakInPlayLabelFromFeedText(raw),
        color: CRICKET_BREAK_IN_PLAY_COLOR
    };
}
function cricketPublicBreakLabel(raw) {
    const text = cricketBreakInPlayLabelFromFeedText(raw);
    if (/rain delay/i.test(text) || cricketFeedTextIndicatesWeatherDelay(raw)) return "MATCH BREAK - RAIN DELAY";
    if (/drinks/i.test(text)) return "MATCH BREAK - DRINKS";
    if (/innings/i.test(text)) return "INNINGS BREAK";
    return "MATCH BREAK";
}
function cricketDisplayedBreakLabel(eventStatus, ...texts) {
    if (cricketEventStatusIndicatesLiveDelivery(eventStatus)) return null;
    let specific = null;
    let generic = (0, _decimalEventStatus.isBreakInPlayStatus)(eventStatus);
    const consider = (raw)=>{
        if (raw == null || raw === "") return;
        if (!(0, _decimalEventStatus.isBreakInPlayStatus)(raw) && !cricketFeedTextIndicatesBreakInPlay(raw)) return;
        const label = cricketPublicBreakLabel(raw);
        if (label === "MATCH BREAK") generic = true;
        else specific = specific ?? label;
    };
    for (const raw of texts)consider(raw);
    consider(eventStatus);
    if (specific) return specific;
    return generic ? "MATCH BREAK" : null;
}
function cricketPhaseSaysMatchInPlay(raw) {
    const text = String(raw ?? "").trim();
    if (!text || cricketFeedTextIndicatesBreakInPlay(text)) return false;
    return text === "In Play" || text.includes("Match in Progress") || /\bin play\b/i.test(text);
}
function isCricketBreakInPlayMatchStatus(status) {
    const text = status.text.trim();
    return text === "Break in Play" || text.startsWith("Break in Play -");
}
function getCricketBreakStatusFromMatch(match) {
    const candidates = [
        match.status,
        match.event_status
    ];
    for (const raw of candidates){
        if (!cricketFeedTextIndicatesBreakInPlay(raw)) continue;
        return cricketBreakStatusFromFeedText(raw);
    }
    return null;
}
const getCricketStatusFromStream = (streamData, opts)=>{
    if (!streamData) return null;
    const status = streamData?.market_update?.event_status ?? streamData?.event?.event_status;
    const inningsBreak = cricketStreamIndicatesInningsBreak(streamData, opts);
    const underway = cricketStreamIndicatesNewInningsPlayUnderway(streamData);
    const skipStaleInningsRestartText = !inningsBreak && (Boolean(opts?.dismissZeroOverInningsBreak) || cricketEventStatusIndicatesLiveDelivery(status) || underway);
    // Live event_status wins over a stale scorecard/game_phase break. Innings breaks still
    // apply: Decimal often sits on MATCH_STABLE with "Play to Restart" between innings.
    const skipStaleBreakCopy = !inningsBreak && cricketEventStatusIndicatesActivePlay(status);
    const overs = cricketScoreboardCount(cricketStreamScoreboardRow(streamData, "Current Innings Overs"));
    const part = cricketScoreboardCount(cricketStreamScoreboardRow(streamData, "Current Innings Part Overs"));
    const skipStaleBreakInPlayStatus = skipStaleInningsRestartText && Boolean(opts?.dismissZeroOverInningsBreak) && overs === 0 && part === 0;
    let genericBreak = null;
    for (const raw of cricketStreamBreakStatusSources(streamData)){
        if (!cricketFeedTextIndicatesBreakInPlay(raw)) continue;
        if (skipStaleBreakCopy && raw !== status) continue;
        if (skipStaleBreakInPlayStatus && (0, _decimalEventStatus.isBreakInPlayStatus)(raw)) continue;
        if (skipStaleInningsRestartText && cricketFeedTextIndicatesInningsRestartGap(raw) && !cricketFeedTextIndicatesWeatherDelay(raw) && !/\bDRINKS\b/i.test(String(raw))) continue;
        const next = cricketBreakStatusFromFeedText(raw);
        // Status 7 is only "Break in Play". Keep looking for the rain / drinks reason on game_phase.
        if (next.text === "Break in Play") {
            genericBreak = genericBreak ?? next;
            continue;
        }
        return next;
    }
    if (genericBreak) return genericBreak;
    if (inningsBreak) return {
        text: "Break in Play - Innings Break",
        color: CRICKET_BREAK_IN_PLAY_COLOR
    };
    return null;
};
function resolveCricketMatchListStatus(match, streamData, fromGet) {
    const prematchCountdown = fromGet.text.startsWith("STARTS IN ") || /^in\s+/i.test(fromGet.text);
    if (prematchCountdown) return fromGet;
    if (streamData) {
        const breakFromStream = getCricketStatusFromStream(streamData);
        if (breakFromStream) return breakFromStream;
        if (streamDataIndicatesCricketInPlay(streamData)) return {
            text: "IN-PLAY",
            color: "text-pink"
        };
        // Stream is attached but not on a break — ignore list-only rain/break status.
        if (isCricketBreakInPlayMatchStatus(fromGet) || getCricketBreakStatusFromMatch(match)) return {
            text: "SCHEDULED",
            color: "text-white"
        };
        return fromGet;
    }
    const breakFromMatch = getCricketBreakStatusFromMatch(match);
    if (breakFromMatch) return breakFromMatch;
    if (isCricketBreakInPlayMatchStatus(fromGet)) return fromGet;
    return fromGet;
}
const formatCountdown = (startTime, now)=>{
    const duration = (0, _matchCountdown.formatCountdownDuration)(startTime - now);
    return duration ? `STARTS IN ${duration}` : null;
};
const getMatchStatus = (match)=>{
    const status = (match.status || "").toUpperCase();
    const sport = (match.sport || "").toLowerCase();
    // Check if match is finished/completed
    // For horse races, also check for EVENT_FULL_RESULT status
    const isFinished = status.includes("MATCH COMPLETE") || status.includes("FINISHED") || status.includes("FULL TIME") || status.includes("EVENT CLOSED") || status === "EVENT_FULL_RESULT" || match.liveScore?.isFinished === true;
    // For horse races, also check if there are results (horses with positions)
    // This helps detect finished races even if status isn't explicitly set
    if (sport === "horses" && !isFinished) {
        const goalserveData = match.goalserveData;
        if (goalserveData?.horses && Array.isArray(goalserveData.horses)) {
            const hasResults = goalserveData.horses.some((horse)=>horse.position && horse.position > 0);
            if (hasResults) return {
                text: "FINISHED",
                color: "text-white"
            };
        }
    }
    // Return FINISHED status if match is finished
    if (isFinished) return {
        text: "FINISHED",
        color: "text-white"
    };
    // Weather / toss delay must beat the kickoff-passed "IN-PLAY" fallback.
    if (sport === "cricket" && cricketFeedTextIndicatesBreakInPlay(match.status)) return cricketBreakStatusFromFeedText(match.status);
    // Prematch Goalserve @status is often HH:MM kick-off clock (UTC), not a live minute.
    const liveScoreStatus = (match.liveScore?.status || "").trim();
    const isKickoffClockStatus = /^\d{1,2}:\d{2}$/.test(status) || /^\d{1,2}:\d{2}$/.test(liveScoreStatus);
    // Feed/live-score signals — ignored for display when kickoff is still in the future
    const looksLikeFootballLiveMinute = !isKickoffClockStatus && (/^\d+(\+\d+)?'?$/.test(status) || status.includes("'") || status.includes("+") && /^\d/.test(status) || /^\d+(\+\d+)?'?$/.test(liveScoreStatus));
    const isLiveFromFeed = status.includes("MATCH IN PROGRESS") || status.includes("IN-PLAY") || status.includes("LIVE") || status.includes("BREAK IN PLAY") || // Cricket: "Break in Play - Stumps", "Break in Play - Drinks", etc.
    status.includes("INNINGS COMPLETE") || // Cricket: Between innings, match still ongoing
    status.includes("PLAY TO RESTART") || // Cricket: after a break, before play resumes
    /\bPLAY TO \d/.test(status) || // Cricket: "Play to 150" chase target (not "Play to Start Shortly")
    looksLikeFootballLiveMinute || !isKickoffClockStatus && match.liveScore?.isLive === true; // Tennis/Football live score indicator
    // Backend always sets actual_start for horses (same as start when not postponed). Use only this for status/countdown.
    const effectiveStart = match.actual_start ?? match.start;
    const startTime = effectiveStart ? new Date(effectiveStart).getTime() : NaN;
    const now = Date.now();
    const minutesUntilStart = Number.isFinite(startTime) ? (startTime - now) / 60000 : null;
    // Kickoff still in the future: never show IN PLAY — prefer imminent "in Xm" or STARTS IN
    if (minutesUntilStart != null && minutesUntilStart > 0) {
        if (minutesUntilStart <= (0, _matchTimeHorizon.MATCH_IMMINENT_MINUTES)) {
            const imminent = (0, _matchCountdown.formatImminentCountdown)(startTime - now);
            if (imminent) return {
                text: imminent,
                color: "text-[#32F78D]"
            };
        }
        const countdown = formatCountdown(startTime, now);
        if (countdown) return {
            text: countdown,
            color: "text-[#32F78D]"
        };
    }
    // If match has started (start time passed) and not finished, consider it IN-PLAY
    if (effectiveStart && !isFinished && !isLiveFromFeed && Number.isFinite(startTime)) {
        const minutesSinceStart = (now - startTime) / 60000;
        if (sport === "horses") {
            // Horse race: IN-PLAY if started and less than 30 minutes ago (reasonable max for a race)
            if (minutesSinceStart >= 0 && minutesSinceStart < 30) return {
                text: "IN-PLAY",
                color: "text-pink"
            };
            // If horse race started more than 30 minutes ago and we can't determine if it's finished,
            // mark it as FINISHED (races typically last only a few minutes)
            if (minutesSinceStart >= 30) return {
                text: "FINISHED",
                color: "text-white"
            };
        } else if (sport === "cricket") {
            // Cricket: kickoff-passed is a weak signal. Weather / toss delay already returned above.
            // Skip IN-PLAY while the list status is still explicitly scheduled / pretoss (Decimal often
            // keeps those labels with curBall -3 until the first ball). Empty status still falls through
            // to IN-PLAY so list cards stay live when the feed is sparse.
            const pretossLike = status.includes("SCHEDULED") || status.includes("STARTING SOON") || status.includes("TOSS PENDING") || status.includes("AWAITING TOSS") || status.includes("PRE MATCH") || status.includes("PRE-MATCH");
            if (!pretossLike && minutesSinceStart >= 0 && minutesSinceStart < 720) return {
                text: "IN-PLAY",
                color: "text-pink"
            };
        } else {
            // Other sports: If match started more than 5 minutes ago and less than 4 hours ago, consider it IN-PLAY
            // (4 hours is a reasonable max match duration)
            if (minutesSinceStart > 5 && minutesSinceStart < 240) return {
                text: "IN-PLAY",
                color: "text-pink"
            };
        }
    }
    // Cricket: show "Break in Play" when feed says so (same as match-play), not generic IN-PLAY
    if (sport === "cricket" && (status.includes("BREAK IN PLAY") || status.includes("PLAY TO RESTART"))) return {
        text: "Break in Play",
        color: "text-[#a855f7]"
    };
    if (isLiveFromFeed) return {
        text: "IN-PLAY",
        color: "text-pink"
    };
    // Fallback for matches without start time
    if (status.includes("STARTING SOON") || status.includes("SCHEDULED")) return {
        text: "STARTING SOON",
        color: "text-purple"
    };
    return {
        text: "",
        color: "text-white"
    };
};
const parseCricketMatchName = (name)=>{
    if (!name) return {
        teams: [],
        competition: ""
    };
    const parts = name.split(",");
    if (parts.length >= 2) {
        const teams = parts[0].split(" v ").map((t)=>t.trim()).filter((t)=>t);
        return {
            teams,
            competition: parts[1]?.trim() || parts[2]?.trim() || ""
        };
    }
    const teams = name.split(" v ").map((t)=>t.trim()).filter((t)=>t);
    return {
        teams,
        competition: ""
    };
};
const extractHorseVenueName = (raceName)=>{
    if (!raceName) return "";
    // Remove time prefix in HH:MM or H:MM format at the start
    // Pattern matches: "16:00 " or "8:00 " at the beginning
    const timePrefixPattern = /^\d{1,2}:\d{2}\s+/;
    const cleaned = raceName.replace(timePrefixPattern, "").trim();
    return cleaned || raceName;
};
const parseFootballTennisMatchData = (match)=>{
    if (!match) return {
        teams: [],
        competition: ""
    };
    const participants = match["event-participants"] || [];
    const teams = participants.map((p)=>p?.["participant-name"] || p?.name).filter((name)=>name && name.trim() !== "");
    // Get competition from meta-tags
    const metaTags = match["meta-tags"] || [];
    let competition = "";
    for (const tag of metaTags)if (tag?.type?.toString().toUpperCase() === "COMPETITION") {
        competition = tag?.name || "";
        break;
    }
    if (!competition) {
        for (const tag of metaTags)if (tag?.type?.toString().toUpperCase() === "COUNTRY" && (tag?.name || "").trim().toLowerCase() === "world") {
            competition = "FIFA World Cup";
            break;
        }
    }
    return {
        teams,
        competition
    };
};
const extractMatchWinnerOdds = (match)=>{
    const participants = match["event-participants"] || [];
    if (!match.markets || match.markets.length === 0) return participants;
    const sport = (match.sport || "").toLowerCase();
    const matchOddsMarket = (0, _marketUtils.findMarketBySport)(match, sport);
    if (!matchOddsMarket?.runners?.length) return participants;
    return participants.map((participant)=>{
        const matchingRunner = (0, _marketUtils.findMatchingRunner)(matchOddsMarket.runners, participant);
        if (!matchingRunner) return participant;
        const odds = (0, _marketUtils.getOddsFromRunner)(matchingRunner);
        const resolvedOdds = odds != null && odds > 0 ? odds : participant.odds ?? participant.price;
        return {
            ...participant,
            odds: resolvedOdds ?? participant.odds,
            price: resolvedOdds ?? participant.price
        };
    });
};
const hasFootballLiveScoreValues = (liveScore)=>{
    if (!liveScore) return false;
    const home = liveScore.home;
    const away = liveScore.away;
    return home != null && away != null && home !== "?" && away !== "?";
};
const shouldShowSportLiveScore = (liveScore, isInPlay)=>{
    if (!liveScore) return false;
    if (liveScore.isLive === true || liveScore.isFinished === true) return true;
    if (isInPlay && hasFootballLiveScoreValues(liveScore)) return true;
    if (isInPlay && (liveScore.player1Sets || liveScore.player2Sets)) return true;
    if (hasFootballLiveScoreValues(liveScore)) return true;
    if (liveScore.player1Sets || liveScore.player2Sets) return true;
    return false;
};

},{"../Bullion/lib/bullionPlayedMatchDetails":"gNcBN","../Trader/Cricket/decimalEventStatus":"f1nlI","../../utils/matchCountdown":"hzPTj","../../utils/matchTimeHorizon":"78nzv","./utils/marketUtils":"kM2d5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gNcBN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MATCH_DETAILS_TABS", ()=>MATCH_DETAILS_TABS);
parcelHelpers.export(exports, "getEventStatusDisplayLabel", ()=>getEventStatusDisplayLabel);
parcelHelpers.export(exports, "looksLikeLiveCricketScoreboard", ()=>looksLikeLiveCricketScoreboard);
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
var _bullionPlayedUiConstants = require("./bullionPlayedUiConstants");
const MATCH_DETAILS_TABS = [
    "SCORECARD",
    "COMMENTARY",
    "LINEUP",
    "CHARTS"
];
const EVENT_STATUS_STRINGS = {
    MATCH_SCHEDULED: (0, _decimalEventStatus.EVENT_STATUS).MATCH_SCHEDULED,
    MATCH_STABLE: (0, _decimalEventStatus.EVENT_STATUS).MATCH_STABLE,
    BALL_IN_PROGRESS: (0, _decimalEventStatus.EVENT_STATUS).BALL_IN_PROGRESS,
    UNKNOWN_EVENT: (0, _decimalEventStatus.EVENT_STATUS).UNKNOWN_EVENT,
    RUNS_LIKELY: (0, _decimalEventStatus.EVENT_STATUS).RUNS_LIKELY,
    POSSIBLE_WICKET: (0, _decimalEventStatus.EVENT_STATUS).POSSIBLE_WICKET,
    UMPIRE_REVIEW: (0, _decimalEventStatus.EVENT_STATUS).UMPIRE_REVIEW,
    BREAK_IN_PLAY: (0, _decimalEventStatus.EVENT_STATUS).BREAK_IN_PLAY,
    DATA_ASSEMBLY_ISSUE: (0, _decimalEventStatus.EVENT_STATUS).DATA_ASSEMBLY_ISSUE,
    SUPER_OVER: (0, _decimalEventStatus.EVENT_STATUS).SUPER_OVER,
    MATCH_COMPLETE: (0, _decimalEventStatus.EVENT_STATUS).MATCH_COMPLETE,
    EVENT_CLOSED: (0, _decimalEventStatus.EVENT_STATUS).EVENT_CLOSED,
    EJECTED: (0, _decimalEventStatus.EVENT_STATUS).EJECTED
};
function getEventStatusDisplayLabel(eventStatus) {
    if (eventStatus == null || eventStatus === "") return null;
    const num = typeof eventStatus === "number" ? eventStatus : parseInt(String(eventStatus), 10);
    if (Number.isFinite(num) && (0, _bullionPlayedUiConstants.EVENT_STATUS_DISPLAY)[num]) return (0, _bullionPlayedUiConstants.EVENT_STATUS_DISPLAY)[num].text;
    const u = String(eventStatus).toUpperCase().replace(/-/g, "_").trim();
    const id = EVENT_STATUS_STRINGS[u];
    if (id !== undefined && (0, _bullionPlayedUiConstants.EVENT_STATUS_DISPLAY)[id]) return (0, _bullionPlayedUiConstants.EVENT_STATUS_DISPLAY)[id].text;
    return null;
}
function looksLikeLiveCricketScoreboard(scoreA, scoreB) {
    const a = String(scoreA || "").trim();
    const b = String(scoreB || "").trim();
    if (!a || !b) return false;
    if (a === "--" || b === "--") return false;
    // Anything beyond "0/0" on either side strongly suggests play has started.
    if (a !== "0/0" || b !== "0/0") return true;
    return false;
}

},{"../../Trader/Cricket/decimalEventStatus":"f1nlI","./bullionPlayedUiConstants":"6gavo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f1nlI":[function(require,module,exports,__globalThis) {
/**
 * Decimal Delta Feed – Event Status (Appendix 1).
 * Used to avoid hardcoded numbers when checking match state (scheduled vs in-play, finished, etc.).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EVENT_STATUS", ()=>EVENT_STATUS);
parcelHelpers.export(exports, "IN_PLAY_STATUS_IDS", ()=>IN_PLAY_STATUS_IDS);
parcelHelpers.export(exports, "FINISHED_STATUS_IDS", ()=>FINISHED_STATUS_IDS);
/** Normalize API value to number for comparison (API may send number or string). */ parcelHelpers.export(exports, "eventStatusToNumber", ()=>eventStatusToNumber);
/** String event_status from API may use spaces or hyphens; align to underscore keys. */ parcelHelpers.export(exports, "eventStatusStringKey", ()=>eventStatusStringKey);
parcelHelpers.export(exports, "isMatchScheduledStatus", ()=>isMatchScheduledStatus);
parcelHelpers.export(exports, "isMatchStableStatus", ()=>isMatchStableStatus);
parcelHelpers.export(exports, "isBallInProgressStatus", ()=>isBallInProgressStatus);
parcelHelpers.export(exports, "isBallInProgressOrMatchStable", ()=>isBallInProgressOrMatchStable);
parcelHelpers.export(exports, "isBreakInPlayStatus", ()=>isBreakInPlayStatus);
/**
 * Decimal often drops `event_status` back to MATCH_SCHEDULED (0) or omits it between innings.
 * Infer the break from the scoreboard unless a ball is in progress, super over, or the match is over.
 */ parcelHelpers.export(exports, "cricketEventStatusAllowsInningsBreakInference", ()=>cricketEventStatusAllowsInningsBreakInference);
/**
 * Delta feed `global_betting_status` / match_update.`betting_status`: open vs suspended.
 * Missing or unknown → treat as open so the lobby does not block play before the first update.
 */ parcelHelpers.export(exports, "isGlobalMatchTradingActive", ()=>isGlobalMatchTradingActive);
parcelHelpers.export(exports, "isMatchFinishedStatus", ()=>isMatchFinishedStatus);
/**
 * True when Decimal scoreboard `winner` is a real team name.
 * Feed sentinels: `NA` (no winner yet / tie path) and `VOID` (abandoned / no result).
 */ parcelHelpers.export(exports, "isDecimalTeamWinner", ()=>isDecimalTeamWinner);
/**
 * True when commentary looks like a match result (e.g. "won by 5 wickets", "India wins").
 * Ignores "won/wins the toss" so early-innings toss lines do not close the markets UI.
 * Also ignores the bogus "VOID wins." line produced from the VOID winner sentinel.
 */ parcelHelpers.export(exports, "commentIndicatesCricketMatchResult", ()=>commentIndicatesCricketMatchResult);
/** Chase line from Decimal scoreboard, e.g. "Romania require 3 runs from 29 balls." */ parcelHelpers.export(exports, "isCricketRrrComment", ()=>isCricketRrrComment);
/**
 * True when a finished-match result sentence cannot be reconciled with the innings totals,
 * e.g. Decimal closing a chase as "won by 5 wickets" while the second innings is still short
 * of the target. Reduced-target chases can legitimately win below the first-innings score, so
 * innings with different max overs are left alone, as are multi-innings (Test) results.
 */ parcelHelpers.export(exports, "cricketResultContradictsScores", ()=>cricketResultContradictsScores);
/**
 * Result sentence to render for a match, or "" when the feed text should be withheld:
 * a stale chase line, or a result the innings totals contradict.
 */ parcelHelpers.export(exports, "cricketResultTextForDisplay", ()=>cricketResultTextForDisplay);
/**
 * Pull a result sentence out of scorecard / game_phase status, e.g.
 * "Match Complete - Nottinghamshire have won by 7 runs" → "Nottinghamshire won by 7 runs".
 */ parcelHelpers.export(exports, "resultCommentFromEventStatus", ()=>resultCommentFromEventStatus);
/**
 * True when game_phase / caption means the *match* is over.
 * Do not treat "Innings Complete" (between-innings break) as finished — bare
 * `includes("complete")` falsely matched that mid-match caption and closed Trader.
 */ parcelHelpers.export(exports, "isCricketGamePhaseFinished", ()=>isCricketGamePhaseFinished);
parcelHelpers.export(exports, "resolveCricketMatchFinished", ()=>resolveCricketMatchFinished);
/** True when both primary innings lines are empty placeholders (0/0 or missing). */ parcelHelpers.export(exports, "cricketPrimaryScoresLookEmpty", ()=>cricketPrimaryScoresLookEmpty);
/** True when a single `runs/wkts` display line is an empty placeholder. */ parcelHelpers.export(exports, "cricketPrimaryScoreLineEmpty", ()=>cricketPrimaryScoreLineEmpty);
/** Runs from a `runs/wkts` display line, or null when it is not a real score. */ parcelHelpers.export(exports, "cricketScoreLineRuns", ()=>cricketScoreLineRuns);
/** Runs summed across every innings slot, or null when none parse. */ parcelHelpers.export(exports, "cricketScoreLinesTotalRuns", ()=>cricketScoreLinesTotalRuns);
const EVENT_STATUS = {
    MATCH_SCHEDULED: 0,
    MATCH_STABLE: 1,
    BALL_IN_PROGRESS: 2,
    UNKNOWN_EVENT: 3,
    RUNS_LIKELY: 4,
    POSSIBLE_WICKET: 5,
    UMPIRE_REVIEW: 6,
    BREAK_IN_PLAY: 7,
    DATA_ASSEMBLY_ISSUE: 8,
    SUPER_OVER: 9,
    MATCH_COMPLETE: 10,
    EVENT_CLOSED: 11,
    EJECTED: 13
};
const IN_PLAY_STATUS_IDS = [
    EVENT_STATUS.MATCH_STABLE,
    EVENT_STATUS.BALL_IN_PROGRESS,
    EVENT_STATUS.UNKNOWN_EVENT,
    EVENT_STATUS.RUNS_LIKELY,
    EVENT_STATUS.POSSIBLE_WICKET,
    EVENT_STATUS.UMPIRE_REVIEW,
    EVENT_STATUS.BREAK_IN_PLAY,
    EVENT_STATUS.DATA_ASSEMBLY_ISSUE,
    EVENT_STATUS.SUPER_OVER
];
const FINISHED_STATUS_IDS = [
    EVENT_STATUS.MATCH_COMPLETE,
    EVENT_STATUS.EVENT_CLOSED,
    EVENT_STATUS.EJECTED
];
function eventStatusToNumber(status) {
    if (status == null) return null;
    if (typeof status === "number" && Number.isFinite(status)) return status;
    const n = parseInt(String(status), 10);
    return Number.isFinite(n) ? n : null;
}
function eventStatusStringKey(status) {
    return String(status ?? "").toUpperCase().replace(/-/g, "_").replace(/\s+/g, "_").trim();
}
function isMatchScheduledStatus(status) {
    const n = eventStatusToNumber(status);
    if (n === null) return false;
    if (n === EVENT_STATUS.MATCH_SCHEDULED) return true;
    return eventStatusStringKey(status) === "MATCH_SCHEDULED";
}
function isMatchStableStatus(status) {
    const n = eventStatusToNumber(status);
    if (n === EVENT_STATUS.MATCH_STABLE) return true;
    return eventStatusStringKey(status) === "MATCH_STABLE";
}
function isBallInProgressStatus(status) {
    const n = eventStatusToNumber(status);
    if (n === EVENT_STATUS.BALL_IN_PROGRESS) return true;
    return eventStatusStringKey(status) === "BALL_IN_PROGRESS";
}
function isBallInProgressOrMatchStable(status) {
    const n = eventStatusToNumber(status);
    if (n !== null && (n === EVENT_STATUS.MATCH_STABLE || n === EVENT_STATUS.BALL_IN_PROGRESS)) return true;
    const s = eventStatusStringKey(status);
    return s === "MATCH_STABLE" || s === "BALL_IN_PROGRESS";
}
function isBreakInPlayStatus(status) {
    const n = eventStatusToNumber(status);
    if (n === EVENT_STATUS.BREAK_IN_PLAY) return true;
    return eventStatusStringKey(status) === "BREAK_IN_PLAY";
}
function cricketEventStatusAllowsInningsBreakInference(status) {
    if (isBallInProgressStatus(status)) return false;
    if (isMatchFinishedStatus(status)) return false;
    const n = eventStatusToNumber(status);
    if (n === EVENT_STATUS.SUPER_OVER) return false;
    if (n === EVENT_STATUS.RUNS_LIKELY || n === EVENT_STATUS.POSSIBLE_WICKET || n === EVENT_STATUS.UMPIRE_REVIEW) return false;
    return true;
}
function isGlobalMatchTradingActive(tradingStatus) {
    if (tradingStatus == null || tradingStatus === "") return true;
    if (tradingStatus === 0 || tradingStatus === "0") return false;
    if (tradingStatus === 1 || tradingStatus === "1") return true;
    const u = String(tradingStatus).toUpperCase();
    if (u === "SUSPENDED" || u === "INACTIVE") return false;
    if (u === "ACTIVE") return true;
    return true;
}
function isMatchFinishedStatus(status) {
    const n = eventStatusToNumber(status);
    if (n !== null && (n === EVENT_STATUS.MATCH_COMPLETE || n === EVENT_STATUS.EVENT_CLOSED || n === EVENT_STATUS.EJECTED)) return true;
    const u = String(status ?? "").toUpperCase().replace(/-/g, "_").trim();
    if (!u || u.includes("NOT FINISHED") || u.includes("NOT ABANDONED")) return false;
    return u.includes("EVENT CLOSED") || u.includes("EVENT_CLOSED") || u.includes("MATCH COMPLETE") || u.includes("MATCH_COMPLETE") || u.includes("FINISHED") || u === "EVENT_FULL_RESULT" || u.includes("ABANDON") || u.includes("NO RESULT") || u.includes("NO_RESULT");
}
function isDecimalTeamWinner(winner) {
    const w = String(winner ?? "").trim();
    if (!w) return false;
    const u = w.toUpperCase();
    return u !== "NA" && u !== "VOID";
}
function commentIndicatesCricketMatchResult(comment) {
    let c = String(comment ?? "").trim();
    if (!c) return false;
    if (/^void\s+wins\.?$/i.test(c)) return false;
    c = c.replace(/\b(won|wins)\s+the\s+toss\b/gi, " ").replace(/\s+/g, " ").trim();
    if (!c) return false;
    return /\bwins\s*$/i.test(c) || /\bwon\b/i.test(c) || /\bwins\b/i.test(c);
}
function isCricketRrrComment(comment) {
    return / require \d+ runs from \d+ ball/i.test(String(comment ?? "").trim());
}
/** Runs from a scorecard innings block, or null when the innings was not played. */ function cricketInningsRuns(innings) {
    if (!innings || typeof innings !== "object") return null;
    const runs = Number.parseInt(String(innings.runs ?? ""), 10);
    if (!Number.isFinite(runs) || runs <= 0) return null;
    return runs;
}
function cricketResultContradictsScores(params) {
    const text = String(params.resultText ?? "").trim();
    if (!text) return false;
    const scorecard = params.scorecard;
    if (!scorecard || typeof scorecard !== "object") return false;
    if (cricketInningsRuns(scorecard.inns3) != null || cricketInningsRuns(scorecard.inns4) != null) return false;
    const firstInningsRuns = cricketInningsRuns(scorecard.inns1);
    const secondInningsRuns = cricketInningsRuns(scorecard.inns2);
    if (firstInningsRuns == null || secondInningsRuns == null) return false;
    if (Array.isArray(params.maxOvers)) {
        const firstMax = Number.parseFloat(String(params.maxOvers[0] ?? ""));
        const secondMax = Number.parseFloat(String(params.maxOvers[1] ?? ""));
        if (Number.isFinite(firstMax) && Number.isFinite(secondMax) && firstMax !== secondMax) return false;
    }
    if (/\bwon by \d+ wickets?\b/i.test(text)) return secondInningsRuns <= firstInningsRuns;
    if (/\bwon by \d+ runs?\b/i.test(text)) return firstInningsRuns <= secondInningsRuns;
    return false;
}
function cricketResultTextForDisplay(params) {
    const text = String(params.matchComment ?? "").trim();
    if (!text || !params.matchFinished) return text;
    if (/^void\s+wins\.?$/i.test(text)) return "";
    if (isCricketRrrComment(text)) return "";
    if (cricketResultContradictsScores({
        resultText: text,
        scorecard: params.scorecard,
        maxOvers: params.maxOvers
    })) return "";
    return text;
}
function resultCommentFromEventStatus(eventStatus) {
    const raw = String(eventStatus ?? "").trim();
    if (!raw) return "";
    const afterComplete = raw.match(/^Match Complete\s*[-–—]\s*(.+)$/i)?.[1]?.trim() ?? "";
    const candidate = afterComplete || raw;
    if (!commentIndicatesCricketMatchResult(candidate) && !/\b(tied|draw|drawn|no result)\b/i.test(candidate)) return "";
    return candidate.replace(/\bhave\s+won\b/gi, "won").replace(/\s+/g, " ").trim();
}
function isCricketGamePhaseFinished(gamePhase) {
    const phaseLower = String(gamePhase ?? "").toLowerCase().trim();
    if (!phaseLower) return false;
    // Mid-match: first innings done, second not started (or similar breaks).
    if (/\binnings?\s+complete\b/.test(phaseLower)) return false;
    return phaseLower.includes("match complete") || phaseLower.includes("event closed") || phaseLower === "closed";
}
function resolveCricketMatchFinished(params) {
    if (isMatchFinishedStatus(params.eventStatus)) return true;
    if (isCricketGamePhaseFinished(params.gamePhase)) return true;
    const winner = String(params.winner ?? "").trim();
    if (winner && winner !== "NA") return true;
    if (commentIndicatesCricketMatchResult(params.matchComment)) return true;
    return false;
}
function cricketPrimaryScoresLookEmpty(scores) {
    if (!Array.isArray(scores) || scores.length < 2) return true;
    return scores.slice(0, 2).every((s)=>cricketPrimaryScoreLineEmpty(s));
}
function cricketPrimaryScoreLineEmpty(score) {
    const v = String(score ?? "").trim();
    return !v || v === "0/0" || v === "-";
}
function cricketScoreLineRuns(score) {
    const v = String(score ?? "").trim();
    if (!v) return null;
    const slashIdx = v.indexOf("/");
    const runs = Number.parseInt(slashIdx >= 0 ? v.slice(0, slashIdx) : v, 10);
    return Number.isFinite(runs) ? runs : null;
}
function cricketScoreLinesTotalRuns(scores) {
    if (!Array.isArray(scores)) return null;
    let total = null;
    for (const line of scores){
        const runs = cricketScoreLineRuns(line);
        if (runs == null) continue;
        total = (total ?? 0) + runs;
    }
    return total;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6gavo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Shared desktop inset for Bullion match chrome, team strip, and content columns (margin-style, not padding on a wrapper). */ parcelHelpers.export(exports, "BULLION_DESKTOP_PAGE_GUTTER_CLASS", ()=>(0, _matchDetailLayout.MATCH_PLAY_DESKTOP_PAGE_GUTTER_CLASS));
parcelHelpers.export(exports, "BULLION_DEBUG_MARKETS", ()=>BULLION_DEBUG_MARKETS);
parcelHelpers.export(exports, "BULLION_WIN_BURST_SRC", ()=>BULLION_WIN_BURST_SRC);
parcelHelpers.export(exports, "BULLION_WIN_BURST_FALLBACK_SRC", ()=>BULLION_WIN_BURST_FALLBACK_SRC);
parcelHelpers.export(exports, "BULLION_BARS_SRC", ()=>BULLION_BARS_SRC);
parcelHelpers.export(exports, "BULLION_BONUS_BARS_ICON_SIZE_CLASS", ()=>BULLION_BONUS_BARS_ICON_SIZE_CLASS);
parcelHelpers.export(exports, "BULLION_LB_LAYOUT_SETTLE_MS", ()=>BULLION_LB_LAYOUT_SETTLE_MS);
parcelHelpers.export(exports, "BULLION_LB_RANK_JUICE_MS", ()=>BULLION_LB_RANK_JUICE_MS);
parcelHelpers.export(exports, "BULLION_LB_MOTION_TOTAL_MS", ()=>BULLION_LB_MOTION_TOTAL_MS);
parcelHelpers.export(exports, "BULLION_LB_ROW_LAYOUT_SPRING", ()=>BULLION_LB_ROW_LAYOUT_SPRING);
parcelHelpers.export(exports, "BULLION_LB_JUICE_EASE", ()=>BULLION_LB_JUICE_EASE);
parcelHelpers.export(exports, "BULLION_LB_CLIMB_BG_GRADIENT", ()=>BULLION_LB_CLIMB_BG_GRADIENT);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_GRID_COLS_CLASS", ()=>BULLION_LEADERBOARD_GRID_COLS_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_RANK_BOX_SIZE_CLASS", ()=>BULLION_LEADERBOARD_RANK_BOX_SIZE_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_RANK_BOX_CLASS", ()=>BULLION_LEADERBOARD_RANK_BOX_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_AVATAR_SIZE_CLASS", ()=>BULLION_LEADERBOARD_AVATAR_SIZE_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_AVATAR_INNER_CLASS", ()=>BULLION_LEADERBOARD_AVATAR_INNER_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_AVATAR_FALLBACK_CLASS", ()=>BULLION_LEADERBOARD_AVATAR_FALLBACK_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_AVATAR_CELL_CLASS", ()=>BULLION_LEADERBOARD_AVATAR_CELL_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_PLAYER_NAME_CLASS", ()=>BULLION_LEADERBOARD_PLAYER_NAME_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_PLAYER_COL_CLASS", ()=>BULLION_LEADERBOARD_PLAYER_COL_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_PLAYER_HEADER_ROW_CLASS", ()=>BULLION_LEADERBOARD_PLAYER_HEADER_ROW_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_HEADER_LABEL_CLASS", ()=>BULLION_LEADERBOARD_HEADER_LABEL_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_STAT_HEADER_CLASS", ()=>BULLION_LEADERBOARD_STAT_HEADER_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_POT_POINTS_CLASS", ()=>BULLION_LEADERBOARD_POT_POINTS_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_POINTS_CLASS", ()=>BULLION_LEADERBOARD_POINTS_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_ROW_HEIGHT_CLASS", ()=>BULLION_LEADERBOARD_ROW_HEIGHT_CLASS);
parcelHelpers.export(exports, "BULLION_LB_PRED_CORRECT", ()=>BULLION_LB_PRED_CORRECT);
parcelHelpers.export(exports, "BULLION_LB_PRED_WRONG", ()=>BULLION_LB_PRED_WRONG);
parcelHelpers.export(exports, "BULLION_LB_PRED_BAR_BG", ()=>BULLION_LB_PRED_BAR_BG);
parcelHelpers.export(exports, "BULLION_LB_PRED_POTENTIAL", ()=>BULLION_LB_PRED_POTENTIAL);
parcelHelpers.export(exports, "BULLION_LB_PRED_BAR_HEIGHT_CLASS", ()=>BULLION_LB_PRED_BAR_HEIGHT_CLASS);
parcelHelpers.export(exports, "BULLION_LB_PRED_BONUS_GRADIENT", ()=>BULLION_LB_PRED_BONUS_GRADIENT);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_PRIZE_RANK_GRADIENT", ()=>BULLION_LEADERBOARD_PRIZE_RANK_GRADIENT);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_PRIZE_COIN_STACK_OFFSET_CLASS", ()=>BULLION_LEADERBOARD_PRIZE_COIN_STACK_OFFSET_CLASS);
parcelHelpers.export(exports, "BULLION_TIE_ICON_SRC", ()=>BULLION_TIE_ICON_SRC);
parcelHelpers.export(exports, "BULLION_SLIP_MARKET_PANEL_BG_STYLE", ()=>BULLION_SLIP_MARKET_PANEL_BG_STYLE);
parcelHelpers.export(exports, "BULLION_HEADER_GRADIENT", ()=>BULLION_HEADER_GRADIENT);
parcelHelpers.export(exports, "BULLION_LIVE_OVER_TAB_GRADIENT", ()=>BULLION_LIVE_OVER_TAB_GRADIENT);
parcelHelpers.export(exports, "BULLION_LIVE_OVER_TAB_LABEL_CLASS", ()=>BULLION_LIVE_OVER_TAB_LABEL_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_HEADER_STYLE", ()=>BULLION_LEADERBOARD_HEADER_STYLE);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_HEADER_HEIGHT_CLASS", ()=>BULLION_LEADERBOARD_HEADER_HEIGHT_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_HEADER_ROW_CLASS", ()=>BULLION_LEADERBOARD_HEADER_ROW_CLASS);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_PLAYED_HEADER_STYLE", ()=>BULLION_LEADERBOARD_PLAYED_HEADER_STYLE);
parcelHelpers.export(exports, "BULLION_LEADERBOARD_PLAYED_HEADER_ROW_CLASS", ()=>BULLION_LEADERBOARD_PLAYED_HEADER_ROW_CLASS);
parcelHelpers.export(exports, "BULLION_GROUP_SECTION_HEADER_CLASS", ()=>BULLION_GROUP_SECTION_HEADER_CLASS);
parcelHelpers.export(exports, "BULLION_GROUP_SECTION_HEADER_STYLE", ()=>BULLION_GROUP_SECTION_HEADER_STYLE);
parcelHelpers.export(exports, "BULLION_ROOM_BOARD_DESKTOP_PAGE_BG_CLASS", ()=>BULLION_ROOM_BOARD_DESKTOP_PAGE_BG_CLASS);
parcelHelpers.export(exports, "BULLION_BONUS_ROW_MARKET_PANEL_BG_STYLE", ()=>BULLION_BONUS_ROW_MARKET_PANEL_BG_STYLE);
parcelHelpers.export(exports, "BULLION_BONUS_ROW_POT_PANEL_BG", ()=>BULLION_BONUS_ROW_POT_PANEL_BG);
parcelHelpers.export(exports, "BULLION_GOLDEN_ROW_NUMERIC_CLASS", ()=>BULLION_GOLDEN_ROW_NUMERIC_CLASS);
parcelHelpers.export(exports, "BULLION_SLIP_PLAYER_HEADSHOT_BACKDROP", ()=>BULLION_SLIP_PLAYER_HEADSHOT_BACKDROP);
parcelHelpers.export(exports, "BullionSlipPlayerImage", ()=>BullionSlipPlayerImage);
parcelHelpers.export(exports, "EVENT_STATUS_DISPLAY", ()=>EVENT_STATUS_DISPLAY);
parcelHelpers.export(exports, "BULLION_COMPLETED_DATA_RETRY_MS", ()=>BULLION_COMPLETED_DATA_RETRY_MS);
parcelHelpers.export(exports, "BULLION_MATCH_CHROME_HEADER_BAR_CLASS", ()=>BULLION_MATCH_CHROME_HEADER_BAR_CLASS);
parcelHelpers.export(exports, "BULLION_MATCH_CHROME_LOBBY_LABEL_CLASS", ()=>BULLION_MATCH_CHROME_LOBBY_LABEL_CLASS);
parcelHelpers.export(exports, "BULLION_MATCH_CHROME_CONTEST_ARENA_CLASS", ()=>BULLION_MATCH_CHROME_CONTEST_ARENA_CLASS);
parcelHelpers.export(exports, "BULLION_MATCH_CHROME_COMPETITION_CLASS", ()=>BULLION_MATCH_CHROME_COMPETITION_CLASS);
parcelHelpers.export(exports, "BULLION_WIN_TOAST_DISMISS_MS", ()=>BULLION_WIN_TOAST_DISMISS_MS);
parcelHelpers.export(exports, "BULLION_WIN_TOAST_ACK_PREFIX", ()=>BULLION_WIN_TOAST_ACK_PREFIX);
parcelHelpers.export(exports, "bullionWinToastReadAckIds", ()=>bullionWinToastReadAckIds);
parcelHelpers.export(exports, "bullionWinToastPersistAckIds", ()=>bullionWinToastPersistAckIds);
parcelHelpers.export(exports, "BULLION_PLAYED_FOOTER_PRIZE_POT_LABEL_CLASS", ()=>BULLION_PLAYED_FOOTER_PRIZE_POT_LABEL_CLASS);
parcelHelpers.export(exports, "BULLION_PLAYED_FOOTER_PRIZE_POT_ROW_CLASS", ()=>BULLION_PLAYED_FOOTER_PRIZE_POT_ROW_CLASS);
parcelHelpers.export(exports, "BULLION_PLAYED_FOOTER_PRIZE_POT_VALUE_CLASS", ()=>BULLION_PLAYED_FOOTER_PRIZE_POT_VALUE_CLASS);
parcelHelpers.export(exports, "BULLION_CURRENCY_COIN_SHADOW_STYLE", ()=>BULLION_CURRENCY_COIN_SHADOW_STYLE);
parcelHelpers.export(exports, "bullionPlayedFooterStripNavTypo", ()=>bullionPlayedFooterStripNavTypo);
parcelHelpers.export(exports, "bullionPlayedFooterStripNavHeight", ()=>bullionPlayedFooterStripNavHeight);
var _logos = require("../../shared/logos");
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
var _matchDetailLayout = require("../../Matches/matchDetailLayout");
const BULLION_DEBUG_MARKETS = false;
const BULLION_WIN_BURST_SRC = "/assets/bullion-win-2x.png";
const BULLION_WIN_BURST_FALLBACK_SRC = "/bullion-win-2x.png";
const BULLION_BARS_SRC = "/assets/bullion.png";
const BULLION_BONUS_BARS_ICON_SIZE_CLASS = "h-[24px] w-[24px] shrink-0 object-contain";
const BULLION_LB_LAYOUT_SETTLE_MS = 520;
const BULLION_LB_RANK_JUICE_MS = 880;
const BULLION_LB_MOTION_TOTAL_MS = BULLION_LB_LAYOUT_SETTLE_MS + BULLION_LB_RANK_JUICE_MS;
const BULLION_LB_ROW_LAYOUT_SPRING = {
    type: "spring",
    stiffness: 130,
    damping: 26,
    mass: 1.05
};
const BULLION_LB_JUICE_EASE = [
    0.22,
    1,
    0.36,
    1
];
const BULLION_LB_CLIMB_BG_GRADIENT = "linear-gradient(91deg, #FBF0A8 0%, #FCE9A0 28%, #F4DA8E 58%, #EAC97F 82%, #F3D88B 100%)";
const BULLION_LEADERBOARD_GRID_COLS_CLASS = "grid-cols-[20px_38px_minmax(0,1fr)_40px_40px_18px] sm:grid-cols-[20px_38px_minmax(0,1fr)_52px_52px_24px] lg:grid-cols-[20px_38px_minmax(0,1fr)_60px_60px_minmax(24px,32px)]";
const BULLION_LEADERBOARD_RANK_BOX_SIZE_CLASS = "box-border inline-flex h-[20px] w-[20px] min-h-[20px] min-w-[20px] max-h-[20px] max-w-[20px] shrink-0 items-center justify-center";
const BULLION_LEADERBOARD_RANK_BOX_CLASS = `${BULLION_LEADERBOARD_RANK_BOX_SIZE_CLASS} text-center font-anton text-[12px] font-normal uppercase leading-[12px] tracking-[0%] text-[#1B062F]`;
const BULLION_LEADERBOARD_AVATAR_SIZE_CLASS = "box-border block h-[30px] w-[30px] min-h-[30px] min-w-[30px] max-h-[30px] max-w-[30px] shrink-0";
const BULLION_LEADERBOARD_AVATAR_INNER_CLASS = `${BULLION_LEADERBOARD_AVATAR_SIZE_CLASS} object-cover`;
const BULLION_LEADERBOARD_AVATAR_FALLBACK_CLASS = `${BULLION_LEADERBOARD_AVATAR_SIZE_CLASS} flex items-center justify-center bg-[#3a1863] font-anton text-[12px]`;
const BULLION_LEADERBOARD_AVATAR_CELL_CLASS = `relative ${BULLION_LEADERBOARD_AVATAR_SIZE_CLASS} mx-1 justify-self-center`;
const BULLION_LEADERBOARD_PLAYER_NAME_CLASS = "min-w-0 truncate inline-flex h-[22px] items-center align-middle font-anton text-[12px] font-normal not-italic uppercase leading-[22px] tracking-[0%] [leading-trim:none]";
const BULLION_LEADERBOARD_PLAYER_COL_CLASS = "flex min-w-0 max-w-full flex-col justify-center gap-1 pl-1 pb-2 text-left sm:pl-2";
const BULLION_LEADERBOARD_PLAYER_HEADER_ROW_CLASS = "flex min-w-0 items-center justify-between gap-2";
const BULLION_LEADERBOARD_HEADER_LABEL_CLASS = "font-anton text-[12px] font-normal not-italic uppercase leading-[100%] tracking-[0%] [leading-trim:none]";
const BULLION_LEADERBOARD_STAT_HEADER_CLASS = `text-center ${BULLION_LEADERBOARD_HEADER_LABEL_CLASS}`;
const BULLION_LEADERBOARD_POT_POINTS_CLASS = "text-center font-anton text-[14px] font-normal leading-[20px] tracking-[0%] tabular-nums text-[#32F78D]/40";
const BULLION_LEADERBOARD_POINTS_CLASS = "text-center font-anton text-[18px] font-normal leading-[20px] tracking-[0%] tabular-nums text-[#32F78D]";
const BULLION_LEADERBOARD_ROW_HEIGHT_CLASS = "h-[54px]";
const BULLION_LB_PRED_CORRECT = "#32F78D";
const BULLION_LB_PRED_WRONG = "rgba(27, 6, 47, 0.2)";
const BULLION_LB_PRED_BAR_BG = "rgba(27, 6, 47, 0.2)";
const BULLION_LB_PRED_POTENTIAL = "rgba(50, 247, 141, 0.4)";
const BULLION_LB_PRED_BAR_HEIGHT_CLASS = "h-[10px]";
const BULLION_LB_PRED_BONUS_GRADIENT = "linear-gradient(107.25deg, #F9FBC7 17.65%, #E6C878 24.64%, #FBF0A8 32.44%, #7B5E2C 72.7%, #AE8E53 82.15%, #AE8E53 89.54%, #7C582D 103.1%)";
const BULLION_LEADERBOARD_PRIZE_RANK_GRADIENT = "linear-gradient(152.58deg, #F9FBC7 17.97%, #E6C878 24.74%, #FBF0A8 32.3%, #7B5E2C 71.33%, #AE8E53 80.49%, #AE8E53 87.66%, #7C582D 100.8%)";
const BULLION_LEADERBOARD_PRIZE_COIN_STACK_OFFSET_CLASS = "-left-[7px]";
const BULLION_TIE_ICON_SRC = "/assets/tie-dark.svg";
function bullionSlipParseHexRgb(hex) {
    const h = String(hex || "").trim().replace(/^#/, "");
    if (h.length !== 6) return {
        r: 101,
        g: 45,
        b: 175
    };
    return {
        r: parseInt(h.slice(0, 2), 16),
        g: parseInt(h.slice(2, 4), 16),
        b: parseInt(h.slice(4, 6), 16)
    };
}
/** My picks market column gradient — single source for panel + headshot tint. */ const BULLION_SLIP_MARKET_GRADIENT_FROM = "#652DAF";
const BULLION_SLIP_MARKET_GRADIENT_TO = "#623998";
const BULLION_SLIP_MARKET_PANEL_BG_STYLE = {
    backgroundImage: `linear-gradient(180deg, ${BULLION_SLIP_MARKET_GRADIENT_FROM} 0%, ${BULLION_SLIP_MARKET_GRADIENT_TO} 100%)`
};
const BULLION_HEADER_GRADIENT = "linear-gradient(91.27deg, #F9FBC7 4.89%, #E6C878 12.85%, #FBF0A8 21.75%, #7B5E2C 67.65%, #AE8E53 78.42%, #AE8E53 86.85%, #7C582D 102.3%)";
const BULLION_LIVE_OVER_TAB_GRADIENT = "linear-gradient(99.27deg, #F9FBC7 4.3%, #E6C878 14.91%, #FBF0A8 26.78%, #7B5E2C 87.98%, #AE8E53 102.34%, #AE8E53 113.58%, #7C582D 134.19%)";
const BULLION_LIVE_OVER_TAB_LABEL_CLASS = "font-anton text-[12px] font-normal not-italic uppercase leading-[100%] tracking-[0%] text-[#1B062F] [leading-trim:none]";
const BULLION_LEADERBOARD_HEADER_STYLE = {
    background: BULLION_HEADER_GRADIENT
};
const BULLION_LEADERBOARD_HEADER_HEIGHT_CLASS = "box-border h-[30px] min-h-[30px] max-h-[30px] shrink-0 overflow-hidden";
const BULLION_LEADERBOARD_HEADER_ROW_CLASS = `relative grid ${BULLION_LEADERBOARD_HEADER_HEIGHT_CLASS} ${BULLION_LEADERBOARD_GRID_COLS_CLASS} items-center border-b border-[#AE8E53]/35 pl-2 pr-0 text-[#1B062F]`;
const BULLION_LEADERBOARD_PLAYED_HEADER_STYLE = {
    ...BULLION_SLIP_MARKET_PANEL_BG_STYLE
};
const BULLION_LEADERBOARD_PLAYED_HEADER_ROW_CLASS = `relative grid ${BULLION_LEADERBOARD_HEADER_HEIGHT_CLASS} ${BULLION_LEADERBOARD_GRID_COLS_CLASS} items-center border-b border-white/10 pl-2 pr-0 text-white`;
const BULLION_GROUP_SECTION_HEADER_CLASS = "bullion-header-shimmer flex h-[30px] items-center px-2 !text-[#2a1604]";
const BULLION_GROUP_SECTION_HEADER_STYLE = {
    background: BULLION_HEADER_GRADIENT
};
const BULLION_ROOM_BOARD_DESKTOP_PAGE_BG_CLASS = "md:bg-[linear-gradient(to_top_right,#1B062F_0%,#3d1869_100%)]";
const BULLION_BONUS_ROW_MARKET_PANEL_BG_STYLE = {
    background: BULLION_HEADER_GRADIENT
};
const BULLION_BONUS_ROW_POT_PANEL_BG = "rgba(27, 6, 47, 0.2)";
const BULLION_GOLDEN_ROW_NUMERIC_CLASS = "font-bold tabular-nums text-lime";
const BULLION_SLIP_PLAYER_HEADSHOT_BACKDROP = (()=>{
    const a = bullionSlipParseHexRgb(BULLION_SLIP_MARKET_GRADIENT_FROM);
    const b = bullionSlipParseHexRgb(BULLION_SLIP_MARKET_GRADIENT_TO);
    const r = Math.round((a.r + b.r) / 2);
    const g = Math.round((a.g + b.g) / 2);
    const bl = Math.round((a.b + b.b) / 2);
    return `rgba(${r}, ${g}, ${bl}, 0.1)`;
})();
const BullionSlipPlayerImage = (0, _logos.PlayerHeadshotImage);
const EVENT_STATUS_DISPLAY = {
    [(0, _decimalEventStatus.EVENT_STATUS).MATCH_SCHEDULED]: {
        text: "SCHEDULED"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).MATCH_STABLE]: {
        text: "IN-PLAY"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).BALL_IN_PROGRESS]: {
        text: "IN-PLAY"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).UNKNOWN_EVENT]: {
        text: "IN-PLAY"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).RUNS_LIKELY]: {
        text: "IN-PLAY"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).POSSIBLE_WICKET]: {
        text: "IN-PLAY"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).UMPIRE_REVIEW]: {
        text: "IN-PLAY"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).BREAK_IN_PLAY]: {
        text: "BREAK IN PLAY"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).DATA_ASSEMBLY_ISSUE]: {
        text: "IN-PLAY"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).SUPER_OVER]: {
        text: "IN-PLAY"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).MATCH_COMPLETE]: {
        text: "FINISHED"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).EVENT_CLOSED]: {
        text: "FINISHED"
    },
    [(0, _decimalEventStatus.EVENT_STATUS).EJECTED]: {
        text: "FINISHED"
    }
};
const BULLION_COMPLETED_DATA_RETRY_MS = 2000;
const BULLION_MATCH_CHROME_HEADER_BAR_CLASS = "bg-[#652CAF]";
const BULLION_MATCH_CHROME_LOBBY_LABEL_CLASS = "font-anton text-[12px] font-normal not-italic uppercase leading-[100%] tracking-[0%] [leading-trim:none] text-white";
const BULLION_MATCH_CHROME_CONTEST_ARENA_CLASS = "min-w-0 truncate font-anton text-[12px] font-normal not-italic uppercase leading-[100%] tracking-[0%] [leading-trim:none] text-[#D2FF00]";
const BULLION_MATCH_CHROME_COMPETITION_CLASS = "min-w-0 max-w-[48%] shrink-0 truncate text-right font-anton text-[12px] font-normal not-italic uppercase leading-[100%] tracking-[0%] [leading-trim:none] text-[#FFFFFF] opacity-50";
const BULLION_WIN_TOAST_DISMISS_MS = 6000;
const BULLION_WIN_TOAST_ACK_PREFIX = "bullion_win_toast_ack:";
function bullionWinToastReadAckIds(gameId) {
    if (gameId == null || typeof window === "undefined") return new Set();
    try {
        const raw = window.localStorage.getItem(`${BULLION_WIN_TOAST_ACK_PREFIX}${String(gameId)}`);
        if (!raw) return new Set();
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return new Set();
        return new Set(parsed.filter((x)=>typeof x === "string"));
    } catch  {
        return new Set();
    }
}
function bullionWinToastPersistAckIds(gameId, rowIds) {
    if (typeof window === "undefined" || rowIds.length === 0) return;
    try {
        const merged = bullionWinToastReadAckIds(gameId);
        for (const id of rowIds)merged.add(id);
        window.localStorage.setItem(`${BULLION_WIN_TOAST_ACK_PREFIX}${String(gameId)}`, JSON.stringify([
            ...merged
        ]));
    } catch  {
    /* quota / private mode */ }
}
const BULLION_PLAYED_FOOTER_PRIZE_POT_LABEL_CLASS = "font-anton text-[12px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-white [leading-trim:none]";
const BULLION_PLAYED_FOOTER_PRIZE_POT_ROW_CLASS = "inline-flex min-w-0 shrink-0 items-center gap-1";
const BULLION_PLAYED_FOOTER_PRIZE_POT_VALUE_CLASS = "inline-flex items-center gap-0.5";
const BULLION_CURRENCY_COIN_SHADOW_STYLE = {
    boxShadow: "0px 2px 3px 0px #00000026"
};
const bullionPlayedFooterStripNavTypo = "font-anton text-[12px] font-normal not-italic uppercase leading-[20px] tracking-[0%] [leading-trim:none]";
const bullionPlayedFooterStripNavHeight = "box-border flex h-[30px] min-h-[30px] max-h-[30px] shrink-0 items-center justify-center py-0";

},{"../../shared/logos":"4XCsm","../../Trader/Cricket/decimalEventStatus":"f1nlI","../../Matches/matchDetailLayout":"01bvE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4XCsm":[function(require,module,exports,__globalThis) {
/**
 * Shared team and player logos used across Trader, Matches, Games, Squares, etc.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CricketTeamLogo", ()=>(0, _cricketTeamLogo.CricketTeamLogo));
parcelHelpers.export(exports, "getOrderedCricketTeamLogoUrls", ()=>(0, _cricketTeamLogo.getOrderedCricketTeamLogoUrls));
parcelHelpers.export(exports, "resolveCricketTeamLogoUrl", ()=>(0, _cricketTeamLogo.resolveCricketTeamLogoUrl));
parcelHelpers.export(exports, "FootballTeamLogo", ()=>(0, _footballTeamLogo.FootballTeamLogo));
parcelHelpers.export(exports, "TennisPlayerImage", ()=>(0, _tennisPlayerImage.TennisPlayerImage));
parcelHelpers.export(exports, "resolveFootballTeamLogoUrl", ()=>(0, _footballTeamLogoResolve.resolveFootballTeamLogoUrl));
parcelHelpers.export(exports, "resolveFootballTeamLogoS3UrlsFromName", ()=>(0, _footballTeamLogoResolve.resolveFootballTeamLogoS3UrlsFromName));
parcelHelpers.export(exports, "resolveTennisPlayerImageUrl", ()=>(0, _tennisPlayerImageResolve.resolveTennisPlayerImageUrl));
parcelHelpers.export(exports, "resolveTennisPlayerImageS3UrlsFromName", ()=>(0, _tennisPlayerImageResolve.resolveTennisPlayerImageS3UrlsFromName));
parcelHelpers.export(exports, "splitTennisDoublesPlayerNames", ()=>(0, _tennisPlayerImageResolve.splitTennisDoublesPlayerNames));
parcelHelpers.export(exports, "isTennisDoublesPlayerName", ()=>(0, _tennisPlayerImageResolve.isTennisDoublesPlayerName));
parcelHelpers.export(exports, "getTennisDoublesPartners", ()=>(0, _tennisDoublesPartners.getTennisDoublesPartners));
parcelHelpers.export(exports, "PlayerHeadshotImage", ()=>(0, _playerHeadshotImage.PlayerHeadshotImage));
parcelHelpers.export(exports, "HorsesJockeyImage", ()=>(0, _horsesJockeyImage.HorsesJockeyImage));
var _cricketTeamLogo = require("./CricketTeamLogo");
var _footballTeamLogo = require("./FootballTeamLogo");
var _tennisPlayerImage = require("./TennisPlayerImage");
var _footballTeamLogoResolve = require("../../../utils/footballTeamLogoResolve");
var _tennisPlayerImageResolve = require("../../../utils/tennisPlayerImageResolve");
var _tennisDoublesPartners = require("../../../utils/tennisDoublesPartners");
var _playerHeadshotImage = require("./PlayerHeadshotImage");
var _horsesJockeyImage = require("./HorsesJockeyImage");

},{"./CricketTeamLogo":"e57Zp","./FootballTeamLogo":"jVSIx","./TennisPlayerImage":"b89MI","../../../utils/footballTeamLogoResolve":"634yE","../../../utils/tennisPlayerImageResolve":"jac0R","../../../utils/tennisDoublesPartners":"9O12E","./PlayerHeadshotImage":"9wH61","./HorsesJockeyImage":"7VsKq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e57Zp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOrderedCricketTeamLogoUrls", ()=>(0, _cricketTeamLogoUrl.getOrderedCricketTeamLogoUrls));
/**
 * First cricket team logo URL that loads successfully, or null (no fallback shield).
 * @param {string} teamName
 * @returns {Promise<string | null>}
 */ parcelHelpers.export(exports, "resolveCricketTeamLogoUrl", ()=>resolveCricketTeamLogoUrl);
parcelHelpers.export(exports, "CricketTeamLogo", ()=>CricketTeamLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _cricketTeamLogoUrl = require("../../../utils/cricketTeamLogoUrl");
var _resolveFirstLoadingImageUrl = require("../../../utils/resolveFirstLoadingImageUrl");
var _useResolvedImageSrc = require("../../../utils/useResolvedImageSrc");
function resolveCricketTeamLogoUrl(teamName) {
    return (0, _resolveFirstLoadingImageUrl.resolveFirstLoadingImageUrl)((0, _cricketTeamLogoUrl.getOrderedCricketTeamLogoUrls)(teamName));
}
const CricketTeamLogo = ({ teamName = "", height = "40px", width = "40px", fallbackOveride = "false", sport = "cricket", logo = null, className = "" })=>{
    const fallbackImageUrl = (0, _cricketTeamLogoUrl.resolveCricketDefaultShieldUrl)(fallbackOveride);
    const orderedUrls = (0, _react.useMemo)(()=>(0, _cricketTeamLogoUrl.getOrderedCricketTeamLogoUrls)(teamName), [
        teamName
    ]);
    const customLogo = typeof logo === "string" && logo.trim() ? logo.trim() : "";
    const candidateUrls = (0, _react.useMemo)(()=>{
        const urls = [];
        if (customLogo) urls.push(customLogo);
        for (const url of orderedUrls)if (url && !urls.includes(url)) urls.push(url);
        return urls;
    }, [
        customLogo,
        orderedUrls
    ]);
    const { src, hidden, onError } = (0, _useResolvedImageSrc.useResolvedImageSrc)(candidateUrls, fallbackImageUrl);
    function handleLoad(event) {
        const img = event.target;
        if (img.naturalHeight > img.naturalWidth) img.style.maxHeight = `${height}`;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `flex items-center ${className}`,
        style: {
            width: width,
            height: height,
            minWidth: width,
            minHeight: height
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: src,
            onError: onError,
            alt: teamName ? `${teamName} team logo` : "Team logo",
            className: `w-[${width}]`,
            onLoad: handleLoad,
            style: {
                width: width,
                height: height,
                maxWidth: width,
                maxHeight: height,
                ...hidden ? {
                    visibility: "hidden"
                } : {}
            },
            decoding: "async"
        })
    });
};
exports.default = CricketTeamLogo;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../../utils/cricketTeamLogoUrl":"901Ku","../../../utils/resolveFirstLoadingImageUrl":"9UXSH","../../../utils/useResolvedImageSrc":"2qQuy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9UXSH":[function(require,module,exports,__globalThis) {
/**
 * Off-DOM image probing with an in-memory session cache.
 * Shared by team crest / player headshot components so remounts skip the
 * placeholder → real swap once a URL has been resolved.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "imageUrlListCacheKey", ()=>imageUrlListCacheKey);
/**
 * @returns `undefined` if not yet probed; `null` if all candidates failed; otherwise the working URL.
 */ parcelHelpers.export(exports, "getCachedResolvedImageUrl", ()=>getCachedResolvedImageUrl);
/**
 * First candidate URL that loads successfully (off-DOM), or null.
 * Same request count as an onError chain, but the visible <img> never needs to
 * show a broken icon when callers start from a placeholder or optimistic URL.
 */ parcelHelpers.export(exports, "resolveFirstLoadingImageUrl", ()=>resolveFirstLoadingImageUrl);
const resolvedByKey = new Map();
const inflightByKey = new Map();
function imageUrlListCacheKey(urls) {
    return (urls || []).filter(Boolean).join("\0");
}
function getCachedResolvedImageUrl(urls) {
    const list = (urls || []).filter(Boolean);
    if (list.length === 0) return null;
    const key = imageUrlListCacheKey(list);
    if (!resolvedByKey.has(key)) return undefined;
    return resolvedByKey.get(key) ?? null;
}
function resolveFirstLoadingImageUrl(urls) {
    const list = (urls || []).filter(Boolean);
    if (list.length === 0) return Promise.resolve(null);
    const key = imageUrlListCacheKey(list);
    if (resolvedByKey.has(key)) return Promise.resolve(resolvedByKey.get(key) ?? null);
    const existing = inflightByKey.get(key);
    if (existing) return existing;
    const promise = new Promise((resolve)=>{
        let i = 0;
        const finish = (result)=>{
            resolvedByKey.set(key, result);
            inflightByKey.delete(key);
            resolve(result);
        };
        const tryNext = ()=>{
            if (i >= list.length) {
                finish(null);
                return;
            }
            const probe = new Image();
            const url = list[i];
            probe.onload = ()=>{
                if (probe.naturalWidth > 0 && probe.naturalHeight > 0) finish(url);
                else {
                    i += 1;
                    tryNext();
                }
            };
            probe.onerror = ()=>{
                i += 1;
                tryNext();
            };
            probe.src = url;
        };
        tryNext();
    });
    inflightByKey.set(key, promise);
    return promise;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2qQuy":[function(require,module,exports,__globalThis) {
/**
 * Shared `<img>` src state for team crests / player headshots that resolve against a
 * list of candidate CDN URLs.
 *
 * Renders the first candidate optimistically so the common case (exact-name asset
 * exists) paints with no swap, while an off-DOM probe confirms in parallel. When the
 * optimistic guess 404s the image is hidden rather than swapped to the fallback —
 * otherwise names whose asset lives under a later candidate (e.g. "South Africa
 * Under-19s", which only has the parent `south-africa.png`) visibly flash the default
 * shield before settling on the real crest.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param candidateUrls Ordered URLs to try. Memoize by the caller — it drives the effect.
 * @param fallbackUrl Placeholder used once every candidate is known to have failed.
 */ parcelHelpers.export(exports, "useResolvedImageSrc", ()=>useResolvedImageSrc);
var _react = require("react");
var _resolveFirstLoadingImageUrl = require("./resolveFirstLoadingImageUrl");
function firstCandidate(urls) {
    return (urls || []).find(Boolean) || "";
}
function initialState(urls, fallbackUrl) {
    const cached = (0, _resolveFirstLoadingImageUrl.getCachedResolvedImageUrl)(urls);
    if (cached !== undefined) return {
        src: cached || fallbackUrl,
        confirmed: true,
        failed: false
    };
    return {
        src: firstCandidate(urls) || fallbackUrl,
        confirmed: false,
        failed: false
    };
}
function useResolvedImageSrc(candidateUrls, fallbackUrl) {
    const [state, setState] = (0, _react.useState)(()=>initialState(candidateUrls, fallbackUrl));
    (0, _react.useEffect)(()=>{
        let cancelled = false;
        const cached = (0, _resolveFirstLoadingImageUrl.getCachedResolvedImageUrl)(candidateUrls);
        if (cached !== undefined) {
            setState({
                src: cached || fallbackUrl,
                confirmed: true,
                failed: false
            });
            return undefined;
        }
        setState({
            src: firstCandidate(candidateUrls),
            confirmed: false,
            failed: false
        });
        (0, _resolveFirstLoadingImageUrl.resolveFirstLoadingImageUrl)(candidateUrls).then((resolved)=>{
            if (cancelled) return;
            setState({
                src: resolved || fallbackUrl,
                confirmed: true,
                failed: false
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        candidateUrls,
        fallbackUrl
    ]);
    const onError = (0, _react.useCallback)(()=>{
        setState((prev)=>{
            if (!prev.confirmed) return prev.failed ? prev : {
                ...prev,
                failed: true
            };
            if (prev.src === fallbackUrl) return prev;
            return {
                src: fallbackUrl,
                confirmed: true,
                failed: false
            };
        });
    }, [
        fallbackUrl
    ]);
    return {
        src: state.src,
        hidden: state.failed && !state.confirmed,
        onError
    };
}

},{"react":"6uln9","./resolveFirstLoadingImageUrl":"9UXSH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVSIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FootballTeamLogo", ()=>FootballTeamLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _footballTeamLogoResolve = require("../../../utils/footballTeamLogoResolve");
var _useResolvedImageSrc = require("../../../utils/useResolvedImageSrc");
const FootballTeamLogo = ({ teamName = "", height = "40px", width = "40px", logo = null, fallbackOveride = "false", className = "" })=>{
    const fallbackShieldUrl = (0, _react.useMemo)(()=>(0, _footballTeamLogoResolve.resolveFootballDefaultShieldUrl)(fallbackOveride), [
        fallbackOveride
    ]);
    const safeTeamName = (teamName || "").toString().trim();
    const s3Urls = (0, _react.useMemo)(()=>(0, _footballTeamLogoResolve.resolveFootballTeamLogoS3UrlsFromName)(safeTeamName), [
        safeTeamName
    ]);
    const goalserveLogo = (0, _footballTeamLogoResolve.isGoalserveFootballLogo)(logo) ? logo : null;
    const candidateUrls = (0, _react.useMemo)(()=>{
        const urls = [
            ...s3Urls
        ];
        if (goalserveLogo && !urls.includes(goalserveLogo)) urls.push(goalserveLogo);
        return urls;
    }, [
        s3Urls,
        goalserveLogo
    ]);
    const { src, hidden, onError } = (0, _useResolvedImageSrc.useResolvedImageSrc)(candidateUrls, fallbackShieldUrl);
    const isBase64 = Boolean(goalserveLogo && src === goalserveLogo);
    function handleLoad(event) {
        const img = event.target;
        img.style.borderRadius = "0";
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `flex shrink-0 items-center justify-center overflow-hidden rounded-none ${className}`.trim(),
        style: {
            width: width,
            height: height,
            minWidth: width,
            minHeight: height
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: src,
            onError: onError,
            alt: teamName ? `${teamName} team logo` : "Team logo",
            onLoad: handleLoad,
            className: "block h-full w-full max-h-full max-w-full rounded-none object-contain",
            style: {
                width,
                height,
                maxWidth: width,
                maxHeight: height,
                borderRadius: 0,
                ...hidden ? {
                    visibility: "hidden"
                } : {}
            },
            loading: isBase64 ? "eager" : undefined,
            decoding: "async"
        })
    });
};
exports.default = FootballTeamLogo;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../../utils/footballTeamLogoResolve":"634yE","../../../utils/useResolvedImageSrc":"2qQuy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"634yE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FOOTBALL_TEAM_LOGO_S3_BASE", ()=>FOOTBALL_TEAM_LOGO_S3_BASE);
parcelHelpers.export(exports, "FOOTBALL_TEAM_LOGO_DEFAULT_S3_FOLDER", ()=>FOOTBALL_TEAM_LOGO_DEFAULT_S3_FOLDER);
/**
 * Default shield when no team crest is found — mirrors {@link CricketTeamLogo} fallbackOveride:
 * - `"false"` → `shield.png`
 * - `"white"` → `shield_white.png`
 * - any other truthy value → `shield_subtle_grey.png`
 */ parcelHelpers.export(exports, "resolveFootballDefaultShieldUrl", ()=>resolveFootballDefaultShieldUrl);
parcelHelpers.export(exports, "isFootballDefaultShieldUrl", ()=>isFootballDefaultShieldUrl);
parcelHelpers.export(exports, "stripClubPrefixFromTeamName", ()=>stripClubPrefixFromTeamName);
parcelHelpers.export(exports, "slugifyFootballTeamName", ()=>slugifyFootballTeamName);
parcelHelpers.export(exports, "stripTeamLogoSuffixes", ()=>stripTeamLogoSuffixes);
parcelHelpers.export(exports, "teamNameVariantsForLogoLookup", ()=>teamNameVariantsForLogoLookup);
parcelHelpers.export(exports, "resolveFootballTeamLogoS3SlugCandidates", ()=>resolveFootballTeamLogoS3SlugCandidates);
parcelHelpers.export(exports, "footballTeamLogoS3Url", ()=>footballTeamLogoS3Url);
parcelHelpers.export(exports, "resolveFootballTeamLogoS3UrlsFromName", ()=>resolveFootballTeamLogoS3UrlsFromName);
/**
 * First football team crest URL that loads successfully, or null (no default shield).
 * Mirrors resolveCricketTeamLogoUrl for My Games history cards.
 * Probes off-DOM so callers never paint a broken-image icon.
 */ parcelHelpers.export(exports, "resolveFootballTeamLogoUrl", ()=>resolveFootballTeamLogoUrl);
parcelHelpers.export(exports, "isGoalserveFootballLogo", ()=>isGoalserveFootballLogo);
/**
 * Resolve S3 crest URL from a display name (first candidate only).
 * Use resolveFootballTeamLogoS3UrlsFromName for full fallback chain.
 */ parcelHelpers.export(exports, "resolveFootballTeamLogoS3UrlFromName", ()=>resolveFootballTeamLogoS3UrlFromName);
var _profileFavFootballTeams = require("../components/Profile/profileFavFootballTeams");
var _resolveFirstLoadingImageUrl = require("./resolveFirstLoadingImageUrl");
var _sportImageCdn = require("./sportImageCdn");
/** Crests at `Football/Team Logos/{slug}.png` (CloudFront → cricket8-web-content). */ const DEFAULT_FOOTBALL_TEAM_LOGO_S3_PREFIX = "Football/Team Logos";
const FOOTBALL_TEAM_LOGO_S3_BASE = (0, _sportImageCdn.sportImagePublicBase)(DEFAULT_FOOTBALL_TEAM_LOGO_S3_PREFIX, undefined);
const FOOTBALL_TEAM_LOGO_DEFAULT_S3_FOLDER = "default";
function resolveFootballDefaultShieldUrl(fallbackOverride = "false") {
    let file = "shield.png";
    if (fallbackOverride && fallbackOverride !== "false") file = fallbackOverride === "white" ? "shield_white.png" : "shield_subtle_grey.png";
    return `${FOOTBALL_TEAM_LOGO_S3_BASE}${FOOTBALL_TEAM_LOGO_DEFAULT_S3_FOLDER}/${file}`;
}
function isFootballDefaultShieldUrl(src) {
    if (typeof src !== "string" || !src) return false;
    try {
        const path = src.startsWith("/") ? src.split("?")[0] : new URL(src).pathname;
        return /\/default\/shield(?:_[\w]+)?\.png$/i.test(path);
    } catch  {
        return /\/default\/shield(?:_[\w]+)?\.png$/i.test(src);
    }
}
const FOOTBALL_TEAM_NAME_ALIASES = {
    "man city": "manchester-city",
    "man utd": "manchester-united",
    "man united": "manchester-united",
    spurs: "tottenham-hotspur",
    tottenham: "tottenham-hotspur",
    "tottenham hotspur": "tottenham-hotspur",
    atletico: "atletico-madrid",
    "atletico madrid": "atletico-madrid",
    "ac milan": "milan",
    inter: "inter-milan",
    "inter milan": "inter-milan",
    bayern: "bayern-munich",
    "bayern munich": "bayern-munich",
    dortmund: "borussia-dortmund",
    "borussia dortmund": "borussia-dortmund",
    psg: "paris-saint-germain",
    "paris saint germain": "paris-saint-germain",
    arsenal: "arsenal",
    "arsenal fc": "arsenal",
    chelsea: "chelsea",
    "chelsea fc": "chelsea",
    liverpool: "liverpool",
    "liverpool fc": "liverpool",
    barcelona: "barcelona",
    "fc barcelona": "barcelona",
    "real madrid": "real-madrid",
    juventus: "juventus",
    "juventus fc": "juventus"
};
/** Strip youth / women / reserve suffixes so "Switzerland U19 W" → "Switzerland". */ const TEAM_LOGO_SUFFIX_PATTERNS = [
    /\s+u\d{1,2}\s+w$/i,
    /\s+u\d{1,2}$/i,
    /\s+w$/i,
    /\s+women$/i,
    /\s+ladies$/i,
    /\s+reserves?$/i,
    /\s+ii$/i,
    /\s+iii$/i,
    /\s+iv$/i,
    /\s+b$/i
];
/** Leading club abbreviations — try slug with and without (e.g. FK Kauno Žalgiris → kauno-zalgiris). */ const TEAM_LOGO_CLUB_PREFIX_PATTERN = /^(?:1\.?\s*)?(?:fk|fc|ac|afc|sc|cd|cf|ca|sv|bsc|tsv|fsv|vfb|vfl|as|ss|us|sd|ud|ec|cr|se|rb|rc|sk|nk|ifk|hsk|spvgg)\.?\s+/i;
const stripClubPrefixFromTeamName = (name)=>{
    const trimmed = String(name || "").trim();
    if (!trimmed) return "";
    const next = trimmed.replace(TEAM_LOGO_CLUB_PREFIX_PATTERN, "").trim();
    return next || trimmed;
};
const normalizeFootballTeamName = (name)=>name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, " ").trim();
const slugifyFootballTeamName = (name)=>name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80);
const stripTeamLogoSuffixes = (name)=>{
    let current = String(name || "").trim();
    if (!current) return "";
    let changed = true;
    while(changed){
        changed = false;
        for (const pattern of TEAM_LOGO_SUFFIX_PATTERNS){
            const next = current.replace(pattern, "").trim();
            if (next && next !== current) {
                current = next;
                changed = true;
            }
        }
    }
    return current;
};
const teamNameVariantsForLogoLookup = (teamName)=>{
    const variants = [];
    const seen = new Set();
    const addVariant = (value)=>{
        const trimmed = value.trim();
        if (!trimmed || seen.has(trimmed)) return;
        seen.add(trimmed);
        variants.push(trimmed);
        const withoutPrefix = stripClubPrefixFromTeamName(trimmed);
        if (withoutPrefix && withoutPrefix !== trimmed && !seen.has(withoutPrefix)) {
            seen.add(withoutPrefix);
            variants.push(withoutPrefix);
        }
    };
    addVariant(teamName);
    let stripped = teamName;
    while(true){
        const next = stripTeamLogoSuffixes(stripped);
        if (!next || next === stripped) break;
        stripped = next;
        addVariant(stripped);
    }
    return variants;
};
const resolveSlugFromNameVariant = (name)=>{
    const norm = normalizeFootballTeamName(name);
    if (!norm) return null;
    const aliasSlug = FOOTBALL_TEAM_NAME_ALIASES[norm];
    if (aliasSlug) return aliasSlug;
    for (const opt of (0, _profileFavFootballTeams.PROFILE_FAV_FOOTBALL_TEAM_OPTIONS)){
        const candidates = [
            opt.slug,
            opt.label,
            (0, _profileFavFootballTeams.favFootballLongLabel)(opt.slug)
        ].filter(Boolean).map((c)=>normalizeFootballTeamName(c));
        if (candidates.includes(norm)) return opt.slug;
    }
    return slugifyFootballTeamName(name) || null;
};
const resolveFootballTeamLogoS3SlugCandidates = (teamName)=>{
    const slugs = [];
    const seen = new Set();
    const add = (slug)=>{
        const value = slug?.trim();
        if (value && !seen.has(value)) {
            seen.add(value);
            slugs.push(value);
        }
    };
    for (const variant of teamNameVariantsForLogoLookup(teamName))add(slugifyFootballTeamName(variant));
    for (const variant of teamNameVariantsForLogoLookup(teamName))add(resolveSlugFromNameVariant(variant));
    return slugs;
};
function footballTeamLogoS3Url(slug) {
    const safe = slugifyFootballTeamName(slug) || slug;
    return `${FOOTBALL_TEAM_LOGO_S3_BASE}${encodeURIComponent(safe)}.png`;
}
function resolveFootballTeamLogoS3UrlsFromName(teamName) {
    return resolveFootballTeamLogoS3SlugCandidates(teamName).map((slug)=>footballTeamLogoS3Url(slug));
}
function resolveFootballTeamLogoUrl(teamName) {
    return (0, _resolveFirstLoadingImageUrl.resolveFirstLoadingImageUrl)(resolveFootballTeamLogoS3UrlsFromName(teamName));
}
function isGoalserveFootballLogo(value) {
    if (typeof value !== "string" || !value) return false;
    return value.startsWith("data:image") || value.startsWith("/9j/") || value.startsWith("iVBOR");
}
function resolveFootballTeamLogoS3UrlFromName(teamName) {
    const urls = resolveFootballTeamLogoS3UrlsFromName(teamName);
    return urls[0] ?? null;
}

},{"../components/Profile/profileFavFootballTeams":"3mxlc","./resolveFirstLoadingImageUrl":"9UXSH","./sportImageCdn":"9gRYS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3mxlc":[function(require,module,exports,__globalThis) {
/**
 * Favourite football clubs for profile grid. Logos live at
 * `favs/football_teams/{slug}.png` on cricket8-web-content.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROFILE_FAV_FOOTBALL_LOGO_BASE", ()=>PROFILE_FAV_FOOTBALL_LOGO_BASE);
parcelHelpers.export(exports, "PROFILE_FAV_FOOTBALL_TEAM_OPTIONS", ()=>PROFILE_FAV_FOOTBALL_TEAM_OPTIONS);
parcelHelpers.export(exports, "footballTeamLogoUrl", ()=>footballTeamLogoUrl);
/** Light crest on transparent PNG — white tile so it reads on purple UI (favourites strip / grid). */ parcelHelpers.export(exports, "footballLogoUsesWhiteTile", ()=>footballLogoUsesWhiteTile);
parcelHelpers.export(exports, "parseFavFootballFromStorage", ()=>parseFavFootballFromStorage);
parcelHelpers.export(exports, "serializeFavFootballToStorage", ()=>serializeFavFootballToStorage);
parcelHelpers.export(exports, "favFootballLabel", ()=>favFootballLabel);
parcelHelpers.export(exports, "favFootballLongLabel", ()=>favFootballLongLabel);
const PROFILE_FAV_FOOTBALL_LOGO_BASE = "https://cricket8-web-content.s3.us-east-1.amazonaws.com/favs/football_teams/";
const PROFILE_FAV_FOOTBALL_TEAM_OPTIONS = [
    // England
    {
        slug: "arsenal",
        label: "Arsenal"
    },
    {
        slug: "chelsea",
        label: "Chelsea"
    },
    {
        slug: "liverpool",
        label: "Liverpool"
    },
    {
        slug: "manchester-city",
        label: "Man City"
    },
    {
        slug: "manchester-united",
        label: "Man Utd"
    },
    {
        slug: "tottenham-hotspur",
        label: "Spurs"
    },
    // Spain
    {
        slug: "atletico-madrid",
        label: "Atl\xe9tico"
    },
    {
        slug: "barcelona",
        label: "Barcelona"
    },
    {
        slug: "real-madrid",
        label: "Real Madrid"
    },
    // Italy
    {
        slug: "milan",
        label: "AC Milan"
    },
    {
        slug: "inter-milan",
        label: "Inter"
    },
    {
        slug: "juventus",
        label: "Juventus"
    },
    {
        slug: "lazio",
        label: "Lazio"
    },
    {
        slug: "napoli",
        label: "Napoli"
    },
    {
        slug: "roma",
        label: "Roma"
    },
    // Germany
    {
        slug: "bayern-munich",
        label: "Bayern"
    },
    {
        slug: "borussia-dortmund",
        label: "Dortmund"
    },
    // France
    {
        slug: "paris-saint-germain",
        label: "PSG"
    },
    // Others
    {
        slug: "al-nassr",
        label: "Al Nassr"
    },
    {
        slug: "inter-miami",
        label: "Inter Miami"
    }
];
const OPTION_SLUGS = PROFILE_FAV_FOOTBALL_TEAM_OPTIONS.map((t)=>t.slug);
const SLUG_SET = new Set(OPTION_SLUGS);
const SLUG_TO_LABEL = Object.fromEntries(PROFILE_FAV_FOOTBALL_TEAM_OPTIONS.map((t)=>[
        t.slug,
        t.label
    ]));
/** Full club names for expanded favourites / tooltips (grid tiles use short `label`). */ const SLUG_TO_LONG_LABEL = {
    arsenal: "Arsenal",
    chelsea: "Chelsea",
    liverpool: "Liverpool",
    "manchester-city": "Manchester City",
    "manchester-united": "Manchester United",
    "tottenham-hotspur": "Tottenham Hotspur",
    "atletico-madrid": "Atl\xe9tico Madrid",
    barcelona: "Barcelona",
    "real-madrid": "Real Madrid",
    milan: "AC Milan",
    "inter-milan": "Inter Milan",
    juventus: "Juventus",
    lazio: "Lazio",
    napoli: "Napoli",
    roma: "Roma",
    "bayern-munich": "Bayern Munich",
    "borussia-dortmund": "Borussia Dortmund",
    "paris-saint-germain": "Paris Saint-Germain",
    "al-nassr": "Al Nassr",
    "inter-miami": "Inter Miami"
};
function footballTeamLogoUrl(slug) {
    return `${PROFILE_FAV_FOOTBALL_LOGO_BASE}${encodeURIComponent(slug)}.png`;
}
function footballLogoUsesWhiteTile(slug) {
    return slug === "tottenham-hotspur" || slug === "napoli" || slug === "liverpool";
}
function parseFavFootballFromStorage(raw) {
    if (!raw?.trim()) return [];
    const parts = raw.split(/,\s*/).map((s)=>s.trim()).filter(Boolean);
    const ordered = [];
    for (const slug of OPTION_SLUGS)if (parts.includes(slug)) ordered.push(slug);
    for (const p of parts)if (!SLUG_SET.has(p) && !ordered.includes(p)) ordered.push(p);
    return ordered;
}
function serializeFavFootballToStorage(selected) {
    if (selected.length === 0) return "";
    const set = new Set(selected);
    const known = OPTION_SLUGS.filter((s)=>set.has(s));
    const unknown = selected.filter((s)=>!SLUG_SET.has(s));
    return [
        ...known,
        ...unknown
    ].join(", ");
}
function favFootballLabel(slug) {
    return SLUG_TO_LABEL[slug] ?? slug.replace(/-/g, " ");
}
function favFootballLongLabel(slug) {
    return SLUG_TO_LONG_LABEL[slug] ?? favFootballLabel(slug);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b89MI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TennisPlayerImage", ()=>TennisPlayerImage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tennisPlayerImageResolve = require("../../../utils/tennisPlayerImageResolve");
var _useResolvedImageSrc = require("../../../utils/useResolvedImageSrc");
const parsePx = (value, fallback = 40)=>{
    const match = String(value || "").match(/^([\d.]+)px$/i);
    return match ? parseFloat(match[1]) : fallback;
};
/**
 * Single tennis player headshot — S3 photo(s) keyed by player name slug, then Goalserve base64 from API,
 * then generic placeholder.
 *
 * Prefers a session-cached URL (or the first candidate optimistically), then confirms
 * off-DOM so missing assets never flash the browser broken-image icon or the placeholder.
 */ const TennisPlayerImageSingle = ({ playerName = "", imageUrl = "", height = "40px", width = "40px", backdropColor = "", imgMixBlendMode = "", className = "" })=>{
    const safePlayer = (playerName || "").toString().trim();
    const fallbackImageUrl = `${"https://dyatkw7msrzcb.cloudfront.net"}/player-placeholder-dark.svg`;
    const goalserveImage = (0, _tennisPlayerImageResolve.isGoalserveTennisPlayerImage)(imageUrl) ? imageUrl.trim() : null;
    const s3Urls = (0, _react.useMemo)(()=>(0, _tennisPlayerImageResolve.resolveTennisPlayerImageS3UrlsFromName)(safePlayer), [
        safePlayer
    ]);
    const candidateUrls = (0, _react.useMemo)(()=>{
        const urls = [
            ...s3Urls
        ];
        if (goalserveImage && !urls.includes(goalserveImage)) urls.push(goalserveImage);
        return urls;
    }, [
        s3Urls,
        goalserveImage
    ]);
    const { src, hidden, onError } = (0, _useResolvedImageSrc.useResolvedImageSrc)(candidateUrls, fallbackImageUrl);
    const isBase64 = Boolean(goalserveImage && src === goalserveImage);
    const altText = safePlayer ? `${safePlayer}` : "Player";
    const backdrop = String(backdropColor || "").trim();
    const blend = String(imgMixBlendMode || "").trim();
    const bullionTile = Boolean(backdrop || blend);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `flex shrink-0 items-center justify-center overflow-hidden ${className}`.trim(),
        style: {
            width,
            height,
            minWidth: width,
            minHeight: height,
            ...backdrop ? {
                backgroundColor: backdrop,
                isolation: "isolate"
            } : {}
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: src,
            onError: onError,
            alt: altText,
            style: {
                width: "100%",
                height: "100%",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                display: "block",
                ...bullionTile ? {
                    backgroundColor: "transparent",
                    ...blend ? {
                        mixBlendMode: blend
                    } : {}
                } : {},
                ...hidden ? {
                    visibility: "hidden"
                } : {}
            },
            loading: isBase64 ? "eager" : undefined,
            decoding: "async"
        })
    });
};
const TennisPlayerImage = ({ playerName = "", imageUrl = "", doublesPartners, height = "40px", width = "40px", backdropColor = "", imgMixBlendMode = "", className = "", gapPx = 2 })=>{
    const safePlayer = (playerName || "").toString().trim();
    const resolvedPartners = (0, _react.useMemo)(()=>{
        if (Array.isArray(doublesPartners) && doublesPartners.length === 2) return doublesPartners.map((partner)=>({
                name: String(partner?.name || "").trim(),
                imageUrl: partner?.image && (0, _tennisPlayerImageResolve.isGoalserveTennisPlayerImage)(partner.image) ? partner.image : ""
            })).filter((partner)=>partner.name);
        return (0, _tennisPlayerImageResolve.splitTennisDoublesPlayerNames)(safePlayer).map((name, index)=>({
                name,
                imageUrl: index === 0 && (0, _tennisPlayerImageResolve.isGoalserveTennisPlayerImage)(imageUrl) ? imageUrl : ""
            }));
    }, [
        doublesPartners,
        imageUrl,
        safePlayer
    ]);
    const isDoubles = resolvedPartners.length === 2;
    if (!isDoubles) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TennisPlayerImageSingle, {
        playerName: safePlayer,
        imageUrl: imageUrl,
        height: height,
        width: width,
        backdropColor: backdropColor,
        imgMixBlendMode: imgMixBlendMode,
        className: className
    });
    const totalWidthPx = parsePx(width);
    const totalHeightPx = parsePx(height);
    const eachWidthPx = Math.max(1, (totalWidthPx - gapPx) / 2);
    const eachWidth = `${eachWidthPx}px`;
    const eachHeight = `${totalHeightPx}px`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `flex shrink-0 items-center justify-center overflow-hidden ${className}`.trim(),
        style: {
            width,
            height,
            minWidth: width,
            minHeight: height,
            gap: `${gapPx}px`
        },
        "aria-label": safePlayer || "Doubles team",
        children: resolvedPartners.map((partner, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TennisPlayerImageSingle, {
                playerName: partner.name,
                imageUrl: partner.imageUrl || "",
                height: eachHeight,
                width: eachWidth,
                backdropColor: backdropColor,
                imgMixBlendMode: imgMixBlendMode
            }, `${partner.name}-${index}`))
    });
};
exports.default = TennisPlayerImage;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../../utils/tennisPlayerImageResolve":"jac0R","../../../utils/useResolvedImageSrc":"2qQuy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jac0R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTennisNationTeamCompetition", ()=>(0, _tennisNationTeamImage.isTennisNationTeamCompetition));
parcelHelpers.export(exports, "parseTennisNationTeamLabel", ()=>(0, _tennisNationTeamImage.parseTennisNationTeamLabel));
parcelHelpers.export(exports, "TENNIS_PLAYER_IMAGE_S3_BASE", ()=>TENNIS_PLAYER_IMAGE_S3_BASE);
parcelHelpers.export(exports, "splitTennisDoublesPlayerNames", ()=>splitTennisDoublesPlayerNames);
parcelHelpers.export(exports, "isTennisDoublesPlayerName", ()=>isTennisDoublesPlayerName);
parcelHelpers.export(exports, "slugifyTennisPlayerName", ()=>slugifyTennisPlayerName);
parcelHelpers.export(exports, "playerNameVariantsForImageLookup", ()=>playerNameVariantsForImageLookup);
parcelHelpers.export(exports, "resolveTennisPlayerImageSlugCandidates", ()=>resolveTennisPlayerImageSlugCandidates);
parcelHelpers.export(exports, "tennisPlayerImageS3Url", ()=>tennisPlayerImageS3Url);
parcelHelpers.export(exports, "resolveTennisPlayerImageS3UrlsFromName", ()=>resolveTennisPlayerImageS3UrlsFromName);
parcelHelpers.export(exports, "isGoalserveTennisPlayerImage", ()=>isGoalserveTennisPlayerImage);
/**
 * First tennis player headshot URL that loads successfully, or null.
 */ parcelHelpers.export(exports, "resolveTennisPlayerImageUrl", ()=>resolveTennisPlayerImageUrl);
var _resolveFirstLoadingImageUrl = require("./resolveFirstLoadingImageUrl");
var _sportImageCdn = require("./sportImageCdn");
var _tennisNationTeamImage = require("./tennisNationTeamImage");
const DEFAULT_TENNIS_PLAYER_IMAGE_S3_PREFIX = "Tennis/Player Images";
const TENNIS_PLAYER_IMAGE_S3_BASE = (0, _sportImageCdn.sportImagePublicBase)(DEFAULT_TENNIS_PLAYER_IMAGE_S3_PREFIX, undefined);
const splitTennisDoublesPlayerNames = (playerName)=>{
    const raw = String(playerName || "").trim();
    if (!raw || !raw.includes("/")) return raw ? [
        raw
    ] : [];
    const parts = raw.split(/\s*\/\s*/).map((p)=>p.trim()).filter(Boolean);
    if (parts.length !== 2) return [
        raw
    ];
    const looksLikePlayerName = (part)=>/[a-zA-Z]/.test(part) && !/^\d+\s*\/\s*\d+$/.test(part) && !/^(over|under)\b/i.test(part);
    if (!looksLikePlayerName(parts[0]) || !looksLikePlayerName(parts[1])) return [
        raw
    ];
    return parts;
};
const isTennisDoublesPlayerName = (playerName)=>splitTennisDoublesPlayerNames(playerName).length === 2;
const slugifyTennisPlayerName = (name)=>String(name || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\./g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80);
const cleanNameToken = (token)=>String(token || "").replace(/\./g, "").trim();
const isLikelyInitial = (token)=>{
    const t = cleanNameToken(token);
    return t.length >= 1 && t.length <= 2;
};
const splitPlayerNameParts = (name)=>String(name || "").trim().split(/\s+/).filter(Boolean);
const playerNameVariantsForImageLookup = (playerName)=>{
    const variants = [];
    const seen = new Set();
    const addVariant = (value)=>{
        const trimmed = String(value || "").trim();
        if (!trimmed || seen.has(trimmed)) return;
        seen.add(trimmed);
        variants.push(trimmed);
    };
    const addInitialSurname = (firstClean, lastClean)=>{
        if (firstClean.length < 2 || lastClean.length <= 2) return;
        if (isLikelyInitial(firstClean)) return;
        addVariant(`${firstClean[0]} ${lastClean}`);
    };
    const raw = String(playerName || "").trim();
    if (!raw) return variants;
    addVariant(raw);
    const nationTeam = (0, _tennisNationTeamImage.parseTennisNationTeamLabel)(raw);
    if (nationTeam) addVariant(nationTeam.country);
    const comma = raw.indexOf(",");
    if (comma > 0) {
        const last = raw.slice(0, comma).trim();
        const first = raw.slice(comma + 1).trim();
        if (first && last) {
            addVariant(`${first} ${last}`);
            addInitialSurname(cleanNameToken(first), cleanNameToken(last));
        }
    }
    if (!raw.includes(",")) {
        const parts = splitPlayerNameParts(raw);
        if (parts.length === 2) {
            const first = parts[0];
            const last = parts[1];
            const firstClean = cleanNameToken(first);
            const lastClean = cleanNameToken(last);
            if (!nationTeam) {
                if (isLikelyInitial(first) && lastClean.length > 2) ;
                else if (firstClean.length > 2 && lastClean.length > 2) {
                    addVariant(`${lastClean}, ${firstClean}`);
                    addInitialSurname(firstClean, lastClean);
                }
                if (parts[1].length <= 2) addVariant(`${parts[1]} ${parts[0]}`.replace(/\./g, "").trim());
            }
        }
        if (parts.length >= 3) {
            const firstClean = cleanNameToken(parts[0]);
            const lastClean = cleanNameToken(parts[parts.length - 1]);
            if (firstClean.length > 1 && lastClean.length > 2) {
                addVariant(`${firstClean} ${lastClean}`);
                addVariant(`${lastClean}, ${firstClean}`);
                addInitialSurname(firstClean, lastClean);
            }
        }
    }
    return variants;
};
const resolveTennisPlayerImageSlugCandidates = (playerName)=>{
    const slugs = [];
    const seen = new Set();
    const addSlug = (variant)=>{
        const slug = slugifyTennisPlayerName(variant);
        if (slug && !seen.has(slug)) {
            seen.add(slug);
            slugs.push(slug);
        }
    };
    const nationTeam = (0, _tennisNationTeamImage.parseTennisNationTeamLabel)(playerName);
    if (nationTeam) addSlug(nationTeam.country);
    for (const variant of playerNameVariantsForImageLookup(playerName))addSlug(variant);
    return slugs;
};
function tennisPlayerImageS3Url(slug) {
    const safe = slugifyTennisPlayerName(slug) || slug;
    return `${TENNIS_PLAYER_IMAGE_S3_BASE}${encodeURIComponent(safe)}.png`;
}
function resolveTennisPlayerImageS3UrlsFromName(playerName) {
    return resolveTennisPlayerImageSlugCandidates(playerName).map((slug)=>tennisPlayerImageS3Url(slug));
}
function isGoalserveTennisPlayerImage(value) {
    if (typeof value !== "string" || !value) return false;
    return value.startsWith("data:image") || value.startsWith("/9j/") || value.startsWith("iVBOR");
}
function resolveTennisPlayerImageUrl(playerName) {
    return (0, _resolveFirstLoadingImageUrl.resolveFirstLoadingImageUrl)(resolveTennisPlayerImageS3UrlsFromName(playerName));
}

},{"./resolveFirstLoadingImageUrl":"9UXSH","./sportImageCdn":"9gRYS","./tennisNationTeamImage":"3nOyy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3nOyy":[function(require,module,exports,__globalThis) {
/**
 * Nation-team labels in Goalserve tennis feeds (BJK Cup, Davis Cup, etc.).
 * e.g. "Algeria W", "Great Britain M" — one country flag image per country, shared across M/W.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTennisNationTeamCompetition", ()=>isTennisNationTeamCompetition);
/** Parse "Algeria W" / "Great Britain M" into country + gender suffix. */ parcelHelpers.export(exports, "parseTennisNationTeamLabel", ()=>parseTennisNationTeamLabel);
function isTennisNationTeamCompetition(competition) {
    const lower = String(competition || "").trim().toLowerCase();
    if (!lower) return false;
    return lower.startsWith("teams -") || lower.includes("davis cup") || lower.includes("billie jean king cup") || lower.includes("united cup");
}
function parseTennisNationTeamLabel(label) {
    const raw = String(label || "").trim();
    const match = raw.match(/^(.+?)\s+([MW])$/);
    if (!match) return null;
    const country = match[1].trim();
    const gender = match[2];
    if (!country || country.length < 2) return null;
    if (/^[A-Z]\.?$/.test(country)) return null;
    return {
        country,
        gender,
        label: raw
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9O12E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Backend-enriched partners for a doubles side (from ATP/WTA + Goalserve profile). */ parcelHelpers.export(exports, "getTennisDoublesPartners", ()=>getTennisDoublesPartners);
function getTennisDoublesPartners(participant) {
    if (!participant || typeof participant !== "object") return undefined;
    const raw = participant.doublesPartners;
    if (!Array.isArray(raw) || raw.length !== 2) return undefined;
    const partners = raw.map((row)=>{
        if (!row || typeof row !== "object") return null;
        const name = String(row.name || "").trim();
        if (!name) return null;
        return {
            name,
            playerId: row.playerId ?? null,
            image: row.image ?? null
        };
    }).filter((row)=>row != null);
    return partners.length === 2 ? partners : undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9wH61":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlayerHeadshotImage", ()=>PlayerHeadshotImage);
parcelHelpers.export(exports, "TennisPlayerImage", ()=>TennisPlayerImage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cricketPlayerImageResolve = require("../../../utils/cricketPlayerImageResolve");
var _useResolvedImageSrc = require("../../../utils/useResolvedImageSrc");
const PlayerHeadshotImage = ({ teamName = "", playerName = "", imageUrl = "", height = "40px", width = "40px", backdropColor = "", imgMixBlendMode = "", fallback = null })=>{
    // Keyed by value: callers often pass a fresh array (or null) each render, which would restart the lookup and keep the image hidden.
    const teamsKey = (Array.isArray(teamName) ? teamName : teamName ? [
        teamName
    ] : []).join("\u0000");
    const teams = (0, _react.useMemo)(()=>teamsKey ? teamsKey.split("\u0000") : [], [
        teamsKey
    ]);
    const safePlayer = (playerName || "").toString().trim();
    const fallbackImageUrl = `${"https://dyatkw7msrzcb.cloudfront.net"}/player-placeholder-dark.svg`;
    const feedUrl = imageUrl && typeof imageUrl === "string" && imageUrl.trim() ? imageUrl.trim() : "";
    const orderedUrls = (0, _react.useMemo)(()=>(0, _cricketPlayerImageResolve.getOrderedCricketPlayerImageUrls)(safePlayer, teams), [
        safePlayer,
        teams
    ]);
    const candidateUrls = (0, _react.useMemo)(()=>{
        const urls = [];
        if (feedUrl) urls.push(feedUrl);
        for (const url of orderedUrls)if (url && !urls.includes(url)) urls.push(url);
        return urls;
    }, [
        feedUrl,
        orderedUrls
    ]);
    const { src, hidden, onError } = (0, _useResolvedImageSrc.useResolvedImageSrc)(candidateUrls, fallbackImageUrl);
    function handleLoad(event) {
        const img = event.target;
        if (img.naturalHeight > img.naturalWidth) img.style.maxHeight = height;
    }
    const teamForAlt = teams[0] || "";
    const altText = safePlayer ? `${safePlayer}${teamForAlt ? ` (${teamForAlt})` : ""}` : "Player";
    const backdrop = String(backdropColor || "").trim();
    const blend = String(imgMixBlendMode || "").trim();
    const bullionTile = Boolean(backdrop || blend);
    if (fallback && src === fallbackImageUrl) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            width,
            height,
            minWidth: width,
            minHeight: height
        },
        children: fallback
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            width,
            height,
            minWidth: width,
            minHeight: height,
            ...backdrop ? {
                backgroundColor: backdrop,
                isolation: "isolate"
            } : {}
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: src,
            onError: onError,
            onLoad: handleLoad,
            alt: altText,
            style: {
                width,
                height,
                maxWidth: width,
                maxHeight: height,
                ...bullionTile ? {
                    objectFit: "contain",
                    display: "block",
                    backgroundColor: "transparent",
                    ...blend ? {
                        mixBlendMode: blend
                    } : {}
                } : {},
                ...hidden ? {
                    visibility: "hidden"
                } : {}
            },
            decoding: "async"
        })
    });
};
const TennisPlayerImage = PlayerHeadshotImage;
exports.default = PlayerHeadshotImage;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../../utils/cricketPlayerImageResolve":"azGex","../../../utils/useResolvedImageSrc":"2qQuy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"azGex":[function(require,module,exports,__globalThis) {
/**
 * Cricket player headshots at `Cricket/Player Images/{slug}.png`
 * (CloudFront → cricket8-web-content; same flat pattern as Tennis/Player Images).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CRICKET_PLAYER_IMAGE_S3_BASE", ()=>CRICKET_PLAYER_IMAGE_S3_BASE);
parcelHelpers.export(exports, "slugifyCricketPlayerName", ()=>slugifyCricketPlayerName);
/**
 * Name variants aligned with backend cricketPlayerNameVariantsForImageLookup.
 * Never emit a bare surname — shared surnames collide (e.g. Potts).
 * Keep initial+surname ("G Potts" → g-potts) for feed-friendly aliases.
 */ parcelHelpers.export(exports, "cricketPlayerNameVariantsForImageLookup", ()=>cricketPlayerNameVariantsForImageLookup);
parcelHelpers.export(exports, "cricketPlayerImageS3Url", ()=>cricketPlayerImageS3Url);
/** Legacy: `{CDN}/IPL+Team+Images/{team}/{Player_Name}.png` */ parcelHelpers.export(exports, "cricketPlayerImageLegacyCdnUrl", ()=>cricketPlayerImageLegacyCdnUrl);
/**
 * Ordered headshot URLs: flat S3 by player name variants, then legacy team-folder CDN paths.
 */ parcelHelpers.export(exports, "getOrderedCricketPlayerImageUrls", ()=>getOrderedCricketPlayerImageUrls);
var _sportImageCdn = require("./sportImageCdn");
const DEFAULT_CRICKET_PLAYER_IMAGE_S3_PREFIX = "Cricket/Player Images";
const LEGACY_CDN_PREFIX = "IPL+Team+Images";
const CRICKET_PLAYER_IMAGE_S3_BASE = (0, _sportImageCdn.sportImagePublicBase)(DEFAULT_CRICKET_PLAYER_IMAGE_S3_PREFIX, undefined);
function slugifyCricketPlayerName(name) {
    return String(name || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\./g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80);
}
const cleanNameToken = (token)=>String(token || "").replace(/\./g, "").trim();
const isLikelyInitial = (token)=>{
    const t = cleanNameToken(token);
    return t.length >= 1 && t.length <= 2;
};
const splitPlayerNameParts = (name)=>String(name || "").trim().split(/\s+/).filter(Boolean);
function cricketPlayerNameVariantsForImageLookup(playerName) {
    const variants = [];
    const seen = new Set();
    const addVariant = (value)=>{
        const trimmed = String(value || "").trim();
        if (!trimmed || seen.has(trimmed)) return;
        seen.add(trimmed);
        variants.push(trimmed);
    };
    const addInitialSurname = (firstClean, lastClean)=>{
        if (firstClean.length < 2 || lastClean.length <= 2) return;
        if (isLikelyInitial(firstClean)) return;
        addVariant(`${firstClean[0]} ${lastClean}`);
    };
    const raw = String(playerName || "").trim();
    if (!raw) return variants;
    addVariant(raw);
    const comma = raw.indexOf(",");
    if (comma > 0) {
        const last = raw.slice(0, comma).trim();
        const first = raw.slice(comma + 1).trim();
        if (first && last) {
            addVariant(`${first} ${last}`);
            addInitialSurname(cleanNameToken(first), cleanNameToken(last));
        }
    }
    if (!raw.includes(",")) {
        const parts = splitPlayerNameParts(raw);
        if (parts.length === 2) {
            const first = parts[0];
            const last = parts[1];
            const firstClean = cleanNameToken(first);
            const lastClean = cleanNameToken(last);
            if (isLikelyInitial(first) && lastClean.length > 2) ;
            else if (firstClean.length > 2 && lastClean.length > 2) {
                addVariant(`${lastClean}, ${firstClean}`);
                addInitialSurname(firstClean, lastClean);
            }
            if (parts[1].length <= 2) addVariant(`${parts[1]} ${parts[0]}`.replace(/\./g, "").trim());
        }
        if (parts.length >= 3) {
            const firstClean = cleanNameToken(parts[0]);
            const lastClean = cleanNameToken(parts[parts.length - 1]);
            const middleClean = parts.slice(1, -1).map(cleanNameToken).filter(Boolean);
            // Particles/middle names ("de Villiers") must stay in the initial alias.
            // Dropping them yields "M Villiers" → m-villiers, which collides with
            // unrelated players (Matthew de Villiers vs Mady Villiers).
            const compoundSurname = middleClean.length > 0 ? [
                ...middleClean,
                lastClean
            ].join(" ") : lastClean;
            if (firstClean.length > 1 && lastClean.length > 2) {
                addVariant(`${firstClean} ${lastClean}`);
                addVariant(`${lastClean}, ${firstClean}`);
                addInitialSurname(firstClean, compoundSurname);
            }
        }
    }
    return variants;
}
function cricketPlayerImageS3Url(playerName) {
    const slug = slugifyCricketPlayerName(playerName);
    if (!slug) return "";
    return `${CRICKET_PLAYER_IMAGE_S3_BASE}${slug}.png`;
}
function cricketPlayerImageLegacyCdnUrl(teamName, playerName) {
    const safeTeam = String(teamName || "").trim();
    const safePlayer = String(playerName || "").trim();
    const cdn = "https://dyatkw7msrzcb.cloudfront.net".replace(/\/$/, "");
    if (!safeTeam || !safePlayer) return "";
    return `${cdn}/${LEGACY_CDN_PREFIX}/${safeTeam.replace(/ /g, "+")}/${safePlayer.replace(/ /g, "_")}.png`;
}
function getOrderedCricketPlayerImageUrls(playerName, teamNames = []) {
    const safePlayer = String(playerName || "").trim();
    if (!safePlayer) return [];
    const urls = [];
    const seen = new Set();
    const push = (url)=>{
        if (!url || seen.has(url)) return;
        seen.add(url);
        urls.push(url);
    };
    for (const variant of cricketPlayerNameVariantsForImageLookup(safePlayer))push(cricketPlayerImageS3Url(variant));
    const teams = Array.isArray(teamNames) ? teamNames : teamNames ? [
        teamNames
    ] : [];
    for (const team of teams)for (const variant of cricketPlayerNameVariantsForImageLookup(safePlayer))push(cricketPlayerImageLegacyCdnUrl(String(team || ""), variant));
    return urls;
}

},{"./sportImageCdn":"9gRYS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VsKq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorsesJockeyImage", ()=>HorsesJockeyImage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const FALLBACKS = {
    default: `${"https://dyatkw7msrzcb.cloudfront.net"}/player-placeholder-dark.svg`,
    jockey: `${"https://dyatkw7msrzcb.cloudfront.net"}/Horse+Racing/Jockey+Images/Rider_no_image.png`
};
// Some upstream image hosts (e.g. matchbook silks) block cross-origin requests and
// return 403/NotSameOrigin for every image. Once we've seen an origin fail, there's no
// point re-requesting any image from it — go straight to the fallback. Remembered for
// the session so live re-renders and navigation don't re-trigger the blocked requests.
const FAILED_IMAGE_ORIGINS_KEY = "horsesImageFailedOrigins";
const getHttpOrigin = (url)=>{
    if (typeof url !== "string" || !/^https?:\/\//i.test(url)) return null;
    try {
        return new URL(url).origin;
    } catch  {
        return null;
    }
};
const loadFailedOrigins = ()=>{
    try {
        const raw = sessionStorage.getItem(FAILED_IMAGE_ORIGINS_KEY);
        return new Set(raw ? JSON.parse(raw) : []);
    } catch  {
        return new Set();
    }
};
const failedImageOrigins = loadFailedOrigins();
const isOriginBlocked = (url)=>{
    const origin = getHttpOrigin(url);
    return origin ? failedImageOrigins.has(origin) : false;
};
const markOriginBlocked = (url)=>{
    const origin = getHttpOrigin(url);
    if (!origin || failedImageOrigins.has(origin)) return;
    failedImageOrigins.add(origin);
    try {
        sessionStorage.setItem(FAILED_IMAGE_ORIGINS_KEY, JSON.stringify([
            ...failedImageOrigins
        ]));
    } catch  {
    // sessionStorage unavailable (private mode/quota) — in-memory Set still applies.
    }
};
const HorsesJockeyImage = ({ runnerImage = "", runnerName = "", height = "40px", width = "40px", whiteBackground = false, fallbackImageUrl, variant = "default" })=>{
    const resolvedFallback = fallbackImageUrl || FALLBACKS[variant] || FALLBACKS.default;
    const handleError = (e)=>{
        const img = e.target;
        markOriginBlocked(img.src);
        if (img.src !== resolvedFallback) img.src = resolvedFallback;
    };
    function handleLoad(event) {
        const img = event.target;
        if (img.naturalHeight > img.naturalWidth) img.style.maxHeight = height;
    }
    const requestedSrc = runnerImage && runnerImage.trim() ? runnerImage : resolvedFallback;
    // Skip the request entirely for origins we've already seen return forbidden/blocked.
    const src = isOriginBlocked(requestedSrc) ? resolvedFallback : requestedSrc;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `flex items-center justify-center flex-shrink-0 overflow-hidden ${whiteBackground ? "bg-white" : ""}`,
        style: {
            width,
            height,
            minWidth: width,
            minHeight: height
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: src,
            onError: handleError,
            alt: runnerName || "Participant",
            onLoad: handleLoad,
            style: {
                width,
                height,
                minWidth: width,
                minHeight: height,
                objectFit: "cover",
                display: "block",
                verticalAlign: "middle"
            },
            loading: "lazy",
            decoding: "async"
        })
    });
};
exports.default = HorsesJockeyImage;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"01bvE":[function(require,module,exports,__globalThis) {
/** Mobile horizontal gutter — aligns Finished label, tabs, and panel content (10px). */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MATCH_DETAIL_MOBILE_INSET_X", ()=>MATCH_DETAIL_MOBILE_INSET_X);
parcelHelpers.export(exports, "MATCH_PLAY_DESKTOP_PAGE_GUTTER_CLASS", ()=>MATCH_PLAY_DESKTOP_PAGE_GUTTER_CLASS);
parcelHelpers.export(exports, "MATCH_DETAIL_INSET_X", ()=>MATCH_DETAIL_INSET_X);
parcelHelpers.export(exports, "MATCH_DETAIL_DESKTOP_INSET_X", ()=>MATCH_DETAIL_DESKTOP_INSET_X);
parcelHelpers.export(exports, "MATCH_DETAIL_HEADER_DESKTOP_INSET", ()=>MATCH_DETAIL_HEADER_DESKTOP_INSET);
parcelHelpers.export(exports, "TENNIS_MATCH_DETAIL_INSET_X", ()=>TENNIS_MATCH_DETAIL_INSET_X);
parcelHelpers.export(exports, "MATCH_DETAIL_DESKTOP_GRID_COLS", ()=>MATCH_DETAIL_DESKTOP_GRID_COLS);
parcelHelpers.export(exports, "MATCH_DETAIL_DESKTOP_GRID_COLS_NARROW_PLAY_RAIL", ()=>MATCH_DETAIL_DESKTOP_GRID_COLS_NARROW_PLAY_RAIL);
parcelHelpers.export(exports, "MATCH_DETAIL_DESKTOP_GRID_GAP", ()=>MATCH_DETAIL_DESKTOP_GRID_GAP);
parcelHelpers.export(exports, "MATCH_DETAIL_EVENTS_CONTEXT_GRID_COLS", ()=>MATCH_DETAIL_EVENTS_CONTEXT_GRID_COLS);
parcelHelpers.export(exports, "MATCH_DETAIL_PANEL_CONTENT_CLASS", ()=>MATCH_DETAIL_PANEL_CONTENT_CLASS);
parcelHelpers.export(exports, "MATCH_DETAIL_PANEL_INNER_CLASS", ()=>MATCH_DETAIL_PANEL_INNER_CLASS);
parcelHelpers.export(exports, "MATCH_DETAIL_MOBILE_BLEED_CLASS", ()=>MATCH_DETAIL_MOBILE_BLEED_CLASS);
parcelHelpers.export(exports, "MATCH_DETAIL_TABLE_MOBILE_BLEED_CLASS", ()=>MATCH_DETAIL_TABLE_MOBILE_BLEED_CLASS);
parcelHelpers.export(exports, "MATCH_DETAIL_MOBILE_BLEED_SURFACE_CLASS", ()=>MATCH_DETAIL_MOBILE_BLEED_SURFACE_CLASS);
parcelHelpers.export(exports, "MATCH_DETAIL_TABLE_MOBILE_SURFACE_CLASS", ()=>MATCH_DETAIL_TABLE_MOBILE_SURFACE_CLASS);
parcelHelpers.export(exports, "MATCH_DETAIL_EMBED_COLUMN_CLASS", ()=>MATCH_DETAIL_EMBED_COLUMN_CLASS);
const MATCH_DETAIL_MOBILE_INSET_X = "px-[10px]";
const MATCH_PLAY_DESKTOP_PAGE_GUTTER_CLASS = "mx-auto box-border w-full min-w-0 max-w-[1280px] md:px-7 lg:px-10 xl:px-0";
const MATCH_DETAIL_INSET_X = "mx-auto w-full max-w-[1280px] px-[10px] md:px-7 lg:px-10 xl:px-12 2xl:px-14";
const MATCH_DETAIL_DESKTOP_INSET_X = "lg:mx-auto lg:w-full lg:max-w-[1280px] lg:px-10 xl:px-12 2xl:px-14";
const MATCH_DETAIL_HEADER_DESKTOP_INSET = "md:mx-auto md:w-full md:max-w-[1280px] md:px-7 md:pb-2 md:pt-5 lg:px-10 lg:pb-3 lg:pt-6 xl:px-12 2xl:px-14";
const TENNIS_MATCH_DETAIL_INSET_X = "mx-auto w-full max-w-[1280px] px-2 sm:px-3 lg:px-10 xl:px-12 2xl:px-14";
const MATCH_DETAIL_DESKTOP_GRID_COLS = "lg:grid-cols-[1.35fr_1fr] xl:grid-cols-[1.5fr_1fr] 2xl:grid-cols-[1.7fr_1fr] min-[1600px]:grid-cols-[1.85fr_1fr]";
const MATCH_DETAIL_DESKTOP_GRID_COLS_NARROW_PLAY_RAIL = "lg:grid-cols-[minmax(0,1fr)_minmax(260px,320px)] xl:grid-cols-[minmax(0,1fr)_minmax(280px,340px)] 2xl:grid-cols-[minmax(0,1fr)_minmax(300px,360px)]";
const MATCH_DETAIL_DESKTOP_GRID_GAP = "lg:gap-4 xl:gap-6";
const MATCH_DETAIL_EVENTS_CONTEXT_GRID_COLS = "lg:grid-cols-[minmax(0,1.45fr)_minmax(0,1fr)] xl:grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)]";
const MATCH_DETAIL_PANEL_CONTENT_CLASS = "min-h-0 px-0 pb-[10px] pt-4 lg:pb-4 lg:pt-6";
const MATCH_DETAIL_PANEL_INNER_CLASS = "min-h-0 px-0 pb-[10px] pt-4 lg:pb-4 lg:pt-0";
const MATCH_DETAIL_MOBILE_BLEED_CLASS = "max-lg:-mx-[10px] max-lg:w-[calc(100%+20px)] md:max-lg:-mx-7 md:max-lg:w-[calc(100%+3.5rem)]";
const MATCH_DETAIL_TABLE_MOBILE_BLEED_CLASS = MATCH_DETAIL_MOBILE_BLEED_CLASS;
const MATCH_DETAIL_MOBILE_BLEED_SURFACE_CLASS = "max-lg:border-x-0 max-lg:shadow-none";
const MATCH_DETAIL_TABLE_MOBILE_SURFACE_CLASS = MATCH_DETAIL_MOBILE_BLEED_SURFACE_CLASS;
const MATCH_DETAIL_EMBED_COLUMN_CLASS = "min-h-0 w-full self-start";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hzPTj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Relative kickoff duration. Zero units are omitted.
 * ≤24h: `5h 30m` | `5h` | `45m` | `1m`
 * >24h: `2d 5h` | `2d`
 */ parcelHelpers.export(exports, "formatCountdownDuration", ()=>formatCountdownDuration);
/** Imminent pre-start label: `in 1m` / `IN 1M` (not IN PLAY). */ parcelHelpers.export(exports, "formatImminentCountdown", ()=>formatImminentCountdown);
parcelHelpers.export(exports, "isImminentCountdownStatus", ()=>isImminentCountdownStatus);
/** Ensure a visible word gap before the duration when feeds omit whitespace (`STARTS IN45m`). */ parcelHelpers.export(exports, "normalizePrematchCountdownSpacing", ()=>normalizePrematchCountdownSpacing);
/** Split pre-kickoff labels like `STARTS IN 1H 56M` / `Starts in 3h 40m` / `IN 14M` into prefix + duration. */ parcelHelpers.export(exports, "parsePrematchCountdownParts", ()=>parsePrematchCountdownParts);
parcelHelpers.export(exports, "isPrematchCountdownLabel", ()=>isPrematchCountdownLabel);
function formatCountdownDuration(ms, unitCase = "lower") {
    if (!Number.isFinite(ms) || ms <= 0) return null;
    const totalDays = Math.floor(ms / 86400000);
    const remainingAfterDays = ms % 86400000;
    const totalHours = Math.floor(ms / 3600000);
    const remainingAfterHours = ms % 3600000;
    const hours = Math.floor(remainingAfterDays / 3600000);
    const minutes = Math.floor(remainingAfterHours / 60000);
    const d = unitCase === "upper" ? "D" : "d";
    const h = unitCase === "upper" ? "H" : "h";
    const m = unitCase === "upper" ? "M" : "m";
    if (totalDays > 0) return hours > 0 ? `${totalDays}${d} ${hours}${h}` : `${totalDays}${d}`;
    if (totalHours > 0) return minutes > 0 ? `${totalHours}${h} ${minutes}${m}` : `${totalHours}${h}`;
    if (minutes > 0) return `${minutes}${m}`;
    return `1${m}`;
}
function formatImminentCountdown(ms, unitCase = "lower") {
    const duration = formatCountdownDuration(ms, unitCase);
    if (!duration) return null;
    return unitCase === "upper" ? `IN ${duration}` : `in ${duration}`;
}
function isImminentCountdownStatus(text) {
    const t = (text ?? "").trim();
    return /^in\s+/i.test(t);
}
function normalizePrematchCountdownSpacing(text) {
    const trimmed = (text ?? "").trim();
    if (!trimmed) return trimmed;
    return trimmed.replace(/^((?:starts in|opens in|markets open in))(\d)/i, "$1 $2").replace(/^in(\d)/i, "in $1");
}
function parsePrematchCountdownParts(text) {
    const trimmed = normalizePrematchCountdownSpacing(text);
    if (!trimmed) return null;
    const startsInMatch = trimmed.match(/^((?:starts in|opens in|markets open in))\s*(.+)$/i);
    if (startsInMatch) {
        const prefix = startsInMatch[1].trimEnd();
        return {
            prefix: `${prefix} `,
            duration: startsInMatch[2].trim()
        };
    }
    const imminentMatch = trimmed.match(/^(in)\s*(.+)$/i);
    if (imminentMatch && !/^in[\s-]?play$/i.test(trimmed)) return {
        prefix: `${imminentMatch[1]} `,
        duration: imminentMatch[2].trim()
    };
    return null;
}
function isPrematchCountdownLabel(text) {
    return parsePrematchCountdownParts(text) != null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"78nzv":[function(require,module,exports,__globalThis) {
/**
 * Time-horizon buckets for match lists (keep aligned with
 * `backend/utils/matchOrdering/timeHorizon.js`).
 *
 * Upcoming sort: imminent (≤15m) → horizon → competition priority → start time.
 * Horizons are loaded from `/trade/homepage-match-centre-mix` into the module cache.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LIST_HORIZONS", ()=>DEFAULT_LIST_HORIZONS);
parcelHelpers.export(exports, "MATCH_TIME_HORIZON_NEAR_HOURS", ()=>MATCH_TIME_HORIZON_NEAR_HOURS);
parcelHelpers.export(exports, "MATCH_TIME_HORIZON_MID_HOURS", ()=>MATCH_TIME_HORIZON_MID_HOURS);
parcelHelpers.export(exports, "MATCH_IMMINENT_MINUTES", ()=>MATCH_IMMINENT_MINUTES);
/** True when kickoff is still in the future and within the imminent window. */ parcelHelpers.export(exports, "isImminentKickoff", ()=>isImminentKickoff);
parcelHelpers.export(exports, "resolveListHorizons", ()=>resolveListHorizons);
parcelHelpers.export(exports, "getActiveListHorizons", ()=>getActiveListHorizons);
parcelHelpers.export(exports, "setActiveListHorizons", ()=>setActiveListHorizons);
parcelHelpers.export(exports, "listHorizonLabels", ()=>listHorizonLabels);
/**
 * @returns 0 = near (incl. past/overdue), 1 = mid, 2 = later / unknown
 */ parcelHelpers.export(exports, "getMatchTimeHorizonBucket", ()=>getMatchTimeHorizonBucket);
parcelHelpers.export(exports, "getMatchTimeHorizonLabel", ()=>getMatchTimeHorizonLabel);
/** Compare two kickoffs by time horizon only (negative if a is nearer-bucket). */ parcelHelpers.export(exports, "compareMatchTimeHorizon", ()=>compareMatchTimeHorizon);
/** Compare two non-live kickoffs: imminent first, then near/mid/later horizon. */ parcelHelpers.export(exports, "compareMatchUpcomingPhase", ()=>compareMatchUpcomingPhase);
const DEFAULT_LIST_HORIZONS = Object.freeze({
    nearHours: 24,
    midHours: 168
});
const MATCH_TIME_HORIZON_NEAR_HOURS = DEFAULT_LIST_HORIZONS.nearHours;
const MATCH_TIME_HORIZON_MID_HOURS = DEFAULT_LIST_HORIZONS.midHours;
const MATCH_IMMINENT_MINUTES = 15;
function isImminentKickoff(startTimeMs, nowMs = Date.now(), minutes = MATCH_IMMINENT_MINUTES) {
    if (startTimeMs == null || !Number.isFinite(startTimeMs) || startTimeMs <= 0) return false;
    const minsUntil = (startTimeMs - nowMs) / 60000;
    return minsUntil > 0 && minsUntil <= minutes;
}
let cachedHorizons = {
    ...DEFAULT_LIST_HORIZONS
};
function resolveListHorizons(raw, fallback = DEFAULT_LIST_HORIZONS) {
    const base = fallback || DEFAULT_LIST_HORIZONS;
    const src = raw && typeof raw === "object" ? raw : {};
    let nearHours = Math.min(Math.max(Number(src.nearHours ?? base.nearHours) || 24, 1), 72);
    let midHours = Math.min(Math.max(Number(src.midHours ?? base.midHours) || 168, 2), 336);
    if (midHours <= nearHours) midHours = Math.min(336, nearHours + 24);
    return {
        nearHours,
        midHours
    };
}
function getActiveListHorizons() {
    return cachedHorizons;
}
function setActiveListHorizons(raw) {
    cachedHorizons = resolveListHorizons(raw);
    return cachedHorizons;
}
function listHorizonLabels(horizons = getActiveListHorizons()) {
    const h = resolveListHorizons(horizons);
    const midDays = h.midHours % 24 === 0 ? h.midHours / 24 : null;
    const midLabel = midDays != null ? `\u{2264}${midDays}d` : `\u{2264}${h.midHours}h`;
    return [
        `\u{2264}${h.nearHours}h`,
        midLabel,
        "Later"
    ];
}
function getMatchTimeHorizonBucket(startTimeMs, nowMs = Date.now(), horizons = getActiveListHorizons()) {
    if (startTimeMs == null || !Number.isFinite(startTimeMs) || startTimeMs <= 0) return 2;
    const h = resolveListHorizons(horizons);
    const hoursUntil = (startTimeMs - nowMs) / 3600000;
    if (hoursUntil <= h.nearHours) return 0;
    if (hoursUntil <= h.midHours) return 1;
    return 2;
}
function getMatchTimeHorizonLabel(startTimeMs, nowMs = Date.now(), horizons = getActiveListHorizons()) {
    const labels = listHorizonLabels(horizons);
    return labels[getMatchTimeHorizonBucket(startTimeMs, nowMs, horizons)] ?? "Later";
}
function compareMatchTimeHorizon(startA, startB, nowMs = Date.now(), horizons = getActiveListHorizons()) {
    return getMatchTimeHorizonBucket(startA, nowMs, horizons) - getMatchTimeHorizonBucket(startB, nowMs, horizons);
}
function compareMatchUpcomingPhase(startA, startB, nowMs = Date.now(), horizons = getActiveListHorizons()) {
    const aImm = isImminentKickoff(startA, nowMs);
    const bImm = isImminentKickoff(startB, nowMs);
    if (aImm !== bImm) return aImm ? -1 : 1;
    if (aImm) return 0;
    return compareMatchTimeHorizon(startA, startB, nowMs, horizons);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kM2d5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findMarketBySport", ()=>findMarketBySport);
parcelHelpers.export(exports, "getOddsFromRunner", ()=>getOddsFromRunner);
parcelHelpers.export(exports, "findMatchingRunner", ()=>findMatchingRunner);
parcelHelpers.export(exports, "findDrawRunner", ()=>findDrawRunner);
parcelHelpers.export(exports, "shouldFootballMatchOddsSuspendThird", ()=>shouldFootballMatchOddsSuspendThird);
parcelHelpers.export(exports, "getCricketMatchFormat", ()=>getCricketMatchFormat);
parcelHelpers.export(exports, "CRICKET_TEST_FORMAT_CODE", ()=>(0, _cricketTestMatch.CRICKET_TEST_FORMAT_CODE));
parcelHelpers.export(exports, "isCricketTestFormatRaw", ()=>(0, _cricketTestMatch.isCricketTestFormatRaw));
parcelHelpers.export(exports, "isCricketTestMatchFromText", ()=>(0, _cricketTestMatch.isCricketTestMatchFromText));
parcelHelpers.export(exports, "findCricketThreeWayMatchWinnerMarket", ()=>findCricketThreeWayMatchWinnerMarket);
parcelHelpers.export(exports, "findCricketTieSelection", ()=>findCricketTieSelection);
parcelHelpers.export(exports, "findCricketMatchWinnerThirdSelection", ()=>findCricketMatchWinnerThirdSelection);
parcelHelpers.export(exports, "cricketMatchWinnerThirdRowLabel", ()=>cricketMatchWinnerThirdRowLabel);
parcelHelpers.export(exports, "isCricketTieOrDrawSelectionName", ()=>isCricketTieOrDrawSelectionName);
parcelHelpers.export(exports, "hasCricketThreeWayMatchWinnerMarket", ()=>hasCricketThreeWayMatchWinnerMarket);
parcelHelpers.export(exports, "findCricketTwoWayMatchWinnerMarket", ()=>findCricketTwoWayMatchWinnerMarket);
parcelHelpers.export(exports, "isCricketTestMatch", ()=>isCricketTestMatch);
parcelHelpers.export(exports, "isCricketThreeWayMatchWinnerReceived", ()=>isCricketThreeWayMatchWinnerReceived);
parcelHelpers.export(exports, "findCricketMatchWinnerMarket", ()=>findCricketMatchWinnerMarket);
parcelHelpers.export(exports, "findCricketMatchWinnerMarketForTie", ()=>findCricketMatchWinnerMarketForTie);
var _oddsUtils = require("../../Trader/oddsUtils");
var _cricketTestMatch = require("../../../utils/cricketTestMatch");
const findMarketBySport = (match, sport)=>{
    if (!match.markets || match.markets.length === 0) return null;
    const sportLower = sport.toLowerCase();
    const markets = match.markets;
    if (sportLower === "tennis") return markets.find((market)=>{
        const marketName = (market.name || "").toLowerCase();
        const marketType = (market.market_type || "").toLowerCase();
        return marketName === "moneyline" || marketType === "money_line" || marketType === "moneyline";
    });
    else if (sportLower === "football") return markets.find((market)=>{
        const marketName = (market.name || "").toLowerCase();
        const marketType = (market.market_type || "").toLowerCase();
        return marketName === "match odds" || marketType === "one_x_two";
    });
    else if (sportLower === "horses") return markets.find((market)=>{
        const marketName = (market.name || "").toLowerCase();
        const marketType = (market.market_type || "").toLowerCase();
        return marketName === "win" || marketType === "outright_ded_fact";
    });
    else if (sportLower === "cricket") return markets.find((market)=>{
        const id = String(market.market_type_id ?? "");
        const marketType = (market.market_type || "").toLowerCase();
        return id === "10" || id === "1010" || marketType.includes("match winner");
    });
    return null;
};
/**
 * Parse a value to a number for odds (handles API returning string odds).
 */ const parseOddsNumber = (value)=>{
    if (value == null || value === "") return null;
    const n = typeof value === "number" ? value : parseFloat(String(value));
    return (0, _oddsUtils.hasValidOdds)(n) ? n : null;
};
const getOddsFromRunner = (runner)=>{
    if (runner == null) return null;
    const fromOdds = parseOddsNumber(runner?.odds ?? runner?.price);
    if (fromOdds != null) return fromOdds;
    const prices = runner.prices || [];
    const backPrices = prices.filter((price)=>price.side === "back");
    if (backPrices.length > 0) {
        const parsed = backPrices.map((p)=>parseOddsNumber(p.odds)).filter((n)=>n != null);
        if (parsed.length > 0) return Math.max(...parsed);
    }
    return null;
};
const findMatchingRunner = (runners, participant)=>{
    if (!runners || runners.length === 0 || !participant) return null;
    return runners.find((runner)=>runner["event-participant-id"] === participant.id || runner.name === participant.name || runner.name === participant["participant-name"] || participant["participant-name"] && runner.name?.includes(participant["participant-name"]) || participant.name && runner.name?.includes(participant.name));
};
const findDrawRunner = (runners)=>{
    if (!runners?.length) return null;
    return runners.find((runner)=>{
        const name = (runner.name || runner["participant-name"] || "").trim().toLowerCase();
        return name === "draw" || name === "the draw" || name === "x";
    }) ?? null;
};
const shouldFootballMatchOddsSuspendThird = (runners, isMarketSuspended)=>{
    if (isMarketSuspended || !runners?.length) return false;
    const validCount = runners.filter((runner)=>(0, _oddsUtils.hasValidOdds)(getOddsFromRunner(runner))).length;
    return validCount === 1;
};
const getCricketMatchFormat = (match, streamData)=>{
    return (0, _cricketTestMatch.normalizeCricketFormatCode)(match?.format ?? match?.Format ?? streamData?.match_update?.format ?? streamData?.event?.format);
};
const findCricketThreeWayMatchWinnerMarket = (0, _cricketTestMatch.findCricketThreeWayMatchWinnerMarket);
const findCricketTieSelection = (0, _cricketTestMatch.findCricketTieSelection);
const findCricketMatchWinnerThirdSelection = (0, _cricketTestMatch.findCricketMatchWinnerThirdSelection);
const cricketMatchWinnerThirdRowLabel = (0, _cricketTestMatch.cricketMatchWinnerThirdRowLabel);
const isCricketTieOrDrawSelectionName = (0, _cricketTestMatch.isCricketTieOrDrawSelectionName);
const hasCricketThreeWayMatchWinnerMarket = (0, _cricketTestMatch.hasCricketThreeWayMatchWinnerMarket);
const findCricketTwoWayMatchWinnerMarket = (markets)=>{
    const list = markets || [];
    const preferred = list.find((market)=>String(market.market_type_id) === "1010");
    if (preferred) return preferred;
    return list.find((market)=>String(market.market_type_id) === "10") ?? null;
};
const isCricketTestMatch = (match, streamData)=>(0, _cricketTestMatch.isCricketTestMatch)({
        match,
        streamData,
        competition: match?.competition ?? streamData?.event?.competition,
        matchName: match?.name
    });
/** Decimal `active` / `display` must be explicitly 1 (missing counts as off). */ const isDecimalActiveOne = (value)=>value === 1 || value === "1";
const isCricketThreeWayMatchWinnerReceived = (market)=>{
    if (!market || String(market.market_type_id) !== "15") return false;
    if (!isDecimalActiveOne(market.active)) return false;
    const selections = market.selectionslist ?? market.selections;
    if (!Array.isArray(selections) || selections.length < 3) return false;
    const drawSelection = selections.find((selection)=>(0, _cricketTestMatch.isCricketDrawSelectionName)(selection?.name));
    if (!drawSelection || !isDecimalActiveOne(drawSelection.active)) return false;
    const teamSelections = selections.filter((selection)=>!(0, _cricketTestMatch.isCricketTieOrDrawSelectionName)(selection?.name));
    if (teamSelections.length < 2) return false;
    return teamSelections.some((selection)=>{
        if (!isDecimalActiveOne(selection?.active)) return false;
        return parseOddsNumber(selection?.recommended_price) != null;
    });
};
const findCricketMatchWinnerMarket = (markets, isTest)=>{
    const twoWay = findCricketTwoWayMatchWinnerMarket(markets);
    const threeWay = findCricketThreeWayMatchWinnerMarket(markets);
    if (isTest) {
        if (isCricketThreeWayMatchWinnerReceived(threeWay)) return threeWay;
        return twoWay ?? threeWay ?? null;
    }
    return twoWay ?? null;
};
const findCricketMatchWinnerMarketForTie = (markets)=>findCricketThreeWayMatchWinnerMarket(markets);

},{"../../Trader/oddsUtils":"jXkCw","../../../utils/cricketTestMatch":"eJTw5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jXkCw":[function(require,module,exports,__globalThis) {
/**
 * Single source of truth for odds validity and market suspension (Horses, Tennis, Football, and shared with cricket helpers).
 * Used by: lobby match cards, Trader market-display, and trade slip so they always show the same thing.
 *
 * - Dead / suspended display: finite and <= 1 (exact 1.00 or below). Values > 1 are valid even if they round to "1.00" at 2dp (e.g. 1.001).
 * - Display: use formatOddsForDisplay so 1.001-style prices are not shown as "1.00".
 * - Market suspended: market.suspended === true (e.g. back-overround from API).
 */ /** True when odds should be treated as dead / SUS (not offerable). Only <= 1, not float "almost 1.00" above 1. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isOddsEffectivelyOne", ()=>isOddsEffectivelyOne);
/**
 * Format decimal odds for UI. Usually 2dp; if value is > 1 but rounds to "1.00" at 2dp, show enough decimals (e.g. 1.001).
 */ parcelHelpers.export(exports, "formatOddsForDisplay", ()=>formatOddsForDisplay);
parcelHelpers.export(exports, "hasValidOdds", ()=>hasValidOdds);
parcelHelpers.export(exports, "isMarketSuspended", ()=>isMarketSuspended);
parcelHelpers.export(exports, "suspendedOddsCellClassName", ()=>suspendedOddsCellClassName);
function isOddsEffectivelyOne(n) {
    return Number.isFinite(n) && n <= 1;
}
function formatOddsForDisplay(odds) {
    const n = odds != null ? Number(odds) : NaN;
    if (!Number.isFinite(n)) return "";
    if (n > 1 && n.toFixed(2) === "1.00") return String(parseFloat(n.toFixed(12)));
    return n.toFixed(2);
}
function hasValidOdds(odds) {
    const n = odds != null ? Number(odds) : NaN;
    return Number.isFinite(n) && n > 0 && !isOddsEffectivelyOne(n);
}
function isMarketSuspended(market) {
    return market?.suspended === true;
}
const suspendedOddsCellClassName = "bg-marketGrey text-marketGreyText cursor-not-allowed";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJTw5":[function(require,module,exports,__globalThis) {
/** Decimal `match.format` code for Test cricket (multi-day). */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CRICKET_TEST_FORMAT_CODE", ()=>CRICKET_TEST_FORMAT_CODE);
parcelHelpers.export(exports, "CRICKET_HUNDRED_FORMAT_CODE", ()=>CRICKET_HUNDRED_FORMAT_CODE);
parcelHelpers.export(exports, "CRICKET_HUNDRED_SCHEDULED_OVERS", ()=>CRICKET_HUNDRED_SCHEDULED_OVERS);
/**
 * True when a raw Decimal `format` value denotes Test cricket (999 or descriptive text).
 * @param {unknown} raw
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketTestFormatRaw", ()=>isCricketTestFormatRaw);
/**
 * Infer Test from competition / fixture title (e.g. "Youth Tests", "1st Test", WTC).
 * @param {unknown} competition
 * @param {unknown} [matchName]
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketTestMatchFromText", ()=>isCricketTestMatchFromText);
/**
 * Parse a format field to a numeric code: 999 for Test, 100 for The Hundred, 1–50 for limited overs, null if unknown.
 * @param {unknown} raw
 * @returns {number|null}
 */ parcelHelpers.export(exports, "normalizeCricketFormatCode", ()=>normalizeCricketFormatCode);
/**
 * Scheduled overs / five-ball sets for ov display and settlement (format 100 → 20).
 * @param {unknown} formatCode
 * @returns {number|null}
 */ parcelHelpers.export(exports, "cricketFormatScheduledOvers", ()=>cricketFormatScheduledOvers);
/** Delta legacy: Test fixtures use max_overs === -1. */ parcelHelpers.export(exports, "isCricketTestMaxOvers", ()=>isCricketTestMaxOvers);
/** True when any innings max-overs value signals Test (999 or -1). */ parcelHelpers.export(exports, "isCricketTestMOvers", ()=>isCricketTestMOvers);
parcelHelpers.export(exports, "findCricketThreeWayMatchWinnerMarket", ()=>findCricketThreeWayMatchWinnerMarket);
/** Decimal 3-way Match Winner draw runner on Test matches. */ parcelHelpers.export(exports, "isCricketDrawSelectionName", ()=>isCricketDrawSelectionName);
/** Decimal 3-way Match Winner tie runner on limited-overs matches. */ parcelHelpers.export(exports, "isCricketTieSelectionName", ()=>isCricketTieSelectionName);
/** Decimal 3-way Match Winner third runner: "Tie" or "Draw" (same UI role). */ parcelHelpers.export(exports, "isCricketTieOrDrawSelectionName", ()=>isCricketTieOrDrawSelectionName);
parcelHelpers.export(exports, "findCricketDrawSelection", ()=>findCricketDrawSelection);
parcelHelpers.export(exports, "findCricketTieSelection", ()=>findCricketTieSelection);
/**
 * Third Match Winner runner when offered: Draw on Test, Tie on limited overs.
 * @param {object|null|undefined} market
 * @param {boolean} isTest
 */ parcelHelpers.export(exports, "findCricketMatchWinnerThirdSelection", ()=>findCricketMatchWinnerThirdSelection);
/** UI label for the third Match Winner row on lobby / match cards. */ parcelHelpers.export(exports, "cricketMatchWinnerThirdRowLabel", ()=>cricketMatchWinnerThirdRowLabel);
parcelHelpers.export(exports, "hasCricketThreeWayMatchWinnerMarket", ()=>hasCricketThreeWayMatchWinnerMarket);
/**
 * Infer The Hundred from competition / fixture title when Decimal `format` is missing.
 * @param {unknown} competition
 * @param {unknown} [matchName]
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketHundredMatchFromText", ()=>isCricketHundredMatchFromText);
/**
 * True when a cricket fixture is The Hundred (format 100 or competition/title text).
 * @param {object} [ctx]
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketHundredMatch", ()=>isCricketHundredMatch);
/**
 * Resolve whether a cricket fixture is Test cricket.
 *
 * Signals (first match wins):
 * - format `999` / `"999"` / `"Test Match"` / similar text
 * - competition or match title text (`Youth Tests`, `1st Test`, `Test Series`, `First Class`, WTC)
 * - `max_overs === -1` or mOvers containing 999 / -1
 * - live feed has Match Winner 3-way (market_type_id 15) with a Draw selection (not Tie)
 *
 * @param {object} [ctx]
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketTestMatch", ()=>isCricketTestMatch);
/**
 * Best-effort numeric format for UI (999 = Test, 20/50 = limited overs).
 * @param {object} [ctx]
 * @returns {number|null}
 */ parcelHelpers.export(exports, "resolveCricketFormatCode", ()=>resolveCricketFormatCode);
const CRICKET_TEST_FORMAT_CODE = 999;
const CRICKET_HUNDRED_FORMAT_CODE = 100;
const CRICKET_HUNDRED_SCHEDULED_OVERS = 20;
/** Keep aligned with backend `utils/cricketTestMatch.js` (Youth Tests when format is missing). */ const TEST_FORMAT_TEXT_RE = /\b(?:\d+(?:st|nd|rd|th)\s+tests?|youth\s+tests?|tests?\s+match(?:es)?|tests?\s+series|first[-\s]?class|county\s+championship|world\s+tests?\s+championship)\b|\btests?\b/i;
function isCricketTestFormatRaw(raw) {
    if (raw == null || raw === "") return false;
    const formatStr = String(raw).trim();
    const formatInt = parseInt(formatStr, 10);
    if (formatInt === CRICKET_TEST_FORMAT_CODE) return true;
    const lower = formatStr.toLowerCase();
    if (lower.includes("test") || lower.includes("first class") || lower.includes("first-class")) return true;
    return TEST_FORMAT_TEXT_RE.test(lower);
}
function isCricketTestMatchFromText(competition, matchName) {
    const blob = `${String(competition ?? "")} ${String(matchName ?? "")}`.trim();
    if (!blob) return false;
    return TEST_FORMAT_TEXT_RE.test(blob);
}
function normalizeCricketFormatCode(raw) {
    if (raw == null || raw === "") return null;
    if (typeof raw === "number" && Number.isFinite(raw)) {
        if (raw === CRICKET_TEST_FORMAT_CODE) return CRICKET_TEST_FORMAT_CODE;
        if (raw === CRICKET_HUNDRED_FORMAT_CODE) return CRICKET_HUNDRED_FORMAT_CODE;
        if (raw > 0 && raw <= 50) return raw;
        return null;
    }
    const s = String(raw).trim();
    const n = parseInt(s, 10);
    if (!Number.isNaN(n)) {
        if (n === CRICKET_TEST_FORMAT_CODE) return CRICKET_TEST_FORMAT_CODE;
        if (n === CRICKET_HUNDRED_FORMAT_CODE) return CRICKET_HUNDRED_FORMAT_CODE;
        if (n > 0 && n <= 50) return n;
    }
    if (isCricketTestFormatRaw(raw)) return CRICKET_TEST_FORMAT_CODE;
    const lower = s.toLowerCase();
    if (lower === "t20" || lower === "twenty20" || lower === "20") return 20;
    if (lower === "t10" || lower === "10") return 10;
    if (lower === "odi" || lower === "50" || lower === "one-day" || lower === "list a") return 50;
    if (/\bthe\s*hundred\b/.test(lower)) return CRICKET_HUNDRED_FORMAT_CODE;
    return null;
}
function cricketFormatScheduledOvers(formatCode) {
    const n = Number(formatCode);
    if (!Number.isFinite(n)) return null;
    if (n === CRICKET_HUNDRED_FORMAT_CODE) return CRICKET_HUNDRED_SCHEDULED_OVERS;
    if (n > 0 && n <= 50) return n;
    return null;
}
function isCricketTestMaxOvers(maxOvers) {
    if (maxOvers == null || maxOvers === "") return false;
    const n = Number(maxOvers);
    return n === -1;
}
function isCricketTestMOvers(mOvers) {
    if (!Array.isArray(mOvers) || mOvers.length === 0) return false;
    return mOvers.some((value)=>{
        if (value == null || value === "") return false;
        const n = Number(value);
        return n === CRICKET_TEST_FORMAT_CODE || n === -1 || String(value).trim() === "999";
    });
}
function findCricketThreeWayMatchWinnerMarket(markets) {
    return (markets || []).find((market)=>String(market?.market_type_id) === "15") ?? null;
}
function isCricketDrawSelectionName(name) {
    return String(name ?? "").trim().toUpperCase() === "DRAW";
}
function isCricketTieSelectionName(name) {
    return String(name ?? "").trim().toUpperCase() === "TIE";
}
function isCricketTieOrDrawSelectionName(name) {
    return isCricketTieSelectionName(name) || isCricketDrawSelectionName(name);
}
function findCricketDrawSelection(market) {
    const selections = market?.selectionslist ?? market?.selections;
    if (!Array.isArray(selections)) return null;
    return selections.find((selection)=>isCricketDrawSelectionName(selection?.name)) ?? null;
}
function findCricketTieSelection(market) {
    const selections = market?.selectionslist ?? market?.selections;
    if (!Array.isArray(selections)) return null;
    return selections.find((selection)=>isCricketTieSelectionName(selection?.name)) ?? null;
}
function findCricketMatchWinnerThirdSelection(market, isTest) {
    return isTest ? findCricketDrawSelection(market) : findCricketTieSelection(market);
}
function cricketMatchWinnerThirdRowLabel(isTest) {
    return isTest ? "DRAW" : "TIE";
}
function hasCricketThreeWayMatchWinnerMarket(markets) {
    const market = findCricketThreeWayMatchWinnerMarket(markets);
    if (market == null) return false;
    const selections = market?.selectionslist ?? market?.selections;
    if (!Array.isArray(selections)) return false;
    return selections.some((selection)=>isCricketDrawSelectionName(selection?.name));
}
function competitionNameFromLineup(lineup) {
    if (!lineup || typeof lineup !== "object") return null;
    const comp = lineup.competition;
    if (typeof comp === "string") return comp;
    if (comp && typeof comp === "object") return comp.name ?? comp.title ?? comp.competition ?? null;
    return null;
}
function isCricketHundredMatchFromText(competition, matchName) {
    const blob = `${String(competition ?? "")} ${String(matchName ?? "")}`.toLowerCase();
    if (!blob) return false;
    return /\bthe\s*hundred\b/.test(blob);
}
function isCricketHundredMatch(ctx = {}) {
    const formatCandidates = [
        ctx.format,
        ctx.eventFormat,
        ctx.matchFormat,
        ctx.match?.format,
        ctx.match?.Format,
        ctx.streamData?.match_update?.format,
        ctx.streamData?.event?.format
    ];
    for (const raw of formatCandidates){
        if (raw == null || raw === "") continue;
        if (normalizeCricketFormatCode(raw) === CRICKET_HUNDRED_FORMAT_CODE) return true;
        if (/\bthe\s*hundred\b/.test(String(raw).toLowerCase())) return true;
    }
    const competition = ctx.competition ?? ctx.match?.competition ?? ctx.streamData?.event?.competition ?? competitionNameFromLineup(ctx.lineup);
    const matchName = ctx.matchName ?? ctx.match?.name;
    return isCricketHundredMatchFromText(competition, matchName);
}
function isCricketTestMatch(ctx = {}) {
    const formatCandidates = [
        ctx.format,
        ctx.eventFormat,
        ctx.matchFormat,
        ctx.match?.format,
        ctx.match?.Format,
        ctx.streamData?.match_update?.format,
        ctx.streamData?.event?.format
    ];
    for (const raw of formatCandidates){
        if (raw == null || raw === "") continue;
        if (normalizeCricketFormatCode(raw) === CRICKET_TEST_FORMAT_CODE) return true;
        if (isCricketTestFormatRaw(raw)) return true;
    }
    if (isCricketTestMaxOvers(ctx.maxOvers ?? ctx.event?.max_overs ?? ctx.streamData?.event?.max_overs)) return true;
    if (isCricketTestMOvers(ctx.mOvers)) return true;
    const competition = ctx.competition ?? ctx.match?.competition ?? ctx.streamData?.event?.competition ?? competitionNameFromLineup(ctx.lineup);
    const matchName = ctx.matchName ?? ctx.match?.name;
    if (isCricketTestMatchFromText(competition, matchName)) return true;
    return hasCricketThreeWayMatchWinnerMarket(ctx.markets ?? ctx.streamData?.market_update?.markets);
}
function resolveCricketFormatCode(ctx = {}) {
    if (isCricketTestMatch(ctx)) return CRICKET_TEST_FORMAT_CODE;
    const formatCandidates = [
        ctx.format,
        ctx.eventFormat,
        ctx.matchFormat,
        ctx.match?.format,
        ctx.streamData?.match_update?.format,
        ctx.streamData?.event?.format
    ];
    for (const raw of formatCandidates){
        const code = normalizeCricketFormatCode(raw);
        if (code != null) return code;
    }
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7FEAE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCricketMatchFinished", ()=>isCricketMatchFinished);
/** True when the fixture has already started or the feed says it is live. */ parcelHelpers.export(exports, "isCricketMatchInPlay", ()=>isCricketMatchInPlay);
/**
 * True when the live cricket stream says the match is over — result, event closed,
 * or abandoned / no result after rain. A rain delay that is still a break is not over.
 */ parcelHelpers.export(exports, "cricketStreamIndicatesMatchFinished", ()=>cricketStreamIndicatesMatchFinished);
/** "INNINGS BREAK" / "MATCH BREAK" while the fixture feed reports a stoppage, else null. */ parcelHelpers.export(exports, "leagueFixtureBreakLabel", ()=>leagueFixtureBreakLabel);
/**
 * Break label from the live cricket stream (scoreboard / event_status).
 * Catches the long innings-break window when Decimal has dropped back to MATCH_STABLE
 * and the events list still reads "Match in Progress".
 */ parcelHelpers.export(exports, "leagueBreakLabelFromStream", ()=>leagueBreakLabelFromStream);
/** Limited-overs format code for seat sizing (10 / 20 / 50 / 100). */ parcelHelpers.export(exports, "formatOversForMatch", ()=>formatOversForMatch);
parcelHelpers.export(exports, "fetchLeagueCricketMatches", ()=>fetchLeagueCricketMatches);
parcelHelpers.export(exports, "cricketMatchToLeagueFixture", ()=>cricketMatchToLeagueFixture);
parcelHelpers.export(exports, "leagueFixturesFromCricketMatches", ()=>leagueFixturesFromCricketMatches);
parcelHelpers.export(exports, "isPrototypeFixtureId", ()=>isPrototypeFixtureId);
/**
 * Archived match centre payload for a finished fixture — same `/completed/:id` source as
 * Match details. Fills thin scorecards from the event scoreboard and derives the who-won line.
 */ parcelHelpers.export(exports, "fetchCompletedCricketArchive", ()=>fetchCompletedCricketArchive);
/** @deprecated Prefer `fetchCompletedCricketArchive` — kept for callers that only need inns scores. */ parcelHelpers.export(exports, "fetchCompletedCricketScorecard", ()=>fetchCompletedCricketScorecard);
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
var _competitionUtils = require("../../Games/competitionUtils");
var _matchUtils = require("../../Games/matchUtils");
var _cricketMatchCardOverDisplay = require("../../Cricket/cricketMatchCardOverDisplay");
var _cricketTestMatch = require("../../../utils/cricketTestMatch");
var _authHeaders = require("../../../utils/authHeaders");
var _leagueCompletedArchive = require("./leagueCompletedArchive");
const CACHE_MS = 30000;
let cache = null;
let inflight = null;
function isCricketMatchFinished(match) {
    const status = String(match.status ?? match.event_status ?? "").toUpperCase();
    return status.includes("COMPLETE") || status.includes("FINISHED") || status.includes("CLOSED") || status.includes("ABANDON") || status === "10" || status === "11" || status === "13";
}
function isCricketMatchInPlay(match) {
    if (isCricketMatchFinished(match)) return false;
    const startMs = match.start ? new Date(match.start).getTime() : NaN;
    if (Number.isFinite(startMs) && startMs > Date.now()) return false;
    const list = (0, _matchUtils.getMatchStatus)({
        ...match,
        sport: match.sport || "cricket"
    });
    if ((0, _matchUtils.isCricketBreakInPlayMatchStatus)(list)) return false;
    if (list.text === "IN-PLAY" || list.text.toUpperCase().includes("SUPER OVER") || list.text.toUpperCase().includes("BALL IN PROGRESS")) return true;
    return (0, _matchUtils.isStreamingFixtureLive)(String(match.status ?? ""));
}
/** Map a feed "Break in Play …" line onto the short labels used on league cards / pills. */ function leagueBreakLabelFromStatusText(text, streamData) {
    if (/innings/i.test(text) || streamData != null && (0, _matchUtils.cricketStreamIndicatesInningsBreak)(streamData)) return "INNINGS BREAK";
    if (/rain|bad weather|weather delay|toss delayed|wet outfield|covers/i.test(text)) return "MATCH BREAK - RAIN DELAY";
    if (/drinks/i.test(text)) return "DRINKS";
    if (/injur/i.test(text)) return "INJURY";
    if (/time\s*out|strategic/i.test(text)) return "TIME OUT";
    return "MATCH BREAK";
}
function streamScoreboardValue(streamData, name) {
    if (!streamData || typeof streamData !== "object") return "";
    const data = streamData;
    const board = data.event?.scoreboard ?? data.event?.event?.scoreboard;
    if (!Array.isArray(board)) return "";
    const entry = board.find((row)=>row?.name === name);
    const value = entry?.value;
    return value == null ? "" : String(value).trim();
}
function cricketStreamIndicatesMatchFinished(streamData) {
    if (!streamData || typeof streamData !== "object") return false;
    const data = streamData;
    const candidates = [
        data.market_update?.event_status,
        data.event?.event_status,
        data.scorecard?.event_status,
        streamScoreboardValue(streamData, "game_phase"),
        streamScoreboardValue(streamData, "status")
    ];
    if (candidates.some((raw)=>raw != null && raw !== "" && (0, _decimalEventStatus.isMatchFinishedStatus)(raw))) return true;
    const winner = streamScoreboardValue(streamData, "winner").toUpperCase();
    return winner !== "" && winner !== "NA";
}
function leagueFixtureBreakLabel(match) {
    if (isCricketMatchFinished(match)) return null;
    const statusId = Number(match.status_id);
    const statusText = String(match.status ?? "");
    const onBreak = statusId === 7 || (0, _matchUtils.isCricketBreakInPlayMatchStatus)((0, _matchUtils.getMatchStatus)(match));
    if (!onBreak) return null;
    return leagueBreakLabelFromStatusText(statusText);
}
function leagueBreakLabelFromStream(streamData) {
    if (!streamData) return null;
    const status = (0, _matchUtils.getCricketStatusFromStream)(streamData);
    if (!status || !(0, _matchUtils.isCricketBreakInPlayMatchStatus)(status)) return null;
    return leagueBreakLabelFromStatusText(status.text, streamData);
}
function durationHoursForMatch(match) {
    const blob = `${match.format || ""} ${match.name || ""} ${match.competition || ""}`.toLowerCase();
    if (blob.includes("test")) return 8;
    if (blob.includes("odi") || blob.includes("50 over") || blob.includes("50-over")) return 8;
    return 4;
}
function formatOversForMatch(match) {
    const fromFields = (0, _cricketTestMatch.normalizeCricketFormatCode)(match.format);
    if (fromFields != null && fromFields !== 999) return fromFields;
    return (0, _cricketMatchCardOverDisplay.cricketFormatOversFromText)(match.competition, match.name);
}
async function fetchLeagueCricketMatches() {
    if (cache && Date.now() - cache.at < CACHE_MS) return cache.matches;
    if (inflight) return inflight;
    inflight = (async ()=>{
        const api = "https://cricket8.com/api";
        if (!api) throw new Error("API_URL is not set");
        const response = await fetch(`${api}/trade/cricket/events?maxmatches=80`, {
            method: "GET",
            headers: (0, _authHeaders.getAuthHeaders)()
        });
        if (!response.ok) throw new Error(`cricket events ${response.status}`);
        const payload = await response.json();
        const matches = (Array.isArray(payload?.matches) ? payload.matches : []).map((row)=>({
                ...row,
                sport: row.sport || "cricket"
            }));
        cache = {
            at: Date.now(),
            matches
        };
        return matches;
    })().finally(()=>{
        inflight = null;
    });
    return inflight;
}
function cricketMatchToLeagueFixture(match) {
    if (!match?.id || isCricketMatchFinished(match) || isCricketMatchInPlay(match)) return null;
    const { teams } = (0, _matchUtils.parseCricketMatchName)(match.name || "");
    const participants = match["event-participants"] || [];
    const home = teams[0] || participants[0]?.name || participants[0]?.["participant-name"] || "";
    const away = teams[1] || participants[1]?.name || participants[1]?.["participant-name"] || "";
    if (!home || !away) return null;
    const startMs = match.start ? new Date(match.start).getTime() : NaN;
    return {
        id: String(match.id),
        name: `${home} v ${away}`,
        homeTeam: home,
        awayTeam: away,
        competition: (0, _competitionUtils.extractCompetition)(match, "CRICKET") || match.competition || "Cricket",
        start: Number.isFinite(startMs) ? new Date(startMs).toISOString() : new Date().toISOString(),
        durationHours: durationHoursForMatch(match),
        formatOvers: formatOversForMatch(match)
    };
}
function leagueFixturesFromCricketMatches(matches) {
    const seen = new Set();
    const fixtures = [];
    for (const match of matches){
        const fixture = cricketMatchToLeagueFixture(match);
        if (!fixture || seen.has(fixture.id)) continue;
        seen.add(fixture.id);
        fixtures.push(fixture);
    }
    fixtures.sort((a, b)=>new Date(a.start).getTime() - new Date(b.start).getTime());
    return fixtures;
}
function isPrototypeFixtureId(fixtureId) {
    return Boolean(fixtureId?.startsWith("proto-"));
}
async function fetchCompletedCricketArchive(matchId) {
    const id = matchId.trim();
    if (!id || isPrototypeFixtureId(id)) return null;
    const api = "https://cricket8.com/api";
    if (!api) return null;
    try {
        const response = await fetch(`${api}/completed/${id}`, {
            method: "GET",
            headers: (0, _authHeaders.getAuthHeaders)()
        });
        if (!response.ok) return null;
        const payload = await response.json();
        return (0, _leagueCompletedArchive.parseCompletedCricketArchive)(payload);
    } catch  {
        return null;
    }
}
async function fetchCompletedCricketScorecard(matchId) {
    const archive = await fetchCompletedCricketArchive(matchId);
    return archive?.scorecard ?? null;
}

},{"../../Trader/Cricket/decimalEventStatus":"f1nlI","../../Games/competitionUtils":"aO5Bw","../../Games/matchUtils":"9QY2j","../../Cricket/cricketMatchCardOverDisplay":"jVYsA","../../../utils/cricketTestMatch":"eJTw5","../../../utils/authHeaders":"5Rczo","./leagueCompletedArchive":"ipKfP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aO5Bw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOCATION_PATTERNS", ()=>LOCATION_PATTERNS);
parcelHelpers.export(exports, "extractCompetition", ()=>extractCompetition);
parcelHelpers.export(exports, "isIplCompetitionName", ()=>isIplCompetitionName);
parcelHelpers.export(exports, "isIplCricketMatch", ()=>isIplCricketMatch);
parcelHelpers.export(exports, "getCricketCompetitionTabOrder", ()=>getCricketCompetitionTabOrder);
parcelHelpers.export(exports, "isFifaMenWorldCupCompetition", ()=>isFifaMenWorldCupCompetition);
parcelHelpers.export(exports, "isFootballCompetitionIgnored", ()=>isFootballCompetitionIgnored);
parcelHelpers.export(exports, "isTennisCompetitionIgnored", ()=>isTennisCompetitionIgnored);
parcelHelpers.export(exports, "getCompetitionShortName", ()=>getCompetitionShortName);
parcelHelpers.export(exports, "getCompetitionTabDisplay", ()=>getCompetitionTabDisplay);
parcelHelpers.export(exports, "getCompetitionFlag", ()=>getCompetitionFlag);
var _matchUtils = require("./matchUtils");
var _utilsJs = require("../Trader/Horses/utils.js");
const LOCATION_PATTERNS = [
    /\s+from\s+[^-]+$/i,
    /\s+at\s+[^-]+$/i,
    /\s*-\s+[^-]+$/i,
    /\s*@\s+[^-]+$/i,
    /\s+in\s+[^-]+$/i
];
// Competition strings that are not real competition names (e.g. from malformed "Team v Team, Only" names)
const MEANINGLESS_CRICKET_COMPETITION = new Set([
    "only",
    "match"
]);
const extractCompetition = (match, sport)=>{
    if (!match) return "";
    let competition = "";
    if (sport === "CRICKET") {
        const parsed = (0, _matchUtils.parseCricketMatchName)(match.name || "");
        competition = parsed.competition;
        // Strip everything after "MATCH" (case-insensitive) for cricket
        if (competition) {
            const matchIndex = competition.toLowerCase().indexOf(" match");
            if (matchIndex !== -1) competition = competition.substring(0, matchIndex).trim();
        }
        // If parsed value is empty or meaningless (e.g. "Only" from "Team v Team, Only"), use API competition or leave empty
        const trimmed = (competition || "").trim().toLowerCase();
        if (!trimmed || MEANINGLESS_CRICKET_COMPETITION.has(trimmed)) competition = match.competition && match.competition.trim() || "";
    } else if (sport === "HORSES") {
        // For horses, use country from meta tags instead of event names
        const country = (0, _utilsJs.getCountryFromFixture)(match);
        competition = country || "";
        // Fallback to event name if country is not available
        if (!competition) {
            const parsed = (0, _matchUtils.parseFootballTennisMatchData)(match);
            competition = parsed.competition || "";
            if (!competition && match.name) competition = (0, _matchUtils.extractHorseVenueName)(match.name);
            else if (competition) competition = (0, _matchUtils.extractHorseVenueName)(competition);
        }
    } else {
        const parsed = (0, _matchUtils.parseFootballTennisMatchData)(match);
        competition = parsed.competition;
    }
    // Strip location/venue information from competition name
    if (competition) {
        let cleaned = competition;
        LOCATION_PATTERNS.forEach((pattern)=>{
            cleaned = cleaned.replace(pattern, '').trim();
        });
        competition = cleaned;
    }
    return competition.trim();
};
const isIplCompetitionName = (competition)=>{
    if (!competition || typeof competition !== "string") return false;
    const c = competition.toLowerCase();
    return c.includes("indian premier league") || c.includes("ipl");
};
const isIplCricketMatch = (match)=>{
    if ((match.sport || "").toLowerCase() !== "cricket") return false;
    if (isIplCompetitionName(extractCompetition(match, "CRICKET"))) return true;
    if (isIplCompetitionName(match.competition)) return true;
    const name = (match.name || "").toLowerCase();
    return name.includes("indian premier league") || name.includes("ipl");
};
const getCricketCompetitionTabOrder = (competition)=>{
    if (!competition || typeof competition !== "string") return 2;
    const c = competition.toLowerCase();
    if (isIplCompetitionName(competition)) return 0;
    if (c.includes("world cup")) return 1;
    return 2;
};
const isFifaMenWorldCupCompetition = (competition)=>{
    if (!competition || typeof competition !== "string") return false;
    const n = competition.trim().toLowerCase().replace(/\bengland\b/g, "english");
    if (n.includes("club world cup") || n.includes("kings world cup") || n.includes("women") || n.includes("u19") || n.includes("u-19") || n.includes("under 19") || n.includes("under-19") || n.includes("qualif")) return false;
    if (n.includes("world cup") || n.includes("world championship")) return true;
    return false;
};
const isFootballCompetitionIgnored = (competition)=>{
    if (!competition || typeof competition !== "string") return false;
    return /premier league\s*2\b/i.test(competition.trim());
};
/** Tennis: low-level circuits; match as whole words (word-boundary) so M500/W500 are not hidden. */ const TENNIS_LOW_LEVEL_KEYWORDS = [
    "challenger",
    "itf",
    "futures",
    "m15",
    "m25",
    "m50",
    "w15",
    "w25",
    "w50",
    "125k",
    "100k",
    "80k",
    "60k"
];
const isTennisCompetitionIgnored = (competition)=>{
    if (!competition || typeof competition !== "string") return false;
    const lower = competition.trim().toLowerCase();
    return TENNIS_LOW_LEVEL_KEYWORDS.some((kw)=>new RegExp(`\\b${kw}\\b`).test(lower));
};
const getCompetitionShortName = (competition, sport)=>{
    if (!competition) return "";
    const compLower = competition.toLowerCase();
    // Cricket competitions
    if (sport === "CRICKET") {
        if (compLower.includes("indian premier league") || compLower.includes("ipl")) return "IPL";
        if (compLower.includes("ashes")) return "THE ASHES";
        if (compLower.includes("big bash") || compLower.includes("bbl")) return "BBL";
        if (compLower.includes("the hundred")) return "THE HUNDRED";
        if (compLower.includes("sa20")) return "SA20";
        if (compLower.includes("caribbean premier league") || compLower.includes("cpl")) return "CPL";
        if (compLower.includes("pakistan super league") || compLower.includes("psl")) return "PSL";
        if (compLower.includes("bangladesh premier league") || compLower.includes("bpl")) return "BPL";
        if (compLower.includes("lanka premier league") || compLower.includes("lpl")) return "LPL";
        if (compLower.includes("vitality blast")) return "VITALITY BLAST";
        if (compLower.includes("women's premier league") || compLower.includes("wpl")) return "WPL";
        if (compLower.includes("women's big bash") || compLower.includes("wbbl")) return "WBBL";
        if (compLower.includes("world cup")) return "WORLD CUP";
        if (compLower.includes("t20 world cup")) return "T20 WORLD CUP";
        if (compLower.includes("champions trophy")) return "CHAMPIONS TROPHY";
    }
    // Football competitions
    if (sport === "FOOTBALL") {
        // Normalize "england" to "english" for consistent matching
        const normalizedComp = compLower.replace(/\bengland\b/g, "english");
        if (normalizedComp.includes("premier league") && (normalizedComp.includes("english") || compLower.includes("england")) || compLower.includes("premier league") && (compLower.includes("english") || compLower.includes("england"))) return "PREMIER LEAGUE";
        if (compLower.includes("la liga") || compLower.includes("laliga")) return "LA LIGA";
        if (compLower.includes("bundesliga")) return "BUNDESLIGA";
        if (compLower.includes("ligue 1") || compLower.includes("ligue1")) return "LIGUE 1";
        if (compLower.includes("serie a") || compLower.includes("seriea")) return "SERIE A";
        if (compLower.includes("champions league")) return "UCL";
        if (compLower.includes("europa league")) return "UEL";
        if (compLower.includes("world cup")) return "WORLD CUP";
        if (compLower.includes("euro") || compLower.includes("european championship")) return "EUROS";
        if (compLower.includes("fa cup")) return "FA CUP";
        if (compLower.includes("copa del rey")) return "COPA DEL REY";
        if (compLower.includes("dfb pokal") || compLower.includes("dfb-pokal")) return "DFB POKAL";
        if (compLower.includes("coupe de france")) return "COUPE DE FRANCE";
        if (compLower.includes("coppa italia")) return "COPPA ITALIA";
        if (compLower.includes("championship") && (compLower.includes("english") || compLower.includes("england"))) return "CHAMPIONSHIP";
    }
    // Tennis competitions
    if (sport === "TENNIS") {
        if (compLower.includes("wimbledon")) return "WIMBLEDON";
        if (compLower.includes("us open")) return "US OPEN";
        if (compLower.includes("french open") || compLower.includes("roland garros")) return "FRENCH OPEN";
        if (compLower.includes("australian open")) return "AUSTRALIAN OPEN";
        if (compLower.includes("atp finals")) return "ATP FINALS";
        if (compLower.includes("wta finals")) return "WTA FINALS";
        if (compLower.includes("davis cup")) return "DAVIS CUP";
        if (compLower.includes("indian wells")) return "INDIAN WELLS";
        if (compLower.includes("miami open")) return "MIAMI OPEN";
        if (compLower.includes("monte carlo") || compLower.includes("monte-carlo")) return "MONTE CARLO";
        if (compLower.includes("madrid open")) return "MADRID OPEN";
        if (compLower.includes("italian open") || compLower.includes("rome")) return "ITALIAN OPEN";
        if (compLower.includes("canadian open") || compLower.includes("rogers cup")) return "CANADIAN OPEN";
        if (compLower.includes("cincinnati")) return "CINCINNATI";
        if (compLower.includes("shanghai masters")) return "SHANGHAI";
        if (compLower.includes("paris masters")) return "PARIS MASTERS";
    }
    // Return uppercase version of original if no alias found
    return competition.toUpperCase();
};
const DEFAULT_COMPETITION_EMOJI = "\uD83C\uDFC6";
const WORLD_EMOJI = "\uD83C\uDF0D";
const getCompetitionTabDisplay = (competition, sport)=>{
    const flag = getCompetitionFlag(competition, sport);
    return {
        flag,
        text: competition
    };
};
const getCompetitionFlag = (competition, sport)=>{
    if (!competition) return DEFAULT_COMPETITION_EMOJI;
    const compLower = competition.toLowerCase();
    if (compLower.includes("world")) return "\uD83C\uDF0D";
    if (sport === "HORSES") return (0, _utilsJs.countryNameToFlag)(competition) || DEFAULT_COMPETITION_EMOJI;
    if (sport === "CRICKET") {
        // Leagues & tournaments (specific first)
        if (compLower.includes("ipl") || compLower.includes("indian premier league")) return "\uD83C\uDDEE\uD83C\uDDF3";
        if (compLower.includes("women's premier league") || compLower.includes("wpl")) return "\uD83C\uDDEE\uD83C\uDDF3";
        if (compLower.includes("big bash") || compLower.includes("bbl")) return "\uD83C\uDDE6\uD83C\uDDFA";
        if (compLower.includes("women's big bash") || compLower.includes("wbbl")) return "\uD83C\uDDE6\uD83C\uDDFA";
        if (compLower.includes("the hundred")) return "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F";
        if (compLower.includes("sa20")) return "\uD83C\uDDFF\uD83C\uDDE6";
        if (compLower.includes("caribbean premier league") || compLower.includes("cpl")) return "\uD83C\uDDE7\uD83C\uDDE7";
        if (compLower.includes("pakistan super league") || compLower.includes("psl")) return "\uD83C\uDDF5\uD83C\uDDF0";
        if (compLower.includes("bangladesh premier league") || compLower.includes("bpl")) return "\uD83C\uDDE7\uD83C\uDDE9";
        if (compLower.includes("international league t20") || compLower.includes("ilt20") || compLower.includes("uae")) return "\uD83C\uDDE6\uD83C\uDDEA";
        if (compLower.includes("major league cricket") || compLower.includes("mlc")) return "\uD83C\uDDFA\uD83C\uDDF8";
        if (compLower.includes("lanka premier league") || compLower.includes("lpl")) return "\uD83C\uDDF1\uD83C\uDDF0";
        if (compLower.includes("super smash")) return "\uD83C\uDDF3\uD83C\uDDFF";
        if (compLower.includes("vitality blast")) return "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F";
        if (compLower.includes("syed mushtaq ali") || compLower.includes("vijay hazare") || compLower.includes("ranji trophy") || compLower.includes("duleep trophy") || compLower.includes("irani cup")) return "\uD83C\uDDEE\uD83C\uDDF3";
        if (compLower.includes("tamil nadu premier league") || compLower.includes("tnpl")) return "\uD83C\uDDEE\uD83C\uDDF3";
        if (compLower.includes("abu dhabi t10") || compLower.includes("emirates d10") || compLower.includes("t10")) return "\uD83C\uDDE6\uD83C\uDDEA";
        if (compLower.includes("falcons champions trophy")) return "\uD83C\uDDE6\uD83C\uDDEA";
        if (compLower.includes("ford trophy")) return "\uD83C\uDDF3\uD83C\uDDFF";
        if (compLower.includes("jagran cricket league")) return "\uD83C\uDDEE\uD83C\uDDF3";
        if (compLower.includes("sheffield")) return "\uD83C\uDDE6\uD83C\uDDFA";
        if (compLower.includes("chandra trophy") || compLower.includes("kanpur")) return "\uD83C\uDDEE\uD83C\uDDF3";
        if (compLower.includes("waterfalls elite league")) return "\uD83C\uDDFF\uD83C\uDDFC";
        if (compLower.includes("wncl") || compLower.includes("women's national cricket league")) return "\uD83C\uDDE6\uD83C\uDDFA";
        if (compLower.includes("kbn premier league")) return "\uD83C\uDDEE\uD83C\uDDF3";
        if (compLower.includes("legends cricket league")) return "\uD83C\uDDEE\uD83C\uDDF3";
        if (compLower.includes("ashes")) return "\uD83C\uDDE6\uD83C\uDDFA";
        // Country-based (tours, series, bilateral)
        if (compLower.includes("india") || compLower.includes("indian")) return "\uD83C\uDDEE\uD83C\uDDF3";
        if (compLower.includes("england") || compLower.includes("english")) return "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F";
        if (compLower.includes("australia") || compLower.includes("australian")) return "\uD83C\uDDE6\uD83C\uDDFA";
        if (compLower.includes("pakistan")) return "\uD83C\uDDF5\uD83C\uDDF0";
        if (compLower.includes("bangladesh")) return "\uD83C\uDDE7\uD83C\uDDE9";
        if (compLower.includes("sri lanka")) return "\uD83C\uDDF1\uD83C\uDDF0";
        if (compLower.includes("new zealand")) return "\uD83C\uDDF3\uD83C\uDDFF";
        if (compLower.includes("south africa")) return "\uD83C\uDDFF\uD83C\uDDE6";
        if (compLower.includes("west indies")) return "\uD83C\uDDE7\uD83C\uDDE7";
        if (compLower.includes("afghanistan")) return "\uD83C\uDDE6\uD83C\uDDEB";
        if (compLower.includes("ireland") || compLower.includes("irish")) return "\uD83C\uDDEE\uD83C\uDDEA";
        if (compLower.includes("zimbabwe")) return "\uD83C\uDDFF\uD83C\uDDFC";
        if (compLower.includes("netherlands") || compLower.includes("dutch")) return "\uD83C\uDDF3\uD83C\uDDF1";
        if (compLower.includes("nepal")) return "\uD83C\uDDF3\uD83C\uDDF5";
        if (compLower.includes("scotland") || compLower.includes("scottish")) return "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F";
        if (compLower.includes("denmark") || compLower.includes("danish")) return "\uD83C\uDDE9\uD83C\uDDF0";
        return DEFAULT_COMPETITION_EMOJI;
    }
    if (sport === "FOOTBALL") {
        if (compLower.includes("germany") || compLower.includes("german") || compLower.includes("bundesliga")) return "\uD83C\uDDE9\uD83C\uDDEA";
        if (compLower.includes("denmark") || compLower.includes("danish")) return "\uD83C\uDDE9\uD83C\uDDF0";
        if (compLower.includes("england") || compLower.includes("english")) return "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F";
        if (compLower.includes("spain") || compLower.includes("spanish") || compLower.includes("la liga") || compLower.includes("laliga")) return "\uD83C\uDDEA\uD83C\uDDF8";
        if ((compLower.includes("premier league") || compLower.includes("championship")) && (compLower.includes("english") || compLower.includes("england"))) return "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F";
        if (compLower.includes("ligue 1") || compLower.includes("ligue1") || compLower.includes("france") || compLower.includes("french")) return "\uD83C\uDDEB\uD83C\uDDF7";
        if (compLower.includes("serie a") || compLower.includes("seriea") || compLower.includes("italy") || compLower.includes("italian")) return "\uD83C\uDDEE\uD83C\uDDF9";
        if (compLower.includes("champions league") || compLower.includes("europa league") || compLower.includes("euro") || compLower.includes("european championship")) return "\uD83C\uDDEA\uD83C\uDDFA";
        // Only English/England FA Cup gets England flag; other FA Cups (e.g. Scotland) get trophy or their flag
        if (compLower.includes("fa cup") && (compLower.includes("english") || compLower.includes("england"))) return "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F";
        return DEFAULT_COMPETITION_EMOJI;
    }
    if (sport === "TENNIS") {
        if (compLower.includes("wimbledon")) return "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F";
        if (compLower.includes("us open")) return "\uD83C\uDDFA\uD83C\uDDF8";
        if (compLower.includes("french open") || compLower.includes("roland garros")) return "\uD83C\uDDEB\uD83C\uDDF7";
        if (compLower.includes("australian open")) return "\uD83C\uDDE6\uD83C\uDDFA";
        if (compLower.includes("atp") || compLower.includes("wta")) return "\uD83C\uDF0D";
        return DEFAULT_COMPETITION_EMOJI;
    }
    return DEFAULT_COMPETITION_EMOJI;
};

},{"./matchUtils":"9QY2j","../Trader/Horses/utils.js":"ioCxh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ioCxh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "countryNameToFlag", ()=>countryNameToFlag);
parcelHelpers.export(exports, "getCountryFromFixture", ()=>getCountryFromFixture);
const countryNameToFlag = (name)=>{
    if (!name) return "";
    const key = name.trim().toLowerCase();
    const map = {
        usa: "\uD83C\uDDFA\uD83C\uDDF8",
        "united states": "\uD83C\uDDFA\uD83C\uDDF8",
        uk: "\uD83C\uDDEC\uD83C\uDDE7",
        "united kingdom": "\uD83C\uDDEC\uD83C\uDDE7",
        england: "\uD83C\uDDEC\uD83C\uDDE7",
        india: "\uD83C\uDDEE\uD83C\uDDF3",
        "hong kong": "\uD83C\uDDED\uD83C\uDDF0",
        "south africa": "\uD83C\uDDFF\uD83C\uDDE6",
        "saudi arabia": "\uD83C\uDDF8\uD83C\uDDE6",
        "saudi": "\uD83C\uDDF8\uD83C\uDDE6",
        "saudi arab": "\uD83C\uDDF8\uD83C\uDDE6",
        "united arab emirates": "\uD83C\uDDE6\uD83C\uDDEA",
        "uae": "\uD83C\uDDE6\uD83C\uDDEA",
        "emirates": "\uD83C\uDDE6\uD83C\uDDEA",
        ireland: "\uD83C\uDDEE\uD83C\uDDEA",
        chile: "\uD83C\uDDE8\uD83C\uDDF1",
        argentina: "\uD83C\uDDE6\uD83C\uDDF7",
        australia: "\uD83C\uDDE6\uD83C\uDDFA",
        brazil: "\uD83C\uDDE7\uD83C\uDDF7",
        "new zealand": "\uD83C\uDDF3\uD83C\uDDFF",
        denmark: "\uD83C\uDDE9\uD83C\uDDF0"
    };
    return map[key] || "";
};
const getCountryFromFixture = (fixture)=>{
    if (!fixture) return null;
    const tags = fixture["meta-tags"] || [];
    if (Array.isArray(tags)) for (const tag of tags){
        const tagType = tag?.type?.toString().toUpperCase();
        if (tagType.includes("COUNTRY")) {
            const value = tag?.name;
            if (value) return value;
        }
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVYsA":[function(require,module,exports,__globalThis) {
/**
 * Shared (ov. current/max) label for cricket lobby cards: Squares, Trader, Games list.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 1-based over from Decimal `curBall` (e.g. `4.3` → 5).
 * Null for pre-match placeholders (`-3`, empty, NaN) — those must not read as OVER NAN / live play.
 */ parcelHelpers.export(exports, "cricketLiveOverNumberFromCurBall", ()=>cricketLiveOverNumberFromCurBall);
/**
 * 1-based live over: prefer Decimal `curBall`, else innings overs bowled (`25.0` → 26).
 * Null when neither is a real in-play token.
 */ parcelHelpers.export(exports, "cricketCurrentOverOneBasedFromLiveState", ()=>cricketCurrentOverOneBasedFromLiveState);
/** True when `curBall` is a real in-play ball token (not pre-toss `-3` / empty / NaN). */ parcelHelpers.export(exports, "cricketCurBallIndicatesLivePlay", ()=>cricketCurBallIndicatesLivePlay);
/** Per-innings over limit from fixtures list (format id or label). Format 100 → 20 sets. */ parcelHelpers.export(exports, "maxOversFromFixtureFormat", ()=>maxOversFromFixtureFormat);
/** Infer T10/D10/T20/F50/Hundred from competition or fixture title when `format` is missing (align with backend `cricketMatchFormatOvers`). */ parcelHelpers.export(exports, "cricketFormatOversFromText", ()=>cricketFormatOversFromText);
/** Resolve format code for Bullion lobby eligibility (20 / 50 / 100). */ parcelHelpers.export(exports, "bullionCricketFormatOversFromMatch", ()=>bullionCricketFormatOversFromMatch);
/**
 * Overs bowled in the current innings.
 * Legacy array scoreboard, then the delta object leagues SSE stores on `scoreboard`,
 * then scorecard `innsN.overs`.
 */ parcelHelpers.export(exports, "cricketInningsOversDecimalFromStream", ()=>cricketInningsOversDecimalFromStream);
/**
 * Live feed innings over cap (e.g. DLS / T20 limit).
 * Prefers legacy array "Max Overs", then delta object `maxovers`, then event.max_overs.
 */ parcelHelpers.export(exports, "maxOversFromStreamEvent", ()=>maxOversFromStreamEvent);
/** Same 1-based “current over” as match play: floor(full + part/6) + 1. */ parcelHelpers.export(exports, "cricketCurrentOver1BasedFromScoreboard", ()=>cricketCurrentOver1BasedFromScoreboard);
/** Decimal overs bowled (full + part/6) from scoreboard, same basis as Trader scorecard / CurPos. */ parcelHelpers.export(exports, "cricketInningsOversDecimalFromScoreboard", ()=>cricketInningsOversDecimalFromScoreboard);
/** Cricket display string e.g. "1.2" (1 over, 2 balls), aligned with Trader scorecard total overs line. */ parcelHelpers.export(exports, "formatCricketOversBowledDisplay", ()=>formatCricketOversBowledDisplay);
/**
 * Match-play footer / tabs: `"5.3"` = **1-based** current over · legal balls in this over (six-ball basis).
 * Derived from the same innings decimal as sticky `(ov. 4.3/20)` (`full + part/6`).
 */ parcelHelpers.export(exports, "formatCricketCurrentOverProgressLabel", ()=>formatCricketCurrentOverProgressLabel);
/**
 * Per-innings over cap from feed `mOvers` (innings1–4 max) when present; else fixture format (T20/ODI).
 * @param {number} inningsIndex1Based 1–4
 * @param {unknown} mOvers - e.g. from socket: max per innings or [max.1, max.2]
 * @param {unknown} fixtureFormat
 * @returns {number|null}
 */ parcelHelpers.export(exports, "maxOversForInningsIndex", ()=>maxOversForInningsIndex);
/**
 * Lobby-style label for match-play sticky bar when live: `(ov. 2.1/20)`.
 * Uses current-innings decimal overs from socket + max for `innsNow`.
 */ /** True when the sticky label would show `0.0` overs bowled (e.g. `(ov. 0.0/20)`). */ parcelHelpers.export(exports, "isSquaresAtInningsOversZero", ()=>isSquaresAtInningsOversZero);
/**
 * Innings switch / chase not started: sticky `(ov. 0.0/20)`, `(ov. 0.0/50)`, etc.
 * Same signal the header uses — not end-of-innings `(ov. 20.0/20)`.
 */ parcelHelpers.export(exports, "isSquaresInningsSwitchOvState", ()=>isSquaresInningsSwitchOvState);
/**
 * True when live overs bowled have reached the innings cap — same basis as sticky `(ov. 20.0/20)` / `(ov. 50.0/50)`.
 */ parcelHelpers.export(exports, "isSquaresAtInningsOversCap", ()=>isSquaresAtInningsOversCap);
/** Highest `ov` on scoregrid for this innings (integer over index, e.g. 20 at end of a T20). */ parcelHelpers.export(exports, "scoregridMaxOverNumber", ()=>scoregridMaxOverNumber);
parcelHelpers.export(exports, "isSquaresScoregridAtInningsOverCap", ()=>isSquaresScoregridAtInningsOverCap);
/**
 * Parse fixture `format` / `max_overs` from stream or list (numeric 50, string "T20", etc.).
 * Returns scheduled overs for display (format 100 → 20 sets). Test → 999.
 * @param {unknown} raw
 * @returns {number|null} scheduled overs, 999 for Test, or null
 */ parcelHelpers.export(exports, "parseCricketFixtureFormatOvers", ()=>parseCricketFixtureFormatOvers);
/**
 * Scheduled overs cap for the live innings — same resolution as the sticky `(ov. x/20)` label.
 * Treats `0` / blank live `mOvers` slots as missing so second-innings RRR can fall back to format.
 */ parcelHelpers.export(exports, "resolveCricketMatchPlayMaxOvers", ()=>resolveCricketMatchPlayMaxOvers);
parcelHelpers.export(exports, "getCricketMatchPlayStickyOvLabel", ()=>getCricketMatchPlayStickyOvLabel);
/**
 * Full display label including parentheses, e.g. "(ov. 12.3/50)" or "(ov. 89.4)".
 * Uses overs bowled (balls notation), not 1-based “current over” index.
 * The over number is kept when the innings has no limited-overs cap (Test, or maxovers blank).
 * @param {object|undefined} streamData - merged SSE payload (event.scoreboard or delta scoreboard)
 * @param {unknown} fixtureFormat - from fixtures list when stream max not yet available
 */ parcelHelpers.export(exports, "getCricketMatchCardOvLabel", ()=>getCricketMatchCardOvLabel);
var _cricketTestMatch = require("../../utils/cricketTestMatch");
function cricketLiveOverNumberFromCurBall(curBall) {
    if (curBall == null || curBall === "") return null;
    const ballOver = Number.parseFloat(String(curBall).trim());
    if (!Number.isFinite(ballOver) || ballOver < 0) return null;
    return Math.floor(ballOver) + 1;
}
function cricketCurrentOverOneBasedFromLiveState(curBall, inningsOversDecimal) {
    const fromBall = cricketLiveOverNumberFromCurBall(curBall);
    if (fromBall != null) return fromBall;
    if (inningsOversDecimal == null || inningsOversDecimal === "") return null;
    const dec = Number(inningsOversDecimal);
    if (!Number.isFinite(dec) || dec < 0) return null;
    // 0.0 without a live curBall is pretoss / unknown — do not paint "OVER 1".
    if (dec <= 1e-6) return null;
    return Math.floor(dec) + 1;
}
function cricketCurBallIndicatesLivePlay(curBall) {
    return cricketLiveOverNumberFromCurBall(curBall) != null;
}
function maxOversFromFixtureFormat(format) {
    if (format == null || format === "") return null;
    if (typeof format === "number" && Number.isFinite(format)) {
        const scheduled = (0, _cricketTestMatch.cricketFormatScheduledOvers)(format);
        if (scheduled != null) return scheduled;
        return null;
    }
    const s = String(format).trim();
    const n = parseInt(s, 10);
    if (!Number.isNaN(n)) {
        const scheduled = (0, _cricketTestMatch.cricketFormatScheduledOvers)(n);
        if (scheduled != null) return scheduled;
    }
    const lower = s.toLowerCase();
    if (lower === "t20" || lower === "twenty20" || lower === "20") return 20;
    if (lower === "odi" || lower === "50" || lower === "one-day" || lower === "list a") return 50;
    if (lower === "t10" || lower === "10") return 10;
    if (/\bthe\s*hundred\b/.test(lower)) return 20;
    return null;
}
function cricketFormatOversFromText(competition, matchName) {
    const blob = `${String(competition ?? "")} ${String(matchName ?? "")}`.toLowerCase();
    if (/\bthe\s*hundred\b/.test(blob)) return 0, _cricketTestMatch.CRICKET_HUNDRED_FORMAT_CODE;
    // D10 / T10 before T20 so "Emirates D10" etc. are not skipped.
    if (/\bd10\b|\bt10s?\b|ten10|10.?over/.test(blob)) return 10;
    // Pro20 / SA20 nest "20" inside the brand (no `\bt20` token).
    if (/\bpro\s*20\b|\bsa\s*20\b|\bt20s?\b|twenty20|twenty-20/.test(blob)) return 20;
    if (/\bodi\b|\bf50\b|50.over|one[-\s]?day|list\s*a\b/.test(blob)) return 50;
    return null;
}
function bullionCricketFormatOversFromMatch(match) {
    if (!match || typeof match !== "object") return null;
    const code = (0, _cricketTestMatch.normalizeCricketFormatCode)(match.format ?? match.Format);
    if (code != null && code !== 999) return code;
    const fromMax = (0, _cricketTestMatch.normalizeCricketFormatCode)(match.max_overs ?? match.maxovers);
    if (fromMax != null && fromMax !== 999) return fromMax;
    return cricketFormatOversFromText(match.competition, match.name ?? match.match_name);
}
/** Parse a limited-overs max (1–50). Hundred sometimes sends `100` → 20 five-ball sets. */ function parseLimitedOversMax(value) {
    if (value == null || value === "") return null;
    const parsed = parseInt(String(value).trim(), 10);
    if (!Number.isFinite(parsed) || parsed <= 0) return null;
    if (parsed === 100) return 20;
    if (parsed > 50) return null;
    return parsed;
}
function maxOversFromArrayScoreboard(scoreboard) {
    if (!Array.isArray(scoreboard)) return null;
    const entry = scoreboard.find((item)=>item?.name === "Max Overs" || item?.name === "maxovers" || item?.name === "max.1");
    return parseLimitedOversMax(entry?.value);
}
/** Delta object scoreboard (`maxovers`) as used by leagues SSE / useCricketStream. */ function maxOversFromObjectScoreboard(sb) {
    if (!sb || typeof sb !== "object" || Array.isArray(sb)) return null;
    return parseLimitedOversMax(sb.maxovers) ?? parseLimitedOversMax(sb.maxOvers) ?? parseLimitedOversMax(sb.max_overs) ?? parseLimitedOversMax(sb["Max Overs"]);
}
/** Innings overs decimal from delta object scoreboard (`currentinningsovers` + part). */ function decimalFromObjectScoreboard(sb) {
    if (!sb || typeof sb !== "object" || Array.isArray(sb)) return null;
    const fullRaw = sb.currentinningsovers ?? sb.currentInningsovers ?? sb.current_innings_overs;
    if (fullRaw == null || fullRaw === "") return null;
    const full = parseFloat(String(fullRaw).trim());
    if (!Number.isFinite(full) || full < 0) return null;
    const partRaw = sb.currentinningspartovers ?? sb.currentInningsPartOvers ?? sb.current_innings_part_overs;
    const part = partRaw == null || partRaw === "" ? 0 : parseFloat(String(partRaw).trim());
    const partSafe = Number.isFinite(part) && part >= 0 ? part : 0;
    return full + partSafe / 6;
}
/** Cricket notation `"12.3"` (12 overs, 3 balls) → true decimal `12.5`. */ function decimalFromCricketNotation(raw) {
    if (raw == null || raw === "") return null;
    const match = String(raw).trim().match(/^(\d+)(?:\.(\d))?$/);
    if (!match) return null;
    const full = parseInt(match[1], 10);
    if (!Number.isFinite(full) || full < 0) return null;
    if (match[2] == null) return full;
    const balls = parseInt(match[2], 10);
    if (!Number.isFinite(balls) || balls < 0 || balls > 5) return null;
    return full + balls / 6;
}
/** Current-innings overs from scorecard `innsN.overs` (cricket notation, not true decimal). */ function decimalFromScorecardInnings(streamData) {
    const card = streamData?.scorecard;
    if (!card || typeof card !== "object" || Array.isArray(card)) return null;
    const inn = Math.floor(Number(card.inns_now ?? card.innsNow));
    if (!Number.isFinite(inn) || inn < 1) return null;
    const inns = card[`inns${inn}`];
    if (!inns || typeof inns !== "object" || Array.isArray(inns)) return null;
    return decimalFromCricketNotation(inns.overs);
}
function cricketInningsOversDecimalFromStream(streamData) {
    if (!streamData || typeof streamData !== "object") return null;
    const eventObj = streamData.event?.event ?? streamData.event;
    const eventBoard = eventObj?.scoreboard;
    return cricketInningsOversDecimalFromScoreboard(eventBoard) ?? decimalFromObjectScoreboard(streamData.scoreboard) ?? decimalFromObjectScoreboard(eventBoard) ?? decimalFromScorecardInnings(streamData);
}
/**
 * `(ov. 12.3/50)` when the innings cap is a limited-overs max.
 * `(ov. 12.3)` when the over is known but there is no cap (Test, or maxovers still blank).
 * Null only when neither the over nor a cap is known.
 */ function formatCricketStickyOvLabel(decimalOvers, maxOvers) {
    const capped = maxOvers != null && Number.isFinite(Number(maxOvers)) ? parseLimitedOversMax(maxOvers) : null;
    const num = decimalOvers != null && Number.isFinite(Number(decimalOvers)) && Number(decimalOvers) >= 0 ? formatCricketOversBowledDisplay(Number(decimalOvers)) : null;
    if (num == null && capped == null) return null;
    if (capped != null) return `(ov. ${num ?? "\u2014"}/${capped})`;
    return `(ov. ${num})`;
}
function maxOversFromStreamEvent(streamData) {
    if (!streamData || typeof streamData !== "object") return null;
    const eventObj = streamData.event?.event ?? streamData.event;
    return maxOversFromArrayScoreboard(eventObj?.scoreboard) ?? maxOversFromObjectScoreboard(streamData.scoreboard) ?? maxOversFromObjectScoreboard(eventObj?.scoreboard) ?? parseLimitedOversMax(eventObj?.max_overs) ?? parseLimitedOversMax(streamData.formatOvers) ?? parseLimitedOversMax(streamData.scheduledOvers) ?? null;
}
function cricketCurrentOver1BasedFromScoreboard(scoreboard) {
    if (!Array.isArray(scoreboard)) return null;
    const fullEntry = scoreboard.find((item)=>item?.name === "Current Innings Overs");
    const partEntry = scoreboard.find((item)=>item?.name === "Current Innings Part Overs");
    const fullRaw = fullEntry?.value;
    if (fullRaw == null || fullRaw === "") return null;
    const full = parseFloat(String(fullRaw).trim());
    if (!Number.isFinite(full) || full < 0) return null;
    const partRaw = partEntry?.value;
    const part = partRaw == null || partRaw === "" ? 0 : parseFloat(String(partRaw).trim());
    const partSafe = Number.isFinite(part) && part >= 0 ? part : 0;
    const decimal = full + partSafe / 6;
    return Math.floor(decimal) + 1;
}
function cricketInningsOversDecimalFromScoreboard(scoreboard) {
    if (!Array.isArray(scoreboard)) return null;
    const fullEntry = scoreboard.find((item)=>item?.name === "Current Innings Overs");
    const partEntry = scoreboard.find((item)=>item?.name === "Current Innings Part Overs");
    const fullRaw = fullEntry?.value;
    if (fullRaw == null || fullRaw === "") return null;
    const full = parseFloat(String(fullRaw).trim());
    if (!Number.isFinite(full) || full < 0) return null;
    const partRaw = partEntry?.value;
    const part = partRaw == null || partRaw === "" ? 0 : parseFloat(String(partRaw).trim());
    const partSafe = Number.isFinite(part) && part >= 0 ? part : 0;
    return full + partSafe / 6;
}
function formatCricketOversBowledDisplay(decimalOvers) {
    if (decimalOvers == null || typeof decimalOvers !== "number" || Number.isNaN(decimalOvers)) return null;
    const full = Math.floor(decimalOvers);
    let balls = Math.round((decimalOvers - full) * 6);
    if (balls >= 6) balls = 0;
    return balls === 0 && full > 0 ? `${full}.0` : `${full}.${balls}`;
}
function formatCricketCurrentOverProgressLabel(decimalOvers) {
    if (decimalOvers == null || typeof decimalOvers !== "number" || Number.isNaN(decimalOvers) || decimalOvers < 0) return null;
    const full = Math.floor(decimalOvers);
    let balls = Math.round((decimalOvers - full) * 6);
    if (balls >= 6) balls = 0;
    const oneBasedOver = full + 1;
    return `${oneBasedOver}.${balls}`;
}
function maxOversForInningsIndex(inningsIndex1Based, mOvers, fixtureFormat) {
    const inn = Math.floor(Number(inningsIndex1Based));
    if (!Number.isFinite(inn) || inn < 1 || inn > 4) return maxOversFromFixtureFormat(fixtureFormat);
    const idx = inn - 1;
    if (Array.isArray(mOvers) && idx >= 0 && idx < mOvers.length) {
        const v = mOvers[idx];
        if (v != null && v !== "") {
            const parsed = parseInt(String(v).trim(), 10);
            if (Number.isFinite(parsed) && parsed > 0 && parsed <= 50) return parsed;
        }
    }
    return maxOversFromFixtureFormat(fixtureFormat);
}
function isSquaresAtInningsOversZero(currentInningsOversDecimal) {
    const dec = currentInningsOversDecimal != null && Number.isFinite(Number(currentInningsOversDecimal)) ? Number(currentInningsOversDecimal) : NaN;
    return Number.isFinite(dec) && dec <= 1e-6;
}
function isSquaresInningsSwitchOvState(currentInningsOversDecimal, inningsIndex1Based, mOvers, fixtureFormat) {
    if (!isSquaresAtInningsOversZero(currentInningsOversDecimal)) return false;
    const max = maxOversForInningsIndex(inningsIndex1Based, mOvers, fixtureFormat);
    return max != null && max >= 1;
}
function isSquaresAtInningsOversCap(currentInningsOversDecimal, inningsIndex1Based, mOvers, fixtureFormat) {
    const max = maxOversForInningsIndex(inningsIndex1Based, mOvers, fixtureFormat);
    if (max == null) return false;
    const dec = currentInningsOversDecimal != null && Number.isFinite(Number(currentInningsOversDecimal)) ? Number(currentInningsOversDecimal) : NaN;
    if (!Number.isFinite(dec)) return false;
    return dec >= max - 1e-6;
}
function scoregridMaxOverNumber(scoreGridData, inningsIndex1Based) {
    const inn = Math.floor(Number(inningsIndex1Based));
    if (!Number.isFinite(inn) || inn < 1) return null;
    const arr = scoreGridData?.overs?.[`inns${inn}`];
    if (!Array.isArray(arr) || arr.length === 0) return null;
    let hi = 0;
    for (const row of arr){
        const ov = Number(row?.ov);
        if (Number.isFinite(ov) && ov > hi) hi = ov;
    }
    return hi > 0 ? hi : null;
}
function isSquaresScoregridAtInningsOverCap(scoreGridData, inningsIndex1Based, mOvers, fixtureFormat) {
    const max = maxOversForInningsIndex(inningsIndex1Based, mOvers, fixtureFormat);
    const gridMax = scoregridMaxOverNumber(scoreGridData, inningsIndex1Based);
    if (max == null || gridMax == null) return false;
    return gridMax >= max;
}
function parseCricketFixtureFormatOvers(raw) {
    if (raw == null || raw === "") return null;
    const normalized = (0, _cricketTestMatch.normalizeCricketFormatCode)(raw);
    if (normalized === 999) return 999;
    if (normalized != null) return (0, _cricketTestMatch.cricketFormatScheduledOvers)(normalized) ?? normalized;
    return maxOversFromFixtureFormat(raw);
}
function resolveCricketMatchPlayMaxOvers(innsNow, mOvers, fixtureFormat, liveMaxOversFromScoreboard = null) {
    const inn = Math.floor(Number(innsNow));
    const indexedMax = Number.isFinite(inn) && inn >= 1 && inn <= 4 ? maxOversForInningsIndex(inn, mOvers, fixtureFormat) : maxOversFromFixtureFormat(fixtureFormat);
    return parseLimitedOversMax(liveMaxOversFromScoreboard) ?? indexedMax;
}
function getCricketMatchPlayStickyOvLabel(currentInningsOversDecimal, innsNow, mOvers, fixtureFormat, liveMaxOversFromScoreboard = null) {
    const max = resolveCricketMatchPlayMaxOvers(innsNow, mOvers, fixtureFormat, liveMaxOversFromScoreboard);
    let dec = null;
    if (currentInningsOversDecimal != null && !Number.isNaN(Number(currentInningsOversDecimal))) dec = Number(currentInningsOversDecimal);
    return formatCricketStickyOvLabel(dec, max);
}
function getCricketMatchCardOvLabel(streamData, fixtureFormat) {
    const max = maxOversFromStreamEvent(streamData) ?? maxOversFromFixtureFormat(fixtureFormat);
    const dec = cricketInningsOversDecimalFromStream(streamData);
    return formatCricketStickyOvLabel(dec, max);
}

},{"../../utils/cricketTestMatch":"eJTw5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ipKfP":[function(require,module,exports,__globalThis) {
/**
 * Parse `/completed/:id` the same way Match details do: thin scorecards often omit inns*
 * while the event scoreboard still has runs.N / wkts.N and the who-won line.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Build inns1–inns4 from scoreboard runs.N / wkts.N (Match list / Match details fallback). */ parcelHelpers.export(exports, "innsFromCompletedScoreboard", ()=>innsFromCompletedScoreboard);
/**
 * Prefer scorecard inns; when the archive only kept Event scoreboard totals, fill inns*
 * so the league score bars can render (same as fixturelist/completed list cards).
 */ parcelHelpers.export(exports, "enrichCompletedScorecard", ()=>enrichCompletedScorecard);
/**
 * Who-won line — same priority as DecimalSocketContext EventProc / backend
 * `deriveFinishedMatchResultComment` used by Match details and finished match cards.
 */ parcelHelpers.export(exports, "deriveCompletedMatchComment", ()=>deriveCompletedMatchComment);
/** Pull scorecard + scoreboard + who-won line from a `/completed/:id` JSON body. */ parcelHelpers.export(exports, "parseCompletedCricketArchive", ()=>parseCompletedCricketArchive);
var _cricketInnsTeamScores = require("../../../utils/cricketInnsTeamScores");
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
function scoreboardValue(scoreboard, name) {
    if (!Array.isArray(scoreboard)) return "";
    const row = scoreboard.find((item)=>item?.name === name);
    return row?.value != null ? String(row.value).trim() : "";
}
function scoreboardInt(scoreboard, name) {
    const v = parseInt(scoreboardValue(scoreboard, name), 10);
    return Number.isNaN(v) ? null : v;
}
function scorecardHasInns(scorecard) {
    return Boolean(scorecard && (scorecard.inns1 != null || scorecard.inns2 != null));
}
function innsFromCompletedScoreboard(scoreboard) {
    const inns = {};
    for(let i = 1; i <= 4; i += 1){
        const runs = scoreboardInt(scoreboard, `runs.${i}`);
        const wkts = scoreboardInt(scoreboard, `wkts.${i}`);
        if (runs == null && wkts == null) continue;
        inns[`inns${i}`] = {
            runs: runs ?? 0,
            wkts: wkts ?? 0
        };
    }
    return inns;
}
function enrichCompletedScorecard(scorecard, scoreboard) {
    const base = (0, _cricketInnsTeamScores.unwrapCricketScorecard)(scorecard);
    const fromSb = innsFromCompletedScoreboard(scoreboard);
    if (scorecardHasInns(base)) {
        const sc = {
            ...base
        };
        if (!String(sc.bat_now ?? sc.batNow ?? "").trim()) {
            const bat = scoreboardValue(scoreboard, "Current Batting Team") || scoreboardValue(scoreboard, "bat_now");
            if (bat) sc.bat_now = bat;
        }
        return sc;
    }
    if (Object.keys(fromSb).length === 0) return base ? {
        ...base
    } : null;
    const bat = scoreboardValue(scoreboard, "Current Batting Team") || scoreboardValue(scoreboard, "bat_now") || scoreboardValue(scoreboard, "batting.2");
    return {
        ...base ? base : {},
        ...fromSb,
        ...bat ? {
            bat_now: bat
        } : {}
    };
}
function deriveCompletedMatchComment(scoreboard, ...statusCandidates) {
    let result = "";
    for (const status of statusCandidates){
        const fromStatus = (0, _decimalEventStatus.resultCommentFromEventStatus)(status);
        if (fromStatus) {
            result = fromStatus;
            break;
        }
    }
    const get = (name)=>scoreboardValue(scoreboard, name);
    const winnerName = get("winner");
    const winnerOk = (0, _decimalEventStatus.isDecimalTeamWinner)(winnerName);
    if (!result) {
        const marginKeys = [
            "wonby",
            "won_by",
            "win_by",
            "winning_margin",
            "result",
            "match_result",
            "victory_margin"
        ];
        for (const key of marginKeys){
            const val = get(key);
            if (!val) continue;
            if (/\bwon\b|\bwins?\b|\bruns?\b|\bwickets?\b|\btied?\b|\bdraw/i.test(val)) {
                result = val;
                break;
            }
            if (winnerOk && /\bruns?\b|\bwickets?\b/i.test(val)) {
                result = `${winnerName} won by ${val}`;
                break;
            }
        }
    }
    if (!result) {
        const bat1 = get("batting.1") || get("home");
        const bat2 = get("batting.2") || get("away");
        const r1 = scoreboardInt(scoreboard, "runs.1");
        const r2 = scoreboardInt(scoreboard, "runs.2");
        const w2 = scoreboardInt(scoreboard, "wkts.2");
        if (r1 != null && r2 != null) {
            if (r2 > r1) {
                const name = bat2 || (winnerOk ? winnerName : "");
                if (name) {
                    const wicketsInHand = w2 == null ? 10 : Math.max(0, 10 - w2);
                    result = `${name} won by ${wicketsInHand} wicket${wicketsInHand !== 1 ? "s" : ""}`;
                }
            } else if (r1 > r2) {
                const chaseNotStarted = r2 === 0 && (w2 == null || w2 === 0);
                if (!chaseNotStarted || winnerOk) {
                    const name = bat1 || (winnerOk ? winnerName : "");
                    if (name) result = `${name} won by ${r1 - r2} runs`;
                }
            } else if (!(r1 === 0 && r2 === 0 && !winnerOk)) result = "Match tied";
        }
    }
    if (!result) {
        let comment = get("match_comment");
        if ((0, _decimalEventStatus.isCricketRrrComment)(comment)) comment = "";
        if ((0, _decimalEventStatus.commentIndicatesCricketMatchResult)(comment)) result = comment;
        else if (winnerOk) result = `${winnerName} wins.`;
    }
    return result;
}
function parseCompletedCricketArchive(payload) {
    const data = payload && typeof payload === "object" && "data" in payload ? payload.data : payload;
    if (data == null || Array.isArray(data) || typeof data !== "object") return null;
    const root = data;
    const sc0 = Array.isArray(root.scorecard) ? root.scorecard[0] : root.scorecard;
    const fromScorecard = sc0 && typeof sc0 === "object" && !Array.isArray(sc0) ? sc0.msg_data ?? sc0 : null;
    const ev0 = Array.isArray(root.event) ? root.event[0] : root.event;
    const eventMd = ev0 && typeof ev0 === "object" && !Array.isArray(ev0) ? ev0.msg_data ?? ev0 : null;
    const fromEventScorecard = eventMd?.scorecard;
    const rawScorecard = fromScorecard && typeof fromScorecard === "object" && !Array.isArray(fromScorecard) ? fromScorecard : fromEventScorecard && typeof fromEventScorecard === "object" && !Array.isArray(fromEventScorecard) ? fromEventScorecard : null;
    const scoreboard = Array.isArray(eventMd?.scoreboard) ? eventMd.scoreboard : [];
    const scorecard = enrichCompletedScorecard(rawScorecard, scoreboard);
    if (!scorecard) return null;
    const eventStatus = rawScorecard?.event_status ?? eventMd?.event_status ?? "";
    const gamePhase = scoreboardValue(scoreboard, "game_phase");
    const matchComment = deriveCompletedMatchComment(scoreboard, gamePhase, eventStatus);
    if (matchComment && !String(scorecard.result ?? "").trim()) scorecard.result = matchComment;
    return {
        scorecard,
        scoreboard,
        matchComment
    };
}

},{"../../../utils/cricketInnsTeamScores":"4117b","../../Trader/Cricket/decimalEventStatus":"f1nlI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4117b":[function(require,module,exports,__globalThis) {
/**
 * Map cricket innings (batting order) onto fixture home/away team rows.
 *
 * Scorecards store inns1..inns4 in batting order (toss decides who bats first).
 * UI rows stay in fixture order (home then away). When bat_now is present we remap;
 * when it is missing we fall back to inns1→home / inns2→away (cannot know toss order).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatCricketInnsScore", ()=>formatCricketInnsScore);
/** Normalize scorecard from object or array-wrapped stream message. */ parcelHelpers.export(exports, "unwrapCricketScorecard", ()=>unwrapCricketScorecard);
parcelHelpers.export(exports, "extractCricketInnsScores", ()=>extractCricketInnsScores);
/** Scorecard `bat_now` vs fixture labels often differ (“NZ” vs “New Zealand”). */ parcelHelpers.export(exports, "cricketTeamLabelsMatch", ()=>cricketTeamLabelsMatch);
/**
 * True when the batting label maps to the fixture home side.
 * Ambiguous / unknown labels return null so callers can skip remapping.
 */ parcelHelpers.export(exports, "batNowIsHomeTeam", ()=>batNowIsHomeTeam);
/**
 * Assign inns1..inns4 onto [homePrimary, awayPrimary, homeSecond, awaySecond]
 * using bat_now + inns_now when available.
 *
 * `fallbackBatNow` — last known batting side when the live frame omitted it (orientation latch).
 */ parcelHelpers.export(exports, "mapCricketInnsScoresToTeams", ()=>mapCricketInnsScoresToTeams);
function formatCricketInnsScore(inns) {
    if (!inns || typeof inns !== "object") return "0/0";
    const row = inns;
    const r = row.runs != null ? Number(row.runs) : 0;
    const w = row.wkts != null ? Number(row.wkts) : 0;
    return `${Number.isFinite(r) ? r : 0}/${Number.isFinite(w) ? w : 0}`;
}
function unwrapCricketScorecard(raw) {
    if (raw == null) return null;
    const sc = Array.isArray(raw) ? raw[0]?.msg_data ?? raw[0] : raw;
    if (!sc || typeof sc !== "object" || Array.isArray(sc)) return null;
    return sc;
}
function extractCricketInnsScores(scorecard) {
    return [
        scorecard.inns1 != null ? formatCricketInnsScore(scorecard.inns1) : "0/0",
        scorecard.inns2 != null ? formatCricketInnsScore(scorecard.inns2) : "0/0",
        scorecard.inns3 != null ? formatCricketInnsScore(scorecard.inns3) : "0/0",
        scorecard.inns4 != null ? formatCricketInnsScore(scorecard.inns4) : "0/0"
    ];
}
function normalizeTeamLabelKey(value) {
    return value.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}
/** Initials / short code for multi-word teams (`New Zealand` → `NZ`); 3-letter slice for single words. */ function cricketTeamAbbreviation(teamName) {
    const words = String(teamName || "").trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return "";
    if (words.length === 1) return words[0].replace(/[^A-Za-z0-9]/g, "").slice(0, 3).toUpperCase();
    return words.map((w)=>w.replace(/[^A-Za-z0-9]/g, "")).filter(Boolean).map((w)=>w[0]).join("").slice(0, 3).toUpperCase();
}
function cricketTeamLabelsMatch(a, b) {
    const left = String(a ?? "").trim();
    const right = String(b ?? "").trim();
    if (!left || !right) return false;
    if (left === right) return true;
    const na = normalizeTeamLabelKey(left);
    const nb = normalizeTeamLabelKey(right);
    if (!na || !nb) return false;
    if (na === nb) return true;
    if (na.includes(nb) || nb.includes(na)) return true;
    const leftUpper = left.toUpperCase();
    const rightUpper = right.toUpperCase();
    const leftAbbr = cricketTeamAbbreviation(left);
    const rightAbbr = cricketTeamAbbreviation(right);
    if (leftAbbr.length >= 2 && leftAbbr === rightUpper) return true;
    if (rightAbbr.length >= 2 && rightAbbr === leftUpper) return true;
    return false;
}
function batNowIsHomeTeam(batNow, teams) {
    const home = String(teams[0] ?? "").trim();
    const away = String(teams[1] ?? "").trim();
    const matchHome = cricketTeamLabelsMatch(batNow, home);
    const matchAway = cricketTeamLabelsMatch(batNow, away);
    if (matchHome && !matchAway) return true;
    if (matchAway && !matchHome) return false;
    if (matchHome && matchAway) {
        const batKey = normalizeTeamLabelKey(batNow);
        const homeKey = normalizeTeamLabelKey(home);
        const awayKey = normalizeTeamLabelKey(away);
        if (batKey === homeKey && batKey !== awayKey) return true;
        if (batKey === awayKey && batKey !== homeKey) return false;
        // Prefer the closer-length label (“India” vs “India A”).
        const homeDist = Math.abs(homeKey.length - batKey.length);
        const awayDist = Math.abs(awayKey.length - batKey.length);
        if (homeDist !== awayDist) return homeDist < awayDist;
        return batNow.trim() === home;
    }
    return null;
}
function mapCricketInnsScoresToTeams(scorecard, teams, fallbackBatNow) {
    const insScore = extractCricketInnsScores(scorecard);
    const liveBatNow = String(scorecard.bat_now ?? scorecard.batNow ?? "").trim();
    const batNow = liveBatNow || String(fallbackBatNow ?? "").trim();
    if (!batNow) return {
        scores: insScore,
        batNow: ""
    };
    const batIsHome = batNowIsHomeTeam(batNow, teams);
    // Unknown batting label: keep batting-order scores rather than guessing away.
    if (batIsHome == null) return {
        scores: insScore,
        batNow: liveBatNow || batNow
    };
    const innsNow = Number(scorecard.inns_now) || 1;
    const oppNow = innsNow === 1 || innsNow === 3 ? 2 : 1;
    const rptNow = innsNow === 1 || innsNow === 3 ? 1 : 2;
    const idx0 = batIsHome ? rptNow - 1 : oppNow - 1;
    const idx1 = batIsHome ? oppNow - 1 : rptNow - 1;
    const idx2 = batIsHome ? rptNow + 1 : oppNow + 1;
    const idx3 = batIsHome ? oppNow + 1 : rptNow + 1;
    return {
        scores: [
            insScore[idx0] || "0/0",
            insScore[idx1] || "0/0",
            insScore[idx2] || "0/0",
            insScore[idx3] || "0/0"
        ],
        batNow: liveBatNow || batNow
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4qS7j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Per-game won / pot totals for one leaderboard row.
 * Won = settled points (Squares: every over return; Trader: stake×odds return; Bullion: slip +
 * place bonus after settle; Sixes: native score) plus live Sixes / Squares+ / Bullion pick score.
 * Open Bullion place bonus is IF NOW on the Bullion tab only — not Overall.
 * Falls back to positive by-game P/L when the prototype seeded stats without matching plays.
 */ parcelHelpers.export(exports, "leagueLeaderboardBarStatsForMember", ()=>leagueLeaderboardBarStatsForMember);
/** Shared bar scale: largest won-points ceiling among visible rows. */ parcelHelpers.export(exports, "leagueLeaderboardBarScaleMax", ()=>leagueLeaderboardBarScaleMax);
parcelHelpers.export(exports, "leagueLeaderboardBarStatsByUserId", ()=>leagueLeaderboardBarStatsByUserId);
/** Restrict stats to a single game tab (same colours, only that slice). */ parcelHelpers.export(exports, "leagueLeaderboardBarStatsForGame", ()=>leagueLeaderboardBarStatsForGame);
parcelHelpers.export(exports, "leagueLeaderboardBarHasSignal", ()=>leagueLeaderboardBarHasSignal);
/**
 * Viewer's overall standing by WON points — same basis as the Overall leaderboard.
 */ parcelHelpers.export(exports, "leagueLiveOverallStanding", ()=>leagueLiveOverallStanding);
/** Same order as play / leaderboard tabs (only games in the included set). */ parcelHelpers.export(exports, "leagueLeaderboardBarGames", ()=>leagueLeaderboardBarGames);
var _leagueBullionProjectedPoints = require("./leagueBullionProjectedPoints");
var _constants = require("./constants");
var _leagueFormat = require("./leagueFormat");
var _leaguePlays = require("./leaguePlays");
function emptySlices(games) {
    const out = {};
    for (const game of games)out[game] = {
        won: 0,
        pot: 0
    };
    return out;
}
function playReturn(play) {
    return (0, _leaguePlays.leaguePlayChipReturn)(play);
}
function settlementReturn(row) {
    // Squares: every over's chip return counts toward league points (not only profitable wins).
    if (row.game === "squares") return (0, _leaguePlays.leaguePlayChipReturn)(row);
    if (row.game === "trader") return (0, _leaguePlays.leagueTraderWonPoints)(row);
    if (row.outcome !== "win" && !(Number(row.delta) > 0)) return 0;
    return (0, _leaguePlays.leaguePlayChipReturn)(row);
}
function leagueLeaderboardBarStatsForMember(league, userId, games = (0, _leagueFormat.leagueIncludedGames)(league)) {
    const buckets = emptySlices(games);
    const gameSet = new Set(games);
    /** Games this user has any play on — real play data wins over the seeded byGame fallback. */ const playedGames = new Set();
    const openBullionLive = games.includes("bullion") ? (0, _leagueBullionProjectedPoints.openBullionLiveByUserId)(league) : null;
    const openBullionRow = openBullionLive?.get(userId) ?? null;
    for (const play of league.plays){
        if (play.userId !== userId || !gameSet.has(play.game)) continue;
        playedGames.add(play.game);
        // Native in-play points per game (unified "points" leaderboard):
        // Bullion open → live pick score on Overall; if-now place bonus on the Bullion tab;
        // Bullion settled → slip + place bonus; Sixes → live card score;
        // Squares open → Super return from balls; Trader → coins.
        const settlement = play.marketDetails?.settlement;
        const bullionPoolShare = play.game === "bullion" && play.status !== "open" && settlement && Number.isFinite(Number(settlement.points)) ? Math.max(0, Math.round(Number(settlement.points) || 0)) : null;
        const sixesScore = play.game === "sixes" && Number.isFinite(Number(play.marketDetails?.cardScore)) ? Math.max(0, Math.round(Number(play.marketDetails.cardScore) || 0)) : null;
        const openSquaresLive = play.game === "squares" && play.status === "open" ? (0, _leaguePlays.leagueSquaresOpenLiveReturn)(play) : null;
        if (play.status === "open") {
            if (play.game === "bullion") continue;
            else if (play.game === "sixes") // Sixes has no pot ceiling — the live card score is WON only and only grows.
            {
                if (sixesScore != null) buckets.sixes.won += sixesScore;
            } else if (play.game === "squares") // Super Squares: live chip return counts as WON (same as settled over return).
            {
                if (openSquaresLive != null) buckets.squares.won += openSquaresLive;
            } else // Trader (and any other stake×odds game): open potential = full return.
            buckets[play.game].pot += (0, _leaguePlays.potentialReturn)(play.stake, play.multiplier);
            continue;
        }
        // Settled: Bullion uses slip + place bonus; Sixes keeps native score;
        // Squares counts each over's chip return; Trader counts full stake×odds return on a win.
        if (bullionPoolShare != null) buckets[play.game].won += bullionPoolShare;
        else if (sixesScore != null) buckets.sixes.won += sixesScore;
        else if (play.game === "squares") buckets.squares.won += playReturn(play);
        else if (play.game === "trader") buckets.trader.won += (0, _leaguePlays.leagueTraderWonPoints)(play);
        else if (play.outcome === "win" || play.delta != null && play.delta > 0) buckets[play.game].won += playReturn(play);
    }
    for (const row of league.settlements){
        if (row.userId !== userId || !gameSet.has(row.game)) continue;
        // Prefer settled play rows when present for this user+game; settlements cover seed gaps.
        const hasSettledPlay = league.plays.some((p)=>p.userId === userId && p.game === row.game && p.status === "settled");
        if (hasSettledPlay) continue;
        buckets[row.game].won += settlementReturn(row);
    }
    const member = league.members.find((m)=>m.userId === userId);
    if (member) for (const game of games){
        // Native-score games and Trader (stake×odds return) must not be clobbered by byGame P/L,
        // which is net coins (wins minus losses) rather than pts won.
        if ((game === "bullion" || game === "sixes" || game === "trader" || game === "squares") && playedGames.has(game)) continue;
        const stats = member.byGame[game];
        if (!stats || stats.pl <= 0) continue;
        // Seeded boards often have byGame P/L without a full settled-play history.
        buckets[game].won = Math.max(buckets[game].won, Math.round(stats.pl));
    }
    const slices = games.map((game)=>{
        const slice = {
            game,
            won: Math.max(0, Math.round(buckets[game].won)),
            pot: Math.max(0, Math.round(buckets[game].pot)),
            color: (0, _constants.LEAGUE_GAME_BAR_COLORS)[game]
        };
        if (game === "bullion" && openBullionRow) {
            const slip = Math.max(0, Math.round(openBullionRow.slip));
            slice.livePts = slip;
            slice.ifNowPts = openBullionRow.ifNow;
            slice.won += slip;
        }
        return slice;
    });
    const wonPoints = slices.reduce((sum, s)=>sum + s.won, 0);
    const remainingPot = slices.reduce((sum, s)=>sum + s.pot, 0);
    return {
        games: slices,
        wonPoints,
        remainingPot,
        potPoints: wonPoints + remainingPot,
        ifNowPoints: null
    };
}
function leagueLeaderboardBarScaleMax(statsList) {
    let max = 1;
    for (const stats of statsList)max = Math.max(max, stats.wonPoints);
    return max;
}
function leagueLeaderboardBarStatsByUserId(league, rows) {
    const games = (0, _leagueFormat.leagueIncludedGames)(league);
    const map = new Map();
    for (const row of rows)map.set(row.userId, leagueLeaderboardBarStatsForMember(league, row.userId, games));
    return map;
}
function leagueLeaderboardBarStatsForGame(stats, game) {
    const slice = stats.games.find((g)=>g.game === game) ?? {
        game,
        won: 0,
        pot: 0,
        color: (0, _constants.LEAGUE_GAME_BAR_COLORS)[game]
    };
    if (game === "bullion" && slice.livePts != null) {
        const live = Math.max(0, Math.round(slice.livePts));
        return {
            games: [
                {
                    ...slice,
                    won: live,
                    pot: 0
                }
            ],
            wonPoints: live,
            remainingPot: 0,
            potPoints: live,
            ifNowPoints: slice.ifNowPts ?? null
        };
    }
    return {
        games: [
            slice
        ],
        wonPoints: slice.won,
        remainingPot: slice.pot,
        potPoints: slice.won + slice.pot,
        ifNowPoints: null
    };
}
function leagueLeaderboardBarHasSignal(stats) {
    return stats.wonPoints > 0;
}
function leagueLiveOverallStanding(league, userId) {
    if (!league.members.some((m)=>m.userId === userId)) return null;
    const scored = league.members.map((member)=>{
        const stats = leagueLeaderboardBarStatsForMember(league, member.userId);
        return {
            userId: member.userId,
            playerName: member.playerName,
            won: stats.wonPoints,
            pot: stats.potPoints
        };
    });
    scored.sort((a, b)=>{
        if (b.won !== a.won) return b.won - a.won;
        if (b.pot !== a.pot) return b.pot - a.pot;
        return a.playerName.localeCompare(b.playerName);
    });
    let lastWon = null;
    let lastRank = 0;
    for(let index = 0; index < scored.length; index += 1){
        const entry = scored[index];
        let rank;
        if (lastWon != null && entry.won === lastWon) rank = lastRank;
        else {
            rank = index + 1;
            lastRank = rank;
            lastWon = entry.won;
        }
        if (entry.userId === userId) return {
            rank,
            wonPoints: entry.won,
            potPoints: entry.pot
        };
    }
    return null;
}
function leagueLeaderboardBarGames(league) {
    return (0, _leagueFormat.leagueIncludedGames)(league);
}

},{"./leagueBullionProjectedPoints":"5BCMN","./constants":"dZVub","./leagueFormat":"jKCIi","./leaguePlays":"iWKr6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5BCMN":[function(require,module,exports,__globalThis) {
/**
 * Live league-points projection for an open Bullion+ battle.
 *
 * Mirrors `rankAndSplitLeagueBullionPoints` in `backend/db/leagues/leagueBullionSettleMath.js`:
 * rank by slip score (then potential, then earliest entry). Everyone keeps their slip score;
 * a place-bonus pool is added as if the battle ended now (1–9 WTA, 10–30 top 3, 31+ top 5
 * from real heads). Extra Rubies grow pool size only.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Payout schedule for the full points pool (no rake). */ parcelHelpers.export(exports, "leagueBullionPointsPrizePlan", ()=>leagueBullionPointsPrizePlan);
parcelHelpers.export(exports, "sortLeagueBullionScored", ()=>sortLeagueBullionScored);
/** Competition rank: same slip score and same potential share a rank (1, 1, 3, …). */ parcelHelpers.export(exports, "rankLeagueBullionScored", ()=>rankLeagueBullionScored);
/**
 * Split the place-bonus pool by competition rank.
 * Plan uses real player count; pool size uses `poolWeight`.
 * @returns play id → place-bonus share
 */ parcelHelpers.export(exports, "leagueBullionPointsByPlayId", ()=>leagueBullionPointsByPlayId);
parcelHelpers.export(exports, "leagueBullionStandingsPointsByPlayId", ()=>leagueBullionStandingsPointsByPlayId);
parcelHelpers.export(exports, "rankAndSplitLeagueBullionPoints", ()=>rankAndSplitLeagueBullionPoints);
/** Live slip + optional if-now standings (slip + place) for each open Bullion entrant. */ parcelHelpers.export(exports, "openBullionLiveByUserId", ()=>openBullionLiveByUserId);
parcelHelpers.export(exports, "leagueHasOpenBullionSlipScore", ()=>leagueHasOpenBullionSlipScore);
parcelHelpers.export(exports, "leagueHasOpenBullionBattle", ()=>leagueHasOpenBullionBattle);
/**
 * League points each open Bullion entrant would receive if the battle finished on the current order
 * (slip + place bonus). Keyed by user id. Settled plays are not included.
 *
 * Empty until at least one entrant has a slip score — prematch / all-zero boards
 * must not credit the place bonus as "won" from entry order alone.
 */ parcelHelpers.export(exports, "openBullionFinishPayoutByUserId", ()=>openBullionFinishPayoutByUserId);
var _leagueGameSurfaces = require("./leagueGameSurfaces");
function leagueBullionPointsPrizePlan(playerCount) {
    const n = Math.floor(Number(playerCount));
    if (!Number.isFinite(n) || n <= 9) return {
        mode: "winner_take_all"
    };
    if (n <= 30) return {
        mode: "tiered",
        shares: [
            0.5,
            0.3,
            0.2
        ]
    };
    return {
        mode: "tiered",
        shares: [
            0.38,
            0.28,
            0.18,
            0.1,
            0.06
        ]
    };
}
function sortLeagueBullionScored(scored) {
    return [
        ...scored
    ].sort((a, b)=>{
        if (b.score !== a.score) return b.score - a.score;
        if (b.potentialPointsRounded !== a.potentialPointsRounded) return b.potentialPointsRounded - a.potentialPointsRounded;
        return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    });
}
function rankLeagueBullionScored(scored) {
    const sorted = sortLeagueBullionScored(scored);
    let lastPts = null;
    let lastPot = null;
    let displayRank = 0;
    let position = 0;
    return sorted.map((row)=>{
        position += 1;
        if (lastPts === null || row.score !== lastPts || row.potentialPointsRounded !== lastPot) {
            displayRank = position;
            lastPts = row.score;
            lastPot = row.potentialPointsRounded;
        }
        return {
            ...row,
            displayRank
        };
    });
}
function largestRemainderMap(idToFloatAmount, targetTotal) {
    const entries = [
        ...idToFloatAmount.entries()
    ].map(([id, v])=>{
        const fv = Number(v);
        const safe = Number.isFinite(fv) && fv > 0 ? fv : 0;
        const floor = Math.floor(safe);
        return {
            id,
            floor,
            rem: safe - floor
        };
    }).filter((e)=>e.floor > 0 || e.rem > 0);
    const target = Math.floor(Number(targetTotal));
    if (entries.length === 0) return new Map();
    let sumFloor = entries.reduce((s, e)=>s + e.floor, 0);
    let deficit = target - sumFloor;
    if (deficit < 0) {
        entries.sort((a, b)=>a.rem - b.rem || a.id - b.id);
        let over = -deficit;
        for (const e of entries){
            if (over <= 0) break;
            if (e.floor > 0) {
                e.floor -= 1;
                over -= 1;
            }
        }
        sumFloor = entries.reduce((s, e)=>s + e.floor, 0);
        deficit = target - sumFloor;
    }
    entries.sort((a, b)=>b.rem - a.rem || a.id - b.id);
    const out = new Map();
    entries.forEach((e, i)=>{
        out.set(e.id, e.floor + (i < deficit ? 1 : 0));
    });
    return out;
}
function normalizePointsSplitArgs(rankedSorted, playerCountOrOpts = rankedSorted.length) {
    const n = rankedSorted.length;
    if (playerCountOrOpts != null && typeof playerCountOrOpts === "object") {
        const playerCountRaw = playerCountOrOpts.playerCount;
        const playerCount = Math.floor(Number(playerCountRaw != null ? playerCountRaw : n));
        const extra = Math.max(0, Math.floor(Number(playerCountOrOpts.extraRubies)) || 0);
        const poolWeightRaw = playerCountOrOpts.poolWeight;
        const poolWeight = Math.floor(Number(poolWeightRaw != null ? poolWeightRaw : (0, _leagueGameSurfaces.leagueBullionPoolWeight)(playerCount, extra)));
        return {
            playerCount: Number.isFinite(playerCount) ? playerCount : n,
            poolWeight: Number.isFinite(poolWeight) ? poolWeight : n
        };
    }
    const playerCount = Math.floor(Number(playerCountOrOpts));
    const safe = Number.isFinite(playerCount) ? playerCount : n;
    return {
        playerCount: safe,
        poolWeight: safe
    };
}
function leagueBullionPointsByPlayId(rankedSorted, playerCountOrOpts = rankedSorted.length) {
    const { playerCount, poolWeight } = normalizePointsSplitArgs(rankedSorted, playerCountOrOpts);
    const prizePool = (0, _leagueGameSurfaces.leagueBullionPointsPoolSize)(poolWeight);
    const n = rankedSorted.length;
    const zeroAll = ()=>new Map(rankedSorted.map((r)=>[
                r.id,
                0
            ]));
    if (n === 0 || prizePool <= 0) return zeroAll();
    const plan = leagueBullionPointsPrizePlan(playerCount);
    const floatAmounts = new Map();
    if (plan.mode === "winner_take_all") {
        const top = rankedSorted[0];
        const maxScore = top != null ? Number(top.score) : 0;
        const topPot = top != null ? Number(top.potentialPointsRounded) : 0;
        const winners = rankedSorted.filter((p)=>Number(p.score) === maxScore && Number(p.potentialPointsRounded) === topPot);
        const nw = winners.length || 1;
        const each = prizePool / nw;
        for (const w of winners)floatAmounts.set(w.id, each);
        const ints = largestRemainderMap(floatAmounts, prizePool);
        const out = zeroAll();
        for (const [id, coins] of ints)out.set(id, coins);
        return out;
    }
    const rawShares = plan.shares;
    const sumShares = rawShares.reduce((a, b)=>a + b, 0);
    const shares = sumShares > 0 ? rawShares.map((s)=>s / sumShares) : rawShares;
    const k = shares.length;
    const topK = rankedSorted.slice(0, Math.min(k, n));
    const rankToPositions = {};
    topK.forEach((row, idx)=>{
        const pos = idx + 1;
        const r = row.displayRank;
        if (!rankToPositions[r]) rankToPositions[r] = [];
        rankToPositions[r].push(pos);
    });
    const rankToCombined = {};
    const rankToCount = {};
    for (const rStr of Object.keys(rankToPositions)){
        const r = Number(rStr);
        const positions = rankToPositions[r];
        rankToCombined[r] = positions.reduce((sum, p)=>sum + (shares[p - 1] || 0), 0);
        rankToCount[r] = positions.length;
    }
    const topKIds = new Set(topK.map((row)=>row.id));
    for (const p of rankedSorted){
        if (!topKIds.has(p.id)) continue;
        const combined = rankToCombined[p.displayRank];
        const count = rankToCount[p.displayRank] || 1;
        if (combined == null) continue;
        floatAmounts.set(p.id, prizePool * combined / count);
    }
    const ints = largestRemainderMap(floatAmounts, prizePool);
    const out = zeroAll();
    for (const [id, coins] of ints)out.set(id, coins);
    return out;
}
function leagueBullionStandingsPointsByPlayId(rankedSorted, placeByPlayId) {
    const out = new Map();
    for (const r of rankedSorted){
        const slip = Math.max(0, Math.round(Number(r.score) || 0));
        const place = Math.max(0, Math.round(Number(placeByPlayId.get(r.id)) || 0));
        out.set(r.id, slip + place);
    }
    return out;
}
function rankAndSplitLeagueBullionPoints(scored, opts = {}) {
    const ranked = rankLeagueBullionScored(scored);
    const { playerCount, poolWeight } = normalizePointsSplitArgs(ranked, {
        playerCount: opts.playerCount ?? ranked.length,
        poolWeight: opts.poolWeight,
        extraRubies: opts.extraRubies
    });
    const poolSize = (0, _leagueGameSurfaces.leagueBullionPointsPoolSize)(poolWeight);
    const placeByPlayId = leagueBullionPointsByPlayId(ranked, {
        playerCount,
        poolWeight
    });
    const standingsByPlayId = leagueBullionStandingsPointsByPlayId(ranked, placeByPlayId);
    return {
        ranked,
        pointsByPlayId: placeByPlayId,
        placeByPlayId,
        standingsByPlayId,
        poolSize,
        poolWeight
    };
}
function openBullionSlip(play) {
    const settlement = play.marketDetails?.settlement;
    const slipRaw = settlement?.slipScore != null && Number.isFinite(Number(settlement.slipScore)) ? Number(settlement.slipScore) : Number(settlement?.points);
    const potentialRaw = Number(settlement?.potentialPoints);
    return {
        score: Number.isFinite(slipRaw) ? Math.max(0, Math.round(slipRaw)) : 0,
        potential: Number.isFinite(potentialRaw) ? Math.max(0, Math.round(potentialRaw)) : 0
    };
}
function openBullionLiveByUserId(league) {
    const open = (league.plays || []).filter((play)=>play.game === "bullion" && play.status === "open");
    const out = new Map();
    if (open.length === 0) return out;
    const scored = open.map((play, index)=>{
        const slip = openBullionSlip(play);
        return {
            id: index,
            userId: play.userId,
            score: slip.score,
            potentialPointsRounded: slip.potential,
            createdAt: play.placedAt
        };
    });
    const extraRubies = league.members && league.entryFeeRubies != null ? (0, _leagueGameSurfaces.leagueExtraRebuyRubies)({
        prizePotCoins: league.prizePotCoins,
        entryFeeRubies: league.entryFeeRubies,
        members: league.members
    }) : 0;
    const projecting = scored.some((row)=>row.score > 0);
    const standingsByPlayId = projecting ? rankAndSplitLeagueBullionPoints(scored, {
        extraRubies
    }).standingsByPlayId : null;
    scored.forEach((play)=>{
        const prev = out.get(play.userId);
        const slip = play.score + (prev?.slip ?? 0);
        const share = standingsByPlayId ? Math.max(0, Math.round(Number(standingsByPlayId.get(play.id)) || 0)) : null;
        const ifNow = share == null ? null : share + (prev?.ifNow ?? 0);
        out.set(play.userId, {
            slip,
            ifNow
        });
    });
    return out;
}
function leagueHasOpenBullionSlipScore(league) {
    for (const row of openBullionLiveByUserId(league).values()){
        if (row.slip > 0) return true;
    }
    return false;
}
function leagueHasOpenBullionBattle(league) {
    return (league.plays || []).some((play)=>play.game === "bullion" && play.status === "open");
}
function openBullionFinishPayoutByUserId(league) {
    const out = new Map();
    for (const [userId, row] of openBullionLiveByUserId(league)){
        if (row.ifNow == null) continue;
        out.set(userId, row.ifNow);
    }
    return out;
}

},{"./leagueGameSurfaces":"gIAym","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gIAym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "leagueBullionBattleEntryBlock", ()=>(0, _leagueBullionEntryBlock.leagueBullionBattleEntryBlock));
/** Re-export: free by default (0). See `constants.ts`. */ parcelHelpers.export(exports, "LEAGUE_BULLION_BATTLE_STAKE", ()=>(0, _constants.LEAGUE_BULLION_BATTLE_STAKE));
/** Same order as `LEAGUE_GAME_KEYS` — Squares, Sixes, Bullion, Trader. */ parcelHelpers.export(exports, "leagueLobbyCardOrder", ()=>leagueLobbyCardOrder);
parcelHelpers.export(exports, "LEAGUE_LOBBY_SECTIONS", ()=>LEAGUE_LOBBY_SECTIONS);
/** Included games grouped into lobby sections (empty sections omitted). */ parcelHelpers.export(exports, "leagueLobbyGamesBySection", ()=>leagueLobbyGamesBySection);
/**
 * When each game is playable inside a match league.
 * All four games: prematch + live (same as the real lobbies — Squares Over 1 is open before kickoff).
 */ parcelHelpers.export(exports, "leagueGameIsPlayable", ()=>leagueGameIsPlayable);
/**
 * Finished leagues stay viewable: open Sixes / Bullion / Trader / Squares read-only
 * (boards, leaderboards, settled picks). Backend still rejects new stakes.
 */ parcelHelpers.export(exports, "leagueGameIsViewable", ()=>leagueGameIsViewable);
/** Players who have opened or settled a Bullion play in this league. */ parcelHelpers.export(exports, "leagueBullionEnteredUserIds", ()=>leagueBullionEnteredUserIds);
parcelHelpers.export(exports, "leagueBullionEnteredCount", ()=>leagueBullionEnteredCount);
parcelHelpers.export(exports, "LEAGUE_BULLION_POINTS_PER_NINE", ()=>LEAGUE_BULLION_POINTS_PER_NINE);
/**
 * League Bullion+ place-bonus pool: ceil(weight / 9) * 1500.
 * Weight is real players, or players + extra Rubies. One to nine share a 1,500 band.
 */ parcelHelpers.export(exports, "leagueBullionPointsPoolSize", ()=>leagueBullionPointsPoolSize);
/** Extra Rubies that grew the coin pot after entry (seat top-ups + Sixes player-switch). */ parcelHelpers.export(exports, "leagueExtraRebuyRubies", ()=>leagueExtraRebuyRubies);
parcelHelpers.export(exports, "leagueBullionPoolWeight", ()=>leagueBullionPoolWeight);
/**
 * Max place-bonus one entrant can win (1st-place share of the bonus pool).
 * Plan uses real player count; pool size uses `poolWeight`.
 */ parcelHelpers.export(exports, "leagueBullionPointsMaxShare", ()=>leagueBullionPointsMaxShare);
/** Roster rows for people in the shared battle — viewer first when they have entered. */ parcelHelpers.export(exports, "leagueBullionEnteredPeople", ()=>leagueBullionEnteredPeople);
/** True when this user has already entered the league’s shared Bullion battle. */ parcelHelpers.export(exports, "leagueViewerInBullionBattle", ()=>leagueViewerInBullionBattle);
parcelHelpers.export(exports, "leagueBullionBattleName", ()=>leagueBullionBattleName);
/** Viewer's Trader pts won in this league — full stake×odds return; losses count 0. */ parcelHelpers.export(exports, "leagueViewerTraderPl", ()=>leagueViewerTraderPl);
/**
 * Viewer's Super Squares points — chip return per over (same as leaderboard / Activity),
 * not net P/L (`SUM(delta)`). Losing overs that still scored chips count those chips; total
 * losses do not drag the sum negative.
 */ parcelHelpers.export(exports, "leagueViewerSquaresPoints", ()=>leagueViewerSquaresPoints);
/** Viewer's Trader plays in this league (open/ACTIVE first, then newest first). */ parcelHelpers.export(exports, "leagueViewerTraderPlays", ()=>leagueViewerTraderPlays);
parcelHelpers.export(exports, "leagueViewerPlayPanelStats", ()=>leagueViewerPlayPanelStats);
/** Seeded match-winner odds when the live feed isn't attached yet (prototype / prematch). */ parcelHelpers.export(exports, "leagueTraderDemoWinnerOdds", ()=>leagueTraderDemoWinnerOdds);
var _constants = require("./constants");
var _leaguePlays = require("./leaguePlays");
var _leagueBullionEntryBlock = require("./leagueBullionEntryBlock");
function leagueLobbyCardOrder(games) {
    const set = new Set(games);
    const ordered = (0, _constants.LEAGUE_GAME_KEYS).filter((game)=>set.has(game));
    const rest = games.filter((game)=>!(0, _constants.LEAGUE_GAME_KEYS).includes(game));
    return [
        ...ordered,
        ...rest
    ];
}
const LEAGUE_LOBBY_SECTIONS = (0, _constants.LEAGUE_GAME_KEYS).map((game)=>({
        id: game,
        label: (0, _constants.LEAGUE_GAME_META)[game].label,
        games: [
            game
        ]
    }));
function leagueLobbyGamesBySection(games) {
    const ordered = leagueLobbyCardOrder(games);
    const set = new Set(ordered);
    return LEAGUE_LOBBY_SECTIONS.map((section)=>({
            section,
            games: section.games.filter((game)=>set.has(game))
        })).filter((entry)=>entry.games.length > 0);
}
function leagueGameIsPlayable(status, _game) {
    if (status === "ended") return false;
    return status === "upcoming" || status === "live";
}
function leagueGameIsViewable(status, _game) {
    if (status === "ended") return true;
    return leagueGameIsPlayable(status, _game);
}
function leagueBullionEnteredUserIds(league) {
    const ids = new Set(league.bullionBattle?.enteredUserIds ?? []);
    league.members.forEach((member)=>{
        if ((member.byGame.bullion?.played ?? 0) > 0) ids.add(member.userId);
    });
    league.plays.forEach((play)=>{
        if (play.game === "bullion") ids.add(play.userId);
    });
    return [
        ...ids
    ];
}
function leagueBullionEnteredCount(league) {
    return leagueBullionEnteredUserIds(league).length;
}
const LEAGUE_BULLION_POINTS_PER_NINE = 1500;
function leagueBullionPointsPoolSize(playerCount) {
    const n = Math.floor(Number(playerCount));
    if (!Number.isFinite(n) || n <= 0) return 0;
    return Math.ceil(n / 9) * LEAGUE_BULLION_POINTS_PER_NINE;
}
function leagueExtraRebuyRubies(league) {
    const seats = league.members.length;
    const stored = league.prizePotCoins;
    const pot = stored != null && Number.isFinite(Number(stored)) ? Math.max(0, Math.round(Number(stored))) : Math.max(0, Math.round(league.entryFeeRubies)) * seats * (0, _constants.PRIZE_COINS_PER_RUBY);
    const unit = Math.max(1, (0, _constants.PRIZE_COINS_PER_RUBY));
    const potUnits = Math.floor(pot / unit);
    const entryUnits = Math.max(0, Math.round(league.entryFeeRubies)) * seats;
    return Math.max(0, potUnits - entryUnits);
}
function leagueBullionPoolWeight(playerCount, extraRubies = 0) {
    const p = Math.max(0, Math.floor(Number(playerCount)) || 0);
    const e = Math.max(0, Math.floor(Number(extraRubies)) || 0);
    return p + e;
}
function leagueBullionPointsMaxShare(playerCount, poolWeight = playerCount) {
    const pool = leagueBullionPointsPoolSize(poolWeight);
    if (pool <= 0) return 0;
    const n = Math.floor(Number(playerCount));
    if (!Number.isFinite(n) || n <= 9) return pool;
    if (n <= 30) return Math.round(pool * 0.5);
    return Math.round(pool * 0.38);
}
function leagueBullionEnteredPeople(league, viewerUserId) {
    const entered = new Set(leagueBullionEnteredUserIds(league));
    const members = league.members.filter((member)=>entered.has(member.userId));
    if (viewerUserId == null) return members;
    const viewer = members.find((member)=>member.userId === viewerUserId);
    if (!viewer) return members;
    return [
        viewer,
        ...members.filter((member)=>member.userId !== viewerUserId)
    ];
}
function leagueViewerInBullionBattle(league, userId) {
    if (league.bullionBattle?.viewerEntered) return true;
    if (league.bullionBattle?.enteredUserIds?.includes(userId)) return true;
    return league.plays.some((play)=>play.game === "bullion" && play.userId === userId);
}
function leagueBullionBattleName(league) {
    const base = league.name.trim() || "League";
    const short = base.length > 28 ? `${base.slice(0, 26)}\u{2026}` : base;
    return `${short} Battle`;
}
function leagueViewerTraderPl(league) {
    const me = league.members.find((member)=>member.isViewer);
    if (!me) return 0;
    const settled = league.plays.filter((play)=>play.game === "trader" && play.userId === me.userId && play.status === "settled");
    if (settled.length > 0) return settled.reduce((sum, play)=>sum + (0, _leaguePlays.leagueTraderWonPoints)(play), 0);
    return Math.max(0, Math.round(Number(me.byGame.trader?.pl) || 0));
}
function leagueViewerSquaresPoints(league, viewerUserId) {
    const uid = viewerUserId ?? league.members.find((member)=>member.isViewer)?.userId;
    if (uid == null) return 0;
    let sum = 0;
    let sawPlay = false;
    for (const play of league.plays || []){
        if (play.game !== "squares" || play.userId !== uid) continue;
        sawPlay = true;
        if (play.status === "open") {
            const live = (0, _leaguePlays.leagueSquaresOpenLiveReturn)(play);
            if (live != null) sum += live;
        } else sum += (0, _leaguePlays.leaguePlaySettledPoints)(play);
    }
    if (sawPlay) return Math.max(0, Math.round(sum));
    // Seed / settlement-only fallback when plays aren't hydrated.
    for (const entry of league.settlements || []){
        if (entry.game !== "squares" || entry.userId !== uid) continue;
        sum += (0, _leaguePlays.leaguePlaySettledPoints)({
            game: "squares",
            stake: entry.stake,
            delta: entry.delta,
            status: "settled",
            outcome: entry.outcome,
            marketDetails: entry.marketDetails
        });
    }
    if (sum > 0) return Math.max(0, Math.round(sum));
    const me = league.members.find((member)=>member.userId === uid);
    return Math.max(0, Math.round(Number(me?.byGame.squares?.pl) || 0));
}
function leagueViewerTraderPlays(league) {
    const me = league.members.find((member)=>member.isViewer);
    if (!me) return [];
    return league.plays.filter((play)=>play.game === "trader" && play.userId === me.userId).sort((a, b)=>{
        const aOpen = a.status === "open" ? 1 : 0;
        const bOpen = b.status === "open" ? 1 : 0;
        if (aOpen !== bOpen) return bOpen - aOpen;
        return new Date(b.placedAt).getTime() - new Date(a.placedAt).getTime();
    });
}
/** Live (open) or settled points for one Sixes / Bullion play; null when the play carries no score yet. */ function leaguePointsModelPlayPoints(play) {
    if (play.status === "open") return (0, _leaguePlays.leaguePlayOpenLivePoints)(play);
    return (0, _leaguePlays.leaguePlaySettledPoints)(play);
}
/**
 * Viewer's Sixes / Bullion points from their plays — live card score / slip score while open,
 * final score after settle. Null when no play has a score (caller falls back to `byGame`).
 */ function leagueViewerPointsModelPoints(league, game, userId) {
    if (userId == null) return null;
    let sum = 0;
    let scored = false;
    for (const play of league.plays){
        if (play.game !== game || play.userId !== userId) continue;
        const points = leaguePointsModelPlayPoints(play);
        if (points == null) continue;
        sum += points;
        scored = true;
    }
    if (scored) return sum;
    if (game === "bullion") {
        const settlement = league.bullionBattle?.viewerSlip?.settlement;
        const slip = Number(settlement?.slipScore ?? settlement?.points);
        if (Number.isFinite(slip)) return Math.max(0, Math.round(slip));
    }
    return null;
}
/** Live Sixes footer counts from linked cards (`wins_count` / `slides_count` / `natural_count`). */ function leagueViewerSixesCardCounts(league, userId) {
    if (userId == null) return null;
    let wins = 0;
    let slides = 0;
    let natural = 0;
    let seen = false;
    for (const play of league.plays){
        if (play.game !== "sixes" || play.userId !== userId) continue;
        const md = play.marketDetails;
        const cardWins = Number(md?.winsCount);
        const cardSlides = Number(md?.slidesCount);
        const cardNatural = Number(md?.naturalCount);
        if (!Number.isFinite(cardWins) && !Number.isFinite(cardSlides) && !Number.isFinite(cardNatural)) continue;
        seen = true;
        if (Number.isFinite(cardWins)) wins += Math.max(0, Math.round(cardWins));
        if (Number.isFinite(cardSlides)) slides += Math.max(0, Math.round(cardSlides));
        if (Number.isFinite(cardNatural)) natural += Math.max(0, Math.round(cardNatural));
    }
    return seen ? {
        wins,
        slides,
        natural
    } : null;
}
/** Viewer's winning Bullion picks on the graded battle slip. Null when there is no slip. */ function leagueViewerBullionWins(league) {
    const picks = league.bullionBattle?.viewerSlip?.picks;
    if (!picks || typeof picks !== "object" || Object.keys(picks).length === 0) return null;
    let wins = 0;
    for (const pick of Object.values(picks)){
        if (!pick || typeof pick !== "object") continue;
        const outcome = String(pick.settlementOutcome ?? "").trim().toLowerCase();
        if (outcome === "win") wins += 1;
    }
    return wins;
}
function bullionSlipScoreFromSettlement(settlement) {
    if (!settlement) return {
        points: 0,
        potentialPoints: 0,
        rank: null
    };
    const slip = settlement.slipScore != null && Number.isFinite(Number(settlement.slipScore)) ? Math.round(Number(settlement.slipScore)) : Math.round(Number(settlement.points) || 0);
    return {
        points: Math.max(0, slip),
        potentialPoints: Math.max(0, Math.round(Number(settlement.potentialPoints) || 0)),
        rank: settlement.rank != null && Number.isFinite(Number(settlement.rank)) && Number(settlement.rank) > 0 ? Number(settlement.rank) : null
    };
}
/** Merge entrant / play / viewer-slip scores so RANK tracks the same live points as the battle board. */ function bullionBattleScoreForUser(league, userId, viewerUserId) {
    const battle = league.bullionBattle;
    const entrant = (battle?.entrants ?? []).find((e)=>Number(e.userId) === Number(userId));
    const fromEntrant = entrant ? {
        points: entrant.slipScore != null && Number.isFinite(Number(entrant.slipScore)) ? Math.max(0, Math.round(Number(entrant.slipScore))) : Math.max(0, Math.round(Number(entrant.points) || 0)),
        potentialPoints: Math.max(0, Math.round(Number(entrant.potentialPoints) || 0)),
        rank: entrant.rank != null && Number.isFinite(Number(entrant.rank)) && Number(entrant.rank) > 0 ? Number(entrant.rank) : null
    } : null;
    const play = league.plays.find((p)=>p.game === "bullion" && Number(p.userId) === Number(userId));
    const fromPlay = bullionSlipScoreFromSettlement(play?.marketDetails?.settlement);
    const fromViewerSlip = Number(userId) === Number(viewerUserId) ? bullionSlipScoreFromSettlement(battle?.viewerSlip?.settlement) : null;
    const points = Math.max(fromEntrant?.points ?? 0, fromPlay.points, fromViewerSlip?.points ?? 0);
    const potentialPoints = Math.max(fromEntrant?.potentialPoints ?? 0, fromPlay.potentialPoints, fromViewerSlip?.potentialPoints ?? 0);
    const rank = fromEntrant?.rank ?? fromPlay.rank ?? fromViewerSlip?.rank ?? null;
    return {
        userId,
        points,
        potentialPoints,
        rank
    };
}
/**
 * Viewer's position on the in-battle Bullion leaderboard.
 * Null until any entrant has slip points (same moment the battle board starts showing POS.).
 */ function leagueViewerBullionBattleRank(league, userId) {
    if (userId == null) return null;
    const battle = league.bullionBattle;
    if (!battle) return null;
    const idSet = new Set();
    for (const e of battle.entrants ?? [])idSet.add(Number(e.userId));
    for (const id of battle.enteredUserIds ?? [])idSet.add(Number(id));
    for (const play of league.plays)if (play.game === "bullion") idSet.add(Number(play.userId));
    if (idSet.size === 0 || !idSet.has(Number(userId))) return null;
    const rows = [
        ...idSet
    ].map((uid)=>bullionBattleScoreForUser(league, uid, userId));
    // Show RANK only once someone on the battle board has points.
    if (!rows.some((row)=>row.points > 0)) return null;
    const mine = rows.find((row)=>Number(row.userId) === Number(userId));
    if (mine?.rank != null && mine.rank > 0) return Math.round(mine.rank);
    const sorted = [
        ...rows
    ].sort((a, b)=>{
        if (a.rank != null && a.rank > 0 && b.rank != null && b.rank > 0 && a.rank !== b.rank) return a.rank - b.rank;
        if (b.points !== a.points) return b.points - a.points;
        if (b.potentialPoints !== a.potentialPoints) return b.potentialPoints - a.potentialPoints;
        return a.userId - b.userId;
    });
    // Competition ranks (1, 1, 3…) when slip score + potential tie.
    let lastPts = null;
    let lastPot = null;
    let displayRank = 0;
    for(let i = 0; i < sorted.length; i += 1){
        const row = sorted[i];
        if (lastPts === null || row.points !== lastPts || row.potentialPoints !== lastPot) {
            displayRank = i + 1;
            lastPts = row.points;
            lastPot = row.potentialPoints;
        }
        if (Number(row.userId) === Number(userId)) return displayRank;
    }
    return null;
}
function leagueViewerPlayPanelStats(league, game) {
    const me = league.members.find((member)=>member.isViewer);
    const stats = me?.byGame[game] ?? {
        pl: 0,
        wins: 0,
        losses: 0,
        played: 0
    };
    const myPlays = league.plays.filter((play)=>play.game === game && (me == null || play.userId === me.userId));
    const sixesCounts = game === "sixes" ? leagueViewerSixesCardCounts(league, me?.userId) : null;
    const liveWins = game === "sixes" ? sixesCounts?.wins ?? null : game === "bullion" ? leagueViewerBullionWins(league) : null;
    const wins = Math.max(0, Math.round(liveWins ?? (Number(stats.wins) || 0)));
    const points = Math.max(0, Math.round(game === "trader" ? leagueViewerTraderPl(league) : game === "squares" ? leagueViewerSquaresPoints(league, me?.userId) : leagueViewerPointsModelPoints(league, game, me?.userId) ?? (Number(stats.pl) || 0)));
    if (game === "trader") return [
        {
            label: "Trades",
            value: myPlays.length || Math.round(Number(stats.played) || 0)
        },
        {
            label: "Wins",
            value: wins
        },
        {
            label: "Points",
            value: points
        }
    ];
    if (game === "squares") return [
        {
            label: "Overs",
            value: Math.round(Number(stats.played) || 0) || myPlays.length
        },
        {
            label: "Wins",
            value: wins
        },
        {
            label: "Points",
            value: points
        }
    ];
    if (game === "sixes") {
        const slides = Math.max(0, Math.round(sixesCounts?.slides ?? 0));
        const natural = Math.max(0, Math.round(sixesCounts?.natural ?? 0));
        return [
            {
                label: "Correct",
                value: wins
            },
            {
                label: "Slides",
                value: slides
            },
            {
                label: "Natural",
                value: natural
            },
            {
                label: "Points",
                value: points
            }
        ];
    }
    const pickCount = (()=>{
        const battle = league.bullionBattle;
        const slipPicks = battle?.viewerSlip?.picks;
        if (slipPicks && typeof slipPicks === "object" && Object.keys(slipPicks).length > 0) return Object.keys(slipPicks).length;
        const saved = me != null ? battle?.viewerPicksByUserId?.[String(me.userId)] : null;
        const selections = saved?.selections;
        if (selections && typeof selections === "object" && Object.keys(selections).length > 0) return Object.keys(selections).length;
        return Math.round(Number(stats.played) || 0) || myPlays.length;
    })();
    const rank = leagueViewerBullionBattleRank(league, me?.userId);
    return [
        {
            label: "Picks",
            value: pickCount
        },
        {
            label: "Wins",
            value: wins
        },
        {
            label: "Points",
            value: points
        },
        {
            label: "Rank",
            value: rank != null && rank > 0 ? rank : "\u2014"
        }
    ];
}
function leagueTraderDemoWinnerOdds(league) {
    let seed = 2166136261;
    const key = `${league.id}:trader-mw:${league.fixture?.id ?? ""}`;
    for(let i = 0; i < key.length; i += 1){
        seed ^= key.charCodeAt(i);
        seed = Math.imul(seed, 16777619);
    }
    seed >>>= 0;
    const next = ()=>{
        seed = Math.imul(seed, 1664525) + 1013904223 >>> 0;
        return seed;
    };
    const home = Math.round((1.55 + next() % 90 / 100) * 100) / 100;
    const away = Math.round((1.55 + next() % 90 / 100) * 100) / 100;
    return {
        home,
        away
    };
}

},{"./constants":"dZVub","./leaguePlays":"iWKr6","./leagueBullionEntryBlock":"aNN1M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iWKr6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Stand-in market list per game. The real version would read live markets from
 * Trader, the Bullion board, Sixes cards and the Squares over grid.
 */ parcelHelpers.export(exports, "playOptionsForGame", ()=>playOptionsForGame);
parcelHelpers.export(exports, "allPlayOptions", ()=>allPlayOptions);
parcelHelpers.export(exports, "potentialReturn", ()=>potentialReturn);
/** Profit if an open Trader play wins (potential return − stake), floored at 0. */ parcelHelpers.export(exports, "potentialProfit", ()=>potentialProfit);
/**
 * Sixes / Bullion are points-model games (not stake × multiplier for league WON).
 * Their `multiplier` on the play row is a placeholder (usually 1) and must not drive UI returns.
 * Bullion league points are the pick score plus a place-bonus share; Sixes uses card score.
 */ parcelHelpers.export(exports, "isLeaguePointsModelGame", ()=>isLeaguePointsModelGame);
/**
 * Chip return scored on a settled Squares over — the stored Super Squares total
 * (`returnCoins`, else stake + delta). Same source of truth as admin / Trader / Bullion / Sixes.
 * Live ball grading is only for open overs (`leagueSquaresOpenLiveReturn`).
 */ parcelHelpers.export(exports, "leaguePlayChipReturn", ()=>leaguePlayChipReturn);
/**
 * Live Super Squares chip return for an open play (selections + ball results, or persisted breakdown).
 * Null when there is nothing to score yet.
 */ parcelHelpers.export(exports, "leagueSquaresOpenLiveReturn", ()=>leagueSquaresOpenLiveReturn);
/**
 * Trader league points: full return (stake × odds), never negative.
 * A loss scores 0; a win scores stake + profit (not profit-only / free-bet style).
 * Void releases the stake hold only — never awards PTS (delta is 0, which would otherwise
 * look like stake + 0 = stake).
 */ parcelHelpers.export(exports, "leagueTraderWonPoints", ()=>leagueTraderWonPoints);
/**
 * PTS shown on My Trades cards — open = potential return if it wins; settled = won return.
 * Must match leaderboard Trader scoring (stake × odds, not profit-only).
 */ parcelHelpers.export(exports, "leagueTraderPlayPoints", ()=>leagueTraderPlayPoints);
/**
 * Bullion / Sixes settled Activity points — never coin P/L.
 * Bullion uses slip + place bonus stored on `settlement.points` after battle settle.
 */ parcelHelpers.export(exports, "leaguePointsModelSettledPoints", ()=>leaguePointsModelSettledPoints);
/**
 * Points shown on settled rows. Squares uses chip return (counts toward league WON),
 * not net P/L — you can score on correct balls even when the over loses overall.
 * Trader uses full return (0 on a loss). Bullion uses slip + place bonus; Sixes uses card score.
 */ parcelHelpers.export(exports, "leaguePlaySettledPoints", ()=>leaguePlaySettledPoints);
parcelHelpers.export(exports, "formatLeaguePlaySettledPoints", ()=>formatLeaguePlaySettledPoints);
parcelHelpers.export(exports, "leaguePlaySettledPointsClass", ()=>leaguePlaySettledPointsClass);
/** Short status under settled Squares rows — avoid "Lost" when the over still scored league points. */ parcelHelpers.export(exports, "leagueSquaresSettledStatusLabel", ()=>leagueSquaresSettledStatusLabel);
/** Coin-denominated open-play return — zero for points-model games (Bullion / Sixes). */ parcelHelpers.export(exports, "openPlayCoinPotentialReturn", ()=>openPlayCoinPotentialReturn);
/**
 * Live WON points for an open Activity row (replaces stake on Active).
 * - Sixes: running card score
 * - Bullion: progressive slip score (same live basis as the battle board; slip + place after settle)
 * - Squares: Super return from ball results / persisted breakdown (same as leaderboard)
 * - Trader: null until the play settles (shown on Past)
 */ parcelHelpers.export(exports, "leaguePlayOpenLivePoints", ()=>leaguePlayOpenLivePoints);
parcelHelpers.export(exports, "formatLeaguePlayOpenLivePoints", ()=>formatLeaguePlayOpenLivePoints);
/**
 * Subtitle under the open-play stake chip.
 * Bullion ranks live on slip score; table points are that score plus a place-bonus share. Sixes has no fixed return.
 */ parcelHelpers.export(exports, "openPlayReturnLabel", ()=>openPlayReturnLabel);
parcelHelpers.export(exports, "formatMultiplier", ()=>formatMultiplier);
/** Human market title for a Trader play (e.g. "Match Odds", "Line 165.5"). */ parcelHelpers.export(exports, "leaguePlayMarketLabel", ()=>leaguePlayMarketLabel);
/**
 * Coarse market family for public Trader activity.
 * Stake + type only — never the pick, player, team, line, or odds.
 */ parcelHelpers.export(exports, "leagueTraderActivityMarketFamily", ()=>leagueTraderActivityMarketFamily);
/** Over-only Squares activity label — never ball-by-ball picks. */ parcelHelpers.export(exports, "leagueSquaresOverLabel", ()=>leagueSquaresOverLabel);
/** Compact ball-pick list for fallback text, e.g. "B1 4, B2 6". */ parcelHelpers.export(exports, "leagueSquaresBallPicksLabel", ()=>leagueSquaresBallPicksLabel);
/**
 * Prefer a structured pick label when market details are present.
 * Line Over/Under → e.g. "Under 62.5 runs" (line + unit), keeping odds/settlement suffixes.
 */ parcelHelpers.export(exports, "leaguePlayPickLabel", ()=>leaguePlayPickLabel);
/**
 * Activity subtitle lines: optional market header + pick/detail body.
 * Squares always returns the over label only — pick cells render separately.
 */ parcelHelpers.export(exports, "leagueActivityDetailLines", ()=>leagueActivityDetailLines);
parcelHelpers.export(exports, "isOpenPlay", ()=>isOpenPlay);
parcelHelpers.export(exports, "openPlaysFor", ()=>openPlaysFor);
parcelHelpers.export(exports, "openStakeFor", ()=>openStakeFor);
/** Settled balance minus anything already committed to open plays. */ parcelHelpers.export(exports, "availableCoinsFor", ()=>availableCoinsFor);
parcelHelpers.export(exports, "settlesInMs", ()=>settlesInMs);
/** Compact settle countdown for lobby / in-play rows. */ parcelHelpers.export(exports, "openPlayCountdownLabel", ()=>openPlayCountdownLabel);
/**
 * 0–1 fill for the open-play progress bar from placedAt → settlesAt.
 * Returns null when there is no usable ETA (caller should show indeterminate UI).
 */ parcelHelpers.export(exports, "openPlayProgress", ()=>openPlayProgress);
var _constants = require("./constants");
var _leagueFormat = require("./leagueFormat");
var _leagueSuperSquares = require("./leagueSuperSquares");
function teamsFor(league) {
    if (league?.fixture) return [
        league.fixture.homeTeam,
        league.fixture.awayTeam
    ];
    return [
        "India",
        "Australia"
    ];
}
function playOptionsForGame(game, league) {
    const [home, away] = teamsFor(league);
    if (game === "trader") return [
        {
            id: "trader-home",
            game,
            label: `${home} to win`,
            sublabel: "Match odds",
            multiplier: 1.8
        },
        {
            id: "trader-away",
            game,
            label: `${away} to win`,
            sublabel: "Match odds",
            multiplier: 2.15
        },
        {
            id: "trader-runs",
            game,
            label: "Over 165.5 total runs",
            sublabel: "Innings runs",
            multiplier: 1.95
        },
        {
            id: "trader-top-bat",
            game,
            label: `${home} top batter`,
            sublabel: "Player market",
            multiplier: 3.4
        }
    ];
    if (game === "bullion") return [
        {
            id: "bullion-arena",
            game,
            label: "Public arena \xb7 5 picks",
            sublabel: "4 of 5 correct",
            multiplier: 2.4
        },
        {
            id: "bullion-arena-max",
            game,
            label: "Public arena \xb7 5 picks",
            sublabel: "5 of 5 correct",
            multiplier: 4.5
        },
        {
            id: "bullion-battle",
            game,
            label: "Private battle \xb7 5 picks",
            sublabel: "Beat the room",
            multiplier: 3.0
        }
    ];
    if (game === "sixes") return [
        {
            id: "sixes-one",
            game,
            label: "One card",
            sublabel: "Complete a row",
            multiplier: 2.2
        },
        {
            id: "sixes-two",
            game,
            label: "Two cards",
            sublabel: "Complete a row on either",
            multiplier: 2.8
        },
        {
            id: "sixes-full",
            game,
            label: "One card",
            sublabel: "Full house",
            multiplier: 6.0
        }
    ];
    return [
        {
            id: "squares-runs",
            game,
            label: "Next over \xb7 4 or more runs",
            sublabel: "Over grid",
            multiplier: 2.0
        },
        {
            id: "squares-wicket",
            game,
            label: "Next over \xb7 wicket falls",
            sublabel: "Over grid",
            multiplier: 3.5
        },
        {
            id: "squares-dot",
            game,
            label: "Next over \xb7 under 4 runs",
            sublabel: "Over grid",
            multiplier: 1.75
        }
    ];
}
function allPlayOptions(league) {
    const games = league ? (0, _leagueFormat.leagueIncludedGames)(league) : [
        ...(0, _constants.LEAGUE_GAME_KEYS)
    ];
    return games.flatMap((game)=>playOptionsForGame(game, league));
}
function potentialReturn(stake, multiplier) {
    return Math.round(stake * multiplier);
}
function potentialProfit(stake, multiplier) {
    return Math.max(0, potentialReturn(stake, multiplier) - Math.max(0, Math.round(stake)));
}
function isLeaguePointsModelGame(game) {
    return game === "sixes" || game === "bullion";
}
function leaguePlayChipReturn(play) {
    const outcome = play.outcome != null ? String(play.outcome).toLowerCase() : "";
    if (outcome === "void") return 0;
    const md = play.marketDetails;
    const superReturn = md?.superSquares?.returnCoins;
    if (superReturn != null && Number.isFinite(Number(superReturn))) return Math.max(0, Math.round(Number(superReturn)));
    if (play.delta == null || !Number.isFinite(Number(play.delta))) return 0;
    const stake = Math.max(0, Math.round(Number(play.stake) || 0));
    return Math.max(0, stake + Math.round(Number(play.delta)));
}
function leagueSquaresOpenLiveReturn(play) {
    if (play.game !== "squares" || play.status !== "open") return null;
    const md = play.marketDetails;
    if (!md?.selections) return null;
    const candidates = [];
    const balls = md.ballResults;
    if (Array.isArray(balls) && balls.length > 0) candidates.push(Math.max(0, (0, _leagueSuperSquares.computeSuperSquaresBreakdown)(md.selections, balls).returnCoins));
    const fromSuper = md.superSquares?.returnCoins;
    if (fromSuper != null && Number.isFinite(Number(fromSuper))) candidates.push(Math.max(0, Math.round(Number(fromSuper))));
    if (candidates.length === 0) return null;
    return Math.max(...candidates);
}
function leagueTraderWonPoints(play) {
    const outcome = play.outcome != null ? String(play.outcome).toLowerCase() : "";
    if (outcome === "void") return 0;
    const stake = Math.max(0, Math.round(Number(play.stake) || 0));
    const delta = Math.round(Number(play.delta) || 0);
    return Math.max(0, stake + delta);
}
function leagueTraderPlayPoints(play) {
    if (play.status === "open") return potentialReturn(play.stake, play.multiplier);
    return leagueTraderWonPoints(play);
}
function leaguePointsModelSettledPoints(play) {
    if (play.game === "bullion") {
        const points = Number(play.marketDetails?.settlement?.points);
        if (Number.isFinite(points)) return Math.max(0, Math.round(points));
        return 0;
    }
    if (play.game === "sixes") {
        const score = Number(play.marketDetails?.cardScore);
        if (Number.isFinite(score)) return Math.max(0, Math.round(score));
        // Stake 0 ⇒ delta === card return; never surface a red loss.
        return Math.max(0, Math.round(Number(play.delta) || 0));
    }
    return 0;
}
function leaguePlaySettledPoints(play) {
    if (play.game === "squares") return leaguePlayChipReturn(play);
    if (play.game === "trader") return leagueTraderWonPoints(play);
    if (isLeaguePointsModelGame(play.game)) return leaguePointsModelSettledPoints(play);
    return Math.round(Number(play.delta) || 0);
}
function formatLeaguePlaySettledPoints(play) {
    if (play.game === "squares") return (0, _leagueFormat.formatWonPoints)(leaguePlayChipReturn(play));
    if (play.game === "trader") return (0, _leagueFormat.formatWonPoints)(leagueTraderWonPoints(play));
    if (isLeaguePointsModelGame(play.game)) return (0, _leagueFormat.formatWonPoints)(leaguePointsModelSettledPoints(play));
    return (0, _leagueFormat.formatPl)(play.delta ?? 0);
}
function leaguePlaySettledPointsClass(play) {
    if (play.game === "squares") return (0, _leagueFormat.wonPointsTextClass)(leaguePlayChipReturn(play));
    if (play.game === "trader") return (0, _leagueFormat.wonPointsTextClass)(leagueTraderWonPoints(play));
    if (isLeaguePointsModelGame(play.game)) return (0, _leagueFormat.wonPointsTextClass)(leaguePointsModelSettledPoints(play));
    return (0, _leagueFormat.plTextClass)(play.delta ?? 0);
}
function leagueSquaresSettledStatusLabel(play) {
    const scored = leaguePlayChipReturn(play);
    if (scored <= 0) return "Lost";
    return play.outcome === "win" ? "Won" : "Scored";
}
function openPlayCoinPotentialReturn(play) {
    if (isLeaguePointsModelGame(play.game)) return 0;
    return potentialReturn(play.stake, play.multiplier);
}
function leaguePlayOpenLivePoints(play) {
    if (play.status !== "open") return null;
    if (play.game === "sixes") {
        const score = Number(play.marketDetails?.cardScore);
        if (!Number.isFinite(score)) return null;
        return Math.max(0, Math.round(score));
    }
    if (play.game === "bullion") {
        const settlement = play.marketDetails?.settlement;
        if (!settlement) return null;
        const slip = settlement.slipScore != null && Number.isFinite(Number(settlement.slipScore)) ? Number(settlement.slipScore) : Number(settlement.points);
        if (!Number.isFinite(slip)) return null;
        return Math.max(0, Math.round(slip));
    }
    if (play.game === "squares") return leagueSquaresOpenLiveReturn(play);
    return null;
}
function formatLeaguePlayOpenLivePoints(play) {
    const pts = leaguePlayOpenLivePoints(play);
    if (pts == null) return null;
    return (0, _leagueFormat.formatWonPoints)(pts);
}
function openPlayReturnLabel(play) {
    if (play.game === "sixes") return "returns card total";
    if (play.game === "bullion") return "live pick score";
    return `to return ${(0, _leagueFormat.formatCoins)(potentialReturn(play.stake, play.multiplier))}`;
}
function formatMultiplier(multiplier) {
    return `${multiplier.toFixed(2)}\xd7`;
}
function leaguePlayMarketLabel(details) {
    if (!details) return null;
    if (details.marketName?.trim()) return details.marketName.trim();
    if (details.marketClass === "Line" && details.marketLine != null && String(details.marketLine).trim() !== "") {
        const line = Number(details.marketLine);
        return Number.isFinite(line) ? `Line ${line.toFixed(1)}` : `Line ${details.marketLine}`;
    }
    if (details.marketClass === "Win") return "Match Winner";
    return null;
}
/** Decimal type ids that are match winner — never infer this from a selection name. */ const TRADER_ACTIVITY_MATCH_WINNER_TYPE_IDS = new Set([
    "10",
    "1010",
    "15"
]);
const TRADER_ACTIVITY_TOSS_TYPE_IDS = new Set([
    "815"
]);
const TRADER_ACTIVITY_PLAYER_TYPE_IDS = new Set([
    "270",
    "280",
    "621",
    "710",
    "720",
    "730",
    "760",
    "910",
    "912",
    "914",
    "940",
    "950"
]);
const TRADER_ACTIVITY_SESSION_TYPE_IDS = new Set([
    "340",
    "342",
    "344",
    "405",
    "410",
    "415",
    "455",
    "460",
    "510",
    "516",
    "855",
    "860"
]);
const TRADER_ACTIVITY_INNINGS_TYPE_IDS = new Set([
    "209",
    "210",
    "216",
    "217",
    "220",
    "230",
    "240",
    "250",
    "260",
    "610",
    "630",
    "635"
]);
const TRADER_ACTIVITY_H2H_TYPE_IDS = new Set([
    "30",
    "35",
    "45",
    "50",
    "55",
    "94",
    "96"
]);
const TRADER_ACTIVITY_MATCH_TYPE_IDS = new Set([
    "12",
    "16",
    "25",
    "60",
    "70",
    "72",
    "75",
    "77",
    "80",
    "85",
    "86",
    "88",
    "90",
    "865",
    "870"
]);
function leagueTraderActivityMarketFamily(details) {
    const id = String(details?.marketTypeId ?? "").trim().replace(/\.0+$/, "");
    const hay = String(details?.marketName ?? "").toLowerCase();
    if (TRADER_ACTIVITY_MATCH_WINNER_TYPE_IDS.has(id) || hay.includes("match winner") || hay.includes("match odds")) return "Match Winner";
    if (TRADER_ACTIVITY_TOSS_TYPE_IDS.has(id) || hay.includes("toss winner") || hay === "toss") return "Toss Winner";
    if (TRADER_ACTIVITY_PLAYER_TYPE_IDS.has(id)) return "Player";
    if (TRADER_ACTIVITY_SESSION_TYPE_IDS.has(id)) return "Session";
    if (TRADER_ACTIVITY_INNINGS_TYPE_IDS.has(id)) return "Innings";
    if (TRADER_ACTIVITY_H2H_TYPE_IDS.has(id)) return "Head to Head";
    if (TRADER_ACTIVITY_MATCH_TYPE_IDS.has(id)) return "Match";
    if (hay.includes("innings")) return "Innings";
    if (hay.includes("session") || hay.includes("runs in over") || hay.includes("first 6")) return "Session";
    if (hay.includes("head to head") || hay.includes("head-to-head") || hay.includes("h2h")) return "Head to Head";
    if (hay.includes("player") || hay.includes("batter") || hay.includes("batsman") || hay.includes("bowler")) return "Player";
    if (details?.marketClass === "Win" && !hay.trim()) return "Match Winner";
    return "Trader";
}
function leagueSquaresOverLabel(selectionOrDetail, details) {
    const over = details?.overNumber;
    if (over != null && Number.isFinite(Number(over)) && Number(over) >= 1) return `Over ${Math.floor(Number(over))}`;
    const fromText = String(selectionOrDetail || "").match(/\bOver\s+(\d+)\b/i);
    if (fromText) return `Over ${fromText[1]}`;
    if (/next\s+over/i.test(String(selectionOrDetail || ""))) return "Next over";
    return "Squares+ over";
}
function leagueSquaresBallPicksLabel(selections) {
    if (!selections || typeof selections !== "object") return null;
    const parts = Object.entries(selections).filter(([, sel])=>sel != null && sel.run != null && String(sel.run).trim() !== "").sort((a, b)=>Number(a[0]) - Number(b[0])).map(([ball, sel])=>`B${ball} ${String(sel.run).trim()}`);
    return parts.length > 0 ? parts.join(", ") : null;
}
/** Unit suffix for Over/Under line picks — derived from market name / type id. */ function leagueTraderLineUnit(details) {
    const id = String(details.marketTypeId ?? "").trim();
    if (id === "914" || id === "730") return "sixes";
    if (id === "912" || id === "720") return "fours";
    if (id === "910" || id === "710") return "runs";
    const hay = String(details.marketName ?? "").toLowerCase();
    if (hay.includes("fall of wicket")) return "runs";
    if (/\bsixes\b/.test(hay)) return "sixes";
    if (/\bfours\b/.test(hay)) return "fours";
    if (/\bwickets?\b/.test(hay)) return "wickets";
    if (/\bextras\b/.test(hay)) return "extras";
    if (/\brun[\s-]?outs?\b/.test(hay)) return "run outs";
    if (/\bruns?\b/.test(hay)) return "runs";
    return "runs";
}
function lineTokenInLabel(label, lineLabel, lineNum) {
    const escaped = lineLabel.replace(/\./g, "\\.");
    if (new RegExp(`\\b${escaped}\\b`).test(label)) return true;
    if (Number.isFinite(lineNum)) {
        const numEscaped = String(lineNum).replace(/\./g, "\\.");
        if (new RegExp(`\\b${numEscaped}\\b`).test(label)) return true;
    }
    return false;
}
function leaguePlayPickLabel(selectionOrDetail, details) {
    if (!details?.selectionName?.trim()) return selectionOrDetail;
    let pick = details.selectionName.trim().replace(/\bOVER\b/g, "Over").replace(/\bUNDER\b/g, "Under");
    const isOverUnder = /^(over|under)\b/i.test(pick);
    const hasLine = details.marketLine != null && String(details.marketLine).trim() !== "" && (details.marketClass === "Line" || isOverUnder);
    if (hasLine) {
        const line = Number(details.marketLine);
        const lineLabel = Number.isFinite(line) ? line.toFixed(1) : String(details.marketLine).trim();
        if (!lineTokenInLabel(pick, lineLabel, line)) pick = `${pick} ${lineLabel}`;
        if (isOverUnder) {
            const unit = leagueTraderLineUnit(details);
            const unitPattern = unit.replace(/\s+/g, "\\s+");
            if (!new RegExp(`\\b${unitPattern}\\b`, "i").test(pick)) pick = `${pick} ${unit}`;
        }
    }
    // Preserve trailing odds / settlement suffix from the stored string when present.
    const atIdx = selectionOrDetail.lastIndexOf(" @ ");
    const dotIdx = selectionOrDetail.indexOf(" \xb7 ");
    if (atIdx >= 0 && (dotIdx < 0 || atIdx < dotIdx)) {
        const oddsAndRest = selectionOrDetail.slice(atIdx); // " @ 1.85" or " @ 1.85 · lost"
        // Avoid duplicating the selection name if the stored string already starts with it.
        if (!selectionOrDetail.toLowerCase().startsWith(pick.toLowerCase())) return `${pick}${oddsAndRest}`;
    }
    if (dotIdx > 0 && !selectionOrDetail.toLowerCase().startsWith(pick.toLowerCase())) {
        // Settled detail like "India @ 1.85 · returned 740" — rebuild head, keep outcome tail.
        const tail = selectionOrDetail.slice(dotIdx); // " · returned 740"
        const head = atIdx >= 0 ? `${pick}${selectionOrDetail.slice(atIdx, dotIdx)}` : pick;
        return `${head}${tail}`;
    }
    if (!selectionOrDetail.toLowerCase().startsWith(pick.toLowerCase())) return pick;
    return selectionOrDetail;
}
function leagueActivityDetailLines(input) {
    if (input.game === "squares") return {
        market: null,
        detail: leagueSquaresOverLabel(input.selectionOrDetail, input.marketDetails)
    };
    const market = leaguePlayMarketLabel(input.marketDetails);
    const detail = leaguePlayPickLabel(input.selectionOrDetail, input.marketDetails);
    if (!market) return {
        market: null,
        detail
    };
    // Newer settlement rows already prefix the market name — don't duplicate.
    if (detail.toLowerCase().startsWith(market.toLowerCase())) return {
        market: null,
        detail
    };
    return {
        market,
        detail
    };
}
function isOpenPlay(play) {
    return play.status === "open";
}
function openPlaysFor(league, userId) {
    return league.plays.filter((play)=>play.status === "open" && (userId == null || play.userId === userId));
}
function openStakeFor(league, userId) {
    return openPlaysFor(league, userId).reduce((total, play)=>total + play.stake, 0);
}
function availableCoinsFor(league, userId) {
    const member = league.members.find((row)=>row.userId === userId) ?? league.members.find((row)=>row.isViewer);
    if (!member) return 0;
    return Math.max(0, member.coins - openStakeFor(league, member.userId));
}
/** Soft ETAs (e.g. league ends_at) can expire while the match is still live. */ const SETTLING_HINT_MS = 30000;
function settlesInMs(play, now = Date.now()) {
    if (!play.settlesAt) return null;
    const settles = new Date(play.settlesAt).getTime();
    if (!Number.isFinite(settles)) return null;
    return settles - now;
}
function openPlayCountdownLabel(play, now = Date.now()) {
    const ms = settlesInMs(play, now);
    if (ms == null) return "in play";
    if (ms <= 0) // Real settlement is event-driven. Only hint "settling…" for a short overdue
    // window (demo / short horizons); long-overdue soft ETAs stay "in play".
    return ms > -SETTLING_HINT_MS ? "settling\u2026" : "in play";
    const seconds = Math.ceil(ms / 1000);
    if (seconds < 60) return `settles in ${seconds}s`;
    return `settles in ${Math.ceil(seconds / 60)}m`;
}
function openPlayProgress(play, now = Date.now()) {
    if (!play.settlesAt) return null;
    const placed = new Date(play.placedAt).getTime();
    const settles = new Date(play.settlesAt).getTime();
    if (!Number.isFinite(placed) || !Number.isFinite(settles) || settles <= placed) return null;
    if (now >= settles) // Brief overdue: full bar. Long overdue soft ETA: indeterminate.
    return now - settles <= SETTLING_HINT_MS ? 1 : null;
    return Math.min(1, Math.max(0, (now - placed) / (settles - placed)));
}

},{"./constants":"dZVub","./leagueFormat":"jKCIi","./leagueSuperSquares":"4dj0v","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4dj0v":[function(require,module,exports,__globalThis) {
/**
 * League Super Squares scoring (frontend mirror of backend/db/leagues/leagueSuperSquares.js).
 * Keep in sync with the backend helper.
 *
 *   return = round((base + streakBonus) × accuracyMult × wicketMult × maidenMult)
 *
 * Accuracy ×4–×6 at 4–6 correct (3 correct is not a multiplier); streak chips
 * 10/25/50/100/200 for 2–6 in a row (added before multipliers); any wicket doubles
 * once (capped at ×2); a completed maiden halves the total.
 * Same-ball bonuses merge into one combo celebration — they still all apply.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STREAK_BONUS_BY_LENGTH", ()=>STREAK_BONUS_BY_LENGTH);
parcelHelpers.export(exports, "superSquaresEventKey", ()=>superSquaresEventKey);
parcelHelpers.export(exports, "superSquaresComboEvent", ()=>superSquaresComboEvent);
/** Stamp label for the multiplicative boost (includes maiden ×0.5). */ parcelHelpers.export(exports, "superSquaresBoostLabel", ()=>superSquaresBoostLabel);
/** True when a counted ball result is a dismissal (W / W+N). */ parcelHelpers.export(exports, "isWicketBallResult", ()=>isWicketBallResult);
parcelHelpers.export(exports, "countWicketsInBallResults", ()=>countWicketsInBallResults);
parcelHelpers.export(exports, "countCorrectBalls", ()=>countCorrectBalls);
/** Longest run of consecutive correct balls (in delivery order). */ parcelHelpers.export(exports, "longestCorrectStreak", ()=>longestCorrectStreak);
/** Flat chip bonus for a streak length (0 if shorter than 2). */ parcelHelpers.export(exports, "streakBonusForLength", ()=>streakBonusForLength);
/** ×2 if any wicket fell; extra wickets do not stack. */ parcelHelpers.export(exports, "wicketMultiplier", ()=>wicketMultiplier);
/** ×4/×5/×6 at 4–6 correct; else ×1. */ parcelHelpers.export(exports, "accuracyMultiplier", ()=>accuracyMultiplier);
/** True when six counted balls are all dots or plain wickets (no runs). */ parcelHelpers.export(exports, "isMaidenOver", ()=>isMaidenOver);
/** ×0.5 on a completed maiden over; else ×1. */ parcelHelpers.export(exports, "maidenMultiplier", ()=>maidenMultiplier);
/** (base + streakBonus) × accuracyMult × wicketMult × maidenMult */ parcelHelpers.export(exports, "superSquaresReturnCoins", ()=>superSquaresReturnCoins);
parcelHelpers.export(exports, "computeSuperSquaresBreakdown", ()=>computeSuperSquaresBreakdown);
/** Six cells for the over; balls after `uptoIndex` render as not bowled. */ parcelHelpers.export(exports, "superSquaresBallCells", ()=>superSquaresBallCells);
/** Indices of the longest correct run (latest one on ties). */ parcelHelpers.export(exports, "superSquaresStreakIndices", ()=>superSquaresStreakIndices);
/** Diff events when a new ball is appended (for live overlay). */ parcelHelpers.export(exports, "superSquaresEventsForNewBall", ()=>superSquaresEventsForNewBall);
/**
 * One delivery can fire several bonuses (wicket + accuracy tier + longer streak + maiden).
 * Catch-up can also dump several unseen bonuses at once. Either way: one stamp,
 * walking every active bonus, then the stacked total.
 *
 * Formula those stamps are celebrating:
 *   round((Σ chips×odds on correct balls + streakBonus) × accuracyMult × wicketMult × maidenMult)
 */ parcelHelpers.export(exports, "mergeSuperSquaresEvents", ()=>mergeSuperSquaresEvents);
/**
 * Live sequence for an over: one celebration per ball that newly earned a bonus.
 * Same-ball bonuses merge (see {@link mergeSuperSquaresEvents}).
 */ parcelHelpers.export(exports, "superSquaresCelebrationsForOver", ()=>superSquaresCelebrationsForOver);
var _squaresBallResultsJs = require("../../Squares/shared/squaresBallResults.js");
const STREAK_BONUS_BY_LENGTH = Object.freeze({
    2: 10,
    3: 25,
    4: 50,
    5: 100,
    6: 200
});
function superSquaresEventKey(event) {
    if (event.type === "wicket") return `${event.type}-${event.ballIndex}-${event.wicketMult}`;
    if (event.type === "accuracy") return `${event.type}-${event.ballIndex}-${event.accuracyMult}`;
    if (event.type === "streak") return `${event.type}-${event.ballIndex}-${event.streakBonus}`;
    if (event.type === "maiden") return `${event.type}-${event.ballIndex}-${event.maidenMult}`;
    return `${event.type}-${event.ballIndex}-${event.combinedMult}-${event.streakBonus}-${event.maidenMult}`;
}
function superSquaresComboEvent(breakdown, ballIndex) {
    return {
        type: "combo",
        ballIndex,
        wicketCount: breakdown.wicketCount,
        wicketMult: breakdown.wicketMult,
        correctCount: breakdown.correctCount,
        accuracyMult: breakdown.accuracyMult,
        streakLength: breakdown.streakLength,
        streakBonus: breakdown.streakBonus,
        maidenMult: breakdown.maidenMult,
        combinedMult: breakdown.combinedMult
    };
}
function superSquaresBoostLabel(combinedMult, streakBonus) {
    const n = Number(combinedMult);
    if (Number.isFinite(n) && n !== 1) return `\xd7${n}`;
    return `+${Math.max(0, Math.round(Number(streakBonus) || 0))}`;
}
function isWicketBallResult(raw) {
    if (raw == null || String(raw).trim() === "") return false;
    const s = String(raw).trim().toLowerCase();
    if (s === "w" || s === "wicket" || s === "wkt") return true;
    if (/^w\+[1-5]$/i.test(s)) return true;
    if (/^wicket\+[1-5]$/i.test(s) || /^wkt\+[1-5]$/i.test(s)) return true;
    // Display-normalised "W"
    if ((0, _squaresBallResultsJs.displayBallResult)(raw) === "W") return true;
    return false;
}
function countWicketsInBallResults(ballResults) {
    if (!Array.isArray(ballResults)) return 0;
    let n = 0;
    for (const raw of ballResults.slice(0, 6))if (isWicketBallResult(raw)) n += 1;
    return n;
}
function ballIsCorrect(selections, ballResults, index) {
    const sel = selections?.[String(index + 1)];
    const pred = sel?.run ?? sel?.runLabel ?? "";
    if (!pred) return false;
    const raw = ballResults[index];
    const display = (0, _squaresBallResultsJs.displayBallResult)(raw) ?? String(raw ?? "");
    return (0, _squaresBallResultsJs.computeBallWon)(display, String(pred)) === true;
}
function countCorrectBalls(selections, ballResults) {
    if (!Array.isArray(ballResults) || ballResults.length === 0) return 0;
    let n = 0;
    const limit = Math.min(ballResults.length, 6);
    for(let i = 0; i < limit; i += 1)if (ballIsCorrect(selections, ballResults, i)) n += 1;
    return n;
}
function longestCorrectStreak(selections, ballResults) {
    if (!Array.isArray(ballResults) || ballResults.length === 0) return 0;
    let best = 0;
    let run = 0;
    const limit = Math.min(ballResults.length, 6);
    for(let i = 0; i < limit; i += 1)if (ballIsCorrect(selections, ballResults, i)) {
        run += 1;
        if (run > best) best = run;
    } else run = 0;
    return best;
}
function streakBonusForLength(streakLength) {
    const n = Math.max(0, Math.floor(Number(streakLength) || 0));
    if (n >= 6) return STREAK_BONUS_BY_LENGTH[6];
    if (n >= 5) return STREAK_BONUS_BY_LENGTH[5];
    if (n >= 4) return STREAK_BONUS_BY_LENGTH[4];
    if (n >= 3) return STREAK_BONUS_BY_LENGTH[3];
    if (n >= 2) return STREAK_BONUS_BY_LENGTH[2];
    return 0;
}
function wicketMultiplier(wicketCount) {
    const n = Math.max(0, Math.floor(Number(wicketCount) || 0));
    return n >= 1 ? 2 : 1;
}
function accuracyMultiplier(correctCount) {
    const n = Math.max(0, Math.floor(Number(correctCount) || 0));
    if (n >= 6) return 6;
    if (n >= 5) return 5;
    if (n >= 4) return 4;
    return 1;
}
function isMaidenOver(ballResults) {
    if (!Array.isArray(ballResults) || ballResults.length < 6) return false;
    for (const raw of ballResults.slice(0, 6)){
        const d = (0, _squaresBallResultsJs.displayBallResult)(raw);
        if (d !== "0" && d !== "W") return false;
    }
    return true;
}
function maidenMultiplier(ballResults) {
    return isMaidenOver(ballResults) ? 0.5 : 1;
}
function superSquaresReturnCoins(baseReturn, accuracyMult, streakBonus, wicketMult, maidenMult = 1) {
    const base = Math.max(0, Number(baseReturn) || 0);
    const acc = Math.max(1, Number(accuracyMult) || 1);
    const streak = Math.max(0, Math.round(Number(streakBonus) || 0));
    const wickets = Math.max(1, Number(wicketMult) || 1);
    const maiden = Number(maidenMult);
    const maidenFactor = Number.isFinite(maiden) && maiden > 0 ? maiden : 1;
    const summed = base + streak;
    if (summed <= 0) return 0;
    return Math.round(summed * acc * wickets * maidenFactor);
}
function baseReturnFromSelections(selections, ballResults) {
    let sum = 0;
    const limit = Math.min(ballResults.length, 6);
    for(let i = 0; i < limit; i += 1){
        const sel = selections?.[String(i + 1)];
        const pred = sel?.run ?? sel?.runLabel ?? "";
        if (!pred || !sel) continue;
        if (!ballIsCorrect(selections, ballResults, i)) continue;
        const chips = Number(sel.chips) || 0;
        const odds = Math.max(0, parseFloat(String(sel.odds ?? "")) || 0);
        if (chips <= 0 || odds <= 0) continue;
        sum += Math.round(chips * odds * 100) / 100;
    }
    return Math.round(sum * 100) / 100;
}
function computeSuperSquaresBreakdown(selections, ballResultsPartial) {
    const balls = Array.isArray(ballResultsPartial) ? ballResultsPartial.slice(0, 6) : [];
    const baseReturn = Math.max(0, baseReturnFromSelections(selections, balls));
    const wicketCount = countWicketsInBallResults(balls);
    const correctCount = countCorrectBalls(selections, balls);
    const streakLength = longestCorrectStreak(selections, balls);
    const streakBonus = streakBonusForLength(streakLength);
    const wicketMult = wicketMultiplier(wicketCount);
    const accuracyMult = accuracyMultiplier(correctCount);
    const maidenMult = maidenMultiplier(balls);
    const combinedMult = wicketMult * accuracyMult * maidenMult;
    return {
        baseReturn,
        wicketCount,
        correctCount,
        streakLength,
        streakBonus,
        wicketMult,
        accuracyMult,
        maidenMult,
        combinedMult,
        returnCoins: superSquaresReturnCoins(baseReturn, accuracyMult, streakBonus, wicketMult, maidenMult)
    };
}
function isPendingBallResult(raw) {
    const s = String(raw ?? "").trim();
    return s === "" || s === "..." || s === "\u2013" || s === "-";
}
function superSquaresBallCells(selections, ballResults, uptoIndex = 5) {
    const balls = Array.isArray(ballResults) ? ballResults : [];
    return Array.from({
        length: 6
    }, (_, i)=>{
        const sel = selections?.[String(i + 1)];
        const pick = String(sel?.runLabel ?? sel?.run ?? "").trim() || null;
        const raw = i <= uptoIndex ? balls[i] : undefined;
        if (isPendingBallResult(raw)) return {
            result: null,
            pick,
            correct: null,
            wicket: false
        };
        const rawText = String(raw).trim();
        const result = (0, _squaresBallResultsJs.displayBallResult)(rawText) ?? rawText;
        return {
            result,
            pick,
            correct: pick ? ballIsCorrect(selections, balls, i) : null,
            wicket: isWicketBallResult(raw)
        };
    });
}
function superSquaresStreakIndices(cells) {
    let best = [];
    let run = [];
    cells.forEach((cell, i)=>{
        if (cell.correct === true) {
            run = [
                ...run,
                i
            ];
            if (run.length >= best.length) best = run;
        } else run = [];
    });
    return best.length >= 2 ? best : [];
}
function superSquaresEventsForNewBall(prevBalls, nextBalls, selections) {
    if (!Array.isArray(nextBalls) || nextBalls.length <= (prevBalls?.length ?? 0)) return [];
    const events = [];
    for(let i = prevBalls.length; i < nextBalls.length; i += 1){
        const slice = nextBalls.slice(0, i + 1);
        const prevSlice = nextBalls.slice(0, i);
        const raw = nextBalls[i];
        const prevWicketMult = wicketMultiplier(countWicketsInBallResults(prevSlice));
        const nextWicketCount = countWicketsInBallResults(slice);
        const nextWicketMult = wicketMultiplier(nextWicketCount);
        if (isWicketBallResult(raw) && nextWicketMult > prevWicketMult) events.push({
            type: "wicket",
            ballIndex: i,
            wicketCount: nextWicketCount,
            wicketMult: nextWicketMult
        });
        const prevCorrect = countCorrectBalls(selections, prevSlice);
        const nextCorrect = countCorrectBalls(selections, slice);
        const prevAcc = accuracyMultiplier(prevCorrect);
        const nextAcc = accuracyMultiplier(nextCorrect);
        if (nextAcc > prevAcc && nextAcc >= 4) events.push({
            type: "accuracy",
            ballIndex: i,
            correctCount: nextCorrect,
            accuracyMult: nextAcc
        });
        const prevStreak = streakBonusForLength(longestCorrectStreak(selections, prevSlice));
        const nextStreakLen = longestCorrectStreak(selections, slice);
        const nextStreak = streakBonusForLength(nextStreakLen);
        if (nextStreak > prevStreak) events.push({
            type: "streak",
            ballIndex: i,
            streakLength: nextStreakLen,
            streakBonus: nextStreak
        });
        const prevMaiden = maidenMultiplier(prevSlice);
        const nextMaiden = maidenMultiplier(slice);
        if (nextMaiden < prevMaiden) events.push({
            type: "maiden",
            ballIndex: i,
            maidenMult: nextMaiden
        });
    }
    return events;
}
function mergeSuperSquaresEvents(events, breakdown) {
    if (events.length === 0) return null;
    if (events.length === 1) return events[0];
    return superSquaresComboEvent(breakdown, events[events.length - 1].ballIndex);
}
function superSquaresCelebrationsForOver(selections, ballResults) {
    const results = Array.isArray(ballResults) ? ballResults.slice(0, 6) : [];
    const out = [];
    for(let i = 0; i < results.length; i += 1){
        const prev = results.slice(0, i);
        const next = results.slice(0, i + 1);
        const events = superSquaresEventsForNewBall(prev, next, selections);
        const celebration = mergeSuperSquaresEvents(events, computeSuperSquaresBreakdown(selections, next));
        if (celebration) out.push(celebration);
    }
    return out;
}

},{"../../Squares/shared/squaresBallResults.js":"idJxQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"idJxQ":[function(require,module,exports,__globalThis) {
/**
 * Squares ball result filtering and display. Must stay in sync with backend squares-settlement-common.js.
 * - Ignore: 1W–7W, W+1w–W+5w, 1NB–8NB, wides (wide, Wd, wide+4, etc.), anything containing "Pen".
 * - Ignore Decimal event-status strings mistakenly stored as ball results (e.g. "Ball In Progress").
 * - Display mapping: 0–7, 1B–7B, 1LB–7LB → 0–7; W → "W"; W+1–W+5 → 1–5.
 */ /**
 * @param {string|number|null|undefined} raw
 * @returns {boolean}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEventStatusPlaceholderBallResult", ()=>isEventStatusPlaceholderBallResult);
/**
 * Six stored values that are all event-status placeholders (bad delta settle) — treat as no ball_results.
 * @param {unknown} arr
 * @returns {boolean}
 */ parcelHelpers.export(exports, "ballResultsAreOnlyEventPlaceholders", ()=>ballResultsAreOnlyEventPlaceholders);
/**
 * For UI/API: real ball_results array, or null if missing / placeholder-only (so we refetch and show empty slots).
 * @param {unknown} ballResults
 * @returns {string[]|null}
 */ parcelHelpers.export(exports, "effectiveSquaresBallResults", ()=>effectiveSquaresBallResults);
/**
 * @param {string|number|null|undefined} raw
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isIgnoreBallResult", ()=>isIgnoreBallResult);
/**
 * Filter raw delivery list to only "counted" balls (non-ignore). Returns up to 6 values.
 * @param {Array<string|number|null|undefined>} rawArray
 * @returns {string[]}
 */ parcelHelpers.export(exports, "filterToCountedBallResults", ()=>filterToCountedBallResults);
/**
 * Map raw result to display string for ball boxes. Returns null for ignore.
 * @param {string|number|null|undefined} raw
 * @returns {string|null} "0"–"7" or "W"
 */ parcelHelpers.export(exports, "displayBallResult", ()=>displayBallResult);
/**
 * Label for My Zone summary white outcome cells (wicket spelled out for narrow tiles).
 * @param {string|null|undefined} displayVal - output of {@link displayBallResult} or padded "–"
 * @returns {string}
 */ parcelHelpers.export(exports, "squaresOutcomeSummaryLabel", ()=>squaresOutcomeSummaryLabel);
/**
 * From raw over delivery list, get the display values for the 6 ball boxes (only counted balls; ignore values are skipped).
 * @param {Array<string|number|null|undefined>} rawOverDelivery
 * @returns {string[]} Length 0–6
 */ parcelHelpers.export(exports, "getDisplayBallResults", ()=>getDisplayBallResults);
/**
 * Normalise display result to run label for comparison to user selection. Matches backend normaliseBallResult logic.
 * Used to compute win/lose on frontend as soon as we have the ball result, without waiting for backend per_ball.
 * @param {string} displayResult - Display value from result box: "0"–"7" or "W"
 * @returns {string|null} One of '0'|'1'|'2'|'3'|'4'|'5+' or null
 */ parcelHelpers.export(exports, "normaliseDisplayResultToRunLabel", ()=>normaliseDisplayResultToRunLabel);
/**
 * Compute whether the user's selection matched the ball result. Use when we have result + prediction but backend per_ball not yet.
 * @param {string} displayResult - Ball result display value ("0"–"7", "W")
 * @param {string} selectedRun - User's selection run label ("0","1","2","3","4","5+")
 * @returns {boolean|null} true = win, false = lose, null = can't compute
 */ parcelHelpers.export(exports, "computeBallWon", ()=>computeBallWon);
/**
 * Effective run label from a selection object (matches backend getSelectionRun).
 * @param {object|null|undefined} sel
 * @returns {string|null}
 */ parcelHelpers.export(exports, "getSelectionRun", ()=>getSelectionRun);
/**
 * Raw feed ball → selection bucket for comparison (matches backend normaliseBallResult).
 * @param {*} actual
 * @returns {string|null}
 */ parcelHelpers.export(exports, "normaliseBallResult", ()=>normaliseBallResult);
/**
 * Per-ball cell state for leaderboard mini-boxes (squares_overs.winners[].selections vs ball_results).
 * @param {unknown} selections - JSON object or string; keys "1".."6"
 * @param {string[]|null|undefined} ballResultsRaw
 * @returns {Array<'won'|'lost'|'pending'>}
 */ parcelHelpers.export(exports, "sixBallLeaderboardCells", ()=>sixBallLeaderboardCells);
/** 1-based ball in current over from feed delivery prefix in ballLabel (e.g. "3.4 Bowler to Batter"). */ parcelHelpers.export(exports, "squaresBallNumberFromBallLabel", ()=>squaresBallNumberFromBallLabel);
function isEventStatusPlaceholderBallResult(raw) {
    if (raw == null || String(raw).trim() === "") return false;
    const n = String(raw).toLowerCase().replace(/-/g, " ").replace(/_/g, " ").replace(/\s+/g, " ").trim();
    if (n.includes("ball in progress")) return true;
    if (n.includes("match stable")) return true;
    if (n.includes("runs likely")) return true;
    if (n.includes("possible wicket")) return true;
    if (n.includes("unknown event")) return true;
    if (n.includes("umpire review")) return true;
    if (n.includes("data assembly")) return true;
    if (n.includes("break in play")) return true;
    if (n.includes("match scheduled")) return true;
    if (n.includes("match complete")) return true;
    if (n.includes("event closed")) return true;
    if (n.includes("ejected")) return true;
    if (n === "super over") return true;
    return false;
}
function ballResultsAreOnlyEventPlaceholders(arr) {
    if (!Array.isArray(arr) || arr.length < 6) return false;
    return arr.slice(0, 6).every((v)=>isEventStatusPlaceholderBallResult(v));
}
function effectiveSquaresBallResults(ballResults) {
    if (!Array.isArray(ballResults) || ballResults.length === 0) return null;
    if (ballResultsAreOnlyEventPlaceholders(ballResults)) return null;
    return ballResults;
}
function isIgnoreBallResult(raw) {
    if (raw == null || String(raw).trim() === "") return true;
    const s = String(raw).trim();
    const lower = s.toLowerCase();
    if (isEventStatusPlaceholderBallResult(s)) return true;
    if (lower.includes("pen")) return true;
    if (lower.includes("wide") || /(^|[^a-z])wd([^a-z]|$)/.test(lower)) return true; // wd, 1wd, wd+1
    if (/^[1-7]w$/i.test(lower)) return true;
    if (/^w\+[1-5]w$/i.test(lower)) return true; // W+1w, W+2w, etc. (wicket+run with trailing w)
    if (/^[1-8]nb$/i.test(lower)) return true;
    if (/no\s*ball|(^|[^a-z])nb([^a-z]|$)/.test(lower)) return true; // nb+1, 1 nb, no ball
    return false;
}
function filterToCountedBallResults(rawArray) {
    if (!Array.isArray(rawArray)) return [];
    const out = [];
    for (const v of rawArray){
        if (v == null || String(v).trim() === "") continue;
        if (isIgnoreBallResult(v)) continue;
        out.push(String(v).trim());
        if (out.length >= 6) break;
    }
    return out;
}
function displayBallResult(raw) {
    if (raw == null || String(raw).trim() === "") return null;
    if (isIgnoreBallResult(raw)) return null;
    const s = String(raw).trim();
    const lower = s.toLowerCase();
    if (lower === "w" || lower === "wicket" || lower === "wkt") return "W";
    if (lower === "w+1" || lower === "wicket+1" || lower === "wkt+1") return "1";
    if (lower === "w+2" || lower === "wicket+2" || lower === "wkt+2") return "2";
    if (lower === "w+3" || lower === "wicket+3" || lower === "wkt+3") return "3";
    if (lower === "w+4" || lower === "wicket+4" || lower === "wkt+4") return "4";
    if (lower === "w+5" || lower === "wicket+5" || lower === "wkt+5") return "5";
    if (lower === "no run" || lower === "0 runs" || lower === "dot" || lower === "no runs") return "0";
    if (lower === "1lb" || lower === "1b" || s === "1") return "1";
    if (lower === "2lb" || lower === "2b" || s === "2") return "2";
    if (lower === "3lb" || lower === "3b" || s === "3") return "3";
    if (lower === "4lb" || lower === "4b" || s === "4") return "4";
    if (lower === "5lb" || lower === "5b" || s === "5") return "5";
    if (lower === "6lb" || lower === "6b" || s === "6") return "6";
    if (lower === "7lb" || lower === "7b" || s === "7") return "7";
    const n = parseInt(s, 10);
    if (Number.isFinite(n) && n >= 0 && n <= 7) return String(n);
    return null;
}
function squaresOutcomeSummaryLabel(displayVal) {
    const s = String(displayVal ?? "\u2013").trim();
    if (s === "\u2013" || s === "") return "\u2013";
    if (s.toUpperCase() === "W") return "WICKET";
    return s;
}
function getDisplayBallResults(rawOverDelivery) {
    const counted = filterToCountedBallResults(rawOverDelivery || []);
    return counted.map((raw)=>displayBallResult(raw)).filter((v)=>v != null);
}
/** Run labels used for selection comparison (must match backend RUN_LABELS). */ const RUN_LABELS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5+"
];
function normaliseDisplayResultToRunLabel(displayResult) {
    if (displayResult == null || String(displayResult).trim() === "") return null;
    const s = String(displayResult).trim();
    const upper = s.toUpperCase();
    if (upper === "W") return "0";
    const lower = s.toLowerCase();
    if (lower === "5+" || lower === "5plus") return "5+";
    // Match backend normaliseBallResult: only selection buckets 0–4 and 5+; 5 / 6 / 7 runs all map to 5+.
    if ([
        "5",
        "6",
        "7"
    ].includes(s)) return "5+";
    if (RUN_LABELS.includes(s)) return s;
    const n = parseInt(s, 10);
    if (Number.isFinite(n) && n >= 5) return "5+";
    if (Number.isFinite(n) && n >= 0 && n <= 4) return String(n);
    return null;
}
function computeBallWon(displayResult, selectedRun) {
    const normalised = normaliseDisplayResultToRunLabel(displayResult);
    if (normalised == null || !selectedRun || !RUN_LABELS.includes(String(selectedRun))) return null;
    return normalised === String(selectedRun);
}
function getSelectionRun(sel) {
    if (!sel) return null;
    const runStr = sel.run != null ? String(sel.run).trim() : "";
    if (runStr && RUN_LABELS.includes(runStr)) return runStr;
    const labelStr = sel.runLabel != null ? String(sel.runLabel).trim() : "";
    if (labelStr && RUN_LABELS.includes(labelStr)) return labelStr;
    return null;
}
function normaliseBallResult(actual) {
    if (actual == null || actual === "") return null;
    if (isIgnoreBallResult(actual)) return null;
    const s = String(actual).trim();
    const lower = s.toLowerCase();
    if (lower === "w" || lower === "wicket" || lower === "wkt") return "0";
    if (lower === "w+1" || lower === "wicket+1" || lower === "wkt+1") return "1";
    if (lower === "w+2" || lower === "wicket+2" || lower === "wkt+2") return "2";
    if (lower === "w+3" || lower === "wicket+3" || lower === "wkt+3") return "3";
    if (lower === "w+4" || lower === "wicket+4" || lower === "wkt+4") return "4";
    if (lower === "w+5" || lower === "wicket+5" || lower === "wkt+5") return "5+";
    if (lower === "no run" || lower === "0 runs" || lower === "dot" || lower === "no runs") return "0";
    if (lower === "1lb" || lower === "1b" || s === "1") return "1";
    if (lower === "2lb" || lower === "2b" || s === "2") return "2";
    if (lower === "3lb" || lower === "3b" || s === "3") return "3";
    if (lower === "4lb" || lower === "4b" || s === "4") return "4";
    if (lower === "5lb" || lower === "5b" || s === "5") return "5+";
    if (lower === "6lb" || lower === "6b" || s === "6") return "5+";
    if (lower === "7lb" || lower === "7b" || s === "7") return "5+";
    if (lower === "5+" || lower === "5plus") return "5+";
    const n = parseInt(s, 10);
    if (Number.isFinite(n)) {
        if (n >= 5) return "5+";
        if (n >= 0 && n <= 4) return String(n);
    }
    return null;
}
function sixBallLeaderboardCells(selections, ballResultsRaw) {
    let sel = selections;
    if (typeof sel === "string") try {
        sel = JSON.parse(sel);
    } catch  {
        sel = null;
    }
    const obj = sel && typeof sel === "object" && !Array.isArray(sel) ? sel : {};
    const effective = effectiveSquaresBallResults(Array.isArray(ballResultsRaw) ? ballResultsRaw : null);
    const br = effective || [];
    const out = [];
    for(let i = 0; i < 6; i++){
        if (i >= br.length) {
            out.push("pending");
            continue;
        }
        const expected = normaliseBallResult(br[i]);
        const run = getSelectionRun(obj[String(i + 1)]);
        if (expected == null) {
            out.push("pending");
            continue;
        }
        if (run == null) {
            out.push("lost");
            continue;
        }
        out.push(run === expected ? "won" : "lost");
    }
    return out;
}
function squaresBallNumberFromBallLabel(ballLabel) {
    if (ballLabel == null || typeof ballLabel !== "string") return null;
    const m = ballLabel.trim().match(/^(\d+)\.(\d+)/);
    if (!m) return null;
    const ball = Number.parseInt(m[2], 10);
    if (!Number.isFinite(ball) || ball < 0 || ball > 6) return null;
    return ball === 0 ? 1 : ball;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aNN1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEAGUE_BULLION_ENTRY_LOCK_MODE", ()=>LEAGUE_BULLION_ENTRY_LOCK_MODE);
parcelHelpers.export(exports, "LEAGUE_BULLION_ENTRY_LOCK_WINDOW_MS", ()=>LEAGUE_BULLION_ENTRY_LOCK_WINDOW_MS);
parcelHelpers.export(exports, "LEAGUE_BULLION_ENTRY_LOCK_EFFECTIVE_WINDOW_MS", ()=>LEAGUE_BULLION_ENTRY_LOCK_EFFECTIVE_WINDOW_MS);
parcelHelpers.export(exports, "LEAGUE_BULLION_ENTRY_LOCK_ON_TOSS_STATUS", ()=>LEAGUE_BULLION_ENTRY_LOCK_ON_TOSS_STATUS);
parcelHelpers.export(exports, "LEAGUE_BULLION_TOSS_ENTRY_LOCK_WINDOW_MS", ()=>LEAGUE_BULLION_TOSS_ENTRY_LOCK_WINDOW_MS);
/** Human label ("5 minutes before first ball" | "at toss"). */ parcelHelpers.export(exports, "leagueBullionEntryLockWhenLabel", ()=>leagueBullionEntryLockWhenLabel);
/** Short label for rules / how-to copy. */ parcelHelpers.export(exports, "leagueBullionEntryLockUntilLabel", ()=>leagueBullionEntryLockUntilLabel);
parcelHelpers.export(exports, "leagueBullionPlaySlipLockedMessage", ()=>leagueBullionPlaySlipLockedMessage);
/** Wall-clock when peer Sixes / Bullion cards first unlock (kick-off minus effective lock window). */ parcelHelpers.export(exports, "leaguePeerCardRevealAtMs", ()=>leaguePeerCardRevealAtMs);
/**
 * League Bullion play lock: configured minutes before kickoff (or toss mode), kickoff passed,
 * live, or in-play status. Toss-only status locks only when mode is `toss`.
 */ parcelHelpers.export(exports, "leagueBullionPlayEntryLocked", ()=>leagueBullionPlayEntryLocked);
parcelHelpers.export(exports, "leagueBullionTossEntryLocked", ()=>leagueBullionTossEntryLocked);
/**
 * Peer Sixes cards / Bullion slips (Activity + standings) unlock when play locks.
 */ parcelHelpers.export(exports, "leaguePeerSixesCardRevealUnlocked", ()=>leaguePeerSixesCardRevealUnlocked);
parcelHelpers.export(exports, "leaguePeerBullionCardRevealUnlocked", ()=>leaguePeerBullionCardRevealUnlocked);
/** Peer reveal for Sixes or Bullion (Activity / Open Plays / member standings). */ parcelHelpers.export(exports, "leaguePeerCardRevealUnlocked", ()=>leaguePeerCardRevealUnlocked);
/**
 * Whether the viewer is blocked from entering the league Bullion battle.
 * Distinguishes late joiners (joined after the lock started) from members who simply missed entry.
 */ parcelHelpers.export(exports, "leagueBullionBattleEntryBlock", ()=>leagueBullionBattleEntryBlock);
var _leagueBullionEntryLockConfigTs = require("./leagueBullionEntryLockConfig.ts");
function lockResolved() {
    return (0, _leagueBullionEntryLockConfigTs.getLeagueBullionEntryLockResolved)() ?? (0, _leagueBullionEntryLockConfigTs.DEFAULT_LEAGUE_BULLION_ENTRY_LOCK);
}
const LEAGUE_BULLION_ENTRY_LOCK_MODE = (0, _leagueBullionEntryLockConfigTs.DEFAULT_LEAGUE_BULLION_ENTRY_LOCK).mode;
const LEAGUE_BULLION_ENTRY_LOCK_WINDOW_MS = (0, _leagueBullionEntryLockConfigTs.DEFAULT_LEAGUE_BULLION_ENTRY_LOCK).minutes * 60000;
const LEAGUE_BULLION_ENTRY_LOCK_EFFECTIVE_WINDOW_MS = (0, _leagueBullionEntryLockConfigTs.DEFAULT_LEAGUE_BULLION_ENTRY_LOCK).windowMs;
const LEAGUE_BULLION_ENTRY_LOCK_ON_TOSS_STATUS = (0, _leagueBullionEntryLockConfigTs.DEFAULT_LEAGUE_BULLION_ENTRY_LOCK).lockOnTossStatus;
const LEAGUE_BULLION_TOSS_ENTRY_LOCK_WINDOW_MS = LEAGUE_BULLION_ENTRY_LOCK_WINDOW_MS;
function leagueBullionEntryLockWhenLabel() {
    return lockResolved().whenLabel;
}
function leagueBullionEntryLockUntilLabel() {
    return lockResolved().untilLabel;
}
function leagueBullionPlaySlipLockedMessage() {
    return lockResolved().playSlipLockedMessage;
}
function leaguePeerCardRevealAtMs(league) {
    const startIso = league.fixture?.start ?? league.startsAt ?? null;
    const startsAtTs = startIso ? new Date(startIso).getTime() : Number.NaN;
    if (!Number.isFinite(startsAtTs)) return null;
    return startsAtTs - lockResolved().windowMs;
}
function viewerInBullionBattle(league, userId) {
    if (league.bullionBattle?.viewerEntered) return true;
    if (league.bullionBattle?.enteredUserIds?.includes(userId)) return true;
    return league.plays.some((play)=>play.game === "bullion" && play.userId === userId);
}
function leagueBullionStatusIndicatesInPlay(statusText) {
    if (!statusText) return false;
    if (/\b(BAT|BATTING|BOWL|BOWLING)\b/i.test(statusText)) return true;
    if (/\bOV\.?\s*\d+(?:\.\d+)?\b/i.test(statusText)) return true;
    if (/\b\d+\s*\/\s*\d+\b/.test(statusText)) return true;
    return false;
}
function leagueBullionStatusIndicatesTossOrInPlay(statusText) {
    if (!statusText) return false;
    if (statusText.toUpperCase().includes("TOSS")) return true;
    return leagueBullionStatusIndicatesInPlay(statusText);
}
function lockFromKickoffWindow(opts) {
    const startsAtTs = opts.fixtureStart ? new Date(opts.fixtureStart).getTime() : Number.NaN;
    if (!Number.isFinite(startsAtTs)) return false;
    if (startsAtTs <= opts.nowMs) return true;
    return startsAtTs - opts.nowMs <= opts.windowMs;
}
function leagueBullionPlayEntryLocked(opts) {
    if (opts.isLive) return true;
    const resolved = lockResolved();
    if (lockFromKickoffWindow({
        fixtureStart: opts.fixtureStart,
        nowMs: opts.nowMs,
        windowMs: resolved.windowMs
    })) return true;
    const status = String(opts.matchStatus ?? "").trim();
    if (resolved.lockOnTossStatus) return leagueBullionStatusIndicatesTossOrInPlay(status);
    return leagueBullionStatusIndicatesInPlay(status);
}
const leagueBullionTossEntryLocked = leagueBullionPlayEntryLocked;
function leaguePeerSixesCardRevealUnlocked(league, nowMs, opts = {}) {
    return leagueBullionPlayEntryLocked({
        fixtureStart: league.fixture?.start ?? league.startsAt ?? null,
        matchStatus: opts.matchStatus,
        isLive: Boolean(opts.isLive),
        nowMs
    });
}
const leaguePeerBullionCardRevealUnlocked = leaguePeerSixesCardRevealUnlocked;
function leaguePeerCardRevealUnlocked(league, nowMs, opts = {}) {
    return leaguePeerSixesCardRevealUnlocked(league, nowMs, opts);
}
function leagueBullionBattleEntryBlock(league, viewerUserId, opts = {}) {
    if (viewerUserId == null) return null;
    if (viewerInBullionBattle(league, viewerUserId)) return null;
    const me = league.members.find((member)=>member.userId === viewerUserId);
    if (!me) return null;
    const nowMs = opts.nowMs ?? Date.now();
    const startsAt = opts.fixtureStart ?? league.fixture?.start ?? league.startsAt ?? null;
    const locked = leagueBullionPlayEntryLocked({
        fixtureStart: startsAt,
        matchStatus: opts.matchStatus,
        isLive: Boolean(opts.isLive),
        nowMs
    });
    if (!locked) return null;
    const startsAtTs = startsAt ? new Date(startsAt).getTime() : Number.NaN;
    const lockStartMs = Number.isFinite(startsAtTs) ? startsAtTs - lockResolved().windowMs : Number.NaN;
    const joinedAtMs = new Date(me.joinedAt).getTime();
    if (Number.isFinite(lockStartMs) && Number.isFinite(joinedAtMs) && joinedAtMs >= lockStartMs) return "joined_after_toss";
    return "entry_closed";
}

},{"./leagueBullionEntryLockConfig.ts":"cdt1w","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cdt1w":[function(require,module,exports,__globalThis) {
/**
 * Runtime league Bullion play lock (admin-editable). Env is the deploy fallback until
 * GET /leagues/bullion-entry-lock loads.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeLeagueBullionEntryLockConfig", ()=>normalizeLeagueBullionEntryLockConfig);
parcelHelpers.export(exports, "resolveLeagueBullionEntryLock", ()=>resolveLeagueBullionEntryLock);
parcelHelpers.export(exports, "DEFAULT_LEAGUE_BULLION_ENTRY_LOCK", ()=>DEFAULT_LEAGUE_BULLION_ENTRY_LOCK);
parcelHelpers.export(exports, "getLeagueBullionEntryLockResolved", ()=>getLeagueBullionEntryLockResolved);
parcelHelpers.export(exports, "setLeagueBullionEntryLockResolved", ()=>setLeagueBullionEntryLockResolved);
parcelHelpers.export(exports, "subscribeLeagueBullionEntryLock", ()=>subscribeLeagueBullionEntryLock);
/** Ensure a fresh(ish) config is loaded; safe to call from effects. */ parcelHelpers.export(exports, "ensureLeagueBullionEntryLockConfig", ()=>ensureLeagueBullionEntryLockConfig);
const TOSS_MODE_LOCK_WINDOW_MS = 1800000;
const CACHE_TTL_MS = 30000;
function readEnvDefaults() {
    const raw = String(undefined ?? "minutes").trim().toLowerCase();
    const mode = raw === "toss" ? "toss" : "minutes";
    const minutesRaw = parseInt(String(undefined ?? ""), 10);
    if (Number.isFinite(minutesRaw) && minutesRaw >= 0) return {
        mode,
        minutes: minutesRaw
    };
    const msRaw = parseInt(String(undefined ?? ""), 10);
    if (Number.isFinite(msRaw) && msRaw >= 0) return {
        mode,
        minutes: Math.max(0, Math.round(msRaw / 60000))
    };
    return {
        mode,
        minutes: 5
    };
}
function normalizeLeagueBullionEntryLockConfig(raw, defaults = readEnvDefaults()) {
    const modeRaw = String(raw?.mode ?? defaults.mode).trim().toLowerCase();
    const mode = modeRaw === "toss" ? "toss" : "minutes";
    const minutesNum = Number(raw?.minutes);
    const minutes = Number.isFinite(minutesNum) && minutesNum >= 0 ? Math.min(180, Math.floor(minutesNum)) : defaults.minutes;
    return {
        mode,
        minutes
    };
}
function resolveLeagueBullionEntryLock(config) {
    const normalized = normalizeLeagueBullionEntryLockConfig(config);
    const lockOnTossStatus = normalized.mode === "toss";
    const windowMs = lockOnTossStatus ? TOSS_MODE_LOCK_WINDOW_MS : Math.max(0, normalized.minutes) * 60000;
    let whenLabel;
    if (normalized.mode === "toss") whenLabel = "at toss";
    else if (normalized.minutes === 1) whenLabel = "1 minute before first ball";
    else whenLabel = `${normalized.minutes} minutes before first ball`;
    const untilLabel = normalized.mode === "toss" ? "until toss" : `until ${whenLabel}`;
    const playSlipLockedMessage = normalized.mode === "toss" ? "Bullion entry closed at toss. A lucky dip is issued automatically if you have not entered." : `Bullion entry closed ${whenLabel}. A lucky dip is issued automatically if you have not entered.`;
    return {
        mode: normalized.mode,
        minutes: normalized.minutes,
        windowMs,
        lockOnTossStatus,
        whenLabel,
        untilLabel,
        playSlipLockedMessage
    };
}
const DEFAULT_LEAGUE_BULLION_ENTRY_LOCK = resolveLeagueBullionEntryLock(readEnvDefaults());
let runtimeResolved = DEFAULT_LEAGUE_BULLION_ENTRY_LOCK;
let cacheAt = 0;
let inflight = null;
const listeners = new Set();
function getLeagueBullionEntryLockResolved() {
    return runtimeResolved;
}
function setLeagueBullionEntryLockResolved(resolved) {
    runtimeResolved = resolved;
    cacheAt = Date.now();
    for (const listener of listeners)listener();
}
function subscribeLeagueBullionEntryLock(listener) {
    listeners.add(listener);
    return ()=>{
        listeners.delete(listener);
    };
}
async function fetchLeagueBullionEntryLock() {
    const base = String("https://cricket8.com/api").replace(/\/$/, "");
    if (!base) return DEFAULT_LEAGUE_BULLION_ENTRY_LOCK;
    try {
        const res = await fetch(`${base}/leagues/bullion-entry-lock`, {
            method: "GET"
        });
        if (!res.ok) return DEFAULT_LEAGUE_BULLION_ENTRY_LOCK;
        const data = await res.json();
        const config = normalizeLeagueBullionEntryLockConfig({
            mode: data.mode,
            minutes: data.minutes
        });
        return resolveLeagueBullionEntryLock(config);
    } catch  {
        return DEFAULT_LEAGUE_BULLION_ENTRY_LOCK;
    }
}
async function ensureLeagueBullionEntryLockConfig(force = false) {
    const now = Date.now();
    if (!force && cacheAt > 0 && now - cacheAt < CACHE_TTL_MS) return runtimeResolved;
    if (!inflight) inflight = fetchLeagueBullionEntryLock().then((resolved)=>{
        setLeagueBullionEntryLockResolved(resolved);
        return resolved;
    }).finally(()=>{
        inflight = null;
    });
    return inflight;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6plTO":[function(require,module,exports,__globalThis) {
/**
 * League XP preview math — mirrors backend finalize in `leaguesLifecycle` /
 * `leagueXpMath.js`. Kept separate from `leagueFormat` to avoid a cycle with
 * `leaguePlays` (settled points).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Game types this user tops among eligible members (settled points only; ties share).
 * Mirrors backend `leagueGameWinnersByGame`.
 */ parcelHelpers.export(exports, "leagueGameWinsForRow", ()=>leagueGameWinsForRow);
/**
 * XP breakdown for a standings row. Score XP tracks live points once the league
 * has started; game-win and podium bonuses apply when those results are known
 * (settled game tops / ended podium). Idle seats (no settled plays) get 0.
 */ parcelHelpers.export(exports, "leagueXpBreakdownForRow", ()=>leagueXpBreakdownForRow);
/** One-line XP reason string for the ended footer. */ parcelHelpers.export(exports, "formatLeagueXpBreakdownLine", ()=>formatLeagueXpBreakdownLine);
/**
 * Total XP a row has earned (or will earn at settle). Matches finalize grants in
 * `leaguesLifecycle`.
 */ parcelHelpers.export(exports, "leagueXpForRow", ()=>leagueXpForRow);
var _constants = require("./constants");
var _leagueFormat = require("./leagueFormat");
var _leaguePlays = require("./leaguePlays");
function leagueScoreXpFromPoints(points) {
    const pts = Math.max(0, Math.floor(Number(points) || 0));
    const raw = Math.floor(pts * ((0, _constants.LEAGUE_XP_POINTS_PCT) / 100));
    const xp = Math.min(raw, (0, _constants.LEAGUE_XP_POINTS_CAP));
    return {
        xp,
        raw,
        capped: xp < raw,
        points: pts
    };
}
/** Eligible standings order: ≥1 settled play (same gate as prize / XP finalize). */ function leagueXpEligibleRows(league) {
    const settledUsers = new Set();
    for (const play of league.plays)if (play.status === "settled") settledUsers.add(play.userId);
    return (0, _leagueFormat.leagueTableRows)(league).filter((entry)=>settledUsers.has(entry.userId));
}
function leagueGameWinsForRow(league, userId) {
    const eligible = new Set(leagueXpEligibleRows(league).map((row)=>row.userId));
    if (!eligible.has(userId)) return [];
    const byGame = new Map();
    for (const play of league.plays){
        if (play.status !== "settled" || !eligible.has(play.userId)) continue;
        const pts = (0, _leaguePlays.leaguePlaySettledPoints)(play);
        if (pts <= 0) continue;
        let userMap = byGame.get(play.game);
        if (!userMap) {
            userMap = new Map();
            byGame.set(play.game, userMap);
        }
        userMap.set(play.userId, (userMap.get(play.userId) ?? 0) + pts);
    }
    const wins = [];
    for (const game of (0, _constants.LEAGUE_GAME_KEYS)){
        const userMap = byGame.get(game);
        if (!userMap) continue;
        let best = 0;
        for (const pts of userMap.values())if (pts > best) best = pts;
        if (best <= 0) continue;
        if ((userMap.get(userId) ?? 0) === best) wins.push(game);
    }
    return wins;
}
function leagueXpBreakdownForRow(league, row, now = Date.now()) {
    if (!(0, _leagueFormat.isLeagueXpLive)(league, now)) return {
        total: 0,
        parts: []
    };
    const settledCount = league.plays.filter((p)=>p.userId === row.userId && p.status === "settled").length;
    if (settledCount <= 0) return {
        total: 0,
        parts: []
    };
    const parts = [];
    const score = leagueScoreXpFromPoints(row.wonPoints);
    if (score.xp > 0) parts.push({
        kind: "points",
        xp: score.xp,
        points: score.points,
        capped: score.capped,
        label: `${score.xp} XP from ${score.points.toLocaleString("en-US")} pts from League play`
    });
    for (const game of leagueGameWinsForRow(league, row.userId)){
        if ((0, _constants.LEAGUE_XP_GAME_WIN) <= 0) break;
        const meta = (0, _constants.LEAGUE_GAME_META)[game];
        parts.push({
            kind: "game_win",
            xp: (0, _constants.LEAGUE_XP_GAME_WIN),
            game,
            label: `${(0, _constants.LEAGUE_XP_GAME_WIN)} ${meta?.label ?? game} win`
        });
    }
    if ((0, _leagueFormat.leagueStatus)(league, now) === "ended") {
        const eligible = leagueXpEligibleRows(league);
        const podiumIndex = eligible.findIndex((entry)=>entry.userId === row.userId);
        if (podiumIndex >= 0 && podiumIndex < (0, _constants.LEAGUE_XP_PLACEMENT_BONUS).length) {
            const bonus = (0, _constants.LEAGUE_XP_PLACEMENT_BONUS)[podiumIndex] ?? 0;
            if (bonus > 0) {
                const place = podiumIndex + 1;
                const placeLabel = place === 1 ? "1st" : place === 2 ? "2nd" : place === 3 ? "3rd" : `${place}th`;
                parts.push({
                    kind: "placement",
                    xp: bonus,
                    place,
                    label: `${bonus} for ${placeLabel}`
                });
            }
        }
    }
    return {
        total: parts.reduce((sum, part)=>sum + part.xp, 0),
        parts
    };
}
function formatLeagueXpBreakdownLine(breakdown) {
    return breakdown.parts.map((part)=>part.label).join(" \xb7 ");
}
function leagueXpForRow(league, row, now = Date.now()) {
    return leagueXpBreakdownForRow(league, row, now).total;
}

},{"./constants":"dZVub","./leagueFormat":"jKCIi","./leaguePlays":"iWKr6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8M1NW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEAGUE_REACTION_ACTIVITY_CAP", ()=>(0, _leagueReactionsTs.LEAGUE_REACTION_ACTIVITY_CAP));
parcelHelpers.export(exports, "LEAGUE_REACTION_FEED_CAP", ()=>(0, _leagueReactionsTs.LEAGUE_REACTION_FEED_CAP));
/** Prepend a throw onto the Activity list; skip duplicates and keep a short window. */ parcelHelpers.export(exports, "prependLeagueReactionEvent", ()=>prependLeagueReactionEvent);
parcelHelpers.export(exports, "leagueReactionActivityFromThrow", ()=>leagueReactionActivityFromThrow);
parcelHelpers.export(exports, "emptyMemberReactions", ()=>emptyMemberReactions);
parcelHelpers.export(exports, "normalizeMemberReactions", ()=>normalizeMemberReactions);
parcelHelpers.export(exports, "memberReactionsReceivedTotal", ()=>memberReactionsReceivedTotal);
/** Emoji this member has received the most of (null if none). */ parcelHelpers.export(exports, "memberTopReceivedEmoji", ()=>memberTopReceivedEmoji);
parcelHelpers.export(exports, "applyMemberReactionSent", ()=>applyMemberReactionSent);
parcelHelpers.export(exports, "applyMemberReactionReceived", ()=>applyMemberReactionReceived);
/** Bump sender sent + target received on a league snapshot (idempotent at the call site). */ parcelHelpers.export(exports, "applyLeagueReactionToMembers", ()=>applyLeagueReactionToMembers);
parcelHelpers.export(exports, "LEAGUE_REACTION_AWARD_CAP", ()=>LEAGUE_REACTION_AWARD_CAP);
/**
 * Ended-league fun callouts — one winner per emoji (ties: lower userId).
 * Omitted when nobody has received that emoji yet.
 * Sorted by count desc so the loudest banter leads; every emoji with receives is included.
 */ parcelHelpers.export(exports, "leagueReactionCallouts", ()=>leagueReactionCallouts);
parcelHelpers.export(exports, "reactionCalloutGlyph", ()=>reactionCalloutGlyph);
/** Top received emojis for a leaderboard stack (highest count first). */ parcelHelpers.export(exports, "memberReceivedStack", ()=>memberReceivedStack);
/** Viewer's throw/receive summary for Mine / ended surfaces. */ parcelHelpers.export(exports, "leagueViewerBanterSummary", ()=>leagueViewerBanterSummary);
parcelHelpers.export(exports, "LEAGUE_BANTER_CALLOUT_ROTATE_MS", ()=>LEAGUE_BANTER_CALLOUT_ROTATE_MS);
parcelHelpers.export(exports, "LEAGUE_REACTION_HEAT_WINDOW_MS", ()=>LEAGUE_REACTION_HEAT_WINDOW_MS);
parcelHelpers.export(exports, "LEAGUE_REACTION_HEAT_MIN_HITS", ()=>LEAGUE_REACTION_HEAT_MIN_HITS);
var _leagueReactionsTs = require("./leagueReactions.ts");
function prependLeagueReactionEvent(events, event) {
    if (events?.some((row)=>row.id === event.id)) return events;
    return [
        event,
        ...events ?? []
    ].slice(0, (0, _leagueReactionsTs.LEAGUE_REACTION_ACTIVITY_CAP));
}
function leagueReactionActivityFromThrow(input) {
    const { reactionId, members, fromUserId, targetUserId, emoji } = input;
    if (!reactionId || fromUserId === targetUserId) return null;
    const from = members.find((m)=>m.userId === fromUserId);
    const target = members.find((m)=>m.userId === targetUserId);
    return {
        id: reactionId,
        at: input.at ?? new Date().toISOString(),
        fromUserId,
        fromPlayerName: from?.playerName?.trim() || input.fromPlayerName?.trim() || `Player ${fromUserId}`,
        targetUserId,
        targetPlayerName: target?.playerName?.trim() || `Player ${targetUserId}`,
        emoji
    };
}
function emptyMemberReactions() {
    return {
        sent: 0,
        received: {
            poop: 0,
            rofl: 0,
            rocket: 0,
            fire: 0,
            clap: 0,
            cry: 0
        }
    };
}
function normalizeMemberReactions(raw) {
    const base = emptyMemberReactions();
    if (!raw || typeof raw !== "object") return base;
    const sent = Math.max(0, Math.floor(Number(raw.sent) || 0));
    const received = {
        ...base.received
    };
    for (const emoji of (0, _leagueReactionsTs.LEAGUE_REACTION_EMOJI_OPTIONS))received[emoji] = Math.max(0, Math.floor(Number(raw.received?.[emoji]) || 0));
    return {
        sent,
        received
    };
}
function memberReactionsReceivedTotal(stats) {
    return (0, _leagueReactionsTs.LEAGUE_REACTION_EMOJI_OPTIONS).reduce((sum, emoji)=>sum + stats.received[emoji], 0);
}
function memberTopReceivedEmoji(stats) {
    let best = null;
    let bestCount = 0;
    for (const emoji of (0, _leagueReactionsTs.LEAGUE_REACTION_EMOJI_OPTIONS)){
        const n = stats.received[emoji];
        if (n > bestCount) {
            best = emoji;
            bestCount = n;
        }
    }
    return bestCount > 0 ? best : null;
}
function applyMemberReactionSent(stats) {
    return {
        ...stats,
        sent: stats.sent + 1
    };
}
function applyMemberReactionReceived(stats, emoji) {
    return {
        ...stats,
        received: {
            ...stats.received,
            [emoji]: stats.received[emoji] + 1
        }
    };
}
function applyLeagueReactionToMembers(members, input) {
    const { fromUserId, targetUserId, emoji } = input;
    if (fromUserId === targetUserId) return members;
    return members.map((member)=>{
        if (member.userId === fromUserId) return {
            ...member,
            reactions: applyMemberReactionSent(normalizeMemberReactions(member.reactions))
        };
        if (member.userId === targetUserId) return {
            ...member,
            reactions: applyMemberReactionReceived(normalizeMemberReactions(member.reactions), emoji)
        };
        return member;
    });
}
const CALLOUT_DEFS = [
    {
        kind: "roasted",
        emoji: "poop",
        label: "Most roasted"
    },
    {
        kind: "laughed",
        emoji: "rofl",
        label: "Most laughed at"
    },
    {
        kind: "hyped",
        emoji: "rocket",
        label: "Most hyped"
    },
    {
        kind: "on_fire",
        emoji: "fire",
        label: "Most on fire"
    },
    {
        kind: "respected",
        emoji: "clap",
        label: "Most respected"
    },
    {
        kind: "saltiest",
        emoji: "cry",
        label: "Most salt"
    }
];
const LEAGUE_REACTION_AWARD_CAP = CALLOUT_DEFS.length;
function leagueReactionCallouts(league) {
    const out = [];
    for (const def of CALLOUT_DEFS){
        let winner = null;
        let best = 0;
        for (const member of league.members){
            const n = normalizeMemberReactions(member.reactions).received[def.emoji];
            if (n <= 0) continue;
            if (n > best || n === best && winner != null && member.userId < winner.userId || n === best && winner == null) {
                best = n;
                winner = member;
            }
        }
        if (!winner || best <= 0) continue;
        out.push({
            kind: def.kind,
            emoji: def.emoji,
            label: def.label,
            count: best,
            member: {
                userId: winner.userId,
                playerName: winner.playerName,
                avatar: winner.avatar,
                avatarFrameUrl: winner.avatarFrameUrl ?? null,
                avatarFrameSmallUrl: winner.avatarFrameSmallUrl ?? null,
                xpWeekCrown: winner.xpWeekCrown
            }
        });
    }
    return out.sort((a, b)=>{
        if (b.count !== a.count) return b.count - a.count;
        return a.member.userId - b.member.userId;
    });
}
function reactionCalloutGlyph(emoji) {
    return (0, _leagueReactionsTs.LEAGUE_REACTION_GLYPH)[emoji];
}
function memberReceivedStack(stats, limit = 3) {
    const normalized = normalizeMemberReactions(stats);
    const take = Math.max(0, Math.floor(limit));
    return (0, _leagueReactionsTs.LEAGUE_REACTION_EMOJI_OPTIONS).map((emoji)=>({
            emoji,
            count: normalized.received[emoji]
        })).filter((row)=>row.count > 0).sort((a, b)=>{
        if (b.count !== a.count) return b.count - a.count;
        return a.emoji.localeCompare(b.emoji);
    }).slice(0, take);
}
function leagueViewerBanterSummary(league) {
    const me = league.members.find((m)=>m.isViewer);
    if (!me) return null;
    const stats = normalizeMemberReactions(me.reactions);
    const receivedTotal = memberReactionsReceivedTotal(stats);
    if (stats.sent <= 0 && receivedTotal <= 0) return null;
    return {
        sent: stats.sent,
        receivedTotal,
        stack: memberReceivedStack(stats, 4)
    };
}
const LEAGUE_BANTER_CALLOUT_ROTATE_MS = 5500;
const LEAGUE_REACTION_HEAT_WINDOW_MS = 8000;
const LEAGUE_REACTION_HEAT_MIN_HITS = 3;

},{"./leagueReactions.ts":"eP1Fb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eP1Fb":[function(require,module,exports,__globalThis) {
/** Live SSE throws plus catch-up rows so offline targets still see them on Leagues open. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEAGUE_REACTION_EVENT", ()=>LEAGUE_REACTION_EVENT);
parcelHelpers.export(exports, "LEAGUE_REACTION_GLYPH", ()=>LEAGUE_REACTION_GLYPH);
parcelHelpers.export(exports, "LEAGUE_REACTION_EMOJI_OPTIONS", ()=>LEAGUE_REACTION_EMOJI_OPTIONS);
parcelHelpers.export(exports, "LEAGUE_REACTION_ACTIVITY_CAP", ()=>LEAGUE_REACTION_ACTIVITY_CAP);
parcelHelpers.export(exports, "LEAGUE_REACTION_FEED_CAP", ()=>LEAGUE_REACTION_FEED_CAP);
parcelHelpers.export(exports, "isLeagueReactionEmoji", ()=>isLeagueReactionEmoji);
/** Normalize an SSE / API payload into a typed reaction, or null if invalid. */ parcelHelpers.export(exports, "parseLeagueReactionPayload", ()=>parseLeagueReactionPayload);
parcelHelpers.export(exports, "newLocalReactionId", ()=>newLocalReactionId);
parcelHelpers.export(exports, "LEAGUE_REACTION_MIN_INTERVAL_MS", ()=>LEAGUE_REACTION_MIN_INTERVAL_MS);
/** Returns false when another throw from this tab is still inside the cooldown. */ parcelHelpers.export(exports, "tryConsumeLeagueReactionThrowSlot", ()=>tryConsumeLeagueReactionThrowSlot);
/** Broadcast a reaction to any mounted leaderboard (SSE bridge uses the same event). */ parcelHelpers.export(exports, "dispatchLeagueReaction", ()=>dispatchLeagueReaction);
/** Subscribe to cross-tab demo throws. Returns an unsubscribe. */ parcelHelpers.export(exports, "subscribeLeagueReactionBroadcast", ()=>subscribeLeagueReactionBroadcast);
/**
 * `/leaguesdemo` helper: invent an incoming throw from a peer.
 * Prefers targeting the viewer so you can see the receive animation on your row.
 */ parcelHelpers.export(exports, "simulateIncomingLeagueReaction", ()=>simulateIncomingLeagueReaction);
const LEAGUE_REACTION_EVENT = "c8-league-reaction";
const LEAGUE_REACTION_GLYPH = {
    poop: "\uD83D\uDCA9",
    rofl: "\uD83E\uDD23",
    rocket: "\uD83D\uDE80",
    fire: "\uD83D\uDD25",
    clap: "\uD83D\uDC4F",
    cry: "\uD83D\uDE2D"
};
const LEAGUE_REACTION_EMOJI_OPTIONS = [
    "poop",
    "rofl",
    "rocket",
    "fire",
    "clap",
    "cry"
];
const LEAGUE_REACTION_ACTIVITY_CAP = 60;
const LEAGUE_REACTION_FEED_CAP = 20;
function isLeagueReactionEmoji(value) {
    return value === "poop" || value === "rofl" || value === "rocket" || value === "fire" || value === "clap" || value === "cry";
}
function parseLeagueReactionPayload(raw) {
    if (!raw || typeof raw !== "object") return null;
    const o = raw;
    const reactionId = String(o.reactionId ?? "").trim();
    const leagueId = String(o.leagueId ?? "").trim();
    const fromUserId = parseInt(String(o.fromUserId ?? ""), 10);
    const targetUserId = parseInt(String(o.targetUserId ?? ""), 10);
    const fromPlayerName = String(o.fromPlayerName ?? "").trim();
    const emoji = o.emoji;
    if (!reactionId || !leagueId) return null;
    if (!Number.isFinite(fromUserId) || fromUserId <= 0) return null;
    if (!Number.isFinite(targetUserId) || targetUserId <= 0) return null;
    if (!isLeagueReactionEmoji(emoji)) return null;
    const extraRaw = parseInt(String(o.extraCount ?? ""), 10);
    const extraCount = Number.isFinite(extraRaw) && extraRaw > 0 ? extraRaw : 0;
    return {
        reactionId,
        leagueId,
        fromUserId,
        fromPlayerName: fromPlayerName || `Player ${fromUserId}`,
        targetUserId,
        emoji,
        ...extraCount > 0 ? {
            extraCount
        } : {}
    };
}
function newLocalReactionId() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    return `local-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
const LEAGUE_REACTION_MIN_INTERVAL_MS = 1000;
let lastLocalThrowAt = 0;
function tryConsumeLeagueReactionThrowSlot() {
    const now = Date.now();
    if (now - lastLocalThrowAt < LEAGUE_REACTION_MIN_INTERVAL_MS) return false;
    lastLocalThrowAt = now;
    return true;
}
const REACTION_BROADCAST = "c8-league-reaction-bc";
function dispatchLeagueReaction(payload) {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent(LEAGUE_REACTION_EVENT, {
        detail: payload
    }));
    // Demo / multi-tab: mirror so every open board sees peer throws without SSE.
    try {
        const channel = new BroadcastChannel(REACTION_BROADCAST);
        channel.postMessage(payload);
        channel.close();
    } catch  {
    /* BroadcastChannel unavailable */ }
}
function subscribeLeagueReactionBroadcast(onReaction) {
    if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") return ()=>{};
    let channel;
    try {
        channel = new BroadcastChannel(REACTION_BROADCAST);
    } catch  {
        return ()=>{};
    }
    const handler = (ev)=>{
        const parsed = parseLeagueReactionPayload(ev.data);
        if (parsed) onReaction(parsed);
    };
    channel.addEventListener("message", handler);
    return ()=>{
        channel.removeEventListener("message", handler);
        channel.close();
    };
}
function simulateIncomingLeagueReaction(leagueId, members, opts) {
    const peers = members.filter((m)=>!m.isViewer);
    if (peers.length === 0) return null;
    const from = peers[Math.floor(Math.random() * peers.length)];
    const viewer = members.find((m)=>m.isViewer);
    const candidates = members.filter((m)=>m.userId !== from.userId);
    if (candidates.length === 0) return null;
    let target = opts?.targetUserId != null ? candidates.find((m)=>m.userId === opts.targetUserId) ?? null : null;
    // Prefer a mix: sometimes the viewer, otherwise any peer — so the whole board lights up.
    if (!target && viewer && viewer.userId !== from.userId && Math.random() < 0.4) target = viewer;
    if (!target) target = candidates[Math.floor(Math.random() * candidates.length)];
    const emoji = opts?.emoji ?? LEAGUE_REACTION_EMOJI_OPTIONS[Math.floor(Math.random() * LEAGUE_REACTION_EMOJI_OPTIONS.length)];
    const payload = {
        reactionId: newLocalReactionId(),
        leagueId,
        fromUserId: from.userId,
        fromPlayerName: from.playerName,
        targetUserId: target.userId,
        emoji
    };
    dispatchLeagueReaction(payload);
    // Keep demo standings tallies in sync with simulated throws.
    require("41913903fa849889").then((m)=>{
        m.recordPrototypeLeagueReaction({
            leagueId,
            reactionId: payload.reactionId,
            fromUserId: payload.fromUserId,
            targetUserId: payload.targetUserId,
            emoji: payload.emoji
        });
    });
    return payload;
}

},{"41913903fa849889":"3Is0d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Is0d":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("dMpsE"));

},{}],"eHIe3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Decode `back=/squares?match=&invitedBy=` from login/signup query and persist invite. */ parcelHelpers.export(exports, "persistSquaresLinkInviteFromBackParam", ()=>persistSquaresLinkInviteFromBackParam);
/** If URL has match + invitedBy, remember for post-login claim (e.g. new signup). */ parcelHelpers.export(exports, "persistSquaresLinkInviteFromSearch", ()=>persistSquaresLinkInviteFromSearch);
/** Current page `?search` plus optional `back=` pointing at a Squares invite link. */ parcelHelpers.export(exports, "persistSquaresInviteFromRouterSearch", ()=>persistSquaresInviteFromRouterSearch);
/** Drop pending Squares invite (e.g. user opened `/bullion?match=&invitedBy=` — same params as Squares). */ parcelHelpers.export(exports, "clearSquaresLinkInvitePendingFromStorage", ()=>clearSquaresLinkInvitePendingFromStorage);
/**
 * After login, create squares_match_challenge from a shared Play-with-a-friend link (if pending).
 * Clears storage only on success so transient failures retry.
 * @param analyticsUserIdHint — logged-in user id for analytics (falls back to in-memory analytics id).
 */ parcelHelpers.export(exports, "tryClaimSquaresLinkInviteFromStorage", ()=>tryClaimSquaresLinkInviteFromStorage);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _analyticsIdentity = require("./analyticsIdentity");
var _authHeaders = require("./authHeaders");
var _frontendTrackingEvents = require("./frontendTrackingEvents");
const STORAGE_KEY = "c8_squares_pending_link_invite";
function persistSquaresLinkInviteFromBackParam(back) {
    if (!back || typeof back !== "string") return;
    const trimmed = back.trim();
    if (!trimmed) return;
    const withSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
    if (!withSlash.startsWith("/squares")) return;
    const qIndex = withSlash.indexOf("?");
    if (qIndex === -1) return;
    persistSquaresLinkInviteFromSearch(withSlash.slice(qIndex));
}
function persistSquaresLinkInviteFromSearch(search) {
    try {
        const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
        const match = params.get("match");
        const invitedBy = params.get("invitedBy") || params.get("invited_by");
        if (!match?.trim() || !invitedBy?.trim()) return;
        const payload = {
            matchId: match.trim(),
            inviterPlayerId: invitedBy.trim()
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch  {
    /* ignore */ }
}
function persistSquaresInviteFromRouterSearch(search) {
    persistSquaresLinkInviteFromSearch(search);
    try {
        const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
        persistSquaresLinkInviteFromBackParam(params.get("back"));
    } catch  {
    /* ignore */ }
}
function clearSquaresLinkInvitePendingFromStorage() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch  {
    /* ignore */ }
}
function readPending() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const o = JSON.parse(raw);
        if (!o?.matchId || !o?.inviterPlayerId) return null;
        return {
            matchId: String(o.matchId).trim(),
            inviterPlayerId: String(o.inviterPlayerId).trim()
        };
    } catch  {
        return null;
    }
}
async function tryClaimSquaresLinkInviteFromStorage(analyticsUserIdHint) {
    const pending = readPending();
    if (!pending) return;
    if (!(0, _jsCookieDefault.default).get("c8_session_token") && !(0, _authHeaders.getJwt)()) return;
    try {
        const res = await fetch(`${"https://cricket8.com/api"}/account/squares-invite-from-link/claim`, {
            method: "POST",
            headers: (0, _authHeaders.getAuthHeaders)(),
            body: JSON.stringify({
                match_id: pending.matchId,
                inviter_player_id: pending.inviterPlayerId
            })
        });
        if (res.ok) {
            sessionStorage.removeItem(STORAGE_KEY);
            const uid = analyticsUserIdHint ?? (0, _analyticsIdentity.getAnalyticsUserId)();
            (0, _frontendTrackingEvents.trackFriendJoinedFromInvite)({
                user_id: uid != null && String(uid).trim() !== "" ? uid : undefined,
                invite_method: "link",
                game_type: "squares",
                visibility: "public",
                entry_point: "squares_lobby",
                fixture_id: pending.matchId,
                pathname: typeof window !== "undefined" ? window.location.pathname : "/squares"
            });
            return;
        }
        if (res.status === 400) {
            const j = await res.json().catch(()=>({}));
            const err = j?.error;
            if (err === "match_not_eligible" || err === "inviter_not_found" || err === "self") sessionStorage.removeItem(STORAGE_KEY);
        }
    } catch  {
    /* keep pending for retry */ }
}

},{"js-cookie":"2P5RE","./analyticsIdentity":"10oOL","./authHeaders":"5Rczo","./frontendTrackingEvents":"4Y90p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ibsbk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Remember a team to favourite after the guest signs up or logs in. */ parcelHelpers.export(exports, "persistPendingFavouriteTeam", ()=>persistPendingFavouriteTeam);
/** Capture `?favteam=` from login/signup (or any) search string. */ parcelHelpers.export(exports, "persistPendingFavouriteTeamFromSearch", ()=>persistPendingFavouriteTeamFromSearch);
parcelHelpers.export(exports, "readPendingFavouriteTeam", ()=>readPendingFavouriteTeam);
parcelHelpers.export(exports, "clearPendingFavouriteTeam", ()=>clearPendingFavouriteTeam);
/** Signup URL that carries the team through auth and returns the guest to `backPath`. */ parcelHelpers.export(exports, "signupPathForFavouriteTeam", ()=>signupPathForFavouriteTeam);
/**
 * After auth, add the pending team to favourites (always an add, never a remove).
 * Clears storage only on success so a transient failure can retry.
 */ parcelHelpers.export(exports, "tryClaimPendingFavouriteTeamFromStorage", ()=>tryClaimPendingFavouriteTeamFromStorage);
var _authHeaders = require("./authHeaders");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _favouriteTeams = require("./favouriteTeams");
const STORAGE_KEY = "c8_pending_favourite_team";
const MAX_TEAM_NAME_LENGTH = 80;
function sanitizeTeamName(raw) {
    return String(raw || "").replace(/,/g, " ").replace(/\s+/g, " ").trim().slice(0, MAX_TEAM_NAME_LENGTH);
}
function persistPendingFavouriteTeam(teamName) {
    const name = sanitizeTeamName(teamName);
    if (!name) return;
    try {
        sessionStorage.setItem(STORAGE_KEY, name);
    } catch  {
    /* ignore */ }
}
function persistPendingFavouriteTeamFromSearch(search) {
    try {
        const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
        const team = params.get("favteam");
        if (team?.trim()) persistPendingFavouriteTeam(team);
    } catch  {
    /* ignore */ }
}
function readPendingFavouriteTeam() {
    try {
        const name = sanitizeTeamName(sessionStorage.getItem(STORAGE_KEY));
        return name || null;
    } catch  {
        return null;
    }
}
function clearPendingFavouriteTeam() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch  {
    /* ignore */ }
}
function signupPathForFavouriteTeam(teamName, backPath) {
    const name = sanitizeTeamName(teamName);
    const params = new URLSearchParams();
    if (name) params.set("favteam", name);
    const back = String(backPath || "").trim();
    if (back) params.set("back", back);
    const query = params.toString();
    return query ? `/signup?${query}` : "/signup";
}
async function tryClaimPendingFavouriteTeamFromStorage() {
    const name = readPendingFavouriteTeam();
    if (!name) return null;
    if (!(0, _jsCookieDefault.default).get("c8_session_token") && !(0, _authHeaders.getJwt)()) return null;
    const plan = (0, _favouriteTeams.buildFavouriteTeamToggle)({}, name);
    if (!plan) {
        clearPendingFavouriteTeam();
        return null;
    }
    try {
        const res = await fetch(`${"https://cricket8.com/api"}/account/favourite-teams/toggle`, {
            method: "POST",
            headers: (0, _authHeaders.getAuthHeaders)(),
            body: JSON.stringify({
                ops: plan.ops
            })
        });
        if (!res.ok) {
            if (res.status === 400 || res.status === 401 || res.status === 403) clearPendingFavouriteTeam();
            return null;
        }
        clearPendingFavouriteTeam();
        const data = await res.json();
        if (data.favourites && typeof data.favourites === "object") return {
            ...plan.next,
            ...data.favourites
        };
        return plan.next;
    } catch  {
        return null;
    }
}

},{"./authHeaders":"5Rczo","js-cookie":"2P5RE","./favouriteTeams":"fwQD0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5EJnb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEAGUE_ID_QUERY", ()=>LEAGUE_ID_QUERY);
parcelHelpers.export(exports, "LEAGUE_JOIN_CODE_QUERY", ()=>LEAGUE_JOIN_CODE_QUERY);
parcelHelpers.export(exports, "LEAGUE_DETAIL_ID_QUERY", ()=>LEAGUE_DETAIL_ID_QUERY);
parcelHelpers.export(exports, "LEAGUE_HUB_TAB_QUERY", ()=>LEAGUE_HUB_TAB_QUERY);
parcelHelpers.export(exports, "LEAGUE_HUB_LISTING_QUERY", ()=>LEAGUE_HUB_LISTING_QUERY);
parcelHelpers.export(exports, "LEAGUES_DEMO_PATH", ()=>LEAGUES_DEMO_PATH);
parcelHelpers.export(exports, "LEAGUE_BULLION_BATTLE_QUERY", ()=>LEAGUE_BULLION_BATTLE_QUERY);
parcelHelpers.export(exports, "readLeagueIdFromSearch", ()=>readLeagueIdFromSearch);
parcelHelpers.export(exports, "withLeagueId", ()=>withLeagueId);
/** Detail URL: `/leagues?id=` or `/leaguesdemo?id=` (query param keeps nginx SPA fallback happy on refresh). */ parcelHelpers.export(exports, "leagueDetailPath", ()=>leagueDetailPath);
parcelHelpers.export(exports, "readLeagueDetailIdFromSearch", ()=>readLeagueDetailIdFromSearch);
/** Join landing URL: `/leagues?code=` or `/leaguesdemo?code=`. */ parcelHelpers.export(exports, "leagueJoinPath", ()=>leagueJoinPath);
parcelHelpers.export(exports, "readLeagueJoinCodeFromSearch", ()=>readLeagueJoinCodeFromSearch);
/** Sharer public player id from `/leagues?code=&invitedBy=` (private-league auto-friend). */ parcelHelpers.export(exports, "readLeagueInvitedByFromSearch", ()=>readLeagueInvitedByFromSearch);
/** Hub URL: bare path = Public + Active; `?listing=private` / `?tab=past` as needed. */ parcelHelpers.export(exports, "leagueHubPath", ()=>leagueHubPath);
/** `past` / `ended` / `finished` → Past tab; anything else → Active. */ parcelHelpers.export(exports, "readLeagueHubTabFromSearch", ()=>readLeagueHubTabFromSearch);
/** `private` → Private listing; anything else → Public (default). */ parcelHelpers.export(exports, "readLeagueHubListingFromSearch", ()=>readLeagueHubListingFromSearch);
parcelHelpers.export(exports, "isLeaguesDemoPath", ()=>isLeaguesDemoPath);
/** League detail page: `/leagues?id=` or `/leaguesdemo?id=` (not the hub or join landing). */ parcelHelpers.export(exports, "isLeagueDetailPath", ()=>isLeagueDetailPath);
parcelHelpers.export(exports, "isLeagueGamePath", ()=>isLeagueGamePath);
parcelHelpers.export(exports, "leagueGameKeyFromPath", ()=>leagueGameKeyFromPath);
/** True when a league game route is in match/board play (not the game lobby). */ parcelHelpers.export(exports, "isLeagueGamePlayPath", ()=>isLeagueGamePlayPath);
/** Bare lobby path for the game route the viewer is on, e.g. `/trader`. */ parcelHelpers.export(exports, "leagueGameLobbyPathFromPathname", ()=>leagueGameLobbyPathFromPathname);
/** True when a game route is showing its lobby (no match/play identifier). */ parcelHelpers.export(exports, "isGameLobbyWithoutMatch", ()=>isGameLobbyWithoutMatch);
/**
 * Where the in-game back control should go while League mode is active.
 * Match leagues (and unknown ids — typical deep-link into play) return to the league detail.
 * Timed leagues return to that game's lobby still tagged with `?leagueId=`.
 * Returns null when not in League mode.
 */ parcelHelpers.export(exports, "resolveLeagueGameBackHref", ()=>resolveLeagueGameBackHref);
/** Match id used for league Sixes deep-links. Prototype fixtures keep their own India/WI demo id. */ parcelHelpers.export(exports, "leagueSixesPlayMatchId", ()=>leagueSixesPlayMatchId);
/**
 * Deep-link into the real game match-play UI for a league lobby.
 * Uses the live cricket event when available; demo match ids only
 * for leftover prototype leagues.
 */ parcelHelpers.export(exports, "leagueGamePlayUrl", ()=>leagueGamePlayUrl);
/** Open a game's own lobby while staying in League mode (duration leagues). */ parcelHelpers.export(exports, "leagueGameLobbyUrl", ()=>leagueGameLobbyUrl);
var _bullionDemoMatchFixtures = require("../../Bullion/lib/bullionDemoMatchFixtures");
var _squaresDemoMatchFixtures = require("../../Squares/lib/squaresDemoMatchFixtures");
var _sixesDemoMatch = require("../../Sixes/demo/sixesDemoMatch");
var _sixesCardRevealStorage = require("../../Sixes/lib/sixesCardRevealStorage");
var _leagueLiveFixtures = require("./leagueLiveFixtures");
const LEAGUE_ID_QUERY = "leagueId";
const LEAGUE_JOIN_CODE_QUERY = "code";
const LEAGUE_DETAIL_ID_QUERY = "id";
const LEAGUE_HUB_TAB_QUERY = "tab";
const LEAGUE_HUB_LISTING_QUERY = "listing";
const LEAGUES_DEMO_PATH = "/leaguesdemo";
const LEAGUE_BULLION_BATTLE_QUERY = "leagueBattle";
const GAME_PATHS = {
    sixes: "/sixes",
    bullion: "/bullion",
    squares: "/squares",
    trader: "/trader"
};
function readLeagueIdFromSearch(search) {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    const value = new URLSearchParams(raw).get(LEAGUE_ID_QUERY);
    return value?.trim() ? value.trim() : null;
}
function withLeagueId(path, leagueId) {
    const [pathname, query = ""] = path.split("?");
    const params = new URLSearchParams(query);
    params.set(LEAGUE_ID_QUERY, leagueId);
    const qs = params.toString();
    return qs ? `${pathname}?${qs}` : pathname;
}
function leagueDetailPath(leagueId, basePath = "/leagues") {
    const trimmed = leagueId.trim();
    if (!trimmed) return basePath;
    const params = new URLSearchParams();
    params.set(LEAGUE_DETAIL_ID_QUERY, trimmed);
    return `${basePath}?${params}`;
}
function readLeagueDetailIdFromSearch(search) {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    const value = new URLSearchParams(raw).get(LEAGUE_DETAIL_ID_QUERY);
    return value?.trim() ? value.trim() : null;
}
function leagueJoinPath(code, basePath = "/leagues", invitedBy = "") {
    const trimmed = code.trim();
    if (!trimmed) return basePath;
    const params = new URLSearchParams();
    params.set(LEAGUE_JOIN_CODE_QUERY, trimmed);
    const inviter = invitedBy.trim();
    if (inviter) params.set("invitedBy", inviter);
    return `${basePath}?${params}`;
}
function readLeagueJoinCodeFromSearch(search) {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    const value = new URLSearchParams(raw).get(LEAGUE_JOIN_CODE_QUERY);
    return value?.trim() ? value.trim() : null;
}
function readLeagueInvitedByFromSearch(search) {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    const params = new URLSearchParams(raw);
    const value = params.get("invitedBy") || params.get("invited_by");
    return value?.trim() ? value.trim() : null;
}
function leagueHubPath(tabOrOpts = "active", basePathArg = "/leagues") {
    const opts = typeof tabOrOpts === "string" ? {
        tab: tabOrOpts,
        basePath: basePathArg
    } : tabOrOpts;
    const tab = opts.tab ?? "active";
    const listing = opts.listing ?? "public";
    const basePath = opts.basePath ?? basePathArg;
    const params = new URLSearchParams();
    if (listing === "private") params.set(LEAGUE_HUB_LISTING_QUERY, "private");
    if (tab === "past") params.set(LEAGUE_HUB_TAB_QUERY, "past");
    const qs = params.toString();
    return qs ? `${basePath}?${qs}` : basePath;
}
function readLeagueHubTabFromSearch(search) {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    const value = new URLSearchParams(raw).get(LEAGUE_HUB_TAB_QUERY)?.trim().toLowerCase();
    if (value === "past" || value === "ended" || value === "finished") return "past";
    return "active";
}
function readLeagueHubListingFromSearch(search) {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    const value = new URLSearchParams(raw).get(LEAGUE_HUB_LISTING_QUERY)?.trim().toLowerCase();
    if (value === "private") return "private";
    return "public";
}
function isLeaguesDemoPath(pathname) {
    return pathname === LEAGUES_DEMO_PATH || pathname.startsWith(`${LEAGUES_DEMO_PATH}/`);
}
function isLeagueDetailPath(pathname, search = "") {
    const base = isLeaguesDemoPath(pathname) ? LEAGUES_DEMO_PATH : "/leagues";
    const normalized = pathname.replace(/\/$/, "") || "/";
    if (normalized !== base) return false;
    return Boolean(readLeagueDetailIdFromSearch(search));
}
function isLeagueGamePath(pathname) {
    return Object.values(GAME_PATHS).some((path)=>pathname === path || pathname.startsWith(`${path}/`));
}
function leagueGameKeyFromPath(pathname) {
    if (pathname === "/sixes" || pathname.startsWith("/sixes/")) return "sixes";
    if (pathname === "/bullion" || pathname.startsWith("/bullion/")) return "bullion";
    if (pathname === "/squares" || pathname.startsWith("/squares/")) return "squares";
    if (pathname === "/trader" || pathname.startsWith("/trader/")) return "trader";
    return null;
}
function isLeagueGamePlayPath(pathname, search) {
    return isLeagueGamePath(pathname) && !isGameLobbyWithoutMatch(pathname, search);
}
function leagueGameLobbyPathFromPathname(pathname) {
    const key = leagueGameKeyFromPath(pathname);
    return key ? GAME_PATHS[key] : "/trader";
}
function isGameLobbyWithoutMatch(pathname, search) {
    const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
    const game = leagueGameKeyFromPath(pathname);
    if (game === "sixes") return !params.get("match") && !params.get("matchId");
    if (game === "bullion") return !params.get("match") && !params.get("game") && !params.get("demo");
    if (game === "squares") return !params.get("match");
    if (game === "trader") return !params.get("matchId") && !params.get("raceId");
    return false;
}
function resolveLeagueGameBackHref(options) {
    const id = String(options.leagueId || "").trim();
    if (!id) return null;
    const league = options.findLeague(id);
    if (!league || league.scope === "match") return leagueDetailPath(id, options.leagueBasePath);
    return withLeagueId(options.gameLobbyPath, id);
}
/** Real cricket event id, or null for proto/demo fixtures that cannot load play pages. */ function realMatchId(fixtureId) {
    const id = fixtureId.trim();
    if (!id || (0, _leagueLiveFixtures.isPrototypeFixtureId)(id)) return null;
    return id;
}
function resolvedPlayMatchId(fixtureId, liveMatchId) {
    const live = String(liveMatchId || "").trim();
    if (live && !(0, _leagueLiveFixtures.isPrototypeFixtureId)(live)) return live;
    return realMatchId(fixtureId);
}
function leagueSixesPlayMatchId(fixtureId, liveMatchId) {
    const trimmed = fixtureId.trim();
    if ((0, _leagueLiveFixtures.isPrototypeFixtureId)(trimmed)) return trimmed;
    return resolvedPlayMatchId(fixtureId, liveMatchId) ?? (0, _sixesDemoMatch.SIXES_DEMO_MATCH_ID);
}
function leagueGamePlayUrl(league, game, options) {
    const fixtureId = league.fixture?.id?.trim() ?? "";
    const matchId = resolvedPlayMatchId(fixtureId, options?.matchId);
    switch(game){
        case "trader":
            {
                const params = new URLSearchParams();
                params.set(LEAGUE_ID_QUERY, league.id);
                params.set("sport", "cricket");
                params.set("matchId", matchId ?? (fixtureId || "league-match"));
                return `/trader?${params}`;
            }
        case "squares":
            {
                const prototypeLive = (0, _leagueLiveFixtures.isPrototypeFixtureId)(fixtureId) && (options?.leagueStatus ?? league.status) === "live";
                const match = (0, _leagueLiveFixtures.isPrototypeFixtureId)(fixtureId) ? fixtureId : (0, _squaresDemoMatchFixtures.SQUARES_DEMO_MATCH_ENABLED) && (prototypeLive || !matchId) ? (0, _squaresDemoMatchFixtures.SQUARES_DEMO_MATCH_ID) : matchId ?? fixtureId;
                const params = new URLSearchParams();
                params.set(LEAGUE_ID_QUERY, league.id);
                params.set("match", match);
                return `/squares?${params}`;
            }
        case "bullion":
            {
                if (matchId) {
                    const params = new URLSearchParams();
                    params.set(LEAGUE_ID_QUERY, league.id);
                    params.set("match", matchId);
                    return `/bullion?${params}`;
                }
                // Prototype leftover: shared battle on the demo pick board.
                const params = new URLSearchParams();
                const [pathname, query = ""] = (0, _bullionDemoMatchFixtures.BULLION_DEMO_MATCH_FLOW_PATH).split("?");
                new URLSearchParams(query).forEach((value, key)=>params.set(key, value));
                params.set(LEAGUE_ID_QUERY, league.id);
                params.set(LEAGUE_BULLION_BATTLE_QUERY, "1");
                return `${pathname}?${params}`;
            }
        case "sixes":
            {
                const params = new URLSearchParams();
                params.set(LEAGUE_ID_QUERY, league.id);
                const sixesMatch = leagueSixesPlayMatchId(fixtureId, options?.matchId);
                params.set("match", sixesMatch);
                const peerCardId = Number(options?.sixesCardId);
                const hasPeerCard = Number.isFinite(peerCardId) && peerCardId > 0;
                const isDemo = (0, _sixesDemoMatch.isSixesDemoMatchId)(sixesMatch);
                const presenterPrematch = (0, _sixesDemoMatch.isLeagueSixesDemoMatchId)(sixesMatch) && !league.presenterMatchStarted;
                const mode = presenterPrematch ? "reveal" : options?.sixesMode ?? (hasPeerCard ? "play" : isDemo && typeof window !== "undefined" && (0, _sixesCardRevealStorage.readSixesCardRevealed)(sixesMatch) ? "play" : "reveal");
                // Real league cards carry the mode too, so re-opening one skips the reveal animation.
                // Presenter India–WI stays reveal until Start the match, even if the card is already open.
                if (mode === "play") params.set("mode", "play");
                if (hasPeerCard) params.set("cardId", String(Math.round(peerCardId)));
                return `/sixes?${params}`;
            }
        default:
            {
                const _exhaustive = game;
                return _exhaustive;
            }
    }
}
function leagueGameLobbyUrl(league, game) {
    return withLeagueId(GAME_PATHS[game], league.id);
}

},{"../../Bullion/lib/bullionDemoMatchFixtures":"aydOs","../../Squares/lib/squaresDemoMatchFixtures":"1xeIm","../../Sixes/demo/sixesDemoMatch":"9ckr8","../../Sixes/lib/sixesCardRevealStorage":"4lDfN","./leagueLiveFixtures":"7FEAE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aydOs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BULLION_DEMO_MATCH_ENABLED", ()=>BULLION_DEMO_MATCH_ENABLED);
parcelHelpers.export(exports, "BULLION_DEMO_MATCH_ID", ()=>BULLION_DEMO_MATCH_ID);
parcelHelpers.export(exports, "BULLION_DEMO_MATCH_NAME", ()=>BULLION_DEMO_MATCH_NAME);
parcelHelpers.export(exports, "BULLION_DEMO_COMPETITION", ()=>BULLION_DEMO_COMPETITION);
parcelHelpers.export(exports, "BULLION_DEMO_MATCH_FLOW_PATH", ()=>BULLION_DEMO_MATCH_FLOW_PATH);
parcelHelpers.export(exports, "BULLION_DEMO_VIEWER_USER_ID", ()=>BULLION_DEMO_VIEWER_USER_ID);
parcelHelpers.export(exports, "BULLION_DEMO_VIEWER_NAME", ()=>BULLION_DEMO_VIEWER_NAME);
parcelHelpers.export(exports, "bullionDemoViewerAvatar", ()=>bullionDemoViewerAvatar);
/** Full board fill for league reopen when the viewer is entered but picks were never persisted. */ parcelHelpers.export(exports, "buildBullionDemoFilledBoard", ()=>buildBullionDemoFilledBoard);
parcelHelpers.export(exports, "BULLION_DEMO_ARENAS", ()=>BULLION_DEMO_ARENAS);
/**
 * Build the demo room from the shared synthetic prematch markets so the real pick board renders a full
 * TEAM / PLAYER / MATCH / INNINGS catalog. Runner odds carry the scoring used by the simulation.
 */ parcelHelpers.export(exports, "buildBullionDemoRoom", ()=>buildBullionDemoRoom);
/**
 * Live variant of the demo room for the settlement simulation. The played view only shows real points
 * (not a hard 0) once the leaderboard is out of its pre-match state, so the sim room must read as in-play:
 * a past start, an in-progress status string, and `isLive`/`fixturePhase: "live"`. Shares the base room's
 * `groups` so the user's picks (keyed by market storage key) still resolve.
 */ parcelHelpers.export(exports, "buildBullionDemoLiveRoom", ()=>buildBullionDemoLiveRoom);
/**
 * Build the scripted settlement simulation from the user's actual picks. Lowest-value lines settle first
 * (the ~bottom third as losses, the rest as wins) so the viewer climbs the leaderboard and takes the lead
 * by the final step. Opponents accrue points on a steady ramp toward a fraction of the viewer's total.
 */ parcelHelpers.export(exports, "buildBullionDemoSimulationSteps", ()=>buildBullionDemoSimulationSteps);
/** Entered card before Start the match — open picks, 0 points, no settlement juice. */ parcelHelpers.export(exports, "buildBullionDemoPrematchPlayedStep", ()=>buildBullionDemoPrematchPlayedStep);
parcelHelpers.export(exports, "readLeagueBullionDemoSimComplete", ()=>readLeagueBullionDemoSimComplete);
parcelHelpers.export(exports, "LEAGUE_BULLION_SIM_COMPLETE_EVENT", ()=>LEAGUE_BULLION_SIM_COMPLETE_EVENT);
parcelHelpers.export(exports, "markLeagueBullionDemoSimComplete", ()=>markLeagueBullionDemoSimComplete);
/**
 * League lobby overlay for the presenter demo: a handful of settled picks after Start the match,
 * then the full scripted slip once the play-page sim has been watched.
 */ parcelHelpers.export(exports, "bullionDemoLobbyLineSettlements", ()=>bullionDemoLobbyLineSettlements);
var _analyticsEnv = require("../../../utils/analyticsEnv");
var _profileAvatarCatalog = require("../../../utils/profileAvatarCatalog");
var _leaguePresenterLiveMatch = require("../../Leagues/lib/leaguePresenterLiveMatch");
var _constants = require("./constants");
var _bullionLuckyDip = require("./bullionLuckyDip");
var _bullionLineScoring = require("./bullionLineScoring");
var _bullionSelectionKeys = require("./bullionSelectionKeys");
var _bullionSyntheticPrematchMarkets = require("./bullionSyntheticPrematchMarkets");
var _roomUtils = require("./roomUtils");
const BULLION_DEMO_MATCH_ENABLED = (0, _analyticsEnv.isDevEnv)();
const BULLION_DEMO_MATCH_ID = "bullion-demo-match";
const BULLION_DEMO_MATCH_NAME = "India v West Indies";
const BULLION_DEMO_COMPETITION = "Cricket8 Exhibition Series";
const BULLION_DEMO_MATCH_FLOW_PATH = "/bullion?demo=match";
const BULLION_DEMO_VIEWER_USER_ID = 9101;
const BULLION_DEMO_VIEWER_NAME = "You";
const AVATAR = (0, _profileAvatarCatalog.FALLBACK_AVATAR_OPTIONS).map((item)=>(0, _profileAvatarCatalog.getAvatarThumbSrc)(item) || item.url || null);
function bullionDemoViewerAvatar() {
    return AVATAR[6] || "";
}
function buildBullionDemoFilledBoard(room) {
    const dip = (0, _bullionLuckyDip.buildLuckyDipSelections)(room);
    if (!dip || Object.keys(dip.picks).length === 0) return null;
    return {
        selections: dip.picks,
        bonusPicks: dip.bonusPicks
    };
}
const BULLION_DEMO_ARENAS = [
    {
        gameId: 990101,
        matchId: BULLION_DEMO_MATCH_ID,
        name: "Public 100",
        entryStake: 100,
        prizePot: 600,
        visibility: "public",
        status: "open",
        playersCount: 6
    },
    {
        gameId: 990102,
        matchId: BULLION_DEMO_MATCH_ID,
        name: "Public 500",
        entryStake: 500,
        prizePot: 6000,
        visibility: "public",
        status: "open",
        playersCount: 12
    },
    {
        gameId: 990103,
        matchId: BULLION_DEMO_MATCH_ID,
        name: "Public 1000",
        entryStake: 1000,
        prizePot: 9000,
        visibility: "public",
        status: "open",
        playersCount: 9
    }
];
/** Demo kickoff a little in the future so the board renders in its prematch state. */ function demoStartIso() {
    return new Date(Date.now() + 3600000).toISOString();
}
function buildBullionDemoRoom(startsAtIso) {
    const start = String(startsAtIso || "").trim() || demoStartIso();
    const rawMarkets = (0, _bullionSyntheticPrematchMarkets.buildCricketSyntheticPrematchRawMarkets)({
        id: BULLION_DEMO_MATCH_ID,
        name: BULLION_DEMO_MATCH_NAME
    });
    const seed = {
        id: BULLION_DEMO_MATCH_ID,
        name: BULLION_DEMO_MATCH_NAME,
        sport: "cricket",
        competition: BULLION_DEMO_COMPETITION,
        start,
        markets: rawMarkets
    };
    const room = (0, _roomUtils.buildBullionRooms)([
        seed
    ], 1)[0];
    if (room) return {
        ...room,
        startsAt: start
    };
    // Defensive fallback — should not happen since the synthetic markets are always non-empty.
    return {
        id: `bullion-${BULLION_DEMO_MATCH_ID}`,
        name: "BULLION demo",
        matchName: BULLION_DEMO_MATCH_NAME,
        matchId: BULLION_DEMO_MATCH_ID,
        sport: "CRICKET",
        competition: BULLION_DEMO_COMPETITION,
        startsAt: start,
        isLive: false,
        fixturePhase: "scheduled",
        skipBullionEntryCoinCheck: true,
        groups: [
            [],
            [],
            [],
            []
        ],
        players: 6
    };
}
function buildBullionDemoLiveRoom(baseRoom) {
    const base = baseRoom ?? buildBullionDemoRoom();
    const live = (0, _leaguePresenterLiveMatch.presenterLiveMatchCard)();
    return {
        ...base,
        startsAt: new Date(Date.now() - 7200000).toISOString(),
        status: live.statusLine,
        isLive: true,
        fixturePhase: "live"
    };
}
const DEMO_OPPONENTS = [
    {
        userId: 9102,
        name: "Giraffe Pro",
        avatarIndex: 0,
        finalFactor: 0.92
    },
    {
        userId: 9103,
        name: "Croc King",
        avatarIndex: 1,
        finalFactor: 0.78
    },
    {
        userId: 9104,
        name: "Rhino Ace",
        avatarIndex: 2,
        finalFactor: 0.62
    },
    {
        userId: 9105,
        name: "Tiger Stripes",
        avatarIndex: 3,
        finalFactor: 0.48
    },
    {
        userId: 9106,
        name: "Monkey Business",
        avatarIndex: 4,
        finalFactor: 0.33
    },
    {
        userId: 9107,
        name: "Panda Smash",
        avatarIndex: 5,
        finalFactor: 0.27
    },
    {
        userId: 9108,
        name: "Falcon Eye",
        avatarIndex: 7,
        finalFactor: 0.22
    },
    {
        userId: 9109,
        name: "Lion Heart",
        avatarIndex: 8,
        finalFactor: 0.17
    },
    {
        userId: 9110,
        name: "Wolf Pack",
        avatarIndex: 9,
        finalFactor: 0.12
    }
];
/** Resolve the viewer's board picks into scored lines (odds + pot points from the real board scoring). */ function resolveDemoLines(room, selections, bonusPicks) {
    const flat = room.groups.flatMap((g)=>g);
    const lines = [];
    for (const market of flat){
        const pickKey = (0, _bullionSelectionKeys.bullionSelectionStorageKey)(market);
        const sel = selections[pickKey] ?? selections[market.id];
        if (!sel || sel.chips <= 0) continue;
        const runner = market.runners.find((r)=>r.id === sel.runnerId);
        if (!runner) continue;
        const odds = (0, _bullionLineScoring.bullionBoardLineOddsForDisplay)(null, market, runner, sel);
        const bonus = bonusPicks.find((b)=>(b.marketId === pickKey || b.marketId === market.id) && b.runnerId === sel.runnerId);
        const bonusPoints = bonus ? (0, _constants.BULLION_BONUS_POINTS_BY_TIER)[bonus.tier] ?? bonus.points : 0;
        const potPoints = (0, _bullionLineScoring.bullionLinePotentialFromOdds)(odds, sel.chips, bonusPoints);
        lines.push({
            pickKey,
            marketId: pickKey,
            runnerId: sel.runnerId,
            marketName: market.name,
            selectionName: runner.name,
            groupIndex: market.groupIndex,
            chips: sel.chips,
            odds,
            bonusPoints,
            potPoints,
            win: false
        });
    }
    return lines;
}
function rankRows(rows) {
    const sorted = [
        ...rows
    ].sort((a, b)=>{
        if (b.points !== a.points) return b.points - a.points;
        // When tied (esp. 0 at demo start), keep the viewer last — lowest userId would wrongly put them 1st.
        const aIsViewer = a.userId === BULLION_DEMO_VIEWER_USER_ID;
        const bIsViewer = b.userId === BULLION_DEMO_VIEWER_USER_ID;
        if (aIsViewer && !bIsViewer) return 1;
        if (bIsViewer && !aIsViewer) return -1;
        return a.userId - b.userId;
    });
    return sorted.map((row, index)=>({
            ...row,
            rank: index + 1
        }));
}
function buildBullionDemoSimulationSteps(room, selections, bonusPicks, entryStake, options) {
    const lines = resolveDemoLines(room, selections, bonusPicks);
    // Settle small → big for a climactic finish; the lowest third lose, the rest win.
    const ordered = [
        ...lines
    ].sort((a, b)=>a.potPoints - b.potPoints);
    const lossCount = Math.floor(ordered.length / 3);
    ordered.forEach((line, index)=>{
        line.win = index >= lossCount;
    });
    const totalMarkets = ordered.length;
    const totalPotential = ordered.reduce((sum, l)=>sum + l.potPoints, 0);
    const viewerFinalPoints = ordered.reduce((sum, l)=>sum + (l.win ? l.potPoints : 0), 0);
    const playerCount = DEMO_OPPONENTS.length + 1;
    const prizePot = entryStake * playerCount;
    // Reveal one market per step (two only when the card is large) so each settlement is easy to follow.
    // League play-page sim can pass a larger batch so the walkthrough does not crawl.
    const batchSize = Math.max(1, Math.round(Number(options?.batchSize) || (totalMarkets > 14 ? 2 : 1)));
    const settlementStepCount = Math.max(1, Math.ceil(totalMarkets / batchSize));
    const totalSteps = settlementStepCount + 1;
    const viewerAvatar = bullionDemoViewerAvatar();
    const steps = [];
    for(let stepIndex = 0; stepIndex < totalSteps; stepIndex += 1){
        const settledThrough = Math.min(totalMarkets, stepIndex * batchSize);
        const prevSettledThrough = Math.min(totalMarkets, Math.max(0, stepIndex - 1) * batchSize);
        const settledLines = ordered.slice(0, settledThrough);
        const newlySettled = ordered.slice(prevSettledThrough, settledThrough);
        const viewerPoints = settledLines.reduce((sum, l)=>sum + (l.win ? l.potPoints : 0), 0);
        const viewerCorrect = settledLines.filter((l)=>l.win).length;
        const correctBonuses = settledLines.filter((l)=>l.win && l.bonusPoints > 0).length;
        // Per-step selections map with settlement fields on the lines settled so far.
        const stepSelections = {};
        for (const line of ordered){
            const settled = settledLines.includes(line);
            const selection = {
                marketId: line.pickKey,
                decimalMarketId: line.pickKey,
                marketName: line.marketName,
                selectionName: line.selectionName,
                runnerId: line.runnerId,
                chips: line.chips,
                odds: line.odds,
                potPoints: line.potPoints,
                linePotPoints: line.potPoints,
                groupIndex: line.groupIndex,
                settled,
                settlementOutcome: settled ? line.win ? "win" : "lose" : undefined,
                settlementResult: settled ? line.selectionName : undefined,
                pointsFromLine: settled ? line.win ? line.potPoints : 0 : null
            };
            stepSelections[line.pickKey] = selection;
        }
        // Everyone starts at 0; opponents ramp up only after the viewer's first settlement so step 1
        // is a solo climb (no mass opponent jump + viewer drop from a false tied-at-zero lead).
        const opponentProgress = stepIndex <= 1 ? 0 : (stepIndex - 1) / Math.max(1, settlementStepCount - 1);
        const rows = DEMO_OPPONENTS.map((opp)=>{
            const oppFinal = Math.round(viewerFinalPoints * opp.finalFactor) || Math.round(40 * opp.finalFactor);
            const points = Math.round(oppFinal * opponentProgress);
            const oppSettled = Math.round(totalMarkets * opponentProgress);
            return {
                rank: 0,
                userId: opp.userId,
                playerName: opp.name,
                avatarUrl: AVATAR[opp.avatarIndex] ?? null,
                points,
                potentialPoints: Math.max(oppFinal, Math.round(totalPotential * opp.finalFactor)),
                settledMarkets: oppSettled,
                totalMarkets,
                correctMarkets: Math.round(oppSettled * 0.66),
                correctBonuses: opponentProgress >= 0.5 ? 1 : 0,
                winnings: null
            };
        });
        rows.push({
            rank: 0,
            userId: BULLION_DEMO_VIEWER_USER_ID,
            playerName: BULLION_DEMO_VIEWER_NAME,
            avatarUrl: viewerAvatar,
            points: viewerPoints,
            potentialPoints: totalPotential,
            settledMarkets: settledThrough,
            totalMarkets,
            correctMarkets: viewerCorrect,
            correctBonuses,
            winnings: null
        });
        const leaderboard = rankRows(rows);
        const self = leaderboard.find((r)=>r.userId === BULLION_DEMO_VIEWER_USER_ID);
        const playState = {
            id: 1,
            userId: BULLION_DEMO_VIEWER_USER_ID,
            gameId: 990001,
            matchId: room.matchId,
            matchName: room.matchName,
            competition: room.competition,
            startsAt: room.startsAt,
            entryStake,
            gameDisplayName: `Public ${entryStake}`,
            gameStatus: stepIndex >= totalSteps - 1 && settledThrough >= totalMarkets ? "SETTLED" : "IN_PLAY",
            oddsSnapshot: null,
            selections: {
                picks: stepSelections,
                bonusPicks
            },
            settled: settledThrough >= totalMarkets,
            settledMarkets: settledThrough,
            totalMarkets,
            potentialPoints: totalPotential,
            prizePot,
            playerCount,
            points: self.points,
            rank: self.rank,
            winnings: null
        };
        steps.push({
            label: stepIndex === 0 ? "Match live \u2014 no settlements yet" : `Settlement ${stepIndex} of ${settlementStepCount}`,
            selections: stepSelections,
            bonusPicks,
            leaderboard,
            playState,
            celebrateMarketNames: newlySettled.filter((l)=>l.win).map((l)=>l.marketName)
        });
    }
    return steps;
}
function buildBullionDemoPrematchPlayedStep(room, selections, bonusPicks, entryStake) {
    const steps = buildBullionDemoSimulationSteps(room, selections, bonusPicks, entryStake);
    const first = steps[0];
    if (!first) return null;
    return {
        ...first,
        label: "Prematch \u2014 card entered",
        celebrateMarketNames: [],
        playState: {
            ...first.playState,
            gameStatus: "OPEN",
            startsAt: room.startsAt
        }
    };
}
function leagueBullionSimCompleteKey(leagueId) {
    return `bullion:league-sim-complete:${String(leagueId || "").trim()}`;
}
function readLeagueBullionDemoSimComplete(leagueId) {
    if (typeof window === "undefined") return false;
    try {
        return window.sessionStorage.getItem(leagueBullionSimCompleteKey(leagueId)) === "1";
    } catch  {
        return false;
    }
}
const LEAGUE_BULLION_SIM_COMPLETE_EVENT = "c8:bullion-league-sim-complete";
function markLeagueBullionDemoSimComplete(leagueId) {
    if (typeof window === "undefined") return;
    const id = String(leagueId || "").trim();
    if (!id) return;
    try {
        window.sessionStorage.setItem(leagueBullionSimCompleteKey(id), "1");
        window.dispatchEvent(new CustomEvent(LEAGUE_BULLION_SIM_COMPLETE_EVENT, {
            detail: {
                leagueId: id
            }
        }));
    } catch  {
    /* ignore */ }
}
function settlementFromDemoSelection(sel) {
    if (!sel.settled) return null;
    const outcomeRaw = String(sel.settlementOutcome || "").toLowerCase();
    const won = outcomeRaw === "win" || outcomeRaw === "won";
    const awarded = Math.max(0, Math.round(Number(sel.pointsFromLine) || 0));
    const pot = Math.max(0, Math.round(Number(sel.potPoints ?? sel.linePotPoints) || 0));
    return {
        outcome: won ? "won" : "lost",
        points: won ? awarded || pot : 0,
        settlementResult: String(sel.settlementResult || sel.selectionName || "").trim() || null,
        marketName: String(sel.marketName || "").trim()
    };
}
function bullionDemoLobbyLineSettlements(selections, bonusPicks, entryStake, simComplete) {
    if (!selections || Object.keys(selections).length === 0) return new Map();
    const steps = buildBullionDemoSimulationSteps(buildBullionDemoLiveRoom(), selections, bonusPicks, Math.max(0, Math.round(Number(entryStake) || 0)));
    const last = steps[steps.length - 1];
    if (!last) return new Map();
    const collect = (keys)=>{
        const map = new Map();
        for (const [key, sel] of Object.entries(last.selections)){
            if (keys && !keys.has(key)) continue;
            const row = settlementFromDemoSelection(sel);
            if (row) map.set(key, row);
        }
        return map;
    };
    if (simComplete) return collect(null);
    const bonusKeys = new Set((bonusPicks || []).map((bonus)=>`${String(bonus.marketId)}:${String(bonus.runnerId)}`));
    const lost = [];
    const won = [];
    for (const [key, sel] of Object.entries(last.selections)){
        const row = settlementFromDemoSelection(sel);
        if (!row) continue;
        if (bonusKeys.has(`${key}:${String(sel.runnerId)}`) || bonusKeys.has(`${sel.marketId}:${String(sel.runnerId)}`)) continue;
        if (row.outcome === "lost") lost.push(key);
        else won.push(key);
    }
    return collect(new Set([
        ...lost.slice(0, 2),
        ...won.slice(0, 2)
    ]));
}

},{"../../../utils/analyticsEnv":"4mdbs","../../../utils/profileAvatarCatalog":"i8TvT","../../Leagues/lib/leaguePresenterLiveMatch":"YkC1d","./constants":"fFw1z","./bullionLuckyDip":"9efee","./bullionLineScoring":"3BWF1","./bullionSelectionKeys":"6sFXt","./bullionSyntheticPrematchMarkets":"2cxx4","./roomUtils":"8f6zP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i8TvT":[function(require,module,exports,__globalThis) {
/**
 * Shared preset avatar catalog for Account page and Profile edit strip.
 * Keys and CDN URLs match `backend/config/avatarCatalog.json` / `/account/avatars`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AVATAR_OPTIONS_CACHE_KEY", ()=>AVATAR_OPTIONS_CACHE_KEY);
parcelHelpers.export(exports, "FALLBACK_AVATAR_OPTIONS", ()=>FALLBACK_AVATAR_OPTIONS);
parcelHelpers.export(exports, "getAvatarThumbSrc", ()=>getAvatarThumbSrc);
/** One catalog entry per animal section (first variant after colour sort) for compact profile strip. */ parcelHelpers.export(exports, "getAnimalPreviewAvatars", ()=>getAnimalPreviewAvatars);
const AVATAR_OPTIONS_CACHE_KEY = "c8_avatar_options_cache_v1";
const FALLBACK_AVATAR_OPTIONS = [
    {
        key: "giraffe-blue",
        animal: "giraffe",
        url: "https://cricket8-web-content.s3.amazonaws.com/avatars/giraffe-blue.png",
        thumb_url: "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/giraffe-blue.webp",
        thumb_urls: {
            "64": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/64/giraffe-blue.webp",
            "96": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/96/giraffe-blue.webp",
            "128": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/128/giraffe-blue.webp"
        }
    },
    {
        key: "croc-blue",
        animal: "crocodile",
        url: "https://cricket8-web-content.s3.amazonaws.com/avatars/croc-blue.png",
        thumb_url: "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/croc-blue.webp",
        thumb_urls: {
            "64": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/64/croc-blue.webp",
            "96": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/96/croc-blue.webp",
            "128": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/128/croc-blue.webp"
        }
    },
    {
        key: "rhino-blue",
        animal: "rhino",
        url: "https://cricket8-web-content.s3.amazonaws.com/avatars/rhino-blue.png",
        thumb_url: "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/rhino-blue.webp",
        thumb_urls: {
            "64": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/64/rhino-blue.webp",
            "96": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/96/rhino-blue.webp",
            "128": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/128/rhino-blue.webp"
        }
    },
    {
        key: "tiger-blue-red",
        animal: "tiger",
        url: "https://cricket8-web-content.s3.amazonaws.com/avatars/tiger-blue-red.png",
        thumb_url: "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/tiger-blue-red.webp",
        thumb_urls: {
            "64": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/64/tiger-blue-red.webp",
            "96": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/96/tiger-blue-red.webp",
            "128": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/128/tiger-blue-red.webp"
        }
    },
    {
        key: "monkey-blue-pink",
        animal: "monkey",
        url: "https://cricket8-web-content.s3.amazonaws.com/avatars/monkey-blue-pink.png",
        thumb_url: "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/monkey-blue-pink.webp",
        thumb_urls: {
            "64": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/64/monkey-blue-pink.webp",
            "96": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/96/monkey-blue-pink.webp",
            "128": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/128/monkey-blue-pink.webp"
        }
    },
    {
        key: "owl-blue",
        animal: "owl",
        url: "https://cricket8-web-content.s3.amazonaws.com/avatars/owl-blue.png",
        thumb_url: "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/owl-blue.webp",
        thumb_urls: {
            "64": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/64/owl-blue.webp",
            "96": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/96/owl-blue.webp",
            "128": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/128/owl-blue.webp"
        }
    },
    {
        key: "shark-blue-pink",
        animal: "shark",
        url: "https://cricket8-web-content.s3.amazonaws.com/avatars/shark-blue-pink.png",
        thumb_url: "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/shark-blue-pink.webp",
        thumb_urls: {
            "64": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/64/shark-blue-pink.webp",
            "96": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/96/shark-blue-pink.webp",
            "128": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/128/shark-blue-pink.webp"
        }
    },
    {
        key: "elephant-blue-pink",
        animal: "elephant",
        url: "https://cricket8-web-content.s3.amazonaws.com/avatars/elephant-blue-pink.png",
        thumb_url: "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/elephant-blue-pink.webp",
        thumb_urls: {
            "64": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/64/elephant-blue-pink.webp",
            "96": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/96/elephant-blue-pink.webp",
            "128": "https://cricket8-web-content.s3.amazonaws.com/avatars/thumbs/128/elephant-blue-pink.webp"
        }
    }
];
function getAvatarThumbSrc(avatar) {
    return avatar?.thumb_urls?.["48"] || avatar?.thumb_urls?.["64"] || avatar?.thumb_url || avatar?.url || null;
}
const AVATAR_KEY_ANIMAL_SLUGS = new Set([
    "croc",
    "giraffe",
    "owl",
    "shark",
    "elephant",
    "monkey",
    "rhino",
    "tiger"
]);
function getAvatarColorSortKey(avatarKey) {
    const k = String(avatarKey || "");
    const parts = k.split("-");
    if (parts.length < 2) return k;
    const slug = parts[0];
    if (!AVATAR_KEY_ANIMAL_SLUGS.has(slug)) return k;
    return parts.slice(1).join("-");
}
/** Same section order as Account.jsx `avatarSections`. */ const ANIMAL_SECTION_ORDER = [
    "giraffe",
    "crocodile",
    "rhino",
    "tiger",
    "monkey",
    "owl",
    "shark",
    "elephant"
];
function getAnimalPreviewAvatars(options) {
    const grouped = {};
    for (const opt of options){
        const animal = opt.animal || "other";
        if (!grouped[animal]) grouped[animal] = [];
        grouped[animal].push(opt);
    }
    return ANIMAL_SECTION_ORDER.map((animal)=>{
        const items = grouped[animal];
        if (!items?.length) return null;
        const sorted = items.slice().sort((a, b)=>{
            const ca = getAvatarColorSortKey(a.key);
            const cb = getAvatarColorSortKey(b.key);
            const byColor = ca.localeCompare(cb, undefined, {
                sensitivity: "base"
            });
            if (byColor !== 0) return byColor;
            return String(a.key).localeCompare(String(b.key));
        });
        return sorted[0] ?? null;
    }).filter((x)=>x != null);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"YkC1d":[function(require,module,exports,__globalThis) {
/**
 * Canonical in-play scoreboard for the `/leaguesdemo` India v WI walkthrough.
 * Lobby match centre, Sixes, Bullion, Trader, and Squares all read this so the
 * over and totals stay the same after Start the match.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PRESENTER_LIVE_HOME", ()=>PRESENTER_LIVE_HOME);
parcelHelpers.export(exports, "PRESENTER_LIVE_AWAY", ()=>PRESENTER_LIVE_AWAY);
parcelHelpers.export(exports, "PRESENTER_LIVE_COMPETITION", ()=>PRESENTER_LIVE_COMPETITION);
parcelHelpers.export(exports, "PRESENTER_LIVE_OVER", ()=>PRESENTER_LIVE_OVER);
parcelHelpers.export(exports, "PRESENTER_LIVE_MAX_OVERS", ()=>PRESENTER_LIVE_MAX_OVERS);
parcelHelpers.export(exports, "PRESENTER_LIVE_BALLS_THROUGH", ()=>PRESENTER_LIVE_BALLS_THROUGH);
parcelHelpers.export(exports, "PRESENTER_LIVE_BALL_RESULTS", ()=>PRESENTER_LIVE_BALL_RESULTS);
parcelHelpers.export(exports, "PRESENTER_LIVE_BASE_RUNS", ()=>PRESENTER_LIVE_BASE_RUNS);
parcelHelpers.export(exports, "PRESENTER_LIVE_BASE_WKTS", ()=>PRESENTER_LIVE_BASE_WKTS);
parcelHelpers.export(exports, "PRESENTER_LIVE_BOWLER", ()=>PRESENTER_LIVE_BOWLER);
parcelHelpers.export(exports, "PRESENTER_LIVE_BATTER_1", ()=>PRESENTER_LIVE_BATTER_1);
parcelHelpers.export(exports, "PRESENTER_LIVE_BATTER_2", ()=>PRESENTER_LIVE_BATTER_2);
parcelHelpers.export(exports, "presenterLiveMatchCard", ()=>presenterLiveMatchCard);
const PRESENTER_LIVE_HOME = "India";
const PRESENTER_LIVE_AWAY = "West Indies";
const PRESENTER_LIVE_COMPETITION = "ICC Men's T20 World Cup";
const PRESENTER_LIVE_OVER = 12;
const PRESENTER_LIVE_MAX_OVERS = 20;
const PRESENTER_LIVE_BALLS_THROUGH = 4;
const PRESENTER_LIVE_BALL_RESULTS = [
    "6",
    "4",
    "1",
    "1",
    "0",
    "2"
];
const PRESENTER_LIVE_BASE_RUNS = 110;
const PRESENTER_LIVE_BASE_WKTS = 2;
const PRESENTER_LIVE_BOWLER = "Alzarri Joseph";
const PRESENTER_LIVE_BATTER_1 = "Hardik Pandya";
const PRESENTER_LIVE_BATTER_2 = "Rinku Singh";
function deliveryRuns(raw) {
    const v = raw.trim().toUpperCase();
    if (!v || v === "W") return 0;
    if (/^W\+\d$/.test(v)) return parseInt(v.slice(2), 10) || 0;
    if (/^\d+W$/.test(v) || v === "WD") return parseInt(v, 10) || 1;
    if (/^\d+NB$/.test(v)) return parseInt(v, 10) || 1;
    if (/^\d+L?B$/.test(v)) return parseInt(v, 10) || 0;
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : 0;
}
function legalBallsIn(results, through) {
    let n = 0;
    for(let i = 0; i < through; i += 1){
        const v = String(results[i] ?? "").trim().toUpperCase();
        if (!v) continue;
        if (v.includes("WD") || v.includes("WIDE") || v.includes("NB")) continue;
        n += 1;
    }
    return n;
}
function presenterLiveMatchCard(ballsThrough = PRESENTER_LIVE_BALLS_THROUGH) {
    const results = PRESENTER_LIVE_BALL_RESULTS;
    const through = Math.max(0, Math.min(results.length, Math.floor(Number(ballsThrough) || 0)));
    const overRuns = results.slice(0, through).reduce((sum, raw)=>sum + deliveryRuns(raw), 0);
    const legal = legalBallsIn(results, through);
    const completedOvers = Math.max(0, PRESENTER_LIVE_OVER - 1);
    const part = Math.min(6, legal);
    const oversStr = `${completedOvers}.${part}`;
    const inns1Runs = PRESENTER_LIVE_BASE_RUNS + overRuns;
    const inns1Wkts = PRESENTER_LIVE_BASE_WKTS;
    const scoreLineHome = `${inns1Runs}/${inns1Wkts}`;
    const scoreLineAway = "0/0";
    return {
        home: PRESENTER_LIVE_HOME,
        away: PRESENTER_LIVE_AWAY,
        batting: PRESENTER_LIVE_HOME,
        competition: PRESENTER_LIVE_COMPETITION,
        overNumber: PRESENTER_LIVE_OVER,
        maxOvers: PRESENTER_LIVE_MAX_OVERS,
        completedOvers,
        legalBalls: part,
        oversStr,
        oversLabel: `${oversStr}/${PRESENTER_LIVE_MAX_OVERS}`,
        inns1Runs,
        inns1Wkts,
        scoreLineHome,
        scoreLineAway,
        scoreLines: [
            scoreLineHome,
            scoreLineAway
        ],
        statusLine: `${scoreLineHome} (${oversStr}) v ${scoreLineAway} Match in Progress`,
        innsNow: 1,
        format: 20,
        bowler: PRESENTER_LIVE_BOWLER,
        batter1: PRESENTER_LIVE_BATTER_1,
        batter2: PRESENTER_LIVE_BATTER_2,
        ballResults: results,
        overDelivery: results.slice(0, through).map((b)=>String(b)),
        commentaryStatus: `${PRESENTER_LIVE_BOWLER} to ${PRESENTER_LIVE_BATTER_1}`,
        currentInningsOversDecimal: completedOvers + part / 6,
        curBall: part < 6 ? `${completedOvers}.${part + 1}` : null
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fFw1z":[function(require,module,exports,__globalThis) {
/**
 * Fallback when the API has not returned `publicEntryStakes` yet — keep in sync with backend default
 * (`BULLION_PUBLIC_ENTRY_STAKES` env or 500,1500,5000).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BULLION_PUBLIC_ENTRY_STAKES_FALLBACK", ()=>BULLION_PUBLIC_ENTRY_STAKES_FALLBACK);
parcelHelpers.export(exports, "BULLION_ENTRY_COINS", ()=>BULLION_ENTRY_COINS);
parcelHelpers.export(exports, "BULLION_GROUP_COUNT", ()=>BULLION_GROUP_COUNT);
parcelHelpers.export(exports, "BULLION_GROUP_CHIP_LIMIT", ()=>BULLION_GROUP_CHIP_LIMIT);
parcelHelpers.export(exports, "BULLION_REGULAR_CHIPS", ()=>BULLION_REGULAR_CHIPS);
parcelHelpers.export(exports, "BULLION_TOTAL_CHIPS", ()=>BULLION_TOTAL_CHIPS);
parcelHelpers.export(exports, "BULLION_CHIPS_PER_CLICK", ()=>BULLION_CHIPS_PER_CLICK);
parcelHelpers.export(exports, "BULLION_PTS_PER_CHIP", ()=>BULLION_PTS_PER_CHIP);
parcelHelpers.export(exports, "LEAGUE_BULLION_PTS_PER_CHIP", ()=>LEAGUE_BULLION_PTS_PER_CHIP);
parcelHelpers.export(exports, "BULLION_BONUS_TIERS", ()=>BULLION_BONUS_TIERS);
parcelHelpers.export(exports, "BULLION_BONUS_COUNT", ()=>BULLION_BONUS_COUNT);
parcelHelpers.export(exports, "BULLION_BONUS_POINTS_BY_TIER", ()=>BULLION_BONUS_POINTS_BY_TIER);
parcelHelpers.export(exports, "BULLION_BONUS_TOTAL_POINTS", ()=>BULLION_BONUS_TOTAL_POINTS);
parcelHelpers.export(exports, "BULLION_BONUS_BAR_UNIT_PTS", ()=>BULLION_BONUS_BAR_UNIT_PTS);
/** Bonus stake on the same scale as placed bars (450 pts → 4.5 bars). */ parcelHelpers.export(exports, "bullionBonusBars", ()=>bullionBonusBars);
/** Bar-scale label for a bonus — `450` → `"4.5"`, `200` → `"2"`. */ parcelHelpers.export(exports, "formatBullionBonusBars", ()=>formatBullionBonusBars);
parcelHelpers.export(exports, "BULLION_MAX_POTENTIAL_PTS", ()=>BULLION_MAX_POTENTIAL_PTS);
parcelHelpers.export(exports, "BULLION_GROUP_TAB_LABELS", ()=>BULLION_GROUP_TAB_LABELS);
parcelHelpers.export(exports, "BULLION_LOBBY_UPCOMING_DAYS", ()=>BULLION_LOBBY_UPCOMING_DAYS);
parcelHelpers.export(exports, "BULLION_LOBBY_MAX_MATCHES", ()=>BULLION_LOBBY_MAX_MATCHES);
parcelHelpers.export(exports, "BULLION_CHALLENGE_NOTIFICATION_ACK_DELAY_MS", ()=>BULLION_CHALLENGE_NOTIFICATION_ACK_DELAY_MS);
const BULLION_PUBLIC_ENTRY_STAKES_FALLBACK = [
    500,
    1500,
    5000
];
const BULLION_ENTRY_COINS = BULLION_PUBLIC_ENTRY_STAKES_FALLBACK[0];
const BULLION_GROUP_COUNT = 4;
const BULLION_GROUP_CHIP_LIMIT = 10;
const BULLION_REGULAR_CHIPS = BULLION_GROUP_CHIP_LIMIT * BULLION_GROUP_COUNT;
const BULLION_TOTAL_CHIPS = BULLION_REGULAR_CHIPS;
const BULLION_CHIPS_PER_CLICK = 1;
const BULLION_PTS_PER_CHIP = 100;
const LEAGUE_BULLION_PTS_PER_CHIP = 100;
const BULLION_BONUS_TIERS = [
    {
        tier: "large",
        points: 450
    }
];
const BULLION_BONUS_COUNT = BULLION_BONUS_TIERS.length;
const BULLION_BONUS_POINTS_BY_TIER = {
    small: 150,
    large: 450
};
const BULLION_BONUS_TOTAL_POINTS = BULLION_BONUS_TIERS.reduce((sum, b)=>sum + b.points, 0);
const BULLION_BONUS_BAR_UNIT_PTS = BULLION_PTS_PER_CHIP;
function bullionBonusBars(bonusPoints) {
    const pts = Math.max(0, Number(bonusPoints) || 0);
    if (BULLION_BONUS_BAR_UNIT_PTS <= 0) return 0;
    return pts / BULLION_BONUS_BAR_UNIT_PTS;
}
function formatBullionBonusBars(bonusPoints) {
    const bars = bullionBonusBars(bonusPoints);
    return Number.isInteger(bars) ? String(bars) : bars.toFixed(1);
}
const BULLION_MAX_POTENTIAL_PTS = BULLION_TOTAL_CHIPS * BULLION_PTS_PER_CHIP + BULLION_BONUS_TOTAL_POINTS;
const BULLION_GROUP_TAB_LABELS = [
    "TEAM",
    "PLAYER",
    "MATCH",
    "INNINGS"
];
const BULLION_LOBBY_UPCOMING_DAYS = 5;
const BULLION_LOBBY_MAX_MATCHES = 24;
const BULLION_CHALLENGE_NOTIFICATION_ACK_DELAY_MS = 8000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9efee":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Random stake fill: `BULLION_GROUP_CHIP_LIMIT` regular bars per available category
 * (up to `BULLION_REGULAR_CHIPS` total) plus the +450 bullion bonus.
 * Returns null only when no category has any market with runners.
 */ parcelHelpers.export(exports, "buildLuckyDipSelections", ()=>buildLuckyDipSelections);
/**
 * “Auto Fill” in the UI: like full Lucky Dip, but keeps existing regular chips and only randomises the remainder
 * per category (and assigns gold if missing — preserves an existing gold pick when it still sits on a staked line).
 */ parcelHelpers.export(exports, "buildLuckyDipRemainingSelections", ()=>buildLuckyDipRemainingSelections);
var _constants = require("./constants");
var _roomUtils = require("./roomUtils");
function rand(n) {
    return Math.floor(Math.random() * n);
}
function shuffle(arr) {
    const a = [
        ...arr
    ];
    for(let i = a.length - 1; i > 0; i -= 1){
        const j = rand(i + 1);
        [a[i], a[j]] = [
            a[j],
            a[i]
        ];
    }
    return a;
}
/** k positive integers that sum to `sum` (each >= 1). */ function randomComposition(sum, k) {
    if (k <= 0 || sum < k) return [];
    if (k === 1) return [
        sum
    ];
    const cuts = new Set();
    while(cuts.size < k - 1)cuts.add(1 + rand(sum - 1));
    const sorted = [
        0,
        ...Array.from(cuts).sort((a, b)=>a - b),
        sum
    ];
    const out = [];
    for(let i = 0; i < sorted.length - 1; i += 1)out.push(sorted[i + 1] - sorted[i]);
    return out;
}
function luckyDipMarketNameKey(name) {
    return String(name || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}
/** Deduped markets per group (same rules as full Lucky Dip). */ function uniqueMarketsForBullionGroup(room, groupIndex) {
    const markets = (room.groups[groupIndex] || []).filter((m)=>m.runners.length > 0);
    const uniqueByKey = new Map();
    const seenNames = new Set();
    for (const market of markets){
        const storageKey = (0, _roomUtils.bullionSelectionStorageKey)(market);
        const nameKey = luckyDipMarketNameKey(market.name);
        if (nameKey) {
            if (seenNames.has(nameKey)) continue;
            seenNames.add(nameKey);
        }
        if (!uniqueByKey.has(storageKey)) uniqueByKey.set(storageKey, market);
    }
    return Array.from(uniqueByKey.values());
}
function cloneBullionSelections(picks) {
    const out = {};
    for (const [k, v] of Object.entries(picks))out[k] = {
        ...v
    };
    return out;
}
function bonusPickStillValid(bonus, picks) {
    if (!bonus) return false;
    const sel = picks[bonus.marketId];
    return sel != null && sel.runnerId === bonus.runnerId && sel.groupIndex === bonus.groupIndex && sel.chips > 0;
}
/** Build up to `BULLION_BONUS_TIERS.length` bonuses on distinct chip-bearing rows, preferring already-valid ones. */ function assignLuckyBonusPicks(picks, existing = []) {
    const candidates = Object.values(picks).filter((p)=>p.chips > 0);
    if (candidates.length === 0) return [];
    const usedKeys = new Set();
    const out = [];
    for (const { tier, points } of (0, _constants.BULLION_BONUS_TIERS)){
        const kept = existing.find((b)=>b.tier === tier && bonusPickStillValid(b, picks) && !usedKeys.has(b.marketId));
        if (kept) {
            usedKeys.add(kept.marketId);
            out.push({
                ...kept,
                points
            });
            continue;
        }
        const pool = shuffle(candidates.filter((c)=>!usedKeys.has(c.marketId)));
        const chosen = pool[0];
        if (!chosen) continue;
        usedKeys.add(chosen.marketId);
        out.push({
            tier,
            points,
            marketId: chosen.marketId,
            runnerId: chosen.runnerId,
            groupIndex: chosen.groupIndex
        });
    }
    return out;
}
function buildLuckyDipSelections(room) {
    const selections = {};
    const groupsWithMarkets = [];
    const uniqueMarketsByGroup = new Map();
    for(let g = 0; g < (0, _constants.BULLION_GROUP_COUNT); g += 1){
        const uniqueMarkets = uniqueMarketsForBullionGroup(room, g);
        uniqueMarketsByGroup.set(g, uniqueMarkets);
        if (uniqueMarkets.length > 0) groupsWithMarkets.push(g);
    }
    if (groupsWithMarkets.length === 0) return null;
    for (const g of groupsWithMarkets){
        const markets = uniqueMarketsByGroup.get(g) || [];
        const k = 1 + rand(Math.min((0, _constants.BULLION_GROUP_CHIP_LIMIT), markets.length));
        const chosen = shuffle(markets).slice(0, k);
        const parts = randomComposition((0, _constants.BULLION_GROUP_CHIP_LIMIT), k);
        if (parts.length !== k) return null;
        for(let i = 0; i < k; i += 1){
            const market = chosen[i];
            const runner = market.runners[rand(market.runners.length)];
            const chips = parts[i] * (0, _constants.BULLION_CHIPS_PER_CLICK);
            if (chips <= 0) continue;
            const pickKey = (0, _roomUtils.bullionSelectionStorageKey)(market);
            const existing = selections[pickKey];
            if (!existing) {
                selections[pickKey] = {
                    marketId: pickKey,
                    runnerId: runner.id,
                    chips,
                    groupIndex: g,
                    marketName: market.name,
                    selectionName: runner.name
                };
                continue;
            }
            // Defensive merge for rare feed duplicates sharing one storage key.
            existing.chips += chips;
        }
    }
    /** Bonuses must land on existing regular bets (rows with chips), on distinct rows. */ const bonusPicks = assignLuckyBonusPicks(selections);
    if (bonusPicks.length === 0) return null;
    return {
        picks: selections,
        bonusPicks
    };
}
function buildLuckyDipRemainingSelections(room, existingPicks, existingBonuses) {
    const selections = cloneBullionSelections(existingPicks);
    for(let g = 0; g < (0, _constants.BULLION_GROUP_COUNT); g += 1){
        const placed = (0, _roomUtils.regularChipsInGroup)(selections, g);
        const d = (0, _constants.BULLION_GROUP_CHIP_LIMIT) - placed;
        if (d <= 0) continue;
        const markets = uniqueMarketsForBullionGroup(room, g);
        if (markets.length === 0) return null;
        const k = 1 + rand(Math.min(d, markets.length));
        const parts = randomComposition(d, k);
        if (parts.length !== k) return null;
        const chosen = shuffle(markets).slice(0, k);
        for(let i = 0; i < k; i += 1){
            const market = chosen[i];
            const pickKey = (0, _roomUtils.bullionSelectionStorageKey)(market);
            const existingRow = selections[pickKey];
            const runner = existingRow && market.runners.some((r)=>r.id === existingRow.runnerId) ? market.runners.find((r)=>r.id === existingRow.runnerId) : market.runners[rand(market.runners.length)];
            const chips = parts[i] * (0, _constants.BULLION_CHIPS_PER_CLICK);
            if (chips <= 0) continue;
            const existing = selections[pickKey];
            if (!existing) {
                selections[pickKey] = {
                    marketId: pickKey,
                    runnerId: runner.id,
                    chips,
                    groupIndex: g,
                    marketName: market.name,
                    selectionName: runner.name
                };
                continue;
            }
            existing.chips += chips;
        }
    }
    const bonusPicks = assignLuckyBonusPicks(selections, existingBonuses);
    if (bonusPicks.length === 0) return null;
    return {
        picks: selections,
        bonusPicks
    };
}

},{"./constants":"fFw1z","./roomUtils":"8f6zP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8f6zP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRawMatchFinishedForBullionLobby", ()=>(0, _bullionRawMatch.isRawMatchFinishedForBullionLobby));
parcelHelpers.export(exports, "isRawMatchLiveForBullionLobby", ()=>(0, _bullionRawMatch.isRawMatchLiveForBullionLobby));
parcelHelpers.export(exports, "bullionLobbyFixturePhase", ()=>(0, _bullionRawMatch.bullionLobbyFixturePhase));
parcelHelpers.export(exports, "bullionRoomResolvedFixturePhase", ()=>(0, _bullionRawMatch.bullionRoomResolvedFixturePhase));
parcelHelpers.export(exports, "isT20BullionLobbyMatch", ()=>(0, _bullionLobbyOrdering.isT20BullionLobbyMatch));
parcelHelpers.export(exports, "isF50BullionLobbyMatch", ()=>(0, _bullionLobbyOrdering.isF50BullionLobbyMatch));
parcelHelpers.export(exports, "mergeBullionLobbySourceLists", ()=>(0, _bullionLobbyOrdering.mergeBullionLobbySourceLists));
parcelHelpers.export(exports, "pickPreservedLobbyRowsForActivePlays", ()=>(0, _bullionLobbyOrdering.pickPreservedLobbyRowsForActivePlays));
parcelHelpers.export(exports, "selectAndOrderBullionLobbyMatches", ()=>(0, _bullionLobbyOrdering.selectAndOrderBullionLobbyMatches));
parcelHelpers.export(exports, "enrichMatchesWithCricketStreamInitialState", ()=>(0, _bullionStreamEnrich.enrichMatchesWithCricketStreamInitialState));
parcelHelpers.export(exports, "bullionSelectionRegularChips", ()=>(0, _bullionSelectionKeys.bullionSelectionRegularChips));
parcelHelpers.export(exports, "totalRegularChips", ()=>(0, _bullionSelectionKeys.totalRegularChips));
parcelHelpers.export(exports, "bullionSelectionStorageKey", ()=>(0, _bullionSelectionKeys.bullionSelectionStorageKey));
parcelHelpers.export(exports, "normalizeBullionSelectionMapKeys", ()=>(0, _bullionSelectionKeys.normalizeBullionSelectionMapKeys));
parcelHelpers.export(exports, "normalizeBullionBonusPicks", ()=>(0, _bullionSelectionKeys.normalizeBullionBonusPicks));
parcelHelpers.export(exports, "coerceBullionBonusPicks", ()=>(0, _bullionSelectionKeys.coerceBullionBonusPicks));
parcelHelpers.export(exports, "regularChipsInGroup", ()=>(0, _bullionSelectionKeys.regularChipsInGroup));
parcelHelpers.export(exports, "parseBullionPlaySelectionsFromApi", ()=>(0, _bullionSelectionKeys.parseBullionPlaySelectionsFromApi));
parcelHelpers.export(exports, "buildBullionRooms", ()=>buildBullionRooms);
parcelHelpers.export(exports, "buildBullionRoomFromPlayBootstrap", ()=>buildBullionRoomFromPlayBootstrap);
/** Prefer `next` but never drop non-empty `oddsSnapshot` from `prev` (stale list fallbacks / races). */ parcelHelpers.export(exports, "bullionPublicGameMergePreferExistingOdds", ()=>bullionPublicGameMergePreferExistingOdds);
/** Map `/bullion/open-game` `game` row into board state (odds snapshot for market hydration). */ parcelHelpers.export(exports, "bullionPublicGameFromOpenGameApiRow", ()=>bullionPublicGameFromOpenGameApiRow);
parcelHelpers.export(exports, "bullionLobbyUserActiveGameToPublicGame", ()=>bullionLobbyUserActiveGameToPublicGame);
parcelHelpers.export(exports, "bullionPlayStateToPublicGame", ()=>bullionPlayStateToPublicGame);
var _matchUtils = require("../../Games/matchUtils");
var _decimalMarketUtils = require("../../Trader/Cricket/decimalMarketUtils");
var _constants = require("./constants");
var _bullionCricketMarketGroups = require("./bullionCricketMarketGroups");
var _bullionInplayTypeIds = require("./bullionInplayTypeIds");
var _bullionOddsSnapshot = require("./bullionOddsSnapshot");
var _bullionRawMatch = require("./bullionRawMatch");
var _bullionDecimalIds = require("./bullionDecimalIds");
var _bullionFrozenBoardMarkets = require("./bullionFrozenBoardMarkets");
var _bullionFixtureScheduledStart = require("./bullionFixtureScheduledStart");
var _cricketMatchCardOverDisplay = require("../../Cricket/cricketMatchCardOverDisplay");
var _bullionLobbyOrdering = require("./bullionLobbyOrdering");
var _bullionStreamEnrich = require("./bullionStreamEnrich");
var _bullionSelectionKeys = require("./bullionSelectionKeys");
function toOdds(raw) {
    const direct = raw.odds != null ? Number(raw.odds) : Number.NaN;
    if (Number.isFinite(direct) && direct > 1) return direct;
    const fallback = raw.recommended_price != null ? Number(raw.recommended_price) : Number.NaN;
    if (Number.isFinite(fallback) && fallback > 1) return fallback;
    return null;
}
function isTossWinnerMarket(market) {
    const id = market.market_type_id != null ? String(market.market_type_id) : "";
    const name = String(market.market_name || market.market_type || market.name || "").toLowerCase();
    return id === "815" || name.includes("toss winner");
}
function selectionDisplayName(runner, index) {
    const raw = runner.name;
    if (typeof raw === "string") return raw.trim();
    if (raw != null && typeof raw === "object") {
        const o = raw;
        if (typeof o.team === "string" && o.team.trim()) return o.team.trim();
        if (typeof o.player === "string" && o.player.trim()) return o.player.trim();
        if (typeof o.text === "string" && o.text.trim()) return o.text.trim();
        try {
            return JSON.stringify(raw).slice(0, 120);
        } catch  {
            return "";
        }
    }
    return (runner["selection-name"] || "").trim() || (runner["participant-name"] || "").trim() || (runner.id != null ? `Selection ${runner.id}` : "").trim();
}
/** Trailing numeric line sometimes embedded in market name (Trader uses this when `line` is absent). */ function lineFromMarketNameEnd(name) {
    const m = String(name || "").trim().match(/(\d+\.?\d*)\s*$/);
    if (!m) return null;
    const n = parseFloat(m[1]);
    return Number.isFinite(n) && n !== 0 ? n : null;
}
function parsePositiveLine(value) {
    if (value == null || value === "") return null;
    const n = parseFloat(String(value));
    return Number.isFinite(n) && n !== 0 ? n : null;
}
/** Best-effort total/handicap for Over/Under from market + selection payload. */ function pickNumericLineFromRaw(market, runnersRaw) {
    const m = market;
    for (const key of [
        "line",
        "Line",
        "handicap",
        "hcp",
        "total",
        "market-line",
        "points"
    ]){
        const hit = parsePositiveLine(m[key]);
        if (hit != null) return hit;
    }
    for (const run of runnersRaw){
        const o = run;
        for (const key of [
            "line",
            "Line",
            "handicap",
            "hcp",
            "points",
            "selection-line"
        ]){
            const hit = parsePositiveLine(o[key]);
            if (hit != null) return hit;
        }
    }
    for (const run of runnersRaw){
        const rawName = typeof run.name === "string" ? run.name.trim() : "";
        const embedded = rawName.match(/\b(?:over|under)\s+(\d+\.?\d*)\b/i);
        if (embedded) {
            const n = parseFloat(embedded[1]);
            if (Number.isFinite(n) && n !== 0) return n;
        }
    }
    return lineFromMarketNameEnd(String(market.name || market.market_name || ""));
}
function isOverUnderRunnerNames(names) {
    if (names.length !== 2) return false;
    const kinds = names.map((n)=>{
        const t = n.trim().toLowerCase();
        if (t === "over" || /^over(\s|$)/i.test(n)) return "O";
        if (t === "under" || /^under(\s|$)/i.test(n)) return "U";
        return "";
    });
    return kinds.includes("O") && kinds.includes("U");
}
function normalizeBullionMarketTypeId(raw) {
    const s = String(raw ?? "").trim();
    if (!s) return "";
    if (/^\d+(\.0+)?$/.test(s)) return String(parseInt(s, 10));
    return s;
}
/** Session-runs overs Bullion keeps: T20 → First 6; 50-over / ODI → First 10. */ function bullionPreferredSessionRunsOvers(formatOvers) {
    return formatOvers === 50 ? 10 : 6;
}
/**
 * BULLION: only offer the format's preferred "Runs in First N …" session lines
 * (T20: 6, ODI: 10), not other First 10/12/15 siblings (same family as Trader session tabs).
 */ function shouldExcludeBullionRunsInFirstNonPreferredSession(market, formatOvers) {
    const blob = `${market.market_type || ""} ${market.name || ""} ${market.market_name || ""}`;
    if (!/runs in first/i.test(blob)) return false;
    const m = blob.match(/runs in first\s*(\d+)/i);
    if (!m) return false;
    const overs = parseInt(m[1], 10);
    return Number.isFinite(overs) && overs !== bullionPreferredSessionRunsOvers(formatOvers);
}
function bullionCricketShouldPutLineOnSelections(market, normalizedRunnerNames) {
    if (!isOverUnderRunnerNames(normalizedRunnerNames)) return false;
    const tid = normalizeBullionMarketTypeId(market.market_type_id);
    if (tid && (0, _bullionCricketMarketGroups.BULLION_CRICKET_BOARD_TYPE_IDS).has(tid)) return true;
    const t = String(market.market_type || market.market_name || market.name || "").toLowerCase();
    if (t.includes("innings fours") || t.includes("innings sixes")) return true;
    if (t.includes("match runs") || t.includes("runs in match")) return true;
    if (t.includes("match fours") || t.includes("match sixes")) return true;
    if (t.includes("match wickets") || t.includes("match run outs")) return true;
    if (t.includes("match highest")) return true;
    if (t.includes("session runs") || t.includes("runs in session")) return true;
    if (t.includes("fall of first wicket")) return true;
    return false;
}
/** Remove a trailing total/handicap when it duplicates the structured line (feed often puts line only in `line`, not title). */ function stripTrailingTotalLineFromTitle(title, lineNum) {
    const trimmed = String(title || "").trim();
    if (lineNum == null || !Number.isFinite(lineNum)) return trimmed;
    const fmt = (0, _decimalMarketUtils.formatHandicap)(lineNum);
    if (fmt) {
        const low = trimmed.toLowerCase();
        const suffix = ` ${fmt}`.toLowerCase();
        if (low.endsWith(suffix)) return trimmed.slice(0, trimmed.length - suffix.length).trim();
    }
    const m = trimmed.match(/^(.*?)\s+(\d+\.?\d*)\s*$/);
    if (m) {
        const tail = parseFloat(m[2]);
        if (Number.isFinite(tail) && Math.abs(tail - lineNum) < 1e-6) return m[1].trim();
    }
    return trimmed;
}
function labelBullionOverUnderRunnersWithLine(runners, lineNum) {
    const fmt = (0, _decimalMarketUtils.formatHandicap)(lineNum);
    if (!fmt) return runners;
    return runners.map((r)=>{
        const raw = String(r.name || "").trim();
        const low = raw.toLowerCase();
        if (low === "over") return {
            ...r,
            name: `Over ${fmt}`
        };
        if (low === "under") return {
            ...r,
            name: `Under ${fmt}`
        };
        return r;
    });
}
/** Append visible line to Over/Under markets when the feed does not include it in `name`. */ function bullionMarketDisplayTitle(market, runnersRaw, normalizedRunnerNames) {
    const base = String(market.name || market.market_name || market.market_type || "Market").trim();
    if (!isOverUnderRunnerNames(normalizedRunnerNames)) return base;
    const lineNum = pickNumericLineFromRaw(market, runnersRaw);
    if (lineNum == null) return base;
    const formatted = (0, _decimalMarketUtils.formatHandicap)(lineNum);
    if (!formatted) return base;
    if (base.includes(formatted)) return base;
    return `${base} ${formatted}`;
}
function runnerImageUrlFromRaw(runner) {
    const raw = runner.image ?? runner.Image ?? runner.photo ?? runner.image_url ?? runner.imageUrl;
    if (raw == null) return undefined;
    const s = String(raw).trim();
    return s || undefined;
}
function normalizeRunner(runner, index, forcedOdds) {
    const name = selectionDisplayName(runner, index);
    if (!name) return null;
    const id = String(runner.id ?? `${name}-${index}`);
    const image = runnerImageUrlFromRaw(runner);
    const base = {
        id,
        name,
        odds: forcedOdds != null ? forcedOdds : toOdds(runner),
        status: runner.status != null ? String(runner.status) : undefined,
        winner: runner.winner === true || runner.winner === 1 || runner.winner === "1"
    };
    if (image) base.image = image;
    return base;
}
function bullionRunnerIsOverSide(name) {
    const raw = String(name || "").trim();
    if (!raw) return false;
    return /^over\b/i.test(raw);
}
function bullionRunnerIsUnderSide(name) {
    const raw = String(name || "").trim();
    if (!raw) return false;
    return /^under\b/i.test(raw);
}
function bullionOverUnderBalance(runners) {
    const over = runners.find((r)=>bullionRunnerIsOverSide(String(r.name || "")));
    const under = runners.find((r)=>bullionRunnerIsUnderSide(String(r.name || "")));
    const overOdds = over?.odds;
    const underOdds = under?.odds;
    if (overOdds == null || underOdds == null || !Number.isFinite(Number(overOdds)) || !Number.isFinite(Number(underOdds))) return null;
    return Math.abs(Number(overOdds) - Number(underOdds));
}
function bullionLineVariantBaseName(name) {
    return String(name || "").toLowerCase().replace(/\s+\d+(\.\d+)?\s*$/g, "").replace(/\s+/g, " ").trim();
}
/** Title + numeric line + O/U balance for cricket duplicate-line collapse (display title may strip the handicap). */ function bullionCricketLineDedupeBasis(row) {
    const runnersRawForRow = Array.isArray(row.raw.selectionslist) ? row.raw.selectionslist : Array.isArray(row.raw.selections) ? row.raw.selections : Array.isArray(row.raw.runners) ? row.raw.runners : [];
    const titleForVariant = String(row.raw.name ?? row.raw.market_name ?? row.market.name ?? "").trim();
    const numericLine = lineFromMarketNameEnd(titleForVariant) ?? lineFromMarketNameEnd(row.market.name) ?? pickNumericLineFromRaw(row.raw, runnersRawForRow);
    const balance = bullionOverUnderBalance(row.market.runners);
    const typeId = normalizeBullionMarketTypeId(row.raw.market_type_id);
    const propSuffix = row.market.groupIndex === 1 && typeId ? `|${typeId}` : "";
    const variantKey = `${row.market.groupIndex}${propSuffix}|${bullionLineVariantBaseName(titleForVariant)}`;
    return {
        runnersRawForRow,
        numericLine,
        balance,
        variantKey
    };
}
function bullionRawMarketResultSettledForPlayedView(raw) {
    const r = raw;
    const ss = r.settled_status ?? r.Settled_status;
    return (0, _decimalMarketUtils.isDecimalMarketSettledStatusFinal)(ss);
}
function normalizeMarkets(markets, match) {
    if (!Array.isArray(markets)) return [];
    const sportUpper = String(match.sport || "CRICKET").toUpperCase();
    const isCricket = sportUpper === "CRICKET";
    const format = match.format;
    const formatOvers = isCricket ? (0, _cricketMatchCardOverDisplay.bullionCricketFormatOversFromMatch)(match) : null;
    const normalized = [];
    const cricketRows = [];
    const seenCricketKeys = new Set();
    markets.forEach((market, marketIndex)=>{
        const hasTypeMeta = market?.market_type_id != null || market?.market_type != null && String(market.market_type).trim() !== "";
        if (isCricket && hasTypeMeta && !(0, _bullionCricketMarketGroups.isBullionTraderCricketMarket)(market, format)) return;
        if (isCricket && (0, _bullionInplayTypeIds.isBullionInplayOnlyMarketTypeId)(market.market_type_id)) return;
        // Frozen `bullion_games.odds_snapshot` slim rows omit `display` (null) — still board-eligible after filtering above.
        if (isCricket && market.display != null && String(market.display).trim() !== "" && !(0, _decimalMarketUtils.isCricketMarketDisplayOne)(market)) return;
        if (isCricket && shouldExcludeBullionRunsInFirstNonPreferredSession(market, formatOvers)) return;
        const runnersRaw = Array.isArray(market.selectionslist) ? market.selectionslist : Array.isArray(market.selections) ? market.selections : Array.isArray(market.runners) ? market.runners : [];
        const forcedOdds = isTossWinnerMarket(market) ? 2.0 : undefined;
        const runners = runnersRaw.map((runner, runnerIndex)=>normalizeRunner(runner, runnerIndex, forcedOdds)).filter((runner)=>runner != null);
        if (runners.length < 2) return;
        const runnerNames = runners.map((r)=>r.name);
        const lineNumForDisplay = pickNumericLineFromRaw(market, runnersRaw);
        const lineOnSelections = isCricket && lineNumForDisplay != null && bullionCricketShouldPutLineOnSelections(market, runnerNames);
        const finalRunners = lineOnSelections && lineNumForDisplay != null ? labelBullionOverUnderRunnersWithLine(runners, lineNumForDisplay) : runners;
        const stableId = (0, _bullionCricketMarketGroups.bullionMarketStableId)(market, marketIndex);
        if (isCricket) {
            if (seenCricketKeys.has(stableId)) return;
            seenCricketKeys.add(stableId);
        }
        const groupIndex = isCricket ? (0, _bullionCricketMarketGroups.clampBullionGroupIndex)((0, _bullionCricketMarketGroups.getBullionCricketMarketGroupIndex)(market)) : marketIndex % (0, _constants.BULLION_GROUP_COUNT);
        const displayName = lineOnSelections && lineNumForDisplay != null ? stripTrailingTotalLineFromTitle(String(market.name || market.market_name || market.market_type || "Market").trim(), lineNumForDisplay) : bullionMarketDisplayTitle(market, runnersRaw, runnerNames);
        const decimalMarketId = market.market_id != null && String(market.market_id).trim() !== "" ? String(market.market_id) : null;
        const row = {
            id: stableId,
            decimalMarketId,
            decimalMarketLineId: (0, _bullionDecimalIds.canonicalBullionDecimalMarketLineId)(decimalMarketId, market.market_line_id != null && String(market.market_line_id).trim() !== "" ? String(market.market_line_id) : null),
            marketTypeId: market.market_type_id != null && String(market.market_type_id).trim() !== "" ? String(market.market_type_id) : null,
            marketType: market.market_type != null && String(market.market_type).trim() !== "" ? String(market.market_type) : null,
            name: displayName,
            groupIndex,
            runners: finalRunners,
            settled: bullionRawMarketResultSettledForPlayedView(market)
        };
        if (isCricket) cricketRows.push({
            raw: market,
            market: row
        });
        else normalized.push(row);
    });
    if (isCricket) {
        const teams = (0, _matchUtils.parseCricketMatchName)(String(match.name || "")).teams;
        const teamA = teams[0] ?? "";
        const teamB = teams[1] ?? "";
        cricketRows.sort((x, y)=>(0, _bullionCricketMarketGroups.compareBullionCricketRawMarketsForOrdering)(x.raw, y.raw, teamA, teamB));
        const bestByVariant = new Map();
        for (const row of cricketRows){
            const { numericLine, balance, variantKey } = bullionCricketLineDedupeBasis(row);
            if (numericLine == null || balance == null) continue;
            const prev = bestByVariant.get(variantKey);
            if (!prev || balance < prev.balance) bestByVariant.set(variantKey, {
                row,
                balance
            });
        }
        return cricketRows.filter((row)=>{
            const { numericLine, balance, variantKey } = bullionCricketLineDedupeBasis(row);
            if (numericLine == null || balance == null) return true;
            return bestByVariant.get(variantKey)?.row.market.id === row.market.id;
        }).map((r)=>r.market);
    }
    return normalized;
}
function splitIntoGroups(markets) {
    const groups = Array.from({
        length: (0, _constants.BULLION_GROUP_COUNT)
    }, ()=>[]);
    markets.forEach((market)=>{
        const groupIndex = (0, _bullionCricketMarketGroups.clampBullionGroupIndex)(market.groupIndex);
        groups[groupIndex].push({
            ...market,
            groupIndex
        });
    });
    return groups;
}
/** Listed matches act as public Bullion rooms; include all fetched fixtures. */ function isListableBullionMatch(match) {
    return true;
}
function bullionMatchStartMs(match) {
    const m = match;
    const raw = m.actual_start ?? match.start ?? m["starts-at"] ?? m.startTime ?? m.start_time;
    if (raw == null || raw === "") return null;
    const t = new Date(String(raw)).getTime();
    return Number.isFinite(t) ? t : null;
}
/** Scheduled kickoff for lobby cards, toss window, and entry lock (not `actual_start`). */ function bullionMatchStartRaw(match) {
    return (0, _bullionFixtureScheduledStart.resolveBullionFixtureScheduledStartRaw)(match) ?? undefined;
}
/** Non-cricket fallback when the feed has no usable markets (four groups, two-way picks). */ function buildFallbackRawMarkets(match) {
    let sideA = "Side 1";
    let sideB = "Side 2";
    const parts = String(match.name || "").split(" v ").map((p)=>p.trim()).filter(Boolean);
    if (parts.length >= 2) {
        sideA = parts[0];
        sideB = parts[1];
    }
    const mid = String(match.id ?? "x");
    const fallbackMeta = [
        {
            market_type_id: "1010",
            market_type: "Match Winner",
            name: "Match Winner"
        },
        {
            market_type_id: "410",
            market_type: "Runs in Over",
            name: `Runs in Over 1`
        },
        {
            market_type_id: "210",
            market_type: "Innings Runs",
            name: "Innings Runs"
        },
        {
            market_type_id: "910",
            market_type: "Batter Runs",
            name: "Batter Runs"
        }
    ];
    return [
        0,
        1,
        2,
        3
    ].map((i)=>({
            id: `bullion-fallback-${mid}-${i}`,
            market_type_id: fallbackMeta[i].market_type_id,
            market_type: fallbackMeta[i].market_type,
            name: fallbackMeta[i].name,
            runners: [
                {
                    id: `${mid}-a-${i}`,
                    name: sideA,
                    odds: 1.91
                },
                {
                    id: `${mid}-b-${i}`,
                    name: sideB,
                    odds: 1.91
                }
            ]
        }));
}
function extractCompetition(match) {
    if ((match.competition || "").trim()) return String(match.competition).trim();
    const sport = String(match.sport || "").toLowerCase();
    if (sport === "cricket") return (0, _matchUtils.parseCricketMatchName)(match.name || "").competition || "Cricket";
    return (0, _matchUtils.parseFootballTennisMatchData)(match).competition || sport.toUpperCase();
}
function buildBullionRooms(matches, maxRooms = (0, _constants.BULLION_LOBBY_MAX_MATCHES)) {
    return matches.filter(isListableBullionMatch).slice(0, maxRooms).map((match, index)=>{
        const sportUpper = String(match.sport || "CRICKET").toUpperCase();
        const rawCombined = (0, _bullionFrozenBoardMarkets.bullionBoardRawMarketsForMatch)(match);
        let markets = normalizeMarkets(rawCombined, match);
        if (markets.length === 0 && sportUpper !== "CRICKET") markets = normalizeMarkets(buildFallbackRawMarkets(match), match);
        return {
            id: `bullion-${String(match.id ?? index)}`,
            name: `BULLION room ${index + 1}`,
            matchName: String(match.name || "").trim(),
            matchId: String(match.id ?? index),
            sport: String(match.sport || "CRICKET").toUpperCase(),
            competition: extractCompetition(match),
            startsAt: bullionMatchStartRaw(match),
            status: match.status ? String(match.status) : undefined,
            isLive: (0, _bullionRawMatch.isRawMatchLiveForBullionLobby)(match),
            fixturePhase: (0, _bullionRawMatch.bullionLobbyFixturePhase)(match),
            groups: splitIntoGroups(markets),
            players: Math.max(2, Math.floor(Math.random() * 16) + 2)
        };
    }).filter((room)=>{
        if (String(room.sport || "").toUpperCase() === "CRICKET") return true;
        return room.groups.some((group)=>group.length > 0);
    });
}
function buildBullionRoomFromPlayBootstrap(b) {
    const matchId = String(b.matchId || "").trim();
    const matchName = String(b.matchName || "").trim() || "Match " + matchId;
    const snapRows = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(b.oddsSnapshot);
    const rawSeed = {
        id: matchId,
        name: matchName,
        sport: "cricket",
        competition: b.competition != null && String(b.competition).trim() !== "" ? String(b.competition).trim() : undefined,
        markets: snapRows
    };
    if (b.startsAt) {
        rawSeed.start = b.startsAt;
        rawSeed["starts-at"] = b.startsAt;
    }
    const built = buildBullionRooms([
        rawSeed
    ], 1);
    const room = built[0];
    if (!room) return {
        id: "bullion-" + matchId,
        name: "BULLION",
        matchName,
        matchId,
        sport: "CRICKET",
        competition: String(b.competition || "").trim() || "Cricket",
        startsAt: b.startsAt || undefined,
        isLive: false,
        skipBullionEntryCoinCheck: true,
        groups: [
            [],
            [],
            [],
            []
        ],
        players: 2
    };
    return {
        ...room,
        isLive: false,
        skipBullionEntryCoinCheck: true
    };
}
function bullionPublicGameMergePreferExistingOdds(prev, next) {
    if (!next) return prev ?? null;
    if (!prev) return next;
    if (Number(prev.gameId) !== Number(next.gameId)) return next;
    const prevN = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(prev.oddsSnapshot).length;
    const nextN = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(next.oddsSnapshot).length;
    if (nextN === 0 && prevN > 0) return {
        ...next,
        oddsSnapshot: prev.oddsSnapshot
    };
    return next;
}
function bullionPublicGameFromOpenGameApiRow(row, matchId, gameId) {
    if (!row || Number(row.gameId) !== gameId) return null;
    const playersCount = Number(row.playersCount ?? 0);
    const entryStake = Number(row.entryStake ?? 0);
    const prizePotRaw = row.prizePot;
    const prizePot = prizePotRaw != null && Number.isFinite(Number(prizePotRaw)) ? Number(prizePotRaw) : playersCount * entryStake;
    const snap = row.oddsSnapshot ?? row.odds_snapshot ?? null;
    return {
        gameId,
        matchId: String(row.matchId ?? matchId),
        name: String(row.name ?? "").trim() || `Game ${gameId}`,
        entryStake,
        prizePot,
        oddsSnapshot: snap == null ? null : snap,
        visibility: String(row.visibility ?? "private"),
        status: String(row.status ?? "open"),
        playersCount,
        createdByUserId: row.createdByUserId != null ? Number(row.createdByUserId) : row.created_by_user_id != null ? Number(row.created_by_user_id) : null,
        creatorPlayerName: row.creatorPlayerName != null ? String(row.creatorPlayerName).trim() || null : row.creator_player_name != null ? String(row.creator_player_name).trim() || null : null,
        viewerIsCreator: Boolean(row.viewerIsCreator),
        inviteCode: row.inviteCode != null && String(row.inviteCode).trim() !== "" ? String(row.inviteCode).trim() : null,
        hostCanDeleteBattle: typeof row.hostCanDeleteBattle === "boolean" ? row.hostCanDeleteBattle : playersCount === 0
    };
}
function bullionLobbyUserActiveGameToPublicGame(matchId, g) {
    return {
        gameId: g.gameId,
        matchId,
        name: g.name || "Game " + g.gameId,
        entryStake: g.entryStake,
        visibility: "public",
        status: g.gameStatus || "open",
        playersCount: 0
    };
}
function bullionPlayStateToPublicGame(play) {
    const entry = Number(play.entryStake ?? 0);
    return {
        gameId: play.gameId,
        matchId: String(play.matchId || "").trim(),
        name: String(play.gameDisplayName || "").trim() || "Game " + play.gameId,
        entryStake: entry > 0 ? entry : 0,
        prizePot: play.prizePot,
        oddsSnapshot: play.oddsSnapshot ?? null,
        visibility: "public",
        status: String(play.gameStatus || "").trim() || "closed",
        playersCount: Math.max(0, Number(play.playerCount ?? 0))
    };
}

},{"../../Games/matchUtils":"9QY2j","../../Trader/Cricket/decimalMarketUtils":"eGjNP","./constants":"fFw1z","./bullionCricketMarketGroups":"9QsrP","./bullionInplayTypeIds":"4ldHi","./bullionOddsSnapshot":"i9JWr","./bullionRawMatch":"jEN44","./bullionDecimalIds":"9SlWC","./bullionFrozenBoardMarkets":"kZmoD","./bullionFixtureScheduledStart":"hiNiA","../../Cricket/cricketMatchCardOverDisplay":"jVYsA","./bullionLobbyOrdering":"dQhbi","./bullionStreamEnrich":"533xU","./bullionSelectionKeys":"6sFXt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eGjNP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PREMATCH_BATSMAN_TYPE_IDS", ()=>(0, _cricketTraderBatsmanBoardFilter.PREMATCH_BATSMAN_TYPE_IDS));
parcelHelpers.export(exports, "INPLAY_BATSMAN_LINE_TYPE_IDS", ()=>(0, _cricketTraderBatsmanBoardFilter.INPLAY_BATSMAN_LINE_TYPE_IDS));
parcelHelpers.export(exports, "isPrematchBatsmanPropMarket", ()=>(0, _cricketTraderBatsmanBoardFilter.isPrematchBatsmanPropMarket));
parcelHelpers.export(exports, "isInPlayBatsmanLineMarket", ()=>(0, _cricketTraderBatsmanBoardFilter.isInPlayBatsmanLineMarket));
parcelHelpers.export(exports, "isDecimalBatterDismissedStatus", ()=>(0, _cricketTraderBatsmanBoardFilter.isDecimalBatterDismissedStatus));
parcelHelpers.export(exports, "isTraderCricketMatchInPlay", ()=>(0, _cricketTraderBatsmanBoardFilter.isTraderCricketMatchInPlay));
parcelHelpers.export(exports, "batsmanMarketPlayerName", ()=>(0, _cricketTraderBatsmanBoardFilter.batsmanMarketPlayerName));
parcelHelpers.export(exports, "isBatsmanLineForDismissedBatter", ()=>(0, _cricketTraderBatsmanBoardFilter.isBatsmanLineForDismissedBatter));
parcelHelpers.export(exports, "getTraderBatsmanMarketHideReason", ()=>(0, _cricketTraderBatsmanBoardFilter.getTraderBatsmanMarketHideReason));
/**
 * Delta Appendix: selection `active` — 1 = displayed; missing or 0 = not displayed (hide runner).
 * @param {Object} selection - selection from market_update
 * @returns {boolean} true only when active is explicitly 1
 */ parcelHelpers.export(exports, "isSelectionActive", ()=>isSelectionActive);
/**
 * Selections to render per Decimal: only `active === 1`. Market-level `active=0` is handled separately (SUS all).
 * @param {Object|null|undefined} marketOrPrice
 * @returns {Object[]}
 */ parcelHelpers.export(exports, "getCricketDisplayableSelections", ()=>getCricketDisplayableSelections);
parcelHelpers.export(exports, "isCricketMatchWinnerForTrade", ()=>isCricketMatchWinnerForTrade);
/**
 * Market offerable per Decimal Integration Guide: display=1 and active=1 (Match Winner exempt).
 */ parcelHelpers.export(exports, "isCricketMarketOfferableForTrade", ()=>isCricketMarketOfferableForTrade);
/**
 * User-facing block reason for trade submit, or null if OK.
 * @param {Object|null|undefined} market
 * @param {Object|null|undefined} selection
 * @param {Object|null|undefined} [marketOrPrice]
 */ parcelHelpers.export(exports, "getCricketMarketTradeBlockReason", ()=>getCricketMarketTradeBlockReason);
/**
 * Market or line (from market_update) must have `active === 1` to be non-suspended; missing or 0 → SUS.
 * @param {Object|null|undefined} marketOrLine
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketMarketActiveOne", ()=>isCricketMarketActiveOne);
/**
 * @param {Object|null|undefined} marketOrLine
 * @returns {boolean} true when market/line should show suspended (active missing or not 1)
 */ parcelHelpers.export(exports, "isCricketMarketSuspendedByActive", ()=>isCricketMarketSuspendedByActive);
/**
 * List/filter: only show a market in the UI when `display` is explicitly 1.
 * @param {Object|null|undefined} market
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketMarketDisplayOne", ()=>isCricketMarketDisplayOne);
/**
 * List/filter: display=1 (missing ⇒ 0); active 1 or 0/missing (missing active ⇒ suspend/SUS).
 * Matches backend `isCricketMarketVisibleOrSuspended`.
 * @param {Object|null|undefined} market
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketMarketVisibleInList", ()=>isCricketMarketVisibleInList);
/** Appendix 4 from `settled_status` / `Settled_status` / Delta `status` (aligns with backend `cricket-settled-status`). */ parcelHelpers.export(exports, "cricketMarketAppendix4StatusForDisplay", ()=>cricketMarketAppendix4StatusForDisplay);
/**
 * List/filter: hide only when Appendix 4 is explicitly SETTLED, VOID, or DEADHEAT.
 * Missing/empty status ⇒ unsettled (matches backend `isUnsettled` / `filterAllowedMarkets`).
 * Trading labels on `status` (ACTIVE / PAUSED) do not map to Appendix 4 and are treated as unsettled.
 * @param {Object|null|undefined} market
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketMarketUnsettledForDisplay", ()=>isCricketMarketUnsettledForDisplay);
/**
 * True when `settled_status` is explicitly final (not UNSETTLED). Missing status → false (server may still block via cache).
 * @param {Object|null|undefined} market
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketMarketSettledForTrading", ()=>isCricketMarketSettledForTrading);
/**
 * Decimal Appendix 4 on a single field (`settled_status`, `status`, etc.). Matches backend `cricket-settled-status`.
 * @param {unknown} settledStatus
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isDecimalMarketSettledStatusFinal", ()=>isDecimalMarketSettledStatusFinal);
/**
 * @param {Object|null|undefined} market
 * @returns {string|null} user-facing error or null
 */ parcelHelpers.export(exports, "getSettledMarketTradeBlockReason", ()=>getSettledMarketTradeBlockReason);
parcelHelpers.export(exports, "isCricketDecimalOddsEffectivelyOne", ()=>isCricketDecimalOddsEffectivelyOne);
/**
 * @param {Object} [selection] - selection with recommended_price
 * @returns {boolean} true when price is usable for trading display (not effectively 1.00 / dead)
 */ parcelHelpers.export(exports, "hasValidCricketRecommendedOdds", ()=>hasValidCricketRecommendedOdds);
/**
 * Decimal API: when probabilities are sent as 0.99/1.00 (uncertainty, injuries, modelling),
 * the market should be suspended. Client must also suspend in the UI.
 * Uses selection.probability only (0–1 scale). Not recommended_price (decimal odds like 1.10, 2.0).
 * We only suspend when some selection has p >= 0.99 (outcome nearly certain). We do NOT suspend
 * for low probability (e.g. p <= 0.01): long-odds selections like 101.00 (prob ~0.01) should
 * remain offerable for trading.
 * @param {Object} marketPrice - market_price_update market object with selections[].probability
 * @returns {boolean} true if market should be treated as suspended due to extreme probabilities
 */ parcelHelpers.export(exports, "hasExtremeProbabilities", ()=>hasExtremeProbabilities);
parcelHelpers.export(exports, "isRunsInOverFamilyMarket", ()=>isRunsInOverFamilyMarket);
/**
 * True when this "runs in over N" line is for an over the scoreboard has already left.
 * Always false: hide/trade from Decimal display/active/status, not our over clock.
 */ parcelHelpers.export(exports, "isRunsInOverMarketPast", ()=>isRunsInOverMarketPast);
/**
 * Whole-market suspend (show SUS on all runners). Per Decimal Integration Guide:
 * market `display=1` + `active=0` suspends the market; selection `active=0` hides that runner only.
 * Event status BALL_IN_PROGRESS is a cue to honour `active` / `bet_delay`, not to blanket-SUS.
 * Appendix 4 `UNSETTLED` is settlement state, not a trading pause.
 * Match Winner keeps last odds: ignore market active/status/extreme probs and match-level
 * `global_betting_status` / `betting_status` (Decimal turns that off for ball-in-play; MW often stays priced).
 *
 * @param {Object} marketOrPrice - Market or price-update (market-level active, status, selections/selectionslist)
 * @param {*} [_eventStatus]
 * @param {Object} [options] - { marketUpdate, selectionCount, curBall, curPos, innsNow, prematch }
 * @returns {{ suspended: boolean, showSUS: boolean }} showSUS = true when UI should display "SUS"
 */ parcelHelpers.export(exports, "getCricketMarketSuspendedState", ()=>getCricketMarketSuspendedState);
/**
 * Returns true if the cricket match is finished (no trading allowed).
 * Uses same logic as match-play.jsx: event_status string (EVENT_CLOSED, MATCH_COMPLETE, FINISHED) or numeric (10, 11, 13).
 * @param {string|number} eventStatus - from market_update or match_update
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isCricketMatchFinished", ()=>isCricketMatchFinished);
/**
 * Format handicap/line for display: whole numbers without .0, keep .5 (e.g. 28 not 28.0, 28.5 stays 28.5).
 * @param {string|number} val - line or handicap value
 * @returns {string}
 */ parcelHelpers.export(exports, "formatHandicap", ()=>formatHandicap);
/** Same idea as backend `isRunsOffDeliveryMarket`. */ parcelHelpers.export(exports, "isRunsOffDeliveryMarket", ()=>isRunsOffDeliveryMarket);
/** Ball index from innings start: completed overs * 6 + ball (matches backend `getRunsOffDeliveryMarketBallIndex`). */ parcelHelpers.export(exports, "getRunsOffDeliveryMarketBallIndex", ()=>getRunsOffDeliveryMarketBallIndex);
/** Parse scoreboard-style `curBall` e.g. "12.4" → ball index in innings. */ parcelHelpers.export(exports, "parseCurBallToBallIndex", ()=>parseCurBallToBallIndex);
/**
 * CurPos from DecimalSocketContext: [innings, Current Innings Overs, Current Innings Part Overs].
 * Same ball index as backend `getCurrentInningsPositionFromScoreboard` — aligns ROD checks with the events server.
 *
 * @param {unknown} curPos
 * @returns {number|null}
 */ parcelHelpers.export(exports, "parseCurPosToBallIndex", ()=>parseCurPosToBallIndex);
/**
 * Current innings ball index for ROD stale checks. Prefers agreement between sources:
 * `curBall` is built from Current Innings Overs + current.delv; `CurPos` uses Part Overs instead of delv —
 * those fields can lag each other. Using the maximum when both parse avoids allowing trades when either
 * stream shows we've moved past the delivery (matches server-side merged scoreboard).
 *
 * @param {{ curBall?: string|null; curPos?: unknown }} opts
 * @returns {number|null}
 */ parcelHelpers.export(exports, "getRunsOffDeliveryCurrentBallIndex", ()=>getRunsOffDeliveryCurrentBallIndex);
/**
 * Block trader submit when Runs off Delivery refers to a delivery the match has already passed (live only).
 * Pass `curPos` from socket context so checks match the events server (see `getRunsOffDeliveryCurrentBallIndex`).
 * Future-innings ROD is allowed when Decimal still offers it; only past innings / past balls are blocked.
 * @returns {string|null} user-facing error, or null if OK / not applicable / cannot determine
 */ parcelHelpers.export(exports, "getRunsOffDeliveryTradeBlockReason", ()=>getRunsOffDeliveryTradeBlockReason);
/** 1-based over currently being bowled (`22.3` → 23), matching Trader `floor(curBall)+1`. */ parcelHelpers.export(exports, "getCurrentBowlingOverNumber", ()=>getCurrentBowlingOverNumber);
/**
 * No longer blocks trades for finished overs — follow Decimal display/active.
 * @returns {null}
 */ parcelHelpers.export(exports, "getCompletedOverTradeBlockReason", ()=>getCompletedOverTradeBlockReason);
var _oddsUtils = require("../oddsUtils");
var _decimalEventStatus = require("./decimalEventStatus");
var _cricketTraderBatsmanBoardFilter = require("./cricketTraderBatsmanBoardFilter");
/** Missing or explicit 0 — treated as off (same as Decimal 0). */ function isDecimalFlagZeroOrMissing(v) {
    return v === undefined || v === null || v === 0 || v === "0";
}
/** Explicit 1 only (missing is not 1). */ function isDecimalFlagOne(v) {
    return v === 1 || v === "1";
}
function isSelectionActive(selection) {
    if (!selection) return false;
    return isDecimalFlagOne(selection.active);
}
function getCricketDisplayableSelections(marketOrPrice) {
    const list = marketOrPrice?.selectionslist ?? marketOrPrice?.selections ?? [];
    if (!Array.isArray(list)) return [];
    if (isCricketMatchWinnerForTrade(marketOrPrice)) return list.filter((s)=>isSelectionActive(s) || hasValidCricketRecommendedOdds(s));
    return list.filter((s)=>isSelectionActive(s));
}
function isCricketMatchWinnerForTrade(market) {
    if (!market) return false;
    const tid = String(market.market_type_id || "");
    return market.market_type?.toLowerCase().includes("match winner") || (market.market_name || market.name || "").toLowerCase().includes("match winner") || tid === "10" || tid === "1010" || tid === "11" || tid === "15";
}
function isCricketMarketOfferableForTrade(market) {
    if (!market) return false;
    if (isCricketMatchWinnerForTrade(market)) return true;
    return isDecimalFlagOne(market.display) && isDecimalFlagOne(market.active);
}
function getCricketMarketTradeBlockReason(market, selection, marketOrPrice = null, liveCtx = null) {
    const m = marketOrPrice || market;
    const settled = getSettledMarketTradeBlockReason(m);
    if (settled) return settled;
    const batsmanHide = (0, _cricketTraderBatsmanBoardFilter.getTraderBatsmanMarketHideReason)(m, liveCtx || {});
    if (batsmanHide) return batsmanHide;
    if (!isCricketMarketOfferableForTrade(m)) {
        if (isDecimalFlagZeroOrMissing(m?.display)) return "This market is not available for trading.";
        if (isDecimalFlagZeroOrMissing(m?.active)) return "This market is currently suspended.";
        return "This market is not available for trading.";
    }
    if (selection && !isSelectionActive(selection)) return "This selection is not available for trading.";
    return null;
}
function isCricketMarketActiveOne(marketOrLine) {
    if (!marketOrLine) return false;
    return isDecimalFlagOne(marketOrLine.active);
}
function isCricketMarketSuspendedByActive(marketOrLine) {
    return !isCricketMarketActiveOne(marketOrLine);
}
function isCricketMarketDisplayOne(market) {
    if (!market) return false;
    return isDecimalFlagOne(market.display);
}
function isCricketMarketVisibleInList(market) {
    if (!market) return false;
    if (isDecimalFlagZeroOrMissing(market.display)) return false;
    return true;
}
const SETTLED_STATUS_NUMERIC = {
    1: "UNSETTLED",
    2: "SETTLED",
    3: "VOID",
    4: "DEADHEAT"
};
function normalizeDecimalSettlementStatusRaw(raw) {
    if (raw == null || raw === "") return null;
    if (typeof raw === "number") return SETTLED_STATUS_NUMERIC[raw] ?? null;
    const s = String(raw).trim();
    const upper = s.toUpperCase();
    if (upper === "UNSETTLED" || upper === "SETTLED" || upper === "VOID" || upper === "DEADHEAT") return upper;
    const n = parseInt(s, 10);
    if (!Number.isNaN(n) && n >= 1 && n <= 4) return SETTLED_STATUS_NUMERIC[n] ?? null;
    return null;
}
function cricketMarketAppendix4StatusForDisplay(market) {
    if (!market || typeof market !== "object") return null;
    for (const raw of [
        market.settled_status,
        market.Settled_status,
        market.status
    ]){
        if (raw == null || raw === "") continue;
        const normalized = normalizeDecimalSettlementStatusRaw(raw);
        if (normalized) return normalized;
    }
    return null;
}
function isCricketMarketUnsettledForDisplay(market) {
    if (!market) return false;
    const norm = cricketMarketAppendix4StatusForDisplay(market);
    if (!norm) return true;
    return norm === "UNSETTLED";
}
function isCricketMarketSettledForTrading(market) {
    if (!market) return false;
    const s = market.settled_status;
    if (s == null || s === "") return false;
    return !isCricketMarketUnsettledForDisplay(market);
}
function isDecimalMarketSettledStatusFinal(settledStatus) {
    if (settledStatus == null || settledStatus === "") return false;
    /** Appendix 4: only 2–4 are final; numeric 0 is common on live objects and must not imply void/settled. */ if (typeof settledStatus === "number") return settledStatus === 2 || settledStatus === 3 || settledStatus === 4;
    const s = String(settledStatus).trim();
    const upper = s.toUpperCase();
    if (upper === "UNSETTLED" || s === "1") return false;
    const n = parseInt(s, 10);
    if (!Number.isNaN(n) && n >= 2 && n <= 4) return true;
    return upper === "SETTLED" || upper === "VOID" || upper === "DEADHEAT";
}
function getSettledMarketTradeBlockReason(market) {
    if (!isCricketMarketSettledForTrading(market)) return null;
    return "This market is settled. Trading is closed.";
}
const isCricketDecimalOddsEffectivelyOne = (0, _oddsUtils.isOddsEffectivelyOne);
function hasValidCricketRecommendedOdds(selection) {
    if (!selection) return false;
    const p = parseFloat(String(selection.recommended_price));
    return Number.isFinite(p) && !(0, _oddsUtils.isOddsEffectivelyOne)(p);
}
function hasExtremeProbabilities(marketPrice) {
    const selections = marketPrice?.selections ?? marketPrice?.selectionslist;
    if (!Array.isArray(selections)) return false;
    return selections.some((s)=>{
        const p = parseFloat(s?.probability); // 0–1 only; odds (1.10, 2.0) are in recommended_price
        if (!Number.isFinite(p) || p < 0 || p > 1) return false; // ignore invalid or wrong-scale values
        if (p >= 0.99) return true; // near-certain outcome: suspend
        return false;
    });
}
/**
 * Over / wicket / boundary-in-over lines (not runs-off-delivery).
 */ const RUNS_IN_OVER_FAMILY_TYPE_IDS = new Set([
    "410",
    "415",
    "455",
    "460"
]);
function isRunsInOverFamilyMarket(market) {
    if (!market || typeof market !== "object") return false;
    const id = market.market_type_id != null ? String(market.market_type_id) : "";
    if (RUNS_IN_OVER_FAMILY_TYPE_IDS.has(id)) return true;
    const t = `${market.market_type || ""} ${market.market_name || ""} ${market.name || ""}`.toLowerCase();
    return t.includes("runs in over") || t.includes("wicket in over") || t.includes("boundary in over");
}
function isRunsInOverMarketPast(_market, _pos = {}) {
    return false;
}
function isDecimalTradingPausedStatus(status) {
    if (status == null || status === "") return false;
    const s = String(status).trim().toUpperCase();
    return s === "PAUSED" || s === "SUSPENDED";
}
function getCricketMarketSuspendedState(marketOrPrice, _eventStatus = null, options = {}) {
    const { marketUpdate } = options;
    const getSel = (m)=>m?.selectionslist ?? m?.selections ?? [];
    const selArray = getSel(marketOrPrice);
    const selectionCount = options.selectionCount !== undefined ? options.selectionCount : selArray.length;
    const isMatchWinner = isCricketMatchWinnerForTrade(marketOrPrice);
    // Match Winner: keep last odds. Do not treat Decimal active/status/extreme-prob as a board suspend.
    const activeSuspendedStrict = !isMatchWinner && isDecimalFlagZeroOrMissing(marketOrPrice?.active);
    const statusSuspended = !isMatchWinner && isDecimalTradingPausedStatus(marketOrPrice?.status);
    const matchTradingSuspended = !isMatchWinner && marketUpdate != null && (marketUpdate.betting_status === 0 || marketUpdate.betting_status === "0" || typeof marketUpdate.betting_status === "string" && marketUpdate.betting_status.toUpperCase() === "SUSPENDED");
    const extremeProbs = !isMatchWinner && hasExtremeProbabilities(marketOrPrice) && selectionCount <= 2;
    const suspended = activeSuspendedStrict || statusSuspended || matchTradingSuspended || extremeProbs;
    return {
        suspended,
        showSUS: suspended
    };
}
function isCricketMatchFinished(eventStatus) {
    return (0, _decimalEventStatus.isMatchFinishedStatus)(eventStatus);
}
function formatHandicap(val) {
    const n = parseFloat(val);
    if (!Number.isFinite(n)) return String(val ?? "");
    return Number.isInteger(n) ? String(n) : n.toFixed(1);
}
/** Align with backend `RUNS_OFF_DELIVERY_MARKET_TYPE_IDS` + name match. */ const RUNS_OFF_DELIVERY_TYPE_IDS = new Set([
    "340",
    "342",
    "344"
]);
function parsePositiveIntLocal(v) {
    if (v == null || v === "") return null;
    const n = typeof v === "number" ? v : parseInt(String(v).trim(), 10);
    return Number.isFinite(n) && !Number.isNaN(n) ? n : null;
}
function isRunsOffDeliveryMarket(market) {
    if (!market || typeof market !== "object") return false;
    const id = market.market_type_id != null ? String(market.market_type_id) : "";
    if (RUNS_OFF_DELIVERY_TYPE_IDS.has(id)) return true;
    return (market.market_type || "").toLowerCase().includes("runs off delivery");
}
function getRunsOffDeliveryMarketBallIndex(market) {
    if (!market || typeof market !== "object") return null;
    const over = parsePositiveIntLocal(market.over);
    const delivery = parsePositiveIntLocal(market.delivery);
    if (over != null && delivery != null) return (over - 1) * 6 + delivery;
    const name = String(market.market_name || market.name || "").trim();
    let mm = name.match(/Delivery\s+(\d+)\.(\d+)\s*$/i);
    if (!mm) mm = name.match(/(\d+)\.(\d+)\s*$/);
    if (!mm) return null;
    const fullOvers = parseInt(mm[1], 10);
    const ball = parseInt(mm[2], 10);
    if (Number.isNaN(fullOvers) || Number.isNaN(ball)) return null;
    return fullOvers * 6 + ball;
}
function parseCurBallToBallIndex(curBall) {
    if (curBall == null || curBall === "") return null;
    const m = String(curBall).trim().match(/^(\d+)\.(\d+)/);
    if (!m) return null;
    const full = parseInt(m[1], 10);
    const ball = parseInt(m[2], 10);
    if (Number.isNaN(full) || Number.isNaN(ball)) return null;
    return full * 6 + ball;
}
function parseCurPosToBallIndex(curPos) {
    if (!curPos || !Array.isArray(curPos) || curPos.length < 3) return null;
    const full = parsePositiveIntLocal(curPos[1]);
    const part = parsePositiveIntLocal(curPos[2]);
    if (full == null || part == null) return null;
    return full * 6 + part;
}
function getRunsOffDeliveryCurrentBallIndex({ curBall, curPos }) {
    const fromPos = parseCurPosToBallIndex(curPos);
    const fromBall = parseCurBallToBallIndex(curBall);
    const vals = [
        fromPos,
        fromBall
    ].filter((v)=>v != null && Number.isFinite(v));
    if (vals.length === 0) return null;
    return Math.max(...vals);
}
function getRunsOffDeliveryTradeBlockReason(market, { curBall, curPos, innsNow, prematch }) {
    if (prematch) return null;
    if (!isRunsOffDeliveryMarket(market)) return null;
    const mi = parsePositiveIntLocal(market.inns);
    const currentInns = parsePositiveIntLocal(innsNow);
    if (mi != null && currentInns != null && mi < currentInns) return "That delivery has already passed. Refresh and place your trade on the current ball.";
    // Future innings: do not apply current-innings ball index.
    if (mi != null && currentInns != null && mi > currentInns) return null;
    const marketBall = getRunsOffDeliveryMarketBallIndex(market);
    if (marketBall == null) return null;
    const posBall = getRunsOffDeliveryCurrentBallIndex({
        curBall,
        curPos
    });
    if (posBall == null) return null;
    if (posBall > marketBall) return "That delivery has already passed. Refresh and place your trade on the current ball.";
    return null;
}
function getCurrentBowlingOverNumber({ curBall, curPos }) {
    const fromBall = (()=>{
        const n = Number.parseFloat(curBall);
        if (!Number.isFinite(n) || n < 0) return null;
        return Math.floor(n) + 1;
    })();
    const fromPos = (()=>{
        if (!curPos || !Array.isArray(curPos) || curPos.length < 2) return null;
        const full = parsePositiveIntLocal(curPos[1]);
        if (full == null || full < 0) return null;
        return full + 1;
    })();
    const vals = [
        fromBall,
        fromPos
    ].filter((v)=>v != null && Number.isFinite(v));
    if (vals.length === 0) return null;
    return Math.max(...vals);
}
function getCompletedOverTradeBlockReason(_market, _pos = {}) {
    return null;
}

},{"../oddsUtils":"jXkCw","./decimalEventStatus":"f1nlI","./cricketTraderBatsmanBoardFilter":"7OKkd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7OKkd":[function(require,module,exports,__globalThis) {
/** Prematch player props (Decimal 910/912/914) — hide once the live innings has started. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PREMATCH_BATSMAN_TYPE_IDS", ()=>PREMATCH_BATSMAN_TYPE_IDS);
parcelHelpers.export(exports, "INPLAY_BATSMAN_LINE_TYPE_IDS", ()=>INPLAY_BATSMAN_LINE_TYPE_IDS);
parcelHelpers.export(exports, "isPrematchBatsmanPropMarket", ()=>isPrematchBatsmanPropMarket);
parcelHelpers.export(exports, "isInPlayBatsmanLineMarket", ()=>isInPlayBatsmanLineMarket);
parcelHelpers.export(exports, "isDecimalBatterDismissedStatus", ()=>isDecimalBatterDismissedStatus);
/** True once Decimal has left Pre Match Service, or live balls/innings are present. */ parcelHelpers.export(exports, "isTraderCricketMatchInPlay", ()=>isTraderCricketMatchInPlay);
parcelHelpers.export(exports, "batsmanMarketPlayerName", ()=>batsmanMarketPlayerName);
parcelHelpers.export(exports, "isBatsmanLineForDismissedBatter", ()=>isBatsmanLineForDismissedBatter);
/**
 * Hide prematch player props once live, and hide in-play batter lines after the scorecard dismissal.
 * Decimal often leaves type 710 `display=1` for several balls after a wicket.
 */ parcelHelpers.export(exports, "getTraderBatsmanMarketHideReason", ()=>getTraderBatsmanMarketHideReason);
const PREMATCH_BATSMAN_TYPE_IDS = new Set([
    "910",
    "912",
    "914"
]);
const INPLAY_BATSMAN_LINE_TYPE_IDS = new Set([
    "710",
    "720",
    "730",
    "760"
]);
const DECIMAL_BATTER_DISMISSAL_RE = /^(Caught|Bowled|Stumped|LBW|Run Out|Hit Wicket|Handled the Ball|Obstructing the Field|Timed Out)\b/i;
function isPrematchBatsmanPropMarket(market) {
    return PREMATCH_BATSMAN_TYPE_IDS.has(String(market?.market_type_id ?? "").trim());
}
function isInPlayBatsmanLineMarket(market) {
    return INPLAY_BATSMAN_LINE_TYPE_IDS.has(String(market?.market_type_id ?? "").trim());
}
function isDecimalBatterDismissedStatus(status) {
    const s = String(status ?? "").trim();
    if (!s || /retired/i.test(s)) return false;
    return DECIMAL_BATTER_DISMISSAL_RE.test(s);
}
function normalizeBatterNameKey(raw) {
    return String(raw ?? "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}
function isTraderCricketMatchInPlay({ prematch, curBall } = {}) {
    if (prematch === false) return true;
    const ball = Number.parseFloat(curBall);
    return Number.isFinite(ball) && ball > 0;
}
function batsmanMarketPlayerName(market) {
    const raw = String(market?.market_name || market?.name || "").trim();
    if (!raw) return "";
    const commaIdx = raw.indexOf(",");
    let player = commaIdx >= 0 ? raw.slice(commaIdx + 1).trim() : raw;
    player = player.replace(/\s+to reach\s+\d+(\.\d+)?\s+runs?\s*$/i, "").trim();
    player = player.replace(/\s+(runs|fours|sixes)\s*$/i, "").trim();
    return player;
}
function scorecardDismissedBatterIndex(scorecard) {
    const ids = new Set();
    const names = new Set();
    if (!scorecard || typeof scorecard !== "object") return {
        ids,
        names
    };
    for (const key of [
        "inns1",
        "inns2",
        "inns3",
        "inns4"
    ]){
        const batting = scorecard[key]?.batting;
        if (!Array.isArray(batting)) continue;
        for (const row of batting){
            if (!isDecimalBatterDismissedStatus(row?.status)) continue;
            const id = String(row?.id ?? "").trim();
            if (id) ids.add(id);
            const name = normalizeBatterNameKey(row?.name);
            if (name) names.add(name);
        }
    }
    return {
        ids,
        names
    };
}
function isBatsmanLineForDismissedBatter(market, scorecard) {
    if (!isInPlayBatsmanLineMarket(market)) return false;
    const dismissed = scorecardDismissedBatterIndex(scorecard);
    const pid = String(market?.player_id ?? "").trim();
    if (pid && dismissed.ids.has(pid)) return true;
    const pname = normalizeBatterNameKey(batsmanMarketPlayerName(market));
    return Boolean(pname && dismissed.names.has(pname));
}
function getTraderBatsmanMarketHideReason(market, { prematch, scorecard, innsNow, curBall } = {}) {
    if (!market) return null;
    if (isPrematchBatsmanPropMarket(market) && isTraderCricketMatchInPlay({
        prematch,
        innsNow,
        curBall
    })) return "Prematch player markets are not offered after the match has started.";
    if (isBatsmanLineForDismissedBatter(market, scorecard)) return "This batter is out. Trading is closed.";
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9QsrP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BULLION_CRICKET_BOARD_TYPE_IDS", ()=>BULLION_CRICKET_BOARD_TYPE_IDS);
parcelHelpers.export(exports, "isBullionTraderCricketMarket", ()=>isBullionTraderCricketMarket);
parcelHelpers.export(exports, "getBullionCricketMarketGroupIndex", ()=>getBullionCricketMarketGroupIndex);
/** Full-board sort: group order TEAM → PLAYER → MATCH → INNINGS, then spec order inside each tab. */ parcelHelpers.export(exports, "compareBullionCricketRawMarketsForOrdering", ()=>compareBullionCricketRawMarketsForOrdering);
/**
 * Stable row id for BULLION / dedupe. When `market_line_id` is missing, many lines share the same `market_id`;
 * we fold in type id + name so each offerable line stays a distinct card (same idea as Trader line keys).
 */ parcelHelpers.export(exports, "bullionMarketStableId", ()=>bullionMarketStableId);
parcelHelpers.export(exports, "clampBullionGroupIndex", ()=>clampBullionGroupIndex);
var _constants = require("./constants");
var _bullionInplayTypeIds = require("./bullionInplayTypeIds");
const BULLION_CRICKET_BOARD_TYPE_IDS = new Set([
    "10",
    "1010",
    "15",
    "815",
    "50",
    "55",
    "45",
    "30",
    "35",
    "510",
    "610",
    "60",
    "70",
    "75",
    "80",
    "85",
    "86",
    "88",
    "220",
    "230",
    "910",
    "914"
]);
/** Batter fours type ids (live 720, prematch 912) — never on the BULLION board. */ const BULLION_EXCLUDED_BATTER_FOURS_TYPE_IDS = new Set([
    "720",
    "912"
]);
function isBullionExcludedBatterFoursMarket(market) {
    const typeId = normalizeTypeId(market.market_type_id);
    if (typeId && BULLION_EXCLUDED_BATTER_FOURS_TYPE_IDS.has(typeId)) return true;
    const t = marketTypeText(market);
    if (/\bpre\s*match\s+batsman\s+fours?\b/i.test(t)) return true;
    if ((/\bbatsman\s+fours?\b/i.test(t) || /\bbatter\s+fours?\b/i.test(t)) && !t.includes("innings fours") && !t.includes("match fours") && !t.includes("most fours")) return true;
    return false;
}
const BULLION_TYPE_ID_TO_GROUP = {
    "10": 0,
    "1010": 0,
    "15": 0,
    "815": 0,
    "50": 0,
    "55": 0,
    "45": 0,
    "30": 0,
    "35": 0,
    "910": 1,
    "914": 1,
    "60": 2,
    "70": 2,
    "75": 2,
    "80": 2,
    "85": 2,
    "88": 2,
    "86": 2,
    "220": 3,
    "230": 3,
    "510": 3,
    "610": 3
};
function normalizeTypeId(raw) {
    const s = String(raw ?? "").trim();
    if (!s) return "";
    if (/^\d+(\.0+)?$/.test(s)) return String(parseInt(s, 10));
    return s;
}
function isMatchWinnerTypeId(typeId) {
    return typeId === "10" || typeId === "1010" || typeId === "15";
}
function marketTypeText(market) {
    return String(market.market_type || market.market_name || market.name || "").toLowerCase();
}
function marketGroupText(market) {
    return String(market.market_group || "").toLowerCase();
}
function isBullionAllowedCricketTypeText(typeText) {
    return typeText.includes("match winner") || typeText.includes("toss winner") || typeText.includes("highest first over") || typeText.includes("highest first session") || typeText.includes("highest opening partnership") || typeText.includes("most fours") || typeText.includes("most sixes") || typeText.includes("match runs") || typeText.includes("runs in match") || typeText.includes("match fours") || typeText.includes("match sixes") || typeText.includes("match wickets") || typeText.includes("match run outs") || typeText.includes("match highest runs off over") || typeText.includes("match highest individual score") || typeText.includes("innings fours") || typeText.includes("innings sixes") || typeText.includes("total fours") || typeText.includes("total sixes") || typeText.includes("session runs") || typeText.includes("fall of first wicket");
}
function isBullionTraderCricketMarket(market, format) {
    const typeId = normalizeTypeId(market.market_type_id);
    const isTest = format === 999;
    if (typeId === "15" && !isTest) return false;
    if (isBullionExcludedBatterFoursMarket(market)) return false;
    if (typeId && (0, _bullionInplayTypeIds.isBullionInplayOnlyMarketTypeId)(typeId)) return false;
    if (isMatchWinnerTypeId(typeId)) return true;
    if (!typeId) {
        const typeText = marketTypeText(market);
        if (isBullionAllowedCricketTypeText(typeText)) return true;
        return false;
    }
    return BULLION_CRICKET_BOARD_TYPE_IDS.has(typeId);
}
function getBullionCricketMarketGroupIndex(market) {
    const typeId = normalizeTypeId(market.market_type_id);
    if (typeId && BULLION_TYPE_ID_TO_GROUP[typeId] !== undefined) return BULLION_TYPE_ID_TO_GROUP[typeId];
    const t = marketTypeText(market);
    const g = marketGroupText(market);
    if (t.includes("match winner") || t.includes("toss winner") || t.includes("highest first over") || t.includes("highest first session") || t.includes("highest opening partnership") || t.includes("most fours") || t.includes("most sixes")) return 0;
    if (!isBullionExcludedBatterFoursMarket(market) && (t.includes("batter") || t.includes("batsman") || t.includes("player"))) return 1;
    if (t.includes("match runs") || t.includes("runs in match") || t.includes("match fours") || t.includes("match sixes") || t.includes("match wickets") || t.includes("match run outs") || t.includes("match highest runs off over") || t.includes("match highest individual score")) return 2;
    if (t.includes("innings fours") || t.includes("innings sixes") || t.includes("total fours") || t.includes("total sixes") || t.includes("session runs") || t.includes("fall of first wicket")) return 3;
    if (g.includes("team")) return 0;
    if (g.includes("player")) return 1;
    if (g.includes("match")) return 2;
    if (g.includes("runs")) return 2;
    if (g.includes("innings")) return 3;
    return 0;
}
/** TEAM tab: Match Winner → Toss → Highest First Over → … → Most Sixes. */ const BULLION_TEAM_TYPE_ORDER = {
    "1010": 0,
    "10": 1,
    "15": 2,
    "815": 3,
    "50": 4,
    "55": 5,
    "45": 6,
    "30": 7,
    "35": 8
};
function displayTitle(m) {
    return String(m.name || m.market_name || m.market_type || "").trim();
}
/** 0 = favours home / team A, 1 = away / team B; used for MATCH + INNINGS paired lines. */ function bullionTeamSlotForTitle(title, teamA, teamB) {
    const n = title.toLowerCase();
    const a = teamA.trim().toLowerCase();
    const b = teamB.trim().toLowerCase();
    if (!a || !b) return 0;
    const ia = n.indexOf(a);
    const ib = n.indexOf(b);
    const hasA = ia >= 0;
    const hasB = ib >= 0;
    if (hasA && !hasB) return 0;
    if (hasB && !hasA) return 1;
    if (hasA && hasB) return ia <= ib ? 0 : 1;
    return 0;
}
/** 1–4 when the title names a batter slot; large when unknown (stable tie-break by name). */ function bullionBatterOrdinalFromTitle(title) {
    const m = title.match(/batter\s*(\d+)|batsman\s*(\d+)|player\s*#?\s*(\d+)/i);
    if (m) {
        const x = parseInt(m[1] || m[2] || m[3], 10);
        if (Number.isFinite(x) && x >= 1 && x <= 99) return x;
    }
    return 500;
}
/**
 * Sort key within one BULLION group (TEAM / PLAYER / MATCH / INNINGS) — product order from spec.
 * Tie-break with `displayTitle` in the comparator.
 */ function bullionCricketInGroupOrderKey(market, teamA, teamB) {
    const typeId = normalizeTypeId(market.market_type_id);
    const title = displayTitle(market);
    const g = getBullionCricketMarketGroupIndex(market);
    if (g === 0) {
        if (typeId && BULLION_TEAM_TYPE_ORDER[typeId] !== undefined) return BULLION_TEAM_TYPE_ORDER[typeId] * 10;
        const t = String(market.market_type || "").toLowerCase();
        if (t.includes("match winner")) return BULLION_TEAM_TYPE_ORDER["1010"] * 10;
        return 9990;
    }
    const slot = bullionTeamSlotForTitle(title, teamA, teamB);
    if (g === 1) {
        const ord = bullionBatterOrdinalFromTitle(title);
        if (typeId === "910") return 0 + ord;
        if (typeId === "914") return 4000 + ord;
        return 9000;
    }
    if (g === 2) {
        if (typeId === "60") return 0;
        if (typeId === "70") return 100;
        if (typeId === "75") return 200;
        if (typeId === "85") return 300;
        if (typeId === "80") return 400;
        if (typeId === "88") return 500;
        if (typeId === "86") return 600;
        return 9000;
    }
    if (g === 3) {
        if (typeId === "510") return 0 + slot * 100;
        if (typeId === "610") return 200 + slot * 100;
        if (typeId === "220") return 400 + slot * 100;
        if (typeId === "230") return 600 + slot * 100;
        return 9000;
    }
    return 9999;
}
function compareBullionCricketRawMarketsForOrdering(a, b, teamA, teamB) {
    const ga = getBullionCricketMarketGroupIndex(a);
    const gb = getBullionCricketMarketGroupIndex(b);
    if (ga !== gb) return ga - gb;
    const ka = bullionCricketInGroupOrderKey(a, teamA, teamB);
    const kb = bullionCricketInGroupOrderKey(b, teamA, teamB);
    if (ka !== kb) return ka - kb;
    return displayTitle(a).localeCompare(displayTitle(b), undefined, {
        sensitivity: "base"
    });
}
function slugKeyPart(raw) {
    return String(raw || "").toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9_-]/g, "").slice(0, 120);
}
function bullionMarketStableId(market, index) {
    const mid = market.market_id != null ? String(market.market_id) : market.id != null ? String(market.id) : "";
    const lineAlt = market.line;
    const lid = market.market_line_id != null && String(market.market_line_id) !== "" ? String(market.market_line_id) : lineAlt != null && String(lineAlt) !== "" ? String(lineAlt) : "";
    const tid = String(market.market_type_id ?? "");
    const nameKey = slugKeyPart(market.name || market.market_name || market.market_type || "");
    if (mid && lid) return `${mid}_${lid}`;
    if (mid) return `${mid}__${lid || "noline"}__${tid}__${nameKey || "noname"}`;
    if (tid) return `${tid}__${nameKey || "noname"}`;
    return `m-${index}__${nameKey || "unnamed"}`;
}
function clampBullionGroupIndex(g) {
    if (!Number.isFinite(g)) return 0;
    return Math.min((0, _constants.BULLION_GROUP_COUNT) - 1, Math.max(0, g));
}

},{"./constants":"fFw1z","./bullionInplayTypeIds":"4ldHi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ldHi":[function(require,module,exports,__globalThis) {
/**
 * Decimal cricket in-play-only `market_type_id` values (Pre_Match=false, In_Play=true).
 * Keep in sync with `backend/data/decimal-cricket-market-phase.json` → `inplayOnly`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BULLION_DECIMAL_INPLAY_ONLY_TYPE_IDS", ()=>BULLION_DECIMAL_INPLAY_ONLY_TYPE_IDS);
parcelHelpers.export(exports, "isBullionInplayOnlyMarketTypeId", ()=>isBullionInplayOnlyMarketTypeId);
const BULLION_DECIMAL_INPLAY_ONLY_TYPE_IDS = new Set([
    "17",
    "89",
    "210",
    "216",
    "217",
    "218",
    "219",
    "221",
    "222",
    "270",
    "280",
    "347",
    "348",
    "349",
    "472",
    "478",
    "516",
    "611",
    "614",
    "620",
    "621",
    "640",
    "645",
    "646",
    "647",
    "648",
    "652",
    "653",
    "654",
    "710",
    "715",
    "720",
    "730",
    "735",
    "740",
    "750",
    "760",
    "765",
    "770",
    "790"
]);
function isBullionInplayOnlyMarketTypeId(raw) {
    const s = String(raw ?? "").trim();
    if (!s) return false;
    const id = /^\d+(\.0+)?$/.test(s) ? String(parseInt(s, 10)) : s;
    return BULLION_DECIMAL_INPLAY_ONLY_TYPE_IDS.has(id);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i9JWr":[function(require,module,exports,__globalThis) {
/** Mirrors `backend/utils/bullionOddsSnapshot.js` — unwrap snapshot jsonb: legacy array or `{ captured_at, markets }`. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bullionOddsSnapshotMarkets", ()=>bullionOddsSnapshotMarkets);
parcelHelpers.export(exports, "bullionOddsSnapshotCapturedAt", ()=>bullionOddsSnapshotCapturedAt);
function bullionOddsSnapshotMarkets(raw) {
    if (!raw) return [];
    if (typeof raw === "string") {
        const s = raw.trim();
        if (!s) return [];
        try {
            return bullionOddsSnapshotMarkets(JSON.parse(s));
        } catch  {
            return [];
        }
    }
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "object" && raw !== null && Array.isArray(raw.markets)) return raw.markets;
    return [];
}
function bullionOddsSnapshotCapturedAt(raw) {
    if (raw && typeof raw === "object" && !Array.isArray(raw) && raw.captured_at != null) {
        const s = String(raw.captured_at).trim();
        return s || null;
    }
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jEN44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Fixture has reached a terminal state on the cricket feed (no longer "in-play" for lobby purposes). */ parcelHelpers.export(exports, "isRawMatchFinishedForBullionLobby", ()=>isRawMatchFinishedForBullionLobby);
/** Stamp terminal feed fields onto a lobby raw row (session cache / landing upsert). */ parcelHelpers.export(exports, "stampFinishedOntoRawMatchRow", ()=>stampFinishedOntoRawMatchRow);
/** Whether BULLION should treat the fixture as "live" for lobby purposes. */ parcelHelpers.export(exports, "isRawMatchLiveForBullionLobby", ()=>isRawMatchLiveForBullionLobby);
/** Pre-start vs in-play vs finished for Bullion lobby / match landing labels. */ parcelHelpers.export(exports, "bullionLobbyFixturePhase", ()=>bullionLobbyFixturePhase);
/** `BullionRoom` built from lobby data or recovery — same phase labels when `fixturePhase` was omitted. */ parcelHelpers.export(exports, "bullionRoomResolvedFixturePhase", ()=>bullionRoomResolvedFixturePhase);
function isRawMatchFinishedForBullionLobby(match) {
    const status = String(match.status || "").toUpperCase();
    if (status.includes("MATCH COMPLETE") || status.includes("FINISHED") || status.includes("FULL TIME") || status.includes("EVENT CLOSED") || status === "EVENT_FULL_RESULT" || status.includes("ABANDONED")) return true;
    const ls = match.liveScore;
    if (ls && typeof ls === "object" && ls.isFinished === true) return true;
    const sport = String(match.sport || "").toLowerCase();
    if (sport === "cricket") {
        const startRaw = match.start ?? match.actual_start;
        if (startRaw) {
            const startMs = new Date(String(startRaw)).getTime();
            if (Number.isFinite(startMs) && startMs <= Date.now()) {
                const st = String(match.status || "").toUpperCase();
                const stillScheduled = st.includes("MATCH SCHEDULED") || st === "" || !String(match.status || "").trim();
                const feedLive = ls && typeof ls === "object" && ls.isLive === true;
                if (stillScheduled && !feedLive) {
                    const hoursSinceKickoff = (Date.now() - startMs) / 3600000;
                    if (hoursSinceKickoff >= 4) return true;
                }
            }
        }
    }
    return false;
}
function stampFinishedOntoRawMatchRow(match) {
    const prevLs = match.liveScore && typeof match.liveScore === "object" ? match.liveScore : {};
    return {
        ...match,
        status: "MATCH COMPLETE",
        liveScore: {
            ...prevLs,
            isFinished: true,
            isLive: false
        }
    };
}
function isRawMatchLiveForBullionLobby(match) {
    if (isRawMatchFinishedForBullionLobby(match)) return false;
    const ls = match.liveScore;
    if (ls && typeof ls === "object") {
        if (ls.isFinished === true) return false;
        if (ls.isLive === true) return true;
    }
    const status = String(match.status || "").toUpperCase();
    if (status.includes("MATCH IN PROGRESS") || status.includes("IN-PLAY") || status.includes("IN PLAY") || status.includes("LIVE") || status.includes("INNINGS BREAK") || status.includes("BREAK IN PLAY") || status.includes("TEA") || status.includes("LUNCH") || status.includes("DRINKS") || status.includes("INNINGS COMPLETE") || // Chase target ("Play to 150") — not pre-match "Play to Start Shortly"
    /\bPLAY TO \d/.test(status)) return true;
    const sport = String(match.sport || "").toLowerCase();
    const effectiveStart = match.actual_start ?? match.start;
    if (sport === "cricket" && effectiveStart) {
        const st = String(match.status || "").toUpperCase();
        const stillScheduled = st.includes("MATCH SCHEDULED") || st === "" || !String(match.status || "").trim();
        if (!stillScheduled) {
            const startMs = new Date(effectiveStart).getTime();
            if (!Number.isNaN(startMs)) {
                const minutesSinceStart = (Date.now() - startMs) / 60000;
                if (minutesSinceStart >= 0 && minutesSinceStart < 720) return true;
            }
        }
    }
    return false;
}
function bullionLobbyFixturePhase(match) {
    if (isRawMatchFinishedForBullionLobby(match)) return "finished";
    if (isRawMatchLiveForBullionLobby(match)) return "live";
    return "scheduled";
}
function bullionRoomResolvedFixturePhase(room) {
    if (room.fixturePhase) return room.fixturePhase;
    const st = String(room.status || "").toUpperCase();
    if (st.includes("MATCH COMPLETE") || st.includes("FINISHED") || st.includes("FULL TIME") || st.includes("EVENT CLOSED") || st === "EVENT_FULL_RESULT" || st.includes("ABANDONED")) return "finished";
    return room.isLive ? "live" : "scheduled";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SlWC":[function(require,module,exports,__globalThis) {
/**
 * Decimal `market_id` / `market_line_id` for Bullion persistence and settlement matching.
 * Win markets (e.g. Toss Winner) sometimes echo `market_line_id === market_id`; treat as no line.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canonicalBullionDecimalMarketLineId", ()=>canonicalBullionDecimalMarketLineId);
function canonicalBullionDecimalMarketLineId(marketId, lineId) {
    const mid = marketId != null ? String(marketId).trim() : "";
    const lid = lineId != null ? String(lineId).trim() : "";
    if (!lid) return null;
    if (mid && lid === mid) return null;
    return lid;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZmoD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Raw markets for the BULLION pick board — frozen prematch `opening_odds` / `odds_snapshot` only.
 * Live Decimal `market_update` is never used here; in-play settlement matches stored
 * `market_id` + `market_line_id` against live feed + settlements API (`bullionSettlementFromDecimalApi.js`).
 */ parcelHelpers.export(exports, "bullionBoardRawMarketsForMatch", ()=>bullionBoardRawMarketsForMatch);
/** Board lines from a contest/play `opening_odds` or `odds_snapshot` payload (no live feed merge). */ parcelHelpers.export(exports, "frozenMarketsFromOpeningOddsSnapshot", ()=>frozenMarketsFromOpeningOddsSnapshot);
var _bullionOddsSnapshot = require("./bullionOddsSnapshot");
function frozenMarketsFromMatchRow(match) {
    const m = match;
    const snap = m.opening_odds ?? m.openingOdds ?? m.bullionOpeningOdds;
    const fromSnap = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(snap);
    if (fromSnap.length > 0) return fromSnap;
    // Lobby API also copies the same snapshot onto `markets` when `opening_odds` is set.
    return (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(m.markets);
}
function bullionBoardRawMarketsForMatch(match) {
    return frozenMarketsFromMatchRow(match);
}
function frozenMarketsFromOpeningOddsSnapshot(frozenOdds) {
    const frozen = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(frozenOdds);
    return frozen.length > 0 ? frozen : [];
}

},{"./bullionOddsSnapshot":"i9JWr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hiNiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveBullionFixtureScheduledStartRaw", ()=>resolveBullionFixtureScheduledStartRaw);
parcelHelpers.export(exports, "parseBullionFixtureDatetimeToMs", ()=>parseBullionFixtureDatetimeToMs);
parcelHelpers.export(exports, "resolveBullionFixtureScheduledStartMs", ()=>resolveBullionFixtureScheduledStartMs);
parcelHelpers.export(exports, "resolveBullionFixtureScheduledStartIso", ()=>resolveBullionFixtureScheduledStartIso);
function resolveBullionFixtureScheduledStartRaw(fixture) {
    if (!fixture || typeof fixture !== "object") return null;
    const m = fixture;
    const candidates = [
        m.start,
        m["starts-at"],
        m.startTime,
        m.start_time,
        m.scheduledStart,
        m.scheduled_start
    ];
    for (const raw of candidates){
        if (raw == null || String(raw).trim() === "") continue;
        if (raw instanceof Date) return raw.toISOString();
        const text = String(raw).trim();
        if (text) return text;
    }
    return null;
}
/** JS `Date` rejects PostgreSQL ISO strings with a 2-digit offset (`+00`) — normalize before parse. */ function normalizeDatetimeStringForParse(raw) {
    if (raw instanceof Date) return raw;
    const text = String(raw).trim();
    if (!text) return text;
    if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(?:\.\d+)?[+-]\d{2}$/.test(text)) return `${text}:00`;
    return text;
}
function parseBullionFixtureDatetimeToMs(raw) {
    if (raw == null || raw === "") return null;
    if (raw instanceof Date) {
        const t = raw.getTime();
        return Number.isFinite(t) ? t : null;
    }
    const t = new Date(normalizeDatetimeStringForParse(raw)).getTime();
    return Number.isFinite(t) ? t : null;
}
function resolveBullionFixtureScheduledStartMs(fixture) {
    const raw = resolveBullionFixtureScheduledStartRaw(fixture);
    if (!raw) return null;
    return parseBullionFixtureDatetimeToMs(raw);
}
function resolveBullionFixtureScheduledStartIso(fixture) {
    const ms = resolveBullionFixtureScheduledStartMs(fixture);
    if (ms == null) return null;
    return new Date(ms).toISOString();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dQhbi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** True when the fixture is T20 (20 overs). */ parcelHelpers.export(exports, "isT20BullionLobbyMatch", ()=>isT20BullionLobbyMatch);
/** True when the fixture is F50 / ODI (50 overs). */ parcelHelpers.export(exports, "isF50BullionLobbyMatch", ()=>isF50BullionLobbyMatch);
/** True when the fixture is The Hundred (Decimal format 100). */ parcelHelpers.export(exports, "isHundredBullionLobbyMatch", ()=>isHundredBullionLobbyMatch);
/** Fixtures offered in the Bullion lobby (keep aligned with `isBullionOfferMatch` in backend). */ parcelHelpers.export(exports, "isBullionLobbyOfferMatch", ()=>isBullionLobbyOfferMatch);
/**
 * When `/bullion/lobby-matches` refreshes it omits live fixtures; keep the last known row for each
 * active-play match id that disappeared from the new API payload.
 */ parcelHelpers.export(exports, "pickPreservedLobbyRowsForActivePlays", ()=>pickPreservedLobbyRowsForActivePlays);
/**
 * Stable key for the same real-world fixture listed under multiple Decimal match ids
 * (e.g. LIVE2026 in-play + LIVE206 still "Match Scheduled").
 */ parcelHelpers.export(exports, "bullionLobbyFixtureDedupeKey", ()=>bullionLobbyFixtureDedupeKey);
/**
 * Collapse Decimal duplicate listings of the same fixture (same teams + kickoff + competition).
 * Prefer rows the user already entered; otherwise prefer live / nearer-to-start over stale scheduled twins.
 */ parcelHelpers.export(exports, "collapseDuplicateBullionLobbyFixtures", ()=>collapseDuplicateBullionLobbyFixtures);
/** Merge Bullion lobby sources (dedupe by match id; primary order wins). */ parcelHelpers.export(exports, "mergeBullionLobbySourceLists", ()=>mergeBullionLobbySourceLists);
/**
 * Bullion lobby: in-progress fixtures only when the user has an active play, except pre-kickoff
 * toss/build-up where the stream can report live before scheduled start; upcoming within `daysAhead`;
 * T20/F50 offers only; ordered by time horizon → competition priority → start time (same as backend).
 */ parcelHelpers.export(exports, "selectAndOrderBullionLobbyMatches", ()=>selectAndOrderBullionLobbyMatches);
var _cricketMatchCardOverDisplay = require("../../Cricket/cricketMatchCardOverDisplay");
var _bullionMatchLandingLobby = require("./bullionMatchLandingLobby");
var _bullionLobbyStalePrune = require("./bullionLobbyStalePrune");
var _bullionFixtureScheduledStart = require("./bullionFixtureScheduledStart");
var _bullionRawMatch = require("./bullionRawMatch");
var _bullionOddsSnapshot = require("./bullionOddsSnapshot");
var _matchTimeHorizon = require("../../../utils/matchTimeHorizon");
function bullionMatchStartMs(match) {
    const m = match;
    const raw = m.actual_start ?? match.start ?? m["starts-at"] ?? m.startTime ?? m.start_time;
    return (0, _bullionFixtureScheduledStart.parseBullionFixtureDatetimeToMs)(raw);
}
/** Scheduled wall-clock start only — `actual_start` can move early during toss feed updates. */ function bullionMatchScheduledStartMs(match) {
    return (0, _bullionFixtureScheduledStart.resolveBullionFixtureScheduledStartMs)(match);
}
function isT20BullionLobbyMatch(match) {
    return (0, _cricketMatchCardOverDisplay.bullionCricketFormatOversFromMatch)(match) === 20;
}
function isF50BullionLobbyMatch(match) {
    return (0, _cricketMatchCardOverDisplay.bullionCricketFormatOversFromMatch)(match) === 50;
}
function isHundredBullionLobbyMatch(match) {
    return (0, _cricketMatchCardOverDisplay.bullionCricketFormatOversFromMatch)(match) === 100;
}
function matchHasBullionLobbyFrozenBoardFromApi(match) {
    const m = match;
    const snap = m.opening_odds ?? m.openingOdds;
    if ((0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(snap).length > 1) return true;
    return (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(m.markets).length > 1;
}
function isBullionLobbyOfferMatch(match) {
    if (matchHasBullionLobbyFrozenBoardFromApi(match)) return true;
    const overs = (0, _cricketMatchCardOverDisplay.bullionCricketFormatOversFromMatch)(match);
    return overs === 20 || overs === 50 || overs === 100;
}
function pickPreservedLobbyRowsForActivePlays(prevRows, apiRows, activeMids, activeByMatch) {
    if (activeMids.length === 0) return [];
    const preserved = [];
    for (const want of activeMids){
        const id = String(want || "").trim();
        if (!id) continue;
        if (activeByMatch && !(0, _bullionLobbyStalePrune.bullionUserHasUnsettledPlayOnMatch)(id, activeByMatch)) continue;
        if (apiRows.some((m)=>(0, _bullionMatchLandingLobby.bullionLobbyMatchIdsEqual)(String(m.id ?? ""), id))) continue;
        const fromPrev = prevRows.find((m)=>(0, _bullionMatchLandingLobby.bullionLobbyMatchIdsEqual)(String(m.id ?? ""), id));
        if (fromPrev && !(0, _bullionRawMatch.isRawMatchFinishedForBullionLobby)(fromPrev)) preserved.push(fromPrev);
    }
    return preserved;
}
function normalizeBullionLobbyTeamToken(raw) {
    return String(raw ?? "").trim().toLowerCase().replace(/\s+/g, " ");
}
function bullionLobbyFixtureDedupeKey(match) {
    const m = match;
    const home = normalizeBullionLobbyTeamToken(m.home);
    const away = normalizeBullionLobbyTeamToken(m.away);
    let teams;
    if (home && away) teams = [
        home,
        away
    ].sort();
    else {
        const name = String(m.name ?? m.matchName ?? "").trim();
        if (!name) return null;
        const beforeComma = name.split(",")[0] || name;
        const parts = beforeComma.split(/\s+v(?:s)?\.?\s+/i).map((t)=>normalizeBullionLobbyTeamToken(t)).filter(Boolean);
        if (parts.length < 2) return null;
        teams = parts.slice(0, 2).sort();
    }
    const startMs = bullionMatchScheduledStartMs(match) ?? bullionMatchStartMs(match);
    if (startMs == null) return null;
    const startBucket = Math.floor(startMs / 60000);
    // Teams + kickoff only — DB-merged rows often omit competition/home/away.
    return `${teams[0]}\u001f${teams[1]}\u001f${startBucket}`;
}
function bullionTwinReadinessScore(match, isLive) {
    const status = String(match.status || "").toUpperCase();
    const id = String(match.id || "");
    if ((0, _bullionRawMatch.isRawMatchFinishedForBullionLobby)(match)) return -100;
    let score = 10;
    if (isLive(match)) score = 100;
    else if (status.includes("PLAY TO START SHORTLY") || status.includes("MATCH STABLE")) score = 60;
    else if (status.includes("TOSS")) score = 45;
    else if (status.includes("MATCH SCHEDULED") || status.includes("PRE MATCH")) score = 30;
    // Prefer …LIVE2026; demote truncated …LIVE206 twins (not the bookable fixture).
    if (/LIVE\d{4}$/i.test(id)) score += 10;
    else if (/LIVE\d{3}$/i.test(id)) score -= 10;
    return score;
}
function collapseDuplicateBullionLobbyFixtures(matches, opts) {
    const list = Array.isArray(matches) ? matches : [];
    if (list.length < 2) return list;
    const hasUserPlay = opts?.hasUserPlay ?? (()=>false);
    const isLive = opts?.isLive ?? ((m)=>(0, _bullionRawMatch.isRawMatchLiveForBullionLobby)(m));
    const groups = new Map();
    const order = [];
    for (const m of list){
        const key = bullionLobbyFixtureDedupeKey(m) || `\0id:${String(m.id ?? "")}`;
        if (!groups.has(key)) {
            groups.set(key, []);
            order.push(key);
        }
        groups.get(key).push(m);
    }
    const out = [];
    for (const key of order){
        const group = groups.get(key) || [];
        if (group.length <= 1 || key.startsWith("\0id:")) {
            out.push(...group);
            continue;
        }
        const withPlay = [];
        const withoutPlay = [];
        for (const m of group){
            const id = String(m.id ?? "").trim();
            if (id && hasUserPlay(id)) withPlay.push(m);
            else withoutPlay.push(m);
        }
        if (withPlay.length > 0) {
            out.push(...withPlay);
            continue;
        }
        let best = withoutPlay[0];
        let bestScore = bullionTwinReadinessScore(best, isLive);
        for(let i = 1; i < withoutPlay.length; i++){
            const cand = withoutPlay[i];
            const score = bullionTwinReadinessScore(cand, isLive);
            if (score > bestScore) {
                best = cand;
                bestScore = score;
            }
        }
        if (best) out.push(best);
    }
    return out;
}
function mergeBullionLobbySourceLists(primary, cricketSupplement) {
    const seen = new Set();
    const out = [];
    for (const m of primary){
        const id = String(m.id ?? "").trim();
        if (!id || seen.has(id)) continue;
        seen.add(id);
        out.push(m);
    }
    for (const m of cricketSupplement){
        const id = String(m.id ?? "").trim();
        if (!id || seen.has(id)) continue;
        if (String(m.sport || "").toLowerCase() !== "cricket") continue;
        seen.add(id);
        out.push(m);
    }
    return out;
}
function shouldIncludeBullionLobbyOfferMatch(match, userActiveMatchIds, bullionActivePlaysLoaded) {
    if (bullionActivePlaysLoaded) {
        const id = String(match.id ?? "").trim();
        if (id && (0, _bullionMatchLandingLobby.bullionLobbyUserHasActivePlay)(id, userActiveMatchIds)) return true;
    }
    return isBullionLobbyOfferMatch(match);
}
function selectAndOrderBullionLobbyMatches(matches, opts) {
    const { userActiveMatchIds, daysAhead, maxMatches, bullionActivePlaysLoaded, activeBullionGamesByMatchId } = opts;
    const now = Date.now();
    const windowEnd = now + daysAhead * 86400000;
    const windowStart = now - 43200000;
    const filtered = [];
    const filteredIds = new Set();
    const push = (row)=>{
        const rid = String(row.id ?? "").trim();
        if (!rid || filteredIds.has(rid)) return;
        filteredIds.add(rid);
        filtered.push(row);
    };
    const inUpcomingWindow = (start)=>start != null && start <= windowEnd && start >= windowStart;
    for (const m of matches){
        if (String(m.sport || "").toLowerCase() !== "cricket") continue;
        const id = String(m.id ?? "").trim();
        if (!id) continue;
        const live = (0, _bullionRawMatch.isRawMatchLiveForBullionLobby)(m);
        const startMs = bullionMatchStartMs(m);
        const scheduledStartMs = bullionMatchScheduledStartMs(m);
        const userPlay = (0, _bullionLobbyStalePrune.bullionLobbyUserHasLobbyRelevantPlay)(id, userActiveMatchIds, bullionActivePlaysLoaded, activeBullionGamesByMatchId);
        if (bullionActivePlaysLoaded && userPlay) {
            push(m);
            continue;
        }
        if (live) {
            if (!bullionActivePlaysLoaded && inUpcomingWindow(startMs ?? scheduledStartMs)) {
                if (shouldIncludeBullionLobbyOfferMatch(m, userActiveMatchIds, bullionActivePlaysLoaded)) push(m);
                continue;
            }
            if (scheduledStartMs != null && now < scheduledStartMs && inUpcomingWindow(scheduledStartMs)) {
                if (shouldIncludeBullionLobbyOfferMatch(m, userActiveMatchIds, bullionActivePlaysLoaded)) push(m);
            }
            continue;
        }
        const upcomingStartMs = scheduledStartMs ?? startMs;
        if (inUpcomingWindow(upcomingStartMs) && shouldIncludeBullionLobbyOfferMatch(m, userActiveMatchIds, bullionActivePlaysLoaded)) push(m);
    }
    if (bullionActivePlaysLoaded) for (const m of matches){
        const id = String(m.id ?? "").trim();
        if (!id || filteredIds.has(id)) continue;
        if (String(m.sport || "").toLowerCase() !== "cricket") continue;
        if ((0, _bullionLobbyStalePrune.bullionLobbyUserHasLobbyRelevantPlay)(id, userActiveMatchIds, bullionActivePlaysLoaded, activeBullionGamesByMatchId)) push(m);
    }
    const collapsed = collapseDuplicateBullionLobbyFixtures(filtered, {
        hasUserPlay: (id)=>(0, _bullionLobbyStalePrune.bullionLobbyUserHasLobbyRelevantPlay)(id, userActiveMatchIds, bullionActivePlaysLoaded, activeBullionGamesByMatchId),
        isLive: (0, _bullionRawMatch.isRawMatchLiveForBullionLobby)
    });
    const userPlayRows = [];
    const otherRows = [];
    for (const row of collapsed){
        const id = String(row.id ?? "").trim();
        if (bullionActivePlaysLoaded && id && (0, _bullionLobbyStalePrune.bullionLobbyUserHasLobbyRelevantPlay)(id, userActiveMatchIds, bullionActivePlaysLoaded, activeBullionGamesByMatchId)) userPlayRows.push(row);
        else otherRows.push(row);
    }
    const resolveLobbyPriority = (match)=>{
        const row = match;
        if (typeof row._priority === "number") return row._priority;
        return 99;
    };
    const sortRows = (rows)=>{
        rows.sort((a, b)=>{
            const ta = bullionMatchStartMs(a);
            const tb = bullionMatchStartMs(b);
            const phase = (0, _matchTimeHorizon.compareMatchUpcomingPhase)(ta, tb);
            if (phase !== 0) return phase;
            const prioA = resolveLobbyPriority(a);
            const prioB = resolveLobbyPriority(b);
            if (prioA !== prioB) return prioA - prioB;
            if (ta != null && tb != null && ta !== tb) return ta - tb;
            if (ta == null && tb != null) return 1;
            if (ta != null && tb == null) return -1;
            return 0;
        });
    };
    sortRows(userPlayRows);
    sortRows(otherRows);
    const capOthers = Math.max(0, maxMatches - userPlayRows.length);
    const merged = [
        ...userPlayRows,
        ...otherRows.slice(0, capOthers)
    ];
    return merged.filter((m)=>{
        if (!(0, _bullionRawMatch.isRawMatchFinishedForBullionLobby)(m)) return true;
        const id = String(m.id ?? "").trim();
        if (!id || !bullionActivePlaysLoaded) return false;
        return (0, _bullionLobbyStalePrune.bullionUserHasUnsettledPlayOnMatch)(id, activeBullionGamesByMatchId);
    });
}

},{"../../Cricket/cricketMatchCardOverDisplay":"jVYsA","./bullionMatchLandingLobby":"6cMJo","./bullionLobbyStalePrune":"6tvlU","./bullionFixtureScheduledStart":"hiNiA","./bullionRawMatch":"jEN44","./bullionOddsSnapshot":"i9JWr","../../../utils/matchTimeHorizon":"78nzv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6cMJo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeBullionMatchQueryParam", ()=>normalizeBullionMatchQueryParam);
/** Match ids from lobby rows vs `/bullion/my-games` can differ by encoding — compare canonically. */ parcelHelpers.export(exports, "bullionLobbyMatchIdsEqual", ()=>bullionLobbyMatchIdsEqual);
parcelHelpers.export(exports, "bullionLobbyUserHasActivePlay", ()=>bullionLobbyUserHasActivePlay);
/** `location.state.room` from lobby PLAY — survives when the frozen lobby refetch omits this fixture. */ parcelHelpers.export(exports, "bullionStateRoomMatchesMatchQuery", ()=>bullionStateRoomMatchesMatchQuery);
/** Unfiltered lobby/trader row for a fixture id (before `selectAndOrderBullionLobbyMatches`). */ parcelHelpers.export(exports, "findRawMatchInBullionLobbyRows", ()=>findRawMatchInBullionLobbyRows);
parcelHelpers.export(exports, "buildBullionRoomFromLobbyRawRow", ()=>buildBullionRoomFromLobbyRawRow);
parcelHelpers.export(exports, "findBullionLobbyGamesForMatchId", ()=>findBullionLobbyGamesForMatchId);
/** Merge match-landing `enteredGames` into the my-games-by-match map (deduped by gameId). */ parcelHelpers.export(exports, "mergeBullionEnteredGamesIntoByMatchId", ()=>mergeBullionEnteredGamesIntoByMatchId);
/** Bullion `/bullion/my-games` can authenticate via JWT (header/cookie) or `session_token` query. */ parcelHelpers.export(exports, "hasBullionMyGamesAuth", ()=>hasBullionMyGamesAuth);
/** Same-session requests without JWT must pass `session_token` for `jwtOptionalAuth`. */ parcelHelpers.export(exports, "withSessionTokenQuery", ()=>withSessionTokenQuery);
parcelHelpers.export(exports, "buildBullionLobbyMergedRowsFromApiMatches", ()=>buildBullionLobbyMergedRowsFromApiMatches);
/**
 * Resolve one fixture row for match landing — session/lobby peek, then Trader cricket events (not full Bullion lobby list).
 */ parcelHelpers.export(exports, "fetchBullionLandingFixtureRowsForMatch", ()=>fetchBullionLandingFixtureRowsForMatch);
parcelHelpers.export(exports, "getInitialBullionMatchLandingLobbyState", ()=>getInitialBullionMatchLandingLobbyState);
/** Upsert one fixture into the lobby session list (do not replace the full lobby with a single row). */ parcelHelpers.export(exports, "writeBullionLandingFixtureRowToSessionCache", ()=>writeBullionLandingFixtureRowToSessionCache);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _authHeaders = require("../../../utils/authHeaders");
var _bullionLobbyApi = require("./bullionLobbyApi");
var _bullionFixtureFrozenOdds = require("./bullionFixtureFrozenOdds");
var _bullionOddsSnapshot = require("./bullionOddsSnapshot");
var _bullionLobbyEventsSessionCache = require("./bullionLobbyEventsSessionCache");
var _bullionLobbyOrdering = require("./bullionLobbyOrdering");
var _bullionFixturePhaseResolve = require("./bullionFixturePhaseResolve");
var _bullionMyGamesByMatchIdCache = require("./bullionMyGamesByMatchIdCache");
var _bullionTraderCricketEventsCache = require("./bullionTraderCricketEventsCache");
var _bullionRawMatch = require("./bullionRawMatch");
var _roomUtils = require("./roomUtils");
function normalizeBullionMatchQueryParam(raw) {
    const t = raw.trim();
    try {
        return decodeURIComponent(t).trim();
    } catch  {
        return t;
    }
}
function bullionLobbyMatchIdsEqual(a, b) {
    const na = normalizeBullionMatchQueryParam(a);
    const nb = normalizeBullionMatchQueryParam(b);
    return Boolean(na && nb && na === nb);
}
function bullionLobbyUserHasActivePlay(matchId, userActiveMatchIds) {
    const want = normalizeBullionMatchQueryParam(matchId);
    if (!want || userActiveMatchIds.size === 0) return false;
    for (const key of userActiveMatchIds){
        if (normalizeBullionMatchQueryParam(key) === want) return true;
    }
    return false;
}
function bullionStateRoomMatchesMatchQuery(room, matchQuery) {
    if (!room || !String(matchQuery || "").trim()) return false;
    const want = normalizeBullionMatchQueryParam(matchQuery);
    if (!want) return false;
    const mid = String(room.matchId ?? "").trim();
    const rid = String(room.id ?? "").trim();
    return mid !== "" && bullionLobbyMatchIdsEqual(mid, want) || rid !== "" && bullionLobbyMatchIdsEqual(rid, want) || rid !== "" && bullionLobbyMatchIdsEqual(rid, `bullion-${want}`);
}
function findRawMatchInBullionLobbyRows(rows, matchQuery) {
    const want = normalizeBullionMatchQueryParam(matchQuery);
    if (!want) return null;
    for (const row of rows){
        const id = String(row?.id ?? "").trim();
        if (id && bullionLobbyMatchIdsEqual(id, want)) return row;
    }
    return null;
}
function buildBullionRoomFromLobbyRawRow(row) {
    if (!row || typeof row !== "object") return null;
    try {
        const built = (0, _roomUtils.buildBullionRooms)([
            row
        ], 1);
        return built[0] ?? null;
    } catch  {
        return null;
    }
}
function findBullionLobbyGamesForMatchId(matchId, byMatch) {
    const want = normalizeBullionMatchQueryParam(matchId);
    if (!want) return [];
    for (const [key, games] of Object.entries(byMatch)){
        if (normalizeBullionMatchQueryParam(key) === want) return games;
    }
    return [];
}
function mergeBullionEnteredGamesIntoByMatchId(prev, matchId, incoming) {
    if (incoming.length === 0) return prev;
    const want = normalizeBullionMatchQueryParam(matchId);
    if (!want) return prev;
    const existingKey = Object.keys(prev).find((k)=>normalizeBullionMatchQueryParam(k) === want) ?? matchId.trim();
    const byId = new Map();
    for (const g of findBullionLobbyGamesForMatchId(matchId, prev))byId.set(Number(g.gameId), g);
    for (const g of incoming)byId.set(Number(g.gameId), g);
    return {
        ...prev,
        [existingKey]: Array.from(byId.values())
    };
}
function hasBullionMyGamesAuth() {
    return Boolean((0, _jsCookieDefault.default).get("c8_session_token") || (0, _authHeaders.getJwt)());
}
function withSessionTokenQuery(url) {
    const st = (0, _jsCookieDefault.default).get("c8_session_token");
    if (!st) return url;
    const u = new URL(url);
    if (!u.searchParams.has("session_token")) u.searchParams.set("session_token", st);
    return u.toString();
}
function buildBullionLobbyMergedRowsFromApiMatches(matches) {
    const events = (Array.isArray(matches) ? matches : []).map((match)=>({
            ...match,
            sport: "cricket"
        }));
    return (0, _bullionLobbyOrdering.mergeBullionLobbySourceLists)(events, []);
}
async function enrichLobbyRowWithFrozenOddsIfNeeded(row) {
    if (!row || typeof row !== "object") return row;
    const mid = String(row?.id ?? "").trim();
    if (!mid) return row;
    const hasFrozen = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(row.opening_odds).length > 0 || (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(row.markets).length > 0;
    if (hasFrozen) return row;
    const frozen = await (0, _bullionFixtureFrozenOdds.fetchBullionFixtureFrozenOdds)(mid);
    if (!frozen.ready && !(frozen.markets?.length ?? 0)) return row;
    return (0, _bullionFixtureFrozenOdds.mergeBullionFrozenOddsOntoLobbyRow)(row, frozen);
}
async function fetchBullionLandingFixtureRowsForMatch(matchQuery) {
    const want = normalizeBullionMatchQueryParam(matchQuery);
    if (!want) return [];
    const sessionRows = (0, _bullionLobbyEventsSessionCache.readCachedBullionLobbyEvents)();
    if (sessionRows?.length) {
        const hit = findRawMatchInBullionLobbyRows(sessionRows, want);
        if (hit) return [
            await enrichLobbyRowWithFrozenOddsIfNeeded(hit)
        ];
    }
    const peek = (0, _bullionLobbyApi.peekBullionLobbyMatchesCache)();
    const peekMatches = peek && Array.isArray(peek.matches) ? peek.matches : [];
    if (peekMatches.length) {
        const hit = findRawMatchInBullionLobbyRows(peekMatches, want);
        if (hit) return [
            await enrichLobbyRowWithFrozenOddsIfNeeded(hit)
        ];
    }
    const trader = await (0, _bullionTraderCricketEventsCache.fetchTraderCricketEventsCached)();
    const row = trader.find((m)=>bullionLobbyMatchIdsEqual(String(m?.id ?? ""), want));
    if (!row) return [];
    return [
        await enrichLobbyRowWithFrozenOddsIfNeeded(row)
    ];
}
function getInitialBullionMatchLandingLobbyState(matchQuery) {
    const want = matchQuery ? normalizeBullionMatchQueryParam(matchQuery) : "";
    const sessionRows = (0, _bullionLobbyEventsSessionCache.readCachedBullionLobbyEvents)();
    if (sessionRows && sessionRows.length > 0) {
        if (want) {
            const hit = findRawMatchInBullionLobbyRows(sessionRows, want);
            if (hit) return {
                rows: [
                    hit
                ],
                hasWarmStart: true
            };
            /** Do not hydrate another fixture from session when the URL targets a different match. */ return {
                rows: [],
                hasWarmStart: false
            };
        }
        return {
            rows: sessionRows,
            hasWarmStart: true
        };
    }
    const peek = (0, _bullionLobbyApi.peekBullionLobbyMatchesCache)();
    const peekMatches = peek && Array.isArray(peek.matches) ? peek.matches : [];
    if (peekMatches.length > 0) {
        const merged = buildBullionLobbyMergedRowsFromApiMatches(peekMatches);
        if (want) {
            const hit = findRawMatchInBullionLobbyRows(merged, want);
            if (hit) return {
                rows: [
                    hit
                ],
                hasWarmStart: true
            };
            return {
                rows: [],
                hasWarmStart: false
            };
        }
        return {
            rows: merged,
            hasWarmStart: true
        };
    }
    return {
        rows: [],
        hasWarmStart: false
    };
}
function writeBullionLandingFixtureRowToSessionCache(row, opts) {
    if (!row || typeof row !== "object") return;
    const id = String(row.id ?? "").trim();
    if (!id) return;
    let patch = row;
    if (opts?.stampFinishedFromRoom) {
        const resolved = (0, _bullionFixturePhaseResolve.resolveBullionMatchFixtureState)(opts.stampFinishedFromRoom, {
            useContestSignals: false
        });
        if (resolved.matchFinished) patch = (0, _bullionRawMatch.stampFinishedOntoRawMatchRow)(patch);
    }
    const existing = (0, _bullionLobbyEventsSessionCache.readCachedBullionLobbyEvents)() ?? [];
    const rest = existing.filter((m)=>!bullionLobbyMatchIdsEqual(String(m?.id ?? ""), id));
    const merged = (0, _bullionLobbyOrdering.mergeBullionLobbySourceLists)([
        patch
    ], rest);
    const activeByMatch = opts?.activeByMatch ?? (0, _bullionMyGamesByMatchIdCache.peekBullionMyGamesByMatchIdCache)() ?? undefined;
    (0, _bullionLobbyEventsSessionCache.writeCachedBullionLobbyEvents)(merged, {
        activeByMatch
    });
}

},{"js-cookie":"2P5RE","../../../utils/authHeaders":"5Rczo","./bullionLobbyApi":"37bEq","./bullionFixtureFrozenOdds":"83sdp","./bullionOddsSnapshot":"i9JWr","./bullionLobbyEventsSessionCache":"jrzfz","./bullionLobbyOrdering":"dQhbi","./bullionFixturePhaseResolve":"ilaJp","./bullionMyGamesByMatchIdCache":"lQPs3","./bullionTraderCricketEventsCache":"hyV6a","./bullionRawMatch":"jEN44","./roomUtils":"8f6zP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"37bEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** In-memory hit for warm starts (same SPA session, within TTL). */ parcelHelpers.export(exports, "peekBullionLobbyMatchesCache", ()=>peekBullionLobbyMatchesCache);
/**
 * Bullion lobby list: same rows as GET `/bullion/lobby-matches` (fixtures with frozen `bullion_match.opening_odds` only).
 */ parcelHelpers.export(exports, "fetchBullionLobbyMatches", ()=>fetchBullionLobbyMatches);
parcelHelpers.export(exports, "invalidateBullionLobbyMatchesCache", ()=>invalidateBullionLobbyMatchesCache);
/**
 * Cached GET `/bullion/lobby-matches` — speeds up match landing and avoids duplicate in-flight requests.
 */ parcelHelpers.export(exports, "fetchBullionLobbyMatchesCached", ()=>fetchBullionLobbyMatchesCached);
var _authHeaders = require("../../../utils/authHeaders");
const BULLION_LOBBY_HTTP_CACHE_TTL_MS = 45000;
let bullionLobbyHttpCache = null;
let bullionLobbyHttpInflight = null;
function peekBullionLobbyMatchesCache() {
    const now = Date.now();
    if (bullionLobbyHttpCache && bullionLobbyHttpCache.expiresAt > now) return bullionLobbyHttpCache.payload;
    return null;
}
async function fetchBullionLobbyMatches() {
    const base = "https://cricket8.com/api".replace(/\/$/, "");
    const url = `${base}/bullion/lobby-matches`;
    const res = await fetch(url, {
        method: "GET",
        headers: (0, _authHeaders.getAuthHeaders)()
    });
    if (!res.ok) return {
        matches: [],
        count: 0
    };
    const data = await res.json().catch(()=>({}));
    const matches = Array.isArray(data.matches) ? data.matches : [];
    const count = typeof data.count === "number" ? data.count : matches.length;
    const maxMatches = typeof data.maxMatches === "number" ? data.maxMatches : undefined;
    return {
        matches,
        count,
        maxMatches
    };
}
function invalidateBullionLobbyMatchesCache() {
    bullionLobbyHttpCache = null;
    bullionLobbyHttpInflight = null;
}
async function fetchBullionLobbyMatchesCached(opts) {
    const now = Date.now();
    if (!opts?.bypassCache) {
        if (bullionLobbyHttpCache && bullionLobbyHttpCache.expiresAt > now) return bullionLobbyHttpCache.payload;
        if (bullionLobbyHttpInflight) return bullionLobbyHttpInflight;
    }
    bullionLobbyHttpInflight = (async ()=>{
        try {
            const payload = await fetchBullionLobbyMatches();
            bullionLobbyHttpCache = {
                expiresAt: Date.now() + BULLION_LOBBY_HTTP_CACHE_TTL_MS,
                payload
            };
            return payload;
        } finally{
            bullionLobbyHttpInflight = null;
        }
    })();
    return bullionLobbyHttpInflight;
}

},{"../../../utils/authHeaders":"5Rczo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"83sdp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Load `bullion_match.opening_odds` for one fixture (board hydration when lobby cache / Trader rows lack frozen lines).
 */ parcelHelpers.export(exports, "fetchBullionFixtureFrozenOdds", ()=>fetchBullionFixtureFrozenOdds);
/** Merge frozen `opening_odds` / `markets` onto a lobby raw row when missing. */ parcelHelpers.export(exports, "mergeBullionFrozenOddsOntoLobbyRow", ()=>mergeBullionFrozenOddsOntoLobbyRow);
var _authHeaders = require("../../../utils/authHeaders");
var _bullionOddsSnapshot = require("./bullionOddsSnapshot");
const frozenOddsInflight = new Map();
async function fetchBullionFixtureFrozenOdds(matchId) {
    const want = String(matchId || "").trim();
    if (!want) return {
        success: false,
        ready: false,
        markets: []
    };
    const existing = frozenOddsInflight.get(want);
    if (existing) return existing;
    const base = "https://cricket8.com/api".replace(/\/$/, "");
    const url = `${base}/bullion/fixture-frozen-odds?matchId=${encodeURIComponent(want)}`;
    const promise = (async ()=>{
        try {
            const res = await fetch(url, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            const data = await res.json().catch(()=>({}));
            if (!res.ok) return {
                success: false,
                ready: false,
                markets: []
            };
            const markets = Array.isArray(data.markets) ? data.markets : (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(data.opening_odds);
            return {
                ...data,
                markets,
                ready: Boolean(data.ready) || markets.length > 0
            };
        } catch  {
            return {
                success: false,
                ready: false,
                markets: []
            };
        } finally{
            frozenOddsInflight.delete(want);
        }
    })();
    frozenOddsInflight.set(want, promise);
    return promise;
}
function mergeBullionFrozenOddsOntoLobbyRow(row, frozen) {
    if (!row || typeof row !== "object" || !frozen) return row;
    const markets = Array.isArray(frozen.markets) ? frozen.markets : (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(frozen.opening_odds);
    if (markets.length === 0) return row;
    const r = row;
    const hasOpening = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(r.opening_odds ?? r.openingOdds).length > 0;
    const hasMarkets = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(r.markets).length > 0;
    if (hasOpening && hasMarkets) return row;
    const opening = frozen.opening_odds ?? r.opening_odds ?? r.openingOdds ?? {
        markets
    };
    return {
        ...r,
        opening_odds: hasOpening ? r.opening_odds ?? r.openingOdds : opening,
        markets: hasMarkets ? r.markets : markets,
        sport: r.sport || "cricket"
    };
}

},{"../../../utils/authHeaders":"5Rczo","./bullionOddsSnapshot":"i9JWr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jrzfz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BULLION_LOBBY_EVENTS_CACHE_KEY", ()=>BULLION_LOBBY_EVENTS_CACHE_KEY);
parcelHelpers.export(exports, "readCachedBullionLobbyEvents", ()=>readCachedBullionLobbyEvents);
parcelHelpers.export(exports, "writeCachedBullionLobbyEvents", ()=>writeCachedBullionLobbyEvents);
var _bullionLobbyStalePrune = require("./bullionLobbyStalePrune");
const BULLION_LOBBY_EVENTS_CACHE_KEY = "c8_bullion_lobby_events_v1";
function readCachedBullionLobbyEvents() {
    if (typeof sessionStorage === "undefined") return null;
    try {
        const raw = sessionStorage.getItem(BULLION_LOBBY_EVENTS_CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const ev = parsed?.events;
        if (!Array.isArray(ev) || ev.length === 0) return null;
        return ev;
    } catch  {
        return null;
    }
}
function writeCachedBullionLobbyEvents(events, opts) {
    const pruned = (0, _bullionLobbyStalePrune.pruneStaleBullionLobbyRows)(events, opts?.activeByMatch);
    try {
        sessionStorage.setItem(BULLION_LOBBY_EVENTS_CACHE_KEY, JSON.stringify({
            events: pruned
        }));
    } catch  {
    // ignore quota / private mode
    }
}

},{"./bullionLobbyStalePrune":"6tvlU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6tvlU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Lobby inclusion for a user’s plays: unsettled only once my-games has loaded.
 * Settled HISTORY rows alone must not keep a finished fixture on the lobby list.
 */ parcelHelpers.export(exports, "bullionLobbyUserHasLobbyRelevantPlay", ()=>bullionLobbyUserHasLobbyRelevantPlay);
parcelHelpers.export(exports, "bullionUserHasUnsettledPlayOnMatch", ()=>bullionUserHasUnsettledPlayOnMatch);
/** Drop terminal fixtures from lobby/session lists unless the user still has an open play there. */ parcelHelpers.export(exports, "pruneStaleBullionLobbyRows", ()=>pruneStaleBullionLobbyRows);
var _bullionMatchLandingLobby = require("./bullionMatchLandingLobby");
var _bullionRawMatch = require("./bullionRawMatch");
function bullionLobbyUserHasLobbyRelevantPlay(matchId, userActiveMatchIds, bullionActivePlaysLoaded, activeByMatch) {
    if (!bullionActivePlaysLoaded) return (0, _bullionMatchLandingLobby.bullionLobbyUserHasActivePlay)(matchId, userActiveMatchIds);
    return bullionUserHasUnsettledPlayOnMatch(matchId, activeByMatch);
}
function bullionUserHasUnsettledPlayOnMatch(matchId, activeByMatch) {
    if (!activeByMatch) return false;
    const games = (0, _bullionMatchLandingLobby.findBullionLobbyGamesForMatchId)(matchId, activeByMatch);
    if (games.length === 0) return false;
    return games.some((g)=>{
        const s = String(g.gameStatus ?? "").toLowerCase();
        return s !== "settled" && s !== "cancelled";
    });
}
function pruneStaleBullionLobbyRows(rows, activeByMatch) {
    return rows.filter((row)=>{
        const match = row;
        const id = String(match?.id ?? "").trim();
        if (!id) return false;
        if (!(0, _bullionRawMatch.isRawMatchFinishedForBullionLobby)(match)) return true;
        return bullionUserHasUnsettledPlayOnMatch(id, activeByMatch);
    });
}

},{"./bullionMatchLandingLobby":"6cMJo","./bullionRawMatch":"jEN44","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ilaJp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Cricket feed / scorecard / commentary signals that the fixture is over (not scheduled or in-play). */ parcelHelpers.export(exports, "bullionFixtureFinishedFromSocketSignals", ()=>bullionFixtureFinishedFromSocketSignals);
/** Visible BULLION contests / plays on this fixture all closed out. */ parcelHelpers.export(exports, "bullionFixtureFinishedFromContestSignals", ()=>bullionFixtureFinishedFromContestSignals);
parcelHelpers.export(exports, "resolveBullionMatchFixtureState", ()=>resolveBullionMatchFixtureState);
/** Apply resolved phase onto a room object for downstream `fixturePhase` / lock helpers. */ parcelHelpers.export(exports, "bullionRoomWithResolvedFixturePhase", ()=>bullionRoomWithResolvedFixturePhase);
/** Lobby rows: mark fixtures finished when all of the user's games on that match are settled. */ parcelHelpers.export(exports, "enrichBullionLobbyRoomsWithMyGames", ()=>enrichBullionLobbyRoomsWithMyGames);
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
var _domain = require("../../MyGames/domain");
var _bullionRawMatch = require("./bullionRawMatch");
var _bullionMatchLandingLobby = require("./bullionMatchLandingLobby");
function scorecardEventStatus(scorecardData) {
    if (!scorecardData || typeof scorecardData !== "object") return null;
    const es = scorecardData.event_status;
    return es != null && es !== "" ? es : null;
}
function bullionFixtureFinishedFromSocketSignals(feed) {
    if (!feed) return false;
    const { eventStatus, status, game_phase, matchComment, scorecardData } = feed;
    const scorecardEv = scorecardEventStatus(scorecardData);
    if ((0, _decimalEventStatus.isMatchFinishedStatus)(eventStatus) || (0, _decimalEventStatus.isMatchFinishedStatus)(scorecardEv) || (0, _decimalEventStatus.commentIndicatesCricketMatchResult)(matchComment)) return true;
    const feedStatus = String(status ?? "").trim();
    if (feedStatus !== "" && (0, _decimalEventStatus.isMatchFinishedStatus)(feedStatus)) return true;
    const uLive = feedStatus.toUpperCase();
    if (uLive.includes("MATCH COMPLETE") || uLive.includes("EVENT CLOSED") || uLive.includes("MATCH ABANDONED")) return true;
    const gp = String(game_phase ?? "").trim();
    if (/\bevent\s*closed\b/i.test(gp) || /\bmatch\s*complete\b/i.test(gp)) return true;
    return false;
}
function bullionFixtureFinishedFromContestSignals(signals) {
    if (!signals) return false;
    const statuses = (signals.gameStatuses ?? []).map((s)=>String(s ?? "").trim().toLowerCase()).filter(Boolean);
    if (statuses.length > 0 && statuses.every((s)=>s === "settled" || s === "cancelled")) return true;
    const plays = (signals.plays ?? []).filter(Boolean);
    if (plays.length > 0 && plays.every((p)=>(0, _domain.isBullionPlayFullyDone)(p))) return true;
    return false;
}
function roomStatusIndicatesFinished(status) {
    const st = String(status ?? "").toUpperCase();
    return st.includes("MATCH COMPLETE") || st.includes("FINISHED") || st.includes("FULL TIME") || st.includes("EVENT CLOSED") || st === "EVENT_FULL_RESULT" || st.includes("ABANDONED");
}
function resolveBullionMatchFixtureState(room, opts) {
    const nowMs = opts?.nowMs ?? Date.now();
    if (!room) return {
        phase: "scheduled",
        matchFinished: false,
        kickoffPassed: false
    };
    const fromSocket = bullionFixtureFinishedFromSocketSignals(opts?.socket);
    const fromContests = opts?.useContestSignals === false ? false : bullionFixtureFinishedFromContestSignals(opts?.contests);
    const fromRoom = room.fixturePhase === "finished" || roomStatusIndicatesFinished(room.status);
    const startsAtTs = room.startsAt ? new Date(room.startsAt).getTime() : Number.NaN;
    const scheduledFuture = Number.isFinite(startsAtTs) && startsAtTs > nowMs;
    /** Stale list rows / settled contests must not mark a future kickoff as finished for entry lock. */ const matchFinished = fromSocket || !scheduledFuture && (fromRoom || fromContests);
    if (matchFinished) return {
        phase: "finished",
        matchFinished: true,
        kickoffPassed: true
    };
    const phase = (0, _bullionRawMatch.bullionRoomResolvedFixturePhase)(room);
    const kickoffFromClock = Number.isFinite(startsAtTs) ? startsAtTs <= nowMs : false;
    const kickoffPassed = kickoffFromClock || Boolean(room.isLive) || phase === "live";
    return {
        phase,
        matchFinished: false,
        kickoffPassed
    };
}
function bullionRoomWithResolvedFixturePhase(room, resolved) {
    if (!resolved.matchFinished && resolved.phase === (0, _bullionRawMatch.bullionRoomResolvedFixturePhase)(room)) return room;
    return {
        ...room,
        fixturePhase: resolved.phase,
        isLive: resolved.matchFinished ? false : room.isLive,
        ...resolved.matchFinished ? {
            status: roomStatusIndicatesFinished(room.status) ? room.status : "MATCH COMPLETE"
        } : null
    };
}
function enrichBullionLobbyRoomsWithMyGames(rooms, activeBullionGamesByMatchId) {
    return rooms.map((room)=>{
        const games = (0, _bullionMatchLandingLobby.findBullionLobbyGamesForMatchId)(room.matchId, activeBullionGamesByMatchId);
        const resolved = resolveBullionMatchFixtureState(room, {
            contests: {
                gameStatuses: games.map((g)=>g.gameStatus)
            }
        });
        return bullionRoomWithResolvedFixturePhase(room, resolved);
    });
}

},{"../../Trader/Cricket/decimalEventStatus":"f1nlI","../../MyGames/domain":"9fISe","./bullionRawMatch":"jEN44","./bullionMatchLandingLobby":"6cMJo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9fISe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatOverUnderDisplay", ()=>formatOverUnderDisplay);
/** Decimal odds for My Zone trader summary pill — always two fractional digits (e.g. 4 → 4.00). Fractional style e.g. `5/1` is left unchanged. */ parcelHelpers.export(exports, "formatTraderOddsTwoDecimals", ()=>formatTraderOddsTwoDecimals);
parcelHelpers.export(exports, "firstSegmentByComma", ()=>firstSegmentByComma);
parcelHelpers.export(exports, "secondSegmentByComma", ()=>secondSegmentByComma);
parcelHelpers.export(exports, "parseSquaresChallengeFromEntityRef", ()=>parseSquaresChallengeFromEntityRef);
parcelHelpers.export(exports, "parseSquaresChallengeMatchIdFromEntityRef", ()=>parseSquaresChallengeMatchIdFromEntityRef);
parcelHelpers.export(exports, "numAmount", ()=>numAmount);
parcelHelpers.export(exports, "formatTradeTypeLabelForDisplay", ()=>formatTradeTypeLabelForDisplay);
parcelHelpers.export(exports, "traderUrlSportParam", ()=>traderUrlSportParam);
parcelHelpers.export(exports, "buildFinishedTraderInitialEvent", ()=>buildFinishedTraderInitialEvent);
parcelHelpers.export(exports, "quickfireOrdinal", ()=>quickfireOrdinal);
parcelHelpers.export(exports, "formatQuickfireHeroLine", ()=>formatQuickfireHeroLine);
parcelHelpers.export(exports, "formatQuickfireSummaryDateBar", ()=>formatQuickfireSummaryDateBar);
/** My Zone settled Quickfire card title — e.g. `Tuesday, 12th April` (local date, sentence-style). */ parcelHelpers.export(exports, "formatQuickfireMyZonePastSessionTitle", ()=>formatQuickfireMyZonePastSessionTitle);
/** Short local date for My Zone PAST row cards (D-M-YYYY, e.g. 12-5-2026). */ parcelHelpers.export(exports, "formatMyGamesPastCardDate", ()=>formatMyGamesPastCardDate);
parcelHelpers.export(exports, "parseQuickfireQuestions", ()=>parseQuickfireQuestions);
parcelHelpers.export(exports, "quickfireSummaryCorrectCount", ()=>quickfireSummaryCorrectCount);
parcelHelpers.export(exports, "quickfireSummaryQuestionTotal", ()=>quickfireSummaryQuestionTotal);
parcelHelpers.export(exports, "normalizeOverWinnerRow", ()=>normalizeOverWinnerRow);
/**
 * Integer chip total from API `winnings` (cent-round then whole chips; matches leaderboard UI).
 * Used so **0 chips** means no numeric rank (show "-" in rank badges / skip ordinal place).
 */ parcelHelpers.export(exports, "squaresLeaderboardChipInt", ()=>squaresLeaderboardChipInt);
parcelHelpers.export(exports, "sortSquaresLeaderboardByPerformance", ()=>sortSquaresLeaderboardByPerformance);
parcelHelpers.export(exports, "findSquaresOrdinalPlace", ()=>findSquaresOrdinalPlace);
parcelHelpers.export(exports, "getHistoryCacheKey", ()=>getHistoryCacheKey);
/** Parse `bullion_match.start_time` / my-games `startTime` to epoch ms, or null if missing/invalid. */ parcelHelpers.export(exports, "parseBullionMatchStartTimeMs", ()=>parseBullionMatchStartTimeMs);
/**
 * True while the fixture should not show as “Match Live” in My Zone: kickoff is strictly in the future,
 * or start time is missing/invalid. Matches BullionMatchLanding (`startsAtMs == null` → kickoff not passed)
 * and BullionPlayedGameView’s future `scheduledStartTs` → scheduled branch.
 */ parcelHelpers.export(exports, "isBullionMatchFixtureNotStartedYet", ()=>isBullionMatchFixtureNotStartedYet);
/**
 * My Zone BULLION pre-kickoff footer — `Starts in 3H 40M` (white body type via caller classes), or em dash when unknown.
 */ parcelHelpers.export(exports, "formatBullionMatchKickoffFooterLabel", ()=>formatBullionMatchKickoffFooterLabel);
/** True when all pick lines are settled by count or the play row is marked settled (My Zone ACTIVE vs PAST). */ parcelHelpers.export(exports, "isBullionPlayFullyDone", ()=>isBullionPlayFullyDone);
/** True when all cheer cells are settled or the card row is marked settled/cancelled (My Zone ACTIVE vs PAST). */ parcelHelpers.export(exports, "isSixesCardFullyDone", ()=>isSixesCardFullyDone);
/** True when a Sixes card was fully voided (admin or natural all-VOID). */ parcelHelpers.export(exports, "isSixesCardVoided", ()=>isSixesCardVoided);
parcelHelpers.export(exports, "isGameActive", ()=>isGameActive);
parcelHelpers.export(exports, "isGameSettled", ()=>isGameSettled);
/**
 * True when a settled row should count as “today” for My Games drawer / PAST ordering:
 * any match kickoff, in-play, settlement, or play timestamp falls on the local calendar day,
 * not only when the row was created.
 */ parcelHelpers.export(exports, "isSettledGameMatchOrActivityTodayLocal", ()=>isSettledGameMatchOrActivityTodayLocal);
/** Drawer: every ACTIVE row plus SETTLED rows that qualify via {@link isSettledGameMatchOrActivityTodayLocal}. */ parcelHelpers.export(exports, "filterGamesForMyGamesDrawer", ()=>filterGamesForMyGamesDrawer);
parcelHelpers.export(exports, "filterGamesByTab", ()=>filterGamesByTab);
parcelHelpers.export(exports, "isTodayLocal", ()=>isTodayLocal);
parcelHelpers.export(exports, "isTodayUtc", ()=>isTodayUtc);
parcelHelpers.export(exports, "hasCompletedQuickfireSessionToday", ()=>hasCompletedQuickfireSessionToday);
parcelHelpers.export(exports, "hasCompletedQuickfirePlayToday", ()=>hasCompletedQuickfirePlayToday);
/** Fallback ACTIVE row when account has partial progress but `quickfire_plays` has not synced yet. */ parcelHelpers.export(exports, "buildSyntheticActiveQuickfireFromUserGames", ()=>buildSyntheticActiveQuickfireFromUserGames);
parcelHelpers.export(exports, "injectSyntheticActiveQuickfireIfNeeded", ()=>injectSyntheticActiveQuickfireIfNeeded);
parcelHelpers.export(exports, "filterGamesByTodayYesterday", ()=>filterGamesByTodayYesterday);
/** Rows whose {@link CombinedGame.date} falls on the user's local calendar today (My Games drawer). */ parcelHelpers.export(exports, "filterGamesByLocalToday", ()=>filterGamesByLocalToday);
parcelHelpers.export(exports, "getCachedHistory", ()=>getCachedHistory);
parcelHelpers.export(exports, "setCachedHistory", ()=>setCachedHistory);
parcelHelpers.export(exports, "clearMyGamesPageCache", ()=>clearMyGamesPageCache);
parcelHelpers.export(exports, "formatDateHeader", ()=>formatDateHeader);
/**
 * Match start / kickoff for My Zone trader summary header (e.g. "12 DEC 2026").
 * Prefers fixture start from market details, then trade timestamps.
 */ parcelHelpers.export(exports, "formatTraderMatchHeroDate", ()=>formatTraderMatchHeroDate);
/**
 * Match start for My Zone squares summary header (e.g. "12 DEC 2026").
 * Prefers fixture kickoff fields, then created_at.
 */ parcelHelpers.export(exports, "formatSquaresMatchHeroDate", ()=>formatSquaresMatchHeroDate);
/** Settled / revealed Sixes card date for summary header (e.g. "12 DEC 2026"). */ parcelHelpers.export(exports, "formatSixesSummaryHeaderDate", ()=>formatSixesSummaryHeaderDate);
var _matchCountdown = require("../../utils/matchCountdown");
var _oddsUtils = require("../Trader/oddsUtils");
var _constants = require("./constants");
function formatOverUnderDisplay(str) {
    if (!str || typeof str !== "string") return str ?? "";
    return str.replace(/\bOVER\b/g, "Over").replace(/\bUNDER\b/g, "Under");
}
function formatTraderOddsTwoDecimals(raw) {
    if (raw == null || raw === "") return "";
    const s = String(raw).trim();
    if (s.includes("/")) return s;
    return (0, _oddsUtils.formatOddsForDisplay)(raw) || s;
}
function firstSegmentByComma(str) {
    if (!str || typeof str !== "string") return str?.trim() || "Match";
    const first = str.split(",")[0]?.trim();
    return first || "Match";
}
function secondSegmentByComma(str) {
    if (!str || typeof str !== "string") return undefined;
    const parts = str.split(",").map((p)=>p.trim()).filter(Boolean);
    return parts[1];
}
function parseSquaresChallengeFromEntityRef(ref) {
    if (typeof ref !== "string" || !ref.trim()) return {
        matchId: null,
        matchName: null
    };
    try {
        const parsed = JSON.parse(ref);
        if (parsed?.match_id == null) return {
            matchId: null,
            matchName: null
        };
        const matchId = String(parsed.match_id).trim() || null;
        const rawName = parsed?.match_name;
        const matchName = rawName != null && String(rawName).trim() !== "" ? String(rawName).trim() : null;
        return {
            matchId,
            matchName
        };
    } catch  {
        return {
            matchId: null,
            matchName: null
        };
    }
}
function parseSquaresChallengeMatchIdFromEntityRef(ref) {
    return parseSquaresChallengeFromEntityRef(ref).matchId;
}
function numAmount(v) {
    if (v == null || v === "") return 0;
    if (typeof v === "number" && Number.isFinite(v)) return v;
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
}
function formatTradeTypeLabelForDisplay(label, marketdetails) {
    if (!label || !marketdetails?.marketname) return label ?? "";
    if (marketdetails.marketname.toLowerCase() === "correct score") return "Correct Score";
    return label;
}
function traderUrlSportParam(sportLower) {
    if (sportLower === "horse") return "horses";
    if (sportLower === "soccer") return "football";
    return sportLower;
}
function buildFinishedTraderInitialEvent(trade) {
    const label = firstSegmentByComma(trade.name || trade.marketdetails?.eventname) || "Match";
    const splitV = label.split(/\s+v\s+/i);
    const sideA = splitV[0]?.trim() || label;
    const sideB = splitV[1]?.trim() || "";
    const participants = sideB ? [
        {
            "participant-name": sideA
        },
        {
            "participant-name": sideB
        }
    ] : [
        {
            "participant-name": sideA
        },
        {
            "participant-name": ""
        }
    ];
    const ls = trade.liveScore && typeof trade.liveScore === "object" && !Array.isArray(trade.liveScore) ? trade.liveScore : {};
    return {
        id: trade.match_id,
        name: label,
        liveScore: {
            isFinished: true,
            ...ls
        },
        "event-participants": participants
    };
}
function quickfireOrdinal(n) {
    const v = n % 100;
    if (v >= 11 && v <= 13) return "TH";
    switch(v % 10){
        case 1:
            return "ST";
        case 2:
            return "ND";
        case 3:
            return "RD";
        default:
            return "TH";
    }
}
function formatQuickfireHeroLine(playedAt, competitions, playName) {
    const backendName = playName?.trim();
    if (backendName) return (backendName.length > 52 ? `${backendName.slice(0, 49)}\u{2026}` : backendName).toUpperCase();
    const c = competitions?.trim();
    if (c) return (c.length > 52 ? `${c.slice(0, 49)}\u{2026}` : c).toUpperCase();
    const d = new Date(playedAt);
    if (isNaN(d.getTime())) return "QUICKFIRE";
    const day = d.getDate();
    return `${(0, _constants.QUICKFIRE_MONTHS_UPPER)[d.getMonth()]} ${day}${quickfireOrdinal(day)}`;
}
function formatQuickfireSummaryDateBar(playedAt, playDateLabel) {
    const backendLabel = playDateLabel?.trim();
    if (backendLabel) return backendLabel.toUpperCase();
    const d = new Date(playedAt);
    if (isNaN(d.getTime())) return "\u2014";
    const wd = (0, _constants.QUICKFIRE_SUMMARY_WEEKDAYS)[d.getDay()];
    const day = d.getDate();
    const month = (0, _constants.QUICKFIRE_MONTHS_UPPER)[d.getMonth()];
    return `${wd} ${day}${quickfireOrdinal(day)} ${month}`;
}
const QUICKFIRE_WEEKDAYS_TITLE = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const QUICKFIRE_MONTHS_TITLE = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
function formatQuickfireMyZonePastSessionTitle(playedAt) {
    const d = new Date(playedAt);
    if (Number.isNaN(d.getTime())) return "Quickfire";
    const wd = QUICKFIRE_WEEKDAYS_TITLE[d.getDay()];
    const day = d.getDate();
    const ord = quickfireOrdinal(day).toLowerCase();
    const month = QUICKFIRE_MONTHS_TITLE[d.getMonth()];
    return `${wd}, ${day}${ord} ${month}`;
}
function formatMyGamesPastCardDate(raw) {
    if (raw == null || raw === "") return null;
    const d = raw instanceof Date ? raw : new Date(typeof raw === "number" ? raw : String(raw));
    if (Number.isNaN(d.getTime())) return null;
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
}
function parseQuickfireQuestions(play) {
    const raw = play.questions;
    let arr = [];
    if (raw == null) arr = [];
    else if (Array.isArray(raw)) arr = raw;
    else if (typeof raw === "string") try {
        const p = JSON.parse(raw);
        arr = Array.isArray(p) ? p : [];
    } catch  {
        arr = [];
    }
    return arr.map((item)=>{
        const o = item && typeof item === "object" ? item : {};
        return {
            correct: o.correct === true,
            answered: o.answered === true,
            question: typeof o.question === "string" ? o.question : "",
            questionId: typeof o.questionId === "number" ? o.questionId : undefined
        };
    });
}
function quickfireSummaryCorrectCount(play, parsed) {
    const fromRow = Number(play.correct);
    if (Number.isFinite(fromRow) && fromRow >= 0) return Math.max(0, Math.floor(fromRow));
    if (parsed.length > 0) return parsed.filter((q)=>q.correct).length;
    return 0;
}
function quickfireSummaryQuestionTotal(play, parsed) {
    if (parsed.length > 0) return parsed.length;
    return Math.max(0, Number(play.max_questions) || 0);
}
function normalizeOverWinnerRow(w) {
    return {
        ...w,
        avatar: w.avatar ?? w.profile_pic ?? null
    };
}
/**
 * Same numeric value as backend `WINNINGS_TIE_EPSILON` (`backend/controllers/squares/squares-constants.js`).
 *
 * Squares scores (`winnings`) are floats; we treat two values as **tied** when their difference is at most
 * this amount, so client-side sort + competition place match the server (sorting, tie groups, skipped ranks).
 */ const SQUARES_WINNINGS_TIE_EPS = 1e-6;
function squaresLeaderboardChipInt(total) {
    const num = Number(total);
    if (!Number.isFinite(num)) return 0;
    const toCents = Math.round(num * 100) / 100;
    return Math.round(toCents);
}
function sortSquaresLeaderboardByPerformance(winners) {
    return [
        ...winners
    ].sort((a, b)=>{
        const diff = (b.winnings ?? 0) - (a.winnings ?? 0);
        if (Math.abs(diff) > SQUARES_WINNINGS_TIE_EPS) return diff > 0 ? 1 : -1;
        const pa = a.play_id != null ? Number(a.play_id) : 0;
        const pb = b.play_id != null ? Number(b.play_id) : 0;
        return pa - pb;
    });
}
/** 1-based competition place for the row at `idx` in `ordered` (best-first, same tie epsilon as backend). */ function squaresCompetitionPlaceAtIndex(ordered, idx) {
    let nextRank = 1;
    let i = 0;
    while(i < ordered.length){
        const score = ordered[i].winnings ?? 0;
        let j = i + 1;
        while(j < ordered.length && Math.abs((ordered[j].winnings ?? 0) - score) <= SQUARES_WINNINGS_TIE_EPS)j++;
        if (idx >= i && idx < j) return nextRank;
        nextRank += j - i;
        i = j;
    }
    return idx + 1;
}
function findSquaresOrdinalPlace(playId, winners, userId) {
    if (!winners?.length || playId == null) return null;
    const sid = String(playId);
    const ordered = sortSquaresLeaderboardByPerformance(winners);
    let idx = ordered.findIndex((w)=>w.play_id != null && String(w.play_id) === sid);
    if (idx < 0 && userId != null && String(userId) !== "") idx = ordered.findIndex((w)=>w.user_id != null && String(w.user_id) === String(userId));
    if (idx < 0) return null;
    if (squaresLeaderboardChipInt(ordered[idx].winnings) <= 0) return null;
    return squaresCompetitionPlaceAtIndex(ordered, idx);
}
function getHistoryCacheKey(activeTab, gameTypeFilter) {
    return `${0, _constants.HISTORY_CACHE_KEY_PREFIX}_${activeTab}_${gameTypeFilter}`;
}
function parseBullionMatchStartTimeMs(startTime) {
    if (startTime == null || String(startTime).trim() === "") return null;
    const t = new Date(startTime).getTime();
    return Number.isFinite(t) ? t : null;
}
function isBullionMatchFixtureNotStartedYet(startTime, nowMs = Date.now()) {
    const ms = parseBullionMatchStartTimeMs(startTime);
    if (ms == null) return true;
    return nowMs < ms;
}
function formatBullionMatchKickoffFooterLabel(startTime, nowMs) {
    const ms = parseBullionMatchStartTimeMs(startTime);
    if (ms == null) return "\u2014";
    const duration = (0, _matchCountdown.formatCountdownDuration)(ms - nowMs, "upper");
    if (!duration) return "\u2014";
    return `Starts in ${duration}`;
}
function isBullionPlayFullyDone(bullionPlay) {
    if (bullionPlay.settled === true) return true;
    const total = Number(bullionPlay.totalMarkets ?? 0);
    const done = Number(bullionPlay.settledMarkets ?? 0);
    return total > 0 && done >= total;
}
function isSixesCardFullyDone(card) {
    const status = String(card.status || "").trim().toLowerCase();
    if (status === "settled" || status === "cancelled") return true;
    const total = Number(card.totalCells ?? 0);
    const done = Number(card.settledCells ?? 0);
    return total > 0 && done >= total;
}
function isSixesCardVoided(card) {
    return String(card?.status || "").trim().toLowerCase() === "cancelled";
}
function isGameActive(game) {
    if (game.type === "trader") return game.data.settled !== true;
    if (game.type === "quickfire") return !game.data.session_complete;
    if (game.type === "bullion") return !isBullionPlayFullyDone(game.data);
    if (game.type === "sixes") return !isSixesCardFullyDone(game.data);
    const s = game.data;
    if (s.settled === true) return false;
    if ([
        "WIN",
        "LOSS",
        "LOST",
        "VOID"
    ].includes(s.outcome || "")) return false;
    return true;
}
function isGameSettled(game) {
    if (game.type === "trader") return game.data.settled === true;
    if (game.type === "quickfire") {
        const q = game.data;
        return q.session_complete === true || !isTodayUtc(q.played_at);
    }
    if (game.type === "bullion") return isBullionPlayFullyDone(game.data);
    if (game.type === "sixes") return isSixesCardFullyDone(game.data);
    const s = game.data;
    return s.settled === true;
}
function isSettledGameMatchOrActivityTodayLocal(game) {
    if (!isGameSettled(game)) return false;
    if (game.type === "trader") {
        const t = game.data;
        const mdStart = t.marketdetails?.start;
        const cands = [
            t.tstamp,
            t.created_at,
            t["starts-at"],
            t.start,
            mdStart != null && mdStart !== "" ? String(mdStart) : undefined
        ];
        return cands.some((d)=>typeof d === "string" && d.trim() !== "" && isTodayLocal(d));
    }
    if (game.type === "squares") {
        const s = game.data;
        const cands = [
            s.settled_at,
            s.actual_start,
            s.start_time,
            s.start,
            s.created_at
        ];
        return cands.some((d)=>typeof d === "string" && d.trim() !== "" && isTodayLocal(d));
    }
    if (game.type === "quickfire") {
        const q = game.data;
        return q.session_complete === true && Boolean(q.played_at?.trim()) && isTodayLocal(q.played_at);
    }
    if (game.type !== "bullion" && game.type !== "sixes") return false;
    if (game.type === "sixes") {
        const sixesCard = game.data;
        const cands = [
            sixesCard.settledAt,
            sixesCard.startTime,
            sixesCard.revealedAt,
            sixesCard.createdAt
        ];
        return cands.some((d)=>d != null && String(d).trim() !== "" && isTodayLocal(String(d)));
    }
    const bullionGame = game.data;
    const cands = [
        bullionGame.startTime,
        bullionGame.createdAt
    ];
    return cands.some((d)=>d != null && String(d).trim() !== "" && isTodayLocal(String(d)));
}
/**
 * Quickfire in the My Games drawer: never show completed or in-progress sessions from earlier local days.
 * (Stale “open” rows can still be classified SETTLED elsewhere via {@link isGameSettled}.)
 */ function isQuickfireIncludedInMyGamesDrawer(game) {
    if (game.type !== "quickfire") return false;
    const q = game.data;
    if (!q.played_at?.trim()) return !q.session_complete;
    return isTodayLocal(q.played_at);
}
function filterGamesForMyGamesDrawer(games) {
    return games.filter((g)=>{
        if (g.type === "quickfire") return isQuickfireIncludedInMyGamesDrawer(g);
        return isGameActive(g) || isSettledGameMatchOrActivityTodayLocal(g);
    });
}
function filterGamesByTab(games, tab) {
    if (tab === "ALL") return games;
    if (tab === "TODAY_YESTERDAY") return filterGamesByTodayYesterday(games);
    if (tab === "ACTIVE") return games.filter(isGameActive);
    return games.filter(isGameSettled);
}
function isTodayLocal(dateStr) {
    if (!dateStr?.trim()) return false;
    const t = new Date(dateStr).getTime();
    if (isNaN(t)) return false;
    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
    const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
    return t >= todayStart && t <= todayEnd;
}
function isTodayUtc(dateStr) {
    if (!dateStr?.trim()) return false;
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return false;
    const now = new Date();
    return d.getUTCFullYear() === now.getUTCFullYear() && d.getUTCMonth() === now.getUTCMonth() && d.getUTCDate() === now.getUTCDate();
}
function hasCompletedQuickfireSessionToday(rows) {
    return rows.some((q)=>q.session_complete === true && isTodayUtc(q.played_at));
}
function hasCompletedQuickfirePlayToday(combinedGames) {
    const rows = combinedGames.filter((g)=>g.type === "quickfire").map((g)=>g.data);
    return hasCompletedQuickfireSessionToday(rows);
}
function buildSyntheticActiveQuickfireFromUserGames(games) {
    if (!games?.length) return null;
    const entry = games.find((g)=>g.name === "quickfire-trivia");
    if (!entry?.values) return null;
    const v = entry.values;
    const last = typeof v.last === "string" ? v.last : "";
    if (!isTodayLocal(last)) return null;
    const answered = Number(v.answered);
    const max = Number(v.questionstoanswer);
    if (!Number.isFinite(answered) || !Number.isFinite(max) || max <= 0) return null;
    if (answered <= 0 || answered >= max) return null;
    return {
        id: 0,
        game_session_id: null,
        played_at: new Date().toISOString(),
        play_name: "QUICKFIRE",
        competitions: null,
        answered_total: answered,
        max_questions: max,
        correct: 0,
        coins_won: Number(v.lastwon) || 0,
        session_complete: false
    };
}
function injectSyntheticActiveQuickfireIfNeeded(games, userGames) {
    const hasActiveQuickfire = games.some((g)=>g.type === "quickfire" && isGameActive(g));
    if (hasActiveQuickfire) return games;
    const synthetic = buildSyntheticActiveQuickfireFromUserGames(userGames);
    if (!synthetic) return games;
    const syntheticGame = {
        type: "quickfire",
        date: synthetic.played_at,
        data: synthetic
    };
    return [
        ...games,
        syntheticGame
    ].sort((a, b)=>new Date(b.date).getTime() - new Date(a.date).getTime());
}
function filterGamesByTodayYesterday(games) {
    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
    const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
    const yesterdayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 0, 0, 0, 0).getTime();
    const yesterdayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59, 999).getTime();
    return games.filter((g)=>{
        const t = new Date(g.date).getTime();
        if (isNaN(t)) return false;
        return t >= yesterdayStart && t <= yesterdayEnd || t >= todayStart && t <= todayEnd;
    });
}
function filterGamesByLocalToday(games) {
    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
    const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
    return games.filter((g)=>{
        const t = new Date(g.date).getTime();
        if (isNaN(t)) return false;
        return t >= todayStart && t <= todayEnd;
    });
}
function getCachedHistory(activeTab, gameTypeFilter, _currentPage, perPage) {
    try {
        const raw = localStorage.getItem(getHistoryCacheKey(activeTab, gameTypeFilter));
        if (!raw) return null;
        const { allGames, timestamp } = JSON.parse(raw);
        if (Date.now() - (timestamp || 0) > (0, _constants.HISTORY_CACHE_TTL_MS)) return null;
        if (!Array.isArray(allGames)) return null;
        const filtered = activeTab === "ALL" ? allGames : filterGamesByTab(allGames, activeTab);
        const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
        return {
            allGames: filtered,
            totalPages,
            fullList: allGames
        };
    } catch  {
        return null;
    }
}
function setCachedHistory(activeTab, gameTypeFilter, _currentPage, allGames) {
    try {
        localStorage.setItem(getHistoryCacheKey(activeTab, gameTypeFilter), JSON.stringify({
            allGames,
            timestamp: Date.now()
        }));
    } catch (e) {
        console.warn("Failed to cache history", e);
    }
}
function clearMyGamesPageCache() {
    try {
        const keysToRemove = [];
        for(let i = 0; i < localStorage.length; i++){
            const key = localStorage.key(i);
            if (key && key.startsWith((0, _constants.HISTORY_CACHE_KEY_PREFIX))) keysToRemove.push(key);
        }
        keysToRemove.forEach((key)=>localStorage.removeItem(key));
    } catch  {
    // ignore
    }
}
function formatDateHeader(date) {
    const days = [
        "SUN",
        "MON",
        "TUE",
        "WED",
        "THU",
        "FRI",
        "SAT"
    ];
    const months = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
    ];
    const dayName = days[date.getDay()];
    const dayNum = date.getDate();
    const month = months[date.getMonth()];
    return `${dayName} ${dayNum}${quickfireOrdinal(dayNum)} ${month}`;
}
const TRADER_SUMMARY_MONTHS = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC"
];
function formatTraderMatchHeroDate(trade) {
    const raw = trade.marketdetails?.start ?? trade.start ?? trade["starts-at"] ?? trade.tstamp ?? trade.created_at;
    if (raw == null || typeof raw !== "string" || String(raw).trim() === "") return null;
    const d = new Date(raw.trim());
    if (Number.isNaN(d.getTime())) return null;
    const day = d.getDate();
    const mon = TRADER_SUMMARY_MONTHS[d.getMonth()];
    const y = d.getFullYear();
    return `${day} ${mon} ${y}`;
}
function formatSquaresMatchHeroDate(square) {
    const raw = square.start_time ?? square.actual_start ?? square.start ?? square.created_at;
    if (raw == null || typeof raw !== "string" || String(raw).trim() === "") return null;
    const d = new Date(raw.trim());
    if (Number.isNaN(d.getTime())) return null;
    const day = d.getDate();
    const mon = TRADER_SUMMARY_MONTHS[d.getMonth()];
    const y = d.getFullYear();
    return `${day} ${mon} ${y}`;
}
function formatSixesSummaryHeaderDate(card) {
    const raw = card.settledAt ?? card.revealedAt ?? card.startTime ?? card.createdAt;
    if (raw == null || String(raw).trim() === "") return null;
    const d = new Date(String(raw).trim());
    if (Number.isNaN(d.getTime())) return null;
    const day = d.getDate();
    const mon = TRADER_SUMMARY_MONTHS[d.getMonth()];
    const y = d.getFullYear();
    return `${day} ${mon} ${y}`;
}

},{"../../utils/matchCountdown":"hzPTj","../Trader/oddsUtils":"jXkCw","./constants":"l1i0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l1i0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FIRST_TIME_MYZONE_KEY", ()=>FIRST_TIME_MYZONE_KEY);
parcelHelpers.export(exports, "HISTORY_CACHE_KEY_PREFIX", ()=>HISTORY_CACHE_KEY_PREFIX);
parcelHelpers.export(exports, "HISTORY_CACHE_TTL_MS", ()=>HISTORY_CACHE_TTL_MS);
parcelHelpers.export(exports, "QUICKFIRE_MONTHS_UPPER", ()=>QUICKFIRE_MONTHS_UPPER);
parcelHelpers.export(exports, "QUICKFIRE_SUMMARY_WEEKDAYS", ()=>QUICKFIRE_SUMMARY_WEEKDAYS);
parcelHelpers.export(exports, "SLIM_FOOTER_COIN_LABEL", ()=>SLIM_FOOTER_COIN_LABEL);
parcelHelpers.export(exports, "SLIM_FOOTER_COIN_AMOUNT", ()=>SLIM_FOOTER_COIN_AMOUNT);
parcelHelpers.export(exports, "SLIM_FOOTER_COIN_LABEL_LIME", ()=>SLIM_FOOTER_COIN_LABEL_LIME);
parcelHelpers.export(exports, "SLIM_FOOTER_COIN_AMOUNT_LIME", ()=>SLIM_FOOTER_COIN_AMOUNT_LIME);
parcelHelpers.export(exports, "MATCH_HERO_CLASS", ()=>MATCH_HERO_CLASS);
parcelHelpers.export(exports, "MYZONE_SUMMARY_WHITE_STRIP_MATCH_CLASS", ()=>MYZONE_SUMMARY_WHITE_STRIP_MATCH_CLASS);
parcelHelpers.export(exports, "MYZONE_SUMMARY_WHITE_STRIP_VS_CLASS", ()=>MYZONE_SUMMARY_WHITE_STRIP_VS_CLASS);
parcelHelpers.export(exports, "MYZONE_WHITE_STRIP_DATE_CLASS", ()=>MYZONE_WHITE_STRIP_DATE_CLASS);
parcelHelpers.export(exports, "MYZONE_PURPLE_HEADER_DATE_CLASS", ()=>MYZONE_PURPLE_HEADER_DATE_CLASS);
parcelHelpers.export(exports, "MYZONE_SQUARES_STAT_LABEL_CLASS", ()=>MYZONE_SQUARES_STAT_LABEL_CLASS);
parcelHelpers.export(exports, "MYZONE_BULLION_SUMMARY_STAT_LABEL_CLASS", ()=>MYZONE_BULLION_SUMMARY_STAT_LABEL_CLASS);
parcelHelpers.export(exports, "MYZONE_BULLION_SUMMARY_HEADER_GAME_NAME_CLASS", ()=>MYZONE_BULLION_SUMMARY_HEADER_GAME_NAME_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_HEADER_ICON_CLASS", ()=>MYZONE_SIXES_SUMMARY_HEADER_ICON_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_HEADER_TITLE_CLASS", ()=>MYZONE_SIXES_SUMMARY_HEADER_TITLE_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_LOBBY_DRAWER_TITLE_CLASS", ()=>MYZONE_SIXES_LOBBY_DRAWER_TITLE_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_LOBBY_DRAWER_HEADER_CLASS", ()=>MYZONE_SIXES_LOBBY_DRAWER_HEADER_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_LOBBY_DRAWER_PANEL_POSITION_CLASS", ()=>MYZONE_SIXES_LOBBY_DRAWER_PANEL_POSITION_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_LOBBY_DRAWER_SHELL_CLASS", ()=>MYZONE_SIXES_LOBBY_DRAWER_SHELL_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_LIST_CARD_FOOTER_BG_CLASS", ()=>MYZONE_SIXES_LIST_CARD_FOOTER_BG_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_LIST_CARD_TOP_BG_CLASS", ()=>MYZONE_SIXES_LIST_CARD_TOP_BG_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_LIST_CARD_THUMB_BG_CLASS", ()=>MYZONE_SIXES_LIST_CARD_THUMB_BG_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_HEADER_DATE_CLASS", ()=>MYZONE_SIXES_SUMMARY_HEADER_DATE_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS", ()=>MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_FINISHED_PILL_CLASS", ()=>MYZONE_SIXES_SUMMARY_FINISHED_PILL_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_ACTIVE_PILL_CLASS", ()=>MYZONE_SIXES_SUMMARY_ACTIVE_PILL_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_VOID_PILL_CLASS", ()=>MYZONE_SIXES_SUMMARY_VOID_PILL_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_STATS_ROW_CLASS", ()=>MYZONE_SIXES_SUMMARY_STATS_ROW_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_FOOTER_CLASS", ()=>MYZONE_SIXES_SUMMARY_FOOTER_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_GO_TO_CARD_BUTTON_SHELL_CLASS", ()=>MYZONE_SIXES_SUMMARY_GO_TO_CARD_BUTTON_SHELL_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_STAT_COIN_ICON_CLASS", ()=>MYZONE_SIXES_SUMMARY_STAT_COIN_ICON_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_WHITE_STRIP_ROW_CLASS", ()=>MYZONE_SIXES_SUMMARY_WHITE_STRIP_ROW_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_WHITE_STRIP_TEAM_NAME_CLASS", ()=>MYZONE_SIXES_SUMMARY_WHITE_STRIP_TEAM_NAME_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_WHITE_STRIP_VS_CLASS", ()=>MYZONE_SIXES_SUMMARY_WHITE_STRIP_VS_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_STAT_TILE_CLASS", ()=>MYZONE_SIXES_SUMMARY_STAT_TILE_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_STAT_LABEL_CLASS", ()=>MYZONE_SIXES_SUMMARY_STAT_LABEL_CLASS);
parcelHelpers.export(exports, "MYZONE_SIXES_SUMMARY_STAT_VALUE_CLASS", ()=>MYZONE_SIXES_SUMMARY_STAT_VALUE_CLASS);
parcelHelpers.export(exports, "MYZONE_BULLION_SUMMARY_STAT_VALUE_CLASS", ()=>MYZONE_BULLION_SUMMARY_STAT_VALUE_CLASS);
parcelHelpers.export(exports, "MYZONE_SQUARES_STAT_VALUE_CLASS", ()=>MYZONE_SQUARES_STAT_VALUE_CLASS);
parcelHelpers.export(exports, "MYZONE_SQUARES_SUMMARY_LEADERBOARD_AVATAR_CLASS", ()=>MYZONE_SQUARES_SUMMARY_LEADERBOARD_AVATAR_CLASS);
parcelHelpers.export(exports, "MYZONE_SQUARES_SUMMARY_LEADERBOARD_CHIPS_AMOUNT_CLASS", ()=>MYZONE_SQUARES_SUMMARY_LEADERBOARD_CHIPS_AMOUNT_CLASS);
parcelHelpers.export(exports, "MYZONE_SQUARES_SUMMARY_LEADERBOARD_COINS_NUMBER_CLASS", ()=>MYZONE_SQUARES_SUMMARY_LEADERBOARD_COINS_NUMBER_CLASS);
parcelHelpers.export(exports, "MYZONE_SQUARES_SUMMARY_LEADERBOARD_RANK_CLASS", ()=>MYZONE_SQUARES_SUMMARY_LEADERBOARD_RANK_CLASS);
parcelHelpers.export(exports, "MYZONE_SQUARES_SUMMARY_LEADERBOARD_USER_NAME_CLASS", ()=>MYZONE_SQUARES_SUMMARY_LEADERBOARD_USER_NAME_CLASS);
parcelHelpers.export(exports, "MYZONE_SQUARES_HEADER_ENTRANCE_CLASS", ()=>MYZONE_SQUARES_HEADER_ENTRANCE_CLASS);
parcelHelpers.export(exports, "MYZONE_SQUARES_HEADER_TITLE_CLASS", ()=>MYZONE_SQUARES_HEADER_TITLE_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_HEADER_TITLE_CLASS", ()=>MYZONE_TRADER_HEADER_TITLE_CLASS);
parcelHelpers.export(exports, "MYZONE_QUICKFIRE_HEADER_TITLE_CLASS", ()=>MYZONE_QUICKFIRE_HEADER_TITLE_CLASS);
parcelHelpers.export(exports, "MYZONE_QUICKFIRE_SUMMARY_STAT_LABEL_CLASS", ()=>MYZONE_QUICKFIRE_SUMMARY_STAT_LABEL_CLASS);
parcelHelpers.export(exports, "MYZONE_QUICKFIRE_SUMMARY_QUESTION_NUM_CLASS", ()=>MYZONE_QUICKFIRE_SUMMARY_QUESTION_NUM_CLASS);
parcelHelpers.export(exports, "MYZONE_QUICKFIRE_SUMMARY_QUESTION_COINS_CLASS", ()=>MYZONE_QUICKFIRE_SUMMARY_QUESTION_COINS_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_CARD_MATCH_NAME_CLASS", ()=>MYZONE_TRADER_TRADE_CARD_MATCH_NAME_CLASS);
parcelHelpers.export(exports, "MYZONE_HEADER_MATCH_VS_CLASS", ()=>MYZONE_HEADER_MATCH_VS_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_TYPE_LABEL_CLASS", ()=>MYZONE_TRADER_TRADE_TYPE_LABEL_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_SELECTION_CLASS", ()=>MYZONE_TRADER_TRADE_SELECTION_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_ODDS_LABEL_CLASS", ()=>MYZONE_TRADER_TRADE_ODDS_LABEL_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_ODDS_VALUE_BOX_CLASS", ()=>MYZONE_TRADER_TRADE_ODDS_VALUE_BOX_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_STAKE_LABEL_CLASS", ()=>MYZONE_TRADER_TRADE_STAKE_LABEL_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_STAKE_VALUE_CLASS", ()=>MYZONE_TRADER_TRADE_STAKE_VALUE_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_RETURNS_LABEL_CLASS", ()=>MYZONE_TRADER_TRADE_RETURNS_LABEL_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_RETURNS_VALUE_BOX_CLASS", ()=>MYZONE_TRADER_TRADE_RETURNS_VALUE_BOX_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_RETURNS_VALUE_CLASS", ()=>MYZONE_TRADER_TRADE_RETURNS_VALUE_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_TRADE_FOOTER_COIN_ICON_CLASS", ()=>MYZONE_TRADER_TRADE_FOOTER_COIN_ICON_CLASS);
parcelHelpers.export(exports, "MYZONE_CARD_HEADER_STATUS_CLASS", ()=>MYZONE_CARD_HEADER_STATUS_CLASS);
parcelHelpers.export(exports, "MYZONE_HEADER_STATUS_PILL_CLASS", ()=>MYZONE_HEADER_STATUS_PILL_CLASS);
parcelHelpers.export(exports, "MYZONE_TRADER_MATCH_RESULTS_BUTTON_CLASS", ()=>MYZONE_TRADER_MATCH_RESULTS_BUTTON_CLASS);
parcelHelpers.export(exports, "MYZONE_GO_TO_MATCH_BUTTON_LABEL_CLASS", ()=>MYZONE_GO_TO_MATCH_BUTTON_LABEL_CLASS);
parcelHelpers.export(exports, "MYZONE_GAME_SUMMARY_MODAL_SLOT_CLASS", ()=>MYZONE_GAME_SUMMARY_MODAL_SLOT_CLASS);
parcelHelpers.export(exports, "MYZONE_GAME_CONTAINER_BG_CLASS", ()=>MYZONE_GAME_CONTAINER_BG_CLASS);
parcelHelpers.export(exports, "MYZONE_GAME_CONTAINER_TITLE_CLASS", ()=>MYZONE_GAME_CONTAINER_TITLE_CLASS);
parcelHelpers.export(exports, "MYZONE_GAME_CONTAINER_COUNT_BADGE_CLASS", ()=>MYZONE_GAME_CONTAINER_COUNT_BADGE_CLASS);
parcelHelpers.export(exports, "MYZONE_PAST_CARD_DATE_CLASS", ()=>MYZONE_PAST_CARD_DATE_CLASS);
parcelHelpers.export(exports, "MYZONE_GAME_CARD_TITLE_COLUMN_CLASS", ()=>MYZONE_GAME_CARD_TITLE_COLUMN_CLASS);
parcelHelpers.export(exports, "MYZONE_GAME_CARD_TEAM_NAME_CLASS", ()=>MYZONE_GAME_CARD_TEAM_NAME_CLASS);
parcelHelpers.export(exports, "MYZONE_GAME_CARD_TEAM_VS_CLASS", ()=>MYZONE_GAME_CARD_TEAM_VS_CLASS);
parcelHelpers.export(exports, "MYZONE_GAME_CARD_COINS_WON_AMOUNT_CLASS", ()=>MYZONE_GAME_CARD_COINS_WON_AMOUNT_CLASS);
parcelHelpers.export(exports, "MYZONE_QUICKFIRE_PAST_SESSION_TITLE_CLASS", ()=>MYZONE_QUICKFIRE_PAST_SESSION_TITLE_CLASS);
const FIRST_TIME_MYZONE_KEY = "c8_myzone_first_time";
const HISTORY_CACHE_KEY_PREFIX = "c8_my_games_history";
const HISTORY_CACHE_TTL_MS = 90000;
const QUICKFIRE_MONTHS_UPPER = [
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER"
];
const QUICKFIRE_SUMMARY_WEEKDAYS = [
    "SUN",
    "MON",
    "TUE",
    "WED",
    "THU",
    "FRI",
    "SAT"
];
const SLIM_FOOTER_COIN_LABEL = "font-chakra-petch text-[9px] font-normal leading-[15px] tracking-[0] text-right text-white";
const SLIM_FOOTER_COIN_AMOUNT = "font-chakra-petch text-[9px] font-bold leading-[15px] tracking-[0] text-right text-white";
const SLIM_FOOTER_COIN_LABEL_LIME = "font-chakra-petch text-[9px] font-normal leading-[15px] tracking-[0] text-right text-[#d4ff1f]";
const SLIM_FOOTER_COIN_AMOUNT_LIME = "font-chakra-petch text-[9px] font-bold leading-[15px] tracking-[0] text-right text-[#d4ff1f]";
const MATCH_HERO_CLASS = "font-anton text-[14px] font-normal uppercase leading-[100%] tracking-normal align-middle";
const MYZONE_SUMMARY_WHITE_STRIP_MATCH_CLASS = "font-anton text-[10px] font-normal not-italic uppercase leading-[15px] tracking-[0] [leading-trim:none] align-middle";
const MYZONE_SUMMARY_WHITE_STRIP_VS_CLASS = "font-anton text-[10px] font-normal not-italic uppercase leading-[15px] tracking-[0] [leading-trim:none] align-middle";
const MYZONE_WHITE_STRIP_DATE_CLASS = "font-anton text-[12px] font-normal uppercase leading-[100%] tracking-normal text-right align-middle text-main/40";
const MYZONE_PURPLE_HEADER_DATE_CLASS = "shrink-0 font-anton text-[10px] font-normal not-italic uppercase leading-[15px] tracking-normal text-right text-white/65 [leading-trim:none]";
const MYZONE_SQUARES_STAT_LABEL_CLASS = "font-anton text-[12px] font-normal uppercase leading-[100%] tracking-normal text-center align-middle text-white/50";
const MYZONE_BULLION_SUMMARY_STAT_LABEL_CLASS = "font-anton text-[12px] font-normal not-italic uppercase leading-[100%] tracking-normal text-center align-middle text-white/40 [leading-trim:none]";
const MYZONE_BULLION_SUMMARY_HEADER_GAME_NAME_CLASS = "min-w-0 flex-1 truncate py-1 font-anton text-[16px] font-normal not-italic uppercase leading-[12px] tracking-[0] [leading-trim:none] text-white align-middle";
const MYZONE_SIXES_SUMMARY_HEADER_ICON_CLASS = "h-[24px] w-[24px] min-h-[24px] min-w-[24px] max-h-[24px] max-w-[24px] shrink-0 object-contain";
const MYZONE_SIXES_SUMMARY_HEADER_TITLE_CLASS = "min-w-0 flex-1 truncate py-1 font-anton text-[16px] font-normal not-italic uppercase leading-[12px] tracking-[0] [leading-trim:none] text-white align-middle";
const MYZONE_SIXES_LOBBY_DRAWER_TITLE_CLASS = "min-w-0 flex-1 truncate py-1 text-center align-middle font-anton text-[16px] font-normal not-italic uppercase leading-[16px] tracking-[0] [leading-trim:none] text-white";
const MYZONE_SIXES_LOBBY_DRAWER_HEADER_CLASS = "!py-3 md:!py-4 overflow-visible";
const MYZONE_SIXES_LOBBY_DRAWER_PANEL_POSITION_CLASS = "items-start justify-center pt-[5vh] sm:pt-[7vh] md:pt-[9vh]";
const MYZONE_SIXES_LOBBY_DRAWER_SHELL_CLASS = "bg-[#461D79]";
const MYZONE_SIXES_LIST_CARD_FOOTER_BG_CLASS = "bg-[#4f2189]";
const MYZONE_SIXES_LIST_CARD_TOP_BG_CLASS = "bg-[#652DAF]";
const MYZONE_SIXES_LIST_CARD_THUMB_BG_CLASS = "bg-[#9747FF]";
const MYZONE_SIXES_SUMMARY_HEADER_DATE_CLASS = "shrink-0 max-w-[120px] truncate font-anton text-[10px] font-normal not-italic uppercase leading-[15px] tracking-[0] text-right text-white/65 [leading-trim:none] sm:max-w-none";
const MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS = "inline-flex h-[21px] min-h-[21px] min-w-[42px] max-h-[21px] shrink-0 items-center justify-center rounded-none px-1 font-anton text-[10px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none]";
const MYZONE_SIXES_SUMMARY_FINISHED_PILL_CLASS = `${MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS} bg-[#32F78D] text-[#1B062F]`;
const MYZONE_SIXES_SUMMARY_ACTIVE_PILL_CLASS = `${MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS} bg-[#F73261] text-white`;
const MYZONE_SIXES_SUMMARY_VOID_PILL_CLASS = `${MYZONE_SIXES_SUMMARY_STATUS_PILL_SHELL_CLASS} bg-[#EAB308] text-[#1B062F]`;
const MYZONE_SIXES_SUMMARY_STATS_ROW_CLASS = "flex min-w-0 gap-0.5 border-y border-[#6f3fbe]/30 bg-[#461d79] pt-1 sm:gap-px";
const MYZONE_SIXES_SUMMARY_FOOTER_CLASS = "shrink-0 bg-[#461d79] px-3 pb-3 pt-2";
const MYZONE_SIXES_SUMMARY_GO_TO_CARD_BUTTON_SHELL_CLASS = "flex h-[40px] min-h-[40px] max-h-[40px] w-full shrink-0 items-center justify-center rounded-none bg-lime px-4 hover:bg-limehover";
const MYZONE_SIXES_SUMMARY_STAT_COIN_ICON_CLASS = "h-4 w-4 min-h-[16px] min-w-[16px] shrink-0 object-contain";
const MYZONE_SIXES_SUMMARY_WHITE_STRIP_ROW_CLASS = "relative flex h-[36px] min-h-[36px] max-h-[36px] w-full min-w-0 items-center justify-between px-2 sm:px-3";
const MYZONE_SIXES_SUMMARY_WHITE_STRIP_TEAM_NAME_CLASS = "font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] align-middle";
const MYZONE_SIXES_SUMMARY_WHITE_STRIP_VS_CLASS = "shrink-0 font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] align-middle";
const MYZONE_SIXES_SUMMARY_STAT_TILE_CLASS = "flex h-[60px] min-h-[60px] max-h-[60px] min-w-0 flex-1 flex-col items-center justify-center gap-0.5 bg-[#652dae] px-1.5 text-center";
const MYZONE_SIXES_SUMMARY_STAT_LABEL_CLASS = "font-anton text-[12px] font-normal not-italic uppercase leading-[100%] tracking-[0] text-center align-middle text-white/40 [leading-trim:none]";
const MYZONE_SIXES_SUMMARY_STAT_VALUE_CLASS = "font-anton text-[20px] font-normal not-italic uppercase leading-[100%] tracking-[0] text-center align-middle tabular-nums text-white [leading-trim:none]";
const MYZONE_BULLION_SUMMARY_STAT_VALUE_CLASS = "font-anton text-[20px] font-normal not-italic uppercase leading-[100%] tracking-normal text-center align-middle tabular-nums text-white [leading-trim:none]";
const MYZONE_SQUARES_STAT_VALUE_CLASS = "font-anton text-[20px] font-normal uppercase leading-[100%] tracking-normal text-center align-middle tabular-nums text-white";
const MYZONE_SQUARES_SUMMARY_LEADERBOARD_AVATAR_CLASS = "h-[30px] w-[30px] shrink-0";
const MYZONE_SQUARES_SUMMARY_LEADERBOARD_CHIPS_AMOUNT_CLASS = "block w-[30px] min-w-[30px] max-w-[30px] shrink-0 truncate text-right font-chakra-petch text-[16px] font-normal not-italic leading-[100%] tracking-[0] [leading-trim:none] tabular-nums text-white";
const MYZONE_SQUARES_SUMMARY_LEADERBOARD_COINS_NUMBER_CLASS = "font-chakra-petch text-[12px] font-normal not-italic leading-[100%] tracking-[0] [leading-trim:none] tabular-nums text-white";
const MYZONE_SQUARES_SUMMARY_LEADERBOARD_RANK_CLASS = "h-[20px] w-[20px] shrink-0";
const MYZONE_SQUARES_SUMMARY_LEADERBOARD_USER_NAME_CLASS = "font-anton text-[16px] font-normal not-italic uppercase leading-[24px] tracking-[0] [leading-trim:none] align-middle text-white";
const MYZONE_SQUARES_HEADER_ENTRANCE_CLASS = "font-chakra-petch text-[11px] font-normal leading-[100%] tracking-normal text-right text-white tabular-nums";
const MYZONE_SQUARES_HEADER_TITLE_CLASS = "font-anton text-[16px] font-normal uppercase leading-[12px] tracking-normal text-white";
const MYZONE_TRADER_HEADER_TITLE_CLASS = "font-anton text-[16px] font-normal uppercase leading-[12px] tracking-normal text-white";
const MYZONE_QUICKFIRE_HEADER_TITLE_CLASS = "font-anton text-[16px] font-normal uppercase leading-[12px] tracking-normal text-white";
const MYZONE_QUICKFIRE_SUMMARY_STAT_LABEL_CLASS = "font-anton text-[12px] font-normal uppercase leading-[100%] tracking-normal text-center align-middle text-white/50";
const MYZONE_QUICKFIRE_SUMMARY_QUESTION_NUM_CLASS = "font-anton text-[20px] font-normal uppercase leading-[15px] tracking-normal text-center align-middle text-[#1B062F]";
const MYZONE_QUICKFIRE_SUMMARY_QUESTION_COINS_CLASS = "min-w-0 truncate text-center font-chakra-petch text-[12px] font-normal leading-[100%] tracking-normal text-white";
const MYZONE_TRADER_TRADE_CARD_MATCH_NAME_CLASS = "font-chakra-petch text-[10px] font-normal leading-[100%] tracking-normal align-middle";
const MYZONE_HEADER_MATCH_VS_CLASS = "font-chakra-petch text-[8px] font-normal leading-[100%] tracking-normal align-middle normal-case";
const MYZONE_TRADER_TRADE_TYPE_LABEL_CLASS = "font-anton text-[12px] font-normal leading-[100%] tracking-normal text-main";
const MYZONE_TRADER_TRADE_SELECTION_CLASS = "min-w-0 text-right font-chakra-petch text-[12px] font-normal not-italic leading-[100%] tracking-[0] [leading-trim:none] text-main";
const MYZONE_TRADER_TRADE_ODDS_LABEL_CLASS = "font-chakra-petch text-[9px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-main/60";
const MYZONE_TRADER_TRADE_ODDS_VALUE_BOX_CLASS = "inline-flex h-5 min-h-[20px] w-[40px] min-w-[40px] max-w-[40px] shrink-0 items-center justify-center truncate bg-[#a8d4f0] px-0.5 font-chakra-petch text-[10px] font-normal not-italic uppercase leading-[10px] tracking-[0] [leading-trim:none] text-center tabular-nums text-main";
const MYZONE_TRADER_TRADE_STAKE_LABEL_CLASS = "font-chakra-petch text-[9px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-main/60";
const MYZONE_TRADER_TRADE_STAKE_VALUE_CLASS = "shrink-0 font-chakra-petch text-[10px] font-bold not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-main tabular-nums";
const MYZONE_TRADER_TRADE_RETURNS_LABEL_CLASS = "font-chakra-petch text-[9px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-right text-main/60";
const MYZONE_TRADER_TRADE_RETURNS_VALUE_BOX_CLASS = "inline-flex h-5 min-h-[20px] shrink-0 items-center justify-end";
const MYZONE_TRADER_TRADE_RETURNS_VALUE_CLASS = "font-chakra-petch text-[10px] font-bold not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-right tabular-nums";
const MYZONE_TRADER_TRADE_FOOTER_COIN_ICON_CLASS = "h-[16px] w-[16px] shrink-0";
const MYZONE_CARD_HEADER_STATUS_CLASS = "font-anton text-[10px] font-normal uppercase leading-[100%] tracking-normal text-center align-middle";
const MYZONE_HEADER_STATUS_PILL_CLASS = "inline-flex h-[22px] min-h-[22px] shrink-0 items-center justify-center px-2.5 py-1 font-anton text-[10px] font-normal uppercase leading-[100%] tracking-normal";
const MYZONE_TRADER_MATCH_RESULTS_BUTTON_CLASS = "flex h-10 min-h-[40px] shrink-0 items-center justify-center px-3 font-anton text-[16px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-center align-middle text-[#1B062F]";
const MYZONE_GO_TO_MATCH_BUTTON_LABEL_CLASS = "text-center align-middle font-anton text-[16px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-[#1B062F]";
const MYZONE_GAME_SUMMARY_MODAL_SLOT_CLASS = "fixed inset-0 z-[10031] flex items-start justify-center px-2 pb-4 pt-10 sm:px-4 sm:pb-4 sm:pt-14 pointer-events-none";
const MYZONE_GAME_CONTAINER_BG_CLASS = "bg-white/[0.07]";
const MYZONE_GAME_CONTAINER_TITLE_CLASS = "font-anton text-[14px] font-normal not-italic uppercase leading-[25px] tracking-[0] [leading-trim:none] text-white";
const MYZONE_GAME_CONTAINER_COUNT_BADGE_CLASS = "inline-flex h-[18px] w-[18px] min-h-[18px] min-w-[18px] max-h-[18px] max-w-[18px] shrink-0 items-center justify-center bg-[#F73261] text-center align-middle font-anton text-[12px] font-normal not-italic uppercase leading-[10px] tracking-[0] [leading-trim:none] text-white tabular-nums";
const MYZONE_PAST_CARD_DATE_CLASS = "text-left align-middle font-anton text-[10px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-white/50 shrink-0 whitespace-nowrap";
const MYZONE_GAME_CARD_TITLE_COLUMN_CLASS = "flex min-w-0 flex-1 flex-col items-start justify-center gap-1 overflow-hidden text-left";
const MYZONE_GAME_CARD_TEAM_NAME_CLASS = "min-w-0 truncate align-middle font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-white";
const MYZONE_GAME_CARD_TEAM_VS_CLASS = "shrink-0 align-middle font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-white/30";
const MYZONE_GAME_CARD_COINS_WON_AMOUNT_CLASS = "font-bold tabular-nums";
const MYZONE_QUICKFIRE_PAST_SESSION_TITLE_CLASS = "align-middle font-anton text-[14px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-white";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lQPs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Same as `BullionMatchLanding` / the Bullion route — `jwtOptionalAuth` may need `session_token` when JWT is absent. */ parcelHelpers.export(exports, "bullionMyGamesListUrl", ()=>bullionMyGamesListUrl);
/** Cached my-games rows for a fixture URL when the lobby list no longer includes that match. */ parcelHelpers.export(exports, "peekBullionMyGamesOrphanRowsForMatch", ()=>peekBullionMyGamesOrphanRowsForMatch);
/** Build synthetic landing room + entered contests from merged `/bullion/my-games` rows. */ parcelHelpers.export(exports, "buildBullionOrphanLandingFromMyGamesRows", ()=>buildBullionOrphanLandingFromMyGamesRows);
parcelHelpers.export(exports, "invalidateBullionMyGamesByMatchIdCache", ()=>invalidateBullionMyGamesByMatchIdCache);
/** Non-expired merged my-games map (for instant match-landing paint after leaving in-play). */ parcelHelpers.export(exports, "peekBullionMyGamesByMatchIdCache", ()=>peekBullionMyGamesByMatchIdCache);
/**
 * Merged ACTIVE + HISTORY `/bullion/my-games` rows keyed by `matchId` — deduped in-flight + short TTL so
 * the Bullion route and `BullionMatchLanding` do not double-fetch the same lists on mount.
 */ parcelHelpers.export(exports, "fetchBullionMyGamesByMatchIdCached", ()=>fetchBullionMyGamesByMatchIdCached);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _authHeaders = require("../../../utils/authHeaders");
var _bullionMatchLandingLobby = require("./bullionMatchLandingLobby");
var _roomUtils = require("./roomUtils");
/** Align with lobby / match-landing caches — avoid refetch on every in-app back navigation. */ const BULLION_MY_GAMES_BY_MATCH_CACHE_TTL_MS = 60000;
let cache = null;
let inflight = null;
function authKey() {
    const st = (0, _jsCookieDefault.default).get("c8_session_token") || "";
    const jwt = (0, _authHeaders.getJwt)() || "";
    if (!st && !jwt) return null;
    return `${st}|${jwt}`;
}
function bullionMyGamesListUrl(tab) {
    const params = new URLSearchParams({
        tab
    });
    const st = (0, _jsCookieDefault.default).get("c8_session_token");
    if (st) params.set("session_token", st);
    return `${"https://cricket8.com/api"}/bullion/my-games?${params.toString()}`;
}
function rowToLobbyGame(row) {
    const mid = String(row.matchId || "").trim();
    if (!mid) return null;
    const gameId = Number(row.gameId);
    if (!Number.isFinite(gameId)) return null;
    return {
        mid,
        game: {
            gameId,
            name: row.gameName ?? null,
            entryStake: Number(row.entryStake ?? 0),
            gameStatus: row.gameStatus ?? null
        }
    };
}
function mergeRowsIntoByMatch(byMatch, orphanRowsByMatchId, rows) {
    for (const row of rows){
        const mapped = rowToLobbyGame(row);
        if (!mapped) continue;
        const { mid, game } = mapped;
        if (!byMatch[mid]) byMatch[mid] = [];
        const list = byMatch[mid];
        if (!list.some((g)=>Number(g.gameId) === Number(game.gameId))) list.push(game);
        const r = row;
        if (!orphanRowsByMatchId[mid]) orphanRowsByMatchId[mid] = [];
        const orphanList = orphanRowsByMatchId[mid];
        if (!orphanList.some((g)=>Number(g.gameId) === Number(game.gameId))) orphanList.push({
            matchId: mid,
            gameId: game.gameId,
            gameName: r.gameName ?? game.name ?? null,
            entryStake: game.entryStake,
            gameStatus: game.gameStatus,
            settled: Boolean(r.settled),
            matchName: r.matchName ?? null,
            competition: r.competition ?? null,
            startTime: r.startTime != null ? String(r.startTime) : null
        });
    }
}
function findOrphanRowsForMatchQuery(orphanRowsByMatchId, matchQuery) {
    const want = (0, _bullionMatchLandingLobby.normalizeBullionMatchQueryParam)(matchQuery);
    if (!want) return [];
    for (const [mid, rows] of Object.entries(orphanRowsByMatchId)){
        if ((0, _bullionMatchLandingLobby.normalizeBullionMatchQueryParam)(mid) === want) return rows;
    }
    return [];
}
function peekBullionMyGamesOrphanRowsForMatch(matchQuery) {
    const key = authKey();
    if (key == null) return null;
    if (!cache || cache.authKey !== key || cache.expiresAt <= Date.now()) return null;
    return findOrphanRowsForMatchQuery(cache.orphanRowsByMatchId, matchQuery);
}
function buildBullionOrphanLandingFromMyGamesRows(rows) {
    if (rows.length === 0) return null;
    const best = rows.find((r)=>Boolean(r.matchName && String(r.matchName).trim())) || rows[0];
    const matchId = String(best.matchId || rows[0]?.matchId || "").trim();
    if (!matchId) return null;
    let syn = (0, _roomUtils.buildBullionRoomFromPlayBootstrap)({
        matchId,
        matchName: best.matchName ?? null,
        competition: best.competition ?? null,
        startsAt: best.startTime ?? null
    });
    const allSettled = rows.every((r)=>Boolean(r.settled));
    const startMs = best.startTime ? new Date(String(best.startTime)).getTime() : Number.NaN;
    const kickoffPassedMeta = Number.isFinite(startMs) && startMs <= Date.now();
    /** Settled plays alone do not mean the fixture is finished — upcoming matches stay open for new entry. */ if (allSettled && kickoffPassedMeta) syn = {
        ...syn,
        fixturePhase: "finished",
        isLive: false,
        status: "MATCH COMPLETE"
    };
    else if (kickoffPassedMeta) syn = {
        ...syn,
        fixturePhase: "live",
        isLive: true
    };
    const plays = rows.map((row)=>({
            gameId: row.gameId,
            name: row.gameName ?? null,
            entryStake: row.entryStake,
            gameStatus: row.gameStatus
        }));
    return {
        room: syn,
        plays
    };
}
function invalidateBullionMyGamesByMatchIdCache() {
    cache = null;
}
function peekBullionMyGamesByMatchIdCache() {
    const key = authKey();
    if (key == null) return null;
    if (!cache || cache.authKey !== key || cache.expiresAt <= Date.now()) return null;
    return cache.byMatch;
}
async function fetchBullionMyGamesByMatchIdCached(opts) {
    const key = authKey();
    if (key == null) return {};
    const now = Date.now();
    if (!opts?.bypassCache && cache && cache.authKey === key && cache.expiresAt > now) return cache.byMatch;
    if (inflight) return inflight;
    inflight = (async ()=>{
        try {
            /** HISTORY has no tab filter (includes settled); ACTIVE covers open plays — FINISHED tab omitted to save a round-trip. */ const [activeRes, historyRes] = await Promise.all([
                fetch(bullionMyGamesListUrl("ACTIVE"), {
                    method: "GET",
                    headers: (0, _authHeaders.getAuthHeaders)()
                }),
                fetch(bullionMyGamesListUrl("HISTORY"), {
                    method: "GET",
                    headers: (0, _authHeaders.getAuthHeaders)()
                })
            ]);
            const byMatch = {};
            const orphanRowsByMatchId = {};
            if (activeRes.ok) {
                const data = await activeRes.json().catch(()=>({}));
                const rows = Array.isArray(data?.games) ? data.games : [];
                mergeRowsIntoByMatch(byMatch, orphanRowsByMatchId, rows);
            }
            if (historyRes.ok) {
                const data = await historyRes.json().catch(()=>({}));
                const rows = Array.isArray(data?.games) ? data.games : [];
                mergeRowsIntoByMatch(byMatch, orphanRowsByMatchId, rows);
            }
            if (!opts?.bypassCache) cache = {
                authKey: key,
                expiresAt: Date.now() + BULLION_MY_GAMES_BY_MATCH_CACHE_TTL_MS,
                byMatch,
                orphanRowsByMatchId
            };
            return byMatch;
        } finally{
            inflight = null;
        }
    })();
    return inflight;
}

},{"js-cookie":"2P5RE","../../../utils/authHeaders":"5Rczo","./bullionMatchLandingLobby":"6cMJo","./roomUtils":"8f6zP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hyV6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * GET `/trade/cricket/events?maxmatches=100` — shared by Bullion lobby gap-fill when active plays
 * reference fixtures not in the frozen Bullion list. Short TTL + in-flight dedupe limits repeat calls
 * when multiple components or effects need the same snapshot.
 */ parcelHelpers.export(exports, "fetchTraderCricketEventsCached", ()=>fetchTraderCricketEventsCached);
parcelHelpers.export(exports, "invalidateTraderCricketEventsCache", ()=>invalidateTraderCricketEventsCache);
/** Match ids in `activeBullionGamesByMatchId` that are not yet present as row `id` on the lobby list. */ parcelHelpers.export(exports, "computeMissingActiveMatchIdsFromLobby", ()=>computeMissingActiveMatchIdsFromLobby);
var _authHeaders = require("../../../utils/authHeaders");
var _bullionMatchLandingLobby = require("./bullionMatchLandingLobby");
const BULLION_TRADER_CRICKET_EVENTS_CACHE_TTL_MS = 20000;
let cache = null;
let inflight = null;
async function fetchTraderCricketEventsCached(opts) {
    const now = Date.now();
    if (!opts?.bypassCache && cache && cache.expiresAt > now) return cache.payload;
    if (inflight) return inflight;
    inflight = (async ()=>{
        try {
            const url = `${"https://cricket8.com/api"}/trade/cricket/events?maxmatches=100`;
            const res = await fetch(url, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            if (!res.ok) return [];
            const data = await res.json().catch(()=>({}));
            const cricket = Array.isArray(data.matches) ? data.matches : [];
            const payload = cricket.map((match)=>({
                    ...match,
                    sport: "cricket"
                }));
            if (!opts?.bypassCache) cache = {
                expiresAt: Date.now() + BULLION_TRADER_CRICKET_EVENTS_CACHE_TTL_MS,
                payload
            };
            return payload;
        } catch  {
            return [];
        } finally{
            inflight = null;
        }
    })();
    return inflight;
}
function invalidateTraderCricketEventsCache() {
    cache = null;
}
function computeMissingActiveMatchIdsFromLobby(activeMids, lobbyRows) {
    const mids = (Array.isArray(activeMids) ? activeMids : []).map((k)=>String(k || "").trim()).filter(Boolean);
    if (mids.length === 0) return [];
    const rows = Array.isArray(lobbyRows) ? lobbyRows : [];
    const lobbyIds = rows.map((r)=>String(r?.id ?? "").trim()).filter(Boolean);
    return mids.filter((id)=>!lobbyIds.some((lid)=>(0, _bullionMatchLandingLobby.bullionLobbyMatchIdsEqual)(lid, id)));
}

},{"../../../utils/authHeaders":"5Rczo","./bullionMatchLandingLobby":"6cMJo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"533xU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Cricket list rows from trade match endpoints often omit live status (odds live on the events server).
 * Merge a slim lobby `initial-state` snapshot so BULLION can mark live/finished boards.
 */ parcelHelpers.export(exports, "enrichMatchesWithCricketStreamInitialState", ()=>enrichMatchesWithCricketStreamInitialState);
var _streamInitialStatePrimedCache = require("../../../utils/streamInitialStatePrimedCache");
var _cricketStreamSubscription = require("../../../utils/cricketStreamSubscription");
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
function extractStreamEventStatusFromInitialSnap(snap) {
    if (!snap || typeof snap !== "object") return null;
    const o = snap;
    const pick = (v)=>v != null && v !== "" ? v : null;
    const sc = o.scorecard;
    if (sc && typeof sc === "object") {
        const es = pick(sc.event_status);
        if (es != null) return es;
    }
    const mu = o.market_update;
    if (mu && typeof mu === "object") {
        const m = mu;
        const esTop = pick(m.event_status);
        if (esTop != null) return esTop;
        const inner = m.market_update;
        if (inner && typeof inner === "object") {
            const esInner = pick(inner.event_status);
            if (esInner != null) return esInner;
        }
    }
    const ev = o.event;
    if (ev && typeof ev === "object") {
        const e = ev;
        const esEv = pick(e.event_status);
        if (esEv != null) return esEv;
        const md = e.msg_data;
        if (md && typeof md === "object") {
            const esMd = pick(md.event_status);
            if (esMd != null) return esMd;
        }
    }
    return null;
}
function extractStreamStatusTextFromInitialSnap(snap) {
    if (!snap || typeof snap !== "object") return "";
    const o = snap;
    const sc = o.scorecard;
    if (sc && typeof sc === "object") {
        const st = sc.status;
        if (st != null && String(st).trim()) return String(st).trim();
    }
    const ev = o.event;
    if (ev && typeof ev === "object") {
        const md = ev.msg_data;
        if (md && typeof md === "object") {
            const st = md.status;
            if (st != null && String(st).trim()) return String(st).trim();
        }
    }
    return "";
}
function bullionLiveScorePatchFromStreamSnap(snap) {
    const es = extractStreamEventStatusFromInitialSnap(snap);
    if (es != null && (0, _decimalEventStatus.isMatchFinishedStatus)(es)) return {
        isLive: false,
        isFinished: true
    };
    const statusText = extractStreamStatusTextFromInitialSnap(snap);
    if (statusText && (0, _decimalEventStatus.isMatchFinishedStatus)(statusText)) return {
        isLive: false,
        isFinished: true
    };
    const u = statusText.toUpperCase();
    if (u.includes("MATCH COMPLETE") || u.includes("EVENT CLOSED") || u.includes("MATCH ABANDONED")) return {
        isLive: false,
        isFinished: true
    };
    const o = snap;
    const gp = String(o?.game_phase ?? "").trim();
    if (/\bevent\s*closed\b/i.test(gp) || /\bmatch\s*complete\b/i.test(gp)) return {
        isLive: false,
        isFinished: true
    };
    const comment = (o?.commentary && typeof o.commentary === "object" ? o.commentary.text : null) ?? o?.match_comment;
    if ((0, _decimalEventStatus.commentIndicatesCricketMatchResult)(comment)) return {
        isLive: false,
        isFinished: true
    };
    if (es == null) return null;
    if ((0, _decimalEventStatus.isMatchScheduledStatus)(es)) return null;
    const n = (0, _decimalEventStatus.eventStatusToNumber)(es);
    if (n != null && (0, _decimalEventStatus.IN_PLAY_STATUS_IDS).includes(n)) return {
        isLive: true,
        isFinished: false
    };
    if (typeof es === "string" && es.trim()) {
        const key = (0, _decimalEventStatus.eventStatusStringKey)(es);
        if (key && key !== "MATCH_SCHEDULED" && !(0, _decimalEventStatus.isMatchFinishedStatus)(es)) return {
            isLive: true,
            isFinished: false
        };
    }
    return null;
}
async function enrichMatchesWithCricketStreamInitialState(matches) {
    const baseApi = "https://cricket8.com/stream";
    const streamBase = (baseApi || "").replace(/\/stream.*$/i, "");
    if (!streamBase || matches.length === 0) return matches;
    const idsNeedingMarkets = new Set();
    for (const m of matches){
        if (String(m.sport || "").toLowerCase() !== "cricket") continue;
        const id = String(m.id ?? "").trim();
        if (id) idsNeedingMarkets.add(id);
    }
    const sortedIds = [
        ...idsNeedingMarkets
    ].sort();
    if (sortedIds.length === 0) return matches;
    const INITIAL_STATE_FETCH_MS = 6000;
    let state = {};
    try {
        const controller = new AbortController();
        const timer = typeof window !== "undefined" ? window.setTimeout(()=>controller.abort(), INITIAL_STATE_FETCH_MS) : undefined;
        try {
            state = await (0, _cricketStreamSubscription.fetchStreamInitialStateBatched)(streamBase, sortedIds, "&tier=lobby", controller.signal);
        } finally{
            if (timer != null) window.clearTimeout(timer);
        }
    } catch  {
        return matches;
    }
    (0, _streamInitialStatePrimedCache.primeInitialStateSnapshotsFromApiBody)(state);
    const liveScoreByMatchId = new Map();
    for (const [matchId, snap] of Object.entries(state)){
        const ls = bullionLiveScorePatchFromStreamSnap(snap);
        if (ls) liveScoreByMatchId.set(String(matchId), ls);
    }
    if (liveScoreByMatchId.size === 0) return matches;
    return matches.map((m)=>{
        if (String(m.sport || "").toLowerCase() !== "cricket") return m;
        const mid = String(m.id ?? "");
        let next = m;
        const ls = liveScoreByMatchId.get(mid);
        if (ls) {
            const prev = next.liveScore && typeof next.liveScore === "object" ? next.liveScore : {};
            next = {
                ...next,
                liveScore: {
                    ...prev,
                    ...ls
                }
            };
        }
        // BULLION board uses frozen opening_odds only — do not merge live stream markets (stable line ids for settlement).
        return next;
    });
}

},{"../../../utils/streamInitialStatePrimedCache":"8TEdU","../../../utils/cricketStreamSubscription":"99RP7","../../Trader/Cricket/decimalEventStatus":"f1nlI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8TEdU":[function(require,module,exports,__globalThis) {
/**
 * Lobby flows call `GET /stream/initial-state` (e.g. Bullion `enrichMatchesWithCricketStreamInitialState`).
 * Opening the played view immediately runs the same endpoint via `DecimalSocketContext` — prime once
 * so the first snapshot poll / bootstrap fetch can reuse data for ~15s without a duplicate HTTP call.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Store per-match snapshots from an initial-state JSON body (keys = match ids). */ parcelHelpers.export(exports, "primeInitialStateSnapshotsFromApiBody", ()=>primeInitialStateSnapshotsFromApiBody);
/** Return and remove one primed snapshot for this match, if still fresh (one-shot). */ parcelHelpers.export(exports, "consumePrimedMatchInitialState", ()=>consumePrimedMatchInitialState);
const TTL_MS = 15000;
const store = new Map();
function primeInitialStateSnapshotsFromApiBody(body) {
    if (!body || typeof body !== "object") return;
    const now = Date.now();
    for (const [mid, snap] of Object.entries(body)){
        if (!mid || !snap || typeof snap !== "object" || Array.isArray(snap)) continue;
        store.set(String(mid).trim(), {
            expiresAt: now + TTL_MS,
            snap: snap
        });
    }
}
function consumePrimedMatchInitialState(matchIdRaw) {
    const mid = String(matchIdRaw || "").trim();
    if (!mid) return null;
    const e = store.get(mid);
    const now = Date.now();
    if (!e) return null;
    if (e.expiresAt <= now) {
        store.delete(mid);
        return null;
    }
    store.delete(mid);
    return e.snap;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"99RP7":[function(require,module,exports,__globalThis) {
/**
 * Shared cricket SSE / initial-state subscription helpers for egress control.
 * Logged-out clients use `tier=lobby` (score + slim scorecard + Match Winner / 410 markets only).
 * Logged-out Trader match play adds `book=catalog` so guests see every market without live prices
 * except Match Winner, plus live cricket chrome (scoregrid / commentary / alerts) for the
 * bat–bowl strip and break panels.
 * Match-league home uses `tier=full` so Squares live balls / scoregrid reach the lobby card.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CRICKET_STREAM_TIER_LOBBY", ()=>CRICKET_STREAM_TIER_LOBBY);
parcelHelpers.export(exports, "CRICKET_STREAM_TIER_FULL", ()=>CRICKET_STREAM_TIER_FULL);
parcelHelpers.export(exports, "CRICKET_STREAM_BOOK_CATALOG", ()=>CRICKET_STREAM_BOOK_CATALOG);
parcelHelpers.export(exports, "CRICKET_STREAM_PRODUCT_TRADER", ()=>CRICKET_STREAM_PRODUCT_TRADER);
/** Query suffix for SSE / initial-state (`&tier=…&product=…`). */ parcelHelpers.export(exports, "cricketStreamQueryExtra", ()=>cricketStreamQueryExtra);
parcelHelpers.export(exports, "CRICKET_LOBBY_POLL_MS", ()=>CRICKET_LOBBY_POLL_MS);
parcelHelpers.export(exports, "CRICKET_LOBBY_MAX_MATCH_IDS", ()=>CRICKET_LOBBY_MAX_MATCH_IDS);
parcelHelpers.export(exports, "CRICKET_LOBBY_SNAPSHOT_MAX_MATCH_IDS", ()=>CRICKET_LOBBY_SNAPSHOT_MAX_MATCH_IDS);
parcelHelpers.export(exports, "CRICKET_LOBBY_MATCH_ID_BATCH", ()=>CRICKET_LOBBY_MATCH_ID_BATCH);
parcelHelpers.export(exports, "streamTierForAuth", ()=>streamTierForAuth);
/** Keep first `max` ids (callers should put live / visible matches first). */ parcelHelpers.export(exports, "capMatchIds", ()=>capMatchIds);
parcelHelpers.export(exports, "chunkMatchIds", ()=>chunkMatchIds);
/**
 * Fetch lobby/full `initial-state` in batches and merge per-match snapshots.
 * @param queryExtra e.g. `&tier=lobby&product=trader` (must start with `&` or be empty)
 */ parcelHelpers.export(exports, "fetchStreamInitialStateBatched", ()=>fetchStreamInitialStateBatched);
parcelHelpers.export(exports, "CRICKET_LOBBY_FEED_FILTER", ()=>CRICKET_LOBBY_FEED_FILTER);
parcelHelpers.export(exports, "CRICKET_LOBBY_WITH_MARKETS_FEED_FILTER", ()=>CRICKET_LOBBY_WITH_MARKETS_FEED_FILTER);
parcelHelpers.export(exports, "CRICKET_TRADER_FULL_FEED_FILTER", ()=>CRICKET_TRADER_FULL_FEED_FILTER);
parcelHelpers.export(exports, "CRICKET_BULLION_FULL_FEED_FILTER", ()=>CRICKET_BULLION_FULL_FEED_FILTER);
parcelHelpers.export(exports, "SQUARES_FULL_FEED_FILTER", ()=>SQUARES_FULL_FEED_FILTER);
parcelHelpers.export(exports, "LOGIN_GATE_STREAM_MESSAGE", ()=>LOGIN_GATE_STREAM_MESSAGE);
/** Subscribe to one match with lobby tier + trimmed feed when the visitor is logged out. */ parcelHelpers.export(exports, "subscribeToMatchForAuth", ()=>subscribeToMatchForAuth);
var _loginSignupCopy = require("../components/shared/loginSignupCopy");
const CRICKET_STREAM_TIER_LOBBY = "lobby";
const CRICKET_STREAM_TIER_FULL = "full";
const CRICKET_STREAM_BOOK_CATALOG = "catalog";
const CRICKET_STREAM_PRODUCT_TRADER = "trader";
function cricketStreamQueryExtra(options = {}) {
    const tier = String(options.tier ?? CRICKET_STREAM_TIER_LOBBY).trim().toLowerCase();
    const product = String(options.product ?? CRICKET_STREAM_PRODUCT_TRADER).trim().toLowerCase();
    const parts = [];
    if (tier) parts.push(`tier=${encodeURIComponent(tier)}`);
    if (product) parts.push(`product=${encodeURIComponent(product)}`);
    return parts.length ? `&${parts.join("&")}` : "";
}
const CRICKET_LOBBY_POLL_MS = 45000;
const CRICKET_LOBBY_MAX_MATCH_IDS = 24;
const CRICKET_LOBBY_SNAPSHOT_MAX_MATCH_IDS = 80;
const CRICKET_LOBBY_MATCH_ID_BATCH = 20;
function streamTierForAuth(isLoggedIn) {
    return isLoggedIn ? undefined : CRICKET_STREAM_TIER_LOBBY;
}
function capMatchIds(ids, max = CRICKET_LOBBY_MAX_MATCH_IDS) {
    const out = [];
    const seen = new Set();
    for (const raw of ids){
        const id = String(raw ?? "").trim();
        if (!id || seen.has(id)) continue;
        seen.add(id);
        out.push(id);
        if (out.length >= max) break;
    }
    return out;
}
function chunkMatchIds(ids, size = CRICKET_LOBBY_MATCH_ID_BATCH) {
    const list = ids.map((id)=>String(id ?? "").trim()).filter(Boolean);
    if (list.length === 0) return [];
    const batches = [];
    for(let i = 0; i < list.length; i += size)batches.push(list.slice(i, i + size));
    return batches;
}
async function fetchStreamInitialStateBatched(streamBase, matchIds, queryExtra = "", signal) {
    const base = String(streamBase || "").replace(/\/$/, "");
    if (!base || matchIds.length === 0) return {};
    const extra = queryExtra && !queryExtra.startsWith("&") ? `&${queryExtra}` : queryExtra;
    const merged = {};
    for (const batch of chunkMatchIds(matchIds)){
        if (signal?.aborted) break;
        const url = `${base}/stream/initial-state?matchIds=${encodeURIComponent(batch.join(","))}${extra}`;
        try {
            const res = await fetch(url, {
                method: "GET",
                credentials: "omit",
                signal
            });
            if (!res.ok) continue;
            const state = await res.json();
            if (state && typeof state === "object") Object.assign(merged, state);
        } catch  {
            if (signal?.aborted) break;
        }
    }
    return merged;
}
const CRICKET_LOBBY_FEED_FILTER = [
    "event",
    "scorecard",
    "scoreboard"
];
const CRICKET_LOBBY_WITH_MARKETS_FEED_FILTER = [
    "event",
    "market_update",
    "scorecard",
    "scoreboard"
];
const CRICKET_TRADER_FULL_FEED_FILTER = [
    "event",
    "market_update",
    "scorecard",
    "scoreboard",
    "commentary",
    "scoregrid",
    "lineups",
    "alerts"
];
const CRICKET_BULLION_FULL_FEED_FILTER = [
    "event",
    "scorecard",
    "scoreboard",
    "commentary",
    "scoregrid",
    "lineups",
    "alerts"
];
const SQUARES_FULL_FEED_FILTER = [
    "event",
    "market_update",
    "scorecard",
    "scoreboard",
    "commentary",
    "scoregrid",
    "lineups",
    "alerts"
];
const LOGIN_GATE_STREAM_MESSAGE = (0, _loginSignupCopy.SIGNUP_LOGIN_POPUP_MESSAGE);
function subscribeToMatchForAuth(subscribeToMatch, matchId, isLoggedIn, fullFeedFilter, options = {}) {
    if (!matchId) return ()=>{};
    const lobbyFilter = options.lobbyFeedFilter ?? CRICKET_LOBBY_FEED_FILTER;
    const feedFilter = isLoggedIn ? [
        ...fullFeedFilter
    ] : [
        ...lobbyFilter
    ];
    const tier = streamTierForAuth(isLoggedIn);
    const product = options.product;
    const book = !isLoggedIn && options.marketCatalog ? CRICKET_STREAM_BOOK_CATALOG : undefined;
    return subscribeToMatch(matchId, feedFilter, undefined, undefined, product, tier, book);
}

},{"../components/shared/loginSignupCopy":"pyqc8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"pyqc8":[function(require,module,exports,__globalThis) {
/** Default value prop on signup / login popups (LoginSignupBanner, game intro modals). */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIGNUP_LOGIN_POPUP_MESSAGE", ()=>SIGNUP_LOGIN_POPUP_MESSAGE);
parcelHelpers.export(exports, "SIGNUP_LOGIN_POPUP_DISCLAIMER", ()=>SIGNUP_LOGIN_POPUP_DISCLAIMER);
const SIGNUP_LOGIN_POPUP_MESSAGE = "Join free to get the fastest live match data and play our fun games!";
const SIGNUP_LOGIN_POPUP_DISCLAIMER = "Free-to-play cricket games. In game currencies have no monetary value and cannot be exchanged or withdrawn for cash";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6sFXt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bullionSelectionRegularChips", ()=>bullionSelectionRegularChips);
parcelHelpers.export(exports, "totalRegularChips", ()=>totalRegularChips);
parcelHelpers.export(exports, "bullionSelectionStorageKey", ()=>bullionSelectionStorageKey);
parcelHelpers.export(exports, "normalizeBullionSelectionMapKeys", ()=>normalizeBullionSelectionMapKeys);
parcelHelpers.export(exports, "normalizeBullionBonusPicks", ()=>normalizeBullionBonusPicks);
/** Normalize an unknown bonus payload (array, or legacy single `goldPick`) into a `BullionBonusPicks` array. */ parcelHelpers.export(exports, "coerceBullionBonusPicks", ()=>coerceBullionBonusPicks);
parcelHelpers.export(exports, "regularChipsInGroup", ()=>regularChipsInGroup);
parcelHelpers.export(exports, "parseBullionPlaySelectionsFromApi", ()=>parseBullionPlaySelectionsFromApi);
var _constants = require("./constants");
function bullionSelectionRegularChips(s) {
    return s.chips;
}
function totalRegularChips(selections) {
    return Object.values(selections).reduce((sum, s)=>sum + bullionSelectionRegularChips(s), 0);
}
function bullionSelectionStorageKey(market) {
    const raw = market.decimalMarketId;
    const mid = raw != null && String(raw).trim() !== "" ? String(raw).trim() : "";
    return mid || market.id;
}
function normalizeBullionSelectionMapKeys(room, picks) {
    const flat = room.groups.flatMap((g)=>g);
    const out = {};
    for (const [key, pick] of Object.entries(picks)){
        const market = flat.find((m)=>bullionSelectionStorageKey(m) === key || m.id === key) || flat.find((m)=>String(m.decimalMarketId ?? "").trim() === String(pick.decimalMarketId ?? "").trim()) || flat.find((m)=>String(m.decimalMarketId ?? "").trim() === String(pick.marketId ?? "").trim()) || undefined;
        const sk = market ? bullionSelectionStorageKey(market) : String(pick.decimalMarketId ?? "").trim() || String(pick.marketId ?? "").trim() || key;
        out[sk] = {
            ...pick,
            marketId: sk
        };
    }
    return out;
}
function normalizeBullionBonusPick(room, bonus) {
    const flat = room.groups.flatMap((g)=>g);
    const market = flat.find((m)=>bullionSelectionStorageKey(m) === bonus.marketId || m.id === bonus.marketId) || flat.find((m)=>String(m.decimalMarketId ?? "").trim() === String(bonus.decimalMarketId ?? "").trim()) || undefined;
    if (!market) return bonus;
    return {
        ...bonus,
        marketId: bullionSelectionStorageKey(market)
    };
}
function normalizeBullionBonusPicks(room, bonuses) {
    if (!Array.isArray(bonuses) || bonuses.length === 0) return [];
    return bonuses.filter(Boolean).map((b)=>normalizeBullionBonusPick(room, b));
}
function coerceBullionBonusPicks(raw) {
    if (Array.isArray(raw)) return raw.filter((b)=>Boolean(b) && typeof b === "object").map((b)=>{
        const tier = b.tier === "small" || b.tier === "large" ? b.tier : "large";
        // Always resolve stake from the live tier table so legacy slips stored as
        // 15/45 (pre-scale) score as 150/450 after the pts/chip raise.
        return {
            ...b,
            tier,
            points: (0, _constants.BULLION_BONUS_POINTS_BY_TIER)[tier]
        };
    });
    // Legacy single gold chip — represent as one bonus so old slips still render a bonus marker.
    if (raw && typeof raw === "object") {
        const g = raw;
        if (g.runnerId != null && g.marketId != null) return [
            {
                tier: "large",
                points: (0, _constants.BULLION_BONUS_POINTS_BY_TIER).large,
                marketId: String(g.marketId),
                runnerId: String(g.runnerId),
                groupIndex: Number(g.groupIndex ?? 0),
                decimalMarketId: g.decimalMarketId ?? null,
                decimalMarketLineId: g.decimalMarketLineId ?? null,
                marketName: g.marketName ?? null,
                selectionName: g.selectionName ?? null
            }
        ];
    }
    return [];
}
function regularChipsInGroup(selections, groupIndex, excludeMarketId) {
    return Object.entries(selections).filter(([id, s])=>s.groupIndex === groupIndex && id !== excludeMarketId).reduce((sum, [, s])=>sum + bullionSelectionRegularChips(s), 0);
}
function parseBullionPlaySelectionsFromApi(raw) {
    if (raw == null) return null;
    let s = raw;
    if (typeof s === "string") try {
        s = JSON.parse(s);
    } catch  {
        return null;
    }
    if (!s || typeof s !== "object" || Array.isArray(s)) return null;
    const obj = s;
    if (obj.picks && typeof obj.picks === "object" && !Array.isArray(obj.picks)) return {
        picks: obj.picks,
        bonusPicks: coerceBullionBonusPicks(obj.bonusPicks ?? obj.goldPick)
    };
    const bonusPicks = coerceBullionBonusPicks(obj.bonusPicks ?? obj.goldPick);
    const flat = {};
    for (const [k, v] of Object.entries(obj)){
        if (k === "goldPick" || k === "bonusPicks") continue;
        if (!v || typeof v !== "object" || Array.isArray(v)) continue;
        const p = v;
        if (p.runnerId != null && p.marketId != null) flat[k] = v;
    }
    if (Object.keys(flat).length) return {
        picks: flat,
        bonusPicks
    };
    return null;
}

},{"./constants":"fFw1z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3BWF1":[function(require,module,exports,__globalThis) {
/**
 * Mirrors backend BULLION odds resolution + line potential math (`bullionLinePotentialMath.js`,
 * `bullionSettlementFromDecimalApi.js`). Keeps board / played-view points aligned with settlement.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decimalIdsFromBullionMarketKey", ()=>decimalIdsFromBullionMarketKey);
/** True when two slip/bonus market keys refer to the same board row. */ parcelHelpers.export(exports, "bullionMarketKeyEquivalence", ()=>bullionMarketKeyEquivalence);
/**
 * Snapshot rows that share `market_id` but omit `market_line_id` on the pick: prefer an unambiguous
 * canonical line (`market_line_id === market_id`), else a single active+display row, else first in feed order.
 */ parcelHelpers.export(exports, "bullionDisambiguateDecimalMarketsWithoutLineId", ()=>bullionDisambiguateDecimalMarketsWithoutLineId);
parcelHelpers.export(exports, "oddsForBullionPick", ()=>oddsForBullionPick);
/**
 * When `liveOddsNum` is >0, that price wins (ephemeral board display). For persisted BULLION math,
 * use {@link bullionFrozenLineOddsForPlay} so stored lines do not follow the in-play ladder.
 */ parcelHelpers.export(exports, "bullionLineOddsForScoring", ()=>bullionLineOddsForScoring);
/**
 * Canonical `pick.odds` / `pick.lineOdds` from the play row (written on first snapshot resolve), else
 * `bullionLineOddsForScoring(..., 0)` — matches backend `bullionFrozenLineOddsForPlay`.
 */ parcelHelpers.export(exports, "bullionFrozenLineOddsForPlay", ()=>bullionFrozenLineOddsForPlay);
/** UI label for BULLION cells; feed from `bullionBoardLineOddsForDisplay` (snapshot first, then live row odds when snapshot misses). */ parcelHelpers.export(exports, "formatBullionBoardOddsLabel", ()=>formatBullionBoardOddsLabel);
/**
 * Board price: opening `bullion_games.odds_snapshot` + persisted pick `odds`/`lineOdds` when set; if still unresolved, `runner.odds` from the feed.
 */ parcelHelpers.export(exports, "bullionBoardLineOddsForDisplay", ()=>bullionBoardLineOddsForDisplay);
parcelHelpers.export(exports, "bullionFindSnapshotMarketForPick", ()=>bullionFindSnapshotMarketForPick);
parcelHelpers.export(exports, "bullionFindSnapshotMarketForPickLoose", ()=>bullionFindSnapshotMarketForPickLoose);
/**
 * Persisted/API picks may carry extra odds fields (`selectionOdds`, `recommended_price`, …).
 */ parcelHelpers.export(exports, "bullionPickRecordForScoring", ()=>bullionPickRecordForScoring);
/** Chip units staked on a line: `chips × pts-per-chip`. Bonus points are staked separately. */ parcelHelpers.export(exports, "bullionLineChipUnits", ()=>bullionLineChipUnits);
/**
 * Rounded line potential at decimal odds: `round(odds × (chip units + bonus))`.
 * `bonusPoints` (0 / 150 / 450) joins the stake, so a winning line pays it at the line's price.
 */ parcelHelpers.export(exports, "bullionLinePotentialFromOdds", ()=>bullionLinePotentialFromOdds);
/** Pts-per-chip for the current Bullion surface (league battle vs cash). */ parcelHelpers.export(exports, "bullionPtsPerChipForLeagueMode", ()=>bullionPtsPerChipForLeagueMode);
var _constants = require("./constants");
var _bullionCricketMarketGroups = require("./bullionCricketMarketGroups");
var _bullionOddsSnapshot = require("./bullionOddsSnapshot");
var _roomUtils = require("./roomUtils");
const BULLION_TOSS_WINNER_DECIMAL_ODDS = 2;
function isBullionTossWinnerBoardMarket(market) {
    const rawId = market.marketTypeId != null ? String(market.marketTypeId).trim() : "";
    const id = /^\d+(\.0+)?$/.test(rawId) ? String(parseInt(rawId, 10)) : rawId;
    const name = String(market.name ?? "").toLowerCase();
    return id === "815" || name.includes("toss winner");
}
function isBullionTossWinnerSnapshotMarket(sm) {
    if (!sm) return false;
    const rawId = sm.market_type_id != null ? String(sm.market_type_id).trim() : "";
    const id = /^\d+(\.0+)?$/.test(rawId) ? String(parseInt(rawId, 10)) : rawId;
    const name = String(sm.market_name ?? sm.market_type ?? sm.name ?? "").toLowerCase();
    return id === "815" || name.includes("toss winner");
}
function decimalIdsFromBullionMarketKey(marketIdOrKey) {
    const s = String(marketIdOrKey || "").trim();
    if (!s) return {
        baseMarketId: "",
        lineId: ""
    };
    if (/^\d+$/.test(s)) return {
        baseMarketId: s,
        lineId: ""
    };
    const twoNums = s.match(/^(\d+)_(\d+)$/);
    if (twoNums) {
        if (twoNums[1] === twoNums[2]) return {
            baseMarketId: twoNums[1],
            lineId: ""
        };
        return {
            baseMarketId: twoNums[1],
            lineId: twoNums[2]
        };
    }
    const midDoubleUnderscore = s.match(/^(\d+)__/);
    if (midDoubleUnderscore) return {
        baseMarketId: midDoubleUnderscore[1],
        lineId: ""
    };
    return {
        baseMarketId: "",
        lineId: ""
    };
}
function bullionMarketKeyEquivalence(a, b) {
    const sa = String(a ?? "").trim();
    const sb = String(b ?? "").trim();
    if (!sa || !sb) return false;
    if (sa === sb) return true;
    const da = decimalIdsFromBullionMarketKey(sa);
    const db = decimalIdsFromBullionMarketKey(sb);
    const plainA = /^\d+$/.test(sa) ? sa : da.baseMarketId;
    const plainB = /^\d+$/.test(sb) ? sb : db.baseMarketId;
    if (plainA && plainB && plainA === plainB) {
        if (!da.lineId || !db.lineId || da.lineId === db.lineId) return true;
    }
    if (da.baseMarketId && db.baseMarketId && da.baseMarketId === db.baseMarketId) {
        if (!da.lineId || !db.lineId || da.lineId === db.lineId) return true;
    }
    return false;
}
function safePositiveNumber(v) {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : 0;
}
function normalizeName(s) {
    return String(s || "").trim().toLowerCase().replace(/\s+/g, " ");
}
function findSnapshotMarket(oddsSnapshot, pickMarketId) {
    const arr = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(oddsSnapshot);
    for(let i = 0; i < arr.length; i++){
        const raw = arr[i];
        if (!raw || typeof raw !== "object") continue;
        const m = raw;
        if ((0, _bullionCricketMarketGroups.bullionMarketStableId)(m, i) === String(pickMarketId || "")) return raw;
    }
    return null;
}
function bullionDisambiguateDecimalMarketsWithoutLineId(candidates) {
    if (!candidates?.length) return null;
    if (candidates.length === 1) return candidates[0];
    const canonical = candidates.filter((m)=>{
        const mid = String(m.market_id ?? "").trim();
        const lid = String(m.market_line_id ?? "").trim();
        return mid !== "" && lid === mid;
    });
    if (canonical.length === 1) return canonical[0];
    const isOn = (v)=>v === 1 || v === true || String(v) === "1";
    const activeDisplayed = candidates.filter((m)=>isOn(m.active) && isOn(m.display));
    if (activeDisplayed.length === 1) return activeDisplayed[0];
    return candidates[0];
}
function findSnapshotMarketByDecimalIds(oddsSnapshot, decimalMarketId, decimalMarketLineId) {
    const arr = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(oddsSnapshot);
    const mid = decimalMarketId != null ? String(decimalMarketId) : "";
    const lid = decimalMarketLineId != null ? String(decimalMarketLineId) : "";
    if (!mid) return null;
    const byMid = arr.filter((m)=>m && typeof m === "object" && String(m.market_id ?? "") === mid);
    if (!byMid.length) return null;
    if (lid) {
        const hit = byMid.find((m)=>String(m.market_line_id ?? "") === lid);
        return hit ?? null;
    }
    return bullionDisambiguateDecimalMarketsWithoutLineId(byMid);
}
function oddsForBullionPick(snapshotMarket, pick) {
    // Toss Winner is a 50/50: prefer the frozen snapshot price (which carries the admin's fixed 2.00 or a
    // margined price), falling back to the fixed 2.00 only when the snapshot has no usable toss odds.
    const isToss = isBullionTossWinnerSnapshotMarket(snapshotMarket);
    const sm = snapshotMarket;
    const selections = Array.isArray(sm?.selectionslist) ? sm.selectionslist : Array.isArray(sm?.selections) ? sm.selections : [];
    if (!selections.length) {
        if (isToss) return BULLION_TOSS_WINNER_DECIMAL_ODDS;
        return safePositiveNumber(pick?.odds ?? pick?.selectionOdds ?? pick?.recommended_price);
    }
    const byRunnerId = selections.find((s)=>String(s.id ?? s.selection_id) === String(pick?.runnerId));
    const byRunnerIdOdds = safePositiveNumber(byRunnerId?.odds ?? byRunnerId?.recommended_price);
    if (byRunnerIdOdds > 0) return byRunnerIdOdds;
    const wantName = normalizeName(String(pick?.selectionName ?? ""));
    if (wantName) {
        const byName = selections.find((s)=>normalizeName(String(s?.name ?? "")) === wantName);
        const byNameOdds = safePositiveNumber(byName?.odds ?? byName?.recommended_price);
        if (byNameOdds > 0) return byNameOdds;
    }
    if (isToss) {
        const firstToss = safePositiveNumber(selections[0]?.odds ?? selections[0]?.recommended_price);
        if (firstToss > 0) return firstToss;
        return BULLION_TOSS_WINNER_DECIMAL_ODDS;
    }
    return safePositiveNumber(pick?.odds ?? pick?.selectionOdds ?? pick?.recommended_price);
}
function bullionLineOddsForScoring(snapshotMarket, pick, liveOddsNum) {
    const live = Number(liveOddsNum);
    const fromLive = Number.isFinite(live) && live > 0 ? live : 0;
    const fromSnap = oddsForBullionPick(snapshotMarket, pick);
    let odds = fromLive > 0 ? fromLive : fromSnap > 0 ? fromSnap : 0;
    if (odds <= 0) odds = Math.max(safePositiveNumber(pick?.odds), safePositiveNumber(pick?.selectionOdds), safePositiveNumber(pick?.recommended_price));
    return odds;
}
function bullionFrozenLineOddsForPlay(snapshotMarket, pick) {
    const fromPersist = Math.max(safePositiveNumber(pick.odds), safePositiveNumber(pick.lineOdds));
    if (fromPersist > 0) return fromPersist;
    return bullionLineOddsForScoring(snapshotMarket, pick, 0);
}
function formatBullionBoardOddsLabel(oddsNum) {
    if (Number.isFinite(oddsNum) && oddsNum > 0) return oddsNum.toFixed(2);
    return "\u2014";
}
function bullionBoardLineOddsForDisplay(oddsSnapshot, market, runner, rowSelection) {
    const isToss = isBullionTossWinnerBoardMarket(market);
    const pickKey = (0, _roomUtils.bullionSelectionStorageKey)(market);
    const sel = rowSelection && rowSelection.runnerId === runner.id ? {
        ...rowSelection,
        marketId: pickKey
    } : {
        marketId: pickKey,
        runnerId: runner.id,
        chips: 0,
        groupIndex: market.groupIndex,
        decimalMarketId: market.decimalMarketId ?? null,
        decimalMarketLineId: market.decimalMarketLineId ?? null,
        marketName: market.name ?? null,
        selectionName: runner.name ?? null
    };
    const pickRec = bullionPickRecordForScoring(sel);
    const snap = bullionFindSnapshotMarketForPickLoose(oddsSnapshot ?? null, pickRec, pickKey);
    const frozen = bullionFrozenLineOddsForPlay(snap, pickRec);
    if (frozen > 0) return frozen;
    // Toss Winner falls back to the fixed 50/50 price only when the snapshot has no frozen odds.
    if (isToss) return BULLION_TOSS_WINNER_DECIMAL_ODDS;
    // Snapshot join can miss some match lines (e.g. totals) while the live row still has Decimal odds.
    const fromRunner = Number(runner.odds);
    return Number.isFinite(fromRunner) && fromRunner > 0 ? fromRunner : 0;
}
function bullionFindSnapshotMarketForPick(oddsSnapshot, pick, pickKey) {
    const mk = pick.marketId ?? pick.market_id ?? pickKey;
    const marketIdKey = mk == null ? "" : String(mk).trim();
    if (!marketIdKey) return null;
    const fromKey = decimalIdsFromBullionMarketKey(marketIdKey);
    const numericPair = /^\d+_\d+$/.test(String(marketIdKey).trim()) && fromKey.baseMarketId && fromKey.lineId ? fromKey : null;
    const plainNumericMid = /^\d+$/.test(String(marketIdKey).trim());
    const dm = pick.decimalMarketId != null ? String(pick.decimalMarketId).trim() : "";
    const dl = pick.decimalMarketLineId != null ? String(pick.decimalMarketLineId).trim() : "";
    const snap = findSnapshotMarketByDecimalIds(oddsSnapshot, dm, dl || null) || findSnapshotMarketByDecimalIds(oddsSnapshot, fromKey.baseMarketId, fromKey.lineId || null) || (plainNumericMid ? findSnapshotMarketByDecimalIds(oddsSnapshot, String(marketIdKey).trim(), null) : null) || findSnapshotMarket(oddsSnapshot, marketIdKey);
    return snap ?? null;
}
function bullionFindSnapshotMarketForPickLoose(oddsSnapshot, pick, pickKey) {
    const tight = bullionFindSnapshotMarketForPick(oddsSnapshot, pick, pickKey);
    if (tight) return tight;
    const arr = (0, _bullionOddsSnapshot.bullionOddsSnapshotMarkets)(oddsSnapshot);
    const rid = pick?.runnerId != null ? String(pick.runnerId).trim() : "";
    if (!rid) return null;
    const marketsWithRunner = [];
    for(let i = 0; i < arr.length; i++){
        const m = arr[i];
        if (!m || typeof m !== "object") continue;
        const rec = m;
        const sels = Array.isArray(rec.selectionslist) ? rec.selectionslist : Array.isArray(rec.selections) ? rec.selections : [];
        const has = sels.some((s)=>String(s?.id ?? s?.selection_id ?? "").trim() === rid);
        if (has) marketsWithRunner.push(rec);
    }
    if (marketsWithRunner.length !== 1) {
        const wantMid = pick?.decimalMarketId != null ? String(pick.decimalMarketId).trim() : "";
        const wantLid = pick?.decimalMarketLineId != null ? String(pick.decimalMarketLineId).trim() : "";
        if (!wantMid) return null;
        const filtered = marketsWithRunner.filter((m)=>String(m.market_id ?? "") === wantMid);
        if (wantLid) {
            const byLine = filtered.filter((m)=>String(m.market_line_id ?? "") === wantLid);
            if (byLine.length === 1) return byLine[0];
            return null;
        }
        return bullionDisambiguateDecimalMarketsWithoutLineId(filtered);
    }
    return marketsWithRunner[0];
}
function bullionPickRecordForScoring(sel) {
    return {
        ...sel,
        market_id: sel.marketId,
        marketId: sel.marketId
    };
}
function bullionLineChipUnits(chipsNorm, ptsPerChip = (0, _constants.BULLION_PTS_PER_CHIP)) {
    const chips = Math.max(0, Math.round(Number(chipsNorm) || 0));
    const rate = Number.isFinite(ptsPerChip) && ptsPerChip > 0 ? ptsPerChip : (0, _constants.BULLION_PTS_PER_CHIP);
    return chips * rate;
}
function bullionLinePotentialFromOdds(odds, chipsNorm, bonusPoints = 0, ptsPerChip = (0, _constants.BULLION_PTS_PER_CHIP)) {
    const o = Number(odds);
    const bonus = Math.max(0, Math.round(Number(bonusPoints) || 0));
    if (!Number.isFinite(o) || o <= 0) return bonus;
    return Math.round(o * (bullionLineChipUnits(chipsNorm, ptsPerChip) + bonus));
}
function bullionPtsPerChipForLeagueMode(isLeagueMode) {
    return isLeagueMode ? (0, _constants.LEAGUE_BULLION_PTS_PER_CHIP) : (0, _constants.BULLION_PTS_PER_CHIP);
}

},{"./constants":"fFw1z","./bullionCricketMarketGroups":"9QsrP","./bullionOddsSnapshot":"i9JWr","./roomUtils":"8f6zP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cxx4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildCricketSyntheticPrematchRawMarkets", ()=>buildCricketSyntheticPrematchRawMarkets);
var _matchUtils = require("../../Games/matchUtils");
function buildCricketSyntheticPrematchRawMarkets(match) {
    const mid = String(match.id ?? "fixture");
    const teams = (0, _matchUtils.parseCricketMatchName)(match.name || "").teams;
    const [tA, tB] = teams.length >= 2 ? [
        teams[0],
        teams[1]
    ] : [
        "Team 1",
        "Team 2"
    ];
    const p = (suffix)=>`synth-${mid}-${suffix}`;
    const twoTeam = (suffix, typeId, mType, title, teamAOdds = 1.92, teamBOdds = 1.92)=>({
            market_id: p(suffix),
            market_type_id: typeId,
            market_type: mType,
            name: title,
            runners: [
                {
                    id: `${p(suffix)}-a`,
                    name: tA,
                    odds: teamAOdds
                },
                {
                    id: `${p(suffix)}-b`,
                    name: tB,
                    odds: teamBOdds
                }
            ]
        });
    const overUnder = (suffix, typeId, mType, title, overOdd = 1.88, underOdd = 1.92)=>({
            market_id: p(suffix),
            market_type_id: typeId,
            market_type: mType,
            name: title,
            runners: [
                {
                    id: `${p(suffix)}-over`,
                    name: "Over",
                    odds: overOdd
                },
                {
                    id: `${p(suffix)}-under`,
                    name: "Under",
                    odds: underOdd
                }
            ]
        });
    const out = [];
    // —— TEAM ——
    out.push(twoTeam("mw", "1010", "Match Winner", "Match Winner"));
    out.push(twoTeam("toss", "815", "Toss Winner", "Toss Winner", 2, 2));
    out.push(twoTeam("hfo", "50", "Highest Score in First Over", "Highest First Over"));
    out.push(twoTeam("hfs", "55", "Highest Score in First Session", "Highest First Session"));
    out.push(twoTeam("hop", "45", "Highest Opening Partnership", "Highest Opening Partnership"));
    out.push(twoTeam("fours", "30", "Most Fours", "Most Fours"));
    out.push(twoTeam("sixes", "35", "Most Sixes", "Most Sixes"));
    // —— PLAYER (BULLION: batter runs + batter sixes only) ——
    for(let i = 1; i <= 4; i++){
        const o = 1.86 + i * 0.01;
        const u = 1.96 - i * 0.01;
        out.push(overUnder(`br${i}`, "910", "Pre Match Batsman Runs", `Batter ${i} \u{2014} runs`, o, u));
    }
    for(let i = 1; i <= 4; i++){
        const o = 1.88 + i * 0.01;
        const u = 1.94 - i * 0.01;
        out.push(overUnder(`bs${i}`, "914", "Pre Match Batsman Sixes", `Batter ${i} \u{2014} sixes`, o, u));
    }
    // —— MATCH ——
    out.push(overUnder("mr", "60", "Match Total Runs", "Match Runs", 1.87, 1.95));
    out.push(overUnder("mf", "70", "Match Fours", "Match Fours", 1.9, 1.9));
    out.push(overUnder("ms", "75", "Match Sixes", "Match Sixes", 1.91, 1.89));
    out.push(overUnder("mwk", "85", "Match Wickets", "Match Wickets", 1.9, 1.9));
    out.push(overUnder("mro", "80", "Match Run Outs", "Match Run Outs", 1.92, 1.88));
    out.push(overUnder("mhro", "88", "Match Highest Runs off Over", "Match Highest Runs off Over", 1.89, 1.93));
    out.push(overUnder("mhis", "86", "Match Highest Individual Score", "Match Highest Individual Score", 1.9, 1.9));
    // —— INNINGS ——
    out.push(overUnder("ifour-a", "220", "Innings Fours", `${tA} Total Fours`, 1.9, 1.9));
    out.push(overUnder("ifour-b", "220", "Innings Fours", `${tB} Total Fours`, 1.89, 1.91));
    out.push(overUnder("isix-a", "230", "Innings Sixes", `${tA} Total Sixes`, 1.88, 1.94));
    out.push(overUnder("isix-b", "230", "Innings Sixes", `${tB} Total Sixes`, 1.9, 1.92));
    out.push(overUnder("sra", "510", "Runs in Session", `${tA} Session Runs`, 1.91, 1.91));
    out.push(overUnder("srb", "510", "Runs in Session", `${tB} Session Runs`, 1.9, 1.92));
    out.push(overUnder("fowa", "610", "Fall of Wicket", `${tA} Fall of First Wicket`, 1.89, 1.93));
    out.push(overUnder("fowb", "610", "Fall of Wicket", `${tB} Fall of First Wicket`, 1.88, 1.94));
    return out;
}

},{"../../Games/matchUtils":"9QY2j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xeIm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SQUARES_DEMO_MATCH_ENABLED", ()=>SQUARES_DEMO_MATCH_ENABLED);
parcelHelpers.export(exports, "SQUARES_DEMO_MATCH_ID", ()=>SQUARES_DEMO_MATCH_ID);
parcelHelpers.export(exports, "SQUARES_DEMO_MATCH_NAME", ()=>SQUARES_DEMO_MATCH_NAME);
parcelHelpers.export(exports, "SQUARES_DEMO_COMPETITION", ()=>SQUARES_DEMO_COMPETITION);
parcelHelpers.export(exports, "SQUARES_DEMO_MATCH_FLOW_PATH", ()=>SQUARES_DEMO_MATCH_FLOW_PATH);
parcelHelpers.export(exports, "SQUARES_DEMO_OVER_NUMBER", ()=>SQUARES_DEMO_OVER_NUMBER);
parcelHelpers.export(exports, "SQUARES_DEMO_VIEWER_USER_ID", ()=>SQUARES_DEMO_VIEWER_USER_ID);
parcelHelpers.export(exports, "SQUARES_DEMO_FORMAT", ()=>SQUARES_DEMO_FORMAT);
parcelHelpers.export(exports, "SQUARES_DEMO_MAX_OVERS", ()=>SQUARES_DEMO_MAX_OVERS);
parcelHelpers.export(exports, "SQUARES_DEMO_BALL_RESULTS", ()=>SQUARES_DEMO_BALL_RESULTS);
parcelHelpers.export(exports, "isSquaresDemoMatchId", ()=>isSquaresDemoMatchId);
parcelHelpers.export(exports, "squaresDemoViewerAvatar", ()=>squaresDemoViewerAvatar);
/** Believable 6×6 odds grid returned by the demo calculate-over-odds handler. */ parcelHelpers.export(exports, "buildSquaresDemoOddsGrid", ()=>buildSquaresDemoOddsGrid);
parcelHelpers.export(exports, "squaresDemoPoolEntrantCount", ()=>squaresDemoPoolEntrantCount);
parcelHelpers.export(exports, "squaresDemoFirstPlacePrize", ()=>squaresDemoFirstPlacePrize);
/** Guest account for trying the demo without logging in. */ parcelHelpers.export(exports, "buildSquaresDemoGuestUserAccount", ()=>buildSquaresDemoGuestUserAccount);
var _analyticsEnv = require("../../../utils/analyticsEnv");
var _profileAvatarCatalog = require("../../../utils/profileAvatarCatalog");
var _squaresConstants = require("../shared/squaresConstants");
const SQUARES_DEMO_MATCH_ENABLED = (0, _analyticsEnv.isDevEnv)();
const SQUARES_DEMO_MATCH_ID = "squares-demo-match";
const SQUARES_DEMO_MATCH_NAME = "Mumbai Indians v Chennai Super Kings";
const SQUARES_DEMO_COMPETITION = "Indian Premier League";
const SQUARES_DEMO_MATCH_FLOW_PATH = `/squares?match=${SQUARES_DEMO_MATCH_ID}`;
const SQUARES_DEMO_OVER_NUMBER = 12;
const SQUARES_DEMO_VIEWER_USER_ID = 9201;
const SQUARES_DEMO_FORMAT = 20;
const SQUARES_DEMO_MAX_OVERS = 20;
const SQUARES_DEMO_BALL_RESULTS = [
    "1",
    "4",
    "0",
    "W",
    "2",
    "6"
];
const AVATAR = (0, _profileAvatarCatalog.FALLBACK_AVATAR_OPTIONS).map((item)=>(0, _profileAvatarCatalog.getAvatarThumbSrc)(item) || item.url || null);
function isSquaresDemoMatchId(matchId) {
    const id = String(matchId || "").trim();
    if (id === "proto-ind-wi") return true;
    if (!SQUARES_DEMO_MATCH_ENABLED) return false;
    return id === SQUARES_DEMO_MATCH_ID;
}
function squaresDemoViewerAvatar() {
    return AVATAR[4] || "";
}
function buildSquaresDemoOddsGrid() {
    const RUN_LABELS = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5+"
    ];
    const base = [
        [
            5.4,
            4.8,
            4.2,
            5.1,
            6.2,
            7.0
        ],
        [
            3.6,
            3.2,
            3.0,
            3.4,
            3.9,
            4.4
        ],
        [
            3.1,
            2.8,
            2.6,
            2.9,
            3.2,
            3.6
        ],
        [
            3.8,
            3.4,
            3.1,
            3.5,
            4.0,
            4.6
        ],
        [
            4.6,
            4.1,
            3.7,
            4.2,
            4.8,
            5.4
        ],
        [
            6.2,
            5.6,
            5.0,
            5.8,
            6.6,
            7.4
        ]
    ];
    const cells = {};
    RUN_LABELS.forEach((runLabel, row)=>{
        cells[runLabel] = {};
        for(let ball = 1; ball <= 6; ball += 1){
            const odds = base[row]?.[ball - 1];
            cells[runLabel][ball] = odds != null ? odds.toFixed(2) : "3.00";
        }
    });
    return {
        cells,
        hasAnyOdds: true
    };
}
function squaresDemoPoolEntrantCount(playCount) {
    return Math.max(4, playCount ?? 11);
}
function squaresDemoFirstPlacePrize() {
    const n = squaresDemoPoolEntrantCount();
    const rake = n <= 6 ? 0.05 : 0.1;
    const share = 0.5;
    return Math.round(n * (0, _squaresConstants.SQUARES_ENTRANCE_FEE) * (1 - rake) * share);
}
function buildSquaresDemoGuestUserAccount() {
    return {
        id: String(SQUARES_DEMO_VIEWER_USER_ID),
        username: "Demo Player",
        player_name: "You",
        avatar: squaresDemoViewerAvatar(),
        wallet: {
            coins: "10000",
            rubies: "0"
        }
    };
}

},{"../../../utils/analyticsEnv":"4mdbs","../../../utils/profileAvatarCatalog":"i8TvT","../shared/squaresConstants":"9tbpY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9tbpY":[function(require,module,exports,__globalThis) {
/**
 * Squares game constants used in the frontend (must match backend squares-constants when relevant).
 */ /** Coins charged per over when user enters a square (entry fee). */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SQUARES_CURRENT_BALL_RESULT_DOT_BASE_CLASS", ()=>(0, _ballInProgressDotStyles.BALL_IN_PROGRESS_DOT_BASE_CLASS));
parcelHelpers.export(exports, "SQUARES_CURRENT_BALL_RESULT_DOT_OPACITY_CLASSES", ()=>(0, _ballInProgressDotStyles.BALL_IN_PROGRESS_DOT_OPACITY_CLASSES));
parcelHelpers.export(exports, "SQUARES_CURRENT_BALL_RESULT_DOT_DELAYS_MS", ()=>(0, _ballInProgressDotStyles.BALL_IN_PROGRESS_DOT_DELAYS_MS));
parcelHelpers.export(exports, "SQUARES_ENTRANCE_FEE", ()=>SQUARES_ENTRANCE_FEE);
/**
 * House rake by pool size (same curve as backend `rakeForEntrantCount`).
 * @param {number} n
 * @returns {number}
 */ parcelHelpers.export(exports, "rakeForEntrantCount", ()=>rakeForEntrantCount);
/**
 * First / second / third share of the post-rake pool (must sum to 1). Same as backend `prizeSharesForEntrantCount`.
 * @param {number} n
 * @returns {[number, number, number]}
 */ parcelHelpers.export(exports, "prizeSharesForEntrantCount", ()=>prizeSharesForEntrantCount);
/**
 * Total post-rake prize pool in coins for a given pool entrant count (same formula as settlement previews).
 * @param {number|null|undefined} poolEntrantCount — `pool_entrant_count` / `squares_pool_entrant_count`
 * @returns {number|null}
 */ parcelHelpers.export(exports, "computeSquaresTotalPrizePoolCoins", ()=>computeSquaresTotalPrizePoolCoins);
/**
 * First-place (top) prize in coins: post-rake pool × 1st-place share. Same as backend `computeTopPrizeFirstPlaceFromN`.
 * @param {number|null|undefined} poolEntrantCount
 * @returns {number|null}
 */ parcelHelpers.export(exports, "computeSquaresTopPrizeFirstPlaceCoins", ()=>computeSquaresTopPrizeFirstPlaceCoins);
parcelHelpers.export(exports, "SQUARES_LOBBY_MATCH_CARD_RIGHT_TEXT_CLASS", ()=>SQUARES_LOBBY_MATCH_CARD_RIGHT_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_MATCH_PLAY_STATUS_TEXT_CLASS", ()=>SQUARES_MATCH_PLAY_STATUS_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_HEADER_STATUS_TEXT_CLASS", ()=>SQUARES_OVER_HEADER_STATUS_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_HEADER_GAME_STATUS_TEXT_CLASS", ()=>SQUARES_OVER_HEADER_GAME_STATUS_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_HEADER_GAME_STATUS_INSET_CLASS", ()=>SQUARES_OVER_HEADER_GAME_STATUS_INSET_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_HEADER_META_TEXT_CLASS", ()=>SQUARES_OVER_HEADER_META_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_HEADER_META_TEXT_RIGHT_CLASS", ()=>SQUARES_OVER_HEADER_META_TEXT_RIGHT_CLASS);
parcelHelpers.export(exports, "SQUARES_SECTION_TAB_GROUP_CLASS", ()=>SQUARES_SECTION_TAB_GROUP_CLASS);
parcelHelpers.export(exports, "SQUARES_SECTION_TAB_BUTTON_BASE_CLASS", ()=>SQUARES_SECTION_TAB_BUTTON_BASE_CLASS);
/** @param {boolean} isSelected */ parcelHelpers.export(exports, "squaresSectionTabButtonClass", ()=>squaresSectionTabButtonClass);
parcelHelpers.export(exports, "SQUARES_INPLAY_BALL_NUMBER_BADGE_CLASS", ()=>SQUARES_INPLAY_BALL_NUMBER_BADGE_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_BALL_RESULT_CELL_CLASS", ()=>SQUARES_OVER_BALL_RESULT_CELL_CLASS);
parcelHelpers.export(exports, "SQUARES_CURRENT_BALL_RESULT_CELL_CLASS", ()=>SQUARES_CURRENT_BALL_RESULT_CELL_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_INPLAY_WAITING_CELL_CLASS", ()=>SQUARES_LEADERBOARD_INPLAY_WAITING_CELL_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_RANK_TEXT_CLASS", ()=>SQUARES_LEADERBOARD_RANK_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_RANK_COL_WIDTH_CLASS", ()=>SQUARES_LEADERBOARD_RANK_COL_WIDTH_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_PLAYER_NAME_TEXT_CLASS", ()=>SQUARES_LEADERBOARD_PLAYER_NAME_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_INPLAY_AVATAR_SIZE_CLASS", ()=>SQUARES_LEADERBOARD_INPLAY_AVATAR_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_INPLAY_PICK_CELL_SIZE_CLASS", ()=>SQUARES_LEADERBOARD_INPLAY_PICK_CELL_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_PLAYER_NAME_OFFSET_CLASS", ()=>SQUARES_LEADERBOARD_PLAYER_NAME_OFFSET_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_PLAYER_NAME_FINISHED_OFFSET_CLASS", ()=>SQUARES_LEADERBOARD_PLAYER_NAME_FINISHED_OFFSET_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_INPLAY_ROW_GRID_COLS", ()=>SQUARES_LEADERBOARD_INPLAY_ROW_GRID_COLS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_WINNERS_ROW_GRID_COLS", ()=>SQUARES_LEADERBOARD_WINNERS_ROW_GRID_COLS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_BALLS_COL_CLASS", ()=>SQUARES_LEADERBOARD_BALLS_COL_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_BALLS_COL_WINNERS_CLASS", ()=>SQUARES_LEADERBOARD_BALLS_COL_WINNERS_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_CHIPS_COL_INPLAY_CLASS", ()=>SQUARES_LEADERBOARD_CHIPS_COL_INPLAY_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_SCORE_TEXT_CLASS", ()=>SQUARES_LEADERBOARD_SCORE_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_CHIP_ICON_SIZE_CLASS", ()=>SQUARES_LEADERBOARD_CHIP_ICON_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_ROW_CHEVRON_SIZE_CLASS", ()=>SQUARES_LEADERBOARD_ROW_CHEVRON_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_ROW_CHEVRON_BUTTON_CLASS", ()=>SQUARES_LEADERBOARD_ROW_CHEVRON_BUTTON_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_CHIPS_COL_WINNERS_CLASS", ()=>SQUARES_LEADERBOARD_CHIPS_COL_WINNERS_CLASS);
parcelHelpers.export(exports, "SQUARES_IN_GAME_BANNER_CLASS", ()=>SQUARES_IN_GAME_BANNER_CLASS);
parcelHelpers.export(exports, "SQUARES_IN_GAME_BANNER_COMPACT_CLASS", ()=>SQUARES_IN_GAME_BANNER_COMPACT_CLASS);
parcelHelpers.export(exports, "SQUARES_IN_GAME_PANEL_CLASS", ()=>SQUARES_IN_GAME_PANEL_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_ODDS_BAR_HEIGHT_CLASS", ()=>SQUARES_OVER_ODDS_BAR_HEIGHT_CLASS);
parcelHelpers.export(exports, "SQUARES_INPLAY_OVER_HEADER_HEIGHT_CLASS", ()=>SQUARES_INPLAY_OVER_HEADER_HEIGHT_CLASS);
parcelHelpers.export(exports, "SQUARES_INPLAY_BALL_STRIP_HEIGHT_CLASS", ()=>SQUARES_INPLAY_BALL_STRIP_HEIGHT_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_INPLAY_ROW_HEIGHT_CLASS", ()=>SQUARES_LEADERBOARD_INPLAY_ROW_HEIGHT_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_INPLAY_ROW_LAYOUT_CLASS", ()=>SQUARES_LEADERBOARD_INPLAY_ROW_LAYOUT_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_INPLAY_LIST_CLASS", ()=>SQUARES_LEADERBOARD_INPLAY_LIST_CLASS);
parcelHelpers.export(exports, "SQUARES_LEADERBOARD_INPLAY_OUTER_CLASS", ()=>SQUARES_LEADERBOARD_INPLAY_OUTER_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_ODDS_PILL_CLASS", ()=>SQUARES_OVER_ODDS_PILL_CLASS);
parcelHelpers.export(exports, "SQUARES_INPLAY_OVER_PILL_CLASS", ()=>SQUARES_INPLAY_OVER_PILL_CLASS);
parcelHelpers.export(exports, "SQUARES_IN_GAME_OVER_CARD_HEIGHT_CLASS", ()=>SQUARES_IN_GAME_OVER_CARD_HEIGHT_CLASS);
parcelHelpers.export(exports, "SQUARES_IN_GAME_OVER_BODY_HEIGHT_CLASS", ()=>SQUARES_IN_GAME_OVER_BODY_HEIGHT_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_SECTION_COLLAPSE_GRID_CLASS", ()=>SQUARES_OVER_SECTION_COLLAPSE_GRID_CLASS);
parcelHelpers.export(exports, "SQUARES_OVER_SECTION_COLLAPSE_INNER_CLASS", ()=>SQUARES_OVER_SECTION_COLLAPSE_INNER_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_CELL_GAP_PX", ()=>SQUARES_ODDS_GRID_CELL_GAP_PX);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_TABLE_WIDTH_CLASS", ()=>SQUARES_ODDS_GRID_TABLE_WIDTH_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_TABLE_MIN_WIDTH_CLASS", ()=>SQUARES_ODDS_GRID_TABLE_MIN_WIDTH_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_MAX_WIDTH_CLASS", ()=>SQUARES_ODDS_GRID_MAX_WIDTH_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_CELL_LG_FLUID_WIDTH_CLASS", ()=>SQUARES_ODDS_GRID_CELL_LG_FLUID_WIDTH_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_BODY_CELL_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_BODY_CELL_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_BODY_CELL_FLUID_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_BODY_CELL_FLUID_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_HEADER_CELL_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_HEADER_CELL_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_HEADER_CELL_FLUID_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_HEADER_CELL_FLUID_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_TABLE_FLUID_DESKTOP_CLASS", ()=>SQUARES_ODDS_GRID_TABLE_FLUID_DESKTOP_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_BODY_CELL_COMPACT_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_BODY_CELL_COMPACT_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_HEADER_CELL_COMPACT_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_HEADER_CELL_COMPACT_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_TABLE_COMPACT_WIDTH_CLASS", ()=>SQUARES_ODDS_GRID_TABLE_COMPACT_WIDTH_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_COMPACT_MAX_WIDTH_CLASS", ()=>SQUARES_ODDS_GRID_COMPACT_MAX_WIDTH_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_BODY_CELL_COMPACT_INNER_CLASS", ()=>SQUARES_ODDS_GRID_BODY_CELL_COMPACT_INNER_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_HEADER_CELL_COMPACT_INNER_CLASS", ()=>SQUARES_ODDS_GRID_HEADER_CELL_COMPACT_INNER_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_ODDS_CELL_COMPACT_INNER_CLASS", ()=>SQUARES_ODDS_GRID_ODDS_CELL_COMPACT_INNER_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_COMPACT_CHIP_POOL_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_COMPACT_CHIP_POOL_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_COMPACT_CHIP_POOL_ICON_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_COMPACT_CHIP_POOL_ICON_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_COMPACT_BALL_HEADER_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_COMPACT_BALL_HEADER_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_COMPACT_RUN_LABEL_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_COMPACT_RUN_LABEL_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_COMPACT_SELECTED_CHIP_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_COMPACT_SELECTED_CHIP_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_COMPACT_SELECTED_CHIP_ICON_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_COMPACT_SELECTED_CHIP_ICON_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_COMPACT_ODDS_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_COMPACT_ODDS_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_BODY_CELL_INNER_CLASS", ()=>SQUARES_ODDS_GRID_BODY_CELL_INNER_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_HEADER_CELL_INNER_CLASS", ()=>SQUARES_ODDS_GRID_HEADER_CELL_INNER_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_ODDS_CELL_INNER_CLASS", ()=>SQUARES_ODDS_GRID_ODDS_CELL_INNER_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_CHIP_POOL_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_CHIP_POOL_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_LEAGUE_CHIP_POOL_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_LEAGUE_CHIP_POOL_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_COMPACT_LEAGUE_CHIP_POOL_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_COMPACT_LEAGUE_CHIP_POOL_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_CHIP_POOL_ICON_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_CHIP_POOL_ICON_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_BALL_HEADER_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_BALL_HEADER_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_RUN_LABEL_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_RUN_LABEL_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_SELECTED_CHIP_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_SELECTED_CHIP_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_SELECTED_CHIP_ICON_SIZE_CLASS", ()=>SQUARES_ODDS_GRID_SELECTED_CHIP_ICON_SIZE_CLASS);
parcelHelpers.export(exports, "SQUARES_ODDS_GRID_ODDS_TEXT_CLASS", ()=>SQUARES_ODDS_GRID_ODDS_TEXT_CLASS);
parcelHelpers.export(exports, "SQUARES_MATCH_PLAY_PAGE_BG_CLASS", ()=>SQUARES_MATCH_PLAY_PAGE_BG_CLASS);
parcelHelpers.export(exports, "SQUARES_MATCH_PLAY_PAGE_BG_STYLE", ()=>SQUARES_MATCH_PLAY_PAGE_BG_STYLE);
/**
 * Lobby kill switch: set env `SQUARES_LOBBY_ENABLED=false` (or `0` / `off`) to hide matches and show empty state.
 * Omit or any other value = lobby on (default).
 */ parcelHelpers.export(exports, "isSquaresLobbyEnabled", ()=>isSquaresLobbyEnabled);
parcelHelpers.export(exports, "SQUARES_TEST_FORMAT_CODE", ()=>SQUARES_TEST_FORMAT_CODE);
parcelHelpers.export(exports, "SQUARES_HUNDRED_FORMAT_CODE", ()=>SQUARES_HUNDRED_FORMAT_CODE);
var _ballInProgressDotStyles = require("../../Cricket/ballInProgressDotStyles");
const SQUARES_ENTRANCE_FEE = 200;
function rakeForEntrantCount(n) {
    const k = Math.floor(Number(n));
    if (!Number.isFinite(k) || k < 1) return 0.1;
    if (k === 4) return 0.03;
    if (k <= 6) return 0.05;
    return 0.1;
}
function prizeSharesForEntrantCount(n) {
    const k = Math.floor(Number(n));
    if (k === 4) return [
        0.42,
        0.31,
        0.27
    ];
    if (k === 5) return [
        0.46,
        0.31,
        0.23
    ];
    return [
        0.5,
        0.3,
        0.2
    ];
}
function computeSquaresTotalPrizePoolCoins(poolEntrantCount) {
    const nk = Math.floor(Number(poolEntrantCount));
    if (!Number.isFinite(nk) || nk <= 0) return null;
    const rake = rakeForEntrantCount(nk);
    return Math.round(nk * SQUARES_ENTRANCE_FEE * (1 - rake));
}
function computeSquaresTopPrizeFirstPlaceCoins(poolEntrantCount) {
    const nk = Math.floor(Number(poolEntrantCount));
    if (!Number.isFinite(nk) || nk <= 0) return null;
    const rake = rakeForEntrantCount(nk);
    const shares = prizeSharesForEntrantCount(nk);
    const totalPrizePool = nk * SQUARES_ENTRANCE_FEE * (1 - rake);
    const share = shares[0] != null ? Number(shares[0]) : 0.5;
    return Math.round(totalPrizePool * share);
}
const SQUARES_LOBBY_MATCH_CARD_RIGHT_TEXT_CLASS = "normal-case font-chakra text-[12px] !font-bold not-italic leading-[100%] tracking-[0] text-right align-middle [leading-trim:none]";
const SQUARES_MATCH_PLAY_STATUS_TEXT_CLASS = "align-middle font-chakra text-[10px] font-normal not-italic leading-[100%] tracking-[0%] [leading-trim:none]";
const SQUARES_OVER_HEADER_STATUS_TEXT_CLASS = "font-anton font-normal not-italic text-[12px] leading-[12px] uppercase tracking-[0%] [leading-trim:none]";
const SQUARES_OVER_HEADER_GAME_STATUS_TEXT_CLASS = "font-anton text-[12px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-left text-[#D2FF00] [leading-trim:none] lg:text-[20px] lg:leading-[20px]";
const SQUARES_OVER_HEADER_GAME_STATUS_INSET_CLASS = "pl-1.5 sm:pl-2";
const SQUARES_OVER_HEADER_META_TEXT_CLASS = "font-anton font-normal not-italic uppercase leading-[12px] tracking-[0%] [leading-trim:none] text-[12px] lg:text-[20px] lg:leading-[12px]";
const SQUARES_OVER_HEADER_META_TEXT_RIGHT_CLASS = `${SQUARES_OVER_HEADER_META_TEXT_CLASS} text-right text-white`;
const SQUARES_SECTION_TAB_GROUP_CLASS = "flex min-h-0 min-w-0 items-center gap-0";
const SQUARES_SECTION_TAB_BUTTON_BASE_CLASS = "box-border flex h-[30px] shrink-0 items-center justify-center rounded-none border-0 font-anton text-[12px] font-normal not-italic uppercase leading-[20px] tracking-[0%] [leading-trim:none] transition-colors";
function squaresSectionTabButtonClass(isSelected) {
    return isSelected ? `${SQUARES_SECTION_TAB_BUTTON_BASE_CLASS} bg-white text-[#1B062F]` : `${SQUARES_SECTION_TAB_BUTTON_BASE_CLASS} bg-white/15 text-white hover:bg-white/25`;
}
const SQUARES_INPLAY_BALL_NUMBER_BADGE_CLASS = "box-border flex h-[18px] w-[35px] shrink-0 flex-row items-center justify-center rounded-none bg-white font-anton text-[10px] font-normal not-italic uppercase leading-[10px] tracking-[0%] text-[#1B062F] [leading-trim:none] md:h-[33px] md:w-[60px] md:min-h-[33px] md:max-h-[33px] md:min-w-[60px] md:max-w-[60px]";
const SQUARES_OVER_BALL_RESULT_CELL_CLASS = "box-border border-2 border-solid border-transparent bg-[#642CAD] text-white";
const SQUARES_CURRENT_BALL_RESULT_CELL_CLASS = "box-border border-2 border-solid border-white bg-[#F73261] text-white";
const SQUARES_LEADERBOARD_INPLAY_WAITING_CELL_CLASS = "box-border border-2 border-[#D2FF00] bg-[#6333A3] text-white/70";
const SQUARES_LEADERBOARD_RANK_TEXT_CLASS = "flex min-w-[12px] shrink-0 items-center justify-center align-middle text-center font-anton text-[12px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-white tabular-nums [leading-trim:none] lg:text-[20px] lg:leading-[12px]";
const SQUARES_LEADERBOARD_RANK_COL_WIDTH_CLASS = "w-[26px] min-w-[26px] max-w-[26px]";
const SQUARES_LEADERBOARD_PLAYER_NAME_TEXT_CLASS = "min-w-0 truncate align-middle text-left font-anton text-[10px] font-normal not-italic uppercase leading-[22px] tracking-[0%] text-white [leading-trim:none] lg:text-[16px] lg:leading-[22px]";
const SQUARES_LEADERBOARD_INPLAY_AVATAR_SIZE_CLASS = "h-6 w-6 shrink-0 lg:h-[44px] lg:w-[44px]";
const SQUARES_LEADERBOARD_INPLAY_PICK_CELL_SIZE_CLASS = "h-[22px] w-[23px] lg:h-[40px] lg:w-[42px]";
const SQUARES_LEADERBOARD_PLAYER_NAME_OFFSET_CLASS = "-ml-1 sm:-ml-1.5 lg:ml-0 lg:pl-2";
const SQUARES_LEADERBOARD_PLAYER_NAME_FINISHED_OFFSET_CLASS = "pl-1 sm:pl-1.5 lg:pl-3";
const SQUARES_LEADERBOARD_INPLAY_ROW_GRID_COLS = "grid-cols-[26px_24px_minmax(0,1fr)_143px_86px] lg:grid-cols-[26px_44px_minmax(0,1fr)_257px_150px]";
const SQUARES_LEADERBOARD_WINNERS_ROW_GRID_COLS = "grid-cols-[auto_minmax(0,1fr)_143px_96px]";
const SQUARES_LEADERBOARD_BALLS_COL_CLASS = "col-start-4 box-border flex w-[143px] min-w-[143px] max-w-[143px] shrink-0 justify-end gap-px lg:w-[257px] lg:min-w-[257px] lg:max-w-[257px]";
const SQUARES_LEADERBOARD_BALLS_COL_WINNERS_CLASS = "col-start-3 box-border flex w-[143px] min-w-[143px] max-w-[143px] shrink-0 justify-end gap-px";
const SQUARES_LEADERBOARD_CHIPS_COL_INPLAY_CLASS = "col-start-5 box-border flex w-[86px] min-w-[86px] max-w-[86px] shrink-0 items-center justify-end gap-1.5 lg:w-[150px] lg:min-w-[150px] lg:max-w-[150px] lg:gap-2.5";
const SQUARES_LEADERBOARD_SCORE_TEXT_CLASS = "mr-0.5 whitespace-nowrap text-right align-middle font-anton text-[12px] font-normal not-italic leading-[100%] tracking-[0%] text-white tabular-nums [leading-trim:none] lg:mr-2 lg:text-[20px]";
const SQUARES_LEADERBOARD_CHIP_ICON_SIZE_CLASS = "h-5 w-5 shrink-0 object-contain lg:h-[36.5px] lg:w-[36.5px]";
const SQUARES_LEADERBOARD_ROW_CHEVRON_SIZE_CLASS = "h-[18px] w-[18px] shrink-0 object-contain lg:h-[29px] lg:w-[29px]";
const SQUARES_LEADERBOARD_ROW_CHEVRON_BUTTON_CLASS = "group flex shrink-0 rounded-none border-0 bg-transparent p-0 outline-none ring-0 transition-colors focus-visible:ring-2 focus-visible:ring-[#D2FF00]/80 lg:mr-2";
const SQUARES_LEADERBOARD_CHIPS_COL_WINNERS_CLASS = "col-start-4 box-border flex w-[96px] min-w-[96px] max-w-[96px] shrink-0 flex-row items-center justify-end gap-1 sm:gap-1.5";
const SQUARES_IN_GAME_BANNER_CLASS = "box-border flex h-[40px] min-h-[40px] max-h-[40px] w-full shrink-0 items-center justify-center bg-lime font-anton text-[12px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-center text-main [leading-trim:none]";
const SQUARES_IN_GAME_BANNER_COMPACT_CLASS = "box-border flex h-[28px] min-h-[28px] max-h-[28px] w-full shrink-0 items-center justify-center bg-lime font-anton text-[11px] font-normal not-italic uppercase leading-[11px] tracking-[0%] text-center text-main [leading-trim:none]";
const SQUARES_IN_GAME_PANEL_CLASS = "flex min-h-0 flex-1 flex-col items-center justify-center gap-4 overflow-y-auto bg-[linear-gradient(to_right,#4e2384,#4d287a)] px-3 py-3 text-center sm:gap-5 sm:px-4 sm:py-4";
const SQUARES_OVER_ODDS_BAR_HEIGHT_CLASS = "h-[55px] min-h-[55px] max-h-[55px]";
const SQUARES_INPLAY_OVER_HEADER_HEIGHT_CLASS = SQUARES_OVER_ODDS_BAR_HEIGHT_CLASS;
const SQUARES_INPLAY_BALL_STRIP_HEIGHT_CLASS = "h-[40px] min-h-[40px] md:h-[73px] md:min-h-[73px] md:max-h-[73px]";
const SQUARES_LEADERBOARD_INPLAY_ROW_HEIGHT_CLASS = "lg:h-[73px] lg:min-h-[73px] lg:max-h-[73px]";
const SQUARES_LEADERBOARD_INPLAY_ROW_LAYOUT_CLASS = "box-border w-full overflow-visible py-1.5 pl-1 pr-1.5 sm:py-2 sm:pl-1.5 sm:pr-2 md:py-0 md:pl-0 md:pr-0";
const SQUARES_LEADERBOARD_INPLAY_LIST_CLASS = "box-border flex w-full flex-col gap-px overflow-x-visible overflow-y-visible border-2 border-[#D2FF00] bg-[#652dae] md:border-0";
const SQUARES_LEADERBOARD_INPLAY_OUTER_CLASS = "mx-auto w-full max-w-[520px] overflow-visible px-1 pt-3 sm:max-w-[560px] sm:pt-4 md:max-w-none md:px-0 md:pt-0";
const SQUARES_OVER_ODDS_PILL_CLASS = "box-border flex h-[55px] w-[50px] min-w-[50px] max-w-[50px] shrink-0 items-center justify-center rounded-none bg-[#D2FF00] p-0 font-anton text-[11px] font-normal uppercase leading-none tracking-[0%] text-[#1B062F] [leading-trim:none] sm:text-[12px]";
const SQUARES_INPLAY_OVER_PILL_CLASS = SQUARES_OVER_ODDS_PILL_CLASS;
const SQUARES_IN_GAME_OVER_CARD_HEIGHT_CLASS = "h-[261px] min-h-[261px] max-h-[261px]";
const SQUARES_IN_GAME_OVER_BODY_HEIGHT_CLASS = "h-[206px] min-h-[206px] max-h-[206px]";
const SQUARES_OVER_SECTION_COLLAPSE_GRID_CLASS = "grid overflow-hidden transition-[grid-template-rows] duration-[560ms] ease-[cubic-bezier(0.22,1,0.36,1)]";
const SQUARES_OVER_SECTION_COLLAPSE_INNER_CLASS = "min-h-0 transition-opacity duration-[560ms] ease-[cubic-bezier(0.22,1,0.36,1)]";
const SQUARES_ODDS_GRID_CELL_GAP_PX = 2;
const SQUARES_ODDS_GRID_TABLE_WIDTH_CLASS = "w-[362px] lg:w-[621px]";
const SQUARES_ODDS_GRID_TABLE_MIN_WIDTH_CLASS = "min-w-[362px] lg:min-w-[621px]";
const SQUARES_ODDS_GRID_MAX_WIDTH_CLASS = "max-w-[362px] lg:max-w-[621px]";
const SQUARES_ODDS_GRID_CELL_LG_HEIGHT_CLASS = "lg:h-[87px] lg:min-h-[87px] lg:max-h-[87px]";
const SQUARES_ODDS_GRID_CELL_LG_WIDTH_CLASS = "lg:w-[87px] lg:min-w-[87px] lg:max-w-[87px]";
const SQUARES_ODDS_GRID_CELL_LG_FLUID_WIDTH_CLASS = "lg:w-auto lg:min-w-0 lg:max-w-none";
const SQUARES_ODDS_GRID_HEADER_CELL_LG_HEIGHT_CLASS = "lg:h-[55.59px] lg:min-h-[55.59px] lg:max-h-[55.59px]";
const SQUARES_ODDS_GRID_BODY_CELL_SIZE_CLASS = `box-border h-[47px] min-h-[47px] max-h-[47px] w-[50px] min-w-[50px] max-w-[50px] border-0 p-0 align-middle ${SQUARES_ODDS_GRID_CELL_LG_HEIGHT_CLASS} ${SQUARES_ODDS_GRID_CELL_LG_WIDTH_CLASS}`;
const SQUARES_ODDS_GRID_BODY_CELL_FLUID_SIZE_CLASS = `box-border h-[47px] min-h-[47px] max-h-[47px] w-[50px] min-w-[50px] max-w-[50px] border-0 p-0 align-middle ${SQUARES_ODDS_GRID_CELL_LG_HEIGHT_CLASS} ${SQUARES_ODDS_GRID_CELL_LG_FLUID_WIDTH_CLASS}`;
const SQUARES_ODDS_GRID_HEADER_CELL_SIZE_CLASS = `box-border h-[55px] min-h-[55px] max-h-[55px] w-[50px] min-w-[50px] max-w-[50px] border-0 p-0 align-middle ${SQUARES_ODDS_GRID_HEADER_CELL_LG_HEIGHT_CLASS} ${SQUARES_ODDS_GRID_CELL_LG_WIDTH_CLASS}`;
const SQUARES_ODDS_GRID_HEADER_CELL_FLUID_SIZE_CLASS = `box-border h-[55px] min-h-[55px] max-h-[55px] w-[50px] min-w-[50px] max-w-[50px] border-0 p-0 align-middle ${SQUARES_ODDS_GRID_HEADER_CELL_LG_HEIGHT_CLASS} ${SQUARES_ODDS_GRID_CELL_LG_FLUID_WIDTH_CLASS}`;
const SQUARES_ODDS_GRID_TABLE_FLUID_DESKTOP_CLASS = "w-full min-w-[362px] max-w-none lg:min-w-0";
const SQUARES_ODDS_GRID_BODY_CELL_COMPACT_SIZE_CLASS = "box-border h-[28px] min-h-[28px] max-h-[28px] w-auto min-w-0 border-0 p-0 align-middle";
const SQUARES_ODDS_GRID_HEADER_CELL_COMPACT_SIZE_CLASS = "box-border h-[32px] min-h-[32px] max-h-[32px] w-auto min-w-0 border-0 p-0 align-middle";
const SQUARES_ODDS_GRID_TABLE_COMPACT_WIDTH_CLASS = "w-full min-w-0 max-w-none";
const SQUARES_ODDS_GRID_COMPACT_MAX_WIDTH_CLASS = "w-full max-w-none";
const SQUARES_ODDS_GRID_BODY_CELL_COMPACT_INNER_CLASS = "flex h-[28px] w-full flex-row items-center justify-center";
const SQUARES_ODDS_GRID_HEADER_CELL_COMPACT_INNER_CLASS = "flex h-[32px] w-full flex-row items-center justify-center";
const SQUARES_ODDS_GRID_ODDS_CELL_COMPACT_INNER_CLASS = "relative box-border flex h-[28px] w-full flex-col items-center justify-center";
const SQUARES_ODDS_GRID_COMPACT_CHIP_POOL_TEXT_CLASS = "font-anton text-[10px] font-normal not-italic uppercase leading-none tracking-[0%] text-white tabular-nums [leading-trim:none]";
const SQUARES_ODDS_GRID_COMPACT_CHIP_POOL_ICON_SIZE_CLASS = "h-3.5 w-3.5 shrink-0 object-contain";
const SQUARES_ODDS_GRID_COMPACT_BALL_HEADER_TEXT_CLASS = "text-center font-anton text-[9px] font-normal not-italic uppercase leading-none tracking-[0%] text-white [leading-trim:none]";
const SQUARES_ODDS_GRID_COMPACT_RUN_LABEL_TEXT_CLASS = "text-center font-anton text-[8px] font-normal not-italic uppercase leading-none tracking-[0%] text-white [leading-trim:none]";
const SQUARES_ODDS_GRID_COMPACT_SELECTED_CHIP_TEXT_CLASS = "font-anton text-[9px] font-normal not-italic leading-none tracking-[0%] text-center text-[#1B062F] [leading-trim:none]";
const SQUARES_ODDS_GRID_COMPACT_SELECTED_CHIP_ICON_SIZE_CLASS = "h-2.5 w-2.5 shrink-0 object-contain";
const SQUARES_ODDS_GRID_COMPACT_ODDS_TEXT_CLASS = "font-chakra text-[9px] font-normal not-italic leading-none tracking-[0%] text-center [leading-trim:none]";
const SQUARES_ODDS_GRID_BODY_CELL_INNER_CLASS = "flex h-[47px] w-full flex-row items-center justify-center lg:h-[87px]";
const SQUARES_ODDS_GRID_HEADER_CELL_INNER_CLASS = "flex h-[55px] w-full flex-row items-center justify-center lg:h-[55.59px] lg:min-h-[55.59px] lg:max-h-[55.59px]";
const SQUARES_ODDS_GRID_ODDS_CELL_INNER_CLASS = "relative box-border flex h-[47px] w-full flex-col items-center justify-center lg:h-[87px]";
const SQUARES_ODDS_GRID_CHIP_POOL_TEXT_CLASS = "font-anton text-[10px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-white tabular-nums [leading-trim:none] lg:text-[20px] lg:leading-[12px]";
const SQUARES_ODDS_GRID_LEAGUE_CHIP_POOL_TEXT_CLASS = "font-anton text-[10px] font-normal not-italic uppercase leading-[11px] tracking-[0%] text-white tabular-nums [leading-trim:none] lg:text-[14px] lg:leading-[14px]";
const SQUARES_ODDS_GRID_COMPACT_LEAGUE_CHIP_POOL_TEXT_CLASS = "font-anton text-[10px] font-normal not-italic uppercase leading-none tracking-[0%] text-white tabular-nums [leading-trim:none]";
const SQUARES_ODDS_GRID_CHIP_POOL_ICON_SIZE_CLASS = "h-[15.8px] w-[15.8px] shrink-0 object-contain lg:h-[33px] lg:w-[33px]";
const SQUARES_ODDS_GRID_BALL_HEADER_TEXT_CLASS = "text-center font-anton text-[11px] font-normal not-italic uppercase leading-none tracking-[0%] text-white [leading-trim:none] lg:text-[20px] lg:leading-[15px]";
const SQUARES_ODDS_GRID_RUN_LABEL_TEXT_CLASS = "text-center font-anton text-[11px] font-normal not-italic uppercase leading-none tracking-[0%] text-white [leading-trim:none] lg:text-[20px] lg:leading-[15px]";
const SQUARES_ODDS_GRID_SELECTED_CHIP_TEXT_CLASS = "font-anton text-[12px] font-normal not-italic leading-[100%] tracking-[0%] text-center align-middle text-[#1B062F] [leading-trim:none] lg:text-[20px]";
const SQUARES_ODDS_GRID_SELECTED_CHIP_ICON_SIZE_CLASS = "h-[19px] w-[19px] shrink-0 object-contain lg:h-[19px] lg:w-[19px]";
const SQUARES_ODDS_GRID_ODDS_TEXT_CLASS = "font-chakra text-[11px] font-normal not-italic leading-[100%] tracking-[0%] text-center align-middle [leading-trim:none] lg:text-[14px]";
const SQUARES_MATCH_PLAY_PAGE_BG_CLASS = "bg-gradient-to-r from-[#1B062F] to-[#381660]";
const SQUARES_MATCH_PLAY_PAGE_BG_STYLE = {
    background: "linear-gradient(to right, #1B062F 0%, #381660 100%)"
};
function isSquaresLobbyEnabled() {
    const v = undefined;
    if (v == null || v === "") return true;
    const s = String(v).trim().toLowerCase();
    return s !== "false" && s !== "0" && s !== "off";
}
const SQUARES_TEST_FORMAT_CODE = 999;
const SQUARES_HUNDRED_FORMAT_CODE = 100;

},{"../../Cricket/ballInProgressDotStyles":"8InoF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8InoF":[function(require,module,exports,__globalThis) {
/** Shared in-play ball indicator dots (Squares ball-results strip). */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BALL_IN_PROGRESS_DOT_BASE_CLASS", ()=>BALL_IN_PROGRESS_DOT_BASE_CLASS);
parcelHelpers.export(exports, "BALL_IN_PROGRESS_DOT_OPACITY_CLASSES", ()=>BALL_IN_PROGRESS_DOT_OPACITY_CLASSES);
parcelHelpers.export(exports, "BALL_IN_PROGRESS_DOT_DELAYS_MS", ()=>BALL_IN_PROGRESS_DOT_DELAYS_MS);
const BALL_IN_PROGRESS_DOT_BASE_CLASS = "h-[3px] w-[3px] shrink-0 rounded-full animate-bounce";
const BALL_IN_PROGRESS_DOT_OPACITY_CLASSES = [
    "bg-white",
    "bg-white/70",
    "bg-white/40"
];
const BALL_IN_PROGRESS_DOT_DELAYS_MS = [
    0,
    150,
    300
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ckr8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIXES_DEMO_ENABLED", ()=>SIXES_DEMO_ENABLED);
parcelHelpers.export(exports, "SIXES_DEMO_MATCH_ID", ()=>SIXES_DEMO_MATCH_ID);
parcelHelpers.export(exports, "LEAGUE_SIXES_DEMO_MATCH_ID", ()=>LEAGUE_SIXES_DEMO_MATCH_ID);
parcelHelpers.export(exports, "SIXES_DEMO_MULTIPLIER_PLAYER", ()=>SIXES_DEMO_MULTIPLIER_PLAYER);
parcelHelpers.export(exports, "LEAGUE_SIXES_DEMO_MULTIPLIER_PLAYER", ()=>LEAGUE_SIXES_DEMO_MULTIPLIER_PLAYER);
parcelHelpers.export(exports, "SIXES_DEMO_HOME_TEAM", ()=>SIXES_DEMO_HOME_TEAM);
parcelHelpers.export(exports, "SIXES_DEMO_AWAY_TEAM", ()=>SIXES_DEMO_AWAY_TEAM);
parcelHelpers.export(exports, "LEAGUE_SIXES_DEMO_HOME_TEAM", ()=>LEAGUE_SIXES_DEMO_HOME_TEAM);
parcelHelpers.export(exports, "LEAGUE_SIXES_DEMO_AWAY_TEAM", ()=>LEAGUE_SIXES_DEMO_AWAY_TEAM);
parcelHelpers.export(exports, "SIXES_DEMO_MULTIPLIER_PLAYER_TEAMS", ()=>SIXES_DEMO_MULTIPLIER_PLAYER_TEAMS);
parcelHelpers.export(exports, "isLeagueSixesDemoMatchId", ()=>isLeagueSixesDemoMatchId);
/** True for the hardcoded demo fixture in every env (embeds/promos need local data on prod too). */ parcelHelpers.export(exports, "isSixesDemoMatchId", ()=>isSixesDemoMatchId);
parcelHelpers.export(exports, "sixesDemoHomeTeam", ()=>sixesDemoHomeTeam);
parcelHelpers.export(exports, "sixesDemoAwayTeam", ()=>sixesDemoAwayTeam);
parcelHelpers.export(exports, "sixesDemoMultiplierPlayer", ()=>sixesDemoMultiplierPlayer);
/** Switch-player carousel pool for design-only demo cards (India/WI vs PBKS/MI). */ parcelHelpers.export(exports, "sixesDemoMultiplierSpinPlayers", ()=>sixesDemoMultiplierSpinPlayers);
parcelHelpers.export(exports, "sixesDemoCompetition", ()=>sixesDemoCompetition);
parcelHelpers.export(exports, "SIXES_DEMO_SCORE_LINES", ()=>SIXES_DEMO_SCORE_LINES);
parcelHelpers.export(exports, "SIXES_DEMO_PREMATCH_SCORE_LINES", ()=>SIXES_DEMO_PREMATCH_SCORE_LINES);
parcelHelpers.export(exports, "SIXES_DEMO_BATTING_TEAM", ()=>SIXES_DEMO_BATTING_TEAM);
parcelHelpers.export(exports, "SIXES_DEMO_STICKY_OV_LABEL", ()=>SIXES_DEMO_STICKY_OV_LABEL);
parcelHelpers.export(exports, "sixesDemoScoreLines", ()=>sixesDemoScoreLines);
parcelHelpers.export(exports, "sixesDemoStickyOvLabel", ()=>sixesDemoStickyOvLabel);
parcelHelpers.export(exports, "sixesDemoBattingTeam", ()=>sixesDemoBattingTeam);
/** Standalone PBKS/MI lobby demo is in-play. Presenter India–WI is live only after Start the match. */ parcelHelpers.export(exports, "sixesDemoIsInPlayScorecard", ()=>sixesDemoIsInPlayScorecard);
var _analyticsEnv = require("../../../utils/analyticsEnv");
var _leaguePresenterLiveMatch = require("../../Leagues/lib/leaguePresenterLiveMatch");
const SIXES_DEMO_ENABLED = (0, _analyticsEnv.isDevEnv)();
const SIXES_DEMO_MATCH_ID = "14872941";
const LEAGUE_SIXES_DEMO_MATCH_ID = "proto-ind-wi";
const SIXES_DEMO_MULTIPLIER_PLAYER = "Shreyas Iyer";
const LEAGUE_SIXES_DEMO_MULTIPLIER_PLAYER = "Virat Kohli";
const SIXES_DEMO_HOME_TEAM = "Punjab Kings";
const SIXES_DEMO_AWAY_TEAM = "Mumbai Indians";
const LEAGUE_SIXES_DEMO_HOME_TEAM = "India";
const LEAGUE_SIXES_DEMO_AWAY_TEAM = "West Indies";
const SIXES_DEMO_MULTIPLIER_PLAYER_TEAMS = {
    [SIXES_DEMO_MULTIPLIER_PLAYER]: SIXES_DEMO_HOME_TEAM,
    "Shashank Singh": SIXES_DEMO_HOME_TEAM,
    "Rohit Sharma": SIXES_DEMO_AWAY_TEAM,
    "Suryakumar Yadav": SIXES_DEMO_AWAY_TEAM,
    [LEAGUE_SIXES_DEMO_MULTIPLIER_PLAYER]: LEAGUE_SIXES_DEMO_HOME_TEAM,
    "Hardik Pandya": LEAGUE_SIXES_DEMO_HOME_TEAM,
    "Nicholas Pooran": LEAGUE_SIXES_DEMO_AWAY_TEAM,
    "Shai Hope": LEAGUE_SIXES_DEMO_AWAY_TEAM
};
function isLeagueSixesDemoMatchId(matchId) {
    return String(matchId || "").trim() === LEAGUE_SIXES_DEMO_MATCH_ID;
}
function isSixesDemoMatchId(matchId) {
    const id = String(matchId || "").trim();
    return id === SIXES_DEMO_MATCH_ID || id === LEAGUE_SIXES_DEMO_MATCH_ID;
}
function sixesDemoHomeTeam(matchId) {
    return isLeagueSixesDemoMatchId(matchId) ? LEAGUE_SIXES_DEMO_HOME_TEAM : SIXES_DEMO_HOME_TEAM;
}
function sixesDemoAwayTeam(matchId) {
    return isLeagueSixesDemoMatchId(matchId) ? LEAGUE_SIXES_DEMO_AWAY_TEAM : SIXES_DEMO_AWAY_TEAM;
}
function sixesDemoMultiplierPlayer(matchId) {
    return isLeagueSixesDemoMatchId(matchId) ? LEAGUE_SIXES_DEMO_MULTIPLIER_PLAYER : SIXES_DEMO_MULTIPLIER_PLAYER;
}
function sixesDemoMultiplierSpinPlayers(matchId) {
    if (isLeagueSixesDemoMatchId(matchId)) return [
        LEAGUE_SIXES_DEMO_MULTIPLIER_PLAYER,
        "Hardik Pandya",
        "Nicholas Pooran",
        "Shai Hope"
    ];
    return [
        SIXES_DEMO_MULTIPLIER_PLAYER,
        "Shashank Singh",
        "Rohit Sharma",
        "Suryakumar Yadav"
    ];
}
function sixesDemoCompetition(matchId) {
    return isLeagueSixesDemoMatchId(matchId) ? "ICC Men's T20 World Cup" : "IPL 2025";
}
const SIXES_DEMO_SCORE_LINES = [
    "92/1",
    "189/5"
];
const SIXES_DEMO_PREMATCH_SCORE_LINES = [
    "--",
    "--"
];
const SIXES_DEMO_BATTING_TEAM = "Punjab Kings";
const SIXES_DEMO_STICKY_OV_LABEL = "10.4/20";
function sixesDemoScoreLines(matchId, matchLive = false) {
    if (isLeagueSixesDemoMatchId(matchId)) {
        if (!matchLive) return SIXES_DEMO_PREMATCH_SCORE_LINES;
        return (0, _leaguePresenterLiveMatch.presenterLiveMatchCard)().scoreLines;
    }
    return SIXES_DEMO_SCORE_LINES;
}
function sixesDemoStickyOvLabel(matchId, matchLive = false) {
    if (isLeagueSixesDemoMatchId(matchId)) return matchLive ? (0, _leaguePresenterLiveMatch.presenterLiveMatchCard)().oversLabel : null;
    return SIXES_DEMO_STICKY_OV_LABEL;
}
function sixesDemoBattingTeam(matchId) {
    return isLeagueSixesDemoMatchId(matchId) ? LEAGUE_SIXES_DEMO_HOME_TEAM : SIXES_DEMO_BATTING_TEAM;
}
function sixesDemoIsInPlayScorecard(matchId, matchLive = false) {
    if (!isSixesDemoMatchId(matchId)) return false;
    if (isLeagueSixesDemoMatchId(matchId)) return matchLive;
    return true;
}

},{"../../../utils/analyticsEnv":"4mdbs","../../Leagues/lib/leaguePresenterLiveMatch":"YkC1d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4lDfN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readSixesCardRevealed", ()=>readSixesCardRevealed);
/** True if any of these match ids was revealed this session (fixture + live event can differ). */ parcelHelpers.export(exports, "readAnySixesCardRevealed", ()=>readAnySixesCardRevealed);
parcelHelpers.export(exports, "markSixesCardRevealed", ()=>markSixesCardRevealed);
parcelHelpers.export(exports, "readSixesSimulationComplete", ()=>readSixesSimulationComplete);
parcelHelpers.export(exports, "SIXES_SIMULATION_COMPLETE_EVENT", ()=>SIXES_SIMULATION_COMPLETE_EVENT);
parcelHelpers.export(exports, "markSixesSimulationComplete", ()=>markSixesSimulationComplete);
/**
 * The celebratory "Match Finished" modal auto-pops once per finished real match (persisted across
 * sessions so revisiting a settled card from My Games never re-pops it).
 */ parcelHelpers.export(exports, "readSixesFinishedModalSeen", ()=>readSixesFinishedModalSeen);
parcelHelpers.export(exports, "markSixesFinishedModalSeen", ()=>markSixesFinishedModalSeen);
/**
 * The "your players changed" popup auto-pops once per lineup-correction batch (keyed by the
 * correction's `at` timestamp) so it never re-pops on reload once the user has acknowledged it.
 */ parcelHelpers.export(exports, "readSixesLineupCorrectionSeen", ()=>readSixesLineupCorrectionSeen);
parcelHelpers.export(exports, "markSixesLineupCorrectionSeen", ()=>markSixesLineupCorrectionSeen);
parcelHelpers.export(exports, "readSixesFormatCorrectionSeen", ()=>readSixesFormatCorrectionSeen);
parcelHelpers.export(exports, "markSixesFormatCorrectionSeen", ()=>markSixesFormatCorrectionSeen);
const STORAGE_KEY_PREFIX = "sixes:card-revealed:";
const SIMULATION_KEY_PREFIX = "sixes:simulation-complete:";
const FINISHED_MODAL_SEEN_KEY_PREFIX = "sixes:finished-modal-seen:";
const LINEUP_CORRECTION_SEEN_KEY_PREFIX = "sixes:lineup-correction-seen:";
const FORMAT_CORRECTION_SEEN_KEY_PREFIX = "sixes:format-correction-seen:";
function readSixesCardRevealed(matchId) {
    if (typeof window === "undefined") return false;
    const id = String(matchId || "").trim();
    if (!id) return false;
    return window.sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${id}`) === "1";
}
function readAnySixesCardRevealed(matchIds) {
    const seen = new Set();
    for (const raw of matchIds){
        const id = String(raw || "").trim();
        if (!id || seen.has(id)) continue;
        seen.add(id);
        if (readSixesCardRevealed(id)) return true;
    }
    return false;
}
function markSixesCardRevealed(matchId) {
    if (typeof window === "undefined") return;
    const id = String(matchId || "").trim();
    if (!id) return;
    window.sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${id}`, "1");
}
function readSixesSimulationComplete(matchId) {
    if (typeof window === "undefined") return false;
    const id = String(matchId || "").trim();
    if (!id) return false;
    return window.sessionStorage.getItem(`${SIMULATION_KEY_PREFIX}${id}`) === "1";
}
const SIXES_SIMULATION_COMPLETE_EVENT = "c8:sixes-simulation-complete";
function markSixesSimulationComplete(matchId) {
    if (typeof window === "undefined") return;
    const id = String(matchId || "").trim();
    if (!id) return;
    window.sessionStorage.setItem(`${SIMULATION_KEY_PREFIX}${id}`, "1");
    window.dispatchEvent(new CustomEvent(SIXES_SIMULATION_COMPLETE_EVENT, {
        detail: {
            matchId: id
        }
    }));
}
function readSixesFinishedModalSeen(matchId) {
    if (typeof window === "undefined") return false;
    const id = String(matchId || "").trim();
    if (!id) return false;
    try {
        return window.localStorage.getItem(`${FINISHED_MODAL_SEEN_KEY_PREFIX}${id}`) === "1";
    } catch  {
        return false;
    }
}
function markSixesFinishedModalSeen(matchId) {
    if (typeof window === "undefined") return;
    const id = String(matchId || "").trim();
    if (!id) return;
    try {
        window.localStorage.setItem(`${FINISHED_MODAL_SEEN_KEY_PREFIX}${id}`, "1");
    } catch  {
    /* quota / private mode */ }
}
function readSixesLineupCorrectionSeen(matchId, at) {
    if (typeof window === "undefined") return false;
    const id = String(matchId || "").trim();
    const key = String(at || "").trim();
    if (!id || !key) return false;
    try {
        return window.localStorage.getItem(`${LINEUP_CORRECTION_SEEN_KEY_PREFIX}${id}:${key}`) === "1";
    } catch  {
        return false;
    }
}
function markSixesLineupCorrectionSeen(matchId, at) {
    if (typeof window === "undefined") return;
    const id = String(matchId || "").trim();
    const key = String(at || "").trim();
    if (!id || !key) return;
    try {
        window.localStorage.setItem(`${LINEUP_CORRECTION_SEEN_KEY_PREFIX}${id}:${key}`, "1");
    } catch  {
    /* quota / private mode */ }
}
function readSixesFormatCorrectionSeen(matchId, at) {
    if (typeof window === "undefined") return false;
    const id = String(matchId || "").trim();
    const key = String(at || "").trim();
    if (!id || !key) return false;
    try {
        return window.localStorage.getItem(`${FORMAT_CORRECTION_SEEN_KEY_PREFIX}${id}:${key}`) === "1";
    } catch  {
        return false;
    }
}
function markSixesFormatCorrectionSeen(matchId, at) {
    if (typeof window === "undefined") return;
    const id = String(matchId || "").trim();
    const key = String(at || "").trim();
    if (!id || !key) return;
    try {
        window.localStorage.setItem(`${FORMAT_CORRECTION_SEEN_KEY_PREFIX}${id}:${key}`, "1");
    } catch  {
    /* quota / private mode */ }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZgkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setActiveLeagueMode", ()=>setActiveLeagueMode);
/** Read the active league id without subscribing (URL builders, click handlers). */ parcelHelpers.export(exports, "peekActiveLeagueId", ()=>peekActiveLeagueId);
/** The id of the league whose mode is currently active, or null. */ parcelHelpers.export(exports, "useActiveLeagueMode", ()=>useActiveLeagueMode);
var _react = require("react");
/**
 * Tracks whether the viewer is currently "in League mode" (on a live league they
 * belong to). The global site header subscribes to this so it can swap itself
 * for a branded league header — league coins instead of the personal wallet.
 *
 * Kept intentionally tiny and separate from the league data store: it holds only
 * the active league id, and consumers read the league itself from the league store.
 *
 * Do not import `leagueGamePlayUrl` here — that module pulls Sixes/Squares/Bullion
 * fixtures, which import this store and make Parcel fail with
 * `Cannot find module '.../leagueModeStore'`.
 */ /** Same key as `LEAGUE_ID_QUERY` in leagueGamePlayUrl (duplicated to avoid that cycle). */ const LEAGUE_ID_QUERY = "leagueId";
function leagueIdFromWindow() {
    if (typeof window === "undefined") return null;
    const value = new URLSearchParams(window.location.search).get(LEAGUE_ID_QUERY);
    return value?.trim() ? value.trim() : null;
}
/** Seed from the URL so a soft/hard land on `?leagueId=` never paints the site header first. */ let activeLeagueId = leagueIdFromWindow();
const listeners = new Set();
function emit() {
    listeners.forEach((listener)=>listener());
}
function setActiveLeagueMode(leagueId) {
    if (activeLeagueId === leagueId) return;
    activeLeagueId = leagueId;
    emit();
}
function subscribe(listener) {
    listeners.add(listener);
    return ()=>{
        listeners.delete(listener);
    };
}
function getSnapshot() {
    return activeLeagueId;
}
function peekActiveLeagueId() {
    return activeLeagueId;
}
function useActiveLeagueMode() {
    return (0, _react.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1bLlx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MY_GAMES_CLIENT_CACHE_TTL_MS", ()=>MY_GAMES_CLIENT_CACHE_TTL_MS);
parcelHelpers.export(exports, "QUICKFIRE_ENDGAME_SYNCED_EVENT", ()=>QUICKFIRE_ENDGAME_SYNCED_EVENT);
/** Clear overview/active My Games caches so the next fetch hits the API (e.g. after Quickfire session written to `quickfire_plays`). */ parcelHelpers.export(exports, "invalidateMyGamesFetchCaches", ()=>invalidateMyGamesFetchCaches);
parcelHelpers.export(exports, "MY_ACTIVE_GAMES_SQUARES_UPDATED", ()=>MY_ACTIVE_GAMES_SQUARES_UPDATED);
parcelHelpers.export(exports, "TraderDataFetcherProvider", ()=>TraderDataFetcherProvider);
parcelHelpers.export(exports, "useTraderDataFetcher", ()=>useTraderDataFetcher);
var _jsxRuntime = require("react/jsx-runtime");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _authHeaders = require("../utils/authHeaders");
var _countDistinctActiveTradeMatches = require("../utils/countDistinctActiveTradeMatches");
const MY_GAMES_PREFETCH_DELAY_MS = 600;
const MY_GAMES_CLIENT_CACHE_TTL_MS = 90000;
const MY_ACTIVE_GAMES_CACHE_KEY = "c8_my_active_games";
const MY_ACTIVE_GAMES_CACHE_TTL_MS = MY_GAMES_CLIENT_CACHE_TTL_MS;
const MY_ACTIVE_TRADER_CACHE_KEY = "c8_my_active_trader";
const MY_ACTIVE_SQUARES_CACHE_KEY = "c8_my_active_squares";
const MY_GAMES_OVERVIEW_CACHE_KEY = "c8_my_games_overview";
const MY_GAMES_OVERVIEW_CACHE_TTL_MS = MY_GAMES_CLIENT_CACHE_TTL_MS;
const MY_GAMES_OVERVIEW_TRADER_CACHE_KEY = "c8_my_games_overview_trader";
const MY_GAMES_OVERVIEW_SQUARES_CACHE_KEY = "c8_my_games_overview_squares";
const QUICKFIRE_ENDGAME_SYNCED_EVENT = "quickfireEndgameSynced";
function invalidateMyGamesFetchCaches() {
    try {
        localStorage.removeItem(MY_ACTIVE_GAMES_CACHE_KEY);
        localStorage.removeItem(MY_ACTIVE_TRADER_CACHE_KEY);
        localStorage.removeItem(MY_ACTIVE_SQUARES_CACHE_KEY);
        localStorage.removeItem(MY_GAMES_OVERVIEW_CACHE_KEY);
        localStorage.removeItem(MY_GAMES_OVERVIEW_TRADER_CACHE_KEY);
        localStorage.removeItem(MY_GAMES_OVERVIEW_SQUARES_CACHE_KEY);
        localStorage.removeItem("c8_games_count");
    } catch  {
    // ignore
    }
}
const MY_ACTIVE_GAMES_SQUARES_UPDATED = "myActiveGamesSquaresUpdated";
const TraderDataFetcherContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
const TraderDataFetcherProvider = ({ children })=>{
    const overviewInFlightRef = (0, _react.useRef)(null);
    const getCachedMyGamesActive = (0, _react.useMemo)(()=>()=>{
            try {
                const raw = localStorage.getItem(MY_ACTIVE_GAMES_CACHE_KEY);
                if (raw) {
                    const { trades, squares, quickfire, totalActiveGames, bullionActivePlaysCount, sixesActiveCardsCount, timestamp } = JSON.parse(raw);
                    // Older caches folded Sixes into `totalActiveGames` but omitted `sixesActiveCardsCount`,
                    // which left the burger SIXES badge at 0 while MY GAMES showed the total. Drop them
                    // (including split trader/squares keys) so the next fetch rewrites a complete payload.
                    if (sixesActiveCardsCount === undefined) {
                        localStorage.removeItem(MY_ACTIVE_GAMES_CACHE_KEY);
                        localStorage.removeItem(MY_ACTIVE_TRADER_CACHE_KEY);
                        localStorage.removeItem(MY_ACTIVE_SQUARES_CACHE_KEY);
                        localStorage.removeItem(MY_GAMES_OVERVIEW_CACHE_KEY);
                        localStorage.removeItem(MY_GAMES_OVERVIEW_TRADER_CACHE_KEY);
                        localStorage.removeItem(MY_GAMES_OVERVIEW_SQUARES_CACHE_KEY);
                        return null;
                    }
                    if (Date.now() - (timestamp || 0) <= MY_ACTIVE_GAMES_CACHE_TTL_MS) {
                        const qf = Array.isArray(quickfire) ? quickfire : [];
                        const bullion = Math.max(0, parseInt(String(bullionActivePlaysCount ?? 0), 10) || 0);
                        const sixes = Math.max(0, parseInt(String(sixesActiveCardsCount ?? 0), 10) || 0);
                        return {
                            trades: Array.isArray(trades) ? trades : [],
                            squares: Array.isArray(squares) ? squares : [],
                            quickfire: qf,
                            bullionActivePlaysCount: bullion,
                            sixesActiveCardsCount: sixes,
                            totalActiveGames: typeof totalActiveGames === "number" ? totalActiveGames : (0, _countDistinctActiveTradeMatches.countDistinctActiveTradeMatches)(Array.isArray(trades) ? trades : []) + (Array.isArray(squares) ? squares.length : 0) + qf.length + bullion + sixes
                        };
                    }
                }
                const traderRaw = localStorage.getItem(MY_ACTIVE_TRADER_CACHE_KEY);
                const squaresRaw = localStorage.getItem(MY_ACTIVE_SQUARES_CACHE_KEY);
                if (traderRaw && squaresRaw) {
                    const trader = JSON.parse(traderRaw);
                    const squares = JSON.parse(squaresRaw);
                    if (Date.now() - (trader.timestamp || 0) <= MY_ACTIVE_GAMES_CACHE_TTL_MS && Date.now() - (squares.timestamp || 0) <= MY_ACTIVE_GAMES_CACHE_TTL_MS) {
                        const trades = Array.isArray(trader.trades) ? trader.trades : [];
                        const sq = Array.isArray(squares.squares?.data) ? squares.squares.data : Array.isArray(squares.squares) ? squares.squares : [];
                        const qf = Array.isArray(trader.quickfire) ? trader.quickfire : [];
                        return {
                            trades,
                            squares: sq,
                            quickfire: qf,
                            bullionActivePlaysCount: 0,
                            sixesActiveCardsCount: 0,
                            totalActiveGames: (0, _countDistinctActiveTradeMatches.countDistinctActiveTradeMatches)(trades) + (squares.squares?.count ?? sq.length) + qf.length
                        };
                    }
                }
                return null;
            } catch  {
                return null;
            }
        }, []);
    const getCachedMyGamesOverview = (0, _react.useMemo)(()=>()=>{
            try {
                const raw = localStorage.getItem(MY_GAMES_OVERVIEW_CACHE_KEY);
                if (raw) {
                    const { active, settledToday, timestamp } = JSON.parse(raw);
                    if (active && active.sixesActiveCardsCount === undefined) {
                        localStorage.removeItem(MY_ACTIVE_GAMES_CACHE_KEY);
                        localStorage.removeItem(MY_ACTIVE_TRADER_CACHE_KEY);
                        localStorage.removeItem(MY_ACTIVE_SQUARES_CACHE_KEY);
                        localStorage.removeItem(MY_GAMES_OVERVIEW_CACHE_KEY);
                        localStorage.removeItem(MY_GAMES_OVERVIEW_TRADER_CACHE_KEY);
                        localStorage.removeItem(MY_GAMES_OVERVIEW_SQUARES_CACHE_KEY);
                        return null;
                    }
                    if (Date.now() - (timestamp || 0) <= MY_GAMES_OVERVIEW_CACHE_TTL_MS && active && settledToday) {
                        const cachedQf = Array.isArray(active.quickfire) ? active.quickfire : [];
                        const bullion = Math.max(0, parseInt(String(active.bullionActivePlaysCount ?? 0), 10) || 0);
                        const sixes = Math.max(0, parseInt(String(active.sixesActiveCardsCount ?? 0), 10) || 0);
                        return {
                            active: {
                                trades: Array.isArray(active.trades) ? active.trades : [],
                                squares: Array.isArray(active.squares) ? active.squares : [],
                                quickfire: cachedQf,
                                bullionActivePlaysCount: bullion,
                                sixesActiveCardsCount: sixes,
                                totalActiveGames: typeof active.totalActiveGames === "number" ? active.totalActiveGames : (0, _countDistinctActiveTradeMatches.countDistinctActiveTradeMatches)(Array.isArray(active.trades) ? active.trades : []) + (Array.isArray(active.squares) ? active.squares.length : 0) + cachedQf.length + bullion + sixes
                            },
                            settledToday: {
                                trades: Array.isArray(settledToday.trades) ? settledToday.trades : [],
                                squares: Array.isArray(settledToday.squares) ? settledToday.squares : []
                            }
                        };
                    }
                }
                const traderRaw = localStorage.getItem(MY_GAMES_OVERVIEW_TRADER_CACHE_KEY);
                const squaresRaw = localStorage.getItem(MY_GAMES_OVERVIEW_SQUARES_CACHE_KEY);
                if (traderRaw && squaresRaw) {
                    const trader = JSON.parse(traderRaw);
                    const squares = JSON.parse(squaresRaw);
                    if (Date.now() - (trader.timestamp || 0) <= MY_GAMES_OVERVIEW_CACHE_TTL_MS && Date.now() - (squares.timestamp || 0) <= MY_GAMES_OVERVIEW_CACHE_TTL_MS) {
                        const activeTrades = Array.isArray(trader.active?.trades) ? trader.active.trades : [];
                        const activeSq = Array.isArray(squares.active?.squares?.data) ? squares.active.squares.data : Array.isArray(squares.active?.squares) ? squares.active.squares : [];
                        const settledTrades = Array.isArray(trader.settledToday?.trades) ? trader.settledToday.trades : [];
                        const settledSq = Array.isArray(squares.settledToday?.squares?.data) ? squares.settledToday.squares.data : Array.isArray(squares.settledToday?.squares) ? squares.settledToday.squares : [];
                        const splitQf = Array.isArray(trader.active?.quickfire) ? trader.active.quickfire : [];
                        return {
                            active: {
                                trades: activeTrades,
                                squares: activeSq,
                                quickfire: splitQf,
                                bullionActivePlaysCount: 0,
                                sixesActiveCardsCount: 0,
                                totalActiveGames: (0, _countDistinctActiveTradeMatches.countDistinctActiveTradeMatches)(activeTrades) + (squares.active?.squares?.count ?? activeSq.length) + splitQf.length
                            },
                            settledToday: {
                                trades: settledTrades,
                                squares: settledSq
                            }
                        };
                    }
                }
                return null;
            } catch  {
                return null;
            }
        }, []);
    const fetchMyGamesOverview = (0, _react.useMemo)(()=>async (opts)=>{
            const emptyPayload = {
                active: {
                    trades: [],
                    squares: [],
                    quickfire: [],
                    bullionActivePlaysCount: 0,
                    sixesActiveCardsCount: 0,
                    totalActiveGames: 0
                },
                settledToday: {
                    trades: [],
                    squares: []
                }
            };
            const sessionToken = (0, _jsCookieDefault.default).get("c8_session_token");
            if (!sessionToken) return emptyPayload;
            if (!opts?.bypassCache) {
                const cached = getCachedMyGamesOverview();
                if (cached) return cached;
                if (overviewInFlightRef.current) return overviewInFlightRef.current;
            }
            const headers = (0, _authHeaders.getAuthHeaders)();
            const apiUrl = "https://cricket8.com/api";
            const run = async ()=>{
                try {
                    const res = await fetch(`${apiUrl}/trade/my-games-overview/${sessionToken}`, {
                        method: "GET",
                        headers
                    });
                    if (!res.ok) {
                        const cached = getCachedMyGamesOverview();
                        return cached ?? emptyPayload;
                    }
                    const data = await res.json();
                    const now = Date.now();
                    const activeTrades = Array.isArray(data?.active?.trades) ? data.active.trades : [];
                    const activeSquaresData = Array.isArray(data?.active?.squares?.data) ? data.active.squares.data : Array.isArray(data?.active?.squares) ? data.active.squares : [];
                    const activeSquaresCount = data?.active?.squares?.count ?? activeSquaresData.length;
                    const activeQuickfireData = Array.isArray(data?.active?.quickfire?.data) ? data.active.quickfire.data : Array.isArray(data?.active?.quickfire) ? data.active.quickfire : [];
                    const activeQuickfireCount = data?.active?.quickfire?.count ?? activeQuickfireData.length;
                    const bullionActivePlaysCount = Math.max(0, parseInt(String(data?.active?.bullionActivePlaysCount ?? 0), 10) || 0);
                    const sixesActiveCardsCount = Math.max(0, parseInt(String(data?.active?.sixesActiveCardsCount ?? 0), 10) || 0);
                    const totalActiveGames = typeof data?.active?.totalActiveGames === "number" ? data.active.totalActiveGames : (0, _countDistinctActiveTradeMatches.countDistinctActiveTradeMatches)(activeTrades) + activeSquaresCount + activeQuickfireCount + bullionActivePlaysCount + sixesActiveCardsCount;
                    const settledTodayTrades = Array.isArray(data?.settledToday?.trades) ? data.settledToday.trades : [];
                    const settledTodaySquares = Array.isArray(data?.settledToday?.squares?.data) ? data.settledToday.squares.data : Array.isArray(data?.settledToday?.squares) ? data.settledToday.squares : [];
                    const active = {
                        trades: activeTrades,
                        squares: activeSquaresData,
                        quickfire: activeQuickfireData,
                        bullionActivePlaysCount,
                        sixesActiveCardsCount,
                        totalActiveGames
                    };
                    const settledToday = {
                        trades: settledTodayTrades,
                        squares: settledTodaySquares
                    };
                    const payload = {
                        active,
                        settledToday
                    };
                    const prevCached = getCachedMyGamesOverview();
                    const prevCount = prevCached?.active?.totalActiveGames;
                    const prevBullion = prevCached?.active?.bullionActivePlaysCount ?? 0;
                    const prevSixes = prevCached?.active?.sixesActiveCardsCount ?? 0;
                    const prevSquaresLen = prevCached?.active?.squares?.length ?? 0;
                    const breakdownChanged = prevCount !== totalActiveGames || prevBullion !== bullionActivePlaysCount || prevSixes !== sixesActiveCardsCount;
                    try {
                        localStorage.setItem(MY_GAMES_OVERVIEW_TRADER_CACHE_KEY, JSON.stringify({
                            active: {
                                trades: activeTrades,
                                quickfire: activeQuickfireData,
                                totalActiveGames: (0, _countDistinctActiveTradeMatches.countDistinctActiveTradeMatches)(activeTrades) + activeQuickfireCount
                            },
                            settledToday: {
                                trades: settledTodayTrades
                            },
                            timestamp: now
                        }));
                        localStorage.setItem(MY_GAMES_OVERVIEW_SQUARES_CACHE_KEY, JSON.stringify({
                            active: {
                                squares: {
                                    data: activeSquaresData,
                                    count: activeSquaresCount
                                }
                            },
                            settledToday: {
                                squares: settledTodaySquares
                            },
                            timestamp: now
                        }));
                        localStorage.setItem(MY_ACTIVE_TRADER_CACHE_KEY, JSON.stringify({
                            trades: activeTrades,
                            quickfire: activeQuickfireData,
                            totalActiveGames: (0, _countDistinctActiveTradeMatches.countDistinctActiveTradeMatches)(activeTrades) + activeQuickfireCount,
                            timestamp: now
                        }));
                        localStorage.setItem(MY_ACTIVE_SQUARES_CACHE_KEY, JSON.stringify({
                            squares: {
                                data: activeSquaresData,
                                count: activeSquaresCount
                            },
                            timestamp: now
                        }));
                        localStorage.setItem(MY_GAMES_OVERVIEW_CACHE_KEY, JSON.stringify({
                            ...payload,
                            timestamp: now
                        }));
                        localStorage.setItem(MY_ACTIVE_GAMES_CACHE_KEY, JSON.stringify({
                            ...active,
                            timestamp: now
                        }));
                        localStorage.setItem("c8_games_count", JSON.stringify({
                            count: totalActiveGames,
                            timestamp: now
                        }));
                        // Fire even when only per-game breakdown changes (same total) so burger badges refresh.
                        if (breakdownChanged) window.dispatchEvent(new CustomEvent("gamesCountUpdated", {
                            detail: {
                                count: totalActiveGames
                            }
                        }));
                        if (activeSquaresData.length !== prevSquaresLen) window.dispatchEvent(new CustomEvent(MY_ACTIVE_GAMES_SQUARES_UPDATED));
                    } catch (e) {
                        console.error("Error updating overview cache:", e);
                    }
                    return payload;
                } catch  {
                    const cached = getCachedMyGamesOverview();
                    return cached ?? emptyPayload;
                }
            };
            if (!opts?.bypassCache) {
                const pending = run().finally(()=>{
                    overviewInFlightRef.current = null;
                });
                overviewInFlightRef.current = pending;
                return pending;
            }
            return run();
        }, [
        getCachedMyGamesOverview
    ]);
    const fetchMyGamesActive = (0, _react.useMemo)(()=>async (opts)=>{
            const sessionToken = (0, _jsCookieDefault.default).get("c8_session_token");
            if (!sessionToken) return {
                trades: [],
                squares: [],
                quickfire: [],
                bullionActivePlaysCount: 0,
                sixesActiveCardsCount: 0,
                totalActiveGames: 0
            };
            if (!opts?.bypassCache) {
                const cached = getCachedMyGamesActive();
                if (cached) return cached;
                const overview = getCachedMyGamesOverview();
                if (overview) return overview.active;
            }
            const payload = await fetchMyGamesOverview({
                bypassCache: opts?.bypassCache
            });
            return payload.active;
        }, [
        getCachedMyGamesActive,
        getCachedMyGamesOverview,
        fetchMyGamesOverview
    ]);
    const contextValue = (0, _react.useMemo)(()=>({
            fetchMyGamesActive,
            getCachedMyGamesActive,
            fetchMyGamesOverview,
            getCachedMyGamesOverview
        }), [
        fetchMyGamesActive,
        getCachedMyGamesActive,
        fetchMyGamesOverview,
        getCachedMyGamesOverview
    ]);
    // Overview prefetch only (drawer/header). History is prefetched when My Zone My Games is opened.
    (0, _react.useEffect)(()=>{
        const sessionToken = (0, _jsCookieDefault.default).get("c8_session_token");
        if (!sessionToken) return;
        const timer = setTimeout(()=>{
            fetchMyGamesOverview().catch(()=>{});
        }, MY_GAMES_PREFETCH_DELAY_MS);
        return ()=>clearTimeout(timer);
    }, [
        fetchMyGamesOverview
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TraderDataFetcherContext.Provider, {
        value: contextValue,
        children: children
    });
};
const useTraderDataFetcher = ()=>{
    const context = (0, _react.useContext)(TraderDataFetcherContext);
    if (!context) throw new Error("useTraderDataFetcher must be used within a DataFetcherProvider");
    return context;
};

},{"react/jsx-runtime":"gaGEj","js-cookie":"2P5RE","react":"6uln9","../utils/authHeaders":"5Rczo","../utils/countDistinctActiveTradeMatches":"19o2L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"19o2L":[function(require,module,exports,__globalThis) {
/**
 * Open Trader legs sharing the same sport + match_id count as one in-play "game"
 * (matches backend `countDistinctActiveTradeMatches`).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "countDistinctActiveTradeMatches", ()=>countDistinctActiveTradeMatches);
function countDistinctActiveTradeMatches(trades) {
    if (!Array.isArray(trades) || trades.length === 0) return 0;
    const keys = new Set();
    let anon = 0;
    for (const raw of trades){
        if (!raw || typeof raw !== "object") continue;
        const t = raw;
        const sport = String(t.sport ?? "").trim().toUpperCase() || "UNKNOWN";
        const mid = String(t.match_id ?? "").trim();
        const id = t.id != null && t.id !== "" ? String(t.id) : "";
        const key = mid ? `${sport}|m:${mid}` : `${sport}|t:${id || `n:${anon++}`}`;
        keys.add(key);
    }
    return keys.size;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2iFcv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SocketContext", ()=>SocketContext);
/**
 * Subscribe to a slice of socket state. Re-renders only when the selected value changes
 * (`isEqual`), not when unrelated Trader fields (e.g. `marketData`) update.
 */ parcelHelpers.export(exports, "useSocketSelector", ()=>useSocketSelector);
/** Stable stream actions — do not change when cricket/market feed state updates. */ parcelHelpers.export(exports, "useSocketActions", ()=>useSocketActions);
parcelHelpers.export(exports, "DecimalSocketProvider", ()=>DecimalSocketProvider);
parcelHelpers.export(exports, "useSocket", ()=>useSocket);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _authHeaders = require("../utils/authHeaders");
var _traderConstants = require("../components/Games/traderConstants");
var _streamInitialStatePrimedCache = require("../utils/streamInitialStatePrimedCache");
var _unwrapStreamMarketUpdate = require("../utils/unwrapStreamMarketUpdate");
var _decimalEventStatus = require("../components/Trader/Cricket/decimalEventStatus");
var _decimalMarketUtils = require("../components/Trader/Cricket/decimalMarketUtils");
var _squaresBallResults = require("../components/Squares/shared/squaresBallResults");
var _cricketMatchCardOverDisplay = require("../components/Cricket/cricketMatchCardOverDisplay");
var _cricketReducedOvers = require("../utils/cricketReducedOvers");
var _cricketLiveBallSignals = require("../utils/cricketLiveBallSignals");
var _cricketTestMatch = require("../utils/cricketTestMatch");
var _mergeStreamCommentary = require("../utils/mergeStreamCommentary");
var _mergeDecimalScorecardDelta = require("../utils/mergeDecimalScorecardDelta");
var _scoregridLatestBowling = require("../utils/scoregridLatestBowling");
function isNonOutcomeCommentaryResult(resultText) {
    const s = String(resultText || "").trim().toLowerCase();
    if (!s) return false;
    return /umpire|review|penalty|\bpen\b|wide|\bwd\b|no\s*ball|\bnb\b|dead\s*ball|lost\s*ball|retired|timed\s*out/.test(s);
}
/** Distinct deliveries at the same display ball (e.g. wide then legal re-bowl) need separate keys
 * when ball ids are coarse. Fine-grained ids uniquely identify one physical delivery — including
 * when Decimal reclassifies a wide/no-ball as a legal outcome on the same id — so those share a key.
 */ function fullCommEntryKey(insKey, ball, commentary) {
    const ballValue = typeof ball === "number" ? ball : parseFloat(String(ball));
    const over0 = Math.floor(ballValue);
    const parts = Number.isFinite(ballValue) ? ballValue.toFixed(1).split(".") : [];
    const delivery1 = parts.length > 1 ? parseInt(parts[1], 10) : 0;
    const coarse = !Number.isFinite(ballValue) || !Number.isFinite(delivery1) || delivery1 < 1 || Math.abs(ballValue - (over0 + delivery1 / 10)) < 1e-9;
    if (!coarse) return `${insKey}-${ballValue}`;
    const result = commentary.split(",")[1]?.trim() ?? "";
    const extraTag = isNonOutcomeCommentaryResult(result) ? "E" : "L";
    return `${insKey}-${ballValue}-${extraTag}`;
}
function parseCommentaryBallFields(ball) {
    const ballValue = typeof ball === "number" ? ball : parseFloat(String(ball ?? ""));
    const over0 = Math.floor(ballValue);
    const parts = ballValue.toFixed(1).split(".");
    const delivery1 = parts.length > 1 ? parseInt(parts[1], 10) : 0;
    return {
        over0,
        delivery1,
        ballValue
    };
}
function fullCommItemKey(item) {
    const ball = item.feedBall ?? item.over + item.ball / 10;
    return fullCommEntryKey(item.inns, ball, item.commentary ?? "");
}
function fullCommCanonicalBall(item) {
    const ball = item.feedBall ?? item.over + item.ball / 10;
    const { over0, delivery1 } = parseCommentaryBallFields(ball);
    return over0 + delivery1 / 10;
}
/** Matches page display: newest balls first; legal re-bowl above wide/no-ball at same display ball. */ function compareFullCommDisplayOrder(a, b) {
    if (a.inns !== b.inns) return a.inns.localeCompare(b.inns);
    const ca = fullCommCanonicalBall(a);
    const cb = fullCommCanonicalBall(b);
    if (ca !== cb) return cb - ca;
    const extraA = isNonOutcomeCommentaryResult(a.result ?? a.commentary.split(",")[1]?.trim() ?? "") || /\bwide\b|\bwd\b|\bno\s*ball\b|\bnb\b/.test(a.commentary.toLowerCase()) ? 1 : 0;
    const extraB = isNonOutcomeCommentaryResult(b.result ?? b.commentary.split(",")[1]?.trim() ?? "") || /\bwide\b|\bwd\b|\bno\s*ball\b|\bnb\b/.test(b.commentary.toLowerCase()) ? 1 : 0;
    if (extraA !== extraB) return extraA - extraB;
    const fineA = typeof a.feedBall === "number" ? a.feedBall : parseFloat(String(a.feedBall ?? fullCommCanonicalBall(a)));
    const fineB = typeof b.feedBall === "number" ? b.feedBall : parseFloat(String(b.feedBall ?? fullCommCanonicalBall(b)));
    return fineB - fineA;
}
/**
 * Merge Delta `commentary.commentaries` into the object TraderCommentary / Squares read (`commentary` state).
 * Merges by ball key so single-ball SSE updates accumulate (see mergeStreamCommentaryPayload).
 */ function mergeCommentariesIntoState(prevCommentary, incomingPayload) {
    const merged = (0, _mergeStreamCommentary.mergeStreamCommentaryPayload)(prevCommentary, incomingPayload);
    return merged ?? prevCommentary ?? {};
}
/** `runs/wkts` line for innings totals — avoids `"undefined/undefined"` from `{}` deltas. */ function inningRunsWktsLine(inns) {
    if (inns == null || typeof inns !== "object" || Array.isArray(inns)) return "0/0";
    const runsRaw = inns.runs;
    const wktsRaw = inns.wkts;
    const r = typeof runsRaw === "number" ? runsRaw : Number(runsRaw);
    const w = typeof wktsRaw === "number" ? wktsRaw : Number(wktsRaw);
    const hasR = runsRaw != null && String(runsRaw).trim() !== "" && Number.isFinite(r);
    const hasW = wktsRaw != null && String(wktsRaw).trim() !== "" && Number.isFinite(w);
    if (!hasR && !hasW) return "0/0";
    return `${hasR ? r : 0}/${hasW ? w : 0}`;
}
/** Sum of `inns1..inns4` runs, or null when no innings carries a usable total. */ function scorecardTotalRuns(card) {
    if (card == null || typeof card !== "object") return null;
    let total = null;
    for (const key of [
        "inns1",
        "inns2",
        "inns3",
        "inns4"
    ]){
        const inns = card[key];
        if (inns == null || typeof inns !== "object") continue;
        const runsRaw = inns.runs;
        const runs = typeof runsRaw === "number" ? runsRaw : Number(runsRaw);
        if (runsRaw == null || String(runsRaw).trim() === "" || !Number.isFinite(runs)) continue;
        total = (total ?? 0) + runs;
    }
    return total;
}
/** True when `incoming` carries a lower aggregate total than what is already held — i.e. it is older. */ function scorecardTotalsRegressed(existing, incoming) {
    const prev = scorecardTotalRuns(existing);
    const next = scorecardTotalRuns(incoming);
    return prev != null && next != null && next < prev;
}
/**
 * `subscribeToMatch(…, feedFilter)` lists which message families to apply. When
 * `market_update` is omitted, we still read win-probability from the payload and
 * status fields on `market_update`, but we do not merge the full book into
 * `trading` / `marketData` (BULLION played view has no live order book).
 */ function feedWantsMarkets(feedFilter) {
    if (feedFilter == null) return true;
    if (!Array.isArray(feedFilter)) return true;
    if (feedFilter.length === 0) return true;
    return feedFilter.includes("market_update");
}
/** Lobby-tier SSE may send `event` without a scoreboard array — never call `.find` on undefined. */ function eventScoreboardRows(event) {
    const sb = event?.scoreboard;
    return Array.isArray(sb) ? sb : [];
}
/** Appendix 4 final + common status strings — used so out-of-order last_update does not drop settlement rows. */ function liveMarketRowIndicatesFinalSettlement(m) {
    if (!m || typeof m !== "object") return false;
    const row = m;
    const ss = row.settled_status ?? row.Settled_status;
    if (ss === 2 || ss === 3 || ss === 4) return true;
    const su = String(ss ?? "").trim().toUpperCase();
    if (su === "SETTLED" || su === "VOID" || su === "DEADHEAT") return true;
    if (su === "2" || su === "3" || su === "4") return true;
    const st = String(row.status ?? row.market_status ?? row.state ?? "").toLowerCase();
    return st.includes("settled") || st.includes("closed") || st.includes("result") || st.includes("complete");
}
/** Same key as markets.jsx getMarketKey (market_id + market_line_id). */ function getStreamMarketKey(p) {
    const mid = p?.market_id != null ? String(p.market_id) : "";
    const lid = p?.market_line_id != null && String(p.market_line_id).trim() !== "" ? String(p.market_line_id) : "";
    if (mid && lid) return `${mid}_${lid}`;
    if (lid) return lid;
    if (mid && p?.line != null && String(p.line).trim() !== "") {
        const n = Number(p.line);
        return `${mid}_line_${Number.isFinite(n) ? String(n) : String(p.line).trim()}`;
    }
    return mid || "unknown";
}
/**
 * Apply SSE/HTTP market rows to the in-memory book.
 * - `fullSnapshot`: authoritative offerable book — upsert incoming keys and delete any key not present
 *   (events server sends this for subscribe/initial-state and for live ticks built from the full cache).
 * - Otherwise merge by key (sparse overlays); Appendix-4 finals delete that key.
 * Settled keys are also removed via `settled_market_keys` on the payload (SSE omits settled rows).
 */ function cricketSelectionHasOfferableOdds(selection) {
    if (!selection || typeof selection !== "object") return false;
    const n = Number(selection.recommended_price ?? selection.odds);
    return Number.isFinite(n) && n > 1.02;
}
function cricketMarketHasOfferableOdds(market) {
    if (!market || typeof market !== "object") return false;
    const list = market.selectionslist ?? market.selections ?? [];
    return Array.isArray(list) && list.some(cricketSelectionHasOfferableOdds);
}
/** Match Winner: keep last priced runners when a tick omits them or sends a pause blank. */ function retainCricketMatchWinnerOdds(prev, incoming) {
    if (!incoming || typeof incoming !== "object") return incoming;
    const isMw = (0, _decimalMarketUtils.isCricketMatchWinnerForTrade)(incoming) || (0, _decimalMarketUtils.isCricketMatchWinnerForTrade)(prev);
    if (!isMw) return incoming;
    if (cricketMarketHasOfferableOdds(incoming)) return incoming;
    if (!prev || typeof prev !== "object" || !cricketMarketHasOfferableOdds(prev)) return incoming;
    const prevSels = prev.selectionslist ?? prev.selections;
    return {
        ...incoming,
        selectionslist: prevSels,
        selections: undefined
    };
}
function applyMarketsFromStreamMessage(map, rawMarkets, options) {
    if (options.staleSettledOnly) {
        rawMarkets.forEach((market)=>{
            if (liveMarketRowIndicatesFinalSettlement(market)) map.delete(getStreamMarketKey(market));
        });
        return;
    }
    if (options.fullSnapshot) {
        const keepKeys = new Set();
        rawMarkets.forEach((market)=>{
            const key = getStreamMarketKey(market);
            if (liveMarketRowIndicatesFinalSettlement(market)) {
                map.delete(key);
                return;
            }
            keepKeys.add(key);
            map.set(key, retainCricketMatchWinnerOdds(map.get(key), market));
        });
        for (const key of [
            ...map.keys()
        ]){
            if (keepKeys.has(key)) continue;
            if ((0, _decimalMarketUtils.isCricketMatchWinnerForTrade)(map.get(key))) continue;
            map.delete(key);
        }
        return;
    }
    rawMarkets.forEach((market)=>{
        const key = getStreamMarketKey(market);
        if (liveMarketRowIndicatesFinalSettlement(market)) {
            map.delete(key);
            return;
        }
        map.set(key, retainCricketMatchWinnerOdds(map.get(key), market));
    });
}
/** Remove markets the server already marked Appendix-4 final (omitted from offerable `markets[]`). */ function applySettledMarketKeyRemovals(map, parsedData) {
    const mu = parsedData.market_update;
    const nestedMu = mu?.market_update;
    const raw = mu?.settled_market_keys ?? nestedMu?.settled_market_keys ?? parsedData.settled_market_keys;
    if (!Array.isArray(raw) || raw.length === 0) return false;
    let removed = false;
    for (const k of raw){
        if (k == null) continue;
        const key = String(k);
        if (!key || key === "unknown") continue;
        if (map.delete(key)) removed = true;
    }
    return removed;
}
/** True when this payload’s markets array is the full offerable book (replace missing keys). */ function streamMessageIsMarketSnapshot(parsedData) {
    return parsedData.market_snapshot === true || parsedData.market_update?.market_snapshot === true;
}
function normalizeTeamLabel(s) {
    return String(s ?? "").trim().toLowerCase().replace(/\s+/g, " ");
}
/** True when a book selection label refers to the same side as a fixture team (exact or substring for nicknames). */ function teamLabelsMatch(selectionName, fixtureTeamName) {
    const a = normalizeTeamLabel(selectionName);
    const b = normalizeTeamLabel(fixtureTeamName);
    if (!a || !b) return false;
    if (a === b) return true;
    const minLen = Math.min(a.length, b.length);
    if (minLen < 4) return false;
    return a.includes(b) || b.includes(a);
}
/** Decimal sends match-winner probability as 0–1 fraction; tolerate 0–100. */ function probabilityPercentFromRaw(raw) {
    const n = Number(raw);
    if (!Number.isFinite(n) || n < 0) return 0;
    if (n <= 1) return Math.round(n * 100);
    return Math.round(Math.min(100, n));
}
/**
 * Prefer home/away from the same stream payload, else "Team A v Team B" from scorecard description.
 */ function resolveTeamOrderFromStreamPayload(parsedData, skipCricketSnapshot) {
    if (skipCricketSnapshot || !parsedData) return undefined;
    const scoreboard = parsedData.event?.scoreboard;
    if (Array.isArray(scoreboard)) {
        const homeObj = scoreboard.find((item)=>item.name === "home");
        const awayObj = scoreboard.find((item)=>item.name === "away");
        const h = homeObj?.value != null ? String(homeObj.value).trim() : "";
        const a = awayObj?.value != null ? String(awayObj.value).trim() : "";
        if (h && a) return [
            h,
            a
        ];
    }
    const desc = parsedData.scorecard?.description;
    if (desc != null && String(desc).trim() !== "") {
        const matchParts = String(desc).split(",");
        const raw = matchParts[0] ?? "";
        const split = raw.split(" v ").map((s)=>s.trim()).filter(Boolean);
        if (split.length >= 2) return [
            split[0],
            split[1]
        ];
    }
    return undefined;
}
/**
 * Map Match Winner (1010) selections (arbitrary API order) onto `teamOrder[0]` / `teamOrder[1]` for the UI.
 */ function alignWinProbabilityPairToTeamOrder(teamOrder, sel) {
    if (!sel || sel.length < 2) return null;
    const t0 = String(teamOrder[0] ?? "").trim();
    const t1 = String(teamOrder[1] ?? "").trim();
    const s0name = String(sel[0]?.name ?? "").trim();
    const s1name = String(sel[1]?.name ?? "").trim();
    const pFirst = probabilityPercentFromRaw(sel[0]?.probability);
    const pSecond = 100 - pFirst;
    if (!t0 || !t1) return [
        {
            name: s0name,
            probability: pFirst
        },
        {
            name: s1name,
            probability: pSecond
        }
    ];
    const slotFor = (selName)=>{
        if (!selName) return null;
        const m0 = teamLabelsMatch(selName, t0);
        const m1 = teamLabelsMatch(selName, t1);
        if (m0 && m1) return null;
        if (m0) return 0;
        if (m1) return 1;
        return null;
    };
    const slotS0 = slotFor(s0name);
    const slotS1 = slotFor(s1name);
    let pForT0 = null;
    let pForT1 = null;
    if (slotS0 === 0) pForT0 = pFirst;
    else if (slotS0 === 1) pForT1 = pFirst;
    if (slotS1 === 0) pForT0 = pSecond;
    else if (slotS1 === 1) pForT1 = pSecond;
    if (pForT0 != null && pForT1 == null) pForT1 = 100 - pForT0;
    else if (pForT1 != null && pForT0 == null) pForT0 = 100 - pForT1;
    else if (pForT0 != null && pForT1 != null) pForT1 = 100 - pForT0;
    else if (teamLabelsMatch(s0name, t1) && teamLabelsMatch(s1name, t0)) return [
        {
            name: t0,
            probability: pSecond
        },
        {
            name: t1,
            probability: pFirst
        }
    ];
    else return [
        {
            name: s0name || t0,
            probability: pFirst
        },
        {
            name: s1name || t1,
            probability: pSecond
        }
    ];
    return [
        {
            name: t0,
            probability: pForT0 ?? 0
        },
        {
            name: t1,
            probability: pForT1 ?? 0
        }
    ];
}
const SocketContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
/** Latest provider value for `useSocketSelector` (avoids re-rendering all `useSocket()` consumers). */ const socketStoreSnapshotRef = {
    current: null
};
const socketStoreListenersRef = {
    current: new Set()
};
function notifySocketStoreListeners() {
    socketStoreListenersRef.current.forEach((listener)=>listener());
}
function useSocketSelector(selector, isEqual = Object.is) {
    const ctx = (0, _react.useContext)(SocketContext);
    if (!ctx) throw new Error("useSocketSelector must be used within a SocketProvider");
    const selectorRef = (0, _react.useRef)(selector);
    selectorRef.current = selector;
    const isEqualRef = (0, _react.useRef)(isEqual);
    isEqualRef.current = isEqual;
    const sliceRef = (0, _react.useRef)(selector(ctx));
    return (0, _react.useSyncExternalStore)((onStoreChange)=>{
        const listener = ()=>{
            const snap = socketStoreSnapshotRef.current;
            if (!snap) return;
            const next = selectorRef.current(snap);
            if (!isEqualRef.current(sliceRef.current, next)) {
                sliceRef.current = next;
                onStoreChange();
            }
        };
        socketStoreListenersRef.current.add(listener);
        return ()=>{
            socketStoreListenersRef.current.delete(listener);
        };
    }, ()=>sliceRef.current, ()=>sliceRef.current);
}
function useSocketActions() {
    return useSocketSelector((ctx)=>({
            subscribeToMatch: ctx.subscribeToMatch,
            getCompletedData: ctx.getCompletedData,
            subscribeToMatches: ctx.subscribeToMatches
        }), (a, b)=>a.subscribeToMatch === b.subscribeToMatch && a.getCompletedData === b.getCompletedData && a.subscribeToMatches === b.subscribeToMatches);
}
const DecimalSocketProvider = ({ children })=>{
    //! State Begin
    const [matchTitle, setMatchTitle] = (0, _react.useState)("");
    const [marketData, setMarketData] = (0, _react.useState)([]);
    // --- home states ---
    const [location, setLocation] = (0, _react.useState)();
    const [tournament, setTournament] = (0, _react.useState)("");
    const [partnership, setPartnership] = (0, _react.useState)({});
    const [matchName, setMatchName] = (0, _react.useState)("");
    const [probability, setProbability] = (0, _react.useState)([
        {
            name: "",
            probability: 0
        },
        {
            name: "",
            probability: 0
        }
    ]);
    const [teams, setTeams] = (0, _react.useState)([
        "",
        ""
    ]);
    const teamsRef = (0, _react.useRef)([
        "",
        ""
    ]);
    (0, _react.useLayoutEffect)(()=>{
        teamsRef.current = [
            teams[0] ?? "",
            teams[1] ?? ""
        ];
    }, [
        teams
    ]);
    /** Keep last-known team names when a partial scoreboard/event frame omits home or away. */ const applyTeamsFromFeed = (0, _react.useCallback)((homeVal, awayVal)=>{
        const prev = teamsRef.current;
        const homeRaw = homeVal != null ? String(homeVal).trim() : "";
        const awayRaw = awayVal != null ? String(awayVal).trim() : "";
        const home = homeRaw || prev[0] || "";
        const away = awayRaw || prev[1] || "";
        if (home === (prev[0] ?? "") && away === (prev[1] ?? "")) return;
        setTeams([
            home,
            away
        ]);
    }, []);
    const applyTeamsFromMatchTitlePart = (0, _react.useCallback)((titlePart)=>{
        const chunks = String(titlePart ?? "").split(" v ").map((s)=>s.trim()).filter(Boolean);
        if (chunks.length < 2) return;
        applyTeamsFromFeed(chunks[0], chunks[1]);
    }, [
        applyTeamsFromFeed
    ]);
    const [game_phase, setGamePhase] = (0, _react.useState)("");
    const [prematch, setPrematch] = (0, _react.useState)(true);
    const prematchRef = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        prematchRef.current = prematch;
    }, [
        prematch
    ]);
    const [localTime, setLocalTime] = (0, _react.useState)("");
    const [batting, setBatting] = (0, _react.useState)(null);
    const [status, setStatus] = (0, _react.useState)("");
    const [curBall, setCurBall] = (0, _react.useState)(null);
    const [curInnsOver, setCurInnsOver] = (0, _react.useState)("");
    const [overDelivery, setOverDelivery] = (0, _react.useState)([]);
    const [commentary, setCommentary] = (0, _react.useState)({});
    const [battings, setBattings] = (0, _react.useState)([]);
    const [homeOvers, setHomeOvers] = (0, _react.useState)([]);
    const [awayOvers, setAwayOvers] = (0, _react.useState)([]);
    const [mOvers, setMOvers] = (0, _react.useState)([]);
    const [innsNow, setInnsNow] = (0, _react.useState)(0);
    const [batNow, setBatNow] = (0, _react.useState)("");
    const [liveBat, setLiveBat] = (0, _react.useState)("");
    const [CurPos, setCurPos] = (0, _react.useState)([
        0,
        0,
        0
    ]);
    const [score, setScore] = (0, _react.useState)([
        "0/0",
        "0/0"
    ]);
    const [overs, setOvers] = (0, _react.useState)([
        ""
    ]);
    // --- score card states ---
    const [scoregrid, setScoregrid] = (0, _react.useState)([]);
    const [matchComment, setMatchComment] = (0, _react.useState)("");
    const [runRate, setRunRate] = (0, _react.useState)("");
    const [currentInnings, setCurrentInnings] = (0, _react.useState)(0);
    // --- match details ---
    const [format, setFormat] = (0, _react.useState)(null);
    /** Live scoreboard "Max Overs" (current innings cap; DLS / reduced overs). */ const [scoreboardMaxOvers, setScoreboardMaxOvers] = (0, _react.useState)(null);
    /** Decimal reduced1/reduced2/reduced_match below 1 — rain-reduced; feed has no revised target. */ const [oversReduced, setOversReduced] = (0, _react.useState)(false);
    /** Competition gender from Delta lineups / event (e.g. M, F) — used for Squares run-distribution model. */ const [competitionGender, setCompetitionGender] = (0, _react.useState)(undefined);
    const [trading, setTrading] = (0, _react.useState)([]);
    const [fullComm, setFullComm] = (0, _react.useState)([]);
    const [striker, setStriker] = (0, _react.useState)("");
    const [battingOvers, setBattingOvers] = (0, _react.useState)([
        0,
        0,
        0,
        0
    ]);
    const [incomingEvent, setIncomingEvent] = (0, _react.useState)(false);
    const [stream, setStream] = (0, _react.useState)(true);
    const [subHeader, setSubHeader] = (0, _react.useState)("standard");
    const [embedcode, setEmbedCode] = (0, _react.useState)("");
    const [lineup, setLineup] = (0, _react.useState)([]);
    const [scoreGridData, setScoreGridData] = (0, _react.useState)([]);
    /**
   * When a scoregrid SSE message is dropped as stale (last_update) but carries more counted balls for the
   * same over as the last applied scoregrid, keep that delivery for Squares only (see SquaresMatchPlayContent).
   */ const [squaresStaleScoregridBallSupplement, setSquaresStaleScoregridBallSupplement] = (0, _react.useState)(null);
    const [scorecardData, setScorecardData] = (0, _react.useState)([]);
    /** Decimal alerts (flags: powerplay, ball in progress, injury, weather, etc.) for scoreboard modal */ const [alerts, setAlerts] = (0, _react.useState)(null);
    /** Latest Decimal batting_analysis (shot, shot_dir, aerial) for the delivery just played. */ const [battingAnalysis, setBattingAnalysis] = (0, _react.useState)(null);
    /** Latest delta ball results (`event.score`), newest first — carries e.g. "WICKET, Bowled". */ const [ballResults, setBallResults] = (0, _react.useState)(null);
    const [bowling, setBowling] = (0, _react.useState)();
    const [feed, setFeed] = (0, _react.useState)([]);
    const [eventStatus, setEventStatus] = (0, _react.useState)();
    const eventStatusRef = (0, _react.useRef)(undefined);
    /** Once a fixture is known finished, ignore stale socket frames that reset scores or chase comments. */ const matchFinishedLatchRef = (0, _react.useRef)(false);
    const scoreRef = (0, _react.useRef)([
        "0/0",
        "0/0"
    ]);
    const matchCommentRef = (0, _react.useRef)("");
    /** Match-level market open status (`betting_status`: ACTIVE/SUSPENDED) from match_update or market_update. Takes precedence over market-level status (Decimal API). */ const [matchTradingStatus, setMatchTradingStatus] = (0, _react.useState)();
    const [matchStartDateTime, setMatchStartDateTime] = (0, _react.useState)(null);
    /** Match ID currently subscribed via subscribeToMatch; used so Markets only merge data for this match. */ const [subscribedMatchId, setSubscribedMatchId] = (0, _react.useState)(null);
    /** Decimal feed state: "recovering" (catch-up) or "realtime". When recovering we replace accumulated markets instead of merge. */ const [subscriptionState, setSubscriptionState] = (0, _react.useState)();
    /** True when the match EventSource has errored/closed (lost connection); cleared when reconnecting or on cleanup. */ const [connectionLost, setConnectionLost] = (0, _react.useState)(false);
    /** Events server bumps this when Squares leaderboards / ball_results are written so match play refetches `/squares/match-over-plays`. */ const [squaresOversRefreshNonce, setSquaresOversRefreshNonce] = (0, _react.useState)(0);
    /** Bumped when BULLION live settlement writes plays for this match (`bullion_settlement_updated` SSE). */ const [bullionSettlementRefresh, setBullionSettlementRefresh] = (0, _react.useState)({
        nonce: 0,
        matchId: "",
        gameIds: []
    });
    // --- trader-match-card
    //! State End
    (0, _react.useLayoutEffect)(()=>{
        eventStatusRef.current = eventStatus;
        if ((0, _decimalEventStatus.isMatchFinishedStatus)(eventStatus)) matchFinishedLatchRef.current = true;
    }, [
        eventStatus
    ]);
    (0, _react.useLayoutEffect)(()=>{
        scoreRef.current = score;
    }, [
        score
    ]);
    (0, _react.useLayoutEffect)(()=>{
        matchCommentRef.current = matchComment;
        if ((0, _decimalEventStatus.commentIndicatesCricketMatchResult)(matchComment)) matchFinishedLatchRef.current = true;
    }, [
        matchComment
    ]);
    const applyEventStatusFromFeed = (0, _react.useCallback)((next)=>{
        if (next == null) return;
        const prev = eventStatusRef.current;
        if ((0, _decimalEventStatus.isMatchFinishedStatus)(prev) && !(0, _decimalEventStatus.isMatchFinishedStatus)(next)) return;
        if (matchFinishedLatchRef.current && (0, _decimalEventStatus.isMatchScheduledStatus)(next) && !(0, _decimalEventStatus.isMatchFinishedStatus)(next)) return;
        // Catalog / thin frames often replay MATCH_SCHEDULED (0) after the match is already live or on a break.
        const prevN = (0, _decimalEventStatus.eventStatusToNumber)(prev);
        if ((0, _decimalEventStatus.isMatchScheduledStatus)(next) && !(0, _decimalEventStatus.isMatchFinishedStatus)(next) && prevN != null && (0, _decimalEventStatus.IN_PLAY_STATUS_IDS).includes(prevN)) return;
        if ((0, _decimalEventStatus.isMatchFinishedStatus)(next)) matchFinishedLatchRef.current = true;
        eventStatusRef.current = next;
        setEventStatus(next);
        setPrematch((0, _decimalEventStatus.isMatchScheduledStatus)(next));
        // Go-live while the match page is already open: pull full detail snapshot once.
        const nextN = (0, _decimalEventStatus.eventStatusToNumber)(next);
        const nextInPlay = nextN != null && (0, _decimalEventStatus.IN_PLAY_STATUS_IDS).includes(nextN);
        if (nextInPlay && (0, _decimalEventStatus.isMatchScheduledStatus)(prev)) requestLiveDetailHydrateRef.current?.();
    }, []);
    const shouldApplyCricketScoreboardScores = (0, _react.useCallback)((nextScores)=>{
        // Live Delta often sends a thin scorecard (inns null / no runs) after a good scoreboard
        // frame. Never wipe known totals with empty placeholders — finished or in-play.
        if ((0, _decimalEventStatus.cricketPrimaryScoresLookEmpty)(nextScores)) return (0, _decimalEventStatus.cricketPrimaryScoresLookEmpty)(scoreRef.current);
        // Incomplete scoreboard (e.g. runs.1 missing → "0/0") must not clear one team's
        // already-known innings total after hydrate from scorecard.
        const prev = scoreRef.current;
        if (!Array.isArray(prev) || prev.length < 2) return true;
        for(let i = 0; i < 2; i++){
            if ((0, _decimalEventStatus.cricketPrimaryScoreLineEmpty)(nextScores[i]) && !(0, _decimalEventStatus.cricketPrimaryScoreLineEmpty)(prev[i])) return false;
        }
        // A finished match never scores fewer runs. `/completed/:id` can hold a snapshot archived at
        // MATCH_COMPLETE, before the feed finished correcting the closing deliveries — applying it over
        // fresher stream scores rolls the scoreboard backwards. Compared as a total across all innings
        // slots, since scoreboard and scorecard order those slots by whoever is batting.
        if (!matchFinishedLatchRef.current) return true;
        const nextTotal = (0, _decimalEventStatus.cricketScoreLinesTotalRuns)(nextScores);
        const prevTotal = (0, _decimalEventStatus.cricketScoreLinesTotalRuns)(prev);
        if (nextTotal != null && prevTotal != null && nextTotal < prevTotal) return false;
        return true;
    }, []);
    const guardedSetScore = (0, _react.useCallback)((nextScores)=>{
        if (!shouldApplyCricketScoreboardScores(nextScores)) return;
        scoreRef.current = nextScores;
        setScore(nextScores);
    }, [
        shouldApplyCricketScoreboardScores
    ]);
    const shouldApplyCricketMatchComment = (0, _react.useCallback)((nextComment)=>{
        const next = String(nextComment ?? "").trim();
        if (!matchFinishedLatchRef.current) return true;
        if ((0, _decimalEventStatus.isCricketRrrComment)(next)) return false;
        if (next) return true;
        return !String(matchCommentRef.current ?? "").trim();
    }, []);
    const guardedSetMatchComment = (0, _react.useCallback)((nextComment)=>{
        if (!shouldApplyCricketMatchComment(nextComment)) return;
        matchCommentRef.current = nextComment;
        setMatchComment(nextComment);
    }, [
        shouldApplyCricketMatchComment
    ]);
    /** Mirrors latest applied scoregrid object for stale-path comparison (not the string[] initial state). */ const scoreGridDataRef = (0, _react.useRef)(null);
    // Throttled store for market_update (markets include selections with prices)
    const marketDataMapRef = (0, _react.useRef)(new Map());
    const marketDataFlushTimeoutRef = (0, _react.useRef)(null);
    // Same key as markets.jsx getMarketKey so accumulation and updates line up (market_id + market_line_id per Delta doc).
    const getMarketKey = (p)=>{
        const mid = p?.market_id != null ? String(p.market_id) : "";
        const lid = p?.market_line_id != null ? String(p.market_line_id) : "";
        if (mid && lid) return `${mid}_${lid}`;
        if (lid) return lid;
        return mid || "unknown";
    };
    const scheduleMarketDataFlush = (0, _react.useCallback)(()=>{
        if (marketDataFlushTimeoutRef.current !== null) return;
        marketDataFlushTimeoutRef.current = window.setTimeout(()=>{
            marketDataFlushTimeoutRef.current = null;
            const arr = Array.from(marketDataMapRef.current.values());
            arr.sort((a, b)=>(a.display_order ?? a.market_do ?? 0) - (b.display_order ?? b.market_do ?? 0));
            setMarketData((prev)=>{
                if (prev.length !== arr.length) return arr;
                const prevMap = new Map(prev.map((p)=>[
                        getMarketKey(p),
                        p
                    ]));
                const hasChanged = arr.some((na)=>{
                    const prevItem = prevMap.get(getMarketKey(na));
                    if (!prevItem) return true;
                    const sel = (x)=>x?.selectionslist ?? x?.selections;
                    return prevItem.name !== na.name || prevItem.market_type !== na.market_type || (prevItem.display_order ?? prevItem.market_do) !== (na.display_order ?? na.market_do) || prevItem.line !== na.line || prevItem.active !== na.active || prevItem.status !== na.status || JSON.stringify(sel(prevItem)) !== JSON.stringify(sel(na));
                });
                return hasChanged ? arr : prev;
            });
        }, 0);
    }, []);
    // Track current matchId to detect when switching matches
    const currentMatchIdRef = (0, _react.useRef)(null);
    /**
   * Monotonic `last_update` for live scoreboard + scorecard + top-level scoreboard only.
   * Kept separate from market updates so a newer market tick does not reject a slightly older scorecard frame
   * (or vice versa), which caused flicker and “previous over” UI after reconnect / split SSE messages.
   */ const latestCricketFeedVersionPerMatchRef = (0, _react.useRef)(new Map());
    /** Monotonic version for full market list replacement (`market_update` with non-empty markets). */ const latestMarketFeedVersionPerMatchRef = (0, _react.useRef)(new Map());
    /** Same idea as cricket/market refs, but only for `scoregrid` payloads. Without this, a market-only
   * message can bump a global version and cause a slightly older scoregrid frame to be dropped entirely. */ const latestScoregridLastUpdatePerMatchRef = (0, _react.useRef)(new Map());
    const devLastCountedBallsRef = (0, _react.useRef)(null);
    /** Scorecard has its own Decimal last_update clock — sharing the event version lane drops cache-replay
   * scorecards on lobby↔match-play remount (newer event, slightly older scorecard). */ const latestScorecardLastUpdatePerMatchRef = (0, _react.useRef)(new Map());
    /** Per-fixture merged scorecard for Delta partials (`inns` null wipes). SSE match id keyed. */ const mergedScorecardByMatchIdRef = (0, _react.useRef)(new Map());
    /** Reuse one active single-match SSE connection across screens (Trader/Squares/Bullion). */ const sharedSingleMatchSubscriptionRef = (0, _react.useRef)(null);
    /**
   * When a match leaves SCHEDULED / pre-match while the page is already open, force one
   * `initial-state` hydrate (scorecard / commentary / lineups / Match Winner). Live event/market
   * SSE otherwise keeps the timed snapshot poll suppressed, so detail tabs stay empty until refresh.
   */ const requestLiveDetailHydrateRef = (0, _react.useRef)(null);
    /** One forced hydrate per match id per visit (go-live only). */ const liveDetailHydrateDoneRef = (0, _react.useRef)(new Set());
    const parseLastUpdateVersion = (0, _react.useCallback)((lastUpdate)=>{
        if (typeof lastUpdate !== "string" || !lastUpdate.trim()) return null;
        const firstPart = lastUpdate.split("-")[0];
        const num = Number(firstPart);
        return Number.isFinite(num) ? num : null;
    }, []);
    const isStaleCricketFeedVersion = (0, _react.useCallback)((matchId, lastUpdate)=>{
        const incomingVersion = parseLastUpdateVersion(lastUpdate);
        if (incomingVersion == null) return false;
        const prev = latestCricketFeedVersionPerMatchRef.current.get(matchId);
        return prev != null && incomingVersion < prev;
    }, [
        parseLastUpdateVersion
    ]);
    const bumpCricketFeedVersion = (0, _react.useCallback)((matchId, lastUpdate)=>{
        const incomingVersion = parseLastUpdateVersion(lastUpdate);
        if (incomingVersion == null) return;
        latestCricketFeedVersionPerMatchRef.current.set(matchId, incomingVersion);
    }, [
        parseLastUpdateVersion
    ]);
    const isStaleMarketFeedVersion = (0, _react.useCallback)((matchId, lastUpdate)=>{
        const incomingVersion = parseLastUpdateVersion(lastUpdate);
        if (incomingVersion == null) return false;
        const prev = latestMarketFeedVersionPerMatchRef.current.get(matchId);
        return prev != null && incomingVersion < prev;
    }, [
        parseLastUpdateVersion
    ]);
    const bumpMarketFeedVersion = (0, _react.useCallback)((matchId, lastUpdate)=>{
        const incomingVersion = parseLastUpdateVersion(lastUpdate);
        if (incomingVersion == null) return;
        latestMarketFeedVersionPerMatchRef.current.set(matchId, incomingVersion);
    }, [
        parseLastUpdateVersion
    ]);
    const isStaleScorecardFeedVersion = (0, _react.useCallback)((matchId, lastUpdate)=>{
        const incomingVersion = parseLastUpdateVersion(lastUpdate);
        if (incomingVersion == null) return false;
        const prev = latestScorecardLastUpdatePerMatchRef.current.get(matchId);
        return prev != null && incomingVersion < prev;
    }, [
        parseLastUpdateVersion
    ]);
    const bumpScorecardFeedVersion = (0, _react.useCallback)((matchId, lastUpdate)=>{
        const incomingVersion = parseLastUpdateVersion(lastUpdate);
        if (incomingVersion == null) return;
        latestScorecardLastUpdatePerMatchRef.current.set(matchId, incomingVersion);
    }, [
        parseLastUpdateVersion
    ]);
    const clearMatchFeedVersionGuards = (0, _react.useCallback)((matchId)=>{
        latestCricketFeedVersionPerMatchRef.current.delete(matchId);
        latestMarketFeedVersionPerMatchRef.current.delete(matchId);
        latestScoregridLastUpdatePerMatchRef.current.delete(matchId);
        latestScorecardLastUpdatePerMatchRef.current.delete(matchId);
    }, []);
    (0, _react.useEffect)(()=>{
        scoreGridDataRef.current = scoreGridData;
    }, [
        scoreGridData
    ]);
    // Cleanup pending flush timers on unmount
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (marketDataFlushTimeoutRef.current !== null) {
                clearTimeout(marketDataFlushTimeoutRef.current);
                marketDataFlushTimeoutRef.current = null;
            }
        };
    }, []);
    const getEmbedCode = (0, _react.useCallback)(async (match_id)=>{
        try {
            const response = await fetch(`${"https://cricket8.com/api"}/embeddedplayer/${match_id}`, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            if (response.status === 200) {
                const data = await response.json();
                setEmbedCode(data.data);
            }
        } catch (error) {
            return null;
        }
    }, []);
    const getCompletedData = (0, _react.useCallback)(async (match_id)=>{
        try {
            const response = await fetch(`${"https://cricket8.com/api"}/completed/${match_id}`, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            if (response.status === 200) {
                const data = await response.json();
                const md = data?.data;
                if (md == null || Array.isArray(md)) return null;
                let archiveIsStale = false;
                try {
                    const sc0 = md.scorecard?.[0];
                    const scMsg = sc0?.msg_data ?? sc0;
                    if (scMsg && typeof scMsg === "object") {
                        const midStr = String(match_id);
                        // `/completed/:id` can hold a snapshot archived at MATCH_COMPLETE, before the feed
                        // finished correcting the closing deliveries. Keep its status/teams, drop its scores.
                        archiveIsStale = scorecardTotalsRegressed(mergedScorecardByMatchIdRef.current.get(midStr) ?? null, scMsg);
                        if (!archiveIsStale) {
                            mergedScorecardByMatchIdRef.current.set(midStr, scMsg);
                            setScorecardData(scMsg);
                        }
                        if (scMsg.event_status != null) applyEventStatusFromFeed(scMsg.event_status);
                        if ((0, _decimalEventStatus.resolveCricketMatchFinished)({
                            eventStatus: scMsg.event_status
                        })) matchFinishedLatchRef.current = true;
                        if (typeof scMsg.description === "string" && scMsg.description.includes(",")) {
                            const matchParts = scMsg.description.split(",");
                            if (matchParts[0]?.includes(" v ")) {
                                setMatchTitle(matchParts.length >= 3 ? matchParts[1].trim() : "");
                                applyTeamsFromMatchTitlePart(matchParts[0]);
                            }
                        }
                        setInnsNow(scMsg.inns_now);
                        setBatNow(scMsg.bat_now);
                        const mp = typeof scMsg.description === "string" ? scMsg.description.split(",") : [];
                        if (mp[0]?.includes(" v ")) {
                            const s1 = inningRunsWktsLine(scMsg.inns1);
                            const s2 = inningRunsWktsLine(scMsg.inns2);
                            const s3 = inningRunsWktsLine(scMsg.inns3);
                            const s4 = inningRunsWktsLine(scMsg.inns4);
                            const insScore = [
                                s1,
                                s2,
                                s3,
                                s4
                            ];
                            const innsnow = scMsg.inns_now;
                            let oppnow = 1;
                            let rptNow = 2;
                            if (innsnow === 1 || innsnow === 3) {
                                oppnow = 2;
                                rptNow = 1;
                            }
                            setLiveBat(scMsg.bat_now);
                            if (scMsg.bat_now === mp[0].split(" v ")[0]) guardedSetScore([
                                insScore[rptNow - 1],
                                insScore[oppnow - 1],
                                insScore[rptNow + 1],
                                insScore[oppnow + 1]
                            ]);
                            else guardedSetScore([
                                insScore[oppnow - 1],
                                insScore[rptNow - 1],
                                insScore[oppnow + 1],
                                insScore[rptNow + 1]
                            ]);
                        }
                    }
                    const ev = md.event?.[0]?.msg_data;
                    if (ev && Array.isArray(ev.scoreboard) && ev.scoreboard.length > 0) await EventProc(ev, match_id);
                } catch (e) {}
                const sg0 = md.scoregrid?.[0];
                const sgMsg = sg0?.msg_data ?? sg0;
                if (!archiveIsStale && sgMsg && typeof sgMsg === "object" && sgMsg.overs) {
                    setScoreGridData(sgMsg);
                    fetchScoreGrid(match_id, sgMsg);
                    setSquaresStaleScoregridBallSupplement((prev)=>prev != null && String(prev.matchId) === String(match_id) ? null : prev);
                }
                const commRaw = md.commentary;
                let commPayload = null;
                if (Array.isArray(commRaw) && commRaw.length > 0) {
                    const first = commRaw[0];
                    commPayload = first?.msg_data?.commentaries != null ? first.msg_data : first?.commentaries != null ? first : null;
                } else if (commRaw && typeof commRaw === "object" && commRaw.commentaries) commPayload = commRaw;
                if (commPayload?.commentaries) setCommentary((prev)=>mergeCommentariesIntoState(prev, commPayload));
                const luRaw = md.lineups;
                let lineupsPayload = null;
                if (Array.isArray(luRaw) && luRaw.length > 0) lineupsPayload = luRaw[0]?.msg_data?.lineups ?? luRaw[0]?.lineups ?? luRaw[0];
                else if (luRaw && typeof luRaw === "object") {
                    const o = luRaw;
                    lineupsPayload = o.msg_data?.lineups ?? o.lineups ?? (Array.isArray(o.teams) ? o : null);
                }
                if (lineupsPayload && typeof lineupsPayload === "object") setLineup(lineupsPayload);
            } else throw new Error("Failed to fetch data");
        } catch (error) {
            //console.error('Error fetching data:', error);
            return null;
        }
    /* EventProc / fetchScoreGrid are stable callbacks defined later in this provider; empty deps avoid TDZ. */ }, []);
    const applyWinProbabilityUpdate = (0, _react.useCallback)((parsedData, skipCricketSnapshot)=>{
        const markets = parsedData?.market_update?.markets ?? [];
        const winPredict = markets.find((m)=>{
            const mid = String(m.market_id ?? "");
            const tid = String(m.market_type_id ?? "");
            return mid === "1010" || tid === "1010" || tid === "10";
        });
        if (!winPredict) return;
        // Decimal sends p >= 0.99 when modelling is uncertain (treat as SUS for trading) — do not paint 99% Win Prob.
        if ((0, _decimalMarketUtils.hasExtremeProbabilities)(winPredict)) return;
        const sel = winPredict.selectionslist ?? winPredict.selections;
        if (!sel || sel.length < 2) return;
        const teamOrderFromPayload = resolveTeamOrderFromStreamPayload(parsedData, skipCricketSnapshot);
        const teamOrder = teamOrderFromPayload ?? teamsRef.current;
        const aligned = alignWinProbabilityPairToTeamOrder(teamOrder, sel);
        if (aligned) setProbability(aligned);
    }, []);
    const matchDetails = (0, _react.useCallback)((data, match_id, cb, opts)=>{
        const skipCricketSnapshot = Boolean(opts?.skipCricketSnapshot);
        const skipMarketData = Boolean(opts?.skipMarketData);
        const skipScorecard = Boolean(opts?.skipScorecard);
        const includeMarketBook = opts?.wantMarkets !== false;
        if (data.msg_type && data.last_update) {
            let timeStamp = parseFloat(data.last_update.split("-")[0]);
            const last_update = new Date(timeStamp);
        }
        if (data.lineups) {
            setLineup(data.lineups);
            const g = data.lineups?.competition?.gender;
            if (g != null && String(g).trim() !== "") setCompetitionGender(String(g).trim());
        }
        if (data.match_update) {
            const normalizedFormat = (0, _cricketTestMatch.normalizeCricketFormatCode)(data.match_update.format);
            if (normalizedFormat != null) setFormat(normalizedFormat);
            if (data.match_update.betting_status) setMatchTradingStatus(data.match_update.betting_status);
            // Extract match start datetime if available
            if (data.match_update.start_datetime) setMatchStartDateTime(data.match_update.start_datetime);
        }
        // Backend delta stream sends format on event, not match_update
        if (!skipCricketSnapshot && data.event) {
            const fromFormat = data.event.format != null ? (0, _cricketTestMatch.normalizeCricketFormatCode)(data.event.format) : null;
            const fromMaxOvers = (0, _cricketTestMatch.isCricketTestMaxOvers)(data.event.max_overs) ? (0, _cricketTestMatch.CRICKET_TEST_FORMAT_CODE) : data.event.max_overs != null ? (0, _cricketTestMatch.normalizeCricketFormatCode)(data.event.max_overs) : null;
            const formatVal = fromFormat ?? fromMaxOvers;
            if (formatVal != null) setFormat(formatVal);
        }
        if (!skipCricketSnapshot && data.event?.gender != null && String(data.event.gender).trim() !== "") setCompetitionGender(String(data.event.gender).trim());
        if (data.market_update && !skipMarketData) {
            if (data.market_update.start_datetime) setMatchStartDateTime(data.market_update.start_datetime);
            if (includeMarketBook) {
                // Backend sends markets already filtered by allowed list; use as-is
                const filteredMarkets = data.market_update.markets ?? [];
                let tm = trading;
                filteredMarkets.forEach((mk, id)=>{
                    let existingIndex = tm.findIndex((item)=>String(item.market_id) === String(mk.market_id));
                    if (existingIndex === -1) tm.push(mk);
                    else tm[existingIndex] = mk;
                });
                tm.sort((a, b)=>parseInt(a.display_order, 10) - parseInt(b.display_order, 10));
                setTrading(tm);
            }
            applyWinProbabilityUpdate(data, skipCricketSnapshot);
        } //**commentary */
        if (data.commentary) {
            let commentary = data.commentary;
            setCommentary((prevC)=>mergeCommentariesIntoState(prevC, commentary));
            // Use functional update to always work with the latest state, preventing duplicates from rapid updates
            setFullComm((prevComms)=>{
                // Create a copy of the existing commentary array
                let comms = [
                    ...prevComms
                ];
                // Use a Map for O(1) lookup and to track the latest state
                const commsMap = new Map(comms.map((item)=>[
                        fullCommItemKey(item),
                        item
                    ]));
                // Track entries processed in this update cycle to prevent duplicates within the same payload
                const processedInThisUpdate = new Set();
                for(let inns = 1; inns <= 4; inns++){
                    let insKey = "inns" + inns;
                    if (commentary.commentaries[insKey]) commentary.commentaries[insKey].forEach((com, idx)=>{
                        const { over0, delivery1, ballValue } = parseCommentaryBallFields(com.ball);
                        let ov = over0;
                        let ba = delivery1;
                        let commKey = fullCommEntryKey(insKey, com.ball ?? ballValue, com.commentary ?? "");
                        // Skip if we've already processed this entry in the current update
                        if (processedInThisUpdate.has(commKey)) return; // Skip duplicate within the same payload
                        // Fine-id legal outcome replaces any prior row for that exact ball id (e.g. mistaken
                        // "wide + 4" corrected to "Four", including legacy keys that tagged extras separately).
                        const resultPart = com.commentary?.split(",")[1]?.trim() ?? "";
                        const incomingIsExtra = isNonOutcomeCommentaryResult(resultPart) || /\bwide\b|\bno\s*ball\b|\bnb\b|\bwd\b/.test(String(com.commentary ?? "").toLowerCase());
                        const feedBallValue = typeof com.ball === "number" ? com.ball : ballValue;
                        const incomingIsFine = Number.isFinite(feedBallValue) && Math.abs(feedBallValue - (over0 + delivery1 / 10)) >= 1e-9;
                        if (!incomingIsExtra && incomingIsFine) for (const [k, item] of [
                            ...commsMap.entries()
                        ]){
                            if (k === commKey) continue;
                            const itemBall = item.feedBall ?? item.over + item.ball / 10;
                            if (itemBall !== feedBallValue) continue;
                            commsMap.delete(k);
                            const removeIdx = comms.findIndex((c)=>fullCommItemKey(c) === k);
                            if (removeIdx !== -1) comms.splice(removeIdx, 1);
                        }
                        // Check if this commentary entry already exists in previous state
                        if (commsMap.has(commKey)) {
                            // Update existing entry
                            const existingItem = commsMap.get(commKey);
                            if (existingItem) {
                                const csplit = com.commentary.split(",");
                                const res = csplit[1];
                                const fr = csplit[0].split(" to ")[0];
                                const tr = csplit[0].split(" to ")[1];
                                const updated = {
                                    ...existingItem,
                                    commentary: com.commentary,
                                    ballFrom: fr,
                                    ballTo: tr,
                                    result: res?.trim(),
                                    feedBall: com.ball,
                                    _corrected: Boolean(com._corrected),
                                    _correctedFrom: typeof com._correctedFrom === "string" ? com._correctedFrom : undefined
                                };
                                commsMap.set(commKey, updated);
                                const idx = comms.findIndex((c)=>fullCommItemKey(c) === commKey);
                                if (idx !== -1) comms[idx] = updated;
                            }
                            processedInThisUpdate.add(commKey);
                            return; // Skip adding duplicate
                        }
                        // Add new entry
                        let csplit = com.commentary.split(",");
                        let res = csplit[1];
                        let fr = csplit[0].split(" to ")[0];
                        let tr = csplit[0].split(" to ")[1];
                        let newObject = {
                            inns: insKey,
                            over: ov,
                            ball: ba,
                            feedBall: com.ball,
                            commentary: com.commentary,
                            ballFrom: fr,
                            ballTo: tr,
                            result: res?.trim(),
                            _corrected: Boolean(com._corrected),
                            _correctedFrom: typeof com._correctedFrom === "string" ? com._correctedFrom : undefined
                        };
                        comms.unshift(newObject);
                        commsMap.set(commKey, newObject); // Track this entry to prevent duplicates
                        processedInThisUpdate.add(commKey); // Mark as processed in this update
                    });
                }
                comms.sort(compareFullCommDisplayOrder);
                return comms;
            });
        }
        // Scorecard uses its own last_update lane — do not gate on the cricket/event version skip.
        if (data.scorecard && !skipScorecard) {
            const mid = match_id != null ? String(match_id) : "";
            const merged = (0, _mergeDecimalScorecardDelta.mergeDecimalScorecardDelta)(mid ? mergedScorecardByMatchIdRef.current.get(mid) ?? null : null, data.scorecard);
            if (mid) mergedScorecardByMatchIdRef.current.set(mid, merged);
            const scorecard = merged;
            setScorecardData(scorecard);
            if (scorecard?.event_status != null) applyEventStatusFromFeed(scorecard.event_status);
        }
        if (data.alerts) setAlerts(data.alerts);
        const battingAnalysisMsg = (0, _cricketLiveBallSignals.battingAnalysisFromMessage)(data);
        if (battingAnalysisMsg) setBattingAnalysis(battingAnalysisMsg);
        if (data.event && !skipCricketSnapshot) EventProc(data.event, match_id);
    }, [
        trading,
        applyWinProbabilityUpdate
    ]);
    const EventProc = (0, _react.useCallback)(async (event, matchId)=>{
        if (!event || typeof event !== "object") return;
        if (event?.gender != null && String(event.gender).trim() !== "") setCompetitionGender(String(event.gender).trim());
        const scoreboard = event.scoreboard;
        if (!Array.isArray(scoreboard) || scoreboard.length === 0) return;
        const getScoreboardValue = (name)=>scoreboard.find((item)=>item.name === name)?.value?.toString?.().trim?.() ?? "";
        const parseScoreInt = (name)=>{
            const v = parseInt(getScoreboardValue(name), 10);
            return Number.isNaN(v) ? null : v;
        };
        const deriveWinTextFromScoreboard = ()=>{
            const winnerName = getScoreboardValue("winner");
            const winnerOk = (0, _decimalEventStatus.isDecimalTeamWinner)(winnerName);
            const possibleMarginKeys = [
                "wonby",
                "won_by",
                "win_by",
                "winning_margin",
                "result",
                "match_result",
                "victory_margin"
            ];
            for (const key of possibleMarginKeys){
                const val = getScoreboardValue(key);
                if (!val) continue;
                if (/\bwon\b|\bwins?\b|\bruns?\b|\bwickets?\b|\btied?\b|\bdraw/i.test(val)) return val;
                if (winnerOk && /\bruns?\b|\bwickets?\b/i.test(val)) return `${winnerName} won by ${val}`;
            }
            // Decimal completed deltas sometimes leave batting.1 / home empty — use winner as name fallback.
            const bat1 = getScoreboardValue("batting.1") || getScoreboardValue("home");
            const bat2 = getScoreboardValue("batting.2") || getScoreboardValue("away");
            const r1 = parseScoreInt("runs.1");
            const r2 = parseScoreInt("runs.2");
            const w2 = parseScoreInt("wkts.2");
            if (r1 == null || r2 == null) return "";
            // Between innings the chase side is still 0/0 — never invent "Team won by N runs".
            const chaseNotStarted = r2 === 0 && (w2 == null || w2 === 0);
            if (r2 > r1) {
                const name = bat2 || (winnerOk ? winnerName : "");
                if (!name) return "";
                const wicketsInHand = w2 == null ? 10 : Math.max(0, 10 - w2);
                return `${name} won by ${wicketsInHand} wicket${wicketsInHand !== 1 ? "s" : ""}`;
            }
            if (r1 > r2) {
                if (chaseNotStarted && !winnerOk) return "";
                const name = bat1 || (winnerOk ? winnerName : "");
                if (!name) return "";
                return `${name} won by ${r1 - r2} runs`;
            }
            if (chaseNotStarted && !winnerOk) return "";
            return "Match tied";
        };
        const matchTitleObj = scoreboard.find((item)=>item.name === "matchtitle");
        const game_phaseObj = scoreboard.find((item)=>item.name === "game_phase");
        const local_timeObj = scoreboard.find((item)=>item.name === "local_time");
        const channelObj = scoreboard.find((item)=>item.name === "channel");
        const homeObj = scoreboard.find((item)=>item.name === "home");
        const awayObj = scoreboard.find((item)=>item.name === "away");
        const battingObj = scoreboard.find((item)=>item.name === "Current Batting Team");
        const commentObj = scoreboard.find((item)=>item.name === "match_comment");
        const winnerObj = scoreboard.find((item)=>item.name === "winner");
        let comment = commentObj?.value?.trim?.() ?? "";
        const winner = winnerObj?.value?.trim?.() ?? "";
        const gamePhase = game_phaseObj?.value ?? "";
        const isRrrComment = (0, _decimalEventStatus.isCricketRrrComment)(comment);
        // Clear a false finished latch from misreading "Innings Complete" as match over.
        const phaseLower = String(gamePhase).toLowerCase();
        const clearlyStillLivePhase = /\binnings?\s+complete\b/.test(phaseLower) || phaseLower.includes("match in progress") || phaseLower.includes("in play");
        if (clearlyStillLivePhase && matchFinishedLatchRef.current && !(0, _decimalEventStatus.isMatchFinishedStatus)(eventStatusRef.current) && // VOID still means the fixture is decided (abandoned); only NA/empty can unlatch.
        (!winner || winner.toUpperCase() === "NA")) matchFinishedLatchRef.current = false;
        const isFinished = (0, _decimalEventStatus.resolveCricketMatchFinished)({
            eventStatus: eventStatusRef.current,
            gamePhase,
            winner,
            matchComment: comment
        });
        if (isFinished) matchFinishedLatchRef.current = true;
        // Finished matches: drop chase / scoreline commentary (e.g. "Surrey are 156 for 7 after 19.6 overs.")
        // so we can show the who-won line instead.
        if (isFinished && (isRrrComment || !(0, _decimalEventStatus.commentIndicatesCricketMatchResult)(comment))) comment = "";
        let matchCommentToSet = comment || ((0, _decimalEventStatus.isDecimalTeamWinner)(winner) ? `${winner} wins.` : "");
        if (isFinished) {
            // Prefer game_phase / status "Match Complete - X won by …" — scoreboard runs are often
            // incomplete on completed deltas, and live match_comment is frequently chase commentary.
            const fromPhase = (0, _decimalEventStatus.resultCommentFromEventStatus)(gamePhase) || (0, _decimalEventStatus.resultCommentFromEventStatus)(eventStatusRef.current);
            const derivedWinText = deriveWinTextFromScoreboard();
            if (fromPhase) matchCommentToSet = fromPhase;
            else if (derivedWinText) matchCommentToSet = derivedWinText;
        }
        guardedSetMatchComment(matchCommentToSet);
        if (local_timeObj) {
            let localdt = new Date(local_timeObj.value);
            let formattedDate = localdt.getDate().toString().padStart(2, "0") + "/" + (localdt.getMonth() + 1).toString().padStart(2, "0") + "/" + localdt.getFullYear();
            setLocalTime(formattedDate);
        }
        let matchname = matchTitleObj ? matchTitleObj.value : " , , ";
        const parts = matchname.split(",");
        setMatchName((parts[1] ?? "").trim());
        setLocation((parts[2] ?? "").trim()); //setTournament((parts[0] ?? "").trim())
        setGamePhase((prev)=>{
            const next = game_phaseObj?.value;
            if (next == null || String(next).trim() === "") return prev;
            return String(next);
        });
        applyTeamsFromFeed(homeObj ? homeObj.value : "", awayObj ? awayObj.value : "");
        setBatting(battingObj ? battingObj.value : "");
        const CurInns = scoreboard.find((item)=>item.name === "Current Innings");
        const CurOvrs = scoreboard.find((item)=>item.name === "Current Innings Overs");
        const CurPart = scoreboard.find((item)=>item.name === "Current Innings Part Overs");
        // Preserve prior CurPos when a thin scoreboard frame omits overs fields —
        // resetting to [0,0,0] falsely opens Squares overs 1–2 mid-innings / on break.
        setCurPos((prev)=>{
            const next = [
                CurInns ? CurInns.value : prev?.[0] ?? 0,
                CurOvrs ? CurOvrs.value : prev?.[1] ?? 0,
                CurPart ? CurPart.value : prev?.[2] ?? 0
            ];
            if (prev && prev.length >= 3 && prev[0] === next[0] && prev[1] === next[1] && prev[2] === next[2]) return prev;
            return next;
        });
        setCurrentInnings(CurInns ? CurInns.value : 0);
        const maxOvers = scoreboard.find((item)=>item.name === "Max Overs");
        if (maxOvers?.value != null && String(maxOvers.value).trim() !== "") {
            const liveMax = (0, _cricketMatchCardOverDisplay.parseCricketFixtureFormatOvers)(maxOvers.value);
            if (liveMax != null) setScoreboardMaxOvers(liveMax);
        }
        const reduced = (0, _cricketReducedOvers.scoreboardOversReduced)(scoreboard);
        if (reduced != null) setOversReduced(reduced);
        const batting1 = scoreboard.find((item)=>item.name === "batting.1");
        const batting1Runs = scoreboard.find((item)=>item.name === "runs.1");
        const batting1Wkts = scoreboard.find((item)=>item.name === "wkts.1");
        const batting1MaxOvers = scoreboard.find((item)=>item.name === "max.1");
        const batting1Overs = scoreboard.find((item)=>item.name === "overs.1");
        const batting2 = scoreboard.find((item)=>item.name === "batting.2");
        const batting2Wkts = scoreboard.find((item)=>item.name === "wkts.2");
        const batting2MaxOvers = scoreboard.find((item)=>item.name === "max.2");
        const batting2Overs = scoreboard.find((item)=>item.name === "overs.2");
        const batting3Overs = scoreboard.find((item)=>item.name === "overs.3");
        const batting4Overs = scoreboard.find((item)=>item.name === "overs.4");
        const batting2Runs = scoreboard.find((item)=>item.name === "runs.2");
        let battingScore = "0/0";
        if (CurInns && CurOvrs) {
            const curInnsRunsItem = scoreboard.filter((item)=>String(item?.name ?? "").includes(`runs.${CurInns.value}`));
            if (curInnsRunsItem && curInnsRunsItem.length > 0) {
                const curInnsPartOvers = scoreboard.find((item)=>item.name === "Current Innings Part Overs");
                const curInnsRuns = parseInt(curInnsRunsItem[0].value);
                const curInnsOvers = parseInt(CurOvrs.value);
                const currInnsPart = parseInt(curInnsPartOvers.value);
                const realOvers = (curInnsOvers * 6 + currInnsPart) / 6;
                setRunRate((curInnsRuns / realOvers).toFixed(2));
            }
        }
        let b1mo = batting1MaxOvers ? batting1MaxOvers.value : 0;
        let b2mo = batting2MaxOvers ? batting2MaxOvers.value : 0;
        let b1o = batting1Overs ? batting1Overs.value : 0;
        let b2o = batting2Overs ? batting2Overs.value : 0;
        let b3o = batting2Overs ? batting3Overs.value : 0;
        let b4o = batting2Overs ? batting4Overs.value : 0;
        setBattingOvers([
            b1o,
            b2o,
            b3o,
            b4o
        ]);
        let b1r = batting1Runs ? batting1Runs.value : 0;
        let b2r = batting2Runs ? batting2Runs.value : 0;
        let b1w = batting1Wkts ? batting1Wkts.value : 0;
        let b2w = batting2Wkts ? batting2Wkts.value : 0;
        let teambowl = "", teambat = "";
        setMOvers([
            b1mo,
            b2mo
        ]);
        let homeOver = b1o + "/" + b1mo;
        if (b1o === b1mo) homeOver = b1mo;
        let awayOver = b2o + "/" + b2mo;
        if (b2o === b2mo) awayOver = b2mo;
        if (awayOver === "") awayOver = "0/" + (maxOvers?.value ?? "");
        let bat1Prog = b1r + "/" + b1w;
        if (bat1Prog === "/") bat1Prog = "0/0";
        let bat2Prog = b2r + "/" + b2w;
        if (bat2Prog === "/") bat2Prog = "0/0";
        let batx1 = batting1 ? batting1.value : "";
        if (batx1 === (homeObj?.value ?? "")) {
            guardedSetScore([
                bat1Prog,
                bat2Prog
            ]);
            setOvers([
                homeOver,
                awayOver
            ]);
            battingScore = bat1Prog;
            teambat = awayObj?.value ?? "";
            teambowl = homeObj?.value ?? "";
        } else {
            guardedSetScore([
                bat2Prog,
                bat1Prog
            ]);
            setOvers([
                awayOver,
                homeOver
            ]);
            battingScore = bat2Prog;
            teambat = awayObj?.value ?? "";
            teambowl = homeObj?.value ?? "";
        }
        let batv = battingObj ? battingObj.value : "";
        const bat1 = scoreboard.find((item)=>item.name === batv + "Bat.1");
        const bat2 = scoreboard.find((item)=>item.name === batv + "Bat.2");
        // Decimal API Appendix 6: "Batsman1 Strike" / "Batsman2 Strike" = 0 or 1 indicate who is on strike
        const strike1 = scoreboard.find((item)=>item.name === "Batsman1 Strike");
        let bowl1 = scoreboard.find((item)=>item.name === "bowler1name");
        let bowl2 = scoreboard.find((item)=>item.name === "bowler2name");
        const runs1 = scoreboard.find((item)=>item.name === "Batsman1 Runs");
        const runs2 = scoreboard.find((item)=>item.name === "Batsman2 Runs");
        let bowl1overs = scoreboard.find((item)=>item.name === "bowler1overs");
        let bowl1runs = scoreboard.find((item)=>item.name === "bowler1runs");
        let bowl1wicks = scoreboard.find((item)=>item.name === "bowler1wickets");
        let bowl2overs = scoreboard.find((item)=>item.name === "bowler2overs");
        let bowl2runs = scoreboard.find((item)=>item.name === "bowler2runs");
        let bowl2wicks = scoreboard.find((item)=>item.name === "bowler2wickets");
        const balls1 = scoreboard.find((item)=>item.name === batv + "Bat.1balls");
        const balls2 = scoreboard.find((item)=>item.name === batv + "Bat.2balls");
        // Current batter = who is on strike per API: Batsman1 Strike "1" => Bat.1, else Bat.2
        const isBatsman1OnStrike = (strike1?.value ?? "1") === "1";
        const strikerbatter = isBatsman1OnStrike ? bat1?.value ?? "" : bat2?.value ?? "";
        const batterruns = isBatsman1OnStrike ? runs1?.value ?? 0 : runs2?.value ?? 0;
        const batterballs = isBatsman1OnStrike ? balls1?.value ?? 0 : balls2?.value ?? 0;
        setStriker(strikerbatter);
        let actbowl = scoreboard.find((item)=>item.name === "bowler");
        let bowlovers = "0 overs";
        let bowlruns = "0";
        let bowlwickets = "0";
        if (bowl1 ? bowl1.value : false) {
            actbowl = bowl1.value;
            bowlovers = bowl1overs.value;
            bowlruns = bowl1runs.value;
            bowlwickets = bowl1wicks.value;
        } else {
            actbowl = bowl2 ? bowl2.value : "";
            bowlovers = bowl2overs ? bowl2overs.value : "";
            bowlruns = bowl2runs ? bowl2runs.value : "";
            bowlwickets = bowl2wicks ? bowl2wicks.value : "";
        }
        setBowling(actbowl);
        setPartnership({
            bowler: actbowl,
            bowlerover: bowlovers,
            bowlerruns: bowlruns,
            bowlerwickets: bowlwickets,
            bowler2: bowl2 ? bowl2.value : "",
            bowlerover2: bowl2overs ? bowl2overs.value : "",
            bowlerruns2: bowl2runs ? bowl2runs.value : "",
            bowlerwickets2: bowl2wicks ? bowl2wicks.value : "",
            bowlteam: teambowl,
            batteam: teambat,
            batter: strikerbatter,
            batterruns: batterruns,
            batterballs: batterballs,
            batter2: bat2?.value ? bat2.value : "",
            batterruns2: runs2?.value ? runs2.value : "",
            batterballs2: balls2?.value ? balls2.value : ""
        }); /** feed events */ 
        if (Array.isArray(event.score) && event.score.length > 0) {
            setBallResults((0, _cricketLiveBallSignals.ballResultsFromEventScore)(event.score));
            const scoreIdx = event.score.findIndex((itm)=>itm && itm.priority === 1);
            const scItem = scoreIdx >= 0 ? event.score[scoreIdx] : null;
            if (scItem && scItem.result != null) {
                const tEvent = String(scItem.result);
                if (tEvent.substring(0, 6).toUpperCase() === "WICKET" || tEvent.includes("6 runs") || tEvent.includes("4 runs")) {
                    setIncomingEvent(true);
                    if (matchId) setTimeout(()=>{
                        fetchEvents(matchId);
                    }, 2000);
                }
            }
        }
    }, []);
    const fetchEvents = (0, _react.useCallback)(async (match_id)=>{
        try {
            const response = await fetch(`${"https://cricket8.com/api"}/events/${match_id}`, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            if (response.status === 200) {
                const data = await response.json();
                setStream(data.stream.trim());
                if (data.stream.trim() === "2") {
                    setSubHeader("stream");
                    if (embedcode === "") getEmbedCode(match_id);
                }
                setFeed(data.data);
                setIncomingEvent(false);
            }
        } catch (error) {
            return null;
        }
    }, [
        embedcode,
        getEmbedCode
    ]);
    const fetchScoreGrid = (0, _react.useCallback)(async (match_id, scoreGridData)=>{
        const data = scoreGridData;
        const overs = data.overs;
        let scoreDisplay = [];
        for(let inns = 1; inns <= 4; inns++){
            const currentInns = overs[`inns${inns}`];
            if (currentInns) currentInns.forEach((over)=>{
                let ignoreOver = true;
                for(let i = 1; i <= 12; i++){
                    const ballKey = `b${i}`;
                    const ballValue = over[ballKey];
                    if (ballValue !== null && ballValue !== "") {
                        ignoreOver = false;
                        scoreDisplay.push(ballValue);
                    }
                }
                if (!ignoreOver) scoreDisplay.push("OVER " + over.ov);
            });
        }
        setScoregrid(scoreDisplay.reverse());
    }, []);
    const applyScoregridFromParsed = (0, _react.useCallback)((matchId, parsedData)=>{
        const sg = parsedData?.scoregrid;
        if (!sg || typeof sg !== "object" || !sg.overs) return;
        const v = parseLastUpdateVersion(parsedData.last_update);
        const map = latestScoregridLastUpdatePerMatchRef.current;
        const prevSg = map.get(matchId);
        if (v != null && prevSg != null && v < prevSg) {
            const incoming = (0, _scoregridLatestBowling.extractLatestBowlingRowFromScoregrid)(sg);
            const curSg = scoreGridDataRef.current;
            const current = curSg && typeof curSg === "object" && curSg.overs ? (0, _scoregridLatestBowling.extractLatestBowlingRowFromScoregrid)(curSg) : null;
            if (incoming && current && incoming.inns === current.inns && Number(incoming.ov) === Number(current.ov)) {
                const incN = (0, _squaresBallResults.filterToCountedBallResults)(incoming.delivery).length;
                const curN = (0, _squaresBallResults.filterToCountedBallResults)(current.delivery).length;
                if (incN > curN) {
                    setSquaresStaleScoregridBallSupplement({
                        matchId: String(matchId),
                        inns: incoming.inns,
                        ov: incoming.ov,
                        delivery: incoming.delivery
                    });
                    // Keep the live delivery strip in sync; otherwise Squares "over in play" only saw bumps via
                    // supplement merge and `overDelivery` could stay stale until a full non-stale scoregrid apply.
                    setOverDelivery(incoming.delivery);
                }
            }
            return;
        }
        setSquaresStaleScoregridBallSupplement((prev)=>prev != null && String(prev.matchId) === String(matchId) ? null : prev);
        if (v != null) map.set(matchId, v);
        setScoreGridData(sg);
        fetchScoreGrid(matchId, sg);
        let found = false;
        for(let i = 4; i >= 1 && !found; i--){
            const thisInns = sg.overs["inns" + i];
            if (!Array.isArray(thisInns) || thisInns.length === 0) continue;
            for(let ov = thisInns.length - 1; ov >= 0; ov--){
                const row = thisInns[ov];
                if (row && row.bowler !== "" && row.bowlerid !== "") {
                    const delivery = [
                        row.b1,
                        row.b2,
                        row.b3,
                        row.b4,
                        row.b5,
                        row.b6,
                        row.b7,
                        row.b8,
                        row.b9,
                        row.b10,
                        row.b11,
                        row.b12
                    ];
                    setOverDelivery(delivery);
                    found = true;
                    break;
                }
            }
        }
    }, [
        fetchScoreGrid,
        parseLastUpdateVersion
    ]);
    const subscribeToMatches = (0, _react.useCallback)((matchIds, feedFilter, cb)=>{
        // Guard against undefined/null matchIds or empty array
        if (!matchIds || !Array.isArray(matchIds) || matchIds.length === 0) {
            console.warn("subscribeToMatches called with invalid matchIds:", matchIds);
            return ()=>{}; // Return a no-op unsubscribe function
        }
        // Filter out any undefined/null values from matchIds
        const validMatchIds = matchIds.filter((id)=>id != null && id !== 'undefined' && id !== 'null');
        if (validMatchIds.length === 0) {
            console.warn("subscribeToMatches: no valid matchIds after filtering");
            return ()=>{};
        }
        const wantMarkets = feedWantsMarkets(feedFilter);
        const baseApi = "https://cricket8.com/stream";
        const url = `${baseApi}?matchIds=${validMatchIds.join(',')}`;
        const es = new EventSource(url, {
            withCredentials: false
        });
        es.addEventListener("open", ()=>{
            validMatchIds.forEach((id)=>clearMatchFeedVersionGuards(String(id)));
        });
        es.addEventListener("message", async function incoming(event) {
            let parsedData;
            try {
                parsedData = JSON.parse(event.data);
            } catch (e) {
                return;
            }
            if (!parsedData) return;
            if (parsedData.market_update) parsedData = {
                ...parsedData,
                market_update: (0, _unwrapStreamMarketUpdate.unwrapStreamMarketUpdate)(parsedData.market_update)
            };
            // If feed_id is missing, we can't safely process this event for multi-match subscriptions
            const currentMatchIdForEvent = parsedData.feed_id;
            if (!currentMatchIdForEvent) {
                // If feed_id is missing and we're subscribed to multiple matches, skip this event
                // to avoid associating data with the wrong match
                if (validMatchIds.length > 1) return;
                // Only use fallback if we're subscribed to a single match (safe assumption)
                if (validMatchIds.length === 1) ;
                else // No valid matchIds, can't process
                return;
            }
            // Use feed_id if available, otherwise fallback to single matchId (only safe when length === 1)
            const matchIdToUse = currentMatchIdForEvent || validMatchIds[0];
            const mid = String(matchIdToUse);
            const lu = parsedData.last_update;
            applyScoregridFromParsed(mid, parsedData);
            const skipCricket = isStaleCricketFeedVersion(mid, lu);
            const skipScorecard = isStaleScorecardFeedVersion(mid, lu);
            const rawMarketsMulti = parsedData.market_update?.markets ?? [];
            const marketLuStale = isStaleMarketFeedVersion(mid, lu);
            const carrySettledMarketUpdates = rawMarketsMulti.some((m)=>liveMarketRowIndicatesFinalSettlement(m));
            const skipMarket = rawMarketsMulti.length > 0 && marketLuStale && !carrySettledMarketUpdates;
            skipCricket && (parsedData.event || parsedData.scoreboard);
            skipScorecard && parsedData.scorecard;
            skipMarket && rawMarketsMulti.length;
            // ----------------------------- market_update -------------------------
            // Full books use market_snapshot (replace/evict). Empty markets (e.g. global_betting_status off) do not overwrite.
            // `settled_market_keys` deletes Appendix-4 finals that SSE omits from `markets[]`.
            if (parsedData.market_update) {
                if (parsedData.market_update.event_status != null) applyEventStatusFromFeed(parsedData.market_update.event_status);
                if (parsedData.market_update.betting_status != null) setMatchTradingStatus(parsedData.market_update.betting_status);
                const rawMarkets = parsedData.market_update.markets ?? [];
                if (!skipMarket && wantMarkets) {
                    let bookChanged = false;
                    if (rawMarkets.length > 0) {
                        const fullSnapshot = streamMessageIsMarketSnapshot(parsedData);
                        if (marketLuStale && carrySettledMarketUpdates) applyMarketsFromStreamMessage(marketDataMapRef.current, rawMarkets, {
                            staleSettledOnly: true
                        });
                        else applyMarketsFromStreamMessage(marketDataMapRef.current, rawMarkets, {
                            fullSnapshot
                        });
                        bookChanged = true;
                    }
                    if (applySettledMarketKeyRemovals(marketDataMapRef.current, parsedData)) bookChanged = true;
                    if (bookChanged) scheduleMarketDataFlush();
                    if (rawMarkets.length > 0) applyWinProbabilityUpdate(parsedData, skipCricket);
                }
            }
            if (parsedData.event && !skipCricket) {
                if (String(parsedData.event.event_description ?? "").includes("Pre Match Service")) {
                    setPrematch(true);
                    const preMatchScoreboard = eventScoreboardRows(parsedData.event);
                    if (preMatchScoreboard.length > 0) {
                        const scoreboard = preMatchScoreboard;
                        const homeObj = scoreboard.find((item)=>item.name === "home");
                        const awayObj = scoreboard.find((item)=>item.name === "away");
                        applyTeamsFromFeed(homeObj ? homeObj.value : "", awayObj ? awayObj.value : "");
                    }
                    setGamePhase((prev)=>prev ? prev : "Scheduled");
                } else {
                    setPrematch(false);
                    const scoreboard = eventScoreboardRows(parsedData.event);
                    if (scoreboard.length === 0) ;
                    else {
                        const matchTitleObj = scoreboard.find((item)=>item.name === "matchtitle");
                        const game_phaseObj = scoreboard.find((item)=>item.name === "game_phase");
                        const local_timeObj = scoreboard.find((item)=>item.name === "local_time");
                        const homeObj = scoreboard.find((item)=>item.name === "home");
                        const awayObj = scoreboard.find((item)=>item.name === "away");
                        const battingObj = scoreboard.find((item)=>item.name === "Current Batting Team");
                        let localdt = new Date(local_timeObj ? local_timeObj.value : "");
                        let formattedDate = localdt.getDate().toString().padStart(2, "0") + "/" + (localdt.getMonth() + 1).toString().padStart(2, "0") + "/" + localdt.getFullYear();
                        let matchname = matchTitleObj ? matchTitleObj.value : "";
                        const parts = matchname.split(",");
                        if (parts.length > 2) {
                            setMatchName(parts[0].trim());
                            setLocation(parts[2].trim());
                            setTournament(parts[1].trim());
                        }
                        setGamePhase((prev)=>{
                            const next = game_phaseObj?.value;
                            if (next == null || String(next).trim() === "") return prev;
                            return String(next);
                        });
                        setLocalTime(formattedDate);
                        applyTeamsFromFeed(homeObj ? homeObj.value : "", awayObj ? awayObj.value : "");
                        setBatting(battingObj ? battingObj.value : "");
                        const CurInns = scoreboard.find((item)=>item.name === "Current Innings");
                        const CurOvrs = scoreboard.find((item)=>item.name === "Current Innings Overs");
                        const CurPart = scoreboard.find((item)=>item.name === "Current Innings Part Overs");
                        setCurPos((prev)=>{
                            const next = [
                                CurInns ? CurInns.value : prev?.[0] ?? 0,
                                CurOvrs ? CurOvrs.value : prev?.[1] ?? 0,
                                CurPart ? CurPart.value : prev?.[2] ?? 0
                            ];
                            if (prev && prev.length >= 3 && prev[0] === next[0] && prev[1] === next[1] && prev[2] === next[2]) return prev;
                            return next;
                        });
                        const maxOvers = scoreboard.find((item)=>item.name === "Max Overs");
                        if (maxOvers?.value != null && String(maxOvers.value).trim() !== "") {
                            const liveMax = (0, _cricketMatchCardOverDisplay.parseCricketFixtureFormatOvers)(maxOvers.value);
                            if (liveMax != null) setScoreboardMaxOvers(liveMax);
                        }
                        const reduced = (0, _cricketReducedOvers.scoreboardOversReduced)(scoreboard);
                        if (reduced != null) setOversReduced(reduced);
                        const batting1 = scoreboard.find((item)=>item.name === "batting.1");
                        const batting1Runs = scoreboard.find((item)=>item.name === "runs.1");
                        const batting1Wkts = scoreboard.find((item)=>item.name === "wkts.1");
                        const batting1MaxOvers = scoreboard.find((item)=>item.name === "max.1");
                        const batting1Overs = scoreboard.find((item)=>item.name === "overs.1");
                        const batting2 = scoreboard.find((item)=>item.name === "batting.2");
                        const batting2Runs = scoreboard.find((item)=>item.name === "runs.2");
                        const batting2Wkts = scoreboard.find((item)=>item.name === "wkts.2");
                        const batting2MaxOvers = scoreboard.find((item)=>item.name === "max.2");
                        const batting2Overs = scoreboard.find((item)=>item.name === "overs.2");
                        let b1mover = batting1MaxOvers ? batting1MaxOvers.value : "";
                        let b2mover = batting2MaxOvers ? batting2MaxOvers.value : "";
                        let b1over = batting1Overs ? batting1Overs.value : "";
                        let b2over = batting2Overs ? batting2Overs.value : "";
                        let homeOver = b1over + "/" + b1mover;
                        if (b1over === b1mover) homeOver = b1mover;
                        let awayOver = b2over + "/" + b2mover;
                        let bat1Runs = batting1Runs ? batting1Runs.value : "";
                        let bat1Wkts = batting1Wkts ? batting1Wkts.value : "";
                        let bat2Runs = batting2Runs ? batting2Runs.value : "";
                        let bat2Wkts = batting2Wkts ? batting2Wkts.value : "";
                        if (b2over === b2mover) awayOver = b2mover;
                        if (awayOver === "") awayOver = "0/" + (maxOvers?.value ?? "");
                        let bat1Prog = bat1Runs + "/" + bat1Wkts;
                        if (bat1Prog === "/") bat1Prog = "0/0";
                        let bat2Prog = bat2Runs + "/" + bat2Wkts;
                        if (bat2Prog === "/") bat2Prog = "0/0";
                        if ((batting1 ? batting1.value : "") === (homeObj?.value ?? "")) {
                            guardedSetScore([
                                bat1Prog,
                                bat2Prog
                            ]);
                            setOvers([
                                homeOver,
                                awayOver
                            ]);
                        } else {
                            guardedSetScore([
                                bat2Prog,
                                bat1Prog
                            ]);
                            setOvers([
                                awayOver,
                                homeOver
                            ]);
                        }
                        const bat1 = scoreboard.find((item)=>item.name === battingObj ? battingObj.value : "Bat.1");
                        const bat2 = scoreboard.find((item)=>item.name === battingObj ? battingObj.value : "Bat.2");
                        const strike1 = scoreboard.find((item)=>item.name === "Batsman1 Strike");
                        const strike2 = scoreboard.find((item)=>item.name === "Batsman2 Strike");
                        let bowl1 = scoreboard.find((item)=>item.name === "bowler1name");
                        let bowl2 = scoreboard.find((item)=>item.name === "bowler2name");
                        const runs1 = scoreboard.find((item)=>item.name === "Batsman1 Runs");
                        const runs2 = scoreboard.find((item)=>item.name === "Batsman2 Runs");
                        let bowl1overs = scoreboard.find((item)=>item.name === "bowler1overs");
                        let bowl1runs = scoreboard.find((item)=>item.name === "bowler1runs");
                        let bowl1wicks = scoreboard.find((item)=>item.name === "bowler1wickets");
                        let bowl2overs = scoreboard.find((item)=>item.name === "bowler2overs");
                        let bowl2runs = scoreboard.find((item)=>item.name === "bowler2runs");
                        let bowl2wicks = scoreboard.find((item)=>item.name === "bowler2wickets");
                        const balls1 = scoreboard.find((item)=>item.name === battingObj ? battingObj.value : "Bat.1balls");
                        const balls2 = scoreboard.find((item)=>item.name === battingObj ? battingObj.value : "Bat.2balls");
                        let strikerbatter = "";
                        let batterruns = 0;
                        let batterballs = 0;
                        if (strike1 && strike1.value === "1") {
                            strikerbatter = bat1 ? bat1.value : 0;
                            batterruns = runs1?.value ?? 0;
                            batterballs = balls1?.value ?? 0;
                        } else {
                            strikerbatter = bat2 ? bat2.value : 0;
                            batterruns = runs2?.value ?? 0;
                            batterballs = balls2?.value ?? 0;
                        }
                        let actbowl = scoreboard.find((item)=>item.name === "bowler");
                        let bowlovers = "0 overs";
                        let bowlruns = "0";
                        let bowlwickets = "0";
                        if (bowl1?.value !== undefined && bowl1.value !== "") {
                            actbowl = bowl1.value;
                            bowlovers = (bowl1overs?.value ?? "") + " overs";
                            bowlruns = bowl1runs?.value ?? "";
                            bowlwickets = bowl1wicks?.value ?? "";
                        } else {
                            actbowl = bowl2?.value ?? "";
                            bowlovers = (bowl2overs?.value ?? "") + " overs";
                            bowlruns = bowl2runs?.value ?? "";
                            bowlwickets = bowl2wicks?.value ?? "";
                        }
                        setPartnership({
                            bowler: actbowl,
                            bowlerover: bowlovers,
                            bowlerruns: bowlruns,
                            bowlerwickets: bowlwickets,
                            batter: strikerbatter,
                            batterruns: batterruns,
                            batterballs: batterballs
                        });
                    }
                }
            }
            // ------------ score card ------------
            if (parsedData.event && !skipCricket) EventProc(parsedData.event, matchIdToUse);
            // ---------------- match details -----------------
            matchDetails(parsedData, matchIdToUse, cb, {
                skipCricketSnapshot: skipCricket,
                skipMarketData: skipMarket,
                skipScorecard: skipScorecard,
                wantMarkets
            });
            //-------------------------- match-play -----------------------------
            if (parsedData.event && !skipCricket) {
                const eventScoreboard = eventScoreboardRows(parsedData.event);
                const winner = eventScoreboard.find((item)=>item.name === "winner")?.value ?? "NA";
                const curOvs = eventScoreboard.find((item)=>item.name === "Current Innings Overs")?.value ?? "";
                const curDelv = eventScoreboard.find((item)=>item.name === "current.delv")?.value ?? "";
                const matchComment = eventScoreboard.find((item)=>item.name === "match_comment")?.value ?? "";
                const gamePhase = eventScoreboard.find((item)=>item.name === "game_phase")?.value ?? "";
                const currentBowler = eventScoreboard.find((item)=>item.name === "bowler")?.value ?? "";
                const currentBatting = eventScoreboard.find((item)=>item.name === "Current Batting Team")?.value ?? "";
                const batsman1 = eventScoreboard.find((item)=>item.name === currentBatting + "Bat.1")?.value ?? "";
                const batsman2 = eventScoreboard.find((item)=>item.name === currentBatting + "Bat.2")?.value ?? "";
                const strike1 = eventScoreboard.find((item)=>item.name === "Batsman1 Strike");
                const strike2 = eventScoreboard.find((item)=>item.name === "Batsman2 Strike");
                let ballStatus = "";
                if ((strike1?.value ?? "1") === "1") ballStatus = currentBowler + " to " + batsman1;
                else if ((strike2?.value ?? "1") === "1") ballStatus = currentBowler + " to " + batsman2;
                if (!(0, _decimalEventStatus.isDecimalTeamWinner)(winner)) {
                    setStatus(ballStatus);
                    setCurBall(curOvs + "." + curDelv);
                    setCurInnsOver(curOvs);
                } else {
                    setStatus(winner + " wins.");
                    setCurBall(null);
                }
            }
            if (parsedData.commentary) setCommentary((prevC)=>mergeCommentariesIntoState(prevC, parsedData.commentary));
            if (parsedData.scoreboard && !skipCricket) {
                setBattings([
                    parsedData.scoreboard.innings1battingteam,
                    parsedData.scoreboard.innings2battingteam,
                    parsedData.scoreboard.innings3battingteam,
                    parsedData.scoreboard.innings4battingteam
                ]);
                let stat = parsedData.scoreboard?.status.split("-")[0];
                if (parsedData.scoreboard.innings1battingteam === parsedData.scoreboard.home) {
                    setHomeOvers([
                        parsedData.scoreboard.innings1overs,
                        parsedData.scoreboard.innings3overs
                    ]);
                    setAwayOvers([
                        parsedData.scoreboard.innings2overs,
                        parsedData.scoreboard.innings4overs
                    ]);
                } else {
                    setAwayOvers([
                        parsedData.scoreboard.innings1overs,
                        parsedData.scoreboard.innings3overs
                    ]);
                    setHomeOvers([
                        parsedData.scoreboard.innings2overs,
                        parsedData.scoreboard.innings4overs
                    ]);
                }
                setMOvers([
                    parsedData.scoreboard.innings1max,
                    parsedData.scoreboard.innings2max,
                    parsedData.scoreboard.innings3max,
                    parsedData.scoreboard.innings4max
                ]);
            }
            if (parsedData.scorecard && !skipScorecard) {
                const cardMap = mergedScorecardByMatchIdRef.current;
                const mergedSc = (0, _mergeDecimalScorecardDelta.mergeDecimalScorecardDelta)(cardMap.get(mid) ?? null, parsedData.scorecard);
                cardMap.set(mid, mergedSc);
                if (typeof mergedSc?.description === "string" && mergedSc.description.includes(",")) {
                    const matchParts = mergedSc.description.split(",");
                    if (matchParts[0]?.includes(" v ")) {
                        setMatchTitle(matchParts.length >= 3 ? matchParts[1].trim() : "");
                        applyTeamsFromMatchTitlePart(matchParts[0]);
                    }
                }
                setInnsNow(mergedSc.inns_now);
                setBatNow(mergedSc.bat_now);
                const mp = typeof mergedSc?.description === "string" ? mergedSc.description.split(",") : [];
                if (mp[0]?.includes(" v ")) {
                    const s1 = inningRunsWktsLine(mergedSc.inns1);
                    const s2 = inningRunsWktsLine(mergedSc.inns2);
                    const s3 = inningRunsWktsLine(mergedSc.inns3);
                    const s4 = inningRunsWktsLine(mergedSc.inns4);
                    const insScore = [
                        s1,
                        s2,
                        s3,
                        s4
                    ];
                    const innsnow = mergedSc.inns_now;
                    let oppnow = 1;
                    let rptNow = 2;
                    if (innsnow === 1 || innsnow === 3) {
                        oppnow = 2;
                        rptNow = 1;
                    }
                    setLiveBat(mergedSc.bat_now);
                    if (mergedSc.bat_now === mp[0].split(" v ")[0]) guardedSetScore([
                        insScore[rptNow - 1],
                        insScore[oppnow - 1],
                        insScore[rptNow + 1],
                        insScore[oppnow + 1]
                    ]);
                    else guardedSetScore([
                        insScore[oppnow - 1],
                        insScore[rptNow - 1],
                        insScore[oppnow + 1],
                        insScore[rptNow + 1]
                    ]);
                }
                setScorecardData(mergedSc);
                if (mergedSc.event_status != null) applyEventStatusFromFeed(mergedSc.event_status);
            }
            if (parsedData.alerts) setAlerts(parsedData.alerts);
            const battingAnalysisMsg = (0, _cricketLiveBallSignals.battingAnalysisFromMessage)(parsedData);
            if (battingAnalysisMsg) setBattingAnalysis(battingAnalysisMsg);
            if (!skipCricket && (parsedData.event || parsedData.scoreboard)) bumpCricketFeedVersion(mid, lu);
            if (parsedData.scorecard && !skipScorecard) bumpScorecardFeedVersion(mid, lu);
            // Advance market monotonic guard on every non-stale market_update tick, including empty `markets`
            // (suspend / metadata-only). Otherwise a newer empty message never bumps the version and a slightly
            // older full list can be skipped as "stale", leaving removed markets on screen until refresh.
            if (parsedData.market_update && parseLastUpdateVersion(lu) != null && !marketLuStale) bumpMarketFeedVersion(mid, lu);
        //-------------------- match-play --------------------------
        //---------------------- trader-match-card ------------------------
        //----------------------- trader-match-card --------------------------
        });
        es.addEventListener("error", function error(ev) {
        // SSE error; browser may auto-retry. Logging for diagnostics.
        // console.error('SSE stream error', ev);
        });
        return ()=>{
            es.close();
        };
    }, [
        scheduleMarketDataFlush,
        applyWinProbabilityUpdate,
        EventProc,
        matchDetails,
        fetchScoreGrid,
        applyScoregridFromParsed,
        isStaleCricketFeedVersion,
        isStaleMarketFeedVersion,
        isStaleScorecardFeedVersion,
        bumpCricketFeedVersion,
        bumpMarketFeedVersion,
        bumpScorecardFeedVersion,
        clearMatchFeedVersionGuards,
        parseLastUpdateVersion
    ]);
    const subscribeToMatch = (0, _react.useCallback)((matchId, feedFilter, traderTeams, cb, product, tier, book)=>{
        /** Trader trades live Decimal prices, so it opts into the server-side house odds margin (`product=trader`). */ const productQuery = String(product ?? "").toLowerCase() === "trader" ? "trader" : "";
        /**
     * `tier=lobby` slims the feed (no commentary / scoregrid / lineups / full scorecard), except
     * `book=catalog` logged-out Trader match play which still sends live cricket chrome.
     * `book=catalog` (logged-out Trader match play) still sends every market, with live prices
     * only on Match Winner.
     */ const tierQuery = String(tier ?? "").toLowerCase() === "lobby" ? "lobby" : "";
        const bookQuery = String(book ?? "").toLowerCase() === "catalog" ? "catalog" : "";
        /** Combined `&`-prefixed query for the `initial-state` endpoint (which already has `matchIds`). */ const initialStateExtraQuery = `${productQuery ? `&product=${productQuery}` : ""}${tierQuery ? `&tier=${tierQuery}` : ""}${bookQuery ? `&book=${bookQuery}` : ""}`;
        /** Full `?`-prefixed query for the single-match SSE URL. */ const streamUrlQuery = [
            productQuery && `product=${productQuery}`,
            tierQuery && `tier=${tierQuery}`,
            bookQuery && `book=${bookQuery}`
        ].filter(Boolean).join("&");
        const streamUrlSuffix = streamUrlQuery ? `?${streamUrlQuery}` : "";
        // Guard against undefined/null matchId
        if (!matchId) {
            console.warn("subscribeToMatch called with undefined/null matchId");
            return ()=>{}; // Return a no-op unsubscribe function
        }
        /** Respect `feedFilter`: Bullion played view omits `market_update` — no live order-book merge; odds come from the frozen Bullion `odds_snapshot`. Match-winner win% still runs via `applyWinProbabilityUpdate` when payloads include MW rows. */ const wantMarkets = feedWantsMarkets(feedFilter);
        // Clear all match-specific state when switching to a new match (only if matchId changed)
        const matchIdStr = String(matchId);
        if (currentMatchIdRef.current !== matchIdStr) {
            marketDataMapRef.current.clear();
            clearMatchFeedVersionGuards(matchIdStr);
            setMarketData([]);
            setSubscribedMatchId(matchIdStr);
            // Reset tournament and matchTitle when switching to a new match
            setTournament("");
            setMatchTitle("");
            // Reset scorecard, commentary, ball runs, RR and all scoreboard state so previous match data is not shown
            mergedScorecardByMatchIdRef.current.clear();
            setScorecardData(null);
            setCommentary({});
            matchFinishedLatchRef.current = false;
            matchCommentRef.current = "";
            setMatchComment("");
            setRunRate("");
            scoreRef.current = [
                "0/0",
                "0/0"
            ];
            setScore([
                "0/0",
                "0/0"
            ]);
            setOvers([
                ""
            ]);
            setLiveBat("");
            setInnsNow(0);
            setBatNow("");
            setOverDelivery([]);
            setCurBall(null);
            setCurInnsOver("");
            setScoregrid([]);
            setScoreGridData([]);
            setBattings([]);
            setHomeOvers([]);
            setAwayOvers([]);
            setMOvers([]);
            setCurPos([
                0,
                0,
                0
            ]);
            setFormat(null);
            setScoreboardMaxOvers(null);
            setOversReduced(false);
            setBattingOvers([
                0,
                0,
                0,
                0
            ]);
            setPartnership({});
            setBatting(null);
            setStriker("");
            setBowling(undefined);
            setFullComm([]);
            setLineup([]);
            setCompetitionGender(undefined);
            setAlerts(null);
            setBattingAnalysis(null);
            setBallResults(null);
            setCurrentInnings(0);
            setPrematch(true);
            prematchRef.current = true;
            setProbability([
                {
                    name: "",
                    probability: 0
                },
                {
                    name: "",
                    probability: 0
                }
            ]);
            setGamePhase("");
            setStatus("");
            eventStatusRef.current = undefined;
            setEventStatus(undefined);
            setMatchTradingStatus(undefined);
            setSubscriptionState(undefined);
            setSquaresOversRefreshNonce(0);
            setBullionSettlementRefresh({
                nonce: 0,
                matchId: "",
                gameIds: []
            });
            setSquaresStaleScoregridBallSupplement(null);
            liveDetailHydrateDoneRef.current.delete(matchIdStr);
            currentMatchIdRef.current = matchIdStr;
        }
        const baseApi = "https://cricket8.com/stream";
        const existingShared = sharedSingleMatchSubscriptionRef.current;
        if (existingShared && existingShared.matchId === matchIdStr) {
            existingShared.subscribers += 1;
            setConnectionLost(false);
            // Shared SSE will not re-replay cache for late joiners — hydrate via HTTP snapshot.
            const streamBase = (baseApi || "").replace(/\/stream.*$/i, "");
            if (streamBase) fetch(`${streamBase}/stream/initial-state?matchIds=${encodeURIComponent(matchIdStr)}${initialStateExtraQuery}`, {
                credentials: "omit"
            }).then((r)=>r.ok ? r.json() : null).then((state)=>{
                if (!state || typeof state !== "object") return;
                const snap = state[matchIdStr];
                if (!snap || typeof snap !== "object") return;
                matchDetails(snap, matchId, cb, {
                    wantMarkets
                });
                if (snap.commentary) setCommentary((prevC)=>mergeCommentariesIntoState(prevC, snap.commentary));
                if (snap.scorecard) {
                    const cardMap = mergedScorecardByMatchIdRef.current;
                    const mergedSc = (0, _mergeDecimalScorecardDelta.mergeDecimalScorecardDelta)(cardMap.get(matchIdStr) ?? null, snap.scorecard);
                    cardMap.set(matchIdStr, mergedSc);
                    setScorecardData(mergedSc);
                }
                if (snap.scoregrid) applyScoregridFromParsed(matchIdStr, snap);
            }).catch(()=>{});
            return ()=>{
                const current = sharedSingleMatchSubscriptionRef.current;
                if (!current || current.matchId !== matchIdStr) return;
                current.subscribers = Math.max(0, current.subscribers - 1);
                if (current.subscribers === 0) current.close();
            };
        }
        if (existingShared && existingShared.matchId !== matchIdStr) {
            existingShared.close();
            sharedSingleMatchSubscriptionRef.current = null;
        }
        // Remount / lobby↔match-play: drop previous visit's last_update guards before cache replay,
        // otherwise a fresher event frame makes an older scorecard look "stale" and detail tabs stay empty.
        clearMatchFeedVersionGuards(matchIdStr);
        const url = `${baseApi}/${matchId}${streamUrlSuffix}`;
        setConnectionLost(false);
        /** Last time this subscription applied an SSE or snapshot payload — used to skip redundant snapshot polls. */ const lastSseMessageAtMsRef = {
            current: 0
        };
        const es = new EventSource(url, {
            withCredentials: false
        });
        es.addEventListener("open", ()=>{
            clearMatchFeedVersionGuards(matchIdStr);
            // Stream connected again (initial open or browser reconnect after deploy/network blip).
            setConnectionLost(false);
        });
        const processSingleMatchStreamPayload = (parsedData)=>{
            if (!parsedData) return;
            if (parsedData.market_update) parsedData = {
                ...parsedData,
                market_update: (0, _unwrapStreamMarketUpdate.unwrapStreamMarketUpdate)(parsedData.market_update)
            };
            lastSseMessageAtMsRef.current = Date.now();
            if (parsedData.msg_type === "squares_overs_updated") {
                const mid = parsedData.match_id != null ? String(parsedData.match_id) : "";
                if (mid && mid === matchIdStr) setSquaresOversRefreshNonce((n)=>n + 1);
                return;
            }
            if (parsedData.msg_type === "bullion_settlement_updated") {
                const mid = parsedData.match_id != null ? String(parsedData.match_id) : "";
                if (mid && mid === matchIdStr) {
                    const gameIds = Array.isArray(parsedData.game_ids) ? parsedData.game_ids.map((g)=>Number(g)).filter((n)=>Number.isFinite(n) && n > 0) : [];
                    setBullionSettlementRefresh((prev)=>({
                            nonce: prev.nonce + 1,
                            matchId: mid,
                            gameIds
                        }));
                }
                return;
            }
            if (parsedData.state) setSubscriptionState(parsedData.state);
            const luSingle = parsedData.last_update;
            applyScoregridFromParsed(matchIdStr, parsedData);
            const skipCricketSingle = isStaleCricketFeedVersion(matchIdStr, luSingle);
            const skipScorecardSingle = isStaleScorecardFeedVersion(matchIdStr, luSingle);
            const rawMarketsForBumpSingle = parsedData.market_update?.markets ?? [];
            const marketLuStaleSingle = isStaleMarketFeedVersion(matchIdStr, luSingle);
            const carrySettledMarketUpdatesSingle = rawMarketsForBumpSingle.some((m)=>liveMarketRowIndicatesFinalSettlement(m));
            const skipMarketSingle = rawMarketsForBumpSingle.length > 0 && marketLuStaleSingle && !carrySettledMarketUpdatesSingle;
            if (parsedData.alerts) setAlerts(parsedData.alerts);
            const battingAnalysisMsg = (0, _cricketLiveBallSignals.battingAnalysisFromMessage)(parsedData);
            if (battingAnalysisMsg) setBattingAnalysis(battingAnalysisMsg);
            // ----------------------------- market_update -------------------------
            // Full books use market_snapshot (replace/evict). Empty markets do not overwrite.
            // `settled_market_keys` deletes Appendix-4 finals that SSE omits from `markets[]`.
            if (parsedData.market_update) {
                if (parsedData.market_update.event_status != null) applyEventStatusFromFeed(parsedData.market_update.event_status);
                if (parsedData.market_update.betting_status != null) setMatchTradingStatus(parsedData.market_update.betting_status);
                const rawMarkets = parsedData.market_update.markets ?? [];
                if (!skipMarketSingle && wantMarkets) {
                    let bookChanged = false;
                    if (rawMarkets.length > 0) {
                        const fullSnapshot = streamMessageIsMarketSnapshot(parsedData);
                        if (marketLuStaleSingle && carrySettledMarketUpdatesSingle) applyMarketsFromStreamMessage(marketDataMapRef.current, rawMarkets, {
                            staleSettledOnly: true
                        });
                        else applyMarketsFromStreamMessage(marketDataMapRef.current, rawMarkets, {
                            fullSnapshot
                        });
                        bookChanged = true;
                    }
                    if (applySettledMarketKeyRemovals(marketDataMapRef.current, parsedData)) bookChanged = true;
                    if (bookChanged) scheduleMarketDataFlush();
                    if (rawMarkets.length > 0) applyWinProbabilityUpdate(parsedData, skipCricketSingle);
                }
            }
            if (parsedData.event && !skipCricketSingle) {
                if (String(parsedData.event.event_description ?? "").includes("Pre Match Service")) {
                    setPrematch(true);
                    prematchRef.current = true;
                    const preMatchScoreboard = eventScoreboardRows(parsedData.event);
                    if (preMatchScoreboard.length > 0) {
                        const scoreboard = preMatchScoreboard;
                        const homeObj = scoreboard.find((item)=>item.name === "home");
                        const awayObj = scoreboard.find((item)=>item.name === "away");
                        applyTeamsFromFeed(homeObj ? homeObj.value : "", awayObj ? awayObj.value : "");
                    }
                    setGamePhase((prev)=>prev ? prev : "Scheduled");
                } else {
                    if (prematchRef.current) // Left Decimal pre-match feed while the page was already open — same hydrate as status go-live.
                    requestLiveDetailHydrateRef.current?.();
                    setPrematch(false);
                    prematchRef.current = false;
                    const scoreboard = eventScoreboardRows(parsedData.event);
                    if (scoreboard.length === 0) ;
                    else {
                        const matchTitleObj = scoreboard.find((item)=>item.name === "matchtitle");
                        const game_phaseObj = scoreboard.find((item)=>item.name === "game_phase");
                        const local_timeObj = scoreboard.find((item)=>item.name === "local_time");
                        const homeObj = scoreboard.find((item)=>item.name === "home");
                        const awayObj = scoreboard.find((item)=>item.name === "away");
                        const battingObj = scoreboard.find((item)=>item.name === "Current Batting Team");
                        let localdt = new Date(local_timeObj ? local_timeObj.value : "");
                        let formattedDate = localdt.getDate().toString().padStart(2, "0") + "/" + (localdt.getMonth() + 1).toString().padStart(2, "0") + "/" + localdt.getFullYear();
                        let matchname = matchTitleObj ? matchTitleObj.value : "";
                        const parts = matchname.split(",");
                        if (parts.length > 2) {
                            setMatchName(parts[0].trim());
                            setLocation(parts[2].trim());
                            setTournament(parts[1].trim());
                        }
                        setGamePhase((prev)=>{
                            const next = game_phaseObj?.value;
                            if (next == null || String(next).trim() === "") return prev;
                            return String(next);
                        });
                        setLocalTime(formattedDate);
                        applyTeamsFromFeed(homeObj ? homeObj.value : "", awayObj ? awayObj.value : "");
                        setBatting(battingObj ? battingObj.value : "");
                        const CurInns = scoreboard.find((item)=>item.name === "Current Innings");
                        const CurOvrs = scoreboard.find((item)=>item.name === "Current Innings Overs");
                        const CurPart = scoreboard.find((item)=>item.name === "Current Innings Part Overs");
                        setCurPos((prev)=>{
                            const next = [
                                CurInns ? CurInns.value : prev?.[0] ?? 0,
                                CurOvrs ? CurOvrs.value : prev?.[1] ?? 0,
                                CurPart ? CurPart.value : prev?.[2] ?? 0
                            ];
                            if (prev && prev.length >= 3 && prev[0] === next[0] && prev[1] === next[1] && prev[2] === next[2]) return prev;
                            return next;
                        });
                        const maxOvers = scoreboard.find((item)=>item.name === "Max Overs");
                        if (maxOvers?.value != null && String(maxOvers.value).trim() !== "") {
                            const liveMax = (0, _cricketMatchCardOverDisplay.parseCricketFixtureFormatOvers)(maxOvers.value);
                            if (liveMax != null) setScoreboardMaxOvers(liveMax);
                        }
                        const reduced = (0, _cricketReducedOvers.scoreboardOversReduced)(scoreboard);
                        if (reduced != null) setOversReduced(reduced);
                        const batting1 = scoreboard.find((item)=>item.name === "batting.1");
                        const batting1Runs = scoreboard.find((item)=>item.name === "runs.1");
                        const batting1Wkts = scoreboard.find((item)=>item.name === "wkts.1");
                        const batting1MaxOvers = scoreboard.find((item)=>item.name === "max.1");
                        const batting1Overs = scoreboard.find((item)=>item.name === "overs.1");
                        const batting2 = scoreboard.find((item)=>item.name === "batting.2");
                        const batting2Runs = scoreboard.find((item)=>item.name === "runs.2");
                        const batting2Wkts = scoreboard.find((item)=>item.name === "wkts.2");
                        const batting2MaxOvers = scoreboard.find((item)=>item.name === "max.2");
                        const batting2Overs = scoreboard.find((item)=>item.name === "overs.2");
                        let b1mover = batting1MaxOvers ? batting1MaxOvers.value : "";
                        let b2mover = batting2MaxOvers ? batting2MaxOvers.value : "";
                        let b1over = batting1Overs ? batting1Overs.value : "";
                        let b2over = batting2Overs ? batting2Overs.value : "";
                        let homeOver = b1over + "/" + b1mover;
                        if (b1over === b1mover) homeOver = b1mover;
                        let awayOver = b2over + "/" + b2mover;
                        let bat1Runs = batting1Runs ? batting1Runs.value : "";
                        let bat1Wkts = batting1Wkts ? batting1Wkts.value : "";
                        let bat2Runs = batting2Runs ? batting2Runs.value : "";
                        let bat2Wkts = batting2Wkts ? batting2Wkts.value : "";
                        if (b2over === b2mover) awayOver = b2mover;
                        if (awayOver === "") awayOver = "0/" + (maxOvers?.value ?? "");
                        let bat1Prog = bat1Runs + "/" + bat1Wkts;
                        if (bat1Prog === "/") bat1Prog = "0/0";
                        let bat2Prog = bat2Runs + "/" + bat2Wkts;
                        if (bat2Prog === "/") bat2Prog = "0/0";
                        if ((batting1 ? batting1.value : "") === (homeObj?.value ?? "")) {
                            guardedSetScore([
                                bat1Prog,
                                bat2Prog
                            ]);
                            setOvers([
                                homeOver,
                                awayOver
                            ]);
                        } else {
                            guardedSetScore([
                                bat2Prog,
                                bat1Prog
                            ]);
                            setOvers([
                                awayOver,
                                homeOver
                            ]);
                        }
                        const bat1 = scoreboard.find((item)=>item.name === battingObj ? battingObj.value : "Bat.1");
                        const bat2 = scoreboard.find((item)=>item.name === battingObj ? battingObj.value : "Bat.2");
                        const strike1 = scoreboard.find((item)=>item.name === "Batsman1 Strike");
                        const strike2 = scoreboard.find((item)=>item.name === "Batsman2 Strike");
                        let bowl1 = scoreboard.find((item)=>item.name === "bowler1name");
                        let bowl2 = scoreboard.find((item)=>item.name === "bowler2name");
                        const runs1 = scoreboard.find((item)=>item.name === "Batsman1 Runs");
                        const runs2 = scoreboard.find((item)=>item.name === "Batsman2 Runs");
                        let bowl1overs = scoreboard.find((item)=>item.name === "bowler1overs");
                        let bowl1runs = scoreboard.find((item)=>item.name === "bowler1runs");
                        let bowl1wicks = scoreboard.find((item)=>item.name === "bowler1wickets");
                        let bowl2overs = scoreboard.find((item)=>item.name === "bowler2overs");
                        let bowl2runs = scoreboard.find((item)=>item.name === "bowler2runs");
                        let bowl2wicks = scoreboard.find((item)=>item.name === "bowler2wickets");
                        const balls1 = scoreboard.find((item)=>item.name === battingObj ? battingObj.value : "Bat.1balls");
                        const balls2 = scoreboard.find((item)=>item.name === battingObj ? battingObj.value : "Bat.2balls");
                        let strikerbatter = "";
                        let batterruns = 0;
                        let batterballs = 0;
                        if (strike1 && strike1.value === "1") {
                            strikerbatter = bat1 ? bat1.value : 0;
                            batterruns = runs1?.value ?? 0;
                            batterballs = balls1?.value ?? 0;
                        } else {
                            strikerbatter = bat2 ? bat2.value : 0;
                            batterruns = runs2?.value ?? 0;
                            batterballs = balls2?.value ?? 0;
                        }
                        let actbowl = scoreboard.find((item)=>item.name === "bowler");
                        let bowlovers = "0 overs";
                        let bowlruns = "0";
                        let bowlwickets = "0";
                        if (bowl1?.value !== undefined && bowl1.value !== "") {
                            actbowl = bowl1.value;
                            bowlovers = (bowl1overs?.value ?? "") + " overs";
                            bowlruns = bowl1runs?.value ?? "";
                            bowlwickets = bowl1wicks?.value ?? "";
                        } else {
                            actbowl = bowl2?.value ?? "";
                            bowlovers = (bowl2overs?.value ?? "") + " overs";
                            bowlruns = bowl2runs?.value ?? "";
                            bowlwickets = bowl2wicks?.value ?? "";
                        }
                        setPartnership({
                            bowler: actbowl,
                            bowlerover: bowlovers,
                            bowlerruns: bowlruns,
                            bowlerwickets: bowlwickets,
                            batter: strikerbatter,
                            batterruns: batterruns,
                            batterballs: batterballs
                        });
                    }
                }
            }
            // ------------ score card ------------
            if (parsedData.event && !skipCricketSingle) EventProc(parsedData.event, matchId);
            // ---------------- match details -----------------
            matchDetails(parsedData, matchId, cb, {
                skipCricketSnapshot: skipCricketSingle,
                skipMarketData: skipMarketSingle,
                skipScorecard: skipScorecardSingle,
                wantMarkets
            });
            //-------------------------- match-play -----------------------------
            if (parsedData.event && !skipCricketSingle) {
                const eventScoreboard = eventScoreboardRows(parsedData.event);
                const winner = eventScoreboard.find((item)=>item.name === "winner")?.value ?? "NA";
                const curOvs = eventScoreboard.find((item)=>item.name === "Current Innings Overs")?.value ?? "";
                const curDelv = eventScoreboard.find((item)=>item.name === "current.delv")?.value ?? "";
                const matchComment = eventScoreboard.find((item)=>item.name === "match_comment")?.value ?? "";
                const gamePhase = eventScoreboard.find((item)=>item.name === "game_phase")?.value ?? "";
                const currentBowler = eventScoreboard.find((item)=>item.name === "bowler")?.value ?? "";
                const currentBatting = eventScoreboard.find((item)=>item.name === "Current Batting Team")?.value ?? "";
                const batsman1 = eventScoreboard.find((item)=>item.name === currentBatting + "Bat.1")?.value ?? "";
                const batsman2 = eventScoreboard.find((item)=>item.name === currentBatting + "Bat.2")?.value ?? "";
                const strike1 = eventScoreboard.find((item)=>item.name === "Batsman1 Strike");
                const strike2 = eventScoreboard.find((item)=>item.name === "Batsman2 Strike");
                let ballStatus = "";
                if ((strike1?.value ?? "1") === "1") ballStatus = currentBowler + " to " + batsman1;
                else if ((strike2?.value ?? "1") === "1") ballStatus = currentBowler + " to " + batsman2;
                if (!(0, _decimalEventStatus.isDecimalTeamWinner)(winner)) {
                    setStatus(ballStatus);
                    setCurBall(curOvs + "." + curDelv);
                    setCurInnsOver(curOvs);
                } else {
                    setStatus(winner + " wins.");
                    setCurBall(null);
                }
            }
            if (parsedData.commentary) setCommentary((prevC)=>mergeCommentariesIntoState(prevC, parsedData.commentary));
            if (parsedData.scoreboard && !skipCricketSingle) {
                setBattings([
                    parsedData.scoreboard.innings1battingteam,
                    parsedData.scoreboard.innings2battingteam,
                    parsedData.scoreboard.innings3battingteam,
                    parsedData.scoreboard.innings4battingteam
                ]);
                let stat = parsedData.scoreboard?.status.split("-")[0];
                if (parsedData.scoreboard.innings1battingteam === parsedData.scoreboard.home) {
                    setHomeOvers([
                        parsedData.scoreboard.innings1overs,
                        parsedData.scoreboard.innings3overs
                    ]);
                    setAwayOvers([
                        parsedData.scoreboard.innings2overs,
                        parsedData.scoreboard.innings4overs
                    ]);
                } else {
                    setAwayOvers([
                        parsedData.scoreboard.innings1overs,
                        parsedData.scoreboard.innings3overs
                    ]);
                    setHomeOvers([
                        parsedData.scoreboard.innings2overs,
                        parsedData.scoreboard.innings4overs
                    ]);
                }
                setMOvers([
                    parsedData.scoreboard.innings1max,
                    parsedData.scoreboard.innings2max,
                    parsedData.scoreboard.innings3max,
                    parsedData.scoreboard.innings4max
                ]);
            }
            if (parsedData.scorecard && !skipScorecardSingle) {
                const cardMap = mergedScorecardByMatchIdRef.current;
                const mergedSc = (0, _mergeDecimalScorecardDelta.mergeDecimalScorecardDelta)(cardMap.get(matchIdStr) ?? null, parsedData.scorecard);
                cardMap.set(matchIdStr, mergedSc);
                if (typeof mergedSc?.description === "string" && mergedSc.description.includes(",")) {
                    const matchParts = mergedSc.description.split(",");
                    if (matchParts[0]?.includes(" v ")) {
                        setMatchTitle(matchParts.length >= 3 ? matchParts[1].trim() : "");
                        applyTeamsFromMatchTitlePart(matchParts[0]);
                    }
                }
                setInnsNow(mergedSc.inns_now);
                setBatNow(mergedSc.bat_now);
                const mp = typeof mergedSc?.description === "string" ? mergedSc.description.split(",") : [];
                if (mp[0]?.includes(" v ")) {
                    const s1 = inningRunsWktsLine(mergedSc.inns1);
                    const s2 = inningRunsWktsLine(mergedSc.inns2);
                    const s3 = inningRunsWktsLine(mergedSc.inns3);
                    const s4 = inningRunsWktsLine(mergedSc.inns4);
                    const insScore = [
                        s1,
                        s2,
                        s3,
                        s4
                    ];
                    const innsnow = mergedSc.inns_now;
                    let oppnow = 1;
                    let rptNow = 2;
                    if (innsnow === 1 || innsnow === 3) {
                        oppnow = 2;
                        rptNow = 1;
                    }
                    setLiveBat(mergedSc.bat_now);
                    if (mergedSc.bat_now === mp[0].split(" v ")[0]) guardedSetScore([
                        insScore[rptNow - 1],
                        insScore[oppnow - 1],
                        insScore[rptNow + 1],
                        insScore[oppnow + 1]
                    ]);
                    else guardedSetScore([
                        insScore[oppnow - 1],
                        insScore[rptNow - 1],
                        insScore[oppnow + 1],
                        insScore[rptNow + 1]
                    ]);
                }
                setScorecardData(mergedSc);
                if (mergedSc.event_status != null) applyEventStatusFromFeed(mergedSc.event_status);
            }
            if (!skipCricketSingle && (parsedData.event || parsedData.scoreboard)) bumpCricketFeedVersion(matchIdStr, luSingle);
            if (parsedData.scorecard && !skipScorecardSingle) bumpScorecardFeedVersion(matchIdStr, luSingle);
            if (parsedData.market_update && parseLastUpdateVersion(luSingle) != null && !marketLuStaleSingle) bumpMarketFeedVersion(matchIdStr, luSingle);
        //-------------------- match-play --------------------------
        //---------------------- trader-match-card ------------------------
        //----------------------- trader-match-card --------------------------
        };
        es.addEventListener("message", (event)=>{
            let parsedData;
            try {
                parsedData = JSON.parse(event.data);
            } catch (e) {
                return;
            }
            processSingleMatchStreamPayload(parsedData);
        });
        let matchSnapshotFetchInFlight = false;
        let pendingForceMatchSnapshot = false;
        const fetchMatchSnapshot = (opts)=>{
            if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
            // Trader needs margined odds; the primed cache is filled by non-Trader lobby flows (raw prices),
            // so Trader always fetches its own margined initial-state instead of reusing a primed snapshot.
            const primed = opts?.force ? null : productQuery ? null : (0, _streamInitialStatePrimedCache.consumePrimedMatchInitialState)(matchIdStr);
            if (primed) {
                processSingleMatchStreamPayload(primed);
                return;
            }
            const streamBase = (baseApi || "").replace(/\/stream.*$/i, "");
            if (!streamBase) return;
            const now = Date.now();
            if (!opts?.force && lastSseMessageAtMsRef.current > 0 && now - lastSseMessageAtMsRef.current < (0, _traderConstants.TRADER_MATCH_SNAPSHOT_SKIP_IF_SSE_RECENT_MS)) return;
            if (matchSnapshotFetchInFlight) {
                if (opts?.force) pendingForceMatchSnapshot = true;
                return;
            }
            matchSnapshotFetchInFlight = true;
            fetch(`${streamBase}/stream/initial-state?matchIds=${encodeURIComponent(matchIdStr)}${initialStateExtraQuery}`, {
                credentials: "omit"
            }).then((r)=>r.ok ? r.json() : null).then((state)=>{
                if (!state || typeof state !== "object") return;
                const snap = state[matchIdStr];
                if (snap && typeof snap === "object") processSingleMatchStreamPayload(snap);
            }).catch(()=>{}).finally(()=>{
                matchSnapshotFetchInFlight = false;
                if (pendingForceMatchSnapshot) {
                    pendingForceMatchSnapshot = false;
                    fetchMatchSnapshot({
                        force: true
                    });
                }
            });
        };
        requestLiveDetailHydrateRef.current = ()=>{
            if (liveDetailHydrateDoneRef.current.has(matchIdStr)) return;
            liveDetailHydrateDoneRef.current.add(matchIdStr);
            clearMatchFeedVersionGuards(matchIdStr);
            lastSseMessageAtMsRef.current = 0;
            fetchMatchSnapshot({
                force: true
            });
        };
        fetchMatchSnapshot();
        const snapshotPollId = window.setInterval(fetchMatchSnapshot, (0, _traderConstants.TRADER_MATCH_SNAPSHOT_POLL_MS));
        es.addEventListener("error", function error() {
            setConnectionLost(true);
            lastSseMessageAtMsRef.current = 0;
            // Do not keep showing pre-outage odds/lines (e.g. old “Runs in Over 7”) after events server restart:
            // clear merged markets and reset monotonic last_update guards so the next snapshot/SSE payload is applied
            // even if Decimal’s last_update sequence restarted lower than our previous client ref.
            if (marketDataFlushTimeoutRef.current !== null) {
                clearTimeout(marketDataFlushTimeoutRef.current);
                marketDataFlushTimeoutRef.current = null;
            }
            marketDataMapRef.current.clear();
            setMarketData([]);
            clearMatchFeedVersionGuards(matchIdStr);
        });
        const closeSharedStream = ()=>{
            window.clearInterval(snapshotPollId);
            es.close();
            setConnectionLost(false);
            if (requestLiveDetailHydrateRef.current) requestLiveDetailHydrateRef.current = null;
            if (sharedSingleMatchSubscriptionRef.current?.matchId === matchIdStr) sharedSingleMatchSubscriptionRef.current = null;
        };
        sharedSingleMatchSubscriptionRef.current = {
            matchId: matchIdStr,
            subscribers: 1,
            close: closeSharedStream
        };
        return ()=>{
            const current = sharedSingleMatchSubscriptionRef.current;
            if (!current || current.matchId !== matchIdStr) return;
            current.subscribers = Math.max(0, current.subscribers - 1);
            if (current.subscribers === 0) current.close();
        };
    }, [
        scheduleMarketDataFlush,
        applyWinProbabilityUpdate,
        EventProc,
        matchDetails,
        fetchScoreGrid,
        applyScoregridFromParsed,
        isStaleCricketFeedVersion,
        isStaleMarketFeedVersion,
        isStaleScorecardFeedVersion,
        bumpCricketFeedVersion,
        bumpMarketFeedVersion,
        bumpScorecardFeedVersion,
        clearMatchFeedVersionGuards
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            sharedSingleMatchSubscriptionRef.current?.close();
            sharedSingleMatchSubscriptionRef.current = null;
        };
    }, []);
    /** Overs bowled in current innings = Current Innings Overs + Current Innings Part Overs / 6 (Decimal API). */ const currentInningsOversDecimal = (0, _react.useMemo)(()=>{
        if (!CurPos || CurPos.length < 3) return null;
        const full = Number(CurPos[1]);
        const part = Number(CurPos[2]);
        if (Number.isNaN(full) || Number.isNaN(part)) return null;
        return full + part / 6;
    }, [
        CurPos
    ]);
    const contextValue = (0, _react.useMemo)(()=>({
            subscribeToMatches,
            subscribeToMatch,
            getCompletedData,
            fetchEvents,
            matchTitle,
            teams,
            marketData,
            tournament,
            score,
            overs,
            scoregrid,
            matchComment,
            runRate,
            currentInnings,
            batting,
            partnership,
            matchName,
            probability,
            lineup,
            format,
            scoreboardMaxOvers,
            oversReduced,
            competitionGender,
            scoreGridData,
            trading,
            fullComm,
            scorecardData,
            alerts,
            battingAnalysis,
            ballResults,
            location,
            localTime,
            game_phase,
            prematch,
            status,
            curBall,
            curInnsOver,
            overDelivery,
            commentary,
            battings,
            homeOvers,
            awayOvers,
            mOvers,
            innsNow,
            batNow,
            liveBat,
            CurPos,
            currentInningsOversDecimal,
            striker,
            battingOvers,
            bowling,
            incomingEvent,
            stream,
            feed,
            subHeader,
            eventStatus,
            matchTradingStatus,
            subscriptionState,
            connectionLost,
            matchStartDateTime,
            setSubHeader,
            subscribedMatchId,
            squaresOversRefreshNonce,
            bullionSettlementRefresh,
            squaresStaleScoregridBallSupplement
        }), [
        subscribeToMatches,
        subscribeToMatch,
        getCompletedData,
        fetchEvents,
        matchTitle,
        teams,
        marketData,
        tournament,
        score,
        overs,
        scoregrid,
        matchComment,
        runRate,
        currentInnings,
        batting,
        partnership,
        matchName,
        probability,
        lineup,
        format,
        scoreboardMaxOvers,
        oversReduced,
        competitionGender,
        scoreGridData,
        trading,
        fullComm,
        scorecardData,
        alerts,
        battingAnalysis,
        ballResults,
        location,
        localTime,
        game_phase,
        prematch,
        status,
        curBall,
        curInnsOver,
        overDelivery,
        commentary,
        battings,
        homeOvers,
        awayOvers,
        mOvers,
        innsNow,
        batNow,
        liveBat,
        CurPos,
        striker,
        battingOvers,
        bowling,
        incomingEvent,
        stream,
        feed,
        subHeader,
        eventStatus,
        matchTradingStatus,
        subscriptionState,
        connectionLost,
        matchStartDateTime,
        subscribedMatchId,
        currentInningsOversDecimal,
        squaresOversRefreshNonce,
        bullionSettlementRefresh,
        squaresStaleScoregridBallSupplement
    ]);
    (0, _react.useLayoutEffect)(()=>{
        socketStoreSnapshotRef.current = contextValue;
        notifySocketStoreListeners();
    }, [
        contextValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocketContext.Provider, {
        value: contextValue,
        children: children
    });
};
const useSocket = ()=>{
    const context = (0, _react.useContext)(SocketContext);
    if (!context) throw new Error("useSocket must be used within a SocketProvider");
    return context;
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../utils/authHeaders":"5Rczo","../components/Games/traderConstants":"jjugl","../utils/streamInitialStatePrimedCache":"8TEdU","../utils/unwrapStreamMarketUpdate":"crc1r","../components/Trader/Cricket/decimalEventStatus":"f1nlI","../components/Trader/Cricket/decimalMarketUtils":"eGjNP","../components/Squares/shared/squaresBallResults":"idJxQ","../components/Cricket/cricketMatchCardOverDisplay":"jVYsA","../utils/cricketReducedOvers":"9TnWC","../utils/cricketLiveBallSignals":"4wd1u","../utils/cricketTestMatch":"eJTw5","../utils/mergeStreamCommentary":"3cgOK","../utils/mergeDecimalScorecardDelta":"39V7C","../utils/scoregridLatestBowling":"9VO1U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jjugl":[function(require,module,exports,__globalThis) {
/**
 * Shared constants for the Trader / match list: sport mapping, refresh interval, and cricket stream reconnect settings.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPORT_MAP", ()=>SPORT_MAP);
parcelHelpers.export(exports, "TRADER_REFRESH_INTERVAL_MS", ()=>TRADER_REFRESH_INTERVAL_MS);
parcelHelpers.export(exports, "TRADER_REFRESH_ALL_SPORTS_INTERVAL_MS", ()=>TRADER_REFRESH_ALL_SPORTS_INTERVAL_MS);
parcelHelpers.export(exports, "STREAM_FIRST_RETRY_MS", ()=>STREAM_FIRST_RETRY_MS);
parcelHelpers.export(exports, "STREAM_RETRY_INTERVAL_MS", ()=>STREAM_RETRY_INTERVAL_MS);
parcelHelpers.export(exports, "STREAM_MAX_AUTO_RETRIES", ()=>STREAM_MAX_AUTO_RETRIES);
parcelHelpers.export(exports, "CRICKET_LIVE_STALE_AFTER_MS", ()=>CRICKET_LIVE_STALE_AFTER_MS);
parcelHelpers.export(exports, "TRADER_MATCH_SNAPSHOT_POLL_MS", ()=>TRADER_MATCH_SNAPSHOT_POLL_MS);
parcelHelpers.export(exports, "TRADER_MATCH_SNAPSHOT_SKIP_IF_SSE_RECENT_MS", ()=>TRADER_MATCH_SNAPSHOT_SKIP_IF_SSE_RECENT_MS);
parcelHelpers.export(exports, "TRADER_MATCH_TAB_STALE_AFTER_MS", ()=>TRADER_MATCH_TAB_STALE_AFTER_MS);
const SPORT_MAP = {
    CRICKET: "cricket",
    HORSES: "horses",
    FOOTBALL: "football",
    TENNIS: "tennis"
};
const TRADER_REFRESH_INTERVAL_MS = 30000;
const TRADER_REFRESH_ALL_SPORTS_INTERVAL_MS = 60000;
const STREAM_FIRST_RETRY_MS = 3000;
const STREAM_RETRY_INTERVAL_MS = 5000;
const STREAM_MAX_AUTO_RETRIES = 4;
const CRICKET_LIVE_STALE_AFTER_MS = 90000;
const TRADER_MATCH_SNAPSHOT_POLL_MS = 18000;
const TRADER_MATCH_SNAPSHOT_SKIP_IF_SSE_RECENT_MS = 22000;
const TRADER_MATCH_TAB_STALE_AFTER_MS = 300000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"crc1r":[function(require,module,exports,__globalThis) {
/**
 * Legacy Decimal/SSE `market_update` shapes:
 * - Live SSE / client store (flat): `{ markets, event_status, betting_status, … }`
 * - HTTP initial-state / subscribe dump (wrapped): `{ msg_type, feed_id, market_update: { markets, … } }`
 *
 * Cards and DecimalSocketContext read `streamData.market_update.markets`. Without unwrapping the
 * nested envelope, lobby poll snapshots look empty → SUS even when Match Winner is priced.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapStreamMarketUpdate", ()=>unwrapStreamMarketUpdate);
function unwrapStreamMarketUpdate(marketUpdate) {
    if (!marketUpdate || typeof marketUpdate !== "object" || Array.isArray(marketUpdate)) return marketUpdate;
    const mu = marketUpdate;
    if (Array.isArray(mu.markets)) return marketUpdate;
    const inner = mu.market_update;
    if (!inner || typeof inner !== "object" || Array.isArray(inner)) return marketUpdate;
    const nested = inner;
    if (!Array.isArray(nested.markets)) return marketUpdate;
    const out = {
        ...nested
    };
    if (out.market_snapshot == null && mu.market_snapshot != null) out.market_snapshot = mu.market_snapshot;
    if (out.settled_market_keys == null && Array.isArray(mu.settled_market_keys)) out.settled_market_keys = mu.settled_market_keys;
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9TnWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * True when Decimal flags a rain-reduced innings/match (factor below 1). The feed carries no
 * revised (DLS) target, so "runs.1 + 1" is not the real target once this is set.
 * Returns null when the scoreboard carries none of the factors.
 */ parcelHelpers.export(exports, "scoreboardOversReduced", ()=>scoreboardOversReduced);
const REDUCED_ROWS = [
    "reduced1",
    "reduced2",
    "reduced_match"
];
function scoreboardOversReduced(scoreboard) {
    if (!Array.isArray(scoreboard)) return null;
    let seen = false;
    for (const name of REDUCED_ROWS){
        const row = scoreboard.find((r)=>r?.name === name);
        const raw = row?.value;
        if (raw == null || String(raw).trim() === "") continue;
        const n = Number(raw);
        if (!Number.isFinite(n)) continue;
        seen = true;
        if (n > 0 && n < 1) return true;
    }
    return seen ? false : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4wd1u":[function(require,module,exports,__globalThis) {
/** Decimal `batting_analysis` for one delivery (shot, where it went, how high). */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * `batting_analysis` from a feed message: the wire message (`{ msg_type, batting_analysis }`),
 * the inner object, or a replay cache holding either. Null when there is no analysis.
 */ parcelHelpers.export(exports, "battingAnalysisFromMessage", ()=>battingAnalysisFromMessage);
/**
 * Ball results from the delta `score` list, newest first. `ball` is cricket notation plus a
 * delivery sequence (`42.40424` = ball 4 of over 43); `result` is Decimal's ball-result text
 * ("4 runs", "WICKET, Bowled", "Runs Likely").
 */ parcelHelpers.export(exports, "ballResultsFromEventScore", ()=>ballResultsFromEventScore);
const num = (v)=>{
    if (v == null || String(v).trim() === "") return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};
const text = (v)=>{
    const s = v == null ? "" : String(v).trim();
    return s === "NA" || s === "0" ? "" : s;
};
function battingAnalysisFromMessage(msg) {
    let x = msg;
    for(let i = 0; i < 3 && x && typeof x === "object" && !x.analysis; i += 1)x = x.batting_analysis ?? null;
    if (!x || typeof x !== "object") return null;
    const a = x.analysis;
    if (!a || typeof a !== "object") return null;
    return {
        inns: num(x.inns),
        over: num(x.over),
        balls: num(x.balls),
        batter: text(x.batter),
        shot: text(a.shot),
        shotDir: text(a.shot_dir),
        aerial: text(a.aerial)
    };
}
function ballResultsFromEventScore(score) {
    if (!Array.isArray(score)) return null;
    const out = [];
    for (const row of score){
        const ball = num(row?.ball);
        const result = String(row?.result ?? "").trim();
        if (ball != null && result) out.push({
            ball,
            result
        });
    }
    return out.sort((a, b)=>b.ball - a.ball);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3cgOK":[function(require,module,exports,__globalThis) {
/**
 * Commentary on the games SSE is accumulated on the server; each message can carry the full innings.
 * Client-side "append only new ball keys" breaks ordering when the first packets were just the latest over
 * and a later packet carries balls 1..N (we would append early overs after late ones).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Canonical delivery key. Decimal may use fine-grained ids (e.g. 0.61) while scoregrid synthesis
 * uses coarse ids (0.6); the UI shows one decimal place so both must merge to one row.
 */ parcelHelpers.export(exports, "commentaryBallMergeKey", ()=>commentaryBallMergeKey);
/**
 * Newest-first display order: at the same display ball, legal re-bowl above wide/no-ball
 * (the extra is bowled first; the counted delivery is the redo).
 */ parcelHelpers.export(exports, "compareCommentaryDisplayOrder", ()=>compareCommentaryDisplayOrder);
parcelHelpers.export(exports, "sortCommentaryForDisplay", ()=>sortCommentaryForDisplay);
parcelHelpers.export(exports, "sortCommentaryByBall", ()=>sortCommentaryByBall);
/**
 * Drop commentary extras that scoregrid no longer supports alongside a legal row at the same
 * display ball (e.g. mistaken "wide + 4" left behind after Decimal corrected to "Four").
 */ parcelHelpers.export(exports, "pruneOrphanExtraCommentaryRows", ()=>pruneOrphanExtraCommentaryRows);
/**
 * Merge `incomingPayload` into previous commentary state.
 * Keeps wide/no-ball and the legal re-bowl at the same display ball as separate rows, but drops
 * an extra when Decimal reclassifies that same fine-grained ball id as a legal outcome.
 */ parcelHelpers.export(exports, "mergeStreamCommentaryPayload", ()=>mergeStreamCommentaryPayload);
/** Mirrors squaresBallResults.isIgnoreBallResult for scoregrid extra slots (wides / no-balls). */ function isScoregridIgnoreSlot(raw) {
    if (raw == null || String(raw).trim() === "") return true;
    const s = String(raw).trim();
    const lower = s.toLowerCase();
    if (lower.includes("pen")) return true;
    if (lower.includes("wide") || /(^|[^a-z])wd([^a-z]|$)/.test(lower)) return true;
    if (/^[1-7]w$/i.test(lower)) return true;
    if (/^w\+[1-5]w$/i.test(lower)) return true;
    if (/^[1-8]nb$/i.test(lower)) return true;
    if (/no\s*ball|(^|[^a-z])nb([^a-z]|$)/.test(lower)) return true;
    return false;
}
function filterToCountedBallResults(rawArray) {
    const out = [];
    for (const v of rawArray){
        if (v == null || String(v).trim() === "") continue;
        if (isScoregridIgnoreSlot(v)) continue;
        out.push(String(v).trim());
        if (out.length >= 6) break;
    }
    return out;
}
function parseCommentaryBall(ball) {
    const n = typeof ball === "number" ? ball : parseFloat(String(ball ?? ""));
    if (!Number.isFinite(n)) return null;
    const over0 = Math.floor(n);
    const parts = n.toFixed(1).split(".");
    const delivery1 = parts.length > 1 ? parseInt(parts[1], 10) : 0;
    if (!Number.isFinite(delivery1) || delivery1 < 1) return null;
    return {
        over0,
        delivery1
    };
}
function commentaryBallId(over0, delivery1) {
    return over0 + delivery1 / 10;
}
function commentaryResultPart(row) {
    const text = String(row.commentary ?? "").trim();
    return text.includes(",") ? text.slice(text.indexOf(",") + 1).trim() : text;
}
function isNonOutcomeCommentaryResult(resultText) {
    const s = String(resultText || "").trim().toLowerCase();
    if (!s) return false;
    return /umpire|review|penalty|\bpen\b|wide|\bwd\b|no\s*ball|\bnb\b|dead\s*ball|lost\s*ball|retired|timed\s*out/.test(s);
}
function isExtraCommentaryRow(row) {
    if (isNonOutcomeCommentaryResult(commentaryResultPart(row))) return true;
    const text = String(row.commentary ?? "").trim().toLowerCase();
    return /\bwide\b|\bno\s*ball\b|\bnb\b|\bwd\b/.test(text);
}
function commentaryBallMergeKey(ball) {
    const parsed = parseCommentaryBall(ball);
    if (parsed) return commentaryBallId(parsed.over0, parsed.delivery1).toString();
    const n = typeof ball === "number" ? ball : parseFloat(String(ball ?? ""));
    return Number.isFinite(n) ? n.toString() : "";
}
function normalizeCommentaryBall(ball) {
    const parsed = parseCommentaryBall(ball);
    if (!parsed) return ball;
    return commentaryBallId(parsed.over0, parsed.delivery1);
}
function isCoarseCommentaryBall(ball) {
    const n = typeof ball === "number" ? ball : parseFloat(String(ball ?? ""));
    if (!Number.isFinite(n)) return true;
    const parsed = parseCommentaryBall(ball);
    if (!parsed) return true;
    return Math.abs(n - commentaryBallId(parsed.over0, parsed.delivery1)) < 1e-9;
}
function canonicalCommentaryDisplayKey(ball) {
    const parsed = parseCommentaryBall(ball);
    if (!parsed) return "";
    return `${parsed.over0}.${parsed.delivery1}`;
}
/** Fine-grained ball id, or null when the id is coarse / unparseable. */ function commentaryFineBallId(ball) {
    if (isCoarseCommentaryBall(ball)) return null;
    const n = typeof ball === "number" ? ball : parseFloat(String(ball ?? ""));
    return Number.isFinite(n) ? n : null;
}
/**
 * Outcome-only identity of an extras row, stable across enrichment passes: the bowler/batter head
 * is rewritten as lineups arrive and Decimal may re-announce the same extra as a thin
 * "CORRECTION: wide + 1." note, so only the result text can identify the delivery.
 */ function commentaryExtraResultKey(row) {
    const s = commentaryResultPart(row).replace(/^correction\s*[:–—-]?\s*/i, "").toLowerCase().replace(/\s+/g, " ").replace(/[.\s]+$/, "").trim();
    return s || "extra";
}
/**
 * Extras collapse per display ball and outcome text, so "wide + 1" and "wide + 4" at the same ball
 * stay separate while the same wide re-sent in packet after packet does not pile up. Keying extras
 * on the ball id instead is not an option: Decimal mostly sends coarse ids for extras and
 * commentary arrives as accumulated innings history, so an id-based key cannot tell a genuinely
 * second wide from the first wide arriving again.
 */ function commentaryDeliveryMergeKey(row) {
    const displayKey = canonicalCommentaryDisplayKey(row.ball);
    if (!displayKey) return null;
    if (!isExtraCommentaryRow(row)) return `n:${displayKey}`;
    return `e:${displayKey}:${commentaryExtraResultKey(row)}`;
}
function compareCommentaryDisplayOrder(a, b) {
    const ba = typeof a.ball === "number" ? a.ball : parseFloat(String(a.ball ?? ""));
    const bb = typeof b.ball === "number" ? b.ball : parseFloat(String(b.ball ?? ""));
    const parsedA = parseCommentaryBall(a.ball);
    const parsedB = parseCommentaryBall(b.ball);
    const canonA = parsedA ? commentaryBallId(parsedA.over0, parsedA.delivery1) : ba;
    const canonB = parsedB ? commentaryBallId(parsedB.over0, parsedB.delivery1) : bb;
    if (canonA !== canonB) return canonB - canonA;
    const extraA = isExtraCommentaryRow(a) ? 1 : 0;
    const extraB = isExtraCommentaryRow(b) ? 1 : 0;
    if (extraA !== extraB) return extraA - extraB;
    return bb - ba;
}
function sortCommentaryForDisplay(arr) {
    return [
        ...arr
    ].sort(compareCommentaryDisplayOrder);
}
function sortCommentaryByBall(arr) {
    return sortCommentaryForDisplay(arr);
}
function commentaryHasAnalysisClause(text) {
    return /\s\([^)]{4,}\)\s*$/.test(String(text ?? "").trim());
}
function commentaryRowQualityScore(row) {
    const text = String(row.commentary ?? "").trim();
    if (!text) return 0;
    const resultPart = text.includes(",") ? text.slice(text.indexOf(",") + 1).trim() : "";
    if (isNonOutcomeCommentaryResult(resultPart)) return 6;
    let base = 1;
    const head = text.split(",")[0]?.trim() ?? "";
    const m = head.match(/^(.+?)\s+to\s+(.+)$/i);
    if (m) {
        const a = m[1].trim().toLowerCase();
        const b = m[2].trim().toLowerCase();
        if (a && b && a === b) base = 1;
        else if (a && b && a !== b) base = 4;
    } else if (/^\s*to\s+/i.test(head)) base = 3;
    else if (!head.includes(" to ")) base = 1;
    else base = text.length >= 12 ? 2 : 1;
    if (commentaryHasAnalysisClause(text)) base += 3;
    return base;
}
function pickPreferredCommentaryRow(existing, incoming) {
    const se = commentaryRowQualityScore(existing);
    const si = commentaryRowQualityScore(incoming);
    let chosen = existing;
    if (si > se) chosen = incoming;
    else if (si < se) chosen = existing;
    else {
        const existingText = String(existing.commentary ?? "");
        const incomingText = String(incoming.commentary ?? "");
        chosen = incomingText.length > existingText.length ? incoming : existing;
    }
    return {
        ...chosen,
        ball: normalizeCommentaryBall(chosen.ball)
    };
}
function mergeCommentaryBallRows(rows) {
    if (!Array.isArray(rows) || rows.length === 0) return [];
    const byKey = new Map();
    const extraKeyByFineBall = new Map();
    let uniqueSeq = 0;
    for (const item of rows){
        const normalized = {
            ...item,
            ball: isCoarseCommentaryBall(item.ball) ? normalizeCommentaryBall(item.ball) : item.ball
        };
        const isExtra = isExtraCommentaryRow(normalized);
        const fineBall = commentaryFineBallId(normalized.ball);
        // Decimal republishing a mistaken wide/no-ball as a legal outcome on the same fine id.
        if (!isExtra && fineBall != null) {
            const staleKey = extraKeyByFineBall.get(fineBall);
            if (staleKey != null) {
                byKey.delete(staleKey);
                extraKeyByFineBall.delete(fineBall);
            }
        }
        const key = commentaryDeliveryMergeKey(normalized) ?? `u:${uniqueSeq++}`;
        const existing = byKey.get(key);
        byKey.set(key, existing ? pickPreferredCommentaryRow(existing, normalized) : normalized);
        if (isExtra && fineBall != null) extraKeyByFineBall.set(fineBall, key);
    }
    return sortCommentaryForDisplay(Array.from(byKey.values()));
}
function commentaryListsEqual(a, b) {
    if (a.length !== b.length) return false;
    const as = sortCommentaryForDisplay([
        ...a
    ]);
    const bs = sortCommentaryForDisplay([
        ...b
    ]);
    for(let i = 0; i < as.length; i++){
        if (as[i].ball !== bs[i].ball || as[i].commentary !== bs[i].commentary) return false;
    }
    return true;
}
function scoregridDeliverySlots(row) {
    if (!row || typeof row !== "object") return [];
    return [
        row.b1,
        row.b2,
        row.b3,
        row.b4,
        row.b5,
        row.b6,
        row.b7,
        row.b8,
        row.b9,
        row.b10,
        row.b11,
        row.b12
    ];
}
function getScoregridOverRow(scoregrid, innsKey, over1Based) {
    if (!scoregrid || typeof scoregrid !== "object") return null;
    const sg = scoregrid;
    const rows = sg.overs?.[innsKey];
    if (!Array.isArray(rows)) return null;
    for (const row of rows){
        if (!row || typeof row !== "object") continue;
        const ov = parseInt(String(row.ov ?? ""), 10);
        if (ov === over1Based) return row;
    }
    return null;
}
function countScoregridExtrasBeforeDelivery(overRow, delivery1) {
    if (!overRow || delivery1 < 1) return null;
    const slots = scoregridDeliverySlots(overRow);
    let hasAnySlot = false;
    let counted = 0;
    let extrasBefore = 0;
    for (const raw of slots){
        if (raw == null || String(raw).trim() === "") continue;
        hasAnySlot = true;
        if (isScoregridIgnoreSlot(raw)) {
            if (counted === delivery1 - 1) extrasBefore += 1;
            continue;
        }
        counted += 1;
        if (counted >= delivery1) break;
    }
    if (!hasAnySlot) return null;
    return extrasBefore;
}
function pruneOrphanExtraCommentaryRows(rows, scoregrid, innsKey) {
    if (!Array.isArray(rows) || rows.length === 0) return rows;
    if (!scoregrid || typeof scoregrid !== "object") return rows;
    const byDisplay = new Map();
    for (const row of rows){
        if (!row) continue;
        const parsed = parseCommentaryBall(row.ball);
        if (!parsed) continue;
        const displayKey = `${parsed.over0}.${parsed.delivery1}`;
        let group = byDisplay.get(displayKey);
        if (!group) {
            group = {
                extras: [],
                legals: [],
                over1: parsed.over0 + 1,
                delivery1: parsed.delivery1
            };
            byDisplay.set(displayKey, group);
        }
        if (isExtraCommentaryRow(row)) group.extras.push(row);
        else group.legals.push(row);
    }
    const drop = new Set();
    for (const group of byDisplay.values()){
        if (group.extras.length === 0 || group.legals.length === 0) continue;
        const overRow = getScoregridOverRow(scoregrid, innsKey, group.over1);
        const allowed = countScoregridExtrasBeforeDelivery(overRow, group.delivery1);
        if (allowed == null) continue;
        const counted = filterToCountedBallResults(scoregridDeliverySlots(overRow));
        if (counted.length < group.delivery1) continue;
        if (allowed <= 0) {
            for (const e of group.extras)drop.add(e);
            continue;
        }
        if (group.extras.length > allowed) {
            const excess = group.extras.length - allowed;
            for(let i = 0; i < excess; i++)drop.add(group.extras[i]);
        }
    }
    if (drop.size === 0) return rows;
    return rows.filter((r)=>!drop.has(r));
}
function mergeStreamCommentaryPayload(prevPayload, incomingPayload) {
    if (!incomingPayload?.commentaries || Object.keys(incomingPayload.commentaries).length === 0) return prevPayload ?? undefined;
    const prev = prevPayload || {};
    const incoming = incomingPayload.commentaries;
    const nextCommentaries = {
        ...prev.commentaries || {}
    };
    let changed = false;
    for (const inningsKey of Object.keys(incoming)){
        const newInnings = incoming[inningsKey];
        if (!Array.isArray(newInnings) || newInnings.length === 0) continue;
        const prevArr = nextCommentaries[inningsKey] || [];
        const merged = mergeCommentaryBallRows([
            ...prevArr,
            ...newInnings
        ]);
        if (!commentaryListsEqual(prevArr, merged)) {
            nextCommentaries[inningsKey] = merged;
            changed = true;
        }
    }
    if (!changed) return prevPayload;
    return {
        ...prev,
        ...incomingPayload,
        commentaries: nextCommentaries
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39V7C":[function(require,module,exports,__globalThis) {
/**
 * Live Delta scorecard payloads often omit innings (`innsN: null`) or send thinner objects
 * than the last frame. A straight replace clears batting/runs and leaves headers stuck at `0/0`.
 *
 * Thin frames also omit `bat_now` / `inns_now`. Dropping those flips home↔away when
 * `mapCricketInnsScoresToTeams` falls back to batting-order = fixture-order.
 */ /** HTTP initial-state used to nest the full WS message under `scorecard`; unwrap to inns*. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeIncomingScorecard", ()=>normalizeIncomingScorecard);
parcelHelpers.export(exports, "mergeDecimalScorecardDelta", ()=>mergeDecimalScorecardDelta);
function normalizeIncomingScorecard(incoming) {
    if (!incoming || typeof incoming !== "object" || Array.isArray(incoming)) return incoming;
    const o = incoming;
    if (o.inns1 != null || o.inns_now != null || o.bat_now != null) return o;
    if (o.scorecard && typeof o.scorecard === "object") return normalizeIncomingScorecard(o.scorecard);
    if (o.msg_data && typeof o.msg_data === "object") return normalizeIncomingScorecard(o.msg_data);
    return o;
}
function scorecardScalarPresent(value) {
    if (value == null) return false;
    if (typeof value === "string") return value.trim() !== "";
    if (typeof value === "number") return Number.isFinite(value);
    return true;
}
/** Keep orientation fields from the prior frame when a delta omits or nulls them. */ function retainScorecardScalar(out, prev, key) {
    if (scorecardScalarPresent(out[key])) return;
    if (scorecardScalarPresent(prev[key])) out[key] = prev[key];
}
function mergeDecimalScorecardDelta(prev, incoming) {
    const normalized = normalizeIncomingScorecard(incoming);
    if (!normalized || typeof normalized !== "object") return prev ?? incoming;
    if (!prev || typeof prev !== "object") return {
        ...normalized
    };
    const p = prev;
    const n = normalized;
    const out = {
        ...n
    };
    for(let i = 1; i <= 4; i++){
        const k = `inns${i}`;
        if (n[k] == null && p[k] != null) out[k] = p[k];
        else if (n[k] != null && typeof n[k] === "object" && !Array.isArray(n[k]) && p[k] != null && typeof p[k] === "object" && !Array.isArray(p[k])) out[k] = {
            ...p[k],
            ...n[k]
        };
    }
    // Preserve batting side / innings index — missing values swap team score rows.
    retainScorecardScalar(out, p, "bat_now");
    retainScorecardScalar(out, p, "batNow");
    retainScorecardScalar(out, p, "inns_now");
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VO1U":[function(require,module,exports,__globalThis) {
/**
 * Same idea as Squares `filterToCountedBallResults` — legal balls only (skip wides / no-balls /
 * penalties / empty). Kept local so this util stays free of component imports.
 * @param {unknown[]} raw
 * @returns {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Same “current over” row selection as {@link applyScoregridFromParsed} in DecimalSocketContext:
 * highest innings (4→1), then last over in that array with bowler set.
 * @param {any} sg scoregrid msg_data with `.overs.inns1` … `inns4`
 * @returns {{ inns: number, ov: number, delivery: any[] } | null}
 */ parcelHelpers.export(exports, "extractLatestBowlingRowFromScoregrid", ()=>extractLatestBowlingRowFromScoregrid);
/**
 * Live bat/bowl delivery strip: prefer a just-finished over when the feed has already opened
 * the next over's empty shell. Otherwise ball 6's FOUR/SIX/OUT reaction is skipped — the
 * strip's `overKey` jumps before the outcome animation can fire.
 *
 * Hold while the latest bowler-set row has 0 counted balls and the previous row in the same
 * innings already has 6. Release as soon as the new over records a counted ball.
 *
 * @param {any} sg scoregrid msg_data with `.overs.inns1` … `inns4`
 * @returns {{ inns: number, ov: number, delivery: any[] } | null}
 */ parcelHelpers.export(exports, "extractLiveDeliveryBowlingRowFromScoregrid", ()=>extractLiveDeliveryBowlingRowFromScoregrid);
function countedBalls(raw) {
    if (!Array.isArray(raw)) return 0;
    let n = 0;
    for (const item of raw){
        if (item == null) continue;
        const s = String(item).trim();
        if (!s) continue;
        const lower = s.toLowerCase();
        if (lower.includes("pen")) continue;
        if (lower.includes("wide") || /(^|[^a-z])wd([^a-z]|$)/.test(lower)) continue;
        if (/^[1-7]w$/i.test(lower)) continue;
        if (/^w\+[1-5]w$/i.test(lower)) continue;
        if (/^[1-8]nb$/i.test(lower)) continue;
        if (/no\s*ball|(^|[^a-z])nb([^a-z]|$)/.test(lower)) continue;
        n += 1;
        if (n >= 6) break;
    }
    return n;
}
/**
 * Same “current over” row selection as {@link applyScoregridFromParsed} in DecimalSocketContext:
 * highest innings (4→1), then last over in that array with bowler set.
 * @param {any} sg scoregrid msg_data with `.overs.inns1` … `inns4`
 * @returns {{ inns: number, ov: number, delivery: any[], rowIndex: number, innsRows: any[] } | null}
 */ function findLatestBowlingRow(sg) {
    if (!sg?.overs || typeof sg.overs !== "object") return null;
    for(let i = 4; i >= 1; i--){
        const thisInns = sg.overs["inns" + i];
        if (!Array.isArray(thisInns) || thisInns.length === 0) continue;
        for(let ov = thisInns.length - 1; ov >= 0; ov--){
            const row = thisInns[ov];
            if (row && row.bowler !== "" && row.bowlerid !== "") return {
                inns: i,
                ov: Number(row.ov),
                delivery: deliveryFromRow(row),
                rowIndex: ov,
                innsRows: thisInns
            };
        }
    }
    return null;
}
function deliveryFromRow(row) {
    return [
        row.b1,
        row.b2,
        row.b3,
        row.b4,
        row.b5,
        row.b6,
        row.b7,
        row.b8,
        row.b9,
        row.b10,
        row.b11,
        row.b12
    ];
}
function extractLatestBowlingRowFromScoregrid(sg) {
    const found = findLatestBowlingRow(sg);
    if (!found) return null;
    return {
        inns: found.inns,
        ov: found.ov,
        delivery: found.delivery
    };
}
function extractLiveDeliveryBowlingRowFromScoregrid(sg) {
    const latest = findLatestBowlingRow(sg);
    if (!latest) return null;
    const latestCounted = countedBalls(latest.delivery);
    if (latestCounted > 0 || latest.rowIndex <= 0) return {
        inns: latest.inns,
        ov: latest.ov,
        delivery: latest.delivery
    };
    const prevRow = latest.innsRows[latest.rowIndex - 1];
    if (!prevRow || prevRow.bowler === "" || prevRow.bowlerid === "") return {
        inns: latest.inns,
        ov: latest.ov,
        delivery: latest.delivery
    };
    const prevDelivery = deliveryFromRow(prevRow);
    if (countedBalls(prevDelivery) < 6) return {
        inns: latest.inns,
        ov: latest.ov,
        delivery: latest.delivery
    };
    return {
        inns: latest.inns,
        ov: Number(prevRow.ov),
        delivery: prevDelivery
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hm9Eh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _userContext = require("../Data/UserContext");
var _authBackPath = require("../utils/authBackPath");
const AuthenticatedRoute = /*#__PURE__*/ (0, _react.memo)(({ children })=>{
    const { user, loading } = (0, _userContext.useUser)();
    const location = (0, _reactRouterDom.useLocation)();
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "app-loading-shell",
        "aria-hidden": "true"
    });
    if (!user) {
        const back = (0, _authBackPath.locationAuthBackPath)(location.pathname, location.search);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
            to: (0, _authBackPath.buildAuthHref)("login", {
                back
            }),
            replace: true
        });
    }
    return children;
});
exports.default = AuthenticatedRoute;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../Data/UserContext":"aqd8b","../utils/authBackPath":"2oqPm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2oqPm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Resolve `?back=` deeplink targets used by login/signup flows. */ parcelHelpers.export(exports, "resolveAuthBackPath", ()=>resolveAuthBackPath);
/**
 * Current page as a post-auth `back=` target.
 * Returns null on login/signup so we don't bounce users in a loop.
 */ parcelHelpers.export(exports, "locationAuthBackPath", ()=>locationAuthBackPath);
/** Build `/login` or `/signup` with optional return path and guest-spin params. */ parcelHelpers.export(exports, "buildAuthHref", ()=>buildAuthHref);
/** Where to send an already-logged-in user who opened /login or /signup. */ parcelHelpers.export(exports, "authPageRedirectTarget", ()=>authPageRedirectTarget);
const EMAIL_LINK_PARAM = "bfe";
const AUTH_PATHS = new Set([
    "/login",
    "/signup"
]);
function resolveAuthBackPath(back) {
    if (!back || back.trim() === "") return null;
    const trimmed = back.trim();
    if (trimmed === "games" || trimmed === "/games") return "/";
    return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
}
function locationAuthBackPath(pathname, search = "") {
    if (AUTH_PATHS.has(pathname)) return null;
    return `${pathname}${search || ""}` || "/";
}
function buildAuthHref(mode, options) {
    const params = new URLSearchParams();
    const o = options || {};
    if (o.gamesession) params.set("gamesession", o.gamesession);
    if (o.game) params.set("game", o.game);
    if (o.coins) params.set("coins", o.coins);
    if (o.rubies) params.set("rubies", o.rubies);
    if (o.back) params.set("back", o.back);
    const qs = params.toString();
    return qs ? `/${mode}?${qs}` : `/${mode}`;
}
function authPageRedirectTarget(search) {
    const params = new URLSearchParams(search);
    const back = resolveAuthBackPath(params.get("back"));
    if (back) return back;
    if (params.get(EMAIL_LINK_PARAM) === "1") return "/?bfe=1";
    return "/";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iGma2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles /opt-in URL:
 * - Logged in: redirect to Account page with Preferences tab.
 * - Logged out: redirect to login with deeplink so after sign-in user lands on preferences.
 */ parcelHelpers.export(exports, "PreferencesRedirect", ()=>PreferencesRedirect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _userContext = require("../../Data/UserContext");
var _sharePageHelmet = require("../shared/SharePageHelmet");
const PREFS_PATH = "/account?t=preferences";
const LOGIN_PATH = "/login";
/** Path to return to after login (with leading slash so window.location.href = deeplink works from /login) */ const BACK_PARAM = "/opt-in";
function PreferencesRedirect() {
    const { user, loading } = (0, _userContext.useUser)();
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharePageHelmet.NoIndexHelmet), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "app-loading-shell",
                "aria-hidden": "true"
            })
        ]
    });
    if (user) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharePageHelmet.NoIndexHelmet), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                to: PREFS_PATH,
                replace: true
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharePageHelmet.NoIndexHelmet), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                to: `${LOGIN_PATH}?back=${encodeURIComponent(BACK_PARAM)}`,
                replace: true
            })
        ]
    });
}
exports.default = PreferencesRedirect;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../../Data/UserContext":"aqd8b","../shared/SharePageHelmet":"1r6QV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1r6QV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SharePageHelmet", ()=>SharePageHelmet);
/** Auth / account surfaces that should not be indexed. */ parcelHelpers.export(exports, "NoIndexHelmet", ()=>NoIndexHelmet);
var _jsxRuntime = require("react/jsx-runtime");
var _reactHelmet = require("react-helmet");
var _shareCopy = require("../../utils/shareCopy");
var _shareOgImage = require("../../utils/shareOgImage");
function SharePageHelmet({ title, description, imageAlt = (0, _shareCopy.OG_IMAGE_ALT), ogGame = "site", imageUrl, keywords, jsonLdMatchName, jsonLdApplication, jsonLdFaq, robots, url, ogType = "website" }) {
    const resolvedUrl = url ?? (typeof window !== "undefined" ? window.location.href : "https://cricket8.com/");
    const image = String(imageUrl ?? "").trim() || (0, _shareOgImage.resolveOgShareImageUrl)(ogGame);
    const matchName = jsonLdMatchName?.trim() || "";
    const jsonLdMatch = matchName ? {
        "@context": "https://schema.org",
        "@type": "SportsEvent",
        name: matchName,
        description,
        url: resolvedUrl,
        organizer: {
            "@type": "Organization",
            name: "Cricket8",
            url: "https://cricket8.com/"
        }
    } : null;
    const appName = jsonLdApplication?.name?.trim() || "";
    const jsonLdApp = !jsonLdMatch && appName ? {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: appName,
        description: String(jsonLdApplication?.description ?? description).trim() || description,
        url: String(jsonLdApplication?.url ?? resolvedUrl).trim() || resolvedUrl,
        applicationCategory: "GameApplication",
        operatingSystem: "Web",
        offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD"
        },
        provider: {
            "@type": "Organization",
            name: "Cricket8",
            url: "https://cricket8.com/"
        }
    } : null;
    const faqItems = Array.isArray(jsonLdFaq) ? jsonLdFaq.map((item)=>({
            question: String(item?.question ?? "").trim(),
            answer: String(item?.answer ?? "").trim()
        })).filter((item)=>item.question && item.answer) : [];
    const jsonLdFaqPage = faqItems.length > 0 ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqItems.map((item)=>({
                "@type": "Question",
                name: item.question,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: item.answer
                }
            }))
    } : null;
    const jsonLdBlocks = [
        jsonLdMatch || jsonLdApp,
        jsonLdFaqPage
    ].filter(Boolean);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmet.Helmet), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "description",
                content: description
            }),
            keywords ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "keywords",
                content: keywords
            }) : null,
            robots ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "robots",
                content: robots
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "canonical",
                href: resolvedUrl
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:site_name",
                content: "Cricket8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:type",
                content: ogType
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:url",
                content: resolvedUrl
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image:alt",
                content: imageAlt
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            jsonLdBlocks.map((block, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("script", {
                    type: "application/ld+json",
                    children: JSON.stringify(block)
                }, `jsonld-${index}`))
        ]
    });
}
function NoIndexHelmet() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHelmet.Helmet), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
            name: "robots",
            content: "noindex, nofollow"
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react-helmet":"5cEyM","../../utils/shareCopy":"9P9zX","../../utils/shareOgImage":"caoHI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"caoHI":[function(require,module,exports,__globalThis) {
/** Which Cricket8 product this share preview represents. Image is the same for every share. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_CDN_ENDPOINT", ()=>DEFAULT_CDN_ENDPOINT);
/** Every website share preview uses the same 1200×630 image. */ parcelHelpers.export(exports, "resolveOgShareImageUrl", ()=>resolveOgShareImageUrl);
const DEFAULT_CDN_ENDPOINT = "https://dyatkw7msrzcb.cloudfront.net";
const DEFAULT_OG_IMAGE = "c8-og.jpg";
function resolveOgShareImageUrl(_game = "site", cdnEndpoint) {
    const base = String(cdnEndpoint ?? "https://dyatkw7msrzcb.cloudfront.net" ?? DEFAULT_CDN_ENDPOINT).replace(/\/$/, "");
    return `${base}/${DEFAULT_OG_IMAGE}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2rJVc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ShopButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _shopDrawer = require("../ShopDrawer");
var _shopDrawerDefault = parcelHelpers.interopDefault(_shopDrawer);
function ShopButton() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const [open, setOpen] = (0, _react.useState)(true);
    function close() {
        setOpen(false);
        // "default" = first entry of this app session (direct visit / external link), so there is nothing in-app to go back to.
        if (location.key !== "default") navigate(-1);
        else navigate("/", {
            replace: true
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shopDrawerDefault.default), {
        isOpen: open,
        onClose: close
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../ShopDrawer":"dhLSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dhLSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _framerMotion = require("framer-motion");
var _modalAndDrawers = require("../consts/modalAndDrawers");
var _closeIcon = require("../icons/CloseIcon");
var _wallet = require("./Shop/Wallet");
var _walletDefault = parcelHelpers.interopDefault(_wallet);
const ShopDrawer = ({ isOpen, onClose })=>{
    (0, _react.useEffect)(()=>{
        if (isOpen) {
            document.body.style.overflow = "hidden";
            document.body.style.overscrollBehavior = "none";
        } else {
            document.body.style.overflow = "";
            document.body.style.overscrollBehavior = "";
        }
        return ()=>{
            document.body.style.overflow = "";
            document.body.style.overscrollBehavior = "";
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.AnimatePresence), {
        children: isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                    "data-c8-overlay-root": "true",
                    "data-c8-overlay-dismiss": "true",
                    initial: {
                        opacity: (0, _modalAndDrawers.MODAL_AND_DRAWERS_CONSTANTS).initialOpacity
                    },
                    animate: {
                        opacity: (0, _modalAndDrawers.MODAL_AND_DRAWERS_CONSTANTS).animationOpacity
                    },
                    exit: {
                        opacity: (0, _modalAndDrawers.MODAL_AND_DRAWERS_CONSTANTS).exitOpacity
                    },
                    onClick: onClose,
                    className: "fixed inset-0 bg-black/70 z-[10000] overflow-hidden touch-none overscroll-none"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
                    initial: {
                        y: "-100%"
                    },
                    animate: {
                        y: 0
                    },
                    exit: {
                        y: "-100%"
                    },
                    transition: {
                        type: "spring",
                        damping: 25,
                        stiffness: 200
                    },
                    id: "shopDrawer",
                    "data-c8-overlay-root": "true",
                    className: "fixed top-0 left-0 right-0 z-[10002] flex max-h-[100dvh] w-full max-w-full flex-col overflow-hidden border-b border-white/10 bg-[#4E2681] md:max-h-[calc(100dvh-50px)] lg:max-h-[calc(100dvh-97px)]",
                    style: {
                        paddingTop: "env(safe-area-inset-top, 0px)"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "z-10 w-full max-w-full shrink-0 overflow-x-hidden border-t-2 border-blue-500",
                            style: {
                                background: "linear-gradient(88.89deg, #652DAF 0%, #623998 100%)"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "c8-shell relative flex items-center justify-center py-3 pl-4 pr-1 md:pl-6 md:pr-1.5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-white font-anton text-[16px] md:text-[18px] uppercase leading-none flex items-center py-0",
                                        children: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        onClick: onClose,
                                        className: "absolute right-0.5 top-1/2 flex min-h-11 min-w-11 -translate-y-1/2 items-center justify-center py-0 leading-none text-white transition-colors hover:text-gray-300 md:right-1",
                                        "aria-label": "Close",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIcon.CloseIcon), {
                                            size: 28
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "min-h-0 w-full max-w-full flex-1 overflow-x-hidden overflow-y-auto overscroll-contain bg-[#401A6E] pb-[max(16px,env(safe-area-inset-bottom,0px))] [-webkit-overflow-scrolling:touch]",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "c8-shell",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _walletDefault.default), {})
                            })
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = ShopDrawer;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","framer-motion":"fI0Q4","../consts/modalAndDrawers":"4tVoT","../icons/CloseIcon":"5C2ma","./Shop/Wallet":"f9M4K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4tVoT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MODAL_AND_DRAWERS_CONSTANTS", ()=>MODAL_AND_DRAWERS_CONSTANTS);
const MODAL_AND_DRAWERS_CONSTANTS = {
    initialOpacity: 0,
    animationOpacity: 0.8,
    exitOpacity: 0
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5C2ma":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseIcon", ()=>(0, _closeIcon.CloseIcon));
var _closeIcon = require("./CloseIcon");

},{"./CloseIcon":"7JRht","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7JRht":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseIcon", ()=>CloseIcon);
var _jsxRuntime = require("react/jsx-runtime");
const CLOSE_X_VIEWBOX = "0 0 256 256";
const CLOSE_X_PATH = "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z";
const CloseIcon = ({ className = "", size = 15 })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: className,
        fill: "currentColor",
        height: size,
        width: size,
        viewBox: CLOSE_X_VIEWBOX,
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: CLOSE_X_PATH
        })
    });
};

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f9M4K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Wallet);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _reactRouterDom = require("react-router-dom");
var _userContext = require("../../Data/UserContext");
var _avatarWithXpCrown = require("../Xp/AvatarWithXpCrown");
var _avatarFrame = require("../Profile/avatarFrame");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _flyingCoins = require("./FlyingCoins");
var _flyingCoinsDefault = parcelHelpers.interopDefault(_flyingCoins);
var _flyingRubies = require("./FlyingRubies");
var _flyingRubiesDefault = parcelHelpers.interopDefault(_flyingRubies);
var _hardOffers = require("./HardOffers");
var _hardOffersDefault = parcelHelpers.interopDefault(_hardOffers);
var _softOffers = require("./SoftOffers");
var _softOffersDefault = parcelHelpers.interopDefault(_softOffers);
var _featureUnlockPack = require("./FeatureUnlockPack");
var _featureUnlockPackDefault = parcelHelpers.interopDefault(_featureUnlockPack);
var _avatarFramesShop = require("./AvatarFramesShop");
var _avatarFramesShopDefault = parcelHelpers.interopDefault(_avatarFramesShop);
var _shopFooter = require("./ShopFooter");
var _shopFooterDefault = parcelHelpers.interopDefault(_shopFooter);
var _authHeaders = require("../../utils/authHeaders");
var _virtualCurrencyDisclaimer = require("../../utils/virtualCurrencyDisclaimer");
var _respectDeviceSilentSwitch = require("../../utils/respectDeviceSilentSwitch");
/** Sounds */ const COINS_WON_SOUND_URL = "/assets/coins_won.mp3";
const RUBY_WON_SOUND_URL = "/assets/ruby_won.mp3";
const SHOP_PAGE_PATH = "/shop";
function Wallet({ rubiesOnly = false } = {}) {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { user, setUser } = (0, _userContext.useUser)();
    const [isAnimatingCoins, setIsAnimatingCoins] = (0, _react.useState)(false);
    const [isAnimatingRubies, setIsAnimatingRubies] = (0, _react.useState)(false);
    const [isUpdatedCoins, setIsUpdatedCoins] = (0, _react.useState)(false);
    const [isUpdatedRubies, setIsUpdatedRubies] = (0, _react.useState)(false);
    const [rubyDecreaseFlash, setRubyDecreaseFlash] = (0, _react.useState)(false);
    const isShopEnabled = true;
    const [coins, setCoins] = (0, _react.useState)(0);
    const [rubies, setRubies] = (0, _react.useState)(0);
    const [hasHardOffers, setHasHardOffers] = (0, _react.useState)(false);
    const coinAnimationTimeoutRef = (0, _react.useRef)(null);
    const rubyAnimationTimeoutRef = (0, _react.useRef)(null);
    const rubyDecreaseFlashTimeoutRef = (0, _react.useRef)(null);
    const prevCoinsRef = (0, _react.useRef)(0);
    const prevRubiesRef = (0, _react.useRef)(0);
    /** Only animate on load when we know the balance increased from a purchase or bonus, not on every Shop open */ const shouldAnimateWalletRef = (0, _react.useRef)(false);
    const coinsWinSoundRef = (0, _react.useRef)(null);
    const rubyWonSoundRef = (0, _react.useRef)(null);
    const playCoinsWinSound = (0, _react.useCallback)(()=>{
        try {
            (0, _respectDeviceSilentSwitch.respectDeviceSilentSwitch)();
            const audio = coinsWinSoundRef.current ?? new Audio(COINS_WON_SOUND_URL);
            coinsWinSoundRef.current = audio;
            audio.currentTime = 0;
            audio.play().catch(()=>{});
        } catch (_) {}
    }, []);
    const playRubyWonSound = (0, _react.useCallback)(()=>{
        try {
            (0, _respectDeviceSilentSwitch.respectDeviceSilentSwitch)();
            const audio = rubyWonSoundRef.current ?? new Audio(RUBY_WON_SOUND_URL);
            rubyWonSoundRef.current = audio;
            audio.currentTime = 0;
            audio.play().catch(()=>{});
        } catch (_) {}
    }, []);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (coinAnimationTimeoutRef.current != null) clearTimeout(coinAnimationTimeoutRef.current);
            if (rubyAnimationTimeoutRef.current != null) clearTimeout(rubyAnimationTimeoutRef.current);
            if (rubyDecreaseFlashTimeoutRef.current != null) clearTimeout(rubyDecreaseFlashTimeoutRef.current);
        };
    }, []);
    (0, _react.useEffect)(()=>{
        (0, _frontendTrackingEvents.trackShopView)({
            user_id: user?.userId,
            pathname: SHOP_PAGE_PATH
        });
    }, [
        user?.userId
    ]);
    function triggerCoinAnimation() {
        setIsAnimatingCoins(true);
        setIsUpdatedCoins(true);
        if (coinAnimationTimeoutRef.current != null) clearTimeout(coinAnimationTimeoutRef.current);
        coinAnimationTimeoutRef.current = setTimeout(()=>{
            setIsAnimatingCoins(false);
            setIsUpdatedCoins(false);
            coinAnimationTimeoutRef.current = null;
        }, 3000);
    }
    function triggerRubyAnimation() {
        setIsAnimatingRubies(true);
        setIsUpdatedRubies(true);
        if (rubyAnimationTimeoutRef.current != null) clearTimeout(rubyAnimationTimeoutRef.current);
        rubyAnimationTimeoutRef.current = setTimeout(()=>{
            setIsAnimatingRubies(false);
            setIsUpdatedRubies(false);
            rubyAnimationTimeoutRef.current = null;
        }, 3000);
    }
    // Play sound when animation state turns true (fallback for updateCoins/updateRubies; primary play is in click handlers via playCoinsWinSound/playRubyWonSound)
    (0, _react.useEffect)(()=>{
        if (isAnimatingCoins) playCoinsWinSound();
    }, [
        isAnimatingCoins,
        playCoinsWinSound
    ]);
    (0, _react.useEffect)(()=>{
        if (isAnimatingRubies) playRubyWonSound();
    }, [
        isAnimatingRubies,
        playRubyWonSound
    ]);
    // Show balance animation only when balance increased from a purchase or bonus (not on every Shop open)
    (0, _react.useEffect)(()=>{
        if (coins > prevCoinsRef.current && shouldAnimateWalletRef.current) {
            triggerCoinAnimation();
            setTimeout(()=>{
                shouldAnimateWalletRef.current = false;
            }, 0);
        }
        prevCoinsRef.current = coins;
    }, [
        coins
    ]);
    (0, _react.useEffect)(()=>{
        if (rubies > prevRubiesRef.current && shouldAnimateWalletRef.current) {
            triggerRubyAnimation();
            setTimeout(()=>{
                shouldAnimateWalletRef.current = false;
            }, 0);
        }
        prevRubiesRef.current = rubies;
    }, [
        rubies
    ]);
    /** @param forceRefresh - when true, always fetch from API (e.g. after payment return) so we don't overwrite with stale user.wallet */ async function getWallet(forceRefresh = false) {
        const session_token = (0, _jsCookieDefault.default).get("c8_session_token");
        if (!session_token) return;
        if (!forceRefresh && user?.wallet != null) {
            setCoins(user.wallet?.coins ?? 0);
            setRubies(user.wallet?.rubies ?? 0);
            return;
        }
        try {
            const response = await fetch(`${"https://cricket8.com/api"}/account/${session_token}`, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            if (response.status === 200) {
                const data = await response.json();
                const coinsVal = data.data?.wallet?.coins ?? 0;
                const rubiesVal = data.data?.wallet?.rubies ?? 0;
                setCoins(coinsVal);
                setRubies(rubiesVal);
                setUser((prev)=>prev ? {
                        ...prev,
                        wallet: {
                            ...prev.wallet ?? {},
                            coins: coinsVal,
                            rubies: rubiesVal
                        }
                    } : null);
            }
        } catch (error) {
            console.error("Error fetching wallet:", error);
        }
    }
    const ANIMATE_WALLET_ON_OPEN_KEY = "c8_animate_wallet_on_open";
    (0, _react.useEffect)(()=>{
        const paymentRubies = sessionStorage.getItem("c8_payment_success_rubies");
        if (paymentRubies != null) {
            const num = Number(paymentRubies);
            if (!Number.isNaN(num)) setRubies(num);
            sessionStorage.removeItem("c8_payment_success_rubies");
            shouldAnimateWalletRef.current = true;
            getWallet(true).catch(console.error);
        } else if (typeof sessionStorage !== "undefined" && sessionStorage.getItem(ANIMATE_WALLET_ON_OPEN_KEY) === "1") {
            sessionStorage.removeItem(ANIMATE_WALLET_ON_OPEN_KEY);
            shouldAnimateWalletRef.current = true;
            getWallet().catch(console.error);
        } else getWallet().catch(console.error);
    }, [
        user?.wallet
    ]);
    // Refetch wallet and show animation when wallet is updated elsewhere (e.g. email bonus)
    (0, _react.useEffect)(()=>{
        const onWalletUpdate = ()=>{
            shouldAnimateWalletRef.current = true;
            getWallet(true).catch(console.error);
        };
        window.addEventListener("walletUpdate", onWalletUpdate);
        return ()=>window.removeEventListener("walletUpdate", onWalletUpdate);
    }, []);
    async function UpdateUserAmount(offerId, offerType, meta) {
        const session_token = (0, _jsCookieDefault.default).get("c8_session_token");
        if (!session_token) return;
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/buy`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    user_session: session_token,
                    offer_id: offerId
                })
            });
            const response = await res.json();
            const { data } = response;
            if (offerType === "soft") {
                if (res.status === 201 && data?.coins !== undefined) {
                    updateCoins(data.coins);
                    setRubies(data.rubies);
                // purchase_success: server Measurement Protocol (/buy soft conversion)
                } else (0, _frontendTrackingEvents.trackPurchaseFailed)({
                    user_id: user?.userId,
                    product_id: offerId,
                    product_type: "coin_pack",
                    amount: meta?.pay_amount,
                    currency: "RUBIES",
                    error_type: "validation_error",
                    pathname: SHOP_PAGE_PATH
                });
            }
            if (data?.rubies !== undefined && offerType === "hard") updateRubies(data.rubies);
        } catch (error) {
            console.error("Error updating user amount:", error);
            if (offerType === "soft") (0, _frontendTrackingEvents.trackPurchaseFailed)({
                user_id: user?.userId,
                product_id: offerId,
                product_type: "coin_pack",
                amount: meta?.pay_amount,
                currency: "RUBIES",
                error_type: "network_error",
                pathname: SHOP_PAGE_PATH
            });
        }
    }
    function updateCoins(newCoins) {
        setCoins(newCoins);
        setIsAnimatingCoins(true);
        setIsUpdatedCoins(true);
        if (coinAnimationTimeoutRef.current != null) clearTimeout(coinAnimationTimeoutRef.current);
        coinAnimationTimeoutRef.current = setTimeout(()=>{
            setIsAnimatingCoins(false);
            setIsUpdatedCoins(false);
            coinAnimationTimeoutRef.current = null;
        }, 3000);
    }
    function updateRubies(newRubies) {
        const isDecrease = newRubies < rubies;
        setRubies(newRubies);
        setUser((prev)=>prev ? {
                ...prev,
                wallet: {
                    ...prev.wallet ?? {
                        coins: 0,
                        rubies: 0
                    },
                    rubies: newRubies,
                    coins: prev.wallet?.coins ?? 0
                }
            } : null);
        if (isDecrease) {
            if (rubyDecreaseFlashTimeoutRef.current != null) clearTimeout(rubyDecreaseFlashTimeoutRef.current);
            setRubyDecreaseFlash(true);
            rubyDecreaseFlashTimeoutRef.current = setTimeout(()=>{
                setRubyDecreaseFlash(false);
                rubyDecreaseFlashTimeoutRef.current = null;
            }, 600);
        } else {
            setIsAnimatingRubies(true);
            setIsUpdatedRubies(true);
            if (rubyAnimationTimeoutRef.current != null) clearTimeout(rubyAnimationTimeoutRef.current);
            rubyAnimationTimeoutRef.current = setTimeout(()=>{
                setIsAnimatingRubies(false);
                setIsUpdatedRubies(false);
                rubyAnimationTimeoutRef.current = null;
            }, 3000);
        }
    }
    const formatCoins = (amount)=>{
        return new Intl.NumberFormat('en-IN').format(amount);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-[100%]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "h-[56px] w-[100%] flex flex-row justify-between items-center bg-[#472176] border-y border-[#1B062F] border-solid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            window.dispatchEvent(new CustomEvent("closeShopDrawer"));
                            navigate("/account");
                        },
                        className: "flex flex-row items-center pl-[7px] cursor-pointer bg-transparent border-none text-left",
                        "aria-label": "Open account",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarWithXpCrown.AvatarWithXpCrown), {
                                crown: user?.xp_week_crown,
                                frameSrc: (0, _avatarFrame.resolveAvatarFrameSrc)("md", user?.avatar_frame_url, user?.avatar_frame_small_url),
                                className: "block h-[40px] w-[40px] shrink-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "h-full w-full rounded-none object-cover",
                                    src: user?.avatar,
                                    alt: "",
                                    loading: "lazy",
                                    decoding: "async"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "ml-[10px] text-white font-[400] text-[14px] font-anton leading-[22px] uppercase",
                                children: user?.player_name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-row items-center gap-[8px] pr-[7px]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `flex flex-row items-center gap-[6px] px-[8px] py-[10px] relative transition-colors duration-300 ${rubyDecreaseFlash ? 'text-[#f87171]' : 'text-white'}`,
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.10)'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flyingRubiesDefault.default), {
                                                isAnimating: isAnimatingRubies
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                alt: 'how many rubies the user has',
                                                className: "w-[20px] h-[20px] relative z-10",
                                                src: "/assets/currency-ruby.png",
                                                loading: "lazy",
                                                decoding: "async"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: `font-chakra text-[14px] font-[700] transition-colors duration-300 ${isUpdatedRubies ? 'amount-increse-animation' : ''} ${rubyDecreaseFlash ? 'text-[#f87171]' : 'text-white'}`,
                                        children: rubies
                                    })
                                ]
                            }),
                            rubiesOnly ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-row items-center gap-[6px] px-[8px] py-[10px] relative",
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.10)'
                                },
                                title: (0, _virtualCurrencyDisclaimer.FTP_DISCLAIMER_SHORT),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flyingCoinsDefault.default), {
                                                isAnimating: isAnimatingCoins
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                alt: "Game coins",
                                                className: "w-[20px] h-[20px] relative z-10",
                                                src: "/assets/currency-coin.png"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-col items-start leading-none",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-anton text-[8px] font-normal uppercase tracking-[0%] text-white/60",
                                                children: "GAME COINS"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: `font-chakra text-white text-[14px] font-[700] ${isUpdatedCoins ? 'amount-increse-animation' : ''}`,
                                                children: formatCoins(coins)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isShopEnabled && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-[100%] flex-col items-center bg-[#401A6E] py-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex h-[30px] w-[100%] flex-row items-center justify-center gap-[8px] font-anton text-[14px] font-[400] leading-[15px] text-white",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "w-[25px] h-[25px]",
                                        src: "/assets/currency-ruby.png",
                                        alt: "ruby icon"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-anton",
                                        children: "GET RUBIES"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "w-[25px] h-[25px]",
                                        src: "/assets/currency-ruby.png",
                                        alt: "ruby icon"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "px-3 pb-1 text-center font-chakra text-[11px] leading-snug text-white/55 normal-case",
                                children: (0, _virtualCurrencyDisclaimer.VIRTUAL_CURRENCY_SHOP_NOTE)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hardOffersDefault.default), {
                        updateRubies: updateRubies,
                        setIsAnimatingRubies: setIsAnimatingRubies,
                        onOffersLoaded: setHasHardOffers
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex w-[100%] flex-col items-center bg-[#401A6E] py-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex h-[30px] w-[100%] flex-row items-center justify-center gap-[8px] font-anton text-[14px] font-[400] leading-[15px] text-white",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "w-[25px] h-[25px]",
                                        src: "/assets/currency-coin.png",
                                        alt: "coin icon"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-anton",
                                        children: "GET COINS"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "w-[25px] h-[25px]",
                                        src: "/assets/currency-coin.png",
                                        alt: "coin icon"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "px-3 pb-1 text-center font-chakra text-[11px] leading-snug text-white/55 normal-case",
                                children: (0, _virtualCurrencyDisclaimer.VIRTUAL_CURRENCY_SHOP_NOTE)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _softOffersDefault.default), {
                        setIsAnimatingCoins: setIsAnimatingCoins,
                        onPlayCoinsSound: playCoinsWinSound,
                        totalRubies: rubies,
                        updateUserAmount: UpdateUserAmount
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-[100%] h-[30px] font-[400] text-[14px] font-anton leading-[15px] bg-[#401A6E] text-white flex flex-row items-center justify-center gap-[8px] py-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-anton",
                            children: "GET PACKS"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex w-[100%] items-center justify-evenly gap-0.5 overflow-x-auto overflow-y-hidden bg-inherit px-[3px]",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureUnlockPackDefault.default), {
                            rubies: rubies,
                            updateRubies: updateRubies,
                            setIsAnimatingRubies: setIsAnimatingRubies
                        })
                    }),
                    rubiesOnly ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarFramesShopDefault.default), {
                        rubies: rubies,
                        coins: coins
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shopFooterDefault.default), {
                        className: "px-3 my-[18px]"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","js-cookie":"2P5RE","react-router-dom":"l6ORY","../../Data/UserContext":"aqd8b","../Xp/AvatarWithXpCrown":"9U2iQ","../Profile/avatarFrame":"k4MjP","../../utils/frontendTrackingEvents":"4Y90p","./FlyingCoins":"lCdgo","./FlyingRubies":"8kosq","./HardOffers":"j5kk5","./SoftOffers":"8WBJo","./FeatureUnlockPack":"ellqq","./AvatarFramesShop":"jAJlP","./ShopFooter":"iy57h","../../utils/authHeaders":"5Rczo","../../utils/virtualCurrencyDisclaimer":"eHHb8","../../utils/respectDeviceSilentSwitch":"f0Qz7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9U2iQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XP_WEEK_CROWN_ASSETS", ()=>XP_WEEK_CROWN_ASSETS);
parcelHelpers.export(exports, "AVATAR_PRESENCE_INDICATOR_Z_CLASS", ()=>AVATAR_PRESENCE_INDICATOR_Z_CLASS);
parcelHelpers.export(exports, "normalizeXpWeekCrown", ()=>normalizeXpWeekCrown);
/** Place label for the current-week avatar crown (last week's podium). */ parcelHelpers.export(exports, "xpWeekCrownReason", ()=>xpWeekCrownReason);
/** Wraps an avatar image/tile with the current-week XP podium crown overlay and optional avatar frame. */ parcelHelpers.export(exports, "AvatarWithXpCrown", ()=>AvatarWithXpCrown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const XP_WEEK_CROWN_ASSETS = {
    gold: "/assets/crown-gold.png",
    silver: "/assets/crown-silver.png",
    bronze: "/assets/crown-bronze.png"
};
const AVATAR_PRESENCE_INDICATOR_Z_CLASS = "z-[3]";
/** Crown image covers ~96% of avatar; dark overlay fills edge-to-edge inside the border. */ const CROWN_IMAGE_RATIO = 0.96;
/** Inside an avatar frame the crown shrinks to clear the frame band and its bottom plate. */ const FRAMED_CROWN_IMAGE_RATIO = 0.7;
/** Optical nudge — crown peaks read high vs pixel bbox; drop-shadow adds weight below. */ const CROWN_VERTICAL_OFFSET = "4%";
const XP_CROWN_BORDER_IMAGE = {
    gold: "linear-gradient(180deg, #F8FCC1 0%, #ECC86A 17.24%, #FDF19E 36.62%, #815D21 50.59%, #B48D48 66.03%, #4E2E03 84.27%, #845824 92.81%, #AE894A 99.54%)",
    silver: "linear-gradient(180deg, #FFF8E3 0%, #E6E6E6 17.24%, #FFFFFF 36.62%, #858585 50.59%, #ABABAB 66.03%, #4D4D4D 84.27%, #878787 92.81%, #B6B6B6 99.54%)",
    bronze: "linear-gradient(180deg, #FCECC1 0%, #EC9C6A 17.24%, #FDCF9E 36.62%, #813321 50.59%, #B46748 66.03%, #4E0B03 84.27%, #843224 92.81%, #AE5B4A 99.54%)"
};
function normalizeXpWeekCrown(value) {
    const v = String(value ?? "").trim().toLowerCase();
    if (v === "gold" || v === "silver" || v === "bronze") return v;
    return null;
}
const XP_WEEK_CROWN_PLACE = {
    gold: "1st",
    silver: "2nd",
    bronze: "3rd"
};
function xpWeekCrownReason(crown) {
    const normalized = normalizeXpWeekCrown(crown);
    if (!normalized) return null;
    return {
        place: XP_WEEK_CROWN_PLACE[normalized]
    };
}
function crownBorderStyle(crown) {
    return {
        border: "1px solid",
        borderImageSource: XP_CROWN_BORDER_IMAGE[crown],
        borderImageSlice: 1
    };
}
function AvatarWithXpCrown({ crown, className = "", crownClassName = "", frameSrc = null, children }) {
    const normalized = normalizeXpWeekCrown(crown);
    const frame = String(frameSrc ?? "").trim();
    const crownRatio = frame ? FRAMED_CROWN_IMAGE_RATIO : CROWN_IMAGE_RATIO;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: `relative inline-flex shrink-0 ${className}`,
        style: normalized && !frame ? crownBorderStyle(normalized) : undefined,
        children: [
            children,
            normalized ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "pointer-events-none absolute inset-0 z-[1] flex items-center justify-center bg-[#1B062FE5]",
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: XP_WEEK_CROWN_ASSETS[normalized],
                    alt: "",
                    className: `block object-contain drop-shadow-[0_0_6px_rgba(0,0,0,0.45)] ${crownClassName}`,
                    style: {
                        width: `${crownRatio * 100}%`,
                        height: `${crownRatio * 100}%`,
                        transform: frame ? undefined : `translateY(${CROWN_VERTICAL_OFFSET})`
                    },
                    loading: "lazy",
                    decoding: "async",
                    "aria-hidden": true
                })
            }) : null,
            frame ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: frame,
                alt: "",
                className: "pointer-events-none absolute inset-0 z-[2] block h-full w-full select-none",
                loading: "lazy",
                decoding: "async",
                draggable: false,
                "aria-hidden": true
            }) : null
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k4MjP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Frame artwork for an avatar size, or null where a frame would just be noise (≤ 22px). */ parcelHelpers.export(exports, "resolveAvatarFrameSrc", ()=>resolveAvatarFrameSrc);
/** Spread onto `UserAvatar` from any API row that carries `avatar_frame_url` / `avatar_frame_small_url`. */ parcelHelpers.export(exports, "avatarFrameProps", ()=>avatarFrameProps);
/** Fine detail (the "5K" plate) only reads from ~64px; below that use the simplified artwork. */ const FULL_FRAME_SIZES = new Set([
    "hero",
    "lg",
    "fill"
]);
const SMALL_FRAME_SIZES = new Set([
    "chip",
    "md",
    "xs",
    "sm",
    "compact"
]);
function resolveAvatarFrameSrc(size, frameUrl, frameSmallUrl) {
    const full = String(frameUrl ?? "").trim();
    if (!full) return null;
    if (FULL_FRAME_SIZES.has(size)) return full;
    if (SMALL_FRAME_SIZES.has(size)) return String(frameSmallUrl ?? "").trim() || full;
    return null;
}
function avatarFrameProps(row) {
    return {
        avatarFrameUrl: row?.avatar_frame_url ?? null,
        avatarFrameSmallUrl: row?.avatar_frame_small_url ?? null
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lCdgo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FlyingCoins);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _flyingCurrency = require("./FlyingCurrency");
var _flyingCurrencyDefault = parcelHelpers.interopDefault(_flyingCurrency);
function FlyingCoins({ isAnimating }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flyingCurrencyDefault.default), {
        variant: "coin",
        isAnimating: isAnimating
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./FlyingCurrency":"lFdq8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lFdq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FlyingCurrency);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const VARIANTS = {
    coin: {
        src: "/assets/currency-coin.png",
        alt: "flying coins"
    },
    ruby: {
        src: "/assets/currency-ruby.png",
        alt: "flying rubies"
    }
};
const PARTICLE_CONFIG = [
    // Large (30px) – no delay
    {
        size: 30,
        direction: "up",
        position: "center"
    },
    {
        size: 30,
        direction: "down",
        position: "center"
    },
    {
        size: 30,
        direction: "left",
        position: "corner"
    },
    {
        size: 30,
        direction: "right",
        position: "corner"
    },
    {
        size: 30,
        direction: "up-left",
        position: "corner"
    },
    {
        size: 30,
        direction: "up-right",
        position: "corner"
    },
    {
        size: 30,
        direction: "down-left",
        position: "corner"
    },
    {
        size: 30,
        direction: "down-right",
        position: "corner"
    },
    // Medium (18px)
    {
        size: 18,
        direction: "up",
        position: "center",
        delay: "0.1s"
    },
    {
        size: 18,
        direction: "down",
        position: "center",
        delay: "0.2s"
    },
    {
        size: 18,
        direction: "left",
        position: "corner",
        delay: "0.15s"
    },
    {
        size: 18,
        direction: "right",
        position: "corner",
        delay: "0.25s"
    },
    {
        size: 18,
        direction: "up-left",
        position: "corner",
        delay: "0.1s"
    },
    {
        size: 18,
        direction: "up-right",
        position: "corner",
        delay: "0.2s"
    },
    {
        size: 18,
        direction: "down-left",
        position: "corner",
        delay: "0.15s"
    },
    {
        size: 18,
        direction: "down-right",
        position: "corner",
        delay: "0.25s"
    },
    // Small (12px)
    {
        size: 12,
        direction: "up",
        position: "center",
        delay: "0.3s"
    },
    {
        size: 12,
        direction: "down",
        position: "center",
        delay: "0.4s"
    },
    {
        size: 12,
        direction: "left",
        position: "corner",
        delay: "0.35s"
    },
    {
        size: 12,
        direction: "right",
        position: "corner",
        delay: "0.45s"
    }
];
function FlyingCurrency({ variant, isAnimating }) {
    if (!isAnimating) return null;
    const { src, alt } = VARIANTS[variant];
    const baseStyle = {
        transformStyle: "preserve-3d"
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "relative",
        style: {
            perspective: "1000px"
        },
        children: PARTICLE_CONFIG.map(({ size, direction, position, delay }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                alt: alt,
                className: `flying-coins-${direction} absolute ${position === "center" ? "top-0 left-1/2 -translate-x-1/2" : "top-0 left-0"}`,
                style: {
                    ...baseStyle,
                    width: size,
                    height: size,
                    ...delay && {
                        animationDelay: delay
                    }
                },
                src: src
            }, `${size}-${direction}-${index}`))
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kosq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FlyingRubies);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _flyingCurrency = require("./FlyingCurrency");
var _flyingCurrencyDefault = parcelHelpers.interopDefault(_flyingCurrency);
function FlyingRubies({ isAnimating }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flyingCurrencyDefault.default), {
        variant: "ruby",
        isAnimating: isAnimating
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./FlyingCurrency":"lFdq8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j5kk5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HardOffers);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _userContext = require("../../Data/UserContext");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _modals = require("../Modals");
var _modalsDefault = parcelHelpers.interopDefault(_modals);
var _paymentModal = require("./PaymentModal");
var _paymentModalDefault = parcelHelpers.interopDefault(_paymentModal);
var _saleCountdown = require("./SaleCountdown");
var _saleCountdownDefault = parcelHelpers.interopDefault(_saleCountdown);
var _offers = require("./api/offers");
const SHOP_PAGE_PATH = '/shop';
/** Skeleton card matching one "Get rubies" offer (icon, amount, button) */ function HardOfferCardSkeleton() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col justify-center items-center gap-1 relative px-2 py-3 bg-white w-full min-w-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-10 h-10 bg-gray-200 animate-pulse shrink-0",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "h-5 w-14 bg-gray-200 animate-pulse shrink-0",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "h-10 w-[100px] bg-gray-200 animate-pulse shrink-0",
                "aria-hidden": true
            })
        ]
    });
}
function HardOffersSkeleton() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-[100%] items-center justify-evenly gap-0.5 overflow-x-auto overflow-y-hidden bg-inherit px-[3px]",
        children: [
            1,
            2,
            3
        ].map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(HardOfferCardSkeleton, {}, i))
    });
}
function HardOffers({ updateRubies, setIsAnimatingRubies, onOffersLoaded }) {
    const { user } = (0, _userContext.useUser)();
    const [open, setOpen] = (0, _react.useState)(false);
    const [hardOffers, setHardOffers] = (0, _react.useState)([]);
    const [selectedOffer, setSelectedOffer] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)("");
    (0, _react.useEffect)(()=>{
        fetchHardOffers();
    }, []);
    async function fetchHardOffers({ silent = false } = {}) {
        if (!silent) {
            setLoading(true);
            setError("");
        }
        try {
            const hardData = await (0, _offers.getHardOffers)();
            setHardOffers(hardData);
            onOffersLoaded?.(hardData.length > 0);
        } catch (error) {
            console.error(error);
            if (!silent) {
                setError(error instanceof Error ? error.message : String(error));
                onOffersLoaded?.(false);
            }
        } finally{
            if (!silent) setLoading(false);
        }
    }
    const refreshAfterSaleEnds = ()=>void fetchHardOffers({
            silent: true
        });
    function openOfferModal(item) {
        setSelectedOffer(item);
        setOpen(true);
    }
    function closeModal() {
        setOpen(false);
        setSelectedOffer(null);
        fetchHardOffers({
            silent: true
        });
    }
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(HardOffersSkeleton, {});
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col items-center gap-2 py-3",
        role: "alert",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "font-anton text-white",
                children: "Couldn't load ruby packs."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                onClick: ()=>void fetchHardOffers(),
                className: "bg-lime px-6 py-2 font-anton text-main",
                children: "Retry"
            })
        ]
    });
    if (hardOffers.length === 0) return null;
    // Hide BEST VALUE while any pack is on sale — sale pricing can change which pack is cheapest.
    const anyOnSale = hardOffers.some((o)=>o.on_sale && o.sale_percent);
    const bestValueId = anyOnSale ? null : (0, _offers.bestValueOfferId)(hardOffers);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex w-[100%] items-stretch justify-evenly gap-0.5 overflow-x-auto overflow-y-hidden bg-inherit px-[3px]",
                children: hardOffers.map((item)=>{
                    const price = (0, _offers.currentPrice)(item);
                    const onSale = Boolean(item.on_sale && item.sale_percent);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `flex flex-col justify-center items-center gap-1 relative overflow-hidden px-2 py-3 bg-white w-full ${onSale ? 'ring-2 ring-inset ring-red' : ''}`,
                        children: [
                            onSale ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "absolute p-[2px] text-[13px] w-[120px] bg-red top-[15px] right-[-40px] rotate-[45deg] text-center font-anton text-white",
                                children: [
                                    "\u2212",
                                    item.sale_percent,
                                    "%"
                                ]
                            }) : item.id === bestValueId ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "absolute p-[2px] text-[10px] w-[120px] bg-goldB top-[15px] right-[-40px] rotate-[45deg] text-center font-anton text-main",
                                children: "BEST VALUE"
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "w-[40px] h-[40px]",
                                src: "/assets/currency-ruby.png",
                                alt: "ruby"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "text-red font-anton font-[400] text-[20px]",
                                children: [
                                    "x",
                                    item.receive_amount
                                ]
                            }),
                            onSale ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "flex items-center gap-[4px] font-anton text-[13px] leading-none",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "text-gray-400 line-through",
                                        "aria-label": `Was \u{20B9}${item.pay_amount}`,
                                        children: [
                                            "\u20B9",
                                            item.pay_amount
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "bg-red px-[4px] py-[1px] text-[11px] uppercase text-white",
                                        children: [
                                            "Save \u20B9",
                                            item.pay_amount - price
                                        ]
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>{
                                    (0, _frontendTrackingEvents.trackProductSelected)({
                                        user_id: user?.userId,
                                        product_id: item.id,
                                        product_type: 'ruby_pack',
                                        product_name: item.offer_name?.trim() || `x${item.receive_amount}_rubies`,
                                        price,
                                        ...onSale && {
                                            original_price: item.pay_amount,
                                            discount_pct: item.sale_percent
                                        },
                                        currency: 'INR',
                                        pathname: SHOP_PAGE_PATH
                                    });
                                    openOfferModal(item);
                                },
                                className: "font-anton text-white uppercase font-[400] text-[14px] flex flex-row items-center justify-center gap-[2px] bg-lime whitespace-nowrap w-[100px] h-[40px] text-center font-[400]",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "font-anton font-[14px] text-[#1B062F]",
                                    children: [
                                        "GET FOR \u20B9",
                                        price
                                    ]
                                })
                            }),
                            onSale && item.sale_ends_at ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _saleCountdownDefault.default), {
                                endsAt: item.sale_ends_at,
                                onExpire: refreshAfterSaleEnds,
                                className: "text-red"
                            }) : null
                        ]
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalsDefault.default), {
                isOpen: open,
                onRequestClose: closeModal,
                contentLabel: "BUY",
                contentClassName: "hide-scrollbar",
                children: selectedOffer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentModalDefault.default), {
                    receiveAmount: selectedOffer.receive_amount,
                    payAmount: (0, _offers.currentPrice)(selectedOffer),
                    originalPayAmount: selectedOffer.on_sale ? selectedOffer.pay_amount : undefined,
                    saleEndsAt: selectedOffer.on_sale ? selectedOffer.sale_ends_at : null,
                    offerId: selectedOffer.id,
                    updateRubies: updateRubies,
                    closeModal: closeModal,
                    offerType: selectedOffer.offer_type,
                    setIsAnimatingRubies: setIsAnimatingRubies
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../Data/UserContext":"aqd8b","../../utils/frontendTrackingEvents":"4Y90p","../Modals":"dJE67","./PaymentModal":"651ko","./SaleCountdown":"fijDF","./api/offers":"1Vfqc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJE67":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
const getModalWidth = ()=>{
    if (window.innerWidth >= 768) return "50%";
    else return "90%";
};
const CustomModal = ({ isOpen, onRequestClose, contentLabel, children, contentClassName })=>{
    (0, _react.useEffect)(()=>{
        const updateWidth = ()=>{
            const modalContent = document.querySelector(".ReactModal__Content");
            if (modalContent) modalContent.style.width = getModalWidth();
        };
        window.addEventListener("resize", updateWidth);
        // Initial call to set width
        if (isOpen) updateWidth();
        return ()=>{
            window.removeEventListener("resize", updateWidth);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        contentLabel: contentLabel,
        className: contentClassName,
        style: {
            content: {
                position: "fixed",
                top: "50vh",
                left: "50vw",
                right: "auto",
                bottom: "auto",
                marginRight: 0,
                transform: "translate(-50%, -50%)",
                backgroundColor: "#401a6e",
                width: getModalWidth(),
                maxHeight: "90vh",
                overflowY: "auto",
                overflowX: "hidden",
                WebkitOverflowScrolling: "touch",
                touchAction: "pan-y",
                margin: 0,
                padding: 0,
                /* Above wallet/XP history portals (10060) and ShopDrawer (10002) —
           * shop buy (HardOffers / SoftOffers) opens from inside that portal. */ zIndex: 10071
            },
            overlay: {
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(11, 2, 18, 0.8)",
                zIndex: 10070
            }
        },
        ariaHideApp: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: children
        })
    });
};
exports.default = CustomModal;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Modal":"2Ei4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Ei4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Modal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _framerMotion = require("framer-motion");
var _useCloseOnHistoryBack = require("../hooks/useCloseOnHistoryBack");
var _overlayScrollLock = require("../hooks/overlayScrollLock");
/** Common overlay: purple background 80% opacity, no border; prevent scroll on overlay */ const defaultOverlay = {
    /* react-modal omits its default overlay styles when overlayClassName is set; keep full-screen hit target */ position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(27, 6, 47, 0.8)",
    border: "none",
    outline: "none",
    overflow: "hidden",
    touchAction: "none",
    overscrollBehavior: "none",
    /* Above the MyZone activity drawer (z: 9995). */ zIndex: 10010
};
/** Common content: no border/outline, no rounded corners */ const defaultContent = {
    borderRadius: 0,
    border: "none",
    outline: "none",
    zIndex: 10011,
    /* Overlay uses touch-action:none (inherited). Restore vertical pan so inner scrollers work on phones. */ touchAction: "pan-y"
};
/**
 * Opacity-only by default. Never use scale/translate: WebGL iframes (Spin /
 * Trivia / Quickfire) often stay blank in Chrome under a transformed ancestor.
 * Pass skipEntranceAnimation for those modals — even opacity:0 on mount can
 * break PIXI/WebGL boot so the Amplify loader spins forever.
 */ const modalContentSpring = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    transition: {
        duration: 0.2,
        ease: "easeOut"
    }
};
const modalContentBoxStyle = {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    flex: 1,
    minHeight: 0,
    maxHeight: "100%",
    overflow: "hidden"
};
function Modal(props) {
    const { onAfterOpen, onAfterClose, style, children, skipEntranceAnimation = false, isOpen, onRequestClose, ...rest } = props;
    (0, _useCloseOnHistoryBack.useCloseOnHistoryBack)(Boolean(isOpen), onRequestClose);
    // Effect cleanup runs on unmount / isOpen→false. onAfterClose is skipped when navigating
    // away with the dialog still open, which used to leave the capture-phase wheel lock on.
    (0, _overlayScrollLock.useOverlayScrollLock)(Boolean(isOpen));
    const mergedStyle = {
        ...style,
        content: {
            ...defaultContent,
            ...style?.content
        },
        overlay: {
            ...defaultOverlay,
            ...style?.overlay
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
        ...rest,
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        style: mergedStyle,
        onAfterOpen: onAfterOpen,
        onAfterClose: onAfterClose,
        children: skipEntranceAnimation ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: modalContentBoxStyle,
            children: children
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
            ...modalContentSpring,
            style: modalContentBoxStyle,
            children: children
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-modal":"8mlRL","framer-motion":"fI0Q4","../hooks/useCloseOnHistoryBack":"1Ha1d","../hooks/overlayScrollLock":"jYfB4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8mlRL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _Modal = require("61f3c1f4b26edd90");
var _Modal2 = _interopRequireDefault(_Modal);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = _Modal2.default;
module.exports = exports["default"];

},{"61f3c1f4b26edd90":"kXURF"}],"kXURF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("9a25229d9e827b16");
var _react2 = _interopRequireDefault(_react);
var _reactDom = require("f910a939b759baac");
var _reactDom2 = _interopRequireDefault(_reactDom);
var _propTypes = require("a79c9e589690789c");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ModalPortal = require("34c4b69c6470c61b");
var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
var _ariaAppHider = require("e68a5208ad96e647");
var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
var _safeHTMLElement = require("573142d9c97c52f");
var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
var _reactLifecyclesCompat = require("ad84566654669dc0");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
var createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var getCreatePortal = function getCreatePortal() {
    return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function getParentElement(parentSelector) {
    return parentSelector();
}
var Modal = function(_Component) {
    _inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = getCreatePortal();
            var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!_safeHTMLElement.canUseDOM) return;
                if (!isReact16) this.node = createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = getParentElement(prevProps.parentSelector);
                var nextParent = getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!_safeHTMLElement.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!_safeHTMLElement.canUseDOM || !isReact16) return null;
                if (!this.node && isReact16) this.node = createHTMLElement("div");
                var createPortal = getCreatePortal();
                return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}(_react.Component);
Modal.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    style: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
    }),
    portalClassName: _propTypes2.default.string,
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    className: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.shape({
            base: _propTypes2.default.string.isRequired,
            afterOpen: _propTypes2.default.string.isRequired,
            beforeClose: _propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.shape({
            base: _propTypes2.default.string.isRequired,
            afterOpen: _propTypes2.default.string.isRequired,
            beforeClose: _propTypes2.default.string.isRequired
        })
    ]),
    appElement: _propTypes2.default.oneOfType([
        _propTypes2.default.instanceOf(_safeHTMLElement2.default),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList),
        _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))
    ]),
    onAfterOpen: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    ariaHideApp: _propTypes2.default.bool,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    preventScroll: _propTypes2.default.bool,
    parentSelector: _propTypes2.default.func,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func,
    id: _propTypes2.default.string,
    overlayElement: _propTypes2.default.func,
    contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
    isOpen: false,
    portalClassName: portalClassName,
    bodyOpenClassName: bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return _react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return _react2.default.createElement("div", props, children);
    }
};
Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, _reactLifecyclesCompat.polyfill)(Modal);
exports.default = Modal;

},{"9a25229d9e827b16":"6uln9","f910a939b759baac":"b8T3j","a79c9e589690789c":"6FKs7","34c4b69c6470c61b":"9bisn","e68a5208ad96e647":"h7ZuP","573142d9c97c52f":"fGfZl","ad84566654669dc0":"jRjXN"}],"9bisn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("d320e8781d21c2c5");
var _propTypes = require("33d52b094ecec2e0");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusManager = require("bfbfef75d8e85e0");
var focusManager = _interopRequireWildcard(_focusManager);
var _scopeTab = require("8960111ee2cff0b2");
var _scopeTab2 = _interopRequireDefault(_scopeTab);
var _ariaAppHider = require("75f7ac26c5b4b642");
var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
var _classList = require("232716fc77648a71");
var classList = _interopRequireWildcard(_classList);
var _safeHTMLElement = require("5ca8a1c1e3ad494a");
var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
var _portalOpenInstances = require("ce306d5e4e8279b3");
var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
require("56e2a18c3da1ec8b");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var ariaHiddenInstances = 0;
var ModalPortal = function(_Component) {
    _inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        _classCallCheck(this, ModalPortal);
        var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && ariaHiddenInstances > 0) {
                ariaHiddenInstances -= 1;
                if (ariaHiddenInstances === 0) ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    focusManager.returnFocus(_this.props.preventScroll);
                    focusManager.teardownScopedFocus();
                } else focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            _portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    focusManager.setupScopedFocus(_this.node);
                    focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if (isTabKey(event)) (0, _scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
                base: CLASS_NAMES[which],
                afterOpen: CLASS_NAMES[which] + "--after-open",
                beforeClose: CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    _createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    ariaHiddenInstances += 1;
                    ariaAppHider.hide(appElement);
                }
                _portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: _extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = _extends({
                    id: id,
                    ref: this.setContentRef,
                    style: _extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", _extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}(_react.Component);
ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
ModalPortal.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    defaultStyles: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
    }),
    style: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
    }),
    className: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.object
    ]),
    overlayClassName: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.object
    ]),
    parentSelector: _propTypes2.default.func,
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    ariaHideApp: _propTypes2.default.bool,
    appElement: _propTypes2.default.oneOfType([
        _propTypes2.default.instanceOf(_safeHTMLElement2.default),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList),
        _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))
    ]),
    onAfterOpen: _propTypes2.default.func,
    onAfterClose: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    preventScroll: _propTypes2.default.bool,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    children: _propTypes2.default.node,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func,
    id: _propTypes2.default.string,
    overlayElement: _propTypes2.default.func,
    contentElement: _propTypes2.default.func,
    testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

},{"d320e8781d21c2c5":"6uln9","33d52b094ecec2e0":"6FKs7","bfbfef75d8e85e0":"8ZxdD","8960111ee2cff0b2":"fsUHQ","75f7ac26c5b4b642":"h7ZuP","232716fc77648a71":"5UkOf","5ca8a1c1e3ad494a":"fGfZl","ce306d5e4e8279b3":"39BQD","56e2a18c3da1ec8b":"1brZu"}],"8ZxdD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;
var _tabbable = require("a3112cb65ea2b6f");
var _tabbable2 = _interopRequireDefault(_tabbable);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function resetState() {
    focusLaterElements = [];
}
/* istanbul ignore next */ function log() {}
/* eslint-enable no-console */ function handleBlur() {
    needToFocus = true;
}
function handleFocus() {
    if (needToFocus) {
        needToFocus = false;
        if (!modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if (modalElement.contains(document.activeElement)) return;
            var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
            el.focus();
        }, 0);
    }
}
function markForFocusLater() {
    focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if (focusLaterElements.length !== 0) {
            toFocus = focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function popWithoutFocus() {
    focusLaterElements.length > 0 && focusLaterElements.pop();
}
function setupScopedFocus(element) {
    modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", handleBlur, false);
        document.addEventListener("focus", handleFocus, true);
    } else {
        window.attachEvent("onBlur", handleBlur);
        document.attachEvent("onFocus", handleFocus);
    }
}
function teardownScopedFocus() {
    modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", handleBlur);
        document.removeEventListener("focus", handleFocus);
    } else {
        window.detachEvent("onBlur", handleBlur);
        document.detachEvent("onFocus", handleFocus);
    }
}

},{"a3112cb65ea2b6f":"1fuxH"}],"1fuxH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";
// match the whole word to prevent fuzzy searching
var tabbableNode = /^(input|select|textarea|button|object|iframe)$/;
function isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if (hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
}
function tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}
function findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter(tabbable);
}
module.exports = exports["default"];

},{}],"fsUHQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = scopeTab;
var _tabbable = require("f055893759989bbd");
var _tabbable2 = _interopRequireDefault(_tabbable);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function scopeTab(node, event) {
    var tabbable = (0, _tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
module.exports = exports["default"];

},{"f055893759989bbd":"1fuxH"}],"h7ZuP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
var _warning = require("6eb0682e790e32c7");
var _warning2 = _interopRequireDefault(_warning);
var _safeHTMLElement = require("776bf46766969f66");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function resetState() {
    if (globalElement) {
        if (globalElement.removeAttribute) globalElement.removeAttribute("aria-hidden");
        else if (globalElement.length != null) globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll(globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    globalElement = null;
}
/* istanbul ignore next */ function log() {
    var check;
}
/* eslint-enable no-console */ function assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        assertNodeList(el, useElement);
        useElement = el;
    }
    globalElement = useElement || globalElement;
    return globalElement;
}
function validateElement(appElement) {
    var el = appElement || globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, _warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function documentNotReadyOrSSRTesting() {
    globalElement = null;
}

},{"6eb0682e790e32c7":"cCKmo","776bf46766969f66":"fGfZl"}],"cCKmo":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"fGfZl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;
var _exenv = require("dfc9e0e910107876");
var _exenv2 = _interopRequireDefault(_exenv);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var EE = _exenv2.default;
var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
var canUseDOM = exports.canUseDOM = EE.canUseDOM;
exports.default = SafeHTMLElement;

},{"dfc9e0e910107876":"gGZ8o"}],"gGZ8o":[function(require,module,exports,__globalThis) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

},{}],"5UkOf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in htmlClassList)removeClass(htmlElement, htmlClassList[cls]);
    var body = document.body;
    for(var _cls in docBodyClassList)removeClass(body, docBodyClassList[_cls]);
    htmlClassList = {};
    docBodyClassList = {};
}
/* istanbul ignore next */ function log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var add = exports.add = function add(element, classString) {
    return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var remove = exports.remove = function remove(element, classString) {
    return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

},{}],"39BQD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.log = log;
exports.resetState = resetState;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    _classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var portalOpenInstances = new PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function log() {
    console.log("portalOpenInstances ----------");
    console.log(portalOpenInstances.openInstances.length);
    portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function resetState() {
    portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */ exports.default = portalOpenInstances;

},{}],"1brZu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
var _portalOpenInstances = require("90d3c301f2b237b9");
var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var before = void 0, after = void 0, instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function resetState() {
    var _arr = [
        before,
        after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    before = after = null;
    instances = [];
}
/* istanbul ignore next */ function log() {
    console.log("bodyTrap ----------");
    console.log(instances.length);
    var _arr2 = [
        before,
        after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function focusContent() {
    if (instances.length === 0) return;
    instances[instances.length - 1].focusContent();
}
function bodyTrap(eventType, openInstances) {
    if (!before && !after) {
        before = document.createElement("div");
        before.setAttribute("data-react-modal-body-trap", "");
        before.style.position = "absolute";
        before.style.opacity = "0";
        before.setAttribute("tabindex", "0");
        before.addEventListener("focus", focusContent);
        after = before.cloneNode();
        after.addEventListener("focus", focusContent);
    }
    instances = openInstances;
    if (instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== before) document.body.insertBefore(before, document.body.firstChild);
        if (document.body.lastChild !== after) document.body.appendChild(after);
    } else {
        // Remove focus trap
        if (before.parentElement) before.parentElement.removeChild(before);
        if (after.parentElement) after.parentElement.removeChild(after);
    }
}
_portalOpenInstances2.default.subscribe(bodyTrap);

},{"90d3c301f2b237b9":"39BQD"}],"jRjXN":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Ha1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** While `isOpen`, Back / iOS swipe-back calls `onClose` instead of navigating away. */ parcelHelpers.export(exports, "useCloseOnHistoryBack", ()=>useCloseOnHistoryBack);
/** Drop-in for overlays that are not function-component-friendly besides a child. */ parcelHelpers.export(exports, "HistoryBackClose", ()=>HistoryBackClose);
var _react = require("react");
var _modalHistoryBack = require("../utils/modalHistoryBack");
function useCloseOnHistoryBack(isOpen, onClose) {
    const onCloseRef = (0, _react.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, _react.useEffect)(()=>{
        if (!isOpen) return undefined;
        if (typeof onCloseRef.current !== "function") return undefined;
        return (0, _modalHistoryBack.acquireModalHistoryEntry)(()=>{
            onCloseRef.current?.();
        });
    }, [
        isOpen
    ]);
}
function HistoryBackClose({ open, onClose }) {
    useCloseOnHistoryBack(open, onClose);
    return null;
}

},{"react":"6uln9","../utils/modalHistoryBack":"goswc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"goswc":[function(require,module,exports,__globalThis) {
/**
 * Swallow browser / iOS swipe-back while a modal is open: each overlay pushes a
 * dummy history entry so Back closes the top overlay instead of leaving the page.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Drop overlay bookkeeping so a later `pushState` is not mistaken for the overlay entry. */ parcelHelpers.export(exports, "copyHistoryStateWithoutOverlayFlag", ()=>copyHistoryStateWithoutOverlayFlag);
/**
 * Absorb the next N `popstate` events without closing an overlay entry.
 * Use when another system (e.g. the profile modal) calls `history.go(-N)` and a
 * follow-up overlay may already be on the stack — otherwise that pop closes it.
 */ parcelHelpers.export(exports, "ignoreNextModalHistoryPops", ()=>ignoreNextModalHistoryPops);
/** Register an open overlay. Returns a disposer for when it closes without Back. */ parcelHelpers.export(exports, "acquireModalHistoryEntry", ()=>acquireModalHistoryEntry);
/**
 * Run `cb` after any in-flight overlay `history.back()` has been applied.
 * Opening another overlay (profile) in the same turn as release races that pop
 * and the new overlay is discarded.
 */ parcelHelpers.export(exports, "whenModalHistoryIdle", ()=>whenModalHistoryIdle);
/** Test-only: drop listeners and in-memory stack. */ parcelHelpers.export(exports, "resetModalHistoryBackForTests", ()=>resetModalHistoryBackForTests);
const HISTORY_FLAG = "__c8Overlay";
function copyHistoryStateWithoutOverlayFlag(state) {
    if (!state || typeof state !== "object") return {};
    const { [HISTORY_FLAG]: _overlayFlag, ...rest } = state;
    return rest;
}
let nextId = 1;
const stack = [];
let skipPopCount = 0;
let listening = false;
let listenerWindow = null;
function historyApi() {
    if (typeof window === "undefined" || !window.history?.pushState) return null;
    return window.history;
}
function onPopState() {
    if (skipPopCount > 0) {
        skipPopCount -= 1;
        return;
    }
    const top = stack.pop();
    if (!top) return;
    try {
        top.onClose();
    } catch  {
    /* overlay close must not break history handling */ }
}
function ensureListener() {
    if (typeof window === "undefined") return;
    if (listening && listenerWindow === window) return;
    if (listening && listenerWindow && listenerWindow !== window) listenerWindow.removeEventListener("popstate", onPopState);
    window.addEventListener("popstate", onPopState);
    listening = true;
    listenerWindow = window;
}
function ignoreNextModalHistoryPops(count) {
    const n = Math.max(0, Math.floor(Number(count) || 0));
    if (n <= 0) return;
    ensureListener();
    skipPopCount += n;
}
function acquireModalHistoryEntry(onClose) {
    const history = historyApi();
    if (!history) return ()=>undefined;
    ensureListener();
    const id = nextId;
    nextId += 1;
    stack.push({
        id,
        onClose
    });
    history.pushState({
        ...copyHistoryStateWithoutOverlayFlag(history.state),
        [HISTORY_FLAG]: id
    }, "");
    return ()=>releaseModalHistoryEntry(id);
}
function releaseModalHistoryEntry(id) {
    const idx = stack.findIndex((entry)=>entry.id === id);
    if (idx < 0) return;
    const wasTop = idx === stack.length - 1;
    stack.splice(idx, 1);
    const history = historyApi();
    if (!wasTop || !history) return;
    const flag = history.state?.[HISTORY_FLAG];
    if (flag !== id) return;
    skipPopCount += 1;
    history.back();
}
function whenModalHistoryIdle(cb) {
    let cancelled = false;
    const run = ()=>{
        if (cancelled) return;
        cancelled = true;
        window.removeEventListener("popstate", onPop);
        window.clearTimeout(fallbackId);
        cb();
    };
    const onPop = ()=>{
        window.setTimeout(()=>{
            if (skipPopCount > 0) return;
            run();
        }, 0);
    };
    let fallbackId = 0;
    if (typeof window === "undefined") {
        cb();
        return ()=>undefined;
    }
    window.addEventListener("popstate", onPop);
    // Wait when a release is in flight (`skipPopCount`) or still registered (`stack`) —
    // callers often close an overlay then navigate; React effect cleanup runs `history.back()`
    // after this call, and a 0ms navigate can be popped on slower mobile WebViews.
    const waitMs = stack.length > 0 || skipPopCount > 0 ? 100 : 0;
    fallbackId = window.setTimeout(run, waitMs);
    return ()=>{
        cancelled = true;
        window.removeEventListener("popstate", onPop);
        window.clearTimeout(fallbackId);
    };
}
function resetModalHistoryBackForTests() {
    stack.length = 0;
    skipPopCount = 0;
    nextId = 1;
    if (listening && listenerWindow) listenerWindow.removeEventListener("popstate", onPopState);
    listening = false;
    listenerWindow = null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jYfB4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OVERLAY_SCROLL_ROOT_SELECTOR", ()=>OVERLAY_SCROLL_ROOT_SELECTOR);
parcelHelpers.export(exports, "OVERLAY_SCROLL_LOCK_CLASS", ()=>OVERLAY_SCROLL_LOCK_CLASS);
parcelHelpers.export(exports, "DOCUMENT_SCROLL_LOCK_CLASS", ()=>DOCUMENT_SCROLL_LOCK_CLASS);
parcelHelpers.export(exports, "lockBackgroundScroll", ()=>lockBackgroundScroll);
parcelHelpers.export(exports, "unlockBackgroundScroll", ()=>unlockBackgroundScroll);
/** Test helper — not used in app code. */ parcelHelpers.export(exports, "resetOverlayScrollLockForTests", ()=>resetOverlayScrollLockForTests);
parcelHelpers.export(exports, "overlayScrollLockOpenCountForTests", ()=>overlayScrollLockOpenCountForTests);
parcelHelpers.export(exports, "overlayScrollLockIsAppliedForTests", ()=>overlayScrollLockIsAppliedForTests);
/** Lock page / nested league column scroll while a portal overlay is open. */ parcelHelpers.export(exports, "useOverlayScrollLock", ()=>useOverlayScrollLock);
var _react = require("react");
const OVERLAY_SCROLL_ROOT_SELECTOR = ".ReactModal__Content, [data-c8-overlay-scroll]";
const OVERLAY_SCROLL_LOCK_CLASS = "c8-overlay-scroll-lock";
const DOCUMENT_SCROLL_LOCK_CLASS = "c8-document-scroll-lock";
/** Nested page scrollers (e.g. league detail `overflow-y-auto`) keep scrolling when only body is locked. */ let openModalCount = 0;
function elementCanScroll(el) {
    const style = window.getComputedStyle(el);
    const oy = style.overflowY;
    const ox = style.overflowX;
    const canY = (oy === "auto" || oy === "scroll" || oy === "overlay") && el.scrollHeight > el.clientHeight + 1;
    const canX = (ox === "auto" || ox === "scroll" || ox === "overlay") && el.scrollWidth > el.clientWidth + 1;
    return canY || canX;
}
/** Allow touch/wheel only inside a scrollable region of an open overlay. */ function isScrollAllowedTarget(target) {
    if (!(target instanceof Element)) return false;
    const modal = target.closest(OVERLAY_SCROLL_ROOT_SELECTOR);
    if (!modal) return false;
    let node = target;
    while(node && node !== modal){
        if (elementCanScroll(node)) return true;
        node = node.parentElement;
    }
    return elementCanScroll(modal);
}
function preventBackgroundScroll(event) {
    if (isScrollAllowedTarget(event.target)) return;
    event.preventDefault();
}
function overlayLockIsApplied() {
    return document.documentElement.classList.contains(OVERLAY_SCROLL_LOCK_CLASS);
}
function lockBackgroundScroll() {
    openModalCount += 1;
    if (openModalCount !== 1) return;
    document.documentElement.classList.add(OVERLAY_SCROLL_LOCK_CLASS);
    document.body.classList.add(OVERLAY_SCROLL_LOCK_CLASS);
    document.addEventListener("touchmove", preventBackgroundScroll, {
        passive: false,
        capture: true
    });
    document.addEventListener("wheel", preventBackgroundScroll, {
        passive: false,
        capture: true
    });
}
function unlockBackgroundScroll() {
    if (openModalCount === 0) return;
    openModalCount -= 1;
    if (openModalCount !== 0) return;
    document.removeEventListener("touchmove", preventBackgroundScroll, {
        capture: true
    });
    document.removeEventListener("wheel", preventBackgroundScroll, {
        capture: true
    });
    document.documentElement.classList.remove(OVERLAY_SCROLL_LOCK_CLASS);
    document.body.classList.remove(OVERLAY_SCROLL_LOCK_CLASS);
}
function resetOverlayScrollLockForTests() {
    if (openModalCount > 0) {
        openModalCount = 1;
        unlockBackgroundScroll();
    }
    openModalCount = 0;
    if (typeof document === "undefined") return;
    document.documentElement.classList.remove(OVERLAY_SCROLL_LOCK_CLASS);
    document.body?.classList.remove(OVERLAY_SCROLL_LOCK_CLASS);
}
function overlayScrollLockOpenCountForTests() {
    return openModalCount;
}
function overlayScrollLockIsAppliedForTests() {
    return overlayLockIsApplied();
}
function useOverlayScrollLock(active) {
    (0, _react.useEffect)(()=>{
        if (!active) return undefined;
        lockBackgroundScroll();
        return ()=>unlockBackgroundScroll();
    }, [
        active
    ]);
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"651ko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PaymentModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modalCloseIcon = require("../ModalCloseIcon");
var _stripePayBtn = require("./StripePayBtn");
var _stripePayBtnDefault = parcelHelpers.interopDefault(_stripePayBtn);
var _saleCountdown = require("./SaleCountdown");
var _saleCountdownDefault = parcelHelpers.interopDefault(_saleCountdown);
var _shopFooter = require("./ShopFooter");
var _shopFooterDefault = parcelHelpers.interopDefault(_shopFooter);
var _virtualCurrencyDisclaimer = require("../../utils/virtualCurrencyDisclaimer");
function PaymentModal({ receiveAmount, payAmount: listedPayAmount, originalPayAmount, saleEndsAt, closeModal, offerId, updateRubies, offerType, setIsAnimatingRubies }) {
    const [isSuccess, setIsSuccess] = (0, _react.useState)(false);
    const [payAmount, setPayAmount] = (0, _react.useState)(listedPayAmount);
    const wrappedCloseModal = (0, _react.useCallback)((success)=>{
        closeModal(success);
    }, [
        closeModal
    ]);
    function handlePaymentSuccess() {
        setIsSuccess(true);
    }
    function handleDone() {
        if (setIsAnimatingRubies) setIsAnimatingRubies(true);
        wrappedCloseModal(true);
        if (setIsAnimatingRubies) setTimeout(()=>{
            setIsAnimatingRubies(false);
        }, 3000);
    }
    // Success view
    if (isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-[100%]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "w-[100%] py-[20px] flex flex-row justify-between items-center relative",
                style: {
                    backgroundColor: '#401A6E'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "font-anton text-white text-[24px] flex-1 text-center",
                        children: "SUCCESS!"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex-1 flex justify-end pr-[7px]",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: ()=>wrappedCloseModal(false),
                            className: "text-white hover:text-gray-300 transition-colors flex items-center justify-center",
                            "aria-label": "Close",
                            style: {
                                height: "40px",
                                width: "40px"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseIcon), {
                                width: 24,
                                height: 24,
                                fill: "currentColor",
                                className: "shrink-0"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "w-[100%] bg-white px-[20px] py-[10px] flex flex-col items-center justify-center",
                style: {
                    backgroundColor: '#FFFFFF'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "font-anton text-main text-[20px]",
                        children: "YOUR WALLET HAS BEEN CREDITED"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "w-[90px] h-[90px]",
                        src: "/assets/currency-ruby.png",
                        alt: "ruby"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "font-anton text-main text-[32px]",
                        children: [
                            "x",
                            receiveAmount
                        ]
                    }),
                    originalPayAmount != null && originalPayAmount > payAmount ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "mt-[2px] bg-red px-[10px] py-[2px] font-anton text-[16px] uppercase text-white",
                        children: [
                            "You saved \u20B9",
                            originalPayAmount - payAmount,
                            "!"
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-[100%] flex flex-row justify-center items-center py-[20px]",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: handleDone,
                    style: {
                        width: "290px",
                        height: "50px",
                        backgroundColor: "#D2FF00",
                        color: "#1B062F",
                        fontWeight: "400",
                        fontFamily: "Anton",
                        fontSize: "16px",
                        lineHeight: "24px",
                        textAlign: "center"
                    },
                    children: "DONE"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shopFooterDefault.default), {})
        ]
    });
    // Purchase view (original)
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-row justify-between items-center h-[70px] px-[7px] relative",
                style: {
                    background: 'linear-gradient(88.89deg, #652DAF 0%, #623998 100%)'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-row items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "w-[40px] h-[40px] mx-2",
                                src: "/assets/currency-ruby.png"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "font-anton text-white text-[20px]",
                                children: [
                                    "GET x",
                                    receiveAmount,
                                    " RUBIES"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-row items-center gap-[8px]",
                        children: [
                            originalPayAmount != null && originalPayAmount > payAmount ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "font-anton text-[14px] text-white/60 line-through",
                                "aria-label": `Was \u{20B9}${originalPayAmount}`,
                                children: [
                                    "\u20B9",
                                    originalPayAmount
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: `font-anton text-main bg-lime py-[8px] ${originalPayAmount != null && originalPayAmount > payAmount ? "px-[16px]" : "px-[30px]"}`,
                                children: [
                                    "\u20B9",
                                    payAmount
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: ()=>wrappedCloseModal(false),
                                className: "text-white hover:text-gray-300 transition-colors flex items-center justify-center",
                                style: {
                                    height: "40px",
                                    width: "40px"
                                },
                                "aria-label": "Close",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseIcon), {
                                    width: 24,
                                    height: 24,
                                    fill: "currentColor",
                                    className: "shrink-0"
                                })
                            })
                        ]
                    })
                ]
            }),
            originalPayAmount != null && originalPayAmount > payAmount ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-row flex-wrap items-center justify-center gap-x-2 bg-red px-4 py-1 text-white",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "font-anton text-[12px] uppercase",
                        children: [
                            "Sale: save \u20B9",
                            originalPayAmount - payAmount
                        ]
                    }),
                    saleEndsAt ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _saleCountdownDefault.default), {
                        endsAt: saleEndsAt,
                        className: "text-white/90"
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "bg-[#4E2681] px-4 py-1.5 text-center font-chakra text-[11px] leading-snug text-white/70 normal-case",
                children: (0, _virtualCurrencyDisclaimer.VIRTUAL_CURRENCY_SHOP_NOTE)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bg-lime h-[30px] flex flex-row justify-start items-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-main font-anton ml-[15px]",
                    children: "PAYMENT METHOD"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-row items-center justify-between gap-3 px-4 py-3 bg-gray-50 border-b border-gray-200",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-row items-center gap-2 min-w-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "inline-flex items-center justify-center w-7 h-7 bg-[#1B062F] text-white shrink-0",
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    width: "15",
                                    height: "15",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M7 10V8a5 5 0 1 1 10 0v2",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                            x: "5",
                                            y: "10",
                                            width: "14",
                                            height: "10",
                                            rx: "2",
                                            stroke: "currentColor",
                                            strokeWidth: "2"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "font-semibold text-main text-[13px] leading-tight",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "block",
                                        children: "Guaranteed and"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "block",
                                        children: "secured payments"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "inline-flex items-center bg-[#1B062F] px-2 py-2 shrink-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white text-[8px] font-semibold uppercase tracking-[0.04em]",
                                children: "Powered by"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: "/assets/stripe.svg",
                                alt: "Stripe",
                                className: "h-[28px] w-auto object-contain brightness-0 invert"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col items-center gap-2 p-2 pb-8 overflow-y-auto overscroll-contain hide-scrollbar",
                style: {
                    minHeight: "min(60vh, 400px)",
                    maxHeight: "min(60vh, 400px)",
                    WebkitOverflowScrolling: "touch"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stripePayBtnDefault.default), {
                    closeModal: wrappedCloseModal,
                    offerId: offerId,
                    payAmount: payAmount,
                    updateRubies: updateRubies,
                    offerType: offerType,
                    onPaymentSuccess: handlePaymentSuccess,
                    onPriceChange: setPayAmount
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shopFooterDefault.default), {
                className: "my-[18px] flex-shrink-0"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../ModalCloseIcon":"aricC","./StripePayBtn":"dHliY","./SaleCountdown":"fijDF","./ShopFooter":"iy57h","../../utils/virtualCurrencyDisclaimer":"eHHb8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aricC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MODAL_CLOSE_ICON_SIZE", ()=>MODAL_CLOSE_ICON_SIZE);
/**
 * Shared close (X) icon for modals. Use with ModalCloseButton for a full button,
 * or render this icon directly inside your own button.
 */ parcelHelpers.export(exports, "ModalCloseIcon", ()=>ModalCloseIcon);
/**
 * Shared close button for modals. Renders a button with ModalCloseIcon inside.
 * Large default hit target + glyph so dismiss is easy to find and tap.
 */ parcelHelpers.export(exports, "ModalCloseButton", ()=>ModalCloseButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/** Phosphor-style X (same geometry as `public/img/x.svg`). */ const MODAL_X_VIEWBOX = "0 0 256 256";
const MODAL_X_PATH = "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z";
const MODAL_CLOSE_ICON_SIZE = 28;
function ModalCloseIcon({ className = "", width = MODAL_CLOSE_ICON_SIZE, height = MODAL_CLOSE_ICON_SIZE, fill = "#fff" }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: className,
        fill: fill,
        height: height,
        width: width,
        viewBox: MODAL_X_VIEWBOX,
        "aria-hidden": true,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: MODAL_X_PATH
        })
    });
}
function ModalCloseButton({ onClick, className = "", ariaLabel = "Close", iconSize = MODAL_CLOSE_ICON_SIZE }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: `flex min-h-11 min-w-11 shrink-0 cursor-pointer items-center justify-center text-white hover:opacity-80 ${className}`,
        onClick: onClick,
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ModalCloseIcon, {
            width: iconSize,
            height: iconSize,
            fill: "currentColor"
        })
    });
}
exports.default = ModalCloseIcon;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dHliY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StripePayBtn);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stripeJs = require("@stripe/stripe-js");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _userContext = require("../../Data/UserContext");
var _authHeaders = require("../../utils/authHeaders");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _gtmEvents = require("../../utils/gtmEvents");
const SHOP_PAGE_PATH = "/shop";
function stripeErrorToPurchaseErrorType(error) {
    if (!error) return "network_error";
    if (error.type === "card_error" || error.code === "card_declined") return "payment_declined";
    if (error.type === "validation_error") return "validation_error";
    return "network_error";
}
function amountMajorFromStripeOrder(amountMinor, currency) {
    const c = String(currency || "inr").toLowerCase();
    if (c === "inr") return amountMinor / 100;
    return amountMinor;
}
function newAttemptId() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
const sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const stripePromise = (0, _stripeJs.loadStripe)("pk_live_51T2oEh46qmV8WHPpcVazANBQ2RkF2Idz5OaHrxhaYwBs2u1kUtwSKeQ9cPHP4iOtnL9XzCTlVl2iZNqvsxo7DAUf00O9vxDU1f");
const PENDING_MESSAGES = {
    processing: "Your payment is processing. Your rubies will be added to your wallet as soon as your bank confirms it.",
    unverified: "Your payment went through, but we couldn't add your rubies yet. They should appear in your wallet within a few minutes. If they don't, please contact support."
};
function StripePaymentForm({ offerId, payAmount, createOrder, closeModal, updateRubies, onPaymentSuccess, onPriceChange }) {
    const { user } = (0, _userContext.useUser)();
    const stripe = (0, _reactStripeJs.useStripe)();
    const elements = (0, _reactStripeJs.useElements)();
    const [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
    const [errorMessage, setErrorMessage] = (0, _react.useState)(null);
    const [elementReady, setElementReady] = (0, _react.useState)(false);
    const [paymentElementKey, setPaymentElementKey] = (0, _react.useState)(0);
    const [pendingOutcome, setPendingOutcome] = (0, _react.useState)(null);
    const errorRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (errorMessage) errorRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }, [
        errorMessage
    ]);
    /** Credits the wallet for a succeeded PaymentIntent. Never closes the modal on failure: the user has paid. */ async function verifyReceipt(receiptId, paymentIntentId, amount, currency) {
        const session_token = (0, _jsCookieDefault.default).get("c8_session_token");
        for(let attempt = 0; attempt < 3; attempt++){
            if (attempt > 0) await sleep(1500 * attempt);
            try {
                const orderResp = await fetch(`${"https://cricket8.com/api"}/offers/${offerId}/receipt/${receiptId}/verify?user_session=${session_token}`, {
                    method: "POST",
                    headers: (0, _authHeaders.getAuthHeaders)(),
                    body: JSON.stringify({
                        payment_intent_id: paymentIntentId
                    })
                });
                const resp = await orderResp.json().catch(()=>({}));
                if (orderResp.status === 200) {
                    (0, _frontendTrackingEvents.clearPendingShopPurchase)();
                    (0, _gtmEvents.trackRubyPurchased)({
                        user_id: session_token ?? "",
                        purchase_amount: amount / 100,
                        currency: currency
                    });
                    // purchase_success: server Measurement Protocol (Stripe webhook / verify)
                    updateRubies(resp.wallet.rubies);
                    if (onPaymentSuccess) onPaymentSuccess();
                    else closeModal(true);
                    return;
                }
                if (resp?.status === "processing") {
                    (0, _frontendTrackingEvents.clearPendingShopPurchase)();
                    setPendingOutcome("processing");
                    return;
                }
                if (orderResp.status === 403 || orderResp.status === 404) break;
            } catch (error) {
                console.error("Verify receipt error:", error);
            }
        }
        (0, _frontendTrackingEvents.clearPendingShopPurchase)();
        setPendingOutcome("unverified");
    }
    async function handleSubmit(e) {
        e.preventDefault();
        if (!stripe || !elements) {
            setErrorMessage("Payment form is still loading. Please wait and try again.");
            return;
        }
        setIsSubmitting(true);
        setErrorMessage(null);
        const userId = user?.userId ?? (0, _jsCookieDefault.default).get("cr8_userId");
        const fallbackCurrency = "INR";
        const fallbackAmountMajor = Number(payAmount);
        const fallbackCurrencyNorm = (0, _frontendTrackingEvents.normalizeShopCurrency)(fallbackCurrency);
        let amountMajor = fallbackAmountMajor;
        let currencyNorm = fallbackCurrencyNorm;
        try {
            const submitResult = await elements.submit();
            if (submitResult.error) {
                (0, _frontendTrackingEvents.trackPurchaseFailed)({
                    user_id: userId,
                    product_type: "ruby_pack",
                    amount: fallbackAmountMajor,
                    currency: fallbackCurrencyNorm,
                    payment_method: "card",
                    error_type: stripeErrorToPurchaseErrorType(submitResult.error),
                    pathname: SHOP_PAGE_PATH
                });
                setErrorMessage(submitResult.error.message ?? "Please complete your payment details.");
                return;
            }
            const orderResult = await createOrder();
            if (!orderResult.order) {
                (0, _frontendTrackingEvents.trackPurchaseFailed)({
                    user_id: userId,
                    product_type: "ruby_pack",
                    amount: fallbackAmountMajor,
                    currency: fallbackCurrencyNorm,
                    payment_method: "card",
                    error_type: "network_error",
                    pathname: SHOP_PAGE_PATH
                });
                setErrorMessage(`${orderResult.error} Please try again.`);
                return;
            }
            const orderDetails = orderResult.order;
            amountMajor = amountMajorFromStripeOrder(orderDetails.amount, orderDetails.currency);
            currencyNorm = (0, _frontendTrackingEvents.normalizeShopCurrency)(orderDetails.currency);
            // The offer list can be stale (e.g. a sale ended while the modal was open): never charge
            // a different amount than the one on screen without the user seeing it first.
            if (orderDetails.amount !== Math.round(Number(payAmount) * 100)) {
                elements.update({
                    amount: orderDetails.amount
                });
                onPriceChange?.(amountMajor);
                setErrorMessage(`The price of this pack has changed from \u{20B9}${payAmount} to \u{20B9}${amountMajor}. Press Pay to continue at the new price.`);
                return;
            }
            const returnUrl = `${window.location.origin}/shop-payment-return` + `?receipt=${encodeURIComponent(orderDetails.receipt)}&offerId=${offerId}`;
            (0, _frontendTrackingEvents.setPendingShopPurchase)({
                offerId,
                amountMinor: orderDetails.amount,
                currency: orderDetails.currency
            });
            const result = await stripe.confirmPayment({
                elements,
                clientSecret: orderDetails.client_secret,
                redirect: "if_required",
                confirmParams: {
                    return_url: returnUrl,
                    payment_method_data: {
                        billing_details: {
                            name: orderDetails.customer_name ?? "Cricket 8 Customer",
                            ...orderDetails.email && {
                                email: orderDetails.email
                            }
                        }
                    }
                }
            });
            const error = result.error;
            const paymentIntent = "paymentIntent" in result ? result.paymentIntent : null;
            if (error) {
                (0, _frontendTrackingEvents.clearPendingShopPurchase)();
                (0, _frontendTrackingEvents.trackPurchaseFailed)({
                    user_id: userId,
                    product_type: "ruby_pack",
                    amount: amountMajor,
                    currency: currencyNorm,
                    payment_method: "card",
                    error_type: stripeErrorToPurchaseErrorType(error),
                    pathname: SHOP_PAGE_PATH
                });
                // Stripe pins declines that carry no `param` to the card-number field and keeps
                // the element invalid until that field is edited, so remount it for a clean retry.
                if (error.type === "card_error" && !error.param) {
                    setElementReady(false);
                    setPaymentElementKey((k)=>k + 1);
                    setErrorMessage(`${error.message ?? "Your card was declined."} Please re-enter your card details or try a different card.`);
                } else setErrorMessage(error.message ?? "Payment failed");
                return;
            }
            if (paymentIntent?.status === "processing") {
                (0, _frontendTrackingEvents.clearPendingShopPurchase)();
                setPendingOutcome("processing");
                return;
            }
            const paymentIntentId = paymentIntent?.id ?? (orderDetails.client_secret.includes("_secret_") ? orderDetails.client_secret.split("_secret_")[0] : null);
            if (paymentIntentId) await verifyReceipt(orderDetails.receipt, paymentIntentId, orderDetails.amount, orderDetails.currency);
            else {
                (0, _frontendTrackingEvents.clearPendingShopPurchase)();
                setPendingOutcome("unverified");
            }
        } catch (err) {
            console.error("Pay submit error:", err);
            (0, _frontendTrackingEvents.clearPendingShopPurchase)();
            (0, _frontendTrackingEvents.trackPurchaseFailed)({
                user_id: userId,
                product_type: "ruby_pack",
                amount: amountMajor,
                currency: currencyNorm,
                payment_method: "card",
                error_type: "network_error",
                pathname: SHOP_PAGE_PATH
            });
            setErrorMessage(err instanceof Error ? err.message : "Something went wrong. Please try again.");
        } finally{
            setIsSubmitting(false);
        }
    }
    if (pendingOutcome) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full px-2 space-y-4 flex flex-col items-center",
        role: "status",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "bg-[#4E2681] px-4 py-3 text-center font-chakra text-[14px] leading-snug text-white",
                children: PENDING_MESSAGES[pendingOutcome]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                onClick: ()=>closeModal(false),
                style: {
                    width: "240px",
                    height: "45px",
                    textAlign: "center",
                    backgroundColor: "#D2FF00",
                    color: "#1B062F",
                    fontFamily: "anton"
                },
                children: "Close"
            })
        ]
    });
    const payDisabled = !stripe || !elements || !elementReady || isSubmitting;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "w-full px-2 space-y-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.PaymentElement), {
                options: {
                    layout: "tabs"
                },
                onReady: ()=>setElementReady(true),
                onChange: (event)=>{
                    if (!event.empty) setErrorMessage(null);
                }
            }, paymentElementKey),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: errorRef,
                role: "alert",
                className: "flex flex-row items-start gap-2 bg-red px-3 py-2 font-chakra text-[14px] font-semibold leading-snug text-white",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": true,
                        className: "inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-white font-anton text-[12px] text-red",
                        children: "!"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full flex justify-center pt-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "submit",
                    disabled: payDisabled,
                    "aria-busy": isSubmitting,
                    className: "disabled:cursor-not-allowed disabled:opacity-50 transition-opacity",
                    style: {
                        width: "240px",
                        height: "45px",
                        textAlign: "center",
                        backgroundColor: "#D2FF00",
                        color: "#1B062F",
                        fontFamily: "anton"
                    },
                    children: isSubmitting ? "Processing\u2026" : !elementReady ? "Loading\u2026" : "Pay"
                })
            })
        ]
    });
}
function StripePayBtn({ closeModal, offerId, payAmount, updateRubies, offerType, onPaymentSuccess, onPriceChange }) {
    async function getOrder() {
        const session_token = (0, _jsCookieDefault.default).get("c8_session_token");
        try {
            const orderResp = await fetch(`${"https://cricket8.com/api"}/offers/${offerId}/order?user_session=${session_token}`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    attempt_id: newAttemptId()
                })
            });
            if (orderResp.status !== 201) {
                const data = await orderResp.json().catch(()=>({}));
                return {
                    error: data?.message ?? "Could not start the payment."
                };
            }
            const resp = await orderResp.json();
            return {
                order: {
                    client_secret: resp.client_secret,
                    receipt: resp.receipt,
                    amount: resp.amount,
                    currency: resp.currency,
                    status: resp.status,
                    ...resp.email && {
                        email: resp.email
                    },
                    ...resp.customer_name && {
                        customer_name: resp.customer_name
                    }
                }
            };
        } catch (err) {
            console.error(err);
            return {
                error: "Could not reach the payment server."
            };
        }
    }
    if (!stripePromise) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: "bg-red px-3 py-2 font-chakra text-[14px] text-white m-2",
        children: "Stripe is not configured (missing STRIPE_PUBLISHABLE_KEY)."
    });
    const formAreaHeight = "min(60vh, 400px)";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "w-[100%] p-2 mb-[20px] flex flex-col items-center relative",
        style: {
            minHeight: formAreaHeight
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.Elements), {
            stripe: stripePromise,
            options: {
                mode: "payment",
                amount: Math.max(1, Math.round(Number(payAmount) * 100)),
                currency: "inr",
                appearance: {
                    theme: "stripe",
                    variables: {
                        colorPrimary: "#FFFFFF",
                        colorText: "#FFFFFF",
                        colorTextSecondary: "#FFFFFF",
                        colorBackground: "#1B062F",
                        colorDanger: "#df1b41"
                    }
                }
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StripePaymentForm, {
                offerId: offerId,
                payAmount: payAmount,
                createOrder: getOrder,
                closeModal: closeModal,
                updateRubies: updateRubies,
                onPaymentSuccess: onPaymentSuccess,
                onPriceChange: onPriceChange
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@stripe/stripe-js":"dJPQw","@stripe/react-stripe-js":"5Zc5C","js-cookie":"2P5RE","../../Data/UserContext":"aqd8b","../../utils/authHeaders":"5Rczo","../../utils/frontendTrackingEvents":"4Y90p","../../utils/gtmEvents":"kxMC4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJPQw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexMjs = require("../dist/index.mjs");
parcelHelpers.exportAll(_indexMjs, exports);

},{"../dist/index.mjs":"drGVQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"drGVQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadStripe", ()=>loadStripe);
var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat(V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "4.6.0",
        startTime: startTime
    });
};
var stripePromise = null;
var onErrorListener = null;
var onLoadListener = null;
var onError = function onError(reject) {
    return function() {
        reject(new Error('Failed to load Stripe.js'));
    };
};
var onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if (stripePromise !== null) return stripePromise;
    stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn(EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = findScript();
            if (script && params) console.warn(EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = injectScript(params);
            else if (script && onLoadListener !== null && onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', onLoadListener);
                script.removeEventListener('error', onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = injectScript(params);
            }
            onLoadListener = onLoad(resolve, reject);
            onErrorListener = onError(reject);
            script.addEventListener('load', onLoadListener);
            script.addEventListener('error', onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return stripePromise["catch"](function(error) {
        stripePromise = null;
        return Promise.reject(error);
    });
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var stripePromise$1;
var loadCalled = false;
var getStripePromise = function getStripePromise() {
    if (stripePromise$1) return stripePromise$1;
    stripePromise$1 = loadScript(null)["catch"](function(error) {
        // clear cache on error
        stripePromise$1 = null;
        return Promise.reject(error);
    });
    return stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return getStripePromise();
})["catch"](function(error) {
    if (!loadCalled) console.warn(error);
});
var loadStripe = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return getStripePromise().then(function(maybeStripe) {
        return initStripe(maybeStripe, args, startTime);
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Zc5C":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports, require("d99b0077bf8bdf43"));
})(this, function(exports1, React) {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "2.8.1"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "2.8.1",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var _excluded = [
        "on",
        "session"
    ];
    var CustomCheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutSdkContext.displayName = 'CustomCheckoutSdkContext';
    var parseCustomCheckoutSdkContext = function parseCustomCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CustomCheckoutProvider> provider."));
        return ctx;
    };
    var CustomCheckoutContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutContext.displayName = 'CustomCheckoutContext';
    var extractCustomCheckoutContextValue = function extractCustomCheckoutContextValue(customCheckoutSdk, sessionState) {
        if (!customCheckoutSdk) return null;
        customCheckoutSdk.on;
        customCheckoutSdk.session;
        var actions = _objectWithoutProperties(customCheckoutSdk, _excluded);
        if (!sessionState) return _objectSpread2(_objectSpread2({}, actions), customCheckoutSdk.session());
        return _objectSpread2(_objectSpread2({}, actions), sessionState);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `CustomCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var CustomCheckoutProvider = function CustomCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                customCheckoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, customCheckoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.customCheckoutSdk) return ctx;
                return {
                    stripe: stripe,
                    customCheckoutSdk: customCheckoutSdk
                };
            });
        }; // Ref used to avoid calling initCustomCheckout multiple times when options changes
        var initCustomCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCustomCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCustomCheckoutCalledRef.current = true;
                    stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                        if (customCheckoutSdk) {
                            safeSetContext(stripe, customCheckoutSdk);
                            customCheckoutSdk.on('change', setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === 'sync' && parsed.stripe && !initCustomCheckoutCalledRef.current) {
                initCustomCheckoutCalledRef.current = true;
                parsed.stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                    if (customCheckoutSdk) {
                        safeSetContext(parsed.stripe, customCheckoutSdk);
                        customCheckoutSdk.on('change', setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on CustomCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            if (!ctx.customCheckoutSdk) return;
            if (options.clientSecret && !isUnknownObject(prevOptions) && !isEqual(options.clientSecret, prevOptions.clientSecret)) console.warn('Unsupported prop change: options.client_secret is not a mutable property.');
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            if (currentAppearance && !isEqual(currentAppearance, previousAppearance)) ctx.customCheckoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.customCheckoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var customCheckoutContextValue = React.useMemo(function() {
            return extractCustomCheckoutContextValue(ctx.customCheckoutSdk, session);
        }, [
            ctx.customCheckoutSdk,
            session
        ]);
        if (!ctx.customCheckoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CustomCheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CustomCheckoutContext.Provider, {
            value: customCheckoutContextValue
        }, children));
    };
    CustomCheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            clientSecret: PropTypes.string.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCustomCheckoutSdkContextWithUseCase = function useCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CustomCheckoutSdkContext);
        return parseCustomCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCustomCheckoutSdkContextWithUseCase = function useElementsOrCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var customCheckoutSdkContext = React.useContext(CustomCheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (customCheckoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CustomCheckoutProvider> and <Elements> providers."));
        if (customCheckoutSdkContext) return parseCustomCheckoutSdkContext(customCheckoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCustomCheckout = function useCustomCheckout() {
        // ensure it's in CustomCheckoutProvider
        useCustomCheckoutSdkContextWithUseCase('calls useCustomCheckout()');
        var ctx = React.useContext(CustomCheckoutContext);
        if (!ctx) throw new Error('Could not find CustomCheckout Context; You need to wrap the part of your app that calls useCustomCheckout() in an <CustomCheckoutProvider> provider.');
        return ctx;
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var customCheckoutSdk = 'customCheckoutSdk' in ctx ? ctx.customCheckoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || customCheckoutSdk)) {
                    var newElement = null;
                    if (customCheckoutSdk) newElement = customCheckoutSdk.createElement(type, options);
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                customCheckoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCustomC = useElementsOrCustomCheckoutSdkContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCustomC.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent('fpxBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent('idealBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent('p24Bank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent('epsBank', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var CurrencySelectorElement = createElementComponent('currencySelector', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent('affirmMessage', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent('afterpayClearpayMessage', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CurrencySelectorElement = CurrencySelectorElement;
    exports1.CustomCheckoutProvider = CustomCheckoutProvider;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCustomCheckout = useCustomCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});

},{"d99b0077bf8bdf43":"6uln9"}],"kxMC4":[function(require,module,exports,__globalThis) {
// GTM dataLayer event tracking utility
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trackPageView", ()=>trackPageView);
parcelHelpers.export(exports, "trackRubyPurchased", ()=>trackRubyPurchased);
parcelHelpers.export(exports, "trackCompleteRegistration", ()=>trackCompleteRegistration);
parcelHelpers.export(exports, "trackGameInitiation", ()=>trackGameInitiation);
parcelHelpers.export(exports, "trackPlayTrader", ()=>trackPlayTrader);
parcelHelpers.export(exports, "trackPlaySquares", ()=>trackPlaySquares);
parcelHelpers.export(exports, "trackPlayBullion", ()=>trackPlayBullion);
parcelHelpers.export(exports, "trackSpinWheelClicked", ()=>trackSpinWheelClicked);
var _analyticsEnv = require("./analyticsEnv");
var _gtm = require("./gtm");
var _gameIntroStorage = require("./gameIntroStorage");
function shouldSkipAnalytics(pagePath) {
    if ((0, _analyticsEnv.isDevEnv)()) return true;
    return (0, _analyticsEnv.isAnalyticsPathExcluded)(pagePath);
}
const trackPageView = (data)=>{
    if (shouldSkipAnalytics(data.page_path)) return;
    (0, _gtm.pushToDataLayer)({
        dataLayer: {
            event: 'new_page_view',
            user_id: data.user_id,
            page_path: data.page_path
        }
    });
};
const trackRubyPurchased = (data)=>{
    if (shouldSkipAnalytics()) return;
    (0, _gtm.pushToDataLayer)({
        dataLayer: {
            event: 'ruby_purchased',
            user_id: data.user_id,
            purchase_amount: data.purchase_amount,
            currency: data.currency
        }
    });
};
const trackCompleteRegistration = (data)=>{
    if (shouldSkipAnalytics()) return;
    (0, _gtm.pushToDataLayer)({
        dataLayer: {
            event: 'CompleteRegistration',
            user_id: data.user_id
        }
    });
};
const trackGameInitiation = (data)=>{
    const lobbyGameTypes = [
        'sixes',
        'bullion',
        'squares',
        'trader'
    ];
    if (lobbyGameTypes.includes(data.game_type)) (0, _gameIntroStorage.markGamePlayed)(data.game_type);
    if (shouldSkipAnalytics()) return;
    (0, _gtm.pushToDataLayer)({
        dataLayer: {
            event: 'game_initiation',
            user_id: data.user_id,
            game_type: data.game_type,
            // Clear sticky funnel vars so legacy wheel pushes cannot leak into trader/squares.
            entry_point: null,
            sport: null,
            submission_type: null,
            prediction_id: null,
            fixture_id: null,
            competition_name: null
        }
    });
};
const trackPlayTrader = (data)=>{
    if (shouldSkipAnalytics()) return;
    (0, _gtm.pushToDataLayer)({
        dataLayer: {
            event: 'play_trader',
            user_id: data.user_id,
            outcome: data.outcome
        }
    });
};
const trackPlaySquares = (data)=>{
    if (shouldSkipAnalytics()) return;
    (0, _gtm.pushToDataLayer)({
        dataLayer: {
            event: 'play_squares',
            user_id: data.user_id,
            outcome: data.outcome
        }
    });
};
const trackPlayBullion = (data)=>{
    if (shouldSkipAnalytics()) return;
    (0, _gtm.pushToDataLayer)({
        dataLayer: {
            event: 'play_bullion',
            user_id: data.user_id,
            outcome: data.outcome
        }
    });
};
const trackSpinWheelClicked = (data)=>{
    if (shouldSkipAnalytics()) return;
    (0, _gtm.pushToDataLayer)({
        dataLayer: {
            event: 'play_wheel_spinner',
            user_id: data.user_id
        }
    });
};

},{"./analyticsEnv":"4mdbs","./gtm":"dO5RN","./gameIntroStorage":"fsW56","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fsW56":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSeenGameIntro", ()=>hasSeenGameIntro);
parcelHelpers.export(exports, "markGameIntroSeen", ()=>markGameIntroSeen);
parcelHelpers.export(exports, "markGamePlayed", ()=>markGamePlayed);
parcelHelpers.export(exports, "hasLocalGamePlayRecord", ()=>hasLocalGamePlayRecord);
/** Called when the global first-visit tour is dismissed or played. */ parcelHelpers.export(exports, "noteFirstVisitPlayTourCompleted", ()=>noteFirstVisitPlayTourCompleted);
/** True when the first-visit tour finished this recently (same visit / short session). */ parcelHelpers.export(exports, "wasFirstVisitPlayTourCompletedWithin", ()=>wasFirstVisitPlayTourCompletedWithin);
parcelHelpers.export(exports, "shouldDeferGameIntroAfterFirstVisitTour", ()=>shouldDeferGameIntroAfterFirstVisitTour);
const INTRO_SEEN_PREFIX = "c8_game_intro_seen_v1:";
const PLAYED_PREFIX = "c8_game_played_v1:";
const FIRST_VISIT_TOUR_AT_KEY = "c8_first_visit_tour_at_v1";
/** Skip per-game lobby intro briefly after the global first-visit tour. */ const INTRO_DEFER_AFTER_TOUR_MS = 86400000;
function introKey(gameType) {
    return `${INTRO_SEEN_PREFIX}${gameType}`;
}
function playedKey(gameType) {
    return `${PLAYED_PREFIX}${gameType}`;
}
function hasSeenGameIntro(gameType) {
    try {
        return localStorage.getItem(introKey(gameType)) === "1";
    } catch  {
        return false;
    }
}
function markGameIntroSeen(gameType) {
    try {
        localStorage.setItem(introKey(gameType), "1");
    } catch  {
    /* ignore */ }
}
function markGamePlayed(gameType) {
    try {
        localStorage.setItem(playedKey(gameType), "1");
        localStorage.setItem(introKey(gameType), "1");
    } catch  {
    /* ignore */ }
}
function hasLocalGamePlayRecord(gameType) {
    try {
        return localStorage.getItem(playedKey(gameType)) === "1";
    } catch  {
        return false;
    }
}
function noteFirstVisitPlayTourCompleted() {
    try {
        localStorage.setItem(FIRST_VISIT_TOUR_AT_KEY, String(Date.now()));
    } catch  {
    /* ignore */ }
}
function wasFirstVisitPlayTourCompletedWithin(ms) {
    try {
        const raw = localStorage.getItem(FIRST_VISIT_TOUR_AT_KEY);
        if (!raw) return false;
        const at = Number(raw);
        if (!Number.isFinite(at)) return false;
        return Date.now() - at < ms;
    } catch  {
        return false;
    }
}
function shouldDeferGameIntroAfterFirstVisitTour() {
    return wasFirstVisitPlayTourCompletedWithin(INTRO_DEFER_AFTER_TOUR_MS);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fijDF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatSaleTimeLeft", ()=>formatSaleTimeLeft);
/** Milliseconds until `endsAt` (ticks every second in the final day); calls `onExpire` once at zero. */ parcelHelpers.export(exports, "useSaleTimeLeft", ()=>useSaleTimeLeft);
parcelHelpers.export(exports, "default", ()=>SaleCountdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const DAY_MS = 86400000;
function formatSaleTimeLeft(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor(totalSeconds % 86400 / 3600);
    const minutes = Math.floor(totalSeconds % 3600 / 60);
    const seconds = totalSeconds % 60;
    const pad = (n)=>String(n).padStart(2, '0');
    if (days > 0) return `${days}D ${pad(hours)}H`;
    if (hours > 0) return `${hours}H ${pad(minutes)}M`;
    return `${minutes}M ${pad(seconds)}S`;
}
function useSaleTimeLeft(endsAt, onExpire) {
    const endMs = endsAt ? Date.parse(endsAt) : NaN;
    const [now, setNow] = (0, _react.useState)(()=>Date.now());
    const expiredRef = (0, _react.useRef)(false);
    const onExpireRef = (0, _react.useRef)(onExpire);
    onExpireRef.current = onExpire;
    const left = Number.isFinite(endMs) ? endMs - now : null;
    const tickMs = left != null && left < DAY_MS ? 1000 : 30000;
    (0, _react.useEffect)(()=>{
        if (!Number.isFinite(endMs)) return;
        expiredRef.current = false;
        const id = window.setInterval(()=>setNow(Date.now()), tickMs);
        return ()=>window.clearInterval(id);
    }, [
        endMs,
        tickMs
    ]);
    (0, _react.useEffect)(()=>{
        if (left != null && left <= 0 && !expiredRef.current) {
            expiredRef.current = true;
            onExpireRef.current?.();
        }
    }, [
        left
    ]);
    return left;
}
function ClockIcon({ className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: className,
        width: "11",
        height: "11",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "9",
                stroke: "currentColor",
                strokeWidth: "2.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M12 7v5l3 2",
                stroke: "currentColor",
                strokeWidth: "2.5",
                strokeLinecap: "round"
            })
        ]
    });
}
function SaleCountdown({ endsAt, onExpire, className = '' }) {
    const left = useSaleTimeLeft(endsAt, onExpire);
    if (left == null || left <= 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: `inline-flex items-center gap-1 font-anton text-[11px] uppercase leading-none tabular-nums ${className}`,
        "aria-label": `Sale ends in ${formatSaleTimeLeft(left)}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockIcon, {
                className: "shrink-0"
            }),
            "ENDS IN ",
            formatSaleTimeLeft(left)
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iy57h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ShopFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _scrollToPageTop = require("../../utils/scrollToPageTop");
var _virtualCurrencyDisclaimer = require("../../utils/virtualCurrencyDisclaimer");
function ShopFooter({ className = "" }) {
    const scrollToTop = ()=>(0, _scrollToPageTop.scrollToPageTop)({
            defer: true
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full flex flex-col gap-2 " + className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "px-1 text-center font-chakra text-[11px] leading-relaxed text-white/60 normal-case sm:text-[12px]",
                children: (0, _virtualCurrencyDisclaimer.VIRTUAL_CURRENCY_DISCLAIMER)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex h-10 w-full flex-row items-center justify-center gap-2 border-t border-[#1B062F] bg-[#401A6E] text-[14px] text-white",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/account?t=tran",
                        onClick: scrollToTop,
                        className: "cursor-pointer font-chakra transition-colors hover:text-lime",
                        children: "Transactions"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/contact",
                        onClick: scrollToTop,
                        className: "cursor-pointer font-chakra transition-colors hover:text-lime",
                        children: "Contact"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/terms",
                        onClick: scrollToTop,
                        className: "cursor-pointer font-chakra transition-colors hover:text-lime",
                        children: "Terms"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/refundpolicy",
                        onClick: scrollToTop,
                        className: "cursor-pointer font-chakra transition-colors hover:text-lime",
                        children: "Refund policy"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../../utils/scrollToPageTop":"7iA1U","../../utils/virtualCurrencyDisclaimer":"eHHb8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7iA1U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrollToPageTop", ()=>scrollToPageTop);
function performScrollToTop() {
    if (typeof window === "undefined") return;
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto"
    });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    const mainMenu = document.getElementById("mainMenu");
    if (mainMenu) mainMenu.scrollTop = 0;
    const content = document.getElementById("content");
    if (content) content.scrollTop = 0;
}
function scrollToPageTop(options = {}) {
    performScrollToTop();
    if (!options.defer || typeof window === "undefined") return;
    window.requestAnimationFrame(()=>{
        window.requestAnimationFrame(()=>{
            performScrollToTop();
        });
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eHHb8":[function(require,module,exports,__globalThis) {
/** Standard virtual-currency disclaimer for Meta / social-gaming compliance surfaces. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VIRTUAL_CURRENCY_DISCLAIMER", ()=>VIRTUAL_CURRENCY_DISCLAIMER);
parcelHelpers.export(exports, "FTP_DISCLAIMER_SHORT_LINES", ()=>FTP_DISCLAIMER_SHORT_LINES);
parcelHelpers.export(exports, "FTP_DISCLAIMER_SHORT", ()=>FTP_DISCLAIMER_SHORT);
parcelHelpers.export(exports, "FTP_DISCLAIMER_COMPACT", ()=>FTP_DISCLAIMER_COMPACT);
parcelHelpers.export(exports, "VIRTUAL_CURRENCY_SHOP_NOTE", ()=>VIRTUAL_CURRENCY_SHOP_NOTE);
const VIRTUAL_CURRENCY_DISCLAIMER = "Cricket8 is a free-to-play social cricket game. Coins, Rubies and XP are virtual in-game currencies, have no monetary value and cannot be exchanged or withdrawn for cash.";
const FTP_DISCLAIMER_SHORT_LINES = [
    "Free-to-play cricket games.",
    "Virtual Coins have no cash value.",
    "No cash prizes."
];
const FTP_DISCLAIMER_SHORT = FTP_DISCLAIMER_SHORT_LINES.join(" ");
const FTP_DISCLAIMER_COMPACT = "Free to play \xb7 Virtual Coins have no cash value \xb7 No cash prizes";
const VIRTUAL_CURRENCY_SHOP_NOTE = "Virtual Coins have no cash value. No cash equivalents.";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Vfqc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "currentPrice", ()=>currentPrice);
/** Offer with the lowest full price per unit received, if it is uniquely the cheapest. */ parcelHelpers.export(exports, "bestValueOfferId", ()=>bestValueOfferId);
parcelHelpers.export(exports, "getAllOffers", ()=>getAllOffers);
parcelHelpers.export(exports, "getHardOffers", ()=>getHardOffers);
parcelHelpers.export(exports, "getSoftOffers", ()=>getSoftOffers);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _authHeaders = require("../../../utils/authHeaders");
function currentPrice(offer) {
    return offer.price ?? offer.pay_amount;
}
function bestValueOfferId(offers) {
    if (offers.length < 2) return null;
    const perUnit = offers.filter((o)=>o.receive_amount > 0).map((o)=>({
            id: o.id,
            rate: o.pay_amount / o.receive_amount
        })).sort((a, b)=>a.rate - b.rate);
    if (perUnit.length < 2 || perUnit[0].rate === perUnit[1].rate) return null;
    return perUnit[0].id;
}
async function fetchOffers(offerType) {
    const session_token = (0, _jsCookieDefault.default).get('c8_session_token') || '';
    const qs = new URLSearchParams({
        ...offerType && {
            offer_type: offerType
        },
        user_session: session_token
    });
    const res = await fetch(`${"https://cricket8.com/api"}/offers?${qs.toString()}`, {
        method: 'GET',
        headers: (0, _authHeaders.getAuthHeaders)()
    });
    if (!res.ok) throw new Error(`Failed to fetch ${offerType ?? 'all'} offers: ${res.status}`);
    return res.json();
}
async function getAllOffers() {
    return fetchOffers();
}
async function getHardOffers() {
    return fetchOffers('hard');
}
async function getSoftOffers() {
    return fetchOffers('soft');
}

},{"js-cookie":"2P5RE","../../../utils/authHeaders":"5Rczo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8WBJo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SoftOffers);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _modals = require("../Modals");
var _modalsDefault = parcelHelpers.interopDefault(_modals);
var _gotIt = require("../Modals/GotIt");
var _gotItDefault = parcelHelpers.interopDefault(_gotIt);
var _buyCoinsWithRubies = require("./BuyCoinsWithRubies");
var _buyCoinsWithRubiesDefault = parcelHelpers.interopDefault(_buyCoinsWithRubies);
var _userContext = require("../../Data/UserContext");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _saleCountdown = require("./SaleCountdown");
var _saleCountdownDefault = parcelHelpers.interopDefault(_saleCountdown);
var _offers = require("./api/offers");
const SHOP_PAGE_PATH = "/shop";
/** Skeleton card matching one "Buy coins" offer (icon, amount, button) */ function SoftOfferCardSkeleton() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col justify-center items-center gap-1 relative px-2 py-3 bg-white w-full min-w-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-10 h-10 bg-gray-200 animate-pulse shrink-0",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "h-5 w-14 bg-gray-200 animate-pulse shrink-0",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "h-10 w-[100px] bg-gray-200 animate-pulse shrink-0",
                "aria-hidden": true
            })
        ]
    });
}
function SoftOffersSkeleton() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex w-[100%] items-center justify-evenly gap-0.5 overflow-x-auto overflow-y-hidden bg-inherit px-[3px]",
        children: [
            1,
            2,
            3
        ].map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SoftOfferCardSkeleton, {}, i))
    });
}
function SoftOffers({ setIsAnimatingCoins, onPlayCoinsSound, totalRubies, updateUserAmount }) {
    const { user } = (0, _userContext.useUser)();
    const [open, setOpen] = (0, _react.useState)(false);
    const [softOffers, setSoftOffers] = (0, _react.useState)([]);
    const [selectedOffer, setSelectedOffer] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)("");
    const [noMoreRubies, setNoMoreRubies] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        fetchSoftOffers();
    }, []);
    async function fetchSoftOffers({ silent = false } = {}) {
        if (!silent) setLoading(true);
        try {
            const softData = await (0, _offers.getSoftOffers)();
            setSoftOffers(softData);
        } catch (error) {
            if (!silent) setError(error);
        } finally{
            if (!silent) setLoading(false);
        }
    }
    const refreshAfterSaleEnds = ()=>void fetchSoftOffers({
            silent: true
        });
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SoftOffersSkeleton, {});
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
        className: "text-red font-anton",
        children: "Something went wrong..."
    });
    function openOfferModal(item) {
        const price = (0, _offers.currentPrice)(item);
        if (price > totalRubies) {
            setNoMoreRubies(true);
            return;
        }
        (0, _frontendTrackingEvents.trackProductSelected)({
            user_id: user?.userId,
            product_id: item.id,
            product_type: "coin_pack",
            product_name: item.offer_name?.trim() || `x${item.receive_amount}_coins`,
            price,
            ...item.on_sale && {
                original_price: item.pay_amount,
                discount_pct: item.sale_percent
            },
            currency: "RUBIES",
            pathname: SHOP_PAGE_PATH
        });
        setSelectedOffer(item);
        setOpen(true);
    }
    function closeModal() {
        setOpen(false);
        setSelectedOffer(null);
    }
    function closeNoRubiesModal() {
        setNoMoreRubies(false);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-[100%] items-center justify-evenly gap-0.5 overflow-x-auto overflow-y-hidden bg-inherit px-[3px]",
                children: [
                    softOffers.map((item)=>{
                        const onSale = Boolean(item.on_sale && item.sale_percent);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `flex flex-col justify-center items-center gap-1 relative overflow-hidden px-2 py-3 bg-white w-full ${onSale ? "ring-2 ring-inset ring-red" : ""}`,
                            children: [
                                onSale ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "absolute p-[2px] text-[13px] w-[120px] bg-red top-[15px] right-[-40px] rotate-[45deg] text-center font-anton text-white",
                                    children: [
                                        "\u2212",
                                        item.sale_percent,
                                        "%"
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "w-[40px] h-[40px]",
                                    src: "/assets/currency-coin.png",
                                    alt: "coin"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-gold font-anton font-[400] text-[20px]",
                                    children: [
                                        "x",
                                        item.receive_amount >= 1000 ? `${(item.receive_amount / 1000).toFixed(0)}K` : item.receive_amount
                                    ]
                                }),
                                onSale ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "flex items-center gap-[4px] font-anton text-[13px] leading-none",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "flex items-center gap-0.5 text-gray-400 line-through",
                                            "aria-label": `Was ${item.pay_amount} rubies`,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "w-[11px] h-[11px] opacity-60",
                                                    src: "/assets/currency-ruby.png",
                                                    alt: ""
                                                }),
                                                item.pay_amount
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "bg-red px-[4px] py-[1px] text-[11px] uppercase text-white",
                                            children: [
                                                "Save ",
                                                item.pay_amount - (0, _offers.currentPrice)(item)
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    onClick: ()=>openOfferModal(item),
                                    className: "font-anton text-white uppercase font-[400] text-[14px] flex flex-row items-center justify-center gap-[2px] bg-lime whitespace-nowrap w-[100px] h-[40px] text-center font-[400]",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-anton font-[14px] text-[#1B062F]",
                                            children: "GET FOR"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "w-[15px] h-[15px] inline-block",
                                            src: "/assets/currency-ruby.png",
                                            alt: "ruby"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-anton font-[14px] text-[#1B062F]",
                                            children: (0, _offers.currentPrice)(item)
                                        })
                                    ]
                                }),
                                onSale && item.sale_ends_at ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _saleCountdownDefault.default), {
                                    endsAt: item.sale_ends_at,
                                    onExpire: refreshAfterSaleEnds,
                                    className: "text-red"
                                }) : null
                            ]
                        }, item.id);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gotItDefault.default), {
                        isOpen: noMoreRubies,
                        onRequestClose: closeNoRubiesModal,
                        contentLabel: "No Rubies",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex justify-center items-center p-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "font-[600] text-white text-center text-[20px]",
                                children: "NOT ENOUGH RUBIES TO MAKE THAT PURCHASE. GET RUBIES AND TRY AGAIN."
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalsDefault.default), {
                isOpen: open,
                onRequestClose: closeModal,
                contentLabel: "BUY",
                children: selectedOffer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buyCoinsWithRubiesDefault.default), {
                    receive_amount: selectedOffer?.receive_amount,
                    pay_amount: (0, _offers.currentPrice)(selectedOffer),
                    original_pay_amount: selectedOffer.on_sale ? selectedOffer.pay_amount : undefined,
                    coinId: selectedOffer?.id,
                    offerType: selectedOffer.offer_type,
                    offerName: selectedOffer?.offer_name,
                    closeModal: closeModal,
                    setIsAnimatingCoins: setIsAnimatingCoins,
                    onPlayCoinsSound: onPlayCoinsSound,
                    updateUserAmount: updateUserAmount
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Modals":"dJE67","../Modals/GotIt":"f7KM7","./BuyCoinsWithRubies":"hM2v8","../../Data/UserContext":"aqd8b","../../utils/frontendTrackingEvents":"4Y90p","./SaleCountdown":"fijDF","./api/offers":"1Vfqc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7KM7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
const getModalWidth = ()=>{
    if (window.innerWidth >= 768) return "50%";
    else return "90%";
};
const GotIt = ({ isOpen, onRequestClose, contentLabel, children })=>{
    (0, _react.useEffect)(()=>{
        const updateWidth = ()=>{
            const modalContent = document.querySelector(".ReactModal__Content");
            if (modalContent) modalContent.style.width = getModalWidth();
        };
        window.addEventListener("resize", updateWidth);
        // Initial call to set width
        if (isOpen) updateWidth();
        return ()=>{
            window.removeEventListener("resize", updateWidth);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        contentLabel: contentLabel,
        style: {
            content: {
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#401a6e",
                width: getModalWidth(),
                margin: 0,
                padding: 0,
                /* Above wallet/XP history portals (10060); SoftOffers "not enough rubies"
           * opens while the shop tab is still mounted. */ zIndex: 10071
            },
            overlay: {
                background: "rgba(11, 2, 18, 0.8)",
                zIndex: 10070
            }
        },
        ariaHideApp: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                children,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: onRequestClose,
                    style: {
                        display: "block",
                        margin: "0 auto",
                        fontSize: "16px",
                        fontFamily: "anton",
                        border: "none",
                        cursor: "pointer",
                        marginBottom: "20px",
                        width: "144px",
                        height: "40px",
                        fontWeight: "600",
                        backgroundColor: "#D2FF00",
                        color: "#1B062F",
                        textAlign: "center"
                    },
                    children: "GOT IT"
                })
            ]
        })
    });
};
exports.default = GotIt;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Modal":"2Ei4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hM2v8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuyCoinsWithRubies);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _shopFooter = require("./ShopFooter");
var _shopFooterDefault = parcelHelpers.interopDefault(_shopFooter);
var _virtualCurrencyDisclaimer = require("../../utils/virtualCurrencyDisclaimer");
function BuyCoinsWithRubies({ pay_amount, original_pay_amount, receive_amount, closeModal, setIsAnimatingCoins, onPlayCoinsSound, updateUserAmount, coinId, offerType, offerName }) {
    const [isSuccess, setIsSuccess] = (0, _react.useState)(false);
    const formatCoins = (amount)=>{
        return new Intl.NumberFormat('en-IN').format(amount);
    };
    function handlePaymentSuccess() {
        updateUserAmount(String(coinId), offerType, {
            pay_amount,
            receive_amount,
            offer_name: offerName
        });
        setIsSuccess(true);
    }
    function handleDone() {
        // Play sound in same synchronous stack as user click (same pattern as Squares) so browser allows it
        onPlayCoinsSound?.();
        // Close modal first
        closeModal(true);
        // Trigger animation after modal closes so it's visible in Wallet
        setTimeout(()=>{
            setIsAnimatingCoins(true);
            // Stop animation after 3 seconds
            setTimeout(()=>{
                setIsAnimatingCoins(false);
            }, 3000);
        }, 100);
    }
    // Success view
    if (isSuccess) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-[100%]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-[100%] py-[20px] flex flex-row justify-center items-center",
                style: {
                    backgroundColor: '#401A6E'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "font-anton text-white text-[24px]",
                    children: "SUCCESS!"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "w-[100%] bg-white px-[20px] py-[10px] flex flex-col items-center justify-center",
                style: {
                    backgroundColor: '#FFFFFF'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "font-anton text-main text-[20px]",
                        children: "COINS ADDED TO WALLET!"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "w-[90px] h-[90px]",
                        src: "/assets/currency-coin.png",
                        alt: "coin"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "font-anton text-main text-[32px]",
                        children: [
                            "+",
                            formatCoins(receive_amount)
                        ]
                    }),
                    original_pay_amount != null && original_pay_amount > pay_amount ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "mt-[2px] flex items-center gap-[4px] bg-red px-[10px] py-[2px] font-anton text-[16px] uppercase text-white",
                        children: [
                            "You saved ",
                            original_pay_amount - pay_amount,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "h-[18px] w-[18px]",
                                src: "/assets/currency-ruby.png",
                                alt: "rubies"
                            }),
                            "!"
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-[100%] flex flex-row justify-center items-center py-[20px]",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: handleDone,
                    style: {
                        width: "290px",
                        height: "50px",
                        backgroundColor: "#D2FF00",
                        color: "#1B062F",
                        fontWeight: "400",
                        fontFamily: "Anton",
                        fontSize: "16px",
                        lineHeight: "24px",
                        textAlign: "center"
                    },
                    children: "DONE"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shopFooterDefault.default), {})
        ]
    });
    // Purchase view (original)
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-[100%]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "shop-content p-4 ml-[7px]",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "font-anton",
                    children: "SHOP"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-row items-center justify-between h-[81px] bg-white px-[15px]",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-row items-center gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "w-[50px] h-[50px]",
                                src: "/assets/currency-coin.png"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "font-[400] text-main font-[20px] font-anton leading-[15px]",
                                children: [
                                    "GET ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "lowercase",
                                        children: "x"
                                    }),
                                    receive_amount,
                                    " COINS"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-row items-center gap-[8px]",
                        children: [
                            original_pay_amount != null && original_pay_amount > pay_amount ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "font-anton text-[14px] text-gray-400 line-through",
                                "aria-label": `Was ${original_pay_amount} rubies`,
                                children: original_pay_amount
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "w-[90px] h-[40px] bg-lime flex flex-row items-center justify-left pl-[10px]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "w-[30px] h-[30px] flex flex-row justify-around items-center mr-[5px]",
                                        src: "/assets/currency-ruby.png"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-main font-[400] font-anton text-[16px] leading-[24px]",
                                        children: pay_amount
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mt-3 px-4 text-center font-chakra text-[12px] leading-snug text-white/70 normal-case",
                children: (0, _virtualCurrencyDisclaimer.VIRTUAL_CURRENCY_SHOP_NOTE)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full flex flex-row justify-center items-center mt-[20px]",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: handlePaymentSuccess,
                    style: {
                        width: "290px",
                        height: "50px",
                        backgroundColor: "#D2FF00",
                        color: "#1B062F",
                        fontWeight: "400",
                        fontFamily: "Anton",
                        fontSize: "16px",
                        lineHeight: "24px",
                        textAlign: "center"
                    },
                    children: "GET COINS"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shopFooterDefault.default), {
                className: "mt-[18px]"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./ShopFooter":"iy57h","../../utils/virtualCurrencyDisclaimer":"eHHb8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ellqq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FeatureUnlockPack);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _framerMotion = require("framer-motion");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _userContext = require("../../Data/UserContext");
var _profileGlobalModalContext = require("../Profile/ProfileGlobalModalContext");
var _authHeaders = require("../../utils/authHeaders");
var _sessionUser = require("../../utils/sessionUser");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
const SHOP_PAGE_PATH = "/shop";
const UNLOCK_COST_RUBIES = 1;
const UNLOCK_BONUS_COINS = 200;
function FeatureUnlockPack({ rubies, updateRubies, setIsAnimatingRubies }) {
    const { openOwnProfile } = (0, _profileGlobalModalContext.useProfileGlobalModal)();
    const { user, setUser } = (0, _userContext.useUser)();
    const [loading, setLoading] = (0, _react.useState)(false);
    const [message, setMessage] = (0, _react.useState)(null);
    const [allowPlayerNameEdit, setAllowPlayerNameEdit] = (0, _react.useState)(null);
    const [justUnlocked, setJustUnlocked] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        fetch(`${"https://cricket8.com/api"}/verifysession`, {
            method: "GET",
            headers: (0, _authHeaders.getAuthHeaders)()
        }).then((res)=>res.ok ? res.json() : null).then((data)=>{
            if (data != null && typeof data.allow_player_name_edit === "boolean") setAllowPlayerNameEdit(data.allow_player_name_edit);
            else setAllowPlayerNameEdit(false);
        }).catch(()=>setAllowPlayerNameEdit(false));
    }, [
        user?.allow_player_name_edit
    ]);
    const alreadyUnlocked = allowPlayerNameEdit === true;
    const canAfford = rubies >= UNLOCK_COST_RUBIES;
    async function handleUnlock() {
        if (alreadyUnlocked || !canAfford || loading) return;
        (0, _frontendTrackingEvents.trackProductSelected)({
            user_id: user?.userId,
            product_id: "profile_unlock_pack",
            product_type: "profile_unlock_pack",
            product_name: "profile_feature_unlock_pack",
            price: UNLOCK_COST_RUBIES,
            currency: "RUBIES",
            pathname: SHOP_PAGE_PATH
        });
        setLoading(true);
        setMessage(null);
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/unlock-player-name-edit`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({})
            });
            const data = await res.json().catch(()=>({}));
            if (res.ok && data.allow_player_name_edit) {
                // purchase_success: server Measurement Protocol (unlock endpoint)
                setAllowPlayerNameEdit(true);
                setJustUnlocked(true);
                setTimeout(()=>setJustUnlocked(false), 800);
                updateRubies(data.wallet?.rubies ?? rubies - UNLOCK_COST_RUBIES);
                setMessage({
                    text: `Unlocked! Player name + avatar enabled. +${UNLOCK_BONUS_COINS} coins added.`,
                    error: false
                });
                const session_token = (0, _jsCookieDefault.default).get("c8_session_token");
                if (session_token && setUser) {
                    const userRes = await fetch(`${"https://cricket8.com/api"}/verifysession`, {
                        method: "GET",
                        headers: (0, _authHeaders.getAuthHeaders)()
                    });
                    if (userRes.status === 200) {
                        const updated = (0, _sessionUser.normalizeSessionPayload)(await userRes.json());
                        setUser(updated);
                    }
                }
                // After in-drawer animation: close drawer, reopen My profile, then run profile name/avatar animation
                setTimeout(()=>{
                    window.dispatchEvent(new CustomEvent("closeShopDrawer"));
                }, 1000);
                setTimeout(()=>{
                    openOwnProfile({
                        openEdit: true
                    });
                }, 1100);
                setTimeout(()=>{
                    sessionStorage.setItem("c8_just_unlocked_player_name", "1");
                    window.dispatchEvent(new CustomEvent("runProfileUnlockAnimation"));
                }, 1500);
            } else if (data.alreadyUnlocked) {
                setAllowPlayerNameEdit(true);
                setJustUnlocked(true);
                setTimeout(()=>setJustUnlocked(false), 800);
                setMessage({
                    text: "Already unlocked.",
                    error: false
                });
                if (setUser && user) setUser({
                    ...user,
                    allow_player_name_edit: true
                });
                setTimeout(()=>window.dispatchEvent(new CustomEvent("closeShopDrawer")), 1000);
                setTimeout(()=>openOwnProfile({
                        openEdit: true
                    }), 1100);
                setTimeout(()=>{
                    sessionStorage.setItem("c8_just_unlocked_player_name", "1");
                    window.dispatchEvent(new CustomEvent("runProfileUnlockAnimation"));
                }, 1500);
            } else {
                (0, _frontendTrackingEvents.trackPurchaseFailed)({
                    user_id: user?.userId,
                    product_id: "profile_unlock_pack",
                    product_type: "profile_unlock_pack",
                    amount: UNLOCK_COST_RUBIES,
                    currency: "RUBIES",
                    error_type: res.status >= 500 ? "network_error" : "validation_error",
                    pathname: SHOP_PAGE_PATH
                });
                setMessage({
                    text: data?.message ?? "Could not unlock. You need 1 ruby.",
                    error: true
                });
            }
        } catch  {
            (0, _frontendTrackingEvents.trackPurchaseFailed)({
                user_id: user?.userId,
                product_id: "profile_unlock_pack",
                product_type: "profile_unlock_pack",
                amount: UNLOCK_COST_RUBIES,
                currency: "RUBIES",
                error_type: "network_error",
                pathname: SHOP_PAGE_PATH
            });
            setMessage({
                text: "Something went wrong. Please try again.",
                error: true
            });
        } finally{
            setLoading(false);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
        className: "flex flex-col justify-center items-center gap-1 relative px-2 py-3 bg-white w-full min-w-[140px]",
        initial: false,
        animate: justUnlocked ? {
            scale: [
                1,
                1.08,
                1
            ],
            transition: {
                duration: 0.4,
                times: [
                    0,
                    0.5,
                    1
                ]
            }
        } : {
            scale: 1
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: `w-[40px] h-[40px] object-contain ${!alreadyUnlocked ? "opacity-60" : ""}`,
                src: "/assets/currency-ruby.png",
                alt: "",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: `font-anton text-[#1B062F] font-[400] text-[14px] text-center leading-tight ${!alreadyUnlocked ? "opacity-60" : ""}`,
                children: "Profile Unlock Pack"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: `font-chakra text-[#1B062F] text-[11px] text-center normal-case ${!alreadyUnlocked ? "opacity-60" : ""}`,
                children: "Unlock player name + avatar change"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `flex items-center justify-center gap-1 ${!alreadyUnlocked ? "opacity-60" : ""}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "font-chakra text-[#1B062F] text-[11px] normal-case",
                        children: [
                            "+",
                            UNLOCK_BONUS_COINS
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: "/img/coin_sm.png",
                        alt: "Coins bonus",
                        className: "w-[17px] h-[10px] object-contain"
                    })
                ]
            }),
            message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: `font-chakra text-[11px] text-center normal-case ${message.error ? "text-[#dc2626]" : "text-[#16a34a]"}`,
                children: message.text
            }),
            alreadyUnlocked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).button, {
                type: "button",
                onClick: ()=>{
                    window.dispatchEvent(new CustomEvent("closeShopDrawer"));
                    openOwnProfile({
                        openEdit: true
                    });
                },
                className: "font-anton uppercase text-[14px] flex items-center justify-center gap-1 bg-gray-400 w-[100px] h-[40px] text-[#1B062F] cursor-pointer",
                initial: justUnlocked ? {
                    scale: 0.5,
                    opacity: 0
                } : false,
                animate: {
                    scale: 1,
                    opacity: 1
                },
                transition: {
                    type: "spring",
                    stiffness: 400,
                    damping: 20
                },
                children: "UNLOCKED"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                onClick: handleUnlock,
                disabled: loading || !canAfford,
                className: `font-anton uppercase font-[400] text-[14px] flex flex-row items-center justify-center gap-1 whitespace-nowrap w-[100px] h-[40px] text-center disabled:cursor-not-allowed ${canAfford ? "bg-lime text-[#1B062F]" : "bg-gray-300 text-[#1B062F]"}`,
                children: loading ? "\u2026" : canAfford ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        "Unlock for ",
                        UNLOCK_COST_RUBIES,
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: "/assets/currency-ruby.png",
                            alt: "",
                            className: "w-4 h-4 object-contain inline-block",
                            "aria-hidden": true
                        })
                    ]
                }) : `Need ${UNLOCK_COST_RUBIES} ruby`
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","framer-motion":"fI0Q4","js-cookie":"2P5RE","../../Data/UserContext":"aqd8b","../Profile/ProfileGlobalModalContext":"eilDL","../../utils/authHeaders":"5Rczo","../../utils/sessionUser":"4xtMD","../../utils/frontendTrackingEvents":"4Y90p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eilDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useProfileGlobalModal", ()=>useProfileGlobalModal);
/**
 * Open a public profile after the current overlay unmounts *and* its dummy
 * `history.back()` has settled. Call, then close the overlay.
 *
 * Opening in the same turn as overlay release is popped by that back navigation.
 * Opening in `useEffect` after unmount is still too early — the popstate is async.
 */ parcelHelpers.export(exports, "useOpenPublicProfileAfterOverlayClose", ()=>useOpenPublicProfileAfterOverlayClose);
parcelHelpers.export(exports, "ProfileGlobalModalProvider", ()=>ProfileGlobalModalProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _framerMotion = require("framer-motion");
var _reactRouterDom = require("react-router-dom");
var _modalHistoryBack = require("../../utils/modalHistoryBack");
var _profileModalNavigation = require("../../utils/profileModalNavigation");
var _userContext = require("../../Data/UserContext");
var _profileLinkTracking = require("../../utils/profileLinkTracking");
var _authenticatedRoute = require("../AuthenticatedRoute");
var _authenticatedRouteDefault = parcelHelpers.interopDefault(_authenticatedRoute);
var _index = require("./index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _publicProfile = require("./PublicProfile");
var _publicProfileDefault = parcelHelpers.interopDefault(_publicProfile);
var _profileModalShell = require("./ProfileModalShell");
function profileModalTargetKey(t) {
    if (t.kind === "own") return "own";
    return `pub-${t.p ?? ""}-${t.u ?? ""}`;
}
const ProfileGlobalModalContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useProfileGlobalModal() {
    const ctx = (0, _react.useContext)(ProfileGlobalModalContext);
    if (!ctx) throw new Error("useProfileGlobalModal must be used within ProfileGlobalModalProvider");
    return ctx;
}
function useOpenPublicProfileAfterOverlayClose(overlayOpen) {
    const { openPublicProfile } = useProfileGlobalModal();
    const pendingRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (overlayOpen) return;
        const pending = pendingRef.current;
        if (!pending) return;
        return (0, _modalHistoryBack.whenModalHistoryIdle)(()=>{
            if (pendingRef.current !== pending) return;
            pendingRef.current = null;
            openPublicProfile(pending);
        });
    }, [
        overlayOpen,
        openPublicProfile
    ]);
    return (0, _react.useCallback)((opts)=>{
        pendingRef.current = {
            p: opts.p?.trim() || undefined,
            u: opts.u?.trim() || undefined
        };
    }, []);
}
function ProfileGlobalModalLayer({ target, onClose }) {
    const { user } = (0, _userContext.useUser)();
    const identifier = target && target.kind === "public" ? (target.p || target.u || "").trim() : "";
    const isOwnPublicLink = Boolean(target) && target.kind === "public" && Boolean(user && identifier) && (user.playerId === identifier || String(user.userId) === identifier || Boolean(user.username && user.username === identifier));
    let inner = null;
    if (target) {
        if (target.kind === "own" || target.kind === "public" && isOwnPublicLink) {
            // Skip AuthenticatedRoute when session is already ready — its loading shell
            // flashes an empty frame inside the modal on every open.
            const page = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault.default), {
                onClose: onClose,
                embedInGlobalModal: true
            });
            inner = user ? page : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authenticatedRouteDefault.default), {
                children: page
            });
        } else if (target.kind === "public" && identifier) inner = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _publicProfileDefault.default), {
            identifier: identifier,
            onClose: onClose
        });
    }
    const layer = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.AnimatePresence), {
        children: target && inner ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileModalShell.ProfileModalShell), {
            onClose: onClose,
            children: inner
        }, profileModalTargetKey(target)) : null
    });
    if (typeof document === "undefined") return layer;
    return /*#__PURE__*/ (0, _reactDom.createPortal)(layer, document.body);
}
function ProfileGlobalModalProvider({ children }) {
    const [targetStack, setTargetStack] = (0, _react.useState)([]);
    const target = targetStack.length > 0 ? targetStack[targetStack.length - 1] : null;
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const { user } = (0, _userContext.useUser)();
    /**
   * Pop dummy profile history entries. Only goes back while the *current* entry is
   * still a profile-modal push — otherwise `history.go(-N)` would leave the page.
   */ const popProfileModalHistory = (0, _react.useCallback)((depth, absorbOverlayPops)=>{
        if (typeof window === "undefined" || depth <= 0 || !window.history?.go) return;
        const state = window.history.state;
        if (!state?.__profileGlobalModal) return;
        const stateDepth = typeof state.__profileModalDepth === "number" && state.__profileModalDepth > 0 ? Math.trunc(state.__profileModalDepth) : 1;
        const goBy = Math.min(depth, stateDepth);
        if (goBy <= 0) return;
        // Only when opening another overlay after close — swallow these pops so the
        // next overlay's history entry is not dismissed by this go().
        if (absorbOverlayPops) (0, _modalHistoryBack.ignoreNextModalHistoryPops)(goBy);
        window.history.go(-goBy);
    }, []);
    const closeProfileModal = (0, _react.useCallback)(()=>{
        const depth = targetStack.length;
        setTargetStack([]);
        popProfileModalHistory(depth, false);
    }, [
        targetStack.length,
        popProfileModalHistory
    ]);
    const dismissProfileModalForNavigation = (0, _react.useCallback)(()=>{
        setTargetStack([]);
    }, []);
    const pushModalTarget = (0, _react.useCallback)((nextTarget)=>{
        // Keep pushState out of the setState updater — React may invoke updaters twice
        // in Strict Mode, which would stack duplicate history entries and make close
        // walk back past the current page.
        let nextDepth = 0;
        setTargetStack((prev)=>{
            const next = [
                ...prev,
                nextTarget
            ];
            nextDepth = next.length;
            return next;
        });
        if (typeof window !== "undefined" && window.history?.pushState && nextDepth > 0) window.history.pushState({
            ...(0, _modalHistoryBack.copyHistoryStateWithoutOverlayFlag)(window.history.state),
            __profileGlobalModal: true,
            __profileModalDepth: nextDepth
        }, "");
    }, []);
    (0, _react.useEffect)(()=>{
        const onClose = (ev)=>{
            const afterClose = ev.detail?.afterClose;
            const depth = targetStack.length;
            const openingNextOverlay = typeof afterClose === "function";
            setTargetStack([]);
            popProfileModalHistory(depth, openingNextOverlay);
            if (!openingNextOverlay) return;
            // `/profile` route also listens; let it invoke afterClose after it navigates away.
            if (depth <= 0) {
                if (typeof window !== "undefined" && window.location.pathname === "/profile") return;
                afterClose();
                return;
            }
            let done = false;
            const finish = ()=>{
                if (done) return;
                done = true;
                window.removeEventListener("popstate", onPop);
                window.clearTimeout(fallbackId);
                // Defer so peer popstate handlers finish before the next overlay pushState.
                window.setTimeout(afterClose, 0);
            };
            const onPop = ()=>finish();
            window.addEventListener("popstate", onPop);
            const fallbackId = window.setTimeout(finish, 150);
        };
        window.addEventListener("closeProfileModal", onClose);
        return ()=>window.removeEventListener("closeProfileModal", onClose);
    }, [
        popProfileModalHistory,
        targetStack.length
    ]);
    (0, _react.useEffect)(()=>{
        if (location.pathname === "/edit-profile" || location.pathname === "/xp-leaderboard") setTargetStack([]);
    }, [
        location.pathname
    ]);
    (0, _react.useEffect)(()=>{
        const onPopState = (ev)=>{
            setTargetStack((prev)=>{
                if (prev.length === 0) return prev;
                const rawDepth = ev.state?.__profileModalDepth;
                const depthFromState = typeof rawDepth === "number" ? Math.trunc(rawDepth) : null;
                const nextDepth = depthFromState != null ? Math.max(0, Math.min(prev.length, depthFromState)) : Math.max(0, prev.length - 1);
                return prev.slice(0, nextDepth);
            });
        };
        window.addEventListener("popstate", onPopState);
        return ()=>window.removeEventListener("popstate", onPopState);
    }, []);
    const openOwnProfile = (0, _react.useCallback)((opts)=>{
        if (opts?.openEdit) {
            setTargetStack([]);
            navigate("/edit-profile", {
                state: (0, _profileModalNavigation.profileModalBackgroundState)(location)
            });
            return;
        }
        pushModalTarget({
            kind: "own"
        });
    }, [
        navigate,
        location,
        pushModalTarget
    ]);
    (0, _react.useEffect)(()=>{
        if (location.pathname === "/edit-profile") return;
        let open = false;
        try {
            open = sessionStorage.getItem((0, _profileModalNavigation.OPEN_OWN_PROFILE_AFTER_EDIT_SAVE_STORAGE_KEY)) === "1";
            if (open) sessionStorage.removeItem((0, _profileModalNavigation.OPEN_OWN_PROFILE_AFTER_EDIT_SAVE_STORAGE_KEY));
        } catch  {
        /* ignore */ }
        if (!open) return;
        if (location.pathname === "/profile") return;
        openOwnProfile();
    }, [
        location.pathname,
        openOwnProfile
    ]);
    const openPublicProfile = (0, _react.useCallback)((opts)=>{
        pushModalTarget({
            kind: "public",
            p: opts.p?.trim() || undefined,
            u: opts.u?.trim() || undefined
        });
        (0, _profileLinkTracking.tryTrackProfileLinkJoinedFromModalOpen)({
            p: opts.p,
            u: opts.u,
            viewer: user,
            user_id: user?.userId,
            pathname: location.pathname
        });
    }, [
        pushModalTarget,
        user,
        location.pathname
    ]);
    const openProfileFromHref = (0, _react.useCallback)((href)=>{
        const parsed = (0, _profileModalNavigation.parseProfileHref)(href);
        if (!parsed) return;
        if (parsed.type === "own") {
            if (parsed.openEdit) {
                setTargetStack([]);
                navigate("/edit-profile", {
                    state: (0, _profileModalNavigation.profileModalBackgroundState)(location)
                });
            } else pushModalTarget({
                kind: "own"
            });
        } else {
            pushModalTarget({
                kind: "public",
                p: parsed.p,
                u: parsed.u
            });
            (0, _profileLinkTracking.tryTrackProfileLinkJoinedFromModalOpen)({
                p: parsed.p,
                u: parsed.u,
                viewer: user,
                user_id: user?.userId,
                pathname: location.pathname
            });
        }
    }, [
        navigate,
        location,
        pushModalTarget,
        user
    ]);
    const value = (0, _react.useMemo)(()=>({
            openOwnProfile,
            openPublicProfile,
            openProfileFromHref,
            closeProfileModal,
            dismissProfileModalForNavigation
        }), [
        openOwnProfile,
        openPublicProfile,
        openProfileFromHref,
        closeProfileModal,
        dismissProfileModalForNavigation
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ProfileGlobalModalContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileGlobalModalLayer, {
                target: target,
                onClose: closeProfileModal
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom":"b8T3j","framer-motion":"fI0Q4","react-router-dom":"l6ORY","../../utils/modalHistoryBack":"goswc","../../utils/profileModalNavigation":"eBA1i","../../Data/UserContext":"aqd8b","../../utils/profileLinkTracking":"kJy0k","../AuthenticatedRoute":"hm9Eh","./index":"gxSdn","./PublicProfile":"d7Q66","./ProfileModalShell":"iXuvs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eBA1i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OPEN_OWN_PROFILE_AFTER_EDIT_SAVE_STORAGE_KEY", ()=>OPEN_OWN_PROFILE_AFTER_EDIT_SAVE_STORAGE_KEY);
parcelHelpers.export(exports, "profileModalBackgroundState", ()=>profileModalBackgroundState);
/**
 * Close the global `/profile` modal (if open), then run `cb` after history has settled.
 * Prefer this over firing `closeProfileModal` and opening another overlay in the same turn.
 */ parcelHelpers.export(exports, "closeProfileModalThen", ()=>closeProfileModalThen);
parcelHelpers.export(exports, "isProfileHref", ()=>isProfileHref);
/** Parse `/profile` and query (p, u, edit). Used to open the global profile modal without routing. */ parcelHelpers.export(exports, "parseProfileHref", ()=>parseProfileHref);
const OPEN_OWN_PROFILE_AFTER_EDIT_SAVE_STORAGE_KEY = "c8_open_own_profile_after_edit_save";
function profileModalBackgroundState(location) {
    return {
        from: {
            pathname: location.pathname,
            search: location.search
        }
    };
}
function closeProfileModalThen(cb) {
    if (typeof window === "undefined") {
        cb();
        return;
    }
    window.dispatchEvent(new CustomEvent("closeProfileModal", {
        detail: {
            afterClose: cb
        }
    }));
}
function isProfileHref(href) {
    const path = href.split("?")[0] || "";
    return path === "/profile";
}
function parseProfileHref(href) {
    try {
        const pathOnly = href.split("?")[0] || "";
        if (pathOnly !== "/profile") return null;
        const qs = href.includes("?") ? href.slice(href.indexOf("?") + 1) : "";
        const params = new URLSearchParams(qs);
        const p = params.get("p")?.trim() || undefined;
        const u = params.get("u")?.trim() || undefined;
        const openEdit = params.get("edit") === "1";
        if (p || u) return {
            type: "public",
            p,
            u
        };
        return {
            type: "own",
            openEdit: openEdit || undefined
        };
    } catch  {
        return null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kJy0k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** `p` (player id) or legacy `u` (user id / username) from a shareable `/profile` URL. */ parcelHelpers.export(exports, "parsePublicProfileLinkSenderId", ()=>parsePublicProfileLinkSenderId);
parcelHelpers.export(exports, "isOwnPublicProfileLink", ()=>isOwnPublicProfileLink);
/**
 * Fire `profile_link_joined` once per tab per profile link (recipient opened a shared `/profile` URL).
 * Also persists referral for `signup_started` / `signup_completed` attribution.
 */ parcelHelpers.export(exports, "tryTrackProfileLinkJoined", ()=>tryTrackProfileLinkJoined);
/** In-app profile modal open (ProfileLink) — same event + dedupe as URL landing. */ parcelHelpers.export(exports, "tryTrackProfileLinkJoinedFromModalOpen", ()=>tryTrackProfileLinkJoinedFromModalOpen);
var _analyticsIdentity = require("./analyticsIdentity");
var _frontendTrackingEvents = require("./frontendTrackingEvents");
const DEDUPE_STORAGE_PREFIX = "c8_profile_link_joined:";
function parseSearchParams(search) {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    return new URLSearchParams(raw);
}
function normalizePathname(pathname) {
    const trimmed = (pathname || "/").trim();
    if (!trimmed || trimmed === "/") return "/";
    const withoutTrailing = trimmed.replace(/\/+$/, "");
    return withoutTrailing || "/";
}
function decodeBackParam(back) {
    let decoded = back.trim();
    if (!decoded) return null;
    try {
        decoded = decodeURIComponent(decoded);
    } catch  {
    /* use raw */ }
    const withSlash = decoded.startsWith("/") ? decoded : `/${decoded}`;
    const qIndex = withSlash.indexOf("?");
    if (qIndex === -1) return {
        pathname: normalizePathname(withSlash),
        search: ""
    };
    return {
        pathname: normalizePathname(withSlash.slice(0, qIndex)),
        search: withSlash.slice(qIndex)
    };
}
function parsePublicProfileLinkSenderId(pathname, search) {
    const path = normalizePathname(pathname);
    if (path !== "/profile") return null;
    const params = parseSearchParams(search);
    if (params.get("edit") === "1") return null;
    const p = params.get("p")?.trim();
    const u = params.get("u")?.trim();
    return p || u || null;
}
function resolvePublicProfileLinkTarget(pathname, search) {
    const senderId = parsePublicProfileLinkSenderId(pathname, search);
    if (senderId) return {
        pathname: normalizePathname(pathname),
        search
    };
    const back = parseSearchParams(search).get("back");
    if (!back) return null;
    const fromBack = decodeBackParam(back);
    if (!fromBack) return null;
    return parsePublicProfileLinkSenderId(fromBack.pathname, fromBack.search) ? fromBack : null;
}
function isOwnPublicProfileLink(senderId, user) {
    if (!senderId?.trim() || !user) return false;
    const sid = senderId.trim();
    const pid = (user.playerId ?? "").trim();
    if (pid && pid === sid) return true;
    if (user.userId != null && String(user.userId) === sid) return true;
    const uname = (user.username ?? "").trim();
    if (uname && uname === sid) return true;
    return false;
}
function buildProfileLinkDedupeKey(senderId) {
    return senderId.trim();
}
function hasTrackedProfileLinkJoin(dedupeKey) {
    try {
        return sessionStorage.getItem(`${DEDUPE_STORAGE_PREFIX}${dedupeKey}`) === "1";
    } catch  {
        return false;
    }
}
function markProfileLinkJoinTracked(dedupeKey) {
    try {
        sessionStorage.setItem(`${DEDUPE_STORAGE_PREFIX}${dedupeKey}`, "1");
    } catch  {
    /* ignore */ }
}
function tryTrackProfileLinkJoined({ pathname, search, user_id, viewer }) {
    const target = resolvePublicProfileLinkTarget(pathname, search);
    if (!target) return;
    const senderId = parsePublicProfileLinkSenderId(target.pathname, target.search);
    if (!senderId || isOwnPublicProfileLink(senderId, viewer)) return;
    const dedupeKey = buildProfileLinkDedupeKey(senderId);
    if (hasTrackedProfileLinkJoin(dedupeKey)) return;
    markProfileLinkJoinTracked(dedupeKey);
    (0, _frontendTrackingEvents.persistProfileReferralForSignup)(senderId);
    const uid = user_id ?? (0, _analyticsIdentity.getAnalyticsUserId)();
    (0, _frontendTrackingEvents.trackProfileLinkJoined)({
        user_id: uid != null && String(uid).trim() !== "" ? uid : undefined,
        sender_user_id: senderId,
        invite_method: "link",
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/profile")
    });
}
function tryTrackProfileLinkJoinedFromModalOpen({ p, u, viewer, user_id, pathname }) {
    const senderId = (p || u || "").trim();
    if (!senderId || isOwnPublicProfileLink(senderId, viewer)) return;
    const dedupeKey = buildProfileLinkDedupeKey(senderId);
    if (hasTrackedProfileLinkJoin(dedupeKey)) return;
    markProfileLinkJoinTracked(dedupeKey);
    (0, _frontendTrackingEvents.persistProfileReferralForSignup)(senderId);
    const uid = user_id ?? (0, _analyticsIdentity.getAnalyticsUserId)();
    (0, _frontendTrackingEvents.trackProfileLinkJoined)({
        user_id: uid != null && String(uid).trim() !== "" ? uid : undefined,
        sender_user_id: senderId,
        invite_method: "link",
        pathname: pathname || (typeof window !== "undefined" ? window.location.pathname : "/")
    });
}

},{"./analyticsIdentity":"10oOL","./frontendTrackingEvents":"4Y90p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gxSdn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ProfilePage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _framerMotion = require("framer-motion");
var _reactRouterDom = require("react-router-dom");
var _profileAvatar = require("./ProfileAvatar");
var _userAvatar = require("./UserAvatar");
var _profileLink = require("./ProfileLink");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _userContext = require("../../Data/UserContext");
var _authHeaders = require("../../utils/authHeaders");
var _profileAvatarCatalog = require("../../utils/profileAvatarCatalog");
var _sessionUser = require("../../utils/sessionUser");
var _profileModalNavigation = require("../../utils/profileModalNavigation");
var _myZoneOnboardingMilestones = require("../../utils/myZoneOnboardingMilestones");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _shareCopy = require("../../utils/shareCopy");
var _useSocialSyncRefresh = require("../../hooks/useSocialSyncRefresh");
var _traderDataFetcherContext = require("../../Data/TraderDataFetcherContext");
var _friendActivityTimeline = require("../MyZone/FriendActivityTimeline");
var _friendActivityTimelineDefault = parcelHelpers.interopDefault(_friendActivityTimeline);
var _profileCountryCombobox = require("./ProfileCountryCombobox");
var _profileFavouritesStrip = require("./ProfileFavouritesStrip");
var _careerStatsStack = require("./CareerStatsStack");
var _logo = require("../Logo/Logo");
var _profileUnlockBanner = require("./ProfileUnlockBanner");
var _avatarChooserModal = require("./AvatarChooserModal");
var _xpHubModal = require("../Xp/XpHubModal");
var _profileFavouriteSportsGrid = require("./ProfileFavouriteSportsGrid");
var _profileFavouriteFootballGrid = require("./ProfileFavouriteFootballGrid");
var _profileFavouriteCricketTeamsGrid = require("./ProfileFavouriteCricketTeamsGrid");
var _profileFavouriteCricketersGrid = require("./ProfileFavouriteCricketersGrid");
var _profileFavSportIcons = require("./profileFavSportIcons");
var _profileFavFootballTeams = require("./profileFavFootballTeams");
var _profileFavIplTeams = require("./profileFavIplTeams");
var _profileFavCricketIntTeams = require("./profileFavCricketIntTeams");
var _favouriteTeams = require("../../utils/favouriteTeams");
var _cricketTeamCanonical = require("../../utils/cricketTeamCanonical");
var _useFavouriteTeams = require("../../Data/useFavouriteTeams");
var _friendDisplayName = require("../../utils/friendDisplayName");
var _profileNameStack = require("./ProfileNameStack");
var _profileFavCricketers = require("./profileFavCricketers");
var _modalCloseIcon = require("../ModalCloseIcon");
var _careerSummary = require("./careerSummary");
var _profileCountryFlag = require("../../utils/profileCountryFlag");
var _nativeShare = require("../../utils/nativeShare");
function openShopDrawer() {
    if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent("openShopDrawer"));
}
/** Background for edit-profile inputs and selects. */ const profileEditFieldBgClass = "bg-[#4f2189]";
/** Label + control + unlock rail in one row; inputs sit directly beside labels (flex-1 fills the rest). */ const profileEditFormRowFlexClass = "flex h-[50px] min-h-[50px] max-h-[50px] w-full min-w-0 flex-nowrap items-center gap-1.5";
const profileEditFormMiddleCellClass = "flex min-w-0 flex-1 items-center overflow-hidden";
const profileEditFormLabelCellClass = "shrink-0 self-center";
const profileEditFormLabelNowrapClass = "whitespace-nowrap";
/** Align Player name / Name / Avatar / Country fields: equal label column width. */ const profileEditFormTopFieldLabelMinClass = "min-w-[5.5rem]";
const profileEditFormRailCellClass = "flex h-[50px] w-[43px] min-w-[43px] max-w-[43px] shrink-0 items-center justify-end";
/** Player name / Name / Avatar / Country row labels (edit profile). */ const profileEditRowLabelClass = "font-anton text-[15px] font-normal not-italic uppercase leading-[12px] tracking-normal text-white [leading-trim:none]";
/** Player name / Name fields (edit profile) — Chakra Petch 12px / 16px line-height; 16px on mobile avoids iOS focus zoom. */ const profileEditUsernameInputClass = "font-chakra text-[16px] font-normal not-italic leading-[16px] tracking-normal [leading-trim:none] md:text-[12px]";
/** Cancel control (edit profile header) — Chakra Petch 11px / 14px mobile; 16px / 14px desktop. */ const profileEditCancelButtonClass = "font-chakra text-[11px] font-normal not-italic leading-[14px] tracking-normal text-right [leading-trim:none] md:text-[16px]";
/** Compact Unlock CTA beside username (edit profile) — Anton 12px / 12px line-height. */ const profileEditUsernameUnlockButtonClass = "inline-flex h-[21px] w-[43px] shrink-0 items-center justify-center overflow-hidden whitespace-nowrap bg-[#d2ff00] p-0 font-anton text-[12px] font-normal uppercase leading-[12px] tracking-normal text-[#1b062f] [leading-trim:none] hover:brightness-95";
/** API `error` values for /account/update that belong under the player name field. */ function isPlayerNameFieldApiError(data) {
    const code = data?.error;
    if (typeof code !== "string") return false;
    return code === "name_taken" || code === "player_name_taken" || code === "username exists" || code === "invalid_name" || code === "name_not_allowed" || code === "player_name_invalid" || code === "player_name_blocked" || code === "player_name_country" || code === "player_name_edit_locked" || code === "feature_disabled";
}
/** API `error` values that belong under the Name (display_name) field. */ function isDisplayNameFieldApiError(data) {
    const code = data?.error;
    if (typeof code !== "string") return false;
    return code === "display_name_invalid" || code === "display_name_blocked" || code === "display_name_edit_locked";
}
function isUsernameAlreadyTakenApiError(data) {
    const code = data?.error;
    return code === "name_taken" || code === "player_name_taken" || code === "username exists";
}
const PLAYER_NAME_ALREADY_TAKEN_MESSAGE = "That player name is already in use.";
function ProfilePage(props) {
    const { onClose, embedInGlobalModal = false, initialOpenEdit = false, editPageMode = false, onLeaveEditPage } = props ?? {};
    const { user, setUser } = (0, _userContext.useUser)();
    const { fetchMyGamesOverview } = (0, _traderDataFetcherContext.useTraderDataFetcher)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const [searchParams, setSearchParams] = (0, _reactRouterDom.useSearchParams)();
    const [careerSummary, setCareerSummary] = (0, _react.useState)(null);
    const [friendsStrip, setFriendsStrip] = (0, _react.useState)([]);
    const [ownActivityDigests, setOwnActivityDigests] = (0, _react.useState)([]);
    const [ownActivityLiveFriends, setOwnActivityLiveFriends] = (0, _react.useState)([]);
    const [ownActivityMyTrades, setOwnActivityMyTrades] = (0, _react.useState)([]);
    const [ownActivityMySquares, setOwnActivityMySquares] = (0, _react.useState)([]);
    const [ownActivityLoading, setOwnActivityLoading] = (0, _react.useState)(false);
    const [ownActivityLoadingMore, setOwnActivityLoadingMore] = (0, _react.useState)(false);
    const [ownActivityHasMore, setOwnActivityHasMore] = (0, _react.useState)(false);
    const [ownActivityResultsLimit, setOwnActivityResultsLimit] = (0, _react.useState)(10);
    const [ownActivityRefreshTick, setOwnActivityRefreshTick] = (0, _react.useState)(0);
    const [inviteCopied, setInviteCopied] = (0, _react.useState)(false);
    const [isEditing, setIsEditing] = (0, _react.useState)(()=>editPageMode);
    const [editCountry, setEditCountry] = (0, _react.useState)("");
    const [editFavSports, setEditFavSports] = (0, _react.useState)([]);
    const [editFavFootballSlugs, setEditFavFootballSlugs] = (0, _react.useState)([]);
    const [editFavIplSlugs, setEditFavIplSlugs] = (0, _react.useState)([]);
    const [editFavCricketIntSlugs, setEditFavCricketIntSlugs] = (0, _react.useState)([]);
    const [editFavCricketerSlugs, setEditFavCricketerSlugs] = (0, _react.useState)([]);
    const [editPlayerName, setEditPlayerName] = (0, _react.useState)("");
    const [editPlayerNameError, setEditPlayerNameError] = (0, _react.useState)(null);
    const [editDisplayName, setEditDisplayName] = (0, _react.useState)("");
    const [editDisplayNameError, setEditDisplayNameError] = (0, _react.useState)(null);
    const [saveFeedback, setSaveFeedback] = (0, _react.useState)(null);
    const [saving, setSaving] = (0, _react.useState)(false);
    const [stripAvatarOptions, setStripAvatarOptions] = (0, _react.useState)((0, _profileAvatarCatalog.FALLBACK_AVATAR_OPTIONS));
    const [avatarChooserOpen, setAvatarChooserOpen] = (0, _react.useState)(false);
    const [xpHubOpen, setXpHubOpen] = (0, _react.useState)(false);
    const [avatarChooserInitialKey, setAvatarChooserInitialKey] = (0, _react.useState)(undefined);
    const justUnlockedProfileTimeoutRef = (0, _react.useRef)(null);
    const editFormScrollRef = (0, _react.useRef)(null);
    const [justUnlockedProfile, setJustUnlockedProfile] = (0, _react.useState)(false);
    const { clubExtras, intExtras, toggle: toggleFavouriteTeam } = (0, _useFavouriteTeams.useFavouriteTeams)();
    const sessionToken = (0, _jsCookieDefault.default).get("c8_session_token");
    const animalPreviewAvatars = (0, _react.useMemo)(()=>{
        if (user?.allow_player_name_edit) return [];
        return (0, _profileAvatarCatalog.getAnimalPreviewAvatars)(stripAvatarOptions);
    }, [
        stripAvatarOptions,
        user?.allow_player_name_edit
    ]);
    /** Own profile header only — not shown on public profiles. */ const ownProfileHeroCountryFlag = (0, _react.useMemo)(()=>(0, _profileCountryFlag.getProfileCountryFlagEmoji)(user?.country), [
        user?.country
    ]);
    (0, _react.useEffect)(()=>{
        if (!isEditing) return;
        let cancelled = false;
        (async ()=>{
            try {
                const cached = sessionStorage.getItem((0, _profileAvatarCatalog.AVATAR_OPTIONS_CACHE_KEY));
                if (cached) {
                    const parsed = JSON.parse(cached);
                    if (Array.isArray(parsed) && parsed.length > 0 && !cancelled) setStripAvatarOptions(parsed);
                }
            } catch  {
            // ignore
            }
            try {
                const res = await fetch(`${"https://cricket8.com/api"}/account/avatars`, {
                    method: "GET",
                    headers: (0, _authHeaders.getAuthHeaders)()
                });
                if (!res.ok || cancelled) return;
                const data = await res.json().catch(()=>({}));
                if (Array.isArray(data?.avatars) && data.avatars.length > 0) {
                    setStripAvatarOptions(data.avatars);
                    try {
                        sessionStorage.setItem((0, _profileAvatarCatalog.AVATAR_OPTIONS_CACHE_KEY), JSON.stringify(data.avatars));
                    } catch  {
                    // ignore
                    }
                }
            } catch  {
            // keep fallback
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        isEditing
    ]);
    (0, _react.useEffect)(()=>{
        if (editPageMode) {
            setIsEditing(true);
            return;
        }
        if (embedInGlobalModal) {
            if (initialOpenEdit) setIsEditing(true);
            return;
        }
        if (searchParams.get("edit") === "1") setIsEditing(true);
    }, [
        searchParams,
        embedInGlobalModal,
        initialOpenEdit,
        editPageMode
    ]);
    const didInitEditFormRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (isEditing && user) {
            if (!didInitEditFormRef.current) {
                didInitEditFormRef.current = true;
                setEditCountry((0, _profileCountryFlag.countryToSelectValue)(user.country));
                setEditFavSports((0, _profileFavSportIcons.parseFavSportsFromStorage)(user.favourites?.favsports));
                setEditFavFootballSlugs((0, _profileFavFootballTeams.parseFavFootballFromStorage)(user.favourites?.favfootballteams));
                setEditFavIplSlugs((0, _profileFavIplTeams.parseFavIplFromStorage)(user.favourites?.faviplteams));
                setEditFavCricketIntSlugs((0, _profileFavCricketIntTeams.parseFavCricketIntFromStorage)(user.favourites?.favnationalteams));
                setEditFavCricketerSlugs((0, _profileFavCricketers.parseFavCricketersFromStorage)(user.favourites?.favcricketers));
                setEditPlayerName(user.player_name?.trim() || user.username?.trim() || "");
                // display_name stays empty by default; friends UI falls back to player_name until set.
                setEditDisplayName(user.display_name?.trim() || "");
                setEditDisplayNameError(null);
            }
        } else didInitEditFormRef.current = false;
    }, [
        isEditing,
        user
    ]);
    // After Profile Unlock Pack purchase: celebrate on profile header (name + avatar), not Account
    (0, _react.useEffect)(()=>{
        if (user?.allow_player_name_edit === true) {
            if (sessionStorage.getItem("c8_just_unlocked_player_name") === "1") {
                sessionStorage.removeItem("c8_just_unlocked_player_name");
                setJustUnlockedProfile(true);
                if (justUnlockedProfileTimeoutRef.current) clearTimeout(justUnlockedProfileTimeoutRef.current);
                justUnlockedProfileTimeoutRef.current = setTimeout(()=>setJustUnlockedProfile(false), 1200);
            }
        }
    }, [
        user?.allow_player_name_edit
    ]);
    (0, _react.useEffect)(()=>{
        const handleRunProfileUnlockAnimation = ()=>{
            if (sessionStorage.getItem("c8_just_unlocked_player_name") !== "1") return;
            if (!user?.allow_player_name_edit) return;
            sessionStorage.removeItem("c8_just_unlocked_player_name");
            setJustUnlockedProfile(true);
            if (justUnlockedProfileTimeoutRef.current) clearTimeout(justUnlockedProfileTimeoutRef.current);
            justUnlockedProfileTimeoutRef.current = setTimeout(()=>setJustUnlockedProfile(false), 1200);
        };
        window.addEventListener("runProfileUnlockAnimation", handleRunProfileUnlockAnimation);
        return ()=>{
            window.removeEventListener("runProfileUnlockAnimation", handleRunProfileUnlockAnimation);
            if (justUnlockedProfileTimeoutRef.current) clearTimeout(justUnlockedProfileTimeoutRef.current);
        };
    }, [
        user?.allow_player_name_edit
    ]);
    const fetchCareerSummary = (0, _react.useCallback)(async ()=>{
        if (!sessionToken) return;
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/career-summary`, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            if (res.ok) {
                const data = await res.json();
                const parsed = (0, _careerSummary.parseCareerSummaryPayload)(data);
                setCareerSummary(parsed);
                if (parsed.xp) window.dispatchEvent(new CustomEvent("c8-xp-updated", {
                    detail: parsed.xp
                }));
            } else setCareerSummary((0, _careerSummary.fallbackCareerSummaryZeros)());
        } catch  {
            setCareerSummary((0, _careerSummary.fallbackCareerSummaryZeros)());
        }
    }, [
        sessionToken
    ]);
    const refreshFriendsStrip = (0, _react.useCallback)(async ()=>{
        if (!user) return;
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/friends`, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            if (!res.ok) return;
            const data = await res.json();
            if (data?.friends) setFriendsStrip(data.friends.slice(0, 12));
        } catch  {
        // keep previous strip
        }
    }, [
        user
    ]);
    (0, _react.useEffect)(()=>{
        fetchCareerSummary();
    }, [
        fetchCareerSummary
    ]);
    (0, _react.useEffect)(()=>{
        refreshFriendsStrip();
    }, [
        refreshFriendsStrip
    ]);
    (0, _react.useEffect)(()=>{
        const viewerId = user?.userId != null ? Number(user.userId) : null;
        if (viewerId == null) {
            setOwnActivityDigests([]);
            setOwnActivityLiveFriends([]);
            setOwnActivityMyTrades([]);
            setOwnActivityMySquares([]);
            setOwnActivityHasMore(false);
            setOwnActivityLoadingMore(false);
            setOwnActivityLoading(false);
            return;
        }
        let cancelled = false;
        const hasExistingOwnActivity = ownActivityDigests.length > 0 || ownActivityLiveFriends.length > 0 || ownActivityMyTrades.length > 0 || ownActivityMySquares.length > 0;
        if (!hasExistingOwnActivity) setOwnActivityLoading(true);
        else setOwnActivityLoadingMore(true);
        const actUrl = `${"https://cricket8.com/api"}/account/friends-activity?${new URLSearchParams({
            friend_id: String(viewerId),
            results_limit: String(ownActivityResultsLimit)
        })}`;
        Promise.all([
            fetch(actUrl, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            }),
            sessionToken ? fetchMyGamesOverview() : Promise.resolve(null)
        ]).then(async ([actRes, myGamesPayload])=>{
            if (cancelled) return;
            if (actRes.ok) {
                const data = await actRes.json();
                setOwnActivityDigests((0, _friendActivityTimeline.mapDigestRows)(data));
                setOwnActivityHasMore(Boolean(data.has_more));
                const lf = data.live_friend;
                if (lf && typeof lf === "object" && lf.userId != null) setOwnActivityLiveFriends([
                    lf
                ]);
                else setOwnActivityLiveFriends([]);
            } else {
                setOwnActivityDigests([]);
                setOwnActivityLiveFriends([]);
            }
            if (myGamesPayload?.active) {
                setOwnActivityMyTrades(Array.isArray(myGamesPayload.active.trades) ? myGamesPayload.active.trades : []);
                setOwnActivityMySquares(Array.isArray(myGamesPayload.active.squares) ? myGamesPayload.active.squares : []);
            } else {
                setOwnActivityMyTrades([]);
                setOwnActivityMySquares([]);
            }
            if (!cancelled) {
                setOwnActivityLoading(false);
                setOwnActivityLoadingMore(false);
            }
        }).catch(()=>{
            if (!cancelled) {
                setOwnActivityDigests([]);
                setOwnActivityLiveFriends([]);
                setOwnActivityMyTrades([]);
                setOwnActivityMySquares([]);
                setOwnActivityHasMore(false);
                setOwnActivityLoading(false);
                setOwnActivityLoadingMore(false);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        fetchMyGamesOverview,
        ownActivityRefreshTick,
        sessionToken,
        user?.userId,
        ownActivityResultsLimit,
        ownActivityDigests.length,
        ownActivityLiveFriends.length,
        ownActivityMyTrades.length,
        ownActivityMySquares.length
    ]);
    (0, _useSocialSyncRefresh.useDebouncedWindowEvents)([
        "c8-activity-updated",
        "c8-my-games-dirty",
        "c8-friends-dirty",
        "c8-profile-dirty",
        "c8-notifications-updated"
    ], ()=>{
        setOwnActivityRefreshTick((n)=>n + 1);
    }, 450, Boolean(user?.userId));
    (0, _useSocialSyncRefresh.useVisibleStaleFallback)(()=>setOwnActivityRefreshTick((n)=>n + 1), Boolean(user?.userId));
    /** Career: SSE + wallet/games signals (avoid c8-notifications-updated — too chatty). */ (0, _useSocialSyncRefresh.useDebouncedWindowEvents)([
        "c8-profile-dirty",
        "walletUpdate",
        "gamesCountUpdated",
        "gamesCountUpdate",
        "c8-my-games-dirty"
    ], ()=>{
        fetchCareerSummary();
    }, 600, Boolean(sessionToken));
    (0, _useSocialSyncRefresh.useVisibleStaleFallback)(()=>fetchCareerSummary(), Boolean(sessionToken));
    /** Friends strip: friend-graph changes from notification SSE → Header. */ (0, _useSocialSyncRefresh.useDebouncedWindowEvents)([
        "c8-friends-dirty",
        "c8-activity-updated"
    ], ()=>{
        refreshFriendsStrip();
    }, 750, Boolean(user));
    (0, _useSocialSyncRefresh.useVisibleStaleFallback)(()=>void refreshFriendsStrip(), Boolean(user));
    (0, _react.useEffect)(()=>{
        document.title = "Player profile | Cricket8";
        return ()=>{
            document.title = "Cricket8";
        };
    }, []);
    if (!user) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "min-h-[60vh] flex items-center justify-center px-4",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "text-white/80 text-center",
            children: "Sign in to view your profile."
        })
    });
    const games = Array.isArray(user.games) ? user.games : [];
    const coins = user.wallet?.coins ?? 0;
    const rubies = user.wallet?.rubies ?? 0;
    const xpTotal = user.wallet?.xp ?? careerSummary?.xp?.total_xp ?? 0;
    const favourites = user.favourites ?? null;
    const playerId = (user.playerId ?? user.player_id)?.trim() || undefined;
    const senderUserId = playerId ?? (user.userId != null ? String(user.userId) : undefined);
    const inviteUrl = typeof window !== "undefined" && user.userId ? playerId ? `${window.location.origin}/profile?p=${encodeURIComponent(playerId)}` : `${window.location.origin}/profile?u=${encodeURIComponent(String(user.userId))}` : "";
    const inviteUrlDisplay = inviteUrl.replace(/^https?:\/\//i, "");
    const handleCopyInvite = (0, _react.useCallback)(()=>{
        if (!inviteUrl) return;
        (0, _frontendTrackingEvents.trackCtaClicked)({
            user_id: user?.userId,
            cta_name: "copy_profile_link",
            cta_location: "profile",
            target_url: inviteUrl,
            source_page: location.pathname,
            pathname: location.pathname
        });
        (0, _frontendTrackingEvents.trackInviteFlowOpened)({
            user_id: user?.userId,
            entry_point: "profile_invite",
            pathname: location.pathname
        });
        const onCopied = ()=>{
            (0, _frontendTrackingEvents.trackProfileLinkShared)({
                user_id: user?.userId,
                invite_method: "link",
                sender_user_id: senderUserId,
                pathname: location.pathname
            });
            if (user?.userId != null) (0, _myZoneOnboardingMilestones.markMyZoneOnboardingMilestone)(user.userId, "invite");
            setInviteCopied(true);
            setTimeout(()=>setInviteCopied(false), 2000);
        };
        const clipboard = typeof navigator !== "undefined" ? navigator.clipboard : undefined;
        if (clipboard?.writeText) clipboard.writeText(inviteUrl).then(onCopied, onCopied);
        else onCopied();
    }, [
        inviteUrl,
        senderUserId,
        user?.userId,
        location.pathname
    ]);
    const inviteShareDisplayName = String(user.player_name ?? user.username ?? "").trim() || undefined;
    const handleShareInvite = (0, _react.useCallback)(()=>{
        if (!inviteUrl || !navigator.share) return;
        (0, _frontendTrackingEvents.trackCtaClicked)({
            user_id: user?.userId,
            cta_name: "share_profile",
            cta_location: "profile",
            target_url: inviteUrl,
            source_page: location.pathname,
            pathname: location.pathname
        });
        (0, _frontendTrackingEvents.trackInviteFlowOpened)({
            user_id: user?.userId,
            entry_point: "profile_invite",
            pathname: location.pathname
        });
        navigator.share((0, _nativeShare.nativeShareData)((0, _shareCopy.buildProfileInviteShareText)(inviteShareDisplayName), inviteUrl, (0, _shareCopy.buildProfileInviteShareTitle)(inviteShareDisplayName))).then(()=>{
            (0, _frontendTrackingEvents.trackProfileLinkShared)({
                user_id: user?.userId,
                invite_method: "share_sheet",
                sender_user_id: senderUserId,
                pathname: location.pathname
            });
            if (user?.userId != null) (0, _myZoneOnboardingMilestones.markMyZoneOnboardingMilestone)(user.userId, "invite");
        }).catch(()=>{});
    }, [
        inviteShareDisplayName,
        inviteUrl,
        senderUserId,
        user?.userId,
        location.pathname
    ]);
    const handleStartEdit = (0, _react.useCallback)(()=>{
        if (editPageMode) return;
        navigate("/edit-profile", {
            state: (0, _profileModalNavigation.profileModalBackgroundState)(location)
        });
    }, [
        editPageMode,
        navigate,
        location
    ]);
    const handleCancelEdit = (0, _react.useCallback)(()=>{
        setSaveFeedback(null);
        setEditPlayerNameError(null);
        if (editPageMode) {
            onLeaveEditPage?.();
            return;
        }
        setIsEditing(false);
        if (embedInGlobalModal) return;
        setSearchParams((prev)=>{
            const next = new URLSearchParams(prev);
            next.delete("edit");
            return next.toString() ? next : {};
        });
    }, [
        editPageMode,
        onLeaveEditPage,
        embedInGlobalModal,
        setSearchParams
    ]);
    const leaveEditPageAfterSave = (0, _react.useCallback)(()=>{
        if (editPageMode) onLeaveEditPage?.({
            openOwnProfileModal: true
        });
    }, [
        editPageMode,
        onLeaveEditPage
    ]);
    /** Mobile save is in a sticky footer; scroll the form panel so the failing field/message is visible. */ (0, _react.useEffect)(()=>{
        if (!isEditing) return;
        const target = editPlayerNameError ? document.getElementById("profile-edit-player-name") : editDisplayNameError ? document.getElementById("profile-edit-display-name") : saveFeedback?.error ? document.getElementById("profile-edit-save-feedback") : null;
        if (!target) return;
        const frame = requestAnimationFrame(()=>{
            const scrollParent = editFormScrollRef.current;
            if (scrollParent) {
                const targetRect = target.getBoundingClientRect();
                const parentRect = scrollParent.getBoundingClientRect();
                const delta = targetRect.top - parentRect.top - (parentRect.height - targetRect.height) / 2;
                scrollParent.scrollBy({
                    top: delta,
                    behavior: "smooth"
                });
            } else target.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            if ((editPlayerNameError || editDisplayNameError) && target instanceof HTMLInputElement) target.focus({
                preventScroll: true
            });
        });
        return ()=>cancelAnimationFrame(frame);
    }, [
        editPlayerNameError,
        editDisplayNameError,
        saveFeedback,
        isEditing
    ]);
    const handleSaveProfile = (0, _react.useCallback)(async ()=>{
        if (!user || !sessionToken || saving) return;
        setSaving(true);
        setSaveFeedback(null);
        setEditPlayerNameError(null);
        setEditDisplayNameError(null);
        const servicecomms = user.servicecomms ?? true;
        let clearSavingInFinally = true;
        try {
            const trimmedPlayerName = editPlayerName.trim();
            const trimmedDisplayName = editDisplayName.trim().replace(/\s+/g, " ");
            const handleFallback = trimmedPlayerName || user.player_name?.trim() || user.username?.trim() || "";
            // Store null when empty or still equal to the handle — UI falls back to player_name.
            const displayNameToSave = !trimmedDisplayName || trimmedDisplayName.toLowerCase() === handleFallback.toLowerCase() ? "" : trimmedDisplayName;
            const res = await fetch(`${"https://cricket8.com/api"}/account/update`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    username: user.username,
                    email: user.email,
                    phone: user.phone ?? "",
                    usersession: sessionToken,
                    marketing: user.marketing ?? false,
                    servicecomms,
                    country: editCountry || undefined,
                    favsports: (0, _profileFavSportIcons.serializeFavSportsToStorage)(editFavSports),
                    favfootballteams: (0, _profileFavFootballTeams.serializeFavFootballToStorage)(editFavFootballSlugs),
                    faviplteams: (0, _profileFavIplTeams.serializeFavIplToStorage)(editFavIplSlugs),
                    favnationalteams: (0, _profileFavCricketIntTeams.serializeFavCricketIntToStorage)(editFavCricketIntSlugs),
                    favcricketers: (0, _profileFavCricketers.serializeFavCricketersToStorage)(editFavCricketerSlugs),
                    ...user.allow_player_name_edit && {
                        player_name: trimmedPlayerName || undefined,
                        display_name: displayNameToSave
                    }
                })
            });
            const data = await res.json().catch(()=>({}));
            if (res.ok && !data.error) {
                const favSportsCount = Array.isArray(editFavSports) ? editFavSports.length : 0;
                const favCricketPlayersCount = Array.isArray(editFavCricketerSlugs) ? editFavCricketerSlugs.length : 0;
                const favFootballCount = Array.isArray(editFavFootballSlugs) ? editFavFootballSlugs.length : 0;
                const favIplCount = Array.isArray(editFavIplSlugs) ? editFavIplSlugs.length : 0;
                const favCricketIntCount = Array.isArray(editFavCricketIntSlugs) ? editFavCricketIntSlugs.length : 0;
                const updatedFields = [];
                if (editCountry) updatedFields.push("country");
                if (favSportsCount > 0) updatedFields.push("favorite_sports");
                if (favCricketPlayersCount > 0) updatedFields.push("favorite_cricket_players");
                if (favIplCount > 0 || favCricketIntCount > 0) updatedFields.push("favorite_cricket_teams");
                if (favFootballCount > 0) updatedFields.push("favorite_football_teams");
                if (user.allow_player_name_edit && trimmedPlayerName) updatedFields.push("player_name");
                if (user.allow_player_name_edit && displayNameToSave) updatedFields.push("display_name");
                (0, _frontendTrackingEvents.trackProfileUpdated)({
                    user_id: user.userId,
                    updated_fields: updatedFields,
                    country: editCountry || undefined,
                    favorite_sports_count: favSportsCount,
                    favorite_cricket_players_count: favCricketPlayersCount,
                    favorite_teams_count: favFootballCount + favIplCount + favCricketIntCount
                });
                const verifyUrl = (0, _authHeaders.getVerifySessionUrl)();
                let refreshedUser = null;
                if (verifyUrl) {
                    const verifyRes = await fetch(verifyUrl, {
                        method: "GET",
                        headers: (0, _authHeaders.getAuthHeaders)()
                    });
                    if (verifyRes.ok) {
                        const updated = await verifyRes.json();
                        refreshedUser = (0, _sessionUser.normalizeSessionPayload)(updated);
                    }
                }
                if (refreshedUser) {
                    const nextUser = refreshedUser;
                    setUser((prev)=>{
                        if (!prev) return nextUser;
                        const nextSrc = (0, _sessionUser.resolveAvatarUrl)(nextUser);
                        const prevSrc = (0, _sessionUser.resolveAvatarUrl)(prev);
                        if (nextSrc) return nextUser;
                        if (prevSrc) return {
                            ...nextUser,
                            avatar: prev.avatar,
                            avatar_url: prev.avatar_url ?? nextUser.avatar_url ?? null,
                            original_avatar: nextUser.original_avatar ?? prev.original_avatar ?? null,
                            avatar_key: nextUser.avatar_key ?? prev.avatar_key ?? null
                        };
                        return nextUser;
                    });
                    if (user.userId != null) (0, _myZoneOnboardingMilestones.markMyZoneOnboardingMilestone)(user.userId, "profile");
                }
                if (editPageMode) {
                    clearSavingInFinally = false;
                    setSaving(false);
                    leaveEditPageAfterSave();
                    return;
                }
                setSaveFeedback({
                    message: data.message || "Profile updated!"
                });
                setTimeout(()=>{
                    setSaveFeedback(null);
                    setIsEditing(false);
                    if (!embedInGlobalModal) setSearchParams((prev)=>{
                        const next = new URLSearchParams(prev);
                        next.delete("edit");
                        return next.toString() ? next : {};
                    });
                }, 1500);
            } else {
                const msg = typeof data.message === "string" && data.message.trim() || "Something went wrong.";
                if (isDisplayNameFieldApiError(data)) setEditDisplayNameError(msg);
                else if (isPlayerNameFieldApiError(data)) setEditPlayerNameError(isUsernameAlreadyTakenApiError(data) ? PLAYER_NAME_ALREADY_TAKEN_MESSAGE : msg);
                else setSaveFeedback({
                    message: msg,
                    error: true
                });
            }
        } catch  {
            setSaveFeedback({
                message: "Something went wrong.",
                error: true
            });
        } finally{
            if (clearSavingInFinally) setSaving(false);
        }
    }, [
        user,
        sessionToken,
        saving,
        editCountry,
        editFavSports,
        editFavFootballSlugs,
        editFavIplSlugs,
        editFavCricketIntSlugs,
        editFavCricketerSlugs,
        editPlayerName,
        editDisplayName,
        setUser,
        setSearchParams,
        embedInGlobalModal,
        editPageMode,
        leaveEditPageAfterSave
    ]);
    const [hasAvatarFrames, setHasAvatarFrames] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (!user?.userId || user.allow_player_name_edit) return undefined;
        let cancelled = false;
        fetch(`${"https://cricket8.com/api"}/account/avatar-frames`, {
            headers: (0, _authHeaders.getAuthHeaders)()
        }).then((res)=>res.ok ? res.json() : null).then((data)=>{
            if (!cancelled) setHasAvatarFrames(Array.isArray(data?.frames) && data.frames.length > 0 || Array.isArray(data?.shopFrames) && data.shopFrames.length > 0);
        }).catch(()=>{});
        return ()=>{
            cancelled = true;
        };
    }, [
        user?.userId,
        user?.allow_player_name_edit
    ]);
    const openAvatarChooser = (0, _react.useCallback)((presetKey)=>{
        setAvatarChooserInitialKey(presetKey !== undefined ? presetKey : undefined);
        setAvatarChooserOpen(true);
    }, []);
    const closeAvatarChooser = (0, _react.useCallback)(()=>{
        setAvatarChooserOpen(false);
        setAvatarChooserInitialKey(undefined);
    }, []);
    const canNativeShare = typeof navigator !== "undefined" && !!navigator.share;
    const formatCoins = (amount)=>new Intl.NumberFormat("en-IN").format(Math.round(amount));
    const profileLinkBackground = {
        from: location.state?.from ?? {
            pathname: location.pathname,
            search: location.search
        }
    };
    const joinDateShort = user.created_at ? new Date(user.created_at).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    }) : null;
    const legacyMiniGamesPlayed = games.reduce((sum, g)=>{
        if (g.name !== "quickfire-trivia") return sum;
        const p = g.values?.played;
        const n = typeof p === "number" ? p : Number(p);
        return sum + (Number.isFinite(n) ? n : 0);
    }, 0);
    const legacyCoinsWonHeader = games.reduce((sum, g)=>{
        const w = g.values?.lastwon;
        const n = typeof w === "number" ? w : Number(w);
        if (g.name === "quickfire-trivia") return sum + (Number.isFinite(n) ? n : 0);
        return sum;
    }, 0) + (careerSummary?.trader.profit ?? 0) + (careerSummary?.squares.net_winnings ?? 0) + (careerSummary?.bullion.net_winnings ?? 0) + (careerSummary?.sixes.net_winnings ?? 0) + (careerSummary?.leagues.net_winnings ?? 0);
    const totalGamesPlayed = careerSummary != null ? careerSummary.totals.games_played : legacyMiniGamesPlayed;
    const coinsWonDisplay = careerSummary != null ? careerSummary.totals.net_coins_won : legacyCoinsWonHeader;
    const favChips = [];
    for (const label of (0, _profileFavSportIcons.parseFavSportsFromStorage)(favourites?.favsports))favChips.push({
        key: `sport-${label}`,
        label
    });
    for (const slug of (0, _profileFavCricketers.parseFavCricketersFromStorage)(favourites?.favcricketers))favChips.push({
        key: `cr-${slug}`,
        label: (0, _profileFavCricketers.favCricketerLabel)(slug)
    });
    const iplStoreSlugs = (0, _profileFavIplTeams.parseFavIplFromStorage)(favourites?.faviplteams);
    const nationalStoreSlugs = (0, _profileFavCricketIntTeams.parseFavCricketIntFromStorage)(favourites?.favnationalteams);
    const pickerTeamSlugs = new Set([
        ...iplStoreSlugs,
        ...nationalStoreSlugs
    ].map((0, _cricketTeamCanonical.canonicalTeamSlug)));
    for (const slug of iplStoreSlugs)favChips.push({
        key: `ipl-${slug}`,
        label: (0, _profileFavIplTeams.favIplLabel)(slug),
        longLabel: (0, _profileFavIplTeams.favIplLongLabel)(slug)
    });
    for (const slug of nationalStoreSlugs)favChips.push({
        key: `cint-${slug}`,
        label: (0, _profileFavCricketIntTeams.favCricketIntLabel)(slug)
    });
    for (const name of (0, _favouriteTeams.parseFavTeamsFromStorage)(favourites?.favcustomcricketteams)){
        if (pickerTeamSlugs.has((0, _cricketTeamCanonical.canonicalTeamSlug)(name))) continue;
        favChips.push({
            key: `team-${(0, _favouriteTeams.slugifyTeamName)(name)}`,
            label: name,
            longLabel: name
        });
    }
    for (const slug of (0, _profileFavFootballTeams.parseFavFootballFromStorage)(favourites?.favfootballteams))favChips.push({
        key: `fb-${slug}`,
        label: (0, _profileFavFootballTeams.favFootballLabel)(slug),
        longLabel: (0, _profileFavFootballTeams.favFootballLongLabel)(slug)
    });
    const playerNameLabel = (0, _friendDisplayName.playerHandleName)(user);
    const realNameLabel = (0, _friendDisplayName.optionalDisplayName)(user);
    const showOnlineBadge = (0, _sessionUser.showOnlineOnOwnProfile)(user);
    /** Unlock next to player name / name: fixed 43×21, spec typography (no room for ruby chip). */ const renderProfileUsernameUnlockButton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            type: "button",
            onClick: openShopDrawer,
            className: profileEditUsernameUnlockButtonClass,
            "aria-label": "Unlock profile features in shop",
            children: "Unlock"
        });
    const renderSaveProfileButton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
            type: "submit",
            form: "profile-edit-form",
            disabled: saving,
            className: "relative flex h-[40px] min-h-[40px] max-h-[40px] w-full min-w-0 items-center justify-center rounded-none border-0 bg-[#D2FF00] px-10 text-center font-anton text-[16px] font-normal not-italic uppercase leading-[100%] tracking-normal text-[#1b062f] transition-[filter] [leading-trim:none] hover:brightness-95 disabled:opacity-60",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-center",
                    children: saving ? "Saving\u2026" : "Save profile"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: "/assets/arrow-right.svg",
                    alt: "",
                    width: 22,
                    height: 22,
                    className: "pointer-events-none absolute right-3 top-1/2 h-[22px] w-[22px] -translate-y-1/2 object-contain sm:right-4",
                    "aria-hidden": true
                })
            ]
        });
    const ownProfileDisplayName = playerNameLabel;
    const ownRawPhotoUrl = (0, _sessionUser.resolveAvatarUrl)(user);
    const ownResolvedHeroSrc = (0, _sessionUser.toProfileHeroAvatarUrl)(ownRawPhotoUrl);
    const ownRawHadPhoto = Boolean(ownRawPhotoUrl && String(ownRawPhotoUrl).trim());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `flex w-full flex-col ${editPageMode ? "h-full min-h-0 flex-1 overflow-hidden bg-[#1B062F] md:h-auto md:flex-none md:overflow-visible" : "h-full min-h-0 flex-1 overflow-hidden"}`,
        children: [
            isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                className: `grid shrink-0 grid-cols-[auto_1fr_auto] items-center gap-2 border-b border-black/15 bg-gradient-to-r from-[#652DAF] to-[#623998] ${editPageMode ? "w-full min-h-[calc(3.125rem+env(safe-area-inset-top,0px))] pt-[env(safe-area-inset-top,0px)] px-4 sm:px-5 md:h-[97px] md:min-h-[97px] md:max-h-[97px] md:px-14 md:pt-0" : "h-[50px] min-h-[50px] max-h-[50px] px-3"}`,
                children: [
                    editPageMode ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: ()=>onLeaveEditPage?.(),
                        className: "flex shrink-0 items-center border-0 bg-transparent p-0",
                        "aria-label": "Back",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: (0, _logo.CRICKET8_LOGO_SRC),
                            alt: "",
                            className: "h-[34px] w-[34px] object-contain md:h-[74px] md:w-[74px]",
                            width: 74,
                            height: 74
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/",
                        className: "flex shrink-0 items-center",
                        "aria-label": "Home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: (0, _logo.CRICKET8_LOGO_SRC),
                            alt: "",
                            className: "h-[34px] w-[34px] object-contain",
                            width: 34,
                            height: 34
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: `min-w-0 truncate text-center font-anton font-normal uppercase tracking-normal text-white [leading-trim:none] ${editPageMode ? "text-base leading-none sm:text-lg md:text-[20px] md:leading-[100%]" : "text-sm"}`,
                        children: "Edit profile"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: handleCancelEdit,
                        className: `shrink-0 border-0 bg-transparent px-1 py-2 text-white hover:opacity-90 ${profileEditCancelButtonClass}`,
                        children: "Cancel"
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "shrink-0 border-b border-white/10 px-3 pb-1 pt-1 sm:pt-1.5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid grid-cols-[1fr_auto_1fr] items-start gap-x-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex min-w-0 flex-col items-start gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: `flex items-center gap-1.5 font-anton text-[8px] font-normal uppercase leading-[12px] tracking-normal [leading-trim:none] ${showOnlineBadge ? "text-[#D2FF00]" : "text-white/55"}`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: `h-[7px] w-[7px] shrink-0 rounded-full ${showOnlineBadge ? "bg-[#D2FF00]" : "bg-white/45"}`,
                                            "aria-hidden": true
                                        }),
                                        showOnlineBadge ? "Online" : "Offline"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: handleStartEdit,
                                    className: "h-8 shrink-0 rounded-none bg-[#D2FF00] px-3 font-anton text-[10px] font-normal uppercase tracking-wide text-black hover:brightness-95",
                                    children: "Edit profile"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "col-start-2 flex max-w-[min(100%,11rem)] flex-col items-center gap-2 justify-self-center sm:max-w-[13rem]",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
                                    className: "relative shrink-0 rounded-full",
                                    initial: false,
                                    animate: justUnlockedProfile ? {
                                        boxShadow: [
                                            "0 0 0 transparent",
                                            "0 0 22px rgba(210,255,0,0.55)",
                                            "0 0 0 transparent"
                                        ],
                                        scale: [
                                            1,
                                            1.06,
                                            1
                                        ]
                                    } : {
                                        boxShadow: "0 0 0 transparent",
                                        scale: 1
                                    },
                                    transition: justUnlockedProfile ? {
                                        duration: 0.9,
                                        times: [
                                            0,
                                            0.35,
                                            1
                                        ],
                                        ease: "easeOut"
                                    } : {
                                        duration: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileAvatar.ProfileAvatarHeroWithFallback), {
                                            resolvedSrc: ownResolvedHeroSrc,
                                            rawHadPhoto: ownRawHadPhoto,
                                            displayName: ownProfileDisplayName,
                                            xpWeekCrown: user.xp_week_crown,
                                            avatarFrameUrl: user.avatar_frame_url,
                                            avatarFrameSmallUrl: user.avatar_frame_small_url
                                        }),
                                        ownProfileHeroCountryFlag ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "pointer-events-none absolute -right-2 -top-2 z-[1] select-none text-[15px] leading-none",
                                            "aria-hidden": true,
                                            children: ownProfileHeroCountryFlag
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileNameStack.ProfileNameStack), {
                                    className: "w-full max-w-full",
                                    playerName: playerNameLabel,
                                    displayName: realNameLabel,
                                    renderPlayerName: (label)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).button, {
                                            type: "button",
                                            onClick: ()=>navigate("/account", {
                                                    state: location.state
                                                }),
                                            className: "max-w-full min-w-0 truncate text-center font-anton text-[20px] font-normal uppercase leading-[26px] tracking-normal text-white [leading-trim:none] hover:text-lime-400",
                                            initial: false,
                                            animate: justUnlockedProfile ? {
                                                color: [
                                                    "#ffffff",
                                                    "#D2FF00",
                                                    "#ffffff"
                                                ],
                                                scale: [
                                                    1,
                                                    1.04,
                                                    1
                                                ]
                                            } : {
                                                color: "#ffffff",
                                                scale: 1
                                            },
                                            transition: justUnlockedProfile ? {
                                                duration: 0.75,
                                                times: [
                                                    0,
                                                    0.4,
                                                    1
                                                ],
                                                ease: "easeOut"
                                            } : {
                                                duration: 0
                                            },
                                            children: label.toUpperCase()
                                        })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col-start-3 justify-self-end self-start",
                            children: onClose ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseButton), {
                                onClick: onClose,
                                ariaLabel: "Close profile",
                                className: "h-11 w-11 shrink-0 rounded-none hover:bg-white/10 hover:opacity-100"
                            }) : null
                        })
                    ]
                })
            }),
            isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: editPageMode ? "flex min-h-0 w-full flex-1 flex-col overflow-hidden md:flex-none md:overflow-visible" : "flex min-h-0 flex-1 flex-col overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        ref: editFormScrollRef,
                        className: editPageMode ? "min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 pt-4 sm:px-6 md:overflow-visible" : "min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 pb-2 pt-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: editPageMode ? "mx-auto w-full max-w-[630px] pb-4 md:pb-32" : "contents",
                            children: [
                                user.is_guest ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "mb-2 w-full bg-[#652DAF] px-3 py-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "font-anton text-[16px] uppercase text-white",
                                            children: "Guest account"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "mt-1 font-chakra text-[12px] normal-case leading-[16px] text-white/80",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    href: "/signup?back=%2Fprofile",
                                                    className: "text-lime underline",
                                                    children: "Sign in with Google, Facebook or phone"
                                                }),
                                                " ",
                                                "to keep your winnings for good."
                                            ]
                                        })
                                    ]
                                }) : null,
                                user.allow_player_name_edit !== true && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileUnlockBanner.ProfileUnlockBanner), {
                                    variant: "edit"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                    className: "mb-0 w-full min-w-0 overflow-x-hidden",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                        id: "profile-edit-form",
                                        onSubmit: (e)=>{
                                            e.preventDefault();
                                            handleSaveProfile();
                                        },
                                        className: "flex w-full min-w-0 flex-col gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                                className: "min-w-0 w-full overflow-hidden rounded-none bg-[#652DAF] px-1.5 py-0 sm:px-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: profileEditFormRowFlexClass,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `${profileEditFormLabelCellClass} ${profileEditFormTopFieldLabelMinClass} ${profileEditFormLabelNowrapClass} ${profileEditRowLabelClass}`,
                                                                children: "Player name"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: profileEditFormMiddleCellClass,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: `box-border flex h-[30px] w-full min-w-0 items-center gap-1 border border-white/20 pl-1 pr-1.5 ${profileEditFieldBgClass} ${!user.allow_player_name_edit ? "cursor-not-allowed" : ""}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                            id: "profile-edit-player-name",
                                                                            type: "text",
                                                                            value: editPlayerName,
                                                                            onChange: user.allow_player_name_edit ? (e)=>{
                                                                                setEditPlayerName(e.target.value);
                                                                                setEditPlayerNameError(null);
                                                                            } : undefined,
                                                                            readOnly: !user.allow_player_name_edit,
                                                                            disabled: !user.allow_player_name_edit,
                                                                            placeholder: "Player name",
                                                                            "aria-label": "Player name",
                                                                            "aria-invalid": editPlayerNameError ? true : undefined,
                                                                            "aria-describedby": editPlayerNameError ? "profile-edit-player-name-error" : undefined,
                                                                            className: `h-full min-h-0 min-w-0 flex-1 bg-transparent py-0 outline-none placeholder:text-white/45 ${profileEditUsernameInputClass} ${user.allow_player_name_edit ? "text-white" : "cursor-not-allowed text-white/55 placeholder:text-white/35"}`
                                                                        }),
                                                                        !user.allow_player_name_edit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "shrink-0 text-sm leading-none opacity-90",
                                                                            "aria-hidden": true,
                                                                            title: "Locked",
                                                                            children: "\uD83D\uDD12"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: profileEditFormRailCellClass,
                                                                children: !user.allow_player_name_edit ? renderProfileUsernameUnlockButton() : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "block h-[21px] w-[43px] shrink-0",
                                                                    "aria-hidden": true
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    editPlayerNameError ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex w-full min-w-0 flex-nowrap items-start gap-1.5 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `${profileEditFormLabelCellClass} ${profileEditFormTopFieldLabelMinClass} shrink-0`,
                                                                "aria-hidden": true
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "flex min-w-0 flex-1 flex-col overflow-hidden",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                    id: "profile-edit-player-name-error",
                                                                    className: "font-chakra text-[12px] font-normal leading-[16px] [leading-trim:none]",
                                                                    style: {
                                                                        color: "red"
                                                                    },
                                                                    role: "alert",
                                                                    children: editPlayerNameError
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "w-[43px] min-w-[43px] max-w-[43px] shrink-0",
                                                                "aria-hidden": true
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                                className: "min-w-0 w-full overflow-hidden rounded-none bg-[#652DAF] px-1.5 py-0 sm:px-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: profileEditFormRowFlexClass,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `${profileEditFormLabelCellClass} ${profileEditFormTopFieldLabelMinClass} ${profileEditFormLabelNowrapClass} ${profileEditRowLabelClass}`,
                                                                children: "Your name"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: profileEditFormMiddleCellClass,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: `box-border flex h-[30px] w-full min-w-0 items-center gap-1 border border-white/20 pl-1 pr-1.5 ${profileEditFieldBgClass} ${!user.allow_player_name_edit ? "cursor-not-allowed" : ""}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                            id: "profile-edit-display-name",
                                                                            type: "text",
                                                                            value: editDisplayName,
                                                                            onChange: user.allow_player_name_edit ? (e)=>{
                                                                                setEditDisplayName(e.target.value);
                                                                                setEditDisplayNameError(null);
                                                                            } : undefined,
                                                                            readOnly: !user.allow_player_name_edit,
                                                                            disabled: !user.allow_player_name_edit,
                                                                            placeholder: "Optional \u2014 shown to friends",
                                                                            "aria-label": "Your name",
                                                                            "aria-invalid": editDisplayNameError ? true : undefined,
                                                                            "aria-describedby": editDisplayNameError ? "profile-edit-display-name-error" : undefined,
                                                                            className: `h-full min-h-0 min-w-0 flex-1 bg-transparent py-0 outline-none placeholder:text-white/45 ${profileEditUsernameInputClass} ${user.allow_player_name_edit ? "text-white" : "cursor-not-allowed text-white/55 placeholder:text-white/35"}`
                                                                        }),
                                                                        !user.allow_player_name_edit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "shrink-0 text-sm leading-none opacity-90",
                                                                            "aria-hidden": true,
                                                                            title: "Locked",
                                                                            children: "\uD83D\uDD12"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: profileEditFormRailCellClass,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "block h-[21px] w-[43px] shrink-0",
                                                                    "aria-hidden": true
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    editDisplayNameError ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex w-full min-w-0 flex-nowrap items-start gap-1.5 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `${profileEditFormLabelCellClass} ${profileEditFormTopFieldLabelMinClass} shrink-0`,
                                                                "aria-hidden": true
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "flex min-w-0 flex-1 flex-col overflow-hidden",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                    id: "profile-edit-display-name-error",
                                                                    className: "font-chakra text-[12px] font-normal leading-[16px] [leading-trim:none]",
                                                                    style: {
                                                                        color: "red"
                                                                    },
                                                                    role: "alert",
                                                                    children: editDisplayNameError
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "w-[43px] min-w-[43px] max-w-[43px] shrink-0",
                                                                "aria-hidden": true
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                                className: "min-w-0 w-full overflow-hidden rounded-none bg-[#652DAF] px-1.5 py-0 sm:px-2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: profileEditFormRowFlexClass,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: `${profileEditFormLabelCellClass} ${profileEditFormTopFieldLabelMinClass} ${profileEditFormLabelNowrapClass} ${profileEditRowLabelClass}`,
                                                            children: "Avatar"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: profileEditFormMiddleCellClass,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "flex h-full w-full min-w-0 flex-1 items-center gap-1 overflow-hidden sm:gap-2",
                                                                children: user.allow_player_name_edit ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                            type: "button",
                                                                            className: `relative box-border h-[30px] w-[30px] shrink-0 overflow-hidden border border-white/20 p-0 ${profileEditFieldBgClass} cursor-pointer hover:brightness-110`,
                                                                            title: "Your current avatar",
                                                                            "aria-label": "Open avatar chooser",
                                                                            onClick: ()=>openAvatarChooser(),
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAvatar.UserAvatar), {
                                                                                src: (0, _sessionUser.resolveAvatarUrl)(user) || user.avatar,
                                                                                displayName: ownProfileDisplayName,
                                                                                size: "sm",
                                                                                withCrown: false
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>openAvatarChooser(),
                                                                            className: "inline-flex h-[30px] min-h-[30px] max-h-[30px] shrink-0 items-center justify-center bg-[#d2ff00] px-2 font-anton text-[11px] font-normal uppercase tracking-wide text-[#1b062f] hover:brightness-95 sm:px-3 sm:text-[12px]",
                                                                            children: "Change"
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex min-w-0 flex-1 items-center gap-1 overflow-x-auto overflow-y-hidden sm:gap-1.5 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden",
                                                                    role: "list",
                                                                    "aria-label": "Avatar choices",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                            type: "button",
                                                                            className: `relative box-border h-[30px] w-[30px] shrink-0 overflow-hidden border border-white/20 p-0 ${profileEditFieldBgClass} cursor-pointer opacity-80`,
                                                                            role: "listitem",
                                                                            title: "Your current avatar",
                                                                            "aria-label": hasAvatarFrames ? "Choose avatar frame" : "Unlock to change avatar",
                                                                            onClick: ()=>hasAvatarFrames ? openAvatarChooser() : openShopDrawer(),
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAvatar.UserAvatar), {
                                                                                src: (0, _sessionUser.resolveAvatarUrl)(user) || user.avatar,
                                                                                displayName: ownProfileDisplayName,
                                                                                size: "sm",
                                                                                withCrown: false
                                                                            })
                                                                        }),
                                                                        hasAvatarFrames ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                            type: "button",
                                                                            role: "listitem",
                                                                            onClick: ()=>openAvatarChooser(),
                                                                            className: "inline-flex h-[30px] min-h-[30px] max-h-[30px] shrink-0 items-center justify-center bg-[#d2ff00] px-2 font-anton text-[11px] font-normal uppercase tracking-wide text-[#1b062f] hover:brightness-95 sm:px-3 sm:text-[12px]",
                                                                            children: "Frame"
                                                                        }) : null,
                                                                        animalPreviewAvatars.map((opt)=>{
                                                                            const thumb = (0, _profileAvatarCatalog.getAvatarThumbSrc)(opt);
                                                                            if (!thumb) return null;
                                                                            const currentAvatarKey = user.avatar_key != null ? String(user.avatar_key).trim() : "";
                                                                            const selected = currentAvatarKey === opt.key;
                                                                            const tileClass = `relative box-border h-[30px] w-[30px] shrink-0 overflow-hidden border border-white/20 ${profileEditFieldBgClass} ${selected ? "ring-2 ring-[#d2ff00] ring-inset" : ""} cursor-pointer opacity-55`;
                                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                                                type: "button",
                                                                                role: "listitem",
                                                                                title: opt.animal ? `${opt.animal} preset` : "Preset avatar",
                                                                                "aria-label": "Unlock to change avatar",
                                                                                "aria-pressed": selected,
                                                                                className: tileClass,
                                                                                onClick: ()=>openShopDrawer(),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                        src: thumb,
                                                                                        alt: "",
                                                                                        className: "h-full w-full object-cover object-center opacity-60",
                                                                                        width: 30,
                                                                                        height: 30,
                                                                                        decoding: "async"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "pointer-events-none absolute bottom-0 right-0 pb-px pr-px text-[10px] leading-none drop-shadow-[0_1px_2px_rgba(0,0,0,0.85)]",
                                                                                        "aria-hidden": true,
                                                                                        children: "\uD83D\uDD12"
                                                                                    })
                                                                                ]
                                                                            }, opt.key);
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: profileEditFormRailCellClass,
                                                            children: !user.allow_player_name_edit ? renderProfileUsernameUnlockButton() : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "block h-[21px] w-[43px] shrink-0",
                                                                "aria-hidden": true
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                                className: "min-w-0 w-full overflow-hidden rounded-none bg-[#652DAF] px-1.5 py-0 sm:px-2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: profileEditFormRowFlexClass,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: `${profileEditFormLabelCellClass} ${profileEditFormTopFieldLabelMinClass} ${profileEditFormLabelNowrapClass} ${profileEditRowLabelClass}`,
                                                            children: "Country"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: profileEditFormMiddleCellClass,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: `relative box-border flex h-[30px] w-full min-w-0 flex-row flex-nowrap items-center gap-1 overflow-hidden border border-white/20 pl-1 pr-1.5 sm:gap-2 ${profileEditFieldBgClass}`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileCountryCombobox.ProfileCountryCombobox), {
                                                                    id: "profile-edit-country",
                                                                    value: editCountry,
                                                                    onChange: setEditCountry
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                                className: "min-w-0 w-full overflow-hidden rounded-none bg-[#652DAF] px-2 py-3 sm:px-4 sm:py-3.5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileFavouriteSportsGrid.ProfileFavouriteSportsGrid), {
                                                    selected: editFavSports,
                                                    onToggle: (sport)=>{
                                                        setEditFavSports((prev)=>prev.includes(sport) ? prev.filter((s)=>s !== sport) : [
                                                                ...prev,
                                                                sport
                                                            ]);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                                className: "min-w-0 w-full overflow-hidden rounded-none bg-[#652DAF] px-1.5 py-3 sm:px-2 sm:py-3.5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileFavouriteCricketersGrid.ProfileFavouriteCricketersGrid), {
                                                    selected: editFavCricketerSlugs,
                                                    onToggle: (slug)=>{
                                                        setEditFavCricketerSlugs((prev)=>prev.includes(slug) ? prev.filter((s)=>s !== slug) : [
                                                                ...prev,
                                                                slug
                                                            ]);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                                className: "min-w-0 w-full overflow-hidden rounded-none bg-[#652DAF] px-1.5 py-3 sm:px-2 sm:py-3.5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileFavouriteCricketTeamsGrid.ProfileFavouriteCricketTeamsGrid), {
                                                    selectedIpl: editFavIplSlugs,
                                                    selectedInt: editFavCricketIntSlugs,
                                                    onToggleIpl: (slug)=>{
                                                        setEditFavIplSlugs((prev)=>prev.includes(slug) ? prev.filter((s)=>s !== slug) : [
                                                                ...prev,
                                                                slug
                                                            ]);
                                                    },
                                                    onToggleInt: (slug)=>{
                                                        setEditFavCricketIntSlugs((prev)=>prev.includes(slug) ? prev.filter((s)=>s !== slug) : [
                                                                ...prev,
                                                                slug
                                                            ]);
                                                    },
                                                    clubExtras: clubExtras,
                                                    intExtras: intExtras,
                                                    onRemoveExtra: (teamName)=>{
                                                        toggleFavouriteTeam(teamName);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                                className: "min-w-0 w-full overflow-hidden rounded-none bg-[#652DAF] px-1.5 py-3 sm:px-2 sm:py-3.5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileFavouriteFootballGrid.ProfileFavouriteFootballGrid), {
                                                    selected: editFavFootballSlugs,
                                                    onToggle: (slug)=>{
                                                        setEditFavFootballSlugs((prev)=>prev.includes(slug) ? prev.filter((s)=>s !== slug) : [
                                                                ...prev,
                                                                slug
                                                            ]);
                                                    }
                                                })
                                            }),
                                            saveFeedback && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                id: "profile-edit-save-feedback",
                                                role: saveFeedback.error ? "alert" : undefined,
                                                className: `text-sm ${saveFeedback.error ? "text-[#f87171]" : "text-emerald-400"}`,
                                                children: saveFeedback.message
                                            }),
                                            editPageMode ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "mt-2 hidden w-full md:mt-10 md:block",
                                                children: renderSaveProfileButton()
                                            }) : null
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `relative z-10 w-full shrink-0 bg-white px-2 py-2 pb-[calc(0.5rem+env(safe-area-inset-bottom,0px))] shadow-[0_-6px_16px_rgba(0,0,0,0.22)] sm:px-2.5 sm:py-2.5 ${editPageMode ? "md:hidden" : ""}`,
                        children: renderSaveProfileButton()
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 pb-8 pt-1",
                children: [
                    !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "relative mb-3 flex flex-col items-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mx-auto mt-0.5 flex items-center justify-center gap-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    type: "button",
                                    onClick: openShopDrawer,
                                    className: "flex items-center justify-center gap-1 rounded-none border-0 bg-transparent p-0 transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/50",
                                    "aria-label": "Open shop",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex shrink-0 items-center justify-center gap-1 rounded-none bg-[#381663] px-2 py-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-ruby.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-anton text-[10px] font-normal leading-[100%] tracking-normal text-white [leading-trim:none]",
                                                    children: rubies
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex shrink-0 items-center justify-center gap-1 rounded-none bg-[#381663] px-2 py-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-coin.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-anton text-[10px] font-normal leading-[100%] tracking-normal text-white [leading-trim:none]",
                                                    children: formatCoins(coins)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        (0, _frontendTrackingEvents.trackCtaClicked)({
                                            cta_name: "xp_history",
                                            cta_location: "profile_balance_strip",
                                            source_page: location.pathname,
                                            pathname: location.pathname
                                        });
                                        setXpHubOpen(true);
                                    },
                                    className: "flex shrink-0 items-center justify-center gap-1 rounded-none border-0 bg-[#381663] px-2 py-2 transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/50",
                                    "aria-label": "XP history",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: "/assets/xp.webp",
                                            alt: "",
                                            className: "h-4 w-4 shrink-0 object-contain",
                                            "aria-hidden": true
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-anton text-[10px] font-normal leading-[100%] tracking-normal text-white tabular-nums [leading-trim:none]",
                                            children: formatCoins(xpTotal)
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !isEditing && user.allow_player_name_edit !== true && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileUnlockBanner.ProfileUnlockBanner), {}),
                    !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `mb-3 grid grid-cols-3 gap-2 text-center ${user.allow_player_name_edit !== true ? "mt-1 sm:mt-1.5" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rounded-none bg-[#652DAF] px-1 py-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "font-anton text-[11px] font-normal uppercase leading-[12px] tracking-normal text-white/40 [leading-trim:none]",
                                        children: "Joined"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "mt-1.5 font-anton text-[15px] font-normal uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                                        children: joinDateShort ?? "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rounded-none bg-[#652DAF] px-1 py-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "font-anton text-[11px] font-normal uppercase leading-[12px] tracking-normal text-white/40 [leading-trim:none]",
                                        children: "Games played"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "mt-1.5 font-anton text-[15px] font-normal uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                                        children: formatCoins(totalGamesPlayed)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rounded-none bg-[#652DAF] px-1 py-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "font-anton text-[11px] font-normal uppercase leading-[12px] tracking-normal text-white/40 [leading-trim:none]",
                                        children: "Game score"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "mt-1.5 flex items-center justify-center gap-1 font-anton text-[15px] font-normal uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "/assets/currency-coin.png",
                                                alt: "",
                                                className: "h-3.5 w-3.5 shrink-0"
                                            }),
                                            formatCoins(coinsWonDisplay)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !isEditing && favChips.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileFavouritesStrip.ProfileFavouritesStrip), {
                        chips: favChips
                    }),
                    !isEditing && careerSummary && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _careerStatsStack.CareerStatsStack), {
                        xp: careerSummary.xp ?? null,
                        trader: {
                            played: careerSummary.trader.trades,
                            won: careerSummary.trader.won,
                            totalWinnings: careerSummary.trader.total_winnings,
                            currentStreak: careerSummary.trader.current_win_streak,
                            bestStreak: careerSummary.trader.record_win_streak,
                            biggestWin: careerSummary.trader.biggest_win
                        },
                        squares: {
                            played: careerSummary.squares.played,
                            won: careerSummary.squares.won,
                            totalWinnings: careerSummary.squares.net_winnings
                        },
                        bullion: {
                            played: careerSummary.bullion.played,
                            won: careerSummary.bullion.won,
                            totalWinnings: careerSummary.bullion.net_winnings
                        },
                        sixes: {
                            played: careerSummary.sixes.played,
                            totalWinnings: careerSummary.sixes.net_winnings,
                            biggestWin: careerSummary.sixes.biggest_win
                        },
                        leagues: {
                            played: careerSummary.leagues.played,
                            won: careerSummary.leagues.won,
                            totalWinnings: careerSummary.leagues.net_winnings
                        },
                        quickfire: {
                            plays: careerSummary.mini_games["quickfire-trivia"].played,
                            correct: careerSummary.mini_games["quickfire-trivia"].correct_answers,
                            totalWinnings: careerSummary.mini_games["quickfire-trivia"].net_coins
                        },
                        formatCoins: formatCoins
                    }),
                    !isEditing && friendsStrip.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        className: "mb-2 flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                className: "mb-2 flex items-center justify-center gap-0.5 font-anton text-[11px] font-normal uppercase leading-[12px] tracking-normal [leading-trim:none]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "shrink-0 text-white",
                                        children: "Friends"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "text-white/40",
                                        children: [
                                            "(",
                                            friendsStrip.length,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full min-w-0 max-w-full overflow-x-auto overflow-y-hidden overscroll-x-contain pb-1 hide-scrollbar snap-x snap-mandatory touch-pan-x scroll-pl-3 scroll-pr-3",
                                "aria-label": "Friends \u2014 swipe or scroll horizontally",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mx-auto flex w-max max-w-none flex-nowrap items-center gap-2",
                                    children: friendsStrip.map((f)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileLink.ProfileLink), {
                                            to: f.player_id ? `/profile?p=${encodeURIComponent(f.player_id)}` : `/profile?u=${encodeURIComponent(String(f.userId))}`,
                                            state: profileLinkBackground,
                                            className: "group shrink-0 snap-start",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileAvatar.ProfileAvatar), {
                                                variant: "chip",
                                                src: (0, _sessionUser.resolveAvatarUrl)({
                                                    profile_pic: f.profile_pic,
                                                    avatar_url: f.avatar_url
                                                }) ?? "",
                                                displayName: (0, _friendDisplayName.playerHandleName)(f),
                                                xpWeekCrown: f.xp_week_crown,
                                                avatarFrameUrl: f.avatar_frame_url,
                                                avatarFrameSmallUrl: f.avatar_frame_small_url
                                            })
                                        }, f.userId))
                                })
                            })
                        ]
                    }),
                    !isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                        className: `border-t border-white/10 ${friendsStrip.length > 0 ? "mt-2 pt-2" : "mt-4 pt-4"}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex h-[70px] w-full shrink-0 flex-col overflow-hidden rounded-none bg-[#381663] px-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "min-h-0 flex-1",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex w-full shrink-0 flex-col items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "w-full max-w-[min(100%,280px)] shrink-0 text-center",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-anton text-[12px] font-normal uppercase leading-[100%] tracking-normal text-[#D2FF00] [leading-trim:none]",
                                                    children: "Invite friends"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-anton text-[12px] font-normal uppercase leading-[100%] tracking-normal text-white [leading-trim:none]",
                                                    children: "with your profile link"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "mb-2 flex w-full min-w-0 max-w-full items-stretch rounded-none",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "box-border flex min-h-[26px] min-w-0 flex-1 items-center gap-2 border border-solid border-[#D2FF00] px-2 py-0.5",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "min-w-0 flex-1 truncate text-left font-chakra text-[9px] font-normal leading-[14px] tracking-normal text-white [leading-trim:none]",
                                                            title: inviteUrl,
                                                            children: inviteUrlDisplay || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            onClick: handleCopyInvite,
                                                            className: "flex h-4 w-4 shrink-0 items-center justify-center opacity-90 transition-opacity hover:opacity-100 disabled:opacity-40",
                                                            "aria-label": "Copy link",
                                                            disabled: !inviteUrl,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: "/assets/copy.svg",
                                                                alt: "",
                                                                className: "h-4 w-4 object-contain",
                                                                width: 16,
                                                                height: 16,
                                                                "aria-hidden": true
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    onClick: canNativeShare ? handleShareInvite : handleCopyInvite,
                                                    disabled: !inviteUrl,
                                                    className: "flex min-w-[76px] shrink-0 items-center justify-center bg-[#D2FF00] px-4 font-anton text-[11px] font-normal uppercase text-black hover:brightness-95 disabled:opacity-50",
                                                    children: inviteCopied ? "Copied" : "Share"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "min-h-0 flex-1",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    }),
                    !isEditing && user && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        className: "mb-2 mt-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                className: "mb-3 text-center font-anton text-[11px] font-normal uppercase leading-[12px] tracking-wide text-white [leading-trim:none]",
                                children: "Activity"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _friendActivityTimelineDefault.default), {
                                digests: ownActivityDigests,
                                liveFriends: ownActivityLiveFriends,
                                myTrades: ownActivityMyTrades,
                                mySquares: ownActivityMySquares,
                                notifications: [],
                                profileModalState: profileLinkBackground,
                                loading: ownActivityLoading,
                                visibleCount: 10,
                                surface: "profile",
                                enableInfiniteScroll: true,
                                infiniteScrollStep: 10,
                                isOwnProfileView: true,
                                hasMoreServerRows: ownActivityHasMore,
                                serverLoadingMore: ownActivityLoadingMore,
                                onReachEnd: ()=>{
                                    if (ownActivityLoadingMore || !ownActivityHasMore) return;
                                    setOwnActivityResultsLimit((prev)=>prev + 10);
                                },
                                onProfileLinkClick: ()=>onClose?.(),
                                emptyMessage: "No recent activity yet."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarChooserModal.AvatarChooserModal), {
                isOpen: avatarChooserOpen,
                onRequestClose: closeAvatarChooser,
                avatarOptions: stripAvatarOptions,
                initialSelectedKey: avatarChooserInitialKey
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpHubModal.XpHubModal), {
                isOpen: xpHubOpen,
                onClose: ()=>setXpHubOpen(false),
                xp: careerSummary?.xp ?? null
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","framer-motion":"fI0Q4","react-router-dom":"l6ORY","./ProfileAvatar":"fwC7C","./UserAvatar":"e6kw2","./ProfileLink":"eCRxx","js-cookie":"2P5RE","../../Data/UserContext":"aqd8b","../../utils/authHeaders":"5Rczo","../../utils/profileAvatarCatalog":"i8TvT","../../utils/sessionUser":"4xtMD","../../utils/profileModalNavigation":"eBA1i","../../utils/myZoneOnboardingMilestones":"h9Unj","../../utils/frontendTrackingEvents":"4Y90p","../../utils/shareCopy":"9P9zX","../../hooks/useSocialSyncRefresh":"1firO","../../Data/TraderDataFetcherContext":"1bLlx","../MyZone/FriendActivityTimeline":"gNFUK","./ProfileCountryCombobox":"cKToa","./ProfileFavouritesStrip":"dZNUw","./CareerStatsStack":"iO9Z8","../Logo/Logo":"2jdXu","./ProfileUnlockBanner":"beKzR","./AvatarChooserModal":"6Tl4s","../Xp/XpHubModal":"lSUlG","./ProfileFavouriteSportsGrid":"bPbDY","./ProfileFavouriteFootballGrid":"652Wq","./ProfileFavouriteCricketTeamsGrid":"2eY8V","./ProfileFavouriteCricketersGrid":"bGG5v","./profileFavSportIcons":"bXwQU","./profileFavFootballTeams":"3mxlc","./profileFavIplTeams":"f7o1p","./profileFavCricketIntTeams":"7D1sc","../../utils/favouriteTeams":"fwQD0","../../utils/cricketTeamCanonical":"3aPXR","../../Data/useFavouriteTeams":"14JPj","../../utils/friendDisplayName":"hUpqQ","./ProfileNameStack":"cQ9gl","./profileFavCricketers":"2PUhI","../ModalCloseIcon":"aricC","./careerSummary":"8bANt","../../utils/profileCountryFlag":"23a1d","../../utils/nativeShare":"c9hr7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fwC7C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserAvatar", ()=>(0, _userAvatar.UserAvatar));
/**
 * Profile modal header: photo when present, otherwise same letter tile as trader leaderboard rows.
 */ parcelHelpers.export(exports, "ProfileAvatarHeroWithFallback", ()=>ProfileAvatarHeroWithFallback);
/** Profile header (large) or friends strip / activity — letter tile when no photo. */ parcelHelpers.export(exports, "ProfileAvatar", ()=>ProfileAvatar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sessionUser = require("../../utils/sessionUser");
var _userAvatar = require("./UserAvatar");
function ProfileAvatarHeroWithFallback({ resolvedSrc, rawHadPhoto, displayName, avatarColor, firstLetter, className = "", syntheticBotLetterTile = false, xpWeekCrown = null, avatarFrameUrl = null, avatarFrameSmallUrl = null }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAvatar.UserAvatar), {
        src: rawHadPhoto ? resolvedSrc : "",
        displayName: displayName,
        avatarColor: avatarColor,
        firstLetter: firstLetter,
        syntheticBotLetterTile: syntheticBotLetterTile,
        xpWeekCrown: xpWeekCrown,
        avatarFrameUrl: avatarFrameUrl,
        avatarFrameSmallUrl: avatarFrameSmallUrl,
        size: "hero",
        className: className,
        loading: "eager"
    });
}
function ProfileAvatar({ src, alt = "", variant, className = "", xpWeekCrown = null, avatarFrameUrl = null, avatarFrameSmallUrl = null, displayName, avatarColor, firstLetter }) {
    const resolvedSrc = variant === "hero" ? (0, _sessionUser.toProfileHeroAvatarUrl)(src) : src;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAvatar.UserAvatar), {
        src: resolvedSrc,
        displayName: displayName,
        avatarColor: avatarColor,
        firstLetter: firstLetter,
        xpWeekCrown: xpWeekCrown,
        avatarFrameUrl: avatarFrameUrl,
        avatarFrameSmallUrl: avatarFrameSmallUrl,
        size: variant === "hero" ? "hero" : "chip",
        className: className,
        alt: alt,
        loading: variant === "hero" ? "eager" : "lazy"
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../utils/sessionUser":"4xtMD","./UserAvatar":"e6kw2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e6kw2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserAvatar", ()=>UserAvatar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _botAvatarPlaceholders = require("../../utils/botAvatarPlaceholders");
var _profileLetterAvatar = require("../../utils/profileLetterAvatar");
var _sessionUser = require("../../utils/sessionUser");
var _avatarWithXpCrown = require("../Xp/AvatarWithXpCrown");
var _avatarFrame = require("./avatarFrame");
const SIZE_CONFIG = {
    hero: {
        box: "h-24 w-24 shrink-0",
        letter: "text-[34px]",
        shadow: "shadow-[0_8px_28px_rgba(8,2,18,0.45)]",
        crownSize: "hero"
    },
    chip: {
        box: "h-11 w-11 shrink-0",
        letter: "text-[20px]",
        shadow: "shadow-[0_2px_10px_rgba(0,0,0,0.3)] transition-shadow duration-200 group-hover:shadow-[0_4px_14px_rgba(0,0,0,0.4)]",
        crownSize: "sm"
    },
    md: {
        box: "h-10 w-10 shrink-0",
        letter: "text-[16px]",
        shadow: "",
        crownSize: "sm"
    },
    sm: {
        box: "h-[30px] w-[30px] shrink-0",
        letter: "text-[14px]",
        shadow: "",
        crownSize: "sm"
    },
    xs: {
        box: "h-8 w-8 shrink-0",
        letter: "text-[13px]",
        shadow: "",
        crownSize: "sm"
    },
    tiny: {
        box: "h-[22px] w-[22px] shrink-0",
        letter: "text-[10px]",
        shadow: "",
        crownSize: "sm"
    },
    lg: {
        box: "h-16 w-16 shrink-0",
        letter: "text-[28px]",
        shadow: "",
        crownSize: "sm"
    },
    compact: {
        box: "h-7 w-7 shrink-0",
        letter: "text-[12px]",
        shadow: "",
        crownSize: "sm"
    },
    micro: {
        box: "h-[14px] w-[14px] shrink-0",
        letter: "text-[8px]",
        shadow: "",
        crownSize: "sm"
    },
    icon16: {
        box: "h-4 w-4 shrink-0",
        letter: "text-[9px]",
        shadow: "",
        crownSize: "sm"
    },
    mini: {
        box: "h-[18px] w-[18px] shrink-0",
        letter: "text-[9px]",
        shadow: "",
        crownSize: "sm"
    },
    fill: {
        box: "h-full w-full",
        letter: "text-[14px]",
        shadow: ""
    }
};
function useFinePointerHover() {
    const [fineHover, setFineHover] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const media = window.matchMedia("(hover: hover) and (pointer: fine)");
        const sync = ()=>setFineHover(media.matches);
        sync();
        media.addEventListener("change", sync);
        return ()=>media.removeEventListener("change", sync);
    }, []);
    return fineHover;
}
function resolveLetter(displayName, firstLetter) {
    if (firstLetter != null && String(firstLetter).trim() !== "") return String(firstLetter).trim().charAt(0).toUpperCase();
    return (0, _profileLetterAvatar.getProfileLetterAvatarLetter)(displayName) || "?";
}
function resolveLetterTileStyle(displayName, avatarColor, syntheticBotLetterTile) {
    if (syntheticBotLetterTile) return (0, _botAvatarPlaceholders.getBotLetterAvatarTileStyle)({
        avatar_color: avatarColor,
        name: displayName
    });
    return {
        backgroundColor: avatarColor?.trim() || (0, _profileLetterAvatar.getProfileLetterAvatarColor)(displayName ?? ""),
        color: "#1B062F"
    };
}
function UserAvatar({ src, displayName, avatarColor, firstLetter, syntheticBotLetterTile = false, xpWeekCrown = null, avatarFrameUrl = null, avatarFrameSmallUrl = null, size = "chip", className = "", imgClassName = "", letterClassName = "", alt = "", loading = "lazy", withCrown = true }) {
    const config = SIZE_CONFIG[size];
    const resolvedSrc = (0, _sessionUser.isUsableAvatarUrl)(src) ? String(src).trim() : "";
    const [failed, setFailed] = (0, _react.useState)(false);
    const [photoRevealed, setPhotoRevealed] = (0, _react.useState)(false);
    const [photoHovered, setPhotoHovered] = (0, _react.useState)(false);
    const finePointerHover = useFinePointerHover();
    const heroCrown = size === "hero" ? (0, _avatarWithXpCrown.normalizeXpWeekCrown)(xpWeekCrown) : null;
    const frameSrc = (0, _avatarFrame.resolveAvatarFrameSrc)(size, avatarFrameUrl, avatarFrameSmallUrl);
    const showPhoto = Boolean(heroCrown) && (finePointerHover ? photoHovered : photoRevealed);
    (0, _react.useEffect)(()=>{
        setFailed(false);
    }, [
        resolvedSrc
    ]);
    (0, _react.useEffect)(()=>{
        setPhotoRevealed(false);
    }, [
        xpWeekCrown
    ]);
    const letter = resolveLetter(displayName, firstLetter);
    const letterTileStyle = resolveLetterTileStyle(displayName, avatarColor, syntheticBotLetterTile);
    const showLetter = !resolvedSrc || failed;
    const botLetterClass = syntheticBotLetterTile && size === "hero" ? "text-[40px] sm:text-[42px]" : config.letter;
    const letterNode = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `flex items-center justify-center ${config.box} ${(0, _botAvatarPlaceholders.BOT_LETTER_AVATAR_FONT_CLASS)} ${config.shadow} ${botLetterClass} ${letterClassName} ${className}`,
        style: letterTileStyle,
        "aria-hidden": alt === "",
        children: letter
    });
    const imgNode = /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        src: resolvedSrc,
        alt: alt,
        className: `object-cover object-center ${config.box} ${config.shadow} ${imgClassName || className}`,
        loading: loading,
        decoding: "async",
        onError: ()=>setFailed(true)
    });
    const inner = showLetter ? letterNode : imgNode;
    if (!withCrown) return inner;
    const crowned = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarWithXpCrown.AvatarWithXpCrown), {
        crown: showPhoto ? null : xpWeekCrown,
        frameSrc: frameSrc,
        size: config.crownSize,
        className: size === "fill" ? "block h-full w-full" : undefined,
        children: inner
    });
    if (!heroCrown) return crowned;
    const hint = showPhoto ? "Show crown" : finePointerHover ? "Hover to view" : "Tap to view";
    const crownReason = (0, _avatarWithXpCrown.xpWeekCrownReason)(heroCrown);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "relative inline-flex",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                onClick: ()=>{
                    if (finePointerHover) return;
                    setPhotoRevealed((revealed)=>!revealed);
                },
                onPointerEnter: (event)=>{
                    if (finePointerHover && event.pointerType === "mouse") setPhotoHovered(true);
                },
                onPointerLeave: ()=>setPhotoHovered(false),
                "aria-pressed": showPhoto,
                "aria-label": showPhoto ? "Show weekly crown" : "Show profile photo",
                className: `relative border-0 bg-transparent p-0 ${finePointerHover ? "cursor-default" : "cursor-pointer"}`,
                children: [
                    crowned,
                    finePointerHover && photoHovered ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "pointer-events-none absolute bottom-1.5 left-1/2 z-[4] -translate-x-1/2 whitespace-nowrap bg-[#D2FF00] px-1.5 py-[3px] font-anton text-[9px] font-normal uppercase leading-none tracking-wide text-black shadow-[0_2px_8px_rgba(0,0,0,0.35)]",
                        children: hint
                    })
                ]
            }),
            showPhoto || !crownReason ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "absolute left-[calc(100%+0.6rem)] top-7 z-[5] flex w-max max-w-[6.75rem] flex-col items-start gap-1.5 text-left",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "font-chakra text-[11px] font-normal normal-case leading-[14px] text-white/80",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white",
                                children: crownReason.place
                            }),
                            " in XP leaderboard last week"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                        to: "/xp-leaderboard",
                        "aria-label": "See this week's XP leaderboard",
                        className: "inline-flex items-center gap-1 whitespace-nowrap font-anton text-[11px] font-normal uppercase leading-none tracking-wide text-white no-underline hover:text-[#D2FF00]",
                        children: [
                            "See this week",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                viewBox: "0 0 256 256",
                                className: "h-3 w-3 shrink-0",
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "currentColor",
                                    d: "M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../../utils/botAvatarPlaceholders":"fYQHe","../../utils/profileLetterAvatar":"7BuGM","../../utils/sessionUser":"4xtMD","../Xp/AvatarWithXpCrown":"9U2iQ","./avatarFrame":"k4MjP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fYQHe":[function(require,module,exports,__globalThis) {
/**
 * Deterministic letter + fill for bot / synthetic placeholders.
 * Must stay in sync with backend `controllers/trader/leaderboard-bots.js` (public profile, trader boards).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @param {string|null|undefined} username */ parcelHelpers.export(exports, "getAvatarColor", ()=>getAvatarColor);
/** @param {string|null|undefined} username */ parcelHelpers.export(exports, "getFirstLetter", ()=>getFirstLetter);
parcelHelpers.export(exports, "BOT_LETTER_AVATAR_FONT_CLASS", ()=>BOT_LETTER_AVATAR_FONT_CLASS);
/**
 * Background + text for bot/synthetic letter-only tiles: API `avatar_color` when set, else {@link getAvatarColor} from a display name.
 * @param {null|undefined|{ avatar_color?: string|null, avatarColor?: string|null, name?: string|null, player_name?: string|null, username?: string|null }} row
 * @returns {{ backgroundColor: string, color: string }}
 */ parcelHelpers.export(exports, "getBotLetterAvatarTileStyle", ()=>getBotLetterAvatarTileStyle);
const AVATAR_COLORS = [
    "#E0FFFF",
    "#F0F8FF",
    "#F5FFFA",
    "#FAEBD7",
    "#FFF0F5",
    "#FFFFF0",
    "#FDF5E6",
    "#FFFAF0",
    "#FAFAD2",
    "#FFDAB9",
    "#FFC0CB",
    "#F0E68C",
    "#E6E6FA",
    "#D8BFD8",
    "#ADD8E6",
    "#90EE90",
    "#B0E0E6",
    "#C0C0C0",
    "#D3D3D3",
    "#F5F5DC"
];
function getAvatarColor(username) {
    if (!username) return AVATAR_COLORS[0];
    let hash = 0;
    for(let i = 0; i < username.length; i++)hash = username.charCodeAt(i) + ((hash << 5) - hash);
    const colorIndex = Math.abs(hash) % AVATAR_COLORS.length;
    return AVATAR_COLORS[colorIndex];
}
function getFirstLetter(username) {
    if (!username) return "?";
    const cleanName = String(username).replace(/_/g, " ").trim();
    return cleanName.charAt(0).toUpperCase();
}
const BOT_LETTER_AVATAR_FONT_CLASS = "font-chakra font-bold uppercase leading-none tracking-normal";
function getBotLetterAvatarTileStyle(row) {
    if (row == null || typeof row !== "object") return {
        backgroundColor: getAvatarColor(""),
        color: "#1B062F"
    };
    const fromApi = row.avatar_color ?? row.avatarColor;
    if (typeof fromApi === "string" && fromApi.trim() !== "") return {
        backgroundColor: fromApi.trim(),
        color: "#1B062F"
    };
    const label = [
        row.name,
        row.player_name,
        row.username
    ].find((s)=>s != null && String(s).trim() !== "");
    const key = label != null ? String(label).trim() : "";
    return {
        backgroundColor: key ? getAvatarColor(key) : getAvatarColor(""),
        color: "#1B062F"
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7BuGM":[function(require,module,exports,__globalThis) {
/**
 * Letter + background for public profile / modal when no photo (same algorithm as backend
 * `controllers/trader/leaderboard-bots.js` getAvatarColor / getFirstLetter).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getProfileLetterAvatarColor", ()=>getProfileLetterAvatarColor);
parcelHelpers.export(exports, "getProfileLetterAvatarLetter", ()=>getProfileLetterAvatarLetter);
const AVATAR_COLORS = [
    "#E0FFFF",
    "#F0F8FF",
    "#F5FFFA",
    "#FAEBD7",
    "#FFF0F5",
    "#FFFFF0",
    "#FDF5E6",
    "#FFFAF0",
    "#FAFAD2",
    "#FFDAB9",
    "#FFC0CB",
    "#F0E68C",
    "#E6E6FA",
    "#D8BFD8",
    "#ADD8E6",
    "#90EE90",
    "#B0E0E6",
    "#C0C0C0",
    "#D3D3D3",
    "#F5F5DC"
];
function getProfileLetterAvatarColor(displayName) {
    const key = displayName != null ? String(displayName).trim() : "";
    if (!key) return AVATAR_COLORS[0];
    let hash = 0;
    for(let i = 0; i < key.length; i++)hash = key.charCodeAt(i) + ((hash << 5) - hash);
    const colorIndex = Math.abs(hash) % AVATAR_COLORS.length;
    return AVATAR_COLORS[colorIndex];
}
function getProfileLetterAvatarLetter(displayName) {
    if (displayName == null || String(displayName).trim() === "") return "?";
    const cleanName = String(displayName).replace(/_/g, " ").trim();
    return cleanName.charAt(0).toUpperCase() || "?";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eCRxx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Same as {@link Link}, but in-app `/profile` targets open the global profile overlay without changing the URL.
 * When already on `/profile` or `/edit-profile`, uses normal client navigation so the route updates.
 */ parcelHelpers.export(exports, "ProfileLink", ()=>ProfileLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _profileModalNavigation = require("../../utils/profileModalNavigation");
var _profileGlobalModalContext = require("./ProfileGlobalModalContext");
function ProfileLink({ to, state, onClick, replace, ...rest }) {
    const href = (0, _reactRouterDom.useHref)(to);
    const location = (0, _reactRouterDom.useLocation)();
    const { openProfileFromHref } = (0, _profileGlobalModalContext.useProfileGlobalModal)();
    if (!(0, _profileModalNavigation.isProfileHref)(href)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: to,
        state: state,
        onClick: onClick,
        replace: replace,
        ...rest
    });
    if (location.pathname === "/profile" || location.pathname === "/edit-profile") return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: to,
        state: state,
        onClick: onClick,
        replace: replace,
        ...rest
    });
    const handleClick = (e)=>{
        onClick?.(e);
        if (e.defaultPrevented) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        openProfileFromHref(href);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: href,
        onClick: handleClick,
        ...rest
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../../utils/profileModalNavigation":"eBA1i","./ProfileGlobalModalContext":"eilDL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h9Unj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Backend default display names before the user picks a real name (e.g. `PlayerAB123`). */ parcelHelpers.export(exports, "isAutoAssignedPlayerName", ()=>isAutoAssignedPlayerName);
/**
 * Profile milestone was originally localStorage-only; infer from account data so long-time users
 * who customised before milestones existed (or saved outside the hook path) are not nagged.
 *
 * Does not treat preset `avatar_key` alone as customised (signup often sets a key while
 * `avatar_url` stays empty until a custom image). Does not treat auto `PlayerAB123`-style names
 * as a chosen display name.
 *
 * OAuth/social `original_avatar` alone does not count — users must set a profile avatar in-app
 * (`avatar_url` or milestone) or satisfy another signal below.
 */ parcelHelpers.export(exports, "inferMyZoneProfileCompleteFromSessionUser", ()=>inferMyZoneProfileCompleteFromSessionUser);
parcelHelpers.export(exports, "MYZONE_ONBOARDING_MILESTONE_EVENT", ()=>MYZONE_ONBOARDING_MILESTONE_EVENT);
parcelHelpers.export(exports, "notifyMyZoneOnboardingMilestone", ()=>notifyMyZoneOnboardingMilestone);
/** True if the account has ever completed a wheel spin (not only today). */ parcelHelpers.export(exports, "hasEverCompletedWheelSpin", ()=>hasEverCompletedWheelSpin);
/** True when verifysession `games` shows any mini-game with a non-zero played count. */ parcelHelpers.export(exports, "hasAnyPlayedGamesFromSession", ()=>hasAnyPlayedGamesFromSession);
parcelHelpers.export(exports, "markMyZoneOnboardingMilestone", ()=>markMyZoneOnboardingMilestone);
/** True when a milestone is already persisted for this account (skip backfill for it). */ parcelHelpers.export(exports, "hasStoredMilestone", ()=>hasStoredMilestone);
/**
 * Storage-first backfill: read localStorage, infer missing milestones from session/friends
 * data (no extra API except play history), persist so the next visit reads storage only.
 */ parcelHelpers.export(exports, "ensureOnboardingMilestonesPersisted", ()=>ensureOnboardingMilestonesPersisted);
parcelHelpers.export(exports, "getMyZoneOnboardingCompletion", ()=>getMyZoneOnboardingCompletion);
function isAutoAssignedPlayerName(name) {
    const s = typeof name === "string" ? name.trim() : "";
    if (s.length < 3) return false;
    return /^Player[A-Za-z0-9]+$/i.test(s);
}
/** True when session favourites have any non-empty value (teams, sports, grid picks, etc.). */ function hasAnyFavouriteSelection(f) {
    if (!f || typeof f !== "object") return false;
    const keys = [
        "favsports",
        "favcricketers",
        "faviplteams",
        "favnationalteams",
        "favfootballteams",
        "favcustomcricketteams"
    ];
    return keys.some((k)=>{
        const v = f[k];
        return typeof v === "string" && v.trim() !== "";
    });
}
function inferMyZoneProfileCompleteFromSessionUser(user) {
    if (!user) return false;
    const customAvatarUrl = user.avatar_url;
    const fromAvatarUrl = typeof customAvatarUrl === "string" && customAvatarUrl.trim() !== "";
    const fromFavourites = hasAnyFavouriteSelection(user.favourites);
    const pnRaw = user.player_name?.trim() ?? "";
    const fromCustomPlayerName = pnRaw !== "" && !isAutoAssignedPlayerName(pnRaw);
    return fromAvatarUrl || fromFavourites || fromCustomPlayerName;
}
const MYZONE_ONBOARDING_MILESTONE_EVENT = "c8-myzone-onboarding-milestone";
function storageKey(userId) {
    return `c8_myzone_ob_${String(userId)}`;
}
function readStored(userId) {
    try {
        const raw = window.localStorage.getItem(storageKey(userId));
        if (!raw) return {};
        const o = JSON.parse(raw);
        if (!o || typeof o !== "object") return {};
        return o;
    } catch  {
        return {};
    }
}
function writeStored(userId, next) {
    try {
        window.localStorage.setItem(storageKey(userId), JSON.stringify(next));
    } catch  {
    /* ignore */ }
}
function notifyMyZoneOnboardingMilestone() {
    try {
        window.dispatchEvent(new CustomEvent(MYZONE_ONBOARDING_MILESTONE_EVENT));
    } catch  {
    /* ignore */ }
}
function hasEverCompletedWheelSpin(games) {
    if (!games || !Array.isArray(games)) return false;
    const entry = games.find((g)=>g?.name === "wheel-spin");
    const played = entry?.values?.played;
    if (typeof played === "number" && Number.isFinite(played) && played > 0) return true;
    const n = Number(played);
    return Number.isFinite(n) && n > 0;
}
function hasAnyPlayedGamesFromSession(games) {
    if (!games || !Array.isArray(games)) return false;
    return games.some((g)=>{
        const played = g?.values?.played;
        if (typeof played === "number" && Number.isFinite(played) && played > 0) return true;
        const n = Number(played);
        return Number.isFinite(n) && n > 0;
    });
}
function markMyZoneOnboardingMilestone(userId, milestone) {
    if (userId == null || userId === "") return;
    const uid = typeof userId === "number" ? userId : String(userId);
    const prev = readStored(uid);
    if (prev[milestone]) return;
    writeStored(uid, {
        ...prev,
        [milestone]: true
    });
    notifyMyZoneOnboardingMilestone();
}
function hasStoredMilestone(userId, milestone) {
    if (userId == null || userId === "") return false;
    const uid = typeof userId === "number" ? userId : String(userId);
    return Boolean(readStored(uid)[milestone]);
}
function ensureOnboardingMilestonesPersisted(input) {
    const { userId, user, games, hasAnyMyGamesEntry, myZoneFriendsLoaded = false, myZoneFriendCount = 0, deferProfileSessionInference = false } = input;
    const uid = typeof userId === "number" ? userId : String(userId);
    let stored = readStored(uid);
    if (!stored.profile && !deferProfileSessionInference && inferMyZoneProfileCompleteFromSessionUser(user)) {
        markMyZoneOnboardingMilestone(uid, "profile");
        stored = readStored(uid);
    }
    if (!stored.spin && hasEverCompletedWheelSpin(games)) {
        markMyZoneOnboardingMilestone(uid, "spin");
        stored = readStored(uid);
    }
    if (!stored.invite && myZoneFriendsLoaded && Number.isFinite(Number(myZoneFriendCount)) && Number(myZoneFriendCount) > 0) {
        markMyZoneOnboardingMilestone(uid, "invite");
        stored = readStored(uid);
    }
    if (stored.play) return {
        needsPlayHistoryApi: false
    };
    if (hasAnyPlayedGamesFromSession(games)) {
        markMyZoneOnboardingMilestone(uid, "play");
        return {
            needsPlayHistoryApi: false
        };
    }
    if (hasAnyMyGamesEntry) {
        markMyZoneOnboardingMilestone(uid, "play");
        return {
            needsPlayHistoryApi: false
        };
    }
    return {
        needsPlayHistoryApi: true
    };
}
function getMyZoneOnboardingCompletion(userId, opts) {
    const base = {
        play: false,
        profile: false,
        invite: false,
        spin: false
    };
    if (userId == null || userId === "") return {
        ...base,
        anyComplete: false
    };
    const uid = typeof userId === "number" ? userId : String(userId);
    const stored = readStored(uid);
    const play = Boolean(stored.play) || opts.hasAnyMyGamesEntry || hasAnyPlayedGamesFromSession(opts.games);
    const spin = Boolean(stored.spin) || hasEverCompletedWheelSpin(opts.games);
    const profile = Boolean(stored.profile) || !opts.deferProfileSessionInference && inferMyZoneProfileCompleteFromSessionUser(opts.user);
    const friendsLoaded = Boolean(opts.myZoneFriendsLoaded);
    const friendCount = Number(opts.myZoneFriendCount);
    const invite = Boolean(stored.invite) || friendsLoaded && Number.isFinite(friendCount) && friendCount > 0;
    const merged = {
        play,
        profile,
        invite,
        spin
    };
    const anyComplete = play || profile || invite || spin;
    return {
        ...merged,
        anyComplete
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1firO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Debounces handler across multiple window events (e.g. Header SSE fan-out).
 * Uses a ref so the latest handler runs without re-subscribing on every render.
 */ parcelHelpers.export(exports, "useDebouncedWindowEvents", ()=>useDebouncedWindowEvents);
/**
 * Rare visible-only safety poll when SSE/events might be missed (tab sleep, reconnect gaps).
 * Self-scheduling with jitter + in-flight guard to avoid overlap.
 */ parcelHelpers.export(exports, "useVisibleStaleFallback", ()=>useVisibleStaleFallback);
var _react = require("react");
function useDebouncedWindowEvents(eventNames, handler, debounceMs, enabled = true) {
    const handlerRef = (0, _react.useRef)(handler);
    handlerRef.current = handler;
    const key = eventNames.join("\0");
    (0, _react.useEffect)(()=>{
        if (!enabled) return;
        let t = null;
        const run = ()=>{
            if (t) clearTimeout(t);
            t = setTimeout(()=>{
                t = null;
                handlerRef.current();
            }, debounceMs);
        };
        for (const ev of eventNames)window.addEventListener(ev, run);
        return ()=>{
            if (t) clearTimeout(t);
            for (const ev of eventNames)window.removeEventListener(ev, run);
        };
    }, [
        enabled,
        debounceMs,
        key
    ]);
}
const DEFAULT_VISIBLE_FALLBACK_MS = 120000;
const DEFAULT_JITTER_MS = 20000;
function useVisibleStaleFallback(callback, enabled, intervalMs = DEFAULT_VISIBLE_FALLBACK_MS, jitterMs = DEFAULT_JITTER_MS) {
    const callbackRef = (0, _react.useRef)(callback);
    callbackRef.current = callback;
    (0, _react.useEffect)(()=>{
        if (!enabled) return;
        let cancelled = false;
        let timeoutId = null;
        let inFlight = false;
        const schedule = ()=>{
            const jitter = Math.floor(Math.random() * jitterMs);
            timeoutId = setTimeout(()=>void run(), intervalMs + jitter);
        };
        const run = async ()=>{
            if (cancelled) return;
            if (typeof document !== "undefined" && document.visibilityState !== "visible") {
                schedule();
                return;
            }
            if (inFlight) {
                schedule();
                return;
            }
            inFlight = true;
            try {
                await Promise.resolve(callbackRef.current());
            } finally{
                inFlight = false;
                schedule();
            }
        };
        schedule();
        return ()=>{
            cancelled = true;
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        enabled,
        intervalMs,
        jitterMs
    ]);
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gNFUK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Same CTA pill as notification rows — used by `PublicProfile` custom rows. */ parcelHelpers.export(exports, "ACTIVITY_ACTION_BUTTON", ()=>(0, _notificationDisplay.NOTIFICATION_CTA_PILL_CLASS));
parcelHelpers.export(exports, "mapDigestRows", ()=>mapDigestRows);
parcelHelpers.export(exports, "default", ()=>FriendActivityTimeline);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _profileLink = require("../Profile/ProfileLink");
var _profileGlobalModalContext = require("../Profile/ProfileGlobalModalContext");
var _userAvatar = require("../Profile/UserAvatar");
var _avatarWithXpCrown = require("../Xp/AvatarWithXpCrown");
var _avatarFrame = require("../Profile/avatarFrame");
var _sessionUser = require("../../utils/sessionUser");
var _friendDisplayName = require("../../utils/friendDisplayName");
var _matchNameDisplay = require("../../utils/matchNameDisplay");
var _traderActivityNavigation = require("../../utils/traderActivityNavigation");
var _profileModalNavigation = require("../../utils/profileModalNavigation");
var _notificationDisplay = require("../notifications/notificationDisplay");
var _notificationItemRow = require("../notifications/NotificationItemRow");
var _notificationTaxonomy = require("../notifications/notificationTaxonomy");
var _xp = require("../../utils/xp");
/**
 * Friends Activity merges `friend_earned_xp` notifications with digest `recentXpResults`.
 * Without dedupe, the same grant (e.g. daily Trader leaderboard) appears twice.
 */ function friendXpDigestCoverageKeys(digests) {
    const keys = new Set();
    for (const f of digests){
        const uid = Number(f.userId);
        if (!uid) continue;
        for (const xp of f.recentXpResults ?? []){
            const reason = String(xp?.reason ?? "").trim();
            if (!reason || reason === "xp_friends_batch" || reason.startsWith("xp_friends_batch:")) continue;
            keys.add(`${uid}::${reason}`);
        }
    }
    return keys;
}
function isFriendEarnedXpCoveredByDigest(notification, covered) {
    if (notification.type !== "friend_earned_xp") return false;
    const sender = notification.sender;
    const senderId = Number(notification.sender_id ?? sender?.userId);
    if (!senderId) return false;
    const { reason } = (0, _notificationDisplay.parseXpEntityRef)(typeof notification.entity_ref === "string" ? notification.entity_ref : "");
    const r = String(reason ?? "").trim();
    if (!r || r === "xp_friends_batch" || r.startsWith("xp_friends_batch:")) return false;
    return covered.has(`${senderId}::${r}`);
}
const NotificationItemRow = (0, _notificationItemRow.NotificationItemRow);
const ACTIVITY_CTA_RAIL_PLACEHOLDER_CLASS = "inline-flex h-[22px] min-w-[4rem] w-[4rem] shrink-0 sm:min-w-[5.25rem] sm:w-[5.25rem]";
const ACTIVITY_PANEL_CTA_RAIL_PLACEHOLDER_CLASS = "inline-flex h-[30px] min-w-[4rem] w-[4rem] shrink-0 sm:min-w-[5.25rem] sm:w-[5.25rem]";
/** Profile modal: tighter than drawer — less space between avatar and copy / time and CTA. */ const ACTIVITY_STREAM_MAIN_TEXT_PAD_PROFILE = "min-h-0 py-0 pl-0 pr-0.5 sm:pr-1";
function bullionPlayTo(matchId, gameId) {
    const q = new URLSearchParams();
    q.set("match", matchId);
    q.set("game", String(gameId));
    return `/bullion?${q.toString()}`;
}
function traderPlayTo(matchId, sportRaw) {
    const sport = (0, _traderActivityNavigation.traderUrlSportParam)(String(sportRaw || "cricket").trim().toLowerCase());
    if (sport === "horses") return `/trader?raceId=${encodeURIComponent(matchId)}&sport=horses`;
    return `/trader?matchId=${encodeURIComponent(matchId)}&sport=${encodeURIComponent(sport)}`;
}
function toTimeValue(value) {
    if (!value) return 0;
    const t = new Date(value).getTime();
    return Number.isNaN(t) ? 0 : t;
}
/** Dedupe key for friend settled-result rows (multiple trades can share match + settled_at). */ function settledResultIdentity(row) {
    return [
        String(row.settled_at ?? ""),
        String(row.match_id ?? ""),
        String(row.outcome ?? ""),
        String(Number(row.net_coins ?? 0)),
        String(row.sport ?? ""),
        row.over_number != null ? String(row.over_number) : ""
    ].join("\u001f");
}
function settledResultReactKey(prefix, userId, row, seq) {
    return `${prefix}-${userId}-${settledResultIdentity(row).replace(/\u001f/g, "-")}-${seq}`;
}
function formatCoinAmount(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return "0";
    return String(Math.round(Math.abs(n)));
}
function normalizeGameLabel(value) {
    const raw = String(value || "").trim().toUpperCase();
    if (raw === "SQUARES") return "SQUARES";
    if (raw === "BULLION") return "BULLION";
    if (raw === "SIXES") return "SIXES";
    return "TRADER";
}
function gameIconFor(label) {
    if (label === "SQUARES") return "/assets/squares.png";
    if (label === "BULLION") return "/assets/bullion.png";
    if (label === "SIXES") return "/assets/sixes.png";
    return "/assets/trader.png";
}
function toOverInt(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return null;
    const i = Math.trunc(n);
    if (i <= 0) return null;
    return i;
}
function isNearInTime(aMs, bMs, windowMs = 21600000) {
    if (!aMs || !bMs) return false;
    return Math.abs(aMs - bMs) <= windowMs;
}
const RECORD_STREAK_ACTIVITY_WINDOW_MS = 604800000;
function isRecentIsoWithin(iso, windowMs) {
    const ts = toTimeValue(iso);
    if (!ts) return false;
    return Date.now() - ts <= windowMs;
}
function activityMatchTitleForRow(matchName, matchId) {
    const id = matchId?.trim() ?? "";
    if ((0, _traderActivityNavigation.hasReadableActivityMatchName)(matchName, id)) {
        const a = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName);
        if (a) return a;
    }
    return "a match";
}
/** One timeline row per friend per Squares match; prefer a shared over with the viewer when possible. */ function mergeFriendSquaresStartedRows(rows, friendUserId, myActiveSquares) {
    const byMatch = new Map();
    for (const r of rows){
        const mid = String(r.matchId || "").trim();
        if (!mid) continue;
        const list = byMatch.get(mid);
        if (list) list.push(r);
        else byMatch.set(mid, [
            r
        ]);
    }
    const out = [];
    for (const [matchId, group] of byMatch){
        if (group.length === 1) {
            out.push(group[0]);
            continue;
        }
        const myOvers = new Set();
        for (const s of myActiveSquares){
            if (String(s.match_id || "").trim() !== matchId) continue;
            const o = toOverInt(s.over ?? s.over_number ?? null);
            if (o != null) myOvers.add(o);
        }
        const withOver = group.map((g)=>({
                row: g,
                overInt: toOverInt(g.overNumber)
            }));
        let chosenOver = null;
        if (myOvers.size > 0) {
            const hit = withOver.filter((x)=>x.overInt != null && myOvers.has(x.overInt));
            if (hit.length > 0) {
                hit.sort((a, b)=>b.row.ts - a.row.ts);
                chosenOver = hit[0].overInt;
            }
        }
        if (chosenOver == null) {
            const distinct = new Set(withOver.map((x)=>x.overInt).filter((o)=>o != null));
            if (distinct.size === 1) chosenOver = distinct.values().next().value ?? null;
        }
        const bestTs = Math.max(...group.map((g)=>g.ts));
        const pickRow = chosenOver != null ? withOver.find((x)=>x.overInt === chosenOver)?.row ?? group[0] : group.reduce((a, b)=>a.ts >= b.ts ? a : b);
        out.push({
            key: `started-sq-${friendUserId}-${matchId}-merged`,
            ts: bestTs,
            name: group[0].name,
            profileTo: group[0].profileTo,
            gameLabel: "SQUARES",
            avatar: group[0].avatar,
            xp_week_crown: group[0].xp_week_crown ?? null,
            avatarFrame: group[0].avatarFrame,
            matchId,
            matchTo: `/squares?match=${encodeURIComponent(matchId)}`,
            overNumber: chosenOver,
            matchName: pickRow.matchName ?? group[0].matchName,
            startedAt: pickRow.startedAt ?? group[0].startedAt ?? null
        });
    }
    return out;
}
function mapDigestRows(data) {
    const rows = data.activity ?? [];
    return rows.filter((r)=>r.friend).map((r)=>({
            ...r.friend,
            traderGamesPlayed: r.traderGamesPlayed,
            traderGamesWon: r.traderGamesWon,
            winRatio: r.winRatio ?? null,
            lastPlayedGame: r.lastPlayedGame ?? null,
            lastPlayedSport: r.lastPlayedSport ?? null,
            lastPlayedAt: r.lastPlayedAt ?? null,
            currentStreak: r.currentStreak ?? 0,
            bestStreak: r.bestStreak ?? 0,
            currentStreakNewestSettledAt: r.currentStreakNewestSettledAt ?? null,
            bestStreakNewestSettledAt: r.bestStreakNewestSettledAt ?? null,
            latestTraderResult: r.latestTraderResult ?? null,
            latestSquaresResult: r.latestSquaresResult ?? null,
            recentTraderResults: r.recentTraderResults ?? [],
            recentSquaresResults: r.recentSquaresResults ?? [],
            latestBullionResult: r.latestBullionResult ?? null,
            recentBullionResults: r.recentBullionResults ?? [],
            latestBullionPersonalBest: r.latestBullionPersonalBest ?? null,
            latestSixesResult: r.latestSixesResult ?? null,
            recentSixesResults: r.recentSixesResults ?? [],
            recentXpResults: r.recentXpResults ?? [],
            recentXpWeekPodium: r.recentXpWeekPodium ?? []
        }));
}
function ActivityStreamRow({ surface, profileTo, profileModalState, onProfileLinkClick, avatarSrc, displayName, avatarColor, firstLetter, xpWeekCrown, avatarFrame, middle, timeLabel, ctaSlot }) {
    const isPanel = surface === "panel";
    const rowGridClass = isPanel ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_ROW_GRID_CLASS) : (0, _notificationDisplay.NOTIFICATION_ACTIVITY_STREAM_ROW_GRID_CLASS);
    const avatarClass = isPanel ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_AVATAR_CLASS) : (0, _notificationDisplay.NOTIFICATION_AVATAR_STREAM_CLASS);
    const frameSrc = (0, _avatarFrame.resolveAvatarFrameSrc)(isPanel ? "md" : "sm", avatarFrame?.avatarFrameUrl, avatarFrame?.avatarFrameSmallUrl);
    const timeClass = isPanel ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_TIME_CLASS) : (0, _notificationDisplay.NOTIFICATION_STREAM_TIME_SIDE_CLASS);
    const mainTextPadClass = isPanel ? "min-h-0 py-0 pl-1 pr-1" : surface === "profile" ? ACTIVITY_STREAM_MAIN_TEXT_PAD_PROFILE : (0, _notificationDisplay.NOTIFICATION_MAIN_TEXT_PAD);
    const timePrClass = isPanel ? "" : surface === "profile" ? "pr-0 sm:pr-0.5" : "pr-0.5 sm:pr-1";
    const linkGapClass = isPanel ? "gap-2" : "gap-1 sm:gap-1.5";
    const sideGapClass = isPanel ? "gap-1" : "gap-1 sm:gap-1.5";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: rowGridClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _profileLink.ProfileLink), {
                to: profileTo,
                state: profileModalState,
                onClick: onProfileLinkClick,
                className: `col-span-2 grid [grid-template-columns:subgrid] min-h-0 min-w-0 items-center text-left ${linkGapClass}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: avatarClass,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarWithXpCrown.AvatarWithXpCrown), {
                            crown: xpWeekCrown,
                            frameSrc: frameSrc,
                            className: "block h-full w-full overflow-hidden",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAvatar.UserAvatar), {
                                src: avatarSrc,
                                displayName: displayName,
                                avatarColor: avatarColor,
                                firstLetter: firstLetter,
                                size: "fill",
                                withCrown: false
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `min-w-0 self-center ${mainTextPadClass}`,
                        children: middle
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `flex min-h-0 shrink-0 flex-row items-center justify-end self-center ${sideGapClass}`,
                children: [
                    timeLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: `${timeClass} inline-block max-w-[4rem] shrink-0 truncate tabular-nums sm:max-w-[4.5rem] ${timePrClass}`,
                        children: timeLabel
                    }) : null,
                    ctaSlot
                ]
            })
        ]
    });
}
function ActivitySkeletonRows({ count = 3 }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        className: "space-y-1.5",
        "aria-hidden": true,
        children: Array.from({
            length: Math.max(1, count)
        }).map((_, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                className: "overflow-hidden",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: (0, _notificationDisplay.NOTIFICATION_ACTIVITY_STREAM_ROW_GRID_CLASS),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "col-span-2 grid [grid-template-columns:subgrid] min-h-0 min-w-0 items-center gap-1 sm:gap-1.5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: `${(0, _notificationDisplay.NOTIFICATION_AVATAR_STREAM_CLASS)} animate-pulse bg-white/10`
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "min-w-0 self-center py-0.5 pr-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "h-3 w-[85%] animate-pulse bg-white/12"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "mt-1 h-3 w-[60%] animate-pulse bg-white/8"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex min-h-0 shrink-0 flex-row items-center justify-end gap-1 self-center sm:gap-1.5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "h-3 w-10 animate-pulse bg-white/12"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "h-[22px] w-[4.5rem] animate-pulse bg-white/10 sm:w-[5.25rem]"
                                })
                            ]
                        })
                    ]
                })
            }, `activity-skeleton-${idx}`))
    });
}
function FriendActivityTimeline({ digests, liveFriends, myTrades, mySquares, notifications, profileModalState, loading, visibleCount, surface, onNotificationRead, loadingMore = false, emptyMessage = "No recent activity yet. Add friends \u2014 updates will show here.", onProfileLinkClick, onTotalRowsChange, enableInfiniteScroll = false, infiniteScrollStep = 10, isOwnProfileView = false, hasMoreServerRows = false, serverLoadingMore = false, onReachEnd }) {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { dismissProfileModalForNavigation } = (0, _profileGlobalModalContext.useProfileGlobalModal)();
    const handleActivityCtaClick = (0, _react.useCallback)((e, to, linkState)=>{
        if ((0, _profileModalNavigation.isProfileHref)(to)) {
            onProfileLinkClick?.();
            return;
        }
        e.preventDefault();
        dismissProfileModalForNavigation();
        navigate(to, linkState ? {
            state: linkState
        } : undefined);
    }, [
        dismissProfileModalForNavigation,
        navigate,
        onProfileLinkClick
    ]);
    const [infiniteVisibleCount, setInfiniteVisibleCount] = (0, _react.useState)(visibleCount);
    const infiniteSentinelRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        setInfiniteVisibleCount(visibleCount);
    }, [
        visibleCount,
        enableInfiniteScroll
    ]);
    const renderGameToken = (gameRaw)=>{
        const game = normalizeGameLabel(gameRaw);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            className: "inline-flex items-center gap-1 align-middle font-anton text-[10px] font-normal uppercase leading-[18px] sm:text-[11px] sm:leading-[20px]",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: gameIconFor(game),
                    alt: "",
                    className: "h-4 w-4 object-contain sm:h-[18px] sm:w-[18px]",
                    loading: "lazy",
                    decoding: "async"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: game
                })
            ]
        });
    };
    const { digestRows, settledResultRows, xpResultRows, startedPlayingRows, timelineRows } = (0, _react.useMemo)(()=>{
        const xpDigestCovered = friendXpDigestCoverageKeys(digests);
        const timelineNotifications = notifications.filter((n)=>!(0, _notificationTaxonomy.isAcknowledgedFriendChallenge)(n) && !isFriendEarnedXpCoveredByDigest(n, xpDigestCovered));
        const notificationRowsInner = timelineNotifications.map((n)=>({
                key: `notif-${String(n.id ?? Math.random())}`,
                ts: toTimeValue(n.created_at ?? null),
                node: n
            }));
        const myActiveSquaresInner = mySquares.filter((s)=>s.settled !== true);
        const startedPlayingRowsInner = liveFriends.flatMap((f)=>{
            const name = (0, _friendDisplayName.playerHandleName)(f);
            const profileTo = f.player_id ? `/profile?p=${encodeURIComponent(f.player_id)}` : `/profile?u=${f.userId}`;
            const avatar = (0, _sessionUser.resolveAvatarUrl)(f);
            const xpWeekCrown = f.xp_week_crown ?? null;
            const avatarFrame = (0, _avatarFrame.avatarFrameProps)(f);
            const traderRowsRaw = Array.isArray(f.active_plays?.trader) ? f.active_plays?.trader || [] : f.active_play?.trader ? [
                f.active_play.trader
            ] : [];
            const squaresRowsRaw = Array.isArray(f.active_plays?.squares) ? f.active_plays?.squares || [] : f.active_play?.squares ? [
                f.active_play.squares
            ] : [];
            const bullionRowsRaw = Array.isArray(f.active_plays?.bullion) ? f.active_plays?.bullion || [] : f.active_play?.bullion ? [
                f.active_play.bullion
            ] : [];
            const sixesRowsRaw = Array.isArray(f.active_plays?.sixes) ? f.active_plays?.sixes || [] : f.active_play?.sixes ? [
                f.active_play.sixes
            ] : [];
            const traderRows = traderRowsRaw.map((t)=>({
                    key: `started-tr-${f.userId}-${t.match_id}-${String(t.started_at || "")}`,
                    ts: toTimeValue(t.started_at ?? null),
                    name,
                    profileTo,
                    gameLabel: "TRADER",
                    avatar,
                    xp_week_crown: xpWeekCrown,
                    avatarFrame,
                    matchId: t.match_id ?? null,
                    matchTo: t.match_id ? traderPlayTo(t.match_id, t.sport) : null,
                    overNumber: null,
                    matchName: t.match_name ?? null,
                    startedAt: t.started_at != null ? String(t.started_at) : null
                }));
            const squaresRows = squaresRowsRaw.map((s)=>({
                    key: `started-sq-${f.userId}-${s.match_id}-${String(s.started_at || "")}`,
                    ts: toTimeValue(s.started_at ?? null),
                    name,
                    profileTo,
                    gameLabel: "SQUARES",
                    avatar,
                    xp_week_crown: xpWeekCrown,
                    avatarFrame,
                    matchId: s.match_id ?? null,
                    matchTo: s.match_id ? `/squares?match=${encodeURIComponent(s.match_id)}` : null,
                    overNumber: s.over_number ?? null,
                    matchName: s.match_name ?? null,
                    startedAt: s.started_at != null ? String(s.started_at) : null
                }));
            const squaresMerged = mergeFriendSquaresStartedRows(squaresRows, f.userId, myActiveSquaresInner);
            const bullionRows = bullionRowsRaw.map((fv)=>{
                const matchId = fv.match_id ?? "";
                const gameId = Number(fv.game_id);
                const isPrivate = String(fv.visibility || "").trim().toLowerCase() === "private";
                return {
                    key: `started-fo-${f.userId}-${matchId}-${gameId}-${String(fv.started_at || "")}`,
                    ts: toTimeValue(fv.started_at ?? null),
                    name,
                    profileTo,
                    gameLabel: "BULLION",
                    avatar,
                    xp_week_crown: xpWeekCrown,
                    avatarFrame,
                    matchId: matchId || null,
                    matchTo: matchId && Number.isFinite(gameId) && gameId > 0 ? bullionPlayTo(matchId, gameId) : null,
                    overNumber: null,
                    matchName: fv.match_name ?? null,
                    startedAt: fv.started_at != null ? String(fv.started_at) : null,
                    bullionEntryKind: isPrivate ? "private_battle" : "public_arena",
                    ctaTo: isPrivate ? profileTo : matchId && gameId > 0 ? bullionPlayTo(matchId, gameId) : null,
                    ctaLabel: isPrivate ? "PROFILE" : "PLAY"
                };
            });
            const sixesRows = sixesRowsRaw.map((sv)=>{
                const matchId = sv.match_id ?? "";
                return {
                    key: `started-sx-${f.userId}-${matchId}-${String(sv.started_at || "")}`,
                    ts: toTimeValue(sv.started_at ?? null),
                    name,
                    profileTo,
                    gameLabel: "SIXES",
                    avatar,
                    xp_week_crown: xpWeekCrown,
                    avatarFrame,
                    matchId: matchId || null,
                    matchTo: "/sixes",
                    overNumber: null,
                    matchName: sv.match_name ?? null,
                    startedAt: sv.started_at != null ? String(sv.started_at) : null,
                    ctaTo: "/sixes",
                    ctaLabel: "PLAY"
                };
            });
            return [
                ...sixesRows,
                ...bullionRows,
                ...squaresMerged,
                ...traderRows
            ];
        });
        const digestRowsInner = digests.flatMap((f)=>{
            const name = (0, _friendDisplayName.playerHandleName)(f);
            const profileTo = f.player_id ? `/profile?p=${encodeURIComponent(f.player_id)}` : `/profile?u=${f.userId}`;
            const avatar = (0, _sessionUser.resolveAvatarUrl)(f) || "";
            const xpWeekCrown = f.xp_week_crown ?? null;
            const avatarFrame = (0, _avatarFrame.avatarFrameProps)(f);
            const baseTs = toTimeValue(f.lastPlayedAt ?? null);
            const currentStreak = Number(f.currentStreak || 0);
            const bestStreak = Number(f.bestStreak || 0);
            const lastPlayedAtIso = f.lastPlayedAt != null ? String(f.lastPlayedAt) : null;
            /** Shown in the row (“Xm” / date) — real `settled_at` of newest trade in the streak / PB run. */ const streakDisplayIso = f.currentStreakNewestSettledAt != null && String(f.currentStreakNewestSettledAt).trim() !== "" ? String(f.currentStreakNewestSettledAt) : lastPlayedAtIso;
            const pbDisplayIso = f.bestStreakNewestSettledAt != null && String(f.bestStreakNewestSettledAt).trim() !== "" ? String(f.bestStreakNewestSettledAt) : lastPlayedAtIso;
            /**
       * Sort key for merged timeline only: keep digest rows stacked with newest digest timestamp so they are not
       * pushed below `visibleCount` by older real streak timestamps vs. fresh notifications.
       */ const streakSortTs = baseTs > 0 ? baseTs - 1 : Math.max(0, toTimeValue(streakDisplayIso)) || (currentStreak >= 2 ? -1 : 0);
            const pbSortTs = baseTs > 0 ? baseTs - (currentStreak >= 2 ? 2 : 1) : Math.max(0, toTimeValue(pbDisplayIso)) || (bestStreak >= 3 ? -2 : 0);
            const out = [];
            if (currentStreak >= 2) out.push({
                key: `digest-${f.userId}-streak`,
                ts: streakSortTs,
                name,
                profileTo,
                avatar,
                xp_week_crown: xpWeekCrown,
                avatarFrame,
                digestVariant: "streak",
                streakValue: currentStreak,
                lastPlayedAt: lastPlayedAtIso,
                digestDisplayAt: streakDisplayIso
            });
            if (bestStreak >= 3 && isRecentIsoWithin(pbDisplayIso, RECORD_STREAK_ACTIVITY_WINDOW_MS)) out.push({
                key: `digest-${f.userId}-pb`,
                ts: pbSortTs,
                name,
                profileTo,
                avatar,
                xp_week_crown: xpWeekCrown,
                avatarFrame,
                digestVariant: "pb",
                pbValue: bestStreak,
                lastPlayedAt: lastPlayedAtIso,
                digestDisplayAt: pbDisplayIso
            });
            const bullionPb = f.latestBullionPersonalBest;
            const bullionPbAt = bullionPb?.settled_at != null && String(bullionPb.settled_at).trim() !== "" ? String(bullionPb.settled_at) : null;
            const bullionPbPicks = Number(bullionPb?.correct_picks ?? 0);
            if (bullionPb && bullionPbPicks >= 1 && bullionPbAt && isRecentIsoWithin(bullionPbAt, RECORD_STREAK_ACTIVITY_WINDOW_MS)) out.push({
                key: `digest-${f.userId}-bullion-pb`,
                ts: Math.max(0, toTimeValue(bullionPbAt)),
                name,
                profileTo,
                avatar,
                xp_week_crown: xpWeekCrown,
                avatarFrame,
                digestVariant: "bullion_pb",
                bullionCorrectPicks: bullionPbPicks,
                lastPlayedAt: lastPlayedAtIso,
                digestDisplayAt: bullionPbAt
            });
            return out;
        });
        const settledResultRowsInner = digests.flatMap((f)=>{
            const name = (0, _friendDisplayName.playerHandleName)(f);
            const profileTo = f.player_id ? `/profile?p=${encodeURIComponent(f.player_id)}` : `/profile?u=${f.userId}`;
            const avatar = (0, _sessionUser.resolveAvatarUrl)(f) || "";
            const xpWeekCrown = f.xp_week_crown ?? null;
            const avatarFrame = (0, _avatarFrame.avatarFrameProps)(f);
            const rows = [];
            const sqRows = (Array.isArray(f.recentSquaresResults) && f.recentSquaresResults.length > 0 ? f.recentSquaresResults : f.latestSquaresResult ? [
                f.latestSquaresResult
            ] : []) || [];
            const seenSquaresResults = new Set();
            for (const sq of sqRows){
                if (!sq?.settled_at) continue;
                const identity = settledResultIdentity(sq);
                if (seenSquaresResults.has(identity)) continue;
                seenSquaresResults.add(identity);
                const matchId = sq.match_id || "";
                const coinsNum = Number(sq.net_coins || 0);
                // Voids (and break-even) are 0 P&L — do not report as "lost 0 coins".
                if (String(sq.outcome ?? "").trim().toUpperCase() === "VOID" || coinsNum === 0) continue;
                rows.push({
                    key: settledResultReactKey("result-sq", f.userId, sq, rows.length),
                    ts: toTimeValue(sq.settled_at),
                    name,
                    profileTo,
                    avatar,
                    xp_week_crown: xpWeekCrown,
                    avatarFrame,
                    gameLabel: "SQUARES",
                    didWin: coinsNum > 0,
                    coins: formatCoinAmount(coinsNum),
                    matchId: matchId || null,
                    matchTo: matchId ? `/matches?id=${encodeURIComponent(matchId)}&status=complete` : null,
                    ctaTo: matchId ? `/matches?id=${encodeURIComponent(matchId)}&status=complete` : null,
                    ctaLabel: "MATCH",
                    matchLabel: activityMatchTitleForRow(sq.match_name),
                    overNumber: sq.over_number ?? null,
                    settledAt: String(sq.settled_at)
                });
            }
            const foRows = (Array.isArray(f.recentBullionResults) && f.recentBullionResults.length > 0 ? f.recentBullionResults : f.latestBullionResult ? [
                f.latestBullionResult
            ] : []) || [];
            const seenBullionResults = new Set();
            for (const fo of foRows){
                if (!fo?.settled_at) continue;
                const identity = [
                    String(fo.settled_at),
                    String(fo.match_id ?? ""),
                    String(fo.game_id ?? ""),
                    String(Number(fo.net_coins ?? 0))
                ].join("\u001f");
                if (seenBullionResults.has(identity)) continue;
                seenBullionResults.add(identity);
                const coinsNum = Number(fo.net_coins || 0);
                if (coinsNum <= 0) continue;
                rows.push({
                    key: `result-fo-${f.userId}-${identity.replace(/\u001f/g, "-")}-${rows.length}`,
                    ts: toTimeValue(fo.settled_at),
                    name,
                    profileTo,
                    avatar,
                    xp_week_crown: xpWeekCrown,
                    avatarFrame,
                    gameLabel: "BULLION",
                    didWin: true,
                    coins: formatCoinAmount(coinsNum),
                    matchId: fo.match_id || null,
                    matchTo: null,
                    ctaTo: profileTo,
                    ctaLabel: "PROFILE",
                    matchLabel: activityMatchTitleForRow(fo.match_name),
                    overNumber: null,
                    settledAt: String(fo.settled_at)
                });
            }
            const sxRows = (Array.isArray(f.recentSixesResults) && f.recentSixesResults.length > 0 ? f.recentSixesResults : f.latestSixesResult ? [
                f.latestSixesResult
            ] : []) || [];
            const seenSixesResults = new Set();
            for (const sx of sxRows){
                if (!sx?.settled_at) continue;
                const identity = [
                    String(sx.settled_at),
                    String(sx.match_id ?? ""),
                    String(Number(sx.net_coins ?? 0))
                ].join("\u001f");
                if (seenSixesResults.has(identity)) continue;
                seenSixesResults.add(identity);
                const coinsNum = Number(sx.net_coins || 0);
                if (coinsNum <= 0) continue;
                rows.push({
                    key: `result-sx-${f.userId}-${identity.replace(/\u001f/g, "-")}-${rows.length}`,
                    ts: toTimeValue(sx.settled_at),
                    name,
                    profileTo,
                    avatar,
                    xp_week_crown: xpWeekCrown,
                    avatarFrame,
                    gameLabel: "SIXES",
                    didWin: true,
                    coins: formatCoinAmount(coinsNum),
                    matchId: sx.match_id || null,
                    matchTo: null,
                    ctaTo: profileTo,
                    ctaLabel: "PROFILE",
                    matchLabel: activityMatchTitleForRow(sx.match_name),
                    overNumber: null,
                    settledAt: String(sx.settled_at)
                });
            }
            const trRows = (Array.isArray(f.recentTraderResults) && f.recentTraderResults.length > 0 ? f.recentTraderResults : f.latestTraderResult ? [
                f.latestTraderResult
            ] : []) || [];
            const seenTraderResults = new Set();
            for (const tr of trRows){
                if (!tr?.settled_at) continue;
                const identity = settledResultIdentity(tr);
                if (seenTraderResults.has(identity)) continue;
                seenTraderResults.add(identity);
                const matchId = tr.match_id || "";
                const coinsNum = Number(tr.net_coins || 0);
                // Voids (and break-even) are 0 P&L — do not report as "lost 0 coins".
                if (String(tr.outcome ?? "").trim().toUpperCase() === "VOID" || coinsNum === 0) continue;
                rows.push({
                    key: settledResultReactKey("result-tr", f.userId, tr, rows.length),
                    ts: toTimeValue(tr.settled_at),
                    name,
                    profileTo,
                    avatar,
                    xp_week_crown: xpWeekCrown,
                    avatarFrame,
                    gameLabel: "TRADER",
                    didWin: coinsNum > 0,
                    coins: formatCoinAmount(coinsNum),
                    matchId: matchId || null,
                    matchTo: matchId ? (0, _traderActivityNavigation.traderActivityMatchHref)(matchId, tr.match_name, tr.sport) : (0, _traderActivityNavigation.traderLobbyHref)(tr.sport),
                    ctaTo: matchId ? (0, _traderActivityNavigation.traderActivityMatchHref)(matchId, tr.match_name, tr.sport) : (0, _traderActivityNavigation.traderLobbyHref)(tr.sport),
                    ctaLabel: "MATCH",
                    matchLabel: activityMatchTitleForRow(tr.match_name, matchId),
                    overNumber: null,
                    settledAt: String(tr.settled_at)
                });
            }
            return rows;
        });
        const xpResultRowsInner = digests.flatMap((f)=>{
            const name = (0, _friendDisplayName.playerHandleName)(f);
            const profileTo = f.player_id ? `/profile?p=${encodeURIComponent(f.player_id)}` : `/profile?u=${f.userId}`;
            const avatar = (0, _sessionUser.resolveAvatarUrl)(f) || "";
            const xpWeekCrown = f.xp_week_crown ?? null;
            const avatarFrame = (0, _avatarFrame.avatarFrameProps)(f);
            const xpRows = Array.isArray(f.recentXpResults) ? f.recentXpResults : [];
            return xpRows.filter((xp)=>xp?.created_at).map((xp, i)=>({
                    key: `xp-${f.userId}-${String(xp.created_at)}-${String(xp.reason ?? "")}-${i}`,
                    ts: toTimeValue(xp.created_at ?? null),
                    name,
                    profileTo,
                    avatar,
                    xp_week_crown: xpWeekCrown,
                    avatarFrame,
                    amount: Number(xp.amount) || 0,
                    reasonDetail: (0, _xp.formatXpHistoryReasonDetail)(xp.reason),
                    createdAt: String(xp.created_at)
                }));
        });
        const xpWeekPodiumRowsInner = digests.flatMap((f)=>{
            const name = (0, _friendDisplayName.playerHandleName)(f);
            const profileTo = f.player_id ? `/profile?p=${encodeURIComponent(f.player_id)}` : `/profile?u=${f.userId}`;
            const avatar = (0, _sessionUser.resolveAvatarUrl)(f) || "";
            const avatarFrame = (0, _avatarFrame.avatarFrameProps)(f);
            const podiumRows = Array.isArray(f.recentXpWeekPodium) ? f.recentXpWeekPodium : [];
            return podiumRows.filter((p)=>p?.awarded_at || p?.period_id).map((p, i)=>{
                const rank = Number(p.rank) || 0;
                const crown = p.crown === "gold" || p.crown === "silver" || p.crown === "bronze" ? p.crown : rank === 1 ? "gold" : rank === 2 ? "silver" : rank === 3 ? "bronze" : null;
                return {
                    key: `xp-podium-${f.userId}-${String(p.period_id ?? "")}-${i}`,
                    ts: toTimeValue(p.awarded_at ?? null),
                    name,
                    profileTo,
                    avatar,
                    xp_week_crown: crown,
                    avatarFrame,
                    rankLabel: String(p.rank_label || "").trim() || "on the podium",
                    periodLabel: String(p.period_label || "").trim() || "last week",
                    xpValue: Number(p.xp_value) || 0,
                    awardedAt: p.awarded_at != null ? String(p.awarded_at) : ""
                };
            });
        });
        const timelineRowsInner = [
            ...notificationRowsInner.map((row)=>({
                    ...row,
                    kind: "notification"
                })),
            ...digestRowsInner.map((row)=>({
                    ...row,
                    kind: "digest"
                })),
            ...settledResultRowsInner.map((row)=>({
                    ...row,
                    kind: "result"
                })),
            ...xpResultRowsInner.map((row)=>({
                    ...row,
                    kind: "xp"
                })),
            ...xpWeekPodiumRowsInner.map((row)=>({
                    ...row,
                    kind: "xp_week_podium"
                })),
            ...startedPlayingRowsInner.map((row)=>({
                    ...row,
                    kind: "started"
                }))
        ].sort((a, b)=>b.ts - a.ts);
        return {
            digestRows: digestRowsInner,
            settledResultRows: settledResultRowsInner,
            xpResultRows: xpResultRowsInner,
            startedPlayingRows: startedPlayingRowsInner,
            timelineRows: timelineRowsInner
        };
    }, [
        digests,
        liveFriends,
        myTrades,
        mySquares,
        notifications
    ]);
    const totalTimelineRows = timelineRows.length;
    const effectiveVisibleCount = enableInfiniteScroll ? infiniteVisibleCount : visibleCount;
    const visibleTimelineRows = timelineRows.slice(0, effectiveVisibleCount);
    const hasMoreRows = enableInfiniteScroll && visibleTimelineRows.length < totalTimelineRows;
    (0, _react.useEffect)(()=>{
        onTotalRowsChange?.(totalTimelineRows);
    }, [
        totalTimelineRows,
        onTotalRowsChange
    ]);
    (0, _react.useEffect)(()=>{
        if (!hasMoreRows) return;
        const target = infiniteSentinelRef.current;
        if (!target) return;
        const observer = new IntersectionObserver((entries)=>{
            const first = entries[0];
            if (!first?.isIntersecting) return;
            if (visibleTimelineRows.length < totalTimelineRows) {
                setInfiniteVisibleCount((prev)=>Math.min(totalTimelineRows, prev + Math.max(1, Math.trunc(infiniteScrollStep))));
                return;
            }
            if (hasMoreServerRows && !serverLoadingMore) onReachEnd?.();
        }, {
            threshold: 0.1
        });
        observer.observe(target);
        return ()=>observer.disconnect();
    }, [
        hasMoreRows,
        totalTimelineRows,
        infiniteScrollStep,
        visibleTimelineRows.length,
        hasMoreServerRows,
        serverLoadingMore,
        onReachEnd
    ]);
    const myActiveSquares = mySquares.filter((s)=>s.settled !== true);
    const myActiveTrades = myTrades.filter((t)=>t.settled !== true);
    const mySettledSquares = mySquares.filter((s)=>s.settled === true || Boolean(s.settled_at));
    const mySettledTrades = myTrades.filter((t)=>t.settled === true || Boolean(t.settled_at));
    const streamBodyClass = surface === "panel" ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_BODY_CLASS) : (0, _notificationDisplay.NOTIFICATION_STREAM_BODY_CLASS);
    const streamNameClass = surface === "panel" ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_NAME_CLASS) : (0, _notificationDisplay.NOTIFICATION_STREAM_NAME_CLASS);
    const streamCtaClass = surface === "panel" ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_CTA_CLASS) : (0, _notificationDisplay.NOTIFICATION_CTA_PILL_CLASS);
    const ctaRailPlaceholderClass = surface === "panel" ? ACTIVITY_PANEL_CTA_RAIL_PLACEHOLDER_CLASS : ACTIVITY_CTA_RAIL_PLACEHOLDER_CLASS;
    const showDigestProfileCta = surface === "drawer" || surface === "panel";
    if (loading) {
        if (surface === "profile") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActivitySkeletonRows, {
            count: 4
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "px-1 py-3 font-chakra text-[14px] text-white/55",
            children: "Loading activity\u2026"
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
        className: "space-y-1.5",
        children: [
            visibleTimelineRows.map((row)=>{
                if (row.kind === "notification") {
                    const n = row.node;
                    const nid = n.id;
                    const readAt = n.read_at;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationItemRow, {
                            notification: n,
                            isUnread: !readAt,
                            onActivate: ()=>onNotificationRead?.(nid),
                            variant: surface === "panel" ? "panel" : "default"
                        })
                    }, row.key);
                }
                if (row.kind === "started") {
                    const startedRel = row.startedAt ? (0, _notificationDisplay.formatTimeAgo)(row.startedAt) : "";
                    const userAlsoOnSquaresSameMatch = row.gameLabel === "SQUARES" && myActiveSquares.some((s)=>String(s.match_id || "") === String(row.matchId || ""));
                    const userAlsoOnTrader = row.gameLabel === "TRADER" && myActiveTrades.some((t)=>String(t.match_id || "") === String(row.matchId || ""));
                    const showBothPlayingSameMatch = userAlsoOnSquaresSameMatch || userAlsoOnTrader;
                    const bullionEntryKind = row.bullionEntryKind;
                    const startedMiddle = row.gameLabel === "BULLION" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: streamBodyClass,
                        children: isOwnProfileView ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: "You"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "text-white/90",
                                    children: [
                                        " ",
                                        "entered a ",
                                        bullionEntryKind === "private_battle" ? "private battle" : "public arena",
                                        " on",
                                        " "
                                    ]
                                }),
                                renderGameToken("BULLION"),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: row.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "text-white/90",
                                    children: [
                                        " ",
                                        "entered a ",
                                        bullionEntryKind === "private_battle" ? "private battle" : "public arena",
                                        " on",
                                        " "
                                    ]
                                }),
                                renderGameToken("BULLION"),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        })
                    }) : row.gameLabel === "SQUARES" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: streamBodyClass,
                        children: isOwnProfileView ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: "You"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: " started playing "
                                }),
                                renderGameToken("SQUARES"),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        }) : showBothPlayingSameMatch ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "You are both playing "
                                }),
                                renderGameToken("SQUARES"),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: row.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: " started playing "
                                }),
                                renderGameToken("SQUARES"),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: streamBodyClass,
                        children: isOwnProfileView ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: "You"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: " started playing "
                                }),
                                renderGameToken(row.gameLabel),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        }) : showBothPlayingSameMatch ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "You are both playing "
                                }),
                                renderGameToken(row.gameLabel),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: row.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: " started playing "
                                }),
                                renderGameToken(row.gameLabel),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        })
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActivityStreamRow, {
                            surface: surface,
                            profileTo: row.profileTo,
                            profileModalState: profileModalState,
                            onProfileLinkClick: onProfileLinkClick,
                            avatarSrc: row.avatar || "",
                            displayName: row.name,
                            xpWeekCrown: row.xp_week_crown,
                            avatarFrame: row.avatarFrame,
                            middle: startedMiddle,
                            timeLabel: startedRel,
                            ctaSlot: (()=>{
                                const ctaTo = row.ctaTo ?? row.matchTo ?? null;
                                const ctaLabel = row.ctaLabel ?? (row.gameLabel === "BULLION" ? "PLAY" : "MATCH");
                                if (!ctaTo) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: ctaRailPlaceholderClass,
                                    "aria-hidden": true
                                });
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileLink.ProfileLink), {
                                    to: ctaTo,
                                    state: ctaLabel === "PROFILE" ? profileModalState : undefined,
                                    className: streamCtaClass,
                                    onClick: (e)=>handleActivityCtaClick(e, ctaTo, ctaLabel === "PROFILE" ? profileModalState : undefined),
                                    children: ctaLabel
                                });
                            })()
                        })
                    }, row.key);
                }
                if (row.kind === "result") {
                    const settledRel = (0, _notificationDisplay.formatTimeAgo)(row.settledAt);
                    const showBothPlayedSameMatch = !isOwnProfileView && (row.gameLabel === "SQUARES" && mySettledSquares.some((s)=>String(s.match_id || "") === String(row.matchId || "")) || row.gameLabel === "TRADER" && mySettledTrades.some((t)=>String(t.match_id || "") === String(row.matchId || "")));
                    const resultMiddle = /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: streamBodyClass,
                        children: isOwnProfileView ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: "You"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: " "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: row.didWin ? "won " : "lost "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: streamNameClass,
                                    children: [
                                        row.coins,
                                        " coins"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: " on "
                                }),
                                renderGameToken(row.gameLabel),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        }) : showBothPlayedSameMatch ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "You both played "
                                }),
                                renderGameToken(row.gameLabel),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: ". "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: row.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: row.didWin ? " won " : " lost "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: streamNameClass,
                                    children: [
                                        row.coins,
                                        " coins"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: row.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: row.didWin ? " won " : " lost "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: streamNameClass,
                                    children: [
                                        row.coins,
                                        " coins"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: " on "
                                }),
                                renderGameToken(row.gameLabel),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: "."
                                })
                            ]
                        })
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActivityStreamRow, {
                            surface: surface,
                            profileTo: row.profileTo,
                            profileModalState: profileModalState,
                            onProfileLinkClick: onProfileLinkClick,
                            avatarSrc: row.avatar || "",
                            displayName: row.name,
                            xpWeekCrown: row.xp_week_crown,
                            avatarFrame: row.avatarFrame,
                            middle: resultMiddle,
                            timeLabel: settledRel,
                            ctaSlot: row.ctaTo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileLink.ProfileLink), {
                                to: row.ctaTo,
                                state: row.ctaLabel === "PROFILE" ? profileModalState : undefined,
                                className: streamCtaClass,
                                onClick: (e)=>handleActivityCtaClick(e, row.ctaTo, row.ctaLabel === "PROFILE" ? profileModalState : undefined),
                                children: row.ctaLabel
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: ctaRailPlaceholderClass,
                                "aria-hidden": true
                            })
                        })
                    }, row.key);
                }
                if (row.kind === "xp") {
                    const xpRel = (0, _notificationDisplay.formatTimeAgo)(row.createdAt);
                    const xpMiddle = /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: streamBodyClass,
                        children: isOwnProfileView ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: "You"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: " earned "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "inline-flex items-center gap-0.5 self-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: streamNameClass,
                                            children: (0, _xp.formatXp)(row.amount)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: (0, _xp.XP_ICON_SRC),
                                            alt: "",
                                            className: "h-3 w-3 shrink-0 object-contain",
                                            "aria-hidden": true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "text-white/90",
                                    children: [
                                        " ",
                                        row.reasonDetail,
                                        "."
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: streamNameClass,
                                    children: row.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-white/90",
                                    children: " earned "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "inline-flex items-center gap-0.5 self-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: streamNameClass,
                                            children: (0, _xp.formatXp)(row.amount)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: (0, _xp.XP_ICON_SRC),
                                            alt: "",
                                            className: "h-3 w-3 shrink-0 object-contain",
                                            "aria-hidden": true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "text-white/90",
                                    children: [
                                        " ",
                                        row.reasonDetail,
                                        "."
                                    ]
                                })
                            ]
                        })
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActivityStreamRow, {
                            surface: surface,
                            profileTo: row.profileTo,
                            profileModalState: profileModalState,
                            onProfileLinkClick: onProfileLinkClick,
                            avatarSrc: row.avatar || "",
                            displayName: row.name,
                            xpWeekCrown: row.xp_week_crown,
                            avatarFrame: row.avatarFrame,
                            middle: xpMiddle,
                            timeLabel: xpRel,
                            ctaSlot: isOwnProfileView && surface === "profile" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: ctaRailPlaceholderClass,
                                "aria-hidden": true
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileLink.ProfileLink), {
                                to: row.profileTo,
                                state: profileModalState,
                                className: streamCtaClass,
                                onClick: onProfileLinkClick,
                                children: isOwnProfileView ? "XP" : "PROFILE"
                            })
                        })
                    }, row.key);
                }
                if (row.kind === "xp_week_podium") {
                    const podiumRel = row.awardedAt ? (0, _notificationDisplay.formatTimeAgo)(row.awardedAt) : "";
                    const podiumMiddle = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: streamBodyClass,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: streamNameClass,
                                children: isOwnProfileView ? "You" : row.name
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white/90",
                                children: " finished "
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: streamNameClass,
                                children: row.rankLabel
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white/90",
                                children: " on the XP leaderboard for "
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: streamNameClass,
                                children: row.periodLabel
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white/90",
                                children: "."
                            }),
                            row.xpValue > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-white/90",
                                        children: " ("
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "inline-flex items-center gap-0.5 self-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: streamNameClass,
                                                children: (0, _xp.formatXp)(row.xpValue)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: (0, _xp.XP_ICON_SRC),
                                                alt: "",
                                                className: "h-3 w-3 shrink-0 object-contain",
                                                "aria-hidden": true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-white/90",
                                        children: ")."
                                    })
                                ]
                            }) : null
                        ]
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActivityStreamRow, {
                            surface: surface,
                            profileTo: row.profileTo,
                            profileModalState: profileModalState,
                            onProfileLinkClick: onProfileLinkClick,
                            avatarSrc: row.avatar || "",
                            displayName: row.name,
                            xpWeekCrown: row.xp_week_crown,
                            avatarFrame: row.avatarFrame,
                            middle: podiumMiddle,
                            timeLabel: podiumRel,
                            ctaSlot: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: streamCtaClass,
                                onClick: ()=>{
                                    onProfileLinkClick?.();
                                    navigate("/xp-leaderboard");
                                },
                                children: "LEADERBOARD"
                            })
                        })
                    }, row.key);
                }
                if (row.kind === "digest") {
                    const d = row;
                    const digestAt = d.digestDisplayAt ?? d.lastPlayedAt;
                    const digestRel = digestAt ? (0, _notificationDisplay.formatTimeAgo)(digestAt) : "";
                    const body = d.digestVariant === "streak" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: streamBodyClass,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: streamNameClass,
                                children: isOwnProfileView ? "Your" : d.name
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-white/90",
                                children: [
                                    " ",
                                    renderGameToken("TRADER"),
                                    " ",
                                    "current streak:",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-[#d4ff1f]",
                                children: [
                                    d.streakValue ?? 0,
                                    " wins in a row"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white/90",
                                children: "."
                            })
                        ]
                    }) : d.digestVariant === "pb" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: streamBodyClass,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: streamNameClass,
                                children: isOwnProfileView ? "Your" : d.name
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-white/90",
                                children: [
                                    " ",
                                    renderGameToken("TRADER"),
                                    " ",
                                    "record:",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-[#d4ff1f]",
                                children: [
                                    d.pbValue ?? 0,
                                    " wins in a row"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white/90",
                                children: "."
                            })
                        ]
                    }) : d.digestVariant === "bullion_pb" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: streamBodyClass,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: streamNameClass,
                                children: isOwnProfileView ? "Your" : d.name
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white/90",
                                children: " scored a new personal best on "
                            }),
                            renderGameToken("BULLION"),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white/90",
                                children: ": "
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-[#d4ff1f]",
                                children: [
                                    d.bullionCorrectPicks ?? 0,
                                    " correct picks"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-white/90",
                                children: "."
                            })
                        ]
                    }) : null;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActivityStreamRow, {
                            surface: surface,
                            profileTo: d.profileTo,
                            profileModalState: profileModalState,
                            onProfileLinkClick: onProfileLinkClick,
                            avatarSrc: d.avatar || "",
                            displayName: d.name,
                            xpWeekCrown: d.xp_week_crown,
                            avatarFrame: d.avatarFrame,
                            middle: body,
                            timeLabel: digestRel,
                            ctaSlot: showDigestProfileCta ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileLink.ProfileLink), {
                                to: d.profileTo,
                                state: profileModalState,
                                className: streamCtaClass,
                                onClick: onProfileLinkClick,
                                children: "Profile"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: ctaRailPlaceholderClass,
                                "aria-hidden": true
                            })
                        })
                    }, row.key);
                }
                return null;
            }),
            !loading && notifications.length === 0 && digests.length === 0 && settledResultRows.length === 0 && xpResultRows.length === 0 && startedPlayingRows.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                className: "px-1 py-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "font-chakra text-[14px] leading-snug text-white/55",
                    children: emptyMessage
                })
            }) : null,
            loadingMore || serverLoadingMore ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                className: "px-1 py-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "font-chakra text-[13px] text-white/60",
                    children: "Loading more\u2026"
                })
            }) : null,
            hasMoreRows || hasMoreServerRows ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                ref: infiniteSentinelRef,
                className: "h-1 w-full",
                "aria-hidden": true
            }) : null
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../Profile/ProfileLink":"eCRxx","../Profile/ProfileGlobalModalContext":"eilDL","../Profile/UserAvatar":"e6kw2","../Xp/AvatarWithXpCrown":"9U2iQ","../Profile/avatarFrame":"k4MjP","../../utils/sessionUser":"4xtMD","../../utils/friendDisplayName":"hUpqQ","../../utils/matchNameDisplay":"cRLsI","../../utils/traderActivityNavigation":"2KLbK","../../utils/profileModalNavigation":"eBA1i","../notifications/notificationDisplay":"5gcn3","../notifications/NotificationItemRow":"ip48z","../notifications/notificationTaxonomy":"gwaMN","../../utils/xp":"jFgAi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUpqQ":[function(require,module,exports,__globalThis) {
/**
 * Profile / friends naming helpers.
 *
 * - `player_name` is the primary handle (games, leaderboards, and the main label on profile/friends).
 * - `display_name` is an optional real/friendly name shown secondarily to the owner and friends.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Primary handle: player_name → username → "Player". */ parcelHelpers.export(exports, "playerHandleName", ()=>playerHandleName);
/**
 * Optional real/friendly name when set. Returns null when empty or identical to the handle
 * (case-insensitive) so we don't duplicate the primary label.
 */ parcelHelpers.export(exports, "optionalDisplayName", ()=>optionalDisplayName);
/** True when the viewer may see the subject's `display_name` (owner or accepted friends). */ parcelHelpers.export(exports, "canSeeDisplayName", ()=>canSeeDisplayName);
/**
 * @deprecated Prefer {@link playerHandleName} + {@link optionalDisplayName}.
 * Kept for call sites that need a single string (still returns the primary handle).
 */ parcelHelpers.export(exports, "friendFacingName", ()=>friendFacingName);
function playerHandleName(person) {
    if (!person) return "Player";
    const player = typeof person.player_name === "string" && person.player_name.trim() || typeof person.playerName === "string" && person.playerName.trim() || "";
    if (player) return player;
    const username = typeof person.username === "string" ? person.username.trim() : "";
    return username || "Player";
}
function optionalDisplayName(person) {
    if (!person) return null;
    const display = typeof person.display_name === "string" ? person.display_name.trim() : "";
    if (!display) return null;
    const handle = playerHandleName(person);
    if (display.toLowerCase() === handle.toLowerCase()) return null;
    return display;
}
function canSeeDisplayName(opts) {
    if (opts.isOwnProfile) return true;
    return opts.friendshipStatus === "friends";
}
function friendFacingName(person) {
    return playerHandleName(person);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cRLsI":[function(require,module,exports,__globalThis) {
/**
 * Keep only the core match title for UI surfaces.
 * Removes trailing metadata like ", from ...", competition segments, and extra commas.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatMatchNameForDisplay", ()=>formatMatchNameForDisplay);
/**
 * Short match line for dense UI (e.g. friends activity drawer).
 * "Royal Challengers Bangalore v Mumbai Indians" → "RCB v MI"; single-sided names truncated.
 */ parcelHelpers.export(exports, "formatMatchNameAbbreviated", ()=>formatMatchNameAbbreviated);
function formatMatchNameForDisplay(raw) {
    if (typeof raw !== "string") return "";
    let name = raw.trim();
    if (!name) return "";
    // Drop trailing ", from ..." fragments.
    name = name.replace(/\s*,\s*from\s+.+$/i, "");
    // Keep only the first comma-separated segment (usually "Team A v Team B").
    name = name.split(",")[0]?.trim() || "";
    return name;
}
const VS_SPLIT = /\s+vs\.?\s+|\s+v\s+/i;
function abbreviateTeamSide(side) {
    const s = side.trim();
    if (!s) return "";
    const words = s.split(/\s+/).filter(Boolean);
    if (words.length === 0) return "";
    if (words.length === 1) {
        const w = words[0].replace(/[^a-zA-Z0-9]/g, "");
        if (w.length <= 4) return w.toUpperCase();
        return w.slice(0, 3).toUpperCase();
    }
    const initials = words.map((w)=>{
        const core = w.replace(/[^a-zA-Z0-9]/g, "");
        return core[0] ?? "";
    }).filter(Boolean).join("").toUpperCase();
    if (initials.length >= 2) return initials.slice(0, 4);
    return s.slice(0, 4).toUpperCase();
}
function formatMatchNameAbbreviated(raw) {
    const trimmed = formatMatchNameForDisplay(raw);
    if (!trimmed) return "";
    const parts = trimmed.split(VS_SPLIT).map((p)=>p.trim()).filter(Boolean);
    if (parts.length >= 2) return `${abbreviateTeamSide(parts[0])} v ${abbreviateTeamSide(parts[parts.length - 1])}`;
    if (trimmed.length > 26) return `${trimmed.slice(0, 23)}\u{2026}`;
    return trimmed;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2KLbK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Trader URL `sport=` slug (cricket, football, tennis, horses). */ parcelHelpers.export(exports, "traderUrlSportParam", ()=>traderUrlSportParam);
parcelHelpers.export(exports, "hasReadableActivityMatchName", ()=>hasReadableActivityMatchName);
/** Sport-specific Trader lobby when fixture/event metadata is unavailable. */ parcelHelpers.export(exports, "traderLobbyHref", ()=>traderLobbyHref);
/** Finished match page when we have a fixture id; otherwise the sport Trader lobby. */ parcelHelpers.export(exports, "traderActivityMatchHref", ()=>traderActivityMatchHref);
var _matchesHubNavigation = require("../components/Matches/matchesHubNavigation");
function traderUrlSportParam(sportLower) {
    if (sportLower === "horse" || sportLower === "horses") return "horses";
    if (sportLower === "soccer" || sportLower === "football") return "football";
    return sportLower;
}
function normalizeTraderSportSlug(sportRaw) {
    return traderUrlSportParam(String(sportRaw || "cricket").trim().toLowerCase());
}
function hasReadableActivityMatchName(matchName, matchId) {
    const name = matchName?.trim() ?? "";
    return name.length > 0 && name !== matchId;
}
function traderLobbyHref(sportRaw) {
    return `/trader?sport=${encodeURIComponent(normalizeTraderSportSlug(sportRaw))}`;
}
function traderActivityMatchHref(matchId, _matchName, sportRaw) {
    const id = matchId.trim();
    if (id) return (0, _matchesHubNavigation.buildMatchCompleteHref)(id, sportRaw);
    return traderLobbyHref(sportRaw);
}

},{"../components/Matches/matchesHubNavigation":"cJbjg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cJbjg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMatchesHubTab", ()=>parseMatchesHubTab);
/** Matches hub sport slug for URL query params — always explicit (including cricket). */ parcelHelpers.export(exports, "matchesHubSportSlug", ()=>matchesHubSportSlug);
/** `sport=cricket` query pair for matches hub / match-detail URLs. */ parcelHelpers.export(exports, "matchesHubSportSearchParam", ()=>matchesHubSportSearchParam);
/** Match hub results page for a finished fixture (all sports). */ parcelHelpers.export(exports, "buildMatchCompleteHref", ()=>buildMatchCompleteHref);
/** Back link to the matches hub, preserving sport and LIVE/FINISHED tab. */ parcelHelpers.export(exports, "buildMatchesListHref", ()=>buildMatchesListHref);
/** Carry matches hub tab through match detail URLs so back navigation can restore it. */ parcelHelpers.export(exports, "withMatchesHubTab", ()=>withMatchesHubTab);
function parseMatchesHubTab(raw) {
    return raw === "finished" ? "finished" : "live";
}
function matchesHubSportSlug(sport) {
    const s = (sport ?? "CRICKET").toString().toUpperCase();
    if (s.includes("HORSE")) return "horses";
    if (s.includes("FOOT")) return "football";
    if (s.includes("TENNIS")) return "tennis";
    return "cricket";
}
function matchesHubSportSearchParam(sport) {
    return `sport=${encodeURIComponent(matchesHubSportSlug(sport))}`;
}
function buildMatchCompleteHref(matchId, sport) {
    return `/matches?id=${encodeURIComponent(String(matchId))}&${matchesHubSportSearchParam(sport)}&status=complete`;
}
function buildMatchesListHref(options) {
    const params = new URLSearchParams();
    params.set("sport", matchesHubSportSlug(options?.sport));
    if (options?.tab === "finished") params.set("tab", "finished");
    return `/matches?${params.toString()}`;
}
function withMatchesHubTab(href, tab) {
    if (tab !== "finished") return href;
    if (href.includes("tab=")) return href;
    const joiner = href.includes("?") ? "&" : "?";
    return `${href}${joiner}tab=finished`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5gcn3":[function(require,module,exports,__globalThis) {
/** Shared copy for notification list rows + toast (keep in sync visually). */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatTimeAgo", ()=>formatTimeAgo);
parcelHelpers.export(exports, "parseXpWeekPodiumEntityRef", ()=>parseXpWeekPodiumEntityRef);
/**
 * `entity_ref` JSON for `admin_message` (Player Communications Center broadcasts):
 * `{ title, body, cta_label?, cta_href?, broadcast_id? }`. All fields are admin-authored.
 */ parcelHelpers.export(exports, "parseAdminMessageEntityRef", ()=>parseAdminMessageEntityRef);
/**
 * `entity_ref` JSON for `wallet_grant` (admin currency gifts):
 * `{ title, body, coins, rubies }`.
 */ parcelHelpers.export(exports, "parseWalletGrantEntityRef", ()=>parseWalletGrantEntityRef);
/** Title segments for wallet gifts — amounts with currency icons when present. */ parcelHelpers.export(exports, "walletGrantTitleParts", ()=>walletGrantTitleParts);
parcelHelpers.export(exports, "parseXpEntityRef", ()=>parseXpEntityRef);
/**
 * Phrase after "for …" in XP earned notifications.
 * @param {string|null|undefined} reason
 * @param {string} [label]
 * @param {number|null} [grantCount]
 * @param {{ forFriend?: boolean }} [opts] — friend activity must avoid second-person "your".
 */ parcelHelpers.export(exports, "xpNotificationDetail", ()=>xpNotificationDetail);
/** True when notification sender should show the lime “online” dot (API may send `is_online`). */ parcelHelpers.export(exports, "notificationSenderAppearsOnline", ()=>notificationSenderAppearsOnline);
parcelHelpers.export(exports, "parseSquaresChallengeEntityRef", ()=>parseSquaresChallengeEntityRef);
/** `entity_ref` JSON for `sixes_card_ready`: `{ title, team_a, team_b, match_name, cta_href, cta_label }`. */ parcelHelpers.export(exports, "parseSixesCardReadyEntityRef", ()=>parseSixesCardReadyEntityRef);
/** `entity_ref` JSON for `bullion_match_challenge` / `bullion_match_challenge_sent`. */ parcelHelpers.export(exports, "parseBullionChallengeEntityRef", ()=>parseBullionChallengeEntityRef);
/** Public arenas also carry `game_id`; prefer `visibility` from entity_ref (backend), then legacy invite-code hint. */ parcelHelpers.export(exports, "isBullionPrivateBattleChallenge", ()=>isBullionPrivateBattleChallenge);
parcelHelpers.export(exports, "parseLeagueInviteEntityRef", ()=>parseLeagueInviteEntityRef);
parcelHelpers.export(exports, "leagueInviteDeepLinkFromEntityRef", ()=>leagueInviteDeepLinkFromEntityRef);
/** `entity_ref` JSON for `sixes_match_challenge` / `_sent` — `{ match_id, match_name }`. */ parcelHelpers.export(exports, "parseSixesChallengeEntityRef", ()=>parseSixesChallengeEntityRef);
/** `entity_ref` JSON for `trader_match_challenge` / `_sent` — `{ match_id, match_name, sport }`. */ parcelHelpers.export(exports, "parseTraderChallengeEntityRef", ()=>parseTraderChallengeEntityRef);
parcelHelpers.export(exports, "sixesMatchDeepLinkFromEntityRef", ()=>sixesMatchDeepLinkFromEntityRef);
parcelHelpers.export(exports, "traderMatchDeepLinkFromEntityRef", ()=>traderMatchDeepLinkFromEntityRef);
/** Deep link for My Zone / notifications CTA — keep in sync with `getNotificationDisplay` bullion cases. */ parcelHelpers.export(exports, "bullionContestDeepLinkFromEntityRef", ()=>bullionContestDeepLinkFromEntityRef);
/**
 * Title line segments. `emphasizeUsername` → Anton 9px uppercase (friend/sender name). `emphasize` → Chakra emphasis (amounts, match labels, etc.). `coinIcon` / `rubyIcon` render currency images inline.
 * @returns {{ titleParts: Array<{ text?: string, emphasize?: boolean, emphasizeUsername?: boolean, rubyIcon?: boolean, coinIcon?: boolean }>, avatarUrl: string | null, avatarObjectFit?: 'cover' | 'contain', cta: { label: string, to: string, openShopDrawer?: boolean, openWalletHistory?: boolean } | null, navigateTo: string }}
 */ parcelHelpers.export(exports, "getNotificationDisplay", ()=>getNotificationDisplay);
parcelHelpers.export(exports, "NOTIFICATION_AVATAR_CLASS", ()=>NOTIFICATION_AVATAR_CLASS);
parcelHelpers.export(exports, "NOTIFICATION_AVATAR_CLASS_COMPACT", ()=>NOTIFICATION_AVATAR_CLASS_COMPACT);
parcelHelpers.export(exports, "NOTIFICATION_AVATAR_STREAM_CLASS", ()=>NOTIFICATION_AVATAR_STREAM_CLASS);
parcelHelpers.export(exports, "NOTIFICATION_MAIN_TEXT_PAD", ()=>NOTIFICATION_MAIN_TEXT_PAD);
parcelHelpers.export(exports, "NOTIFICATION_CTA_PILL_CLASS", ()=>NOTIFICATION_CTA_PILL_CLASS);
parcelHelpers.export(exports, "NOTIFICATION_ACTIVITY_STREAM_ROW_GRID_CLASS", ()=>NOTIFICATION_ACTIVITY_STREAM_ROW_GRID_CLASS);
parcelHelpers.export(exports, "NOTIFICATION_STREAM_BODY_CLASS", ()=>NOTIFICATION_STREAM_BODY_CLASS);
parcelHelpers.export(exports, "NOTIFICATION_STREAM_NAME_CLASS", ()=>NOTIFICATION_STREAM_NAME_CLASS);
parcelHelpers.export(exports, "NOTIFICATION_STREAM_TIME_SIDE_CLASS", ()=>NOTIFICATION_STREAM_TIME_SIDE_CLASS);
parcelHelpers.export(exports, "NOTIFICATION_STREAM_TIME_SUBLINE_CLASS", ()=>NOTIFICATION_STREAM_TIME_SUBLINE_CLASS);
parcelHelpers.export(exports, "MY_ZONE_ACTIVITY_PANEL_ROW_GRID_CLASS", ()=>MY_ZONE_ACTIVITY_PANEL_ROW_GRID_CLASS);
parcelHelpers.export(exports, "MY_ZONE_ACTIVITY_PANEL_AVATAR_CLASS", ()=>MY_ZONE_ACTIVITY_PANEL_AVATAR_CLASS);
parcelHelpers.export(exports, "MY_ZONE_ACTIVITY_PANEL_CTA_CLASS", ()=>MY_ZONE_ACTIVITY_PANEL_CTA_CLASS);
parcelHelpers.export(exports, "MY_ZONE_ACTIVITY_PANEL_BODY_CLASS", ()=>MY_ZONE_ACTIVITY_PANEL_BODY_CLASS);
parcelHelpers.export(exports, "MY_ZONE_ACTIVITY_PANEL_NAME_CLASS", ()=>MY_ZONE_ACTIVITY_PANEL_NAME_CLASS);
parcelHelpers.export(exports, "MY_ZONE_ACTIVITY_PANEL_TIME_CLASS", ()=>MY_ZONE_ACTIVITY_PANEL_TIME_CLASS);
parcelHelpers.export(exports, "MY_ZONE_ACTIVITY_PANEL_TITLE_LINE_CLASS", ()=>MY_ZONE_ACTIVITY_PANEL_TITLE_LINE_CLASS);
parcelHelpers.export(exports, "MY_ZONE_ACTIVITY_PANEL_TITLE_USERNAME_CLASS", ()=>MY_ZONE_ACTIVITY_PANEL_TITLE_USERNAME_CLASS);
parcelHelpers.export(exports, "getNotificationRowShellClass", ()=>getNotificationRowShellClass);
/** Grid row: text column is minmax(0,1fr) so copy uses full width up to time/CTA (avoids flex min-content width traps). */ parcelHelpers.export(exports, "getNotificationRowGridShellClass", ()=>getNotificationRowGridShellClass);
var _sessionUser = require("../../utils/sessionUser");
var _xp = require("../../utils/xp");
var _logo = require("../Logo");
var _matchNameDisplay = require("../../utils/matchNameDisplay");
var _notificationTaxonomy = require("./notificationTaxonomy");
function formatTimeAgo(dateStr) {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return "";
    const sec = Math.floor((Date.now() - d) / 1000);
    if (sec < 60) return "now";
    if (sec < 3600) return `${Math.floor(sec / 60)}m`;
    if (sec < 86400) return `${Math.floor(sec / 3600)}h`;
    if (sec < 604800) return `${Math.floor(sec / 86400)}d`;
    const nowY = new Date().getFullYear();
    return d.getFullYear() === nowY ? d.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric"
    }) : d.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
}
function senderProfileTo(notification) {
    const s = notification.sender;
    if (s?.player_id) return `/profile?p=${encodeURIComponent(s.player_id)}`;
    if (s?.userId) return `/profile?u=${s.userId}`;
    return "/profile";
}
function parseXpWeekPodiumEntityRef(ref) {
    try {
        const o = JSON.parse(ref || "{}");
        const rank = parseInt(String(o.rank), 10);
        const xpValue = parseInt(String(o.xp_value), 10);
        const tiedCount = parseInt(String(o.tied_count), 10);
        return {
            periodLabel: typeof o.period_label === "string" ? o.period_label.trim() : "",
            rank: Number.isFinite(rank) && rank > 0 ? rank : null,
            rankLabel: typeof o.rank_label === "string" ? o.rank_label.trim() : "",
            xpValue: Number.isFinite(xpValue) && xpValue >= 0 ? xpValue : null,
            crown: typeof o.crown === "string" ? o.crown.trim() : "",
            tiedCount: Number.isFinite(tiedCount) && tiedCount > 0 ? tiedCount : 1
        };
    } catch  {
        return {
            periodLabel: "",
            rank: null,
            rankLabel: "",
            xpValue: null,
            crown: "",
            tiedCount: 1
        };
    }
}
function parseAdminMessageEntityRef(ref) {
    try {
        const o = JSON.parse(ref || "{}");
        const title = typeof o.title === "string" ? o.title.trim() : "";
        const body = typeof o.body === "string" ? o.body.trim() : "";
        const ctaLabel = typeof o.cta_label === "string" ? o.cta_label.trim() : "";
        const ctaHrefRaw = typeof o.cta_href === "string" ? o.cta_href.trim() : "";
        // Only accept internal paths — never navigate to an external/absolute URL from a notification.
        const ctaHref = ctaHrefRaw.startsWith("/") && !ctaHrefRaw.startsWith("//") ? ctaHrefRaw : "";
        return {
            title,
            body,
            ctaLabel,
            ctaHref
        };
    } catch  {
        return {
            title: "",
            body: "",
            ctaLabel: "",
            ctaHref: ""
        };
    }
}
function parseWalletGrantEntityRef(ref) {
    try {
        const o = JSON.parse(ref || "{}");
        const coins = parseInt(String(o.coins), 10);
        const rubies = parseInt(String(o.rubies), 10);
        return {
            title: typeof o.title === "string" ? o.title.trim() : "",
            body: typeof o.body === "string" ? o.body.trim() : "",
            coins: Number.isFinite(coins) && coins > 0 ? coins : 0,
            rubies: Number.isFinite(rubies) && rubies > 0 ? rubies : 0
        };
    } catch  {
        return {
            title: "",
            body: "",
            coins: 0,
            rubies: 0
        };
    }
}
const WALLET_GRANT_DEFAULT_TITLE = "You received a gift!";
function walletGrantTitleParts({ title, body, coins, rubies }) {
    const parts = [];
    const customTitle = title && title !== WALLET_GRANT_DEFAULT_TITLE ? title : "";
    if (customTitle) {
        parts.push({
            text: customTitle,
            emphasize: true
        });
        parts.push({
            text: " "
        });
    }
    if (coins > 0 || rubies > 0) {
        parts.push({
            text: customTitle ? "We've added " : "You've been gifted "
        });
        if (coins > 0) {
            parts.push({
                text: String(coins),
                emphasize: true
            });
            parts.push({
                coinIcon: true
            });
        }
        if (coins > 0 && rubies > 0) parts.push({
            text: " and "
        });
        if (rubies > 0) {
            parts.push({
                text: String(rubies),
                emphasize: true
            });
            parts.push({
                rubyIcon: true
            });
        }
        parts.push({
            text: " to your wallet."
        });
        return parts;
    }
    if (body) {
        parts.push({
            text: body
        });
        return parts;
    }
    if (parts.length === 0) parts.push({
        text: "You received a gift in your wallet."
    });
    return parts;
}
function parseXpEntityRef(ref) {
    try {
        const o = JSON.parse(ref || "{}");
        const amount = parseInt(String(o.amount), 10);
        const grantCount = parseInt(String(o.grant_count), 10);
        return {
            amount: Number.isFinite(amount) ? amount : 0,
            label: typeof o.label === "string" ? o.label.trim() : "",
            reason: typeof o.reason === "string" ? o.reason : "",
            grantCount: Number.isFinite(grantCount) && grantCount > 0 ? grantCount : null,
            batched: o.batched === true
        };
    } catch  {
        return {
            amount: 0,
            label: "",
            reason: "",
            grantCount: null,
            batched: false
        };
    }
}
function xpNotificationDetail(reason, label, grantCount = null, opts = {}) {
    const forFriend = opts?.forFriend === true;
    const base = String(reason ?? "").trim().split(":")[0];
    if (base === "xp_friends_batch") {
        if (grantCount != null && grantCount > 1) return `${grantCount} activities`;
        return "recent activity";
    }
    if (base === "wheel_multiplier_home" || base === "wheel_multiplier_away") return "winning in Wheel Trivia multiplier";
    if (base === "trader_win") return "winning a Trader game";
    if (base === "trader_all_in_first") return forFriend ? "a first all-in Trader game" : "your first all-in Trader game";
    if (base.startsWith("trader_match_wins")) return "winning multiple Trader games in one match";
    if (base === "trader_win_streak_4" || base === "trader_win_streak_8") return "a Trader win streak";
    if (base.startsWith("trader_daily_coins_first")) return (0, _xp.formatTraderDailyLeaderboardXpNotificationDetail)(reason);
    if (base.startsWith("sixes_daily_coins_first")) return (0, _xp.formatSixesDailyLeaderboardXpNotificationDetail)(reason);
    if (base === "login_daily" || base.startsWith("login_daily:")) return "visiting Cricket8 today";
    if (base === "login_streak_4" || base === "login_streak_8") return forFriend ? "a daily visit streak" : "your daily visit streak";
    if (base.startsWith("squares_play_over")) return "playing a Squares over";
    if (base.startsWith("squares_win_over")) return "winning a Squares over";
    if (base.startsWith("squares_five_balls")) return "getting 5 balls right in Squares";
    if (base.startsWith("squares_perfect_over")) return "a perfect Squares over";
    if (base.startsWith("bullion_play_private")) return "playing a private Bullion game";
    if (base.startsWith("bullion_play_public")) return "playing a public Bullion game";
    if (base.startsWith("bullion_win_private_first")) return "winning a private Bullion game";
    if (base.startsWith("bullion_win_public_first")) return "winning a public Bullion game";
    if (base.startsWith("bullion_place_private")) return "placing in a private Bullion game";
    if (base.startsWith("bullion_place_public")) return "placing in a public Bullion game";
    if (base.startsWith("bullion_predictions_80pct")) return "80%+ correct picks in Bullion";
    if (base.startsWith("shop_rubies_3")) return "purchasing a 3-pack of Rubies";
    if (base.startsWith("shop_rubies_10")) return "purchasing a 10-pack of Rubies";
    if (base.startsWith("shop_rubies_25")) return "purchasing a 25-pack of Rubies";
    if (base.startsWith("shop_feature_pack")) return "unlocking the Profile Unlock Pack";
    if (base === "shop_first_ruby_pack") return forFriend ? "a first Ruby pack purchase" : "your first Ruby pack purchase";
    if (base === "social_first_friend") return forFriend ? "adding a first friend" : "adding your first friend";
    if (base.startsWith("social_invite_new_user")) return "inviting a new user";
    if (base.startsWith("social_friend_existing")) return "making a new friend";
    if (base === "social_favourite_team") return forFriend ? "adding a favourite team to the profile" : "adding a favourite team to your profile";
    if (base === "social_favourite_player") return forFriend ? "adding a favourite player to the profile" : "adding a favourite player to your profile";
    if (base === "social_favourite_sport") return forFriend ? "adding a favourite sport to the profile" : "adding a favourite sport to your profile";
    if (base === "social_country") return forFriend ? "adding a country to the profile" : "adding your country to your profile";
    if (base === "social_player_name") return forFriend ? "creating a player name" : "creating your player name";
    if (base === "social_avatar") return forFriend ? "choosing an avatar" : "choosing your avatar";
    if (base.startsWith("quickfire_correct")) return "a correct Quickfire answer";
    if (base === "quickfire_daily_perfect" || base.startsWith("quickfire_daily_perfect:")) return "getting every daily Quickfire question right";
    if (base === "wheel_spin_daily") return forFriend ? "Daily Free Coins" : "your Daily Free Coins";
    if (base.startsWith("wheel_multiplier_streak")) return forFriend ? "a Wheel Trivia multiplier streak" : "your Wheel Trivia multiplier streak";
    if (label) return label.charAt(0).toLowerCase() + label.slice(1);
    return "activity";
}
function playRouteForType(type) {
    if (!type) return "/trader";
    const t = String(type).toLowerCase();
    if (t.includes("squares")) return "/squares";
    if (t.includes("bullion")) return "/bullion";
    if (t.includes("league")) return "/leagues";
    if (t.includes("quickfire")) return "/quickfire";
    return "/trader";
}
function isPlayInviteType(type) {
    if (!type) return false;
    if (type === "trader_game_starting") return true;
    const t = String(type);
    return t.endsWith("_invite") || t.includes("challenge") || t.includes("game_invite");
}
function notificationSenderAppearsOnline(sender) {
    if (!sender || typeof sender !== "object") return false;
    if (typeof sender.is_online === "boolean") return sender.is_online;
    if (typeof sender.online === "boolean") return sender.online;
    if (typeof sender.online_status === "boolean") return sender.online_status;
    if (typeof sender.online_status === "string") {
        const status = sender.online_status.trim().toLowerCase();
        if (status === "online") return true;
        if (status === "offline") return false;
    }
    if (typeof sender.presence === "boolean") return sender.presence;
    if (sender.presence && typeof sender.presence === "object" && typeof sender.presence.online === "boolean") return sender.presence.online;
    return false;
}
function parseSquaresChallengeEntityRef(ref) {
    if (ref == null || typeof ref !== "string") return {
        matchId: null,
        matchName: null
    };
    try {
        const o = JSON.parse(ref);
        return {
            matchId: o.match_id != null ? String(o.match_id) : null,
            matchName: o.match_name != null ? String(o.match_name) : null
        };
    } catch  {
        return {
            matchId: null,
            matchName: null
        };
    }
}
function parseSixesCardReadyEntityRef(ref) {
    if (ref != null && typeof ref === "object") return ref;
    try {
        const o = JSON.parse(ref || "{}");
        return o && typeof o === "object" && !Array.isArray(o) ? o : {};
    } catch  {
        return {};
    }
}
function parseBullionChallengeEntityRef(ref) {
    if (ref == null || typeof ref !== "string") return {
        matchId: null,
        matchName: null,
        gameId: null,
        gameName: null,
        inviteCode: null,
        visibility: null
    };
    try {
        const o = JSON.parse(ref);
        const gid = o.game_id != null ? parseInt(String(o.game_id), 10) : NaN;
        const visRaw = o.visibility != null && String(o.visibility).trim() !== "" ? String(o.visibility).trim().toLowerCase() : null;
        const visibility = visRaw === "public" || visRaw === "private" ? visRaw : null;
        return {
            matchId: o.match_id != null ? String(o.match_id) : null,
            matchName: o.match_name != null ? String(o.match_name) : null,
            gameId: Number.isFinite(gid) ? gid : null,
            gameName: o.game_name != null ? String(o.game_name) : null,
            inviteCode: o.invite_code != null && String(o.invite_code).trim() !== "" ? String(o.invite_code).trim() : null,
            visibility
        };
    } catch  {
        return {
            matchId: null,
            matchName: null,
            gameId: null,
            gameName: null,
            inviteCode: null,
            visibility: null
        };
    }
}
function isBullionPrivateBattleChallenge(parsed) {
    if (!parsed || typeof parsed !== "object") return false;
    if (parsed.visibility === "public") return false;
    if (parsed.visibility === "private") return true;
    return Boolean(parsed.inviteCode && String(parsed.inviteCode).trim());
}
/** `entity_ref` JSON for league invite / join / starting / cancelled notifications. */ function normalizeLeagueCancelReason(raw) {
    const key = String(raw ?? "").trim().toLowerCase();
    if (key === "underfill" || key === "abandoned" || key === "admin") return key;
    return null;
}
function parseLeagueInviteEntityRef(ref) {
    if (ref == null || typeof ref !== "string") return {
        leagueId: null,
        leagueName: null,
        code: null,
        matchName: null,
        matchLive: false,
        rubiesRefunded: false,
        cancelReason: null,
        place: null,
        placeLabel: null,
        prizeCoins: 0,
        xpEarned: 0
    };
    try {
        const o = JSON.parse(ref);
        const leagueId = o.league_id != null && String(o.league_id).trim() ? String(o.league_id).trim() : null;
        const placeRaw = parseInt(String(o.place ?? ""), 10);
        const place = Number.isFinite(placeRaw) && placeRaw > 0 ? placeRaw : null;
        const prizeRaw = parseInt(String(o.prize_coins ?? ""), 10);
        const prizeCoins = Number.isFinite(prizeRaw) && prizeRaw > 0 ? prizeRaw : 0;
        const xpRaw = parseInt(String(o.xp_earned ?? ""), 10);
        const xpEarned = Number.isFinite(xpRaw) && xpRaw > 0 ? xpRaw : 0;
        const placeLabel = typeof o.place_label === "string" && o.place_label.trim() ? o.place_label.trim().toLowerCase() : place != null ? formatLeaguePlaceLabel(place) : null;
        return {
            leagueId,
            leagueName: o.league_name != null && String(o.league_name).trim() ? String(o.league_name).trim() : null,
            code: o.code != null && String(o.code).trim() ? String(o.code).trim() : null,
            matchName: o.match_name != null && String(o.match_name).trim() ? String(o.match_name).trim() : null,
            matchLive: o.match_live === true,
            rubiesRefunded: o.rubies_refunded === true,
            cancelReason: normalizeLeagueCancelReason(o.reason),
            place,
            placeLabel,
            prizeCoins,
            xpEarned
        };
    } catch  {
        return {
            leagueId: null,
            leagueName: null,
            code: null,
            matchName: null,
            matchLive: false,
            rubiesRefunded: false,
            cancelReason: null,
            place: null,
            placeLabel: null,
            prizeCoins: 0,
            xpEarned: 0
        };
    }
}
/** Lowercase ordinal for league finish copy, e.g. "1st" / "2nd". */ function formatLeaguePlaceLabel(place) {
    const n = Math.max(0, Math.floor(Number(place) || 0));
    if (n <= 0) return "";
    const mod100 = n % 100;
    let suffix = "th";
    if (mod100 < 11 || mod100 > 13) {
        const mod10 = n % 10;
        if (mod10 === 1) suffix = "st";
        else if (mod10 === 2) suffix = "nd";
        else if (mod10 === 3) suffix = "rd";
    }
    return `${n}${suffix}`;
}
function leagueInviteDeepLinkFromEntityRef(entityRef) {
    const { leagueId, code } = parseLeagueInviteEntityRef(entityRef);
    if (leagueId) return `/leagues?id=${encodeURIComponent(leagueId)}`;
    if (code) return `/leagues?code=${encodeURIComponent(code)}`;
    return "/leagues";
}
function parseSixesChallengeEntityRef(ref) {
    if (ref == null || typeof ref !== "string") return {
        matchId: null,
        matchName: null
    };
    try {
        const o = JSON.parse(ref);
        return {
            matchId: o.match_id != null ? String(o.match_id) : null,
            matchName: o.match_name != null ? String(o.match_name) : null
        };
    } catch  {
        return {
            matchId: null,
            matchName: null
        };
    }
}
function parseTraderChallengeEntityRef(ref) {
    if (ref == null || typeof ref !== "string") return {
        matchId: null,
        matchName: null,
        sport: null
    };
    try {
        const o = JSON.parse(ref);
        return {
            matchId: o.match_id != null ? String(o.match_id) : null,
            matchName: o.match_name != null ? String(o.match_name) : null,
            sport: o.sport != null ? String(o.sport).trim().toLowerCase() : null
        };
    } catch  {
        return {
            matchId: null,
            matchName: null,
            sport: null
        };
    }
}
function sixesMatchDeepLinkFromEntityRef(entityRef) {
    const { matchId } = parseSixesChallengeEntityRef(entityRef);
    if (!matchId) return "/sixes";
    return `/sixes?match=${encodeURIComponent(matchId)}`;
}
function traderMatchDeepLinkFromEntityRef(entityRef) {
    const { matchId, sport } = parseTraderChallengeEntityRef(entityRef);
    if (!matchId) return "/trader";
    const params = new URLSearchParams();
    const sportKey = sport || "cricket";
    params.set("sport", sportKey);
    if (sportKey === "horses") params.set("raceId", matchId);
    else params.set("matchId", matchId);
    return `/trader?${params.toString()}`;
}
function bullionContestDeepLinkFromEntityRef(entityRef) {
    const { matchId, gameId, inviteCode } = parseBullionChallengeEntityRef(entityRef);
    if (!matchId || gameId == null || Number.isNaN(gameId)) return "/bullion";
    const q = new URLSearchParams();
    q.set("match", matchId);
    q.set("game", String(gameId));
    if (inviteCode) q.set("invite", inviteCode);
    return `/bullion?${q.toString()}`;
}
function getNotificationDisplay(notification) {
    const senderName = notification.sender ? notification.sender.player_name || notification.sender.username || "Someone" : "Cricket8";
    const profileTo = senderProfileTo(notification);
    const senderPic = (0, _sessionUser.resolveAvatarUrl)(notification.sender);
    switch(notification.type){
        case "xp_earned":
            {
                const { amount, label, reason, grantCount } = parseXpEntityRef(notification.entity_ref);
                const detail = xpNotificationDetail(reason, label, grantCount);
                return {
                    titleParts: [
                        {
                            text: "You earned "
                        },
                        {
                            text: String(amount || 0),
                            emphasize: true
                        },
                        {
                            xpIcon: true
                        },
                        {
                            text: ` for ${detail}.`
                        }
                    ],
                    avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                    avatarObjectFit: "contain",
                    cta: {
                        label: "XP",
                        to: "/profile"
                    },
                    navigateTo: "/profile"
                };
            }
        case "friend_earned_xp":
            {
                const { amount, label, reason, grantCount } = parseXpEntityRef(notification.entity_ref);
                const detail = xpNotificationDetail(reason, label, grantCount, {
                    forFriend: true
                });
                return {
                    titleParts: [
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " earned "
                        },
                        {
                            text: String(amount || 0),
                            emphasize: true
                        },
                        {
                            xpIcon: true
                        },
                        {
                            text: ` for ${detail}.`
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: {
                        label: "PROFILE",
                        to: profileTo
                    },
                    navigateTo: profileTo
                };
            }
        case "xp_week_podium":
            {
                const { periodLabel, rankLabel, xpValue } = parseXpWeekPodiumEntityRef(notification.entity_ref);
                const place = rankLabel || "on the podium";
                const weekLabel = periodLabel || "last week";
                const titleParts = [
                    {
                        text: "You finished "
                    },
                    {
                        text: place,
                        emphasize: true
                    },
                    {
                        text: " on the XP leaderboard for "
                    },
                    {
                        text: weekLabel,
                        emphasize: true
                    },
                    {
                        text: "."
                    }
                ];
                if (xpValue != null) titleParts.push({
                    text: " ("
                }, {
                    text: String(xpValue),
                    emphasize: true
                }, {
                    xpIcon: true
                }, {
                    text: ")."
                });
                return {
                    titleParts,
                    avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                    avatarObjectFit: "contain",
                    cta: {
                        label: "LEADERBOARD",
                        to: "/xp-leaderboard"
                    },
                    navigateTo: "/xp-leaderboard"
                };
            }
        case "welcome_bonus":
            return {
                titleParts: [
                    {
                        text: "Welcome to Cricket8",
                        emphasize: true
                    },
                    {
                        text: " \uD83C\uDF89"
                    },
                    {
                        text: " You've been gifted "
                    },
                    {
                        text: "1000 ",
                        emphasize: true
                    },
                    {
                        coinIcon: true
                    },
                    {
                        text: " and "
                    },
                    {
                        text: "1 ",
                        emphasize: true
                    },
                    {
                        rubyIcon: true
                    },
                    {
                        text: " to play our games."
                    }
                ],
                avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                avatarObjectFit: "contain",
                cta: {
                    label: "SHOP",
                    to: "/shop",
                    openShopDrawer: true
                },
                navigateTo: "/"
            };
        case "friend_request":
            return {
                titleParts: [
                    {
                        text: senderName,
                        emphasizeUsername: true
                    },
                    {
                        text: " sent you a friend request"
                    }
                ],
                avatarUrl: senderPic,
                cta: {
                    label: "PROFILE",
                    to: profileTo
                },
                navigateTo: profileTo
            };
        case "friend_request_accepted":
        case "now_friends":
            return {
                titleParts: [
                    {
                        text: senderName,
                        emphasizeUsername: true
                    },
                    {
                        text: " is now your friend."
                    }
                ],
                avatarUrl: senderPic,
                cta: {
                    label: "PROFILE",
                    to: profileTo
                },
                navigateTo: profileTo
            };
        case "trader_game_starting":
            return {
                titleParts: [
                    {
                        text: "Trader game is starting"
                    }
                ],
                avatarUrl: senderPic,
                cta: {
                    label: "PLAY",
                    to: "/trader"
                },
                navigateTo: "/trader"
            };
        case "squares_match_challenge":
            {
                const { matchId, matchName } = parseSquaresChallengeEntityRef(notification.entity_ref);
                const label = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName) || "a live match";
                const playTo = matchId ? `/squares?match=${encodeURIComponent(matchId)}` : "/squares";
                const playable = (0, _notificationTaxonomy.isFriendChallengePlayable)(notification);
                const matchOpen = (0, _notificationTaxonomy.isFriendChallengeMatchOpen)(notification);
                const history = (0, _notificationTaxonomy.isFriendChallengeHistory)(notification);
                // History (entered match) keeps invite copy; closed match adds finished suffix.
                const closedSuffix = !matchOpen && !history ? ". That match has finished." : ".";
                return {
                    titleParts: [
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " challenged you to play Squares on "
                        },
                        {
                            text: label,
                            emphasize: true
                        },
                        {
                            text: closedSuffix
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: playable ? {
                        label: "PLAY SQUARES",
                        to: playTo
                    } : null,
                    // History can still reopen a live match; finished rows go to profile.
                    navigateTo: matchOpen ? playTo : profileTo
                };
            }
        case "squares_match_challenge_sent":
            {
                const { matchId, matchName } = parseSquaresChallengeEntityRef(notification.entity_ref);
                const label = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName) || "a live match";
                const playTo = matchId ? `/squares?match=${encodeURIComponent(matchId)}` : "/squares";
                const playable = (0, _notificationTaxonomy.isFriendChallengePlayable)(notification);
                const matchOpen = (0, _notificationTaxonomy.isFriendChallengeMatchOpen)(notification);
                const history = (0, _notificationTaxonomy.isFriendChallengeHistory)(notification);
                const closedSuffix = !matchOpen && !history ? ". That match has finished." : ".";
                return {
                    titleParts: [
                        {
                            text: "You challenged "
                        },
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " to play Squares on "
                        },
                        {
                            text: label,
                            emphasize: true
                        },
                        {
                            text: closedSuffix
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: playable ? {
                        label: "MATCH",
                        to: playTo
                    } : null,
                    navigateTo: matchOpen ? playTo : profileTo
                };
            }
        case "bullion_match_challenge":
            {
                const parsed = parseBullionChallengeEntityRef(notification.entity_ref);
                const { matchName, gameName } = parsed;
                const matchLabel = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName) || "this match";
                const gameLabel = gameName && gameName.trim() ? gameName.trim() : "";
                const playTo = bullionContestDeepLinkFromEntityRef(notification.entity_ref);
                const playable = (0, _notificationTaxonomy.isFriendChallengePlayable)(notification);
                const matchOpen = (0, _notificationTaxonomy.isFriendChallengeMatchOpen)(notification);
                const history = (0, _notificationTaxonomy.isFriendChallengeHistory)(notification);
                const isPrivateBattle = isBullionPrivateBattleChallenge(parsed);
                const inviteVerbPhrase = isPrivateBattle ? " invited you to the private battle " : " invited you to the public arena ";
                const closedSuffixText = isPrivateBattle ? ". That battle has closed." : ". That arena has closed.";
                const closedSuffix = !matchOpen && !history ? closedSuffixText : ".";
                const challengeLine = [
                    {
                        text: senderName,
                        emphasizeUsername: true
                    },
                    {
                        text: inviteVerbPhrase
                    },
                    ...gameLabel ? [
                        {
                            text: gameLabel,
                            emphasize: true
                        },
                        {
                            text: " on "
                        }
                    ] : [
                        {
                            text: "on "
                        }
                    ],
                    {
                        text: matchLabel,
                        emphasize: true
                    },
                    {
                        text: closedSuffix
                    }
                ];
                return {
                    titleParts: challengeLine,
                    avatarUrl: senderPic,
                    cta: playable ? {
                        label: "PLAY BULLION",
                        to: playTo
                    } : null,
                    navigateTo: matchOpen ? playTo : profileTo
                };
            }
        case "bullion_match_challenge_sent":
            {
                const parsed = parseBullionChallengeEntityRef(notification.entity_ref);
                const { matchName, gameName } = parsed;
                const matchLabel = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName) || "this match";
                const gameLabel = gameName && gameName.trim() ? gameName.trim() : "";
                const playTo = bullionContestDeepLinkFromEntityRef(notification.entity_ref);
                const playable = (0, _notificationTaxonomy.isFriendChallengePlayable)(notification);
                const matchOpen = (0, _notificationTaxonomy.isFriendChallengeMatchOpen)(notification);
                const history = (0, _notificationTaxonomy.isFriendChallengeHistory)(notification);
                const isPrivateBattle = isBullionPrivateBattleChallenge(parsed);
                const inviteVerbPhrase = isPrivateBattle ? " to the private battle " : " to the public arena ";
                const closedSuffixText = isPrivateBattle ? ". That battle has closed." : ". That arena has closed.";
                const closedSuffix = !matchOpen && !history ? closedSuffixText : ".";
                const sentLine = [
                    {
                        text: "You invited "
                    },
                    {
                        text: senderName,
                        emphasizeUsername: true
                    },
                    {
                        text: inviteVerbPhrase
                    },
                    ...gameLabel ? [
                        {
                            text: gameLabel,
                            emphasize: true
                        },
                        {
                            text: " on "
                        }
                    ] : [
                        {
                            text: "on "
                        }
                    ],
                    {
                        text: matchLabel,
                        emphasize: true
                    },
                    {
                        text: closedSuffix
                    }
                ];
                return {
                    titleParts: sentLine,
                    avatarUrl: senderPic,
                    cta: playable ? {
                        label: "OPEN",
                        to: playTo
                    } : null,
                    navigateTo: matchOpen ? playTo : profileTo
                };
            }
        case "league_invite":
            {
                const { leagueName, matchName, matchLive } = parseLeagueInviteEntityRef(notification.entity_ref);
                const playTo = leagueInviteDeepLinkFromEntityRef(notification.entity_ref);
                const nameLabel = leagueName || "a league";
                const matchLabel = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName);
                return {
                    titleParts: [
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " invited you to "
                        },
                        {
                            text: nameLabel,
                            emphasize: true
                        },
                        ...matchLabel ? [
                            {
                                text: " on "
                            },
                            {
                                text: matchLabel,
                                emphasize: true
                            }
                        ] : [],
                        {
                            text: matchLive ? ". The match is live \u2014 you can still join." : "."
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: {
                        label: "JOIN LEAGUE",
                        to: playTo
                    },
                    navigateTo: playTo
                };
            }
        case "bullion_battle_entered":
            {
                const parsed = parseBullionChallengeEntityRef(notification.entity_ref);
                const { matchName, gameName } = parsed;
                const matchLabel = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName) || "this match";
                const gameLabel = gameName && gameName.trim() ? gameName.trim() : "";
                const playTo = bullionContestDeepLinkFromEntityRef(notification.entity_ref);
                return {
                    titleParts: [
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " entered your private battle "
                        },
                        ...gameLabel ? [
                            {
                                text: gameLabel,
                                emphasize: true
                            },
                            {
                                text: " on "
                            }
                        ] : [
                            {
                                text: "on "
                            }
                        ],
                        {
                            text: matchLabel,
                            emphasize: true
                        },
                        {
                            text: "."
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: {
                        label: "OPEN",
                        to: playTo
                    },
                    navigateTo: playTo
                };
            }
        case "league_member_joined":
            {
                const { leagueName } = parseLeagueInviteEntityRef(notification.entity_ref);
                const playTo = leagueInviteDeepLinkFromEntityRef(notification.entity_ref);
                return {
                    titleParts: [
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " joined "
                        },
                        {
                            text: leagueName || "your league",
                            emphasize: true
                        },
                        {
                            text: "."
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: {
                        label: "OPEN",
                        to: playTo
                    },
                    navigateTo: playTo
                };
            }
        case "league_member_joined_live":
            {
                const { leagueName } = parseLeagueInviteEntityRef(notification.entity_ref);
                const playTo = leagueInviteDeepLinkFromEntityRef(notification.entity_ref);
                return {
                    titleParts: [
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " joined "
                        },
                        {
                            text: leagueName || "your league",
                            emphasize: true
                        },
                        {
                            text: " mid-match."
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: {
                        label: "OPEN",
                        to: playTo
                    },
                    navigateTo: playTo
                };
            }
        case "league_invite_sent":
            {
                const { leagueName, matchName } = parseLeagueInviteEntityRef(notification.entity_ref);
                const playTo = leagueInviteDeepLinkFromEntityRef(notification.entity_ref);
                const nameLabel = leagueName || "a league";
                const matchLabel = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName);
                return {
                    titleParts: [
                        {
                            text: "You invited "
                        },
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " to "
                        },
                        {
                            text: nameLabel,
                            emphasize: true
                        },
                        ...matchLabel ? [
                            {
                                text: " on "
                            },
                            {
                                text: matchLabel,
                                emphasize: true
                            }
                        ] : [],
                        {
                            text: "."
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: {
                        label: "OPEN",
                        to: playTo
                    },
                    navigateTo: playTo
                };
            }
        case "league_starting":
            {
                const { leagueName, matchName } = parseLeagueInviteEntityRef(notification.entity_ref);
                const playTo = leagueInviteDeepLinkFromEntityRef(notification.entity_ref);
                const nameLabel = leagueName || "your league";
                const matchLabel = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName);
                return {
                    titleParts: [
                        {
                            text: nameLabel,
                            emphasize: true
                        },
                        {
                            text: " starts soon"
                        },
                        ...matchLabel ? [
                            {
                                text: " \u2014 "
                            },
                            {
                                text: matchLabel,
                                emphasize: true
                            }
                        ] : [],
                        {
                            text: "."
                        }
                    ],
                    avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                    avatarObjectFit: "contain",
                    cta: {
                        label: "OPEN LEAGUE",
                        to: playTo
                    },
                    navigateTo: playTo
                };
            }
        case "league_cancelled":
            {
                const { leagueName, rubiesRefunded, cancelReason } = parseLeagueInviteEntityRef(notification.entity_ref);
                const playTo = leagueInviteDeepLinkFromEntityRef(notification.entity_ref);
                const nameLabel = leagueName || "Your league";
                const reasonBit = cancelReason === "underfill" ? " \u2014 not enough players joined" : cancelReason === "abandoned" ? " \u2014 the match was abandoned" : "";
                const refundBit = rubiesRefunded ? reasonBit ? ". Your Rubies were returned." : " \u2014 your Rubies were returned." : ".";
                return {
                    titleParts: [
                        {
                            text: nameLabel,
                            emphasize: true
                        },
                        {
                            text: " was cancelled"
                        },
                        {
                            text: `${reasonBit}${refundBit}`
                        }
                    ],
                    avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                    avatarObjectFit: "contain",
                    cta: {
                        label: "VIEW LEAGUE",
                        to: playTo
                    },
                    navigateTo: playTo
                };
            }
        case "league_finished":
            {
                const { leagueName, placeLabel, prizeCoins, xpEarned } = parseLeagueInviteEntityRef(notification.entity_ref);
                const playTo = leagueInviteDeepLinkFromEntityRef(notification.entity_ref);
                const nameLabel = leagueName || "your league";
                /** @type {Array<{ text?: string, emphasize?: boolean, coinIcon?: boolean, xpIcon?: boolean }>} */ const titleParts = placeLabel ? [
                    {
                        text: "You finished "
                    },
                    {
                        text: placeLabel,
                        emphasize: true
                    },
                    {
                        text: " in "
                    },
                    {
                        text: nameLabel,
                        emphasize: true
                    }
                ] : [
                    {
                        text: nameLabel,
                        emphasize: true
                    },
                    {
                        text: " has finished"
                    }
                ];
                if (prizeCoins > 0 || xpEarned > 0) {
                    titleParts.push({
                        text: ". You received "
                    });
                    if (prizeCoins > 0) titleParts.push({
                        text: prizeCoins.toLocaleString("en-US"),
                        emphasize: true
                    }, {
                        text: " "
                    }, {
                        coinIcon: true
                    });
                    if (prizeCoins > 0 && xpEarned > 0) titleParts.push({
                        text: " and "
                    });
                    if (xpEarned > 0) titleParts.push({
                        text: xpEarned.toLocaleString("en-US"),
                        emphasize: true
                    }, {
                        text: " "
                    }, {
                        xpIcon: true
                    });
                    titleParts.push({
                        text: "."
                    });
                } else titleParts.push({
                    text: ". Results are ready."
                });
                return {
                    titleParts,
                    avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                    avatarObjectFit: "contain",
                    cta: {
                        label: "SEE RESULTS",
                        to: playTo
                    },
                    navigateTo: playTo
                };
            }
        case "sixes_match_challenge":
            {
                const { matchId, matchName } = parseSixesChallengeEntityRef(notification.entity_ref);
                const label = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName) || "a live match";
                const playTo = matchId ? sixesMatchDeepLinkFromEntityRef(notification.entity_ref) : "/sixes";
                const playable = (0, _notificationTaxonomy.isFriendChallengePlayable)(notification);
                const matchOpen = (0, _notificationTaxonomy.isFriendChallengeMatchOpen)(notification);
                const history = (0, _notificationTaxonomy.isFriendChallengeHistory)(notification);
                const closedSuffix = !matchOpen && !history ? ". That match has finished." : ".";
                return {
                    titleParts: [
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " challenged you to play Sixes on "
                        },
                        {
                            text: label,
                            emphasize: true
                        },
                        {
                            text: closedSuffix
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: playable ? {
                        label: "PLAY SIXES",
                        to: playTo
                    } : null,
                    navigateTo: matchOpen ? playTo : profileTo
                };
            }
        case "sixes_match_challenge_sent":
            {
                const { matchName } = parseSixesChallengeEntityRef(notification.entity_ref);
                const label = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName) || "a live match";
                const playTo = sixesMatchDeepLinkFromEntityRef(notification.entity_ref);
                const playable = (0, _notificationTaxonomy.isFriendChallengePlayable)(notification);
                const matchOpen = (0, _notificationTaxonomy.isFriendChallengeMatchOpen)(notification);
                const history = (0, _notificationTaxonomy.isFriendChallengeHistory)(notification);
                const closedSuffix = !matchOpen && !history ? ". That match has finished." : ".";
                return {
                    titleParts: [
                        {
                            text: "You challenged "
                        },
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: " to play Sixes on "
                        },
                        {
                            text: label,
                            emphasize: true
                        },
                        {
                            text: closedSuffix
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: playable ? {
                        label: "MATCH",
                        to: playTo
                    } : null,
                    navigateTo: matchOpen ? playTo : profileTo
                };
            }
        case "trader_match_challenge":
            {
                const { matchName, sport } = parseTraderChallengeEntityRef(notification.entity_ref);
                const label = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName) || "a live match";
                const playTo = traderMatchDeepLinkFromEntityRef(notification.entity_ref);
                const playable = (0, _notificationTaxonomy.isFriendChallengePlayable)(notification);
                const matchOpen = (0, _notificationTaxonomy.isFriendChallengeMatchOpen)(notification);
                const history = (0, _notificationTaxonomy.isFriendChallengeHistory)(notification);
                const closedSuffix = !matchOpen && !history ? ". That match has finished." : ".";
                const sportBit = sport ? ` (${sport})` : "";
                return {
                    titleParts: [
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: ` challenged you to trade${sportBit} on `
                        },
                        {
                            text: label,
                            emphasize: true
                        },
                        {
                            text: closedSuffix
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: playable ? {
                        label: "TRADE",
                        to: playTo
                    } : null,
                    navigateTo: matchOpen ? playTo : profileTo
                };
            }
        case "trader_match_challenge_sent":
            {
                const { matchName, sport } = parseTraderChallengeEntityRef(notification.entity_ref);
                const label = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName) || "a live match";
                const playTo = traderMatchDeepLinkFromEntityRef(notification.entity_ref);
                const playable = (0, _notificationTaxonomy.isFriendChallengePlayable)(notification);
                const matchOpen = (0, _notificationTaxonomy.isFriendChallengeMatchOpen)(notification);
                const history = (0, _notificationTaxonomy.isFriendChallengeHistory)(notification);
                const closedSuffix = !matchOpen && !history ? ". That match has finished." : ".";
                const sportBit = sport ? ` (${sport})` : "";
                return {
                    titleParts: [
                        {
                            text: "You challenged "
                        },
                        {
                            text: senderName,
                            emphasizeUsername: true
                        },
                        {
                            text: ` to trade${sportBit} on `
                        },
                        {
                            text: label,
                            emphasize: true
                        },
                        {
                            text: closedSuffix
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: playable ? {
                        label: "MATCH",
                        to: playTo
                    } : null,
                    navigateTo: matchOpen ? playTo : profileTo
                };
            }
        case "coins_running_low":
            return {
                titleParts: [
                    {
                        text: "Your coins are running low."
                    },
                    {
                        text: " Top up in the Shop to keep playing."
                    }
                ],
                avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                avatarObjectFit: "contain",
                cta: {
                    label: "SHOP",
                    to: "/shop",
                    openShopDrawer: true
                },
                navigateTo: "/"
            };
        case "unlock_username_emoji":
            return {
                titleParts: [
                    {
                        text: "Unlock your "
                    },
                    {
                        text: "username / emoji",
                        emphasize: true
                    },
                    {
                        text: " pack to personalise your profile."
                    }
                ],
                avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                avatarObjectFit: "contain",
                cta: {
                    label: "MY ACCOUNT",
                    to: "/account"
                },
                navigateTo: "/account"
            };
        case "promo":
            return {
                titleParts: [
                    {
                        text: "New promo is live. Check it out now."
                    }
                ],
                avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                avatarObjectFit: "contain",
                cta: {
                    label: "PLAY",
                    to: "/"
                },
                navigateTo: "/"
            };
        case "sixes_card_ready":
            {
                const ref = parseSixesCardReadyEntityRef(notification.entity_ref);
                const teamA = typeof ref.team_a === "string" ? ref.team_a.trim() : "";
                const teamB = typeof ref.team_b === "string" ? ref.team_b.trim() : "";
                const matchTitle = typeof ref.title === "string" && ref.title.trim() ? ref.title.trim() : teamA && teamB ? `${teamA} v ${teamB}` : typeof ref.match_name === "string" && ref.match_name.trim() ? ref.match_name.trim() : "today";
                const ctaHref = typeof ref.cta_href === "string" && ref.cta_href.trim() ? ref.cta_href.trim() : "/sixes";
                const ctaLabel = typeof ref.cta_label === "string" && ref.cta_label.trim() ? ref.cta_label.trim().slice(0, 18) : "OPEN SIXES";
                return {
                    titleParts: [
                        {
                            text: "Your Sixes card for "
                        },
                        {
                            text: matchTitle,
                            emphasize: true
                        },
                        {
                            text: " is ready to reveal."
                        }
                    ],
                    avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                    avatarObjectFit: "contain",
                    cta: {
                        label: ctaLabel,
                        to: ctaHref
                    },
                    navigateTo: ctaHref
                };
            }
        case "sixes_cards_online":
            {
                const ref = parseSixesCardReadyEntityRef(notification.entity_ref);
                const teamA = typeof ref.team_a === "string" ? ref.team_a.trim() : "";
                const teamB = typeof ref.team_b === "string" ? ref.team_b.trim() : "";
                const matchTitle = typeof ref.title === "string" && ref.title.trim() ? ref.title.trim() : teamA && teamB ? `${teamA} v ${teamB}` : "";
                const ctaHref = typeof ref.cta_href === "string" && ref.cta_href.trim() ? ref.cta_href.trim() : "/sixes";
                const ctaLabel = typeof ref.cta_label === "string" && ref.cta_label.trim() ? ref.cta_label.trim().slice(0, 18) : "OPEN SIXES";
                return {
                    titleParts: matchTitle ? [
                        {
                            text: "Sixes cards are online \u2014 "
                        },
                        {
                            text: matchTitle,
                            emphasize: true
                        },
                        {
                            text: " is ready to play."
                        }
                    ] : [
                        {
                            text: "Sixes cards are online. Open the lobby to play."
                        }
                    ],
                    avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                    avatarObjectFit: "contain",
                    cta: {
                        label: ctaLabel,
                        to: ctaHref
                    },
                    navigateTo: ctaHref
                };
            }
        case "playable_game_offer":
            {
                const ref = parseSixesCardReadyEntityRef(notification.entity_ref);
                const gameTypeRaw = typeof ref.game_type === "string" ? ref.game_type.trim().toLowerCase() : "";
                const gameType = gameTypeRaw === "bullion" ? "bullion" : gameTypeRaw === "leagues" ? "leagues" : "sixes";
                const matchTitle = typeof ref.title === "string" && ref.title.trim() ? ref.title.trim() : typeof ref.match_name === "string" && ref.match_name.trim() ? ref.match_name.trim() : "today";
                const ctaHrefRaw = typeof ref.cta_href === "string" ? ref.cta_href.trim() : "";
                const ctaHref = ctaHrefRaw.startsWith("/") && !ctaHrefRaw.startsWith("//") ? ctaHrefRaw : gameType === "bullion" ? "/bullion" : gameType === "leagues" ? "/leagues" : "/sixes";
                const ctaLabel = typeof ref.cta_label === "string" && ref.cta_label.trim() ? ref.cta_label.trim().slice(0, 18) : gameType === "bullion" ? "MAKE PICKS" : gameType === "leagues" ? "JOIN LEAGUE" : "REVEAL CARD";
                const lead = gameType === "bullion" ? "Make your picks in Bullion \u2014 " : gameType === "leagues" ? "Join the public league \u2014 " : "Reveal your card in Sixes \u2014 ";
                return {
                    titleParts: [
                        {
                            text: lead
                        },
                        {
                            text: matchTitle,
                            emphasize: true
                        }
                    ],
                    avatarUrl: gameType === "bullion" ? "/assets/bullion.png" : gameType === "leagues" ? "/assets/league-trophy.png" : "/assets/sixes.png",
                    avatarObjectFit: "contain",
                    cta: {
                        label: ctaLabel,
                        to: ctaHref
                    },
                    navigateTo: ctaHref
                };
            }
        case "wallet_grant":
            {
                const grant = parseWalletGrantEntityRef(notification.entity_ref);
                return {
                    titleParts: walletGrantTitleParts(grant),
                    avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                    avatarObjectFit: "contain",
                    cta: {
                        label: "WALLET",
                        to: "/",
                        openWalletHistory: true
                    },
                    navigateTo: "/"
                };
            }
        case "admin_message":
            {
                const { title, body, ctaLabel, ctaHref } = parseAdminMessageEntityRef(notification.entity_ref);
                const titleParts = [];
                if (title) titleParts.push({
                    text: title,
                    emphasize: true
                });
                if (title && body) titleParts.push({
                    text: " "
                });
                if (body) titleParts.push({
                    text: body
                });
                if (titleParts.length === 0) titleParts.push({
                    text: "You have a new message from Cricket8."
                });
                const opensShop = /^\/shop(?:[/?#]|$)/.test(ctaHref);
                const cta = ctaLabel && ctaHref ? {
                    label: ctaLabel.slice(0, 18),
                    to: ctaHref,
                    ...opensShop && {
                        openShopDrawer: true
                    }
                } : null;
                return {
                    titleParts,
                    avatarUrl: (0, _logo.CRICKET8_LOGO_SRC),
                    avatarObjectFit: "contain",
                    cta,
                    navigateTo: opensShop ? "/" : ctaHref || "/"
                };
            }
        default:
            if (isPlayInviteType(notification.type)) {
                const to = playRouteForType(notification.type);
                const raw = notification.type?.replace(/_/g, " ") || "New notification";
                return {
                    titleParts: [
                        {
                            text: raw
                        }
                    ],
                    avatarUrl: senderPic,
                    cta: {
                        label: "PLAY",
                        to
                    },
                    navigateTo: to
                };
            }
            return {
                titleParts: [
                    {
                        text: notification.type?.replace(/_/g, " ") || "New notification"
                    }
                ],
                avatarUrl: senderPic,
                cta: null,
                navigateTo: "/profile"
            };
    }
}
const NOTIFICATION_AVATAR_CLASS = "relative h-[30px] w-[30px] shrink-0 self-start bg-[#d379f6]/25";
const NOTIFICATION_AVATAR_CLASS_COMPACT = "relative h-[30px] w-[30px] shrink-0 self-start bg-[#d379f6]/25";
const NOTIFICATION_AVATAR_STREAM_CLASS = "relative h-[30px] w-[30px] shrink-0 self-center bg-[#d379f6]/25";
const NOTIFICATION_MAIN_TEXT_PAD = "min-h-0 py-0 pl-0.5 pr-1 sm:pl-1 sm:pr-1.5";
const NOTIFICATION_CTA_PILL_CLASS = "inline-flex h-[22px] min-w-[4rem] w-[4rem] max-h-[22px] shrink-0 items-center justify-center whitespace-nowrap rounded-none border-0 bg-white px-1.5 py-0 text-center font-anton text-[9px] font-normal uppercase leading-none tracking-wide text-black transition-opacity hover:opacity-90 sm:min-w-[5.25rem] sm:w-[5.25rem] sm:px-2 sm:text-[10px]";
const NOTIFICATION_ACTIVITY_STREAM_ROW_GRID_CLASS = "grid w-full min-w-0 grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-x-0 overflow-x-hidden bg-[#7234c1] pr-1 transition-[filter] hover:brightness-105 sm:pr-2";
const NOTIFICATION_STREAM_BODY_CLASS = "min-w-0 break-words font-chakra text-[12px] font-normal leading-[18px] tracking-normal text-white sm:text-[13px] sm:leading-[20px]";
const NOTIFICATION_STREAM_NAME_CLASS = "font-anton text-[10px] font-normal leading-[18px] tracking-normal uppercase sm:text-[11px] sm:leading-[20px]";
const NOTIFICATION_STREAM_TIME_SIDE_CLASS = "whitespace-nowrap text-[11px] leading-none text-[#c4b8d4] sm:text-[12px]";
const NOTIFICATION_STREAM_TIME_SUBLINE_CLASS = "mt-0.5 text-[11px] leading-tight text-[#c4b8d4] sm:text-[12px]";
const MY_ZONE_ACTIVITY_PANEL_ROW_GRID_CLASS = "grid w-full min-w-0 grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-x-2 overflow-x-hidden bg-[#1B062F]/30 min-h-[40px] pr-2 transition-[filter] hover:brightness-105";
const MY_ZONE_ACTIVITY_PANEL_AVATAR_CLASS = "relative h-[40px] w-[40px] shrink-0 self-center bg-[#d379f6]/25";
const MY_ZONE_ACTIVITY_PANEL_CTA_CLASS = "inline-flex h-[30px] min-w-[4rem] w-[4rem] shrink-0 items-center justify-center whitespace-nowrap rounded-none border-0 bg-white px-2 py-0 text-center font-anton text-[9px] font-normal uppercase leading-none tracking-wide text-black transition-opacity hover:opacity-90 sm:min-w-[5.25rem] sm:w-[5.25rem] sm:text-[10px]";
const MY_ZONE_ACTIVITY_PANEL_BODY_CLASS = "min-w-0 break-words [overflow-wrap:anywhere] font-chakra text-[12px] font-normal leading-[16px] tracking-normal text-white";
const MY_ZONE_ACTIVITY_PANEL_NAME_CLASS = "font-anton text-[12px] font-normal leading-[16px] tracking-normal uppercase [overflow-wrap:anywhere]";
const MY_ZONE_ACTIVITY_PANEL_TIME_CLASS = "whitespace-nowrap font-chakra text-[10px] font-normal leading-[16px] tracking-normal text-right text-[#c4b8d4]";
const MY_ZONE_ACTIVITY_PANEL_TITLE_LINE_CLASS = "!block w-full min-w-0 break-words [overflow-wrap:anywhere] font-chakra text-[12px] font-normal leading-[16px] tracking-normal text-white";
const MY_ZONE_ACTIVITY_PANEL_TITLE_USERNAME_CLASS = "font-anton text-[12px] font-normal leading-[16px] tracking-normal uppercase [overflow-wrap:anywhere]";
/** Min height matches avatar; row grows with wrapped title (drawer / activity / toast). */ const NOTIFICATION_ROW_HEIGHT_CLASS = "min-h-[30px]";
const NOTIFICATION_ALERT_ROW_HEIGHT_CLASS = "min-h-[30px]";
function getNotificationRowShellClass(isUnread, includeUnreadRing = true, isAlertRow = false) {
    const ring = includeUnreadRing && isUnread ? "ring-2 ring-inset ring-white/25" : "";
    const rowHeightClass = isAlertRow ? NOTIFICATION_ALERT_ROW_HEIGHT_CLASS : NOTIFICATION_ROW_HEIGHT_CLASS;
    return `flex w-full min-w-0 items-start gap-0.5 overflow-x-hidden pr-1 transition-[filter] sm:gap-1 sm:pr-2 bg-[#7234c1] ${rowHeightClass} ${ring} hover:brightness-105`;
}
function getNotificationRowGridShellClass(isUnread, includeUnreadRing = true, isAlertRow = false) {
    const ring = includeUnreadRing && isUnread ? "ring-2 ring-inset ring-white/25" : "";
    const rowHeightClass = isAlertRow ? NOTIFICATION_ALERT_ROW_HEIGHT_CLASS : NOTIFICATION_ROW_HEIGHT_CLASS;
    return `grid w-full min-w-0 grid-cols-[auto_minmax(0,1fr)_auto] items-start gap-x-0 overflow-x-hidden pr-1 transition-[filter] sm:pr-2 bg-[#7234c1] ${rowHeightClass} ${ring} hover:brightness-105`;
}

},{"../../utils/sessionUser":"4xtMD","../../utils/xp":"jFgAi","../Logo":"62Wf7","../../utils/matchNameDisplay":"cRLsI","./notificationTaxonomy":"gwaMN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jFgAi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XP_ICON_SRC", ()=>XP_ICON_SRC);
parcelHelpers.export(exports, "formatXp", ()=>formatXp);
parcelHelpers.export(exports, "formatXpRank", ()=>formatXpRank);
parcelHelpers.export(exports, "formatWeekCountdown", ()=>formatWeekCountdown);
parcelHelpers.export(exports, "parseXpWeekOptions", ()=>parseXpWeekOptions);
/** Current XP week start (most recent Monday 00:00 IST) — matches the backend weekly cadence. */ parcelHelpers.export(exports, "getXpWeekStart", ()=>getXpWeekStart);
/** Sport segment from `trader_daily_coins_first:SPORT:YYYY-MM-DD` XP reasons. */ parcelHelpers.export(exports, "parseTraderDailyLeaderboardSportFromReason", ()=>parseTraderDailyLeaderboardSportFromReason);
/** IST day segment from `trader_daily_coins_first:SPORT:YYYY-MM-DD`. */ parcelHelpers.export(exports, "parseTraderDailyLeaderboardDayFromReason", ()=>parseTraderDailyLeaderboardDayFromReason);
parcelHelpers.export(exports, "formatTraderSportDisplayName", ()=>formatTraderSportDisplayName);
/** Activity / XP history parenthetical, e.g. "(Daily Cricket Trader leaderboard win, 12 Jun)". */ parcelHelpers.export(exports, "formatTraderDailyLeaderboardXpDetail", ()=>formatTraderDailyLeaderboardXpDetail);
/** Notification phrase after "for …", e.g. "topping the 12 Jun Cricket Trader daily leaderboard". */ parcelHelpers.export(exports, "formatTraderDailyLeaderboardXpNotificationDetail", ()=>formatTraderDailyLeaderboardXpNotificationDetail);
/** IST day segment from `sixes_daily_coins_first:YYYY-MM-DD`. */ parcelHelpers.export(exports, "parseSixesDailyLeaderboardDayFromReason", ()=>parseSixesDailyLeaderboardDayFromReason);
/** Activity / XP history parenthetical, e.g. "(Daily Sixes leaderboard win, 12 Jun)". */ parcelHelpers.export(exports, "formatSixesDailyLeaderboardXpDetail", ()=>formatSixesDailyLeaderboardXpDetail);
/** Notification phrase after "for …", e.g. "topping the 12 Jun Sixes daily leaderboard". */ parcelHelpers.export(exports, "formatSixesDailyLeaderboardXpNotificationDetail", ()=>formatSixesDailyLeaderboardXpNotificationDetail);
parcelHelpers.export(exports, "formatXpHistoryRelative", ()=>formatXpHistoryRelative);
/** Parenthetical XP history copy for league_* reasons (supports `:count` / `:place` / `:game` suffixes). */ parcelHelpers.export(exports, "formatLeagueXpHistoryDetail", ()=>formatLeagueXpHistoryDetail);
parcelHelpers.export(exports, "formatXpHistoryReasonDetail", ()=>formatXpHistoryReasonDetail);
parcelHelpers.export(exports, "parseXpSummary", ()=>parseXpSummary);
/** Merge incoming XP summary without downgrading week totals (e.g. partial career payloads). */ parcelHelpers.export(exports, "mergeXpSummaryPreferHigher", ()=>mergeXpSummaryPreferHigher);
/**
 * My Zone banner: load `/account/xp-summary`, then fall back to the week leaderboard row for the viewer.
 */ parcelHelpers.export(exports, "fetchMyZoneXpSummary", ()=>fetchMyZoneXpSummary);
const XP_ICON_SRC = "/assets/xp.webp";
function formatXp(value) {
    const n = Number(value) || 0;
    return new Intl.NumberFormat("en-IN").format(n);
}
function formatXpRank(rank) {
    const r = Math.trunc(Number(rank) || 0);
    if (r <= 0) return "\u2014";
    const mod100 = r % 100;
    const mod10 = r % 10;
    if (mod100 >= 11 && mod100 <= 13) return `${r}TH`;
    if (mod10 === 1) return `${r}ST`;
    if (mod10 === 2) return `${r}ND`;
    if (mod10 === 3) return `${r}RD`;
    return `${r}TH`;
}
function formatWeekCountdown(countdown) {
    if (!countdown) return "";
    const d = Math.max(0, Number(countdown.days) || 0);
    const h = Math.max(0, Number(countdown.hours) || 0);
    const m = Math.max(0, Number(countdown.minutes) || 0);
    const parts = [];
    if (d > 0) parts.push(`${d}D`);
    if (h > 0) parts.push(`${h}H`);
    if (m > 0 || parts.length === 0) parts.push(`${m}M`);
    return parts.join(" ");
}
function parseXpWeekOptions(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map((item)=>{
        if (!item || typeof item !== "object") return null;
        const o = item;
        const week_key = String(o.week_key ?? "").trim();
        if (!week_key) return null;
        return {
            week_key,
            label: String(o.label ?? week_key),
            is_current: Boolean(o.is_current),
            finalized: Boolean(o.finalized)
        };
    }).filter((x)=>x != null);
}
// XP week is anchored to Monday 00:00 IST (fixed; the leaderboard finalizes weekly on Mondays).
const XP_WEEK_TZ = "Asia/Kolkata";
const XP_WEEK_ANCHOR_DOW = 1;
const XP_WEEK_ANCHOR_HOUR = 0;
const XP_WEEK_ANCHOR_MINUTE = 0;
const WEEK_MS = 604800000;
function zonedWallClockToUtc(y, monthIndex, d, hour, minute, second, timeZone) {
    const dtf = new Intl.DateTimeFormat("en-US", {
        timeZone,
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });
    let ms = Date.UTC(y, monthIndex, d, hour, minute, second);
    for(let i = 0; i < 4; i++){
        const formatted = Object.fromEntries(dtf.formatToParts(new Date(ms)).filter((p)=>p.type !== "literal").map((p)=>[
                p.type,
                parseInt(p.value, 10)
            ]));
        const formattedMs = Date.UTC(formatted.year, formatted.month - 1, formatted.day, formatted.hour, formatted.minute, formatted.second);
        const targetMs = Date.UTC(y, monthIndex, d, hour, minute, second);
        const delta = targetMs - formattedMs;
        ms += delta;
        if (delta === 0) break;
    }
    return new Date(ms);
}
function getZonedDateTimeParts(now, timeZone) {
    const dtf = new Intl.DateTimeFormat("en-US", {
        timeZone,
        hourCycle: "h23",
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });
    const parts = Object.fromEntries(dtf.formatToParts(now).filter((p)=>p.type !== "literal").map((p)=>[
            p.type,
            p.value
        ]));
    const dayMap = {
        Sun: 0,
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6
    };
    return {
        y: parseInt(parts.year, 10),
        m: parseInt(parts.month, 10) - 1,
        d: parseInt(parts.day, 10),
        dow: dayMap[parts.weekday] ?? 0
    };
}
function getXpWeekStart(now = new Date()) {
    const parts = getZonedDateTimeParts(now, XP_WEEK_TZ);
    const daysFromAnchor = (parts.dow - XP_WEEK_ANCHOR_DOW + 7) % 7;
    const anchorCalendar = new Date(Date.UTC(parts.y, parts.m, parts.d));
    anchorCalendar.setUTCDate(anchorCalendar.getUTCDate() - daysFromAnchor);
    let weekStart = zonedWallClockToUtc(anchorCalendar.getUTCFullYear(), anchorCalendar.getUTCMonth(), anchorCalendar.getUTCDate(), XP_WEEK_ANCHOR_HOUR, XP_WEEK_ANCHOR_MINUTE, 0, XP_WEEK_TZ);
    if (weekStart.getTime() > now.getTime()) weekStart = new Date(weekStart.getTime() - WEEK_MS);
    return weekStart;
}
const TRADER_SPORT_DISPLAY = {
    cricket: "Cricket",
    horses: "Horses",
    football: "Football",
    tennis: "Tennis"
};
function parseTraderDailyLeaderboardSportFromReason(reason) {
    const parts = String(reason ?? "").trim().split(":");
    if (parts[0]?.toLowerCase() !== "trader_daily_coins_first" || parts.length < 2) return null;
    const sport = parts[1]?.trim();
    return sport || null;
}
function parseTraderDailyLeaderboardDayFromReason(reason) {
    const parts = String(reason ?? "").trim().split(":");
    if (parts[0]?.toLowerCase() !== "trader_daily_coins_first" || parts.length < 3) return null;
    const day = parts[2]?.trim();
    return day && /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : null;
}
function formatTraderSportDisplayName(sport) {
    const key = String(sport ?? "").trim().toLowerCase();
    if (!key) return null;
    return TRADER_SPORT_DISPLAY[key] ?? `${key.charAt(0).toUpperCase()}${key.slice(1)}`;
}
function formatTraderDailyLeaderboardDayLabel(dayKey) {
    if (!dayKey) return null;
    const d = new Date(`${dayKey}T12:00:00+05:30`);
    if (Number.isNaN(d.getTime())) return dayKey;
    return d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        timeZone: "Asia/Kolkata"
    });
}
function formatTraderDailyLeaderboardXpDetail(reason) {
    const sport = formatTraderSportDisplayName(parseTraderDailyLeaderboardSportFromReason(reason));
    const day = formatTraderDailyLeaderboardDayLabel(parseTraderDailyLeaderboardDayFromReason(reason));
    if (sport && day) return `(Daily ${sport} Trader leaderboard win, ${day})`;
    if (sport) return `(Daily ${sport} Trader leaderboard win)`;
    return "(Daily trader leaderboard win)";
}
function formatTraderDailyLeaderboardXpNotificationDetail(reason) {
    const sport = formatTraderSportDisplayName(parseTraderDailyLeaderboardSportFromReason(reason));
    const day = formatTraderDailyLeaderboardDayLabel(parseTraderDailyLeaderboardDayFromReason(reason));
    if (sport && day) return `topping the ${day} ${sport} Trader daily leaderboard`;
    if (sport) return `topping the daily ${sport} Trader leaderboard`;
    return "topping the daily Trader leaderboard";
}
function parseSixesDailyLeaderboardDayFromReason(reason) {
    const parts = String(reason ?? "").trim().split(":");
    if (parts[0]?.toLowerCase() !== "sixes_daily_coins_first" || parts.length < 2) return null;
    const day = parts[1]?.trim();
    return day && /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : null;
}
function formatSixesDailyLeaderboardXpDetail(reason) {
    const day = formatTraderDailyLeaderboardDayLabel(parseSixesDailyLeaderboardDayFromReason(reason));
    if (day) return `(Daily Sixes leaderboard win, ${day})`;
    return "(Daily Sixes leaderboard win)";
}
function formatSixesDailyLeaderboardXpNotificationDetail(reason) {
    const day = formatTraderDailyLeaderboardDayLabel(parseSixesDailyLeaderboardDayFromReason(reason));
    if (day) return `topping the ${day} Sixes daily leaderboard`;
    return "topping the daily Sixes leaderboard";
}
function formatXpHistoryRelative(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const sec = Math.max(0, Math.floor((Date.now() - d.getTime()) / 1000));
    if (sec < 60) return "Just now";
    if (sec < 3600) return `${Math.floor(sec / 60)}m`;
    if (sec < 86400) return `${Math.floor(sec / 3600)}h`;
    if (sec < 604800) return `${Math.floor(sec / 86400)}d`;
    return `${Math.floor(sec / 604800)}w`;
}
const LEAGUE_XP_GAME_LABELS = {
    trader: "Trader",
    squares: "Squares+",
    sixes: "Sixes",
    bullion: "Bullion+"
};
function formatLeaguePlaceSuffix(place) {
    const mod100 = place % 100;
    let suffix = "th";
    if (mod100 < 11 || mod100 > 13) {
        const mod10 = place % 10;
        if (mod10 === 1) suffix = "st";
        else if (mod10 === 2) suffix = "nd";
        else if (mod10 === 3) suffix = "rd";
    }
    return `${place}${suffix}`;
}
function formatLeagueXpHistoryDetail(reason) {
    const raw = String(reason ?? "").trim();
    const parts = raw.toLowerCase().split(":");
    const base = parts[0] ?? "";
    if (base === "league_participation") return "(Finished a League)";
    if (base === "league_game_played") {
        const n = Number.parseInt(String(parts[1] ?? ""), 10);
        if (Number.isFinite(n) && n > 0) return n === 1 ? "(Played 1 League game)" : `(Played ${n} League games)`;
        return "(Played League games)";
    }
    if (base === "league_points") {
        const points = Number.parseInt(String(parts[1] ?? ""), 10);
        if (Number.isFinite(points) && points >= 0) return `(${points.toLocaleString("en-US")} pts from League play)`;
        return "(League play)";
    }
    if (base === "league_game_win") {
        const game = String(parts[1] ?? "");
        const label = LEAGUE_XP_GAME_LABELS[game] ?? (game ? game : null);
        return label ? `(${label} game win)` : "(League game win)";
    }
    if (base === "league_placement") {
        const place = Number.parseInt(String(parts[1] ?? ""), 10);
        if (place === 1) return "(Won a League)";
        if (place === 2) return "(2nd place in a League)";
        if (place === 3) return "(3rd place in a League)";
        if (Number.isFinite(place) && place > 0) return `(${formatLeaguePlaceSuffix(place)} place in a League)`;
        return "(League podium finish)";
    }
    return null;
}
function formatXpHistoryReasonDetail(reason) {
    const raw = String(reason ?? "activity").trim();
    const key = raw.toLowerCase();
    const base = key.split(":")[0] ?? key;
    if (base === "trader_daily_coins_first") return formatTraderDailyLeaderboardXpDetail(raw);
    if (base === "sixes_daily_coins_first") return formatSixesDailyLeaderboardXpDetail(raw);
    const leagueDetail = formatLeagueXpHistoryDetail(raw);
    if (leagueDetail) return leagueDetail;
    const labels = {
        signup: "(New account)",
        login_daily: "(Daily login)",
        login_streak_4: "(4-day login streak)",
        login_streak_8: "(8-day login streak)",
        wheel_spin_daily: "(Daily Free Coins)",
        wheel_multiplier_home: "(Wheel Trivia multiplier)",
        wheel_multiplier_away: "(Wheel Trivia multiplier)",
        trader_win: "(Trader win)",
        trader_all_in_first: "(First all-in)",
        trader_win_streak_4: "(4-trade win streak)",
        trader_win_streak_8: "(8-trade win streak)",
        trader_match_wins_3: "(3 wins in a match)",
        trader_match_wins_5: "(5 wins in a match)",
        squares_play_over: "(Play a Squares over)",
        squares_win_over: "(Win a Squares over)",
        squares_five_balls: "(5 balls correct in Squares)",
        squares_perfect_over: "(Perfect Squares over)",
        sixes_play_card: "(Played a Sixes game)",
        sixes_coins_won: "(Sixes coins won)",
        bullion_play_private: "(Private Bullion game played)",
        bullion_play_public: "(Public Bullion game played)",
        bullion_win_private_first: "(Private Bullion win)",
        bullion_win_public_first: "(Public Bullion win)",
        bullion_place_private: "(Private Bullion place prize)",
        bullion_place_public: "(Public Bullion place prize)",
        bullion_predictions_80pct: "(80%+ Bullion predictions)",
        shop_rubies_3: "(3-pack Rubies purchase)",
        shop_rubies_10: "(10-pack Rubies purchase)",
        shop_rubies_25: "(25-pack Rubies purchase)",
        shop_feature_pack: "(Profile Unlock Pack)",
        shop_first_ruby_pack: "(First Ruby pack purchase)",
        social_first_friend: "(First friend added)",
        social_invite_new_user: "(Invited a new user)",
        social_friend_existing: "(New friend)",
        social_favourite_team: "(Favourite team on profile)",
        social_favourite_player: "(Favourite player on profile)",
        social_favourite_sport: "(Favourite sport on profile)",
        social_country: "(Country on profile)",
        social_player_name: "(Player name saved)",
        social_avatar: "(Avatar chosen)",
        wheel_multiplier_streak_4: "(Multiplier streak)",
        wheel_multiplier_streak_8: "(Multiplier streak)",
        quickfire_correct: "(Correct answer)",
        quickfire_daily_perfect: "(Perfect Quickfire day)",
        quickfire: "(Quickfire)",
        squares: "(Squares)",
        bullion: "(Bullion)",
        trader: "(Trader)",
        activity: "(Activity)"
    };
    const label = labels[base] ?? labels[key] ?? `(${base.replace(/_/g, " ")})`;
    return label.startsWith("(") ? label : `(${label})`;
}
function parseXpSummary(raw) {
    if (!raw || typeof raw !== "object") return null;
    const root = raw;
    const o = root.xp && typeof root.xp === "object" && !Array.isArray(root.xp) ? root.xp : root;
    const fin = o.weekly_finishes && typeof o.weekly_finishes === "object" ? o.weekly_finishes : root.weekly_finishes && typeof root.weekly_finishes === "object" ? root.weekly_finishes : {};
    const weekRankRaw = o.week_rank ?? o.weekRank;
    const loginStreakRaw = o.login_streak ?? o.loginStreak ?? root.login_streak;
    return {
        total_xp: Number(o.total_xp ?? o.totalXp) || 0,
        week_xp: Number(o.week_xp ?? o.weekXp) || 0,
        week_rank: weekRankRaw != null && weekRankRaw !== "" ? Number(weekRankRaw) || null : null,
        login_streak: loginStreakRaw != null && loginStreakRaw !== "" ? Number(loginStreakRaw) || 0 : undefined,
        weekly_finishes: {
            first: Number(fin.first ?? fin.first_place) || 0,
            second: Number(fin.second ?? fin.second_place) || 0,
            third: Number(fin.third ?? fin.third_place) || 0
        }
    };
}
function mergeXpSummaryPreferHigher(prev, next) {
    if (!next) return prev;
    if (!prev) return next;
    const week_xp = Math.max(prev.week_xp, next.week_xp);
    const week_rank = next.week_rank != null && next.week_rank > 0 ? next.week_rank : week_xp > 0 && prev.week_rank != null && prev.week_rank > 0 ? prev.week_rank : next.week_rank ?? prev.week_rank;
    return {
        total_xp: Math.max(prev.total_xp, next.total_xp),
        week_xp,
        week_rank,
        login_streak: next.login_streak ?? prev.login_streak,
        weekly_finishes: next.weekly_finishes
    };
}
async function fetchMyZoneXpSummary(apiUrl, headers, walletXp) {
    const base = apiUrl.replace(/\/$/, "");
    let summary = null;
    try {
        const res = await fetch(`${base}/account/xp-summary`, {
            method: "GET",
            headers
        });
        if (res.ok) summary = parseXpSummary(await res.json());
    } catch  {
    // keep summary null
    }
    const needsLeaderboard = !summary || summary.week_xp <= 0 || summary.week_rank == null || summary.week_rank <= 0;
    if (!needsLeaderboard) return summary;
    try {
        const lbRes = await fetch(`${base}/xp/leaderboard?period=week&scope=all`, {
            headers
        });
        if (!lbRes.ok) return summary;
        const lb = await lbRes.json();
        const rows = Array.isArray(lb.leaderboard) ? lb.leaderboard : [];
        const me = rows.find((r)=>r.isCurrentUser);
        const meXp = me != null ? Number(me.xp) || 0 : 0;
        const meRank = me != null ? Number(me.rank) || 0 : 0;
        const userRank = typeof lb.userRank === "number" && lb.userRank > 0 ? lb.userRank : null;
        const week_xp = Math.max(summary?.week_xp ?? 0, meXp);
        const week_rank = meRank > 0 ? meRank : userRank ?? summary?.week_rank ?? null;
        if (week_xp <= 0 && (week_rank == null || week_rank <= 0)) return summary;
        return {
            total_xp: summary?.total_xp ?? (walletXp != null ? Number(walletXp) || 0 : 0),
            week_xp,
            week_rank,
            login_streak: summary?.login_streak,
            weekly_finishes: summary?.weekly_finishes ?? {
                first: 0,
                second: 0,
                third: 0
            }
        };
    } catch  {
        return summary;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"62Wf7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Logo", ()=>(0, _logo.Logo));
parcelHelpers.export(exports, "CRICKET8_LOGO_SRC", ()=>(0, _logo.CRICKET8_LOGO_SRC));
var _logo = require("./Logo");

},{"./Logo":"2jdXu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2jdXu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CRICKET8_LOGO_SRC", ()=>CRICKET8_LOGO_SRC);
parcelHelpers.export(exports, "Logo", ()=>Logo);
var _jsxRuntime = require("react/jsx-runtime");
const CRICKET8_LOGO_SRC = "https://dyatkw7msrzcb.cloudfront.net/assets/image-1.png";
const Logo = ({ className = "" })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `w-[300px] h-[300px] bg-cover bg-[50%_50%] ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: CRICKET8_LOGO_SRC,
            alt: "Cricket8"
        })
    });
};

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwaMN":[function(require,module,exports,__globalThis) {
/**
 * Shared routing of notification types across surfaces.
 * - Notification Centre: admin/user alerts and actionable inbox items.
 * - Activity Drawer: timeline-style friend/user activity feed.
 *
 * Bell unread (`GET /account/notifications/unread-count`) and the default notifications
 * list (`GET /account/notifications?surface=centre`) allowlist the same Centre types
 * (plus challenge/invite-like). Keep `NOTIFICATION_CENTER_TYPES` in sync with
 * `NOTIFICATION_CENTRE_TYPES` in `backend/db/notifications/notifications.js`.
 * Friends Activity uses `?surface=activity`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldShowInNotificationCenter", ()=>shouldShowInNotificationCenter);
parcelHelpers.export(exports, "isFriendChallengeNotificationType", ()=>isFriendChallengeNotificationType);
/** Incoming invites only (not “You challenged…” sent copies). */ parcelHelpers.export(exports, "isIncomingFriendChallengeNotificationType", ()=>isIncomingFriendChallengeNotificationType);
/** True when the user entered the match/contest (soft-ack) — Centre history, no CTA. */ parcelHelpers.export(exports, "isFriendChallengeHistory", ()=>isFriendChallengeHistory);
/** Match/contest still open per API enrichment (ignores history flag). */ parcelHelpers.export(exports, "isFriendChallengeMatchOpen", ()=>isFriendChallengeMatchOpen);
/**
 * Still offer PLAY / chips / Activity — open match and not yet entered (history).
 */ parcelHelpers.export(exports, "isFriendChallengePlayable", ()=>isFriendChallengePlayable);
/**
 * Challenge rows leave Activity after enter-match history or when the match is closed.
 * Sent copies also leave Activity once read. Finished / history rows remain in Notification Centre
 * (see shouldHideFriendChallengeFromNotificationCenter).
 */ parcelHelpers.export(exports, "isAcknowledgedFriendChallenge", ()=>isAcknowledgedFriendChallenge);
/**
 * Notification Centre keeps:
 * - enter-match history rows (until Clear All)
 * - still-playable challenges even after read (sent copies clear badge on open; row stays)
 * Finished + read rows hide.
 */ parcelHelpers.export(exports, "shouldHideFriendChallengeFromNotificationCenter", ()=>shouldHideFriendChallengeFromNotificationCenter);
parcelHelpers.export(exports, "shouldShowInActivityDrawer", ()=>shouldShowInActivityDrawer);
const NOTIFICATION_CENTER_TYPES = new Set([
    "welcome_bonus",
    "xp_week_podium",
    "friend_request",
    "friend_request_accepted",
    "now_friends",
    "squares_match_challenge",
    "squares_match_challenge_accepted",
    "bullion_match_challenge",
    "bullion_match_challenge_sent",
    "league_invite",
    "league_invite_sent",
    "league_member_joined",
    "league_member_joined_live",
    "league_starting",
    "league_cancelled",
    "league_finished",
    "bullion_battle_entered",
    "sixes_match_challenge",
    "sixes_match_challenge_sent",
    "trader_match_challenge",
    "trader_match_challenge_sent",
    "unlock_username_emoji",
    "coins_running_low",
    "promo",
    "admin_message",
    "wallet_grant",
    "sixes_card_ready",
    "sixes_cards_online"
]);
const ACTIVITY_DRAWER_TYPES = new Set([
    "xp_earned",
    "xp_week_podium",
    "friend_earned_xp",
    "friend_request_accepted",
    "now_friends",
    "squares_match_challenge",
    "squares_match_challenge_sent",
    "bullion_match_challenge",
    "bullion_match_challenge_sent",
    "league_invite",
    "league_invite_sent",
    "sixes_match_challenge",
    "sixes_match_challenge_sent",
    "trader_match_challenge",
    "trader_match_challenge_sent",
    "friend_started_playing_game",
    "friend_just_played_game",
    "friend_streak",
    "friend_pb"
]);
/** Friend duel invites — hide from Activity once history / finished. */ const FRIEND_CHALLENGE_NOTIFICATION_TYPES = new Set([
    "squares_match_challenge",
    "squares_match_challenge_sent",
    "bullion_match_challenge",
    "bullion_match_challenge_sent",
    "sixes_match_challenge",
    "sixes_match_challenge_sent",
    "trader_match_challenge",
    "trader_match_challenge_sent"
]);
function isTruthyString(value) {
    return typeof value === "string" && value.trim() !== "";
}
/**
 * Keep legacy/flexible support for challenge/invite-like event names.
 */ function isChallengeLike(type) {
    if (!isTruthyString(type)) return false;
    const t = String(type).toLowerCase();
    return t.includes("challenge") || t.endsWith("_invite") || t.includes("game_invite");
}
function shouldShowInNotificationCenter(notification) {
    const type = notification?.type;
    if (!isTruthyString(type)) return false;
    // Non-actionable / history challenges still list here (see notificationDisplay).
    // Activity / chips / My Games strips may hide them separately.
    if (NOTIFICATION_CENTER_TYPES.has(type)) return true;
    // Challenges/invites should always be visible in the Notifications Centre.
    return isChallengeLike(type);
}
function isFriendChallengeNotificationType(type) {
    return typeof type === "string" && FRIEND_CHALLENGE_NOTIFICATION_TYPES.has(type);
}
function isIncomingFriendChallengeNotificationType(type) {
    return type === "squares_match_challenge" || type === "bullion_match_challenge" || type === "sixes_match_challenge" || type === "trader_match_challenge";
}
function isFriendChallengeHistory(notification) {
    if (!isFriendChallengeNotificationType(notification?.type)) return false;
    if (notification?.challenge_history === true) return true;
    if (notification?.entity_ref == null || typeof notification.entity_ref !== "string") return false;
    try {
        const o = JSON.parse(notification.entity_ref);
        return o?.challenge_history === true;
    } catch  {
        return false;
    }
}
function isFriendChallengeMatchOpen(notification) {
    return notification?.challenge_match_actionable !== false;
}
function isFriendChallengePlayable(notification) {
    if (!isFriendChallengeNotificationType(notification?.type)) return false;
    if (isFriendChallengeHistory(notification)) return false;
    return isFriendChallengeMatchOpen(notification);
}
function isAcknowledgedFriendChallenge(notification) {
    if (!isFriendChallengeNotificationType(notification?.type)) return false;
    if (isFriendChallengeHistory(notification)) return true;
    if (!notification?.read_at) return false;
    const incoming = isIncomingFriendChallengeNotificationType(notification.type);
    if (incoming) // Still playable → keep listed (badge may be cleared via read_at; friends chips use read_at).
    return !isFriendChallengeMatchOpen(notification);
    return true;
}
function shouldHideFriendChallengeFromNotificationCenter(notification) {
    if (!isFriendChallengeNotificationType(notification?.type)) return false;
    if (isFriendChallengeHistory(notification)) return false;
    if (isFriendChallengePlayable(notification)) return false;
    // Finished / closed: keep while unread (finished copy); hide once read.
    return Boolean(notification?.read_at);
}
function shouldShowInActivityDrawer(notification) {
    const type = notification?.type;
    if (!isTruthyString(type)) return false;
    // Keep Activity focused on actionable invites; history / finished stay in Notification Centre.
    if (isFriendChallengeNotificationType(type)) {
        if (!isFriendChallengePlayable(notification)) return false;
    }
    if (ACTIVITY_DRAWER_TYPES.has(type)) return true;
    // Keep the activity stream focused; treat only explicit activity types here.
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ip48z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Single notification row — same layout as NotificationsDrawer list items / toast / activity notifications.
 * @param {boolean} [includeUnreadRing=true] — set false for toast alerts (no inset white ring).
 * @param {string} [rowShellClassName] — optional override for row container classes.
 * @param {boolean} [hideTime=false] — omit relative time in the side rail / subline.
 */ parcelHelpers.export(exports, "NotificationItemRow", ()=>NotificationItemRow);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _challengeEntryTracking = require("../../utils/challengeEntryTracking");
var _profileLink = require("../Profile/ProfileLink");
var _avatarWithXpCrown = require("../Xp/AvatarWithXpCrown");
var _userAvatar = require("../Profile/UserAvatar");
var _avatarFrame = require("../Profile/avatarFrame");
var _profileGlobalModalContext = require("../Profile/ProfileGlobalModalContext");
var _profileModalNavigation = require("../../utils/profileModalNavigation");
var _notificationDisplay = require("./notificationDisplay");
const NOTIFICATION_SENDER_ONLINE_DOT_CLASS = `pointer-events-none absolute -right-0.5 -top-0.5 ${(0, _avatarWithXpCrown.AVATAR_PRESENCE_INDICATOR_Z_CLASS)} h-2 w-2 rounded-full border border-[#1B062F] bg-[#d4ff1f] shadow-[0_0_0_1px_rgba(27,6,47,0.35),0_2px_4px_rgba(0,0,0,0.45)]`;
function NotificationRowAvatar({ boxClass, src, imgClass, notification, xpWeekCrown, isSenderAvatar, frameSize }) {
    const showOnline = (0, _notificationDisplay.notificationSenderAppearsOnline)(notification?.sender);
    const sender = notification?.sender;
    const displayName = sender?.player_name || sender?.playerName || sender?.username || notification?.sender_name || null;
    const frameSrc = isSenderAvatar ? (0, _avatarFrame.resolveAvatarFrameSrc)(frameSize, sender?.avatar_frame_url, sender?.avatar_frame_small_url) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: boxClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarWithXpCrown.AvatarWithXpCrown), {
                crown: xpWeekCrown,
                frameSrc: frameSrc,
                className: "block h-full w-full overflow-hidden",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAvatar.UserAvatar), {
                    src: src,
                    displayName: displayName,
                    size: "fill",
                    imgClassName: imgClass,
                    withCrown: false
                })
            }),
            showOnline ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: NOTIFICATION_SENDER_ONLINE_DOT_CLASS,
                "aria-hidden": true
            }) : null
        ]
    });
}
const RUBY_ICON_SRC = "/assets/currency-ruby.png";
const COIN_ICON_SRC = "/assets/currency-coin.png";
const XP_ICON_SRC = "/assets/xp.webp";
const INLINE_CURRENCY_ICON_CLASS = "mx-px inline-block h-[1.05em] w-[1.05em] max-h-[15px] max-w-[15px] shrink-0 object-contain align-[-0.2em] sm:max-h-[16px] sm:max-w-[16px]";
function NotificationRemoveButton({ onRemove }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onRemove();
        },
        className: "mt-0.5 flex h-[30px] w-[30px] shrink-0 items-center justify-center self-start rounded-none border-0 bg-transparent text-white/60 transition-colors hover:bg-white/10 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40",
        "aria-label": "Remove notification",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: "h-4 w-4",
            "aria-hidden": true,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M3 6h18"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                    x1: "10",
                    y1: "11",
                    x2: "10",
                    y2: "17"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                    x1: "14",
                    y1: "11",
                    x2: "14",
                    y2: "17"
                })
            ]
        })
    });
}
/** Body: Chakra Petch 400, 12–13px; friend username: Anton 400, 10–11px uppercase. Optional single-line clamp. */ function NotificationTitleLine({ parts, lineClamp = true, lineClass: lineClassOverride, emphasizeUsernameClass: emphasizeUsernameClassOverride }) {
    const lineClass = lineClassOverride ?? [
        "!block w-full min-w-0 font-chakra text-[12px] font-normal leading-[18px] tracking-normal text-white sm:text-[13px] sm:leading-[20px]",
        lineClamp ? "line-clamp-1 min-w-0" : "whitespace-normal break-words"
    ].join(" ");
    const emphasizeUsernameClass = emphasizeUsernameClassOverride ?? "font-anton text-[10px] font-normal leading-[18px] tracking-normal uppercase sm:text-[11px] sm:leading-[20px]";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: lineClass,
        children: parts.map((part, i)=>{
            if (part.coinIcon) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: COIN_ICON_SRC,
                alt: "",
                className: INLINE_CURRENCY_ICON_CLASS,
                "aria-hidden": true
            }, i);
            if (part.rubyIcon) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: RUBY_ICON_SRC,
                alt: "",
                className: INLINE_CURRENCY_ICON_CLASS,
                "aria-hidden": true
            }, i);
            if (part.xpIcon) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: XP_ICON_SRC,
                alt: "",
                className: INLINE_CURRENCY_ICON_CLASS,
                "aria-hidden": true
            }, i);
            const t = part.text ?? "";
            if (part.emphasizeUsername) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: emphasizeUsernameClass,
                children: t
            }, i);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: t
            }, i);
        })
    });
}
function NotificationItemRow({ notification, isUnread = true, onActivate, onRemove, includeUnreadRing = true, rowShellClassName, hideTime = false, isAlertRow = false, /** My Zone desktop activity panel typography and row sizing. */ variant = "default" }) {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const { openProfileFromHref } = (0, _profileGlobalModalContext.useProfileGlobalModal)();
    const { titleParts, avatarUrl, cta, navigateTo, avatarObjectFit } = (0, _notificationDisplay.getNotificationDisplay)(notification);
    const profileRowState = (0, _profileModalNavigation.isProfileHref)(navigateTo) ? (0, _profileModalNavigation.profileModalBackgroundState)(location) : undefined;
    const profileCtaState = cta?.to && (0, _profileModalNavigation.isProfileHref)(cta.to) ? (0, _profileModalNavigation.profileModalBackgroundState)(location) : undefined;
    const avatarSrc = avatarUrl || "";
    const avatarImgClass = avatarObjectFit === "contain" ? "h-full w-full object-contain p-0" : "h-full w-full object-cover";
    const isPanelVariant = variant === "panel";
    const rowShell = rowShellClassName ?? (isPanelVariant ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_ROW_GRID_CLASS) : (0, _notificationDisplay.getNotificationRowShellClass)(isUnread, includeUnreadRing, isAlertRow));
    const rowGridShell = rowShellClassName ?? (isPanelVariant ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_ROW_GRID_CLASS) : (0, _notificationDisplay.getNotificationRowGridShellClass)(isUnread, includeUnreadRing, isAlertRow));
    /** Titles wrap; row height follows content (shell uses min-h only). */ const rowShellD = rowShell;
    const titleLineClamp = false;
    const useGridNotificationLayout = !rowShellClassName || isPanelVariant;
    const avatarBoxClass = isPanelVariant ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_AVATAR_CLASS) : (0, _notificationDisplay.NOTIFICATION_AVATAR_CLASS);
    /** Logo / game-icon avatars use `contain`; only real sender photos get the sender's frame. */ const isSenderAvatar = avatarObjectFit !== "contain";
    const avatarFrameSize = isPanelVariant ? "md" : "sm";
    const gapClass = isPanelVariant ? "gap-2" : "gap-1 sm:gap-1.5";
    const sideMetaClass = isPanelVariant ? "gap-1" : "gap-0.5 sm:gap-1";
    const timeClass = isPanelVariant ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_TIME_CLASS) : "whitespace-nowrap text-[11px] leading-none text-[#c4b8d4] sm:text-[12px]";
    const ctaClass = isPanelVariant ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_CTA_CLASS) : (0, _notificationDisplay.NOTIFICATION_CTA_PILL_CLASS);
    const titleLineClass = isPanelVariant ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_TITLE_LINE_CLASS) : undefined;
    const titleUsernameClass = isPanelVariant ? (0, _notificationDisplay.MY_ZONE_ACTIVITY_PANEL_TITLE_USERNAME_CLASS) : undefined;
    /** Natural width + truncate so short times (e.g. 23h) don’t leave a wide empty strip before the CTA. */ const timeRailSlotClass = isPanelVariant ? "inline-block max-w-[4rem] shrink-0 truncate text-right tabular-nums sm:max-w-[4.5rem]" : "inline-block max-w-[4rem] shrink-0 truncate pr-0.5 text-right tabular-nums sm:max-w-[4.5rem] sm:pr-1";
    const fireActivate = ()=>{
        if (cta && !cta.openShopDrawer && !cta.openWalletHistory) (0, _challengeEntryTracking.persistChallengeGameEntryFromNotification)(notification);
        onActivate?.();
    };
    const handleDrawerCtaClick = ()=>{
        fireActivate();
        if (cta?.openShopDrawer) {
            try {
                sessionStorage.setItem("c8_animate_wallet_on_open", "1");
            } catch (_) {
            /* ignore */ }
            window.dispatchEvent(new CustomEvent("openShopDrawer"));
            return;
        }
        if (cta?.openWalletHistory) window.dispatchEvent(new CustomEvent("openWalletHistoryDrawer"));
    };
    const ctaControl = cta?.openShopDrawer || cta?.openWalletHistory ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: handleDrawerCtaClick,
        className: ctaClass,
        children: cta.label
    }) : cta ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileLink.ProfileLink), {
        to: cta.to,
        state: profileCtaState,
        onClick: fireActivate,
        className: ctaClass,
        children: cta.label
    }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "w-full",
        children: cta ? useGridNotificationLayout ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: rowGridShell,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _profileLink.ProfileLink), {
                    to: navigateTo,
                    state: profileRowState,
                    onClick: fireActivate,
                    className: `col-span-2 grid [grid-template-columns:subgrid] min-h-0 min-w-0 items-center text-left ${gapClass}`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationRowAvatar, {
                            boxClass: avatarBoxClass,
                            src: avatarSrc,
                            imgClass: avatarImgClass,
                            notification: notification,
                            xpWeekCrown: notification?.sender?.xp_week_crown,
                            isSenderAvatar: isSenderAvatar,
                            frameSize: avatarFrameSize
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `min-w-0 self-center overflow-x-hidden ${(0, _notificationDisplay.NOTIFICATION_MAIN_TEXT_PAD)}`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationTitleLine, {
                                parts: titleParts,
                                lineClamp: titleLineClamp,
                                lineClass: titleLineClass,
                                emphasizeUsernameClass: titleUsernameClass
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex shrink-0 items-center gap-1 self-center sm:gap-1.5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `flex shrink-0 items-center ${sideMetaClass}`,
                            children: [
                                !hideTime ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: `${timeClass} ${timeRailSlotClass}`,
                                    children: (0, _notificationDisplay.formatTimeAgo)(notification.created_at) || "\u00a0"
                                }) : null,
                                ctaControl
                            ]
                        }),
                        typeof onRemove === "function" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationRemoveButton, {
                            onRemove: onRemove
                        }) : null
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: rowShell,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _profileLink.ProfileLink), {
                    to: navigateTo,
                    state: profileRowState,
                    onClick: fireActivate,
                    className: `flex min-h-0 min-w-0 flex-1 items-center text-left ${gapClass}`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationRowAvatar, {
                            boxClass: avatarBoxClass,
                            src: avatarSrc,
                            imgClass: avatarImgClass,
                            notification: notification,
                            xpWeekCrown: notification?.sender?.xp_week_crown,
                            isSenderAvatar: isSenderAvatar,
                            frameSize: avatarFrameSize
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `flex w-0 min-w-0 max-w-full flex-1 flex-col justify-start overflow-x-hidden ${(0, _notificationDisplay.NOTIFICATION_MAIN_TEXT_PAD)}`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationTitleLine, {
                                parts: titleParts,
                                lineClamp: titleLineClamp,
                                lineClass: titleLineClass,
                                emphasizeUsernameClass: titleUsernameClass
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: `flex shrink-0 items-center self-center ${sideMetaClass}`,
                    children: [
                        !hideTime ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: `${timeClass} ${timeRailSlotClass}`,
                            children: (0, _notificationDisplay.formatTimeAgo)(notification.created_at) || "\u00a0"
                        }) : null,
                        ctaControl
                    ]
                }),
                typeof onRemove === "function" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationRemoveButton, {
                    onRemove: onRemove
                }) : null
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `${rowShellD} flex w-full min-w-0 items-center`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _profileLink.ProfileLink), {
                    to: navigateTo,
                    state: profileRowState,
                    onClick: fireActivate,
                    className: `flex min-w-0 flex-1 items-center ${gapClass}`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationRowAvatar, {
                            boxClass: avatarBoxClass,
                            src: avatarSrc,
                            imgClass: avatarImgClass,
                            notification: notification,
                            xpWeekCrown: notification?.sender?.xp_week_crown,
                            isSenderAvatar: isSenderAvatar,
                            frameSize: avatarFrameSize
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `flex w-0 min-w-0 max-w-full flex-1 flex-col justify-start overflow-x-hidden ${(0, _notificationDisplay.NOTIFICATION_MAIN_TEXT_PAD)}`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationTitleLine, {
                                parts: titleParts,
                                lineClamp: titleLineClamp,
                                lineClass: titleLineClass,
                                emphasizeUsernameClass: titleUsernameClass
                            })
                        })
                    ]
                }),
                !hideTime ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `ml-2 flex shrink-0 items-center self-center ${sideMetaClass}`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: `${timeClass} ${timeRailSlotClass}`,
                        children: (0, _notificationDisplay.formatTimeAgo)(notification.created_at) || "\u00a0"
                    })
                }) : null,
                typeof onRemove === "function" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotificationRemoveButton, {
                    onRemove: onRemove
                }) : null
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","../../utils/challengeEntryTracking":"bdWq1","../Profile/ProfileLink":"eCRxx","../Xp/AvatarWithXpCrown":"9U2iQ","../Profile/UserAvatar":"e6kw2","../Profile/avatarFrame":"k4MjP","../Profile/ProfileGlobalModalContext":"eilDL","../../utils/profileModalNavigation":"eBA1i","./notificationDisplay":"5gcn3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bdWq1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Persist `entry_point: challenge` when user enters a game from a challenge notification. */ parcelHelpers.export(exports, "persistChallengeGameEntryFromNotification", ()=>persistChallengeGameEntryFromNotification);
var _notificationDisplay = require("../components/notifications/notificationDisplay");
var _frontendTrackingEvents = require("./frontendTrackingEvents");
const CHALLENGE_NOTIFICATION_TYPES = new Set([
    "squares_match_challenge",
    "squares_match_challenge_sent",
    "bullion_match_challenge",
    "bullion_match_challenge_sent"
]);
function persistChallengeGameEntryFromNotification(notification) {
    const type = notification?.type;
    if (!type || !CHALLENGE_NOTIFICATION_TYPES.has(type)) return;
    if (type.startsWith("squares_")) {
        const { matchId } = (0, _notificationDisplay.parseSquaresChallengeEntityRef)(notification.entity_ref ?? null);
        if (!matchId) return;
        (0, _frontendTrackingEvents.persistGameEntryPoint)({
            entry_point: (0, _frontendTrackingEvents.ENTRY_POINT_CHALLENGE),
            fixture_id: matchId,
            game_type: "squares"
        });
        return;
    }
    if (type.startsWith("bullion_")) {
        const { matchId } = (0, _notificationDisplay.parseBullionChallengeEntityRef)(notification.entity_ref ?? null);
        if (!matchId) return;
        (0, _frontendTrackingEvents.persistGameEntryPoint)({
            entry_point: (0, _frontendTrackingEvents.ENTRY_POINT_CHALLENGE),
            fixture_id: matchId,
            game_type: "bullion"
        });
    }
}

},{"../components/notifications/notificationDisplay":"5gcn3","./frontendTrackingEvents":"4Y90p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cKToa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProfileCountryCombobox", ()=>ProfileCountryCombobox);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _countries = require("../Account/Countries");
function ProfileCountryCombobox({ id, value, onChange }) {
    const [open, setOpen] = (0, _react.useState)(false);
    const [query, setQuery] = (0, _react.useState)("");
    const [highlighted, setHighlighted] = (0, _react.useState)(0);
    const [panelStyle, setPanelStyle] = (0, _react.useState)({});
    const triggerRef = (0, _react.useRef)(null);
    const panelRef = (0, _react.useRef)(null);
    const listboxRef = (0, _react.useRef)(null);
    const searchRef = (0, _react.useRef)(null);
    const rowRefs = (0, _react.useRef)([]);
    const filteredCountries = (0, _react.useMemo)(()=>{
        const q = query.trim().toLowerCase();
        if (!q) return 0, _countries.countriesList;
        return (0, _countries.countriesList).filter((c)=>c.country.toLowerCase().includes(q) || c.code.toLowerCase().includes(q));
    }, [
        query
    ]);
    const rows = (0, _react.useMemo)(()=>{
        return [
            {
                kind: "clear"
            },
            ...filteredCountries.map((c)=>({
                    kind: "country",
                    ...c
                }))
        ];
    }, [
        filteredCountries
    ]);
    const noCountryMatches = query.trim() !== "" && filteredCountries.length === 0;
    const updatePanelPosition = (0, _react.useCallback)(()=>{
        const el = triggerRef.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        setPanelStyle({
            position: "fixed",
            left: rect.left,
            top: rect.bottom + 2,
            width: Math.max(rect.width, 280),
            zIndex: 10050
        });
    }, []);
    (0, _react.useLayoutEffect)(()=>{
        if (!open) return;
        updatePanelPosition();
    }, [
        open,
        updatePanelPosition
    ]);
    (0, _react.useEffect)(()=>{
        if (!open) return;
        const onWin = ()=>updatePanelPosition();
        window.addEventListener("resize", onWin);
        window.addEventListener("scroll", onWin, true);
        return ()=>{
            window.removeEventListener("resize", onWin);
            window.removeEventListener("scroll", onWin, true);
        };
    }, [
        open,
        updatePanelPosition
    ]);
    (0, _react.useEffect)(()=>{
        if (!open) return;
        const onDoc = (e)=>{
            const t = e.target;
            if (triggerRef.current?.contains(t)) return;
            if (panelRef.current?.contains(t)) return;
            setOpen(false);
            setQuery("");
        };
        document.addEventListener("mousedown", onDoc);
        return ()=>document.removeEventListener("mousedown", onDoc);
    }, [
        open
    ]);
    (0, _react.useEffect)(()=>{
        if (open) {
            setQuery("");
            setHighlighted(0);
            requestAnimationFrame(()=>{
                searchRef.current?.focus({
                    preventScroll: true
                });
            });
        }
    }, [
        open
    ]);
    (0, _react.useEffect)(()=>{
        setHighlighted((h)=>Math.min(h, Math.max(0, rows.length - 1)));
    }, [
        rows.length
    ]);
    /** Keep highlighted row visible inside the listbox only — avoid `scrollIntoView`, which scrolls the page. */ (0, _react.useLayoutEffect)(()=>{
        if (!open) return;
        const listbox = listboxRef.current;
        const row = rowRefs.current[highlighted];
        if (!listbox || !row) return;
        const lr = listbox.getBoundingClientRect();
        const rr = row.getBoundingClientRect();
        if (rr.top < lr.top) listbox.scrollTop -= lr.top - rr.top;
        else if (rr.bottom > lr.bottom) listbox.scrollTop += rr.bottom - lr.bottom;
    }, [
        highlighted,
        open
    ]);
    const selectedLabel = value ? (0, _countries.getCountryNameByCode)(value) : "";
    const displayFlag = value ? (0, _countries.countryCodeToFlagEmoji)(value) : "\u2014";
    const selectRow = (0, _react.useCallback)((row)=>{
        if (row.kind === "clear") onChange("");
        else onChange(row.code);
        setOpen(false);
        setQuery("");
        triggerRef.current?.focus();
    }, [
        onChange
    ]);
    const onSearchKeyDown = (e)=>{
        if (e.key === "Escape") {
            e.preventDefault();
            setOpen(false);
            setQuery("");
            triggerRef.current?.focus();
            return;
        }
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlighted((h)=>Math.min(h + 1, rows.length - 1));
            return;
        }
        if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlighted((h)=>Math.max(h - 1, 0));
            return;
        }
        if (e.key === "Enter") {
            e.preventDefault();
            const row = rows[highlighted];
            if (row) selectRow(row);
        }
    };
    const onTriggerKeyDown = (e)=>{
        if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            if (!open) setOpen(true);
        }
    };
    const listboxId = `${id}-listbox`;
    const searchId = `${id}-search`;
    const panel = open ? /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: panelRef,
        className: "flex max-h-[min(320px,calc(100vh-120px))] flex-col overflow-hidden rounded-none border border-white/20 bg-[#4f2189] shadow-lg",
        style: panelStyle,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                ref: searchRef,
                id: searchId,
                type: "text",
                value: query,
                onChange: (e)=>{
                    setQuery(e.target.value);
                    setHighlighted(0);
                },
                onKeyDown: onSearchKeyDown,
                placeholder: "Search country\u2026",
                autoComplete: "off",
                autoCorrect: "off",
                spellCheck: false,
                "aria-label": "Search countries",
                className: "w-full shrink-0 border-b border-white/15 bg-[#381663] px-2 py-2 font-chakra text-[12px] font-normal leading-[16px] tracking-normal text-white placeholder:text-white/40 outline-none [leading-trim:none] focus:border-b focus:border-white/25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: listboxRef,
                id: listboxId,
                role: "listbox",
                "aria-label": "Countries",
                className: "min-h-0 flex-1 overflow-y-auto overscroll-contain",
                children: [
                    noCountryMatches ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "px-2 py-2 text-center font-chakra text-[11px] font-normal leading-snug text-white/55 [leading-trim:none]",
                        children: "No countries match"
                    }) : null,
                    rows.map((row, i)=>{
                        const active = i === highlighted;
                        const isClear = row.kind === "clear";
                        const key = isClear ? "__clear" : `${row.code}-${row.country}`;
                        const flag = isClear ? "\u2014" : (0, _countries.countryCodeToFlagEmoji)(row.code);
                        const name = isClear ? "No country" : row.country;
                        const isSelected = isClear ? value === "" : value === row.code;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            role: "option",
                            "aria-selected": isSelected,
                            ref: (el)=>{
                                rowRefs.current[i] = el;
                            },
                            onMouseEnter: ()=>setHighlighted(i),
                            onClick: ()=>selectRow(row),
                            className: `flex w-full min-w-0 items-center gap-2 px-2 py-2 text-left font-chakra text-[12px] font-normal leading-[16px] tracking-normal [leading-trim:none] ${active ? "bg-white/15 text-white" : "text-white/95 hover:bg-white/10"} ${isSelected ? "ring-1 ring-inset ring-[#D2FF00]/40" : ""}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "shrink-0 text-[18px] leading-none",
                                    "aria-hidden": true,
                                    children: flag
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "min-w-0 flex-1 truncate",
                                    children: name
                                })
                            ]
                        }, key);
                    })
                ]
            })
        ]
    }), document.body) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "relative h-full min-h-0 min-w-0 flex-1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                ref: triggerRef,
                type: "button",
                id: id,
                "aria-haspopup": "listbox",
                "aria-expanded": open,
                "aria-controls": open ? listboxId : undefined,
                "aria-label": selectedLabel ? `Country: ${selectedLabel}` : "Country",
                title: selectedLabel || undefined,
                onClick: ()=>setOpen((o)=>!o),
                onKeyDown: onTriggerKeyDown,
                className: "h-full w-full min-h-0 min-w-0 cursor-pointer border-0 bg-transparent py-0 pr-7 text-left text-[20px] leading-none text-white outline-none focus-visible:ring-1 focus-visible:ring-white/40",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "block pl-0.5",
                    children: displayFlag
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "pointer-events-none absolute right-1.5 top-1/2 -translate-y-1/2 text-sm text-white/70",
                "aria-hidden": true,
                children: "\u25BC"
            }),
            panel
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom":"b8T3j","../Account/Countries":"307aP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"307aP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "countriesList", ()=>countriesList);
parcelHelpers.export(exports, "getCountryNameByCode", ()=>getCountryNameByCode);
/**
 * ISO 3166-1 alpha-2 code → regional flag emoji (e.g. "AU" → 🇦🇺).
 * Uses Unicode regional indicator symbols U+1F1E6–U+1F1FF.
 */ parcelHelpers.export(exports, "countryCodeToFlagEmoji", ()=>countryCodeToFlagEmoji);
parcelHelpers.export(exports, "Countries", ()=>Countries);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const countriesList = [
    {
        code: 'AF',
        country: 'Afghanistan'
    },
    {
        code: 'AL',
        country: 'Albania'
    },
    {
        code: 'DZ',
        country: 'Algeria'
    },
    {
        code: 'AS',
        country: 'American Samoa'
    },
    {
        code: 'AD',
        country: 'Andorra'
    },
    {
        code: 'AO',
        country: 'Angola'
    },
    {
        code: 'AI',
        country: 'Anguilla'
    },
    {
        code: 'AQ',
        country: 'Antarctica'
    },
    {
        code: 'AG',
        country: 'Antigua and Barbuda'
    },
    {
        code: 'AR',
        country: 'Argentina'
    },
    {
        code: 'AM',
        country: 'Armenia'
    },
    {
        code: 'AW',
        country: 'Aruba'
    },
    {
        code: 'AU',
        country: 'Australia'
    },
    {
        code: 'AT',
        country: 'Austria'
    },
    {
        code: 'AZ',
        country: 'Azerbaijan'
    },
    {
        code: 'BS',
        country: 'Bahamas'
    },
    {
        code: 'BH',
        country: 'Bahrain'
    },
    {
        code: 'BD',
        country: 'Bangladesh'
    },
    {
        code: 'BB',
        country: 'Barbados'
    },
    {
        code: 'BY',
        country: 'Belarus'
    },
    {
        code: 'BE',
        country: 'Belgium'
    },
    {
        code: 'BZ',
        country: 'Belize'
    },
    {
        code: 'BJ',
        country: 'Benin'
    },
    {
        code: 'BM',
        country: 'Bermuda'
    },
    {
        code: 'BT',
        country: 'Bhutan'
    },
    {
        code: 'BO',
        country: 'Bolivia'
    },
    {
        code: 'BA',
        country: 'Bosnia and Herzegovina'
    },
    {
        code: 'BW',
        country: 'Botswana'
    },
    {
        code: 'BV',
        country: 'Bouvet Island'
    },
    {
        code: 'BR',
        country: 'Brazil'
    },
    {
        code: 'IO',
        country: 'British Indian Ocean Territory'
    },
    {
        code: 'BN',
        country: 'Brunei Darussalam'
    },
    {
        code: 'BG',
        country: 'Bulgaria'
    },
    {
        code: 'BF',
        country: 'Burkina Faso'
    },
    {
        code: 'BI',
        country: 'Burundi'
    },
    {
        code: 'CV',
        country: 'Cabo Verde'
    },
    {
        code: 'KH',
        country: 'Cambodia'
    },
    {
        code: 'CM',
        country: 'Cameroon'
    },
    {
        code: 'CA',
        country: 'Canada'
    },
    {
        code: 'KY',
        country: 'Cayman Islands'
    },
    {
        code: 'CF',
        country: 'Central African Republic'
    },
    {
        code: 'TD',
        country: 'Chad'
    },
    {
        code: 'CL',
        country: 'Chile'
    },
    {
        code: 'CN',
        country: 'China'
    },
    {
        code: 'CX',
        country: 'Christmas Island'
    },
    {
        code: 'CC',
        country: 'Cocos (Keeling) Islands'
    },
    {
        code: 'CO',
        country: 'Colombia'
    },
    {
        code: 'KM',
        country: 'Comoros'
    },
    {
        code: 'CG',
        country: 'Congo'
    },
    {
        code: 'CD',
        country: 'Congo, Democratic Republic of the'
    },
    {
        code: 'CK',
        country: 'Cook Islands'
    },
    {
        code: 'CR',
        country: 'Costa Rica'
    },
    {
        code: 'HR',
        country: 'Croatia'
    },
    {
        code: 'CU',
        country: 'Cuba'
    },
    {
        code: 'CW',
        country: "Cura\xe7ao"
    },
    {
        code: 'CY',
        country: 'Cyprus'
    },
    {
        code: 'CZ',
        country: 'Czechia'
    },
    {
        code: 'CI',
        country: "C\xf4te d'Ivoire"
    },
    {
        code: 'DK',
        country: 'Denmark'
    },
    {
        code: 'DJ',
        country: 'Djibouti'
    },
    {
        code: 'DM',
        country: 'Dominica'
    },
    {
        code: 'DO',
        country: 'Dominican Republic'
    },
    {
        code: 'EC',
        country: 'Ecuador'
    },
    {
        code: 'EG',
        country: 'Egypt'
    },
    {
        code: 'SV',
        country: 'El Salvador'
    },
    {
        code: 'GQ',
        country: 'Equatorial Guinea'
    },
    {
        code: 'ER',
        country: 'Eritrea'
    },
    {
        code: 'EE',
        country: 'Estonia'
    },
    {
        code: 'SZ',
        country: 'Eswatini'
    },
    {
        code: 'ET',
        country: 'Ethiopia'
    },
    {
        code: 'FK',
        country: 'Falkland Islands (Malvinas)'
    },
    {
        code: 'FO',
        country: 'Faroe Islands'
    },
    {
        code: 'FJ',
        country: 'Fiji'
    },
    {
        code: 'FI',
        country: 'Finland'
    },
    {
        code: 'FR',
        country: 'France'
    },
    {
        code: 'GF',
        country: 'French Guiana'
    },
    {
        code: 'PF',
        country: 'French Polynesia'
    },
    {
        code: 'TF',
        country: 'French Southern Territories'
    },
    {
        code: 'GA',
        country: 'Gabon'
    },
    {
        code: 'GM',
        country: 'Gambia'
    },
    {
        code: 'GE',
        country: 'Georgia'
    },
    {
        code: 'DE',
        country: 'Germany'
    },
    {
        code: 'GH',
        country: 'Ghana'
    },
    {
        code: 'GI',
        country: 'Gibraltar'
    },
    {
        code: 'GR',
        country: 'Greece'
    },
    {
        code: 'GL',
        country: 'Greenland'
    },
    {
        code: 'GD',
        country: 'Grenada'
    },
    {
        code: 'GP',
        country: 'Guadeloupe'
    },
    {
        code: 'GU',
        country: 'Guam'
    },
    {
        code: 'GT',
        country: 'Guatemala'
    },
    {
        code: 'GG',
        country: 'Guernsey'
    },
    {
        code: 'GN',
        country: 'Guinea'
    },
    {
        code: 'GW',
        country: 'Guinea-Bissau'
    },
    {
        code: 'GY',
        country: 'Guyana'
    },
    {
        code: 'HT',
        country: 'Haiti'
    },
    {
        code: 'HM',
        country: 'Heard Island and McDonald Islands'
    },
    {
        code: 'VA',
        country: 'Holy See'
    },
    {
        code: 'HN',
        country: 'Honduras'
    },
    {
        code: 'HK',
        country: 'Hong Kong'
    },
    {
        code: 'HU',
        country: 'Hungary'
    },
    {
        code: 'IS',
        country: 'Iceland'
    },
    {
        code: 'IN',
        country: 'India'
    },
    {
        code: 'ID',
        country: 'Indonesia'
    },
    {
        code: 'IR',
        country: 'Iran (Islamic Republic of)'
    },
    {
        code: 'IQ',
        country: 'Iraq'
    },
    {
        code: 'IE',
        country: 'Ireland'
    },
    {
        code: 'IM',
        country: 'Isle of Man'
    },
    {
        code: 'IL',
        country: 'Israel'
    },
    {
        code: 'IT',
        country: 'Italy'
    },
    {
        code: 'JM',
        country: 'Jamaica'
    },
    {
        code: 'JP',
        country: 'Japan'
    },
    {
        code: 'JE',
        country: 'Jersey'
    },
    {
        code: 'JO',
        country: 'Jordan'
    },
    {
        code: 'KZ',
        country: 'Kazakhstan'
    },
    {
        code: 'KE',
        country: 'Kenya'
    },
    {
        code: 'KI',
        country: 'Kiribati'
    },
    {
        code: 'KP',
        country: "Korea (Democratic People's Republic of)"
    },
    {
        code: 'KR',
        country: 'Korea, Republic of'
    },
    {
        code: 'XK',
        country: 'Kosovo'
    },
    {
        code: 'KW',
        country: 'Kuwait'
    },
    {
        code: 'KG',
        country: 'Kyrgyzstan'
    },
    {
        code: 'LA',
        country: "Lao People's Democratic Republic"
    },
    {
        code: 'LV',
        country: 'Latvia'
    },
    {
        code: 'LB',
        country: 'Lebanon'
    },
    {
        code: 'LS',
        country: 'Lesotho'
    },
    {
        code: 'LR',
        country: 'Liberia'
    },
    {
        code: 'LY',
        country: 'Libya'
    },
    {
        code: 'LI',
        country: 'Liechtenstein'
    },
    {
        code: 'LT',
        country: 'Lithuania'
    },
    {
        code: 'LU',
        country: 'Luxembourg'
    },
    {
        code: 'MO',
        country: 'Macao'
    },
    {
        code: 'MG',
        country: 'Madagascar'
    },
    {
        code: 'MW',
        country: 'Malawi'
    },
    {
        code: 'MY',
        country: 'Malaysia'
    },
    {
        code: 'MV',
        country: 'Maldives'
    },
    {
        code: 'ML',
        country: 'Mali'
    },
    {
        code: 'MT',
        country: 'Malta'
    },
    {
        code: 'MH',
        country: 'Marshall Islands'
    },
    {
        code: 'MQ',
        country: 'Martinique'
    },
    {
        code: 'MR',
        country: 'Mauritania'
    },
    {
        code: 'MU',
        country: 'Mauritius'
    },
    {
        code: 'YT',
        country: 'Mayotte'
    },
    {
        code: 'MX',
        country: 'Mexico'
    },
    {
        code: 'FM',
        country: 'Micronesia (Federated States of)'
    },
    {
        code: 'MD',
        country: 'Moldova, Republic of'
    },
    {
        code: 'MC',
        country: 'Monaco'
    },
    {
        code: 'MN',
        country: 'Mongolia'
    },
    {
        code: 'ME',
        country: 'Montenegro'
    },
    {
        code: 'MS',
        country: 'Montserrat'
    },
    {
        code: 'MA',
        country: 'Morocco'
    },
    {
        code: 'MZ',
        country: 'Mozambique'
    },
    {
        code: 'MM',
        country: 'Myanmar'
    },
    {
        code: 'NA',
        country: 'Namibia'
    },
    {
        code: 'NR',
        country: 'Nauru'
    },
    {
        code: 'NP',
        country: 'Nepal'
    },
    {
        code: 'NL',
        country: 'Netherlands'
    },
    {
        code: 'NC',
        country: 'New Caledonia'
    },
    {
        code: 'NZ',
        country: 'New Zealand'
    },
    {
        code: 'NI',
        country: 'Nicaragua'
    },
    {
        code: 'NE',
        country: 'Niger'
    },
    {
        code: 'NG',
        country: 'Nigeria'
    },
    {
        code: 'NU',
        country: 'Niue'
    },
    {
        code: 'NF',
        country: 'Norfolk Island'
    },
    {
        code: 'MK',
        country: 'North Macedonia'
    },
    {
        code: 'MP',
        country: 'Northern Mariana Islands'
    },
    {
        code: 'NO',
        country: 'Norway'
    },
    {
        code: 'OM',
        country: 'Oman'
    },
    {
        code: 'PK',
        country: 'Pakistan'
    },
    {
        code: 'PW',
        country: 'Palau'
    },
    {
        code: 'PS',
        country: 'Palestine, State of'
    },
    {
        code: 'PA',
        country: 'Panama'
    },
    {
        code: 'PG',
        country: 'Papua New Guinea'
    },
    {
        code: 'PY',
        country: 'Paraguay'
    },
    {
        code: 'PE',
        country: 'Peru'
    },
    {
        code: 'PH',
        country: 'Philippines'
    },
    {
        code: 'PN',
        country: 'Pitcairn'
    },
    {
        code: 'PL',
        country: 'Poland'
    },
    {
        code: 'PT',
        country: 'Portugal'
    },
    {
        code: 'PR',
        country: 'Puerto Rico'
    },
    {
        code: 'QA',
        country: 'Qatar'
    },
    {
        code: 'RE',
        country: "R\xe9union"
    },
    {
        code: 'RO',
        country: 'Romania'
    },
    {
        code: 'RU',
        country: 'Russian Federation'
    },
    {
        code: 'RW',
        country: 'Rwanda'
    },
    {
        code: 'BL',
        country: "Saint Barth\xe9lemy"
    },
    {
        code: 'SH',
        country: 'Saint Helena, Ascension and Tristan da Cunha'
    },
    {
        code: 'KN',
        country: 'Saint Kitts and Nevis'
    },
    {
        code: 'LC',
        country: 'Saint Lucia'
    },
    {
        code: 'MF',
        country: 'Saint Martin (French part)'
    },
    {
        code: 'PM',
        country: 'Saint Pierre and Miquelon'
    },
    {
        code: 'VC',
        country: 'Saint Vincent and the Grenadines'
    },
    {
        code: 'WS',
        country: 'Samoa'
    },
    {
        code: 'SM',
        country: 'San Marino'
    },
    {
        code: 'ST',
        country: 'Sao Tome and Principe'
    },
    {
        code: 'SA',
        country: 'Saudi Arabia'
    },
    {
        code: 'SN',
        country: 'Senegal'
    },
    {
        code: 'RS',
        country: 'Serbia'
    },
    {
        code: 'SC',
        country: 'Seychelles'
    },
    {
        code: 'SL',
        country: 'Sierra Leone'
    },
    {
        code: 'SG',
        country: 'Singapore'
    },
    {
        code: 'SX',
        country: 'Sint Maarten (Dutch part)'
    },
    {
        code: 'SK',
        country: 'Slovakia'
    },
    {
        code: 'SI',
        country: 'Slovenia'
    },
    {
        code: 'SB',
        country: 'Solomon Islands'
    },
    {
        code: 'SO',
        country: 'Somalia'
    },
    {
        code: 'ZA',
        country: 'South Africa'
    },
    {
        code: 'GS',
        country: 'South Georgia and the South Sandwich Islands'
    },
    {
        code: 'SS',
        country: 'South Sudan'
    },
    {
        code: 'ES',
        country: 'Spain'
    },
    {
        code: 'LK',
        country: 'Sri Lanka'
    },
    {
        code: 'SD',
        country: 'Sudan'
    },
    {
        code: 'SR',
        country: 'Suriname'
    },
    {
        code: 'SJ',
        country: 'Svalbard and Jan Mayen'
    },
    {
        code: 'SE',
        country: 'Sweden'
    },
    {
        code: 'CH',
        country: 'Switzerland'
    },
    {
        code: 'SY',
        country: 'Syrian Arab Republic'
    },
    {
        code: 'TW',
        country: 'Taiwan, Province of China'
    },
    {
        code: 'TJ',
        country: 'Tajikistan'
    },
    {
        code: 'TZ',
        country: 'Tanzania, United Republic of'
    },
    {
        code: 'TH',
        country: 'Thailand'
    },
    {
        code: 'TL',
        country: 'Timor-Leste'
    },
    {
        code: 'TG',
        country: 'Togo'
    },
    {
        code: 'TK',
        country: 'Tokelau'
    },
    {
        code: 'TO',
        country: 'Tonga'
    },
    {
        code: 'TT',
        country: 'Trinidad and Tobago'
    },
    {
        code: 'TN',
        country: 'Tunisia'
    },
    {
        code: 'TR',
        country: 'Turkey'
    },
    {
        code: 'TM',
        country: 'Turkmenistan'
    },
    {
        code: 'TC',
        country: 'Turks and Caicos Islands'
    },
    {
        code: 'TV',
        country: 'Tuvalu'
    },
    {
        code: 'UG',
        country: 'Uganda'
    },
    {
        code: 'UA',
        country: 'Ukraine'
    },
    {
        code: 'AE',
        country: 'United Arab Emirates'
    },
    {
        code: 'GB',
        country: 'United Kingdom'
    },
    /** Same ISO code as UK — listed separately so users can pick a home nation; still stored/sent as GB. */ {
        code: 'GB',
        country: 'England'
    },
    {
        code: 'GB',
        country: 'Scotland'
    },
    {
        code: 'GB',
        country: 'Wales'
    },
    {
        code: 'GB',
        country: 'Northern Ireland'
    },
    {
        code: 'UM',
        country: 'United States Minor Outlying Islands'
    },
    {
        code: 'US',
        country: 'United States of America'
    },
    {
        code: 'UY',
        country: 'Uruguay'
    },
    {
        code: 'UZ',
        country: 'Uzbekistan'
    },
    {
        code: 'VU',
        country: 'Vanuatu'
    },
    {
        code: 'VE',
        country: 'Venezuela (Bolivarian Republic of)'
    },
    {
        code: 'VN',
        country: 'Viet Nam'
    },
    {
        code: 'VG',
        country: 'Virgin Islands (British)'
    },
    {
        code: 'VI',
        country: 'Virgin Islands (U.S.)'
    },
    {
        code: 'WF',
        country: 'Wallis and Futuna'
    },
    {
        code: 'EH',
        country: 'Western Sahara'
    },
    {
        code: 'YE',
        country: 'Yemen'
    },
    {
        code: 'ZM',
        country: 'Zambia'
    },
    {
        code: 'ZW',
        country: 'Zimbabwe'
    }
];
const getCountryNameByCode = (code)=>{
    if (!code || typeof code !== "string") return code || "";
    const c = countriesList.find((item)=>item.code === code.trim());
    return c ? c.country : code;
};
function countryCodeToFlagEmoji(code) {
    if (!code || typeof code !== "string") return "";
    const trimmed = code.trim().toUpperCase();
    if (trimmed.length !== 2 || !/^[A-Z]{2}$/.test(trimmed)) return "\uD83C\uDFF3\uFE0F";
    const base = 0x1f1e6; // Regional Indicator Symbol Letter A
    const cp = (ch)=>base + (ch.charCodeAt(0) - 65);
    return String.fromCodePoint(cp(trimmed[0]), cp(trimmed[1]));
}
const Countries = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    (0, _react.useEffect)(()=>{
        if (ref.current) ref.current = props.selectedCountry;
    }, [
        ref,
        props.selectedCountry
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "font-chakra text-[#18062f] !text-left text-[12px] md:text-[14px]",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "select-wrapper !w-[100%]",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                ref: ref,
                id: "country",
                name: "country",
                className: "dropdown !h-[40px]",
                value: props.selectedCountry,
                onChange: (e)=>props.setSelectedCountry(e.target.value),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                        value: "",
                        children: "--"
                    }),
                    countriesList.map((country, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                            value: country.code,
                            children: country.country
                        }, index))
                ]
            })
        })
    });
});
exports.default = Countries;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZNUw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Horizontal favourites row (30×30 chips); tap toggles a readable label below.
 */ parcelHelpers.export(exports, "ProfileFavouritesStrip", ()=>ProfileFavouritesStrip);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _favouritesSportIcon = require("./FavouritesSportIcon");
/** Cricketer headshots + generic cricket/football glyphs get the padded tile; sports rasters + team crests stay flush on the strip. */ function favChipUsesTintedTile(chipKey) {
    if (chipKey.startsWith("cr-")) return true;
    if (chipKey.startsWith("team-")) return true;
    if (chipKey === "tour") return true;
    if (chipKey === "t1" || chipKey === "t2") return true;
    return false;
}
function ProfileFavouritesStrip({ chips }) {
    const [expandedKey, setExpandedKey] = (0, _react.useState)(null);
    const expanded = expandedKey ? chips.find((c)=>c.key === expandedKey) : undefined;
    const scrollRef = (0, _react.useRef)(null);
    const [overflowing, setOverflowing] = (0, _react.useState)(false);
    const updateOverflow = (0, _react.useCallback)(()=>{
        const el = scrollRef.current;
        if (!el) return;
        setOverflowing(el.scrollWidth > el.clientWidth + 1);
    }, []);
    (0, _react.useLayoutEffect)(()=>{
        updateOverflow();
        const el = scrollRef.current;
        if (!el) return;
        const ro = new ResizeObserver(()=>updateOverflow());
        ro.observe(el);
        return ()=>ro.disconnect();
    }, [
        chips,
        updateOverflow
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        className: "mb-4",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col items-center justify-center gap-2 rounded-none bg-[#652DAF] px-3 py-2.5",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-center font-anton text-[11px] font-normal uppercase leading-[12px] tracking-normal text-white/40 [leading-trim:none]",
                    children: "Favourites"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    ref: scrollRef,
                    className: "hide-scrollbar w-full min-w-0 max-w-full shrink-0 overflow-x-auto overflow-y-hidden",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `flex min-w-full flex-nowrap items-center gap-2.5 ${overflowing ? "justify-start" : "justify-center"}`,
                        children: chips.map((c)=>{
                            const isOpen = expandedKey === c.key;
                            const tinted = favChipUsesTintedTile(c.key);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: ()=>setExpandedKey((k)=>k === c.key ? null : c.key),
                                className: `box-border flex h-[30px] w-[30px] shrink-0 items-center justify-center overflow-hidden rounded-none p-0 leading-none text-center transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40 ${tinted ? isOpen ? "border border-white/35 bg-white/20" : "border border-transparent bg-white/10 hover:bg-white/15" : isOpen ? "ring-1 ring-inset ring-white/45" : ""}`,
                                "aria-expanded": isOpen,
                                "aria-label": c.longLabel ?? c.label,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _favouritesSportIcon.FavouritesSportIcon), {
                                    chipKey: c.key,
                                    label: c.label,
                                    size: tinted ? "stripTinted" : "stripFlat"
                                })
                            }, c.key);
                        })
                    })
                }),
                expanded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "w-full max-w-full break-words px-1 text-center font-anton text-[13px] font-normal uppercase leading-snug tracking-normal text-white [leading-trim:none]",
                    children: expanded.longLabel ?? expanded.label
                }) : null
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./FavouritesSportIcon":"7RLpu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7RLpu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Maps profile favourite chips to sport/team assets. Favourite sports use raster icons from
 * {@link favSportIcon}. Favourite cricket team (t1) uses CricketTeamLogo — same CDN resolution as match cards.
 */ parcelHelpers.export(exports, "FavouritesSportIcon", ()=>FavouritesSportIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utilsJs = require("../Games/utils.js");
var _logos = require("../shared/logos");
var _profileFavSportIcons = require("./profileFavSportIcons");
var _profileFavFootballTeams = require("./profileFavFootballTeams");
var _profileFavIplTeams = require("./profileFavIplTeams");
var _profileFavCricketIntTeams = require("./profileFavCricketIntTeams");
var _profileFavCricketers = require("./profileFavCricketers");
const SIZE_CLASSES = {
    default: {
        icon: "h-[18px] w-[18px]",
        img: "h-[22px] w-[22px]",
        cricketLogo: "28px",
        tourFallback: "text-[8px]"
    },
    large: {
        icon: "h-7 w-7",
        img: "h-8 w-8",
        cricketLogo: "36px",
        tourFallback: "text-[11px]"
    },
    /** 30×30 profile strip — full bleed (no tile border). */ stripFlat: {
        icon: "h-[30px] w-[30px]",
        img: "h-[30px] w-[30px] min-h-[30px] min-w-[30px]",
        cricketLogo: "30px",
        tourFallback: "text-[9px]"
    },
    /** 30×30 outer tile with 1px border — graphics fill inner ~28×28. */ stripTinted: {
        icon: "h-[28px] w-[28px]",
        img: "h-[28px] w-[28px] min-h-[28px] min-w-[28px]",
        cricketLogo: "28px",
        tourFallback: "text-[8px]"
    }
};
/** Solid white — same line/read as sport tabs inactive state on dark UI. */ const LINE = "#FFFFFF";
function FavouritesSportIcon({ chipKey, label, size = "default" }) {
    const s = SIZE_CLASSES[size];
    if (chipKey === "sport" || chipKey.startsWith("sport-")) return (0, _profileFavSportIcons.favSportIcon)(label.trim(), LINE, `${s.icon} flex-shrink-0`);
    if (chipKey === "t1") {
        const name = label.trim();
        if (name) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logos.CricketTeamLogo), {
            teamName: name,
            width: s.cricketLogo,
            height: s.cricketLogo,
            className: "shrink-0 justify-center [&_img]:object-contain"
        });
        return (0, _utilsJs.SportsIconsSVG).cricket(LINE, s.icon);
    }
    if (chipKey === "t2") return (0, _utilsJs.SportsIconsSVG).football(LINE, s.icon);
    if (chipKey.startsWith("fb-")) {
        const slug = chipKey.slice(3);
        if (slug) {
            const whiteTile = (0, _profileFavFootballTeams.footballLogoUsesWhiteTile)(slug);
            const img = /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _profileFavFootballTeams.footballTeamLogoUrl)(slug),
                alt: "",
                className: whiteTile ? "max-h-full max-w-full object-contain" : `${s.img} shrink-0 object-contain`,
                loading: "lazy"
            });
            if (whiteTile) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `inline-flex shrink-0 items-center justify-center rounded-none bg-white p-0.5 box-border ${s.img}`,
                children: img
            });
            return img;
        }
    }
    if (chipKey.startsWith("ipl-")) {
        const slug = chipKey.slice(4);
        if (slug) {
            const whiteTile = (0, _profileFavIplTeams.iplLogoUsesWhiteTile)(slug);
            const img = /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _profileFavIplTeams.iplTeamLogoUrl)(slug),
                alt: "",
                className: whiteTile ? "max-h-full max-w-full object-contain" : `${s.img} shrink-0 object-contain`,
                loading: "lazy"
            });
            if (whiteTile) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `inline-flex shrink-0 items-center justify-center rounded-none bg-white p-0.5 box-border ${s.img}`,
                children: img
            });
            return img;
        }
    }
    if (chipKey.startsWith("cint-")) {
        const slug = chipKey.slice(5);
        if (slug) {
            const whiteTile = (0, _profileFavCricketIntTeams.cricketIntLogoUsesWhiteTile)(slug);
            const img = /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _profileFavCricketIntTeams.cricketIntTeamLogoUrl)(slug),
                alt: "",
                className: whiteTile ? "max-h-full max-w-full object-contain" : `${s.img} shrink-0 object-contain`,
                loading: "lazy"
            });
            if (whiteTile) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `inline-flex shrink-0 items-center justify-center rounded-none bg-white p-0.5 box-border ${s.img}`,
                children: img
            });
            return img;
        }
    }
    if (chipKey.startsWith("team-")) {
        const name = label.trim();
        if (name) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logos.CricketTeamLogo), {
            teamName: name,
            width: s.cricketLogo,
            height: s.cricketLogo,
            className: "shrink-0 justify-center [&_img]:object-contain"
        });
        return (0, _utilsJs.SportsIconsSVG).cricket(LINE, s.icon);
    }
    if (chipKey.startsWith("cr-")) {
        const slug = chipKey.slice(3);
        if (slug) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _profileFavCricketers.cricketerLogoUrl)(slug),
            alt: "",
            className: `${s.img} shrink-0 object-cover`,
            loading: "lazy"
        });
    }
    if (chipKey === "tour") return (0, _utilsJs.SportsIconsSVG).cricket(LINE, s.icon);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: `font-anton ${s.tourFallback} font-normal uppercase leading-none tracking-normal text-white/40 [leading-trim:none]`,
        children: label.slice(0, 3).toUpperCase()
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Games/utils.js":"c7Szu","../shared/logos":"4XCsm","./profileFavSportIcons":"bXwQU","./profileFavFootballTeams":"3mxlc","./profileFavIplTeams":"f7o1p","./profileFavCricketIntTeams":"7D1sc","./profileFavCricketers":"2PUhI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c7Szu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isToday", ()=>isToday);
parcelHelpers.export(exports, "getClientTzAndDate", ()=>getClientTzAndDate);
parcelHelpers.export(exports, "generateSessionId", ()=>generateSessionId);
parcelHelpers.export(exports, "SportsIconsSVG", ()=>SportsIconsSVG);
var _jsxRuntime = require("react/jsx-runtime");
function isToday(dateString) {
    if (dateString == null || dateString === '') return false;
    const s = String(dateString).trim();
    // Backend stores game "last" as UTC calendar day (e.g. gameApplyWinnings: toISOString().slice(0, 10)).
    // Comparing YYYY-MM-DD to *local* today made spinPlayed false on many timezones the same calendar day → replay allowed.
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        const utcTodayStr = new Date().toISOString().slice(0, 10);
        return s === utcTodayStr;
    }
    const today = new Date();
    const someDate = new Date(dateString);
    return !Number.isNaN(someDate.getTime()) && someDate.toDateString() === today.toDateString();
}
function getClientTzAndDate() {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    try {
        const date = new Intl.DateTimeFormat("en-CA", {
            timeZone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).format(new Date());
        return {
            clientTZ: timeZone,
            clientDate: date
        };
    } catch  {
        return {
            clientTZ: timeZone,
            clientDate: new Date().toISOString().slice(0, 10)
        };
    }
}
const generateSessionId = (size)=>{
    let result = [];
    let hexRef = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ];
    for(let n = 0; n < size; n++)result.push(hexRef[Math.floor(Math.random() * 16)]);
    return result.join("");
};
const SportsIconsSVG = {
    // Usage: SportsIconsSVG.cricket("#fff") OR SportsIconsSVG.cricket("#fff", "w-8 h-8")
    cricket: (fillColor, className)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            className: `${className} flex-shrink-0`,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#clip0_7036_9206)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M12.2426 6.58579C12.4379 6.78105 12.4379 7.09764 12.2426 7.2929L11.5355 8.00001C11.3403 8.19527 11.0237 8.19527 10.8284 8.00001C10.6332 7.80474 10.6332 7.48816 10.8284 7.2929L11.5355 6.58579C11.7308 6.39053 12.0474 6.39053 12.2426 6.58579Z",
                            fill: fillColor
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M10.1213 8.70711C10.3166 8.90237 10.3166 9.21896 10.1213 9.41422L9.41421 10.1213C9.21895 10.3166 8.90237 10.3166 8.70711 10.1213C8.51184 9.92606 8.51184 9.60948 8.70711 9.41422L9.41421 8.70711C9.60948 8.51185 9.92606 8.51185 10.1213 8.70711Z",
                            fill: fillColor
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M8 10.8284C8.19526 11.0237 8.19526 11.3403 8 11.5355L7.29289 12.2426C7.09763 12.4379 6.78105 12.4379 6.58579 12.2426C6.39052 12.0474 6.39052 11.7308 6.58579 11.5355L7.29289 10.8284C7.48816 10.6332 7.80474 10.6332 8 10.8284Z",
                            fill: fillColor
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M9.41421 3.75736C9.60948 3.95263 9.60948 4.26921 9.41421 4.46447L8.70711 5.17158C8.51184 5.36684 8.19526 5.36684 8 5.17158C7.80474 4.97632 7.80474 4.65973 8 4.46447L8.70711 3.75736C8.90237 3.5621 9.21895 3.5621 9.41421 3.75736Z",
                            fill: fillColor
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M7.29289 5.87868C7.48816 6.07395 7.48816 6.39053 7.29289 6.58579L6.58579 7.2929C6.39052 7.48816 6.07394 7.48816 5.87868 7.2929C5.68342 7.09764 5.68342 6.78105 5.87868 6.58579L6.58579 5.87868C6.78105 5.68342 7.09763 5.68342 7.29289 5.87868Z",
                            fill: fillColor
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M5.17157 8.00001C5.36683 8.19527 5.36683 8.51185 5.17157 8.70711L4.46447 9.41422C4.2692 9.60948 3.95262 9.60948 3.75736 9.41422C3.5621 9.21896 3.5621 8.90237 3.75736 8.70711L4.46447 8.00001C4.65973 7.80474 4.97631 7.80474 5.17157 8.00001Z",
                            fill: fillColor
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M12.5962 12.5962C10.0578 15.1346 5.94221 15.1346 3.40381 12.5962C0.865398 10.0578 0.865398 5.94222 3.40381 3.40381C5.94221 0.865403 10.0578 0.865403 12.5962 3.40381C15.1346 5.94222 15.1346 10.0578 12.5962 12.5962ZM4.48032 12.2268C6.64114 14.0304 9.86038 13.9178 11.8891 11.8891C13.9178 9.86039 14.0304 6.64115 12.2268 4.48033L4.48032 12.2268ZM3.77321 11.5197L11.5197 3.77322C9.35886 1.96965 6.13962 2.08221 4.11091 4.11092C2.08221 6.13962 1.96964 9.35886 3.77321 11.5197Z",
                            fill: fillColor
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "clip0_7036_9206",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    })
                })
            ]
        }),
    horses: (fillColor, strokeColor, className)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            className: `${className} flex-shrink-0`,
            viewBox: "0 0 256 256",
            fill: fillColor,
            stroke: strokeColor,
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M204.90039,52.169A107.22224,107.22224,0,0,0,128,20h-8a12.00028,12.00028,0,0,0-12,12V57.29443L9.71094,117.78027a11.99917,11.99917,0,0,0-3.44336,17.23926l13.78711,19.11621a35.803,35.803,0,0,0,35.25,14.42725c12.27441-2.07764,34.001-3.84278,54.68359,4.00732L88.75977,202.29053a84.0305,84.0305,0,0,1-16.75684-11.67676,11.99982,11.99982,0,1,0-16.00586,17.88281A107.64568,107.64568,0,0,0,128.01172,236q1.08252,0,2.168-.02148A108.00034,108.00034,0,0,0,204.90039,52.169Zm-17.4082,134.9707a83.47468,83.47468,0,0,1-57.78711,24.84375,84.68094,84.68094,0,0,1-17.34473-1.44238l22.06348-30.88916A60.08219,60.08219,0,0,0,188,120a12,12,0,0,0-24,0,36.04146,36.04146,0,0,1-33.04688,35.86914c-29.552-16.19922-62.364-13.89648-79.65429-10.96924a11.96127,11.96127,0,0,1-11.7793-4.80322l-6.2334-8.644,93.00293-57.23291A11.99983,11.99983,0,0,0,132,64V44.09277a83.88226,83.88226,0,0,1,55.49219,143.04688ZM144,104a16,16,0,1,1-16-16A16.01833,16.01833,0,0,1,144,104Z"
            })
        }),
    football: (fillColor, className)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            className: `${className} flex-shrink-0`,
            viewBox: "0 0 256 256",
            fill: fillColor,
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm76.52,147.42H170.9l-9.26-12.76,12.63-36.78,15-4.89,26.24,20.13A87.38,87.38,0,0,1,204.52,171.42Zm-164-34.3L66.71,117l15,4.89,12.63,36.78L85.1,171.42H51.48A87.38,87.38,0,0,1,40.47,137.12Zm10-50.64,5.51,18.6L40.71,116.77A87.33,87.33,0,0,1,50.43,86.48ZM109,152,97.54,118.65,128,97.71l30.46,20.94L147,152Zm91.07-46.92,5.51-18.6a87.33,87.33,0,0,1,9.72,30.29Zm-6.2-35.38-9.51,32.08-15.07,4.89L136,83.79V68.21l29.09-20A88.58,88.58,0,0,1,193.86,69.7ZM146.07,41.87,128,54.29,109.93,41.87a88.24,88.24,0,0,1,36.14,0ZM90.91,48.21l29.09,20V83.79L86.72,106.67l-15.07-4.89L62.14,69.7A88.58,88.58,0,0,1,90.91,48.21ZM63.15,187.42H83.52l7.17,20.27A88.4,88.4,0,0,1,63.15,187.42ZM110,214.13,98.12,180.71,107.35,168h41.3l9.23,12.71-11.83,33.42a88,88,0,0,1-36.1,0Zm55.36-6.44,7.17-20.27h20.37A88.4,88.4,0,0,1,165.31,207.69Z"
            })
        }),
    tennis: (fillColor, className)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            className: `${className} flex-shrink-0`,
            viewBox: "-1.5 -1.5 27 27",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.9999 11.9998C22.9999 18.0749 18.075 22.9998 11.9999 22.9998C5.92478 22.9998 0.999908 18.0749 0.999908 11.9998C0.999908 5.92462 5.92478 0.999756 11.9999 0.999756C18.075 0.999756 22.9999 5.92462 22.9999 11.9998ZM3.00674 11.9998C3.00674 14.5875 4.09974 16.92 5.84927 18.5608C6.0769 18.2328 6.34676 17.808 6.61709 17.2997C7.31622 15.9851 8 14.1476 8 12C8 9.85239 7.31622 8.01489 6.61709 6.7003C6.34668 6.19183 6.07674 5.7669 5.84906 5.43891C4.09965 7.07965 3.00674 9.41207 3.00674 11.9998ZM11.9999 20.9929C10.3404 20.9929 8.78593 20.5434 7.45152 19.7596C7.72696 19.3672 8.05519 18.855 8.38291 18.2388C9.18378 16.7329 10 14.5704 10 12C10 9.42961 9.18378 7.26711 8.38291 5.7612C8.0551 5.14481 7.72676 4.6325 7.45127 4.24005C8.78574 3.45612 10.3403 3.00659 11.9999 3.00659C13.6595 3.00659 15.2142 3.45615 16.5487 4.24013C16.2732 4.63257 15.9449 5.14485 15.6171 5.7612C14.8162 7.26711 14 9.42961 14 12C14 14.5704 14.8162 16.7329 15.6171 18.2388C15.9448 18.855 16.273 19.3671 16.5484 19.7595C15.214 20.5434 13.6594 20.9929 11.9999 20.9929ZM18.1507 18.5607C19.9001 16.9199 20.9931 14.5875 20.9931 11.9998C20.9931 9.41213 19.9002 7.07975 18.1509 5.43901C17.9232 5.76699 17.6533 6.19189 17.3829 6.7003C16.6838 8.01489 16 9.85239 16 12C16 14.1476 16.6838 15.9851 17.3829 17.2997C17.6532 17.808 17.923 18.2328 18.1507 18.5607Z",
                fill: fillColor
            })
        })
};

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bXwQU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROFILE_FAV_SPORT_GRID_OPTIONS", ()=>PROFILE_FAV_SPORT_GRID_OPTIONS);
/** Maps API / trader `match.sport` slug to profile catalogue name (for shared WebP assets). */ parcelHelpers.export(exports, "traderSportSlugToFavSportName", ()=>traderSportSlugToFavSportName);
/**
 * Favourite-sport icons for the profile grid and chips.
 */ parcelHelpers.export(exports, "favSportIcon", ()=>favSportIcon);
parcelHelpers.export(exports, "parseFavSportsFromStorage", ()=>parseFavSportsFromStorage);
/** Persist as comma-separated string; known sports in catalog order, then any legacy tokens. */ parcelHelpers.export(exports, "serializeFavSportsToStorage", ()=>serializeFavSportsToStorage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const PROFILE_FAV_SPORT_GRID_OPTIONS = [
    "Cricket",
    "Football",
    "Tennis",
    "Horse Racing",
    "Golf",
    "Kabaddi",
    "MMA",
    "F1"
];
const OPTION_SET = new Set(PROFILE_FAV_SPORT_GRID_OPTIONS);
function traderSportSlugToFavSportName(sport) {
    const s = sport.trim().toLowerCase();
    if (s === "cricket") return "Cricket";
    if (s === "horses" || s === "horse") return "Horse Racing";
    if (s === "football") return "Football";
    if (s === "tennis") return "Tennis";
    return sport.trim() || sport;
}
/** Served from `frontend/static/assets` → `/assets/…` after build. */ const FAV_SPORT_ICON_SRC = {
    Cricket: "/assets/cricket.webp",
    Football: "/assets/football.webp",
    Tennis: "/assets/tennis.webp",
    "Horse Racing": "/assets/horse-racing.webp",
    Golf: "/assets/golf.webp",
    Kabaddi: "/assets/kabaddi.webp",
    MMA: "/assets/mma.webp",
    F1: "/assets/f1.webp"
};
const DEFAULT_ICON_CLASS = "mx-auto h-8 w-8 shrink-0 sm:h-9 sm:w-9";
function favSportIcon(sport, _color, className = DEFAULT_ICON_CLASS) {
    if (OPTION_SET.has(sport)) {
        const src = FAV_SPORT_ICON_SRC[sport];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: `flex items-center justify-center ${className}`,
            "aria-hidden": true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: src,
                alt: "",
                className: "block h-full w-full min-h-0 min-w-0 object-contain object-center",
                loading: "lazy",
                decoding: "async",
                draggable: false
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-anton text-[10px] font-normal uppercase leading-none text-white/50 [leading-trim:none]",
        children: sport.slice(0, 3)
    });
}
function parseFavSportsFromStorage(raw) {
    if (!raw?.trim()) return [];
    const parts = raw.split(/,\s*/).map((s)=>s.trim()).filter(Boolean);
    const ordered = [];
    for (const opt of PROFILE_FAV_SPORT_GRID_OPTIONS)if (parts.includes(opt)) ordered.push(opt);
    for (const p of parts)if (!OPTION_SET.has(p)) ordered.push(p);
    return ordered;
}
function serializeFavSportsToStorage(selected) {
    if (selected.length === 0) return "";
    const set = new Set(selected);
    const known = PROFILE_FAV_SPORT_GRID_OPTIONS.filter((o)=>set.has(o));
    const unknown = selected.filter((s)=>!OPTION_SET.has(s));
    return [
        ...known,
        ...unknown
    ].join(", ");
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2PUhI":[function(require,module,exports,__globalThis) {
/**
 * Favourite cricketers for profile grid. Headshots live at
 * `favs/cricketers/{slug}.png` on cricket8-web-content.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROFILE_FAV_CRICKETER_LOGO_BASE", ()=>PROFILE_FAV_CRICKETER_LOGO_BASE);
parcelHelpers.export(exports, "PROFILE_FAV_CRICKETER_OPTIONS", ()=>PROFILE_FAV_CRICKETER_OPTIONS);
parcelHelpers.export(exports, "cricketerLogoUrl", ()=>cricketerLogoUrl);
parcelHelpers.export(exports, "parseFavCricketersFromStorage", ()=>parseFavCricketersFromStorage);
parcelHelpers.export(exports, "serializeFavCricketersToStorage", ()=>serializeFavCricketersToStorage);
parcelHelpers.export(exports, "favCricketerLabel", ()=>favCricketerLabel);
const PROFILE_FAV_CRICKETER_LOGO_BASE = "https://cricket8-web-content.s3.us-east-1.amazonaws.com/favs/cricketers/";
const PROFILE_FAV_CRICKETER_OPTIONS = [
    {
        slug: "abhishek-sharma",
        label: "Abhishek Sharma"
    },
    {
        slug: "daryl-mitchell",
        label: "Daryl Mitchell"
    },
    {
        slug: "hardik-pandya",
        label: "Hardik Pandya"
    },
    {
        slug: "jasprit-bumrah",
        label: "Jasprit Bumrah"
    },
    {
        slug: "jos-buttler",
        label: "Jos Buttler"
    },
    {
        slug: "rashid-khan",
        label: "Rashid Khan"
    },
    {
        slug: "kl-rahul",
        label: "KL Rahul"
    },
    {
        slug: "mohammed-siraj",
        label: "Mohammed Siraj"
    },
    {
        slug: "ms-dhoni",
        label: "MS Dhoni"
    },
    {
        slug: "ravindra-jadeja",
        label: "Ravindra Jadeja"
    },
    {
        slug: "rishabh-pant",
        label: "Rishabh Pant"
    },
    {
        slug: "rohit-sharma",
        label: "Rohit Sharma"
    },
    {
        slug: "sanju-samson",
        label: "Sanju Samson"
    },
    {
        slug: "shubman-gill",
        label: "Shubman Gill"
    },
    {
        slug: "suryakumar-yadav",
        label: "Suryakumar Yadav"
    },
    {
        slug: "virat-kohli",
        label: "Virat Kohli"
    }
];
const OPTION_SLUGS = PROFILE_FAV_CRICKETER_OPTIONS.map((t)=>t.slug);
const SLUG_SET = new Set(OPTION_SLUGS);
const SLUG_TO_LABEL = Object.fromEntries(PROFILE_FAV_CRICKETER_OPTIONS.map((t)=>[
        t.slug,
        t.label
    ]));
function cricketerLogoUrl(slug) {
    return `${PROFILE_FAV_CRICKETER_LOGO_BASE}${encodeURIComponent(slug)}.png`;
}
function parseFavCricketersFromStorage(raw) {
    if (!raw?.trim()) return [];
    const parts = raw.split(/,\s*/).map((s)=>s.trim()).filter(Boolean);
    const ordered = [];
    for (const slug of OPTION_SLUGS)if (parts.includes(slug)) ordered.push(slug);
    for (const p of parts)if (!SLUG_SET.has(p) && !ordered.includes(p)) ordered.push(p);
    return ordered;
}
function serializeFavCricketersToStorage(selected) {
    if (selected.length === 0) return "";
    const set = new Set(selected);
    const known = OPTION_SLUGS.filter((s)=>set.has(s));
    const unknown = selected.filter((s)=>!SLUG_SET.has(s));
    return [
        ...known,
        ...unknown
    ].join(", ");
}
function favCricketerLabel(slug) {
    return SLUG_TO_LABEL[slug] ?? slug.replace(/-/g, " ");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iO9Z8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CareerStatsStack", ()=>CareerStatsStack);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _xpCareerSection = require("../Xp/XpCareerSection");
var _careerStatCardHeader = require("./CareerStatCardHeader");
function StatCell({ label, value }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex min-h-[74px] flex-col items-center justify-center bg-[#2f1455] px-2 py-2 text-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "font-anton text-[12px] font-normal uppercase leading-[12px] tracking-normal text-white/35 [leading-trim:none]",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mt-2 font-anton text-[16px] font-normal uppercase leading-none tracking-normal text-white tabular-nums [leading-trim:none]",
                children: value
            })
        ]
    });
}
function Header({ iconSrc, title }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex h-[38px] items-center gap-2 bg-[#5f2bb0] px-3",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: iconSrc,
                alt: "",
                className: "h-5 w-5 shrink-0 object-contain",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-anton text-[17px] font-normal uppercase leading-none tracking-normal text-white",
                children: title
            })
        ]
    });
}
function CareerStatsStack({ xp, showXpHistoryLink = true, trader, squares, bullion, sixes, leagues, quickfire, formatCoins }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: "mb-4 pt-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "mb-4 text-center font-anton text-[15px] font-normal uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                children: "Career stats"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpCareerSection.XpCareerSection), {
                        xp: xp ?? null,
                        showHistoryLink: showXpHistoryLink
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overflow-hidden border border-white/10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                                iconSrc: (0, _careerStatCardHeader.CAREER_STAT_ICONS).leagues,
                                title: "Leagues"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-3 gap-[2px] border-t border-white/5 bg-[#3a1a64]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Played",
                                        value: leagues.played
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Won",
                                        value: leagues.won
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Career total",
                                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-coin.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain",
                                                    "aria-hidden": true
                                                }),
                                                formatCoins(leagues.totalWinnings)
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overflow-hidden border border-white/10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                                iconSrc: (0, _careerStatCardHeader.CAREER_STAT_ICONS).bullion,
                                title: "Bullion"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-3 gap-[2px] border-t border-white/5 bg-[#3a1a64]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Played",
                                        value: bullion.played
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Won",
                                        value: bullion.won
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Career total",
                                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-coin.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain",
                                                    "aria-hidden": true
                                                }),
                                                formatCoins(bullion.totalWinnings)
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overflow-hidden border border-white/10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                                iconSrc: (0, _careerStatCardHeader.CAREER_STAT_ICONS).sixes,
                                title: "Sixes"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-3 gap-[2px] border-t border-white/5 bg-[#3a1a64]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Played",
                                        value: sixes.played
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Best result",
                                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-coin.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain",
                                                    "aria-hidden": true
                                                }),
                                                formatCoins(Math.max(0, Number(sixes.biggestWin ?? 0)))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Career total",
                                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-coin.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain",
                                                    "aria-hidden": true
                                                }),
                                                formatCoins(sixes.totalWinnings)
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overflow-hidden border border-white/10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                                iconSrc: (0, _careerStatCardHeader.CAREER_STAT_ICONS).trader,
                                title: "Trader"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-3 gap-[2px] border-t border-white/5 bg-[#3a1a64]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Played",
                                        value: trader.played
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Won",
                                        value: trader.won
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Career total",
                                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-coin.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain",
                                                    "aria-hidden": true
                                                }),
                                                formatCoins(trader.totalWinnings)
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-[2px] grid grid-cols-3 gap-[2px] border-t border-white/5 bg-[#3a1a64]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Current streak",
                                        value: `${Math.max(0, Math.trunc(trader.currentStreak ?? 0))} wins`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Best streak",
                                        value: `${Math.max(0, Math.trunc(trader.bestStreak ?? 0))} wins`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Best result",
                                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-coin.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain",
                                                    "aria-hidden": true
                                                }),
                                                formatCoins(Math.max(0, Number(trader.biggestWin ?? 0)))
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overflow-hidden border border-white/10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                                iconSrc: (0, _careerStatCardHeader.CAREER_STAT_ICONS).squares,
                                title: "Squares"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-3 gap-[2px] border-t border-white/5 bg-[#3a1a64]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Played",
                                        value: squares.played
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Won",
                                        value: squares.won
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Career total",
                                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-coin.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain",
                                                    "aria-hidden": true
                                                }),
                                                formatCoins(squares.totalWinnings)
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overflow-hidden border border-white/10",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                                iconSrc: (0, _careerStatCardHeader.CAREER_STAT_ICONS).quickfire,
                                title: "Quickfire"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-3 gap-[2px] border-t border-white/5 bg-[#3a1a64]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Plays",
                                        value: quickfire.plays
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Correct",
                                        value: quickfire.correct
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                                        label: "Career total",
                                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-coin.png",
                                                    alt: "",
                                                    className: "h-4 w-4 shrink-0 object-contain",
                                                    "aria-hidden": true
                                                }),
                                                formatCoins(quickfire.totalWinnings)
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Xp/XpCareerSection":"816T0","./CareerStatCardHeader":"k4ekZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"816T0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XpCareerSection", ()=>XpCareerSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _xpHubModal = require("./XpHubModal");
var _xpCareerStatsRow = require("./XpCareerStatsRow");
var _xp = require("../../utils/xp");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _avatarWithXpCrown = require("./AvatarWithXpCrown");
function FinishCrown({ src }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        src: src,
        alt: "",
        className: "mx-auto h-5 w-5 object-contain",
        loading: "lazy",
        decoding: "async",
        "aria-hidden": true
    });
}
function XpCareerSection({ xp, showHistoryLink = true }) {
    const [hubOpen, setHubOpen] = (0, _react.useState)(false);
    const summary = xp ?? {
        total_xp: 0,
        week_xp: 0,
        week_rank: null,
        weekly_finishes: {
            first: 0,
            second: 0,
            third: 0
        }
    };
    const openHub = ()=>{
        const pathname = typeof window !== "undefined" ? window.location.pathname : undefined;
        (0, _frontendTrackingEvents.trackCtaClicked)({
            cta_name: "xp_history",
            cta_location: "profile",
            source_page: pathname,
            pathname
        });
        setHubOpen(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overflow-hidden border border-white/10",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex h-[26px] items-center gap-2 bg-[#5f2bb0] px-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _xp.XP_ICON_SRC),
                                alt: "",
                                className: "h-4 w-4 shrink-0 object-contain",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "min-w-0 flex-1 font-anton text-[12px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-white [leading-trim:none]",
                                children: "XP"
                            }),
                            showHistoryLink ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: openHub,
                                className: "shrink-0 border-0 bg-transparent p-0 text-right font-chakra text-[10px] font-normal not-italic normal-case leading-[16px] tracking-[0%] text-[#D2FF00] hover:underline [leading-trim:none]",
                                children: "My XP history"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `flex flex-col ${(0, _xpCareerStatsRow.XP_STAT_BOX_GAP_PROFILE)}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpCareerStatsRow.XpCareerStatsRow), {
                                xp: xp,
                                boxBgClassName: (0, _xpCareerStatsRow.XP_STAT_BOX_BG_PROFILE),
                                boxGapClassName: (0, _xpCareerStatsRow.XP_STAT_BOX_GAP_PROFILE),
                                statLabelClassName: (0, _xpCareerStatsRow.XP_STAT_LABEL_CLASS_PROFILE),
                                statValueClassName: (0, _xpCareerStatsRow.XP_STAT_VALUE_CLASS),
                                onLeaderboardClick: showHistoryLink ? openHub : undefined
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `flex ${(0, _xpCareerStatsRow.XP_WEEKLY_FINISHES_BOX_HEIGHT_PROFILE)} w-full flex-col items-center justify-center overflow-hidden px-2 py-0.5 ${(0, _xpCareerStatsRow.XP_STAT_BOX_BG_PROFILE)}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "mb-0 shrink-0 text-center font-anton text-[9px] font-normal not-italic uppercase leading-[10px] tracking-[0%] text-white/40 [leading-trim:none]",
                                        children: "Weekly XP leaderboard finishes"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex shrink-0 justify-center gap-5 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-col items-center gap-0.5",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FinishCrown, {
                                                        src: (0, _avatarWithXpCrown.XP_WEEK_CROWN_ASSETS).gold
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "font-anton text-[15px] font-normal not-italic uppercase leading-[100%] tracking-[0%] text-white [leading-trim:none]",
                                                        children: summary.weekly_finishes.first
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-col items-center gap-0.5",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FinishCrown, {
                                                        src: (0, _avatarWithXpCrown.XP_WEEK_CROWN_ASSETS).silver
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "font-anton text-[15px] font-normal not-italic uppercase leading-[100%] tracking-[0%] text-white [leading-trim:none]",
                                                        children: summary.weekly_finishes.second
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex flex-col items-center gap-0.5",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FinishCrown, {
                                                        src: (0, _avatarWithXpCrown.XP_WEEK_CROWN_ASSETS).bronze
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "font-anton text-[15px] font-normal not-italic uppercase leading-[100%] tracking-[0%] text-white [leading-trim:none]",
                                                        children: summary.weekly_finishes.third
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showHistoryLink ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpHubModal.XpHubModal), {
                isOpen: hubOpen,
                onClose: ()=>setHubOpen(false),
                xp: xp
            }) : null
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./XpHubModal":"lSUlG","./XpCareerStatsRow":"jpDcU","../../utils/xp":"jFgAi","../../utils/frontendTrackingEvents":"4Y90p","./AvatarWithXpCrown":"9U2iQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSUlG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XpHubModal", ()=>XpHubModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactRouterDom = require("react-router-dom");
var _framerMotion = require("framer-motion");
var _userContext = require("../../Data/UserContext");
var _authHeaders = require("../../utils/authHeaders");
var _sessionUser = require("../../utils/sessionUser");
var _profileCountryFlag = require("../../utils/profileCountryFlag");
var _xp = require("../../utils/xp");
var _profileModalShell = require("../Profile/ProfileModalShell");
var _useCloseOnHistoryBack = require("../../hooks/useCloseOnHistoryBack");
var _profileAvatar = require("../Profile/ProfileAvatar");
var _modalCloseIcon = require("../ModalCloseIcon");
var _xpCareerStatsRow = require("./XpCareerStatsRow");
var _xpHistoryListRow = require("./XpHistoryListRow");
var _xpAboutModal = require("./XpAboutModal");
var _xpModalNav = require("./xpModalNav");
function apiRowToListItem(row, avatarSrc, displayName, frame) {
    return {
        amount: row.amount,
        detail: (0, _xp.formatXpHistoryReasonDetail)(row.reason),
        relative: (0, _xp.formatXpHistoryRelative)(row.created_at),
        iconSrc: avatarSrc,
        displayName,
        ...frame
    };
}
function XpHubModal({ isOpen, onClose, xp: xpProp, backLabel = "PROFILE" }) {
    (0, _useCloseOnHistoryBack.useCloseOnHistoryBack)(isOpen, onClose);
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { user } = (0, _userContext.useUser)();
    const [xp, setXp] = (0, _react.useState)(xpProp ?? null);
    const [rows, setRows] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [historyPeriod, setHistoryPeriod] = (0, _react.useState)("week");
    const [aboutOpen, setAboutOpen] = (0, _react.useState)(false);
    const displayName = (user?.playerName || user?.username || "Player").trim();
    const countryFlag = (0, _react.useMemo)(()=>(0, _profileCountryFlag.getProfileCountryFlagEmoji)(user?.country), [
        user?.country
    ]);
    const avatarSrc = (0, _sessionUser.resolveAvatarUrl)(user) || null;
    const avatarFrameUrl = user?.avatar_frame_url ?? null;
    const avatarFrameSmallUrl = user?.avatar_frame_small_url ?? null;
    const fetchData = (0, _react.useCallback)(async ()=>{
        if (!user?.userId || false) return;
        setLoading(true);
        try {
            const headers = (0, _authHeaders.getAuthHeaders)();
            const [summaryRes, historyRes] = await Promise.all([
                xpProp ? Promise.resolve(null) : fetch(`${"https://cricket8.com/api"}/account/xp-summary`, {
                    method: "GET",
                    headers
                }),
                fetch(`${"https://cricket8.com/api"}/account/xp-history?limit=50`, {
                    method: "GET",
                    headers
                })
            ]);
            if (!xpProp && summaryRes) {
                if (await (0, _authHeaders.consumeAccountDeletedIfPresent)(summaryRes)) return;
                if (summaryRes.ok) {
                    const summaryData = await summaryRes.json();
                    setXp((0, _xp.parseXpSummary)(summaryData));
                }
            }
            if (historyRes) {
                if (await (0, _authHeaders.consumeAccountDeletedIfPresent)(historyRes)) return;
                if (historyRes.ok) {
                    const data = await historyRes.json();
                    setRows(Array.isArray(data.history) ? data.history : []);
                } else setRows([]);
            }
        } catch  {
            if (!xpProp) setXp(null);
            setRows([]);
        } finally{
            setLoading(false);
        }
    }, [
        user?.userId,
        xpProp
    ]);
    (0, _react.useEffect)(()=>{
        if (xpProp) setXp(xpProp);
    }, [
        xpProp
    ]);
    (0, _react.useEffect)(()=>{
        if (isOpen) fetchData();
    }, [
        isOpen,
        fetchData
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen) return;
        const onXpActivity = ()=>{
            fetchData();
        };
        window.addEventListener("c8-notifications-updated", onXpActivity);
        return ()=>window.removeEventListener("c8-notifications-updated", onXpActivity);
    }, [
        isOpen,
        fetchData
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen) setAboutOpen(false);
    }, [
        isOpen
    ]);
    const weekStart = (0, _react.useMemo)(()=>(0, _xp.getXpWeekStart)(), [
        isOpen,
        historyPeriod
    ]);
    const filteredRows = (0, _react.useMemo)(()=>{
        if (historyPeriod === "all") return rows;
        return rows.filter((row)=>{
            if (!row.created_at) return false;
            const t = new Date(row.created_at).getTime();
            return !Number.isNaN(t) && t >= weekStart.getTime();
        });
    }, [
        rows,
        historyPeriod,
        weekStart
    ]);
    const historyListItems = (0, _react.useMemo)(()=>filteredRows.map((row)=>apiRowToListItem(row, avatarSrc, displayName, {
                avatarFrameUrl,
                avatarFrameSmallUrl
            })), [
        filteredRows,
        avatarSrc,
        displayName,
        avatarFrameUrl,
        avatarFrameSmallUrl
    ]);
    const historyEmptyMessage = historyPeriod === "week" ? "No XP earned this week yet." : "No XP history yet.";
    const openLeaderboardPage = ()=>{
        onClose();
        navigate("/xp-leaderboard");
    };
    if (typeof document === "undefined") return null;
    return /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.AnimatePresence), {
        children: [
            isOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileModalShell.ProfileModalShell), {
                onClose: onClose,
                zIndexClass: "z-[10060]",
                overlayAriaLabel: "Close XP",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex min-h-0 flex-1 flex-col",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "shrink-0 border-b border-white/10 px-3 pb-1 pt-1 sm:pt-1.5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "grid shrink-0 grid-cols-[1fr_auto_1fr] items-start gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-start-1 flex min-w-0 flex-col items-start self-start",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                onClick: onClose,
                                                className: (0, _xpModalNav.XP_LIME_BACK_BUTTON_CLASS),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: (0, _xpModalNav.XP_BACK_ARROW_SRC),
                                                        alt: "",
                                                        className: (0, _xpModalNav.XP_BACK_ARROW_CLASS),
                                                        "aria-hidden": true
                                                    }),
                                                    backLabel
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-start-2 flex max-w-[min(100%,11rem)] flex-col items-center justify-self-center self-start",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "relative h-[70px] w-[70px] shrink-0",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileAvatar.ProfileAvatar), {
                                                        variant: "hero",
                                                        src: avatarSrc ?? "",
                                                        displayName: displayName,
                                                        alt: "",
                                                        xpWeekCrown: user?.xp_week_crown,
                                                        avatarFrameUrl: avatarFrameUrl,
                                                        avatarFrameSmallUrl: avatarFrameSmallUrl,
                                                        className: "!h-[70px] !w-[70px] shadow-[0_6px_20px_rgba(8,2,18,0.45)]"
                                                    }),
                                                    countryFlag ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "pointer-events-none absolute -right-1.5 -top-1.5 z-[1] select-none text-[15px] leading-none",
                                                        "aria-hidden": true,
                                                        children: countryFlag
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-start-3 justify-self-end self-start",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseButton), {
                                                onClick: onClose,
                                                ariaLabel: "Close XP",
                                                className: "h-11 w-11 shrink-0 rounded-none hover:bg-white/10 hover:opacity-100"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mt-2 truncate text-center font-anton text-[20px] font-normal uppercase leading-[26px] tracking-normal text-white [leading-trim:none]",
                                    children: displayName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 pb-4 pt-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overflow-hidden border border-white/10",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpCareerStatsRow.XpCareerStatsRow), {
                                        xp: xp,
                                        statIconClassName: (0, _xpCareerStatsRow.XP_STAT_ICON_CLASS),
                                        statValueClassName: (0, _xpCareerStatsRow.XP_STAT_VALUE_CLASS),
                                        onLeaderboardClick: openLeaderboardPage
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mt-4 py-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "mb-2 flex w-full items-center justify-between gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                    className: "shrink-0 font-anton text-[15px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-white [leading-trim:none]",
                                                    children: "XP history"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex shrink-0 items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "box-border flex h-[30px] w-[130px] shrink-0 border border-solid border-[#1B062F]",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                                                    value: historyPeriod,
                                                                    onChange: (e)=>setHistoryPeriod(e.target.value),
                                                                    className: "h-full min-w-0 flex-1 appearance-none rounded-none border-0 bg-white py-0 pl-2 pr-2 font-chakra text-[11px] font-normal normal-case leading-[16px] text-[#1B062F] [leading-trim:none]",
                                                                    "aria-label": "XP history period",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                            value: "week",
                                                                            children: "This week"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                                            value: "all",
                                                                            children: "All time"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "flex h-full w-[30px] shrink-0 items-center justify-center border-0 border-l border-solid border-[#1B062F] bg-white",
                                                                    "aria-hidden": true,
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: "/assets/chevron-down.svg",
                                                                        alt: "",
                                                                        className: "h-3 w-3 object-contain"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>setAboutOpen(true),
                                                            className: "inline-flex h-[30px] w-[60px] shrink-0 items-center justify-center rounded-none border-0 bg-white/15 p-0 text-center font-anton text-[12px] font-normal not-italic uppercase leading-[20px] tracking-[0%] text-white hover:bg-white/20 [leading-trim:none]",
                                                            children: "About XP"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "py-6 text-center font-chakra text-[12px] text-white/50",
                                            children: "Loading\u2026"
                                        }) : historyListItems.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "py-6 text-center font-chakra text-[12px] text-white/50",
                                            children: historyEmptyMessage
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                            className: "flex flex-col gap-1.5",
                                            children: historyListItems.map((item, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpHistoryListRow.XpHistoryListRow), {
                                                    item: item
                                                }, `${item.relative}-${item.detail}-${i}`))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpAboutModal.XpAboutModal), {
                isOpen: aboutOpen,
                onClose: ()=>setAboutOpen(false)
            })
        ]
    }), document.body);
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom":"b8T3j","react-router-dom":"l6ORY","framer-motion":"fI0Q4","../../Data/UserContext":"aqd8b","../../utils/authHeaders":"5Rczo","../../utils/sessionUser":"4xtMD","../../utils/profileCountryFlag":"23a1d","../../utils/xp":"jFgAi","../Profile/ProfileModalShell":"iXuvs","../../hooks/useCloseOnHistoryBack":"1Ha1d","../Profile/ProfileAvatar":"fwC7C","../ModalCloseIcon":"aricC","./XpCareerStatsRow":"jpDcU","./XpHistoryListRow":"57a79","./XpAboutModal":"1Ahe9","./xpModalNav":"dPzya","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"23a1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Map session `country` (ISO code or full name) to select value (always code). */ parcelHelpers.export(exports, "countryToSelectValue", ()=>countryToSelectValue);
/** Flag emoji for profile overlays when country is a known ISO code; otherwise "". */ parcelHelpers.export(exports, "getProfileCountryFlagEmoji", ()=>getProfileCountryFlagEmoji);
var _countries = require("../components/Account/Countries");
function countryToSelectValue(stored) {
    const t = stored?.trim() ?? "";
    if (!t) return "";
    if ((0, _countries.countriesList).some((c)=>c.code === t)) return t;
    const row = (0, _countries.countriesList).find((c)=>c.country.toLowerCase() === t.toLowerCase());
    return row?.code ?? t;
}
function getProfileCountryFlagEmoji(stored) {
    const code = countryToSelectValue(stored);
    if (!code || !(0, _countries.countriesList).some((c)=>c.code === code)) return "";
    return (0, _countries.countryCodeToFlagEmoji)(code);
}

},{"../components/Account/Countries":"307aP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iXuvs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Full-viewport overlay + scrollable panel. Used for every `/profile` view so users stay on context.
 * Wrap with Framer Motion `AnimatePresence` where the modal should animate out on close (e.g. global profile).
 */ parcelHelpers.export(exports, "ProfileModalShell", ()=>ProfileModalShell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _framerMotion = require("framer-motion");
var _overlayScrollLock = require("../../hooks/overlayScrollLock");
/** Exit-only fade — entering at opacity 0 reads as a blink on desktop. */ const fadeEase = [
    0.25,
    0.1,
    0.25,
    1
];
/** Above react-modal (10010/10011), header overlays (10020), and league sheets. */ const PROFILE_MODAL_Z_CLASS = "z-[10050]";
function ProfileModalShell({ children, onClose, zIndexClass = PROFILE_MODAL_Z_CLASS, overlayAriaLabel = "Close profile" }) {
    (0, _overlayScrollLock.useOverlayScrollLock)(true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
        className: `fixed inset-0 ${zIndexClass} flex items-start justify-center px-3 pb-3 pt-[max(0.5rem,env(safe-area-inset-top,0px))] sm:px-4 sm:pb-4 sm:pt-3`,
        role: "dialog",
        "aria-modal": "true",
        initial: false,
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.2,
            ease: fadeEase
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                "data-c8-overlay-dismiss": "true",
                className: "absolute inset-0 cursor-default border-0 bg-black/75 p-0",
                "aria-label": overlayAriaLabel,
                onClick: onClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "data-c8-overlay-scroll": true,
                className: "relative z-[1] flex h-[min(92dvh,820px,calc(100dvh-2rem))] w-full max-w-[440px] shrink-0 flex-col overflow-hidden rounded-none border border-white/10 bg-[#461D79] text-white shadow-2xl",
                onClick: (e)=>e.stopPropagation(),
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","framer-motion":"fI0Q4","../../hooks/overlayScrollLock":"jYfB4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpDcU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XP_STAT_BOX_BG", ()=>XP_STAT_BOX_BG);
parcelHelpers.export(exports, "XP_STAT_BOX_BG_PROFILE", ()=>XP_STAT_BOX_BG_PROFILE);
parcelHelpers.export(exports, "XP_STAT_BOX_GAP", ()=>XP_STAT_BOX_GAP);
parcelHelpers.export(exports, "XP_STAT_BOX_GAP_PROFILE", ()=>XP_STAT_BOX_GAP_PROFILE);
parcelHelpers.export(exports, "XP_STAT_BOX_HEIGHT", ()=>XP_STAT_BOX_HEIGHT);
parcelHelpers.export(exports, "XP_WEEKLY_FINISHES_BOX_HEIGHT_PROFILE", ()=>XP_WEEKLY_FINISHES_BOX_HEIGHT_PROFILE);
parcelHelpers.export(exports, "XP_BOX_INNER_PX", ()=>XP_BOX_INNER_PX);
parcelHelpers.export(exports, "XP_STAT_LABEL_CLASS_PROFILE", ()=>XP_STAT_LABEL_CLASS_PROFILE);
parcelHelpers.export(exports, "XP_STAT_LABEL_CLASS", ()=>XP_STAT_LABEL_CLASS);
parcelHelpers.export(exports, "XP_STAT_ICON_CLASS", ()=>XP_STAT_ICON_CLASS);
parcelHelpers.export(exports, "XP_STAT_VALUE_CLASS", ()=>XP_STAT_VALUE_CLASS);
parcelHelpers.export(exports, "XpCareerStatsRow", ()=>XpCareerStatsRow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _xpAmount = require("./XpAmount");
var _xp = require("../../utils/xp");
const XP_STAT_BOX_BG = "bg-[#652DAF]";
const XP_STAT_BOX_BG_PROFILE = "bg-[#1B062F4D]";
const XP_STAT_BOX_GAP = "gap-2";
const XP_STAT_BOX_GAP_PROFILE = "gap-[2px]";
const XP_STAT_BOX_HEIGHT = "h-[50px]";
const XP_WEEKLY_FINISHES_BOX_HEIGHT_PROFILE = "h-[70px]";
const XP_BOX_INNER_PX = "px-2";
const XP_STAT_LABEL_CLASS_PROFILE = "text-center font-anton text-[10px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-white/40 [leading-trim:none]";
const XP_STAT_LABEL_CLASS = "text-center font-anton text-[11px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-white/40 [leading-trim:none]";
const XP_STAT_ICON_CLASS = "h-[17px] w-[17px] shrink-0 object-contain";
const XP_STAT_VALUE_CLASS = "align-middle font-anton text-[15px] font-normal not-italic uppercase leading-[100%] tracking-[0%] text-white tabular-nums [leading-trim:none]";
function StatCell({ label, children, cornerAction, boxBgClassName, labelClassName }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `relative flex ${XP_STAT_BOX_HEIGHT} flex-col items-center justify-center ${XP_BOX_INNER_PX} py-1 text-center ${boxBgClassName}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: labelClassName,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-1 flex items-center justify-center",
                children: children
            }),
            cornerAction
        ]
    });
}
function XpCareerStatsRow({ xp, onLeaderboardClick, boxBgClassName = XP_STAT_BOX_BG, boxGapClassName = XP_STAT_BOX_GAP, statLabelClassName = XP_STAT_LABEL_CLASS, statIconClassName = XP_STAT_ICON_CLASS, statValueClassName = XP_STAT_VALUE_CLASS }) {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const summary = xp ?? {
        total_xp: 0,
        week_xp: 0,
        week_rank: null,
        weekly_finishes: {
            first: 0,
            second: 0,
            third: 0
        }
    };
    const openLeaderboard = ()=>{
        if (onLeaderboardClick) {
            onLeaderboardClick();
            return;
        }
        navigate("/xp-leaderboard");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `grid grid-cols-3 ${boxGapClassName} border-t border-white/5`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                label: "All time XP",
                boxBgClassName: boxBgClassName,
                labelClassName: statLabelClassName,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpAmount.XpAmount), {
                    value: summary.total_xp,
                    iconClassName: statIconClassName,
                    valueClassName: statValueClassName,
                    className: "inline-flex items-center gap-1"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                label: "XP This week",
                boxBgClassName: boxBgClassName,
                labelClassName: statLabelClassName,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpAmount.XpAmount), {
                    value: summary.week_xp,
                    iconClassName: statIconClassName,
                    valueClassName: statValueClassName,
                    className: "inline-flex items-center gap-1"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatCell, {
                label: "XP Weekly leaderboard",
                boxBgClassName: boxBgClassName,
                labelClassName: statLabelClassName,
                cornerAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    onClick: openLeaderboard,
                    className: "absolute bottom-1 right-1 flex h-5 w-5 items-center justify-center bg-[#D2FF00] hover:brightness-95",
                    "aria-label": "Open XP leaderboard",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: "/assets/arrow-right.svg",
                        alt: "",
                        className: "h-3 w-3 object-contain",
                        "aria-hidden": true
                    })
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: statValueClassName,
                    children: (0, _xp.formatXpRank)(summary.week_rank)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","./XpAmount":"4Z8ho","../../utils/xp":"jFgAi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Z8ho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** XP icon + formatted amount (shared header / profile / career stats). */ parcelHelpers.export(exports, "XpAmount", ()=>XpAmount);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _xp = require("../../utils/xp");
function XpAmount({ value, iconClassName = "h-4 w-4 shrink-0 object-contain", valueClassName = "font-anton text-[10px] font-normal leading-[100%] tracking-normal text-white [leading-trim:none]", className = "inline-flex items-center gap-1" }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _xp.XP_ICON_SRC),
                alt: "",
                className: iconClassName,
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `tabular-nums ${valueClassName}`,
                children: (0, _xp.formatXp)(value)
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../utils/xp":"jFgAi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"57a79":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XpHistoryListRow", ()=>XpHistoryListRow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _userAvatar = require("../Profile/UserAvatar");
var _xp = require("../../utils/xp");
/** History rows: no left padding so avatar aligns with box edge; right inset matches stat cells. */ const XP_HISTORY_ROW_PX = "pl-0 pr-2";
const YOU_LABEL_CLASS = "font-anton text-[9px] font-normal not-italic uppercase leading-[16px] tracking-[0%] text-white [leading-trim:none]";
const HISTORY_BODY_CLASS = "font-chakra text-[10px] font-normal not-italic leading-[16px] tracking-[0%] text-white [leading-trim:none]";
const HISTORY_TIME_CLASS = "font-chakra text-[10px] font-normal not-italic leading-[16px] tracking-[0%] text-white/45 [leading-trim:none]";
function XpHistoryListRow({ item }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
        className: `flex h-[30px] w-full items-center gap-2 bg-[#1B062F4D] ${XP_HISTORY_ROW_PX}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAvatar.UserAvatar), {
                src: item.iconSrc,
                displayName: item.displayName,
                avatarFrameUrl: item.avatarFrameUrl,
                avatarFrameSmallUrl: item.avatarFrameSmallUrl,
                size: "sm"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex min-h-0 min-w-0 flex-1 items-center gap-1.5 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: `shrink-0 ${YOU_LABEL_CLASS}`,
                        children: "YOU"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: `inline-flex min-w-0 items-center gap-1 truncate ${HISTORY_BODY_CLASS}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "truncate",
                                children: [
                                    "earned +",
                                    (0, _xp.formatXp)(item.amount),
                                    " XP"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _xp.XP_ICON_SRC),
                                alt: "",
                                className: "h-[17px] w-[17px] shrink-0 object-contain",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "truncate",
                                children: item.detail
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `flex shrink-0 items-center ${HISTORY_TIME_CLASS}`,
                children: item.relative
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Profile/UserAvatar":"e6kw2","../../utils/xp":"jFgAi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Ahe9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XpAboutModal", ()=>XpAboutModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _framerMotion = require("framer-motion");
var _profileModalShell = require("../Profile/ProfileModalShell");
var _useCloseOnHistoryBack = require("../../hooks/useCloseOnHistoryBack");
var _modalCloseIcon = require("../ModalCloseIcon");
var _xpRulesContent = require("./xpRulesContent");
var _xpModalNav = require("./xpModalNav");
function XpAboutModal({ isOpen, onClose }) {
    (0, _useCloseOnHistoryBack.useCloseOnHistoryBack)(isOpen, onClose);
    (0, _react.useEffect)(()=>{
        if (!isOpen) return undefined;
        const onKey = (e)=>{
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        isOpen,
        onClose
    ]);
    if (typeof document === "undefined") return null;
    return /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.AnimatePresence), {
        children: isOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileModalShell.ProfileModalShell), {
            onClose: onClose,
            zIndexClass: "z-[10030]",
            overlayAriaLabel: "Close About XP",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex min-h-0 flex-1 flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "shrink-0 border-b border-white/10 px-3 py-2 pt-1 sm:pt-1.5",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "grid shrink-0 grid-cols-[1fr_auto_1fr] items-center gap-x-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-start-1 flex min-w-0 items-start justify-self-start",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        type: "button",
                                        onClick: onClose,
                                        className: (0, _xpModalNav.XP_LIME_BACK_BUTTON_CLASS),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: (0, _xpModalNav.XP_BACK_ARROW_SRC),
                                                alt: "",
                                                className: (0, _xpModalNav.XP_BACK_ARROW_CLASS),
                                                "aria-hidden": true
                                            }),
                                            "XP HISTORY"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "col-start-2 flex min-w-0 items-center justify-center justify-self-center gap-1.5 px-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: "/assets/xp.webp",
                                            alt: "",
                                            className: "h-5 w-5 shrink-0 object-contain",
                                            "aria-hidden": true
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            id: "xp-about-title",
                                            className: "truncate font-anton text-[20px] font-normal uppercase leading-[26px] tracking-normal text-white [leading-trim:none]",
                                            children: "About XP"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-start-3 justify-self-end",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseButton), {
                                        onClick: onClose,
                                        ariaLabel: "Close About XP",
                                        className: "h-11 w-11 shrink-0 rounded-none hover:bg-white/10 hover:opacity-100"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 pb-4 pt-3",
                        "aria-labelledby": "xp-about-title",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xpRulesContent.XpRulesContent), {})
                    })
                ]
            })
        }) : null
    }), document.body);
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom":"b8T3j","framer-motion":"fI0Q4","../Profile/ProfileModalShell":"iXuvs","../../hooks/useCloseOnHistoryBack":"1Ha1d","../ModalCloseIcon":"aricC","./xpRulesContent":"hNwxE","./xpModalNav":"dPzya","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNwxE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Shared copy for About XP / rules surfaces. */ parcelHelpers.export(exports, "XpRulesContent", ()=>XpRulesContent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _xp = require("../../utils/xp");
function XpRulesContent() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-4 font-chakra text-[12px] font-normal normal-case leading-[18px] tracking-normal text-white/85",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "leading-[18px]",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "inline-flex items-baseline gap-1 align-baseline",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _xp.XP_ICON_SRC),
                                alt: "",
                                className: "h-[14px] w-[14px] shrink-0 object-contain",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                className: "font-anton text-[13px] font-normal uppercase leading-[18px] text-white [leading-trim:none]",
                                children: "XP"
                            })
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "inline leading-[18px]",
                        children: "lets you earn XP by playing our games, watching matches and interacting with your friends. Battle on the weekly leaderboard to earn bragging rights with your friends, and collect crown finishes on your profile."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "mb-1.5 font-anton text-[13px] font-normal uppercase leading-[16px] text-white",
                        children: "How you earn XP"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        className: "list-disc space-y-2 pl-5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        className: "text-white",
                                        children: "Daily habits"
                                    }),
                                    " \u2014 log in, spin the Wheel, and keep streaks going."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        className: "text-white",
                                        children: "Games"
                                    }),
                                    " \u2014 play Quickfire, Squares, Bullion, Sixes, and Trader."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        className: "text-white",
                                        children: "Profile & friends"
                                    }),
                                    " \u2014 complete your profile, add friends, and invite new players."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        className: "text-white",
                                        children: "Shop"
                                    }),
                                    " \u2014 unlock packs and get Rubies."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mt-2 text-[11px] text-white/55",
                        children: "Exact amounts appear in your XP history for each award."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "mb-1.5 font-anton text-[13px] font-normal uppercase leading-[16px] text-white",
                        children: "Weekly leaderboard"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                        className: "list-disc space-y-2 pl-5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    "Each week runs Monday 00:00 to Sunday 23:59 ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        className: "text-white",
                                        children: "IST"
                                    }),
                                    " (India time)."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        className: "text-white",
                                        children: "Week XP"
                                    }),
                                    " is the XP you earned during the current week only."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    "Finish in the top three when the week ends to earn a gold, silver, or bronze crown on your avatar and a finish count on your profile under ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                        className: "not-italic text-white/70",
                                        children: "Weekly XP leaderboard finishes"
                                    }),
                                    ". Tied ranks share the same crown (e.g. two players tied for 1st both wear gold the following week)."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                children: "Open the leaderboard from your profile or XP history to see rankings and time left in the week."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "mb-1.5 font-anton text-[13px] font-normal uppercase leading-[16px] text-white",
                        children: "All-time XP"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                className: "text-white",
                                children: "All-time XP"
                            }),
                            " is your lifetime total and never resets. Use the Week / All time toggle on the leaderboard to compare weekly competition with career totals."
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../utils/xp":"jFgAi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dPzya":[function(require,module,exports,__globalThis) {
/** Lime nav back control — PROFILE / XP HISTORY in XP modals. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XP_LIME_BACK_BUTTON_CLASS", ()=>XP_LIME_BACK_BUTTON_CLASS);
parcelHelpers.export(exports, "XP_BACK_ARROW_SRC", ()=>XP_BACK_ARROW_SRC);
parcelHelpers.export(exports, "XP_BACK_ARROW_CLASS", ()=>XP_BACK_ARROW_CLASS);
const XP_LIME_BACK_BUTTON_CLASS = "inline-flex h-[30px] min-h-[30px] max-h-[30px] shrink-0 items-center justify-center gap-1 rounded-none border-0 bg-[#D2FF00] px-2.5 text-center font-anton text-[12px] font-normal uppercase leading-[12px] tracking-normal text-black hover:brightness-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black/30 [leading-trim:none]";
const XP_BACK_ARROW_SRC = "/assets/arrow-left.svg";
const XP_BACK_ARROW_CLASS = "h-[20px] w-[20px] shrink-0 object-contain";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k4ekZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Career stat card top bar: game icon + name (left), coins value + coin icon (right). */ parcelHelpers.export(exports, "CareerStatCardHeader", ()=>CareerStatCardHeader);
parcelHelpers.export(exports, "CAREER_STAT_ICONS", ()=>CAREER_STAT_ICONS);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const COIN_SRC = "/assets/currency-coin.png";
/**
 * Single flex row with items-center so sign and digits share one vertical center.
 * Anton’s +/− sit low in the em box; translate up so they optically match the digits.
 */ function CoinsLabelWithSign({ label }) {
    const first = label[0];
    if (first === "+" || first === "-") return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "inline-flex items-center gap-px whitespace-nowrap text-right font-anton font-normal text-white [leading-trim:none]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "inline-block shrink-0 translate-y-[-0.14em] text-[18px] leading-none tracking-normal",
                children: first
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "inline-block min-w-0 text-[10px] leading-none tracking-normal tabular-nums",
                children: label.slice(1)
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "whitespace-nowrap text-right font-anton text-[10px] font-normal uppercase leading-[12px] tracking-normal tabular-nums text-white [leading-trim:none]",
        children: label
    });
}
function CareerStatCardHeader({ iconSrc, title, coinsLabel }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex min-h-[26px] items-center justify-between gap-3 bg-[#652DAF] px-2 py-0.5",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "flex min-w-0 flex-1 items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: iconSrc,
                        alt: "",
                        className: "h-4 w-4 shrink-0 object-contain",
                        loading: "lazy",
                        decoding: "async"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "min-w-0 truncate font-anton text-[12px] font-normal uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "flex shrink-0 items-center justify-end gap-1 text-right",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CoinsLabelWithSign, {
                        label: coinsLabel
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: COIN_SRC,
                        alt: "",
                        className: "h-3.5 w-3.5 shrink-0 object-contain",
                        "aria-hidden": true
                    })
                ]
            })
        ]
    });
}
const CAREER_STAT_ICONS = {
    spin: "/assets/spinner.png",
    trader: "/assets/trader.png",
    squares: "/assets/squares.png",
    bullion: "/assets/bullion.png",
    sixes: "/assets/sixes.png",
    leagues: "/assets/league-trophy.png",
    quickfire: "/assets/quickfire_square.png"
};

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"beKzR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Promotional strip when profile name/avatar editing is locked.
 * - `default`: compact row for My profile.
 * - `edit`: purple block with promo + lime “Profile unlock” CTA for Edit profile.
 */ parcelHelpers.export(exports, "ProfileUnlockBanner", ()=>ProfileUnlockBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const PREVIEW_SRC = "/assets/profile_unlock.png";
const PROFILE_UNLOCK_RUBY_COST = 1;
/** My profile (view) — compact strip; keep small so the bar stays light. */ const UNLOCK_PREVIEW_HEIGHT_DEFAULT_PX = 118;
const UNLOCK_PREVIEW_WIDTH_DEFAULT_PX = Math.round(320 * UNLOCK_PREVIEW_HEIGHT_DEFAULT_PX / 200);
/** Edit profile — larger hero-style preview (slightly smaller than max for balance). */ const UNLOCK_PREVIEW_HEIGHT_EDIT_PX = 200;
const UNLOCK_PREVIEW_WIDTH_EDIT_PX = Math.round(320 * UNLOCK_PREVIEW_HEIGHT_EDIT_PX / 200);
const UNLOCK_CTA_BORDER = "#00AEEF";
const unlockBannerPromoTypeClass = "font-anton text-[12px] font-normal uppercase leading-[15px] tracking-normal not-italic [leading-trim:none]";
const unlockBannerButtonTypeClass = "font-anton text-[12px] font-normal uppercase leading-none tracking-normal not-italic [leading-trim:none]";
function openShopDrawer() {
    if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent("openShopDrawer"));
}
/** Compact single-row strip for My profile (view mode). */ function ProfileUnlockBannerDefault() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: openShopDrawer,
        className: "relative z-[6] mb-0 w-full cursor-pointer overflow-visible border-0 bg-transparent px-0 pt-0 pb-[1.65rem] text-left transition-opacity hover:opacity-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40 sm:pb-[2.1rem]",
        "aria-label": "Open shop to unlock custom username and premium avatars",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "relative flex h-[42px] min-h-[42px] max-h-[42px] shrink-0 items-center gap-2 bg-[#583484] pl-3 pr-[min(38vw,9.5rem)] sm:h-auto sm:max-h-none sm:min-h-[42px] sm:py-1.5 sm:pr-[11.5rem] md:min-h-[44px] md:py-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "shrink-0 select-none text-[17px] leading-none drop-shadow-sm sm:text-[19px] md:text-[21px]",
                    "aria-hidden": true,
                    children: "\uD83D\uDD12"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "min-w-0 flex-1 font-anton text-[11px] font-normal uppercase leading-[13px] tracking-normal text-white [leading-trim:none] sm:text-[12px] sm:leading-[15px] md:text-[13px] md:leading-[17px]",
                    children: [
                        "Unlock ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-[#D2FF00]",
                            children: "custom username"
                        }),
                        " and",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-[#D2FF00]",
                            children: "premium avatars"
                        }),
                        "!"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: PREVIEW_SRC,
                    alt: "",
                    width: UNLOCK_PREVIEW_WIDTH_DEFAULT_PX,
                    height: UNLOCK_PREVIEW_HEIGHT_DEFAULT_PX,
                    className: "pointer-events-none absolute bottom-0 right-0 z-10 w-auto max-w-[min(48vw,9.25rem)] origin-bottom object-contain object-bottom drop-shadow-[0_6px_18px_rgba(0,0,0,0.35)] translate-x-2 translate-y-[20%] sm:right-0 sm:max-w-[10.5rem] sm:translate-x-3 sm:translate-y-[26%]",
                    style: {
                        height: UNLOCK_PREVIEW_HEIGHT_DEFAULT_PX
                    },
                    decoding: "async"
                })
            ]
        })
    });
}
/** Taller block with inline lime CTA — Edit profile only. */ function ProfileUnlockBannerEdit() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: openShopDrawer,
        className: "relative z-[6] mb-0 mt-2 w-full cursor-pointer overflow-visible border-0 bg-transparent px-0 pt-1 pb-[2.65rem] text-left transition-opacity hover:opacity-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40 sm:mt-3 sm:pb-[3.35rem]",
        "aria-label": "Open shop to unlock custom username and premium avatars",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "relative shrink-0 bg-[#583484] pl-3 pr-[min(38vw,9.5rem)] py-2 sm:pr-[11.5rem]",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "relative z-20 flex gap-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex min-w-0 flex-1 flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: `text-white ${unlockBannerPromoTypeClass}`,
                                children: [
                                    "Unlock ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-[#D2FF00]",
                                        children: "custom username"
                                    }),
                                    " and",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-[#D2FF00]",
                                        children: "premium avatars"
                                    }),
                                    "!"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "relative box-border flex h-[30px] min-h-[30px] max-h-[30px] w-[144px] min-w-[144px] max-w-[144px] shrink-0 items-center overflow-hidden border-2 bg-[#d2ff00]",
                                style: {
                                    borderColor: UNLOCK_CTA_BORDER
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "flex h-full shrink-0 items-center pl-1.5 text-[15px] leading-none sm:pl-2",
                                        "aria-hidden": true,
                                        children: "\uD83D\uDD13"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: `flex h-full min-w-0 flex-1 items-center justify-center px-1.5 text-center text-[#1b062f] ${unlockBannerButtonTypeClass}`,
                                        children: "Profile unlock"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "flex h-full shrink-0 items-center gap-0.5 pr-1.5 sm:pr-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "/assets/currency-ruby.png",
                                                alt: "",
                                                className: "h-3.5 w-3.5 object-contain sm:h-4 sm:w-4",
                                                width: 16,
                                                height: 16,
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `tabular-nums text-[#1b062f] ${unlockBannerButtonTypeClass}`,
                                                children: PROFILE_UNLOCK_RUBY_COST
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: PREVIEW_SRC,
                    alt: "",
                    width: UNLOCK_PREVIEW_WIDTH_EDIT_PX,
                    height: UNLOCK_PREVIEW_HEIGHT_EDIT_PX,
                    className: "pointer-events-none absolute bottom-0 right-0 z-10 w-auto max-w-[min(68vw,17rem)] origin-bottom object-contain object-bottom drop-shadow-[0_10px_28px_rgba(0,0,0,0.4)] translate-x-3 translate-y-[26%] sm:right-0 sm:max-w-[18.5rem] sm:translate-x-4 sm:translate-y-[31%]",
                    style: {
                        height: UNLOCK_PREVIEW_HEIGHT_EDIT_PX
                    },
                    decoding: "async"
                })
            ]
        })
    });
}
function ProfileUnlockBanner({ variant = "default" }) {
    return variant === "edit" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileUnlockBannerEdit, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileUnlockBannerDefault, {});
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Tl4s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AvatarChooserModal", ()=>AvatarChooserModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@iconify/react");
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _userContext = require("../../Data/UserContext");
var _authHeaders = require("../../utils/authHeaders");
var _sessionUser = require("../../utils/sessionUser");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _profileAvatarCatalog = require("../../utils/profileAvatarCatalog");
const AVATAR_MODAL_IMAGE_SIZES = "(max-width: 380px) 64px, (max-width: 640px) 72px, 80px";
const AVATAR_MODAL_CAROUSEL_VARS = {
    "--avatar-tile": "clamp(44px, 14vw, 80px)",
    "--avatar-gap": "8px",
    "--avatar-preview-tile": "clamp(72px, 22vw, 120px)"
};
const AVATAR_INITIAL_ACTIVE_SECTIONS = 2;
const AVATAR_SECTION_REVEAL_INTERVAL_MS = 180;
const FEATURE_UNLOCK_COST_RUBY = 1;
const FEATURE_UNLOCK_BONUS_COINS = 200;
const getAvatarThumbSrcSet = (avatar)=>{
    if (avatar?.thumb_srcset) return avatar.thumb_srcset;
    const entries = Object.entries(avatar?.thumb_urls || {}).map(([size, url])=>[
            Number.parseInt(size, 10),
            url
        ]).filter(([size, url])=>Number.isFinite(size) && size > 0 && Boolean(url)).sort((a, b)=>a[0] - b[0]);
    const items = entries.map(([size, url])=>`${url} ${size}w`);
    return items.length > 0 ? items.join(", ") : undefined;
};
const AVATAR_KEY_ANIMAL_SLUGS = new Set([
    "croc",
    "giraffe",
    "owl",
    "shark",
    "elephant",
    "monkey",
    "rhino",
    "tiger"
]);
const getAvatarColorSortKey = (avatarKey)=>{
    const k = String(avatarKey || "");
    const parts = k.split("-");
    if (parts.length < 2) return k;
    const slug = parts[0];
    if (!AVATAR_KEY_ANIMAL_SLUGS.has(slug)) return k;
    return parts.slice(1).join("-");
};
const FRAME_CURRENCY_ICON = {
    CR8_RBY: "/assets/currency-ruby.png",
    COINS: "/assets/currency-coin.png"
};
const FRAME_CURRENCY_NAME = {
    CR8_RBY: "rubies",
    COINS: "coins"
};
function parseFrameState(data) {
    const d = data;
    if (!d || !Array.isArray(d.frames)) return null;
    return {
        frames: d.frames,
        shopFrames: Array.isArray(d.shopFrames) ? d.shopFrames : [],
        activeFrameId: d.activeFrameId != null ? Number(d.activeFrameId) : null
    };
}
function AvatarChooserModal({ isOpen, onRequestClose, avatarOptions, onAfterSaveSuccess, initialSelectedKey }) {
    const { user, setUser } = (0, _userContext.useUser)();
    const [selectedAvatarKey, setSelectedAvatarKey] = (0, _react.useState)(null);
    const [avatarSaving, setAvatarSaving] = (0, _react.useState)(false);
    const [avatarFeedback, setAvatarFeedback] = (0, _react.useState)("");
    const [avatarFeedbackError, setAvatarFeedbackError] = (0, _react.useState)(false);
    const prefetchedAvatarUrlsRef = (0, _react.useRef)(new Set());
    const [loadedAvatarThumbKeys, setLoadedAvatarThumbKeys] = (0, _react.useState)(()=>new Set());
    const [activeAvatarSectionCount, setActiveAvatarSectionCount] = (0, _react.useState)(AVATAR_INITIAL_ACTIVE_SECTIONS);
    const [openAvatarSections, setOpenAvatarSections] = (0, _react.useState)({});
    const [isProfilePreviewModalOpen, setIsProfilePreviewModalOpen] = (0, _react.useState)(false);
    const [profilePreviewImageUrl, setProfilePreviewImageUrl] = (0, _react.useState)("");
    const [frameState, setFrameState] = (0, _react.useState)(null);
    const [pickedFrame, setPickedFrame] = (0, _react.useState)(null);
    const prefetchAvatarUrls = (0, _react.useCallback)((urls = [])=>{
        for (const url of urls){
            if (!url || prefetchedAvatarUrlsRef.current.has(url)) continue;
            prefetchedAvatarUrlsRef.current.add(url);
            const img = new Image();
            img.decoding = "async";
            img.src = url;
        }
    }, []);
    const avatarSections = (0, _react.useMemo)(()=>{
        const order = [
            "giraffe",
            "crocodile",
            "rhino",
            "tiger",
            "monkey",
            "owl",
            "shark",
            "elephant"
        ];
        const grouped = avatarOptions.reduce((acc, option)=>{
            const animal = option?.animal || "other";
            if (!acc[animal]) acc[animal] = [];
            acc[animal].push(option);
            return acc;
        }, {});
        return order.filter((animal)=>Array.isArray(grouped[animal]) && grouped[animal].length > 0).map((animal)=>({
                animal,
                items: grouped[animal].slice().sort((a, b)=>{
                    const ca = getAvatarColorSortKey(a.key);
                    const cb = getAvatarColorSortKey(b.key);
                    const byColor = ca.localeCompare(cb, undefined, {
                        sensitivity: "base"
                    });
                    if (byColor !== 0) return byColor;
                    return String(a.key).localeCompare(String(b.key));
                })
            }));
    }, [
        avatarOptions
    ]);
    const hasOriginalPhoto = Boolean(user?.original_avatar && String(user.original_avatar).trim() !== "");
    const selectedAvatarPreviewUrl = (0, _react.useMemo)(()=>{
        if (selectedAvatarKey == null) return hasOriginalPhoto ? user?.original_avatar ?? null : null;
        const selected = avatarOptions.find((option)=>option.key === selectedAvatarKey);
        return (0, _profileAvatarCatalog.getAvatarThumbSrc)(selected);
    }, [
        selectedAvatarKey,
        hasOriginalPhoto,
        user?.original_avatar,
        avatarOptions
    ]);
    const selectedAvatarFullUrl = (0, _react.useMemo)(()=>{
        if (selectedAvatarKey == null) return hasOriginalPhoto ? user?.original_avatar ?? null : null;
        const selected = avatarOptions.find((option)=>option.key === selectedAvatarKey);
        return selected?.url || selected?.thumb_url || null;
    }, [
        selectedAvatarKey,
        hasOriginalPhoto,
        user?.original_avatar,
        avatarOptions
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen) return;
        let next = null;
        if (user?.avatar_key != null && String(user.avatar_key).trim() !== "") next = String(user.avatar_key).trim();
        if (initialSelectedKey !== undefined) next = initialSelectedKey;
        setSelectedAvatarKey(next);
        setLoadedAvatarThumbKeys(new Set());
        setActiveAvatarSectionCount(AVATAR_INITIAL_ACTIVE_SECTIONS);
        setAvatarFeedback("");
        setAvatarFeedbackError(false);
        const urls = avatarOptions.map((a)=>(0, _profileAvatarCatalog.getAvatarThumbSrc)(a)).filter(Boolean);
        prefetchAvatarUrls(urls.slice(0, 28));
        prefetchAvatarUrls(urls.slice(0, 56));
    }, [
        isOpen,
        user?.avatar_key,
        initialSelectedKey,
        avatarOptions,
        prefetchAvatarUrls
    ]);
    (0, _react.useEffect)(()=>{
        setOpenAvatarSections((prev)=>{
            const next = {
                ...prev
            };
            for (const section of avatarSections)if (next[section.animal] == null) next[section.animal] = true;
            return next;
        });
    }, [
        avatarSections
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen) return;
        prefetchAvatarUrls([
            selectedAvatarFullUrl,
            selectedAvatarPreviewUrl,
            user?.original_avatar
        ].filter(Boolean));
        const visibleSectionUrls = avatarSections.slice(0, activeAvatarSectionCount).flatMap((section)=>section.items.map((a)=>(0, _profileAvatarCatalog.getAvatarThumbSrc)(a))).filter(Boolean);
        const warmRemaining = ()=>prefetchAvatarUrls(visibleSectionUrls);
        if (typeof window !== "undefined" && "requestIdleCallback" in window) {
            const id = window.requestIdleCallback(warmRemaining, {
                timeout: 1200
            });
            return ()=>window.cancelIdleCallback(id);
        }
        const t = setTimeout(warmRemaining, 124);
        return ()=>clearTimeout(t);
    }, [
        isOpen,
        avatarSections,
        activeAvatarSectionCount,
        selectedAvatarFullUrl,
        selectedAvatarPreviewUrl,
        user?.original_avatar,
        prefetchAvatarUrls
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen) return undefined;
        if (activeAvatarSectionCount >= avatarSections.length) return undefined;
        const id = setInterval(()=>{
            setActiveAvatarSectionCount((prev)=>{
                if (prev >= avatarSections.length) return prev;
                return prev + 1;
            });
        }, AVATAR_SECTION_REVEAL_INTERVAL_MS);
        return ()=>clearInterval(id);
    }, [
        isOpen,
        activeAvatarSectionCount,
        avatarSections.length
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen) return undefined;
        let cancelled = false;
        setPickedFrame(null);
        fetch(`${"https://cricket8.com/api"}/account/avatar-frames`, {
            headers: (0, _authHeaders.getAuthHeaders)()
        }).then((res)=>res.ok ? res.json() : null).then((data)=>{
            const next = parseFrameState(data);
            if (!cancelled && next) setFrameState(next);
        }).catch(()=>{});
        return ()=>{
            cancelled = true;
        };
    }, [
        isOpen
    ]);
    const savedFrame = frameState?.activeFrameId ?? "none";
    const selectedFrame = pickedFrame ?? savedFrame;
    const selectedShopFrame = selectedFrame === "none" ? null : frameState?.shopFrames.find((f)=>f.id === selectedFrame) ?? null;
    const frameChanged = Boolean(frameState) && selectedFrame !== savedFrame && !selectedShopFrame;
    const selectedFrameUrl = selectedFrame === "none" ? null : (selectedShopFrame ?? frameState?.frames.find((f)=>f.id === selectedFrame))?.imageUrl ?? null;
    const hasFrameOptions = Boolean(frameState && (frameState.frames.length > 0 || frameState.shopFrames.length > 0));
    const framePreviewAvatarUrl = selectedAvatarFullUrl || selectedAvatarPreviewUrl || user?.avatar || "";
    const allowEdit = user?.allow_player_name_edit === true;
    const refreshSessionUser = async ()=>{
        const verifyUrl = (0, _authHeaders.getVerifySessionUrl)();
        if (!verifyUrl || !setUser) return;
        try {
            const userResponse = await fetch(verifyUrl, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            if (userResponse.status === 200) setUser((0, _sessionUser.normalizeSessionPayload)(await userResponse.json()));
        } catch (e) {}
    };
    /** @returns error message, or null when saved / nothing to save. */ const saveFrameChoice = async ()=>{
        if (!frameChanged) return null;
        const response = await fetch(`${"https://cricket8.com/api"}/account/avatar-frame`, {
            method: "POST",
            headers: (0, _authHeaders.getAuthHeaders)(),
            body: JSON.stringify({
                choice: selectedFrame
            })
        });
        if (response.ok) return null;
        const data = await response.json().catch(()=>({}));
        return data?.message || "Could not update frame.";
    };
    const handleSaveFrameOnly = async ()=>{
        setAvatarSaving(true);
        setAvatarFeedback("");
        setAvatarFeedbackError(false);
        try {
            const frameError = await saveFrameChoice();
            if (frameError) {
                setAvatarFeedback(frameError);
                setAvatarFeedbackError(true);
                return;
            }
            await refreshSessionUser();
            await onAfterSaveSuccess?.();
            onRequestClose();
        } catch  {
            setAvatarFeedback("Something went wrong. Please try again.");
            setAvatarFeedbackError(true);
        } finally{
            setAvatarSaving(false);
        }
    };
    const handleBuyFrame = async ()=>{
        if (!selectedShopFrame) return;
        setAvatarSaving(true);
        setAvatarFeedback("");
        setAvatarFeedbackError(false);
        try {
            const response = await fetch(`${"https://cricket8.com/api"}/account/avatar-frames/${selectedShopFrame.id}/buy`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            const data = await response.json().catch(()=>({}));
            if (!response.ok) {
                setAvatarFeedback(data?.message || "Could not buy this frame.");
                setAvatarFeedbackError(true);
                return;
            }
            const next = parseFrameState(data);
            if (next) setFrameState(next);
            setPickedFrame(null);
            window.dispatchEvent(new CustomEvent("walletUpdate"));
            await refreshSessionUser();
            await onAfterSaveSuccess?.();
            setAvatarFeedback(`${selectedShopFrame.name} is yours and now on your avatar.`);
        } catch  {
            setAvatarFeedback("Something went wrong. Please try again.");
            setAvatarFeedbackError(true);
        } finally{
            setAvatarSaving(false);
        }
    };
    const handleSaveAvatar = async ()=>{
        if (!allowEdit) {
            setAvatarFeedback(`Unlock feature pack to change avatar (${FEATURE_UNLOCK_COST_RUBY} ruby + ${FEATURE_UNLOCK_BONUS_COINS} coins).`);
            setAvatarFeedbackError(true);
            return;
        }
        setAvatarSaving(true);
        setAvatarFeedback("");
        setAvatarFeedbackError(false);
        try {
            const response = await fetch(`${"https://cricket8.com/api"}/account/update-avatar`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    avatar_key: selectedAvatarKey
                })
            });
            const data = await response.json().catch(()=>({}));
            if (response.ok) {
                setAvatarFeedback("Avatar updated.");
                setAvatarFeedbackError(false);
                const avatarId = data?.avatar_key != null && String(data.avatar_key).trim() !== "" ? String(data.avatar_key).trim() : null;
                if (avatarId && user?.userId != null && user.userId !== "") (0, _frontendTrackingEvents.trackAvatarSelected)({
                    user_id: user.userId,
                    avatar_id: avatarId
                });
                const frameError = await saveFrameChoice();
                await refreshSessionUser();
                if (frameError) {
                    setAvatarFeedback(`Avatar updated, but the frame was not saved: ${frameError}`);
                    setAvatarFeedbackError(true);
                    return;
                }
                await onAfterSaveSuccess?.();
                onRequestClose();
            } else {
                setAvatarFeedback(data?.message || "Could not update avatar.");
                setAvatarFeedbackError(true);
            }
        } catch  {
            setAvatarFeedback("Something went wrong. Please try again.");
            setAvatarFeedbackError(true);
        } finally{
            setAvatarSaving(false);
        }
    };
    const openShopDrawer = ()=>{
        if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent("openShopDrawer"));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                isOpen: isProfilePreviewModalOpen,
                onRequestClose: ()=>setIsProfilePreviewModalOpen(false),
                style: {
                    overlay: {
                        zIndex: 4000
                    },
                    content: {
                        zIndex: 4001,
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -50%)",
                        width: "min(94vw, 520px)",
                        background: "#1b062f",
                        color: "#fff",
                        border: "1px solid rgba(255,255,255,0.1)",
                        padding: "16px",
                        textAlign: "center"
                    }
                },
                contentLabel: "Profile picture preview",
                ariaHideApp: false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: profilePreviewImageUrl || user?.avatar || "",
                    className: "mx-auto h-auto w-full max-w-[min(88vw,440px)] border border-white/15 object-contain",
                    alt: "Profile picture preview"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                isOpen: isOpen,
                onRequestClose: onRequestClose,
                overlayClassName: "avatar-modal-choose-overlay",
                className: "avatar-modal-choose box-border outline-none hide-scrollbar min-h-0 max-h-full w-full max-w-full overflow-x-hidden overflow-y-auto",
                style: {
                    overlay: {
                        display: "flex",
                        alignItems: "stretch",
                        justifyContent: "stretch",
                        padding: 0,
                        overflow: "hidden",
                        touchAction: "auto"
                    },
                    content: {
                        position: "relative",
                        top: "auto",
                        left: "auto",
                        right: "auto",
                        bottom: "auto",
                        margin: "0",
                        transform: "none",
                        flex: "1 1 auto",
                        alignSelf: "stretch",
                        width: "100%",
                        maxWidth: "100%",
                        height: "100dvh",
                        maxHeight: "100dvh",
                        minHeight: "100dvh",
                        background: "#1b062f",
                        color: "#fff",
                        border: "none",
                        padding: "0",
                        boxSizing: "border-box"
                    }
                },
                contentLabel: "Choose Avatar",
                ariaHideApp: false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "avatar-modal-choose-body flex h-full min-h-0 max-h-full w-full min-w-0 max-w-full flex-1 flex-col overflow-x-hidden overflow-y-hidden bg-[radial-gradient(circle_at_top,rgba(210,255,0,0.12),rgba(27,6,47,0.92)_32%,rgba(27,6,47,1)_62%)] pt-[max(12px,env(safe-area-inset-top,0px))] pr-[max(12px,env(safe-area-inset-right,0px))] pb-[max(12px,env(safe-area-inset-bottom,0px))] pl-[max(12px,env(safe-area-inset-left,0px))] max-[380px]:pt-[max(8px,env(safe-area-inset-top,0px))] max-[380px]:pr-[max(8px,env(safe-area-inset-right,0px))] max-[380px]:pb-[max(8px,env(safe-area-inset-bottom,0px))] max-[380px]:pl-[max(8px,env(safe-area-inset-left,0px))] sm:pt-[max(16px,env(safe-area-inset-top,0px))] sm:pr-[max(16px,env(safe-area-inset-right,0px))] sm:pb-[max(16px,env(safe-area-inset-bottom,0px))] sm:pl-[max(16px,env(safe-area-inset-left,0px))]",
                    style: AVATAR_MODAL_CAROUSEL_VARS,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-2 shrink-0 border border-white/10 bg-[#27183f]/85 px-3 py-2 shadow-[0_8px_22px_rgba(0,0,0,0.38)] sm:mb-[12px] sm:px-4 sm:py-2.5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "font-anton text-[16px] leading-[1.2] text-white sm:text-[18px]",
                                    children: "Choose Avatar"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mt-0.5 font-chakra text-[11px] text-white/70 normal-case sm:text-[12px]",
                                    children: "Pick a style that matches your vibe."
                                })
                            ]
                        }),
                        hasOriginalPhoto && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-2 shrink-0 border border-white/10 bg-white/[0.04] px-2 py-2 sm:mb-[10px] sm:px-2.5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mb-[6px] font-chakra text-[10px] text-white/80 normal-case",
                                    children: "Use original photo"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: `inline-flex aspect-square h-[30px] w-[30px] min-w-0 shrink-0 items-center justify-center overflow-hidden rounded-none border-2 p-0 leading-none transition-all duration-150 ${selectedAvatarKey == null ? "border-[#d2ff00] shadow-[0_0_0_1px_rgba(210,255,0,0.22)]" : "border-white/20 hover:border-white/45"}`,
                                    onClick: ()=>setSelectedAvatarKey(null),
                                    "aria-label": "Use original profile photo",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: user?.original_avatar || "",
                                        className: "block h-[30px] w-[30px] object-cover",
                                        alt: "Original avatar",
                                        decoding: "async"
                                    })
                                })
                            ]
                        }),
                        frameState && hasFrameOptions ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-2 shrink-0 border border-[#d2ff00]/30 bg-[#2a1f43]/80 px-2 pb-2 pt-1.5 sm:mb-[12px] sm:px-2.5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-[6px] flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "h-[1px] flex-1 bg-white/20"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-anton text-[11px] uppercase tracking-[1.3px] text-[#d2ff00]",
                                            children: "Frame"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "h-[1px] flex-1 bg-white/20"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "hide-scrollbar flex flex-row flex-nowrap gap-[var(--avatar-gap)] overflow-x-auto py-[1px]",
                                    children: [
                                        {
                                            value: "none",
                                            label: "No frame",
                                            src: null,
                                            price: null
                                        }
                                    ].concat(frameState.frames.map((f)=>({
                                            value: f.id,
                                            label: f.name,
                                            src: f.imageUrl,
                                            price: null
                                        }))).concat(frameState.shopFrames.map((f)=>({
                                            value: f.id,
                                            label: f.name,
                                            src: f.imageUrl,
                                            price: f
                                        }))).map((option)=>{
                                        const active = selectedFrame === option.value;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            type: "button",
                                            className: "flex shrink-0 flex-col items-center gap-1 bg-transparent p-0",
                                            onClick: ()=>setPickedFrame(option.value),
                                            "aria-pressed": active,
                                            "aria-label": option.price?.priceAmount != null && option.price.priceCurrency ? `${option.label} frame, ${option.price.priceAmount} ${FRAME_CURRENCY_NAME[option.price.priceCurrency]}` : option.src ? `${option.label} frame` : "No frame",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: `relative block overflow-hidden border-2 bg-[#2a2342] transition-all duration-150 ${active ? "border-[#d2ff00] shadow-[0_0_0_1px_rgba(210,255,0,0.28),0_6px_16px_rgba(0,0,0,0.35)]" : "border-transparent hover:border-white/30"}`,
                                                    style: {
                                                        width: "var(--avatar-tile)",
                                                        height: "var(--avatar-tile)"
                                                    },
                                                    children: [
                                                        framePreviewAvatarUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: framePreviewAvatarUrl,
                                                            alt: "",
                                                            className: "block h-full w-full object-cover",
                                                            decoding: "async"
                                                        }) : null,
                                                        option.src ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: option.src,
                                                            alt: "",
                                                            className: "pointer-events-none absolute inset-0 block h-full w-full",
                                                            decoding: "async"
                                                        }) : null,
                                                        option.price?.priceAmount != null && option.price.priceCurrency ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "absolute bottom-0 right-0 flex items-center gap-0.5 bg-[#1b062f]/90 px-1 py-[1px] font-anton text-[10px] leading-none text-white",
                                                            children: [
                                                                option.price.priceAmount.toLocaleString(),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: FRAME_CURRENCY_ICON[option.price.priceCurrency],
                                                                    alt: "",
                                                                    className: "h-3 w-3 object-contain",
                                                                    "aria-hidden": true
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: `max-w-[var(--avatar-tile)] truncate font-chakra text-[10px] normal-case ${active ? "text-[#d2ff00]" : "text-white/70"}`,
                                                    children: option.label
                                                })
                                            ]
                                        }, String(option.value));
                                    })
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "min-h-0 flex-1 overflow-y-auto overflow-x-hidden hide-scrollbar pr-[2px] pt-0 max-[380px]:pr-1",
                            children: avatarSections.map((section, sectionIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-2 border border-white/10 bg-[#2a1f43]/70 px-2 pb-2 pt-0 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] last:mb-0 sm:mb-[12px] max-[380px]:px-1.5 max-[380px]:pb-1.5 max-[380px]:pt-0",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            type: "button",
                                            className: "mb-[8px] flex w-full items-center gap-2",
                                            onClick: ()=>setOpenAvatarSections((prev)=>({
                                                        ...prev,
                                                        [section.animal]: prev[section.animal] === false
                                                    })),
                                            "aria-label": `Toggle ${section.animal} avatars`,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "h-[1px] flex-1 bg-white/20"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-anton text-[11px] uppercase tracking-[1.3px] text-[#d2ff00]",
                                                    children: section.animal
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "h-[1px] flex-1 bg-white/20"
                                                })
                                            ]
                                        }),
                                        openAvatarSections[section.animal] !== false && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "relative mt-[4px]",
                                            children: [
                                                (sectionIndex >= activeAvatarSectionCount || section.items.every((avatar)=>!loadedAvatarThumbKeys.has(avatar.key))) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "pointer-events-none absolute inset-0 z-10 flex items-center gap-[var(--avatar-gap)] overflow-hidden",
                                                    "aria-hidden": true,
                                                    children: section.items.map((avatar)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "relative aspect-square shrink-0 overflow-hidden border border-white/10 bg-[#231a38] shadow-[inset_0_1px_0_rgba(255,255,255,0.05)]",
                                                            style: {
                                                                width: "var(--avatar-tile)",
                                                                height: "var(--avatar-tile)"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "absolute inset-[20%] bg-white/8"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "absolute inset-0 animate-pulse bg-gradient-to-r from-transparent via-white/12 to-transparent"
                                                                })
                                                            ]
                                                        }, `skeleton-${avatar.key}`))
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex w-full min-w-0 justify-center overflow-hidden",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "avatar-carousel-viewport hide-scrollbar max-w-full shrink-0 touch-pan-x snap-x snap-mandatory overflow-x-auto overflow-y-hidden",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flex w-max flex-row flex-nowrap items-center gap-[var(--avatar-gap)] py-[1px]",
                                                            style: {
                                                                minHeight: "var(--avatar-tile)"
                                                            },
                                                            children: section.items.map((avatar)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    type: "button",
                                                                    className: `flex aspect-square shrink-0 snap-start items-center justify-center overflow-hidden rounded-none border-2 bg-[#2a2342] p-0 transition-all duration-150 hover:-translate-y-[1px] hover:scale-[1.02] ${selectedAvatarKey === avatar.key ? "border-[#d2ff00] shadow-[0_0_0_1px_rgba(210,255,0,0.28),0_6px_16px_rgba(0,0,0,0.35)]" : "border-transparent hover:border-white/30"}`,
                                                                    onClick: ()=>setSelectedAvatarKey(avatar.key),
                                                                    "aria-label": `${avatar.animal} avatar`,
                                                                    disabled: sectionIndex >= activeAvatarSectionCount,
                                                                    style: {
                                                                        width: "var(--avatar-tile)",
                                                                        height: "var(--avatar-tile)"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: sectionIndex < activeAvatarSectionCount ? (0, _profileAvatarCatalog.getAvatarThumbSrc)(avatar) : undefined,
                                                                        srcSet: sectionIndex < activeAvatarSectionCount ? getAvatarThumbSrcSet(avatar) : undefined,
                                                                        sizes: AVATAR_MODAL_IMAGE_SIZES,
                                                                        className: `block h-full w-full object-cover transition-opacity duration-150 ${sectionIndex < activeAvatarSectionCount && loadedAvatarThumbKeys.has(avatar.key) ? "opacity-100" : "opacity-70"}`,
                                                                        alt: `${avatar.animal} avatar`,
                                                                        loading: "lazy",
                                                                        fetchpriority: "low",
                                                                        decoding: "async",
                                                                        onLoad: ()=>{
                                                                            setLoadedAvatarThumbKeys((prev)=>{
                                                                                if (prev.has(avatar.key)) return prev;
                                                                                const next = new Set(prev);
                                                                                next.add(avatar.key);
                                                                                return next;
                                                                            });
                                                                        },
                                                                        onError: ()=>{
                                                                            setLoadedAvatarThumbKeys((prev)=>{
                                                                                if (prev.has(avatar.key)) return prev;
                                                                                const next = new Set(prev);
                                                                                next.add(avatar.key);
                                                                                return next;
                                                                            });
                                                                        }
                                                                    })
                                                                }, avatar.key))
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, section.animal))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mt-3 flex shrink-0 flex-row flex-nowrap items-center justify-between gap-2 border border-white/10 bg-[#241538]/90 px-2.5 py-2.5 shadow-[0_-8px_24px_rgba(0,0,0,0.3)] sm:mt-[14px] sm:gap-3 sm:px-3 sm:py-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex shrink-0 items-center justify-start",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: `relative flex aspect-square shrink-0 items-center justify-center overflow-hidden rounded-none border border-white/30 bg-[#2a2342] p-0 transition-colors duration-150 ${allowEdit ? "hover:border-white/50" : "cursor-not-allowed"}`,
                                                style: {
                                                    width: "var(--avatar-preview-tile)",
                                                    height: "var(--avatar-preview-tile)"
                                                },
                                                onClick: ()=>{
                                                    if (!allowEdit) return;
                                                    if (!selectedAvatarFullUrl) return;
                                                    setProfilePreviewImageUrl(selectedAvatarFullUrl);
                                                    setIsProfilePreviewModalOpen(true);
                                                },
                                                "aria-label": allowEdit ? "Open selected avatar preview" : "Avatar preview locked",
                                                disabled: !allowEdit,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "absolute inset-0 overflow-hidden",
                                                    children: [
                                                        selectedAvatarPreviewUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: selectedAvatarFullUrl || selectedAvatarPreviewUrl,
                                                            className: `absolute inset-0 m-0 block h-full w-full max-w-none object-cover p-0 ${!allowEdit ? "opacity-60" : ""}`,
                                                            alt: "Selected avatar preview",
                                                            loading: "lazy",
                                                            decoding: "async"
                                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "flex h-full w-full items-center justify-center font-chakra text-xs text-white/60",
                                                            children: "none"
                                                        }),
                                                        selectedFrameUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: selectedFrameUrl,
                                                            alt: "",
                                                            className: "pointer-events-none absolute inset-0 m-0 block h-full w-full max-w-none p-0",
                                                            decoding: "async",
                                                            "aria-hidden": true
                                                        }) : null
                                                    ]
                                                })
                                            }),
                                            !allowEdit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "pointer-events-none absolute inset-0 flex items-center justify-center",
                                                "aria-hidden": true,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Icon), {
                                                    icon: "mdi:lock",
                                                    className: "h-7 w-7 text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)] sm:h-8 sm:w-8"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex min-w-0 flex-1 flex-row flex-nowrap items-center justify-end gap-1.5 sm:gap-3",
                                    children: [
                                        allowEdit ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "shrink-0 rounded-none bg-[#d2ff00] px-3 py-2 font-anton text-[12px] tracking-[0.3px] text-[#1b062f] shadow-[0_3px_10px_rgba(210,255,0,0.3)] disabled:cursor-not-allowed disabled:opacity-60 sm:px-3.5 sm:py-2.5 sm:text-[14px] md:p-[10px] md:text-[16px]",
                                            onClick: ()=>void handleSaveAvatar(),
                                            disabled: avatarSaving,
                                            children: avatarSaving ? "Saving..." : "Save Avatar"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            type: "button",
                                            className: "inline-flex shrink-0 items-center justify-center gap-1 rounded-none bg-[#d2ff00] px-3 py-2 font-anton text-[11px] tracking-[0.3px] text-[#1b062f] shadow-[0_3px_10px_rgba(210,255,0,0.3)] disabled:cursor-not-allowed disabled:opacity-60 sm:gap-1.5 sm:px-3 sm:py-2.5 sm:text-[13px] md:p-[10px] md:text-[16px]",
                                            onClick: openShopDrawer,
                                            children: [
                                                "Unlock for ",
                                                FEATURE_UNLOCK_COST_RUBY,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/assets/currency-ruby.png",
                                                    alt: "",
                                                    className: "inline-block h-4 w-4 object-contain",
                                                    "aria-hidden": true
                                                })
                                            ]
                                        }),
                                        selectedShopFrame?.priceAmount != null && selectedShopFrame.priceCurrency ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "inline-flex shrink-0 items-center justify-center gap-1 rounded-none bg-[#d2ff00] px-3 py-2 font-anton text-[12px] tracking-[0.3px] text-[#1b062f] shadow-[0_3px_10px_rgba(210,255,0,0.3)] disabled:cursor-not-allowed disabled:opacity-60 sm:px-3.5 sm:py-2.5 sm:text-[14px] md:p-[10px] md:text-[16px]",
                                            onClick: ()=>void handleBuyFrame(),
                                            disabled: avatarSaving,
                                            children: avatarSaving ? "Buying..." : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    "Buy frame for",
                                                    " ",
                                                    selectedShopFrame.priceAmount.toLocaleString(),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: FRAME_CURRENCY_ICON[selectedShopFrame.priceCurrency],
                                                        alt: "",
                                                        className: "inline-block h-4 w-4 object-contain",
                                                        "aria-hidden": true
                                                    })
                                                ]
                                            })
                                        }) : null,
                                        !allowEdit && frameChanged ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "shrink-0 rounded-none bg-[#d2ff00] px-3 py-2 font-anton text-[12px] tracking-[0.3px] text-[#1b062f] shadow-[0_3px_10px_rgba(210,255,0,0.3)] disabled:cursor-not-allowed disabled:opacity-60 sm:px-3.5 sm:py-2.5 sm:text-[14px] md:p-[10px] md:text-[16px]",
                                            onClick: ()=>void handleSaveFrameOnly(),
                                            disabled: avatarSaving,
                                            children: avatarSaving ? "Saving..." : "Save Frame"
                                        }) : null,
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "shrink-0 rounded-none border border-white/20 bg-[#3a2952] px-3 py-2 font-anton text-[12px] text-white transition-colors duration-150 hover:border-white/40 sm:px-3 sm:py-2.5 sm:text-[14px] md:p-[10px] md:text-[16px]",
                                            onClick: onRequestClose,
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        }),
                        avatarFeedback ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: `mt-2 shrink-0 px-2 text-center font-chakra text-[11px] normal-case sm:text-[12px] ${avatarFeedbackError ? "text-[#f87171]" : "text-[#32F78D]"}`,
                            children: avatarFeedback
                        }) : null
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@iconify/react":"sspkD","../Modal":"2Ei4y","../../Data/UserContext":"aqd8b","../../utils/authHeaders":"5Rczo","../../utils/sessionUser":"4xtMD","../../utils/frontendTrackingEvents":"4Y90p","../../utils/profileAvatarCatalog":"i8TvT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sspkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icon", ()=>Icon);
parcelHelpers.export(exports, "InlineIcon", ()=>InlineIcon);
parcelHelpers.export(exports, "_api", ()=>_api);
parcelHelpers.export(exports, "addAPIProvider", ()=>addAPIProvider);
parcelHelpers.export(exports, "addCollection", ()=>addCollection);
parcelHelpers.export(exports, "addIcon", ()=>addIcon);
parcelHelpers.export(exports, "buildIcon", ()=>iconToSVG);
parcelHelpers.export(exports, "calculateSize", ()=>calculateSize);
parcelHelpers.export(exports, "disableCache", ()=>disableCache);
parcelHelpers.export(exports, "enableCache", ()=>enableCache);
parcelHelpers.export(exports, "getIcon", ()=>getIcon);
parcelHelpers.export(exports, "iconExists", ()=>iconLoaded);
parcelHelpers.export(exports, "iconLoaded", ()=>iconLoaded);
parcelHelpers.export(exports, "listIcons", ()=>listIcons);
parcelHelpers.export(exports, "loadIcon", ()=>loadIcon);
parcelHelpers.export(exports, "loadIcons", ()=>loadIcons);
parcelHelpers.export(exports, "replaceIDs", ()=>replaceIDs);
parcelHelpers.export(exports, "setCustomIconLoader", ()=>setCustomIconLoader);
parcelHelpers.export(exports, "setCustomIconsLoader", ()=>setCustomIconsLoader);
var _react = require("react");
'use client';
const defaultIconDimensions = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
});
const defaultIconTransformations = Object.freeze({
    rotate: 0,
    vFlip: false,
    hFlip: false
});
const defaultIconProps = Object.freeze({
    ...defaultIconDimensions,
    ...defaultIconTransformations
});
const defaultExtendedIconProps = Object.freeze({
    ...defaultIconProps,
    body: "",
    hidden: false
});
function mergeIconTransformations(obj1, obj2) {
    const result = {};
    if (!obj1.hFlip !== !obj2.hFlip) result.hFlip = true;
    if (!obj1.vFlip !== !obj2.vFlip) result.vFlip = true;
    const rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
    if (rotate) result.rotate = rotate;
    return result;
}
function mergeIconData(parent, child) {
    const result = mergeIconTransformations(parent, child);
    for(const key in defaultExtendedIconProps){
        if (key in defaultIconTransformations) {
            if (key in parent && !(key in result)) result[key] = defaultIconTransformations[key];
        } else if (key in child) result[key] = child[key];
        else if (key in parent) result[key] = parent[key];
    }
    return result;
}
function getIconsTree(data, names) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    const resolved = /* @__PURE__ */ Object.create(null);
    function resolve(name) {
        if (icons[name]) return resolved[name] = [];
        if (!(name in resolved)) {
            resolved[name] = null;
            const parent = aliases[name] && aliases[name].parent;
            const value = parent && resolve(parent);
            if (value) resolved[name] = [
                parent
            ].concat(value);
        }
        return resolved[name];
    }
    Object.keys(icons).concat(Object.keys(aliases)).forEach(resolve);
    return resolved;
}
function internalGetIconData(data, name, tree) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    let currentProps = {};
    function parse(name2) {
        currentProps = mergeIconData(icons[name2] || aliases[name2], currentProps);
    }
    parse(name);
    tree.forEach(parse);
    return mergeIconData(data, currentProps);
}
function parseIconSet(data, callback) {
    const names = [];
    if (typeof data !== "object" || typeof data.icons !== "object") return names;
    if (data.not_found instanceof Array) data.not_found.forEach((name)=>{
        callback(name, null);
        names.push(name);
    });
    const tree = getIconsTree(data);
    for(const name in tree){
        const item = tree[name];
        if (item) {
            callback(name, internalGetIconData(data, name, item));
            names.push(name);
        }
    }
    return names;
}
const optionalPropertyDefaults = {
    provider: "",
    aliases: {},
    not_found: {},
    ...defaultIconDimensions
};
function checkOptionalProps(item, defaults) {
    for(const prop in defaults){
        if (prop in item && typeof item[prop] !== typeof defaults[prop]) return false;
    }
    return true;
}
function quicklyValidateIconSet(obj) {
    if (typeof obj !== "object" || obj === null) return null;
    const data = obj;
    if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") return null;
    if (!checkOptionalProps(obj, optionalPropertyDefaults)) return null;
    const icons = data.icons;
    for(const name in icons){
        const icon = icons[name];
        if (// Name cannot be empty
        !name || // Must have body
        typeof icon.body !== "string" || // Check other props
        !checkOptionalProps(icon, defaultExtendedIconProps)) return null;
    }
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    for(const name in aliases){
        const icon = aliases[name];
        const parent = icon.parent;
        if (// Name cannot be empty
        !name || // Parent must be set and point to existing icon
        typeof parent !== "string" || !icons[parent] && !aliases[parent] || // Check other props
        !checkOptionalProps(icon, defaultExtendedIconProps)) return null;
    }
    return data;
}
const matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const stringToIcon = (value, validate, allowSimpleName, provider = "")=>{
    const colonSeparated = value.split(":");
    if (value.slice(0, 1) === "@") {
        if (colonSeparated.length < 2 || colonSeparated.length > 3) return null;
        provider = colonSeparated.shift().slice(1);
    }
    if (colonSeparated.length > 3 || !colonSeparated.length) return null;
    if (colonSeparated.length > 1) {
        const name2 = colonSeparated.pop();
        const prefix = colonSeparated.pop();
        const result = {
            // Allow provider without '@': "provider:prefix:name"
            provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
            prefix,
            name: name2
        };
        return validate && !validateIconName(result) ? null : result;
    }
    const name = colonSeparated[0];
    const dashSeparated = name.split("-");
    if (dashSeparated.length > 1) {
        const result = {
            provider,
            prefix: dashSeparated.shift(),
            name: dashSeparated.join("-")
        };
        return validate && !validateIconName(result) ? null : result;
    }
    if (allowSimpleName && provider === "") {
        const result = {
            provider,
            prefix: "",
            name
        };
        return validate && !validateIconName(result, allowSimpleName) ? null : result;
    }
    return null;
};
const validateIconName = (icon, allowSimpleName)=>{
    if (!icon) return false;
    return !!// Check name: cannot be empty
    ((allowSimpleName && icon.prefix === "" || !!icon.prefix) && !!icon.name);
};
const dataStorage = /* @__PURE__ */ Object.create(null);
function newStorage(provider, prefix) {
    return {
        provider,
        prefix,
        icons: /* @__PURE__ */ Object.create(null),
        missing: /* @__PURE__ */ new Set()
    };
}
function getStorage(provider, prefix) {
    const providerStorage = dataStorage[provider] || (dataStorage[provider] = /* @__PURE__ */ Object.create(null));
    return providerStorage[prefix] || (providerStorage[prefix] = newStorage(provider, prefix));
}
function addIconSet(storage, data) {
    if (!quicklyValidateIconSet(data)) return [];
    return parseIconSet(data, (name, icon)=>{
        if (icon) storage.icons[name] = icon;
        else storage.missing.add(name);
    });
}
function addIconToStorage(storage, name, icon) {
    try {
        if (typeof icon.body === "string") {
            storage.icons[name] = {
                ...icon
            };
            return true;
        }
    } catch (err) {}
    return false;
}
function listIcons(provider, prefix) {
    let allIcons = [];
    const providers = typeof provider === "string" ? [
        provider
    ] : Object.keys(dataStorage);
    providers.forEach((provider2)=>{
        const prefixes = typeof provider2 === "string" && typeof prefix === "string" ? [
            prefix
        ] : Object.keys(dataStorage[provider2] || {});
        prefixes.forEach((prefix2)=>{
            const storage = getStorage(provider2, prefix2);
            allIcons = allIcons.concat(Object.keys(storage.icons).map((name)=>(provider2 !== "" ? "@" + provider2 + ":" : "") + prefix2 + ":" + name));
        });
    });
    return allIcons;
}
let simpleNames = false;
function allowSimpleNames(allow) {
    if (typeof allow === "boolean") simpleNames = allow;
    return simpleNames;
}
function getIconData(name) {
    const icon = typeof name === "string" ? stringToIcon(name, true, simpleNames) : name;
    if (icon) {
        const storage = getStorage(icon.provider, icon.prefix);
        const iconName = icon.name;
        return storage.icons[iconName] || (storage.missing.has(iconName) ? null : void 0);
    }
}
function addIcon(name, data) {
    const icon = stringToIcon(name, true, simpleNames);
    if (!icon) return false;
    const storage = getStorage(icon.provider, icon.prefix);
    if (data) return addIconToStorage(storage, icon.name, data);
    else {
        storage.missing.add(icon.name);
        return true;
    }
}
function addCollection(data, provider) {
    if (typeof data !== "object") return false;
    if (typeof provider !== "string") provider = data.provider || "";
    if (simpleNames && !provider && !data.prefix) {
        let added = false;
        if (quicklyValidateIconSet(data)) {
            data.prefix = "";
            parseIconSet(data, (name, icon)=>{
                if (addIcon(name, icon)) added = true;
            });
        }
        return added;
    }
    const prefix = data.prefix;
    if (!validateIconName({
        provider,
        prefix,
        name: "a"
    })) return false;
    const storage = getStorage(provider, prefix);
    return !!addIconSet(storage, data);
}
function iconLoaded(name) {
    return !!getIconData(name);
}
function getIcon(name) {
    const result = getIconData(name);
    return result ? {
        ...defaultIconProps,
        ...result
    } : result;
}
const defaultIconSizeCustomisations = Object.freeze({
    width: null,
    height: null
});
const defaultIconCustomisations = Object.freeze({
    // Dimensions
    ...defaultIconSizeCustomisations,
    // Transformations
    ...defaultIconTransformations
});
const unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
const unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function calculateSize(size, ratio, precision) {
    if (ratio === 1) return size;
    precision = precision || 100;
    if (typeof size === "number") return Math.ceil(size * ratio * precision) / precision;
    if (typeof size !== "string") return size;
    const oldParts = size.split(unitsSplit);
    if (oldParts === null || !oldParts.length) return size;
    const newParts = [];
    let code = oldParts.shift();
    let isNumber = unitsTest.test(code);
    while(true){
        if (isNumber) {
            const num = parseFloat(code);
            if (isNaN(num)) newParts.push(code);
            else newParts.push(Math.ceil(num * ratio * precision) / precision);
        } else newParts.push(code);
        code = oldParts.shift();
        if (code === void 0) return newParts.join("");
        isNumber = !isNumber;
    }
}
function splitSVGDefs(content, tag = "defs") {
    let defs = "";
    const index = content.indexOf("<" + tag);
    while(index >= 0){
        const start = content.indexOf(">", index);
        const end = content.indexOf("</" + tag);
        if (start === -1 || end === -1) break;
        const endEnd = content.indexOf(">", end);
        if (endEnd === -1) break;
        defs += content.slice(start + 1, end).trim();
        content = content.slice(0, index).trim() + content.slice(endEnd + 1);
    }
    return {
        defs,
        content
    };
}
function mergeDefsAndContent(defs, content) {
    return defs ? "<defs>" + defs + "</defs>" + content : content;
}
function wrapSVGContent(body, start, end) {
    const split = splitSVGDefs(body);
    return mergeDefsAndContent(split.defs, start + split.content + end);
}
const isUnsetKeyword = (value)=>value === "unset" || value === "undefined" || value === "none";
function iconToSVG(icon, customisations) {
    const fullIcon = {
        ...defaultIconProps,
        ...icon
    };
    const fullCustomisations = {
        ...defaultIconCustomisations,
        ...customisations
    };
    const box = {
        left: fullIcon.left,
        top: fullIcon.top,
        width: fullIcon.width,
        height: fullIcon.height
    };
    let body = fullIcon.body;
    [
        fullIcon,
        fullCustomisations
    ].forEach((props)=>{
        const transformations = [];
        const hFlip = props.hFlip;
        const vFlip = props.vFlip;
        let rotation = props.rotate;
        if (hFlip) {
            if (vFlip) rotation += 2;
            else {
                transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
                transformations.push("scale(-1 1)");
                box.top = box.left = 0;
            }
        } else if (vFlip) {
            transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
            transformations.push("scale(1 -1)");
            box.top = box.left = 0;
        }
        let tempValue;
        if (rotation < 0) rotation -= Math.floor(rotation / 4) * 4;
        rotation = rotation % 4;
        switch(rotation){
            case 1:
                tempValue = box.height / 2 + box.top;
                transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
            case 2:
                transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
                break;
            case 3:
                tempValue = box.width / 2 + box.left;
                transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
        }
        if (rotation % 2 === 1) {
            if (box.left !== box.top) {
                tempValue = box.left;
                box.left = box.top;
                box.top = tempValue;
            }
            if (box.width !== box.height) {
                tempValue = box.width;
                box.width = box.height;
                box.height = tempValue;
            }
        }
        if (transformations.length) body = wrapSVGContent(body, '<g transform="' + transformations.join(" ") + '">', "</g>");
    });
    const customisationsWidth = fullCustomisations.width;
    const customisationsHeight = fullCustomisations.height;
    const boxWidth = box.width;
    const boxHeight = box.height;
    let width;
    let height;
    if (customisationsWidth === null) {
        height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
        width = calculateSize(height, boxWidth / boxHeight);
    } else {
        width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
        height = customisationsHeight === null ? calculateSize(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    }
    const attributes = {};
    const setAttr = (prop, value)=>{
        if (!isUnsetKeyword(value)) attributes[prop] = value.toString();
    };
    setAttr("width", width);
    setAttr("height", height);
    const viewBox = [
        box.left,
        box.top,
        boxWidth,
        boxHeight
    ];
    attributes.viewBox = viewBox.join(" ");
    return {
        attributes,
        viewBox,
        body
    };
}
const regex = /\sid="(\S+)"/g;
const randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let counter = 0;
function replaceIDs(body, prefix = randomPrefix) {
    const ids = [];
    let match;
    while(match = regex.exec(body))ids.push(match[1]);
    if (!ids.length) return body;
    const suffix = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
    ids.forEach((id)=>{
        const newID = typeof prefix === "function" ? prefix(id) : prefix + (counter++).toString();
        const escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        body = body.replace(// Allowed characters before id: [#;"]
        // Allowed characters after id: [)"], .[a-z]
        new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"), "$1" + newID + suffix + "$3");
    });
    body = body.replace(new RegExp(suffix, "g"), "");
    return body;
}
const storage = /* @__PURE__ */ Object.create(null);
function setAPIModule(provider, item) {
    storage[provider] = item;
}
function getAPIModule(provider) {
    return storage[provider] || storage[""];
}
function createAPIConfig(source) {
    let resources;
    if (typeof source.resources === "string") resources = [
        source.resources
    ];
    else {
        resources = source.resources;
        if (!(resources instanceof Array) || !resources.length) return null;
    }
    const result = {
        // API hosts
        resources,
        // Root path
        path: source.path || "/",
        // URL length limit
        maxURL: source.maxURL || 500,
        // Timeout before next host is used.
        rotate: source.rotate || 750,
        // Timeout before failing query.
        timeout: source.timeout || 5e3,
        // Randomise default API end point.
        random: source.random === true,
        // Start index
        index: source.index || 0,
        // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
        dataAfterTimeout: source.dataAfterTimeout !== false
    };
    return result;
}
const configStorage = /* @__PURE__ */ Object.create(null);
const fallBackAPISources = [
    "https://api.simplesvg.com",
    "https://api.unisvg.com"
];
const fallBackAPI = [];
while(fallBackAPISources.length > 0){
    if (fallBackAPISources.length === 1) fallBackAPI.push(fallBackAPISources.shift());
    else if (Math.random() > 0.5) fallBackAPI.push(fallBackAPISources.shift());
    else fallBackAPI.push(fallBackAPISources.pop());
}
configStorage[""] = createAPIConfig({
    resources: [
        "https://api.iconify.design"
    ].concat(fallBackAPI)
});
function addAPIProvider(provider, customConfig) {
    const config = createAPIConfig(customConfig);
    if (config === null) return false;
    configStorage[provider] = config;
    return true;
}
function getAPIConfig(provider) {
    return configStorage[provider];
}
function listAPIProviders() {
    return Object.keys(configStorage);
}
const detectFetch = ()=>{
    let callback;
    try {
        callback = fetch;
        if (typeof callback === "function") return callback;
    } catch (err) {}
};
let fetchModule = detectFetch();
function setFetch(fetch2) {
    fetchModule = fetch2;
}
function getFetch() {
    return fetchModule;
}
function calculateMaxLength(provider, prefix) {
    const config = getAPIConfig(provider);
    if (!config) return 0;
    let result;
    if (!config.maxURL) result = 0;
    else {
        let maxHostLength = 0;
        config.resources.forEach((item)=>{
            const host = item;
            maxHostLength = Math.max(maxHostLength, host.length);
        });
        const url = prefix + ".json?icons=";
        result = config.maxURL - maxHostLength - config.path.length - url.length;
    }
    return result;
}
function shouldAbort(status) {
    return status === 404;
}
const prepare = (provider, prefix, icons)=>{
    const results = [];
    const maxLength = calculateMaxLength(provider, prefix);
    const type = "icons";
    let item = {
        type,
        provider,
        prefix,
        icons: []
    };
    let length = 0;
    icons.forEach((name, index)=>{
        length += name.length + 1;
        if (length >= maxLength && index > 0) {
            results.push(item);
            item = {
                type,
                provider,
                prefix,
                icons: []
            };
            length = name.length;
        }
        item.icons.push(name);
    });
    results.push(item);
    return results;
};
function getPath(provider) {
    if (typeof provider === "string") {
        const config = getAPIConfig(provider);
        if (config) return config.path;
    }
    return "/";
}
const send = (host, params, callback)=>{
    if (!fetchModule) {
        callback("abort", 424);
        return;
    }
    let path = getPath(params.provider);
    switch(params.type){
        case "icons":
            {
                const prefix = params.prefix;
                const icons = params.icons;
                const iconsList = icons.join(",");
                const urlParams = new URLSearchParams({
                    icons: iconsList
                });
                path += prefix + ".json?" + urlParams.toString();
                break;
            }
        case "custom":
            {
                const uri = params.uri;
                path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
                break;
            }
        default:
            callback("abort", 400);
            return;
    }
    let defaultError = 503;
    fetchModule(host + path).then((response)=>{
        const status = response.status;
        if (status !== 200) {
            setTimeout(()=>{
                callback(shouldAbort(status) ? "abort" : "next", status);
            });
            return;
        }
        defaultError = 501;
        return response.json();
    }).then((data)=>{
        if (typeof data !== "object" || data === null) {
            setTimeout(()=>{
                if (data === 404) callback("abort", data);
                else callback("next", defaultError);
            });
            return;
        }
        setTimeout(()=>{
            callback("success", data);
        });
    }).catch(()=>{
        callback("next", defaultError);
    });
};
const fetchAPIModule = {
    prepare,
    send
};
function sortIcons(icons) {
    const result = {
        loaded: [],
        missing: [],
        pending: []
    };
    const storage = /* @__PURE__ */ Object.create(null);
    icons.sort((a, b)=>{
        if (a.provider !== b.provider) return a.provider.localeCompare(b.provider);
        if (a.prefix !== b.prefix) return a.prefix.localeCompare(b.prefix);
        return a.name.localeCompare(b.name);
    });
    let lastIcon = {
        provider: "",
        prefix: "",
        name: ""
    };
    icons.forEach((icon)=>{
        if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) return;
        lastIcon = icon;
        const provider = icon.provider;
        const prefix = icon.prefix;
        const name = icon.name;
        const providerStorage = storage[provider] || (storage[provider] = /* @__PURE__ */ Object.create(null));
        const localStorage = providerStorage[prefix] || (providerStorage[prefix] = getStorage(provider, prefix));
        let list;
        if (name in localStorage.icons) list = result.loaded;
        else if (prefix === "" || localStorage.missing.has(name)) list = result.missing;
        else list = result.pending;
        const item = {
            provider,
            prefix,
            name
        };
        list.push(item);
    });
    return result;
}
function removeCallback(storages, id) {
    storages.forEach((storage)=>{
        const items = storage.loaderCallbacks;
        if (items) storage.loaderCallbacks = items.filter((row)=>row.id !== id);
    });
}
function updateCallbacks(storage) {
    if (!storage.pendingCallbacksFlag) {
        storage.pendingCallbacksFlag = true;
        setTimeout(()=>{
            storage.pendingCallbacksFlag = false;
            const items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];
            if (!items.length) return;
            let hasPending = false;
            const provider = storage.provider;
            const prefix = storage.prefix;
            items.forEach((item)=>{
                const icons = item.icons;
                const oldLength = icons.pending.length;
                icons.pending = icons.pending.filter((icon)=>{
                    if (icon.prefix !== prefix) return true;
                    const name = icon.name;
                    if (storage.icons[name]) icons.loaded.push({
                        provider,
                        prefix,
                        name
                    });
                    else if (storage.missing.has(name)) icons.missing.push({
                        provider,
                        prefix,
                        name
                    });
                    else {
                        hasPending = true;
                        return true;
                    }
                    return false;
                });
                if (icons.pending.length !== oldLength) {
                    if (!hasPending) removeCallback([
                        storage
                    ], item.id);
                    item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
                }
            });
        });
    }
}
let idCounter = 0;
function storeCallback(callback, icons, pendingSources) {
    const id = idCounter++;
    const abort = removeCallback.bind(null, pendingSources, id);
    if (!icons.pending.length) return abort;
    const item = {
        id,
        icons,
        callback,
        abort
    };
    pendingSources.forEach((storage)=>{
        (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
    });
    return abort;
}
function listToIcons(list, validate = true, simpleNames = false) {
    const result = [];
    list.forEach((item)=>{
        const icon = typeof item === "string" ? stringToIcon(item, validate, simpleNames) : item;
        if (icon) result.push(icon);
    });
    return result;
}
// src/config.ts
var defaultConfig = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: false,
    dataAfterTimeout: false
};
// src/query.ts
function sendQuery(config, payload, query, done) {
    const resourcesCount = config.resources.length;
    const startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
    let resources;
    if (config.random) {
        let list = config.resources.slice(0);
        resources = [];
        while(list.length > 1){
            const nextIndex = Math.floor(Math.random() * list.length);
            resources.push(list[nextIndex]);
            list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
        }
        resources = resources.concat(list);
    } else resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
    const startTime = Date.now();
    let status = "pending";
    let queriesSent = 0;
    let lastError;
    let timer = null;
    let queue = [];
    let doneCallbacks = [];
    if (typeof done === "function") doneCallbacks.push(done);
    function resetTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function abort() {
        if (status === "pending") status = "aborted";
        resetTimer();
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function subscribe(callback, overwrite) {
        if (overwrite) doneCallbacks = [];
        if (typeof callback === "function") doneCallbacks.push(callback);
    }
    function getQueryStatus() {
        return {
            startTime,
            payload,
            status,
            queriesSent,
            queriesPending: queue.length,
            subscribe,
            abort
        };
    }
    function failQuery() {
        status = "failed";
        doneCallbacks.forEach((callback)=>{
            callback(void 0, lastError);
        });
    }
    function clearQueue() {
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function moduleResponse(item, response, data) {
        const isError = response !== "success";
        queue = queue.filter((queued)=>queued !== item);
        switch(status){
            case "pending":
                break;
            case "failed":
                if (isError || !config.dataAfterTimeout) return;
                break;
            default:
                return;
        }
        if (response === "abort") {
            lastError = data;
            failQuery();
            return;
        }
        if (isError) {
            lastError = data;
            if (!queue.length) {
                if (!resources.length) failQuery();
                else execNext();
            }
            return;
        }
        resetTimer();
        clearQueue();
        if (!config.random) {
            const index = config.resources.indexOf(item.resource);
            if (index !== -1 && index !== config.index) config.index = index;
        }
        status = "completed";
        doneCallbacks.forEach((callback)=>{
            callback(data);
        });
    }
    function execNext() {
        if (status !== "pending") return;
        resetTimer();
        const resource = resources.shift();
        if (resource === void 0) {
            if (queue.length) {
                timer = setTimeout(()=>{
                    resetTimer();
                    if (status === "pending") {
                        clearQueue();
                        failQuery();
                    }
                }, config.timeout);
                return;
            }
            failQuery();
            return;
        }
        const item = {
            status: "pending",
            resource,
            callback: (status2, data)=>{
                moduleResponse(item, status2, data);
            }
        };
        queue.push(item);
        queriesSent++;
        timer = setTimeout(execNext, config.rotate);
        query(resource, payload, item.callback);
    }
    setTimeout(execNext);
    return getQueryStatus;
}
// src/index.ts
function initRedundancy(cfg) {
    const config = {
        ...defaultConfig,
        ...cfg
    };
    let queries = [];
    function cleanup() {
        queries = queries.filter((item)=>item().status === "pending");
    }
    function query(payload, queryCallback, doneCallback) {
        const query2 = sendQuery(config, payload, queryCallback, (data, error)=>{
            cleanup();
            if (doneCallback) doneCallback(data, error);
        });
        queries.push(query2);
        return query2;
    }
    function find(callback) {
        return queries.find((value)=>{
            return callback(value);
        }) || null;
    }
    const instance = {
        query,
        find,
        setIndex: (index)=>{
            config.index = index;
        },
        getIndex: ()=>config.index,
        cleanup
    };
    return instance;
}
function emptyCallback$1() {}
const redundancyCache = /* @__PURE__ */ Object.create(null);
function getRedundancyCache(provider) {
    if (!redundancyCache[provider]) {
        const config = getAPIConfig(provider);
        if (!config) return;
        const redundancy = initRedundancy(config);
        const cachedReundancy = {
            config,
            redundancy
        };
        redundancyCache[provider] = cachedReundancy;
    }
    return redundancyCache[provider];
}
function sendAPIQuery(target, query, callback) {
    let redundancy;
    let send;
    if (typeof target === "string") {
        const api = getAPIModule(target);
        if (!api) {
            callback(void 0, 424);
            return emptyCallback$1;
        }
        send = api.send;
        const cached = getRedundancyCache(target);
        if (cached) redundancy = cached.redundancy;
    } else {
        const config = createAPIConfig(target);
        if (config) {
            redundancy = initRedundancy(config);
            const moduleKey = target.resources ? target.resources[0] : "";
            const api = getAPIModule(moduleKey);
            if (api) send = api.send;
        }
    }
    if (!redundancy || !send) {
        callback(void 0, 424);
        return emptyCallback$1;
    }
    return redundancy.query(query, send, callback)().abort;
}
function emptyCallback() {}
function loadedNewIcons(storage) {
    if (!storage.iconsLoaderFlag) {
        storage.iconsLoaderFlag = true;
        setTimeout(()=>{
            storage.iconsLoaderFlag = false;
            updateCallbacks(storage);
        });
    }
}
function checkIconNamesForAPI(icons) {
    const valid = [];
    const invalid = [];
    icons.forEach((name)=>{
        (name.match(matchIconName) ? valid : invalid).push(name);
    });
    return {
        valid,
        invalid
    };
}
function parseLoaderResponse(storage, icons, data) {
    function checkMissing() {
        const pending = storage.pendingIcons;
        icons.forEach((name)=>{
            if (pending) pending.delete(name);
            if (!storage.icons[name]) storage.missing.add(name);
        });
    }
    if (data && typeof data === "object") try {
        const parsed = addIconSet(storage, data);
        if (!parsed.length) {
            checkMissing();
            return;
        }
    } catch (err) {
        console.error(err);
    }
    checkMissing();
    loadedNewIcons(storage);
}
function parsePossiblyAsyncResponse(response, callback) {
    if (response instanceof Promise) response.then((data)=>{
        callback(data);
    }).catch(()=>{
        callback(null);
    });
    else callback(response);
}
function loadNewIcons(storage, icons) {
    if (!storage.iconsToLoad) storage.iconsToLoad = icons;
    else storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
    if (!storage.iconsQueueFlag) {
        storage.iconsQueueFlag = true;
        setTimeout(()=>{
            storage.iconsQueueFlag = false;
            const { provider, prefix } = storage;
            const icons2 = storage.iconsToLoad;
            delete storage.iconsToLoad;
            if (!icons2 || !icons2.length) return;
            const customIconLoader = storage.loadIcon;
            if (storage.loadIcons && (icons2.length > 1 || !customIconLoader)) {
                parsePossiblyAsyncResponse(storage.loadIcons(icons2, prefix, provider), (data)=>{
                    parseLoaderResponse(storage, icons2, data);
                });
                return;
            }
            if (customIconLoader) {
                icons2.forEach((name)=>{
                    const response = customIconLoader(name, prefix, provider);
                    parsePossiblyAsyncResponse(response, (data)=>{
                        const iconSet = data ? {
                            prefix,
                            icons: {
                                [name]: data
                            }
                        } : null;
                        parseLoaderResponse(storage, [
                            name
                        ], iconSet);
                    });
                });
                return;
            }
            const { valid, invalid } = checkIconNamesForAPI(icons2);
            if (invalid.length) parseLoaderResponse(storage, invalid, null);
            if (!valid.length) return;
            const api = prefix.match(matchIconName) ? getAPIModule(provider) : null;
            if (!api) {
                parseLoaderResponse(storage, valid, null);
                return;
            }
            const params = api.prepare(provider, prefix, valid);
            params.forEach((item)=>{
                sendAPIQuery(provider, item, (data)=>{
                    parseLoaderResponse(storage, item.icons, data);
                });
            });
        });
    }
}
const loadIcons = (icons, callback)=>{
    const cleanedIcons = listToIcons(icons, true, allowSimpleNames());
    const sortedIcons = sortIcons(cleanedIcons);
    if (!sortedIcons.pending.length) {
        let callCallback = true;
        if (callback) setTimeout(()=>{
            if (callCallback) callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, emptyCallback);
        });
        return ()=>{
            callCallback = false;
        };
    }
    const newIcons = /* @__PURE__ */ Object.create(null);
    const sources = [];
    let lastProvider, lastPrefix;
    sortedIcons.pending.forEach((icon)=>{
        const { provider, prefix } = icon;
        if (prefix === lastPrefix && provider === lastProvider) return;
        lastProvider = provider;
        lastPrefix = prefix;
        sources.push(getStorage(provider, prefix));
        const providerNewIcons = newIcons[provider] || (newIcons[provider] = /* @__PURE__ */ Object.create(null));
        if (!providerNewIcons[prefix]) providerNewIcons[prefix] = [];
    });
    sortedIcons.pending.forEach((icon)=>{
        const { provider, prefix, name } = icon;
        const storage = getStorage(provider, prefix);
        const pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */ new Set());
        if (!pendingQueue.has(name)) {
            pendingQueue.add(name);
            newIcons[provider][prefix].push(name);
        }
    });
    sources.forEach((storage)=>{
        const list = newIcons[storage.provider][storage.prefix];
        if (list.length) loadNewIcons(storage, list);
    });
    return callback ? storeCallback(callback, sortedIcons, sources) : emptyCallback;
};
const loadIcon = (icon)=>{
    return new Promise((fulfill, reject)=>{
        const iconObj = typeof icon === "string" ? stringToIcon(icon, true) : icon;
        if (!iconObj) {
            reject(icon);
            return;
        }
        loadIcons([
            iconObj || icon
        ], (loaded)=>{
            if (loaded.length && iconObj) {
                const data = getIconData(iconObj);
                if (data) {
                    fulfill({
                        ...defaultIconProps,
                        ...data
                    });
                    return;
                }
            }
            reject(icon);
        });
    });
};
function setCustomIconsLoader(loader, prefix, provider) {
    getStorage(provider || "", prefix).loadIcons = loader;
}
function setCustomIconLoader(loader, prefix, provider) {
    getStorage(provider || "", prefix).loadIcon = loader;
}
function mergeCustomisations(defaults, item) {
    const result = {
        ...defaults
    };
    for(const key in item){
        const value = item[key];
        const valueType = typeof value;
        if (key in defaultIconSizeCustomisations) {
            if (value === null || value && (valueType === "string" || valueType === "number")) result[key] = value;
        } else if (valueType === typeof result[key]) result[key] = key === "rotate" ? value % 4 : value;
    }
    return result;
}
const separator = /[\s,]+/;
function flipFromString(custom, flip) {
    flip.split(separator).forEach((str)=>{
        const value = str.trim();
        switch(value){
            case "horizontal":
                custom.hFlip = true;
                break;
            case "vertical":
                custom.vFlip = true;
                break;
        }
    });
}
function rotateFromString(value, defaultValue = 0) {
    const units = value.replace(/^-?[0-9.]*/, "");
    function cleanup(value2) {
        while(value2 < 0)value2 += 4;
        return value2 % 4;
    }
    if (units === "") {
        const num = parseInt(value);
        return isNaN(num) ? 0 : cleanup(num);
    } else if (units !== value) {
        let split = 0;
        switch(units){
            case "%":
                split = 25;
                break;
            case "deg":
                split = 90;
        }
        if (split) {
            let num = parseFloat(value.slice(0, value.length - units.length));
            if (isNaN(num)) return 0;
            num = num / split;
            return num % 1 === 0 ? cleanup(num) : 0;
        }
    }
    return defaultValue;
}
function iconToHTML(body, attributes) {
    let renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
    for(const attr in attributes)renderAttribsHTML += " " + attr + '="' + attributes[attr] + '"';
    return '<svg xmlns="http://www.w3.org/2000/svg"' + renderAttribsHTML + ">" + body + "</svg>";
}
function encodeSVGforURL(svg) {
    return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function svgToData(svg) {
    return "data:image/svg+xml," + encodeSVGforURL(svg);
}
function svgToURL(svg) {
    return 'url("' + svgToData(svg) + '")';
}
let policy;
function createPolicy() {
    try {
        policy = window.trustedTypes.createPolicy("iconify", {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            createHTML: (s)=>s
        });
    } catch (err) {
        policy = null;
    }
}
function cleanUpInnerHTML(html) {
    if (policy === void 0) createPolicy();
    return policy ? policy.createHTML(html) : html;
}
const defaultExtendedIconCustomisations = {
    ...defaultIconCustomisations,
    inline: false
};
/**
 * Default SVG attributes
 */ const svgDefaults = {
    'xmlns': 'http://www.w3.org/2000/svg',
    'xmlnsXlink': 'http://www.w3.org/1999/xlink',
    'aria-hidden': true,
    'role': 'img'
};
/**
 * Style modes
 */ const commonProps = {
    display: 'inline-block'
};
const monotoneProps = {
    backgroundColor: 'currentColor'
};
const coloredProps = {
    backgroundColor: 'transparent'
};
// Dynamically add common props to variables above
const propsToAdd = {
    Image: 'var(--svg)',
    Repeat: 'no-repeat',
    Size: '100% 100%'
};
const propsToAddTo = {
    WebkitMask: monotoneProps,
    mask: monotoneProps,
    background: coloredProps
};
for(const prefix in propsToAddTo){
    const list = propsToAddTo[prefix];
    for(const prop in propsToAdd)list[prefix + prop] = propsToAdd[prop];
}
/**
 * Default values for customisations for inline icon
 */ const inlineDefaults = {
    ...defaultExtendedIconCustomisations,
    inline: true
};
/**
 * Fix size: add 'px' to numbers
 */ function fixSize(value) {
    return value + (value.match(/^[-0-9.]+$/) ? 'px' : '');
}
/**
 * Render icon
 */ const render = (// Icon must be validated before calling this function
icon, // Partial properties
props, // Icon name
name)=>{
    // Get default properties
    const defaultProps = props.inline ? inlineDefaults : defaultExtendedIconCustomisations;
    // Get all customisations
    const customisations = mergeCustomisations(defaultProps, props);
    // Check mode
    const mode = props.mode || 'svg';
    // Create style
    const style = {};
    const customStyle = props.style || {};
    // Create SVG component properties
    const componentProps = {
        ...mode === 'svg' ? svgDefaults : {}
    };
    if (name) {
        const iconName = stringToIcon(name, false, true);
        if (iconName) {
            const classNames = [
                'iconify'
            ];
            const props = [
                'provider',
                'prefix'
            ];
            for (const prop of props)if (iconName[prop]) classNames.push('iconify--' + iconName[prop]);
            componentProps.className = classNames.join(' ');
        }
    }
    // Get element properties
    for(let key in props){
        const value = props[key];
        if (value === void 0) continue;
        switch(key){
            // Properties to ignore
            case 'icon':
            case 'style':
            case 'children':
            case 'onLoad':
            case 'mode':
            case 'ssr':
                break;
            // Forward ref
            case '_ref':
                componentProps.ref = value;
                break;
            // Merge class names
            case 'className':
                componentProps[key] = (componentProps[key] ? componentProps[key] + ' ' : '') + value;
                break;
            // Boolean attributes
            case 'inline':
            case 'hFlip':
            case 'vFlip':
                customisations[key] = value === true || value === 'true' || value === 1;
                break;
            // Flip as string: 'horizontal,vertical'
            case 'flip':
                if (typeof value === 'string') flipFromString(customisations, value);
                break;
            // Color: copy to style
            case 'color':
                style.color = value;
                break;
            // Rotation as string
            case 'rotate':
                if (typeof value === 'string') customisations[key] = rotateFromString(value);
                else if (typeof value === 'number') customisations[key] = value;
                break;
            // Remove aria-hidden
            case 'ariaHidden':
            case 'aria-hidden':
                if (value !== true && value !== 'true') delete componentProps['aria-hidden'];
                break;
            // Copy missing property if it does not exist in customisations
            default:
                if (defaultProps[key] === void 0) componentProps[key] = value;
        }
    }
    // Generate icon
    const item = iconToSVG(icon, customisations);
    const renderAttribs = item.attributes;
    // Inline display
    if (customisations.inline) style.verticalAlign = '-0.125em';
    if (mode === 'svg') {
        // Add style
        componentProps.style = {
            ...style,
            ...customStyle
        };
        // Add icon stuff
        Object.assign(componentProps, renderAttribs);
        // Counter for ids based on "id" property to render icons consistently on server and client
        let localCounter = 0;
        let id = props.id;
        if (typeof id === 'string') // Convert '-' to '_' to avoid errors in animations
        id = id.replace(/-/g, '_');
        // Add icon stuff
        componentProps.dangerouslySetInnerHTML = {
            __html: cleanUpInnerHTML(replaceIDs(item.body, id ? ()=>id + 'ID' + localCounter++ : 'iconifyReact'))
        };
        return (0, _react.createElement)('svg', componentProps);
    }
    // Render <span> with style
    const { body, width, height } = icon;
    const useMask = mode === 'mask' || (mode === 'bg' ? false : body.indexOf('currentColor') !== -1);
    // Generate SVG
    const html = iconToHTML(body, {
        ...renderAttribs,
        width: width + '',
        height: height + ''
    });
    // Generate style
    componentProps.style = {
        ...style,
        '--svg': svgToURL(html),
        'width': fixSize(renderAttribs.width),
        'height': fixSize(renderAttribs.height),
        ...commonProps,
        ...useMask ? monotoneProps : coloredProps,
        ...customStyle
    };
    return (0, _react.createElement)('span', componentProps);
};
/**
 * Enable cache
 *
 * @deprecated No longer used
 */ function enableCache(storage) {
//
}
/**
 * Disable cache
 *
 * @deprecated No longer used
 */ function disableCache(storage) {
//
}
/**
 * Initialise stuff
 */ // Enable short names
allowSimpleNames(true);
// Set API module
setAPIModule('', fetchAPIModule);
/**
 * Browser stuff
 */ if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    const _window = window;
    // Load icons from global "IconifyPreload"
    if (_window.IconifyPreload !== void 0) {
        const preload = _window.IconifyPreload;
        const err = 'Invalid IconifyPreload syntax.';
        if (typeof preload === 'object' && preload !== null) (preload instanceof Array ? preload : [
            preload
        ]).forEach((item)=>{
            try {
                if (// Check if item is an object and not null/array
                typeof item !== 'object' || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
                typeof item.icons !== 'object' || typeof item.prefix !== 'string' || // Add icon set
                !addCollection(item)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        });
    }
    // Set API from global "IconifyProviders"
    if (_window.IconifyProviders !== void 0) {
        const providers = _window.IconifyProviders;
        if (typeof providers === 'object' && providers !== null) for(let key in providers){
            const err = 'IconifyProviders[' + key + '] is invalid.';
            try {
                const value = providers[key];
                if (typeof value !== 'object' || !value || value.resources === void 0) continue;
                if (!addAPIProvider(key, value)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        }
    }
}
function IconComponent(props) {
    const [mounted, setMounted] = (0, _react.useState)(!!props.ssr);
    const [abort, setAbort] = (0, _react.useState)({});
    // Get initial state
    function getInitialState(mounted) {
        if (mounted) {
            const name = props.icon;
            if (typeof name === 'object') // Icon as object
            return {
                name: '',
                data: name
            };
            const data = getIconData(name);
            if (data) return {
                name,
                data
            };
        }
        return {
            name: ''
        };
    }
    const [state, setState] = (0, _react.useState)(getInitialState(!!props.ssr));
    // Cancel loading
    function cleanup() {
        const callback = abort.callback;
        if (callback) {
            callback();
            setAbort({});
        }
    }
    // Change state if it is different
    function changeState(newState) {
        if (JSON.stringify(state) !== JSON.stringify(newState)) {
            cleanup();
            setState(newState);
            return true;
        }
    }
    // Update state
    function updateState() {
        var _a;
        const name = props.icon;
        if (typeof name === 'object') {
            // Icon as object
            changeState({
                name: '',
                data: name
            });
            return;
        }
        // New icon or got icon data
        const data = getIconData(name);
        if (changeState({
            name,
            data
        })) {
            if (data === undefined) {
                // Load icon, update state when done
                const callback = loadIcons([
                    name
                ], updateState);
                setAbort({
                    callback
                });
            } else if (data) // Icon data is available: trigger onLoad callback if present
            (_a = props.onLoad) === null || _a === void 0 || _a.call(props, name);
        }
    }
    // Mounted state, cleanup for loader
    (0, _react.useEffect)(()=>{
        setMounted(true);
        return cleanup;
    }, []);
    // Icon changed or component mounted
    (0, _react.useEffect)(()=>{
        if (mounted) updateState();
    }, [
        props.icon,
        mounted
    ]);
    // Render icon
    const { name, data } = state;
    if (!data) return props.children ? props.children : (0, _react.createElement)('span', {});
    return render({
        ...defaultIconProps,
        ...data
    }, props, name);
}
/**
 * Block icon
 *
 * @param props - Component properties
 */ const Icon = (0, _react.forwardRef)((props, ref)=>IconComponent({
        ...props,
        _ref: ref
    }));
/**
 * Inline icon (has negative verticalAlign that makes it behave like icon font)
 *
 * @param props - Component properties
 */ const InlineIcon = (0, _react.forwardRef)((props, ref)=>IconComponent({
        inline: true,
        ...props,
        _ref: ref
    }));
/**
 * Internal API
 */ const _api = {
    getAPIConfig,
    setAPIModule,
    sendAPIQuery,
    setFetch,
    getFetch,
    listAPIProviders
};

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPbDY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProfileFavouriteSportsGrid", ()=>ProfileFavouriteSportsGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileFavSportIcons = require("./profileFavSportIcons");
const LIME = "#D2FF00";
function ProfileFavouriteSportsGrid({ selected, onToggle }) {
    const selectedSet = (0, _react.useMemo)(()=>new Set(selected), [
        selected
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full min-w-0 pb-3 sm:pb-5",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pt-3 pb-5 sm:pt-4 sm:pb-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-center font-anton text-[15px] font-normal not-italic uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                    children: "Favourite Sports"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mx-auto grid w-max max-w-full grid-cols-[repeat(4,70px)] justify-items-center gap-x-4 gap-y-3 sm:gap-x-5 sm:gap-y-4",
                children: (0, _profileFavSportIcons.PROFILE_FAV_SPORT_GRID_OPTIONS).map((sport)=>{
                    const isSelected = selectedSet.has(sport);
                    const color = isSelected ? LIME : "#FFFFFF";
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        onClick: ()=>onToggle(sport),
                        "aria-pressed": isSelected,
                        "aria-label": sport,
                        className: `flex h-[70px] min-h-[70px] w-[70px] min-w-[70px] shrink-0 flex-col items-center justify-center gap-1 overflow-hidden rounded-none border-[3px] px-0.5 py-1 transition-colors ${isSelected ? "border-[#D2FF00] bg-[#8255BE]" : "border-transparent bg-white/10 hover:bg-white/[0.14]"}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "flex shrink-0 items-center justify-center",
                                children: (0, _profileFavSportIcons.favSportIcon)(sport, color, "mx-auto h-[24px] w-[24px] shrink-0")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: `w-full min-w-0 shrink-0 px-0.5 text-center font-anton text-[10px] font-normal not-italic uppercase leading-[16px] tracking-normal [leading-trim:none] ${sport === "Horse Racing" ? "mt-1 whitespace-nowrap" : "line-clamp-2"} ${isSelected ? "text-[#D2FF00]" : "text-white"}`,
                                children: sport
                            })
                        ]
                    }, sport);
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./profileFavSportIcons":"bXwQU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"652Wq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProfileFavouriteFootballGrid", ()=>ProfileFavouriteFootballGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileFavFootballTeams = require("./profileFavFootballTeams");
function ProfileFavouriteFootballGrid({ selected, onToggle }) {
    const selectedSet = (0, _react.useMemo)(()=>new Set(selected), [
        selected
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full min-w-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-3 text-center font-anton text-[15px] font-normal not-italic uppercase leading-[12px] tracking-normal text-white [leading-trim:none] sm:mb-3.5",
                children: "Favourite Football teams"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "grid grid-cols-5 justify-items-center gap-2 sm:gap-2.5",
                children: (0, _profileFavFootballTeams.PROFILE_FAV_FOOTBALL_TEAM_OPTIONS).map(({ slug, label })=>{
                    const isSelected = selectedSet.has(slug);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        onClick: ()=>onToggle(slug),
                        "aria-pressed": isSelected,
                        "aria-label": label,
                        className: `flex h-[70px] w-[70px] shrink-0 flex-col items-stretch justify-between gap-0 overflow-hidden rounded-none border-[3px] transition-colors ${isSelected ? "border-[#D2FF00] bg-[#8255BE]" : "border-transparent bg-white/10 hover:bg-white/[0.14]"}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "flex min-h-0 flex-1 flex-col items-center justify-center px-1 py-1.5",
                                children: (0, _profileFavFootballTeams.footballLogoUsesWhiteTile)(slug) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "inline-flex max-h-full max-w-full items-center justify-center rounded-none bg-white p-0.5",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: (0, _profileFavFootballTeams.footballTeamLogoUrl)(slug),
                                        alt: "",
                                        className: "max-h-full max-w-full object-contain",
                                        loading: "lazy",
                                        decoding: "async"
                                    })
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: (0, _profileFavFootballTeams.footballTeamLogoUrl)(slug),
                                    alt: "",
                                    className: "max-h-full max-w-full object-contain",
                                    loading: "lazy",
                                    decoding: "async"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: `shrink-0 px-0.5 pb-1 text-center font-anton text-[10px] font-normal uppercase leading-[12px] tracking-normal [leading-trim:none] line-clamp-2 ${isSelected ? "text-[#D2FF00]" : "text-white"}`,
                                children: label
                            })
                        ]
                    }, slug);
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./profileFavFootballTeams":"3mxlc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2eY8V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProfileFavouriteCricketTeamsGrid", ()=>ProfileFavouriteCricketTeamsGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logos = require("../shared/logos");
var _profileFavIplTeams = require("./profileFavIplTeams");
var _profileFavCricketIntTeams = require("./profileFavCricketIntTeams");
const SECTION_TITLE_CLASS = "mb-3 text-center font-anton text-[15px] font-normal not-italic uppercase leading-[12px] tracking-normal text-white [leading-trim:none] sm:mb-3.5";
const SUBHEAD_BAR_CLASS = "mb-2 flex h-[20px] min-h-[20px] max-h-[20px] w-full items-center justify-center bg-white/10 text-center font-anton text-[10px] font-normal not-italic uppercase leading-[16px] tracking-normal text-white [leading-trim:none]";
const TILE_BTN_CLASS = "flex h-[70px] w-[70px] shrink-0 flex-col items-stretch justify-between gap-0 overflow-hidden rounded-none border-[3px] transition-colors";
function ExtraTeamTile({ extra, onRemove }) {
    const label = extra.label || extra.name;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        type: "button",
        onClick: ()=>onRemove?.(extra.name),
        "aria-pressed": true,
        "aria-label": `Remove ${extra.name}`,
        title: "Remove",
        className: `${TILE_BTN_CLASS} border-[#D2FF00] bg-[#8255BE]`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "flex min-h-0 flex-1 flex-col items-center justify-center px-1 py-1.5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logos.CricketTeamLogo), {
                    teamName: extra.name,
                    width: "40px",
                    height: "40px",
                    className: "shrink-0 justify-center [&_img]:object-contain"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "line-clamp-2 shrink-0 px-0.5 pb-1 text-center font-anton text-[10px] font-normal uppercase leading-[12px] tracking-normal text-[#D2FF00] [leading-trim:none]",
                children: label
            })
        ]
    });
}
function ProfileFavouriteCricketTeamsGrid({ selectedIpl, selectedInt, onToggleIpl, onToggleInt, clubExtras = [], intExtras = [], onRemoveExtra }) {
    const iplSet = (0, _react.useMemo)(()=>new Set(selectedIpl), [
        selectedIpl
    ]);
    const intSet = (0, _react.useMemo)(()=>new Set(selectedInt), [
        selectedInt
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full min-w-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: SECTION_TITLE_CLASS,
                children: "Favourite Cricket teams"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: SUBHEAD_BAR_CLASS,
                children: "Club teams"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid grid-cols-5 justify-items-center gap-2 sm:gap-2.5",
                children: [
                    (0, _profileFavIplTeams.PROFILE_FAV_IPL_TEAM_OPTIONS).map(({ slug, label })=>{
                        const isSelected = iplSet.has(slug);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            onClick: ()=>onToggleIpl(slug),
                            "aria-pressed": isSelected,
                            "aria-label": label,
                            className: `${TILE_BTN_CLASS} ${isSelected ? "border-[#D2FF00] bg-[#8255BE]" : "border-transparent bg-white/10 hover:bg-white/[0.14]"}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "flex min-h-0 flex-1 flex-col items-center justify-center px-1 py-1.5",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: (0, _profileFavIplTeams.iplTeamLogoUrl)(slug),
                                        alt: "",
                                        className: "max-h-full max-w-full object-contain",
                                        loading: "lazy",
                                        decoding: "async"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: `shrink-0 px-0.5 pb-1 text-center font-anton text-[10px] font-normal uppercase leading-[12px] tracking-normal [leading-trim:none] line-clamp-2 ${isSelected ? "text-[#D2FF00]" : "text-white"}`,
                                    children: label
                                })
                            ]
                        }, slug);
                    }),
                    clubExtras.map((extra)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ExtraTeamTile, {
                            extra: extra,
                            onRemove: onRemoveExtra
                        }, `club-${extra.slug}`))
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `${SUBHEAD_BAR_CLASS} mt-4`,
                children: "International"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid grid-cols-5 justify-items-center gap-2 sm:gap-2.5",
                children: [
                    (0, _profileFavCricketIntTeams.PROFILE_FAV_CRICKET_INT_OPTIONS).map(({ slug, label })=>{
                        const isSelected = intSet.has(slug);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            onClick: ()=>onToggleInt(slug),
                            "aria-pressed": isSelected,
                            "aria-label": label,
                            className: `${TILE_BTN_CLASS} ${isSelected ? "border-[#D2FF00] bg-[#8255BE]" : "border-transparent bg-white/10 hover:bg-white/[0.14]"}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "flex min-h-0 flex-1 flex-col items-center justify-center px-1 py-1.5",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: (0, _profileFavCricketIntTeams.cricketIntLogoUsesWhiteTile)(slug) ? "flex max-h-full max-w-full items-center justify-center rounded-none bg-white p-0.5" : "flex max-h-full max-w-full items-center justify-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: (0, _profileFavCricketIntTeams.cricketIntTeamLogoUrl)(slug),
                                            alt: "",
                                            className: "max-h-full max-w-full object-contain",
                                            loading: "lazy",
                                            decoding: "async"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: `shrink-0 px-0.5 pb-1 text-center font-anton text-[10px] font-normal uppercase leading-[12px] tracking-normal [leading-trim:none] line-clamp-2 ${isSelected ? "text-[#D2FF00]" : "text-white"}`,
                                    children: label
                                })
                            ]
                        }, slug);
                    }),
                    intExtras.map((extra)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ExtraTeamTile, {
                            extra: extra,
                            onRemove: onRemoveExtra
                        }, `int-${extra.slug}`))
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../shared/logos":"4XCsm","./profileFavIplTeams":"f7o1p","./profileFavCricketIntTeams":"7D1sc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGG5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProfileFavouriteCricketersGrid", ()=>ProfileFavouriteCricketersGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileFavCricketers = require("./profileFavCricketers");
function ProfileFavouriteCricketersGrid({ selected, onToggle }) {
    const selectedSet = (0, _react.useMemo)(()=>new Set(selected), [
        selected
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-full min-w-0 pb-5 sm:pb-7",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pt-3 pb-5 sm:pt-4 sm:pb-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-center font-anton text-[15px] font-normal not-italic uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                    children: "Favourite Cricket players"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "grid grid-cols-2 gap-2 sm:gap-2.5",
                children: (0, _profileFavCricketers.PROFILE_FAV_CRICKETER_OPTIONS).map(({ slug, label })=>{
                    const isSelected = selectedSet.has(slug);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        onClick: ()=>onToggle(slug),
                        "aria-pressed": isSelected,
                        "aria-label": label,
                        className: `flex h-[32px] min-h-[32px] max-h-[32px] w-full min-w-0 flex-row items-center overflow-hidden rounded-none border-[3px] transition-colors box-border ${isSelected ? "border-[#D2FF00] bg-[#8255BE]" : "border-transparent bg-white/10 hover:bg-white/[0.14]"}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _profileFavCricketers.cricketerLogoUrl)(slug),
                                alt: "",
                                width: 24,
                                height: 24,
                                className: "h-[24px] w-[24px] shrink-0 object-cover",
                                loading: "lazy",
                                decoding: "async"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: `flex min-w-0 flex-1 items-center truncate px-1.5 text-left font-anton text-[12px] font-normal uppercase leading-[16px] tracking-normal not-italic [leading-trim:none] sm:px-2 ${isSelected ? "text-[#D2FF00]" : "text-white"}`,
                                children: label
                            })
                        ]
                    }, slug);
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./profileFavCricketers":"2PUhI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"14JPj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Starred / stored favourites that are not in the curated Club teams (IPL) or
 * International pickers — shown as selected extra tiles in those sections.
 */ parcelHelpers.export(exports, "profileFavouriteTeamExtras", ()=>profileFavouriteTeamExtras);
/**
 * Read/toggle the logged-in user's favourite teams across all three stores
 * (IPL picker, national picker, custom). Optimistically updates UserContext + cache,
 * then persists via `POST /account/favourite-teams/toggle`.
 * Guests cannot toggle here — FavouriteTeamStar sends them to sign up instead.
 */ parcelHelpers.export(exports, "useFavouriteTeams", ()=>useFavouriteTeams);
var _react = require("react");
var _userContext = require("./UserContext");
var _authHeaders = require("../utils/authHeaders");
var _favouriteTeams = require("../utils/favouriteTeams");
var _cricketTeamCanonical = require("../utils/cricketTeamCanonical");
var _profileFavIplTeams = require("../components/Profile/profileFavIplTeams");
var _profileFavCricketIntTeams = require("../components/Profile/profileFavCricketIntTeams");
const IPL_CATALOG = new Set((0, _profileFavIplTeams.PROFILE_FAV_IPL_TEAM_OPTIONS).map((t)=>t.slug));
const INT_CATALOG = new Set((0, _profileFavCricketIntTeams.PROFILE_FAV_CRICKET_INT_OPTIONS).map((t)=>t.slug));
function profileFavouriteTeamExtras(favourites) {
    const clubExtras = [];
    const intExtras = [];
    const seenClub = new Set();
    const seenInt = new Set();
    const pushClub = (slug, name, label)=>{
        if (!slug || seenClub.has(slug) || IPL_CATALOG.has(slug)) return;
        seenClub.add(slug);
        clubExtras.push({
            slug,
            name,
            label
        });
    };
    const pushInt = (slug, name, label)=>{
        if (!slug || seenInt.has(slug) || INT_CATALOG.has(slug)) return;
        seenInt.add(slug);
        intExtras.push({
            slug,
            name,
            label
        });
    };
    for (const slug of (0, _profileFavIplTeams.parseFavIplFromStorage)(favourites?.faviplteams))if (!IPL_CATALOG.has(slug)) {
        const label = (0, _profileFavIplTeams.favIplLabel)(slug);
        pushClub(slug, label, label);
    }
    for (const slug of (0, _profileFavCricketIntTeams.parseFavCricketIntFromStorage)(favourites?.favnationalteams))if (!INT_CATALOG.has(slug)) {
        // Prefer title-cased slug for logo lookup when not in the curated picker.
        const label = (0, _profileFavCricketIntTeams.favCricketIntLabel)(slug);
        const display = label === slug.replace(/-/g, " ") ? slug.split("-").map((w)=>w ? w.charAt(0).toUpperCase() + w.slice(1) : w).join(" ") : label;
        pushInt(slug, display, display);
    }
    const iplStore = new Set((0, _favouriteTeams.parseCommaList)(favourites?.faviplteams).map((0, _cricketTeamCanonical.canonicalTeamSlug)));
    const natStore = new Set((0, _favouriteTeams.parseCommaList)(favourites?.favnationalteams).map((0, _cricketTeamCanonical.canonicalTeamSlug)));
    for (const name of (0, _favouriteTeams.parseFavTeamsFromStorage)(favourites?.favcustomcricketteams)){
        const { slug, category } = (0, _cricketTeamCanonical.resolveCanonicalTeam)(name);
        if (!slug || iplStore.has(slug) || natStore.has(slug)) continue;
        if (category === "national" || INT_CATALOG.has(slug)) pushInt(slug, name);
        else if (category === "ipl" || IPL_CATALOG.has(slug)) continue;
        else pushClub(slug, name);
    }
    return {
        clubExtras,
        intExtras
    };
}
function useFavouriteTeams() {
    const { user, setUser } = (0, _userContext.useUser)();
    const inFlight = (0, _react.useRef)(new Set());
    const favourites = user?.favourites ?? null;
    const { clubExtras, intExtras } = (0, _react.useMemo)(()=>profileFavouriteTeamExtras(favourites), [
        favourites
    ]);
    /** @deprecated Prefer clubExtras / intExtras — custom-only names for legacy callers. */ const favTeams = (0, _react.useMemo)(()=>[
            ...clubExtras,
            ...intExtras
        ].map((e)=>e.name), [
        clubExtras,
        intExtras
    ]);
    const canFavourite = Boolean(user?.userId);
    const isFavourite = (0, _react.useCallback)((teamName)=>(0, _favouriteTeams.isFavouriteTeam)(favourites, teamName), [
        favourites
    ]);
    const toggle = (0, _react.useCallback)(async (teamName)=>{
        const name = String(teamName || "").trim();
        const slug = (0, _cricketTeamCanonical.resolveCanonicalTeam)(name).slug;
        if (!name || !slug || !user?.userId) return null;
        if (inFlight.current.has(slug)) return null;
        const plan = (0, _favouriteTeams.buildFavouriteTeamToggle)(favourites, name);
        if (!plan) return null;
        inFlight.current.add(slug);
        const previous = {
            ...favourites ?? {}
        };
        const applyFavourites = (next)=>{
            setUser((prev)=>prev ? {
                    ...prev,
                    favourites: {
                        ...next
                    }
                } : prev);
            (0, _userContext.patchCachedUserFavourites)(next);
        };
        applyFavourites(plan.next);
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/favourite-teams/toggle`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    ops: plan.ops
                })
            });
            if (!res.ok) throw new Error(`toggle failed: ${res.status}`);
            const data = await res.json();
            if (data.favourites && typeof data.favourites === "object") applyFavourites({
                ...plan.next,
                ...data.favourites
            });
            return Boolean(data.favourited);
        } catch  {
            applyFavourites(previous);
            return null;
        } finally{
            inFlight.current.delete(slug);
        }
    }, [
        favourites,
        setUser,
        user?.userId
    ]);
    return {
        favTeams,
        clubExtras,
        intExtras,
        canFavourite,
        isFavourite,
        toggle
    };
}

},{"react":"6uln9","./UserContext":"aqd8b","../utils/authHeaders":"5Rczo","../utils/favouriteTeams":"fwQD0","../utils/cricketTeamCanonical":"3aPXR","../components/Profile/profileFavIplTeams":"f7o1p","../components/Profile/profileFavCricketIntTeams":"7D1sc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cQ9gl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Profile / friends name stack: player handle on top, optional display_name beneath.
 */ parcelHelpers.export(exports, "ProfileNameStack", ()=>ProfileNameStack);
/** Compact two-line name for friends list / invite rows (left-aligned). */ parcelHelpers.export(exports, "FriendNameStack", ()=>FriendNameStack);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function ProfileNameStack({ playerName, displayName, className = "", renderPlayerName }) {
    const primary = String(playerName || "Player").trim() || "Player";
    const secondary = typeof displayName === "string" ? displayName.trim() : "";
    const showSecondary = Boolean(secondary) && secondary.toLowerCase() !== primary.toLowerCase();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `flex min-w-0 flex-col items-center ${className}`.trim(),
        children: [
            renderPlayerName ? renderPlayerName(primary) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "w-full max-w-full truncate text-center font-anton text-[20px] font-normal uppercase leading-[26px] tracking-normal text-white [leading-trim:none]",
                children: primary.toUpperCase()
            }),
            showSecondary ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "mt-0.5 max-w-full truncate text-center font-chakra text-[12px] font-normal normal-case leading-[16px] tracking-normal text-white/55 [leading-trim:none]",
                children: secondary
            }) : null
        ]
    });
}
function FriendNameStack({ playerName, displayName, className = "", playerNameClassName = "truncate text-left font-anton text-[15px] leading-tight text-white max-[640px]:text-[13px] max-[420px]:text-[11px]", displayNameClassName = "mt-0.5 truncate text-left font-chakra text-[11px] normal-case leading-none text-white/50" }) {
    const primary = String(playerName || "Player").trim() || "Player";
    const secondary = typeof displayName === "string" ? displayName.trim() : "";
    const showSecondary = Boolean(secondary) && secondary.toLowerCase() !== primary.toLowerCase();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: `flex min-w-0 flex-col ${className}`.trim(),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: playerNameClassName,
                children: primary
            }),
            showSecondary ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: displayNameClassName,
                children: secondary
            }) : null
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8bANt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCareerSummaryPayload", ()=>parseCareerSummaryPayload);
parcelHelpers.export(exports, "fallbackCareerSummaryZeros", ()=>fallbackCareerSummaryZeros);
/**
 * Public profile `career` from API. Always normalizes through {@link parseCareerSummaryPayload}
 * so Quickfire (and wheel) mini-game stats use the same shape as `/account/career-summary`
 * (Quickfire counts/coins come from `quickfire_plays` on the server).
 */ parcelHelpers.export(exports, "coercePublicCareer", ()=>coercePublicCareer);
var _xp = require("../../utils/xp");
function emptyMiniGamesRow() {
    return {
        played: 0,
        net_coins: 0,
        net_rubies: 0
    };
}
function emptyQuickfireMiniGamesRow() {
    return {
        played: 0,
        correct_answers: 0,
        net_coins: 0,
        net_rubies: 0
    };
}
function parseCareerSummaryPayload(data) {
    const d = data && typeof data === "object" ? data : {};
    const pickMini = (key)=>{
        const raw = d.mini_games && typeof d.mini_games === "object" ? d.mini_games[key] : null;
        const o = raw && typeof raw === "object" ? raw : {};
        const base = {
            played: Number(o.played) || 0,
            net_coins: Number(o.net_coins) || 0,
            net_rubies: Number(o.net_rubies) || 0
        };
        if (key === "quickfire-trivia") return {
            ...base,
            correct_answers: Number(o.correct_answers) || 0
        };
        return base;
    };
    const totalsRaw = d.totals && typeof d.totals === "object" ? d.totals : {};
    const tr = d.trader && typeof d.trader === "object" ? d.trader : {};
    const sq = d.squares && typeof d.squares === "object" ? d.squares : {};
    const fo = d.bullion && typeof d.bullion === "object" ? d.bullion : {};
    const sx = d.sixes && typeof d.sixes === "object" ? d.sixes : {};
    const lg = d.leagues && typeof d.leagues === "object" ? d.leagues : {};
    return {
        xp: (0, _xp.parseXpSummary)(d.xp),
        trader: {
            trades: Number(tr.trades) || 0,
            won: Number(tr.won) || 0,
            profit: Number(tr.profit) || 0,
            total_winnings: Number(tr.total_winnings) || 0,
            current_win_streak: Number(tr.current_win_streak) || 0,
            record_win_streak: Number(tr.record_win_streak) || 0,
            biggest_win: Number(tr.biggest_win) || 0
        },
        squares: {
            played: Number(sq.played) || 0,
            won: Number(sq.won) || 0,
            net_winnings: Number(sq.net_winnings) || 0
        },
        bullion: {
            played: Number(fo.played) || 0,
            won: Number(fo.won) || 0,
            net_winnings: (()=>{
                const n = Number(fo.net_winnings);
                return Number.isFinite(n) ? n : 0;
            })()
        },
        sixes: {
            played: Number(sx.played) || 0,
            net_winnings: (()=>{
                const n = Number(sx.net_winnings);
                return Number.isFinite(n) ? n : 0;
            })(),
            biggest_win: (()=>{
                const n = Number(sx.biggest_win);
                return Number.isFinite(n) ? n : 0;
            })()
        },
        leagues: {
            played: Number(lg.played) || 0,
            won: Number(lg.won) || 0,
            net_winnings: (()=>{
                const n = Number(lg.net_winnings);
                return Number.isFinite(n) ? n : 0;
            })()
        },
        mini_games: {
            "wheel-spin": pickMini("wheel-spin"),
            "quickfire-trivia": pickMini("quickfire-trivia")
        },
        totals: {
            games_played: Number(totalsRaw.games_played) || 0,
            net_coins_won: Number(totalsRaw.net_coins_won) || 0
        }
    };
}
function fallbackCareerSummaryZeros() {
    return {
        xp: null,
        trader: {
            trades: 0,
            won: 0,
            profit: 0,
            total_winnings: 0,
            current_win_streak: 0,
            record_win_streak: 0,
            biggest_win: 0
        },
        squares: {
            played: 0,
            won: 0,
            net_winnings: 0
        },
        bullion: {
            played: 0,
            won: 0,
            net_winnings: 0
        },
        sixes: {
            played: 0,
            net_winnings: 0,
            biggest_win: 0
        },
        leagues: {
            played: 0,
            won: 0,
            net_winnings: 0
        },
        mini_games: {
            "wheel-spin": emptyMiniGamesRow(),
            "quickfire-trivia": emptyQuickfireMiniGamesRow()
        },
        totals: {
            games_played: 0,
            net_coins_won: 0
        }
    };
}
function coercePublicCareer(career) {
    if (!career || typeof career !== "object") return null;
    return parseCareerSummaryPayload(career);
}

},{"../../utils/xp":"jFgAi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7Q66":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PublicProfile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _reactRouterDom = require("react-router-dom");
var _profileAvatar = require("./ProfileAvatar");
var _profileLink = require("./ProfileLink");
var _profileGlobalModalContext = require("./ProfileGlobalModalContext");
var _traderDataFetcherContext = require("../../Data/TraderDataFetcherContext");
var _useSocialSyncRefresh = require("../../hooks/useSocialSyncRefresh");
var _userContext = require("../../Data/UserContext");
var _authHeaders = require("../../utils/authHeaders");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _mutedFriendsStorage = require("../../utils/mutedFriendsStorage");
var _countries = require("../Account/Countries");
var _sessionUser = require("../../utils/sessionUser");
var _profileFavouritesStrip = require("./ProfileFavouritesStrip");
var _profileFavSportIcons = require("./profileFavSportIcons");
var _profileFavFootballTeams = require("./profileFavFootballTeams");
var _profileFavIplTeams = require("./profileFavIplTeams");
var _profileFavCricketIntTeams = require("./profileFavCricketIntTeams");
var _favouriteTeams = require("../../utils/favouriteTeams");
var _cricketTeamCanonical = require("../../utils/cricketTeamCanonical");
var _friendDisplayName = require("../../utils/friendDisplayName");
var _profileNameStack = require("./ProfileNameStack");
var _profileFavCricketers = require("./profileFavCricketers");
var _careerStatsStack = require("./CareerStatsStack");
var _careerStatCardHeader = require("./CareerStatCardHeader");
var _careerSummary = require("./careerSummary");
var _modalHistoryBack = require("../../utils/modalHistoryBack");
var _squaresChallengeFriendModal = require("../MyZone/SquaresChallengeFriendModal");
var _squaresChallengeFriendModalDefault = parcelHelpers.interopDefault(_squaresChallengeFriendModal);
var _challengeGameSelectPopover = require("../MyZone/ChallengeGameSelectPopover");
var _challengeGameSelectPopoverDefault = parcelHelpers.interopDefault(_challengeGameSelectPopover);
var _bullionPrivateContestsFriendModal = require("../MyZone/BullionPrivateContestsFriendModal");
var _bullionPrivateContestsFriendModalDefault = parcelHelpers.interopDefault(_bullionPrivateContestsFriendModal);
var _areYouSureModal = require("../Modals/AreYouSureModal");
var _areYouSureModalDefault = parcelHelpers.interopDefault(_areYouSureModal);
var _threeDotsCircleIcon = require("../../icons/ThreeDotsCircleIcon/ThreeDotsCircleIcon");
var _modalCloseIcon = require("../ModalCloseIcon");
var _matchNameDisplay = require("../../utils/matchNameDisplay");
var _matchesHubNavigation = require("../Matches/matchesHubNavigation");
var _traderActivityNavigation = require("../../utils/traderActivityNavigation");
var _friendActivityTimeline = require("../MyZone/FriendActivityTimeline");
var _friendActivityTimelineDefault = parcelHelpers.interopDefault(_friendActivityTimeline);
var _useLiveSquaresChallengeFromLobby = require("../../hooks/useLiveSquaresChallengeFromLobby");
var _useGamesEnabled = require("../../hooks/useGamesEnabled");
var _useMyLeaguesLists = require("../Leagues/hooks/useMyLeaguesLists");
var _xp = require("../../utils/xp");
const PUBLIC_PROFILE_CACHE_TTL_MS = 45000;
function publicProfileCacheKey(identifier, viewerUserId) {
    const viewer = viewerUserId != null && String(viewerUserId).trim() !== "" ? String(viewerUserId) : "anon";
    return `c8_public_profile_${viewer}_${identifier.trim().toLowerCase()}`;
}
function parseRestrictedPreviewFromApi(raw) {
    if (!raw || typeof raw !== "object") return null;
    const o = raw;
    return {
        player_name: typeof o.player_name === "string" ? o.player_name : null,
        username: typeof o.username === "string" ? o.username : null,
        profile_pic: typeof o.profile_pic === "string" ? o.profile_pic : null,
        avatar_url: typeof o.avatar_url === "string" ? o.avatar_url : null,
        avatar_color: typeof o.avatar_color === "string" ? o.avatar_color : null,
        first_letter: typeof o.first_letter === "string" ? o.first_letter : null,
        xp_week_crown: typeof o.xp_week_crown === "string" ? o.xp_week_crown : null,
        avatar_frame_url: typeof o.avatar_frame_url === "string" ? o.avatar_frame_url : null,
        avatar_frame_small_url: typeof o.avatar_frame_small_url === "string" ? o.avatar_frame_small_url : null
    };
}
function readPublicProfileCache(identifier, viewerUserId) {
    try {
        const raw = sessionStorage.getItem(publicProfileCacheKey(identifier, viewerUserId));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const ts = typeof parsed.ts === "number" ? parsed.ts : 0;
        if (!ts || Date.now() - ts > PUBLIC_PROFILE_CACHE_TTL_MS) return null;
        return {
            profile: parsed.profile ?? null,
            privateMessage: parsed.privateMessage ?? null,
            restrictedPreview: parsed.restrictedPreview ?? null
        };
    } catch  {
        return null;
    }
}
function writePublicProfileCache(identifier, viewerUserId, payload) {
    try {
        sessionStorage.setItem(publicProfileCacheKey(identifier, viewerUserId), JSON.stringify({
            ts: Date.now(),
            ...payload
        }));
    } catch  {
    // ignore storage errors
    }
}
/** Leaderboard / Squares listed bots: no real account (`userId` 0). */ function isNonUserPublicProfile(profile) {
    if (!profile) return false;
    if (profile.synthetic_bot) return true;
    return Number(profile.userId) <= 0;
}
/**
 * Hidden / bot / not-found public profile — same header grid as a visible public profile
 * (OFFLINE + dot col 1, avatar + name col 2, modal close col 3); message in scroll body.
 */ function ProfileUnavailablePanel({ message, onClose, identity }) {
    const hasIdentity = Boolean(identity && (identity.player_name?.trim() || identity.username?.trim() || identity.profile_pic?.trim() || identity.avatar_url?.trim()));
    const rawPhotoUrl = (0, _sessionUser.resolveAvatarUrl)({
        profile_pic: identity?.profile_pic,
        avatar_url: identity?.avatar_url
    });
    const resolvedHeroSrc = (0, _sessionUser.toProfileHeroAvatarUrl)(rawPhotoUrl);
    const rawHadPhoto = Boolean(rawPhotoUrl && String(rawPhotoUrl).trim());
    const displayNameForAvatar = identity?.player_name || identity?.username || null;
    const displayName = hasIdentity ? (identity.player_name || identity.username || "Player").trim().toUpperCase() || "PLAYER" : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid shrink-0 grid-cols-[1fr_auto_1fr] items-start gap-x-2 border-b border-white/10 px-3 py-1.5 sm:py-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col-start-1 flex min-w-0 flex-col items-start gap-2 self-start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "flex items-center gap-1.5 font-anton text-[8px] font-normal uppercase leading-[12px] tracking-normal text-white/55 [leading-trim:none]",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "h-[7px] w-[7px] shrink-0 rounded-full bg-white/45",
                                    "aria-hidden": true
                                }),
                                "OFFLINE"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col-start-2 flex max-w-[min(100%,11rem)] flex-col items-center gap-3 justify-self-center self-start sm:max-w-[13rem]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "relative shrink-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileAvatar.ProfileAvatarHeroWithFallback), {
                                    resolvedSrc: resolvedHeroSrc,
                                    rawHadPhoto: rawHadPhoto,
                                    displayName: displayNameForAvatar,
                                    avatarColor: identity?.avatar_color,
                                    firstLetter: identity?.first_letter,
                                    xpWeekCrown: identity?.xp_week_crown,
                                    avatarFrameUrl: identity?.avatar_frame_url,
                                    avatarFrameSmallUrl: identity?.avatar_frame_small_url
                                })
                            }),
                            displayName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "w-full max-w-full truncate text-center font-anton text-[20px] font-normal uppercase leading-[26px] tracking-normal text-white [leading-trim:none]",
                                children: displayName
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col-start-3 justify-self-end self-start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseButton), {
                            onClick: onClose,
                            ariaLabel: "Close profile",
                            className: "h-11 w-11 shrink-0 translate-x-1.5 -translate-y-1.5 rounded-none hover:bg-white/10 hover:opacity-100"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex min-h-0 flex-1 flex-col items-center justify-center overflow-y-auto overscroll-contain px-3 pb-8 pt-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "max-w-md text-center text-sm text-white/80",
                    children: message
                })
            })
        ]
    });
}
function formatCoins(amount) {
    return new Intl.NumberFormat("en-IN").format(Math.round(amount));
}
function formatActivityRelative(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const sec = Math.max(0, Math.floor((Date.now() - d.getTime()) / 1000));
    if (sec < 60) return `${sec}s`;
    if (sec < 3600) return `${Math.floor(sec / 60)}m`;
    if (sec < 86400) return `${Math.floor(sec / 3600)}h`;
    if (sec < 604800) return `${Math.floor(sec / 86400)}d`;
    return `${Math.floor(sec / 604800)}w`;
}
function profileIsOnlineNow(profile) {
    if (!profile) return false;
    if (typeof profile.is_online === "boolean") return profile.is_online;
    if (typeof profile.online === "boolean") return profile.online;
    if (typeof profile.online_status === "boolean") return profile.online_status;
    if (typeof profile.online_status === "string") {
        const status = profile.online_status.trim().toLowerCase();
        if (status === "online") return true;
        if (status === "offline") return false;
    }
    if (typeof profile.presence === "boolean") return profile.presence;
    if (typeof profile.presence === "string") {
        const status = profile.presence.trim().toLowerCase();
        if (status === "online") return true;
        if (status === "offline") return false;
    }
    if (profile.presence && typeof profile.presence === "object" && typeof profile.presence.online === "boolean") return profile.presence.online;
    return false;
}
function gameValues(games, name) {
    const g = games?.find((x)=>x.name === name);
    const v = g?.values || {};
    return {
        played: typeof v.played === "number" ? v.played : Number(v.played) || 0,
        lastwon: typeof v.lastwon === "number" ? v.lastwon : Number(v.lastwon) || 0,
        answered: typeof v.answered === "number" ? v.answered : Number(v.answered) || 0,
        questions: typeof v.questionstoanswer === "number" ? v.questionstoanswer : Number(v.questionstoanswer) || 0
    };
}
function PublicProfile({ identifier, onClose }) {
    const { openOwnProfile, dismissProfileModalForNavigation } = (0, _profileGlobalModalContext.useProfileGlobalModal)();
    const { fetchMyGamesOverview } = (0, _traderDataFetcherContext.useTraderDataFetcher)();
    const { user } = (0, _userContext.useUser)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const profileLinkBackground = {
        from: location.state?.from ?? {
            pathname: location.pathname,
            search: location.search
        }
    };
    const navigateFromProfileOverlay = (0, _react.useCallback)((to)=>{
        dismissProfileModalForNavigation();
        navigate(to, {
            state: profileLinkBackground
        });
    }, [
        dismissProfileModalForNavigation,
        navigate,
        profileLinkBackground
    ]);
    const [profile, setProfile] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [privateMessage, setPrivateMessage] = (0, _react.useState)(null);
    const [restrictedPreview, setRestrictedPreview] = (0, _react.useState)(null);
    const [addFriendState, setAddFriendState] = (0, _react.useState)("idle");
    const [removeFriendLoading, setRemoveFriendLoading] = (0, _react.useState)(false);
    const [acceptRequestLoading, setAcceptRequestLoading] = (0, _react.useState)(false);
    const [cancelRequestLoading, setCancelRequestLoading] = (0, _react.useState)(false);
    const [squaresChallengeFriend, setSquaresChallengeFriend] = (0, _react.useState)(null);
    const [challengeGamePicker, setChallengeGamePicker] = (0, _react.useState)(null);
    const [bullionContestFriend, setBullionContestFriend] = (0, _react.useState)(null);
    const openChallengedMatchFromProfile = (0, _react.useCallback)((href)=>{
        setChallengeGamePicker(null);
        setSquaresChallengeFriend(null);
        setBullionContestFriend(null);
        const background = {
            from: location.state?.from ?? {
                pathname: location.pathname,
                search: location.search
            }
        };
        (0, _modalHistoryBack.whenModalHistoryIdle)(()=>{
            dismissProfileModalForNavigation();
            navigate(href, {
                state: background
            });
        });
    }, [
        dismissProfileModalForNavigation,
        location.pathname,
        location.search,
        location.state,
        navigate
    ]);
    const [friendProfileMenuOpen, setFriendProfileMenuOpen] = (0, _react.useState)(false);
    const [confirmFriendProfileAction, setConfirmFriendProfileAction] = (0, _react.useState)(null);
    const [profileFriendMuted, setProfileFriendMuted] = (0, _react.useState)(false);
    const [muteFriendLoading, setMuteFriendLoading] = (0, _react.useState)(false);
    const [friendFeedDigests, setFriendFeedDigests] = (0, _react.useState)([]);
    const [friendLiveFriends, setFriendLiveFriends] = (0, _react.useState)([]);
    const [friendFeedMyTrades, setFriendFeedMyTrades] = (0, _react.useState)([]);
    const [friendFeedMySquares, setFriendFeedMySquares] = (0, _react.useState)([]);
    const [friendFeedLoading, setFriendFeedLoading] = (0, _react.useState)(false);
    const [friendFeedLoadingMore, setFriendFeedLoadingMore] = (0, _react.useState)(false);
    const [friendFeedHasMore, setFriendFeedHasMore] = (0, _react.useState)(false);
    const [friendFeedResultsLimit, setFriendFeedResultsLimit] = (0, _react.useState)(10);
    const [profileRefreshTick, setProfileRefreshTick] = (0, _react.useState)(0);
    const liveSquaresForChallenge = (0, _useLiveSquaresChallengeFromLobby.useLiveSquaresChallengeFromLobby)({
        enabled: Boolean(user && profile && !isNonUserPublicProfile(profile) && profile.friendshipStatus === "friends" && Number(profile.userId) !== Number(user.userId))
    });
    const { isBullionEnabled } = (0, _useGamesEnabled.useGamesEnabled)();
    const leaguesAccess = (0, _useMyLeaguesLists.useLeaguesAccess)();
    const showLeaguesChallenge = leaguesAccess.ready && leaguesAccess.vip;
    const canChallengeFriend = isBullionEnabled || liveSquaresForChallenge || showLeaguesChallenge;
    const fetchProfile = (0, _react.useCallback)(async (opts)=>{
        const requestedSilent = opts?.silent === true;
        if (!identifier?.trim()) {
            if (!requestedSilent) setLoading(false);
            return;
        }
        const cached = readPublicProfileCache(identifier, user?.userId);
        const silent = requestedSilent || Boolean(cached);
        if (!requestedSilent && cached) {
            setProfile(cached.profile);
            setPrivateMessage(cached.privateMessage);
            setRestrictedPreview(cached.restrictedPreview ?? null);
            setLoading(false);
        } else if (!silent) {
            setLoading(true);
            setPrivateMessage(null);
            setRestrictedPreview(null);
        }
        try {
            const url = `${"https://cricket8.com/api"}/account/public-profile/${encodeURIComponent(identifier.trim())}`;
            const res = await fetch(url, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            if (res.ok) {
                const data = await res.json();
                setProfile(data);
                setPrivateMessage(null);
                setRestrictedPreview(null);
                writePublicProfileCache(identifier, user?.userId, {
                    profile: data,
                    privateMessage: null,
                    restrictedPreview: null
                });
            } else if (res.status === 403) {
                const data = await res.json().catch(()=>({}));
                const pm = typeof data.message === "string" && data.message.trim() ? data.message : "This profile is not visible to others.";
                const preview = parseRestrictedPreviewFromApi(data.preview);
                setProfile(null);
                setPrivateMessage(pm);
                setRestrictedPreview(preview);
                writePublicProfileCache(identifier, user?.userId, {
                    profile: null,
                    privateMessage: pm,
                    restrictedPreview: preview
                });
            } else if (!silent) {
                setProfile(null);
                setPrivateMessage(null);
                setRestrictedPreview(null);
            }
        } catch  {
            if (!silent) {
                setProfile(null);
                setPrivateMessage(null);
                setRestrictedPreview(null);
            }
        } finally{
            if (!silent) setLoading(false);
        }
    }, [
        identifier,
        user?.userId
    ]);
    (0, _react.useEffect)(()=>{
        fetchProfile();
    }, [
        fetchProfile
    ]);
    /** Rare visible-only reconcile; primary updates from c8-* listeners below. */ (0, _useSocialSyncRefresh.useVisibleStaleFallback)(()=>{
        fetchProfile({
            silent: true
        });
        setProfileRefreshTick((n)=>n + 1);
    }, Boolean(identifier?.trim()));
    (0, _react.useEffect)(()=>{
        let timer = null;
        const scheduleRefresh = ()=>{
            if (timer != null) window.clearTimeout(timer);
            timer = window.setTimeout(()=>{
                timer = null;
                fetchProfile({
                    silent: true
                });
                setProfileRefreshTick((n)=>n + 1);
            }, 450);
        };
        window.addEventListener("c8-profile-dirty", scheduleRefresh);
        window.addEventListener("c8-activity-updated", scheduleRefresh);
        window.addEventListener("c8-my-games-dirty", scheduleRefresh);
        window.addEventListener("c8-friends-dirty", scheduleRefresh);
        window.addEventListener("c8-notifications-updated", scheduleRefresh);
        return ()=>{
            if (timer != null) window.clearTimeout(timer);
            window.removeEventListener("c8-profile-dirty", scheduleRefresh);
            window.removeEventListener("c8-activity-updated", scheduleRefresh);
            window.removeEventListener("c8-my-games-dirty", scheduleRefresh);
            window.removeEventListener("c8-friends-dirty", scheduleRefresh);
            window.removeEventListener("c8-notifications-updated", scheduleRefresh);
        };
    }, [
        fetchProfile
    ]);
    (0, _react.useEffect)(()=>{
        if (profile) document.title = `${(0, _friendDisplayName.playerHandleName)(profile)} | Cricket8`;
        return ()=>{
            document.title = "Cricket8";
        };
    }, [
        profile
    ]);
    (0, _react.useEffect)(()=>{
        setFriendProfileMenuOpen(false);
        setProfileFriendMuted(false);
        setConfirmFriendProfileAction(null);
    }, [
        identifier
    ]);
    (0, _react.useEffect)(()=>{
        const viewerId = user?.userId != null ? Number(user.userId) : null;
        if (viewerId == null || profile?.userId == null || isNonUserPublicProfile(profile)) {
            setProfileFriendMuted(false);
            return;
        }
        const sync = ()=>setProfileFriendMuted((0, _mutedFriendsStorage.getMutedFriendIdsSet)(viewerId).has(Number(profile.userId)));
        sync();
        window.addEventListener((0, _mutedFriendsStorage.MUTED_FRIENDS_CHANGED_EVENT), sync);
        return ()=>window.removeEventListener((0, _mutedFriendsStorage.MUTED_FRIENDS_CHANGED_EVENT), sync);
    }, [
        user?.userId,
        profile?.userId
    ]);
    (0, _react.useEffect)(()=>{
        setFriendFeedDigests([]);
        setFriendLiveFriends([]);
        setFriendFeedMyTrades([]);
        setFriendFeedMySquares([]);
        setFriendFeedHasMore(false);
        setFriendFeedResultsLimit(10);
        setFriendFeedLoadingMore(false);
        setFriendFeedLoading(false);
    }, [
        identifier
    ]);
    (0, _react.useEffect)(()=>{
        const viewerId = user?.userId != null ? Number(user.userId) : null;
        if (viewerId == null || !profile) {
            setFriendFeedDigests([]);
            setFriendLiveFriends([]);
            setFriendFeedMyTrades([]);
            setFriendFeedMySquares([]);
            setFriendFeedLoading(false);
            return;
        }
        if (isNonUserPublicProfile(profile)) {
            setFriendFeedDigests([]);
            setFriendLiveFriends([]);
            setFriendFeedMyTrades([]);
            setFriendFeedMySquares([]);
            setFriendFeedLoading(false);
            return;
        }
        const viewingOwnProfile = Number(profile.userId) === viewerId;
        if (!viewingOwnProfile && profile.friendshipStatus !== "friends") {
            setFriendFeedDigests([]);
            setFriendLiveFriends([]);
            setFriendFeedMyTrades([]);
            setFriendFeedMySquares([]);
            setFriendFeedLoading(false);
            return;
        }
        let cancelled = false;
        const controller = new AbortController();
        const hasExistingFeedData = friendFeedDigests.length > 0 || friendLiveFriends.length > 0 || friendFeedMyTrades.length > 0 || friendFeedMySquares.length > 0;
        const isIncrementalLoad = hasExistingFeedData;
        if (!isIncrementalLoad) setFriendFeedLoading(true);
        else setFriendFeedLoadingMore(true);
        const uid = profile.userId;
        const sessionToken = (0, _jsCookieDefault.default).get("c8_session_token");
        const actUrl = `${"https://cricket8.com/api"}/account/friends-activity?${new URLSearchParams({
            friend_id: String(uid),
            recent_days: "7",
            results_limit: String(friendFeedResultsLimit)
        })}`;
        Promise.all([
            fetch(actUrl, {
                method: "GET",
                headers: (0, _authHeaders.getAuthHeaders)(),
                signal: controller.signal
            }),
            sessionToken ? fetchMyGamesOverview() : Promise.resolve(null)
        ]).then(async ([actRes, myGamesPayload])=>{
            if (cancelled) return;
            if (actRes.ok) {
                const data = await actRes.json();
                setFriendFeedDigests((0, _friendActivityTimeline.mapDigestRows)(data));
                setFriendFeedHasMore(Boolean(data.has_more));
                const lf = data.live_friend;
                if (lf && typeof lf === "object" && lf.userId != null) setFriendLiveFriends([
                    lf
                ]);
                else setFriendLiveFriends([]);
            } else {
                setFriendFeedDigests([]);
                setFriendLiveFriends([]);
            }
            if (myGamesPayload?.active) {
                setFriendFeedMyTrades(Array.isArray(myGamesPayload.active.trades) ? myGamesPayload.active.trades : []);
                setFriendFeedMySquares(Array.isArray(myGamesPayload.active.squares) ? myGamesPayload.active.squares : []);
            } else {
                setFriendFeedMyTrades([]);
                setFriendFeedMySquares([]);
            }
            if (!cancelled) {
                setFriendFeedLoading(false);
                setFriendFeedLoadingMore(false);
            }
        }).catch(()=>{
            if (controller.signal.aborted) return;
            if (!cancelled) {
                setFriendFeedDigests([]);
                setFriendLiveFriends([]);
                setFriendFeedMyTrades([]);
                setFriendFeedMySquares([]);
                setFriendFeedHasMore(false);
                setFriendFeedLoading(false);
                setFriendFeedLoadingMore(false);
            }
        });
        return ()=>{
            cancelled = true;
            controller.abort();
        };
    }, [
        fetchMyGamesOverview,
        profileRefreshTick,
        user?.userId,
        profile?.userId,
        profile?.friendshipStatus,
        profile?.synthetic_bot,
        friendFeedDigests.length,
        friendLiveFriends.length,
        friendFeedMyTrades.length,
        friendFeedMySquares.length,
        friendFeedResultsLimit
    ]);
    (0, _react.useEffect)(()=>{
        if (!friendProfileMenuOpen) return;
        const handleDocumentPointerDown = (event)=>{
            const target = event.target;
            if (!(target instanceof Element)) return;
            if (target.closest("[data-public-friend-actions]")) return;
            setFriendProfileMenuOpen(false);
        };
        document.addEventListener("pointerdown", handleDocumentPointerDown);
        return ()=>document.removeEventListener("pointerdown", handleDocumentPointerDown);
    }, [
        friendProfileMenuOpen
    ]);
    const handleAddFriend = (0, _react.useCallback)(async ()=>{
        if (!user) {
            const returnTo = window.location.pathname + window.location.search;
            navigate(`/login?back=${encodeURIComponent(returnTo)}`, {
                replace: true
            });
            return;
        }
        if (isNonUserPublicProfile(profile)) return;
        if (profile?.userId === user.userId) {
            openOwnProfile();
            return;
        }
        setAddFriendState("loading");
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/friend-request/send`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    receiver_id: profile.userId
                })
            });
            const data = res.ok ? await res.json().catch(()=>({})) : await res.json().catch(()=>({}));
            if (res.ok && data.success) {
                (0, _frontendTrackingEvents.trackFriendRequestSent)({
                    user_id: user.userId,
                    sender_user_id: user.userId,
                    receiver_user_id: profile.userId,
                    pathname: location.pathname
                });
                setProfile((p)=>p ? {
                        ...p,
                        friendshipStatus: "pending_sent"
                    } : null);
            } else {
                const err = data?.error;
                if (err === "already_friends") setProfile((p)=>p ? {
                        ...p,
                        friendshipStatus: "friends"
                    } : null);
                else if (err === "pending" || err === "pending_received") setProfile((p)=>p ? {
                        ...p,
                        friendshipStatus: err === "pending_received" ? "pending_received" : "pending_sent"
                    } : null);
                else if (err === "requests_disabled") setProfile((p)=>p ? {
                        ...p,
                        accept_friend_requests: false
                    } : null);
                else setAddFriendState("error");
            }
        } catch  {
            setAddFriendState("error");
        } finally{
            setAddFriendState((s)=>s === "loading" ? "idle" : s);
        }
    }, [
        user,
        profile?.userId,
        profile?.synthetic_bot,
        navigate,
        openOwnProfile,
        location.pathname
    ]);
    const handleRemoveFriend = (0, _react.useCallback)(async ()=>{
        if (!user || !profile || profile.friendshipStatus !== "friends") return;
        setRemoveFriendLoading(true);
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/friend/remove`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    friend_id: profile.userId
                })
            });
            const data = res.ok ? await res.json().catch(()=>({})) : {};
            if (res.ok && data.success) {
                if (user?.userId != null && profile?.userId != null) (0, _mutedFriendsStorage.removeMutedFriend)(Number(user.userId), Number(profile.userId));
                setProfile((p)=>p ? {
                        ...p,
                        friendshipStatus: "none"
                    } : null);
                setFriendProfileMenuOpen(false);
                setProfileFriendMuted(false);
            }
        } finally{
            setRemoveFriendLoading(false);
        }
    }, [
        user,
        profile?.userId,
        profile?.friendshipStatus
    ]);
    const handleMuteProfileFriend = (0, _react.useCallback)(async ()=>{
        if (!profile || user?.userId == null) return;
        setMuteFriendLoading(true);
        try {
            (0, _mutedFriendsStorage.addMutedFriend)(Number(user.userId), Number(profile.userId));
            setProfileFriendMuted(true);
        } finally{
            setMuteFriendLoading(false);
        }
    }, [
        profile,
        user?.userId
    ]);
    const handleUnmuteProfileFriend = (0, _react.useCallback)(async ()=>{
        if (!profile || user?.userId == null) return;
        setMuteFriendLoading(true);
        try {
            (0, _mutedFriendsStorage.removeMutedFriend)(user.userId, profile.userId);
            setProfileFriendMuted(false);
        } finally{
            setMuteFriendLoading(false);
        }
    }, [
        profile,
        user?.userId
    ]);
    const closeConfirmFriendProfileAction = (0, _react.useCallback)(()=>{
        setConfirmFriendProfileAction(null);
    }, []);
    const confirmSelectedFriendProfileAction = (0, _react.useCallback)(async ()=>{
        if (!confirmFriendProfileAction) return;
        if (confirmFriendProfileAction === "remove") await handleRemoveFriend();
        else if (confirmFriendProfileAction === "unmute") await handleUnmuteProfileFriend();
        else await handleMuteProfileFriend();
        setConfirmFriendProfileAction(null);
    }, [
        confirmFriendProfileAction,
        handleRemoveFriend,
        handleMuteProfileFriend,
        handleUnmuteProfileFriend
    ]);
    const handleAcceptFriendRequest = (0, _react.useCallback)(async ()=>{
        if (!user || !profile || profile.friendshipStatus !== "pending_received" || profile.friendRequestId == null) return;
        setAcceptRequestLoading(true);
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/friend-request/accept`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    request_id: profile.friendRequestId
                })
            });
            const data = res.ok ? await res.json().catch(()=>({})) : {};
            if (res.ok && data.success) {
                if (user?.userId != null && profile?.userId != null) (0, _frontendTrackingEvents.trackFriendRequestResponse)({
                    user_id: user.userId,
                    response: "accepted",
                    friend_request_sender_user_id: profile.userId,
                    friend_request_receiver_user_id: user.userId,
                    pathname: location.pathname
                });
                setProfile((p)=>p ? {
                        ...p,
                        friendshipStatus: "friends"
                    } : null);
            }
        } finally{
            setAcceptRequestLoading(false);
        }
    }, [
        user,
        profile?.friendshipStatus,
        profile?.friendRequestId,
        profile?.userId,
        location.pathname
    ]);
    const handleCancelFriendRequest = (0, _react.useCallback)(async ()=>{
        if (!user || !profile || profile.friendshipStatus !== "pending_sent") return;
        setCancelRequestLoading(true);
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/friend-request/cancel`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    receiver_id: profile.userId
                })
            });
            const data = res.ok ? await res.json().catch(()=>({})) : await res.json().catch(()=>({}));
            if (res.ok && data.success) {
                (0, _frontendTrackingEvents.trackFriendRequestCancelled)({
                    user_id: user.userId,
                    sender_user_id: user.userId,
                    receiver_user_id: profile.userId,
                    pathname: location.pathname
                });
                setProfile((p)=>p ? {
                        ...p,
                        friendshipStatus: "none"
                    } : null);
            } else if (data?.error === "not_found") setProfile((p)=>p ? {
                    ...p,
                    friendshipStatus: "none"
                } : null);
        } finally{
            setCancelRequestLoading(false);
        }
    }, [
        user,
        profile?.friendshipStatus,
        profile?.userId,
        location.pathname
    ]);
    const isOwnProfile = Boolean(user && profile && Number(profile.userId) === Number(user.userId));
    const country = profile?.country?.trim() || "";
    const favourites = profile?.favourites ? (0, _favouriteTeams.normalizeFavourites)(profile.favourites) : null;
    const joinDateShort = profile?.created_at ? new Date(profile.created_at).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    }) : null;
    const games = profile?.games;
    const spin = gameValues(games, "wheel-spin");
    const wheelTrivia = gameValues(games, "wheel-trivia");
    const wheelLegacyLastwon = spin.lastwon + wheelTrivia.lastwon;
    const career = profile?.career;
    const careerLedger = career ? (0, _careerSummary.coercePublicCareer)(career) : null;
    const friendsPreview = profile?.friends_preview ?? [];
    const recent = profile?.recent_activity ?? [];
    const legacyMiniGamesPlayed = games?.reduce((sum, g)=>{
        if (g.name !== "quickfire-trivia") return sum;
        const p = g.values?.played;
        const n = typeof p === "number" ? p : Number(p);
        return sum + (Number.isFinite(n) ? n : 0);
    }, 0) ?? 0;
    const legacyCoinsWonHeader = (games?.reduce((sum, g)=>{
        const w = g.values?.lastwon;
        const n = typeof w === "number" ? w : Number(w);
        if (g.name === "quickfire-trivia") return sum + (Number.isFinite(n) ? n : 0);
        return sum;
    }, 0) ?? 0) + (career?.trader?.profit ?? 0) + (career?.squares?.net_winnings ?? 0) + (careerLedger?.bullion.net_winnings ?? career?.bullion?.net_winnings ?? 0) + (careerLedger?.sixes.net_winnings ?? career?.sixes?.net_winnings ?? 0) + (careerLedger?.leagues.net_winnings ?? career?.leagues?.net_winnings ?? 0);
    const totalGamesPlayed = careerLedger != null ? careerLedger.totals.games_played : legacyMiniGamesPlayed + (career?.trader?.trades ?? 0) + (career?.squares?.played ?? 0) + (career?.bullion?.played ?? 0) + (career?.sixes?.played ?? 0) + (career?.leagues?.played ?? 0);
    const coinsWonDisplay = careerLedger != null ? careerLedger.totals.net_coins_won : legacyCoinsWonHeader;
    const favChips = [];
    for (const label of (0, _profileFavSportIcons.parseFavSportsFromStorage)(favourites?.favsports))favChips.push({
        key: `sport-${label}`,
        label
    });
    for (const slug of (0, _profileFavCricketers.parseFavCricketersFromStorage)(favourites?.favcricketers))favChips.push({
        key: `cr-${slug}`,
        label: (0, _profileFavCricketers.favCricketerLabel)(slug)
    });
    const iplStoreSlugs = (0, _profileFavIplTeams.parseFavIplFromStorage)(favourites?.faviplteams);
    const nationalStoreSlugs = (0, _profileFavCricketIntTeams.parseFavCricketIntFromStorage)(favourites?.favnationalteams);
    const pickerTeamSlugs = new Set([
        ...iplStoreSlugs,
        ...nationalStoreSlugs
    ].map((0, _cricketTeamCanonical.canonicalTeamSlug)));
    for (const slug of iplStoreSlugs)favChips.push({
        key: `ipl-${slug}`,
        label: (0, _profileFavIplTeams.favIplLabel)(slug),
        longLabel: (0, _profileFavIplTeams.favIplLongLabel)(slug)
    });
    for (const slug of nationalStoreSlugs)favChips.push({
        key: `cint-${slug}`,
        label: (0, _profileFavCricketIntTeams.favCricketIntLabel)(slug)
    });
    for (const name of (0, _favouriteTeams.parseFavTeamsFromStorage)(favourites?.favcustomcricketteams)){
        if (pickerTeamSlugs.has((0, _cricketTeamCanonical.canonicalTeamSlug)(name))) continue;
        favChips.push({
            key: `team-${(0, _favouriteTeams.slugifyTeamName)(name)}`,
            label: name,
            longLabel: name
        });
    }
    for (const slug of (0, _profileFavFootballTeams.parseFavFootballFromStorage)(favourites?.favfootballteams))favChips.push({
        key: `fb-${slug}`,
        label: (0, _profileFavFootballTeams.favFootballLabel)(slug),
        longLabel: (0, _profileFavFootballTeams.favFootballLongLabel)(slug)
    });
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid shrink-0 grid-cols-[1fr_auto_1fr] items-start gap-x-2 border-b border-white/10 px-3 py-1.5 sm:py-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col-start-1 mt-1 h-4 w-16 animate-pulse bg-white/12"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col-start-2 flex flex-col items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "h-[86px] w-[86px] animate-pulse bg-white/12 sm:h-[92px] sm:w-[92px]"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "h-6 w-36 animate-pulse bg-white/12"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col-start-3 mt-1 h-8 w-8 justify-self-end animate-pulse bg-white/12"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "min-h-0 flex-1 space-y-4 overflow-y-auto px-3 py-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-2 h-3 w-24 animate-pulse bg-white/12"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-2 gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "h-16 animate-pulse bg-white/10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "h-16 animate-pulse bg-white/10"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-2 h-3 w-20 animate-pulse bg-white/12"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-2 gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "h-24 animate-pulse bg-white/10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "h-24 animate-pulse bg-white/10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "h-24 animate-pulse bg-white/10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "h-24 animate-pulse bg-white/10"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mb-2 h-3 w-24 animate-pulse bg-white/12"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-1.5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "h-[46px] animate-pulse bg-white/10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "h-[46px] animate-pulse bg-white/10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "h-[46px] animate-pulse bg-white/10"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    if (!profile) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileUnavailablePanel, {
        message: privateMessage ?? "Profile not found.",
        onClose: onClose,
        identity: restrictedPreview
    });
    if (isNonUserPublicProfile(profile)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileUnavailablePanel, {
        message: "This profile is not visible to others.",
        onClose: onClose,
        identity: {
            player_name: profile.player_name,
            username: profile.username,
            profile_pic: profile.profile_pic,
            avatar_url: profile.avatar_url,
            avatar_color: profile.avatar_color,
            first_letter: profile.first_letter
        }
    });
    const showRealName = (0, _friendDisplayName.canSeeDisplayName)({
        isOwnProfile,
        friendshipStatus: profile.friendshipStatus
    });
    const playerNameLabel = (0, _friendDisplayName.playerHandleName)(profile);
    const realNameLabel = showRealName ? (0, _friendDisplayName.optionalDisplayName)(profile) : null;
    const displayName = playerNameLabel.toUpperCase();
    const rawPhotoUrl = (0, _sessionUser.resolveAvatarUrl)(profile);
    const resolvedHeroSrc = (0, _sessionUser.toProfileHeroAvatarUrl)(rawPhotoUrl);
    const rawHadPhoto = Boolean(rawPhotoUrl && String(rawPhotoUrl).trim());
    const displayNameForAvatar = playerNameLabel;
    /** Chips / activity rows — same URL as hero (letter fallback only on hero). */ const avatarSrc = resolvedHeroSrc;
    const isOnline = profileIsOnlineNow(profile);
    const profileBlocksNewFriendRequests = profile.accept_friend_requests === false && (profile.friendshipStatus === "none" || profile.friendshipStatus == null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid shrink-0 grid-cols-[1fr_auto_1fr] items-start gap-x-2 border-b border-white/10 px-3 py-1.5 sm:py-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col-start-1 flex min-w-0 flex-col items-start gap-2 self-start",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: `flex items-center gap-1.5 font-anton text-[8px] font-normal uppercase leading-[12px] tracking-normal [leading-trim:none] ${isOnline ? "text-[#D2FF00]" : "text-white/55"}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: `h-[7px] w-[7px] shrink-0 rounded-full ${isOnline ? "bg-[#D2FF00]" : "bg-white/45"}`,
                                        "aria-hidden": true
                                    }),
                                    isOnline ? "ONLINE" : "OFFLINE"
                                ]
                            }),
                            !isOwnProfile && !isNonUserPublicProfile(profile) ? user ? profile.friendshipStatus === "friends" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-0 flex shrink-0 items-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            if (!canChallengeFriend) return;
                                            const friend = {
                                                userId: profile.userId,
                                                player_name: profile.player_name,
                                                display_name: profile.display_name,
                                                username: profile.username
                                            };
                                            (0, _frontendTrackingEvents.trackChallengeFriendClicked)({
                                                user_id: user?.userId,
                                                cta_location: "public_profile",
                                                pathname: location.pathname
                                            });
                                            const availableCount = Number(isBullionEnabled) + Number(liveSquaresForChallenge) + Number(showLeaguesChallenge);
                                            if (availableCount === 1) {
                                                if (isBullionEnabled) {
                                                    setBullionContestFriend(friend);
                                                    return;
                                                }
                                                if (liveSquaresForChallenge) {
                                                    setSquaresChallengeFriend(friend);
                                                    return;
                                                }
                                                (0, _useMyLeaguesLists.openCreateLeagueModal)({
                                                    challengeFriendUserId: friend.userId
                                                });
                                                return;
                                            }
                                            setChallengeGamePicker({
                                                friend,
                                                anchorRect: e.currentTarget.getBoundingClientRect()
                                            });
                                        },
                                        disabled: !canChallengeFriend,
                                        title: !canChallengeFriend ? "No challengeable games right now" : undefined,
                                        className: "h-8 shrink-0 cursor-default rounded-none bg-[#D2FF00] px-3 font-anton text-[10px] font-normal uppercase tracking-wide text-black hover:brightness-95 disabled:cursor-default disabled:bg-white/15 disabled:text-white/45 disabled:hover:bg-white/15",
                                        children: "CHALLENGE"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "relative z-20 flex shrink-0 items-center gap-0.5",
                                        "data-public-friend-actions": true,
                                        children: [
                                            profileFriendMuted ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setConfirmFriendProfileAction("unmute"),
                                                disabled: muteFriendLoading,
                                                className: "flex h-8 shrink-0 items-center justify-center rounded-none pr-0.5 enabled:hover:opacity-90 disabled:opacity-50",
                                                title: "Unmute friend",
                                                "aria-label": "Unmute friend",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: "/img/mute-red.svg",
                                                    alt: "",
                                                    className: "h-4 w-4 object-contain",
                                                    width: 16,
                                                    height: 16,
                                                    decoding: "async"
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "relative",
                                                "data-public-friend-actions": true,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setFriendProfileMenuOpen((o)=>!o),
                                                        disabled: removeFriendLoading || muteFriendLoading,
                                                        className: "flex h-[24px] min-w-[24px] items-center justify-center border-0 bg-white/10 px-1 text-white hover:bg-white/20 disabled:opacity-60",
                                                        "aria-label": "More actions",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _threeDotsCircleIcon.ThreeDotsCircleIcon), {
                                                            className: "text-white",
                                                            size: 14
                                                        })
                                                    }),
                                                    friendProfileMenuOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        "data-public-friend-actions": true,
                                                        className: "absolute left-0 top-full z-30 mt-1.5 w-[140px] border border-[#7f5aca] bg-[#7944c3] p-1 shadow-[0_8px_22px_rgba(8,2,18,0.6)]",
                                                        children: [
                                                            profileFriendMuted ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                                type: "button",
                                                                onClick: ()=>{
                                                                    setFriendProfileMenuOpen(false);
                                                                    setConfirmFriendProfileAction("unmute");
                                                                },
                                                                disabled: muteFriendLoading,
                                                                className: "mb-1 flex h-9 w-full items-center justify-start gap-2 bg-[#552ca6] px-3 font-anton text-[14px] text-white hover:bg-[#6138b0] disabled:opacity-60",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: "/img/mute.svg",
                                                                        alt: "",
                                                                        className: "h-4 w-4 shrink-0 opacity-90"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        children: "UNMUTE"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                                type: "button",
                                                                onClick: ()=>{
                                                                    setFriendProfileMenuOpen(false);
                                                                    setConfirmFriendProfileAction("mute");
                                                                },
                                                                disabled: muteFriendLoading,
                                                                className: "mb-1 flex h-9 w-full items-center justify-start gap-2 bg-[#552ca6] px-3 font-anton text-[14px] text-white hover:bg-[#6138b0] disabled:opacity-60",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: "/img/mute.svg",
                                                                        alt: "",
                                                                        className: "h-4 w-4 shrink-0"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        children: "MUTE"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                                type: "button",
                                                                onClick: ()=>{
                                                                    setFriendProfileMenuOpen(false);
                                                                    setConfirmFriendProfileAction("remove");
                                                                },
                                                                disabled: removeFriendLoading,
                                                                className: "flex h-9 w-full items-center justify-start gap-2 bg-[#552ca6] px-3 font-anton text-[14px] text-white hover:bg-[#6138b0] disabled:opacity-60",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: "/img/x.svg",
                                                                        alt: "",
                                                                        className: "h-4 w-4 shrink-0"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        children: "REMOVE"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : profile.friendshipStatus === "pending_sent" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: handleCancelFriendRequest,
                                disabled: cancelRequestLoading,
                                className: "mt-0 h-8 shrink-0 rounded-none bg-white px-3 font-anton text-[10px] font-normal uppercase tracking-wide text-[#1B062F] hover:bg-white/90 disabled:opacity-60",
                                children: cancelRequestLoading ? "\u2026" : "CANCEL REQUEST"
                            }) : profile.friendshipStatus === "pending_received" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: handleAcceptFriendRequest,
                                disabled: acceptRequestLoading,
                                className: "mt-0 h-8 shrink-0 rounded-none bg-[#D2FF00] px-3 font-anton text-[10px] font-normal uppercase tracking-wide text-black hover:brightness-95 disabled:opacity-60",
                                children: acceptRequestLoading ? "\u2026" : "ACCEPT REQUEST"
                            }) : profileBlocksNewFriendRequests ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: handleAddFriend,
                                disabled: addFriendState === "loading",
                                className: "mt-0 inline-flex h-8 min-h-8 shrink-0 items-center justify-center rounded-none border-0 bg-white px-3 font-anton text-[10px] font-normal uppercase tracking-wide text-[#1B062F] hover:bg-white/90 disabled:opacity-60",
                                children: addFriendState === "loading" ? "\u2026" : addFriendState === "error" ? "TRY AGAIN" : "ADD TO FRIENDS"
                            }) : profileBlocksNewFriendRequests ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: handleAddFriend,
                                className: "mt-0 inline-flex h-8 min-h-8 shrink-0 items-center justify-center rounded-none border-0 bg-white px-3 font-anton text-[10px] font-normal uppercase tracking-wide text-[#1B062F] hover:bg-white/90",
                                children: "ADD TO FRIENDS"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col-start-2 flex max-w-[min(100%,11rem)] flex-col items-center gap-3 justify-self-center self-start sm:max-w-[13rem]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "relative shrink-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileAvatar.ProfileAvatarHeroWithFallback), {
                                    resolvedSrc: resolvedHeroSrc,
                                    rawHadPhoto: rawHadPhoto,
                                    displayName: displayNameForAvatar,
                                    avatarColor: profile.avatar_color,
                                    firstLetter: profile.first_letter,
                                    syntheticBotLetterTile: Boolean(profile.synthetic_bot),
                                    xpWeekCrown: profile.xp_week_crown,
                                    avatarFrameUrl: profile.avatar_frame_url,
                                    avatarFrameSmallUrl: profile.avatar_frame_small_url
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileNameStack.ProfileNameStack), {
                                className: "w-full max-w-full",
                                playerName: playerNameLabel,
                                displayName: realNameLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col-start-3 justify-self-end self-start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseButton), {
                            onClick: onClose,
                            ariaLabel: "Close profile",
                            className: "h-11 w-11 shrink-0 translate-x-1.5 -translate-y-1.5 rounded-none hover:bg-white/10 hover:opacity-100"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 pb-8 pt-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-3 mt-2 grid grid-cols-3 gap-2 text-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rounded-none bg-[#652DAF] px-1 py-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "font-anton text-[11px] font-normal uppercase leading-[12px] tracking-normal text-white/40 [leading-trim:none]",
                                        children: "Joined"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "mt-1.5 font-anton text-[15px] font-normal uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                                        children: joinDateShort ?? "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rounded-none bg-[#652DAF] px-1 py-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "font-anton text-[11px] font-normal uppercase leading-[12px] tracking-normal text-white/40 [leading-trim:none]",
                                        children: "Games played"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "mt-1.5 font-anton text-[15px] font-normal uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                                        children: formatCoins(totalGamesPlayed)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rounded-none bg-[#652DAF] px-1 py-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "font-anton text-[11px] font-normal uppercase leading-[12px] tracking-normal text-white/40 [leading-trim:none]",
                                        children: "Game score"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "mt-1.5 flex items-center justify-center gap-1 font-anton text-[15px] font-normal uppercase leading-[12px] tracking-normal text-white [leading-trim:none]",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "/assets/currency-coin.png",
                                                alt: "",
                                                className: "h-3.5 w-3.5 shrink-0"
                                            }),
                                            formatCoins(Math.round(coinsWonDisplay))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    favChips.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileFavouritesStrip.ProfileFavouritesStrip), {
                        chips: favChips
                    }),
                    !career ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-4 text-center text-xs text-white/50",
                        children: "This player's detailed game statistics are private."
                    }) : null,
                    career && careerLedger && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _careerStatsStack.CareerStatsStack), {
                        xp: careerLedger.xp ?? null,
                        showXpHistoryLink: false,
                        trader: {
                            played: careerLedger.trader.trades,
                            won: careerLedger.trader.won,
                            totalWinnings: careerLedger.trader.total_winnings,
                            currentStreak: careerLedger.trader.current_win_streak,
                            bestStreak: careerLedger.trader.record_win_streak,
                            biggestWin: careerLedger.trader.biggest_win
                        },
                        squares: {
                            played: careerLedger.squares.played,
                            won: careerLedger.squares.won,
                            totalWinnings: careerLedger.squares.net_winnings
                        },
                        bullion: {
                            played: careerLedger.bullion.played,
                            won: careerLedger.bullion.won,
                            totalWinnings: careerLedger.bullion.net_winnings
                        },
                        sixes: {
                            played: careerLedger.sixes.played,
                            totalWinnings: careerLedger.sixes.net_winnings,
                            biggestWin: careerLedger.sixes.biggest_win
                        },
                        leagues: {
                            played: careerLedger.leagues.played,
                            won: careerLedger.leagues.won,
                            totalWinnings: careerLedger.leagues.net_winnings
                        },
                        quickfire: {
                            plays: careerLedger.mini_games["quickfire-trivia"].played,
                            correct: careerLedger.mini_games["quickfire-trivia"].correct_answers,
                            totalWinnings: careerLedger.mini_games["quickfire-trivia"].net_coins
                        },
                        formatCoins: formatCoins
                    }),
                    friendsPreview.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        className: "mb-4 flex flex-col items-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                className: "mb-2 flex items-center justify-center gap-0.5 font-anton text-[11px] font-normal uppercase leading-[12px] tracking-normal [leading-trim:none]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "shrink-0 text-white",
                                        children: "Friends"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "text-white/40",
                                        children: [
                                            "(",
                                            friendsPreview.length,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full min-w-0 max-w-full overflow-x-auto overflow-y-hidden overscroll-x-contain pb-1 hide-scrollbar snap-x snap-mandatory touch-pan-x scroll-pl-3 scroll-pr-3",
                                "aria-label": "Friends \u2014 swipe or scroll horizontally",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mx-auto flex w-max max-w-none flex-nowrap items-center gap-2",
                                    children: friendsPreview.map((f)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileLink.ProfileLink), {
                                            to: f.player_id ? `/profile?p=${encodeURIComponent(f.player_id)}` : `/profile?u=${encodeURIComponent(String(f.userId))}`,
                                            state: profileLinkBackground,
                                            className: "group shrink-0 snap-start",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileAvatar.ProfileAvatar), {
                                                variant: "chip",
                                                src: (0, _sessionUser.resolveAvatarUrl)({
                                                    profile_pic: f.profile_pic,
                                                    avatar_url: f.avatar_url
                                                }) ?? "",
                                                displayName: f.player_name || f.username,
                                                xpWeekCrown: f.xp_week_crown,
                                                avatarFrameUrl: f.avatar_frame_url,
                                                avatarFrameSmallUrl: f.avatar_frame_small_url
                                            })
                                        }, f.userId))
                                })
                            })
                        ]
                    }),
                    isOwnProfile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        className: "rounded-none border border-white/10 bg-white/5 p-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                className: "mb-2 font-anton text-sm uppercase text-white",
                                children: "Details"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-2 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between gap-2 border-b border-white/5 pb-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-white/60",
                                                children: "Country"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-white",
                                                children: (0, _countries.getCountryNameByCode)(country) || country || "\u2014"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-white/60",
                                                children: "Favourite Sports"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "max-w-[60%] text-right text-white",
                                                children: (0, _profileFavSportIcons.parseFavSportsFromStorage)(favourites?.favsports).join(", ") || "\u2014"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-white/60",
                                                children: "Favourite Cricket players"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "max-w-[60%] text-right text-white",
                                                children: (0, _profileFavCricketers.parseFavCricketersFromStorage)(favourites?.favcricketers).map((s)=>(0, _profileFavCricketers.favCricketerLabel)(s)).join(", ") || "\u2014"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-white/60",
                                                children: "Club teams"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "max-w-[60%] text-right text-white",
                                                children: [
                                                    ...(0, _profileFavIplTeams.parseFavIplFromStorage)(favourites?.faviplteams).map((s)=>(0, _profileFavIplTeams.favIplLabel)(s)),
                                                    ...(0, _favouriteTeams.parseFavTeamsFromStorage)(favourites?.favcustomcricketteams).filter((name)=>(0, _cricketTeamCanonical.resolveCanonicalTeam)(name).category !== "national").filter((name)=>!pickerTeamSlugs.has((0, _cricketTeamCanonical.canonicalTeamSlug)(name)))
                                                ].join(", ") || "\u2014"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-white/60",
                                                children: "International cricket"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "max-w-[60%] text-right text-white",
                                                children: [
                                                    ...(0, _profileFavCricketIntTeams.parseFavCricketIntFromStorage)(favourites?.favnationalteams).map((s)=>(0, _profileFavCricketIntTeams.favCricketIntLabel)(s)),
                                                    ...(0, _favouriteTeams.parseFavTeamsFromStorage)(favourites?.favcustomcricketteams).filter((name)=>(0, _cricketTeamCanonical.resolveCanonicalTeam)(name).category === "national").filter((name)=>!pickerTeamSlugs.has((0, _cricketTeamCanonical.canonicalTeamSlug)(name)))
                                                ].join(", ") || "\u2014"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-white/60",
                                                children: "Favourite Football teams"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "max-w-[60%] text-right text-white",
                                                children: (0, _profileFavFootballTeams.parseFavFootballFromStorage)(favourites?.favfootballteams).map((s)=>(0, _profileFavFootballTeams.favFootballLabel)(s)).join(", ") || "\u2014"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    user && (isOwnProfile || profile?.friendshipStatus === "friends") && !isNonUserPublicProfile(profile) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        className: "mb-2 mt-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                className: "mb-3 text-center font-anton text-[11px] font-normal uppercase leading-[12px] tracking-wide text-white [leading-trim:none]",
                                children: "Activity"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _friendActivityTimelineDefault.default), {
                                digests: friendFeedDigests,
                                liveFriends: friendLiveFriends,
                                myTrades: friendFeedMyTrades,
                                mySquares: friendFeedMySquares,
                                notifications: [],
                                profileModalState: profileLinkBackground,
                                loading: friendFeedLoading,
                                visibleCount: 10,
                                surface: "profile",
                                enableInfiniteScroll: true,
                                infiniteScrollStep: 10,
                                isOwnProfileView: isOwnProfile,
                                hasMoreServerRows: friendFeedHasMore,
                                serverLoadingMore: friendFeedLoadingMore,
                                onReachEnd: ()=>{
                                    if (friendFeedLoadingMore || !friendFeedHasMore) return;
                                    setFriendFeedResultsLimit((prev)=>prev + 10);
                                },
                                onProfileLinkClick: ()=>onClose(),
                                emptyMessage: isOwnProfile ? "No recent activity yet." : "No shared activity yet."
                            })
                        ]
                    }),
                    !isOwnProfile && !(user && profile?.friendshipStatus === "friends") && !isNonUserPublicProfile(profile) && recent.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        className: "mb-2 mt-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                className: "mb-3 text-center font-anton text-[11px] font-normal uppercase leading-[12px] tracking-wide text-white [leading-trim:none]",
                                children: "Recent activity"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                className: "flex flex-col gap-2",
                                children: recent.map((ev, i)=>{
                                    const kind = ev.kind ?? "trader";
                                    if (kind === "xp") {
                                        const rel = formatActivityRelative(ev.settled_at ?? ev.created_at ?? null);
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                            className: "flex items-center gap-2 rounded-none border border-white/10 bg-[#381663]/40 px-2 py-2.5",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileAvatar.ProfileAvatar), {
                                                    variant: "chip",
                                                    src: avatarSrc,
                                                    displayName: displayNameForAvatar,
                                                    avatarColor: profile.avatar_color,
                                                    firstLetter: profile.first_letter,
                                                    xpWeekCrown: profile.xp_week_crown,
                                                    avatarFrameUrl: profile.avatar_frame_url,
                                                    avatarFrameSmallUrl: profile.avatar_frame_small_url,
                                                    className: "shrink-0"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex min-w-0 flex-1 flex-col gap-0.5",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-wrap items-center gap-x-1 gap-y-0.5 text-[11px] leading-snug text-white",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "font-bold uppercase",
                                                                children: displayName
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "font-normal",
                                                                children: " earned "
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "inline-flex items-center gap-0.5 self-center font-bold leading-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "tabular-nums",
                                                                        children: (0, _xp.formatXp)(ev.xp_amount ?? 0)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: (0, _xp.XP_ICON_SRC),
                                                                        alt: "",
                                                                        className: "h-3 w-3 shrink-0 object-contain",
                                                                        "aria-hidden": true
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "font-normal",
                                                                children: [
                                                                    (0, _xp.formatXpHistoryReasonDetail)(ev.xp_reason),
                                                                    "."
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "shrink-0 self-center text-[10px] text-white/55",
                                                    children: rel
                                                })
                                            ]
                                        }, `xp-${String(ev.settled_at ?? "")}-${String(ev.xp_reason ?? "")}-${i}`);
                                    }
                                    const oc = String(ev.outcome ?? "").toUpperCase();
                                    const isActive = kind === "squares_active";
                                    const rel = formatActivityRelative(isActive ? ev.created_at ?? null : ev.settled_at ?? null);
                                    const coinSpan = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "inline-flex items-center gap-0.5 self-center whitespace-nowrap leading-none",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "/assets/currency-coin.png",
                                                alt: "",
                                                className: "h-3 w-3 shrink-0 object-contain",
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "tabular-nums",
                                                children: formatCoins(Math.abs(Math.round(ev.profit)))
                                            })
                                        ]
                                    });
                                    let middle;
                                    if (isActive) middle = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-bold uppercase",
                                                children: displayName
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-normal",
                                                children: " is currently playing on "
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "inline-flex items-center gap-1 self-center font-bold uppercase leading-none",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: (0, _careerStatCardHeader.CAREER_STAT_ICONS).squares,
                                                        alt: "",
                                                        className: "h-3.5 w-3.5 shrink-0 object-contain",
                                                        "aria-hidden": true
                                                    }),
                                                    "SQUARES"
                                                ]
                                            })
                                        ]
                                    });
                                    else if (kind === "squares") {
                                        if (oc === "VOID") middle = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-bold uppercase",
                                                    children: displayName
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-normal",
                                                    children: " voided on "
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "inline-flex items-center gap-1 self-center font-bold uppercase leading-none",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: (0, _careerStatCardHeader.CAREER_STAT_ICONS).squares,
                                                            alt: "",
                                                            className: "h-3.5 w-3.5 shrink-0 object-contain",
                                                            "aria-hidden": true
                                                        }),
                                                        "SQUARES"
                                                    ]
                                                })
                                            ]
                                        });
                                        else {
                                            const won = oc === "WIN";
                                            middle = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-bold uppercase",
                                                        children: displayName
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-normal",
                                                        children: won ? " won " : " lost "
                                                    }),
                                                    coinSpan,
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-normal",
                                                        children: " on "
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "inline-flex items-center gap-1 self-center font-bold uppercase leading-none",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: (0, _careerStatCardHeader.CAREER_STAT_ICONS).squares,
                                                                alt: "",
                                                                className: "h-3.5 w-3.5 shrink-0 object-contain",
                                                                "aria-hidden": true
                                                            }),
                                                            "SQUARES"
                                                        ]
                                                    })
                                                ]
                                            });
                                        }
                                    } else if (kind === "sixes") middle = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-bold uppercase",
                                                children: displayName
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-normal",
                                                children: " won "
                                            }),
                                            coinSpan,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-normal",
                                                children: " on "
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "inline-flex items-center gap-1 self-center font-bold uppercase leading-none",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: (0, _careerStatCardHeader.CAREER_STAT_ICONS).sixes,
                                                        alt: "",
                                                        className: "h-3.5 w-3.5 shrink-0 object-contain",
                                                        "aria-hidden": true
                                                    }),
                                                    "SIXES"
                                                ]
                                            })
                                        ]
                                    });
                                    else if (oc === "VOID") middle = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-bold uppercase",
                                                children: displayName
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-normal",
                                                children: " voided on "
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "inline-flex items-center gap-1 self-center font-bold uppercase leading-none",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: (0, _careerStatCardHeader.CAREER_STAT_ICONS).trader,
                                                        alt: "",
                                                        className: "h-3.5 w-3.5 shrink-0 object-contain",
                                                        "aria-hidden": true
                                                    }),
                                                    "TRADER"
                                                ]
                                            })
                                        ]
                                    });
                                    else {
                                        const won = oc === "WIN";
                                        middle = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-bold uppercase",
                                                    children: displayName
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-normal",
                                                    children: won ? " won " : " lost "
                                                }),
                                                coinSpan,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-normal",
                                                    children: " on "
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "inline-flex items-center gap-1 self-center font-bold uppercase leading-none",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: (0, _careerStatCardHeader.CAREER_STAT_ICONS).trader,
                                                            alt: "",
                                                            className: "h-3.5 w-3.5 shrink-0 object-contain",
                                                            "aria-hidden": true
                                                        }),
                                                        "TRADER"
                                                    ]
                                                })
                                            ]
                                        });
                                    }
                                    const matchIdTrim = ev.match_id?.trim() ?? "";
                                    const rawMatchName = ev.match_name?.trim();
                                    const hasReadableMatchName = (0, _traderActivityNavigation.hasReadableActivityMatchName)(rawMatchName, matchIdTrim);
                                    const matchDisplayLabel = hasReadableMatchName ? (0, _matchNameDisplay.formatMatchNameAbbreviated)(rawMatchName) || null : null;
                                    const overNum = typeof ev.over_number === "number" && Number.isFinite(ev.over_number) && ev.over_number > 0 ? ev.over_number : null;
                                    const isSquaresKind = kind === "squares" || kind === "squares_active";
                                    const isSixesKind = kind === "sixes";
                                    let matchTo = null;
                                    if (!isSixesKind) {
                                        if (isSquaresKind) {
                                            if (isActive) matchTo = matchIdTrim ? `/squares?match=${encodeURIComponent(matchIdTrim)}` : "/squares";
                                            else if (matchIdTrim) matchTo = (0, _matchesHubNavigation.buildMatchCompleteHref)(matchIdTrim, ev.sport);
                                            else matchTo = "/squares";
                                        } else if (kind === "trader") matchTo = (0, _traderActivityNavigation.traderActivityMatchHref)(matchIdTrim, rawMatchName, ev.sport);
                                    }
                                    const matchDetail = matchDisplayLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mt-0.5 flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0.5 text-[10px] leading-tight text-white/80",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "min-w-0 max-w-full truncate",
                                                children: matchDisplayLabel
                                            }),
                                            isSquaresKind && overNum != null ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "shrink-0 whitespace-nowrap text-white/55",
                                                children: [
                                                    "Over ",
                                                    overNum
                                                ]
                                            }) : null
                                        ]
                                    }) : null;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                        className: `flex items-center gap-2 rounded-none border px-2 py-2.5 ${isActive ? "border-[#D2FF00] bg-[#5a2fa3]/80" : "border-white/10 bg-[#381663]/40"}`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileAvatar.ProfileAvatar), {
                                                variant: "chip",
                                                src: avatarSrc,
                                                displayName: displayNameForAvatar,
                                                avatarColor: profile.avatar_color,
                                                firstLetter: profile.first_letter,
                                                xpWeekCrown: profile.xp_week_crown,
                                                avatarFrameUrl: profile.avatar_frame_url,
                                                avatarFrameSmallUrl: profile.avatar_frame_small_url,
                                                className: "shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex min-w-0 flex-1 flex-col gap-0.5",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex flex-wrap items-center gap-x-1 gap-y-0.5 text-[11px] leading-snug text-white",
                                                        children: middle
                                                    }),
                                                    matchDetail
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex shrink-0 flex-row items-center justify-end gap-2",
                                                children: [
                                                    rel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "inline-flex items-center whitespace-nowrap text-[10px] leading-none text-white/45",
                                                        children: rel
                                                    }) : null,
                                                    matchTo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileLink.ProfileLink), {
                                                        to: matchTo,
                                                        state: profileLinkBackground,
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            navigateFromProfileOverlay(matchTo);
                                                        },
                                                        className: (0, _friendActivityTimeline.ACTIVITY_ACTION_BUTTON),
                                                        children: "MATCH"
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    }, `${kind}-${String(ev.settled_at ?? "")}-${String(ev.created_at ?? "")}-${String(ev.match_id ?? "")}-${i}`);
                                })
                            })
                        ]
                    })
                ]
            }),
            challengeGamePicker ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _challengeGameSelectPopoverDefault.default), {
                anchorRect: challengeGamePicker.anchorRect,
                onClose: ()=>setChallengeGamePicker(null),
                onPickBullion: ()=>{
                    const f = challengeGamePicker.friend;
                    (0, _frontendTrackingEvents.trackChallengeGameSelected)({
                        user_id: user?.userId,
                        game_type: "bullion",
                        cta_location: "public_profile",
                        pathname: location.pathname
                    });
                    setBullionContestFriend(f);
                },
                onPickSquares: ()=>{
                    const f = challengeGamePicker.friend;
                    (0, _frontendTrackingEvents.trackChallengeGameSelected)({
                        user_id: user?.userId,
                        game_type: "squares",
                        cta_location: "public_profile",
                        pathname: location.pathname
                    });
                    setSquaresChallengeFriend(f);
                },
                onPickLeagues: ()=>{
                    const f = challengeGamePicker.friend;
                    (0, _frontendTrackingEvents.trackChallengeGameSelected)({
                        user_id: user?.userId,
                        game_type: "leagues",
                        cta_location: "public_profile",
                        pathname: location.pathname
                    });
                    (0, _useMyLeaguesLists.openCreateLeagueModal)({
                        challengeFriendUserId: f.userId
                    });
                },
                showBullion: isBullionEnabled,
                showSquares: liveSquaresForChallenge,
                showLeagues: showLeaguesChallenge
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _squaresChallengeFriendModalDefault.default), {
                isOpen: squaresChallengeFriend != null,
                onRequestClose: ()=>setSquaresChallengeFriend(null),
                friend: squaresChallengeFriend,
                analyticsEntryPoint: "public_profile",
                onOpenMatch: openChallengedMatchFromProfile
            }),
            isBullionEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bullionPrivateContestsFriendModalDefault.default), {
                isOpen: bullionContestFriend != null,
                onRequestClose: ()=>setBullionContestFriend(null),
                friend: bullionContestFriend,
                analyticsEntryPoint: "public_profile",
                onOpenMatch: openChallengedMatchFromProfile
            }) : null,
            confirmFriendProfileAction ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _areYouSureModalDefault.default), {
                isOpen: true,
                onRequestClose: closeConfirmFriendProfileAction,
                contentLabel: "Confirm friend action",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col items-center gap-4 p-5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-center font-anton text-[22px] text-white",
                            children: confirmFriendProfileAction === "unmute" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    "ARE YOU SURE YOU WANT TO UNMUTE",
                                    " ",
                                    (0, _friendDisplayName.playerHandleName)(profile).toUpperCase(),
                                    "?"
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    "Are you sure you want to",
                                    " ",
                                    confirmFriendProfileAction === "remove" ? "remove" : confirmFriendProfileAction,
                                    " ",
                                    (0, _friendDisplayName.playerHandleName)(profile).toUpperCase(),
                                    "?"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: closeConfirmFriendProfileAction,
                                    className: "flex h-9 min-w-[112px] items-center justify-center rounded-none border-2 border-solid border-lime bg-transparent px-4 font-anton text-[14px] text-lime transition-colors hover:border-limehover hover:text-limehover",
                                    children: "CANCEL"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: confirmSelectedFriendProfileAction,
                                    disabled: confirmFriendProfileAction === "remove" ? removeFriendLoading : muteFriendLoading,
                                    className: "flex h-9 min-w-[112px] items-center justify-center rounded-none bg-lime px-4 font-anton text-[14px] text-main transition-colors hover:bg-limehover disabled:opacity-60",
                                    children: "YES"
                                })
                            ]
                        })
                    ]
                })
            }) : null
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","js-cookie":"2P5RE","react-router-dom":"l6ORY","./ProfileAvatar":"fwC7C","./ProfileLink":"eCRxx","./ProfileGlobalModalContext":"eilDL","../../Data/TraderDataFetcherContext":"1bLlx","../../hooks/useSocialSyncRefresh":"1firO","../../Data/UserContext":"aqd8b","../../utils/authHeaders":"5Rczo","../../utils/frontendTrackingEvents":"4Y90p","../../utils/mutedFriendsStorage":"ebacJ","../Account/Countries":"307aP","../../utils/sessionUser":"4xtMD","./ProfileFavouritesStrip":"dZNUw","./profileFavSportIcons":"bXwQU","./profileFavFootballTeams":"3mxlc","./profileFavIplTeams":"f7o1p","./profileFavCricketIntTeams":"7D1sc","../../utils/favouriteTeams":"fwQD0","../../utils/cricketTeamCanonical":"3aPXR","../../utils/friendDisplayName":"hUpqQ","./ProfileNameStack":"cQ9gl","./profileFavCricketers":"2PUhI","./CareerStatsStack":"iO9Z8","./CareerStatCardHeader":"k4ekZ","./careerSummary":"8bANt","../../utils/modalHistoryBack":"goswc","../MyZone/SquaresChallengeFriendModal":"bGMai","../MyZone/ChallengeGameSelectPopover":"4oyz4","../MyZone/BullionPrivateContestsFriendModal":"iEI1v","../Modals/AreYouSureModal":"12SRH","../../icons/ThreeDotsCircleIcon/ThreeDotsCircleIcon":"dcN2P","../ModalCloseIcon":"aricC","../../utils/matchNameDisplay":"cRLsI","../Matches/matchesHubNavigation":"cJbjg","../../utils/traderActivityNavigation":"2KLbK","../MyZone/FriendActivityTimeline":"gNFUK","../../hooks/useLiveSquaresChallengeFromLobby":"f7N3P","../../hooks/useGamesEnabled":"ex0m1","../Leagues/hooks/useMyLeaguesLists":"jgpEe","../../utils/xp":"jFgAi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ebacJ":[function(require,module,exports,__globalThis) {
/** Persist muted friends per account (device-local until a mute API exists). */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MUTED_FRIENDS_CHANGED_EVENT", ()=>MUTED_FRIENDS_CHANGED_EVENT);
parcelHelpers.export(exports, "readMutedFriendIdsArray", ()=>readMutedFriendIdsArray);
parcelHelpers.export(exports, "getMutedFriendIdsSet", ()=>getMutedFriendIdsSet);
parcelHelpers.export(exports, "addMutedFriend", ()=>addMutedFriend);
parcelHelpers.export(exports, "removeMutedFriend", ()=>removeMutedFriend);
parcelHelpers.export(exports, "excludeMutedSendersQueryParam", ()=>excludeMutedSendersQueryParam);
parcelHelpers.export(exports, "getNotificationSenderUserId", ()=>getNotificationSenderUserId);
parcelHelpers.export(exports, "isNotificationFromMutedFriend", ()=>isNotificationFromMutedFriend);
/** API rows may use numeric or string `userId`; muted set is always numeric from storage. */ parcelHelpers.export(exports, "isFriendUserIdMuted", ()=>isFriendUserIdMuted);
const MUTED_FRIENDS_CHANGED_EVENT = "c8-muted-friends-changed";
function normalizeAccountId(id) {
    if (id == null) return undefined;
    if (typeof id === "number") return Number.isFinite(id) && id > 0 ? id : undefined;
    if (typeof id === "string") {
        const n = parseInt(id, 10);
        return Number.isFinite(n) && n > 0 ? n : undefined;
    }
    return undefined;
}
function storageKey(accountUserId) {
    return `c8_muted_friend_ids:${accountUserId}`;
}
function parseIds(raw) {
    if (raw == null || raw === "") return [];
    try {
        const v = JSON.parse(raw);
        if (!Array.isArray(v)) return [];
        const out = [];
        for (const x of v){
            const n = typeof x === "number" ? x : parseInt(String(x), 10);
            if (Number.isFinite(n) && n > 0) out.push(n);
        }
        return [
            ...new Set(out)
        ];
    } catch  {
        return [];
    }
}
function readMutedFriendIdsArray(accountUserId) {
    if (typeof window === "undefined") return [];
    return parseIds(window.localStorage.getItem(storageKey(accountUserId)));
}
function getMutedFriendIdsSet(accountUserId) {
    const id = normalizeAccountId(accountUserId);
    if (id == null) return new Set();
    return new Set(readMutedFriendIdsArray(id));
}
function writeMutedFriendIdsArray(accountUserId, ids) {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(storageKey(accountUserId), JSON.stringify(ids));
}
function dispatchMutedFriendsChanged() {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent(MUTED_FRIENDS_CHANGED_EVENT));
}
function addMutedFriend(accountUserId, friendUserId) {
    const aid = normalizeAccountId(accountUserId);
    const fid = normalizeAccountId(friendUserId);
    if (aid == null || fid == null) return;
    const ids = readMutedFriendIdsArray(aid);
    if (ids.includes(fid)) {
        dispatchMutedFriendsChanged();
        return;
    }
    ids.push(fid);
    writeMutedFriendIdsArray(aid, ids);
    dispatchMutedFriendsChanged();
}
function removeMutedFriend(accountUserId, friendUserId) {
    const aid = normalizeAccountId(accountUserId);
    const fid = normalizeAccountId(friendUserId);
    if (aid == null || fid == null) return;
    const next = readMutedFriendIdsArray(aid).filter((id)=>id !== fid);
    writeMutedFriendIdsArray(aid, next);
    dispatchMutedFriendsChanged();
}
/** Max IDs appended to unread-count query (server also caps). */ const MAX_EXCLUDE_QUERY_IDS = 200;
function excludeMutedSendersQueryParam(accountUserId) {
    const id = normalizeAccountId(accountUserId);
    if (id == null) return "";
    const ids = readMutedFriendIdsArray(id).slice(0, MAX_EXCLUDE_QUERY_IDS);
    if (ids.length === 0) return "";
    return `exclude_sender_ids=${ids.map((id)=>encodeURIComponent(String(id))).join(",")}`;
}
function getNotificationSenderUserId(n) {
    const sender = n.sender;
    if (sender && typeof sender.userId === "number" && Number.isFinite(sender.userId)) return sender.userId;
    const sid = n.sender_id;
    if (typeof sid === "number" && Number.isFinite(sid)) return sid;
    if (typeof sid === "string") {
        const p = parseInt(sid, 10);
        return Number.isFinite(p) ? p : null;
    }
    return null;
}
function isNotificationFromMutedFriend(n, muted) {
    const id = getNotificationSenderUserId(n);
    if (id == null) return false;
    return muted.has(id);
}
function isFriendUserIdMuted(muted, rawFriendUserId) {
    if (typeof rawFriendUserId === "number" && Number.isFinite(rawFriendUserId)) return muted.has(rawFriendUserId);
    if (typeof rawFriendUserId === "string") {
        const n = parseInt(rawFriendUserId, 10);
        return Number.isFinite(n) ? muted.has(n) : false;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGMai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SquaresChallengeFriendModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _userContext = require("../../Data/UserContext");
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _closeIcon = require("../../icons/CloseIcon/CloseIcon");
var _squaresApi = require("../Squares/shared/squaresApi");
var _squaresLobbyMatchUtils = require("../Squares/lobby/squaresLobbyMatchUtils");
var _squaresLobbyGameOpen = require("../Squares/lobby/squaresLobbyGameOpen");
var _squaresConstants = require("../Squares/shared/squaresConstants");
var _squaresMatchCard = require("../Squares/lobby/squares-match-card");
var _squaresMatchCardDefault = parcelHelpers.interopDefault(_squaresMatchCard);
var _authHeaders = require("../../utils/authHeaders");
var _matchNameDisplay = require("../../utils/matchNameDisplay");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _modalHistoryBack = require("../../utils/modalHistoryBack");
var _friendDisplayName = require("../../utils/friendDisplayName");
function matchLabelFromChallengePayload(matchName) {
    const a = (0, _matchNameDisplay.formatMatchNameAbbreviated)(matchName);
    if (a) return a;
    return "a match";
}
/** One row per match (API / UI can repeat the same match_id for multiple notifications or sends). */ function dedupeChallengeEntriesByMatchId(entries) {
    const seen = new Set();
    const out = [];
    for (const e of entries){
        const m = String(e.matchId ?? "").trim();
        if (!m) continue;
        if (seen.has(m)) continue;
        seen.add(m);
        out.push(e);
    }
    return out;
}
function subscribeToSquaresLobbyStream(matchIds, streamDataPerMatchId, bump) {
    if (matchIds.length === 0) return;
    const baseApi = "https://cricket8.com/stream";
    if (!baseApi) return;
    const url = `${baseApi}?matchIds=${matchIds.join(",")}&tier=lobby`;
    const es = new EventSource(url, {
        withCredentials: false
    });
    const onMessage = (event)=>{
        try {
            const parsedData = JSON.parse(event.data);
            if (!parsedData?.feed_id) return;
            const matchId = parsedData.feed_id;
            const existing = streamDataPerMatchId.current.get(matchId) || {};
            streamDataPerMatchId.current.set(matchId, {
                ...existing,
                ...parsedData
            });
            bump();
        } catch  {
        /* ignore */ }
    };
    es.addEventListener("message", onMessage);
    es.addEventListener("error", ()=>{});
    return ()=>{
        try {
            es.removeEventListener("message", onMessage);
            es.close();
        } catch  {
        /* ignore */ }
    };
}
function SquaresChallengeFriendModal({ isOpen, onRequestClose, friend, onChallengeSent, analyticsEntryPoint, analyticsGameType, onOpenMatch }) {
    const { user } = (0, _userContext.useUser)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const challengeFlowOpenedTrackedRef = (0, _react.useRef)(false);
    const challengeGameType = (0, _react.useMemo)(()=>{
        const s = analyticsGameType?.trim().toLowerCase();
        return s && s.length > 0 ? s : "squares";
    }, [
        analyticsGameType
    ]);
    const [allFixtures, setAllFixtures] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [sendingId, setSendingId] = (0, _react.useState)(null);
    const [successEntries, setSuccessEntries] = (0, _react.useState)([]);
    const [priorChallengesLoading, setPriorChallengesLoading] = (0, _react.useState)(false);
    const streamDataPerMatchId = (0, _react.useRef)(new Map());
    const [streamTick, setStreamTick] = (0, _react.useState)(0);
    const bumpStream = (0, _react.useCallback)(()=>setStreamTick((t)=>t + 1), []);
    const matchIdsKey = (0, _react.useMemo)(()=>allFixtures.map((f)=>String(f.match_id ?? "").trim()).filter(Boolean).sort().join(","), [
        allFixtures
    ]);
    /** Finished challenges are omitted; at most one row per match_id. */ const visibleSuccessEntries = (0, _react.useMemo)(()=>dedupeChallengeEntriesByMatchId(successEntries.filter((e)=>e.matchOpen !== false)), [
        successEntries
    ]);
    const loadFixtures = (0, _react.useCallback)(()=>{
        if (!(0, _squaresConstants.isSquaresLobbyEnabled)()) {
            setAllFixtures([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        streamDataPerMatchId.current.clear();
        (0, _squaresApi.fetchSquaresPrioritisedMatches)().then((data)=>{
            const events = Array.isArray(data?.events) ? data.events : [];
            setAllFixtures((0, _squaresLobbyMatchUtils.mapFilterSquaresPlayableLobbyFixturesForHome)(events));
        }).catch(()=>{
            setAllFixtures([]);
            setError("Could not load matches.");
        }).finally(()=>setLoading(false));
    }, []);
    (0, _react.useEffect)(()=>{
        if (!isOpen || !friend) return;
        loadFixtures();
    }, [
        isOpen,
        friend,
        loadFixtures
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen) {
            challengeFlowOpenedTrackedRef.current = false;
            setSuccessEntries([]);
            setError(null);
            setPriorChallengesLoading(false);
        }
    }, [
        isOpen
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen || !friend || user?.userId == null) return;
        if (!analyticsEntryPoint?.trim()) return;
        if (challengeFlowOpenedTrackedRef.current) return;
        challengeFlowOpenedTrackedRef.current = true;
        (0, _frontendTrackingEvents.trackGameChallengeFlowOpened)({
            user_id: user.userId,
            game_type: challengeGameType,
            entry_point: analyticsEntryPoint.trim(),
            pathname: location.pathname
        });
    }, [
        isOpen,
        friend,
        user?.userId,
        analyticsEntryPoint,
        challengeGameType,
        location.pathname
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen || !friend) return;
        const fid = friend.userId;
        const fl = (0, _friendDisplayName.friendFacingName)(friend) || "your friend";
        let cancelled = false;
        setPriorChallengesLoading(true);
        (async ()=>{
            try {
                const res = await fetch(`${"https://cricket8.com/api"}/account/friends/squares-challenges-sent?friend_id=${encodeURIComponent(String(fid))}`, {
                    headers: (0, _authHeaders.getAuthHeaders)()
                });
                const data = await res.json().catch(()=>({}));
                if (cancelled) return;
                if (!res.ok) {
                    setSuccessEntries([]);
                    return;
                }
                const list = Array.isArray(data.challenges) ? data.challenges : [];
                const entries = dedupeChallengeEntriesByMatchId(list.filter((c)=>c.match_id != null && String(c.match_id).trim()).map((c)=>({
                        key: `prior-${c.id}`,
                        matchId: String(c.match_id),
                        matchLabel: matchLabelFromChallengePayload(c.match_name),
                        friendLabel: fl,
                        matchOpen: c.match_open
                    }))).slice(0, 8);
                setSuccessEntries(entries);
            } catch  {
                if (!cancelled) setSuccessEntries([]);
            } finally{
                if (!cancelled) setPriorChallengesLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        isOpen,
        friend?.userId,
        friend?.player_name,
        friend?.username
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen || !friend) return;
        const onChallengesDirty = ()=>{
            loadFixtures();
            const fid = friend.userId;
            const fl = (0, _friendDisplayName.friendFacingName)(friend) || "your friend";
            setPriorChallengesLoading(true);
            (async ()=>{
                try {
                    const res = await fetch(`${"https://cricket8.com/api"}/account/friends/squares-challenges-sent?friend_id=${encodeURIComponent(String(fid))}`, {
                        headers: (0, _authHeaders.getAuthHeaders)()
                    });
                    const data = await res.json().catch(()=>({}));
                    if (!res.ok) return;
                    const list = Array.isArray(data.challenges) ? data.challenges : [];
                    const entries = dedupeChallengeEntriesByMatchId(list.filter((c)=>c.match_id != null && String(c.match_id).trim()).map((c)=>({
                            key: `prior-${c.id}`,
                            matchId: String(c.match_id),
                            matchLabel: matchLabelFromChallengePayload(c.match_name),
                            friendLabel: fl,
                            matchOpen: c.match_open
                        }))).slice(0, 8);
                    setSuccessEntries(entries);
                } finally{
                    setPriorChallengesLoading(false);
                }
            })();
        };
        window.addEventListener("c8-squares-challenges-dirty", onChallengesDirty);
        return ()=>window.removeEventListener("c8-squares-challenges-dirty", onChallengesDirty);
    }, [
        friend,
        isOpen,
        loadFixtures
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen || matchIdsKey.length === 0) return;
        const ids = matchIdsKey.split(",").filter(Boolean);
        const cleanup = subscribeToSquaresLobbyStream(ids, streamDataPerMatchId, bumpStream);
        return ()=>{
            cleanup?.();
        };
    }, [
        isOpen,
        matchIdsKey,
        bumpStream
    ]);
    const liveFixtures = (0, _react.useMemo)(()=>{
        return allFixtures.filter((f)=>{
            const mid = String(f.match_id ?? "").trim();
            if (!mid) return false;
            const streamData = streamDataPerMatchId.current.get(mid);
            if (!(0, _squaresLobbyMatchUtils.isSquaresFixtureLiveForChallengeList)(f, streamData)) return false;
            return (0, _squaresLobbyGameOpen.isSquaresGameOpenFromStream)(f, streamData);
        });
    }, [
        allFixtures,
        streamTick
    ]);
    const openChallengedMatch = (0, _react.useCallback)((matchId)=>{
        const href = `/squares?match=${encodeURIComponent(matchId)}`;
        if (onOpenMatch) {
            onOpenMatch(href);
            return;
        }
        onRequestClose();
        (0, _modalHistoryBack.whenModalHistoryIdle)(()=>navigate(href));
    }, [
        navigate,
        onOpenMatch,
        onRequestClose
    ]);
    const sendChallenge = (0, _react.useCallback)(async (matchId)=>{
        if (!friend) return;
        setSendingId(matchId);
        setError(null);
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/friends/squares-challenge`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...(0, _authHeaders.getAuthHeaders)()
                },
                body: JSON.stringify({
                    friend_id: friend.userId,
                    match_id: matchId
                })
            });
            const data = await res.json().catch(()=>({}));
            if (!res.ok) {
                const code = data?.error;
                if (code === "not_friends") setError("You can only challenge friends.");
                else if (code === "match_not_eligible") setError("That match is no longer in the Squares lobby.");
                else setError("Could not send challenge. Try again.");
                return;
            }
            if (user?.userId != null && analyticsEntryPoint?.trim()) (0, _frontendTrackingEvents.trackGameChallengeSent)({
                user_id: user.userId,
                game_type: challengeGameType,
                entry_point: analyticsEntryPoint.trim(),
                challenged_friend_user_id: friend.userId,
                challenge_target_id: matchId,
                pathname: location.pathname
            });
            onChallengeSent?.();
            window.dispatchEvent(new CustomEvent("c8-squares-challenges-dirty"));
            openChallengedMatch(matchId);
        } catch  {
            setError("Could not send challenge. Try again.");
        } finally{
            setSendingId(null);
        }
    }, [
        friend,
        onChallengeSent,
        user?.userId,
        analyticsEntryPoint,
        challengeGameType,
        location.pathname,
        openChallengedMatch
    ]);
    const friendLabel = (0, _friendDisplayName.friendFacingName)(friend) || "your friend";
    const lobbyOff = !(0, _squaresConstants.isSquaresLobbyEnabled)();
    /** Above ProfileModalShell (z-10050) so challenge opens in front of the profile overlay. */ const CHALLENGE_MODAL_OVERLAY_Z = 10060;
    const CHALLENGE_MODAL_CONTENT_Z = 10061;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        isOpen: isOpen && friend != null,
        onRequestClose: onRequestClose,
        contentLabel: "Challenge friend to Squares",
        ariaHideApp: false,
        style: {
            content: {
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                padding: 0,
                background: "transparent",
                width: "min(560px, calc(100vw - 16px))",
                maxWidth: "100%",
                maxHeight: "min(90vh, 720px)",
                overflow: "hidden",
                zIndex: CHALLENGE_MODAL_CONTENT_Z
            },
            overlay: {
                background: "rgba(11, 2, 18, 0.8)",
                zIndex: CHALLENGE_MODAL_OVERLAY_Z
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex max-h-[min(90vh,720px)] flex-col overflow-hidden border border-[#2d1548] bg-[#2a0a55] shadow-[0_12px_40px_rgba(0,0,0,0.45)]",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid shrink-0 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2 bg-[#e470ff] py-2 pl-3 pr-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "min-w-0",
                            "aria-hidden": true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "text-center font-anton text-[17px] font-bold uppercase leading-none tracking-wide text-white max-[420px]:text-[15px]",
                            children: "Squares challenge"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex min-w-0 justify-end",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: onRequestClose,
                                className: "!flex !h-11 !w-11 shrink-0 !items-center !justify-center text-white transition-opacity hover:opacity-80",
                                "aria-label": "Close",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIcon.CloseIcon), {
                                    className: "text-white",
                                    size: 28
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "min-h-0 flex-1 space-y-3 overflow-y-auto bg-[#461d79] px-3 py-3 sm:px-4 sm:py-4",
                    children: [
                        priorChallengesLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded border border-[#d4ff1f]/35 bg-[#1b062f]/55 px-3 py-2.5 text-center font-chakra text-[14px] leading-snug text-white/70 max-[420px]:text-[13px]",
                            children: "Loading\u2026"
                        }) : visibleSuccessEntries.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded border border-[#d4ff1f]/35 bg-[#1b062f]/55 px-3 py-2.5 text-center font-chakra text-[14px] leading-snug text-white max-[420px]:text-[13px]",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    "Challenge ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-semibold",
                                        children: friendLabel
                                    }),
                                    " to play",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-semibold text-[#d4ff1f]",
                                        children: " Squares"
                                    }),
                                    " with you."
                                ]
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                            className: "space-y-3",
                            "aria-live": "polite",
                            children: visibleSuccessEntries.map((entry)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                    className: "space-y-2",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "border border-[#d4ff1f]/35 bg-[#1b062f]/55 px-3 py-2.5 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "font-chakra text-[13px] leading-snug text-white sm:text-[14px]",
                                                children: [
                                                    "You challenged ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-semibold",
                                                        children: entry.friendLabel
                                                    }),
                                                    " to match",
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-semibold text-[#d4ff1f]",
                                                        children: entry.matchLabel
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                to: `/squares?match=${encodeURIComponent(entry.matchId)}`,
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    openChallengedMatch(entry.matchId);
                                                },
                                                className: "inline-block font-chakra text-[13px] font-semibold text-[#d4ff1f] underline decoration-[#d4ff1f]/55 underline-offset-2 hover:text-white hover:decoration-white sm:text-[14px]",
                                                children: "Open match in Squares"
                                            })
                                        ]
                                    })
                                }, entry.matchId))
                        }),
                        error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-chakra text-[13px] font-semibold sm:text-[14px]",
                            style: {
                                color: "#ef4444"
                            },
                            role: "alert",
                            "aria-live": "polite",
                            children: error
                        }) : null,
                        lobbyOff ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-chakra text-[14px] leading-snug text-white/70",
                            children: "The Squares lobby is currently unavailable."
                        }) : loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-center font-chakra text-sm text-white/60",
                            children: "Loading\u2026"
                        }) : liveFixtures.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "font-chakra text-[14px] leading-snug text-white/70",
                            children: [
                                "No ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    className: "text-white",
                                    children: "live"
                                }),
                                " Squares matches right now. When a game is live, it will show up here."
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex flex-col gap-3 pb-1",
                            style: {
                                background: "linear-gradient(88.89deg, #652DAF 0%, #623998 100%)"
                            },
                            children: liveFixtures.map((fixture)=>{
                                const mid = String(fixture.match_id ?? "").trim();
                                const streamData = streamDataPerMatchId.current.get(mid);
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _squaresMatchCardDefault.default), {
                                    fixture: fixture,
                                    streamData: streamData,
                                    challengePickMode: true,
                                    challengeCompactTeamRow: true,
                                    onChallengePick: ()=>sendChallenge(mid),
                                    challengeSending: sendingId === mid,
                                    challengeOtherSending: sendingId != null && sendingId !== mid
                                }, mid);
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../../Data/UserContext":"aqd8b","../Modal":"2Ei4y","../../icons/CloseIcon/CloseIcon":"7JRht","../Squares/shared/squaresApi":"aMqbW","../Squares/lobby/squaresLobbyMatchUtils":"j3UmL","../Squares/lobby/squaresLobbyGameOpen":"4Pj06","../Squares/shared/squaresConstants":"9tbpY","../Squares/lobby/squares-match-card":"6GOk1","../../utils/authHeaders":"5Rczo","../../utils/matchNameDisplay":"cRLsI","../../utils/frontendTrackingEvents":"4Y90p","../../utils/modalHistoryBack":"goswc","../../utils/friendDisplayName":"hUpqQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMqbW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "squaresApiBaseUrl", ()=>squaresApiBaseUrl);
/**
 * @param {URLSearchParams | Record<string, string>} searchParams
 * @returns {Promise<{ plays?: unknown[]; overs?: Record<string, unknown>; overOddsLocked?: Record<string, unknown> }>}
 */ /**
 * Friends playing this over + unread challenge notifications for this match (Squares match play).
 * Query: match_id (required), innings_number, over_number (omit when match finished / over unknown).
 * @param {URLSearchParams | Record<string, string>} searchParams
 * @returns {Promise<{ friends_on_over?: { user_id: number; name: string }[]; challenges?: { notification_id: number; sender_user_id: number; name: string }[] }>}
 */ parcelHelpers.export(exports, "fetchSquaresMatchSocial", ()=>fetchSquaresMatchSocial);
parcelHelpers.export(exports, "fetchSquaresMatchOverPlays", ()=>fetchSquaresMatchOverPlays);
/**
 * @param {URLSearchParams | Record<string, string>} searchParams
 * @returns {Promise<{ plays?: unknown[] }>}
 */ parcelHelpers.export(exports, "fetchSquaresOverPlays", ()=>fetchSquaresOverPlays);
/**
 * @param {string} sessionToken
 * @param {{ matchId: string; inningsNumber: number }} query
 */ parcelHelpers.export(exports, "fetchSquaresMyOversInMatch", ()=>fetchSquaresMyOversInMatch);
/** @param {string} sessionToken */ parcelHelpers.export(exports, "fetchSquaresMyMatches", ()=>fetchSquaresMyMatches);
/** @param {{ matchId: string; inningsNumber: number; overNumber: number; session_token?: string }} body — include session_token when using session cookie auth without JWT */ parcelHelpers.export(exports, "postSquaresTrySettleOver", ()=>postSquaresTrySettleOver);
/** @param {string} sessionToken @param {Record<string, unknown>} body @param {object} [userAccount] — used by dev demo submit only */ parcelHelpers.export(exports, "postSquaresSubmit", ()=>postSquaresSubmit);
/** @param {Record<string, unknown>} body — matchId, inningsNumber, overNumber, maxOvers, optional 410 fields */ parcelHelpers.export(exports, "postSquaresCalculateOverOdds", ()=>postSquaresCalculateOverOdds);
/** @returns {Promise<{ events?: unknown[] } & Record<string, unknown>>} */ parcelHelpers.export(exports, "fetchSquaresPrioritisedMatches", ()=>fetchSquaresPrioritisedMatches);
/**
 * @param {string} sessionToken
 * @param {{ page: number; perpage: number; states?: string; dateFrom?: string; dateTo?: string }} query
 * @returns {Promise<{ ok: boolean; data: unknown[]; count: number }>}
 */ parcelHelpers.export(exports, "fetchSquaresMySquares", ()=>fetchSquaresMySquares);
var _authHeaders = require("../../../utils/authHeaders");
var _squaresDemoApi = require("../lib/squaresDemoApi");
var _leagueSquaresRoomApi = require("../../Leagues/lib/leagueSquaresRoomApi");
const EMPTY_MATCH_OVER_PLAYS = {
    plays: [],
    overs: {},
    overOddsLocked: {}
};
function squaresApiBaseUrl() {
    return "https://cricket8.com/api".replace(/\/$/, "");
}
function jsonAuthHeaders() {
    return {
        "Content-Type": "application/json",
        ...(0, _authHeaders.getAuthHeaders)()
    };
}
function fetchSquaresMatchSocial(searchParams) {
    const q = searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams(searchParams);
    const matchId = q.get("match_id") ?? q.get("matchId") ?? "";
    // League room is members-only — don't surface public Squares friends/challenges.
    if ((0, _leagueSquaresRoomApi.resolveActiveLeagueIdForSquaresRoom)()) return Promise.resolve({
        friends_on_over: [],
        challenges: []
    });
    if ((0, _squaresDemoApi.isSquaresDemoMatchId)(matchId)) return (0, _squaresDemoApi.squaresDemoMatchSocial)();
    const url = `${squaresApiBaseUrl()}/account/friends/squares-match-social?${q.toString()}`;
    return fetch(url, {
        method: "GET",
        headers: (0, _authHeaders.getAuthHeaders)()
    }).then((res)=>res.ok ? res.json() : {
            friends_on_over: [],
            challenges: []
        });
}
function fetchSquaresMatchOverPlays(searchParams) {
    const q = searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams(searchParams);
    // League mode first: prototype rooms restore league.plays (Over 1), not the demo over-12 script.
    return (0, _leagueSquaresRoomApi.fetchLeagueSquaresRoomIfActive)(q).then((leagueRoom)=>{
        if (leagueRoom) return leagueRoom;
        const demo = (0, _squaresDemoApi.squaresDemoMatchOverPlays)(q);
        if (demo) return demo;
        const url = `${squaresApiBaseUrl()}/squares/match-over-plays?${q.toString()}`;
        return fetch(url, {
            method: "GET",
            headers: (0, _authHeaders.getAuthHeaders)()
        }).then((res)=>res.ok ? res.json() : {
                ...EMPTY_MATCH_OVER_PLAYS
            });
    });
}
function fetchSquaresOverPlays(searchParams) {
    const q = searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams(searchParams);
    return (0, _leagueSquaresRoomApi.fetchLeagueSquaresRoomIfActive)(q).then((leagueRoom)=>{
        if (leagueRoom) return leagueRoom;
        const demo = (0, _squaresDemoApi.squaresDemoOverPlays)(q);
        if (demo) return demo;
        const url = `${squaresApiBaseUrl()}/squares/over-plays?${q.toString()}`;
        return fetch(url, {
            method: "GET",
            headers: (0, _authHeaders.getAuthHeaders)()
        }).then((res)=>res.ok ? res.json() : {
                plays: []
            });
    });
}
function fetchSquaresMyOversInMatch(sessionToken, { matchId, inningsNumber }, viewerUserId) {
    return (0, _leagueSquaresRoomApi.fetchLeagueSquaresMyOversIfActive)(matchId, inningsNumber).then((leagueMine)=>{
        if (leagueMine) return leagueMine;
        const demo = (0, _squaresDemoApi.squaresDemoMyOversInMatch)(sessionToken, {
            matchId,
            inningsNumber
        }, viewerUserId);
        if (demo) return demo;
        const q = new URLSearchParams({
            matchId: String(matchId),
            inningsNumber: String(inningsNumber)
        });
        const url = `${squaresApiBaseUrl()}/squares/my-overs-in-match/${encodeURIComponent(sessionToken)}?${q.toString()}`;
        return fetch(url, {
            method: "GET",
            headers: (0, _authHeaders.getAuthHeaders)()
        }).then((res)=>res.ok ? res.json() : {
                overNumbers: []
            });
    });
}
function fetchSquaresMyMatches(sessionToken) {
    const url = `${squaresApiBaseUrl()}/squares/my-matches/${encodeURIComponent(sessionToken)}`;
    return fetch(url, {
        method: "GET",
        headers: (0, _authHeaders.getAuthHeaders)()
    }).then((res)=>res.ok ? res.json() : {
            matches: []
        });
}
function postSquaresTrySettleOver(body) {
    if ((0, _squaresDemoApi.isSquaresDemoMatchId)(body?.matchId)) return (0, _squaresDemoApi.squaresDemoTrySettleOver)();
    // League Squares settles via leagueSquaresSettlement — never public squares_plays.
    if ((0, _leagueSquaresRoomApi.resolveActiveLeagueIdForSquaresRoom)()) return Promise.resolve(new Response(null, {
        status: 204
    }));
    const url = `${squaresApiBaseUrl()}/squares/try-settle-over`;
    return fetch(url, {
        method: "POST",
        headers: jsonAuthHeaders(),
        body: JSON.stringify(body)
    });
}
async function postSquaresSubmit(sessionToken, body, userAccount) {
    const demo = await (0, _squaresDemoApi.squaresDemoSubmit)(sessionToken, body, userAccount);
    if (demo) return demo;
    const url = `${squaresApiBaseUrl()}/squares/submit/${encodeURIComponent(sessionToken)}`;
    const res = await fetch(url, {
        method: "POST",
        headers: jsonAuthHeaders(),
        body: JSON.stringify(body)
    });
    const data = await res.json().catch(()=>({}));
    return {
        ok: res.ok,
        status: res.status,
        data
    };
}
async function postSquaresCalculateOverOdds(body) {
    const demo = (0, _squaresDemoApi.squaresDemoCalculateOverOdds)(body);
    if (demo) return demo;
    const url = `${squaresApiBaseUrl()}/squares/calculate-over-odds`;
    const res = await fetch(url, {
        method: "POST",
        headers: jsonAuthHeaders(),
        body: JSON.stringify(body)
    });
    let data = null;
    try {
        data = await res.json();
    } catch  {
        data = null;
    }
    if (!res.ok) return null;
    return data;
}
function fetchSquaresPrioritisedMatches() {
    const url = `${squaresApiBaseUrl()}/squares/prioritised-matches`;
    return fetch(url, {
        method: "GET",
        headers: (0, _authHeaders.getAuthHeaders)()
    }).then(async (res)=>{
        if (!res.ok) return {
            events: []
        };
        try {
            return await res.json();
        } catch  {
            return {
                events: []
            };
        }
    });
}
async function fetchSquaresMySquares(sessionToken, query) {
    const { page, perpage, states, dateFrom, dateTo } = query;
    const q = new URLSearchParams({
        page: String(page),
        perpage: String(perpage)
    });
    if (states) q.set("states", states);
    if (dateFrom) q.set("dateFrom", dateFrom);
    if (dateTo) q.set("dateTo", dateTo);
    const url = `${squaresApiBaseUrl()}/squares/mysquares/${encodeURIComponent(sessionToken)}?${q.toString()}`;
    const res = await fetch(url, {
        method: "GET",
        headers: (0, _authHeaders.getAuthHeaders)()
    });
    if (!res.ok) return {
        ok: false,
        data: [],
        count: 0
    };
    const result = await res.json().catch(()=>({}));
    return {
        ok: true,
        data: Array.isArray(result.data) ? result.data : [],
        count: typeof result.count === "number" ? result.count : 0
    };
}

},{"../../../utils/authHeaders":"5Rczo","../lib/squaresDemoApi":"gwrom","../../Leagues/lib/leagueSquaresRoomApi":"5Mc3o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwrom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSquaresDemoMatchId", ()=>(0, _squaresDemoMatchFixtures.isSquaresDemoMatchId));
parcelHelpers.export(exports, "squaresDemoCalculateOverOdds", ()=>squaresDemoCalculateOverOdds);
parcelHelpers.export(exports, "squaresDemoSubmit", ()=>squaresDemoSubmit);
parcelHelpers.export(exports, "squaresDemoMatchOverPlays", ()=>squaresDemoMatchOverPlays);
parcelHelpers.export(exports, "squaresDemoOverPlays", ()=>squaresDemoOverPlays);
parcelHelpers.export(exports, "squaresDemoMatchSocial", ()=>squaresDemoMatchSocial);
parcelHelpers.export(exports, "squaresDemoMyOversInMatch", ()=>squaresDemoMyOversInMatch);
parcelHelpers.export(exports, "squaresDemoTrySettleOver", ()=>squaresDemoTrySettleOver);
parcelHelpers.export(exports, "resetSquaresDemoSession", ()=>resetSquaresDemoSession);
var _squaresDemoState = require("./squaresDemoState");
var _squaresDemoMatchFixtures = require("./squaresDemoMatchFixtures");
function squaresDemoCalculateOverOdds(body) {
    const matchId = body?.matchId != null ? String(body.matchId) : "";
    if (!(0, _squaresDemoMatchFixtures.isSquaresDemoMatchId)(matchId)) return null;
    return (0, _squaresDemoMatchFixtures.buildSquaresDemoOddsGrid)();
}
async function squaresDemoSubmit(_sessionToken, body, userAccount) {
    const matchId = body?.matchId != null ? String(body.matchId) : "";
    if (!(0, _squaresDemoMatchFixtures.isSquaresDemoMatchId)(matchId)) return null;
    const selections = body?.selections ?? {};
    const overNumber = Number(body?.overNumber);
    const data = (0, _squaresDemoState.recordSquaresDemoSubmit)(selections, userAccount, Number.isFinite(overNumber) ? overNumber : undefined);
    return {
        ok: true,
        status: 200,
        data: {
            ...data,
            success: true
        }
    };
}
function squaresDemoMatchOverPlays(searchParams) {
    const matchId = searchParams.get("matchId") ?? "";
    if (!(0, _squaresDemoMatchFixtures.isSquaresDemoMatchId)(matchId)) return null;
    return Promise.resolve((0, _squaresDemoState.buildSquaresDemoMatchOverPlaysResponse)());
}
function squaresDemoOverPlays(searchParams) {
    const matchId = searchParams.get("matchId") ?? "";
    if (!(0, _squaresDemoMatchFixtures.isSquaresDemoMatchId)(matchId)) return null;
    const overNum = parseInt(searchParams.get("overNumber") ?? "", 10);
    let ballResults = null;
    const raw = searchParams.get("ballResults");
    if (raw) try {
        const parsed = JSON.parse(raw);
        ballResults = Array.isArray(parsed) ? parsed.map(String) : null;
    } catch  {
        ballResults = null;
    }
    return Promise.resolve((0, _squaresDemoState.buildSquaresDemoOverPlaysResponse)(overNum, ballResults));
}
function squaresDemoMatchSocial() {
    return Promise.resolve({
        friends_on_over: [],
        challenges: []
    });
}
function squaresDemoMyOversInMatch(_sessionToken, query, viewerUserId) {
    if (!(0, _squaresDemoMatchFixtures.isSquaresDemoMatchId)(query?.matchId)) return null;
    return Promise.resolve((0, _squaresDemoState.buildSquaresDemoMyOversInMatch)(viewerUserId));
}
function squaresDemoTrySettleOver() {
    return Promise.resolve({
        ok: true
    });
}
function resetSquaresDemoSession() {
    (0, _squaresDemoState.resetSquaresDemoState)();
}

},{"./squaresDemoState":"iZmLT","./squaresDemoMatchFixtures":"1xeIm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZmLT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeSquaresDemoState", ()=>subscribeSquaresDemoState);
parcelHelpers.export(exports, "resetSquaresDemoState", ()=>resetSquaresDemoState);
/** Sync viewer name/avatar after submit when the account payload resolves (e.g. wallet load). */ parcelHelpers.export(exports, "configureSquaresDemoViewer", ()=>configureSquaresDemoViewer);
parcelHelpers.export(exports, "getSquaresDemoSnapshot", ()=>getSquaresDemoSnapshot);
parcelHelpers.export(exports, "recordSquaresDemoSubmit", ()=>recordSquaresDemoSubmit);
parcelHelpers.export(exports, "buildSquaresDemoMatchOverPlaysResponse", ()=>buildSquaresDemoMatchOverPlaysResponse);
parcelHelpers.export(exports, "buildSquaresDemoOverPlaysResponse", ()=>buildSquaresDemoOverPlaysResponse);
parcelHelpers.export(exports, "buildSquaresDemoMyOversInMatch", ()=>buildSquaresDemoMyOversInMatch);
var _squaresBallResults = require("../shared/squaresBallResults");
var _squaresConstants = require("../shared/squaresConstants");
var _profileAvatarCatalog = require("../../../utils/profileAvatarCatalog");
var _leagueSuperSquares = require("../../Leagues/lib/leagueSuperSquares");
var _leagueModeStore = require("../../Leagues/lib/leagueModeStore");
var _leagueStore = require("../../Leagues/lib/leagueStore");
var _squaresDemoMatchFixtures = require("./squaresDemoMatchFixtures");
var _leaguePresenterLiveMatch = require("../../Leagues/lib/leaguePresenterLiveMatch");
function resolveDemoLeagueId() {
    const fromMode = (0, _leagueModeStore.peekActiveLeagueId)();
    if (fromMode) return fromMode;
    if (typeof window === "undefined") return null;
    try {
        return new URLSearchParams(window.location.search).get("leagueId")?.trim() || null;
    } catch  {
        return null;
    }
}
function isSuperSquaresDemoContext() {
    return Boolean(resolveDemoLeagueId());
}
const BALL_COUNT = 6;
const DEMO_OPPONENTS = [
    {
        userId: -9202,
        name: "Giraffe Pro",
        avatarIndex: 0,
        picks: [
            "2",
            "4",
            "0",
            "1",
            "2",
            "5+"
        ]
    },
    {
        userId: -9203,
        name: "Croc King",
        avatarIndex: 1,
        picks: [
            "1",
            "1",
            "1",
            "0",
            "3",
            "4"
        ]
    },
    {
        userId: -9204,
        name: "Rhino Ace",
        avatarIndex: 2,
        picks: [
            "0",
            "2",
            "2",
            "2",
            "1",
            "5+"
        ]
    },
    {
        userId: -9205,
        name: "Tiger Stripes",
        avatarIndex: 3,
        picks: [
            "4",
            "4",
            "4",
            "4",
            "4",
            "4"
        ]
    },
    {
        userId: -9206,
        name: "Monkey Business",
        avatarIndex: 4,
        picks: [
            "3",
            "3",
            "3",
            "3",
            "3",
            "3"
        ]
    },
    {
        userId: -9207,
        name: "Owl Eyes",
        avatarIndex: 5,
        picks: [
            "0",
            "0",
            "1",
            "1",
            "2",
            "2"
        ]
    },
    {
        userId: -9208,
        name: "Shark Attack",
        avatarIndex: 6,
        picks: [
            "5+",
            "5+",
            "4",
            "4",
            "3",
            "3"
        ]
    },
    {
        userId: -9209,
        name: "Elephant Power",
        avatarIndex: 7,
        picks: [
            "2",
            "2",
            "2",
            "3",
            "3",
            "3"
        ]
    },
    {
        userId: -9210,
        name: "Croc Crusher",
        avatarIndex: 1,
        picks: [
            "1",
            "2",
            "3",
            "4",
            "5+",
            "0"
        ]
    },
    {
        userId: -9211,
        name: "Rhino Rush",
        avatarIndex: 2,
        picks: [
            "5+",
            "5+",
            "4",
            "3",
            "2",
            "1"
        ]
    }
];
function demoBotAvatarUrl(avatarIndex) {
    const item = (0, _profileAvatarCatalog.FALLBACK_AVATAR_OPTIONS)[avatarIndex % (0, _profileAvatarCatalog.FALLBACK_AVATAR_OPTIONS).length];
    return (0, _profileAvatarCatalog.getAvatarThumbSrc)(item) || item?.url || null;
}
function resolveViewerUserId(userAccount) {
    const raw = userAccount?.id ?? userAccount?.userId ?? (0, _squaresDemoMatchFixtures.SQUARES_DEMO_VIEWER_USER_ID);
    if (raw == null || raw === "") return 0, _squaresDemoMatchFixtures.SQUARES_DEMO_VIEWER_USER_ID;
    const asNumber = Number(raw);
    return Number.isFinite(asNumber) ? asNumber : String(raw);
}
function resolveViewerDisplayName(userAccount) {
    return userAccount?.player_name || userAccount?.username || userAccount?.name || "You";
}
function resolveViewerAvatar(userAccount) {
    return userAccount?.avatar ?? (0, _squaresDemoMatchFixtures.squaresDemoViewerAvatar)();
}
function withAvatarFields(avatar) {
    return {
        avatar,
        profile_pic: avatar
    };
}
const BALL_MS = 2400;
let simTimer = null;
const listeners = new Set();
function emit() {
    listeners.forEach((fn)=>fn());
}
function chipsPerBall(totalChips) {
    const per = Math.floor(totalChips / BALL_COUNT);
    return per > 0 ? per : 1;
}
function buildSelectionsFromPicks(picks, grid) {
    const perBall = chipsPerBall(100);
    const selections = {};
    for(let ball = 1; ball <= 6; ball += 1){
        const runLabel = picks[ball - 1] ?? "1";
        const odds = parseFloat(grid.cells[runLabel]?.[ball] ?? "3");
        selections[String(ball)] = {
            run: runLabel,
            runLabel,
            chips: perBall,
            odds: Number.isFinite(odds) ? odds : 3
        };
    }
    return selections;
}
function runningChipsFor(selections, ballResults, superMode = false) {
    let sum = 0;
    for(let ball = 1; ball <= ballResults.length; ball += 1){
        const sel = selections[String(ball)];
        const result = ballResults[ball - 1];
        if (!sel || !result) continue;
        const pred = sel.run ?? sel.runLabel ?? "";
        const chips = Number(sel.chips) || 0;
        const odds = Number(sel.odds) || 0;
        if (chips <= 0 || odds <= 0 || !pred) continue;
        if ((0, _squaresBallResults.computeBallWon)(result, pred)) sum += chips * odds;
    }
    const base = Math.round(sum);
    if (!superMode) return base;
    return (0, _leagueSuperSquares.computeSuperSquaresBreakdown)(selections, ballResults).returnCoins;
}
function perBallFor(selections, ballResults) {
    const n = Math.min(ballResults.length, 6);
    const out = [];
    for(let i = 0; i < n; i += 1){
        const ball = i + 1;
        const sel = selections[String(ball)];
        const pred = sel?.run ?? sel?.runLabel ?? "";
        const selected = pred ? String(pred).trim() : null;
        const result = ballResults[i] != null ? String(ballResults[i]).trim() : "";
        const computed = result && selected ? (0, _squaresBallResults.computeBallWon)(result, selected) : null;
        const won = computed === true;
        out.push({
            ball,
            result,
            selected,
            won
        });
    }
    return out;
}
function rankPlays(plays) {
    const sorted = [
        ...plays
    ].sort((a, b)=>{
        const ar = Number(a.runningChips ?? a.score ?? 0);
        const br = Number(b.runningChips ?? b.score ?? 0);
        if (br !== ar) return br - ar;
        return (a.id ?? 0) - (b.id ?? 0);
    });
    let lastScore = null;
    let rank = 0;
    return sorted.map((p, i)=>{
        const score = Number(p.runningChips ?? p.score ?? 0);
        if (lastScore == null || score < lastScore) {
            rank = i + 1;
            lastScore = score;
        }
        return {
            ...p,
            rank
        };
    });
}
function enrichPlays(plays, ballsRevealed) {
    const results = activeBallResults();
    const raw = results.slice(0, ballsRevealed).map((b)=>(0, _squaresBallResults.displayBallResult)(b) ?? "0");
    const superMode = isSuperSquaresDemoContext();
    const enriched = plays.map((p)=>{
        const runningChips = runningChipsFor(p.selections, raw, superMode);
        return {
            ...p,
            runningChips,
            per_ball: perBallFor(p.selections, raw),
            ball_results: ballsRevealed >= 6 ? [
                ...results
            ] : null,
            score: ballsRevealed >= 6 ? runningChips : p.score,
            settled: ballsRevealed >= 6,
            ...superMode ? {
                super_squares: (0, _leagueSuperSquares.computeSuperSquaresBreakdown)(p.selections, raw)
            } : {}
        };
    });
    const ranked = rankPlays(enriched);
    if (ballsRevealed >= 6 && state.viewerSubmitted) return ensureViewerWinsRanking(ranked);
    return ranked;
}
function clearSimTimer() {
    if (simTimer != null) {
        clearInterval(simTimer);
        simTimer = null;
    }
}
const grid = (0, _squaresDemoMatchFixtures.buildSquaresDemoOddsGrid)();
function demoOverNumber() {
    return isSuperSquaresDemoContext() ? (0, _leaguePresenterLiveMatch.PRESENTER_LIVE_OVER) : (0, _squaresDemoMatchFixtures.SQUARES_DEMO_OVER_NUMBER);
}
function defaultBallResults() {
    return isSuperSquaresDemoContext() ? [
        ...(0, _leaguePresenterLiveMatch.PRESENTER_LIVE_BALL_RESULTS)
    ] : [
        ...(0, _squaresDemoMatchFixtures.SQUARES_DEMO_BALL_RESULTS)
    ];
}
function activeBallResults() {
    return state.scriptedBallResults;
}
/** Raw feed value that resolves as a win for the given Squares run label. */ function rawResultForRunLabel(runLabel) {
    const run = String(runLabel).trim();
    if (run === "5+") return "6";
    if (run === "0") return "0";
    if (run === "1") return "1";
    if (run === "2") return "2";
    if (run === "3") return "3";
    if (run === "4") return "4";
    return "1";
}
/** Demo showcase: land each ball on the viewer's pick so their row goes green. */ function ballResultsFromViewerSelections(selections) {
    return Array.from({
        length: 6
    }, (_, i)=>{
        const sel = selections[String(i + 1)];
        const run = sel?.run ?? sel?.runLabel;
        if (run == null || String(run).trim() === "") return "1";
        return rawResultForRunLabel(String(run));
    });
}
/**
 * League Super Squares demo: mostly hit the viewer's picks (accuracy tiers climb live)
 * and force a mid-over wicket so the ×2 celebration fires.
 */ function ballResultsForSuperSquaresDemo(selections) {
    const fromPicks = ballResultsFromViewerSelections(selections);
    const out = [
        ...fromPicks
    ];
    out[3] = "W";
    return out;
}
function ensureViewerWinsRanking(plays) {
    const uid = String(state.viewerUserId);
    const top = Math.max(0, ...plays.map((p)=>Number(p.runningChips ?? 0)));
    const boosted = plays.map((p)=>{
        if (!p.isBot && String(p.user_id) === uid) return {
            ...p,
            runningChips: Math.max(top + 1, Number(p.runningChips ?? 0))
        };
        return p;
    });
    return rankPlays(boosted);
}
const state = {
    phase: "idle",
    ballsRevealed: 0,
    refreshNonce: 0,
    viewerPlayId: 900001,
    plays: [],
    viewerUserId: (0, _squaresDemoMatchFixtures.SQUARES_DEMO_VIEWER_USER_ID),
    viewerSubmitted: false,
    scriptedBallResults: defaultBallResults(),
    oddsLocked: {
        [(0, _squaresDemoMatchFixtures.SQUARES_DEMO_OVER_NUMBER)]: true,
        [(0, _squaresDemoMatchFixtures.SQUARES_DEMO_OVER_NUMBER) + 1]: true
    }
};
function resolveSubmittedOverNumber(overNumber) {
    const n = Math.floor(Number(overNumber));
    return Number.isFinite(n) && n >= 1 ? n : demoOverNumber();
}
function buildViewerPlay(selections, userAccount, overNumber) {
    const userId = resolveViewerUserId(userAccount);
    const avatar = resolveViewerAvatar(userAccount);
    return {
        id: state.viewerPlayId,
        user_id: userId,
        name: resolveViewerDisplayName(userAccount),
        ...withAvatarFields(avatar),
        isBot: false,
        selections,
        created_at: new Date().toISOString(),
        stake: (0, _squaresConstants.SQUARES_ENTRANCE_FEE),
        ball_results: null,
        rank: null,
        score: null,
        winnings: null,
        settled: false,
        outcome: null,
        return: null,
        totalPot: null,
        over_number: resolveSubmittedOverNumber(overNumber)
    };
}
function seedBotPlays() {
    return DEMO_OPPONENTS.map((opp, idx)=>{
        const avatar = demoBotAvatarUrl(opp.avatarIndex);
        return {
            id: 900010 + idx,
            user_id: opp.userId,
            name: opp.name,
            ...withAvatarFields(avatar),
            isBot: true,
            selections: buildSelectionsFromPicks(opp.picks, grid),
            created_at: new Date().toISOString(),
            stake: (0, _squaresConstants.SQUARES_ENTRANCE_FEE),
            ball_results: null,
            rank: null,
            score: null,
            winnings: null,
            settled: false,
            outcome: null,
            return: null,
            totalPot: null,
            over_number: demoOverNumber()
        };
    });
}
function upsertSubmittedViewerProfile(userAccount) {
    if (!state.viewerSubmitted) return;
    const userId = resolveViewerUserId(userAccount);
    state.viewerUserId = userId;
    const humanIdx = state.plays.findIndex((p)=>!p.isBot);
    if (humanIdx < 0) return;
    const viewerPlay = {
        ...state.plays[humanIdx],
        user_id: userId,
        name: resolveViewerDisplayName(userAccount),
        ...withAvatarFields(resolveViewerAvatar(userAccount))
    };
    state.plays = [
        viewerPlay,
        ...state.plays.filter((p)=>p.isBot)
    ];
}
function resetInternal() {
    clearSimTimer();
    state.phase = "idle";
    state.ballsRevealed = 0;
    state.refreshNonce = 0;
    state.viewerPlayId = 900001;
    state.viewerUserId = (0, _squaresDemoMatchFixtures.SQUARES_DEMO_VIEWER_USER_ID);
    state.viewerSubmitted = false;
    state.scriptedBallResults = defaultBallResults();
    state.plays = seedBotPlays();
}
resetInternal();
function subscribeSquaresDemoState(listener) {
    listeners.add(listener);
    return ()=>listeners.delete(listener);
}
function resetSquaresDemoState() {
    resetInternal();
    emit();
}
function configureSquaresDemoViewer(userAccount) {
    if (!state.viewerSubmitted) return;
    upsertSubmittedViewerProfile(userAccount);
    emit();
}
function getSquaresDemoSnapshot() {
    return {
        phase: state.phase,
        ballsRevealed: state.ballsRevealed,
        refreshNonce: state.refreshNonce,
        ballResults: activeBallResults(),
        plays: enrichPlays(state.plays, state.ballsRevealed),
        oddsLocked: state.oddsLocked
    };
}
function bumpRefresh() {
    state.refreshNonce += 1;
}
/** When the scripted over finishes in a prototype league, settle the open Super Squares play. */ function settleProtoLeagueSquaresFromDemo(viewerPlay) {
    const leagueId = resolveDemoLeagueId();
    if (!leagueId) return;
    const league = (0, _leagueStore.findLeague)(leagueId);
    if (!league) return;
    const uid = Number(viewerPlay.user_id);
    if (!Number.isFinite(uid)) return;
    const overNum = Number(viewerPlay.over_number) || demoOverNumber();
    const open = league.plays.find((row)=>row.status === "open" && row.game === "squares" && row.userId === uid && Number(row.marketDetails?.overNumber) === overNum);
    if (!open) return;
    const balls = Array.isArray(viewerPlay.ball_results) ? viewerPlay.ball_results.map((b)=>String(b ?? "")) : activeBallResults();
    const superBr = viewerPlay.super_squares ?? (open.marketDetails?.selections ? (0, _leagueSuperSquares.computeSuperSquaresBreakdown)(open.marketDetails.selections, balls) : null);
    const returned = Math.max(0, Math.round(Number(superBr?.returnCoins ?? viewerPlay.runningChips ?? viewerPlay.score ?? 0) || 0));
    (0, _leagueStore.settleOpenPlayWithReturn)(leagueId, open.id, returned, {
        ...balls.length > 0 ? {
            ballResults: balls
        } : {},
        ...superBr ? {
            superSquares: {
                baseReturn: superBr.baseReturn,
                wicketCount: superBr.wicketCount,
                correctCount: superBr.correctCount,
                streakLength: superBr.streakLength,
                streakBonus: superBr.streakBonus,
                wicketMult: superBr.wicketMult,
                accuracyMult: superBr.accuracyMult,
                combinedMult: superBr.combinedMult,
                returnCoins: superBr.returnCoins
            }
        } : {}
    });
}
function advanceBallInternal() {
    if (state.ballsRevealed >= 6) return true;
    state.ballsRevealed += 1;
    if (state.ballsRevealed >= 6) {
        state.phase = "settled";
        const settled = enrichPlays(state.plays, 6).map((p)=>({
                ...p,
                settled: true,
                score: p.runningChips ?? 0,
                winnings: p.rank === 1 ? (0, _squaresDemoMatchFixtures.squaresDemoFirstPlacePrize)() : null,
                outcome: p.rank === 1 ? "WIN" : "LOSE",
                return: p.rank === 1 ? (0, _squaresDemoMatchFixtures.squaresDemoFirstPlacePrize)() : 0
            }));
        state.plays = settled;
        const viewer = settled.find((p)=>!p.isBot && String(p.user_id) === String(state.viewerUserId));
        if (viewer) settleProtoLeagueSquaresFromDemo(viewer);
        clearSimTimer();
        bumpRefresh();
        emit();
        return true;
    }
    state.plays = enrichPlays(state.plays, state.ballsRevealed);
    bumpRefresh();
    emit();
    return false;
}
function startSimTimer() {
    clearSimTimer();
    const tick = ()=>{
        if (advanceBallInternal()) clearSimTimer();
    };
    tick();
    simTimer = setInterval(tick, BALL_MS);
}
function recordSquaresDemoSubmit(selections, userAccount, overNumber) {
    state.viewerUserId = resolveViewerUserId(userAccount);
    const viewerPlay = buildViewerPlay(selections, userAccount, overNumber);
    state.plays = [
        viewerPlay,
        ...state.plays.filter((p)=>p.isBot || p.over_number !== viewerPlay.over_number)
    ];
    state.viewerSubmitted = true;
    const liveOver = demoOverNumber();
    const shouldSimulateLiveOver = viewerPlay.over_number === liveOver;
    if (shouldSimulateLiveOver) {
        state.phase = "simulating";
        state.ballsRevealed = 0;
        state.scriptedBallResults = isSuperSquaresDemoContext() ? ballResultsForSuperSquaresDemo(selections) : ballResultsFromViewerSelections(selections);
        bumpRefresh();
        emit();
        startSimTimer();
    } else {
        bumpRefresh();
        emit();
    }
    return {
        success: true,
        playId: viewerPlay.id
    };
}
function buildSquaresDemoMatchOverPlaysResponse() {
    const plays = enrichPlays(state.plays, state.ballsRevealed);
    const pool = (0, _squaresDemoMatchFixtures.squaresDemoPoolEntrantCount)(state.plays.length);
    // League Super Squares is points-model — no shared 1st-place coin prize.
    const top = isSuperSquaresDemoContext() ? 0 : (0, _squaresDemoMatchFixtures.squaresDemoFirstPlacePrize)();
    const results = activeBallResults();
    const ballResults = state.ballsRevealed >= 6 ? [
        ...results
    ] : null;
    const overs = {};
    if (ballResults) overs[demoOverNumber()] = {
        winners: plays,
        ball_results: ballResults,
        total_pot: pool * (0, _squaresConstants.SQUARES_ENTRANCE_FEE)
    };
    return {
        plays,
        overs,
        overOddsLocked: state.oddsLocked,
        over_economy: {
            [demoOverNumber()]: {
                pool_entrant_count: pool,
                top_prize: top,
                min_players: 4
            },
            [demoOverNumber() + 1]: {
                pool_entrant_count: pool,
                top_prize: top,
                min_players: 4
            }
        }
    };
}
function buildSquaresDemoOverPlaysResponse(overNumber, ballResultsParam) {
    const overNum = Number(overNumber);
    const plays = enrichPlays(state.plays.filter((p)=>p.over_number === overNum), state.ballsRevealed);
    let ballResults = ballResultsParam;
    if (ballResults == null && state.ballsRevealed > 0) ballResults = activeBallResults().slice(0, state.ballsRevealed).map((b)=>(0, _squaresBallResults.displayBallResult)(b) ?? "0");
    const pool = (0, _squaresDemoMatchFixtures.squaresDemoPoolEntrantCount)(state.plays.length);
    const ballsForEnrichment = ballResults && ballResults.length > 0 ? ballResults.length : state.ballsRevealed;
    return {
        plays: ballsForEnrichment > 0 ? enrichPlays(plays, ballsForEnrichment) : plays,
        ball_results: ballResults,
        min_players: 4,
        pool_entrant_count: pool,
        top_prize: isSuperSquaresDemoContext() ? 0 : (0, _squaresDemoMatchFixtures.squaresDemoFirstPlacePrize)()
    };
}
function buildSquaresDemoMyOversInMatch(viewerUserId) {
    const uid = viewerUserId != null ? String(viewerUserId) : String(state.viewerUserId);
    const overNumbers = [
        ...new Set(state.plays.filter((p)=>!p.isBot && (uid === "" || String(p.user_id) === uid)).map((p)=>Number(p.over_number)).filter((n)=>Number.isFinite(n) && n >= 1))
    ].sort((a, b)=>a - b);
    return {
        overNumbers
    };
}

},{"../shared/squaresBallResults":"idJxQ","../shared/squaresConstants":"9tbpY","../../../utils/profileAvatarCatalog":"i8TvT","../../Leagues/lib/leagueSuperSquares":"4dj0v","../../Leagues/lib/leagueModeStore":"kZgkv","../../Leagues/lib/leagueStore":"dMpsE","./squaresDemoMatchFixtures":"1xeIm","../../Leagues/lib/leaguePresenterLiveMatch":"YkC1d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMpsE":[function(require,module,exports,__globalThis) {
/**
 * Prototype store for the Leagues feature.
 *
 * Everything lives client-side: state is seeded from `prototypeData`, kept in a
 * module singleton, persisted to localStorage and published through
 * `useSyncExternalStore`. A timer fakes the realtime settlement stream so the
 * league table moves while you watch it.
 *
 * When this becomes real, swap the action bodies for API calls and the settlement
 * timer for the existing settlement sockets — component code should not change.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Demo-only local toggle for league start reminders. */ parcelHelpers.export(exports, "patchLeagueRemindMePrototype", ()=>patchLeagueRemindMePrototype);
parcelHelpers.export(exports, "getLeaguesSnapshot", ()=>getLeaguesSnapshot);
parcelHelpers.export(exports, "subscribeToLeagues", ()=>subscribeToLeagues);
parcelHelpers.export(exports, "findLeague", ()=>findLeague);
/** Shared prematch kickoff for `/leaguesdemo` lobby, Sixes, Bullion, Trader, and Squares. */ parcelHelpers.export(exports, "presenterDemoKickoffIso", ()=>presenterDemoKickoffIso);
parcelHelpers.export(exports, "findLeagueByCode", ()=>findLeagueByCode);
/** Leagues the viewer hosts or has joined. */ parcelHelpers.export(exports, "myLeagues", ()=>myLeagues);
parcelHelpers.export(exports, "pendingInvites", ()=>pendingInvites);
/** The first league the viewer is in (as host or member) for a given fixture, if any. */ parcelHelpers.export(exports, "viewerLeagueForFixture", ()=>viewerLeagueForFixture);
parcelHelpers.export(exports, "setVip", ()=>setVip);
parcelHelpers.export(exports, "setSimulating", ()=>setSimulating);
parcelHelpers.export(exports, "resetLeaguesPrototype", ()=>resetLeaguesPrototype);
/** Flip the presenter India–WI fixture to live and start light peer-play juice. */ parcelHelpers.export(exports, "startPresenterMatch", ()=>startPresenterMatch);
/**
 * Settle every open play, freeze the boards, and close the presenter league so the podium draws.
 */ parcelHelpers.export(exports, "finishPresenterLeague", ()=>finishPresenterLeague);
/**
 * Re-seeds the walkthrough league (kept for Tools / accidental callers).
 */ parcelHelpers.export(exports, "replayLiveLeagueDemo", ()=>replayLiveLeagueDemo);
parcelHelpers.export(exports, "createLeague", ()=>createLeague);
/**
 * Idempotent: ensure a match league with Bullion has a shared prototype private battle.
 * Returns the battle meta (existing or newly written).
 */ parcelHelpers.export(exports, "ensureLeagueBullionBattle", ()=>ensureLeagueBullionBattle);
/**
 * Prototype: mark the viewer as entered in the shared Bullion battle and open a
 * league play for the entry stake (idempotent if already entered).
 * Pass picks to persist the board for the demo played-view reopen.
 * Returns `{ ok: true }` or `{ ok: false, error }` when coins are short.
 */ parcelHelpers.export(exports, "enterLeagueBullionBattle", ()=>enterLeagueBullionBattle);
parcelHelpers.export(exports, "inviteFriendsToLeague", ()=>inviteFriendsToLeague);
/**
 * Prototype stand-in for a friend accepting: moves an invited friend into the
 * table so the host can see the effect of an invite without a second browser.
 */ parcelHelpers.export(exports, "simulateInviteAccepted", ()=>simulateInviteAccepted);
/** The viewer paying the entry fee and taking their starting coins. */ parcelHelpers.export(exports, "joinLeague", ()=>joinLeague);
/**
 * Prototype seat top-up: credit chips + bump startingCoins (profit-neutral) + grow pot.
 * Does not debit real rubies in demo mode.
 */ parcelHelpers.export(exports, "topUpLeagueSeat", ()=>topUpLeagueSeat);
parcelHelpers.export(exports, "declineInvite", ()=>declineInvite);
/**
 * Demo: bump sent/received tallies and prepend an Activity throw row.
 */ parcelHelpers.export(exports, "recordPrototypeLeagueReaction", ()=>recordPrototypeLeagueReaction);
/**
 * Apply a wallet coin delta that originated from a real game page in League mode.
 * Spends open a held play; positive returns settle that play for points without refilling chips.
 */ parcelHelpers.export(exports, "applyLeagueWalletDelta", ()=>applyLeagueWalletDelta);
/** Settle an open play by absolute chips scored as points (used by Super Squares demo). */ parcelHelpers.export(exports, "settleOpenPlayWithReturn", ()=>settleOpenPlayWithReturn);
/** Places a play. Coins are not debited until settlement — the stake is held open.
 * Squares: replacing picks on the same open over updates stake + grid in place. */ parcelHelpers.export(exports, "placePlay", ()=>placePlay);
/** First Sixes reveal in a prototype league — Activity + My Games card. Idempotent. */ parcelHelpers.export(exports, "recordPrototypeSixesCardIssued", ()=>recordPrototypeSixesCardIssued);
/** Prototype control: settle whichever open play is closest to settling. */ parcelHelpers.export(exports, "settleNow", ()=>settleNow);
/** Exported for the create flow preview: coins each player receives on join. */ parcelHelpers.export(exports, "previewStartingCoins", ()=>previewStartingCoins);
var _constants = require("./constants");
var _leagueFormat = require("./leagueFormat");
var _leagueGameSurfaces = require("./leagueGameSurfaces");
var _leagueBullionLobbyPicks = require("./leagueBullionLobbyPicks");
var _leaguePlays = require("./leaguePlays");
var _leagueReactionStats = require("./leagueReactionStats");
var _bullionDemoMatchFixtures = require("../../Bullion/lib/bullionDemoMatchFixtures");
var _sixesDemoFinish = require("../../Sixes/demo/sixesDemoFinish");
var _prototypeData = require("./prototypeData");
const STORAGE_KEY = "c8_leagues_prototype_v12";
const listeners = new Set();
/** Wall-clock when the current seed was written — must not reset on every tick/persist. */ let seededAtMs = Date.now();
let state = loadState();
let timerId = null;
function seedState() {
    seededAtMs = Date.now();
    return {
        leagues: (0, _prototypeData.prototypeLeagues)(),
        vip: true,
        simulating: false
    };
}
/**
 * Seed data is written relative to "now", so after a reload every timestamp is
 * replayed forward by however long the tab was closed. That keeps live leagues
 * live and the activity feed fresh without re-seeding away the user's own leagues.
 */ function shiftTimestamps(input, driftMs) {
    if (!Number.isFinite(driftMs) || driftMs <= 0) return input;
    const shift = (iso)=>{
        const at = new Date(iso).getTime();
        return Number.isFinite(at) ? new Date(at + driftMs).toISOString() : iso;
    };
    return {
        ...input,
        leagues: input.leagues.map((league)=>({
                ...league,
                createdAt: shift(league.createdAt),
                startsAt: shift(league.startsAt),
                endsAt: shift(league.endsAt),
                fixture: league.fixture ? {
                    ...league.fixture,
                    start: shift(league.fixture.start)
                } : null,
                members: league.members.map((member)=>({
                        ...member,
                        joinedAt: shift(member.joinedAt),
                        rankMovedAt: member.rankMovedAt ? shift(member.rankMovedAt) : undefined
                    })),
                settlements: league.settlements.map((row)=>({
                        ...row,
                        at: shift(row.at)
                    })),
                seatTopUps: (league.seatTopUps ?? []).map((row)=>({
                        ...row,
                        at: shift(row.at)
                    })),
                reactionEvents: (league.reactionEvents ?? []).map((row)=>({
                        ...row,
                        at: shift(row.at)
                    })),
                plays: (league.plays ?? []).map((row)=>({
                        ...row,
                        placedAt: shift(row.placedAt),
                        settlesAt: row.settlesAt ? shift(row.settlesAt) : row.settlesAt,
                        settledAt: row.settledAt ? shift(row.settledAt) : row.settledAt
                    }))
            }))
    };
}
/** Previous seat rates. Rebase persisted demo leagues to the current format-aware rate. */ const LEGACY_CHIPS_PER_RUBY = [
    1000,
    3000,
    5000,
    10000
];
function normalizeLeague(league) {
    const included = league.includedGames?.filter((game)=>(0, _constants.LEAGUE_GAME_KEYS).includes(game)) ?? [
        ...(0, _constants.LEAGUE_GAME_KEYS)
    ];
    const newStarting = (0, _leagueFormat.startingCoinsFor)(league.entryFeeRubies, (0, _leagueFormat.leagueFormatOvers)(league));
    const fee = Math.max(0, Math.round(league.entryFeeRubies));
    return {
        ...league,
        includedGames: included.length > 0 ? included : [
            ...(0, _constants.LEAGUE_GAME_KEYS)
        ],
        plays: league.plays ?? [],
        seatTopUps: league.seatTopUps ?? [],
        reactionEvents: league.reactionEvents ?? [],
        members: league.members.map((member)=>{
            const legacyRate = LEGACY_CHIPS_PER_RUBY.find((rate)=>member.startingCoins === fee * rate);
            if (legacyRate == null) return member;
            const oldStarting = fee * legacyRate;
            if (oldStarting === newStarting) return member;
            return {
                ...member,
                startingCoins: newStarting,
                coins: Math.max(0, member.coins + (newStarting - oldStarting))
            };
        })
    };
}
/**
 * Presenter India–WI must stay upcoming until Start match. Older localStorage
 * (or a closed tab) can let kickoff age into the past — only then rewind it.
 * A still-future kickoff is kept so the lobby and game pages share one clock.
 */ function ensurePresenterPrematch(input, now = Date.now()) {
    const idx = input.leagues.findIndex((league)=>league.id === (0, _prototypeData.WALKTHROUGH_LIVE_LEAGUE_ID));
    if (idx < 0) return {
        ...input,
        leagues: [
            (0, _prototypeData.buildWalkthroughLiveLeague)(now),
            ...input.leagues
        ]
    };
    const league = input.leagues[idx];
    if (league.presenterMatchStarted || league.settledAt) return input;
    const currentStart = new Date(league.fixture?.start || league.startsAt).getTime();
    if (Number.isFinite(currentStart) && currentStart > now) return input;
    const startMs = now + (0, _prototypeData.PRESENTER_PREMATCH_MS);
    const durationHours = league.fixture?.durationHours ?? 5;
    const next = {
        ...league,
        startsAt: new Date(startMs).toISOString(),
        endsAt: new Date(startMs + durationHours * 3600000).toISOString(),
        fixture: league.fixture ? {
            ...league.fixture,
            start: new Date(startMs).toISOString()
        } : league.fixture,
        presenterMatchStarted: false
    };
    const leagues = input.leagues.map((row, i)=>i === idx ? next : row);
    return {
        ...input,
        leagues
    };
}
function loadState() {
    if (typeof window === "undefined") return seedState();
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return seedState();
        const parsed = JSON.parse(raw);
        if (!parsed || !Array.isArray(parsed.leagues) || parsed.leagues.length === 0) return seedState();
        seededAtMs = Number(parsed.seededAt ?? Date.now());
        if (!Number.isFinite(seededAtMs)) seededAtMs = Date.now();
        const shifted = shiftTimestamps({
            leagues: parsed.leagues.map(normalizeLeague),
            vip: parsed.vip !== false,
            simulating: parsed.simulating === true
        }, Date.now() - seededAtMs);
        return ensurePresenterPrematch(shifted);
    } catch  {
        return seedState();
    }
}
function persist() {
    if (typeof window === "undefined") return;
    try {
        const payload = {
            ...state,
            seededAt: seededAtMs
        };
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch  {
    /* Private mode / quota — the prototype still works in memory. */ }
}
function commit(next) {
    state = next;
    persist();
    listeners.forEach((listener)=>listener());
    syncTimer();
}
function updateLeague(leagueId, updater) {
    let changed = false;
    const leagues = state.leagues.map((league)=>{
        if (league.id !== leagueId) return league;
        changed = true;
        return updater(league);
    });
    if (!changed) return;
    commit({
        ...state,
        leagues
    });
}
function patchLeagueRemindMePrototype(leagueId, remindMe) {
    updateLeague(leagueId, (league)=>({
            ...league,
            remindMe: Boolean(remindMe)
        }));
}
function getLeaguesSnapshot() {
    return state;
}
function subscribeToLeagues(listener) {
    listeners.add(listener);
    syncTimer();
    // Settle already-due seed plays on first subscriber without waiting a full tick.
    if (listeners.size === 1 && state.simulating) queueMicrotask(()=>tick());
    return ()=>{
        listeners.delete(listener);
        syncTimer();
    };
}
function findLeague(leagueId) {
    if (!leagueId) return null;
    return state.leagues.find((league)=>league.id === leagueId) ?? null;
}
function presenterDemoKickoffIso(leagueId, matchId) {
    const fromLeague = leagueId ? findLeague(leagueId) : null;
    const needle = String(matchId || "").trim();
    const fromMatch = needle ? state.leagues.find((row)=>String(row.fixture?.id || "").trim() === needle) ?? null : null;
    const league = fromLeague ?? fromMatch;
    if (!league) return null;
    const iso = String(league.fixture?.start || league.startsAt || "").trim();
    return iso || null;
}
function findLeagueByCode(code) {
    const needle = String(code ?? "").trim().toUpperCase();
    if (!needle) return null;
    return state.leagues.find((league)=>league.code.toUpperCase() === needle) ?? null;
}
function myLeagues() {
    return state.leagues.filter((league)=>league.membership === "host" || league.membership === "member");
}
function pendingInvites() {
    return state.leagues.filter((league)=>league.membership === "invited");
}
function viewerLeagueForFixture(fixtureId, excludeLeagueId) {
    if (!fixtureId) return null;
    return state.leagues.find((league)=>league.id !== excludeLeagueId && (league.membership === "host" || league.membership === "member") && league.fixture?.id === fixtureId) ?? null;
}
function setVip(vip) {
    commit({
        ...state,
        vip
    });
}
function setSimulating(simulating) {
    commit({
        ...state,
        simulating
    });
}
function resetLeaguesPrototype() {
    clearPresenterSixesReveal();
    commit(seedState());
}
function clearPresenterSixesReveal() {
    if (typeof window === "undefined") return;
    const matchId = "proto-ind-wi";
    try {
        window.sessionStorage.removeItem(`sixes:card-revealed:${matchId}`);
        window.sessionStorage.removeItem(`sixes:simulation-complete:${matchId}`);
        window.sessionStorage.removeItem(`sixes:demo-buckets:${matchId}`);
        window.localStorage.removeItem(`sixes:settlement-seen:${matchId}`);
        window.sessionStorage.removeItem(`bullion:league-sim-complete:${(0, _prototypeData.WALKTHROUGH_LIVE_LEAGUE_ID)}`);
    } catch  {
    /* ignore */ }
}
function clearPresenterSixesSettlement() {
    if (typeof window === "undefined") return;
    const matchId = "proto-ind-wi";
    try {
        window.sessionStorage.removeItem(`sixes:simulation-complete:${matchId}`);
        window.localStorage.removeItem(`sixes:settlement-seen:${matchId}`);
        window.sessionStorage.removeItem(`bullion:league-sim-complete:${(0, _prototypeData.WALKTHROUGH_LIVE_LEAGUE_ID)}`);
    } catch  {
    /* ignore */ }
}
function markPresenterBullionSimComplete(leagueId) {
    if (typeof window === "undefined") return;
    const id = String(leagueId || "").trim();
    if (!id) return;
    try {
        window.sessionStorage.setItem(`bullion:league-sim-complete:${id}`, "1");
        window.dispatchEvent(new CustomEvent("c8:bullion-league-sim-complete", {
            detail: {
                leagueId: id
            }
        }));
    } catch  {
    /* ignore */ }
}
/**
 * If the viewer skipped Bullion entry / Trader before kickoff, fill a lucky-dip slip
 * and a few open trades so My Games is not an empty Closed / No trades board.
 */ function seedPresenterKickoffViewerBoards(leagueId) {
    const league = findLeague(leagueId);
    if (!league) return;
    const viewer = league.members.find((member)=>member.isViewer);
    if (!viewer) return;
    if ((0, _leagueFormat.leagueIncludedGames)(league).includes("bullion")) {
        const slip = (0, _leagueBullionLobbyPicks.resolveLeagueBullionViewerSlip)(league, viewer.userId);
        const picks = slip?.picks;
        const hasPicks = Boolean(picks && typeof picks === "object" && Object.keys(picks).length > 0);
        if (!hasPicks) {
            const filled = (0, _bullionDemoMatchFixtures.buildBullionDemoFilledBoard)((0, _bullionDemoMatchFixtures.buildBullionDemoRoom)(league.fixture?.start));
            if (filled) enterLeagueBullionBattle(leagueId, {
                userId: viewer.userId,
                playerName: viewer.playerName,
                selections: filled.selections,
                bonusPicks: filled.bonusPicks
            });
        }
    }
    const latest = findLeague(leagueId) ?? league;
    if (!(0, _leagueFormat.leagueIncludedGames)(latest).includes("trader")) return;
    if (latest.plays.some((play)=>play.game === "trader" && play.userId === viewer.userId)) return;
    const home = latest.fixture?.homeTeam?.trim() || "India";
    const away = latest.fixture?.awayTeam?.trim() || "West Indies";
    const trades = [
        {
            stake: 200,
            selection: `${home} @ 1.72`,
            multiplier: 1.72,
            marketDetails: {
                marketName: "Match Winner",
                selectionName: home,
                marketClass: "Win",
                marketTeam: home
            }
        },
        {
            stake: 150,
            selection: `Over 165.5 @ 1.88`,
            multiplier: 1.88,
            marketDetails: {
                marketName: `${home} Innings Runs`,
                selectionName: "Over",
                marketClass: "Line",
                marketLine: "165.5",
                marketTeam: home
            }
        },
        {
            stake: 100,
            selection: `${away} Most Sixes @ 2.02`,
            multiplier: 2.02,
            marketDetails: {
                marketName: "Most Sixes",
                selectionName: away,
                marketClass: "Win",
                marketTeam: away
            }
        }
    ];
    for (const trade of trades)placePlay(leagueId, {
        userId: viewer.userId,
        playerName: viewer.playerName,
        game: "trader",
        stake: trade.stake,
        selection: trade.selection,
        multiplier: trade.multiplier,
        marketDetails: trade.marketDetails
    });
}
function startPresenterMatch(leagueId = (0, _prototypeData.WALKTHROUGH_LIVE_LEAGUE_ID)) {
    clearPresenterSixesSettlement();
    const now = Date.now();
    updateLeague(leagueId, (league)=>{
        const durationHours = league.fixture?.durationHours ?? 5;
        return {
            ...league,
            presenterMatchStarted: true,
            startsAt: new Date(now).toISOString(),
            endsAt: new Date(now + durationHours * 3600000).toISOString(),
            fixture: league.fixture ? {
                ...league.fixture,
                start: new Date(now).toISOString()
            } : league.fixture
        };
    });
    seedPresenterKickoffViewerBoards(leagueId);
    commit({
        ...state,
        simulating: true
    });
}
function presenterDemoScore(userId, salt) {
    return 40 + (Math.abs(userId) * 17 + salt) % 9 * 20;
}
function presenterTraderWon(play) {
    const hay = `${play.marketDetails?.selectionName ?? ""} ${play.selection}`.toLowerCase();
    if (hay.includes("west indies") || hay.includes("away")) return false;
    return hay.includes("india") || hay.includes("over") || hay.includes("home");
}
function settlePresenterOpenPlay(league, play) {
    if (play.status !== "open") return league;
    if (play.game === "sixes") {
        const existing = Math.max(0, Math.round(Number(play.marketDetails?.cardScore) || 0));
        const cardScore = existing > 0 ? existing : presenterDemoScore(play.userId, 3);
        return settlePlayWithReturn(league, play.id, cardScore, {
            cardScore,
            cardScoreUpdatedAt: new Date().toISOString()
        });
    }
    if (play.game === "bullion") {
        const existing = Math.max(0, Math.round(Number(play.marketDetails?.settlement?.points) || 0));
        const slip = existing > 0 ? existing : presenterDemoScore(play.userId, 11);
        return settlePlayWithReturn(league, play.id, slip, {
            settlement: {
                points: slip,
                potentialPoints: slip,
                settledMarkets: 5,
                totalMarkets: 5,
                allSettled: true,
                slipScore: slip,
                placeBonus: 0
            }
        });
    }
    if (play.game === "squares") {
        const scored = Math.max(0, Math.round(Number(play.marketDetails?.superSquares?.returnCoins) || 0));
        const returned = scored > 0 ? scored : Math.max(0, Math.round(play.stake * 0.45));
        return settlePlayWithReturn(league, play.id, returned);
    }
    const won = presenterTraderWon(play);
    const returned = won ? Math.round(play.stake * play.multiplier) : 0;
    return settlePlayWithReturn(league, play.id, returned);
}
function finishPresenterLeague(leagueId = (0, _prototypeData.WALKTHROUGH_LIVE_LEAGUE_ID)) {
    const current = findLeague(leagueId);
    if (!current || current.settledAt) return;
    const matchId = String(current.fixture?.id || "").trim() || "proto-ind-wi";
    (0, _sixesDemoFinish.persistSixesDemoMatchFinished)(matchId);
    markPresenterBullionSimComplete(leagueId);
    const now = Date.now();
    const iso = new Date(now).toISOString();
    updateLeague(leagueId, (league)=>{
        if (league.settledAt) return league;
        let next = league;
        for (const play of league.plays.filter((row)=>row.status === "open"))next = settlePresenterOpenPlay(next, play);
        next = {
            ...next,
            plays: next.plays.map((play)=>{
                if (play.game === "sixes") {
                    const score = Math.max(0, Math.round(Number(play.marketDetails?.cardScore) || 0));
                    if (score > 0) return play;
                    const cardScore = presenterDemoScore(play.userId, 3);
                    return {
                        ...play,
                        marketDetails: {
                            ...play.marketDetails ?? {},
                            cardScore,
                            cardScoreUpdatedAt: iso
                        }
                    };
                }
                if (play.game === "bullion" && play.marketDetails?.settlement?.points == null) {
                    const slip = presenterDemoScore(play.userId, 11);
                    return {
                        ...play,
                        marketDetails: {
                            ...play.marketDetails ?? {},
                            settlement: {
                                points: slip,
                                potentialPoints: slip,
                                settledMarkets: 5,
                                totalMarkets: 5,
                                allSettled: true,
                                slipScore: slip,
                                placeBonus: 0
                            }
                        }
                    };
                }
                return play;
            })
        };
        return {
            ...next,
            presenterMatchStarted: true,
            startsAt: league.presenterMatchStarted ? league.startsAt : iso,
            endsAt: iso,
            settledAt: iso,
            status: "ended",
            fixture: next.fixture ? {
                ...next.fixture,
                start: league.presenterMatchStarted ? next.fixture.start : iso
            } : next.fixture,
            bullionBattle: next.bullionBattle ? {
                ...next.bullionBattle,
                status: "settled",
                settledAt: iso
            } : next.bullionBattle
        };
    });
    if (state.simulating) commit({
        ...state,
        simulating: false
    });
}
function replayLiveLeagueDemo(leagueId) {
    if (leagueId !== (0, _prototypeData.WALKTHROUGH_LIVE_LEAGUE_ID)) return;
    resetLeaguesPrototype();
}
function makeCode(name) {
    const letters = name.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 4).padEnd(3, "X");
    let code = "";
    for(let attempt = 0; attempt < 50; attempt += 1){
        const suffix = Math.floor(100 + Math.random() * 900);
        code = `${letters}${suffix}`;
        if (!findLeagueByCode(code)) return code;
    }
    return code;
}
function createLeague(input, viewer) {
    const now = Date.now();
    const fixture = input.fixture ?? (input.fixtureId ? (0, _prototypeData.prototypeFixtures)(now).find((f)=>f.id === input.fixtureId) ?? null : null);
    const startsAt = input.scope === "match" && fixture ? fixture.start : new Date(now).toISOString();
    const endsAt = input.scope === "match" && fixture ? new Date(new Date(fixture.start).getTime() + fixture.durationHours * 3600000).toISOString() : new Date(input.endsAt ?? now + 86400000).toISOString();
    const includedGames = (()=>{
        const picked = input.includedGames?.filter((game)=>(0, _constants.LEAGUE_GAME_KEYS).includes(game)) ?? [
            ...(0, _constants.LEAGUE_GAME_KEYS)
        ];
        return picked.length > 0 ? picked : [
            ...(0, _constants.LEAGUE_GAME_KEYS)
        ];
    })();
    const league = {
        id: `league-${now}-${Math.floor(Math.random() * 1000)}`,
        code: makeCode(input.name),
        name: input.name.trim(),
        scope: input.scope,
        entryFeeRubies: input.entryFeeRubies,
        prizePotCoins: (0, _leagueFormat.leaguePrizePotCoinsForSeats)(input.entryFeeRubies, 1),
        createdAt: new Date(now).toISOString(),
        startsAt,
        endsAt,
        fixture: input.scope === "match" ? fixture : null,
        includedGames,
        hostUserId: (0, _constants.LEAGUE_VIEWER_USER_ID),
        hostName: viewer.name,
        members: [
            (0, _prototypeData.newMember)({
                userId: (0, _constants.LEAGUE_VIEWER_USER_ID),
                playerName: viewer.name,
                avatar: viewer.avatar,
                xpWeekCrown: viewer.xpWeekCrown ?? null,
                isHost: true,
                isViewer: true,
                entryFeeRubies: input.entryFeeRubies,
                formatOvers: input.scope === "match" ? fixture?.formatOvers : null,
                joinedAt: new Date(now).toISOString()
            })
        ],
        invitedUserIds: [],
        membership: "host",
        settlements: [],
        seatTopUps: [],
        reactionEvents: [],
        plays: [],
        bullionBattle: input.scope === "match" && includedGames.includes("bullion") ? {
            name: (0, _leagueGameSurfaces.leagueBullionBattleName)({
                name: input.name.trim()
            }),
            entryStake: (0, _leagueGameSurfaces.LEAGUE_BULLION_BATTLE_STAKE),
            ensuredAt: new Date(now).toISOString()
        } : undefined
    };
    commit({
        ...state,
        leagues: [
            league,
            ...state.leagues
        ]
    });
    return league;
}
function ensureLeagueBullionBattle(leagueId) {
    const existing = findLeague(leagueId);
    if (!existing) return null;
    if (existing.scope !== "match" || !(0, _leagueFormat.leagueIncludedGames)(existing).includes("bullion")) return existing.bullionBattle ?? null;
    if (existing.bullionBattle?.name) return existing.bullionBattle;
    const battle = {
        name: (0, _leagueGameSurfaces.leagueBullionBattleName)(existing),
        entryStake: (0, _leagueGameSurfaces.LEAGUE_BULLION_BATTLE_STAKE),
        ensuredAt: new Date().toISOString()
    };
    updateLeague(leagueId, (league)=>({
            ...league,
            bullionBattle: battle
        }));
    return battle;
}
function enterLeagueBullionBattle(leagueId, input) {
    const league = findLeague(leagueId);
    if (!league) return {
        ok: false,
        error: "League not found."
    };
    if (!(0, _leagueFormat.leagueIncludedGames)(league).includes("bullion")) return {
        ok: false,
        error: "Bullion is not in this league."
    };
    const battle = ensureLeagueBullionBattle(leagueId) ?? league.bullionBattle;
    if (!battle) return {
        ok: false,
        error: "Battle not ready."
    };
    const alreadyIn = battle.enteredUserIds?.includes(input.userId) || league.plays.some((play)=>play.game === "bullion" && play.userId === input.userId);
    const stake = Number.isFinite(Number(battle.entryStake)) ? Math.max(0, Math.round(Number(battle.entryStake))) : (0, _leagueGameSurfaces.LEAGUE_BULLION_BATTLE_STAKE);
    if (!alreadyIn && stake > 0) {
        const available = (0, _leaguePlays.availableCoinsFor)(league, input.userId);
        if (available < stake) return {
            ok: false,
            error: "Not enough league balls for this battle."
        };
    }
    const now = Date.now();
    const play = alreadyIn ? null : {
        id: `play-${now}-${input.userId}-bullion`,
        userId: input.userId,
        playerName: input.playerName,
        game: "bullion",
        stake,
        selection: battle.name,
        multiplier: 3,
        placedAt: new Date(now).toISOString(),
        settlesAt: new Date(now + (0, _constants.LEAGUE_PLAY_SETTLE_DELAY_MS)).toISOString(),
        status: "open"
    };
    const hasPicks = input.selections != null && Object.keys(input.selections).length > 0;
    updateLeague(leagueId, (row)=>{
        const current = row.bullionBattle ?? battle;
        const enteredUserIds = current.enteredUserIds?.includes(input.userId) ? current.enteredUserIds : [
            ...current.enteredUserIds ?? [],
            input.userId
        ];
        const viewerPicksByUserId = {
            ...current.viewerPicksByUserId ?? {}
        };
        const bonusPicks = Array.isArray(input.bonusPicks) ? input.bonusPicks : [];
        if (hasPicks) viewerPicksByUserId[String(input.userId)] = {
            selections: input.selections,
            bonusPicks
        };
        const viewerSlip = hasPicks ? {
            picks: input.selections,
            bonusPicks
        } : current.viewerSlip;
        return {
            ...row,
            bullionBattle: {
                ...current,
                enteredUserIds,
                viewerPicksByUserId,
                viewerEntered: true,
                ...viewerSlip ? {
                    viewerSlip
                } : {}
            },
            plays: play ? [
                play,
                ...row.plays
            ] : row.plays
        };
    });
    return {
        ok: true
    };
}
function inviteFriendsToLeague(leagueId, userIds) {
    updateLeague(leagueId, (league)=>{
        const existing = new Set(league.invitedUserIds);
        league.members.forEach((member)=>existing.add(member.userId));
        (league.declinedUserIds ?? []).forEach((id)=>existing.add(id));
        const added = userIds.filter((id)=>!existing.has(id));
        if (added.length === 0) return league;
        const invitedMembers = [
            ...league.invitedMembers ?? []
        ];
        for (const userId of added){
            const friend = (0, _prototypeData.friendById)(userId);
            invitedMembers.push({
                userId,
                playerName: friend?.playerName ?? `Player ${userId}`,
                avatar: friend?.avatar ?? null,
                xpWeekCrown: friend?.xpWeekCrown ?? null
            });
        }
        return {
            ...league,
            invitedUserIds: [
                ...league.invitedUserIds,
                ...added
            ],
            invitedMembers
        };
    });
}
function simulateInviteAccepted(leagueId, userId) {
    updateLeague(leagueId, (league)=>{
        if (!league.invitedUserIds.includes(userId)) return league;
        const friend = (0, _prototypeData.friendById)(userId);
        const entryBump = Math.max(0, Math.round(league.entryFeeRubies)) * (0, _constants.PRIZE_COINS_PER_RUBY);
        return {
            ...league,
            prizePotCoins: (0, _leagueFormat.leaguePrizePotCoins)(league) + entryBump,
            invitedUserIds: league.invitedUserIds.filter((id)=>id !== userId),
            invitedMembers: league.invitedMembers?.filter((member)=>member.userId !== userId),
            declinedUserIds: league.declinedUserIds?.filter((id)=>id !== userId),
            declinedMembers: league.declinedMembers?.filter((member)=>member.userId !== userId),
            members: [
                ...league.members,
                (0, _prototypeData.newMember)({
                    userId,
                    playerName: friend?.playerName ?? `Player ${userId}`,
                    avatar: friend?.avatar ?? null,
                    xpWeekCrown: friend?.xpWeekCrown ?? null,
                    isOnline: friend?.isOnline ?? false,
                    entryFeeRubies: league.entryFeeRubies,
                    formatOvers: (0, _leagueFormat.leagueFormatOvers)(league)
                })
            ]
        };
    });
}
function joinLeague(leagueId, viewer) {
    const target = findLeague(leagueId);
    if (!target) return false;
    if (target.members.some((member)=>member.isViewer)) return false;
    updateLeague(leagueId, (league)=>{
        const entryBump = Math.max(0, Math.round(league.entryFeeRubies)) * (0, _constants.PRIZE_COINS_PER_RUBY);
        return {
            ...league,
            prizePotCoins: (0, _leagueFormat.leaguePrizePotCoins)(league) + entryBump,
            membership: "member",
            invitedUserIds: league.invitedUserIds.filter((id)=>id !== (0, _constants.LEAGUE_VIEWER_USER_ID)),
            invitedMembers: league.invitedMembers?.filter((member)=>member.userId !== (0, _constants.LEAGUE_VIEWER_USER_ID)),
            declinedUserIds: league.declinedUserIds?.filter((id)=>id !== (0, _constants.LEAGUE_VIEWER_USER_ID)),
            declinedMembers: league.declinedMembers?.filter((member)=>member.userId !== (0, _constants.LEAGUE_VIEWER_USER_ID)),
            members: [
                ...league.members,
                (0, _prototypeData.newMember)({
                    userId: (0, _constants.LEAGUE_VIEWER_USER_ID),
                    playerName: viewer.name,
                    avatar: viewer.avatar,
                    xpWeekCrown: viewer.xpWeekCrown ?? null,
                    isViewer: true,
                    entryFeeRubies: league.entryFeeRubies,
                    formatOvers: (0, _leagueFormat.leagueFormatOvers)(league)
                })
            ]
        };
    });
    return true;
}
function topUpLeagueSeat(leagueId, userId = (0, _constants.LEAGUE_VIEWER_USER_ID)) {
    const target = findLeague(leagueId);
    if (!target) return {
        ok: false,
        error: "League not found."
    };
    if ((0, _leagueFormat.isLeagueRefunded)(target) || (0, _leagueFormat.leagueStatus)(target) === "ended" || target.scope === "match" && Boolean(target.matchFinishedAt)) return {
        ok: false,
        error: "This league is no longer open for top-ups."
    };
    const member = target.members.find((row)=>row.userId === userId);
    if (!member) return {
        ok: false,
        error: "You have not joined this league."
    };
    if ((0, _leagueFormat.memberSeatTopups)(member) >= (0, _constants.seatTopUpMax)((0, _leagueFormat.leagueFormatOvers)(target))) return {
        ok: false,
        error: "You have used all seat top-ups for this league."
    };
    const topUpAtOrBelow = (0, _leagueFormat.leagueSeatTopUpAvailableAtOrBelow)(target);
    const counting = (0, _leagueFormat.seatChipsCountingTowardTopUp)(target, userId);
    if (topUpAtOrBelow <= 0 || counting > topUpAtOrBelow) return {
        ok: false,
        error: `You can still play every game here \u{2014} top up once you have ${(0, _leagueFormat.formatCoins)(topUpAtOrBelow)} free league balls or fewer.`
    };
    const chips = (0, _leagueFormat.seatTopUpChips)((0, _leagueFormat.leagueFormatOvers)(target));
    const potBump = (0, _constants.SEAT_TOPUP_RUBIES) * (0, _constants.PRIZE_COINS_PER_RUBY);
    const seatTopupsAfter = (0, _leagueFormat.memberSeatTopups)(member) + 1;
    const playerName = member.playerName?.trim() || `Player ${userId}`;
    updateLeague(leagueId, (league)=>({
            ...league,
            prizePotCoins: (0, _leagueFormat.leaguePrizePotCoins)(league) + potBump,
            members: league.members.map((row)=>{
                if (row.userId !== userId) return row;
                return {
                    ...row,
                    coins: row.coins + chips,
                    startingCoins: row.startingCoins + chips,
                    seatTopups: seatTopupsAfter
                };
            }),
            plays: league.plays.map((play)=>{
                if (play.userId !== userId || play.game !== "squares" || play.status !== "open") return play;
                const current = Math.max(0, Math.floor(Number(play.stake) || 0));
                if (current <= 0) return play;
                const previous = Math.max(0, Math.floor(Number(play.marketDetails?.stakeFloor) || 0));
                const stakeFloor = Math.max(previous, current);
                return {
                    ...play,
                    marketDetails: {
                        ...play.marketDetails ?? {},
                        stakeFloor
                    }
                };
            }),
            seatTopUps: [
                {
                    id: `seat-topup-${leagueId}-${userId}-${seatTopupsAfter}`,
                    at: new Date().toISOString(),
                    userId,
                    playerName,
                    chips,
                    potBump,
                    rubies: (0, _constants.SEAT_TOPUP_RUBIES),
                    seatTopupsAfter
                },
                ...league.seatTopUps ?? []
            ]
        }));
    return {
        ok: true
    };
}
function declineInvite(leagueId) {
    updateLeague(leagueId, (league)=>{
        if (league.membership !== "invited") return league;
        const declined = league.invitedMembers?.find((member)=>member.userId === (0, _constants.LEAGUE_VIEWER_USER_ID));
        return {
            ...league,
            membership: "none",
            invitedUserIds: league.invitedUserIds.filter((id)=>id !== (0, _constants.LEAGUE_VIEWER_USER_ID)),
            invitedMembers: league.invitedMembers?.filter((member)=>member.userId !== (0, _constants.LEAGUE_VIEWER_USER_ID)),
            declinedUserIds: [
                ...(league.declinedUserIds ?? []).filter((id)=>id !== (0, _constants.LEAGUE_VIEWER_USER_ID)),
                (0, _constants.LEAGUE_VIEWER_USER_ID)
            ],
            declinedMembers: [
                ...(league.declinedMembers ?? []).filter((member)=>member.userId !== (0, _constants.LEAGUE_VIEWER_USER_ID)),
                ...declined ? [
                    declined
                ] : [
                    {
                        userId: (0, _constants.LEAGUE_VIEWER_USER_ID),
                        playerName: "You",
                        avatar: null
                    }
                ]
            ]
        };
    });
}
function recordPrototypeLeagueReaction(input) {
    const { leagueId, fromUserId, targetUserId, emoji } = input;
    if (!leagueId || fromUserId === targetUserId) return;
    updateLeague(leagueId, (league)=>{
        const event = (0, _leagueReactionStats.leagueReactionActivityFromThrow)({
            reactionId: input.reactionId?.trim() || `proto-throw-${Date.now()}-${fromUserId}-${targetUserId}`,
            members: league.members,
            fromUserId,
            targetUserId,
            emoji
        });
        return {
            ...league,
            members: (0, _leagueReactionStats.applyLeagueReactionToMembers)(league.members, {
                fromUserId,
                targetUserId,
                emoji
            }),
            reactionEvents: event ? (0, _leagueReactionStats.prependLeagueReactionEvent)(league.reactionEvents, event) : league.reactionEvents
        };
    });
    if (fromUserId === (0, _constants.LEAGUE_VIEWER_USER_ID) && typeof window !== "undefined") window.setTimeout(()=>{
        require("db7767eb15a6aec").then((mod)=>{
            const latest = findLeague(leagueId);
            if (!latest) return;
            mod.simulateIncomingLeagueReaction(leagueId, latest.members, {
                targetUserId: fromUserId
            });
        });
    }, 1200);
}
function pick(items) {
    return items[Math.floor(Math.random() * items.length)];
}
function applyLeagueWalletDelta(leagueId, input) {
    if (!Number.isFinite(input.delta) || input.delta === 0) return;
    if (input.delta < 0) {
        placePlay(leagueId, {
            userId: input.userId,
            playerName: input.playerName,
            game: input.game,
            stake: Math.round(Math.abs(input.delta)),
            selection: input.selection ?? `${(0, _constants.LEAGUE_GAME_META)[input.game].label} play`,
            multiplier: 2,
            settleDelayMs: 120000
        });
        return;
    }
    updateLeague(leagueId, (league)=>{
        const play = league.plays.find((row)=>row.status === "open" && row.userId === input.userId && row.game === input.game);
        // Orphan credits used to refill seat chips — ignore them. Chips only come from ruby top-ups.
        if (!play) return league;
        return settlePlayWithReturn(league, play.id, Math.round(input.delta));
    });
}
function settlePlayWithReturn(league, playId, returnedCoins, marketDetailsPatch) {
    const play = league.plays.find((row)=>row.id === playId && row.status === "open");
    if (!play) return league;
    // Squares points model: any scored return is a win. Other games still need to beat stake.
    const won = play.game === "squares" ? returnedCoins > 0 : returnedCoins > play.stake;
    const delta = returnedCoins - play.stake;
    // Spend the held stake; scoring return never refills chips.
    const seatDelta = -play.stake;
    const ranksBefore = new Map((0, _leagueFormat.leagueTableRows)(league).map((row)=>[
            row.userId,
            row.rank
        ]));
    const nextMarketDetails = marketDetailsPatch != null ? {
        ...play.marketDetails ?? {},
        ...marketDetailsPatch
    } : play.marketDetails;
    const members = league.members.map((member)=>{
        if (member.userId !== play.userId) return member;
        const stats = member.byGame[play.game] ?? {
            pl: 0,
            wins: 0,
            losses: 0,
            played: 0
        };
        return {
            ...member,
            coins: member.coins + seatDelta,
            byGame: {
                ...member.byGame,
                [play.game]: {
                    pl: stats.pl + delta,
                    wins: stats.wins + (won ? 1 : 0),
                    losses: stats.losses + (won ? 0 : 1),
                    played: stats.played + 1
                }
            }
        };
    });
    const settlement = {
        id: `settle-${play.id}`,
        at: new Date().toISOString(),
        userId: play.userId,
        playerName: play.playerName,
        game: play.game,
        outcome: won ? "win" : "loss",
        stake: play.stake,
        delta,
        detail: `${play.selection} \xb7 ${won ? `scored ${returnedCoins.toLocaleString()}` : "lost"}`,
        ...nextMarketDetails ? {
            marketDetails: nextMarketDetails
        } : {}
    };
    const settled = {
        ...league,
        members,
        plays: league.plays.map((row)=>row.id === play.id ? {
                ...row,
                status: "settled",
                outcome: won ? "win" : "loss",
                delta,
                ...nextMarketDetails ? {
                    marketDetails: nextMarketDetails
                } : {}
            } : row),
        settlements: [
            settlement,
            ...league.settlements
        ]
    };
    return markRankChanges(settled, ranksBefore);
}
function settleOpenPlayWithReturn(leagueId, playId, returnedCoins, marketDetailsPatch) {
    updateLeague(leagueId, (league)=>settlePlayWithReturn(league, playId, Math.max(0, Math.round(returnedCoins)), marketDetailsPatch));
}
function placePlay(leagueId, input) {
    updateLeague(leagueId, (league)=>{
        if (!(0, _leagueFormat.leagueIncludedGames)(league).includes(input.game)) return league;
        if (input.game === "squares" && input.marketDetails?.overNumber != null) {
            const overNum = Number(input.marketDetails.overNumber);
            const innsNum = input.marketDetails.inningsNumber != null ? Number(input.marketDetails.inningsNumber) : 1;
            const existing = league.plays.find((row)=>row.status === "open" && row.game === "squares" && row.userId === input.userId && Number(row.marketDetails?.overNumber) === overNum && Number(row.marketDetails?.inningsNumber ?? 1) === innsNum);
            if (existing) {
                const available = (0, _leaguePlays.availableCoinsFor)(league, input.userId) + Math.max(0, Number(existing.stake) || 0);
                if (input.stake > available) return league;
                const stakeFloor = Math.max(0, Math.floor(Number(existing.marketDetails?.stakeFloor) || 0));
                if (input.stake < stakeFloor) return league;
                return {
                    ...league,
                    plays: league.plays.map((row)=>row.id === existing.id ? {
                            ...row,
                            stake: input.stake,
                            selection: input.selection,
                            multiplier: input.multiplier,
                            marketDetails: {
                                ...input.marketDetails,
                                ...stakeFloor > 0 ? {
                                    stakeFloor
                                } : {}
                            }
                        } : row)
                };
            }
        }
        const now = Date.now();
        const available = (0, _leaguePlays.availableCoinsFor)(league, input.userId);
        if (input.stake > available) return league;
        const play = {
            id: `play-${now}-${input.userId}-${Math.floor(Math.random() * 10000)}`,
            userId: input.userId,
            playerName: input.playerName,
            game: input.game,
            stake: input.stake,
            selection: input.selection,
            multiplier: input.multiplier,
            placedAt: new Date(now).toISOString(),
            settlesAt: new Date(now + (input.settleDelayMs ?? (0, _constants.LEAGUE_PLAY_SETTLE_DELAY_MS))).toISOString(),
            status: "open",
            ...input.marketDetails ? {
                marketDetails: input.marketDetails
            } : {}
        };
        return {
            ...league,
            plays: [
                play,
                ...league.plays
            ]
        };
    });
}
function recordPrototypeSixesCardIssued(leagueId, viewer) {
    const league = findLeague(leagueId);
    if (!league) return;
    const already = league.plays.some((play)=>play.game === "sixes" && play.userId === viewer.userId);
    if (already) return;
    placePlay(leagueId, {
        userId: viewer.userId,
        playerName: viewer.name,
        game: "sixes",
        stake: 0,
        selection: "One card",
        multiplier: 1,
        settleDelayMs: 28800000,
        marketDetails: {
            cardScore: 0
        }
    });
}
/** Records who actually changed position, so the movement arrows survive a few settlements. */ function markRankChanges(league, before) {
    const movedAt = new Date().toISOString();
    const after = new Map((0, _leagueFormat.leagueTableRows)(league).map((row)=>[
            row.userId,
            row.rank
        ]));
    return {
        ...league,
        members: league.members.map((member)=>{
            const previous = before.get(member.userId);
            const current = after.get(member.userId);
            if (previous == null || current == null || previous === current) return member;
            return {
                ...member,
                previousRank: previous,
                rankMovedAt: movedAt
            };
        })
    };
}
/** Longer odds win less often. Seeded viewer plays lean win-y so the walkthrough shows a toast. */ function didPlayWin(multiplier, play) {
    if (play.id.startsWith("seed-play-") && play.userId === (0, _constants.LEAGUE_VIEWER_USER_ID)) return Math.random() < 0.78;
    const chance = Math.min(0.7, Math.max(0.12, 0.98 / multiplier));
    return Math.random() < chance;
}
function applyPlaySettlement(league, playId) {
    const play = league.plays.find((row)=>row.id === playId && row.status === "open");
    if (!play) return league;
    const won = didPlayWin(play.multiplier, play);
    const returned = won ? Math.round(play.stake * play.multiplier) : 0;
    const delta = returned - play.stake;
    const seatDelta = -play.stake;
    const ranksBefore = new Map((0, _leagueFormat.leagueTableRows)(league).map((row)=>[
            row.userId,
            row.rank
        ]));
    const members = league.members.map((member)=>{
        if (member.userId !== play.userId) return member;
        const stats = member.byGame[play.game] ?? {
            pl: 0,
            wins: 0,
            losses: 0,
            played: 0
        };
        return {
            ...member,
            coins: member.coins + seatDelta,
            byGame: {
                ...member.byGame,
                [play.game]: {
                    pl: stats.pl + delta,
                    wins: stats.wins + (won ? 1 : 0),
                    losses: stats.losses + (won ? 0 : 1),
                    played: stats.played + 1
                }
            }
        };
    });
    const settlement = {
        id: `settle-${play.id}`,
        at: new Date().toISOString(),
        userId: play.userId,
        playerName: play.playerName,
        game: play.game,
        outcome: won ? "win" : "loss",
        stake: play.stake,
        delta,
        detail: `${play.selection} \xb7 ${won ? `scored ${returned.toLocaleString()}` : "lost"}`,
        ...play.marketDetails ? {
            marketDetails: play.marketDetails
        } : {}
    };
    const settled = {
        ...league,
        members,
        plays: league.plays.map((row)=>row.id === play.id ? {
                ...row,
                status: "settled",
                outcome: won ? "win" : "loss",
                delta
            } : row),
        settlements: [
            settlement,
            ...league.settlements
        ]
    };
    return markRankChanges(settled, ranksBefore);
}
/** Bots keep the in-play list and the feed alive without the viewer doing anything. */ function addBotPlay(league) {
    const openByBots = league.plays.filter((play)=>play.status === "open" && !isViewerId(league, play.userId));
    if (openByBots.length >= (0, _constants.LEAGUE_MAX_OPEN_BOT_PLAYS)) return league;
    const candidates = league.members.filter((member)=>!member.isViewer && (0, _leaguePlays.availableCoinsFor)(league, member.userId) >= (0, _constants.LEAGUE_PLAY_STAKE_MIN));
    if (candidates.length === 0) return league;
    const member = pick(candidates);
    const available = (0, _leaguePlays.availableCoinsFor)(league, member.userId);
    const affordable = (0, _constants.LEAGUE_PLAY_STAKE_PRESETS).filter((stake)=>stake <= available);
    const options = (0, _leaguePlays.allPlayOptions)(league);
    if (options.length === 0) return league;
    const option = pick(options);
    const now = Date.now();
    const play = {
        id: `play-${now}-${member.userId}-${Math.floor(Math.random() * 10000)}`,
        userId: member.userId,
        playerName: member.playerName,
        game: option.game,
        stake: affordable.length > 0 ? pick(affordable) : (0, _constants.LEAGUE_PLAY_STAKE_MIN),
        selection: option.label,
        multiplier: option.multiplier,
        placedAt: new Date(now).toISOString(),
        settlesAt: new Date(now + (0, _constants.LEAGUE_BOT_PLAY_SETTLE_MIN_MS) + Math.random() * ((0, _constants.LEAGUE_BOT_PLAY_SETTLE_MAX_MS) - (0, _constants.LEAGUE_BOT_PLAY_SETTLE_MIN_MS))).toISOString(),
        status: "open"
    };
    return {
        ...league,
        plays: [
            play,
            ...league.plays
        ]
    };
}
function isViewerId(league, userId) {
    return league.members.some((member)=>member.userId === userId && member.isViewer);
}
function advanceLeague(league, now) {
    let next = league;
    const due = next.plays.filter((play)=>{
        if (play.status !== "open" || !play.settlesAt) return false;
        return new Date(play.settlesAt).getTime() <= now;
    });
    due.forEach((play)=>{
        next = applyPlaySettlement(next, play.id);
    });
    const botChance = league.id === (0, _prototypeData.WALKTHROUGH_LIVE_LEAGUE_ID) ? 0.12 : (0, _constants.LEAGUE_BOT_PLAY_CHANCE);
    if (Math.random() < botChance) next = addBotPlay(next);
    return next;
}
function settleNow(leagueId) {
    updateLeague(leagueId, (league)=>{
        const open = league.plays.filter((play)=>play.status === "open").sort((a, b)=>{
            const aAt = a.settlesAt ? new Date(a.settlesAt).getTime() : Number.POSITIVE_INFINITY;
            const bAt = b.settlesAt ? new Date(b.settlesAt).getTime() : Number.POSITIVE_INFINITY;
            return aAt - bAt;
        });
        if (open.length === 0) {
            const seeded = addBotPlay(league);
            const first = seeded.plays.find((play)=>play.status === "open");
            return first ? applyPlaySettlement(seeded, first.id) : league;
        }
        return applyPlaySettlement(league, open[0].id);
    });
}
function tick() {
    if (!state.simulating) return;
    const now = Date.now();
    let changed = false;
    const leagues = state.leagues.map((league)=>{
        if (league.membership !== "host" && league.membership !== "member") return league;
        if ((0, _leagueFormat.leagueStatus)(league, now) !== "live") return league;
        if ((0, _leagueFormat.isLeagueRefunded)(league, now)) return league;
        const next = advanceLeague(league, now);
        if (next !== league) changed = true;
        return next;
    });
    if (!changed) return;
    commit({
        ...state,
        leagues
    });
}
function shouldRunTimer() {
    if (listeners.size === 0 || !state.simulating) return false;
    return state.leagues.some((league)=>(league.membership === "host" || league.membership === "member") && (0, _leagueFormat.leagueStatus)(league) === "live" && !(0, _leagueFormat.isLeagueRefunded)(league));
}
function syncTimer() {
    if (typeof window === "undefined") return;
    const wanted = shouldRunTimer();
    if (wanted && timerId == null) {
        timerId = setInterval(tick, (0, _constants.LEAGUE_SIMULATION_TICK_MS));
        return;
    }
    if (!wanted && timerId != null) {
        clearInterval(timerId);
        timerId = null;
    }
}
function previewStartingCoins(entryFeeRubies) {
    return (0, _leagueFormat.startingCoinsFor)(entryFeeRubies);
}

},{"./constants":"dZVub","./leagueFormat":"jKCIi","./leagueGameSurfaces":"gIAym","./leagueBullionLobbyPicks":"ehhHA","./leaguePlays":"iWKr6","./leagueReactionStats":"8M1NW","../../Bullion/lib/bullionDemoMatchFixtures":"aydOs","../../Sixes/demo/sixesDemoFinish":"4ujkj","./prototypeData":"8QimC","db7767eb15a6aec":"4EyCR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ehhHA":[function(require,module,exports,__globalThis) {
/**
 * Curate Bullion slip picks for the league Play lobby rail.
 * Prefer: biggest open pot, biggest won pts, and the gold/bonus line.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Prefer API `viewerSlip`; fall back to prototype `viewerPicksByUserId` (demo enter path).
 */ parcelHelpers.export(exports, "resolveLeagueBullionViewerSlip", ()=>resolveLeagueBullionViewerSlip);
parcelHelpers.export(exports, "LEAGUE_BULLION_LOBBY_PICK_LIMIT", ()=>LEAGUE_BULLION_LOBBY_PICK_LIMIT);
parcelHelpers.export(exports, "LEAGUE_BULLION_LOBBY_CARD_WIDTH_PX", ()=>LEAGUE_BULLION_LOBBY_CARD_WIDTH_PX);
parcelHelpers.export(exports, "LEAGUE_BULLION_LOBBY_CARD_GAP_PX", ()=>LEAGUE_BULLION_LOBBY_CARD_GAP_PX);
parcelHelpers.export(exports, "LEAGUE_BULLION_LOBBY_RAIL_PADDING_PX", ()=>LEAGUE_BULLION_LOBBY_RAIL_PADDING_PX);
/** How many 80px cards fit in the lobby rail (up to the full slip). */ parcelHelpers.export(exports, "leagueBullionLobbyPickLimitForWidth", ()=>leagueBullionLobbyPickLimitForWidth);
/**
 * Pick a small highlight set from the full slip, then order for the lobby:
 * open pot → won pts → gold (deduped).
 */ parcelHelpers.export(exports, "selectLeagueBullionLobbyPickCards", ()=>selectLeagueBullionLobbyPickCards);
/** Story order for the lobby rail: cooking pot → biggest hit → gold bar. */ parcelHelpers.export(exports, "orderLeagueBullionLobbyPickCards", ()=>orderLeagueBullionLobbyPickCards);
var _constants = require("./constants");
function resolveLeagueBullionViewerSlip(league, userId) {
    const battle = league.bullionBattle;
    if (!battle) return null;
    const slip = battle.viewerSlip ?? null;
    const slipPicks = slip?.picks;
    if (slipPicks && typeof slipPicks === "object" && Object.keys(slipPicks).length > 0) return slip;
    if (userId != null && userId > 0) {
        const saved = battle.viewerPicksByUserId?.[String(userId)] ?? battle.viewerPicksByUserId?.[String((0, _constants.LEAGUE_VIEWER_USER_ID))];
        const selections = saved?.selections;
        if (selections && typeof selections === "object" && Object.keys(selections).length > 0) return {
            picks: selections,
            bonusPicks: Array.isArray(saved?.bonusPicks) ? saved.bonusPicks : []
        };
    }
    return slip;
}
const LEAGUE_BULLION_LOBBY_PICK_LIMIT = 6;
const LEAGUE_BULLION_LOBBY_CARD_WIDTH_PX = 80;
const LEAGUE_BULLION_LOBBY_CARD_GAP_PX = 8;
const LEAGUE_BULLION_LOBBY_RAIL_PADDING_PX = 16;
function leagueBullionLobbyPickLimitForWidth(railWidthPx, totalPicks) {
    if (totalPicks <= 0) return 0;
    const inner = Math.max(0, railWidthPx - LEAGUE_BULLION_LOBBY_RAIL_PADDING_PX);
    const slot = LEAGUE_BULLION_LOBBY_CARD_WIDTH_PX + LEAGUE_BULLION_LOBBY_CARD_GAP_PX;
    const fits = slot > 0 ? Math.floor((inner + LEAGUE_BULLION_LOBBY_CARD_GAP_PX) / slot) : 1;
    return Math.min(totalPicks, Math.max(1, fits));
}
function sortByDesc(a, b) {
    return b - a;
}
function selectLeagueBullionLobbyPickCards(cards, limit = LEAGUE_BULLION_LOBBY_PICK_LIMIT) {
    if (cards.length === 0) return [];
    const max = Math.max(1, Math.floor(limit));
    if (cards.length <= max) return orderLeagueBullionLobbyPickCards(cards);
    const selected = new Map();
    const take = (card)=>{
        if (!card || selected.has(card.key) || selected.size >= max) return;
        selected.set(card.key, card);
    };
    const openByPot = cards.filter((card)=>card.outcome === "open").sort((a, b)=>sortByDesc(a.potPoints, b.potPoints));
    const wonByPts = cards.filter((card)=>card.outcome === "won").sort((a, b)=>sortByDesc(a.points, b.points));
    const gold = cards.find((card)=>card.gold);
    const restByPot = [
        ...cards
    ].sort((a, b)=>sortByDesc(a.potPoints, b.potPoints));
    // Always surface the bonus line, then best correct pts, then best remaining pot.
    take(gold);
    take(wonByPts[0]);
    take(openByPot[0]);
    for (const card of wonByPts)take(card);
    for (const card of openByPot)take(card);
    // Avoid filling with settled misses (0 pts) — bonus is already taken above.
    for (const card of restByPot.filter((row)=>row.outcome !== "lost"))take(card);
    return orderLeagueBullionLobbyPickCards([
        ...selected.values()
    ]);
}
function orderLeagueBullionLobbyPickCards(cards) {
    if (cards.length <= 1) return cards;
    const ordered = [];
    const used = new Set();
    const push = (card)=>{
        if (!card || used.has(card.key)) return;
        used.add(card.key);
        ordered.push(card);
    };
    push([
        ...cards
    ].filter((card)=>card.outcome === "open").sort((a, b)=>sortByDesc(a.potPoints, b.potPoints))[0]);
    // Prefer a non-gold win in the middle so the bonus keeps its own end slot.
    const wonSorted = [
        ...cards
    ].filter((card)=>card.outcome === "won").sort((a, b)=>sortByDesc(a.points, b.points));
    push(wonSorted.find((card)=>!card.gold) ?? wonSorted[0]);
    push(cards.find((card)=>card.gold));
    for (const card of [
        ...cards
    ].sort((a, b)=>sortByDesc(a.potPoints, b.potPoints)))push(card);
    return ordered;
}

},{"./constants":"dZVub","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ujkj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Persist a finished demo card so the lobby mini-grid and Open Card skip the live sim.
 * Used by the presenter Finish league control.
 */ parcelHelpers.export(exports, "persistSixesDemoMatchFinished", ()=>persistSixesDemoMatchFinished);
var _sixesDemoCard = require("./sixesDemoCard");
var _sixesBucketSlide = require("../lib/sixesBucketSlide");
var _sixesMarketBucket = require("../lib/sixesMarketBucket");
var _sixesCardRevealStorage = require("../lib/sixesCardRevealStorage");
var _sixesSettlementSeenStorage = require("../lib/sixesSettlementSeenStorage");
function persistSixesDemoMatchFinished(matchId) {
    const id = String(matchId || "").trim();
    if (!id) return;
    (0, _sixesCardRevealStorage.markSixesCardRevealed)(id);
    const card = (0, _sixesDemoCard.generateSixesDemoCard)(id);
    const outcomes = (0, _sixesBucketSlide.buildSettledCellOutcomes)(card);
    const stats = (0, _sixesBucketSlide.settledFooterStats)(card);
    (0, _sixesSettlementSeenStorage.writeSixesSeenSettlement)(id, {
        v: 2,
        outcomes,
        celebratedLineKeys: [],
        celebratedBuckets: card.slideTargets.map((target)=>target.bucket),
        footerStats: {
            wins: stats.wins,
            slides: stats.slides,
            natural: stats.natural,
            coins: stats.coins,
            multiplierSixes: 2
        },
        cellColors: card.buckets.map((bucket)=>(0, _sixesMarketBucket.sixesBucketColor)(bucket)),
        buckets: card.buckets
    });
    (0, _sixesCardRevealStorage.markSixesSimulationComplete)(id);
}

},{"./sixesDemoCard":"6LVJp","../lib/sixesBucketSlide":"c46Rx","../lib/sixesMarketBucket":"87iM1","../lib/sixesCardRevealStorage":"4lDfN","../lib/sixesSettlementSeenStorage":"2x0p1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6LVJp":[function(require,module,exports,__globalThis) {
/**
 * Demo Sixes card generator.
 *
 * A fixture has 9 candidate buckets but a card uses only 7 (see {@link sixesMarketBucket}):
 *   - a random **flip** picks one team's Runs bucket + the *other* team's Player bucket;
 *   - Match and the other four 4-draw buckets are 4 cells each;
 *   - Team H2H and C8 Own (Player H2H) are "6-draw" buckets — 6 cells each.
 *
 * The settlement script showcases the v5 movement engine: four 4-draw buckets complete in order and
 * claim all four 4-draw lines — COL2 → COL3 → diagonal ↘ (DIAG_TLBR) → diagonal ↗ (DIAG_TRBL). The
 * component drives the slides through the shared {@link sixesMovement} engine, so the demo and real
 * cards move the same.
 *
 * Geometry follows the same **zone + rook** placement rules as real cards (`assignSixesGridPositions`):
 *  - all five 4-draw buckets are rook-placed in the outer rows (0,1,4,5) — one cell per outer row,
 *    every cell in a distinct column;
 *  - the two 6-draw buckets fill the middle-row side cells first, then the four leftover outer cells.
 *
 * On top of that it is **fixed and verified conflict-free** for the slide showcase: the completing
 * buckets are placed so no winner is ever bumped by another bucket's slide — only loser cells get
 * displaced. (Most rook layouts are *not* conflict-free for a four-line claim, so the geometry is a
 * specific verified one — see `sixesDemoLayout.test.js`.) Bucket identities + labels still vary by
 * flip and shuffle, and the structure (which cell is which role) is fixed so every variant stays
 * rook + zone + conflict-free.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Build a demo card — buckets, labels, and the settlement script.
 * Pass a seed (e.g. match id) for a stable board across reloads; omit for a fresh random card.
 */ parcelHelpers.export(exports, "generateSixesDemoCard", ()=>generateSixesDemoCard);
var _sixesGridLayout = require("../lib/sixesGridLayout");
var _sixesMovement = require("../lib/sixesMovement");
/** Label pools per bucket (demo copy). Pools are >= the cells the bucket can take. */ const BUCKET_LABEL_POOLS = {
    team_h2h: [
        "TEAM A V B",
        "MOST SIXES",
        "MOST FOURS",
        "TOSS WINNER",
        "MATCH WINNER",
        "HIGH 1ST OVER"
    ],
    firsts: [
        "FIRST BALL RUNS",
        "FIRST OVER RUNS",
        "FIRST WICKET",
        "FIRST 6 OVERS"
    ],
    team_a_runs: [
        "TEAM A OVER 1",
        "TEAM A OVER 6",
        "TEAM A OVER 15",
        "TEAM A FIRST DELIVERY"
    ],
    team_b_runs: [
        "TEAM B OVER 1",
        "TEAM B OVER 6",
        "TEAM B OVER 15",
        "TEAM B FIRST DELIVERY"
    ],
    innings: [
        "TEAM A INN RUNS",
        "TEAM B INN RUNS",
        "TEAM A INN SIXES",
        "TEAM B INN SIXES"
    ],
    team_a_player: [
        "IYER RUNS",
        "SHASHANK SIXES",
        "STOINIS RUNS",
        "INGLIS FOURS"
    ],
    team_b_player: [
        "ROHIT RUNS",
        "SURYA SIXES",
        "TILAK RUNS",
        "HARDIK FOURS"
    ],
    match: [
        "MATCH RUNS",
        "MATCH SIXES",
        "MATCH FOURS",
        "MATCH WICKETS",
        "MATCH HIGHEST SCORE",
        "MATCH 50+ RUNS"
    ],
    c8_own: [
        "IYER V ROHIT",
        "SURYA V SHASHANK",
        "TILAK V STOINIS",
        "HARDIK V INGLIS",
        "ISHAN V PRABH",
        "MAXWELL V NAMAN"
    ]
};
// ---- Fixed, rook + zone, conflict-free geometry (market-cell indices) -------
// Four completing 4-draw buckets, in claim order. All four (plus the non-completing bucket) are
// rook-placed in the outer rows (one cell per outer row, distinct columns). Verified so each visibly
// slides onto its line and no winner is ever bumped by another bucket's slide — only losers get
// displaced (`sixesDemoLayout.test.js` re-checks this against the live movement engine).
const COMPLETING_FOUR_CELLS = [
    [
        2,
        9,
        25,
        26
    ],
    [
        1,
        6,
        24,
        29
    ],
    [
        0,
        11,
        21,
        30
    ],
    [
        5,
        10,
        20,
        27
    ]
];
// The 5th (non-completing) 4-draw bucket — losers only, also rook-placed in the outer rows.
const NON_COMPLETING_FOUR_CELLS = [
    4,
    8,
    23,
    31
];
// Both 6-draw buckets are non-completing here (losers): the 12 cells are the 8 middle-row side cells
// plus the 4 leftover outer cells (zone rule). The split is cosmetic — neither ever slides.
const SIX_A_CELLS = [
    3,
    12,
    13,
    16,
    17,
    22
];
const SIX_B_CELLS = [
    7,
    14,
    15,
    18,
    19,
    28
];
function shuffle(items, rng) {
    const out = [
        ...items
    ];
    for(let i = out.length - 1; i > 0; i -= 1){
        const j = Math.floor(rng() * (i + 1));
        [out[i], out[j]] = [
            out[j],
            out[i]
        ];
    }
    return out;
}
/**
 * Randomly merge two sequences while preserving each one's internal order. Each step picks from a
 * stream with probability proportional to its remaining count, which self-balances the two so they
 * stay interleaved end to end (no long run of one kind). Used to sprinkle the demo's misses through
 * its wins instead of resolving every miss first.
 */ function interleavePreservingOrder(a, b, rng) {
    const out = [];
    let i = 0;
    let j = 0;
    while(i < a.length || j < b.length){
        const remA = a.length - i;
        const remB = b.length - j;
        const takeA = j >= b.length || i < a.length && rng() * (remA + remB) < remA;
        if (takeA) out.push(a[i++]);
        else out.push(b[j++]);
    }
    return out;
}
const COIN_PAYOUT_SCALE = [
    55,
    50,
    48,
    45,
    42,
    40,
    38,
    36,
    35,
    34,
    32,
    30,
    28,
    27,
    25,
    24,
    22,
    20
];
function generateSixesDemoCard(seed) {
    const rng = seed != null ? (0, _sixesMovement.seededRng)((0, _sixesMovement.seedFromCardId)(seed)) : Math.random;
    const flip = rng() < 0.5 ? "A" : "B";
    // State A: Team A Runs + Team B Player · State B: Team B Runs + Team A Player.
    const runsBucket = flip === "A" ? "team_a_runs" : "team_b_runs";
    const playerBucket = flip === "A" ? "team_b_player" : "team_a_player";
    // Shuffle which bucket plays which fixed role: first 4 complete (COL2/COL3/DIAG↘/DIAG↗), last
    // one doesn't. The engine claims lines by completion order, so role order = claim order.
    const fourDrawBuckets = shuffle([
        "firsts",
        "innings",
        "match",
        runsBucket,
        playerBucket
    ], rng);
    const completingFour = fourDrawBuckets.slice(0, 4);
    const nonCompletingFour = fourDrawBuckets[4];
    const [sixA, sixB] = shuffle([
        "team_h2h",
        "c8_own"
    ], rng);
    const buckets = Array.from({
        length: (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT)
    }, ()=>null);
    const place = (bucket, cells)=>{
        for (const idx of cells)buckets[idx] = bucket;
    };
    completingFour.forEach((bucket, role)=>place(bucket, COMPLETING_FOUR_CELLS[role]));
    place(nonCompletingFour, NON_COMPLETING_FOUR_CELLS);
    place(sixA, SIX_A_CELLS);
    place(sixB, SIX_B_CELLS);
    // Labels — draw from each bucket's pool without repeats.
    const poolCursors = {};
    const labels = buckets.map((bucket)=>{
        if (!bucket) return "";
        const pool = BUCKET_LABEL_POOLS[bucket];
        const cursor = poolCursors[bucket] ?? 0;
        poolCursors[bucket] = cursor + 1;
        return pool[cursor % pool.length] ?? "";
    });
    // ---- Settlement script -------------------------------------------------
    // The four completing 4-draw buckets finish one-after-another, so the engine claims lines in
    // completion order: COL2 → COL3 → diagonal ↘ → diagonal ↗. Only completing cells win — every
    // slide bumps losers only.
    const fourCells = completingFour.map((_, role)=>[
            ...COMPLETING_FOUR_CELLS[role]
        ]);
    const winningIndices = fourCells.flat();
    const slideTargets = completingFour.map((bucket, i)=>({
            id: `slide-four-${i}`,
            bucket
        }));
    // Wins stay in bucket-completion order (bucket 0's four, then 1's, …) so the engine still claims
    // COL2 → COL3 → ↘ → ↗ in that order — the verified conflict-free sequence; only the order WITHIN
    // each bucket is shuffled.
    const winsInOrder = [
        ...shuffle(fourCells[0], rng),
        ...shuffle(fourCells[1], rng),
        ...shuffle(fourCells[2], rng),
        ...shuffle(fourCells[3], rng)
    ];
    // Misses are interleaved through the wins so the board fills with a mix of correct + wrong cells
    // the whole way through (rather than every miss first, then a burst of wins + slides). Each
    // bucket still completes — and slides — as soon as its 4th win lands, now spread across the run.
    const completingCells = new Set(winningIndices);
    const misses = shuffle(Array.from({
        length: (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT)
    }, (_, i)=>i).filter((i)=>!completingCells.has(i)), rng);
    const resolutionOrder = interleavePreservingOrder(winsInOrder, misses, rng);
    const coinPayouts = winningIndices.map((_, i)=>COIN_PAYOUT_SCALE[i] ?? 20);
    return {
        flip,
        buckets,
        labels,
        winningIndices,
        slideTargets,
        resolutionOrder,
        coinPayouts
    };
}

},{"../lib/sixesGridLayout":"EvkJs","../lib/sixesMovement":"6GIBc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"EvkJs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIXES_MARKET_CELL_COUNT", ()=>SIXES_MARKET_CELL_COUNT);
parcelHelpers.export(exports, "SIXES_COL_THROUGH_MULTIPLIER", ()=>SIXES_COL_THROUGH_MULTIPLIER);
parcelHelpers.export(exports, "SIXES_ROW_THROUGH_MULTIPLIER", ()=>SIXES_ROW_THROUGH_MULTIPLIER);
/** Row/col for each market cell in the 6×6 grid (centre 2×2 is the multiplier). */ parcelHelpers.export(exports, "marketCellGridPosition", ()=>marketCellGridPosition);
parcelHelpers.export(exports, "marketCellIndexFromGrid", ()=>marketCellIndexFromGrid);
parcelHelpers.export(exports, "emptySixesGridCellSlot", ()=>emptySixesGridCellSlot);
/** @deprecated Use buildMarketCellsFromApiCells */ parcelHelpers.export(exports, "buildMarketCellLabelsFromApiCells", ()=>buildMarketCellLabelsFromApiCells);
parcelHelpers.export(exports, "buildMarketCellsFromApiCells", ()=>buildMarketCellsFromApiCells);
parcelHelpers.export(exports, "buildDemoMarketCells", ()=>buildDemoMarketCells);
var _sixesCellDisplay = require("./sixesCellDisplay");
var _sixesMarketBucket = require("./sixesMarketBucket");
const SIXES_MARKET_CELL_COUNT = 32;
const SIXES_COL_THROUGH_MULTIPLIER = [
    3,
    9,
    23,
    29
];
const SIXES_ROW_THROUGH_MULTIPLIER = [
    16,
    17,
    18,
    19
];
function marketCellGridPosition(index) {
    if (index < 6) return {
        row: 0,
        col: index
    };
    if (index < 12) return {
        row: 1,
        col: index - 6
    };
    if (index < 14) return {
        row: 2,
        col: index - 12
    };
    if (index < 16) return {
        row: 2,
        col: index - 14 + 4
    };
    if (index < 18) return {
        row: 3,
        col: index - 16
    };
    if (index < 20) return {
        row: 3,
        col: index - 18 + 4
    };
    if (index < 26) return {
        row: 4,
        col: index - 20
    };
    return {
        row: 5,
        col: index - 26
    };
}
function marketCellIndexFromGrid(row, col) {
    for(let i = 0; i < SIXES_MARKET_CELL_COUNT; i += 1){
        const pos = marketCellGridPosition(i);
        if (pos.row === row && pos.col === col) return i;
    }
    return -1;
}
function emptySixesGridCellSlot() {
    return {
        shortLabel: "",
        overUnderLine: null,
        fullSentence: "",
        bannerEmphasis: "",
        statLabel: "RESULT?",
        bucket: null
    };
}
function buildMarketCellLabelsFromApiCells(cells) {
    return buildMarketCellsFromApiCells(cells).map((c)=>c.shortLabel || "");
}
function buildMarketCellsFromApiCells(cells, opts = {}) {
    const slots = Array.from({
        length: SIXES_MARKET_CELL_COUNT
    }, ()=>emptySixesGridCellSlot());
    for (const cell of cells){
        const idx = marketCellIndexFromGrid(cell.row, cell.col);
        if (idx >= 0) {
            const slot = (0, _sixesCellDisplay.sixesCellDisplayFromSentence)(cell.sentence, opts);
            const persisted = (0, _sixesMarketBucket.normalizeSixesBucket)(cell.bucket ?? null);
            slots[idx] = persisted ? {
                ...slot,
                bucket: persisted
            } : slot;
        }
    }
    return slots;
}
function buildDemoMarketCells(labels, homeTeam, awayTeam, buckets = []) {
    return labels.map((label, idx)=>{
        const slot = (0, _sixesCellDisplay.sixesCellDisplayFromDemoLabel)(label, homeTeam, awayTeam);
        const bucket = buckets[idx];
        return bucket !== undefined ? {
            ...slot,
            bucket
        } : slot;
    });
}

},{"./sixesCellDisplay":"41804","./sixesMarketBucket":"87iM1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"41804":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Derive a compact grid label + popup copy from a full cheer sentence. */ parcelHelpers.export(exports, "sixesCellDisplayFromSentence", ()=>sixesCellDisplayFromSentence);
/** Demo grid labels already short — expand for the detail popup. */ parcelHelpers.export(exports, "sixesCellDisplayFromDemoLabel", ()=>sixesCellDisplayFromDemoLabel);
var _sixesMarketBucket = require("./sixesMarketBucket");
/**
 * Surname particles kept with the final token on grid labels.
 * Case-insensitive single tokens; multi-word forms (`van der`, `de la`) fall out by walking left.
 * Extend this set when a cricket-relevant naming convention shows up in feeds — do not special-case countries in callers.
 */ const SURNAME_PARTICLES = new Set([
    // Dutch / Afrikaans / Flemish (SA, NL, BEL)
    "van",
    "de",
    "den",
    "der",
    "ter",
    "ten",
    "te",
    // German
    "von",
    // Romance / Iberian / Italian (incl. Lankan Portuguese-influenced "de Silva")
    "da",
    "das",
    "do",
    "dos",
    "di",
    "del",
    "della",
    "dei",
    "degli",
    "du",
    "le",
    "la",
    // Arabic / South Asian particle-style prefixes sometimes left as separate tokens
    "al",
    "el",
    "bin",
    "binti",
    "ibn"
]);
/** Last surname token plus any leading particles (`de Kock`, `van der Dussen`, `de Silva`). */ function surnameToken(name) {
    const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return String(name || "").toUpperCase();
    if (parts.length === 1) return parts[0].toUpperCase();
    let start = parts.length - 1;
    while(start > 0 && SURNAME_PARTICLES.has(parts[start - 1].toLowerCase()))start -= 1;
    return parts.slice(start).join(" ").toUpperCase();
}
/** Same 3-letter convention as cricket logos / scoreboard labels. */ function abbrevTeam(name) {
    const words = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return "";
    if (words.length === 1) return words[0].replace(/[^A-Za-z0-9]/g, "").slice(0, 3).toUpperCase();
    return words.map((w)=>w.replace(/[^A-Za-z0-9]/g, "")).filter(Boolean).map((w)=>w[0]).join("").slice(0, 3).toUpperCase();
}
function normalizeTeamKey(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}
/** True when `subject` is exactly one of the fixture team names (not a partial/player match). */ function isFixtureTeamSubject(subject, homeTeam, awayTeam) {
    const key = normalizeTeamKey(subject);
    if (!key) return false;
    return [
        homeTeam,
        awayTeam
    ].some((team)=>{
        const fullKey = normalizeTeamKey(team);
        return fullKey && fullKey === key;
    });
}
/** Map a sentence token (full name or feed abbrev) to the fixture's canonical team abbrev. */ function fixtureTeamAbbrev(token, homeTeam, awayTeam) {
    const raw = String(token || "").trim();
    if (!raw) return "";
    const rawUpper = raw.toUpperCase();
    for (const team of [
        homeTeam,
        awayTeam
    ]){
        const full = String(team || "").trim();
        if (!full) continue;
        const abbr = abbrevTeam(full);
        if (!abbr) continue;
        if (rawUpper === full.toUpperCase() || rawUpper === abbr) return abbr;
        const rawKey = normalizeTeamKey(raw);
        const fullKey = normalizeTeamKey(full);
        if (rawKey && fullKey && (fullKey.includes(rawKey) || rawKey.includes(fullKey))) return abbr;
    }
    return abbrevTeam(raw);
}
/**
 * Hard max for a player surname on a grid cell. Shorter names stay intact (CSS truncate
 * clips visually); anything longer gets an explicit "..." so we never soft-chop mid-word
 * into something like "LAWRENC".
 */ const PLAYER_CELL_NAME_MAX = 12;
function playerNameToken(name) {
    const token = surnameToken(name);
    if (token.length <= PLAYER_CELL_NAME_MAX) return token;
    const keep = Math.max(1, PLAYER_CELL_NAME_MAX - 3);
    return `${token.slice(0, keep)}...`;
}
function playerPropShortLabel(player, prop) {
    const name = playerNameToken(player);
    const single = `${name} ${prop}`;
    // Stack when the combined label is tight so the name line can CSS-ellipsis without eating the prop.
    if (single.length > 13) return `${name}\n${prop}`;
    return single;
}
function formatOverUnderLineValue(line) {
    const n = Number(line);
    if (!Number.isFinite(n)) return String(line || "").trim();
    return Number.isInteger(n) ? String(n) : n.toFixed(1).replace(/\.0$/, "");
}
function overUnderLineFromSide(sideToken, lineToken) {
    const side = String(sideToken || "").trim().toLowerCase().startsWith("u") ? "u" : "o";
    return {
        side,
        line: formatOverUnderLineValue(lineToken)
    };
}
function expandTeamTokens(text, homeTeam, awayTeam) {
    let out = text;
    const homeShort = abbrevTeam(homeTeam);
    const awayShort = abbrevTeam(awayTeam);
    if (homeShort) out = out.replace(new RegExp(`\\b${homeShort}\\b`, "gi"), homeTeam);
    if (awayShort) out = out.replace(new RegExp(`\\b${awayShort}\\b`, "gi"), awayTeam);
    return out;
}
function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
/** Trim to at most `maxLen` characters on a word boundary — no trailing ellipsis. */ function trimToWords(text, maxLen) {
    const t = String(text || "").trim();
    if (t.length <= maxLen) return t;
    const cut = t.slice(0, maxLen);
    const lastSpace = cut.lastIndexOf(" ");
    return (lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trim();
}
/**
 * Build a short, meaningful label from a market subject (e.g. "Surrey runs in first 6").
 * Replaces a leading team name with its abbreviation and compacts common phrases.
 */ function compactSubjectLabel(title, homeTeam, awayTeam) {
    let rest = String(title || "").trim();
    let teamPrefix = "";
    for (const team of [
        homeTeam,
        awayTeam
    ]){
        const t = String(team || "").trim();
        if (!t) continue;
        if (new RegExp(`^${escapeRegExp(t)}\\b`, "i").test(rest)) {
            teamPrefix = abbrevTeam(t);
            rest = rest.slice(t.length).trim();
            break;
        }
        const abbr = abbrevTeam(t);
        if (abbr && new RegExp(`^${escapeRegExp(abbr)}\\b`, "i").test(rest)) {
            teamPrefix = abbr;
            rest = rest.slice(abbr.length).trim();
            break;
        }
        if (new RegExp(`\\b${escapeRegExp(t)}\\s*$`, "i").test(rest)) {
            teamPrefix = abbrevTeam(t);
            rest = rest.replace(new RegExp(`\\b${escapeRegExp(t)}\\s*$`, "i"), "").trim();
            break;
        }
    }
    let compacted = rest.replace(/\bin the\b/gi, "").replace(/\bruns in first\s+(\d+)\b/gi, "RUNS FIRST $1").replace(/\bruns in first\b/gi, "RUNS FIRST").replace(/\bin first\b/gi, "1ST").replace(/\bfirst\b/gi, "1ST").replace(/\bovers?\b/gi, "OV").replace(/\bsession\b/gi, "SESS").replace(/\bpartnership\b/gi, "P-SHIP").replace(/\binnings\b/gi, "INN").replace(/\s+/g, " ").trim();
    if (/^RUNS FIRST \d+$/i.test(compacted)) compacted = `${compacted} OV`;
    const label = `${teamPrefix} ${compacted}`.trim().toUpperCase();
    if (!label) return "RESULT?";
    return trimToWords(label, 22);
}
/**
 * Red banner span in the cell detail modal: the prediction/outcome after the subject.
 * "MATCH TO HAVE UNDER 12.5 WICKETS" → "HAVE UNDER 12.5 WICKETS"
 * "MATCH HIGHEST INDIVIDUAL SCORE OVER 55.5" → "HIGHEST INDIVIDUAL SCORE OVER 55.5"
 */ function pickEmphasis(upper) {
    // Take the full predicate after TO/WILL (do not stop at IN/AT/ON — that left
    // "IN THE FIRST SESSION" navy while the rest of the same clause was red).
    const toMatch = upper.match(/\bTO\b (.+)$/);
    if (toMatch?.[1]) return toMatch[1].trim();
    const willMatch = upper.match(/\bWILL\b (.+)$/);
    if (willMatch?.[1]) return willMatch[1].trim();
    // Match-titled lines that never use "to" (highest individual score, etc.).
    const matchLead = upper.match(/^MATCH\b (.+)$/);
    if (matchLead?.[1]) return matchLead[1].trim();
    // "OVER/UNDER X — title": emphasise the market title after the dash.
    const dashTitle = upper.match(/^(?:OVER|UNDER) [\d.]+\s*[—–-]\s*(.+)$/);
    if (dashTitle?.[1]) return dashTitle[1].trim();
    return "";
}
function inferStatLabel(text) {
    const lower = text.toLowerCase();
    if (lower.includes("highest runscorer") || lower.includes("top score")) return "TOP SCORE?";
    if (lower.includes("highest wicket") || lower.includes("top bowl")) return "TOP BOWL?";
    if (lower.includes("extra")) return "EXTRAS?";
    if (lower.includes("wicket")) return "WICKET?";
    if (lower.includes("six")) return "SIXES?";
    if (lower.includes("four")) return "FOURS?";
    if (lower.includes("run")) return "RUNS?";
    if (lower.includes("toss")) return "TOSS?";
    if (lower.includes("win")) return "WIN?";
    return "RESULT?";
}
/** Rewrite legacy innings sentences that duplicated "Innings {stat} innings will have". */ function normalizeLegacyInningsSentence(raw) {
    const m = raw.match(/^(.+?) innings will have (over|under) ([\d.]+) (\w+)$/i);
    if (!m) return raw;
    const teamPart = m[1].trim();
    const cleaned = teamPart.replace(/\s+Innings\s+(Fours|Sixes|Wickets|Runs)\s*$/i, "").trim();
    if (!cleaned || cleaned === teamPart) return raw;
    return `${cleaned} will have ${m[2].toLowerCase()} ${m[3]} ${m[4].toLowerCase()}`;
}
/** Rewrite legacy session sentences that left the raw "Runs in First N" market title. */ function normalizeLegacySessionSentence(raw) {
    const m = raw.match(/^(Over|Under) ([\d.]+) — (.+?) Runs in First (\d+)$/i);
    if (!m) return raw;
    const team = m[3].trim();
    return `${team} will score ${m[1].toLowerCase()} ${m[2]} runs in first ${m[4]} overs`;
}
/** Rewrite legacy highest-individual sentences to the match-titled form. */ function normalizeLegacyHighestIndividualSentence(raw) {
    const over = raw.match(/^A batter will score over ([\d.]+) runs$/i);
    if (over) return `Match highest individual score over ${over[1]}`;
    const under = raw.match(/^No batter will score over ([\d.]+) runs$/i);
    if (under) return `Match highest individual score under ${under[1]}`;
    return raw;
}
/** Rewrite legacy "Team — Team of Highest …" fallback sentences (pre type-94/96 cheer shapes). */ function normalizeLegacyTeamOfHighestSentence(raw) {
    let m = raw.match(/^(.+?)\s*[—–-]\s*Team of Highest Runscorer$/i);
    if (m) return `${m[1].trim()} will have the highest runscorer`;
    m = raw.match(/^(.+?)\s*[—–-]\s*Team of Highest Wicket Taker$/i);
    if (m) return `${m[1].trim()} will have the highest wicket taker`;
    return raw;
}
/** Normalize persisted sentences that predate sentence-builder fixes. */ function normalizeLegacyRunsOffDeliverySentence(raw) {
    // "… runs off delivery 0.1" / "… runs off first delivery" → "… runs first delivery"
    return String(raw || "").replace(/\bruns\s+off\s+(?:first\s+)?delivery(?:\s+[\d.]+)?\b/gi, "runs first delivery");
}
/** Rewrite legacy fall-of-wicket cheer shapes to `Team first wicket - over/under X`. */ function normalizeLegacyFallOfWicketSentence(raw) {
    let m = raw.match(/^(.+?) will lose their first wicket (after|before) over ([\d.]+)$/i);
    if (m) {
        const side = m[2].toLowerCase() === "after" ? "over" : "under";
        return `${m[1].trim()} first wicket - ${side} ${m[3]}`;
    }
    m = raw.match(/^(.+?) first wicket will fall (after|before) over ([\d.]+)$/i);
    if (m) {
        const side = m[2].toLowerCase() === "after" ? "over" : "under";
        return `${m[1].trim()} first wicket - ${side} ${m[3]}`;
    }
    m = raw.match(/^First wicket will fall (after|before) over ([\d.]+)$/i);
    if (m) {
        const side = m[1].toLowerCase() === "after" ? "over" : "under";
        return `First wicket - ${side} ${m[2]}`;
    }
    return raw;
}
/** Normalize persisted sentences that predate sentence-builder fixes. */ function normalizeLegacySentence(raw) {
    return normalizeLegacyTeamOfHighestSentence(normalizeLegacyHighestIndividualSentence(normalizeLegacySessionSentence(normalizeLegacyInningsSentence(normalizeLegacyFallOfWicketSentence(normalizeLegacyRunsOffDeliverySentence(raw))))));
}
function runsOffDeliveryShortLabel(subject, _line, homeTeam, awayTeam) {
    const m = String(subject || "").trim().match(/^(.+?)\s+runs(?:\s+off)?\s+(?:first\s+)?delivery\b/i);
    const teamToken = m ? m[1].trim() : String(subject || "").trim().split(/\s+/)[0] || "";
    const abbr = teamToken ? fixtureTeamAbbrev(teamToken, homeTeam, awayTeam) : "";
    return abbr ? `${abbr} FIRST DELIVERY` : "FIRST DELIVERY";
}
function matchTotalShortLabel(stat) {
    const normalized = String(stat || "").trim().toLowerCase();
    if (normalized.includes("run out")) return "MATCH RUN OUTS";
    return `MATCH ${stat.toUpperCase()}`;
}
/** Strip trailing odd/even hints from a feed market title before building the grid label. */ function normalizeOddEvenMarketTitle(title) {
    let t = String(title || "").trim();
    if (!t) return t;
    t = t.replace(/,?\s*odd\s*(?:\/|-)?\s*even\s*$/i, "").trim();
    t = t.replace(/\s+odd\s+or\s+even\s*$/i, "").trim();
    // Drop any trailing comma/whitespace left behind once the odd/even hint is stripped
    // (feed titles like "Match Fours, Odd/Even" otherwise leave a dangling "Match Fours,").
    t = t.replace(/[\s,]+$/, "").trim();
    // Bare "{Team} Innings" odd/even lines are fours markets in Sixes feeds.
    if (/\binnings\s*$/i.test(t) && !/\b(fours|sixes|wickets|runs|extras|run outs)\b/i.test(t)) t = `${t} Fours`;
    return t;
}
function oddEvenMarketShortLabel(title, homeTeam, awayTeam) {
    const normalized = normalizeOddEvenMarketTitle(title);
    if (!normalized) return "O/E";
    const teamAbbr = (token)=>fixtureTeamAbbrev(token, homeTeam, awayTeam);
    // Match totals: "Match Fours", "Match Sixes", etc.
    // Stack as three rows so cells show "MATCH / FOURS / O/E" instead of truncating
    // the first line to "MATCH F…".
    let m = normalized.match(/^Match\s+(Fours|Sixes|Runs|Wickets|Extras|Run Outs)\s*$/i);
    if (m) return `MATCH\n${m[1].toUpperCase()}\nO/E`;
    // Team innings stat: "{Team} Innings Fours|Sixes|Runs|Wickets|Extras"
    m = normalized.match(/^(.+?)\s+Innings\s+(Fours|Sixes|Runs|Wickets|Extras)\s*$/i);
    if (m) {
        const abbr = teamAbbr(m[1].trim());
        return `${abbr} INN ${m[2].toUpperCase()}\nO/E`;
    }
    // Session: "{Team} Runs in First N"
    m = normalized.match(/^(.+?)\s+Runs in First\s+(\d+)\s*$/i);
    if (m) {
        const abbr = teamAbbr(m[1].trim());
        return `${abbr} RUNS 1ST ${m[2]}\nO/E`;
    }
    // Over: "{Team} Runs in Over N"
    m = normalized.match(/^(.+?)\s+Runs in Over\s+(\d+)\s*$/i);
    if (m) {
        const abbr = teamAbbr(m[1].trim());
        return `${abbr} OVER ${m[2]}\nO/E`;
    }
    const compact = compactSubjectLabel(normalized, homeTeam, awayTeam);
    return compact.length > 14 ? `${compact}\nO/E` : `${compact} O/E`;
}
function sixesCellDisplayFromSentence(sentence, opts = {}) {
    const raw = normalizeLegacySentence(String(sentence || "").trim());
    if (!raw) return {
        shortLabel: "",
        overUnderLine: null,
        fullSentence: "",
        bannerEmphasis: "",
        statLabel: "RESULT?",
        bucket: null
    };
    const homeTeam = opts.homeTeam || "";
    const awayTeam = opts.awayTeam || "";
    let shortLabel = raw.toUpperCase();
    let overUnderLine = null;
    const teamAbbr = (token)=>fixtureTeamAbbrev(token, homeTeam, awayTeam);
    let m = raw.match(/^(.+?) will win the match$/i);
    if (m) shortLabel = "MATCH WINNER";
    else if (m = raw.match(/^(.+?) will win the toss$/i)) shortLabel = "TOSS WINNER";
    else if (m = raw.match(/^(.+?) \([+-][\d.]+\) will hit more sixes$/i)) shortLabel = "MOST SIXES HCP";
    else if (m = raw.match(/^(.+?) will hit more sixes \(handicap\)$/i)) shortLabel = "MOST SIXES HCP";
    else if (m = raw.match(/^(.+?) will hit most sixes$/i)) shortLabel = "MOST SIXES";
    else if (m = raw.match(/^(.+?) \([+-][\d.]+\) will score more runs$/i)) shortLabel = `${playerNameToken(m[1])} HCP`;
    else if (m = raw.match(/^(.+?) will score more runs \(handicap\)$/i)) shortLabel = `${playerNameToken(m[1])} HCP`;
    else if (m = raw.match(/^(.+?) \([+-][\d.]+\) will hit more fours$/i)) shortLabel = "MOST FOURS HCP";
    else if (m = raw.match(/^(.+?) will hit more fours \(handicap\)$/i)) shortLabel = "MOST FOURS HCP";
    else if (m = raw.match(/^(.+?) will hit most fours$/i)) shortLabel = "MOST FOURS";
    else if (m = raw.match(/^(.+?) \([+-][\d.]+\) will have higher opening partnership$/i)) shortLabel = "OPEN P-SHIP HCP";
    else if (m = raw.match(/^(.+?) will have higher opening partnership \(handicap\)$/i)) shortLabel = "OPEN P-SHIP HCP";
    else if (m = raw.match(/^(.+?) will (?:have )?highest opening partnership$/i)) shortLabel = "HIGHEST OPEN P-SHIP";
    else if (m = raw.match(/^(.+?) will have the highest runscorer$/i)) shortLabel = "TEAM OF TOP SCORER";
    else if (m = raw.match(/^(.+?) will have the highest wicket taker$/i)) shortLabel = "TEAM OF TOP BOWLER";
    else if (m = raw.match(/^(.+?) will win highest first over$/i)) shortLabel = "HIGHEST 1ST OVER";
    else if (m = raw.match(/^(.+?) will win highest first (\d+) overs$/i)) shortLabel = `HIGHEST 1ST ${m[2]} OV`;
    else if (m = raw.match(/^(.+?) will win highest first session$/i)) shortLabel = "HIGHEST 1ST 6 OV";
    else if (m = raw.match(/^(.+?) will hit (over|under) ([\d.]+) (sixes|fours)$/i)) {
        shortLabel = playerPropShortLabel(m[1], m[4].toUpperCase());
        overUnderLine = overUnderLineFromSide(m[2], m[3]);
    } else if (m = raw.match(/^(.+?) will score (over|under) ([\d.]+) runs in first (\d+) balls$/i)) {
        shortLabel = `${teamAbbr(m[1])} RUNS 1ST ${m[4]} BALLS`;
        overUnderLine = overUnderLineFromSide(m[2], m[3]);
    } else if (m = raw.match(/^(.+?) will score (over|under) ([\d.]+) runs in first (\d+) overs$/i)) {
        shortLabel = `${teamAbbr(m[1])} RUNS 1ST ${m[4]} OV`;
        overUnderLine = overUnderLineFromSide(m[2], m[3]);
    } else if (m = raw.match(/^(.+?) will score (over|under) ([\d.]+) runs in the first session$/i)) {
        shortLabel = `${teamAbbr(m[1])} RUNS 1ST OV`;
        overUnderLine = overUnderLineFromSide(m[2], m[3]);
    } else if (m = raw.match(/^(.+?) will score (over|under) ([\d.]+) runs$/i)) {
        const subject = m[1].trim();
        shortLabel = isFixtureTeamSubject(subject, homeTeam, awayTeam) ? `${teamAbbr(subject)} RUNS` : playerPropShortLabel(subject, "RUNS");
        overUnderLine = overUnderLineFromSide(m[2], m[3]);
    } else if (m = raw.match(/^Match will have (over|under) ([\d.]+) (.+)$/i)) {
        shortLabel = matchTotalShortLabel(m[3]);
        overUnderLine = overUnderLineFromSide(m[1], m[2]);
    } else if (m = raw.match(/^(.+?) will have (over|under) ([\d.]+) (wickets|fours|sixes|runs|extras)(?: if batting (?:first|second))?$/i)) {
        shortLabel = `${teamAbbr(m[1])} INN ${m[4].toUpperCase()}`;
        overUnderLine = overUnderLineFromSide(m[2], m[3]);
    } else if (m = raw.match(/^(.+?) innings will have (over|under) ([\d.]+) (\w+)(?: if batting (?:first|second))?$/i)) {
        shortLabel = `${teamAbbr(m[1])} INN ${m[4].toUpperCase()}`;
        overUnderLine = overUnderLineFromSide(m[2], m[3]);
    } else if (m = raw.match(/^First (\d+) overs will have (over|under) ([\d.]+) runs$/i)) {
        shortLabel = `1ST ${m[1]} OV RUNS`;
        overUnderLine = overUnderLineFromSide(m[2], m[3]);
    } else if (m = raw.match(/^First session will have (over|under) ([\d.]+) runs$/i)) {
        shortLabel = `1ST OV RUNS`;
        overUnderLine = overUnderLineFromSide(m[1], m[2]);
    } else if (m = raw.match(/^(Over|Under) ([\d.]+) — match highest runs off over$/i)) {
        shortLabel = "MATCH HIGH OVER";
        overUnderLine = overUnderLineFromSide(m[1], m[2]);
    } else if (m = raw.match(/^Match highest individual score (over|under) ([\d.]+)$/i)) {
        shortLabel = "MATCH INDIVIDUAL SCORE";
        overUnderLine = overUnderLineFromSide(m[1], m[2]);
    } else if (m = raw.match(/^(?:A|No) batter will score over ([\d.]+) runs$/i)) {
        shortLabel = "MATCH INDIVIDUAL SCORE";
        overUnderLine = overUnderLineFromSide(raw.toLowerCase().startsWith("no") ? "under" : "over", m[1]);
    } else if (m = raw.match(/^(.+?) first wicket - (over|under) ([\d.]+)$/i)) {
        shortLabel = `${teamAbbr(m[1])} 1ST WKT`;
        overUnderLine = overUnderLineFromSide(m[2], m[3]);
    } else if (m = raw.match(/^First wicket - (over|under) ([\d.]+)$/i)) {
        shortLabel = "FIRST WICKET";
        overUnderLine = overUnderLineFromSide(m[1], m[2]);
    } else if (m = raw.match(/^(.+?) will lose their first wicket after over ([\d.]+)$/i)) {
        shortLabel = `${teamAbbr(m[1])} 1ST WKT`;
        overUnderLine = overUnderLineFromSide("over", m[2]);
    } else if (m = raw.match(/^(.+?) will lose their first wicket before over ([\d.]+)$/i)) {
        shortLabel = `${teamAbbr(m[1])} 1ST WKT`;
        overUnderLine = overUnderLineFromSide("under", m[2]);
    } else if (m = raw.match(/^First wicket will fall after over ([\d.]+)$/i)) {
        shortLabel = "FIRST WICKET";
        overUnderLine = overUnderLineFromSide("over", m[1]);
    } else if (m = raw.match(/^First wicket will fall before over ([\d.]+)$/i)) {
        shortLabel = "FIRST WICKET";
        overUnderLine = overUnderLineFromSide("under", m[1]);
    } else if (m = raw.match(/^(.+?) will score more runs than (.+)$/i)) shortLabel = `${playerNameToken(m[1])} V ${playerNameToken(m[2])}`;
    else if (m = raw.match(/^(Odd|Even)\s*[—–-]\s*(.+)$/i)) shortLabel = oddEvenMarketShortLabel(m[2].trim(), homeTeam, awayTeam);
    else if (m = raw.match(/^(Over|Under) ([\d.]+) — (.+)$/i)) {
        overUnderLine = overUnderLineFromSide(m[1], m[2]);
        const title = m[3].toLowerCase();
        if (title.includes("wicket")) shortLabel = "FIRST WICKET";
        else if (title.includes("delivery")) shortLabel = runsOffDeliveryShortLabel(m[3], m[2], homeTeam, awayTeam);
        else if (/session runs$/i.test(m[3].trim())) {
            const teamPart = m[3].replace(/\s+session runs\s*$/i, "").trim();
            shortLabel = teamPart ? `${fixtureTeamAbbrev(teamPart, homeTeam, awayTeam)} RUNS` : "RUNS";
        } else shortLabel = compactSubjectLabel(m[3], homeTeam, awayTeam);
    } else if (raw.length > 22) shortLabel = trimToWords(raw, 22).toUpperCase();
    const expanded = expandTeamTokens(raw, homeTeam, awayTeam);
    const fullSentence = expanded.replace(/\bwill\b/gi, "TO").replace(/\s+/g, " ").trim().toUpperCase();
    const bannerEmphasis = pickEmphasis(fullSentence);
    const statLabel = inferStatLabel(raw);
    const bucket = (0, _sixesMarketBucket.sixesBucketFromSentence)(raw, {
        homeTeam,
        awayTeam
    });
    return {
        shortLabel,
        overUnderLine,
        fullSentence,
        bannerEmphasis,
        statLabel,
        bucket
    };
}
function titleCaseToken(token) {
    const t = String(token || "").trim();
    if (!t) return "";
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
}
/** Map PBKS/MI abbreviations in demo labels to fixture team names. */ function demoTeamFromAbbrev(abbrev, homeTeam, awayTeam) {
    const key = String(abbrev || "").trim().toUpperCase();
    if (key === "PBKS" || key === abbrevTeam(homeTeam)) return homeTeam || "Punjab Kings";
    if (key === "MI" || key === abbrevTeam(awayTeam)) return awayTeam || "Mumbai Indians";
    return homeTeam || "Punjab Kings";
}
/**
 * Turn a demo grid label into a real cheer sentence (same shapes as `buildSixesCheerSentence`).
 * Labels stay short on the grid; this copy powers the detail modal only.
 */ function demoLabelToCheerSentence(label, homeTeam, awayTeam) {
    const shortLabel = String(label || "").trim().toUpperCase();
    const home = homeTeam || "Punjab Kings";
    const away = awayTeam || "Mumbai Indians";
    const exact = {
        "PBKS V MI": `${home} will win the match`,
        "MOST SIXES": `${home} will hit most sixes`,
        "MOST SIXES HCP": `${home} (-1.5) will hit more sixes`,
        "MOST FOURS": `${home} will hit most fours`,
        "MOST FOURS HCP": `${home} (-1.5) will hit more fours`,
        "OPEN P-SHIP HCP": `${home} (-5.5) will have higher opening partnership`,
        "HIGHEST OPEN P-SHIP": `${home} will have highest opening partnership`,
        "TOSS WINNER": `${home} will win the toss`,
        "MATCH WINNER": `${home} will win the match`,
        "HIGH 1ST OVER": `${home} will win highest first over`,
        "FIRST BALL RUNS": "Over 0.5 \u2014 First ball runs",
        "FIRST OVER RUNS": `Over 8.5 \u{2014} ${home} runs in first over`,
        "FIRST WICKET": "First wicket - over 6",
        "FIRST 6 OVERS": `Over 46.5 \u{2014} ${home} runs in first 6 overs`,
        "PBKS OVER 1": `Over 5.5 \u{2014} ${home} runs in over 1`,
        "PBKS OVER 6": `Over 8.5 \u{2014} ${home} runs in over 6`,
        "PBKS OVER 15": `Over 7.5 \u{2014} ${home} runs in over 15`,
        "PBKS FIRST DELIVERY": `Over 0.5 \u{2014} ${home} runs first delivery`,
        "PBKS DEL 0.5 RUNS": `Over 0.5 \u{2014} ${home} runs first delivery`,
        "MI OVER 1": `Over 5.5 \u{2014} ${away} runs in over 1`,
        "MI OVER 6": `Over 8.5 \u{2014} ${away} runs in over 6`,
        "MI OVER 15": `Over 7.5 \u{2014} ${away} runs in over 15`,
        "MI FIRST DELIVERY": `Over 0.5 \u{2014} ${away} runs first delivery`,
        "MI DEL 0.5 RUNS": `Over 0.5 \u{2014} ${away} runs first delivery`,
        "PBKS INN RUNS": `${home} will have over 165.5 runs`,
        "MI INN RUNS": `${away} will have over 172.5 runs`,
        "PBKS INN SIXES": `${home} will have over 8.5 sixes`,
        "MI INN SIXES": `${away} will have over 9.5 sixes`,
        "IYER RUNS": "Shreyas Iyer will score over 32.5 runs",
        "SHASHANK SIXES": "Shashank Singh will hit over 0.5 sixes",
        "STOINIS RUNS": "Marcus Stoinis will score over 18.5 runs",
        "INGLIS FOURS": "Phil Inglis will hit over 2.5 fours",
        "ROHIT RUNS": "Rohit Sharma will score over 28.5 runs",
        "SURYA SIXES": "Suryakumar Yadav will hit over 0.5 sixes",
        "TILAK RUNS": "Tilak Varma will score over 24.5 runs",
        "HARDIK FOURS": "Hardik Pandya will hit over 2.5 fours",
        "MATCH RUNS": "Match will have over 340.5 runs",
        "MATCH SIXES": "Match will have over 22.5 sixes",
        "MATCH FOURS": "Match will have over 36.5 fours",
        "MATCH WICKETS": "Match will have over 13.5 wickets",
        "IYER V ROHIT": "Shreyas Iyer will score more runs than Rohit Sharma",
        "SURYA V SHASHANK": "Suryakumar Yadav will score more runs than Shashank Singh",
        "TILAK V STOINIS": "Tilak Varma will score more runs than Marcus Stoinis",
        "HARDIK V INGLIS": "Hardik Pandya will score more runs than Phil Inglis",
        "ISHAN V PRABH": "Ishan Kishan will score more runs than Prabhsimran Singh",
        "MAXWELL V NAMAN": "Glenn Maxwell will score more runs than Naman Dhir"
    };
    if (exact[shortLabel]) return exact[shortLabel];
    const playerProp = shortLabel.match(/^([A-Z]+)\s+(RUNS|SIXES|FOURS)$/);
    if (playerProp) {
        const player = titleCaseToken(playerProp[1]);
        const prop = playerProp[2];
        if (prop === "RUNS") return `${player} will score over 24.5 runs`;
        if (prop === "SIXES") return `${player} will hit over 0.5 sixes`;
        return `${player} will hit over 2.5 fours`;
    }
    const playerH2h = shortLabel.match(/^([A-Z]+)\s+V\s+([A-Z]+)$/);
    if (playerH2h) return `${titleCaseToken(playerH2h[1])} will score more runs than ${titleCaseToken(playerH2h[2])}`;
    const teamOver = shortLabel.match(/^(PBKS|MI)\s+OVER\s+(\d+)$/);
    if (teamOver) {
        const team = demoTeamFromAbbrev(teamOver[1], home, away);
        const overNo = teamOver[2];
        const line = overNo === "1" ? "5.5" : overNo === "6" ? "8.5" : "7.5";
        return `Over ${line} \u{2014} ${team} runs in over ${overNo}`;
    }
    const teamDel = shortLabel.match(/^(PBKS|MI)\s+(?:FIRST DELIVERY|DEL(?:\s+[\d.]+)?(?:\s+RUNS)?)$/);
    if (teamDel) {
        const team = demoTeamFromAbbrev(teamDel[1], home, away);
        return `Over 0.5 \u{2014} ${team} runs first delivery`;
    }
    const inn = shortLabel.match(/^(PBKS|MI)\s+INN\s+(RUNS|SIXES|FOURS|WICKETS)$/);
    if (inn) {
        const team = demoTeamFromAbbrev(inn[1], home, away);
        const stat = inn[2].toLowerCase();
        const line = stat === "runs" ? "165.5" : stat === "sixes" ? "8.5" : stat === "fours" ? "32.5" : "13.5";
        return `${team} will have over ${line} ${stat}`;
    }
    return `${home} \u{2014} ${shortLabel}`;
}
function sixesCellDisplayFromDemoLabel(label, homeTeam, awayTeam) {
    const shortLabel = String(label || "").trim().toUpperCase();
    const fromSentence = sixesCellDisplayFromSentence(demoLabelToCheerSentence(shortLabel, homeTeam, awayTeam), {
        homeTeam,
        awayTeam
    });
    return {
        ...fromSentence,
        shortLabel
    };
}

},{"./sixesMarketBucket":"87iM1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"87iM1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIXES_BUCKETS", ()=>SIXES_BUCKETS);
parcelHelpers.export(exports, "SIXES_SIX_DRAW_BUCKETS", ()=>SIXES_SIX_DRAW_BUCKETS);
parcelHelpers.export(exports, "SIXES_BUCKET_COLORS", ()=>SIXES_BUCKET_COLORS);
parcelHelpers.export(exports, "SIXES_BUCKET_LABELS", ()=>SIXES_BUCKET_LABELS);
/** Normalize a persisted or derived bucket id to a known Sixes bucket. */ parcelHelpers.export(exports, "normalizeSixesBucket", ()=>normalizeSixesBucket);
/** Resolve the cell base colour for a (possibly missing) bucket. */ parcelHelpers.export(exports, "sixesBucketColor", ()=>sixesBucketColor);
/**
 * Classify a cheer sentence (as produced by `buildSixesCheerSentence`) into one of the 9 buckets.
 * Returns null when the sentence shape is unrecognised. (Demo cards assign buckets directly; this
 * path is the fallback for real API cards.)
 */ parcelHelpers.export(exports, "sixesBucketFromSentence", ()=>sixesBucketFromSentence);
/** Resolve per-cell buckets for a full API card (handles player props without team in the sentence). */ parcelHelpers.export(exports, "buildSixesBucketMapFromApiCells", ()=>buildSixesBucketMapFromApiCells);
/** Short bucket title for the cell detail modal header bar. */ parcelHelpers.export(exports, "sixesBucketDisplayLabel", ()=>sixesBucketDisplayLabel);
var _sixesGridLayout = require("./sixesGridLayout");
const SIXES_BUCKETS = [
    "team_h2h",
    "firsts",
    "team_a_runs",
    "team_b_runs",
    "innings",
    "team_a_player",
    "team_b_player",
    "match",
    "c8_own"
];
const SIXES_SIX_DRAW_BUCKETS = [
    "team_h2h",
    "c8_own"
];
const SIXES_BUCKET_COLORS = {
    team_h2h: "#FC51BB",
    firsts: "#FFE033",
    team_a_runs: "#BF00FF",
    team_b_runs: "#BF00FF",
    innings: "#FF6B6B",
    team_a_player: "#00E5FF",
    team_b_player: "#00E5FF",
    match: "#FF8C00",
    c8_own: "#2D6BFF"
};
const SIXES_BUCKET_LABELS = {
    team_h2h: "Team H2H",
    firsts: "Firsts",
    team_a_runs: "Team A Runs",
    team_b_runs: "Team B Runs",
    innings: "Innings",
    team_a_player: "Team A Player",
    team_b_player: "Team B Player",
    match: "Match",
    c8_own: "C8 Own (Player H2H)"
};
const SIXES_BUCKET_SET = new Set(SIXES_BUCKETS);
/** Neutral non-purple fallback for a cell we cannot classify (real cards should always classify). */ const SIXES_BUCKET_FALLBACK_COLOR = "#3A3F66";
function normalizeSixesBucket(bucket) {
    const key = String(bucket || "").trim();
    if (!key) return null;
    return SIXES_BUCKET_SET.has(key) ? key : null;
}
function sixesBucketColor(bucket) {
    const normalized = normalizeSixesBucket(bucket ?? null);
    return normalized ? SIXES_BUCKET_COLORS[normalized] : SIXES_BUCKET_FALLBACK_COLOR;
}
function normalizeTeamKey(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}
function abbrevTeam(name) {
    const words = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return "";
    if (words.length === 1) return words[0].replace(/[^A-Za-z0-9]/g, "").slice(0, 3).toUpperCase();
    return words.map((w)=>w.replace(/[^A-Za-z0-9]/g, "")).filter(Boolean).map((w)=>w[0]).join("").slice(0, 3).toUpperCase();
}
function teamNameMentioned(text, teamName) {
    const team = String(teamName || "").trim();
    if (!team) return false;
    const textLower = text.toLowerCase();
    const teamLower = team.toLowerCase();
    if (textLower.includes(teamLower)) return true;
    const textKey = normalizeTeamKey(text);
    const teamKey = normalizeTeamKey(team);
    if (textKey && teamKey && (textKey.includes(teamKey) || teamKey.includes(textKey))) return true;
    const abbr = abbrevTeam(team);
    if (abbr.length >= 2 && new RegExp(`\\b${abbr.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "i").test(text)) return true;
    return false;
}
/** Which fixture side a sentence refers to. Home maps to team_a_* slots, away to team_b_*. */ function teamSideFromText(text, homeTeam = "", awayTeam = "") {
    const homeHit = teamNameMentioned(text, homeTeam);
    const awayHit = teamNameMentioned(text, awayTeam);
    if (homeHit && !awayHit) return "home";
    if (awayHit && !homeHit) return "away";
    return null;
}
function runsBucketForSide(side) {
    if (side === "away") return "team_b_runs";
    if (side === "home") return "team_a_runs";
    return null;
}
function playerBucketForSide(side) {
    if (side === "away") return "team_b_player";
    if (side === "home") return "team_a_player";
    return null;
}
function isPlayerPropSentence(sentence) {
    const s = String(sentence || "").trim().toLowerCase();
    return /will score (over|under) [\d.]+ runs$/.test(s) || /will hit (over|under) [\d.]+ (fours|sixes)$/.test(s);
}
function sixesBucketFromSentence(sentence, options = {}) {
    const raw = String(sentence || "").trim();
    if (!raw) return null;
    const s = raw.toLowerCase();
    const homeTeam = String(options.homeTeam || "").trim();
    const awayTeam = String(options.awayTeam || "").trim();
    const side = teamSideFromText(raw, homeTeam, awayTeam);
    // C8 player-vs-player ("X will score more runs than Y").
    if (/will score more runs than /.test(s)) return "c8_own";
    // Team head-to-heads: match winner / toss / most boundaries / highest partnership / first over / 6 overs.
    if (/will win the toss$/.test(s)) return "team_h2h";
    if (/will win the match$/.test(s)) return "team_h2h";
    if (/will hit more sixes/.test(s) || /will hit most (sixes|fours)$/.test(s)) return "team_h2h";
    if (/will (have )?highest opening partnership$/.test(s)) return "team_h2h";
    if (/will win highest first over$/.test(s)) return "team_h2h";
    if (/will win highest first \d+ overs$/.test(s)) return "team_h2h";
    if (/will win highest first session$/.test(s)) return "team_h2h";
    if (/will (have|win) (the )?highest first \d+ overs( score)?$/.test(s)) return "team_h2h";
    if (/will have the highest runscorer$/.test(s)) return "team_h2h";
    if (/will have the highest wicket taker$/.test(s)) return "team_h2h";
    if (/—\s*team of highest runscorer$/i.test(raw)) return "team_h2h";
    if (/—\s*team of highest wicket taker$/i.test(raw)) return "team_h2h";
    // "Firsts": over-1 runs / off the first ball / fall of the first wicket / runs first delivery.
    if (/runs in over\s+1\b/.test(s)) return "firsts";
    if (/off (the )?first ball/.test(s)) return "firsts";
    if (/runs(?: off)? (?:first )?delivery/.test(s)) return "firsts";
    if (/first wicket - (over|under)/.test(s)) return "firsts";
    if (/(?:first wicket will fall|will lose their first wicket) (after|before) over/.test(s)) return "firsts";
    // Match totals ("a/no batter", "match will have …").
    if (/^(a|no) batter will score over [\d.]+ runs$/.test(s)) return "match";
    if (/^match highest individual score (over|under) [\d.]+$/.test(s)) return "match";
    if (/^match will have (over|under) [\d.]+/.test(s)) return "match";
    // Innings totals (per team) — legacy "X innings will have" and "{team} will have … wickets|fours|sixes".
    if (/ innings will have (over|under) [\d.]+/.test(s)) return "innings";
    if (/ will have (over|under) [\d.]+ (wickets|fours|sixes)\b/.test(s) && !/^match will have/.test(s)) return "innings";
    // Team runs: overs 2+ + session runs (per team, overs or balls). Over 1 is firsts (above).
    if (/runs in over|runs in the over|runs in first \d+ overs|runs in first \d+ balls|runs in the first session|session runs/.test(s)) return runsBucketForSide(side);
    // Player runs / boundaries (per team) — side may be resolved in a second pass when absent.
    if (isPlayerPropSentence(raw)) return playerBucketForSide(side);
    // "Over N — <title>" fallbacks for over/delivery runners.
    const dashIdx = raw.indexOf("\u2014");
    const tail = dashIdx >= 0 ? raw.slice(dashIdx + 1).toLowerCase() : s;
    if (/runs(?: off)? (?:first )?delivery|\bdelivery\b/.test(tail)) return "firsts";
    if (/runs in over\s+1\b/.test(tail)) return "firsts";
    if (/runs in over/.test(tail)) return runsBucketForSide(teamSideFromText(tail, homeTeam, awayTeam) ?? side);
    if (/innings/.test(tail)) return "innings";
    if (/match/.test(tail)) return "match";
    return null;
}
function resolvePersistedBucket(persisted) {
    return normalizeSixesBucket(persisted);
}
function buildSixesBucketMapFromApiCells(cells, homeTeam, awayTeam) {
    const buckets = Array.from({
        length: (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT)
    }, ()=>null);
    for (const cell of cells){
        const idx = (0, _sixesGridLayout.marketCellIndexFromGrid)(cell.row, cell.col);
        if (idx < 0) continue;
        // Prefer the bucket persisted at generation time; fall back to deriving it from the
        // sentence for legacy cards (cells whose bucket predates the column).
        const persisted = String(cell.bucket || "").trim();
        buckets[idx] = resolvePersistedBucket(persisted) ?? sixesBucketFromSentence(cell.sentence, {
            homeTeam,
            awayTeam
        });
    }
    let homePlayerCount = 0;
    let awayPlayerCount = 0;
    for (const bucket of buckets){
        if (bucket === "team_a_player") homePlayerCount += 1;
        if (bucket === "team_b_player") awayPlayerCount += 1;
    }
    const activePlayerBucket = awayPlayerCount > homePlayerCount ? "team_b_player" : "team_a_player";
    for (const cell of cells){
        const idx = (0, _sixesGridLayout.marketCellIndexFromGrid)(cell.row, cell.col);
        if (idx < 0 || buckets[idx] != null) continue;
        if (isPlayerPropSentence(cell.sentence)) buckets[idx] = activePlayerBucket;
    }
    return buckets;
}
function sixesBucketDisplayLabel(bucket, homeTeam = "", awayTeam = "") {
    const normalized = normalizeSixesBucket(bucket ?? null);
    if (!normalized) return "Market";
    switch(normalized){
        case "team_a_runs":
            return homeTeam ? `${abbrevTeam(homeTeam)} Runs` : "Team A Runs";
        case "team_b_runs":
            return awayTeam ? `${abbrevTeam(awayTeam)} Runs` : "Team B Runs";
        case "team_a_player":
            return homeTeam ? `${abbrevTeam(homeTeam)} Player` : "Team A Player";
        case "team_b_player":
            return awayTeam ? `${abbrevTeam(awayTeam)} Player` : "Team B Player";
        case "c8_own":
            return "Player H2H";
        default:
            return SIXES_BUCKET_LABELS[normalized];
    }
}

},{"./sixesGridLayout":"EvkJs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6GIBc":[function(require,module,exports,__globalThis) {
/**
 * Sixes cell-movement engine (spec v5).
 *
 * Buckets do not move until they cross a threshold. When they do, they claim — in completion
 * order, first come first served — one line from a fixed catalog and slide their winners onto it,
 * swapping out whatever occupies each destination slot (the universal swap rule).
 *
 * Bucket families (by cell count on the grid):
 *   - 4-draw (4 cells, rook-placed one-per-row in outer rows 0,1,4,5): complete at 4/4 and claim,
 *     in order, COL2 → COL3 → DIAG_TLBR → DIAG_TRBL (5th = jackpot, no geometric line yet).
 *   - 6-draw (6 cells): at 4/6 claim a row (ROW2 → ROW3); at 6/6 upgrade to a full unaided
 *     column (COL0_FULL → COL5_FULL).
 *
 * Coordinates are 0-indexed market-cell indices (centre 2×2 multiplier excluded — it is the
 * "wild" that completes any line passing through it).
 *
 * This module is the single source of truth shared by set counting and the live grid animation.
 * It is mirrored byte-for-logic in `backend/utils/sixesMovement.js`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIXES_MERGED_RUNS_SLIDE_BUCKET", ()=>SIXES_MERGED_RUNS_SLIDE_BUCKET);
parcelHelpers.export(exports, "SIXES_MERGED_PLAYER_SLIDE_BUCKET", ()=>SIXES_MERGED_PLAYER_SLIDE_BUCKET);
parcelHelpers.export(exports, "SIXES_BUCKET_SLIDE_MIN_WINS", ()=>SIXES_BUCKET_SLIDE_MIN_WINS);
parcelHelpers.export(exports, "SIXES_SIX_DRAW_FULL_WINS", ()=>SIXES_SIX_DRAW_FULL_WINS);
parcelHelpers.export(exports, "SIXES_LINE_TARGETS", ()=>SIXES_LINE_TARGETS);
parcelHelpers.export(exports, "SIXES_FOUR_DRAW_LINE_ORDER", ()=>SIXES_FOUR_DRAW_LINE_ORDER);
parcelHelpers.export(exports, "SIXES_SIX_DRAW_ROW_ORDER", ()=>SIXES_SIX_DRAW_ROW_ORDER);
parcelHelpers.export(exports, "SIXES_SIX_DRAW_COL_ORDER", ()=>SIXES_SIX_DRAW_COL_ORDER);
parcelHelpers.export(exports, "bucketCellIndices", ()=>bucketCellIndices);
parcelHelpers.export(exports, "bucketWonCellIndices", ()=>bucketWonCellIndices);
parcelHelpers.export(exports, "bucketWonCount", ()=>bucketWonCount);
/** A bucket is a 6-draw bucket when it has 6 cells on the grid (else 4-draw). */ parcelHelpers.export(exports, "isSixDrawBucket", ()=>isSixDrawBucket);
parcelHelpers.export(exports, "bothRunsBucketsOnCard", ()=>bothRunsBucketsOnCard);
/** Won cells across both runs buckets — used when a legacy card has both purple sides. */ parcelHelpers.export(exports, "mergedRunsWonCellIndices", ()=>mergedRunsWonCellIndices);
parcelHelpers.export(exports, "isMergedRunsSlideReady", ()=>isMergedRunsSlideReady);
parcelHelpers.export(exports, "bothPlayerBucketsOnCard", ()=>bothPlayerBucketsOnCard);
/** Won cells across both player buckets — same colour on the board, one slide family. */ parcelHelpers.export(exports, "mergedPlayerWonCellIndices", ()=>mergedPlayerWonCellIndices);
parcelHelpers.export(exports, "isMergedPlayerSlideReady", ()=>isMergedPlayerSlideReady);
parcelHelpers.export(exports, "isBucketSlideReady", ()=>isBucketSlideReady);
/**
 * Build the ordered movement plan from buckets + outcomes.
 *
 * @param settleRank optional cell index → settle order (lower = earlier). Drives "first come first
 *   served" line claiming. Omit for set counting (count is order-invariant); pass it server-side
 *   so the persisted layout matches the real settlement order.
 * @param rng optional seeded RNG for the random slot assignment within 6-draw lines. Omit for the
 *   canonical (deterministic) layout used by set counting.
 */ parcelHelpers.export(exports, "buildSixesMovementPlan", ()=>buildSixesMovementPlan);
/**
 * Swaps that slide a bucket's winners onto a claimed line from their HOME positions (identity
 * layout). Used by the live grid, whose cells animate via absolute-from-home offsets (content is
 * never permuted), so `from` is always a winner's home index.
 */ parcelHelpers.export(exports, "sixesLineClaimSwaps", ()=>sixesLineClaimSwaps);
/** Flatten a movement plan into ordered directional swaps (cell at `from` slides to `to`). */ parcelHelpers.export(exports, "movementPlanSwaps", ()=>movementPlanSwaps);
/** Deterministic 0..1 RNG (mulberry32) so a card's random slot assignment is stable. */ parcelHelpers.export(exports, "seededRng", ()=>seededRng);
/** Stable 32-bit seed from a card id (number or string), mirroring the backend. */ parcelHelpers.export(exports, "seedFromCardId", ()=>seedFromCardId);
/** Apply directional swaps to an array, in order (each swaps the values at the two slots). */ parcelHelpers.export(exports, "applySixesSwaps", ()=>applySixesSwaps);
var _sixesGridLayout = require("./sixesGridLayout");
var _sixesLiveData = require("./sixesLiveData");
var _sixesMarketBucket = require("./sixesMarketBucket");
const SIXES_RUNS_SIDE_BUCKETS = [
    "team_a_runs",
    "team_b_runs"
];
const SIXES_PLAYER_SIDE_BUCKETS = [
    "team_a_player",
    "team_b_player"
];
const SIXES_OUTER_GRID_ROWS = new Set([
    0,
    1,
    4,
    5
]);
function mergedSideClaimKind(mergedWon) {
    const allOuter = mergedWon.every((idx)=>SIXES_OUTER_GRID_ROWS.has((0, _sixesGridLayout.marketCellGridPosition)(idx).row));
    return allOuter ? "four_draw" : "six_draw_row";
}
function mergedRunsClaimKind(buckets, outcomes) {
    return mergedSideClaimKind(mergedRunsWonCellIndices(buckets, outcomes));
}
const SIXES_MERGED_RUNS_SLIDE_BUCKET = "team_a_runs";
const SIXES_MERGED_PLAYER_SLIDE_BUCKET = "team_a_player";
const SIXES_BUCKET_SLIDE_MIN_WINS = 4;
const SIXES_SIX_DRAW_FULL_WINS = 6;
const SIXES_LINE_TARGETS = {
    COL2: [
        2,
        8,
        22,
        28
    ],
    COL3: [
        3,
        9,
        23,
        29
    ],
    DIAG_TLBR: [
        0,
        7,
        24,
        31
    ],
    DIAG_TRBL: [
        5,
        10,
        21,
        26
    ],
    ROW2: [
        12,
        13,
        14,
        15
    ],
    ROW3: [
        16,
        17,
        18,
        19
    ],
    COL0_FULL: [
        0,
        6,
        12,
        16,
        20,
        26
    ],
    COL5_FULL: [
        5,
        11,
        15,
        19,
        25,
        31
    ]
};
const SIXES_FOUR_DRAW_LINE_ORDER = [
    "COL2",
    "COL3",
    "DIAG_TLBR",
    "DIAG_TRBL"
];
const SIXES_SIX_DRAW_ROW_ORDER = [
    "ROW2",
    "ROW3"
];
const SIXES_SIX_DRAW_COL_ORDER = [
    "COL0_FULL",
    "COL5_FULL"
];
function bucketCellIndices(buckets, bucket) {
    const out = [];
    buckets.forEach((b, i)=>{
        if (b === bucket) out.push(i);
    });
    return out;
}
function bucketWonCellIndices(buckets, outcomes, bucket) {
    return bucketCellIndices(buckets, bucket).filter((idx)=>(0, _sixesLiveData.isSixesCellWon)(outcomes[idx] ?? "pending"));
}
function bucketWonCount(buckets, outcomes, bucket) {
    return bucketWonCellIndices(buckets, outcomes, bucket).length;
}
function isSixDrawBucket(buckets, bucket) {
    return bucketCellIndices(buckets, bucket).length >= SIXES_SIX_DRAW_FULL_WINS;
}
function bothRunsBucketsOnCard(buckets) {
    return bucketCellIndices(buckets, "team_a_runs").length > 0 && bucketCellIndices(buckets, "team_b_runs").length > 0;
}
function mergedRunsWonCellIndices(buckets, outcomes) {
    return [
        ...bucketWonCellIndices(buckets, outcomes, "team_a_runs"),
        ...bucketWonCellIndices(buckets, outcomes, "team_b_runs")
    ];
}
function isMergedRunsSlideReady(buckets, outcomes) {
    return bothRunsBucketsOnCard(buckets) && mergedRunsWonCellIndices(buckets, outcomes).length >= SIXES_BUCKET_SLIDE_MIN_WINS;
}
function bothPlayerBucketsOnCard(buckets) {
    return bucketCellIndices(buckets, "team_a_player").length > 0 && bucketCellIndices(buckets, "team_b_player").length > 0;
}
function mergedPlayerWonCellIndices(buckets, outcomes) {
    return [
        ...bucketWonCellIndices(buckets, outcomes, "team_a_player"),
        ...bucketWonCellIndices(buckets, outcomes, "team_b_player")
    ];
}
function isMergedPlayerSlideReady(buckets, outcomes) {
    return bothPlayerBucketsOnCard(buckets) && mergedPlayerWonCellIndices(buckets, outcomes).length >= SIXES_BUCKET_SLIDE_MIN_WINS;
}
function mergedPlayerClaimKind(buckets, outcomes) {
    return mergedSideClaimKind(mergedPlayerWonCellIndices(buckets, outcomes));
}
function isBucketSlideReady(buckets, outcomes, bucket) {
    if (bothRunsBucketsOnCard(buckets) && SIXES_RUNS_SIDE_BUCKETS.includes(bucket)) {
        if (bucket === "team_b_runs") return false;
        return isMergedRunsSlideReady(buckets, outcomes);
    }
    if (bothPlayerBucketsOnCard(buckets) && SIXES_PLAYER_SIDE_BUCKETS.includes(bucket)) {
        if (bucket === "team_b_player") return false;
        return isMergedPlayerSlideReady(buckets, outcomes);
    }
    return bucketWonCount(buckets, outcomes, bucket) >= SIXES_BUCKET_SLIDE_MIN_WINS;
}
/**
 * Completion rank for ordering claims. `settleRank` maps a cell index → settle order (lower =
 * earlier); when absent we fall back to the cell index so ordering stays deterministic.
 *
 * - 4-draw (and 6-draw 6/6): rank = the LATEST winning cell (the cell that crossed the threshold).
 * - 6-draw 4/6: rank = the Nth-earliest winning cell where N = the row threshold (4).
 */ function completionRank(wonIndices, settleRank, threshold, mode) {
    const rankOf = (idx)=>settleRank ? settleRank(idx) : idx;
    const ranks = wonIndices.map(rankOf).sort((a, b)=>a - b);
    if (ranks.length === 0) return Number.POSITIVE_INFINITY;
    if (mode === "last") return ranks[ranks.length - 1];
    const i = Math.min(threshold, ranks.length) - 1;
    return ranks[Math.max(0, i)];
}
function shuffleInPlace(items, rng) {
    if (!rng) return items;
    for(let i = items.length - 1; i > 0; i -= 1){
        const j = Math.floor(rng() * (i + 1));
        [items[i], items[j]] = [
            items[j],
            items[i]
        ];
    }
    return items;
}
/**
 * Resolve the slot-level swaps that slide a bucket's winners onto a line, given the live layout.
 *
 * @param slotOf map original cell index → the slot it currently occupies (after earlier claims).
 * @returns swaps to apply (and which update `slotOf` / `originalAt` in the caller).
 */ function resolveClaimSwaps(lineId, kind, wonOriginalIndices, slotOf, rng) {
    const targets = SIXES_LINE_TARGETS[lineId];
    const curSlot = (orig)=>slotOf.get(orig) ?? orig;
    const winnerSlots = wonOriginalIndices.map(curSlot);
    const out = [];
    if (kind === "four_draw") {
        // A winner already sitting on a target stays put; every remaining target then takes a
        // winner — preferring one in the same row (the clean rook slide), else any leftover winner.
        // Preferring same-row keeps canonically rook-placed cards animating exactly as before, while
        // the fallback guarantees the line is fully filled with the bucket's colour even when the
        // card was NOT rook-placed (e.g. two winners share a row), instead of stranding a target.
        const usedMovers = new Set();
        const assignedTargets = new Set();
        for (const target of targets)if (winnerSlots.includes(target)) {
            out.push({
                target,
                moverSlot: target
            });
            usedMovers.add(target);
            assignedTargets.add(target);
        }
        for (const target of targets){
            if (assignedTargets.has(target)) continue;
            const targetRow = (0, _sixesGridLayout.marketCellGridPosition)(target).row;
            let moverSlot = winnerSlots.find((slot)=>!usedMovers.has(slot) && (0, _sixesGridLayout.marketCellGridPosition)(slot).row === targetRow);
            if (moverSlot == null) moverSlot = winnerSlots.find((slot)=>!usedMovers.has(slot));
            if (moverSlot != null) {
                out.push({
                    target,
                    moverSlot
                });
                usedMovers.add(moverSlot);
                assignedTargets.add(target);
            }
        }
        return out;
    }
    // 6-draw row/column: winners already on a target slot stay; the rest fill remaining slots
    // (random when an rng is supplied — server-authoritative; stable otherwise for set counting).
    const targetSet = new Set(targets);
    const remainingTargets = [];
    const used = new Set();
    for (const target of targets)if (winnerSlots.includes(target)) {
        out.push({
            target,
            moverSlot: target
        });
        used.add(target);
    } else remainingTargets.push(target);
    const remainingMovers = shuffleInPlace(winnerSlots.filter((slot)=>!used.has(slot) && !targetSet.has(slot)), rng);
    remainingTargets.forEach((target, i)=>{
        const moverSlot = remainingMovers[i];
        if (moverSlot != null) out.push({
            target,
            moverSlot
        });
    });
    return out;
}
function buildSixesMovementPlan(buckets, outcomes, opts = {}) {
    const settleRank = opts.settleRank ?? null;
    const rng = opts.rng ?? null;
    const fourDraw = [];
    const sixRow = [];
    const sixCol = [];
    const splitRuns = bothRunsBucketsOnCard(buckets);
    let mergedRunsClaimed = false;
    const splitPlayers = bothPlayerBucketsOnCard(buckets);
    let mergedPlayersClaimed = false;
    for (const bucket of (0, _sixesMarketBucket.SIXES_BUCKETS)){
        const cells = bucketCellIndices(buckets, bucket);
        if (cells.length === 0) continue;
        if (splitRuns && SIXES_RUNS_SIDE_BUCKETS.includes(bucket)) continue;
        if (splitPlayers && SIXES_PLAYER_SIDE_BUCKETS.includes(bucket)) continue;
        const won = bucketWonCellIndices(buckets, outcomes, bucket);
        const orderBucketIdx = (0, _sixesMarketBucket.SIXES_BUCKETS).indexOf(bucket);
        const sixDraw = cells.length >= SIXES_SIX_DRAW_FULL_WINS;
        if (!sixDraw) {
            if (won.length >= SIXES_BUCKET_SLIDE_MIN_WINS) fourDraw.push({
                bucket,
                kind: "four_draw",
                rank: completionRank(won, settleRank, SIXES_BUCKET_SLIDE_MIN_WINS, "last"),
                orderBucketIdx
            });
            continue;
        }
        if (won.length >= SIXES_SIX_DRAW_FULL_WINS) sixCol.push({
            bucket,
            kind: "six_draw_col",
            rank: completionRank(won, settleRank, SIXES_SIX_DRAW_FULL_WINS, "last"),
            orderBucketIdx
        });
        else if (won.length >= SIXES_BUCKET_SLIDE_MIN_WINS) sixRow.push({
            bucket,
            kind: "six_draw_row",
            rank: completionRank(won, settleRank, SIXES_BUCKET_SLIDE_MIN_WINS, "threshold"),
            orderBucketIdx
        });
    }
    if (splitRuns && isMergedRunsSlideReady(buckets, outcomes)) {
        const mergedWon = mergedRunsWonCellIndices(buckets, outcomes);
        const mergedKind = mergedRunsClaimKind(buckets, outcomes);
        const mergedPending = {
            bucket: SIXES_MERGED_RUNS_SLIDE_BUCKET,
            kind: mergedKind,
            rank: completionRank(mergedWon, settleRank, SIXES_BUCKET_SLIDE_MIN_WINS, mergedKind === "four_draw" ? "last" : "threshold"),
            orderBucketIdx: (0, _sixesMarketBucket.SIXES_BUCKETS).indexOf(SIXES_MERGED_RUNS_SLIDE_BUCKET)
        };
        if (mergedKind === "four_draw") fourDraw.push(mergedPending);
        else sixRow.push(mergedPending);
        mergedRunsClaimed = true;
    }
    if (splitPlayers && isMergedPlayerSlideReady(buckets, outcomes)) {
        const mergedWon = mergedPlayerWonCellIndices(buckets, outcomes);
        const mergedKind = mergedPlayerClaimKind(buckets, outcomes);
        const mergedPending = {
            bucket: SIXES_MERGED_PLAYER_SLIDE_BUCKET,
            kind: mergedKind,
            rank: completionRank(mergedWon, settleRank, SIXES_BUCKET_SLIDE_MIN_WINS, mergedKind === "four_draw" ? "last" : "threshold"),
            orderBucketIdx: (0, _sixesMarketBucket.SIXES_BUCKETS).indexOf(SIXES_MERGED_PLAYER_SLIDE_BUCKET)
        };
        if (mergedKind === "four_draw") fourDraw.push(mergedPending);
        else sixRow.push(mergedPending);
        mergedPlayersClaimed = true;
    }
    const byRank = (a, b)=>a.rank - b.rank || a.orderBucketIdx - b.orderBucketIdx;
    fourDraw.sort(byRank);
    sixRow.sort(byRank);
    sixCol.sort(byRank);
    const jackpot = fourDraw.length >= SIXES_FOUR_DRAW_LINE_ORDER.length + 1;
    const assigned = [];
    fourDraw.forEach((p, i)=>{
        const lineId = SIXES_FOUR_DRAW_LINE_ORDER[i];
        if (lineId) assigned.push({
            ...p,
            lineId
        });
    });
    sixRow.forEach((p, i)=>{
        const lineId = SIXES_SIX_DRAW_ROW_ORDER[i];
        if (lineId) assigned.push({
            ...p,
            lineId
        });
    });
    sixCol.forEach((p, i)=>{
        const lineId = SIXES_SIX_DRAW_COL_ORDER[i];
        if (lineId) assigned.push({
            ...p,
            lineId
        });
    });
    // Apply claims in completion order against an evolving layout so later claims slide from where
    // cells actually sit — the universal swap rule then composes correctly.
    assigned.sort((a, b)=>a.rank - b.rank || a.orderBucketIdx - b.orderBucketIdx);
    const slotOf = new Map(); // original cell → current slot
    const originalAt = new Map(); // current slot → original cell
    const curSlot = (orig)=>slotOf.get(orig) ?? orig;
    const origAt = (slot)=>originalAt.get(slot) ?? slot;
    const claims = [];
    for (const a of assigned){
        const won = mergedRunsClaimed && a.bucket === SIXES_MERGED_RUNS_SLIDE_BUCKET && splitRuns ? mergedRunsWonCellIndices(buckets, outcomes) : mergedPlayersClaimed && a.bucket === SIXES_MERGED_PLAYER_SLIDE_BUCKET && splitPlayers ? mergedPlayerWonCellIndices(buckets, outcomes) : bucketWonCellIndices(buckets, outcomes, a.bucket);
        const moves = resolveClaimSwaps(a.lineId, a.kind, won, slotOf, rng);
        const swaps = [];
        for (const { target, moverSlot } of moves){
            if (moverSlot === target) continue;
            swaps.push({
                from: moverSlot,
                to: target
            });
            // Swap the originals sitting at the two slots, keeping both maps in sync.
            const movingOrig = origAt(moverSlot);
            const displacedOrig = origAt(target);
            slotOf.set(movingOrig, target);
            slotOf.set(displacedOrig, moverSlot);
            originalAt.set(target, movingOrig);
            originalAt.set(moverSlot, displacedOrig);
        }
        claims.push({
            bucket: a.bucket,
            lineId: a.lineId,
            kind: a.kind,
            rank: a.rank,
            swaps
        });
    }
    return {
        claims,
        jackpot
    };
}
function sixesLineClaimSwaps(lineId, kind, wonHomeIndices, rng = null) {
    const moves = resolveClaimSwaps(lineId, kind, wonHomeIndices, new Map(), rng);
    return moves.filter((m)=>m.moverSlot !== m.target).map((m)=>({
            from: m.moverSlot,
            to: m.target
        }));
}
function movementPlanSwaps(plan) {
    const swaps = [];
    for (const claim of plan.claims)swaps.push(...claim.swaps);
    return swaps;
}
function seededRng(seed) {
    let a = seed >>> 0;
    return function next() {
        a |= 0;
        a = a + 0x6d2b79f5 | 0;
        let t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function seedFromCardId(cardId) {
    const s = String(cardId ?? "");
    let h = 2166136261;
    for(let i = 0; i < s.length; i += 1){
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
}
function applySixesSwaps(values, swaps) {
    const next = [
        ...values
    ];
    for (const { from, to } of swaps){
        if (from === to) continue;
        const tmp = next[from];
        next[from] = next[to];
        next[to] = tmp;
    }
    return next;
}

},{"./sixesGridLayout":"EvkJs","./sixesLiveData":"jPlrt","./sixesMarketBucket":"87iM1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPlrt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** True when Decimal / fixture text indicates a stoppage (rain, drinks, innings break). */ parcelHelpers.export(exports, "sixesStatusTextIndicatesBreakInPlay", ()=>sixesStatusTextIndicatesBreakInPlay);
/**
 * Human-readable break label for the tab row — preserves rain / delay detail when present.
 * @param {unknown[]} sources — scorecard event_status, live header status, fixture status, etc.
 */ parcelHelpers.export(exports, "formatSixesBreakInPlayDisplayLabel", ()=>formatSixesBreakInPlayDisplayLabel);
/**
 * Lobby / tab-row label from fixture or live feed text (uppercase, matches existing Sixes badges).
 */ parcelHelpers.export(exports, "formatSixesFixtureStatusDisplayLabel", ()=>formatSixesFixtureStatusDisplayLabel);
/**
 * Tab-row status text from derived lifecycle + raw feed strings.
 */ parcelHelpers.export(exports, "formatSixesLiveStatusDisplayLabel", ()=>formatSixesLiveStatusDisplayLabel);
/**
 * Headline + detail for the match-finished modal — abandoned, no-result, rain, or normal result line.
 */ parcelHelpers.export(exports, "deriveSixesMatchFinishedOutcome", ()=>deriveSixesMatchFinishedOutcome);
/**
 * Derive the match lifecycle status from the live cricket feed — same precedence as
 * `BullionPlayedGameView`, trimmed to the signals available to the Sixes card view.
 */ parcelHelpers.export(exports, "deriveSixesMatchStatus", ()=>deriveSixesMatchStatus);
parcelHelpers.export(exports, "sixesMatchStatusIsLive", ()=>sixesMatchStatusIsLive);
/**
 * Pull a toss-result line (e.g. "India won the toss and elected to bat") out of the feed's
 * `match_comment` so it can be shown before play begins. Returns "" when the comment isn't a toss line
 * (avoids surfacing chase/RRR/result comments pre-match).
 */ parcelHelpers.export(exports, "extractSixesTossComment", ()=>extractSixesTossComment);
parcelHelpers.export(exports, "isSixesCellWon", ()=>isSixesCellWon);
parcelHelpers.export(exports, "isSixesCellVoid", ()=>isSixesCellVoid);
/**
 * Card lines (rows, columns, both diagonals) as arrays of market-cell indices, excluding the
 * centre 2×2 multiplier block — mirrors backend `sixesCardLineDefinitions` for set detection.
 */ parcelHelpers.export(exports, "sixesCardLineIndices", ()=>sixesCardLineIndices);
parcelHelpers.export(exports, "isCardLineFullyWon", ()=>isCardLineFullyWon);
parcelHelpers.export(exports, "cardLineCelebrationKey", ()=>cardLineCelebrationKey);
/** Lines that just became a full win (backend "set") since the previous outcome snapshot. */ parcelHelpers.export(exports, "findNewlyCompletedCardLines", ()=>findNewlyCompletedCardLines);
/**
 * Map each cell's settlement result onto its grid index (for the cell detail modal stat box).
 * Uses any captured result from the server, including in-progress values when present.
 */ parcelHelpers.export(exports, "buildSixesResultsFromApiCells", ()=>buildSixesResultsFromApiCells);
/** Map one API cell to a grid outcome (void vs lost vs win). */ parcelHelpers.export(exports, "resolveSixesCellOutcomeFromApiCell", ()=>resolveSixesCellOutcomeFromApiCell);
/** Map server settlement to grid outcomes — wins are pink only (green is applied in the UI). */ parcelHelpers.export(exports, "buildSixesPinkOutcomesFromApiCells", ()=>buildSixesPinkOutcomesFromApiCells);
/** Promote every cell in a fully-won card line to green (backend "set"). */ parcelHelpers.export(exports, "promoteCardLineWinsToGreen", ()=>promoteCardLineWinsToGreen);
/** Pink wins plus green on completed card lines (static / skip-animation entry). */ parcelHelpers.export(exports, "buildSixesOutcomesFromApiCells", ()=>buildSixesOutcomesFromApiCells);
/** True when the server already settled at least one market cell and the card has scored coins (e.g. toss). */ parcelHelpers.export(exports, "sixesCardHasPrematchSettlementWithPoints", ()=>sixesCardHasPrematchSettlementWithPoints);
/** True when the live board already reflects a prematch settlement that scored coins. */ parcelHelpers.export(exports, "sixesBoardHasPrematchSettlementWithPoints", ()=>sixesBoardHasPrematchSettlementWithPoints);
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
var _bullionPlayedMatchDetails = require("../../Bullion/lib/bullionPlayedMatchDetails");
var _bullionPlayedSlipDisplay = require("../../Bullion/lib/bullionPlayedSlipDisplay");
var _matchCardCompactUi = require("../../Games/MatchCards/matchCardCompactUi");
var _sixesGridLayout = require("./sixesGridLayout");
function sixesStatusTextIndicatesBreakInPlay(raw) {
    const s = String(raw ?? "").trim();
    if (!s) return false;
    return (0, _bullionPlayedSlipDisplay.normalizeMatchStatus)(s) === "BREAK IN PLAY";
}
function formatSixesBreakInPlayDisplayLabel(...sources) {
    for (const raw of sources){
        const s = String(raw ?? "").trim();
        if (!s || !sixesStatusTextIndicatesBreakInPlay(s)) continue;
        const withoutParen = s.replace(/\s*\([^)]*\)\s*/g, " ").replace(/\s+/g, " ").trim();
        if (/break in play/i.test(withoutParen)) {
            const parts = withoutParen.split(/\s*-\s*/);
            const tail = parts.slice(1).join(" - ").trim();
            if (tail) return `MATCH BREAK - ${tail.toUpperCase()}`;
            return "MATCH BREAK";
        }
        if (/rain delay|bad weather|weather delay|toss delayed|wet outfield/i.test(s)) return "MATCH BREAK - RAIN DELAY";
        if (/drinks/i.test(s)) return "MATCH BREAK - DRINKS";
        return "MATCH BREAK";
    }
    return "MATCH BREAK";
}
function formatSixesFixtureStatusDisplayLabel(fixtureStatus) {
    const s = String(fixtureStatus ?? "").trim();
    if (!s) return null;
    const normalized = (0, _bullionPlayedSlipDisplay.normalizeMatchStatus)(s);
    if (normalized === "FINISHED") return "FINISHED";
    if (normalized === "IN-PLAY") return "MATCH LIVE";
    if (normalized === "BREAK IN PLAY") return formatSixesBreakInPlayDisplayLabel(s);
    return null;
}
function formatSixesLiveStatusDisplayLabel(params) {
    const { displayMatchStatus, scheduledStatusLabel = "SCHEDULED", scorecardData, liveStatus = "", fixtureStatusFallback = "", gamePhase = "" } = params;
    if (displayMatchStatus === "FINISHED") return "FINISHED";
    if (displayMatchStatus === "IN-PLAY") return "MATCH LIVE";
    if (displayMatchStatus === "BREAK IN PLAY") {
        const scorecardEv = scorecardData?.event_status;
        return formatSixesBreakInPlayDisplayLabel(scorecardEv, liveStatus, fixtureStatusFallback, gamePhase);
    }
    return scheduledStatusLabel;
}
function deriveBreakInPlayFromFeedTexts(...sources) {
    return sources.some((raw)=>sixesStatusTextIndicatesBreakInPlay(raw));
}
function isRrrChaseComment(comment) {
    return / require \d+ runs from \d+ ball/i.test(comment);
}
function statusTextIndicatesAbandoned(text) {
    const u = text.toUpperCase();
    return u.includes("MATCH ABANDONED") || /\babandon/.test(u) && !u.includes("NOT ABANDONED");
}
function statusTextIndicatesNoResult(text) {
    return text.toUpperCase().includes("NO RESULT");
}
function statusTextIndicatesRainOrWeather(text) {
    const u = text.toUpperCase();
    return u.includes("RAIN DELAY") || u.includes("RAIN") || u.includes("BAD WEATHER") || u.includes("TOSS DELAYED") || u.includes("WET OUTFIELD") || u.includes("BREAK IN PLAY") || u.includes("PLAY SUSPENDED") || u.includes("CURTAILED");
}
function deriveSixesMatchFinishedOutcome(params) {
    const comment = String(params.matchComment ?? "").trim();
    const scorecardEv = String(params.scorecardData?.event_status ?? "").trim();
    const liveStatus = String(params.liveStatus ?? "").trim();
    const fixtureStatus = String(params.fixtureStatusFallback ?? "").trim();
    const gamePhase = String(params.gamePhase ?? "").trim();
    const tabRow = String(params.tabRowStatusLabel ?? "").trim();
    const feedTexts = [
        comment,
        scorecardEv,
        liveStatus,
        fixtureStatus,
        gamePhase,
        tabRow
    ].filter(Boolean);
    if (comment && (0, _decimalEventStatus.commentIndicatesCricketMatchResult)(comment) && !isRrrChaseComment(comment)) return {
        title: "Match Finished",
        message: (0, _matchCardCompactUi.formatCricketSentenceCase)(comment)
    };
    for (const text of feedTexts){
        if (statusTextIndicatesNoResult(text)) return {
            title: "No Result",
            message: (0, _matchCardCompactUi.formatCricketSentenceCase)(text) || "This match ended with no result."
        };
    }
    for (const text of feedTexts){
        if (statusTextIndicatesAbandoned(text)) return {
            title: "Match Abandoned",
            message: (0, _matchCardCompactUi.formatCricketSentenceCase)(text) || "This match was abandoned."
        };
    }
    for (const text of feedTexts)if (statusTextIndicatesRainOrWeather(text)) {
        const hasWinningComment = comment && (0, _decimalEventStatus.commentIndicatesCricketMatchResult)(comment) && !isRrrChaseComment(comment);
        return {
            title: hasWinningComment ? "Match Finished" : "No Result",
            message: (0, _matchCardCompactUi.formatCricketSentenceCase)(text)
        };
    }
    if (comment && !isRrrChaseComment(comment)) {
        const u = comment.toUpperCase();
        if (u.includes("RAIN") || u.includes("ABANDON") || u.includes("NO RESULT") || u.includes("SUSPEND") || u.includes("CURTAILED")) {
            const title = u.includes("NO RESULT") ? "No Result" : u.includes("ABANDON") ? "Match Abandoned" : "Match Finished";
            return {
                title,
                message: (0, _matchCardCompactUi.formatCricketSentenceCase)(comment)
            };
        }
    }
    if (scorecardEv && /match complete|event closed/i.test(scorecardEv)) return {
        title: "Match Finished",
        message: ""
    };
    const formatCells = Array.isArray(params.formatCorrection?.cells) ? params.formatCorrection.cells.length : 0;
    if (formatCells > 0) {
        const overs = params.formatCorrection?.formatOvers;
        const oversNote = overs != null && Number.isFinite(Number(overs)) ? ` Reduced to ${Math.round(Number(overs))} overs per side.` : "";
        return {
            title: "No Result",
            message: `Rain affected this match.${oversNote} Voided cheers show as VOID on your card.`
        };
    }
    if (tabRow && statusTextIndicatesRainOrWeather(tabRow)) return {
        title: "No Result",
        message: formatSixesBreakInPlayDisplayLabel(tabRow)
    };
    return {
        title: "Match Finished",
        message: ""
    };
}
function deriveSixesMatchStatus(params) {
    const { eventStatus, liveStatus, gamePhase, matchComment, scorecardData, scorePrimaryA, scorePrimaryB, hasLiveBallFeed, scheduledStartTs, nowTs, forceFinished = false, fixtureStatusFallback = "" } = params;
    if (forceFinished) return "FINISHED";
    const fixtureStatus = String(fixtureStatusFallback || liveStatus || "").trim();
    const uFixture = fixtureStatus.toUpperCase();
    if (uFixture.includes("MATCH COMPLETE") || uFixture.includes("EVENT CLOSED") || uFixture.includes("MATCH ABANDONED") || uFixture.includes("FINISHED") && !uFixture.includes("NOT FINISHED")) return "FINISHED";
    const scorecardEv = scorecardData?.event_status;
    if ((0, _decimalEventStatus.isMatchFinishedStatus)(eventStatus) || (0, _decimalEventStatus.isMatchFinishedStatus)(scorecardEv) || (0, _decimalEventStatus.commentIndicatesCricketMatchResult)(matchComment)) return "FINISHED";
    const feedStatus = String(liveStatus ?? "").trim();
    if (feedStatus !== "" && (0, _decimalEventStatus.isMatchFinishedStatus)(liveStatus)) return "FINISHED";
    const uLive = feedStatus.toUpperCase();
    if (uLive.includes("MATCH COMPLETE") || uLive.includes("EVENT CLOSED") || uLive.includes("MATCH ABANDONED")) return "FINISHED";
    const gp = String(gamePhase || "").trim();
    if (/\bevent\s*closed\b/i.test(gp) || /\bmatch\s*complete\b/i.test(gp)) return "FINISHED";
    const scorecardEvStr = scorecardData?.event_status != null ? String(scorecardData.event_status).trim() : "";
    // Prefer scorecard / fixture break signals before generic in-play heuristics (stale header may lag).
    if (deriveBreakInPlayFromFeedTexts(scorecardEvStr, fixtureStatus, feedStatus, gp)) return "BREAK IN PLAY";
    const hasConcreteLiveSignals = (0, _bullionPlayedMatchDetails.looksLikeLiveCricketScoreboard)(scorePrimaryA, scorePrimaryB) || hasLiveBallFeed;
    // Prefer fixture kickoff: if kickoff is still in the future, force pre-match.
    if (scheduledStartTs != null && scheduledStartTs > nowTs) return "SCHEDULED";
    const fromEvent = (0, _bullionPlayedMatchDetails.getEventStatusDisplayLabel)(eventStatus);
    if (fromEvent === "FINISHED") return "FINISHED";
    if (fromEvent === "BREAK IN PLAY") return "BREAK IN PLAY";
    if (fromEvent === "IN-PLAY") return "IN-PLAY";
    const fromScorecardEvent = (0, _bullionPlayedMatchDetails.getEventStatusDisplayLabel)(scorecardEvStr);
    if (fromScorecardEvent === "BREAK IN PLAY") return "BREAK IN PLAY";
    if (fromScorecardEvent === "IN-PLAY") return "IN-PLAY";
    if (feedStatus.includes("Match in Progress")) return "IN-PLAY";
    if (gp === "In Play" || gp.toLowerCase().includes("in play")) return "IN-PLAY";
    const esNum = (0, _decimalEventStatus.eventStatusToNumber)(eventStatus);
    if (esNum != null && esNum !== (0, _decimalEventStatus.EVENT_STATUS).MATCH_SCHEDULED) {
        if (esNum === (0, _decimalEventStatus.EVENT_STATUS).BREAK_IN_PLAY) return "BREAK IN PLAY";
        if (esNum === (0, _decimalEventStatus.EVENT_STATUS).MATCH_COMPLETE || esNum === (0, _decimalEventStatus.EVENT_STATUS).EVENT_CLOSED || esNum === (0, _decimalEventStatus.EVENT_STATUS).EJECTED) return "FINISHED";
        return "IN-PLAY";
    }
    if (hasConcreteLiveSignals) return "IN-PLAY";
    const fromText = (0, _bullionPlayedSlipDisplay.normalizeMatchStatus)(liveStatus);
    if (fromText === "FINISHED") return "FINISHED";
    const kickoffPast = scheduledStartTs == null || scheduledStartTs <= nowTs;
    if (fromText === "SCHEDULED" && kickoffPast) // Without live signals, do not assume IN-PLAY after kickoff (finished feeds often stay "scheduled").
    return hasConcreteLiveSignals ? "IN-PLAY" : "SCHEDULED";
    return fromText;
}
function sixesMatchStatusIsLive(status) {
    return status === "IN-PLAY" || status === "BREAK IN PLAY";
}
function extractSixesTossComment(matchComment) {
    const s = String(matchComment ?? "").trim();
    if (!s) return "";
    // Pre-toss scorecards use "0 won the toss…" as a placeholder.
    if (/^\d+\s+won the toss\b/i.test(s)) return "";
    const isToss = /\bwon\s+the\s+toss\b/i.test(s) || /\b(elected|chose|opt(?:ed)?|decided)\s+to\s+(bat|bowl|field)\b/i.test(s);
    return isToss ? s : "";
}
function isSixesCellWon(outcome) {
    return outcome === "win-pink" || outcome === "win-green";
}
function isSixesCellVoid(outcome) {
    return outcome === "void";
}
function sixesCardLineIndices() {
    const lines = [];
    for(let row = 0; row < 6; row += 1){
        const cells = [];
        for(let col = 0; col < 6; col += 1){
            const idx = (0, _sixesGridLayout.marketCellIndexFromGrid)(row, col);
            if (idx >= 0) cells.push(idx);
        }
        if (cells.length >= 2) lines.push(cells);
    }
    for(let col = 0; col < 6; col += 1){
        const cells = [];
        for(let row = 0; row < 6; row += 1){
            const idx = (0, _sixesGridLayout.marketCellIndexFromGrid)(row, col);
            if (idx >= 0) cells.push(idx);
        }
        if (cells.length >= 2) lines.push(cells);
    }
    const diag1 = [];
    const diag2 = [];
    for(let i = 0; i < 6; i += 1){
        const a = (0, _sixesGridLayout.marketCellIndexFromGrid)(i, i);
        if (a >= 0) diag1.push(a);
        const b = (0, _sixesGridLayout.marketCellIndexFromGrid)(i, 5 - i);
        if (b >= 0) diag2.push(b);
    }
    if (diag1.length >= 2) lines.push(diag1);
    if (diag2.length >= 2) lines.push(diag2);
    return lines;
}
function isCardLineFullyWon(line, outcomes) {
    return line.length >= 2 && line.every((idx)=>isSixesCellWon(outcomes[idx] ?? "pending"));
}
function cardLineCelebrationKey(line) {
    return line.join(",");
}
function findNewlyCompletedCardLines(prev, next) {
    const newly = [];
    for (const line of sixesCardLineIndices())if (!isCardLineFullyWon(line, prev) && isCardLineFullyWon(line, next)) newly.push([
        ...line
    ]);
    return newly;
}
function buildSixesResultsFromApiCells(cells) {
    const results = Array.from({
        length: (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT)
    }, ()=>null);
    for (const cell of cells){
        const idx = (0, _sixesGridLayout.marketCellIndexFromGrid)(Number(cell.row), Number(cell.col));
        if (idx < 0) continue;
        const value = cell.settlementResult != null && String(cell.settlementResult).trim() !== "" ? String(cell.settlementResult).trim() : null;
        if (value) results[idx] = value;
    }
    return results;
}
function resolveSixesCellOutcomeFromApiCell(cell) {
    if (!cell.settled) return "pending";
    if (cell.won) return "win-pink";
    const outcome = String(cell.settlementOutcome ?? "").trim().toUpperCase();
    if (outcome === "VOID") return "void";
    const result = String(cell.settlementResult ?? "").trim().toLowerCase();
    if (result === "void" || result === "reduced overs") return "void";
    return "lost";
}
function buildSixesPinkOutcomesFromApiCells(cells) {
    const outcomes = Array.from({
        length: (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT)
    }, ()=>"pending");
    for (const cell of cells){
        const idx = (0, _sixesGridLayout.marketCellIndexFromGrid)(Number(cell.row), Number(cell.col));
        if (idx < 0) continue;
        outcomes[idx] = resolveSixesCellOutcomeFromApiCell(cell);
    }
    return outcomes;
}
function promoteCardLineWinsToGreen(outcomes) {
    const next = [
        ...outcomes
    ];
    for (const line of sixesCardLineIndices()){
        if (!isCardLineFullyWon(line, next)) continue;
        for (const idx of line)if (next[idx] === "win-pink") next[idx] = "win-green";
    }
    return next;
}
function buildSixesOutcomesFromApiCells(cells) {
    return promoteCardLineWinsToGreen(buildSixesPinkOutcomesFromApiCells(cells));
}
function sixesCardHasPrematchSettlementWithPoints(data) {
    const coins = Math.round(Number(data.card.totalCoins) || 0);
    if (coins <= 0) return false;
    return data.cells.some((cell)=>!cell.isMultiplier && Boolean(cell.settled));
}
function sixesBoardHasPrematchSettlementWithPoints(cellOutcomes, coinsTotal) {
    if (coinsTotal <= 0) return false;
    return cellOutcomes.some((outcome)=>outcome !== "pending");
}

},{"../../Trader/Cricket/decimalEventStatus":"f1nlI","../../Bullion/lib/bullionPlayedMatchDetails":"gNcBN","../../Bullion/lib/bullionPlayedSlipDisplay":"axTBp","../../Games/MatchCards/matchCardCompactUi":"9NhAM","./sixesGridLayout":"EvkJs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"axTBp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "teamScoresFromStatus", ()=>teamScoresFromStatus);
parcelHelpers.export(exports, "normalizeMatchStatus", ()=>normalizeMatchStatus);
parcelHelpers.export(exports, "formatBullionCountdown", ()=>formatBullionCountdown);
parcelHelpers.export(exports, "formatBullionStartsAtDateTime", ()=>formatBullionStartsAtDateTime);
parcelHelpers.export(exports, "isBullionMarketRunnerTie", ()=>isBullionMarketRunnerTie);
/**
 * Bare "Over" / "Under" from DB or snapshot → "Over 12.5" when `line` is known (room board uses the same rule).
 */ parcelHelpers.export(exports, "bullionRunnerDisplayNameWithLine", ()=>bullionRunnerDisplayNameWithLine);
/**
 * Markets that should show a player headshot on the slip (aligned with Trader `market-display.jsx`,
 * plus BULLION player-tab type IDs: batter runs / batter sixes (710/910/730/914).
 */ parcelHelpers.export(exports, "bullionMarketShowsPlayerImage", ()=>bullionMarketShowsPlayerImage);
parcelHelpers.export(exports, "normalizeTeamKey", ()=>normalizeTeamKey);
/**
 * Scorecard `bat_now` vs fixture row labels often differ (“NZ” vs “New Zealand”).
 * Matches strict equality first, then normalized substring equality (same idea as slip-side inference).
 */ parcelHelpers.export(exports, "bullionBattingLabelMatchesFixtureTeam", ()=>bullionBattingLabelMatchesFixtureTeam);
/** Same logic as Trader `Cricket/match-play` — Test multi-innings: `120/3 & 45/2`. */ parcelHelpers.export(exports, "formatTraderMatchPlayDisplayScore", ()=>formatTraderMatchPlayDisplayScore);
/** Trader `match-play.jsx` / Squares `formatStatusWithSurnames` — socket `status` “Bowler to Batsman” → surnames. */ parcelHelpers.export(exports, "formatTraderMatchPlayBallStatusCaption", ()=>formatTraderMatchPlayBallStatusCaption);
/** Leading overs token from `match_comment` (fallback for pink OVER when innings decimal missing). */ parcelHelpers.export(exports, "parseMatchCommentLeadingOver", ()=>parseMatchCommentLeadingOver);
/** Trader `recentDeliveries`: last 5 raw feed entries (no Squares filtration). */ parcelHelpers.export(exports, "traderMatchRecentDeliveryStrip", ()=>traderMatchRecentDeliveryStrip);
/**
 * Mobile/desktop live OVER tab + white ball strip.
 * Hide during innings break / chase-not-started (`0.0`) so we never paint empty OVER 1 + pink 0.0.
 */ parcelHelpers.export(exports, "shouldShowBullionLiveBallStrip", ()=>shouldShowBullionLiveBallStrip);
/**
 * Trader `markets.jsx` currentOverNumber: `Math.floor(parseFloat(curBall)) + 1`, else innings completed overs + 1.
 */ parcelHelpers.export(exports, "traderMatchPlayCurrentOverOneBased", ()=>traderMatchPlayCurrentOverOneBased);
parcelHelpers.export(exports, "inferSelectionSide", ()=>inferSelectionSide);
/**
 * `PlayerHeadshotImage` CDN path uses full franchise-style folder names. Scoreboard `home`/`away` are often
 * abbreviations (e.g. IND, KKR); align them to the long names from the fixture title when possible.
 */ parcelHelpers.export(exports, "bullionResolvedTeamNameForPlayerCdnFolder", ()=>bullionResolvedTeamNameForPlayerCdnFolder);
/**
 * Player headshots use `Cricket/Player Images/{slug}.png` (flat S3). Team + player live in the
 * market title (e.g. `PK, Cooper Connolly Runs 22.5` or `Delhi Capitals, Axar Patel Bullion 1.5`).
 */ parcelHelpers.export(exports, "bullionParseCommaPrefixedPlayerPropForCdn", ()=>bullionParseCommaPrefixedPlayerPropForCdn);
/**
 * Team crests for the slip leader column, plus any crests implied by teams named in `marketName` (deduped).
 * When the selection is Tie, returns [] — the slip row renders the draw icon instead (no team/player marks).
 */ parcelHelpers.export(exports, "bullionSlipLeaderCrests", ()=>bullionSlipLeaderCrests);
/**
 * Line markets often embed the handicap/total in the market title (e.g. "India Innings Runs Over 110.5").
 * Put the base market in the primary column and "Over 110.5" / "Under 250.5" in the selection column.
 */ parcelHelpers.export(exports, "splitBullionLineMarketForSlipRow", ()=>splitBullionLineMarketForSlipRow);
parcelHelpers.export(exports, "playerInitials", ()=>playerInitials);
/**
 * True once anyone has earned points or settled a pick line.
 * Until then POS stays "-" and prize-coin stacks stay hidden — potential-only ordering is not a real standing.
 */ parcelHelpers.export(exports, "bullionLeaderboardScoringStarted", ()=>bullionLeaderboardScoringStarted);
/**
 * Competition display rank from the API (points desc, then potential points desc).
 * Hidden while pre-match / before anyone has scored — the board still sorts by potential, but POS is "-".
 */ parcelHelpers.export(exports, "bullionLeaderboardDisplayRank", ()=>bullionLeaderboardDisplayRank);
/** Leaderboard name cell — prefer the signed-in account name on the viewer's own row. */ parcelHelpers.export(exports, "bullionLeaderboardRowPlayerLabel", ()=>bullionLeaderboardRowPlayerLabel);
var _cricketTestMatch = require("../../../utils/cricketTestMatch");
var _matchCountdown = require("../../../utils/matchCountdown");
var _matchUtils = require("../../Games/matchUtils");
var _scoreboardOutcomeAnimation = require("../../common/scoreboardOutcomeAnimation");
var _cricketMatchCardOverDisplay = require("../../Cricket/cricketMatchCardOverDisplay");
var _bullionTeamAbbreviation = require("./bullionTeamAbbreviation");
var _cricketTeamLogoResolve = require("../../shared/logos/cricketTeamLogoResolve");
function teamScoresFromStatus(status) {
    const values = String(status || "").match(/\d+\/\d+/g) || [];
    return [
        values[0] || "--",
        values[1] || "--"
    ];
}
function normalizeMatchStatus(raw) {
    const s = String(raw || "").toUpperCase();
    if (s.includes("MATCH COMPLETE") || s.includes("EVENT CLOSED") || s.includes("MATCH FINISHED") || s.includes("FINISHED") && !s.includes("NOT FINISHED")) return "FINISHED";
    if (s.includes("IN-PLAY") || s.includes("MATCH IN PROGRESS") || /^\d+/.test(s)) return "IN-PLAY";
    if (s.includes("BREAK IN PLAY") || s.includes("DRINKS") || s.includes("RAIN DELAY") || s.includes("BAD WEATHER") || s.includes("WEATHER DELAY") || s.includes("TOSS DELAYED") || s.includes("WET OUTFIELD")) return "BREAK IN PLAY";
    return "SCHEDULED";
}
function formatBullionCountdown(ms) {
    return (0, _matchCountdown.formatCountdownDuration)(ms) ?? "1m";
}
function formatBullionStartsAtDateTime(ts) {
    const d = new Date(ts);
    if (!Number.isFinite(d.getTime())) return "SCHEDULED";
    return `Starts ${d.toLocaleString(undefined, {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit"
    })}`;
}
function isBullionMarketRunnerTie(runnerName) {
    return (0, _cricketTestMatch.isCricketTieOrDrawSelectionName)(runnerName);
}
function formatBullionHandicapLine(val) {
    const n = typeof val === "number" ? val : parseFloat(String(val ?? "").trim());
    if (!Number.isFinite(n) || n <= 0) return null;
    return Number.isInteger(n) ? String(n) : n.toFixed(1);
}
function bullionRunnerDisplayNameWithLine(runnerName, line) {
    const raw = String(runnerName ?? "").trim();
    if (!raw) return "\u2014";
    const low = raw.toLowerCase();
    if (/\b(?:over|under)\s+\d/.test(low)) return raw;
    const fmt = formatBullionHandicapLine(line);
    if (!fmt) return raw;
    if (low === "over") return `Over ${fmt}`;
    if (low === "under") return `Under ${fmt}`;
    return raw;
}
function bullionMarketShowsPlayerImage(meta) {
    const idRaw = String(meta.marketTypeId ?? "").trim();
    const id = /^\d+(\.0+)?$/.test(idRaw) ? String(parseInt(idRaw, 10)) : idRaw;
    const mt = String(meta.marketType ?? "").trim();
    const marketTypeLower = mt.toLowerCase();
    const name = String(meta.marketName ?? "").toLowerCase();
    if (mt === "Next Player Out") return true;
    if (id === "270" || id === "940" || id === "280" || id === "950" || id === "710" || id === "730" || id === "910" || id === "914") return true;
    if (marketTypeLower.includes("top batter") || marketTypeLower.includes("top batsman") || marketTypeLower.includes("top bowler") || marketTypeLower.includes("batter runs") || marketTypeLower.includes("batter sixes") || marketTypeLower.includes("batsman sixes") || marketTypeLower.includes("batter match") || marketTypeLower.includes("bowler match") || marketTypeLower.includes("player of the") || marketTypeLower.includes("man of the") || marketTypeLower.includes("player performance")) return true;
    if (name.includes("next player out")) return true;
    if (name.includes("top batter") || name.includes("top batsman") || name.includes("top bowler")) return true;
    if (name.includes("batter runs") || name.includes("batter sixes") || name.includes("batsman sixes")) return true;
    if (name.includes("player of the") || name.includes("man of the")) return true;
    if (/\bplayer\s+to\s+score\b/i.test(String(meta.marketName ?? ""))) return true;
    if (name.includes("to reach") && name.includes("runs")) return true;
    return false;
}
function normalizeTeamKey(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}
function bullionBattingLabelMatchesFixtureTeam(batNowLabel, fixtureTeamLabel) {
    const bat = String(batNowLabel ?? "").trim();
    const row = String(fixtureTeamLabel ?? "").trim();
    if (!bat || !row) return false;
    if (bat === row) return true;
    const bKey = normalizeTeamKey(bat);
    const rKey = normalizeTeamKey(row);
    if (!bKey || !rKey) return false;
    if (bKey === rKey) return true;
    return bKey.includes(rKey) || rKey.includes(bKey);
}
function formatTraderMatchPlayDisplayScore(primary, secondary) {
    return (0, _scoreboardOutcomeAnimation.formatCricketCombinedInningsScore)(primary, secondary);
}
function formatTraderMatchPlayBallStatusCaption(statusText) {
    const trimmed = String(statusText ?? "").trim();
    if (!trimmed || trimmed === "to 0" || trimmed === "to") return null;
    if (trimmed.toLowerCase().startsWith("to ")) return null;
    const toMatch = trimmed.match(/^(.+?)\s+to\s+(.+?)$/i);
    if (!toMatch) return trimmed;
    const [, bowler, batsman] = toMatch;
    const bowlerSurname = bowler.trim().split(/\s+/).pop();
    const batsmanSurname = batsman.trim().split(/\s+/).pop();
    if (bowlerSurname === "0" || batsmanSurname === "0" || !bowlerSurname || !batsmanSurname) return null;
    return `${bowlerSurname} to ${batsmanSurname}`;
}
function parseMatchCommentLeadingOver(trimmedComment) {
    const trimmed = String(trimmedComment ?? "").trim();
    if (!trimmed) return {
        overToken: null,
        body: ""
    };
    const withRest = trimmed.match(/^(\d+(?:\.\d+)?)\s+(.*)$/);
    if (withRest?.[1] != null && withRest[2] != null) return {
        overToken: withRest[1],
        body: String(withRest[2]).trim()
    };
    const alone = trimmed.match(/^(\d+(?:\.\d+)?)$/);
    if (alone?.[1]) return {
        overToken: alone[1],
        body: ""
    };
    return {
        overToken: null,
        body: trimmed
    };
}
function traderMatchRecentDeliveryStrip(overDelivery) {
    return (overDelivery || []).filter((ball)=>ball !== "" && ball !== null && ball !== undefined).slice(-5).map((b)=>String(b));
}
function shouldShowBullionLiveBallStrip(matchStatus, currentInningsOversDecimal, opts) {
    if (matchStatus !== "IN-PLAY" && matchStatus !== "BREAK IN PLAY") return false;
    if (opts?.isInningsBreak) return false;
    if ((0, _cricketMatchCardOverDisplay.isSquaresAtInningsOversZero)(currentInningsOversDecimal)) return false;
    return true;
}
function traderMatchPlayCurrentOverOneBased(curBall, battingOvers, innsNow) {
    const fromBall = (0, _cricketMatchCardOverDisplay.cricketLiveOverNumberFromCurBall)(curBall);
    if (fromBall != null) return fromBall;
    if (!battingOvers || !Array.isArray(battingOvers) || innsNow == null || Number(innsNow) < 1) return null;
    const idx = Number(innsNow) - 1;
    if (idx >= battingOvers.length) return null;
    const completed = Number(battingOvers[idx]);
    if (!Number.isFinite(completed) || completed < 0) return null;
    return completed + 1;
}
function inferSelectionSide(runnerName, marketName, homeTeam, awayTeam) {
    const runnerKey = normalizeTeamKey(runnerName);
    const marketKey = normalizeTeamKey(marketName);
    const combined = `${runnerKey} ${marketKey}`;
    if (/\bhome\b/.test(combined)) return "home";
    if (/\baway\b/.test(combined)) return "away";
    const homeKey = normalizeTeamKey(homeTeam);
    const awayKey = normalizeTeamKey(awayTeam);
    if (homeKey && (runnerKey === homeKey || runnerKey.includes(homeKey) || homeKey.includes(runnerKey))) return "home";
    if (awayKey && (runnerKey === awayKey || runnerKey.includes(awayKey) || awayKey.includes(runnerKey))) return "away";
    const runRaw = String(runnerName || "").trim();
    const abbrHome = (0, _bullionTeamAbbreviation.bullionTeamAbbreviation)(homeTeam);
    const abbrAway = (0, _bullionTeamAbbreviation.bullionTeamAbbreviation)(awayTeam);
    if (abbrHome.length >= 2 && bullionAbbrevAppearsAsDistinctToken(runRaw, abbrHome) && homeKey) return "home";
    if (abbrAway.length >= 2 && bullionAbbrevAppearsAsDistinctToken(runRaw, abbrAway) && awayKey) return "away";
    return null;
}
function bullionTextMentionsTeam(text, team) {
    const h = normalizeTeamKey(text);
    const t = normalizeTeamKey(team);
    if (!h || !t) return false;
    return h.includes(t) || t.includes(h);
}
/** True when `abbr` appears as its own token in `text` (e.g. "KKR" in "KKR Total Runs", not a substring of a longer word). */ function bullionAbbrevAppearsAsDistinctToken(text, abbr) {
    const a = String(abbr || "").trim();
    if (a.length < 2) return false;
    let escaped;
    try {
        escaped = a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    } catch  {
        return false;
    }
    try {
        return new RegExp(`\\b${escaped}\\b`, "i").test(String(text || ""));
    } catch  {
        return false;
    }
}
function bullionResolvedTeamNameForPlayerCdnFolder(fixtureSideLabel, parsedOrFallbackPool) {
    return (0, _cricketTeamLogoResolve.resolveCricketTeamNameForLogo)(fixtureSideLabel, parsedOrFallbackPool);
}
/** Batter-style markets: `{team or abbr}, {player} Runs|Fours|…` (runner is often Over/Under only). */ const BULLION_COMMA_PLAYER_PROP_HEAD_RE = /^([^,]+),\s*(.+?)\s+(Runs|Fours|Sixes|Wickets)\b/i;
function bullionParseCommaPrefixedPlayerPropForCdn(marketName, teamA, teamB, roomMatchName) {
    const raw = String(marketName || "").trim();
    const m = raw.match(BULLION_COMMA_PLAYER_PROP_HEAD_RE);
    if (!m) return null;
    const teamToken = String(m[1] || "").trim();
    const playerPart = String(m[2] || "").trim();
    if (!teamToken || !playerPart) return null;
    const pt = (0, _matchUtils.parseCricketMatchName)(roomMatchName || "").teams;
    const pool = pt.length >= 2 ? pt : [
        teamA,
        teamB
    ];
    const folderTeam = bullionResolvedTeamNameForPlayerCdnFolder(teamToken, pool);
    return {
        folderTeam,
        playerName: playerPart
    };
}
/**
 * Fixture-order teams referenced in the slip line: full names or common short codes
 * (from `bullionTeamAbbreviation`) in either the market title or the selection name.
 */ function teamsMentionedInBullionSlipContext(marketName, runnerName, homeTeam, awayTeam) {
    const out = [];
    const keys = new Set();
    const combined = `${String(marketName || "")} ${String(runnerName || "")}`.trim();
    for (const team of [
        homeTeam,
        awayTeam
    ]){
        const nk = normalizeTeamKey(team);
        if (!nk || keys.has(nk)) continue;
        if (bullionTextMentionsTeam(combined, team)) {
            keys.add(nk);
            out.push(team);
            continue;
        }
        const abbr = (0, _bullionTeamAbbreviation.bullionTeamAbbreviation)(team);
        if (bullionAbbrevAppearsAsDistinctToken(combined, abbr)) {
            keys.add(nk);
            out.push(team);
        }
    }
    return out;
}
function bullionSlipLeaderCrests(runnerName, marketName, side, teamA, teamB) {
    if (isBullionMarketRunnerTie(runnerName)) return [];
    const crests = [];
    const seenTeam = new Set();
    {
        const tn = side === "home" ? teamA : side === "away" ? teamB : null;
        if (tn != null && normalizeTeamKey(tn)) {
            seenTeam.add(normalizeTeamKey(tn));
            crests.push({
                kind: "team",
                name: tn
            });
        }
    }
    for (const team of teamsMentionedInBullionSlipContext(marketName, runnerName, teamA, teamB)){
        const nk = normalizeTeamKey(team);
        if (!nk || seenTeam.has(nk)) continue;
        seenTeam.add(nk);
        crests.push({
            kind: "team",
            name: team
        });
    }
    return crests;
}
function replaceTeamsWithAbbreviationsInBullionMarketName(marketName, teams) {
    let out = String(marketName || "");
    for (const team of teams){
        const full = String(team || "").trim();
        if (!full) continue;
        const abbr = (0, _bullionTeamAbbreviation.bullionTeamAbbreviation)(full);
        if (!abbr) continue;
        const escaped = full.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        out = out.replace(new RegExp(escaped, "gi"), abbr);
    }
    return out;
}
function splitBullionLineMarketForSlipRow(marketName, runnerName, teamA, teamB) {
    const mn = replaceTeamsWithAbbreviationsInBullionMarketName(marketName, [
        teamA,
        teamB
    ]).trim();
    const rn = replaceTeamsWithAbbreviationsInBullionMarketName(runnerName, [
        teamA,
        teamB
    ]).trim();
    const re = /\s+(Over|Under)\s+([\d]+\.?[\d]*)\s*$/i;
    const match = mn.match(re);
    if (isBullionMarketRunnerTie(runnerName)) {
        if (match) {
            const base = mn.slice(0, match.index).trim();
            const line = `${match[1]} ${match[2]}`.replace(/\s+/g, " ").trim();
            if (base) return {
                primary: base,
                secondary: "Tie"
            };
            return {
                primary: mn,
                secondary: "Tie"
            };
        }
        return {
            primary: mn,
            secondary: "Tie"
        };
    }
    if (match) {
        const base = mn.slice(0, match.index).trim();
        const line = `${match[1]} ${match[2]}`.replace(/\s+/g, " ").trim();
        if (base) {
            const rLow = rn.toLowerCase();
            if (!rn || rLow === "over" || rLow === "under") return {
                primary: base,
                secondary: line
            };
            return {
                primary: base,
                secondary: `${line} \xb7 ${rn}`
            };
        }
        return {
            primary: mn,
            secondary: line
        };
    }
    return {
        primary: mn,
        secondary: rn
    };
}
function playerInitials(name) {
    const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    const first = parts[0]?.[0] || "";
    const second = parts.length > 1 ? parts[1]?.[0] || "" : "";
    return (first + second).toUpperCase();
}
function bullionLeaderboardScoringStarted(rows) {
    return rows.some((row)=>{
        if (Math.round(Number(row.points) || 0) > 0) return true;
        if (Math.round(Number(row.settledMarkets) || 0) > 0) return true;
        return false;
    });
}
function bullionLeaderboardDisplayRank({ rank, isPreMatch }) {
    if (isPreMatch) return 0;
    const rankInt = Math.round(Number(rank) || 0);
    return rankInt > 0 ? rankInt : 0;
}
function bullionLeaderboardRowPlayerLabel(row, options) {
    const rowName = String(row.playerName || "").trim();
    if (options.isCurrentUser) {
        const viewerName = String(options.viewerPlayerName || "").trim();
        if (viewerName) return viewerName;
    }
    return rowName || `Player ${row.userId}`;
}

},{"../../../utils/cricketTestMatch":"eJTw5","../../../utils/matchCountdown":"hzPTj","../../Games/matchUtils":"9QY2j","../../common/scoreboardOutcomeAnimation":"iLsHH","../../Cricket/cricketMatchCardOverDisplay":"jVYsA","./bullionTeamAbbreviation":"69hMh","../../shared/logos/cricketTeamLogoResolve":"7c4Rs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iLsHH":[function(require,module,exports,__globalThis) {
/** Non-breaking space after `&` so multi-innings scores do not collapse in tight score tiles. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CRICKET_COMBINED_INNINGS_SCORE_SEP", ()=>CRICKET_COMBINED_INNINGS_SCORE_SEP);
/** Test / multi-innings display — e.g. `120 & 86/3` inside a single score box. */ parcelHelpers.export(exports, "formatCricketCombinedInningsScore", ()=>formatCricketCombinedInningsScore);
/**
 * Parse sticky scoreboard lines like `86/3` or `120 & 86/3` (Trader / Squares / Bullion).
 * The segment after ` & ` (or the whole line) is the active innings score.
 */ parcelHelpers.export(exports, "parseScoreboardDisplayLine", ()=>parseScoreboardDisplayLine);
/** @param {ReturnType<typeof parseScoreboardDisplayLine>} prev */ /** @param {ReturnType<typeof parseScoreboardDisplayLine>} next */ parcelHelpers.export(exports, "deriveScoreboardOutcome", ()=>deriveScoreboardOutcome);
/** Per-column digit pairs for slot-style roll (right-aligned). */ parcelHelpers.export(exports, "scoreboardDigitColumns", ()=>scoreboardDigitColumns);
const CRICKET_COMBINED_INNINGS_SCORE_SEP = " &\u00a0";
function formatCricketCombinedInningsScore(primary, secondary) {
    const p = String(primary ?? "").trim();
    const s = String(secondary ?? "").trim();
    if (!p) return "--";
    if (s && s !== "0/0" && s !== "-") {
        const head = p.split("/")[0] ?? p;
        return `${head}${CRICKET_COMBINED_INNINGS_SCORE_SEP}${s}`;
    }
    return p;
}
function findCombinedInningsSeparator(trimmed) {
    const nbspIdx = trimmed.indexOf(CRICKET_COMBINED_INNINGS_SCORE_SEP);
    if (nbspIdx >= 0) return {
        ampIdx: nbspIdx,
        sepLen: CRICKET_COMBINED_INNINGS_SCORE_SEP.length
    };
    const spaceIdx = trimmed.indexOf(" & ");
    if (spaceIdx >= 0) return {
        ampIdx: spaceIdx,
        sepLen: 3
    };
    return {
        ampIdx: -1,
        sepLen: 0
    };
}
function parseScoreboardDisplayLine(line) {
    const trimmed = String(line ?? "").trim();
    if (!trimmed || trimmed === "-" || trimmed === "--") return null;
    const { ampIdx, sepLen } = findCombinedInningsSeparator(trimmed);
    const activePart = ampIdx >= 0 ? trimmed.slice(ampIdx + sepLen).trim() : trimmed;
    const slashIdx = activePart.indexOf("/");
    if (slashIdx < 0) return null;
    const runs = Number.parseInt(activePart.slice(0, slashIdx), 10);
    const wkts = Number.parseInt(activePart.slice(slashIdx + 1), 10);
    if (!Number.isFinite(runs) || !Number.isFinite(wkts)) return null;
    return {
        runs,
        wkts,
        prefix: ampIdx >= 0 ? `${trimmed.slice(0, ampIdx + 2)}${"\u00a0"}` : "",
        activePart
    };
}
function deriveScoreboardOutcome(prev, next) {
    if (!prev || !next) return null;
    const runsDelta = next.runs - prev.runs;
    const wktsDelta = next.wkts - prev.wkts;
    if (runsDelta <= 0 && wktsDelta <= 0) return null;
    let bubbleLabel = null;
    if (runsDelta > 0) bubbleLabel = `+${runsDelta} RUN${runsDelta === 1 ? "" : "S"}`;
    else if (wktsDelta > 0) bubbleLabel = wktsDelta === 1 ? "WICKET" : `${wktsDelta} WICKETS`;
    if (!bubbleLabel) return null;
    return {
        bubbleLabel,
        runsDelta,
        wktsDelta,
        rollRuns: runsDelta > 0,
        rollWkts: wktsDelta > 0
    };
}
function scoreboardDigitColumns(from, to) {
    const fromStr = String(from);
    const toStr = String(to);
    const len = Math.max(fromStr.length, toStr.length);
    const cols = [];
    for(let i = 0; i < len; i += 1){
        const fromIdx = i - (len - fromStr.length);
        const toIdx = i - (len - toStr.length);
        const fromCh = fromIdx >= 0 ? fromStr[fromIdx] : null;
        const toCh = toStr[toIdx];
        cols.push({
            from: fromCh,
            to: toCh,
            animate: fromCh !== toCh
        });
    }
    return cols;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"69hMh":[function(require,module,exports,__globalThis) {
/**
 * Short label for Bullion UI (e.g. "Kolkata Knight Riders" → "KKR", "Gujarat Titans" → "GT").
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bullionTeamAbbreviation", ()=>bullionTeamAbbreviation);
function bullionTeamAbbreviation(teamName) {
    const words = String(teamName || "").trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return "";
    if (words.length === 1) return words[0].replace(/[^A-Za-z0-9]/g, "").slice(0, 3).toUpperCase();
    return words.map((w)=>w.replace(/[^A-Za-z0-9]/g, "")).filter(Boolean).map((w)=>w[0]).join("").slice(0, 3).toUpperCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7c4Rs":[function(require,module,exports,__globalThis) {
/**
 * Map scoreboard / market short labels (e.g. KKR, IND) to full franchise names used for
 * cricket logo / headshot lookups, using fixture title teams as the candidate pool.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveCricketTeamNameForLogo", ()=>resolveCricketTeamNameForLogo);
function normalizeTeamKey(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}
function cricketTeamAbbreviation(teamName) {
    const words = String(teamName || "").trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return "";
    if (words.length === 1) return words[0].replace(/[^A-Za-z0-9]/g, "").slice(0, 3).toUpperCase();
    return words.map((w)=>w.replace(/[^A-Za-z0-9]/g, "")).filter(Boolean).map((w)=>w[0]).join("").slice(0, 3).toUpperCase();
}
function abbrevAppearsAsDistinctToken(text, abbr) {
    const a = String(abbr || "").trim();
    if (a.length < 2) return false;
    const escaped = a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    try {
        return new RegExp(`\\b${escaped}\\b`, "i").test(String(text || ""));
    } catch  {
        return false;
    }
}
function resolveCricketTeamNameForLogo(label, candidatePool) {
    const raw = String(label ?? "").trim();
    if (!raw) return "";
    const pool = (candidatePool || []).map((t)=>String(t ?? "").trim()).filter(Boolean);
    if (pool.length === 0) return raw;
    for (const cand of pool){
        if (raw === cand) return cand;
        if (raw.toLowerCase() === cand.toLowerCase()) return cand;
    }
    const rawKey = normalizeTeamKey(raw);
    for (const cand of pool){
        const candKey = normalizeTeamKey(cand);
        if (!rawKey || !candKey) continue;
        if (rawKey === candKey) return cand;
        if (rawKey.includes(candKey) || candKey.includes(rawKey)) return cand;
    }
    const rawUpper = raw.toUpperCase();
    for (const cand of pool){
        const abbr = cricketTeamAbbreviation(cand);
        if (abbr.length >= 2 && (rawUpper === abbr || abbrevAppearsAsDistinctToken(raw, abbr))) return cand;
    }
    return raw;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9NhAM":[function(require,module,exports,__globalThis) {
/** Shared compact match-card tokens (Matches page / compact hub layout). */ /** Fixed compact card shell — header 42 + body 121 (60+1+60) + footer 60 = 223px. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_CARD_HEIGHT_PX", ()=>MATCH_CARD_COMPACT_CARD_HEIGHT_PX);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_HEADER_HEIGHT_PX", ()=>MATCH_CARD_COMPACT_HEADER_HEIGHT_PX);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_BODY_HEIGHT_PX", ()=>MATCH_CARD_COMPACT_BODY_HEIGHT_PX);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_BODY_SIZE_CLASS", ()=>MATCH_CARD_COMPACT_BODY_SIZE_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_FOOTER_HEIGHT_PX", ()=>MATCH_CARD_COMPACT_FOOTER_HEIGHT_PX);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_CARD_SIZE_CLASS", ()=>MATCH_CARD_COMPACT_CARD_SIZE_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_HORSE_BODY_HEIGHT_PX", ()=>MATCH_CARD_COMPACT_HORSE_BODY_HEIGHT_PX);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_HORSE_BODY_SIZE_CLASS", ()=>MATCH_CARD_COMPACT_HORSE_BODY_SIZE_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_HORSE_CARD_HEIGHT_PX", ()=>MATCH_CARD_COMPACT_HORSE_CARD_HEIGHT_PX);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_HORSE_CARD_SIZE_CLASS", ()=>MATCH_CARD_COMPACT_HORSE_CARD_SIZE_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_HEADER_ROW_CLASS", ()=>MATCH_CARD_COMPACT_HEADER_ROW_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_SPORT_ICON_WRAP_CLASS", ()=>MATCH_CARD_COMPACT_SPORT_ICON_WRAP_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_SPORT_ICON_SIZE_CLASS", ()=>MATCH_CARD_COMPACT_SPORT_ICON_SIZE_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_COUNTRY_FLAG_CLASS", ()=>MATCH_CARD_COMPACT_COUNTRY_FLAG_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_HEADER_COMPETITION_TEXT_CLASS", ()=>MATCH_CARD_COMPACT_HEADER_COMPETITION_TEXT_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_STATUS_WRAP_CLASS", ()=>MATCH_CARD_COMPACT_STATUS_WRAP_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_STATUS_TEXT_CLASS", ()=>MATCH_CARD_COMPACT_STATUS_TEXT_CLASS);
/**
 * User-facing match status copy (ads / compliance): keep internal tokens as IN-PLAY /
 * BREAK IN PLAY for logic; map only at display time.
 * Horses live status → RACE LIVE; other sports → MATCH LIVE.
 */ parcelHelpers.export(exports, "formatMatchStatusForDisplay", ()=>formatMatchStatusForDisplay);
/** Matches hub header — live status reads as MATCH LIVE; keep other labels as-is. */ parcelHelpers.export(exports, "formatCompactMatchCardStatusText", ()=>formatCompactMatchCardStatusText);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_STATUS_SENTENCE_CLASS", ()=>MATCH_CARD_COMPACT_STATUS_SENTENCE_CLASS);
parcelHelpers.export(exports, "isFootballUpcomingListStatus", ()=>isFootballUpcomingListStatus);
parcelHelpers.export(exports, "isCompactMatchCardStartsInStatus", ()=>isCompactMatchCardStartsInStatus);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_STARTS_IN_STATUS_CLASS", ()=>MATCH_CARD_COMPACT_STARTS_IN_STATUS_CLASS);
/** Football listings — sentence-case “Starts in 3h 40m” / “in 1m” / “Starting soon”. */ parcelHelpers.export(exports, "formatFootballListCardStatusText", ()=>formatFootballListCardStatusText);
parcelHelpers.export(exports, "CRICKET_MATCH_FINISHED_STATUS_LABEL", ()=>CRICKET_MATCH_FINISHED_STATUS_LABEL);
parcelHelpers.export(exports, "CRICKET_MATCH_FINISHED_STATUS_TEXT_CLASS", ()=>CRICKET_MATCH_FINISHED_STATUS_TEXT_CLASS);
parcelHelpers.export(exports, "CRICKET_MATCH_FINISHED_STATUS_CLASS", ()=>CRICKET_MATCH_FINISHED_STATUS_CLASS);
parcelHelpers.export(exports, "CRICKET_MATCH_RESULT_COMMENT_CLASS", ()=>CRICKET_MATCH_RESULT_COMMENT_CLASS);
/** Sentence case for ALL CAPS feed labels; mixed-case comments are left as-is. */ parcelHelpers.export(exports, "formatCricketSentenceCase", ()=>formatCricketSentenceCase);
/** Title-case competition / tournament labels from feed data (any uniform casing → readable). */ parcelHelpers.export(exports, "formatCompetitionDisplayName", ()=>formatCompetitionDisplayName);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_TEAM_ROW_CLASS", ()=>MATCH_CARD_COMPACT_TEAM_ROW_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_LOGO_BOX_CLASS", ()=>MATCH_CARD_COMPACT_LOGO_BOX_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_LOGO_SIZE", ()=>MATCH_CARD_COMPACT_LOGO_SIZE);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_TEAM_NAME_CLASS", ()=>MATCH_CARD_COMPACT_TEAM_NAME_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_SCORE_CLASS", ()=>MATCH_CARD_COMPACT_SCORE_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_SCORE_MUTED_CLASS", ()=>MATCH_CARD_COMPACT_SCORE_MUTED_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_FOOTER_ROW_CLASS", ()=>MATCH_CARD_COMPACT_FOOTER_ROW_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_FOOTER_PLAY_ROW_CLASS", ()=>MATCH_CARD_COMPACT_FOOTER_PLAY_ROW_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_PLAY_LABEL_CLASS", ()=>MATCH_CARD_COMPACT_PLAY_LABEL_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_GAME_CHIP_CLASS", ()=>MATCH_CARD_COMPACT_GAME_CHIP_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_GAME_CHIP_ICON_ONLY_CLASS", ()=>MATCH_CARD_COMPACT_GAME_CHIP_ICON_ONLY_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_GAME_CHIP_LABEL_CLASS", ()=>MATCH_CARD_COMPACT_GAME_CHIP_LABEL_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_GAME_ICON_CLASS", ()=>MATCH_CARD_COMPACT_GAME_ICON_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_WATCH_LIVE_CLASS", ()=>MATCH_CARD_COMPACT_WATCH_LIVE_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_WATCH_LIVE_ICON_ONLY_CLASS", ()=>MATCH_CARD_COMPACT_WATCH_LIVE_ICON_ONLY_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_WATCH_LIVE_HEADER_CLASS", ()=>MATCH_CARD_COMPACT_WATCH_LIVE_HEADER_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_MATCH_CTA_WRAP_CLASS", ()=>MATCH_CARD_COMPACT_MATCH_CTA_WRAP_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_MATCH_CTA_LABEL_CLASS", ()=>MATCH_CARD_COMPACT_MATCH_CTA_LABEL_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_MATCH_CTA_SIZE_CLASS", ()=>MATCH_CARD_COMPACT_MATCH_CTA_SIZE_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_MATCH_CTA_CLASS", ()=>MATCH_CARD_COMPACT_MATCH_CTA_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_HORSE_RACE_DETAILS_WRAP_CLASS", ()=>MATCH_CARD_COMPACT_HORSE_RACE_DETAILS_WRAP_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_HORSE_RACE_DETAILS_TEXT_CLASS", ()=>MATCH_CARD_COMPACT_HORSE_RACE_DETAILS_TEXT_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_RESULT_COMMENT_WRAP_CLASS", ()=>MATCH_CARD_COMPACT_RESULT_COMMENT_WRAP_CLASS);
parcelHelpers.export(exports, "MATCH_CARD_COMPACT_RESULT_COMMENT_TEXT_CLASS", ()=>MATCH_CARD_COMPACT_RESULT_COMMENT_TEXT_CLASS);
const MATCH_CARD_COMPACT_CARD_HEIGHT_PX = 223;
const MATCH_CARD_COMPACT_HEADER_HEIGHT_PX = 42;
const MATCH_CARD_COMPACT_BODY_HEIGHT_PX = 121;
const MATCH_CARD_COMPACT_BODY_SIZE_CLASS = "h-[121px] min-h-[121px] max-h-[121px]";
const MATCH_CARD_COMPACT_FOOTER_HEIGHT_PX = 60;
const MATCH_CARD_COMPACT_CARD_SIZE_CLASS = "h-[223px] min-h-[223px] max-h-[223px]";
const MATCH_CARD_COMPACT_HORSE_BODY_HEIGHT_PX = 61;
const MATCH_CARD_COMPACT_HORSE_BODY_SIZE_CLASS = "h-[61px] min-h-[61px] max-h-[61px]";
const MATCH_CARD_COMPACT_HORSE_CARD_HEIGHT_PX = 163;
const MATCH_CARD_COMPACT_HORSE_CARD_SIZE_CLASS = "h-[163px] min-h-[163px] max-h-[163px]";
const MATCH_CARD_COMPACT_HEADER_ROW_CLASS = "flex h-[42px] min-h-[42px] max-h-[42px] items-stretch justify-between gap-2";
const MATCH_CARD_COMPACT_SPORT_ICON_WRAP_CLASS = "flex min-w-0 flex-1 items-center gap-1.5 pl-2";
const MATCH_CARD_COMPACT_SPORT_ICON_SIZE_CLASS = "h-[21px] w-[21px] shrink-0";
const MATCH_CARD_COMPACT_COUNTRY_FLAG_CLASS = "flex shrink-0 items-center text-[18px] leading-none";
const MATCH_CARD_COMPACT_HEADER_COMPETITION_TEXT_CLASS = "min-w-0 flex-1 truncate font-chakra text-[12px] font-normal leading-none tracking-normal normal-case text-white";
const MATCH_CARD_COMPACT_STATUS_WRAP_CLASS = "flex flex-shrink-0 items-center gap-1.5 pl-2 pr-3";
const MATCH_CARD_COMPACT_STATUS_TEXT_CLASS = "whitespace-nowrap text-right font-chakra text-[12px] font-normal uppercase leading-[100%] tracking-normal";
function formatMatchStatusForDisplay(text, options) {
    const trimmed = String(text ?? "").trim();
    if (!trimmed) return trimmed;
    const upper = trimmed.toUpperCase();
    const sport = String(options?.sport ?? "").toLowerCase();
    const isHorses = sport === "horses" || sport === "horse" || sport === "racing";
    if (upper === "RACING" || upper === "RUNNING") return "RACE LIVE";
    if (upper === "IN-PLAY" || upper === "IN PLAY") return isHorses ? "RACE LIVE" : "MATCH LIVE";
    const inPlayPrefix = /^(in[-\s]?play)\b/i;
    if (inPlayPrefix.test(trimmed) && !upper.startsWith("BREAK IN PLAY")) {
        const rest = trimmed.replace(inPlayPrefix, "").trim();
        const live = isHorses ? "RACE LIVE" : "MATCH LIVE";
        return rest ? `${live} ${rest}` : live;
    }
    if (upper.startsWith("BREAK IN PLAY")) return trimmed.replace(/break\s+in\s+play/gi, "MATCH BREAK");
    return trimmed;
}
function formatCompactMatchCardStatusText(text) {
    const trimmed = text.trim();
    if (!trimmed) return trimmed;
    return formatMatchStatusForDisplay(trimmed);
}
const MATCH_CARD_COMPACT_STATUS_SENTENCE_CLASS = "whitespace-nowrap text-right font-chakra text-[12px] font-normal normal-case leading-[100%] tracking-normal";
function isFootballUpcomingListStatus(text) {
    const normalized = text.trim().toUpperCase();
    return normalized.startsWith("STARTS IN ") || normalized.startsWith("IN ") || normalized === "STARTING SOON";
}
function isCompactMatchCardStartsInStatus(text) {
    const normalized = text.trim().toUpperCase();
    return normalized.startsWith("STARTS IN ") || /^IN\s+\d/.test(normalized);
}
const MATCH_CARD_COMPACT_STARTS_IN_STATUS_CLASS = "text-[#32F78D]";
function formatFootballListCardStatusText(text) {
    const trimmed = text.trim();
    if (!trimmed) return trimmed;
    if (trimmed.toUpperCase() === "IN-PLAY" || trimmed.toUpperCase() === "IN PLAY") return "MATCH LIVE";
    if (trimmed.toUpperCase().startsWith("STARTS IN ")) return `Starts in ${trimmed.slice(10)}`;
    if (/^in\s+/i.test(trimmed)) return trimmed.replace(/^in\s+/i, "in ");
    if (trimmed.toUpperCase() === "STARTING SOON") return "Starting soon";
    return formatCompactMatchCardStatusText(trimmed);
}
const CRICKET_MATCH_FINISHED_STATUS_LABEL = "Finished";
const CRICKET_MATCH_FINISHED_STATUS_TEXT_CLASS = "align-middle font-chakra text-[12px] font-normal not-italic normal-case leading-[100%] tracking-[0] text-[#32F78D] [leading-trim:none]";
const CRICKET_MATCH_FINISHED_STATUS_CLASS = `whitespace-nowrap text-right ${CRICKET_MATCH_FINISHED_STATUS_TEXT_CLASS}`;
const CRICKET_MATCH_RESULT_COMMENT_CLASS = CRICKET_MATCH_FINISHED_STATUS_TEXT_CLASS;
function formatCricketSentenceCase(value) {
    const trimmed = value.trim();
    if (!trimmed) return trimmed;
    if (trimmed !== trimmed.toUpperCase()) return trimmed;
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}
function titleCaseWord(word) {
    if (!word) return word;
    return word.split("-").map((part)=>part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : part).join("-");
}
function formatCompetitionDisplayName(value) {
    const trimmed = value.trim();
    if (!trimmed) return trimmed;
    const hasMixedCase = trimmed !== trimmed.toUpperCase() && trimmed !== trimmed.toLowerCase();
    if (hasMixedCase) return trimmed;
    return trimmed.toLowerCase().split(/\s+/).map(titleCaseWord).join(" ");
}
const MATCH_CARD_COMPACT_TEAM_ROW_CLASS = "flex h-[60px] min-h-[60px] max-h-[60px] items-center justify-between bg-white pl-0 pr-2.5";
const MATCH_CARD_COMPACT_LOGO_BOX_CLASS = "flex h-[60px] w-[60px] min-h-[60px] min-w-[60px] flex-shrink-0 items-center justify-center";
const MATCH_CARD_COMPACT_LOGO_SIZE = "48px";
const MATCH_CARD_COMPACT_TEAM_NAME_CLASS = "min-w-0 flex-1 truncate align-middle font-anton text-[20px] font-normal not-italic uppercase leading-[100%] tracking-[0] [leading-trim:none] text-main";
const MATCH_CARD_COMPACT_SCORE_CLASS = "min-w-[36px] text-right align-middle font-chakra text-[18px] font-normal not-italic leading-[100%] tracking-[0] [leading-trim:none] text-main";
const MATCH_CARD_COMPACT_SCORE_MUTED_CLASS = "text-right font-chakra text-[11px] font-normal leading-[100%] text-main/60";
const MATCH_CARD_COMPACT_FOOTER_ROW_CLASS = "flex h-[60px] min-h-[60px] max-h-[60px] items-stretch border-t border-main60";
const MATCH_CARD_COMPACT_FOOTER_PLAY_ROW_CLASS = "flex min-w-0 flex-1 items-center gap-1 overflow-x-auto hide-scrollbar py-0 pl-2.5 pr-0.5";
const MATCH_CARD_COMPACT_PLAY_LABEL_CLASS = "mr-1.5 shrink-0 align-middle font-anton text-[11px] font-normal not-italic uppercase leading-[9px] tracking-[0] [leading-trim:none] text-white/85";
const MATCH_CARD_COMPACT_GAME_CHIP_CLASS = "flex h-[40px] min-h-[40px] max-h-[40px] min-w-0 flex-shrink-0 items-center gap-1 bg-[#1B062F]/40 px-2 transition-colors hover:bg-[#1B062F]/55";
const MATCH_CARD_COMPACT_GAME_CHIP_ICON_ONLY_CLASS = "flex h-[40px] w-[40px] min-h-[40px] max-h-[40px] min-w-[40px] max-w-[40px] flex-shrink-0 items-center justify-center bg-[#1B062F]/40 transition-colors hover:bg-[#1B062F]/55";
const MATCH_CARD_COMPACT_GAME_CHIP_LABEL_CLASS = "align-middle font-anton text-[11px] font-normal not-italic uppercase leading-[9px] tracking-[0] [leading-trim:none] text-white";
const MATCH_CARD_COMPACT_GAME_ICON_CLASS = "h-[30px] w-[30px] min-h-[30px] min-w-[30px] max-h-[30px] max-w-[30px] shrink-0 object-contain";
const MATCH_CARD_COMPACT_WATCH_LIVE_CLASS = "flex h-[26px] min-h-[26px] max-h-[26px] flex-shrink-0 items-center border border-pink bg-transparent px-1.5 font-anton text-[11px] font-normal uppercase leading-[9px] tracking-normal text-pink transition-opacity hover:opacity-90";
const MATCH_CARD_COMPACT_WATCH_LIVE_ICON_ONLY_CLASS = "flex h-[40px] w-[40px] min-h-[40px] max-h-[40px] min-w-[40px] max-w-[40px] flex-shrink-0 items-center justify-center border border-pink bg-transparent text-pink transition-opacity hover:opacity-90";
const MATCH_CARD_COMPACT_WATCH_LIVE_HEADER_CLASS = "box-border flex h-[26px] min-h-[26px] max-h-[26px] shrink-0 items-center justify-center bg-[#F73261] px-1.5 text-center align-middle font-anton text-[11px] font-normal not-italic uppercase leading-[9px] tracking-[0] text-white transition-opacity hover:opacity-90";
const MATCH_CARD_COMPACT_MATCH_CTA_WRAP_CLASS = "flex min-w-[60px] flex-shrink-0 flex-col items-center justify-center self-stretch pl-0 pr-2";
const MATCH_CARD_COMPACT_MATCH_CTA_LABEL_CLASS = "text-center align-middle font-anton text-[16px] font-normal not-italic uppercase leading-[18px] tracking-[0] [leading-trim:none] text-main";
const MATCH_CARD_COMPACT_MATCH_CTA_SIZE_CLASS = "box-border flex h-[40px] w-[60px] min-h-[40px] max-h-[40px] min-w-[60px] max-w-[60px] shrink-0 items-center justify-center p-0";
const MATCH_CARD_COMPACT_MATCH_CTA_CLASS = `${MATCH_CARD_COMPACT_MATCH_CTA_SIZE_CLASS} bg-lime transition-colors hover:bg-limehover ${MATCH_CARD_COMPACT_MATCH_CTA_LABEL_CLASS}`;
const MATCH_CARD_COMPACT_HORSE_RACE_DETAILS_WRAP_CLASS = "flex min-w-0 max-w-[min(52vw,220px)] flex-shrink items-center self-stretch pr-1";
const MATCH_CARD_COMPACT_HORSE_RACE_DETAILS_TEXT_CLASS = "min-w-0 truncate font-chakra text-[10px] font-normal normal-case leading-[100%] tracking-normal text-white/75";
const MATCH_CARD_COMPACT_RESULT_COMMENT_WRAP_CLASS = "flex min-w-0 flex-1 items-center self-stretch overflow-hidden pl-2.5 pr-1";
const MATCH_CARD_COMPACT_RESULT_COMMENT_TEXT_CLASS = "min-w-0 truncate text-left align-middle font-chakra text-[12px] font-normal not-italic normal-case leading-[16px] tracking-[0] text-[#32F78D]";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c46Rx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FOOTER_JUICE_ORDER", ()=>FOOTER_JUICE_ORDER);
parcelHelpers.export(exports, "sortFooterJuiceKeys", ()=>sortFooterJuiceKeys);
parcelHelpers.export(exports, "footerStatsIncreased", ()=>footerStatsIncreased);
parcelHelpers.export(exports, "isCellWon", ()=>isCellWon);
parcelHelpers.export(exports, "bucketsMapFromMarketCells", ()=>bucketsMapFromMarketCells);
parcelHelpers.export(exports, "uniformBucketOnLine", ()=>uniformBucketOnLine);
/** Market-cell indices that belong to a bucket, for the current (generated) card. */ parcelHelpers.export(exports, "bucketCellIndices", ()=>bucketCellIndices);
parcelHelpers.export(exports, "bucketWonCellIndices", ()=>bucketWonCellIndices);
parcelHelpers.export(exports, "bucketWonCount", ()=>bucketWonCount);
parcelHelpers.export(exports, "isBucketSlideReady", ()=>(0, _sixesMovement.isBucketSlideReady));
/** Buckets to mark celebrated/applied when a slide animation runs (merged runs → both sides). */ parcelHelpers.export(exports, "slideCelebrationBuckets", ()=>slideCelebrationBuckets);
parcelHelpers.export(exports, "findNewlySlideReadyBuckets", ()=>findNewlySlideReadyBuckets);
/**
 * Buckets that are slide-ready right now and have not yet been animated/snapped this session.
 *
 * Unlike {@link findNewlySlideReadyBuckets}, this does NOT require the bucket to have *just* crossed
 * the threshold between two snapshots — a set is built whenever all of a bucket's cells are won (per
 * the slide threshold), regardless of the order or which poll each cell settled in. The
 * celebrated / applied / pending sets are the dedup, so a bucket animates exactly once.
 */ parcelHelpers.export(exports, "findUnshownSlideReadyBuckets", ()=>findUnshownSlideReadyBuckets);
parcelHelpers.export(exports, "bucketWonIndicesOverlapCelebratedLine", ()=>bucketWonIndicesOverlapCelebratedLine);
/** Buckets whose slide layout should be restored (slide threshold met, not yet applied this session). */ parcelHelpers.export(exports, "bucketsNeedingPersistedSlideRestore", ()=>bucketsNeedingPersistedSlideRestore);
parcelHelpers.export(exports, "bucketPendingSiblingIndices", ()=>bucketPendingSiblingIndices);
/**
 * Travel from one grid slot to another, in whole tracks. Deliberately resolution-independent: the
 * board's track size changes with the viewport, so offsets are turned into pixels by the browser at
 * paint time (see {@link sixesSlideTransform}) instead of being measured off the grid mid-slide.
 */ parcelHelpers.export(exports, "slideSwapDelta", ()=>slideSwapDelta);
/** Apply swap pairs onto a running offset map (same math as the animated slide celebration). */ parcelHelpers.export(exports, "accumulateSlideOffsetsFromSwaps", ()=>accumulateSlideOffsetsFromSwaps);
/**
 * Absolute-from-home offsets for the *net permutation* of a composed movement plan.
 *
 * A plan's swaps form a single conflict-free permutation of slots. Replaying them on an identity
 * array yields `order[slot] = the home cell that ends up at that slot`; each home cell then gets one
 * offset (home → its final slot). This composes correctly across any number of buckets — unlike
 * per-bucket bidirectional swaps, where a slot that is both a mover and a displaced occupant would
 * clobber itself (last write wins) and break the line.
 */ parcelHelpers.export(exports, "offsetsFromPlanPermutation", ()=>offsetsFromPlanPermutation);
/**
 * Validate + type the server-persisted `line_claims` JSON into a `SixesMovementPlan`. Returns null
 * for anything malformed so the caller can fall back to a local (server-consistent) recompute.
 */ parcelHelpers.export(exports, "parseServerMovementPlan", ()=>parseServerMovementPlan);
parcelHelpers.export(exports, "promoteBucketToGreen", ()=>promoteBucketToGreen);
parcelHelpers.export(exports, "promoteAllCompletedBuckets", ()=>promoteAllCompletedBuckets);
/** Fully-settled outcomes for a generated card (wins promoted to green where a bucket completes). */ parcelHelpers.export(exports, "buildSettledCellOutcomes", ()=>buildSettledCellOutcomes);
parcelHelpers.export(exports, "settledFooterStats", ()=>settledFooterStats);
var _sixesMarketBucket = require("./sixesMarketBucket");
var _sixesLiveData = require("./sixesLiveData");
var _sixesGridLayout = require("./sixesGridLayout");
var _sixesMovement = require("./sixesMovement");
var _sixesPrizeCounts = require("./sixesPrizeCounts");
const FOOTER_JUICE_ORDER = [
    "wins",
    "slides",
    "natural",
    "multiplier",
    "coins"
];
function sortFooterJuiceKeys(keys) {
    const set = new Set(keys);
    return FOOTER_JUICE_ORDER.filter((key)=>set.has(key));
}
function footerStatsIncreased(prev, next) {
    const juice = [];
    if (next.wins > prev.wins) juice.push("wins");
    if (next.slides > prev.slides) juice.push("slides");
    if (next.natural > prev.natural) juice.push("natural");
    if (next.multiplierSixes > prev.multiplierSixes) juice.push("multiplier");
    if (next.coins > prev.coins) juice.push("coins");
    return sortFooterJuiceKeys(juice);
}
function isCellWon(outcome) {
    return (0, _sixesLiveData.isSixesCellWon)(outcome);
}
function bucketsMapFromMarketCells(cells) {
    return cells.map((c)=>c.bucket);
}
function uniformBucketOnLine(line, buckets) {
    let bucket = null;
    for (const idx of line){
        const b = buckets[idx];
        if (!b) return null;
        if (bucket == null) bucket = b;
        else if (bucket !== b) return null;
    }
    return bucket;
}
function bucketCellIndices(buckets, bucket) {
    const out = [];
    buckets.forEach((b, i)=>{
        if (b === bucket) out.push(i);
    });
    return out;
}
function bucketWonCellIndices(buckets, outcomes, bucket) {
    if ((0, _sixesMovement.bothRunsBucketsOnCard)(buckets) && bucket === (0, _sixesMovement.SIXES_MERGED_RUNS_SLIDE_BUCKET)) return (0, _sixesMovement.mergedRunsWonCellIndices)(buckets, outcomes);
    if ((0, _sixesMovement.bothPlayerBucketsOnCard)(buckets) && bucket === (0, _sixesMovement.SIXES_MERGED_PLAYER_SLIDE_BUCKET)) return (0, _sixesMovement.mergedPlayerWonCellIndices)(buckets, outcomes);
    return bucketCellIndices(buckets, bucket).filter((idx)=>isCellWon(outcomes[idx] ?? "pending"));
}
function bucketWonCount(buckets, outcomes, bucket) {
    return bucketWonCellIndices(buckets, outcomes, bucket).length;
}
function slideCelebrationBuckets(buckets, bucket) {
    if ((0, _sixesMovement.bothRunsBucketsOnCard)(buckets) && bucket === (0, _sixesMovement.SIXES_MERGED_RUNS_SLIDE_BUCKET)) return [
        "team_a_runs",
        "team_b_runs"
    ];
    if ((0, _sixesMovement.bothPlayerBucketsOnCard)(buckets) && bucket === (0, _sixesMovement.SIXES_MERGED_PLAYER_SLIDE_BUCKET)) return [
        "team_a_player",
        "team_b_player"
    ];
    return [
        bucket
    ];
}
function findNewlySlideReadyBuckets(buckets, prev, next, celebrated) {
    return (0, _sixesMarketBucket.SIXES_BUCKETS).filter((b)=>!celebrated.has(b) && !(0, _sixesMovement.isBucketSlideReady)(buckets, prev, b) && (0, _sixesMovement.isBucketSlideReady)(buckets, next, b));
}
function findUnshownSlideReadyBuckets(buckets, outcomes, celebrated, layoutApplied, pendingAnimation) {
    return (0, _sixesMarketBucket.SIXES_BUCKETS).filter((b)=>!celebrated.has(b) && !layoutApplied.has(b) && !pendingAnimation.has(b) && (0, _sixesMovement.isBucketSlideReady)(buckets, outcomes, b));
}
function bucketWonIndicesOverlapCelebratedLine(wonIndices, skipIfLineCelebrated) {
    return skipIfLineCelebrated.some((line)=>line.length === wonIndices.length && wonIndices.every((idx)=>line.includes(idx)));
}
function bucketsNeedingPersistedSlideRestore(bucketsMap, outcomes, celebratedBuckets, layoutApplied, pendingAnimation, skipIfLineCelebrated, restoreAllCompleted) {
    return (0, _sixesMarketBucket.SIXES_BUCKETS).filter((bucket)=>{
        if (layoutApplied.has(bucket)) return false;
        if (pendingAnimation.has(bucket)) return false;
        if (!restoreAllCompleted && !celebratedBuckets.has(bucket)) return false;
        if (!(0, _sixesMovement.isBucketSlideReady)(bucketsMap, outcomes, bucket)) return false;
        const wonIndices = bucketWonCellIndices(bucketsMap, outcomes, bucket);
        if (bucketWonIndicesOverlapCelebratedLine(wonIndices, skipIfLineCelebrated)) return false;
        return true;
    });
}
function bucketPendingSiblingIndices(buckets, outcomes, wonCellIndex) {
    const bucket = buckets[wonCellIndex];
    if (!bucket) return [];
    return bucketCellIndices(buckets, bucket).filter((idx)=>{
        if (idx === wonCellIndex) return false;
        return (outcomes[idx] ?? "pending") === "pending";
    });
}
function slideSwapDelta(fromIdx, toIdx) {
    const from = (0, _sixesGridLayout.marketCellGridPosition)(fromIdx);
    const to = (0, _sixesGridLayout.marketCellGridPosition)(toIdx);
    return {
        dCol: to.col - from.col,
        dRow: to.row - from.row
    };
}
function accumulateSlideOffsetsFromSwaps(swaps, baseOffsets) {
    const offsets = {
        ...baseOffsets
    };
    const movers = [];
    for (const { from, to } of swaps){
        offsets[from] = slideSwapDelta(from, to);
        if (!movers.includes(from)) movers.push(from);
    }
    return {
        offsets,
        movers
    };
}
function offsetsFromPlanPermutation(planSwaps) {
    const identity = Array.from({
        length: (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT)
    }, (_, i)=>i);
    const order = (0, _sixesMovement.applySixesSwaps)(identity, planSwaps); // order[slot] = home cell now at slot
    const offsets = {};
    const movers = [];
    order.forEach((home, slot)=>{
        if (home === slot) return;
        offsets[home] = slideSwapDelta(home, slot);
        movers.push(home);
    });
    return {
        offsets,
        movers,
        order
    };
}
const SIXES_VALID_LINE_IDS = new Set(Object.keys((0, _sixesMovement.SIXES_LINE_TARGETS)));
const SIXES_VALID_CLAIM_KINDS = new Set([
    "four_draw",
    "six_draw_row",
    "six_draw_col"
]);
function parseServerMovementPlan(raw) {
    if (!raw || typeof raw !== "object") return null;
    const obj = raw;
    if (!Array.isArray(obj.claims)) return null;
    const claims = [];
    for (const entry of obj.claims){
        if (!entry || typeof entry !== "object") return null;
        const c = entry;
        if (typeof c.bucket !== "string") return null;
        if (typeof c.lineId !== "string" || !SIXES_VALID_LINE_IDS.has(c.lineId)) return null;
        if (typeof c.kind !== "string" || !SIXES_VALID_CLAIM_KINDS.has(c.kind)) return null;
        if (typeof c.rank !== "number") return null;
        if (!Array.isArray(c.swaps)) return null;
        const swaps = [];
        for (const s of c.swaps){
            if (!s || typeof s !== "object") return null;
            const sw = s;
            if (typeof sw.from !== "number" || typeof sw.to !== "number") return null;
            swaps.push({
                from: sw.from,
                to: sw.to
            });
        }
        claims.push({
            bucket: c.bucket,
            lineId: c.lineId,
            kind: c.kind,
            rank: c.rank,
            swaps
        });
    }
    return {
        claims,
        jackpot: Boolean(obj.jackpot)
    };
}
function promoteBucketToGreen(buckets, outcomes, bucket) {
    let next = [
        ...outcomes
    ];
    const bucketsToPromote = (0, _sixesMovement.bothRunsBucketsOnCard)(buckets) && bucket === (0, _sixesMovement.SIXES_MERGED_RUNS_SLIDE_BUCKET) ? [
        "team_a_runs",
        "team_b_runs"
    ] : (0, _sixesMovement.bothPlayerBucketsOnCard)(buckets) && bucket === (0, _sixesMovement.SIXES_MERGED_PLAYER_SLIDE_BUCKET) ? [
        "team_a_player",
        "team_b_player"
    ] : [
        bucket
    ];
    for (const b of bucketsToPromote){
        for (const idx of bucketCellIndices(buckets, b))if (next[idx] === "win-pink") next[idx] = "win-green";
    }
    return next;
}
function promoteAllCompletedBuckets(buckets, outcomes) {
    let next = [
        ...outcomes
    ];
    for (const b of (0, _sixesMarketBucket.SIXES_BUCKETS))if ((0, _sixesMovement.isBucketSlideReady)(buckets, next, b)) next = promoteBucketToGreen(buckets, next, b);
    return next;
}
function buildSettledCellOutcomes(card) {
    const resolved = card.buckets.map(()=>"lost");
    for (const idx of card.winningIndices)resolved[idx] = "win-pink";
    return promoteAllCompletedBuckets(card.buckets, resolved);
}
function settledFooterStats(card) {
    const outcomes = buildSettledCellOutcomes(card);
    const { slidesCount, naturalCount } = (0, _sixesPrizeCounts.countSixesPrizeCategories)(card.buckets, outcomes);
    return {
        wins: card.winningIndices.length,
        coins: card.coinPayouts.reduce((sum, n)=>sum + n, 0),
        slides: slidesCount,
        natural: naturalCount
    };
}

},{"./sixesMarketBucket":"87iM1","./sixesLiveData":"jPlrt","./sixesGridLayout":"EvkJs","./sixesMovement":"6GIBc","./sixesPrizeCounts":"3msMr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3msMr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Slide and natural line win counts — mirrors backend `countSixesPrizeCategories`.
 */ parcelHelpers.export(exports, "countSixesPrizeCategories", ()=>countSixesPrizeCategories);
var _sixesLiveData = require("./sixesLiveData");
var _sixesMovement = require("./sixesMovement");
/** Movement-plan line id → card-line key — mirrors backend `SIXES_LINE_ID_TO_CARD_KEY`. */ const SIXES_LINE_ID_TO_CARD_KEY = {
    COL2: "col:2",
    COL3: "col:3",
    COL0_FULL: "col:0",
    COL5_FULL: "col:5",
    ROW2: "row:2",
    ROW3: "row:3",
    DIAG_TLBR: "diag:0",
    DIAG_TRBL: "diag:1"
};
const LINE_KEYS_BY_DEFINITION = [
    ...Array.from({
        length: 6
    }, (_, row)=>`row:${row}`),
    ...Array.from({
        length: 6
    }, (_, col)=>`col:${col}`),
    "diag:0",
    "diag:1"
];
function completedLineKeys(outcomes) {
    const keys = new Set();
    const lines = (0, _sixesLiveData.sixesCardLineIndices)();
    for(let i = 0; i < lines.length; i += 1){
        const line = lines[i];
        const key = LINE_KEYS_BY_DEFINITION[i];
        if (key && line.length >= 2 && line.every((idx)=>(0, _sixesLiveData.isSixesCellWon)(outcomes[idx] ?? "pending"))) keys.add(key);
    }
    return keys;
}
function countSixesPrizeCategories(buckets, outcomes) {
    const plan = (0, _sixesMovement.buildSixesMovementPlan)(buckets, outcomes);
    const slidLineKeys = new Set();
    let slidesCount = 0;
    for (const claim of plan.claims){
        slidesCount += 1;
        const key = SIXES_LINE_ID_TO_CARD_KEY[claim.lineId];
        if (key) slidLineKeys.add(key);
    }
    const wonInPlaceKeys = completedLineKeys(outcomes);
    const postSlideOutcomes = (0, _sixesMovement.applySixesSwaps)(outcomes, (0, _sixesMovement.movementPlanSwaps)(plan));
    const naturalKeys = new Set();
    for (const key of wonInPlaceKeys)if (!slidLineKeys.has(key)) naturalKeys.add(key);
    for (const key of completedLineKeys(postSlideOutcomes))if (!slidLineKeys.has(key)) naturalKeys.add(key);
    return {
        slidesCount,
        naturalCount: naturalKeys.size
    };
}

},{"./sixesLiveData":"jPlrt","./sixesMovement":"6GIBc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2x0p1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_SIXES_SEEN_FOOTER_STATS", ()=>EMPTY_SIXES_SEEN_FOOTER_STATS);
parcelHelpers.export(exports, "emptySixesSeenPinkOutcomes", ()=>emptySixesSeenPinkOutcomes);
parcelHelpers.export(exports, "readSixesSeenSettlement", ()=>readSixesSeenSettlement);
parcelHelpers.export(exports, "readSixesSeenFooterStats", ()=>readSixesSeenFooterStats);
parcelHelpers.export(exports, "writeSixesSeenSettlement", ()=>writeSixesSeenSettlement);
parcelHelpers.export(exports, "resetSixesSeenSettlement", ()=>resetSixesSeenSettlement);
parcelHelpers.export(exports, "pinkOutcomesSnapshotEqual", ()=>pinkOutcomesSnapshotEqual);
var _sixesGridLayout = require("./sixesGridLayout");
var _sixesMarketBucket = require("./sixesMarketBucket");
const STORAGE_KEY_PREFIX = "sixes:settlement-seen:";
const EMPTY_SIXES_SEEN_FOOTER_STATS = {
    wins: 0,
    slides: 0,
    natural: 0,
    coins: 0,
    multiplierSixes: 0
};
function emptySixesSeenPinkOutcomes() {
    return Array.from({
        length: (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT)
    }, ()=>"pending");
}
function storageKey(matchId) {
    return `${STORAGE_KEY_PREFIX}${String(matchId || "").trim()}`;
}
function readSixesSeenSettlement(matchId) {
    if (typeof window === "undefined") return null;
    const id = String(matchId || "").trim();
    if (!id) return null;
    try {
        const raw = window.localStorage.getItem(storageKey(id));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const version = parsed?.v === 2 ? 2 : parsed?.v === 1 ? 1 : null;
        if (!version || !Array.isArray(parsed.outcomes)) return null;
        if (parsed.outcomes.length !== (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT)) return null;
        const legacySets = version === 2 && parsed.footerStats && typeof parsed.footerStats === "object" && "sets" in parsed.footerStats ? Math.max(0, Math.round(Number(parsed.footerStats.sets) || 0)) : 0;
        const footerStats = version === 2 && parsed.footerStats && typeof parsed.footerStats === "object" ? {
            wins: Math.max(0, Math.round(Number(parsed.footerStats.wins) || 0)),
            slides: Math.max(0, Math.round(Number(parsed.footerStats.slides ?? legacySets) || 0)),
            natural: Math.max(0, Math.round(Number(parsed.footerStats.natural) || 0)),
            coins: Math.max(0, Math.round(Number(parsed.footerStats.coins) || 0)),
            multiplierSixes: Math.max(0, Math.round(Number(parsed.footerStats.multiplierSixes) || 0))
        } : {
            ...EMPTY_SIXES_SEEN_FOOTER_STATS
        };
        const cellColors = Array.isArray(parsed.cellColors) ? parsed.cellColors.map((c)=>String(c || "").trim()).filter(Boolean) : undefined;
        const buckets = Array.isArray(parsed.buckets) ? parsed.buckets.map((bucket)=>typeof bucket === "string" ? (0, _sixesMarketBucket.normalizeSixesBucket)(bucket) : null) : undefined;
        const celebratedBuckets = Array.isArray(parsed.celebratedBuckets) ? parsed.celebratedBuckets.map((bucket)=>(0, _sixesMarketBucket.normalizeSixesBucket)(bucket)).filter((bucket)=>bucket != null) : [];
        return {
            v: 2,
            outcomes: parsed.outcomes,
            celebratedLineKeys: Array.isArray(parsed.celebratedLineKeys) ? parsed.celebratedLineKeys : [],
            celebratedBuckets,
            footerStats,
            cellColors: cellColors && cellColors.length === (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT) ? cellColors : undefined,
            buckets: buckets && buckets.length === (0, _sixesGridLayout.SIXES_MARKET_CELL_COUNT) ? buckets : undefined
        };
    } catch  {
        return null;
    }
}
function readSixesSeenFooterStats(matchId) {
    return readSixesSeenSettlement(matchId)?.footerStats ?? {
        ...EMPTY_SIXES_SEEN_FOOTER_STATS
    };
}
function writeSixesSeenSettlement(matchId, snapshot) {
    if (typeof window === "undefined") return;
    const id = String(matchId || "").trim();
    if (!id) return;
    try {
        window.localStorage.setItem(storageKey(id), JSON.stringify(snapshot));
    } catch  {
    /* quota / private mode */ }
}
function resetSixesSeenSettlement(matchId) {
    if (typeof window === "undefined") return;
    const id = String(matchId || "").trim();
    if (!id) return;
    window.localStorage.removeItem(storageKey(id));
}
function pinkOutcomesSnapshotEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((value, idx)=>value === b[idx]);
}

},{"./sixesGridLayout":"EvkJs","./sixesMarketBucket":"87iM1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8QimC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hardcoded fixture shortlist. Real implementation reads `/trade/prioritised-matches`
 * or `/api/fixturelist`; the shape below is deliberately close to those rows.
 */ parcelHelpers.export(exports, "prototypeFixtures", ()=>prototypeFixtures);
parcelHelpers.export(exports, "PROTOTYPE_FRIENDS", ()=>PROTOTYPE_FRIENDS);
parcelHelpers.export(exports, "rememberLiveFriends", ()=>rememberLiveFriends);
parcelHelpers.export(exports, "friendById", ()=>friendById);
parcelHelpers.export(exports, "emptyGameStats", ()=>emptyGameStats);
parcelHelpers.export(exports, "newMember", ()=>newMember);
parcelHelpers.export(exports, "WALKTHROUGH_LIVE_LEAGUE_ID", ()=>WALKTHROUGH_LIVE_LEAGUE_ID);
parcelHelpers.export(exports, "PRESENTER_LEAGUE_CODE", ()=>PRESENTER_LEAGUE_CODE);
parcelHelpers.export(exports, "PRESENTER_PREMATCH_MS", ()=>PRESENTER_PREMATCH_MS);
/**
 * Single invited India v West Indies room for the `/leaguesdemo` presenter walkthrough.
 * Viewer is not seated until they click Join. Host is Rohan.
 */ parcelHelpers.export(exports, "buildWalkthroughLiveLeague", ()=>buildWalkthroughLiveLeague);
parcelHelpers.export(exports, "prototypeLeagues", ()=>prototypeLeagues);
var _profileAvatarCatalog = require("../../../utils/profileAvatarCatalog");
var _constants = require("./constants");
var _leagueFormat = require("./leagueFormat");
const HOUR = 3600000;
const DAY = 24 * HOUR;
function presetAvatar(index) {
    const option = (0, _profileAvatarCatalog.FALLBACK_AVATAR_OPTIONS)[index % (0, _profileAvatarCatalog.FALLBACK_AVATAR_OPTIONS).length];
    return option?.thumb_urls?.["96"] ?? option?.url ?? null;
}
function prototypeFixtures(now = Date.now()) {
    return [
        {
            id: "proto-ind-wi",
            name: "India v West Indies",
            homeTeam: "India",
            awayTeam: "West Indies",
            competition: "ICC Men's T20 World Cup",
            start: new Date(now + 5400000).toISOString(),
            durationHours: 5,
            formatOvers: 20,
            availableGames: [
                "sixes",
                "bullion",
                "trader",
                "squares"
            ]
        },
        {
            id: "proto-aus-eng",
            name: "Australia v England",
            homeTeam: "Australia",
            awayTeam: "England",
            competition: "Ashes ODI Series",
            start: new Date(now + 1 * DAY + 2 * HOUR).toISOString(),
            durationHours: 9,
            formatOvers: 50,
            availableGames: [
                "bullion",
                "trader"
            ]
        },
        {
            id: "proto-mi-csk",
            name: "Mumbai Indians v Chennai Super Kings",
            homeTeam: "Mumbai Indians",
            awayTeam: "Chennai Super Kings",
            competition: "Indian Premier League",
            start: new Date(now + 2 * DAY + 5 * HOUR).toISOString(),
            durationHours: 4,
            formatOvers: 20,
            availableGames: [
                "sixes",
                "bullion",
                "trader",
                "squares"
            ]
        },
        {
            id: "proto-pak-nz",
            name: "Pakistan v New Zealand",
            homeTeam: "Pakistan",
            awayTeam: "New Zealand",
            competition: "T20I Series",
            start: new Date(now + 3 * DAY).toISOString(),
            durationHours: 4,
            formatOvers: 20,
            availableGames: [
                "sixes",
                "trader",
                "squares"
            ]
        },
        {
            id: "proto-sa-sl",
            name: "South Africa v Sri Lanka",
            homeTeam: "South Africa",
            awayTeam: "Sri Lanka",
            competition: "ICC Men's T20 World Cup",
            start: new Date(now + 4 * DAY + 6 * HOUR).toISOString(),
            durationHours: 4,
            formatOvers: 20,
            availableGames: [
                "sixes",
                "bullion",
                "trader"
            ]
        }
    ];
}
const PROTOTYPE_FRIENDS = [
    {
        userId: 101,
        username: "rohan_84",
        playerName: "Rohan",
        avatar: presetAvatar(0),
        isOnline: true,
        xpWeekCrown: "gold"
    },
    {
        userId: 102,
        username: "meera.k",
        playerName: "Meera",
        avatar: presetAvatar(1),
        isOnline: true
    },
    {
        userId: 103,
        username: "dazza",
        playerName: "Darren",
        avatar: presetAvatar(2),
        isOnline: false
    },
    {
        userId: 104,
        username: "priya_p",
        playerName: "Priya",
        avatar: presetAvatar(3),
        isOnline: true,
        xpWeekCrown: "silver"
    },
    {
        userId: 105,
        username: "big_kev",
        playerName: "Kev",
        avatar: presetAvatar(4),
        isOnline: false
    },
    {
        userId: 106,
        username: "sanjay7",
        playerName: "Sanjay",
        avatar: presetAvatar(5),
        isOnline: false
    },
    {
        userId: 107,
        username: "aisha",
        playerName: "Aisha",
        avatar: presetAvatar(6),
        isOnline: true
    },
    {
        userId: 108,
        username: "tomtom",
        playerName: "Tom",
        avatar: presetAvatar(7),
        isOnline: false
    },
    {
        userId: 109,
        username: "nadia_c",
        playerName: "Nadia",
        avatar: presetAvatar(8),
        isOnline: true
    },
    {
        userId: 110,
        username: "vik",
        playerName: "Vikram",
        avatar: presetAvatar(9),
        isOnline: false
    },
    {
        userId: 111,
        username: "dev_r",
        playerName: "Dev",
        avatar: presetAvatar(10),
        isOnline: true
    },
    {
        userId: 112,
        username: "anika",
        playerName: "Anika",
        avatar: presetAvatar(11),
        isOnline: true,
        xpWeekCrown: "bronze"
    },
    {
        userId: 113,
        username: "jamal_k",
        playerName: "Jamal",
        avatar: presetAvatar(12),
        isOnline: true
    },
    {
        userId: 114,
        username: "sana.m",
        playerName: "Sana",
        avatar: presetAvatar(13),
        isOnline: true
    },
    {
        userId: 115,
        username: "chris_t",
        playerName: "Chris",
        avatar: presetAvatar(14),
        isOnline: false
    },
    {
        userId: 116,
        username: "riya8",
        playerName: "Riya",
        avatar: presetAvatar(15),
        isOnline: true
    },
    {
        userId: 117,
        username: "omar_b",
        playerName: "Omar",
        avatar: presetAvatar(16),
        isOnline: true
    }
];
const liveFriendsById = new Map();
function rememberLiveFriends(friends) {
    friends.forEach((friend)=>liveFriendsById.set(friend.userId, friend));
}
function friendById(userId) {
    return liveFriendsById.get(userId) ?? PROTOTYPE_FRIENDS.find((f)=>f.userId === userId) ?? null;
}
const EMPTY_GAME_STATS = {
    trader: {
        pl: 0,
        wins: 0,
        losses: 0,
        played: 0
    },
    bullion: {
        pl: 0,
        wins: 0,
        losses: 0,
        played: 0
    },
    sixes: {
        pl: 0,
        wins: 0,
        losses: 0,
        played: 0
    },
    squares: {
        pl: 0,
        wins: 0,
        losses: 0,
        played: 0
    }
};
function emptyGameStats() {
    return JSON.parse(JSON.stringify(EMPTY_GAME_STATS));
}
function newMember(params) {
    const startingCoins = (0, _leagueFormat.startingCoinsFor)(params.entryFeeRubies, params.formatOvers);
    return {
        userId: params.userId,
        playerName: params.playerName,
        avatar: params.avatar ?? null,
        xpWeekCrown: params.xpWeekCrown ?? null,
        isOnline: params.isOnline ?? true,
        isHost: params.isHost === true,
        isViewer: params.isViewer === true,
        joinedAt: params.joinedAt ?? new Date().toISOString(),
        startingCoins,
        coins: startingCoins,
        seatTopups: 0,
        reactions: params.reactions ?? {
            sent: 0,
            received: {
                poop: 0,
                rofl: 0,
                rocket: 0,
                fire: 0,
                clap: 0,
                cry: 0
            }
        },
        byGame: emptyGameStats()
    };
}
/** Seeds a member with plausible mid-league numbers so tables are not empty on first load. */ function seededMember(friendId, entryFeeRubies, perGame, options = {}) {
    const friend = friendId === "viewer" ? null : friendById(friendId);
    const member = newMember({
        userId: friendId === "viewer" ? (0, _constants.LEAGUE_VIEWER_USER_ID) : friendId,
        playerName: friendId === "viewer" ? "Alex" : friend?.playerName ?? "Player",
        avatar: friend?.avatar ?? null,
        xpWeekCrown: friend?.xpWeekCrown ?? null,
        isOnline: friendId === "viewer" ? true : Boolean(friend?.isOnline),
        isHost: options.isHost === true,
        isViewer: friendId === "viewer",
        entryFeeRubies,
        formatOvers: 20,
        joinedAt: options.joinedAt,
        reactions: options.reactions
    });
    let pl = 0;
    Object.keys(perGame).forEach((key)=>{
        const entry = perGame[key];
        if (!entry) return;
        const [gamePl, wins, losses] = entry;
        member.byGame[key] = {
            pl: gamePl,
            wins,
            losses,
            played: wins + losses
        };
        pl += gamePl;
    });
    member.coins = member.startingCoins + pl;
    if (options.previousRank != null) member.previousRank = options.previousRank;
    if (options.rankMovedAt) member.rankMovedAt = options.rankMovedAt;
    return member;
}
/** Seeds an in-play bet so the "in play" list is populated on first load. */ function openPlay(member, game, stake, selection, multiplier, placedSecondsAgo, settlesInSeconds, marketDetails) {
    const now = Date.now();
    return {
        id: `seed-play-${member.userId}-${game}-${placedSecondsAgo}`,
        userId: member.userId,
        playerName: member.playerName,
        game,
        stake,
        selection,
        multiplier,
        placedAt: new Date(now - placedSecondsAgo * 1000).toISOString(),
        settlesAt: new Date(now + settlesInSeconds * 1000).toISOString(),
        status: "open",
        ...marketDetails ? {
            marketDetails
        } : {}
    };
}
function settlement(at, member, game, delta, stake, detail, marketDetails) {
    return {
        id: `seed-${member.userId}-${game}-${at}`,
        at: new Date(at).toISOString(),
        userId: member.userId,
        playerName: member.playerName,
        game,
        outcome: delta >= 0 ? "win" : "loss",
        stake,
        delta,
        detail,
        ...marketDetails ? {
            marketDetails
        } : {}
    };
}
function seededThrow(members, now, fromUserId, targetUserId, emoji, agoMs) {
    const from = members.find((m)=>m.userId === fromUserId);
    const target = members.find((m)=>m.userId === targetUserId);
    return {
        id: `seed-throw-${fromUserId}-${targetUserId}-${agoMs}`,
        at: new Date(now - agoMs).toISOString(),
        fromUserId,
        fromPlayerName: from?.playerName?.trim() || `Player ${fromUserId}`,
        targetUserId,
        targetPlayerName: target?.playerName?.trim() || `Player ${targetUserId}`,
        emoji
    };
}
const WALKTHROUGH_LIVE_LEAGUE_ID = "proto-league-ind-wi";
const PRESENTER_LEAGUE_CODE = "IND8WI";
const PRESENTER_PREMATCH_MS = 5400000;
const PRESENTER_HOST_ID = 101;
function memberById(members, userId) {
    const found = members.find((row)=>row.userId === userId);
    if (!found) throw new Error(`Missing presenter seed member ${userId}`);
    return found;
}
function buildWalkthroughLiveLeague(now = Date.now()) {
    const fixtures = prototypeFixtures(now);
    const indVsWi = fixtures[0];
    const fee = 5;
    const startMs = now + PRESENTER_PREMATCH_MS;
    const joinAgo = (hours)=>new Date(now - hours * HOUR).toISOString();
    const emptyReceived = ()=>({
            poop: 0,
            rofl: 0,
            rocket: 0,
            fire: 0,
            clap: 0,
            cry: 0
        });
    const members = [
        seededMember(PRESENTER_HOST_ID, fee, {
            trader: [
                80,
                1,
                0
            ]
        }, {
            isHost: true,
            joinedAt: joinAgo(30),
            reactions: {
                sent: 1,
                received: {
                    ...emptyReceived(),
                    rocket: 2,
                    clap: 1
                }
            }
        }),
        seededMember(102, fee, {
            sixes: [
                0,
                0,
                0
            ]
        }, {
            joinedAt: joinAgo(28),
            reactions: {
                sent: 2,
                received: {
                    ...emptyReceived(),
                    poop: 1
                }
            }
        }),
        seededMember(104, fee, {
            bullion: [
                0,
                0,
                0
            ]
        }, {
            joinedAt: joinAgo(26),
            reactions: {
                sent: 0,
                received: {
                    ...emptyReceived(),
                    rofl: 3,
                    cry: 1
                }
            }
        }),
        seededMember(107, fee, {
            trader: [
                40,
                1,
                0
            ]
        }, {
            joinedAt: joinAgo(22),
            reactions: {
                sent: 3,
                received: emptyReceived()
            }
        }),
        seededMember(109, fee, {
            sixes: [
                0,
                0,
                0
            ]
        }, {
            joinedAt: joinAgo(20),
            reactions: {
                sent: 0,
                received: {
                    ...emptyReceived(),
                    poop: 2,
                    fire: 1
                }
            }
        }),
        seededMember(103, fee, {}, {
            joinedAt: joinAgo(18)
        }),
        seededMember(105, fee, {
            trader: [
                0,
                0,
                0
            ]
        }, {
            joinedAt: joinAgo(16)
        }),
        seededMember(111, fee, {
            sixes: [
                0,
                0,
                0
            ]
        }, {
            joinedAt: joinAgo(14),
            reactions: {
                sent: 1,
                received: {
                    ...emptyReceived(),
                    rocket: 4
                }
            }
        }),
        seededMember(112, fee, {
            bullion: [
                0,
                0,
                0
            ]
        }, {
            joinedAt: joinAgo(12)
        }),
        seededMember(113, fee, {
            trader: [
                20,
                1,
                0
            ]
        }, {
            joinedAt: joinAgo(10),
            reactions: {
                sent: 2,
                received: emptyReceived()
            }
        }),
        seededMember(114, fee, {}, {
            joinedAt: joinAgo(8)
        }),
        seededMember(116, fee, {
            sixes: [
                0,
                0,
                0
            ]
        }, {
            joinedAt: joinAgo(6),
            reactions: {
                sent: 1,
                received: emptyReceived()
            }
        }),
        seededMember(117, fee, {
            bullion: [
                0,
                0,
                0
            ]
        }, {
            joinedAt: joinAgo(4)
        }),
        seededMember(110, fee, {}, {
            joinedAt: joinAgo(2)
        })
    ];
    const rohan = memberById(members, 101);
    const meera = memberById(members, 102);
    const priya = memberById(members, 104);
    const aisha = memberById(members, 107);
    const nadia = memberById(members, 109);
    const jamal = memberById(members, 113);
    const anika = memberById(members, 112);
    const dev = memberById(members, 111);
    return {
        id: WALKTHROUGH_LIVE_LEAGUE_ID,
        code: PRESENTER_LEAGUE_CODE,
        name: "India v WI Ruby Rumble",
        scope: "match",
        entryFeeRubies: fee,
        createdAt: new Date(now - 2 * DAY).toISOString(),
        startsAt: new Date(startMs).toISOString(),
        endsAt: new Date(startMs + indVsWi.durationHours * HOUR).toISOString(),
        fixture: {
            ...indVsWi,
            start: new Date(startMs).toISOString()
        },
        hostUserId: PRESENTER_HOST_ID,
        hostName: "Rohan",
        members,
        invitedUserIds: [
            (0, _constants.LEAGUE_VIEWER_USER_ID),
            115
        ],
        membership: "invited",
        presenterMatchStarted: false,
        settlements: [],
        plays: [
            openPlay(rohan, "trader", 200, "India @ 1.72", 1.72, 900, 3600, {
                marketName: "Match Winner",
                selectionName: "India",
                marketClass: "Win"
            }),
            openPlay(aisha, "trader", 150, "West Indies @ 2.15", 2.15, 720, 3600, {
                marketName: "Match Winner",
                selectionName: "West Indies",
                marketClass: "Win"
            }),
            openPlay(jamal, "trader", 80, "Over 165.5 @ 1.88", 1.88, 480, 3600, {
                marketName: "India Innings Runs",
                selectionName: "Over",
                marketClass: "Line",
                marketLine: "165.5"
            }),
            openPlay(meera, "sixes", 0, "One card", 1, 640, 7200, {
                cardScore: 0
            }),
            openPlay(nadia, "sixes", 0, "One card", 1, 400, 7200, {
                cardScore: 0
            }),
            openPlay(dev, "sixes", 0, "One card", 1, 220, 7200, {
                cardScore: 0
            }),
            openPlay(priya, "bullion", 500, "India v WI Ruby Rumble Battle", 3, 800, 7200),
            openPlay(anika, "bullion", 500, "India v WI Ruby Rumble Battle", 3, 360, 7200)
        ],
        bullionBattle: {
            name: "India v WI Ruby Rumble Battle",
            entryStake: (0, _constants.LEAGUE_BULLION_BATTLE_STAKE),
            status: "open",
            viewerEntered: false,
            enteredUserIds: [
                104,
                112
            ],
            ensuredAt: new Date(now - 6 * HOUR).toISOString()
        },
        includedGames: [
            "sixes",
            "bullion",
            "trader",
            "squares"
        ],
        reactionEvents: [
            seededThrow(members, now, 102, 104, "rofl", 480000),
            seededThrow(members, now, 107, 101, "rocket", 840000),
            seededThrow(members, now, 113, 109, "poop", 1320000),
            seededThrow(members, now, 116, 111, "rocket", 1860000)
        ]
    };
}
function prototypeLeagues(now = Date.now()) {
    return [
        buildWalkthroughLiveLeague(now)
    ];
}

},{"../../../utils/profileAvatarCatalog":"i8TvT","./constants":"dZVub","./leagueFormat":"jKCIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4EyCR":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("eP1Fb"));

},{}],"5Mc3o":[function(require,module,exports,__globalThis) {
/**
 * League Squares room client — members-only grids for the match-play UI.
 * Used by `squaresApi` when League mode is active so public/bot rooms never load.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildPrototypeLeagueSquaresRoom", ()=>(0, _leagueSquaresPrototypeRoom.buildPrototypeLeagueSquaresRoom));
/** Active league id for Squares room isolation (mode store or `?leagueId=`). */ parcelHelpers.export(exports, "resolveActiveLeagueIdForSquaresRoom", ()=>resolveActiveLeagueIdForSquaresRoom);
/**
 * Fetch the league-only Squares room for a match/innings (optionally one over).
 * Returns null when not in league mode (and no `leagueId` override) so callers can fall through
 * to public Squares APIs.
 */ parcelHelpers.export(exports, "fetchLeagueSquaresRoomIfActive", ()=>fetchLeagueSquaresRoomIfActive);
/**
 * Viewer's overs in the league Squares room for this match/innings.
 * Returns null when not in league mode.
 */ parcelHelpers.export(exports, "fetchLeagueSquaresMyOversIfActive", ()=>fetchLeagueSquaresMyOversIfActive);
var _authHeaders = require("../../../utils/authHeaders");
var _leagueGamePlayUrl = require("./leagueGamePlayUrl");
var _leagueModeStore = require("./leagueModeStore");
var _persistedLeagueId = require("./persistedLeagueId");
var _leagueStore = require("./leagueStore");
var _constants = require("./constants");
var _leagueSquaresPrototypeRoom = require("./leagueSquaresPrototypeRoom");
const EMPTY_MATCH = {
    plays: [],
    overs: {},
    overOddsLocked: {},
    over_economy: {},
    myOverNumbers: [],
    top_prize: 0
};
function apiBase() {
    return "https://cricket8.com/api".replace(/\/$/, "");
}
function resolveActiveLeagueIdForSquaresRoom() {
    const fromMode = (0, _leagueModeStore.peekActiveLeagueId)();
    if (fromMode) return fromMode;
    if (typeof window === "undefined") return null;
    try {
        const fromUrl = new URLSearchParams(window.location.search).get((0, _leagueGamePlayUrl.LEAGUE_ID_QUERY));
        const trimmed = fromUrl?.trim();
        return trimmed || null;
    } catch  {
        return null;
    }
}
async function fetchLeagueSquaresRoomIfActive(searchParams, options) {
    const leagueId = String(options?.leagueId || "").trim() || resolveActiveLeagueIdForSquaresRoom();
    if (!leagueId) return null;
    const q = searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams(searchParams);
    const matchId = q.get("matchId") ?? q.get("match_id") ?? "";
    if (!matchId) return {
        ...EMPTY_MATCH
    };
    const proto = (0, _leagueStore.findLeague)(leagueId);
    if (proto) return (0, _leagueSquaresPrototypeRoom.buildPrototypeLeagueSquaresRoom)(proto, q, (0, _constants.LEAGUE_VIEWER_USER_ID));
    // Lobby chrome (e.g. "lobby-finished") is a local board, not a row in `leagues`.
    if (!(0, _persistedLeagueId.isPersistedLeagueId)(leagueId)) return {
        ...EMPTY_MATCH
    };
    const params = new URLSearchParams({
        matchId: String(matchId)
    });
    const innings = q.get("inningsNumber") ?? q.get("innings_number");
    if (innings != null && String(innings).trim() !== "") params.set("inningsNumber", String(innings));
    const overNumber = q.get("overNumber") ?? q.get("over_number");
    if (overNumber != null && String(overNumber).trim() !== "") params.set("overNumber", String(overNumber));
    const currentOverNumber = q.get("currentOverNumber") ?? q.get("current_over_number");
    if (currentOverNumber != null && String(currentOverNumber).trim() !== "") params.set("currentOverNumber", String(currentOverNumber));
    const ballResults = q.get("ballResults") ?? q.get("ball_results");
    if (ballResults != null && String(ballResults).trim() !== "") params.set("ballResults", String(ballResults));
    const url = `${apiBase()}/leagues/${encodeURIComponent(leagueId)}/squares-plays?${params.toString()}`;
    try {
        const res = await fetch(url, {
            method: "GET",
            headers: (0, _authHeaders.getAuthHeaders)()
        });
        if (!res.ok) return {
            ...EMPTY_MATCH
        };
        const data = await res.json();
        return {
            plays: Array.isArray(data?.plays) ? data.plays : [],
            overs: data?.overs && typeof data.overs === "object" ? data.overs : {},
            overOddsLocked: data?.overOddsLocked && typeof data.overOddsLocked === "object" ? data.overOddsLocked : {},
            over_economy: data?.over_economy && typeof data.over_economy === "object" ? data.over_economy : {},
            myOverNumbers: Array.isArray(data?.myOverNumbers) ? data.myOverNumbers.map((n)=>Number(n)).filter((n)=>Number.isFinite(n)) : [],
            min_players: data?.min_players,
            pool_entrant_count: data?.pool_entrant_count,
            top_prize: data?.top_prize ?? 0,
            ...Array.isArray(data?.ball_results) ? {
                ball_results: data.ball_results
            } : {}
        };
    } catch  {
        return {
            ...EMPTY_MATCH
        };
    }
}
async function fetchLeagueSquaresMyOversIfActive(matchId, inningsNumber) {
    const leagueId = resolveActiveLeagueIdForSquaresRoom();
    if (!leagueId) return null;
    const data = await fetchLeagueSquaresRoomIfActive({
        matchId: String(matchId),
        inningsNumber: String(inningsNumber)
    });
    if (!data) return null;
    return {
        overNumbers: data.myOverNumbers || []
    };
}

},{"../../../utils/authHeaders":"5Rczo","./leagueGamePlayUrl":"5EJnb","./leagueModeStore":"kZgkv","./persistedLeagueId":"gVyFA","./leagueStore":"dMpsE","./constants":"dZVub","./leagueSquaresPrototypeRoom":"2PniI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gVyFA":[function(require,module,exports,__globalThis) {
/** Real `leagues.id` values are UUIDs. Lobby and demo boards use synthetic ids. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPersistedLeagueId", ()=>isPersistedLeagueId);
const PERSISTED_LEAGUE_ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function isPersistedLeagueId(leagueId) {
    return PERSISTED_LEAGUE_ID_RE.test(String(leagueId ?? "").trim());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2PniI":[function(require,module,exports,__globalThis) {
/**
 * Client-side Squares room for `/leaguesdemo`.
 * League.plays is the source of truth — there is no `/leagues/:id/squares-plays` for proto ids.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildPrototypeLeagueSquaresRoom", ()=>buildPrototypeLeagueSquaresRoom);
var _leagueSquaresStake = require("./leagueSquaresStake");
function parseInnings(raw) {
    const n = raw != null ? Math.floor(Number(raw)) : NaN;
    return Number.isFinite(n) && n >= 1 ? n : 1;
}
function parseOverFilter(raw) {
    if (raw == null || String(raw).trim() === "") return null;
    const n = Math.floor(Number(raw));
    return Number.isFinite(n) && n >= 1 ? n : null;
}
function squaresSourceMatchesRoom(source, matchId, inningsNumber, overFilter) {
    if (source.game !== "squares") return null;
    const over = Math.floor(Number(source.marketDetails?.overNumber));
    if (!Number.isFinite(over) || over < 1) return null;
    const inns = Math.floor(Number(source.marketDetails?.inningsNumber ?? 1)) || 1;
    if (inns !== inningsNumber) return null;
    if (overFilter != null && over !== overFilter) return null;
    const playMatch = String(source.matchId || "").trim();
    if (playMatch && playMatch !== String(matchId)) return null;
    return over;
}
function mapProtoPlayRow(source, over, settled) {
    const selections = source.marketDetails?.selections && typeof source.marketDetails.selections === "object" ? source.marketDetails.selections : {};
    const balls = source.marketDetails?.ballResults;
    const winnings = settled && source.delta != null && Number.isFinite(Number(source.delta)) ? Math.max(0, Number(source.stake || 0) + Number(source.delta)) : null;
    const placedAt = "placedAt" in source ? source.placedAt : "at" in source ? source.at : null;
    return {
        id: String(source.id),
        user_id: Number(source.userId),
        name: String(source.playerName || "You"),
        isBot: false,
        selections,
        created_at: placedAt ?? null,
        stake: Number(source.stake) || 0,
        stake_floor: (0, _leagueSquaresStake.leagueSquaresPlayStakeFloor)(source) || null,
        ball_results: Array.isArray(balls) ? balls.map((b)=>String(b ?? "")) : null,
        rank: null,
        score: null,
        winnings,
        settled,
        outcome: source.outcome ?? null,
        return: winnings,
        totalPot: null,
        over_number: over
    };
}
function buildPrototypeLeagueSquaresRoom(league, searchParams, viewerUserId = 1) {
    const q = searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams(searchParams);
    const matchId = q.get("matchId") ?? q.get("match_id") ?? "";
    const inningsNumber = parseInnings(q.get("inningsNumber") ?? q.get("innings_number"));
    const overFilter = parseOverFilter(q.get("overNumber") ?? q.get("over_number"));
    const byKey = new Map();
    const absorb = (row)=>{
        const key = `${row.user_id}:${row.over_number}`;
        const existing = byKey.get(key);
        if (!existing || row.settled && !existing.settled) byKey.set(key, row);
    };
    for (const play of league.plays || []){
        const over = squaresSourceMatchesRoom(play, matchId, inningsNumber, overFilter);
        if (over == null) continue;
        absorb(mapProtoPlayRow(play, over, play.status === "settled"));
    }
    for (const entry of league.settlements || []){
        const over = squaresSourceMatchesRoom(entry, matchId, inningsNumber, overFilter);
        if (over == null) continue;
        absorb(mapProtoPlayRow(entry, over, true));
    }
    const plays = [
        ...byKey.values()
    ].sort((a, b)=>a.over_number - b.over_number);
    const overs = {};
    const over_economy = {};
    const counts = new Map();
    for (const p of plays)counts.set(p.over_number, (counts.get(p.over_number) ?? 0) + 1);
    for (const [on, count] of counts){
        overs[on] = {
            winners: [],
            ball_results: null,
            total_pot: null
        };
        over_economy[on] = {
            pool_entrant_count: count,
            top_prize: 0
        };
    }
    const myOverNumbers = [
        ...new Set(plays.filter((p)=>Number(p.user_id) === Number(viewerUserId)).map((p)=>p.over_number))
    ].sort((a, b)=>a - b);
    return {
        plays,
        overs,
        overOddsLocked: {},
        over_economy,
        myOverNumbers,
        top_prize: 0,
        pool_entrant_count: overFilter != null ? counts.get(overFilter) ?? 0 : plays.length
    };
}

},{"./leagueSquaresStake":"318Xs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"318Xs":[function(require,module,exports,__globalThis) {
/**
 * Pure stake helpers for League Squares (chips on the grid = stake; no flat entrance fee).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Sum of chip amounts on the grid selections. */ parcelHelpers.export(exports, "sumSquaresSelectionChips", ()=>sumSquaresSelectionChips);
/**
 * League Squares stake = chips placed on the grid (totalChips preferred, else Σ selection chips).
 */ parcelHelpers.export(exports, "resolveLeagueSquaresStake", ()=>resolveLeagueSquaresStake);
/** Chip floor stamped on an open Squares play at seat top-up (0 = may still reduce). */ parcelHelpers.export(exports, "leagueSquaresPlayStakeFloor", ()=>leagueSquaresPlayStakeFloor);
function sumSquaresSelectionChips(selections) {
    if (!selections || typeof selections !== "object") return 0;
    let total = 0;
    for (const sel of Object.values(selections))total += Math.max(0, Math.floor(Number(sel?.chips) || 0));
    return total;
}
function resolveLeagueSquaresStake(input) {
    const fromTotal = Math.floor(Number(input.totalChips));
    if (Number.isFinite(fromTotal) && fromTotal > 0) return fromTotal;
    const fromSelections = sumSquaresSelectionChips(input.selections);
    if (fromSelections > 0) return fromSelections;
    const fromStake = Math.floor(Number(input.stake));
    return Number.isFinite(fromStake) && fromStake > 0 ? fromStake : 0;
}
function leagueSquaresPlayStakeFloor(play) {
    if (play == null) return 0;
    const fromPlay = Math.max(0, Math.floor(Number(play.stake_floor ?? play.stakeFloor) || 0));
    const fromMd = Math.max(0, Math.floor(Number(play.marketDetails?.stakeFloor) || 0));
    const floor = Math.max(fromPlay, fromMd);
    return Number.isFinite(floor) ? floor : 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j3UmL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Build ctx for {@link isCricketTestMatch} / {@link isCricketHundredMatch} from lobby fixture + stream snapshot.
 * Keep aligned with Squares match-play unsupported-format checks.
 * @param {object | undefined | null} fixture
 * @param {object | undefined | null} streamData
 */ parcelHelpers.export(exports, "buildSquaresFormatCheckContext", ()=>buildSquaresFormatCheckContext);
/**
 * False for Test cricket and The Hundred — same product rules as Squares match-play.
 * @param {object | undefined | null} fixture
 * @param {object | undefined | null} streamData
 */ parcelHelpers.export(exports, "isSquaresSupportedCricketFormat", ()=>isSquaresSupportedCricketFormat);
/**
 * Match Centre / Matches list PLAY chips: show Squares when the fixture is in the
 * offer-ready lobby set (not scheduled / pretoss) and the format is supported.
 *
 * Do not require stream 410 markets. Listings subscribe with `product=trader`, and
 * trader lobby SSE drops 410s, so PLAY OVER N never resolves on these cards even
 * when Squares is available.
 *
 * @param {object | undefined | null} fixture
 * @param {object | undefined | null} streamData
 * @param {boolean} offerReady — from useSquaresOfferMatchIds
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isSquaresOfferedOnMatchListCard", ()=>isSquaresOfferedOnMatchListCard);
/**
 * Match completion / lobby visibility — keep in sync with Squares lobby (UpcomingMatches).
 * @param { { status?: string | null } } fixture
 */ parcelHelpers.export(exports, "isSquaresLobbyMatchCompleted", ()=>isSquaresLobbyMatchCompleted);
/**
 * Normalise prioritised API events to lobby card shape (match_id) and drop completed.
 * @param {unknown[]} events
 */ parcelHelpers.export(exports, "mapAndFilterSquaresLobbyFixtures", ()=>mapAndFilterSquaresLobbyFixtures);
/**
 * Normalised list status line (aligns with SquaresMatchCard matchStatus for "Match in Progress").
 * @param { { status?: string | null } } fixture
 */ parcelHelpers.export(exports, "listNormalizedMatchStatusForSquares", ()=>listNormalizedMatchStatusForSquares);
/**
 * Whether Squares is offered for play on Matches/homepage cards (not merely listed in the lobby).
 * Aligns with Squares lobby CTAs that are not yet playable: "OPENS IN …" (scheduled) and
 * "AWAITING TOSS" (pretoss / pre-match). Does not require SSE.
 * @param { { status?: string | null, liveScore?: { isFinished?: boolean } } } fixture
 */ parcelHelpers.export(exports, "isSquaresFixturePlayableForHomeBadge", ()=>isSquaresFixturePlayableForHomeBadge);
/**
 * Same as lobby list minus scheduled / pretoss fixtures (for Matches cards + "games available" counts).
 * @param {unknown[]} events
 */ parcelHelpers.export(exports, "mapFilterSquaresPlayableLobbyFixturesForHome", ()=>mapFilterSquaresPlayableLobbyFixturesForHome);
/**
 * @param {unknown[]} events
 */ parcelHelpers.export(exports, "countSquaresPlayableLobbyFixturesForHome", ()=>countSquaresPlayableLobbyFixturesForHome);
/**
 * True when the match is treated as live for Squares (in-play from fixture list and/or stream event_status).
 * Used to show only live rows in the friend-challenge modal.
 * Also requires offer-ready status (excludes scheduled / pretoss even if stream looks live early).
 * @param {object} fixture
 * @param {object | undefined} streamData
 */ parcelHelpers.export(exports, "isSquaresFixtureLiveForChallengeList", ()=>isSquaresFixtureLiveForChallengeList);
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
var _cricketTestMatch = require("../../../utils/cricketTestMatch");
function buildSquaresFormatCheckContext(fixture, streamData) {
    const mu = streamData?.market_update;
    return {
        format: fixture?.format ?? fixture?.Format ?? streamData?.event?.format ?? streamData?.match_update?.format,
        mOvers: streamData?.mOvers ?? streamData?.event?.mOvers,
        maxOvers: streamData?.event?.max_overs,
        competition: fixture?.competition ?? streamData?.event?.competition,
        matchName: fixture?.name ?? fixture?.match_name,
        streamData,
        markets: mu?.markets ?? mu?.market_update?.markets
    };
}
function isSquaresSupportedCricketFormat(fixture, streamData) {
    const ctx = buildSquaresFormatCheckContext(fixture, streamData);
    if ((0, _cricketTestMatch.isCricketTestMatch)(ctx)) return false;
    if ((0, _cricketTestMatch.isCricketHundredMatch)(ctx)) return false;
    return true;
}
function isSquaresOfferedOnMatchListCard(fixture, streamData, offerReady) {
    if (!offerReady) return false;
    return isSquaresSupportedCricketFormat(fixture, streamData);
}
function isSquaresLobbyMatchCompleted(fixture) {
    if (!fixture || typeof fixture !== "object") return false;
    const ls = fixture.liveScore;
    if (ls && typeof ls === "object" && ls.isFinished === true) return true;
    if (!fixture.status) return false;
    const full = String(fixture.status);
    const status = full.split(" - ");
    let matchstatus = status[0].replace(/\s*\(.*?\)\s*/g, "").trim();
    if (full.includes("Match in Progress")) matchstatus = "IN-PLAY";
    const upperStatus = matchstatus.toUpperCase();
    const uFull = full.toUpperCase();
    return upperStatus.startsWith("CANCELLED") || upperStatus.startsWith("MATCH ABANDONED") || upperStatus.startsWith("MATCH COMPLETE") || upperStatus.startsWith("EVENT CLOSED") || upperStatus.startsWith("FINISHED") || upperStatus.startsWith("FULL TIME") || uFull.includes("MATCH COMPLETE") || uFull.includes("EVENT CLOSED") || uFull.includes("FINISHED") || uFull.includes("FULL TIME") || uFull.includes("EVENT_FULL_RESULT") || uFull.includes("MATCH ABANDONED");
}
function mapAndFilterSquaresLobbyFixtures(events) {
    const list = Array.isArray(events) ? events : [];
    const asFixtures = list.map((ev)=>({
            ...ev,
            match_id: ev.id ?? ev.match_id
        }));
    return asFixtures.filter((fixture)=>!isSquaresLobbyMatchCompleted(fixture));
}
function listNormalizedMatchStatusForSquares(fixture) {
    const rawFull = fixture?.status || "";
    const fixtureStatusUpper = rawFull.toUpperCase();
    const rawStatus = rawFull.split(" - ")[0] || "";
    let normalized = rawStatus.replace(/\s*\(.*?\)\s*/g, "").trim();
    if (rawFull.includes("Match in Progress")) normalized = "IN-PLAY";
    if (fixtureStatusUpper.includes("BREAK IN PLAY")) normalized = "BREAK IN PLAY";
    return normalized;
}
function isSquaresFixturePlayableForHomeBadge(fixture) {
    if (!fixture || typeof fixture !== "object") return false;
    if (isSquaresLobbyMatchCompleted(fixture)) return false;
    const full = String(fixture.status || "");
    const fullUpper = full.toUpperCase();
    if (fullUpper.includes("CANCELLED") || fullUpper.includes("MATCH ABANDONED")) return false;
    const norm = listNormalizedMatchStatusForSquares(fixture);
    const normUpper = norm.toUpperCase();
    // Prematch / scheduled — Squares lobby shows OPENS IN / OPENS SOON
    if (normUpper === "MATCH SCHEDULED" || fullUpper.includes("MATCH SCHEDULED")) return false;
    // Pretoss — Squares lobby shows AWAITING TOSS until toss confirms play
    if (fullUpper.includes("TOSS PENDING") || fullUpper.includes("TOSS DELAYED") || normUpper === "TOSS PENDING" || normUpper === "TOSS DELAYED") return false;
    return true;
}
function mapFilterSquaresPlayableLobbyFixturesForHome(events) {
    return mapAndFilterSquaresLobbyFixtures(events).filter((f)=>isSquaresFixturePlayableForHomeBadge(f));
}
function countSquaresPlayableLobbyFixturesForHome(events) {
    return mapFilterSquaresPlayableLobbyFixturesForHome(events).length;
}
function isSquaresFixtureLiveForChallengeList(fixture, streamData) {
    if (!fixture) return false;
    if (!isSquaresFixturePlayableForHomeBadge(fixture)) return false;
    const norm = listNormalizedMatchStatusForSquares(fixture);
    if (norm === "IN-PLAY" || norm === "BREAK IN PLAY") return true;
    const mu = streamData?.market_update;
    const es = mu?.event_status ?? mu?.market_update?.event_status ?? null;
    const n = (0, _decimalEventStatus.eventStatusToNumber)(es);
    if (n != null && (0, _decimalEventStatus.IN_PLAY_STATUS_IDS).includes(n)) return true;
    return false;
}

},{"../../Trader/Cricket/decimalEventStatus":"f1nlI","../../../utils/cricketTestMatch":"eJTw5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Pj06":[function(require,module,exports,__globalThis) {
/**
 * Shared “Squares game open” signal for Matches / homepage / challenge cards.
 * Same rules as Squares lobby CTA: live (or post-toss) phase + a playable 410 over.
 * Without stream markets → not open (GAME NOT OPEN YET).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * True once Squares treats the match as past pure pretoss (toss confirmed and/or in-play).
 * @param {object} fixture
 * @param {object | undefined} streamData
 */ parcelHelpers.export(exports, "isSquaresLivePhaseForGameOpen", ()=>isSquaresLivePhaseForGameOpen);
/**
 * 1-based over Squares would advertise on the lobby card, or null when GAME NOT OPEN YET.
 * @param {object} fixture
 * @param {object | undefined} streamData
 * @returns {number | null}
 */ parcelHelpers.export(exports, "getSquaresLobbyPlayOverNumber", ()=>getSquaresLobbyPlayOverNumber);
/**
 * True when the Squares lobby would show PLAY OVER N (not GAME NOT OPEN YET).
 * Needs 410 markets — use on Squares lobby / match-detail streams, not trader-lobby listings.
 * @param {object} fixture
 * @param {object | undefined} streamData
 */ parcelHelpers.export(exports, "isSquaresGameOpenFromStream", ()=>isSquaresGameOpenFromStream);
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
var _squaresCommentaryToss = require("../shared/squaresCommentaryToss");
var _squaresPlayOpenWindow = require("../shared/squaresPlayOpenWindow");
var _squaresOverOdds = require("../shared/squaresOverOdds");
var _cricketMatchCardOverDisplay = require("../../Cricket/cricketMatchCardOverDisplay");
var _squaresLobbyMatchUtils = require("./squaresLobbyMatchUtils");
var _matchUtils = require("../../Games/matchUtils");
function isStreamLiveEventStatus(status) {
    const n = (0, _decimalEventStatus.eventStatusToNumber)(status);
    return n != null && (0, _decimalEventStatus.IN_PLAY_STATUS_IDS).includes(n);
}
function streamEventStatus(streamData) {
    const mu = streamData?.market_update;
    if (!mu) return null;
    if (mu.event_status != null && mu.event_status !== "") return mu.event_status;
    return mu.market_update?.event_status ?? null;
}
function isSquaresLivePhaseForGameOpen(fixture, streamData) {
    if (!fixture) return false;
    const fixtureStatusUpper = String(fixture.status || "").toUpperCase();
    const matchStatus = (0, _squaresLobbyMatchUtils.listNormalizedMatchStatusForSquares)(fixture);
    const upper = (matchStatus || "").toUpperCase();
    if (upper.startsWith("CANCELLED") || upper.startsWith("MATCH ABANDONED") || upper.startsWith("MATCH COMPLETE") || upper.startsWith("EVENT CLOSED")) return false;
    const isInPlay = matchStatus === "IN-PLAY";
    const isTossPendingList = fixtureStatusUpper.startsWith("TOSS PENDING") || fixtureStatusUpper.startsWith("TOSS DELAYED") || fixtureStatusUpper.includes("TOSS PENDING") || fixtureStatusUpper.includes("TOSS DELAYED");
    const tossKnownFromCommentary = (0, _squaresCommentaryToss.commentaryIndicatesTossWon)(streamData?.commentary);
    const scorecardToss = (0, _squaresPlayOpenWindow.scorecardTossConfirmed)(streamData?.scorecard?.toss);
    const tossAllowsSquaresPlay = isTossPendingList ? tossKnownFromCommentary : tossKnownFromCommentary || scorecardToss;
    const es = streamEventStatus(streamData);
    const isStreamInPlayPhase = isStreamLiveEventStatus(es);
    const withinOpenCountdown = (0, _squaresPlayOpenWindow.isWithinSquaresPlayOpenCountdown)(fixture?.start);
    return isInPlay || matchStatus === "BREAK IN PLAY" || isStreamInPlayPhase || tossAllowsSquaresPlay || withinOpenCountdown;
}
function getSquaresLobbyPlayOverNumber(fixture, streamData) {
    if (!isSquaresLivePhaseForGameOpen(fixture, streamData)) return null;
    const lobbyInningsMaxOvers = (0, _cricketMatchCardOverDisplay.maxOversFromStreamEvent)(streamData) ?? (0, _cricketMatchCardOverDisplay.maxOversFromFixtureFormat)(fixture?.format);
    const eventObj = streamData?.event?.event ?? streamData?.event;
    const rawCurrent = (0, _cricketMatchCardOverDisplay.cricketCurrentOver1BasedFromScoreboard)(eventObj?.scoreboard);
    let cricketCurrentOver = rawCurrent;
    if (cricketCurrentOver != null && lobbyInningsMaxOvers != null && Number.isFinite(lobbyInningsMaxOvers) && lobbyInningsMaxOvers > 0) cricketCurrentOver = Math.min(cricketCurrentOver, lobbyInningsMaxOvers);
    const inningsOversDec = (0, _cricketMatchCardOverDisplay.cricketInningsOversDecimalFromScoreboard)(eventObj?.scoreboard);
    const inningsBreak = (0, _matchUtils.cricketStreamIndicatesInningsBreak)(streamData);
    if (inningsBreak || inningsOversDec != null && lobbyInningsMaxOvers != null && Number.isFinite(lobbyInningsMaxOvers) && lobbyInningsMaxOvers > 0 && inningsOversDec >= lobbyInningsMaxOvers) // Completed innings: open Over 1 of the chase. Do not advertise leftover
    // inns-1 410s (e.g. Over 5 after all-out) while Decimal still offers them.
    return 1;
    const mu = streamData?.market_update;
    const markets = mu?.markets ?? mu?.market_update?.markets;
    const fromMarkets = (0, _squaresOverOdds.getPlayableSquaresOverFromMarkets)(markets, cricketCurrentOver);
    let n = fromMarkets ?? null;
    if (n != null && lobbyInningsMaxOvers != null && Number.isFinite(lobbyInningsMaxOvers) && lobbyInningsMaxOvers > 0) n = Math.min(Number(n), lobbyInningsMaxOvers);
    return n != null && Number.isFinite(Number(n)) ? Number(n) : null;
}
function isSquaresGameOpenFromStream(fixture, streamData) {
    if (!(0, _squaresLobbyMatchUtils.isSquaresSupportedCricketFormat)(fixture, streamData)) return false;
    return getSquaresLobbyPlayOverNumber(fixture, streamData) != null;
}

},{"../../Trader/Cricket/decimalEventStatus":"f1nlI","../shared/squaresCommentaryToss":"gwyam","../shared/squaresPlayOpenWindow":"437C0","../shared/squaresOverOdds":"7MFo9","../../Cricket/cricketMatchCardOverDisplay":"jVYsA","./squaresLobbyMatchUtils":"j3UmL","../../Games/matchUtils":"9QY2j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwyam":[function(require,module,exports,__globalThis) {
/**
 * Delta feed: commentary payload shape `{ commentaries: { inns1: [{ ball, commentary, ... }], ... } }`.
 * Used to open Squares during TOSS PENDING only after a real toss text appears (rejects "0 won the toss").
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {unknown} commentary - `commentary` from socket / merged stream (may be null)
 * @returns {boolean} true if any commentary line indicates a team won the toss
 */ parcelHelpers.export(exports, "commentaryIndicatesTossWon", ()=>commentaryIndicatesTossWon);
var _squaresPlayOpenWindow = require("./squaresPlayOpenWindow");
function commentaryIndicatesTossWon(commentary) {
    return (0, _squaresPlayOpenWindow.commentaryIndicatesRealTossWon)(commentary);
}

},{"./squaresPlayOpenWindow":"437C0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"437C0":[function(require,module,exports,__globalThis) {
/**
 * When Squares accepts plays: real toss, or within N minutes of scheduled start
 * (or already in-play / overs under way).
 */ /** Must match backend `SQUARES_PLAY_OPENS_MINUTES_BEFORE_START`. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SQUARES_PLAY_OPENS_MINUTES_BEFORE_START", ()=>SQUARES_PLAY_OPENS_MINUTES_BEFORE_START);
/** Decimal often ships `"0 won the toss…"` before the real toss. */ parcelHelpers.export(exports, "isPlaceholderTossWinnerTeam", ()=>isPlaceholderTossWinnerTeam);
parcelHelpers.export(exports, "parseTossWinnerTeamFromText", ()=>parseTossWinnerTeamFromText);
/**
 * @param {unknown} commentary
 * @returns {boolean}
 */ parcelHelpers.export(exports, "commentaryIndicatesRealTossWon", ()=>commentaryIndicatesRealTossWon);
/**
 * @param {unknown} toss
 * @returns {boolean}
 */ parcelHelpers.export(exports, "scorecardTossConfirmed", ()=>scorecardTossConfirmed);
/**
 * @param {unknown} startDateTime
 * @param {number} [nowMs]
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isWithinSquaresPlayOpenCountdown", ()=>isWithinSquaresPlayOpenCountdown);
/**
 * @param {{
 *   commentary?: unknown,
 *   scorecardToss?: unknown,
 *   eventStatusInPlay?: boolean,
 *   oversUnderWay?: boolean,
 *   matchStartDateTime?: unknown,
 *   nowMs?: number,
 * }} input
 * @returns {boolean}
 */ parcelHelpers.export(exports, "squaresPlayOpenWindowFromFeeds", ()=>squaresPlayOpenWindowFromFeeds);
const SQUARES_PLAY_OPENS_MINUTES_BEFORE_START = 30;
const TOSS_WON_IN_COMMENTARY = /\b(won|wins|winning|win)\s+the\s+toss\b/i;
const TOSS_WON_RE = /^(.+?)\s+won the toss\b/i;
function normalizeTeamName(s) {
    return String(s ?? "").trim().toLowerCase().replace(/\s+/g, " ");
}
function isPlaceholderTossWinnerTeam(name) {
    const n = normalizeTeamName(name);
    if (!n) return true;
    if (n === "0" || n === "-" || n === "n/a" || n === "na" || n === "unknown" || n === "none" || n === "null") return true;
    return /^\d+$/.test(n);
}
function parseTossWinnerTeamFromText(text) {
    const raw = String(text ?? "").trim();
    if (!raw) return null;
    const m = raw.match(TOSS_WON_RE);
    const team = m ? m[1].trim() : null;
    if (!team || isPlaceholderTossWinnerTeam(team)) return null;
    return team;
}
function commentaryIndicatesRealTossWon(commentary) {
    const com = commentary?.commentaries;
    if (!com || typeof com !== "object" || Array.isArray(com)) return false;
    for (const key of Object.keys(com)){
        const arr = com[key];
        if (!Array.isArray(arr)) continue;
        for (const item of arr){
            const text = item?.commentary != null ? String(item.commentary) : "";
            if (!text || !TOSS_WON_IN_COMMENTARY.test(text)) continue;
            if (parseTossWinnerTeamFromText(text)) return true;
            const m = text.match(/^(.+?)\s+(?:won|wins|winning|win)\s+the\s+toss\b/i);
            if (m?.[1] && !isPlaceholderTossWinnerTeam(m[1])) return true;
        }
    }
    return false;
}
function scorecardTossConfirmed(toss) {
    if (toss == null) return false;
    if (typeof toss === "object" && !Array.isArray(toss)) {
        const won = toss.won != null ? String(toss.won).trim() : "";
        return Boolean(won && !isPlaceholderTossWinnerTeam(won));
    }
    const text = String(toss).trim();
    if (!text) return false;
    return parseTossWinnerTeamFromText(text) != null;
}
function isWithinSquaresPlayOpenCountdown(startDateTime, nowMs = Date.now()) {
    if (startDateTime == null || startDateTime === "") return false;
    const start = new Date(startDateTime).getTime();
    if (!Number.isFinite(start)) return false;
    const now = Number.isFinite(nowMs) ? nowMs : Date.now();
    return now >= start - SQUARES_PLAY_OPENS_MINUTES_BEFORE_START * 60000;
}
function squaresPlayOpenWindowFromFeeds(input = {}) {
    const { commentary, scorecardToss, eventStatusInPlay = false, oversUnderWay = false, matchStartDateTime = null, nowMs = Date.now() } = input;
    if (eventStatusInPlay || oversUnderWay) return true;
    if (commentaryIndicatesRealTossWon(commentary) || scorecardTossConfirmed(scorecardToss)) return true;
    return isWithinSquaresPlayOpenCountdown(matchStartDateTime, nowMs);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7MFo9":[function(require,module,exports,__globalThis) {
/**
 * Squares over odds: helpers to extract inputs from Decimal Over market (market_type_id 410).
 * Grid odds come from the backend only (POST /squares/calculate-over-odds): DB if locked, else generate+lock+persist.
 */ /** market_type_id for Decimal Over market used by Squares */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SQUARES_OVER_MARKET_TYPE_ID", ()=>SQUARES_OVER_MARKET_TYPE_ID);
/**
 * Extract over number from market 410 name (e.g. "Team Runs in Over 8" -> 8).
 * Accepts a market object (`market_name` / `name` / `over`) or a raw name string.
 */ parcelHelpers.export(exports, "getRunsInOverNumber", ()=>getRunsInOverNumber);
/**
 * Extract line (P4) from market: price.line, market.line, market_type prefix, name suffix, then
 * market_line_id only when it looks like a handicap (not a feed row id).
 */ parcelHelpers.export(exports, "getOverLineFromMarket", ()=>getOverLineFromMarket);
/**
 * Get Over selection decimal price (selection id 1) from market.
 * @param {object} market - Market object
 * @param {Map|object} marketPriceMap - Either a Map (key -> price) or a single price/market object to use when no Map
 */ parcelHelpers.export(exports, "getOverPriceFromMarket", ()=>getOverPriceFromMarket);
/**
 * Over index (1-based) for a 410 market: `over` field when set, else parsed from name.
 */ parcelHelpers.export(exports, "overNumberFromSquaresMarket", ()=>overNumberFromSquaresMarket);
/**
 * Set of 1-based over indices present in Squares Decimal Over (410) markets (from stream `market_update.markets`).
 */ parcelHelpers.export(exports, "getSquares410OverNumbersFromMarkets", ()=>getSquares410OverNumbersFromMarkets);
/**
 * Best lobby label over from 410 markets for Squares: only **current** and **next** over (not deeper futures).
 * - With `cricketCurrentOver` (1-based), prefers the smallest 410 over in `[current, current+1]` if present.
 * - Without anchor, falls back to the minimum 410 over in the payload (e.g. pre-match).
 * @param {Array|undefined} markets - `market_update.markets` from the events stream
 * @param {number|null|undefined} cricketCurrentOver - `Math.floor(full + part/6) + 1` from Current Innings Overs + Part Overs
 */ parcelHelpers.export(exports, "getPlayableSquaresOverFromMarkets", ()=>getPlayableSquaresOverFromMarkets);
/**
 * Pick preferred 410 market for a given over:
 * - consider all markets for that over
 * - keep only lines in [2.5, 21.5]
 * - choose price closest to 2.0 (deterministic tie-break: lower line first)
 */ parcelHelpers.export(exports, "selectPreferredOverMarketForOver", ()=>selectPreferredOverMarketForOver);
/**
 * Any playable 410 line (not tied to an over). Used at innings 0.0 / chase Over 1 when
 * Decimal still publishes leftover prior-over 410s until it lists Over 1 of the new innings.
 */ parcelHelpers.export(exports, "selectPreferredOverMarketAnyOver", ()=>selectPreferredOverMarketAnyOver);
/** Over-specific 410, else any leftover 410 when generating Over 1 at innings 0.0. */ parcelHelpers.export(exports, "selectSquares410MarketForOddsGrid", ()=>selectSquares410MarketForOddsGrid);
const SQUARES_OVER_MARKET_TYPE_ID = "410";
/** Handicap lines we accept for Squares 410 (matches selectPreferredOverMarketForOver filter). */ const SQUARES_RUNS_LINE_MIN = 2.5;
const SQUARES_RUNS_LINE_MAX = 21.5;
function marketNameForSquares(marketOrName) {
    if (marketOrName != null && typeof marketOrName === "object") return marketOrName.market_name ?? marketOrName.name ?? "";
    return marketOrName ?? "";
}
function isPlausibleSquaresRunsLine(n) {
    return Number.isFinite(n) && n >= SQUARES_RUNS_LINE_MIN && n <= SQUARES_RUNS_LINE_MAX;
}
function lineFromMarketTypePrefix(marketType) {
    if (!marketType) return null;
    const m = String(marketType).match(/^(\d+\.?\d*)\s/);
    return m ? parseFloat(m[1]) : null;
}
function lineFromNameSuffix(name, overNum) {
    if (!name) return null;
    const m = String(name).match(/(\d+\.?\d*)\s*$/);
    if (!m) return null;
    const parsed = parseFloat(m[1]);
    // "Team Runs in Over 12" — trailing integer is the over index, not the handicap line.
    if (overNum != null && Number.isFinite(overNum) && parsed === overNum) return null;
    return parsed;
}
function getRunsInOverNumber(nameOrMarket) {
    if (nameOrMarket != null && typeof nameOrMarket === "object") {
        const fromField = nameOrMarket.over != null && Number.isFinite(Number(nameOrMarket.over)) ? Number(nameOrMarket.over) : null;
        if (fromField != null && fromField >= 1) return fromField;
    }
    const name = marketNameForSquares(nameOrMarket);
    if (!name || typeof name !== "string") return null;
    const m = name.match(/Runs in Over\s+(\d+)/i);
    return m ? parseInt(m[1], 10) : null;
}
function getOverLineFromMarket(market, price, overNum) {
    const p = price ?? market;
    const priceLine = p?.line != null && p.line !== "" ? parseFloat(p.line) : NaN;
    if (Number.isFinite(priceLine) && priceLine !== 0 && isPlausibleSquaresRunsLine(priceLine)) return priceLine;
    const marketLine = market?.line != null && market.line !== "" ? parseFloat(market.line) : NaN;
    if (Number.isFinite(marketLine) && marketLine !== 0 && isPlausibleSquaresRunsLine(marketLine)) return marketLine;
    const handicap = market?.handicap != null && market.handicap !== "" ? parseFloat(market.handicap) : NaN;
    if (Number.isFinite(handicap) && handicap !== 0 && isPlausibleSquaresRunsLine(handicap)) return handicap;
    const fromType = lineFromMarketTypePrefix(market?.market_type);
    if (isPlausibleSquaresRunsLine(fromType)) return fromType;
    const fromName = lineFromNameSuffix(marketNameForSquares(market), overNum);
    if (isPlausibleSquaresRunsLine(fromName)) return fromName;
    const lid = market?.market_line_id;
    if (lid != null && lid !== "") {
        const parsed = parseFloat(String(lid));
        if (isPlausibleSquaresRunsLine(parsed)) return parsed;
    }
    return null;
}
function getOverPriceFromMarket(market, marketPriceMap) {
    const getMarketKey = (p)=>{
        const mid = p?.market_id != null ? String(p.market_id) : "";
        const lid = p?.market_line_id != null ? String(p.market_line_id) : "";
        if (mid && lid) return `${mid}_${lid}`;
        if (lid) return lid;
        return mid || "";
    };
    const price = marketPriceMap && typeof marketPriceMap.get === "function" ? marketPriceMap.get(getMarketKey(market)) || market : marketPriceMap || market;
    const sel = price?.selectionslist ?? price?.selections;
    const list = Array.isArray(sel) ? sel : [];
    const overSel = list.find((s)=>String(s?.id) === "1" || String(s?.selection_id) === "1") || list.find((s)=>/^over\b/i.test(String(s?.name ?? s?.["selection-name"] ?? "").trim()));
    if (!overSel) return null;
    const recommended = parseFloat(overSel?.recommended_price);
    if (Number.isFinite(recommended) && recommended >= 1) return recommended;
    const odds = parseFloat(overSel?.odds);
    return Number.isFinite(odds) && odds >= 1 ? odds : null;
}
function overNumberFromSquaresMarket(m) {
    const overNum = getRunsInOverNumber(m);
    if (overNum == null || !Number.isFinite(overNum) || overNum < 1) return null;
    return overNum;
}
function getSquares410OverNumbersFromMarkets(markets) {
    const overs = new Set();
    if (!Array.isArray(markets)) return overs;
    for (const m of markets){
        if (String(m?.market_type_id) !== SQUARES_OVER_MARKET_TYPE_ID) continue;
        const n = overNumberFromSquaresMarket(m);
        if (n != null) overs.add(n);
    }
    return overs;
}
function getPlayableSquaresOverFromMarkets(markets, cricketCurrentOver) {
    if (!Array.isArray(markets) || markets.length === 0) return null;
    const overs = new Set();
    for (const m of markets){
        if (String(m?.market_type_id) !== SQUARES_OVER_MARKET_TYPE_ID) continue;
        const n = overNumberFromSquaresMarket(m);
        if (n != null) overs.add(n);
    }
    if (overs.size === 0) return null;
    const sorted = [
        ...overs
    ].sort((a, b)=>a - b);
    if (cricketCurrentOver != null && Number.isFinite(cricketCurrentOver)) {
        const cur = cricketCurrentOver;
        const inWindow = sorted.filter((n)=>n >= cur && n <= cur + 1);
        if (inWindow.length > 0) return inWindow[0];
        const ge = sorted.find((n)=>n >= cur);
        if (ge != null) return ge;
    }
    return sorted[0];
}
/**
 * Pick preferred 410 market for a given over:
 * - consider all markets for that over
 * - keep only lines in [2.5, 21.5]
 * - choose price closest to 2.0 (deterministic tie-break: lower line first)
 */ function squares410MarketCandidates(markets, marketPriceMap, overNumFilter) {
    return (markets || []).filter((m)=>{
        if (String(m?.market_type_id) !== SQUARES_OVER_MARKET_TYPE_ID) return false;
        if (overNumFilter == null) return true;
        return overNumberFromSquaresMarket(m) === overNumFilter;
    }).map((market)=>{
        const priceObj = marketPriceMap && typeof marketPriceMap.get === "function" ? marketPriceMap.get((()=>{
            const mid = market?.market_id != null ? String(market.market_id) : "";
            const lid = market?.market_line_id != null ? String(market.market_line_id) : "";
            if (mid && lid) return `${mid}_${lid}`;
            if (lid) return lid;
            return mid || "";
        })()) || market : market;
        const overNum = overNumberFromSquaresMarket(market);
        const line = getOverLineFromMarket(market, priceObj, overNum);
        const price = getOverPriceFromMarket(market, marketPriceMap);
        return {
            market,
            line,
            price
        };
    }).filter((x)=>Number.isFinite(x.line) && x.line >= 2.5 && x.line <= 21.5 && Number.isFinite(x.price) && x.price >= 1);
}
function pickPreferredSquares410Candidate(candidates) {
    if (!candidates.length) return null;
    candidates.sort((a, b)=>{
        const d = Math.abs(a.price - 2.0) - Math.abs(b.price - 2.0);
        if (d !== 0) return d;
        return a.line - b.line;
    });
    return candidates[0];
}
function selectPreferredOverMarketForOver(markets, overNum, marketPriceMap) {
    return pickPreferredSquares410Candidate(squares410MarketCandidates(markets, marketPriceMap, overNum));
}
function selectPreferredOverMarketAnyOver(markets, marketPriceMap) {
    return pickPreferredSquares410Candidate(squares410MarketCandidates(markets, marketPriceMap, null));
}
function selectSquares410MarketForOddsGrid(markets, overNum, marketPriceMap, { atInningsOverZero = false } = {}) {
    const exact = selectPreferredOverMarketForOver(markets, overNum, marketPriceMap);
    if (exact) return exact;
    if (atInningsOverZero && Number(overNum) === 1) return selectPreferredOverMarketAnyOver(markets, marketPriceMap);
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6GOk1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _userContext = require("../../../Data/UserContext");
var _modal = require("../../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalCloseIcon = require("../../ModalCloseIcon");
var _loginSignupBanner = require("../../Trader/LoginSignupBanner");
var _loginSignupBannerDefault = parcelHelpers.interopDefault(_loginSignupBanner);
var _logos = require("../../shared/logos");
var _favouriteTeamStar = require("../../shared/FavouriteTeamStar");
var _decimalEventStatus = require("../../Trader/Cricket/decimalEventStatus");
var _frontendTrackingEvents = require("../../../utils/frontendTrackingEvents");
var _squaresApi = require("../shared/squaresApi");
var _squaresPrizePoolBadge = require("../shared/SquaresPrizePoolBadge");
var _squaresOverOdds = require("../shared/squaresOverOdds");
var _squaresCommentaryToss = require("../shared/squaresCommentaryToss");
var _squaresPlayOpenWindow = require("../shared/squaresPlayOpenWindow");
var _cricketMatchCardOverDisplay = require("../../Cricket/cricketMatchCardOverDisplay");
var _squaresConstants = require("../shared/squaresConstants");
var _prematchCountdownLabel = require("../../shared/ui/PrematchCountdownLabel");
var _lobbyActiveGamesSticker = require("../../shared/ui/LobbyActiveGamesSticker");
var _watchLiveButton = require("../../shared/ui/WatchLiveButton");
var _matchCountdown = require("../../../utils/matchCountdown");
var _cricketInnsTeamScores = require("../../../utils/cricketInnsTeamScores");
function isStreamLiveEventStatus(status) {
    const n = (0, _decimalEventStatus.eventStatusToNumber)(status);
    return n != null && (0, _decimalEventStatus.IN_PLAY_STATUS_IDS).includes(n);
}
const getCountdownText = (startValue)=>{
    if (!startValue) return "";
    const duration = (0, _matchCountdown.formatCountdownDuration)(new Date(startValue).getTime() - Date.now(), "upper");
    return duration || "SOON";
};
/** Delta scorecard `toss` — reject Decimal placeholders like "0 won the toss". */ function scorecardTossKnown(streamData) {
    return (0, _squaresPlayOpenWindow.scorecardTossConfirmed)(streamData?.scorecard?.toss);
}
const SquaresMatchCard = ({ fixture, streamData, challengePickMode = false, challengeCompactTeamRow = false, onChallengePick, challengeSending = false, challengeOtherSending = false, activeSquaresGamesCount = 0, hasStream = false, onWatchLive, /** League mode: open this URL instead of `/squares?match=`. */ playHref = "", /** League mode: force the lime CTA label (skips scheduled/toss gates). */ ctaLabel = "", /** League lobby: Sixes-like type (regular weight, smaller). */ dense = false })=>{
    const { user } = (0, _userContext.useUser)();
    const [liveBat, setLiveBat] = (0, _react.useState)("");
    const [scores, setScores] = (0, _react.useState)([
        "0/0",
        "0/0",
        "0/0",
        "0/0"
    ]);
    const [loginModal, setLoginModal] = (0, _react.useState)(false);
    const [tradingStatus, setTradingStatus] = (0, _react.useState)("");
    const [matchStart, setMatchStart] = (0, _react.useState)(()=>getCountdownText(fixture.start));
    /** Economy row for the lobby “open” over when match is IN-PLAY (replaces IN-PLAY pill). */ const [lobbyPoolEcon, setLobbyPoolEcon] = (0, _react.useState)(null);
    /** When IN-PLAY + pool loaded: alternate pill between 1st-place prize and IN-PLAY for lobby “juice”. */ const [lobbyJuiceShowsPrize, setLobbyJuiceShowsPrize] = (0, _react.useState)(true);
    const matchParts = (0, _react.useMemo)(()=>(fixture?.name || "").split(","), [
        fixture?.name
    ]);
    const competitionName = (0, _react.useMemo)(()=>fixture?.competition || "", [
        fixture?.competition
    ]);
    const teams = (0, _react.useMemo)(()=>(matchParts[0] || "").split(" v ").map((team)=>team.trim()).filter(Boolean), [
        matchParts
    ]);
    const headerIconWrapClass = dense ? "flex h-[30px] w-[30px] flex-shrink-0 items-center justify-center" : "flex h-[36px] w-[36px] flex-shrink-0 items-center justify-center p-2 md:h-[42px] md:w-[42px] box-border";
    const headerIconInnerClass = dense ? "flex h-4 w-4 items-center justify-center" : "flex h-[20px] w-[20px] items-center justify-center md:h-[26px] md:w-[26px]";
    const competitionClass = dense ? "min-w-0 flex-1 truncate font-chakra text-[10px] font-normal normal-case leading-none text-white" : "text-white font-chakra text-[14px] md:text-[16px] font-bold truncate normal-case min-w-0 flex-1";
    const teamRowClass = dense ? "flex h-[40px] items-center justify-between bg-white px-2" : "flex items-center justify-between bg-white px-3 py-1 md:px-4 md:py-2 h-[48px] md:h-[52px]";
    const teamNameClass = dense ? "min-w-0 truncate font-anton text-[14px] font-normal uppercase leading-none text-main" : "text-main font-anton text-[18px] md:text-[20px] font-bold truncate uppercase block min-w-0";
    const teamLogoSize = dense ? "32px" : "40px";
    const teamStarSize = dense ? 18 : 22;
    const teamScoreClass = dense ? "min-w-[32px] text-right font-chakra text-[12px] font-normal leading-none text-main tabular-nums" : `text-main ${0, _squaresConstants.SQUARES_LOBBY_MATCH_CARD_RIGHT_TEXT_CLASS} min-w-[40px] tabular-nums`;
    const fixtureStatusUpper = (0, _react.useMemo)(()=>(fixture?.status || "").toUpperCase(), [
        fixture?.status
    ]);
    const matchStatus = (0, _react.useMemo)(()=>{
        const rawFull = fixture?.status || "";
        const es = streamData?.market_update?.event_status ?? streamData?.event?.event_status;
        if ((0, _decimalEventStatus.eventStatusToNumber)(es) === (0, _decimalEventStatus.EVENT_STATUS).BREAK_IN_PLAY) return "BREAK IN PLAY";
        const rawStatus = rawFull.split(" - ")[0] || "";
        let normalized = rawStatus.replace(/\s*\(.*?\)\s*/g, "").trim();
        if (rawFull.includes("Match in Progress")) normalized = "IN-PLAY";
        if (fixtureStatusUpper.includes("BREAK IN PLAY")) normalized = "BREAK IN PLAY";
        return normalized;
    }, [
        fixture?.status,
        fixtureStatusUpper,
        streamData?.market_update?.event_status,
        streamData?.event?.event_status
    ]);
    const isClosed = (0, _react.useMemo)(()=>{
        const upper = (matchStatus || "").toUpperCase();
        return upper.startsWith("CANCELLED") || upper.startsWith("MATCH ABANDONED") || upper.startsWith("MATCH COMPLETE") || upper.startsWith("EVENT CLOSED");
    }, [
        matchStatus
    ]);
    const isInPlay = matchStatus === "IN-PLAY";
    const isTossPendingList = fixtureStatusUpper.startsWith("TOSS PENDING") || fixtureStatusUpper.startsWith("TOSS DELAYED") || fixtureStatusUpper.includes("TOSS PENDING") || fixtureStatusUpper.includes("TOSS DELAYED");
    const streamEventStatus = (0, _react.useMemo)(()=>{
        const mu = streamData?.market_update;
        if (!mu) return null;
        if (mu.event_status != null && mu.event_status !== "") return mu.event_status;
        return mu.market_update?.event_status ?? null;
    }, [
        streamData?.market_update
    ]);
    const isStreamInPlayPhase = (0, _react.useMemo)(()=>isStreamLiveEventStatus(streamEventStatus), [
        streamEventStatus
    ]);
    const tossKnownFromCommentary = (0, _react.useMemo)(()=>(0, _squaresCommentaryToss.commentaryIndicatesTossWon)(streamData?.commentary), [
        streamData
    ]);
    const scorecardToss = (0, _react.useMemo)(()=>scorecardTossKnown(streamData), [
        streamData
    ]);
    /**
   * TOSS PENDING (fixture list): only commentary with “won/wins the toss” opens Squares (not scorecard.toss alone).
   * Other states: commentary or scorecard toss, plus in-play paths below.
   */ const tossAllowsSquaresPlay = (0, _react.useMemo)(()=>{
        if (isTossPendingList) return tossKnownFromCommentary;
        return tossKnownFromCommentary || scorecardToss;
    }, [
        isTossPendingList,
        tossKnownFromCommentary,
        scorecardToss
    ]);
    /** Playable once toss is confirmed, within T-30 of start, or match is in-play. */ const livePhaseForSquares = (0, _react.useMemo)(()=>{
        if (isClosed) return false;
        return isInPlay || matchStatus === "BREAK IN PLAY" || isStreamInPlayPhase || tossAllowsSquaresPlay || (0, _squaresPlayOpenWindow.isWithinSquaresPlayOpenCountdown)(fixture?.start);
    }, [
        isClosed,
        isInPlay,
        matchStatus,
        isStreamInPlayPhase,
        tossAllowsSquaresPlay,
        fixture?.start
    ]);
    const tradingOpen = (0, _decimalEventStatus.isGlobalMatchTradingActive)(tradingStatus);
    const hasTradingSignal = tradingStatus != null && tradingStatus !== "";
    /** Block when the match feed marks trading closed and we are not in a playable phase. */ const blockPlaySquares = hasTradingSignal && !tradingOpen && !livePhaseForSquares;
    const isMatchScheduledOnly = !livePhaseForSquares && !fixtureStatusUpper.startsWith("CANCELLED") && !fixtureStatusUpper.includes("MATCH ABANDONED") && (fixtureStatusUpper.includes("MATCH SCHEDULED") || matchStatus.toUpperCase() === "MATCH SCHEDULED");
    /** Max legal overs for the innings (stream “Max Overs” or T20/ODI from fixture list). Used to cap lobby CTA over. */ const lobbyInningsMaxOvers = (0, _react.useMemo)(()=>(0, _cricketMatchCardOverDisplay.maxOversFromStreamEvent)(streamData) ?? (0, _cricketMatchCardOverDisplay.maxOversFromFixtureFormat)(fixture?.format), [
        streamData,
        fixture?.format
    ]);
    /**
   * Cricket current over (1-based): floor(full + part/6) + 1 from scoreboard.
   * When the feed reports a completed innings as full=20 part=0, that formula returns 21 (past the last over of a T20).
   * Clamp to max overs so the lobby never shows “PLAY OVER 21” after 20/20 in the first innings.
   */ const cricketCurrentOver = (0, _react.useMemo)(()=>{
        if (!livePhaseForSquares || !streamData?.event) return null;
        const eventObj = streamData.event?.event ?? streamData.event;
        const raw = (0, _cricketMatchCardOverDisplay.cricketCurrentOver1BasedFromScoreboard)(eventObj?.scoreboard);
        if (raw == null) return null;
        const cap = lobbyInningsMaxOvers;
        if (cap != null && Number.isFinite(cap) && cap > 0) return Math.min(raw, cap);
        return raw;
    }, [
        livePhaseForSquares,
        streamData?.event,
        lobbyInningsMaxOvers
    ]);
    /** Over with an open 410 market (what Squares actually accepts). Never fall back to scoreboard-only over. */ const playOverNumber = (0, _react.useMemo)(()=>{
        if (!livePhaseForSquares) return null;
        const mu = streamData?.market_update;
        const markets = mu?.markets ?? mu?.market_update?.markets;
        const overs410 = (0, _squaresOverOdds.getSquares410OverNumbersFromMarkets)(markets);
        const fromMarkets = (0, _squaresOverOdds.getPlayableSquaresOverFromMarkets)(markets, cricketCurrentOver);
        let n = fromMarkets ?? null;
        const cap = lobbyInningsMaxOvers;
        if (n != null && cap != null && Number.isFinite(cap) && cap > 0) n = Math.min(Number(n), cap);
        const eventObj = streamData?.event?.event ?? streamData?.event;
        const inningsOversDec = (0, _cricketMatchCardOverDisplay.cricketInningsOversDecimalFromScoreboard)(eventObj?.scoreboard);
        const max = lobbyInningsMaxOvers;
        if (inningsOversDec != null && max != null && Number.isFinite(max) && max > 0 && inningsOversDec >= max) {
            if (overs410.has(1)) return 1;
            return null;
        }
        return n;
    }, [
        livePhaseForSquares,
        streamData?.market_update,
        streamData?.event,
        cricketCurrentOver,
        streamEventStatus,
        lobbyInningsMaxOvers
    ]);
    const isBreakInPlay = (0, _decimalEventStatus.eventStatusToNumber)(streamEventStatus) === (0, _decimalEventStatus.EVENT_STATUS).BREAK_IN_PLAY;
    const statusText = (0, _react.useMemo)(()=>{
        if (isClosed) return "FINISHED";
        if (isTossPendingList && !tossKnownFromCommentary) return "TOSS PENDING";
        if (isTossPendingList && tossKnownFromCommentary) return "PRE-MATCH";
        if (isMatchScheduledOnly) return "SCHEDULED";
        if (livePhaseForSquares && isBreakInPlay) return "BREAK IN PLAY";
        if (isInPlay || livePhaseForSquares && !isMatchScheduledOnly) return "IN-PLAY";
        if (blockPlaySquares) return matchStart === "SOON" ? "STARTING SOON" : `STARTS IN ${matchStart}`;
        if (matchStatus.toUpperCase() === "MATCH SCHEDULED") return matchStart === "SOON" ? "STARTING SOON" : matchStart ? `STARTS IN ${matchStart}` : "MATCH SCHEDULED";
        return matchStatus || "";
    }, [
        isClosed,
        isTossPendingList,
        tossKnownFromCommentary,
        isMatchScheduledOnly,
        livePhaseForSquares,
        isBreakInPlay,
        isInPlay,
        blockPlaySquares,
        matchStart,
        matchStatus
    ]);
    const statusColor = isTossPendingList && !isClosed ? "text-lime" : livePhaseForSquares && isBreakInPlay && !isClosed ? "text-[#a855f7]" : isInPlay || isStreamInPlayPhase ? "text-pink" : "text-white";
    const inningsForLobbyPool = (0, _react.useMemo)(()=>{
        const raw = streamData?.scorecard?.inns_now;
        const n = parseInt(String(raw ?? "1"), 10);
        return Number.isFinite(n) && n >= 1 ? n : 1;
    }, [
        streamData?.scorecard?.inns_now
    ]);
    (0, _react.useEffect)(()=>{
        if (!fixture?.match_id || statusText !== "IN-PLAY") {
            setLobbyPoolEcon(null);
            return;
        }
        const overNum = playOverNumber;
        if (overNum == null || !Number.isFinite(Number(overNum)) || Number(overNum) < 1) {
            setLobbyPoolEcon(null);
            return;
        }
        let cancelled = false;
        const tid = setTimeout(()=>{
            const curHint = cricketCurrentOver != null && Number.isFinite(Number(cricketCurrentOver)) ? Math.floor(Number(cricketCurrentOver)) : Math.floor(Number(overNum));
            const params = new URLSearchParams({
                matchId: String(fixture.match_id),
                inningsNumber: String(inningsForLobbyPool),
                currentOverNumber: String(Math.max(1, curHint)),
                bootstrap: "1"
            });
            const fmt = fixture?.format;
            if (fmt != null && String(fmt).trim() !== "") {
                const fn = parseInt(String(fmt), 10);
                if (Number.isFinite(fn)) params.set("format", String(fn));
            }
            (0, _squaresApi.fetchSquaresMatchOverPlays)(params).then((data)=>{
                if (cancelled) return;
                const on = Math.floor(Number(overNum));
                const econ = data?.over_economy?.[String(on)] ?? data?.over_economy?.[on];
                const pc = econ?.pool_entrant_count;
                if (pc != null && Number.isFinite(Number(pc))) setLobbyPoolEcon({
                    pool_entrant_count: Number(pc)
                });
                else setLobbyPoolEcon(null);
            }).catch(()=>{
                if (!cancelled) setLobbyPoolEcon(null);
            });
        }, 400);
        return ()=>{
            cancelled = true;
            clearTimeout(tid);
        };
    }, [
        fixture?.match_id,
        fixture?.format,
        statusText,
        playOverNumber,
        cricketCurrentOver,
        inningsForLobbyPool
    ]);
    (0, _react.useEffect)(()=>{
        if (lobbyPoolEcon != null) setLobbyJuiceShowsPrize(true);
    }, [
        lobbyPoolEcon?.pool_entrant_count
    ]);
    (0, _react.useEffect)(()=>{
        if (statusText !== "IN-PLAY" || lobbyPoolEcon == null) return undefined;
        const id = setInterval(()=>setLobbyJuiceShowsPrize((v)=>!v), 2400);
        return ()=>clearInterval(id);
    }, [
        statusText,
        lobbyPoolEcon
    ]);
    const ovDisplayLabel = (0, _react.useMemo)(()=>livePhaseForSquares ? (0, _cricketMatchCardOverDisplay.getCricketMatchCardOvLabel)(streamData, fixture?.format) : null, [
        livePhaseForSquares,
        streamData,
        fixture?.format
    ]);
    const scoreRef = (0, _react.useRef)(scores);
    (0, _react.useEffect)(()=>{
        scoreRef.current = scores;
    }, [
        scores
    ]);
    (0, _react.useEffect)(()=>{
        setMatchStart(getCountdownText(fixture.start));
    }, [
        fixture.start
    ]);
    /** Keep OPENS IN countdown moving for scheduled lobby cards (stream may be light). */ (0, _react.useEffect)(()=>{
        if (!isMatchScheduledOnly || isClosed || !fixture?.start) return;
        const src = fixture.start;
        const tick = ()=>setMatchStart(getCountdownText(src));
        tick();
        const id = setInterval(tick, 30000);
        return ()=>clearInterval(id);
    }, [
        isMatchScheduledOnly,
        isClosed,
        fixture?.start
    ]);
    (0, _react.useEffect)(()=>{
        if (!streamData) return;
        if (streamData.match_update) {
            if (streamData.match_update.betting_status != null && streamData.match_update.betting_status !== "") setTradingStatus(streamData.match_update.betting_status);
            if (streamData.match_update.start_datetime) setMatchStart(getCountdownText(streamData.match_update.start_datetime));
        }
        const muBs = streamData.market_update?.betting_status ?? streamData.market_update?.market_update?.betting_status;
        if (muBs != null && muBs !== "") setTradingStatus(muBs);
        if (!streamData.scorecard || teams.length < 2) return;
        const sc = (0, _cricketInnsTeamScores.unwrapCricketScorecard)(streamData.scorecard);
        if (!sc) return;
        const { scores: nextScore, batNow: nextLiveBat } = (0, _cricketInnsTeamScores.mapCricketInnsScoresToTeams)(sc, teams);
        setLiveBat(nextLiveBat);
        const prev = scoreRef.current;
        const nextEmpty = [
            nextScore[0],
            nextScore[1]
        ].every((s)=>s === "0/0" || s === "-" || !s);
        const prevHasData = [
            prev[0],
            prev[1]
        ].some((s)=>s && s !== "0/0" && s !== "-");
        if (nextEmpty && prevHasData) return;
        if (prev[0] !== nextScore[0] || prev[1] !== nextScore[1] || prev[2] !== nextScore[2] || prev[3] !== nextScore[3]) setScores(nextScore);
    }, [
        streamData,
        teams
    ]);
    const handlePlaySquares = (0, _react.useCallback)(()=>{
        if (playHref) {
            if (user) {
                (0, _frontendTrackingEvents.trackMatchCardGameEntry)({
                    user_id: user.userId,
                    game_type: "squares",
                    fixture_id: fixture.match_id,
                    sport: "cricket",
                    competition_name: competitionName || undefined,
                    cta_location: "squares_lobby",
                    target_url: playHref
                });
                window.location.href = playHref;
                return;
            }
            setLoginModal(true);
            return;
        }
        if (isClosed || blockPlaySquares || !livePhaseForSquares) return;
        if (challengePickMode && onChallengePick) {
            if (challengeSending || challengeOtherSending) return;
            onChallengePick();
            return;
        }
        if (user) {
            (0, _frontendTrackingEvents.trackMatchCardGameEntry)({
                user_id: user.userId,
                game_type: "squares",
                fixture_id: fixture.match_id,
                sport: "cricket",
                competition_name: competitionName || undefined,
                cta_location: "squares_lobby",
                target_url: `/squares?match=${fixture.match_id}`
            });
            window.location.href = `/squares?match=${fixture.match_id}`;
            return;
        }
        setLoginModal(true);
    }, [
        challengeOtherSending,
        challengePickMode,
        challengeSending,
        competitionName,
        fixture.match_id,
        isClosed,
        blockPlaySquares,
        livePhaseForSquares,
        onChallengePick,
        playHref,
        user
    ]);
    const gamesStickerEl = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lobbyActiveGamesSticker.LobbyActiveGamesSticker), {
        count: activeSquaresGamesCount,
        avatarSrc: user?.avatar || "/img/avatar.png",
        xpWeekCrown: user?.xp_week_crown,
        labelSingular: "Play",
        labelPlural: "Plays"
    });
    const renderAction = ()=>{
        if (playHref) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "relative flex items-center h-full",
            id: "aa",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bg-lime hover:bg-limehover text-main font-anton text-[12px] leading-[18px] px-3 md:px-4 py-0 uppercase whitespace-nowrap min-w-[80px] md:min-w-[120px] flex items-center justify-center self-stretch cursor-pointer",
                style: {
                    letterSpacing: "0%",
                    textAlign: "center"
                },
                onClick: handlePlaySquares,
                role: "button",
                tabIndex: 0,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handlePlaySquares();
                    }
                },
                children: ctaLabel || "PLAY"
            })
        });
        if (isClosed) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "relative flex items-center h-full",
            id: "aa",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "bg-lime hover:bg-limehover text-main font-anton text-[12px] leading-[18px] px-3 md:px-4 py-0 uppercase whitespace-nowrap min-w-[80px] md:min-w-[120px] flex items-center justify-center self-stretch",
                style: {
                    letterSpacing: "0%",
                    textAlign: "center"
                },
                children: "MATCH COMPLETED"
            })
        });
        if (isMatchScheduledOnly) {
            const opensDisplay = matchStart === "SOON" ? "OPENS SOON" : `OPENS IN ${matchStart || "\u2014"}`;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "relative flex items-center h-full pl-0 pr-1 md:pr-1.5",
                id: "aa",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: `${(0, _squaresConstants.SQUARES_LOBBY_MATCH_CARD_RIGHT_TEXT_CLASS)} text-lime whitespace-nowrap tabular-nums`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prematchCountdownLabel.PrematchCountdownLabel), {
                        text: opensDisplay
                    })
                })
            });
        }
        if (isTossPendingList && !tossKnownFromCommentary && !isClosed) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "relative flex items-center h-full pl-0 pr-1 md:pr-1.5",
            id: "aa",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `${(0, _squaresConstants.SQUARES_LOBBY_MATCH_CARD_RIGHT_TEXT_CLASS)} text-white/90 whitespace-nowrap`,
                children: "AWAITING TOSS"
            })
        });
        if (blockPlaySquares) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "relative flex items-center h-full",
            id: "aa",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bg-lime hover:bg-limehover text-main font-anton text-[12px] leading-[18px] px-3 md:px-4 py-0 uppercase whitespace-nowrap min-w-[80px] md:min-w-[120px] flex items-center justify-center self-stretch",
                style: {
                    letterSpacing: "0%",
                    textAlign: "center"
                },
                onClick: handlePlaySquares,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prematchCountdownLabel.PrematchCountdownLabel), {
                    text: matchStart === "SOON" ? "STARTS SOON" : `STARTS IN ${matchStart}`
                })
            })
        });
        const challengeCtaDisabled = challengePickMode && (challengeSending || challengeOtherSending);
        const challengeCtaLabel = challengeSending ? "SENDING\u2026" : playOverNumber != null ? `CHALLENGE \xb7 OVER ${playOverNumber}` : "CHALLENGE";
        const playCtaLabel = playOverNumber != null ? `PLAY OVER ${playOverNumber}` : "GAME NOT OPEN YET";
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "relative flex items-center h-full",
            id: "aa",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `bg-lime text-main font-anton text-[12px] leading-[18px] px-3 md:px-4 py-0 uppercase whitespace-nowrap min-w-[80px] md:min-w-[120px] flex items-center justify-center self-stretch ${challengeCtaDisabled ? "cursor-not-allowed opacity-60" : "hover:bg-limehover cursor-pointer"}`,
                style: {
                    letterSpacing: "0%",
                    textAlign: "center"
                },
                onClick: handlePlaySquares,
                role: "button",
                tabIndex: 0,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handlePlaySquares();
                    }
                },
                children: challengePickMode ? challengeCtaLabel : playCtaLabel
            })
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "bg-mainH border border-main60 w-full overflow-visible",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "relative z-10 flex items-stretch justify-between overflow-visible pb-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2 flex-1 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: headerIconWrapClass,
                                        style: {
                                            backgroundColor: "#3F1A6D"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: headerIconInnerClass,
                                            "aria-hidden": true,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: "/assets/cricket.webp",
                                                alt: "",
                                                className: "block h-full w-full min-h-0 min-w-0 object-contain object-center",
                                                loading: "lazy",
                                                decoding: "async",
                                                draggable: false
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: competitionClass,
                                        children: competitionName || "SQUARES"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `relative z-10 flex items-center flex-shrink-0 overflow-visible ${isMatchScheduledOnly ? "gap-0.5" : statusText === "IN-PLAY" && lobbyPoolEcon != null ? "gap-1" : "gap-1.5"}`,
                                children: [
                                    statusText === "IN-PLAY" && lobbyPoolEcon != null ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: `${(0, _squaresConstants.SQUARES_LOBBY_MATCH_CARD_RIGHT_TEXT_CLASS)} inline-grid max-w-[min(220px,70vw)] flex-shrink-0 grid-cols-1 grid-rows-1 rounded-full px-2 py-1 ${statusColor}`,
                                        "aria-label": "Match live; first place prize rotates in this pill",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `col-start-1 row-start-1 flex w-full min-w-0 items-center justify-end transition-opacity duration-500 ease-in-out ${lobbyJuiceShowsPrize ? "z-[1] opacity-100" : "pointer-events-none opacity-0"}`,
                                                "aria-hidden": !lobbyJuiceShowsPrize,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _squaresPrizePoolBadge.SquaresPrizePoolBadge), {
                                                    econ: lobbyPoolEcon,
                                                    className: "text-[9px] sm:text-[10px] md:text-[11px]"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `col-start-1 row-start-1 flex w-full items-center justify-end transition-opacity duration-500 ease-in-out ${lobbyJuiceShowsPrize ? "pointer-events-none opacity-0" : "z-[1] opacity-100"}`,
                                                "aria-hidden": lobbyJuiceShowsPrize,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-nowrap",
                                                    children: "MATCH LIVE"
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prematchCountdownLabel.PrematchCountdownLabel), {
                                        text: statusText,
                                        className: `${(0, _squaresConstants.SQUARES_LOBBY_MATCH_CARD_RIGHT_TEXT_CLASS)} whitespace-nowrap inline-flex items-center px-2 py-0.5 rounded-full ${statusColor}`
                                    }),
                                    hasStream && livePhaseForSquares && onWatchLive ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _watchLiveButton.WatchLiveButton), {
                                        fixtureId: String(fixture?.match_id ?? ""),
                                        ctaLocation: "squares_lobby",
                                        onClick: onWatchLive
                                    }) : null,
                                    renderAction(),
                                    gamesStickerEl
                                ]
                            })
                        ]
                    }),
                    challengePickMode && challengeCompactTeamRow && teams.length >= 2 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-full h-[1px] bg-main"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex w-full min-h-[44px] items-center gap-1.5 bg-white px-2 py-2 md:min-h-[48px] md:gap-2 md:px-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logos.CricketTeamLogo), {
                                            teamName: teams[0],
                                            width: "36px",
                                            height: "36px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex min-w-0 flex-1 items-center justify-end gap-1 overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "min-w-0 truncate text-right font-anton text-[14px] font-bold uppercase text-main md:text-[16px]",
                                                children: teams[0]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _favouriteTeamStar.FavouriteTeamStar), {
                                                teamName: teams[0],
                                                size: 20
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "flex-shrink-0 font-anton text-[11px] font-bold uppercase text-main/70 md:text-[12px]",
                                        "aria-hidden": true,
                                        children: "V"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex min-w-0 flex-1 items-center gap-1 overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _favouriteTeamStar.FavouriteTeamStar), {
                                                teamName: teams[1],
                                                size: 20
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "min-w-0 truncate text-left font-anton text-[14px] font-bold uppercase text-main md:text-[16px]",
                                                children: teams[1]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logos.CricketTeamLogo), {
                                            teamName: teams[1],
                                            width: "36px",
                                            height: "36px"
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : teams.length > 0 ? teams.slice(0, 2).map((team, idx)=>{
                        const displayScore = idx === 0 ? scores[0] : scores[1];
                        const isBatting = livePhaseForSquares && liveBat === team;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "w-full h-[1px] bg-main"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: teamRowClass,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-3 flex-1 min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-shrink-0 mt-1 md:mt-0",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logos.CricketTeamLogo), {
                                                        teamName: team,
                                                        width: teamLogoSize,
                                                        height: teamLogoSize
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex items-center gap-1.5 flex-1 min-w-0 overflow-hidden",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: teamNameClass,
                                                            children: team
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _favouriteTeamStar.FavouriteTeamStar), {
                                                            teamName: team,
                                                            size: teamStarSize
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-1.5 flex-shrink-0",
                                            children: [
                                                isBatting && ovDisplayLabel != null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: `text-main/65 ${(0, _squaresConstants.SQUARES_LOBBY_MATCH_CARD_RIGHT_TEXT_CLASS)} tabular-nums`,
                                                    title: "Current over / max overs (innings)",
                                                    children: ovDisplayLabel
                                                }) : null,
                                                isBatting && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "relative flex-shrink-0 w-[12px] h-[12px] flex items-center justify-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "absolute w-[10px] h-[10px] rounded-full pulse-pink-glow",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "relative z-10 w-[8px] h-[8px] bg-pink rounded-full"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: teamScoreClass,
                                                    children: displayScore || "0/0"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `${fixture.match_id}-${team}`);
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-full h-[1px] bg-main",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-white font-chakra text-[12px] p-2",
                            children: fixture.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                isOpen: loginModal,
                onRequestClose: ()=>setLoginModal(false),
                style: {
                    overlay: {
                        backgroundColor: "rgba(27, 6, 47, 0.7)"
                    },
                    content: {
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -50%)",
                        width: "100%",
                        maxWidth: "400px",
                        background: "transparent",
                        border: "none",
                        padding: "0"
                    }
                },
                contentLabel: "Login or Sign Up",
                ariaHideApp: false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "absolute top-2 right-2 cursor-pointer bg-white hover:bg-gray-100 rounded-none p-1.5 flex items-center justify-center shadow-lg transition-colors z-10",
                            onClick: ()=>setLoginModal(false),
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalCloseIcon.ModalCloseIcon), {
                                width: 28,
                                height: 28,
                                fill: "#1b062f"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginSignupBannerDefault.default), {
                            deeplink: playHref || `/squares?match=${fixture.match_id}`
                        })
                    ]
                })
            })
        ]
    });
};
const areEqual = (prevProps, nextProps)=>{
    const p = prevProps.fixture || {};
    const n = nextProps.fixture || {};
    if (p.match_id !== n.match_id || p.name !== n.name || p.status !== n.status || p.start !== n.start || p.competition !== n.competition || p.format !== n.format) return false;
    if (prevProps.challengePickMode !== nextProps.challengePickMode) return false;
    if (prevProps.challengeCompactTeamRow !== nextProps.challengeCompactTeamRow) return false;
    if (prevProps.challengeSending !== nextProps.challengeSending) return false;
    if (prevProps.challengeOtherSending !== nextProps.challengeOtherSending) return false;
    if (prevProps.activeSquaresGamesCount !== nextProps.activeSquaresGamesCount) return false;
    if (prevProps.dense !== nextProps.dense) return false;
    return prevProps.streamData === nextProps.streamData;
};
exports.default = /*#__PURE__*/ (0, _reactDefault.default).memo(SquaresMatchCard, areEqual);

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../../Data/UserContext":"aqd8b","../../Modal":"2Ei4y","../../ModalCloseIcon":"aricC","../../Trader/LoginSignupBanner":"5vl8x","../../shared/logos":"4XCsm","../../shared/FavouriteTeamStar":"6kcuk","../../Trader/Cricket/decimalEventStatus":"f1nlI","../../../utils/frontendTrackingEvents":"4Y90p","../shared/squaresApi":"aMqbW","../shared/SquaresPrizePoolBadge":"f7v7n","../shared/squaresOverOdds":"7MFo9","../shared/squaresCommentaryToss":"gwyam","../shared/squaresPlayOpenWindow":"437C0","../../Cricket/cricketMatchCardOverDisplay":"jVYsA","../shared/squaresConstants":"9tbpY","../../shared/ui/PrematchCountdownLabel":"rwZ3c","../../shared/ui/LobbyActiveGamesSticker":"gCUBA","../../shared/ui/WatchLiveButton":"Vn0go","../../../utils/matchCountdown":"hzPTj","../../../utils/cricketInnsTeamScores":"4117b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5vl8x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _loginSignupCopy = require("../shared/loginSignupCopy");
var _ftpDisclaimer = require("../shared/FtpDisclaimer");
var _authBackPath = require("../../utils/authBackPath");
/** @param {{ isTradeSlip?: boolean, compact?: boolean, message?: string, deeplink?: string | null }} props — isTradeSlip: render inside the trade slip modal; compact: match-page gate (no extra top margin) */ const LoginSignupBanner = ({ isTradeSlip = false, compact = false, message = (0, _loginSignupCopy.SIGNUP_LOGIN_POPUP_MESSAGE), deeplink = null })=>{
    const location = (0, _reactRouterDom.useLocation)();
    const back = (0, _react.useMemo)(()=>deeplink || (0, _authBackPath.locationAuthBackPath)(location.pathname, location.search), [
        deeplink,
        location.pathname,
        location.search
    ]);
    const loginHref = (0, _authBackPath.buildAuthHref)("login", {
        back
    });
    const signupHref = (0, _authBackPath.buildAuthHref)("signup", {
        back
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `bg-white border border-solid border-main ${compact ? "p-3 md:p-4" : "p-[15px]"} ${!isTradeSlip && !compact ? "mt-[30px]" : ""} ${isTradeSlip ? "border-t-0" : ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `text-center ${compact ? "mb-3" : "mb-[20px]"}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: `font-anton uppercase text-main ${compact ? "text-[12px] md:text-[13px] leading-snug" : "text-[14px] md:text-[16px]"}`,
                    children: message
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: loginHref,
                        className: `flex-1 bg-lime hover:bg-limehover font-anton text-center uppercase cursor-pointer transition-colors text-main ${compact ? "text-[12px] md:text-[13px] px-3 py-2 md:py-2.5" : "text-[14px] md:text-[16px] px-[20px] py-[10px] md:py-[12px]"}`,
                        children: "LOGIN"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: signupHref,
                        className: `flex-1 bg-lime hover:bg-limehover font-anton text-center uppercase cursor-pointer transition-colors text-main ${compact ? "text-[12px] md:text-[13px] px-3 py-2 md:py-2.5" : "text-[14px] md:text-[16px] px-[20px] py-[10px] md:py-[12px]"}`,
                        children: "SIGN UP"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ftpDisclaimer.FtpDisclaimer), {
                text: (0, _loginSignupCopy.SIGNUP_LOGIN_POPUP_DISCLAIMER),
                className: "mt-3 text-center text-main/60"
            })
        ]
    });
};
exports.default = LoginSignupBanner;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../shared/loginSignupCopy":"pyqc8","../shared/FtpDisclaimer":"hC20Z","../../utils/authBackPath":"2oqPm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hC20Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Shared free-to-play / no-cash-value disclaimer for wallets, modals, and lobbies. */ parcelHelpers.export(exports, "FtpDisclaimer", ()=>FtpDisclaimer);
var _jsxRuntime = require("react/jsx-runtime");
var _virtualCurrencyDisclaimer = require("../../utils/virtualCurrencyDisclaimer");
const DEFAULT_CLASS = "font-chakra text-[11px] font-normal leading-snug tracking-normal normal-case sm:text-[12px]";
function FtpDisclaimer({ variant = "short", text, className = "" }) {
    const defaultText = variant === "compact" ? (0, _virtualCurrencyDisclaimer.FTP_DISCLAIMER_COMPACT) : (0, _virtualCurrencyDisclaimer.FTP_DISCLAIMER_SHORT);
    const displayText = text ?? defaultText;
    const alignmentClass = /\btext-(left|right|center|start|end)\b/.test(className) ? "" : "text-center";
    const colorClass = /\btext-/.test(className) ? "" : "text-white/55";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: `${DEFAULT_CLASS} ${colorClass} ${alignmentClass} ${className}`.trim(),
        children: displayText
    });
}

},{"react/jsx-runtime":"gaGEj","../../utils/virtualCurrencyDisclaimer":"eHHb8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6kcuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Star toggle to favourite a team in-context (match cards / scoreboards).
 * Logged-out users see the empty star and are sent to sign up to follow the team.
 * Stops click propagation so it never triggers the surrounding card/link navigation.
 * Desktop: tooltip on hover. Mobile: tooltip on tap (confirmation after toggle).
 */ parcelHelpers.export(exports, "FavouriteTeamStar", ()=>FavouriteTeamStar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactRouterDom = require("react-router-dom");
var _useFavouriteTeams = require("../../Data/useFavouriteTeams");
var _pendingFavouriteTeam = require("../../utils/pendingFavouriteTeam");
const HOVER_MQ = "(hover: hover) and (pointer: fine)";
const TOOLTIP_GAP_PX = 8;
const TOOLTIP_VIEWPORT_PAD_PX = 8;
const TOUCH_TOOLTIP_MS = 4500;
function useCanHover() {
    const [canHover, setCanHover] = (0, _react.useState)(()=>{
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
        return window.matchMedia(HOVER_MQ).matches;
    });
    (0, _react.useEffect)(()=>{
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
        const mq = window.matchMedia(HOVER_MQ);
        const apply = ()=>setCanHover(mq.matches);
        apply();
        mq.addEventListener("change", apply);
        return ()=>mq.removeEventListener("change", apply);
    }, []);
    return canHover;
}
function favouriteStarWillDoHint(canFavourite, active, name) {
    if (!canFavourite) return `Sign up to follow ${name}`;
    return active ? `Remove ${name} from your favourite teams` : `Add ${name} to your favourite teams`;
}
function FavouriteTeamStar({ teamName, size = 24, className = "", color = "#FFC02E" }) {
    const { canFavourite, isFavourite, toggle } = (0, _useFavouriteTeams.useFavouriteTeams)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const canHover = useCanHover();
    const [busy, setBusy] = (0, _react.useState)(false);
    const [tooltipOpen, setTooltipOpen] = (0, _react.useState)(false);
    const [touchMessage, setTouchMessage] = (0, _react.useState)(null);
    const [coords, setCoords] = (0, _react.useState)(null);
    const btnRef = (0, _react.useRef)(null);
    const tooltipRef = (0, _react.useRef)(null);
    const lastPointerTypeRef = (0, _react.useRef)("mouse");
    const tooltipId = (0, _react.useId)();
    const name = String(teamName || "").trim();
    const active = canFavourite && isFavourite(name);
    const willDoHint = favouriteStarWillDoHint(canFavourite, active, name);
    const tooltipText = touchMessage ?? willDoHint;
    const updateTooltipPosition = (0, _react.useCallback)(()=>{
        const btn = btnRef.current;
        const tip = tooltipRef.current;
        if (!btn || !tip) return;
        const br = btn.getBoundingClientRect();
        const tw = tip.offsetWidth;
        const th = tip.offsetHeight;
        const maxLeft = Math.max(TOOLTIP_VIEWPORT_PAD_PX, window.innerWidth - tw - TOOLTIP_VIEWPORT_PAD_PX);
        const left = Math.min(Math.max(br.left + br.width / 2 - tw / 2, TOOLTIP_VIEWPORT_PAD_PX), maxLeft);
        let top = br.top - th - TOOLTIP_GAP_PX;
        if (top < TOOLTIP_VIEWPORT_PAD_PX) top = br.bottom + TOOLTIP_GAP_PX;
        setCoords({
            top,
            left
        });
    }, []);
    (0, _react.useLayoutEffect)(()=>{
        if (!tooltipOpen) {
            setCoords(null);
            return;
        }
        updateTooltipPosition();
    }, [
        tooltipOpen,
        tooltipText,
        updateTooltipPosition
    ]);
    (0, _react.useEffect)(()=>{
        if (!tooltipOpen) return;
        const onReposition = ()=>updateTooltipPosition();
        window.addEventListener("resize", onReposition);
        window.addEventListener("scroll", onReposition, true);
        return ()=>{
            window.removeEventListener("resize", onReposition);
            window.removeEventListener("scroll", onReposition, true);
        };
    }, [
        tooltipOpen,
        updateTooltipPosition
    ]);
    (0, _react.useEffect)(()=>{
        if (!tooltipOpen) return;
        const onPointerDown = (e)=>{
            const target = e.target;
            if (btnRef.current?.contains(target) || tooltipRef.current?.contains(target)) return;
            setTooltipOpen(false);
            setTouchMessage(null);
        };
        const onKeyDown = (e)=>{
            if (e.key === "Escape") {
                setTooltipOpen(false);
                setTouchMessage(null);
            }
        };
        document.addEventListener("pointerdown", onPointerDown);
        document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("pointerdown", onPointerDown);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        tooltipOpen
    ]);
    (0, _react.useEffect)(()=>{
        if (!tooltipOpen || canHover) return;
        const t = window.setTimeout(()=>{
            setTooltipOpen(false);
            setTouchMessage(null);
        }, TOUCH_TOOLTIP_MS);
        return ()=>window.clearTimeout(t);
    }, [
        tooltipOpen,
        canHover,
        tooltipText
    ]);
    const goToSignup = (0, _react.useCallback)(()=>{
        (0, _pendingFavouriteTeam.persistPendingFavouriteTeam)(name);
        const back = `${location.pathname}${location.search}${location.hash}`;
        navigate((0, _pendingFavouriteTeam.signupPathForFavouriteTeam)(name, back));
    }, [
        name,
        navigate,
        location.pathname,
        location.search,
        location.hash
    ]);
    const onPointerDown = (0, _react.useCallback)((e)=>{
        lastPointerTypeRef.current = e.pointerType || "mouse";
        e.stopPropagation();
    }, []);
    const onClick = (0, _react.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (busy || !name) return;
        const coarseTap = lastPointerTypeRef.current === "touch" || !canHover;
        if (!canFavourite) {
            if (coarseTap && !tooltipOpen) {
                setTouchMessage(`${willDoHint}. Tap again to continue.`);
                setTooltipOpen(true);
                return;
            }
            setTooltipOpen(false);
            setTouchMessage(null);
            goToSignup();
            return;
        }
        const adding = !active;
        setBusy(true);
        try {
            await toggle(name);
        } finally{
            setBusy(false);
        }
        if (coarseTap) {
            setTouchMessage(adding ? `Added ${name} to your favourite teams` : `Removed ${name} from your favourite teams`);
            setTooltipOpen(true);
        }
    }, [
        busy,
        name,
        canHover,
        canFavourite,
        tooltipOpen,
        willDoHint,
        goToSignup,
        active,
        toggle
    ]);
    if (!name) return null;
    const guestLabel = `Sign up to follow ${name}`;
    const ariaLabel = canFavourite ? active ? `Remove ${name} from favourite teams` : `Add ${name} to favourite teams` : guestLabel;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                ref: btnRef,
                type: "button",
                onClick: onClick,
                onPointerDown: onPointerDown,
                onPointerEnter: ()=>{
                    if (canHover) {
                        setTouchMessage(null);
                        setTooltipOpen(true);
                    }
                },
                onPointerLeave: ()=>{
                    if (canHover) setTooltipOpen(false);
                },
                onFocus: ()=>{
                    if (canHover) {
                        setTouchMessage(null);
                        setTooltipOpen(true);
                    }
                },
                onBlur: ()=>{
                    if (canHover) setTooltipOpen(false);
                },
                "aria-pressed": active,
                "aria-label": ariaLabel,
                "aria-describedby": tooltipOpen ? tooltipId : undefined,
                className: `inline-flex shrink-0 items-center justify-center rounded-full p-0.5 leading-none transition-opacity hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-current disabled:opacity-60 ${className}`.trim(),
                disabled: busy,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: size,
                    height: size,
                    viewBox: "0 0 24 24",
                    fill: active ? color : "none",
                    stroke: color,
                    strokeWidth: active ? 0 : 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    "aria-hidden": true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.46L12 17.9l-5.8 3.05 1.11-6.46-4.7-4.58 6.49-.94L12 2.5z"
                    })
                })
            }),
            tooltipOpen && typeof document !== "undefined" ? /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: tooltipRef,
                id: tooltipId,
                role: "tooltip",
                style: {
                    top: coords?.top ?? 0,
                    left: coords?.left ?? 0,
                    visibility: coords ? "visible" : "hidden"
                },
                className: "pointer-events-none fixed z-[10030] max-w-[min(240px,calc(100vw-16px))] rounded-md bg-[#1B062F] px-2.5 py-1.5 text-center font-chakra text-[11px] font-semibold leading-snug text-white shadow-[0_4px_16px_rgba(0,0,0,0.45)] ring-1 ring-white/15",
                children: tooltipText
            }), document.body) : null
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom":"b8T3j","react-router-dom":"l6ORY","../../Data/useFavouriteTeams":"14JPj","../../utils/pendingFavouriteTeam":"ibsbk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7v7n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 1st-place prize label + amount: prefers `top_prize` from API when set; else from `pool_entrant_count`
 * like backend `computeTopPrizeFirstPlaceFromN`. Explicit `top_prize: 0` (league Super Squares) hides
 * the coin prize but still shows player count in the match-play header.
 */ parcelHelpers.export(exports, "SquaresPrizePoolBadge", ()=>SquaresPrizePoolBadge);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _squaresConstants = require("./squaresConstants");
const SIZE_CLASSES = {
    default: "text-[8px] sm:text-[9px]",
    /** Match play over header: players · prize (right-aligned). */ matchPlayHeader: (0, _squaresConstants.SQUARES_OVER_HEADER_META_TEXT_RIGHT_CLASS)
};
const IMG_SIZE_CLASSES = {
    default: "h-3.5 w-3.5 sm:h-4 sm:w-4",
    matchPlayHeader: "h-[18px] w-[18px] lg:h-[20px] lg:w-[20px]"
};
function SquaresPrizePoolBadge({ econ, className = "", size = "default", entrantCount: entrantCountProp }) {
    const tp = econ?.top_prize;
    let top = null;
    if (tp != null && Number.isFinite(Number(tp))) // 0 = points-model / no shared pot — do not invent a public 1st-place prize from pool size.
    top = Number(tp) > 0 ? Math.round(Number(tp)) : null;
    else top = (0, _squaresConstants.computeSquaresTopPrizeFirstPlaceCoins)(econ?.pool_entrant_count);
    const isHeader = size === "matchPlayHeader";
    const sizeCls = SIZE_CLASSES[size] ?? SIZE_CLASSES.default;
    const imgCls = IMG_SIZE_CLASSES[size] ?? IMG_SIZE_CLASSES.default;
    const entrantRaw = entrantCountProp != null && Number.isFinite(Number(entrantCountProp)) ? Math.max(0, Math.floor(Number(entrantCountProp))) : econ?.pool_entrant_count != null && Number.isFinite(Number(econ.pool_entrant_count)) ? Math.max(0, Math.floor(Number(econ.pool_entrant_count))) : null;
    if (isHeader) {
        const playersLabel = entrantRaw != null ? `${entrantRaw} ${entrantRaw === 1 ? "PLAYER" : "PLAYERS"}` : null;
        if (playersLabel == null && top == null) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            className: `inline-flex max-w-full flex-nowrap items-center justify-end gap-x-1 whitespace-nowrap ${sizeCls} ${className}`.trim(),
            children: [
                playersLabel != null && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "shrink-0",
                            children: playersLabel
                        }),
                        top != null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: `shrink-0 opacity-30 ${(0, _squaresConstants.SQUARES_OVER_HEADER_META_TEXT_CLASS)} text-right`,
                            "aria-hidden": true,
                            children: "\xb7"
                        }) : null
                    ]
                }),
                top != null ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "inline-flex min-w-0 shrink items-center justify-end gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "shrink-0",
                            children: "1ST PLACE:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "tabular-nums shrink-0",
                            children: top
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: "/assets/currency-coin.png",
                            alt: "",
                            className: `shrink-0 object-contain opacity-95 ${imgCls}`.trim(),
                            "aria-hidden": true
                        })
                    ]
                }) : null
            ]
        });
    }
    if (top == null) return null;
    const tone = "text-orange-400";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: `inline-flex flex-nowrap items-center gap-x-1 whitespace-nowrap font-anton uppercase tracking-wide ${sizeCls} ${tone} ${className}`.trim(),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-current opacity-80",
                children: "1st place"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "inline-flex items-center gap-0.5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: "/assets/currency-coin.png",
                        alt: "",
                        className: `shrink-0 object-contain opacity-95 ${imgCls}`.trim(),
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "tabular-nums text-current",
                        children: top
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./squaresConstants":"9tbpY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"rwZ3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PREMATCH_COUNTDOWN_FLASH_CLASS", ()=>PREMATCH_COUNTDOWN_FLASH_CLASS);
/** Renders `STARTS IN 1H 56M`-style labels with a soft flash on the time portion only. */ parcelHelpers.export(exports, "PrematchCountdownLabel", ()=>PrematchCountdownLabel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _matchCardCompactUi = require("../../Games/MatchCards/matchCardCompactUi");
var _matchCountdown = require("../../../utils/matchCountdown");
const PREMATCH_COUNTDOWN_FLASH_CLASS = "prematch-countdown-flash";
/**
 * True only for Tailwind display utilities (`flex`, `inline-flex`, including variants).
 * `flex-1` / `flex-none` set grow, not display — treating them as flex drops the gap
 * between "STARTS IN" and the time (`STARTS IN1H`).
 */ function classNameSetsFlexDisplay(className) {
    return className.split(/\s+/).some((token)=>{
        const base = token.split(":").pop() ?? "";
        return base === "flex" || base === "inline-flex";
    });
}
function PrematchCountdownLabel({ text, className = "", durationClassName = PREMATCH_COUNTDOWN_FLASH_CLASS, style }) {
    const normalizedText = (0, _matchCountdown.normalizePrematchCountdownSpacing)(text);
    const parts = (0, _matchCountdown.parsePrematchCountdownParts)(normalizedText);
    if (!parts) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: className,
        style: style,
        children: (0, _matchCardCompactUi.formatMatchStatusForDisplay)(normalizedText)
    });
    const hasFlexLayout = classNameSetsFlexDisplay(className);
    const splitClassName = hasFlexLayout ? className : `${className} inline-flex items-center`.trim();
    const splitStyle = {
        ...style,
        columnGap: "0.35em"
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: splitClassName,
        style: splitStyle,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "shrink-0",
                children: parts.prefix.trimEnd()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: durationClassName,
                children: parts.duration
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../Games/MatchCards/matchCardCompactUi":"9NhAM","../../../utils/matchCountdown":"hzPTj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gCUBA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Lobby match-card badge: avatar + count + “GAME(S)” — shared by Bullion, Squares, and Trader lobbies. */ parcelHelpers.export(exports, "LobbyActiveGamesSticker", ()=>LobbyActiveGamesSticker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _userContext = require("../../../Data/UserContext");
var _avatarFrame = require("../../Profile/avatarFrame");
var _avatarWithXpCrown = require("../../Xp/AvatarWithXpCrown");
const OVERLAY_ROOT_CLASS = "absolute -bottom-4 right-0 z-12 flex translate-y-[5px] items-center overflow-hidden border border-[#1B062F]/30 bg-[#6432A5] shadow-[0_4px_12px_rgba(0,0,0,0.25)] md:-bottom-5 md:translate-y-[5px]";
const INLINE_ROOT_CLASS = "flex flex-shrink-0 items-center overflow-hidden border border-[#1B062F]/30 bg-[#6432A5] h-[32px] md:h-[34px]";
const INLINE_COMPACT_ROOT_CLASS = "flex flex-shrink-0 items-center overflow-hidden border border-[#1B062F]/30 bg-[#6432A5] h-[26px] md:h-[28px]";
/** Match-card header badge — avatar in orange tile + “N GAMES” (Figma). */ const HEADER_ROOT_CLASS = "flex h-[24px] min-h-[24px] max-h-[24px] flex-shrink-0 items-stretch overflow-hidden bg-[#9747FF] shadow-[0px_0px_5px_0px_#00000099]";
function LobbyActiveGamesSticker({ count, avatarSrc = "/img/avatar.png", xpWeekCrown = null, avatarFrameUrl, avatarFrameSmallUrl, labelSingular = "Game", labelPlural = "Games", interactive = false, onActivate, ariaLabel, layout = "overlay", compact = false }) {
    const viewer = (0, _react.useContext)((0, _userContext.UserContext))?.user;
    const n = Math.max(0, Math.floor(Number(count) || 0));
    if (n <= 0) return null;
    const label = (n === 1 ? labelSingular : labelPlural).toUpperCase();
    const defaultAria = `${n} active ${n === 1 ? labelSingular.toLowerCase() : labelPlural.toLowerCase()}`;
    const handleKeyDown = (e)=>{
        if (!interactive || !onActivate) return;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onActivate(e);
        }
    };
    const handleClick = (e)=>{
        if (!interactive || !onActivate) return;
        e.preventDefault();
        e.stopPropagation();
        onActivate(e);
    };
    const rootClass = layout === "header" ? HEADER_ROOT_CLASS : layout === "inline" ? compact ? INLINE_COMPACT_ROOT_CLASS : INLINE_ROOT_CLASS : OVERLAY_ROOT_CLASS;
    const avatarSizeClass = layout === "header" ? "h-[18px] w-[18px]" : layout === "inline" && compact ? "h-[20px] w-[20px]" : "h-[24px] w-[24px]";
    /** Header (18px) and compact inline (20px) avatars are too small for a frame. */ const frameSrc = layout === "header" || layout === "inline" && compact ? null : (0, _avatarFrame.resolveAvatarFrameSrc)("compact", avatarFrameUrl !== undefined ? avatarFrameUrl : viewer?.avatar_frame_url, avatarFrameSmallUrl !== undefined ? avatarFrameSmallUrl : viewer?.avatar_frame_small_url);
    const countSizeClass = layout === "inline" && compact ? "inline-flex h-[20px] w-[20px] flex-shrink-0 items-center justify-center bg-[#F73261] font-anton text-[13px] font-normal uppercase leading-none text-white" : "inline-flex h-[24px] w-[24px] flex-shrink-0 items-center justify-center bg-[#F73261] font-anton text-[16px] font-normal uppercase leading-[13.33px] text-white";
    if (layout === "header") return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: interactive ? "button" : undefined,
        tabIndex: interactive ? 0 : undefined,
        onClick: interactive ? handleClick : undefined,
        onKeyDown: interactive ? handleKeyDown : undefined,
        className: `${rootClass} ${interactive ? "cursor-pointer" : "cursor-default"}`,
        "aria-label": ariaLabel ?? (interactive ? `${n} ${n === 1 ? labelSingular.toLowerCase() : labelPlural.toLowerCase()} \u{2014} open My Games` : defaultAria),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex h-[24px] w-[24px] flex-shrink-0 items-center justify-center bg-[#FF8A3D]",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarWithXpCrown.AvatarWithXpCrown), {
                    crown: xpWeekCrown,
                    className: `block flex-shrink-0 ${avatarSizeClass}`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: avatarSrc,
                        alt: "",
                        className: "h-full w-full rounded-full border border-white object-cover",
                        draggable: false
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "flex flex-shrink-0 items-center whitespace-nowrap px-2 font-anton text-[11px] font-normal uppercase leading-none text-white",
                style: {
                    fontVariantNumeric: "tabular-nums"
                },
                children: [
                    n,
                    " ",
                    label
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: interactive ? "button" : undefined,
        tabIndex: interactive ? 0 : undefined,
        onClick: interactive ? handleClick : undefined,
        onKeyDown: interactive ? handleKeyDown : undefined,
        className: `${rootClass} ${interactive ? "cursor-pointer" : layout === "inline" ? "cursor-default" : "pointer-events-none cursor-default"}`,
        "aria-label": ariaLabel ?? (interactive ? undefined : defaultAria),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-shrink-0 items-center justify-center p-0.5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarWithXpCrown.AvatarWithXpCrown), {
                    crown: xpWeekCrown,
                    frameSrc: frameSrc,
                    className: `block flex-shrink-0 ${avatarSizeClass}`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex h-full w-full flex-shrink-0 items-center justify-center bg-[#6432A5]",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: avatarSrc,
                            alt: "",
                            className: "h-full w-full rounded-full object-cover",
                            draggable: false
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-shrink-0 items-center justify-center p-0.5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: countSizeClass,
                    style: {
                        letterSpacing: "0%",
                        textAlign: "center",
                        fontVariantNumeric: "tabular-nums"
                    },
                    children: n
                })
            }),
            layout === "inline" && compact ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "inline-flex h-[24px] flex-shrink-0 items-center justify-end bg-[#6432A5] pl-[5px] pr-[11px] font-anton text-[13.33px] font-normal uppercase leading-[14.67px] text-white",
                style: {
                    letterSpacing: "0%"
                },
                children: label
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../../Data/UserContext":"aqd8b","../../Profile/avatarFrame":"k4MjP","../../Xp/AvatarWithXpCrown":"9U2iQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Vn0go":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Pink WATCH / WATCH LIVE CTA — opens the stream player (not auto-mounted). */ parcelHelpers.export(exports, "WatchLiveButton", ()=>WatchLiveButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _userContext = require("../../../Data/UserContext");
var _frontendTrackingEvents = require("../../../utils/frontendTrackingEvents");
var _matchCardCompactUi = require("../../Games/MatchCards/matchCardCompactUi");
function WatchLiveButton({ fixtureId, ctaLocation, onClick, className = (0, _matchCardCompactUi.MATCH_CARD_COMPACT_WATCH_LIVE_HEADER_CLASS), label = "responsive" }) {
    const { user } = (0, _userContext.useUser)();
    const location = (0, _reactRouterDom.useLocation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: className,
        "aria-label": "Watch live",
        title: "Watch live",
        onClick: (e)=>{
            e.stopPropagation();
            (0, _frontendTrackingEvents.trackWatchLiveClicked)({
                user_id: user?.userId,
                cta_location: ctaLocation,
                fixture_id: fixtureId,
                pathname: location.pathname
            });
            onClick();
        },
        children: label === "full" ? "WATCH LIVE" : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "md:hidden",
                    children: "WATCH"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "hidden md:inline",
                    children: "WATCH LIVE"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../../../Data/UserContext":"aqd8b","../../../utils/frontendTrackingEvents":"4Y90p","../../Games/MatchCards/matchCardCompactUi":"9NhAM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4oyz4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ChallengeGameSelectPopover);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
/** Above ProfileModalShell (z-10050). */ const POPOVER_Z = 10060;
function ChallengeGameSelectPopover({ anchorRect, onClose, onPickBullion, onPickSquares, onPickLeagues, showBullion = true, showSquares = true, showLeagues = false }) {
    const rootRef = (0, _react.useRef)(null);
    const hasAny = showBullion || showSquares || showLeagues;
    (0, _react.useEffect)(()=>{
        if (!hasAny) onClose();
    }, [
        hasAny,
        onClose
    ]);
    (0, _react.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        onClose
    ]);
    (0, _react.useEffect)(()=>{
        const onPointer = (e)=>{
            const el = rootRef.current;
            const t = e.target;
            if (!el || !(t instanceof Node)) return;
            if (!el.contains(t)) onClose();
        };
        document.addEventListener("mousedown", onPointer);
        document.addEventListener("touchstart", onPointer, {
            passive: true
        });
        return ()=>{
            document.removeEventListener("mousedown", onPointer);
            document.removeEventListener("touchstart", onPointer);
        };
    }, [
        onClose
    ]);
    if (!hasAny) return null;
    const width = 228;
    const left = Math.min(Math.max(8, anchorRect.right - width), typeof window !== "undefined" ? window.innerWidth - width - 8 : anchorRect.left);
    const top = anchorRect.bottom + 6;
    const menu = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: rootRef,
        className: "fixed border-2 border-[#c99cff] bg-[#7a3eb8] p-2 shadow-[0_10px_28px_rgba(8,2,18,0.55)]",
        style: {
            zIndex: POPOVER_Z,
            top,
            left,
            width
        },
        role: "dialog",
        "aria-label": "Select game",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-2 pl-0.5 font-anton text-[11px] font-bold uppercase leading-none tracking-wide text-white",
                children: "Select game"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-1.5",
                children: [
                    showLeagues ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            onPickLeagues();
                            onClose();
                        },
                        className: "flex w-full items-center gap-2 bg-[#552ca6] px-2 py-2 text-left font-anton text-[14px] font-bold uppercase leading-none tracking-wide text-white transition-colors hover:bg-[#6138b0]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: "/assets/league-trophy.png",
                                alt: "",
                                className: "h-9 w-9 shrink-0 object-contain",
                                width: 36,
                                height: 36
                            }),
                            "LEAGUES"
                        ]
                    }) : null,
                    showBullion ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            onPickBullion();
                            onClose();
                        },
                        className: "flex w-full items-center gap-2 bg-[#552ca6] px-2 py-2 text-left font-anton text-[14px] font-bold uppercase leading-none tracking-wide text-white transition-colors hover:bg-[#6138b0]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: "/assets/bullion.png",
                                alt: "",
                                className: "h-9 w-9 shrink-0 object-contain",
                                width: 36,
                                height: 36
                            }),
                            "BULLION"
                        ]
                    }) : null,
                    showSquares ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            onPickSquares();
                            onClose();
                        },
                        className: "flex w-full items-center gap-2 bg-[#552ca6] px-2 py-2 text-left font-anton text-[14px] font-bold uppercase leading-none tracking-wide text-white transition-colors hover:bg-[#6138b0]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: "/assets/squares.png",
                                alt: "",
                                className: "h-9 w-9 shrink-0 object-contain",
                                width: 36,
                                height: 36
                            }),
                            "SQUARES"
                        ]
                    }) : null
                ]
            })
        ]
    });
    if (typeof document === "undefined") return null;
    return /*#__PURE__*/ (0, _reactDom.createPortal)(menu, document.body);
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom":"b8T3j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iEI1v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BullionPrivateContestsFriendModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _closeIcon = require("../../icons/CloseIcon/CloseIcon");
var _authHeaders = require("../../utils/authHeaders");
var _userContext = require("../../Data/UserContext");
var _matchNameDisplay = require("../../utils/matchNameDisplay");
var _frontendTrackingEvents = require("../../utils/frontendTrackingEvents");
var _modalHistoryBack = require("../../utils/modalHistoryBack");
var _friendDisplayName = require("../../utils/friendDisplayName");
function formatFixtureStart(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString(undefined, {
        dateStyle: "medium",
        timeStyle: "short"
    });
}
function bullionChallengeHref(matchId, gameId, inviteCode) {
    const mid = matchId != null ? String(matchId).trim() : "";
    if (!mid) return "/bullion";
    const inv = inviteCode != null && String(inviteCode).trim() !== "" ? String(inviteCode).trim() : "";
    return `/bullion?match=${encodeURIComponent(mid)}&game=${encodeURIComponent(String(gameId))}${inv ? `&invite=${encodeURIComponent(inv)}` : ""}`;
}
/** One row per game_id */ function dedupeBullionChallengeEntriesByGameId(entries) {
    const seen = new Set();
    const out = [];
    for (const e of entries){
        const gid = Number(e.gameId);
        if (!Number.isFinite(gid) || gid <= 0) continue;
        if (seen.has(gid)) continue;
        seen.add(gid);
        out.push(e);
    }
    return out;
}
/** Above ProfileModalShell (z-10050) so challenge opens in front of the profile overlay. */ const CHALLENGE_MODAL_OVERLAY_Z = 10060;
const CHALLENGE_MODAL_CONTENT_Z = 10061;
function BullionPrivateContestsFriendModal({ isOpen, onRequestClose, friend, analyticsEntryPoint, onOpenMatch }) {
    const { user } = (0, _userContext.useUser)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const challengeFlowOpenedTrackedRef = (0, _react.useRef)(false);
    const [games, setGames] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [sendingId, setSendingId] = (0, _react.useState)(null);
    const [successEntries, setSuccessEntries] = (0, _react.useState)([]);
    const [priorChallengesLoading, setPriorChallengesLoading] = (0, _react.useState)(false);
    const friendLabel = (0, _react.useMemo)(()=>(0, _friendDisplayName.friendFacingName)(friend) || "your friend", [
        friend
    ]);
    const loadGames = (0, _react.useCallback)(()=>{
        if (!isOpen) return;
        setLoading(true);
        setError(null);
        (async ()=>{
            try {
                const res = await fetch(`${"https://cricket8.com/api"}/bullion/private-games/my-created`, {
                    method: "GET",
                    headers: (0, _authHeaders.getAuthHeaders)()
                });
                const payload = await res.json().catch(()=>({}));
                if (!res.ok) throw new Error(payload?.message || "Unable to load private battles.");
                const raw = Array.isArray(payload?.games) ? payload.games : [];
                const normalized = raw.map((g)=>({
                        gameId: Number(g.gameId),
                        matchId: String(g.matchId ?? ""),
                        name: String(g.name ?? ""),
                        entryStake: Number(g.entryStake ?? 0),
                        prizePot: Number(g.prizePot ?? 0),
                        playersCount: Number(g.playersCount ?? 0),
                        inviteCode: g.inviteCode != null && String(g.inviteCode).trim() !== "" ? String(g.inviteCode).trim() : null,
                        matchName: g.matchName != null ? String(g.matchName) : null,
                        competition: g.competition != null ? String(g.competition) : null,
                        startTime: g.startTime != null ? String(g.startTime) : null,
                        createdAt: g.createdAt != null ? String(g.createdAt) : null
                    }));
                setGames(normalized.filter((x)=>Number.isFinite(x.gameId) && x.gameId > 0 && x.matchId.trim() !== ""));
            } catch (e) {
                setGames([]);
                setError(e instanceof Error ? e.message : "Unable to load private battles.");
            } finally{
                setLoading(false);
            }
        })();
    }, [
        isOpen
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen || !friend) return;
        loadGames();
    }, [
        isOpen,
        friend,
        loadGames
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen) {
            challengeFlowOpenedTrackedRef.current = false;
            setGames([]);
            setError(null);
            setSuccessEntries([]);
            setPriorChallengesLoading(false);
            setSendingId(null);
            return;
        }
    }, [
        isOpen
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen || !friend || user?.userId == null) return;
        if (!analyticsEntryPoint?.trim()) return;
        if (challengeFlowOpenedTrackedRef.current) return;
        challengeFlowOpenedTrackedRef.current = true;
        (0, _frontendTrackingEvents.trackGameChallengeFlowOpened)({
            user_id: user.userId,
            game_type: "bullion",
            entry_point: analyticsEntryPoint.trim(),
            pathname: location.pathname
        });
    }, [
        isOpen,
        friend,
        user?.userId,
        analyticsEntryPoint,
        location.pathname
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen || !friend) return;
        const fid = friend.userId;
        const fl = (0, _friendDisplayName.friendFacingName)(friend) || "your friend";
        let cancelled = false;
        setPriorChallengesLoading(true);
        (async ()=>{
            try {
                const res = await fetch(`${"https://cricket8.com/api"}/account/friends/bullion-challenges-sent?friend_id=${encodeURIComponent(String(fid))}`, {
                    headers: (0, _authHeaders.getAuthHeaders)()
                });
                const data = await res.json().catch(()=>({}));
                if (cancelled) return;
                if (!res.ok) {
                    setSuccessEntries([]);
                    return;
                }
                const list = Array.isArray(data.challenges) ? data.challenges : [];
                const entries = dedupeBullionChallengeEntriesByGameId(list.filter((c)=>c.game_id != null && Number.isFinite(c.game_id) && c.game_id > 0).map((c)=>{
                    const midLabel = (0, _matchNameDisplay.formatMatchNameAbbreviated)(c.match_name || "") || (c.match_name != null && String(c.match_name).trim() !== "" ? String(c.match_name).trim() : "this match");
                    const contest = c.game_name != null && String(c.game_name).trim() !== "" ? String(c.game_name).trim() : "Private battle";
                    return {
                        key: `prior-${c.id}`,
                        gameId: Number(c.game_id),
                        contestLabel: contest,
                        matchLabel: midLabel,
                        friendLabel: fl,
                        matchOpen: c.game_open !== false,
                        matchId: c.match_id != null && String(c.match_id).trim() !== "" ? String(c.match_id) : null,
                        inviteCode: c.invite_code != null && String(c.invite_code).trim() !== "" ? String(c.invite_code).trim() : null
                    };
                })).slice(0, 8);
                setSuccessEntries(entries);
            } catch  {
                if (!cancelled) setSuccessEntries([]);
            } finally{
                if (!cancelled) setPriorChallengesLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        isOpen,
        friend?.userId,
        friend?.player_name,
        friend?.username
    ]);
    (0, _react.useEffect)(()=>{
        if (!isOpen || !friend) return;
        const onDirty = ()=>{
            const fid = friend.userId;
            const fl = (0, _friendDisplayName.friendFacingName)(friend) || "your friend";
            setPriorChallengesLoading(true);
            (async ()=>{
                try {
                    const res = await fetch(`${"https://cricket8.com/api"}/account/friends/bullion-challenges-sent?friend_id=${encodeURIComponent(String(fid))}`, {
                        headers: (0, _authHeaders.getAuthHeaders)()
                    });
                    const data = await res.json().catch(()=>({}));
                    if (!res.ok) return;
                    const list = Array.isArray(data.challenges) ? data.challenges : [];
                    const entries = dedupeBullionChallengeEntriesByGameId(list.filter((c)=>c.game_id != null && Number.isFinite(c.game_id) && c.game_id > 0).map((c)=>{
                        const midLabel = (0, _matchNameDisplay.formatMatchNameAbbreviated)(c.match_name || "") || (c.match_name != null && String(c.match_name).trim() !== "" ? String(c.match_name).trim() : "this match");
                        const contest = c.game_name != null && String(c.game_name).trim() !== "" ? String(c.game_name).trim() : "Private battle";
                        return {
                            key: `prior-${c.id}`,
                            gameId: Number(c.game_id),
                            contestLabel: contest,
                            matchLabel: midLabel,
                            friendLabel: fl,
                            matchOpen: c.game_open !== false,
                            matchId: c.match_id != null && String(c.match_id).trim() !== "" ? String(c.match_id) : null,
                            inviteCode: c.invite_code != null && String(c.invite_code).trim() !== "" ? String(c.invite_code).trim() : null
                        };
                    })).slice(0, 8);
                    setSuccessEntries(entries);
                } finally{
                    setPriorChallengesLoading(false);
                }
            })();
        };
        window.addEventListener("c8-bullion-challenges-dirty", onDirty);
        return ()=>window.removeEventListener("c8-bullion-challenges-dirty", onDirty);
    }, [
        friend,
        isOpen
    ]);
    const visibleSuccessEntries = (0, _react.useMemo)(()=>dedupeBullionChallengeEntriesByGameId(successEntries.filter((e)=>e.matchOpen !== false)), [
        successEntries
    ]);
    const openChallengedMatch = (0, _react.useCallback)((href)=>{
        if (onOpenMatch) {
            onOpenMatch(href);
            return;
        }
        onRequestClose();
        (0, _modalHistoryBack.whenModalHistoryIdle)(()=>navigate(href));
    }, [
        navigate,
        onOpenMatch,
        onRequestClose
    ]);
    const sendChallenge = (0, _react.useCallback)(async (g)=>{
        if (!friend) return;
        setSendingId(g.gameId);
        setError(null);
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/friends/bullion-challenge`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...(0, _authHeaders.getAuthHeaders)()
                },
                body: JSON.stringify({
                    friend_id: friend.userId,
                    game_id: g.gameId
                })
            });
            const data = await res.json().catch(()=>({}));
            if (!res.ok) {
                const code = data?.error;
                if (code === "not_friends") setError("You can only challenge friends.");
                else if (code === "not_contest_host") setError("You can only challenge from battles you host.");
                else if (code === "contest_not_open" || code === "game_not_found") setError("That battle is no longer open.");
                else if (code === "missing_invite_code") setError("That battle cannot be shared yet. Try again.");
                else setError("Could not send challenge. Try again.");
                return;
            }
            if (user?.userId != null && analyticsEntryPoint?.trim()) (0, _frontendTrackingEvents.trackGameChallengeSent)({
                user_id: user.userId,
                game_type: "bullion",
                entry_point: analyticsEntryPoint.trim(),
                challenged_friend_user_id: friend.userId,
                challenge_target_id: String(g.gameId),
                pathname: location.pathname
            });
            window.dispatchEvent(new CustomEvent("c8-bullion-challenges-dirty"));
            openChallengedMatch(bullionChallengeHref(g.matchId, g.gameId, g.inviteCode));
        } catch  {
            setError("Could not send challenge. Try again.");
        } finally{
            setSendingId(null);
        }
    }, [
        friend,
        user?.userId,
        analyticsEntryPoint,
        location.pathname,
        openChallengedMatch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        isOpen: isOpen && friend != null,
        onRequestClose: onRequestClose,
        contentLabel: "Challenge friend to BULLION",
        ariaHideApp: false,
        style: {
            content: {
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                padding: 0,
                background: "transparent",
                width: "min(560px, calc(100vw - 16px))",
                maxWidth: "100%",
                maxHeight: "min(90vh, 720px)",
                overflow: "hidden",
                zIndex: CHALLENGE_MODAL_CONTENT_Z
            },
            overlay: {
                background: "rgba(11, 2, 18, 0.8)",
                zIndex: CHALLENGE_MODAL_OVERLAY_Z
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex max-h-[min(90vh,720px)] flex-col overflow-hidden border border-[#2d1548] bg-[#2a0a55] shadow-[0_12px_40px_rgba(0,0,0,0.45)]",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid shrink-0 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2 bg-[#e470ff] py-2 pl-3 pr-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "min-w-0",
                            "aria-hidden": true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "text-center font-anton text-[17px] font-bold uppercase leading-none tracking-wide text-white max-[420px]:text-[15px]",
                            children: "BULLION challenge"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex min-w-0 justify-end",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: onRequestClose,
                                className: "!flex !h-11 !w-11 shrink-0 !items-center !justify-center text-white transition-opacity hover:opacity-80",
                                "aria-label": "Close",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIcon.CloseIcon), {
                                    className: "text-white",
                                    size: 28
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "min-h-0 flex-1 space-y-3 overflow-y-auto bg-[#461d79] px-3 py-3 sm:px-4 sm:py-4",
                    children: [
                        priorChallengesLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded border border-[#d4ff1f]/35 bg-[#1b062f]/55 px-3 py-2.5 text-center font-chakra text-[14px] leading-snug text-white/70 max-[420px]:text-[13px]",
                            children: "Loading\u2026"
                        }) : visibleSuccessEntries.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded border border-[#d4ff1f]/35 bg-[#1b062f]/55 px-3 py-2.5 text-center font-chakra text-[14px] leading-snug text-white max-[420px]:text-[13px]",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    "Challenge ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-semibold",
                                        children: friendLabel
                                    }),
                                    " to play",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-semibold text-[#d4ff1f]",
                                        children: " BULLION"
                                    }),
                                    " with you."
                                ]
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                            className: "space-y-3",
                            "aria-live": "polite",
                            children: visibleSuccessEntries.map((entry)=>{
                                const gFromList = games.find((x)=>x.gameId === entry.gameId);
                                const openTo = bullionChallengeHref(entry.matchId ?? gFromList?.matchId, entry.gameId, entry.inviteCode ?? gFromList?.inviteCode);
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                    className: "space-y-2",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "border border-[#d4ff1f]/35 bg-[#1b062f]/55 px-3 py-2.5 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "font-chakra text-[13px] leading-snug text-white sm:text-[14px]",
                                                children: [
                                                    "You challenged ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-semibold",
                                                        children: entry.friendLabel
                                                    }),
                                                    " to",
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-semibold text-[#d4ff1f]",
                                                        children: entry.contestLabel
                                                    }),
                                                    " on",
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-semibold text-[#d4ff1f]",
                                                        children: entry.matchLabel
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                to: openTo,
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    openChallengedMatch(openTo);
                                                },
                                                className: "inline-block font-chakra text-[13px] font-semibold text-[#d4ff1f] underline decoration-[#d4ff1f]/55 underline-offset-2 hover:text-white hover:decoration-white sm:text-[14px]",
                                                children: "Open battle in BULLION"
                                            })
                                        ]
                                    })
                                }, entry.gameId);
                            })
                        }),
                        error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "font-chakra text-[13px] font-semibold sm:text-[14px]",
                            style: {
                                color: "#ef4444"
                            },
                            role: "alert",
                            "aria-live": "polite",
                            children: error
                        }) : null,
                        loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-center font-chakra text-sm text-white/60",
                            children: "Loading battles\u2026"
                        }) : games.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "font-chakra text-[14px] leading-snug text-white/70",
                                    children: [
                                        "No ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            className: "text-white",
                                            children: "open"
                                        }),
                                        " private battles yet. When you create one in BULLION, it will show up here so you can send a challenge."
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/bullion",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        openChallengedMatch("/bullion");
                                    },
                                    className: "inline-block font-chakra text-[13px] font-semibold text-[#d4ff1f] underline decoration-[#d4ff1f]/55 underline-offset-2 hover:text-white hover:decoration-white sm:text-[14px]",
                                    children: "Open BULLION lobby"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col gap-3 pb-1",
                            style: {
                                background: "linear-gradient(88.89deg, #652DAF 0%, #623998 100%)"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                    className: "flex flex-col gap-3 px-0 pt-1 sm:px-0",
                                    "aria-label": "Your private battles",
                                    children: games.map((g)=>{
                                        const matchLine = (0, _matchNameDisplay.formatMatchNameAbbreviated)(g.matchName || "") || g.matchName || "Match";
                                        const when = formatFixtureStart(g.startTime);
                                        const metaBits = [
                                            g.competition,
                                            when
                                        ].filter(Boolean);
                                        const challengeDisabled = !g.inviteCode;
                                        const challengeSending = sendingId === g.gameId;
                                        const challengeOtherSending = sendingId != null && sendingId !== g.gameId;
                                        const challengeCtaDisabled = challengeDisabled || challengeSending || challengeOtherSending;
                                        const challengeCtaLabel = challengeSending ? "SENDING\u2026" : "CHALLENGE";
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                            className: "px-2",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "border border-[#d4ff1f]/35 bg-[#1b062f]/55 px-3 py-2.5 sm:px-3.5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex flex-wrap items-start justify-between gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "min-w-0 flex-1 text-left",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                    className: "font-chakra text-[13px] leading-snug text-white sm:text-[14px]",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "font-semibold text-[#d4ff1f]",
                                                                        children: g.name.trim() || "Private battle"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    className: "mt-1 font-chakra text-[13px] leading-snug text-white sm:text-[14px]",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "font-semibold text-white",
                                                                            children: matchLine
                                                                        }),
                                                                        metaBits.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "text-white/75",
                                                                            children: [
                                                                                " ",
                                                                                "\xb7 ",
                                                                                metaBits.join(" \xb7 ")
                                                                            ]
                                                                        }) : null
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    className: "mt-1 font-chakra text-[12px] text-white/65 sm:text-[13px]",
                                                                    children: [
                                                                        "Entry ",
                                                                        g.entryStake.toLocaleString(),
                                                                        " coins \xb7 ",
                                                                        g.playersCount,
                                                                        " player",
                                                                        g.playersCount === 1 ? "" : "s",
                                                                        g.prizePot > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                            children: [
                                                                                " ",
                                                                                "\xb7 Pot ",
                                                                                g.prizePot.toLocaleString()
                                                                            ]
                                                                        }) : null
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            disabled: challengeDisabled || challengeCtaDisabled,
                                                            onClick: ()=>sendChallenge(g),
                                                            className: `shrink-0 bg-lime font-anton text-[12px] leading-[18px] px-3 py-0 uppercase whitespace-nowrap min-w-[80px] flex items-center justify-center text-main ${challengeDisabled || challengeCtaDisabled ? "cursor-not-allowed opacity-60" : "hover:bg-limehover cursor-pointer"}`,
                                                            style: {
                                                                letterSpacing: "0%",
                                                                textAlign: "center"
                                                            },
                                                            children: challengeCtaLabel
                                                        })
                                                    ]
                                                })
                                            })
                                        }, g.gameId);
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "border-t border-white/10 px-2 pb-2 pt-1 text-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: "/bullion",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            openChallengedMatch("/bullion");
                                        },
                                        className: "inline-block font-chakra text-[13px] font-semibold text-[#d4ff1f] underline decoration-[#d4ff1f]/55 underline-offset-2 hover:text-white hover:decoration-white sm:text-[14px]",
                                        children: "Create more private battles"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","../Modal":"2Ei4y","../../icons/CloseIcon/CloseIcon":"7JRht","../../utils/authHeaders":"5Rczo","../../Data/UserContext":"aqd8b","../../utils/matchNameDisplay":"cRLsI","../../utils/frontendTrackingEvents":"4Y90p","../../utils/modalHistoryBack":"goswc","../../utils/friendDisplayName":"hUpqQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"12SRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
const getModalWidth = ()=>{
    if (window.innerWidth >= 768) return "50%";
    else return "90%";
};
const AreYouSure = ({ isOpen, onRequestClose, contentLabel, children })=>{
    (0, _react.useEffect)(()=>{
        const updateWidth = ()=>{
            const modalContent = document.querySelector(".ReactModal__Content");
            if (modalContent) modalContent.style.width = getModalWidth();
        };
        window.addEventListener("resize", updateWidth);
        // Initial call to set width
        if (isOpen) updateWidth();
        return ()=>{
            window.removeEventListener("resize", updateWidth);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        contentLabel: contentLabel,
        style: {
            content: {
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#401a6e",
                width: getModalWidth(),
                margin: 0,
                padding: 0,
                /* Above ProfileModalShell (z-index 10010) so confirm dialogs work inside the profile overlay */ zIndex: 10022
            },
            overlay: {
                background: "rgba(11, 2, 18, 0.8)",
                zIndex: 10021
            }
        },
        ariaHideApp: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "are-you-sure-modal-contents",
            children: children
        })
    });
};
exports.default = AreYouSure;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Modal":"2Ei4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dcN2P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThreeDotsCircleIcon", ()=>ThreeDotsCircleIcon);
var _jsxRuntime = require("react/jsx-runtime");
const ThreeDotsCircleIcon = ({ className = "text-white/90", size = 16 })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        fill: "none",
        viewBox: "0 0 24 24",
        className: className,
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "6.5",
                cy: "12",
                r: "1.8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "1.8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "17.5",
                cy: "12",
                r: "1.8",
                fill: "currentColor"
            })
        ]
    });

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7N3P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * True when the Squares lobby lists at least one match that counts as live for friend challenges
 * (same fixture-list signal as {@link isSquaresFixtureLiveForChallengeList} without stream).
 * Polls while `enabled` so the friends CHALLENGE control stays in sync with the challenge modal.
 */ parcelHelpers.export(exports, "useLiveSquaresChallengeFromLobby", ()=>useLiveSquaresChallengeFromLobby);
var _react = require("react");
var _squaresApi = require("../components/Squares/shared/squaresApi");
var _squaresConstants = require("../components/Squares/shared/squaresConstants");
var _squaresLobbyMatchUtils = require("../components/Squares/lobby/squaresLobbyMatchUtils");
function useLiveSquaresChallengeFromLobby(opts) {
    const { enabled, pollMs = 20000 } = opts;
    const [hasLiveMatch, setHasLiveMatch] = (0, _react.useState)(false);
    const refresh = (0, _react.useCallback)(async ()=>{
        if (!enabled || !(0, _squaresConstants.isSquaresLobbyEnabled)()) {
            setHasLiveMatch(false);
            return;
        }
        try {
            const data = await (0, _squaresApi.fetchSquaresPrioritisedMatches)();
            const events = Array.isArray(data?.events) ? data.events : [];
            const fixtures = (0, _squaresLobbyMatchUtils.mapFilterSquaresPlayableLobbyFixturesForHome)(events);
            // Without stream we can only know live status — game-open needs 410 markets (modal SSE).
            const anyLive = fixtures.some((f)=>(0, _squaresLobbyMatchUtils.isSquaresFixtureLiveForChallengeList)(f, undefined));
            setHasLiveMatch(anyLive);
        } catch  {
            setHasLiveMatch(false);
        }
    }, [
        enabled
    ]);
    (0, _react.useEffect)(()=>{
        if (!enabled) {
            setHasLiveMatch(false);
            return;
        }
        refresh();
        let intervalId = 0;
        const schedule = ()=>{
            if (intervalId) window.clearInterval(intervalId);
            const hidden = typeof document !== "undefined" && document.visibilityState !== "visible";
            const effectivePollMs = hidden ? Math.max(pollMs, 60000) : pollMs;
            intervalId = window.setInterval(()=>void refresh(), effectivePollMs);
        };
        schedule();
        const onVisibilityChange = ()=>schedule();
        document.addEventListener("visibilitychange", onVisibilityChange);
        return ()=>{
            if (intervalId) window.clearInterval(intervalId);
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, [
        enabled,
        refresh,
        pollMs
    ]);
    return hasLiveMatch;
}

},{"react":"6uln9","../components/Squares/shared/squaresApi":"aMqbW","../components/Squares/shared/squaresConstants":"9tbpY","../components/Squares/lobby/squaresLobbyMatchUtils":"j3UmL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ex0m1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidateGamesEnabledCache", ()=>invalidateGamesEnabledCache);
/**
 * Start loading game visibility as early as possible (e.g. from index.tsx before React mounts).
 */ parcelHelpers.export(exports, "prefetchGamesEnabled", ()=>prefetchGamesEnabled);
/**
 * Shared hook for /isgameenabled/ALL. Loads once on mount; polls a tiny revision endpoint
 * every 2 minutes while the tab is visible (plus when the tab is refocused) and refetches
 */ parcelHelpers.export(exports, "useGamesEnabled", ()=>useGamesEnabled);
var _react = require("react");
var _authHeaders = require("../utils/authHeaders");
var _gamePlayerVisibility = require("../utils/gamePlayerVisibility");
const GAMES_ENABLED_REVISION_POLL_MS = 120000; // revision check every 2 min while tab is open
const LEGACY_GAMES_ENABLED_STORAGE_KEYS = [
    "c8_games_enabled_v1",
    "c8_games_enabled_v2"
];
let gamesEnabledFetchPromise = null;
const gamesEnabledListeners = new Set();
let revisionWatchStarted = false;
let knownRevision = null;
let snapshot = {
    data: [],
    loading: true,
    error: false
};
function emitGamesEnabledChange() {
    gamesEnabledListeners.forEach((listener)=>listener());
}
function subscribeGamesEnabled(listener) {
    gamesEnabledListeners.add(listener);
    return ()=>{
        gamesEnabledListeners.delete(listener);
    };
}
function getGamesEnabledSnapshot() {
    return snapshot;
}
function updateGamesEnabledSnapshot(partial) {
    snapshot = {
        ...snapshot,
        ...partial
    };
    emitGamesEnabledChange();
}
function clearLegacyGamesEnabledStorage() {
    if (typeof window === "undefined") return;
    for (const key of LEGACY_GAMES_ENABLED_STORAGE_KEYS)try {
        sessionStorage.removeItem(key);
    } catch  {
    // ignore
    }
}
function invalidateGamesEnabledCache() {
    gamesEnabledFetchPromise = null;
    knownRevision = null;
    clearLegacyGamesEnabledStorage();
    updateGamesEnabledSnapshot({
        data: [],
        loading: true,
        error: false
    });
    ensureGamesEnabledLoaded(true);
}
function parseGamesList(parsed) {
    if (Array.isArray(parsed)) return parsed;
    if (parsed && typeof parsed === "object" && "data" in parsed && Array.isArray(parsed.data)) return parsed.data;
    return [];
}
function parseApiResponse(parsed) {
    if (parsed && typeof parsed === "object" && "data" in parsed) {
        const payload = parsed;
        return {
            data: parseGamesList(parsed),
            revision: typeof payload.revision === "number" ? payload.revision : null
        };
    }
    return {
        data: parseGamesList(parsed),
        revision: null
    };
}
function fetchGamesEnabledFromApi(force = false) {
    if (!gamesEnabledFetchPromise) {
        const url = new URL(`${"https://cricket8.com/api"}/isgameenabled/ALL`);
        if (force) url.searchParams.set("_", String(Date.now()));
        gamesEnabledFetchPromise = fetch(url.toString(), {
            method: "GET",
            headers: (0, _authHeaders.getAuthHeaders)(),
            cache: "no-store"
        }).then((res)=>{
            if (res.status !== 200) return Promise.reject(new Error(`HTTP ${res.status}`));
            return res.json();
        }).then((parsed)=>{
            const { data, revision } = parseApiResponse(parsed);
            knownRevision = revision;
            return {
                data,
                revision
            };
        }).finally(()=>{
            gamesEnabledFetchPromise = null;
        });
    }
    return gamesEnabledFetchPromise;
}
function fetchRemoteGamesRevision() {
    const url = new URL(`${"https://cricket8.com/api"}/player-games/revision`);
    url.searchParams.set("_", String(Date.now()));
    return fetch(url.toString(), {
        method: "GET",
        headers: (0, _authHeaders.getAuthHeaders)(),
        cache: "no-store"
    }).then((res)=>{
        if (res.status !== 200) return Promise.reject(new Error(`HTTP ${res.status}`));
        return res.json();
    }).then((parsed)=>{
        if (parsed && typeof parsed === "object" && typeof parsed.revision === "number") return parsed.revision;
        return null;
    });
}
function checkRemoteGamesRevision() {
    return fetchRemoteGamesRevision().then((remoteRevision)=>{
        if (remoteRevision == null) return;
        if (knownRevision != null && remoteRevision === knownRevision) return;
        return ensureGamesEnabledLoaded(true);
    }).catch(()=>{});
}
function startGamesEnabledRevisionWatch() {
    if (typeof window === "undefined" || revisionWatchStarted) return;
    revisionWatchStarted = true;
    const onVisibilityChange = ()=>{
        if (document.hidden) return;
        checkRemoteGamesRevision();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    window.setInterval(()=>{
        if (!document.hidden) checkRemoteGamesRevision();
    }, GAMES_ENABLED_REVISION_POLL_MS);
    checkRemoteGamesRevision();
}
function prefetchGamesEnabled() {
    if (typeof window === "undefined") return;
    clearLegacyGamesEnabledStorage();
    ensureGamesEnabledLoaded(false);
    startGamesEnabledRevisionWatch();
}
function ensureGamesEnabledLoaded(force = false) {
    const hasDisplayData = snapshot.data.length > 0;
    if (!hasDisplayData) updateGamesEnabledSnapshot({
        loading: true,
        error: false
    });
    return fetchGamesEnabledFromApi(force).then(({ data })=>{
        updateGamesEnabledSnapshot({
            data,
            loading: false,
            error: false
        });
    }).catch(()=>{
        if (!hasDisplayData) updateGamesEnabledSnapshot({
            data: [],
            loading: false,
            error: true
        });
        else updateGamesEnabledSnapshot({
            loading: false,
            error: true
        });
    });
}
function deriveFlags(data, isLoading) {
    const byName = (name)=>data.find((x)=>(x.game_name || "").toLowerCase() === name.toLowerCase());
    const resolveGame = (name)=>{
        const row = byName(name);
        if (isLoading && !row) return {
            visible: false,
            live: false,
            comingSoon: false
        };
        return (0, _gamePlayerVisibility.resolvePlayerGameState)(row);
    };
    const bullion = resolveGame("Bullion");
    const sixes = resolveGame("Sixes");
    const squares = resolveGame("Squares");
    const trader = resolveGame("Trader");
    const quickfire = resolveGame("Quickfire");
    return {
        isBullionEnabled: bullion.live,
        isBullionVisible: bullion.visible,
        isBullionComingSoon: bullion.comingSoon,
        isSixesEnabled: sixes.live,
        isSixesVisible: sixes.visible,
        isSixesComingSoon: sixes.comingSoon,
        isSquaresEnabled: squares.live,
        isSquaresVisible: squares.visible,
        isSquaresComingSoon: squares.comingSoon,
        isTraderEnabled: trader.live,
        isTraderVisible: trader.visible,
        isTraderComingSoon: trader.comingSoon,
        isQuickfireEnabled: quickfire.live,
        isQuickfireVisible: quickfire.visible,
        isQuickfireComingSoon: quickfire.comingSoon,
        bullionVisibility: (0, _gamePlayerVisibility.readPlayerVisibility)(byName("Bullion")),
        sixesVisibility: (0, _gamePlayerVisibility.readPlayerVisibility)(byName("Sixes")),
        squaresVisibility: (0, _gamePlayerVisibility.readPlayerVisibility)(byName("Squares")),
        traderVisibility: (0, _gamePlayerVisibility.readPlayerVisibility)(byName("Trader")),
        quickfireVisibility: (0, _gamePlayerVisibility.readPlayerVisibility)(byName("Quickfire"))
    };
}
function useGamesEnabled() {
    const { data, loading, error } = (0, _react.useSyncExternalStore)(subscribeGamesEnabled, getGamesEnabledSnapshot, getGamesEnabledSnapshot);
    (0, _react.useEffect)(()=>{
        ensureGamesEnabledLoaded(false);
        startGamesEnabledRevisionWatch();
    }, []);
    const flags = deriveFlags(data, loading);
    return {
        data,
        ...flags,
        loading,
        error
    };
}

},{"react":"6uln9","../utils/authHeaders":"5Rczo","../utils/gamePlayerVisibility":"dJrDr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJrDr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readPlayerVisibility", ()=>readPlayerVisibility);
parcelHelpers.export(exports, "resolveTeaserGameState", ()=>resolveTeaserGameState);
parcelHelpers.export(exports, "resolvePlayerGameState", ()=>resolvePlayerGameState);
parcelHelpers.export(exports, "playerStatusLabel", ()=>playerStatusLabel);
parcelHelpers.export(exports, "playerStatusTone", ()=>playerStatusTone);
parcelHelpers.export(exports, "nextPlayerVisibility", ()=>nextPlayerVisibility);
parcelHelpers.export(exports, "visibilityActionLabel", ()=>visibilityActionLabel);
parcelHelpers.export(exports, "visibilitySummaryLabel", ()=>visibilitySummaryLabel);
function readPlayerVisibility(row) {
    const raw = String(row?.player_visibility || "").toLowerCase();
    if (raw === "coming_soon") return "coming_soon";
    if (raw === "hidden") return "hidden";
    if (raw === "live") return "live";
    if (row?.is_enabled) return "live";
    const gameName = String(row?.game_name || "").toLowerCase();
    if (gameName === "bullion" || gameName === "sixes") return "coming_soon";
    return "hidden";
}
function resolveTeaserGameState(row) {
    return resolvePlayerGameState(row);
}
function resolvePlayerGameState(row) {
    if (!row) return {
        visible: false,
        live: false,
        comingSoon: false
    };
    const visibility = readPlayerVisibility(row);
    if (visibility === "hidden") return {
        visible: false,
        live: false,
        comingSoon: false
    };
    const live = Boolean(row?.is_enabled);
    if (visibility === "coming_soon") return {
        visible: true,
        live: false,
        comingSoon: true
    };
    return {
        visible: true,
        live,
        comingSoon: !live
    };
}
function playerStatusLabel(status) {
    if (status === "Coming soon" || status === "Hidden") return status;
    return "Live";
}
function playerStatusTone(status) {
    return status === "Live" ? "success" : "neutral";
}
function nextPlayerVisibility(game) {
    if (game.supports_coming_soon) {
        if (game.player_visibility === "live") return "coming_soon";
        if (game.player_visibility === "coming_soon") return "hidden";
        return "live";
    }
    return game.player_visibility === "live" ? "hidden" : "live";
}
function visibilityActionLabel(nextVisibility) {
    if (nextVisibility === "live") return "Set live";
    if (nextVisibility === "coming_soon") return "Set coming soon";
    return "Set hidden";
}
function visibilitySummaryLabel(visibility) {
    if (visibility === "live") return "Live";
    if (visibility === "coming_soon") return "Coming soon";
    return "Hidden";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgpEe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMyLeaguesLists", ()=>useMyLeaguesLists);
/**
 * Leagues nav / tiles are visible to everyone when the Leagues platform flag is on; logged-out
 * visitors land on a sign-up screen. `vip` means "may create leagues and invite friends": any
 * non-guest account. Private invite links stay reachable without this gate.
 */ parcelHelpers.export(exports, "useLeaguesAccess", ()=>useLeaguesAccess);
parcelHelpers.export(exports, "openMyLeaguesDrawer", ()=>openMyLeaguesDrawer);
parcelHelpers.export(exports, "OPEN_CREATE_LEAGUE_MODAL_EVENT", ()=>OPEN_CREATE_LEAGUE_MODAL_EVENT);
/** Opens create-league modal at app level (survives play drawer close; stacks above header overlay). */ parcelHelpers.export(exports, "openCreateLeagueModal", ()=>openCreateLeagueModal);
var _react = require("react");
var _userContext = require("../../../Data/UserContext");
var _usePlatformFeatureFlags = require("../../../hooks/usePlatformFeatureFlags");
var _leagueApiStore = require("../lib/leagueApiStore");
var _leagueFormat = require("../lib/leagueFormat");
var _leaguesDataSource = require("../lib/LeaguesDataSource");
var _useLeaguesPrototype = require("./useLeaguesPrototype");
function useMyLeaguesLists(now) {
    const { leagues, vip, simulating } = (0, _useLeaguesPrototype.useLeaguesState)();
    // An invite to a league that has finished or been cancelled can never be accepted — the join
    // endpoint rejects it — so it must not sit in the list with a live Join button.
    const invites = (0, _react.useMemo)(()=>leagues.filter((league)=>league.membership === "invited" && (0, _leagueFormat.leagueStatus)(league, now) !== "ended"), [
        leagues,
        now
    ]);
    const mine = (0, _react.useMemo)(()=>leagues.filter((league)=>league.membership === "host" || league.membership === "member"), [
        leagues
    ]);
    const { active, ended } = (0, _react.useMemo)(()=>{
        const activeLeagues = [];
        const endedLeagues = [];
        mine.forEach((league)=>{
            if ((0, _leagueFormat.leagueStatus)(league, now) === "ended" || (0, _leagueFormat.isLeagueRefunded)(league, now)) endedLeagues.push(league);
            else activeLeagues.push(league);
        });
        const startMs = (league)=>new Date(league.startsAt).getTime();
        // Same as public hub: soonest match start first (live already-started rows surface first).
        const byStartAsc = (a, b)=>startMs(a) - startMs(b);
        // Past: most recent match start first.
        const byStartDesc = (a, b)=>startMs(b) - startMs(a);
        return {
            active: activeLeagues.sort(byStartAsc),
            ended: endedLeagues.sort(byStartDesc)
        };
    }, [
        mine,
        now
    ]);
    return {
        leagues,
        invites,
        mine,
        active,
        ended,
        vip,
        simulating
    };
}
function useLeaguesAccess() {
    const { user, loading: userLoading } = (0, _userContext.useUser)();
    const { isLeaguesEnvEnabled, loading: flagsLoading } = (0, _usePlatformFeatureFlags.usePlatformFeatureFlags)();
    const snap = (0, _react.useSyncExternalStore)((0, _leaguesDataSource.apiDataSource).subscribe, (0, _leaguesDataSource.apiDataSource).getSnapshot, (0, _leaguesDataSource.apiDataSource).getSnapshot);
    const userId = user?.userId != null && String(user.userId) !== "" ? String(user.userId) : null;
    (0, _react.useEffect)(()=>{
        if (userId || !userLoading) (0, _leagueApiStore.setLeaguesViewer)(userId);
    }, [
        userId,
        userLoading
    ]);
    if (!isLeaguesEnvEnabled) return {
        ready: !flagsLoading && !userLoading,
        canAccess: false,
        vip: false,
        listReady: !userLoading,
        loggedIn: Boolean(userId)
    };
    if (!userId) return {
        ready: !userLoading,
        canAccess: !userLoading,
        vip: false,
        listReady: !userLoading,
        loggedIn: false
    };
    const hydrated = snap.hydratedFor === userId;
    const vip = user?.is_guest !== true;
    return {
        ready: true,
        canAccess: true,
        vip,
        listReady: hydrated,
        loggedIn: true
    };
}
function openMyLeaguesDrawer(detail) {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent("openMyLeaguesDrawer", {
        detail: detail ?? {}
    }));
}
const OPEN_CREATE_LEAGUE_MODAL_EVENT = "openCreateLeagueModal";
function openCreateLeagueModal(detail) {
    if (typeof window === "undefined") return;
    const fixtureId = typeof detail?.fixtureId === "string" ? detail.fixtureId.trim() : "";
    const rawFriendId = detail?.challengeFriendUserId;
    const challengeFriendUserId = typeof rawFriendId === "number" && Number.isFinite(rawFriendId) && rawFriendId > 0 ? Math.trunc(rawFriendId) : undefined;
    const nextDetail = {};
    if (fixtureId) nextDetail.fixtureId = fixtureId;
    if (challengeFriendUserId != null) nextDetail.challengeFriendUserId = challengeFriendUserId;
    window.dispatchEvent(new CustomEvent(OPEN_CREATE_LEAGUE_MODAL_EVENT, {
        detail: nextDetail
    }));
}

},{"react":"6uln9","../../../Data/UserContext":"aqd8b","../../../hooks/usePlatformFeatureFlags":"Ruxh7","../lib/leagueApiStore":"ju6aY","../lib/leagueFormat":"jKCIi","../lib/LeaguesDataSource":"hvV1t","./useLeaguesPrototype":"kpdfK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Ruxh7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Shared hook for `/platform-flags`. Caches for 2 minutes so login, layout, and routes
 * reuse the same runtime admin overrides without a frontend redeploy.
 */ parcelHelpers.export(exports, "usePlatformFeatureFlags", ()=>usePlatformFeatureFlags);
var _react = require("react");
var _authHeaders = require("../utils/authHeaders");
var _featureFlags = require("../utils/featureFlags");
const PLATFORM_FLAGS_CACHE_TTL_MS = 120000;
let platformFlagsCache = null;
function getCached() {
    if (!platformFlagsCache) return null;
    if (Date.now() - platformFlagsCache.timestamp > PLATFORM_FLAGS_CACHE_TTL_MS) {
        platformFlagsCache = null;
        return null;
    }
    return platformFlagsCache.data;
}
function setCached(data) {
    platformFlagsCache = {
        data,
        timestamp: Date.now()
    };
    (0, _featureFlags.setRuntimePlatformFlags)(data);
}
function usePlatformFeatureFlags() {
    const envFallback = (0, _featureFlags.getEnvFallbackPlatformFlags)();
    const cached = getCached();
    const [flags, setFlags] = (0, _react.useState)(cached ?? envFallback);
    const [loading, setLoading] = (0, _react.useState)(!cached);
    const [error, setError] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const cachedNow = getCached();
        if (cachedNow) {
            setFlags(cachedNow);
            setLoading(false);
            setError(false);
            return;
        }
        let cancelled = false;
        setLoading(true);
        setError(false);
        fetch(`${"https://cricket8.com/api"}/platform-flags`, {
            method: "GET",
            headers: (0, _authHeaders.getAuthHeaders)()
        }).then((res)=>{
            if (cancelled) return null;
            if (res.status !== 200) return Promise.reject(new Error(`HTTP ${res.status}`));
            return res.json();
        }).then((parsed)=>{
            if (cancelled) return;
            const parsedFlags = (0, _featureFlags.parsePlatformFlagsResponse)(parsed);
            if (!parsedFlags) {
                setError(true);
                return;
            }
            setFlags(parsedFlags);
            setCached(parsedFlags);
            setError(false);
        }).catch(()=>{
            if (!cancelled) setError(true);
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    return {
        flags,
        loading,
        error,
        isSmsLoginEnabled: flags.sms_login,
        isBullionEnvEnabled: flags.bullion_env,
        isSixesEnvEnabled: flags.sixes_env,
        isNewRegistrationBonusEnabled: flags.new_registration_bonus,
        isLeaguesEnvEnabled: flags.leagues_env
    };
}

},{"react":"6uln9","../utils/authHeaders":"5Rczo","../utils/featureFlags":"aMvyj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMvyj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setRuntimePlatformFlags", ()=>setRuntimePlatformFlags);
/** Build-time defaults used until `/platform-flags` loads. */ parcelHelpers.export(exports, "getEnvFallbackPlatformFlags", ()=>getEnvFallbackPlatformFlags);
parcelHelpers.export(exports, "parsePlatformFlagsResponse", ()=>parsePlatformFlagsResponse);
/** Mirrors backend `featureFlags.isSmsLoginEnabled`. */ parcelHelpers.export(exports, "isSmsLoginEnabled", ()=>isSmsLoginEnabled);
/** Mirrors backend `featureFlags.isBullionEnabled`. */ parcelHelpers.export(exports, "isBullionEnvEnabled", ()=>isBullionEnvEnabled);
/** Mirrors backend `featureFlags.isSixesEnabled`. */ parcelHelpers.export(exports, "isSixesEnvEnabled", ()=>isSixesEnvEnabled);
/** Mirrors backend `featureFlags.isNewRegistrationBonusEnabled`. */ parcelHelpers.export(exports, "isNewRegistrationBonusEnabled", ()=>isNewRegistrationBonusEnabled);
/**
 * Header / drawer active-game badge — exclude in-progress BULLION/SIXES when the platform
 * env flag is off. Pass `isBullionEnvEnabled()` / `isSixesEnvEnabled()` (same source as the
 * count API), not player lobby `live` flags from `useGamesEnabled` (those are false while
 * loading and will zero the badge).
 */ parcelHelpers.export(exports, "computeMyGamesBadgeCount", ()=>computeMyGamesBadgeCount);
const PLATFORM_FLAG_KEYS = [
    "sms_login",
    "bullion_env",
    "sixes_env",
    "new_registration_bonus"
];
let runtimeFlags = null;
function setRuntimePlatformFlags(flags) {
    runtimeFlags = flags;
}
function readEnvDefault(raw) {
    if (raw == null || raw === "") return true;
    return raw.toLowerCase() !== "false";
}
function getEnvFallbackPlatformFlags() {
    return {
        sms_login: true,
        bullion_env: readEnvDefault("true"),
        sixes_env: readEnvDefault(undefined),
        new_registration_bonus: true,
        leagues_env: false
    };
}
function effective(key) {
    if (runtimeFlags) return runtimeFlags[key];
    return getEnvFallbackPlatformFlags()[key];
}
function parsePlatformFlagsResponse(parsed) {
    if (!parsed || typeof parsed !== "object") return null;
    const data = parsed.data;
    if (!data || typeof data !== "object") return null;
    const record = data;
    const result = {};
    for (const key of PLATFORM_FLAG_KEYS){
        if (typeof record[key] !== "boolean") return null;
        result[key] = record[key];
    }
    result.leagues_env = record.leagues_env === true;
    return result;
}
function isSmsLoginEnabled() {
    return effective("sms_login");
}
function isBullionEnvEnabled() {
    return effective("bullion_env");
}
function isSixesEnvEnabled() {
    return effective("sixes_env");
}
function isNewRegistrationBonusEnabled() {
    return effective("new_registration_bonus");
}
function computeMyGamesBadgeCount(totalActiveGames, bullionActivePlaysCount, isBullionEnabled, sixesActiveCardsCount, isSixesEnabled) {
    let total = Math.max(0, parseInt(String(totalActiveGames ?? 0), 10) || 0);
    if (!isBullionEnabled) {
        const bullion = Math.max(0, parseInt(String(bullionActivePlaysCount ?? 0), 10) || 0);
        total = Math.max(0, total - bullion);
    }
    if (isSixesEnabled === false) {
        const sixes = Math.max(0, parseInt(String(sixesActiveCardsCount ?? 0), 10) || 0);
        total = Math.max(0, total - sixes);
    }
    return total;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ju6aY":[function(require,module,exports,__globalThis) {
/**
 * API-backed Leagues store.
 *
 * Mirrors the prototype store's external-store contract (`subscribeToLeagues` /
 * `getLeaguesSnapshot` returning a `LeaguesState`) so the same React hooks can
 * read from either source. Instead of a client-side simulation timer, this store
 * loads from the backend and polls while there are active subscribers — real
 * settlements land via the lifecycle/settlement cron and show up on the next poll.
 *
 * Actions call the real endpoints in `leagueApi.ts` and merge the fresh league
 * the server returns back into the cached snapshot, then notify subscribers.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "leagueDetailPollMs", ()=>leagueDetailPollMs);
/** Optimistic sent/received tallies so the board updates before the next feed poll. */ parcelHelpers.export(exports, "recordLiveLeagueReaction", ()=>recordLiveLeagueReaction);
/** Activity-feed only — does not bump sent/received so the leaderboard hit can play first. */ parcelHelpers.export(exports, "recordLiveLeagueReactionActivity", ()=>recordLiveLeagueReactionActivity);
/** Reflect a player-name change in every held league now, instead of waiting for the next poll. */ parcelHelpers.export(exports, "renameLeagueMember", ()=>renameLeagueMember);
parcelHelpers.export(exports, "getLeaguesApiSnapshot", ()=>getLeaguesApiSnapshot);
/**
 * Tell the store who is viewing (user id, or null for guests). On a change it swaps in that
 * viewer's persisted list so the hub / nav render instantly, then revalidates from the server.
 */ parcelHelpers.export(exports, "setLeaguesViewer", ()=>setLeaguesViewer);
/** Refresh the whole list + VIP flag from the server. */ parcelHelpers.export(exports, "refreshLeagues", ()=>refreshLeagues);
parcelHelpers.export(exports, "subscribeToLeaguesApi", ()=>subscribeToLeaguesApi);
/** Fetch one league and merge it in — used by the detail route (and its live poll). */ parcelHelpers.export(exports, "loadLeagueDetail", ()=>loadLeagueDetail);
/** Fetch a league by share code fresh and merge it in — used by the join landing. */ parcelHelpers.export(exports, "loadLeagueByCode", ()=>loadLeagueByCode);
parcelHelpers.export(exports, "findLeagueApi", ()=>findLeagueApi);
/** Optimistic/local update after POST/DELETE /leagues/:id/remind. */ parcelHelpers.export(exports, "patchLeagueRemindMeApi", ()=>patchLeagueRemindMeApi);
parcelHelpers.export(exports, "findLeagueByCodeApi", ()=>findLeagueByCodeApi);
parcelHelpers.export(exports, "createLeagueApi", ()=>createLeagueApi);
parcelHelpers.export(exports, "joinLeagueApi", ()=>joinLeagueApi);
parcelHelpers.export(exports, "topUpLeagueSeatApi", ()=>topUpLeagueSeatApi);
parcelHelpers.export(exports, "declineLeagueApi", ()=>declineLeagueApi);
parcelHelpers.export(exports, "inviteFriendsApi", ()=>inviteFriendsApi);
parcelHelpers.export(exports, "placeLeaguePlayApi", ()=>placeLeaguePlayApi);
/**
 * Fetch (and lazily create, server-side) the league's Bullion battle, merging it onto the cached
 * league so the lobby card renders real data. Returns the battle (or null when not ready yet).
 */ parcelHelpers.export(exports, "loadBullionBattleApi", ()=>loadBullionBattleApi);
/** Enter (or replace) the viewer's Bullion battle slip; merges the fresh league the server returns. */ parcelHelpers.export(exports, "enterBullionBattleApi", ()=>enterBullionBattleApi);
var _leagueApi = require("./leagueApi");
var _persistedLeagueId = require("./persistedLeagueId");
var _leagueListFinal = require("./leagueListFinal");
var _leagueWire = require("./leagueWire");
var _leagueReactionStats = require("./leagueReactionStats");
const DEFAULT_POLL_MS = 15000;
/** No live (or about to start) league in the list: hub cards and the nav badge barely change. */ const IDLE_POLL_MS = 60000;
/** Treat a league as active this long before kickoff so the first-ball switch is picked up. */ const ACTIVE_BEFORE_START_MS = 1800000;
/**
 * Open live league page: full feed (plays / settlements / activity). Hub list is card-only.
 * Matches the ~5s server feed cache so every member of a live league sees new rows quickly
 * without each client bypassing the shared snapshot. Prematch / ended pages hydrate once.
 */ const DEFAULT_DETAIL_POLL_MS = 4000;
function pollIntervalMs() {
    const raw = Number(undefined);
    return Number.isFinite(raw) && raw >= 3000 ? raw : DEFAULT_POLL_MS;
}
function leagueDetailPollMs() {
    const raw = Number(undefined);
    return Number.isFinite(raw) && raw >= 2000 ? raw : DEFAULT_DETAIL_POLL_MS;
}
/** Real data has no client-side simulation; `simulating` stays false. */ const EMPTY_STATE = {
    leagues: [],
    vip: false,
    simulating: false
};
/** v2 stores leagues in wire form where possible, so the first poll after a reload is a delta. */ const CACHE_KEY_PREFIX = "c8_leagues_cache_v2_";
const LEGACY_CACHE_KEY_PREFIX = "c8_leagues_cache_v1_";
/** Skip persisting very large payloads (plays/settlements) rather than blowing the storage quota. */ const CACHE_MAX_CHARS = 1500000;
const listeners = new Set();
let state = EMPTY_STATE;
let pollId = null;
let loadedOnce = false;
let inFlight = null;
let inFlightKey = undefined;
let viewerKey = undefined;
/**
 * Leagues trusted for the final-league fingerprint: server-fresh in this session, or finalized
 * rows hydrated from localStorage (settledAt/cancelledAt are immutable, so a matching
 * fingerprint can stub them on the first poll without a full past-league download).
 */ const serverFreshIds = new Set();
function knownFinalFingerprint() {
    const markers = [];
    for (const league of state.leagues){
        if (isSharePreviewLeague(league) || !serverFreshIds.has(league.id)) continue;
        const marker = (0, _leagueListFinal.leagueFinalMarker)(league);
        if (marker) markers.push(marker);
    }
    return markers.length > 0 ? (0, _leagueListFinal.finalLeaguesFingerprint)(markers) : null;
}
/** Trust cached finals for the fingerprint so cold loads can stub past leagues immediately. */ function markCachedFinalsFresh(leagues) {
    for (const league of leagues){
        if (isSharePreviewLeague(league)) continue;
        if ((0, _leagueListFinal.leagueFinalMarker)(league)) serverFreshIds.add(league.id);
    }
}
function readCache(key) {
    try {
        const raw = localStorage.getItem(`${CACHE_KEY_PREFIX}${key}`);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed.leagues)) return null;
        const leagues = parsed.leagues.map((row)=>(0, _leagueWire.hydrateWireLeague)(row)).filter((row)=>row != null);
        return {
            leagues,
            vip: Boolean(parsed.vip)
        };
    } catch  {
        return null;
    }
}
function writeCache(key, leagues, vip) {
    try {
        localStorage.removeItem(`${LEGACY_CACHE_KEY_PREFIX}${key}`);
        const stored = leagues.map((league)=>(0, _leagueWire.completeWireLeague)(league) ?? league);
        const raw = JSON.stringify({
            leagues: stored,
            vip
        });
        if (raw.length > CACHE_MAX_CHARS) {
            localStorage.removeItem(`${CACHE_KEY_PREFIX}${key}`);
            return;
        }
        localStorage.setItem(`${CACHE_KEY_PREFIX}${key}`, raw);
    } catch  {
    /* Storage full / disabled — the cache is only a speed-up. */ }
}
function emit() {
    listeners.forEach((listener)=>listener());
}
/** Only replace state (and re-render) when something actually changed. */ function commit(next) {
    if (sameState(state, next)) return;
    state = next;
    if (next.loadedFor && next.loadedFor === viewerKey) writeCache(next.loadedFor, next.leagues.filter((row)=>!isSharePreviewLeague(row)), next.vip);
    emit();
}
function sameState(a, b) {
    if (a === b) return true;
    if (a.vip !== b.vip || a.simulating !== b.simulating) return false;
    if (a.loadedFor !== b.loadedFor || a.hydratedFor !== b.hydratedFor) return false;
    if (a.leagues.length !== b.leagues.length) return false;
    // Hydration hands back the same object for an unchanged league, so only rebuilt ones are
    // compared structurally (they can still be equal, e.g. a mutation response).
    return a.leagues.every((league, i)=>league === b.leagues[i] || JSON.stringify(league) === JSON.stringify(b.leagues[i]));
}
function upsertLeague(league) {
    if (!league) return;
    serverFreshIds.add(league.id);
    const idx = state.leagues.findIndex((row)=>row.id === league.id);
    // A league the viewer declined/left should drop out of their list on refresh;
    // upsert only ever adds or replaces — removal happens via a full refresh.
    const leagues = idx >= 0 ? state.leagues.map((row, i)=>i === idx ? league : row) : [
        league,
        ...state.leagues
    ];
    commit({
        ...state,
        leagues
    });
}
const appliedReactionIds = new Set();
function recordLiveLeagueReaction(input) {
    const { reactionId, leagueId, fromUserId, targetUserId, emoji } = input;
    if (!reactionId || !leagueId || fromUserId === targetUserId) return;
    if (appliedReactionIds.has(reactionId)) return;
    appliedReactionIds.add(reactionId);
    if (appliedReactionIds.size > 80) {
        const keep = [
            ...appliedReactionIds
        ].slice(-40);
        appliedReactionIds.clear();
        for (const id of keep)appliedReactionIds.add(id);
    }
    const current = findLeagueApi(leagueId);
    if (!current) return;
    const event = (0, _leagueReactionStats.leagueReactionActivityFromThrow)({
        reactionId,
        members: current.members,
        fromUserId,
        fromPlayerName: input.fromPlayerName,
        targetUserId,
        emoji
    });
    upsertLeague({
        ...current,
        members: (0, _leagueReactionStats.applyLeagueReactionToMembers)(current.members, {
            fromUserId,
            targetUserId,
            emoji
        }),
        reactionEvents: event ? (0, _leagueReactionStats.prependLeagueReactionEvent)(current.reactionEvents, event) : current.reactionEvents
    });
}
function recordLiveLeagueReactionActivity(input) {
    const { reactionId, leagueId, fromUserId, targetUserId, emoji } = input;
    if (!reactionId || !leagueId || fromUserId === targetUserId) return;
    const current = findLeagueApi(leagueId);
    if (!current) return;
    const event = (0, _leagueReactionStats.leagueReactionActivityFromThrow)({
        reactionId,
        members: current.members,
        fromUserId,
        fromPlayerName: input.fromPlayerName,
        targetUserId,
        emoji
    });
    if (!event) return;
    if ((current.reactionEvents ?? []).some((row)=>row.id === event.id)) return;
    upsertLeague({
        ...current,
        reactionEvents: (0, _leagueReactionStats.prependLeagueReactionEvent)(current.reactionEvents, event)
    });
}
function renameLeagueMember(userId, playerName) {
    let changed = false;
    const leagues = state.leagues.map((league)=>{
        if (!league.members.some((m)=>m.userId === userId && m.playerName !== playerName)) return league;
        changed = true;
        return {
            ...league,
            members: league.members.map((m)=>m.userId === userId ? {
                    ...m,
                    playerName
                } : m)
        };
    });
    if (changed) commit({
        ...state,
        leagues
    });
}
function removeLeague(leagueId) {
    const leagues = state.leagues.filter((row)=>row.id !== leagueId);
    if (leagues.length === state.leagues.length) return;
    commit({
        ...state,
        leagues
    });
}
/**
 * Share-link / join-landing leagues the viewer has not joined yet.
 * `GET /leagues` never returns these, so a full list refresh must not drop them —
 * especially when logged out (list 401) while Header still polls the store.
 */ function isSharePreviewLeague(league) {
    return league.membership === "none";
}
/** Keep join-by-code (and similar) previews that the viewer's list endpoint omits. */ function mergeListedWithPreviews(listed) {
    const listedIds = new Set(listed.map((row)=>row.id));
    const previews = state.leagues.filter((row)=>isSharePreviewLeague(row) && !listedIds.has(row.id));
    return previews.length === 0 ? listed : [
        ...listed,
        ...previews
    ];
}
function getLeaguesApiSnapshot() {
    return state;
}
function setLeaguesViewer(key) {
    if (key === viewerKey) return;
    viewerKey = key;
    if (state.loadedFor === key) return;
    serverFreshIds.clear();
    (0, _leagueWire.resetLeagueWire)();
    const cached = key ? readCache(key) : null;
    if (cached?.leagues?.length) markCachedFinalsFresh(cached.leagues);
    commit({
        leagues: mergeListedWithPreviews(cached?.leagues ?? []),
        vip: cached?.vip ?? false,
        simulating: false,
        hydratedFor: cached ? key : undefined
    });
    refreshLeagues();
}
/** VIP rarely changes: background polls reuse it for this long; explicit refreshes always recheck. */ const VIP_POLL_REFRESH_MS = 300000;
let vipCheckedAt = 0;
let vipCheckedFor;
let lastRefreshAt = 0;
function isTabHidden() {
    return typeof document !== "undefined" && document.visibilityState === "hidden";
}
async function refreshLeagues(opts = {}) {
    if (inFlight) {
        // A request started before the viewer was known is adopted by whoever reports first.
        if (inFlightKey === undefined || inFlightKey === viewerKey) return inFlight;
        return inFlight.then(()=>refreshLeagues());
    }
    const requestedKey = viewerKey;
    inFlightKey = requestedKey;
    const resolveKey = ()=>requestedKey === undefined ? viewerKey : requestedKey;
    lastRefreshAt = Date.now();
    const vipFresh = opts.poll === true && vipCheckedFor === requestedKey && Date.now() - vipCheckedAt < VIP_POLL_REFRESH_MS;
    inFlight = (async ()=>{
        try {
            const final = knownFinalFingerprint();
            const [firstListed, vip] = await Promise.all([
                (0, _leagueApi.apiLeaguesFeed)(final, (0, _leagueWire.leagueWireHave)()),
                vipFresh ? state.vip : (0, _leagueApi.apiGetVipStatus)().then((v)=>{
                    vipCheckedAt = Date.now();
                    vipCheckedFor = requestedKey;
                    return v;
                }, ()=>state.vip)
            ]);
            let listed = firstListed;
            let hydrated = listed.map((row)=>(0, _leagueListFinal.isUnchangedLeagueStub)(row) ? row : (0, _leagueWire.hydrateWireLeague)(row));
            if (hydrated.includes(null)) {
                // A reused chunk was dropped by a racing fetch — ask again without reuse.
                (0, _leagueWire.resetLeagueWire)();
                listed = await (0, _leagueApi.apiLeaguesFeed)(final, {});
                hydrated = listed.map((row)=>(0, _leagueListFinal.isUnchangedLeagueStub)(row) ? row : (0, _leagueWire.hydrateWireLeague)(row));
            }
            const key = resolveKey();
            // Viewer switched mid-flight — this payload belongs to someone else.
            if (key !== viewerKey) return;
            loadedOnce = true;
            const heldById = new Map(state.leagues.map((row)=>[
                    row.id,
                    row
                ]));
            const leagues = [];
            let missingHeld = false;
            for (const row of hydrated){
                if (!row) continue;
                if ((0, _leagueListFinal.isUnchangedLeagueStub)(row)) {
                    const held = heldById.get(row.id);
                    if (held) {
                        serverFreshIds.add(row.id);
                        leagues.push(held);
                    } else missingHeld = true;
                    continue;
                }
                serverFreshIds.add(row.id);
                leagues.push((0, _leagueListFinal.mergeListSlimLeague)(heldById.get(row.id), row));
            }
            const listedIds = new Set(listed.map((row)=>row.id));
            for (const id of Object.keys((0, _leagueWire.leagueWireHave)()))if (!listedIds.has(id)) (0, _leagueWire.resetLeagueWire)(id);
            // A stub we can't resolve (e.g. removed mid-flight): force a full list next poll.
            if (missingHeld) serverFreshIds.clear();
            commit({
                leagues: mergeListedWithPreviews(leagues),
                vip,
                simulating: false,
                loadedFor: key,
                hydratedFor: key
            });
        } catch (e) {
            // Keep the last good snapshot on a transient failure; polling will retry.
            // On 401 (logged out), drop viewer leagues but keep share-code previews so the
            // join landing is not wiped by Header's store subscription.
            if (e instanceof (0, _leagueApi.LeagueApiError) && e.status === 401) {
                const key = resolveKey();
                if (key !== viewerKey) return;
                loadedOnce = true;
                serverFreshIds.clear();
                (0, _leagueWire.resetLeagueWire)();
                vipCheckedFor = undefined;
                const previews = state.leagues.filter(isSharePreviewLeague);
                commit({
                    leagues: previews,
                    vip: false,
                    simulating: false,
                    loadedFor: key,
                    hydratedFor: key
                });
            }
        } finally{
            inFlight = null;
            inFlightKey = undefined;
        }
    })();
    return inFlight;
}
function hasActiveLeague(now) {
    return state.leagues.some((league)=>{
        if (isSharePreviewLeague(league) || league.settledAt || league.cancelledAt) return false;
        const start = new Date(league.startsAt).getTime();
        const end = new Date(league.endsAt).getTime();
        if (Number.isFinite(end) && now >= end) return false;
        return !Number.isFinite(start) || now >= start - ACTIVE_BEFORE_START_MS;
    });
}
/** Fast while a league is live or about to start; otherwise an idle cadence. */ function currentPollMs() {
    const fast = pollIntervalMs();
    return hasActiveLeague(Date.now()) ? fast : Math.max(fast, IDLE_POLL_MS);
}
/** Background tabs skip ticks; coming back catches up at once if a tick was missed. */ function onVisibilityChange() {
    if (viewerKey === null) return;
    if (!isTabHidden() && Date.now() - lastRefreshAt >= currentPollMs()) refreshLeagues({
        poll: true
    });
}
function scheduleNextPoll() {
    pollId = setTimeout(()=>{
        // Logged-out viewers have no league list to poll (the feed would 401 every tick).
        if (!isTabHidden() && viewerKey !== null && Date.now() - lastRefreshAt >= currentPollMs() - 1000) refreshLeagues({
            poll: true
        });
        scheduleNextPoll();
    }, pollIntervalMs());
}
function startPolling() {
    if (typeof window === "undefined" || pollId != null) return;
    scheduleNextPoll();
    document.addEventListener("visibilitychange", onVisibilityChange);
}
function stopPolling() {
    if (pollId != null) {
        clearTimeout(pollId);
        pollId = null;
        document.removeEventListener("visibilitychange", onVisibilityChange);
    }
}
function subscribeToLeaguesApi(listener) {
    listeners.add(listener);
    if (listeners.size === 1) {
        if (!loadedOnce) refreshLeagues();
        startPolling();
    }
    return ()=>{
        listeners.delete(listener);
        if (listeners.size === 0) stopPolling();
    };
}
const detailInFlight = new Map();
async function loadLeagueDetail(leagueId, opts) {
    const key = `${leagueId}:${opts?.fresh ? "1" : "0"}`;
    const existing = detailInFlight.get(key);
    if (existing) return existing;
    const promise = (async ()=>{
        try {
            const league = await (0, _leagueApi.apiGetLeague)(leagueId, {
                fresh: Boolean(opts?.fresh)
            });
            if (!league) return findLeagueApi(leagueId);
            upsertLeague((0, _leagueListFinal.mergePolledLeagueDetail)(findLeagueApi(leagueId), league));
            return findLeagueApi(leagueId) ?? league;
        } catch  {
            return findLeagueApi(leagueId);
        } finally{
            detailInFlight.delete(key);
        }
    })();
    detailInFlight.set(key, promise);
    return promise;
}
async function loadLeagueByCode(code) {
    try {
        const league = await (0, _leagueApi.apiGetLeagueByCode)(code);
        upsertLeague(league);
        return league;
    } catch (e) {
        if (e instanceof (0, _leagueApi.LeagueApiError) && e.status === 429) throw e;
        const held = findLeagueByCodeApi(code);
        if (held) return held;
        // Finished leagues the viewer already joined still appear on GET /leagues; by-code can
        // 404/500 while the list is cold or the join endpoint is flaky — refresh once and retry.
        try {
            await refreshLeagues();
        } catch  {
        /* keep going — find below may still hit a cached row */ }
        return findLeagueByCodeApi(code);
    }
}
function findLeagueApi(leagueId) {
    if (!leagueId) return null;
    return state.leagues.find((row)=>row.id === leagueId) ?? null;
}
function patchLeagueRemindMeApi(leagueId, remindMe) {
    const current = findLeagueApi(leagueId);
    if (!current) return;
    upsertLeague({
        ...current,
        remindMe: Boolean(remindMe)
    });
}
function findLeagueByCodeApi(code) {
    const needle = String(code ?? "").trim().toUpperCase();
    if (!needle) return null;
    return state.leagues.find((row)=>row.code.toUpperCase() === needle) ?? null;
}
async function createLeagueApi(input) {
    const league = await (0, _leagueApi.apiCreateLeague)(input);
    upsertLeague(league);
    return league;
}
async function joinLeagueApi(target) {
    const league = await (0, _leagueApi.apiJoinLeague)(target);
    upsertLeague(league);
    return league;
}
async function topUpLeagueSeatApi(leagueId) {
    const league = await (0, _leagueApi.apiTopUpLeagueSeat)(leagueId);
    upsertLeague(league);
    return league;
}
async function declineLeagueApi(leagueId) {
    await (0, _leagueApi.apiDeclineLeague)(leagueId);
    removeLeague(leagueId);
}
async function inviteFriendsApi(leagueId, userIds) {
    const { invited, league } = await (0, _leagueApi.apiInviteFriends)(leagueId, userIds);
    upsertLeague(league);
    return invited;
}
async function placeLeaguePlayApi(leagueId, input) {
    const { playId, league } = await (0, _leagueApi.apiPlaceLeaguePlay)(leagueId, input);
    upsertLeague(league);
    return playId;
}
/** Merge a freshly-fetched Bullion battle onto the cached league (keeps other league fields). */ function mergeBattleIntoLeague(leagueId, battle) {
    const current = findLeagueApi(leagueId);
    if (!current) return;
    // A not-ready / empty battle response must not wipe a slip the lobby already has.
    if (!battle) return;
    upsertLeague({
        ...current,
        bullionBattle: battle
    });
}
async function loadBullionBattleApi(leagueId) {
    if (!(0, _persistedLeagueId.isPersistedLeagueId)(leagueId)) return {
        battle: null,
        reason: null
    };
    try {
        const { battle, reason } = await (0, _leagueApi.apiGetBullionBattle)(leagueId);
        mergeBattleIntoLeague(leagueId, battle);
        return {
            battle,
            reason
        };
    } catch  {
        return {
            battle: findLeagueApi(leagueId)?.bullionBattle ?? null,
            reason: null
        };
    }
}
async function enterBullionBattleApi(leagueId, slip) {
    const { playId, league, battle } = await (0, _leagueApi.apiEnterBullionBattle)(leagueId, slip);
    if (league) upsertLeague(league);
    else mergeBattleIntoLeague(leagueId, battle);
    return {
        playId,
        battle
    };
}

},{"./leagueApi":"bcswU","./persistedLeagueId":"gVyFA","./leagueListFinal":"l25FL","./leagueWire":"keY4u","./leagueReactionStats":"8M1NW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bcswU":[function(require,module,exports,__globalThis) {
/**
 * Real Leagues API client.
 *
 * Thin, typed wrappers over the backend `/leagues` routes (see
 * backend/controllers/leagues.controller.js). The backend already serializes
 * rows into the same shape as the frontend `League` type, so responses are
 * consumed with minimal mapping.
 *
 * Auth + base URL follow the app convention: `process.env.API_URL` for the base
 * and `getAuthHeaders()` for the Bearer token.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Error thrown by any client call. `code` mirrors the backend `error` field. */ parcelHelpers.export(exports, "LeagueApiError", ()=>LeagueApiError);
/** GET /leagues — the viewer's leagues + pending invites. */ parcelHelpers.export(exports, "apiListLeagues", ()=>apiListLeagues);
/** GET /leagues/public — browse public arenas (`tab=active|past`). */ parcelHelpers.export(exports, "apiListPublicLeagues", ()=>apiListPublicLeagues);
/**
 * POST /leagues/feed — the list poll in compact wire form (hydrate rows with `hydrateWireLeague`).
 * Falls back to `GET /leagues` against a backend that does not serve the feed yet.
 */ parcelHelpers.export(exports, "apiLeaguesFeed", ()=>apiLeaguesFeed);
/** GET /leagues/:id — one league (detail). */ parcelHelpers.export(exports, "apiGetLeague", ()=>apiGetLeague);
/** GET /leagues/by-code/:code — join-landing lookup by share code. */ parcelHelpers.export(exports, "apiGetLeagueByCode", ()=>apiGetLeagueByCode);
/** GET /leagues/vip-status — whether the viewer can create leagues. */ parcelHelpers.export(exports, "apiGetVipStatus", ()=>apiGetVipStatus);
/** POST /leagues — create a league (registered accounts; not guests). Returns the created league. */ parcelHelpers.export(exports, "apiCreateLeague", ()=>apiCreateLeague);
/** POST /leagues/join — join by id or share code. Returns the joined league. */ parcelHelpers.export(exports, "apiJoinLeague", ()=>apiJoinLeague);
/** POST /leagues/:id/top-up — pay rubies for more league chips (+ grow prize pot). */ parcelHelpers.export(exports, "apiTopUpLeagueSeat", ()=>apiTopUpLeagueSeat);
/** POST /leagues/:id/decline — decline a pending invite. */ parcelHelpers.export(exports, "apiDeclineLeague", ()=>apiDeclineLeague);
/** POST /leagues/:id/invite — invite friends by user id. Returns invited count + fresh league. */ parcelHelpers.export(exports, "apiInviteFriends", ()=>apiInviteFriends);
/** POST /leagues/:id/plays — place an isolated league play. Returns id + fresh league. */ parcelHelpers.export(exports, "apiPlaceLeaguePlay", ()=>apiPlaceLeaguePlay);
/**
 * GET /leagues/:id/bullion-battle — the league's shared Bullion battle (created lazily server-side
 * once the board is ready). `reason` explains a null battle (e.g. board not ready).
 */ parcelHelpers.export(exports, "apiGetBullionBattle", ()=>apiGetBullionBattle);
/**
 * POST /leagues/:id/reactions — throw an ephemeral emoji at a joined competitor (SSE fan-out).
 */ parcelHelpers.export(exports, "apiPostLeagueReaction", ()=>apiPostLeagueReaction);
/** GET /leagues/reactions/pending — unseen throws aimed at the viewer (newest first). */ parcelHelpers.export(exports, "apiListPendingLeagueReactions", ()=>apiListPendingLeagueReactions);
/** POST /leagues/reactions/ack — stop replaying these throws on the next visit. */ parcelHelpers.export(exports, "apiAckLeagueReactions", ()=>apiAckLeagueReactions);
/** GET /leagues/:id/reactions?targetUserId= — recent throws at a member. */ parcelHelpers.export(exports, "apiListLeagueReactionsAtTarget", ()=>apiListLeagueReactionsAtTarget);
/**
 * POST /leagues/:id/bullion-battle/plays — enter (or replace) the viewer's Bullion battle slip.
 * League coins (the battle entry stake) are held. Returns the play id + fresh league + battle.
 */ parcelHelpers.export(exports, "apiEnterBullionBattle", ()=>apiEnterBullionBattle);
/** POST /leagues/results-share — mint a short `/leagues?r=CODE` link. */ parcelHelpers.export(exports, "apiCreateLeagueResultsShare", ()=>apiCreateLeagueResultsShare);
/** GET /leagues/results-share/:code — public podium snapshot for a short link. */ parcelHelpers.export(exports, "apiGetLeagueResultsShare", ()=>apiGetLeagueResultsShare);
/** GET /leagues/:id/public-results — podium for a finished public league (non-member viewers). */ parcelHelpers.export(exports, "apiGetPublicLeagueResults", ()=>apiGetPublicLeagueResults);
var _authHeaders = require("../../../utils/authHeaders");
var _leagueReactions = require("./leagueReactions");
var _leagueWire = require("./leagueWire");
class LeagueApiError extends Error {
    constructor(message, code, status){
        super(message);
        this.name = "LeagueApiError";
        this.code = code;
        this.status = status;
    }
}
function apiBase() {
    const base = "https://cricket8.com/api";
    if (!base) throw new LeagueApiError("API is not configured.", "no_api_url", 0);
    return base.replace(/\/+$/, "");
}
async function request(path, init) {
    let response;
    try {
        response = await fetch(`${apiBase()}${path}`, {
            ...init,
            headers: {
                ...(0, _authHeaders.getAuthHeaders)(),
                ...init?.headers ?? {}
            }
        });
    } catch (networkError) {
        throw new LeagueApiError("Network error. Please try again.", "network_error", 0);
    }
    let payload = null;
    try {
        payload = await response.json();
    } catch  {
        payload = null;
    }
    if (!response.ok) {
        const body = payload ?? {};
        throw new LeagueApiError(body.message || "Something went wrong.", body.error || `http_${response.status}`, response.status);
    }
    return payload ?? {};
}
async function apiListLeagues(knownFinalFingerprint) {
    const query = knownFinalFingerprint ? `?final=${encodeURIComponent(knownFinalFingerprint)}` : "";
    const data = await request(`/leagues${query}`, {
        method: "GET"
    });
    return Array.isArray(data.leagues) ? data.leagues : [];
}
async function apiListPublicLeagues(tab = "active") {
    const data = await request(`/leagues/public?tab=${encodeURIComponent(tab)}`, {
        method: "GET"
    });
    if (!Array.isArray(data.leagues)) return [];
    return data.leagues.map((league)=>(0, _leagueWire.hydrateWireLeague)(league)).filter((league)=>league != null);
}
async function apiLeaguesFeed(knownFinalFingerprint, have) {
    try {
        const data = await request("/leagues/feed", {
            method: "POST",
            body: JSON.stringify({
                final: knownFinalFingerprint ?? undefined,
                have
            })
        });
        return Array.isArray(data.leagues) ? data.leagues : [];
    } catch (e) {
        if (e instanceof LeagueApiError && e.status === 404) return apiListLeagues(knownFinalFingerprint);
        throw e;
    }
}
async function apiGetLeague(leagueId, opts) {
    const query = new URLSearchParams({
        wire: "1"
    });
    if (opts?.fresh) query.set("fresh", "1");
    const data = await request(`/leagues/${encodeURIComponent(leagueId)}?${query}`, {
        method: "GET"
    });
    return data.league ? (0, _leagueWire.hydrateWireLeague)(data.league) : null;
}
async function apiGetLeagueByCode(code) {
    const data = await request(`/leagues/by-code/${encodeURIComponent(code)}`, {
        method: "GET"
    });
    return data.league ?? null;
}
async function apiGetVipStatus() {
    const data = await request("/leagues/vip-status", {
        method: "GET"
    });
    return Boolean(data.is_vip);
}
async function apiCreateLeague(input) {
    const data = await request("/leagues", {
        method: "POST",
        body: JSON.stringify({
            name: input.name,
            scope: input.scope,
            entryFeeRubies: input.entryFeeRubies,
            endsAt: input.endsAt,
            fixtureId: input.fixtureId,
            fixture: input.fixture,
            includedGames: input.includedGames
        })
    });
    if (!data.league) throw new LeagueApiError("League was not created.", "server_error", 500);
    return data.league;
}
async function apiJoinLeague(target) {
    const inviter = target.inviterPlayerId != null && String(target.inviterPlayerId).trim() !== "" ? String(target.inviterPlayerId).trim() : undefined;
    const data = await request("/leagues/join", {
        method: "POST",
        body: JSON.stringify({
            leagueId: target.leagueId,
            code: target.code,
            ...inviter ? {
                inviter_player_id: inviter,
                invitedBy: inviter
            } : {}
        })
    });
    if (!data.league) throw new LeagueApiError("Could not join the league.", "server_error", 500);
    return data.league;
}
async function apiTopUpLeagueSeat(leagueId) {
    const data = await request(`/leagues/${encodeURIComponent(leagueId)}/top-up`, {
        method: "POST",
        body: JSON.stringify({})
    });
    if (!data.league) throw new LeagueApiError("Could not top up league balls.", "server_error", 500);
    return data.league;
}
async function apiDeclineLeague(leagueId) {
    await request(`/leagues/${encodeURIComponent(leagueId)}/decline`, {
        method: "POST"
    });
}
async function apiInviteFriends(leagueId, userIds) {
    const data = await request(`/leagues/${encodeURIComponent(leagueId)}/invite`, {
        method: "POST",
        body: JSON.stringify({
            userIds
        })
    });
    return {
        invited: Number(data.invited) || 0,
        league: data.league ?? null
    };
}
async function apiPlaceLeaguePlay(leagueId, input) {
    const data = await request(`/leagues/${encodeURIComponent(leagueId)}/plays`, {
        method: "POST",
        body: JSON.stringify({
            game: input.game,
            stake: input.stake,
            multiplier: input.multiplier,
            selection: input.selection,
            matchId: input.matchId,
            marketId: input.marketId,
            marketLineId: input.marketLineId,
            selectionKey: input.selectionKey,
            settlesAt: input.settlesAt,
            marketDetails: input.marketDetails,
            prematch: input.prematch === true
        })
    });
    return {
        playId: String(data.playId ?? ""),
        league: data.league ?? null
    };
}
async function apiGetBullionBattle(leagueId) {
    const data = await request(`/leagues/${encodeURIComponent(leagueId)}/bullion-battle`, {
        method: "GET"
    });
    return {
        battle: data.battle ?? null,
        reason: data.reason ?? null
    };
}
async function apiPostLeagueReaction(leagueId, input) {
    const data = await request(`/leagues/${encodeURIComponent(leagueId)}/reactions`, {
        method: "POST",
        body: JSON.stringify({
            targetUserId: input.targetUserId,
            emoji: input.emoji,
            reactionId: input.reactionId
        })
    });
    return {
        reactionId: String(data.reactionId ?? input.reactionId ?? ""),
        leagueId: String(data.leagueId ?? leagueId),
        fromUserId: Number(data.fromUserId) || 0,
        fromPlayerName: String(data.fromPlayerName ?? "").trim(),
        targetUserId: Number(data.targetUserId) || input.targetUserId,
        emoji: (0, _leagueReactions.isLeagueReactionEmoji)(data.emoji) ? data.emoji : input.emoji
    };
}
function mapReactionPayload(raw) {
    if (!(0, _leagueReactions.isLeagueReactionEmoji)(raw.emoji)) return null;
    const reactionId = String(raw.reactionId ?? "").trim();
    const leagueId = String(raw.leagueId ?? "").trim();
    const fromUserId = Number(raw.fromUserId) || 0;
    const targetUserId = Number(raw.targetUserId) || 0;
    if (!reactionId || !leagueId || fromUserId <= 0 || targetUserId <= 0) return null;
    const extraRaw = Number(raw.extraCount) || 0;
    return {
        reactionId,
        leagueId,
        fromUserId,
        fromPlayerName: String(raw.fromPlayerName ?? "").trim() || `Player ${fromUserId}`,
        targetUserId,
        emoji: raw.emoji,
        ...extraRaw > 0 ? {
            extraCount: extraRaw
        } : {}
    };
}
async function apiListPendingLeagueReactions(leagueId) {
    const query = leagueId ? `?leagueId=${encodeURIComponent(leagueId)}` : "";
    const data = await request(`/leagues/reactions/pending${query}`, {
        method: "GET"
    });
    const reactions = (data.reactions ?? []).map(mapReactionPayload).filter((row)=>row != null);
    const missedRaw = Number(data.missed);
    return {
        reactions,
        missed: Number.isFinite(missedRaw) ? Math.max(missedRaw, reactions.length) : reactions.length
    };
}
async function apiAckLeagueReactions(reactionIds, opts) {
    if (opts?.all) {
        await request(`/leagues/reactions/ack`, {
            method: "POST",
            body: JSON.stringify({
                all: true,
                ...opts.leagueId ? {
                    leagueId: opts.leagueId
                } : {}
            })
        });
        return;
    }
    const ids = [
        ...new Set(reactionIds.map((id)=>String(id || "").trim()).filter(Boolean))
    ];
    if (ids.length === 0) return;
    await request(`/leagues/reactions/ack`, {
        method: "POST",
        body: JSON.stringify({
            reactionIds: ids
        })
    });
}
async function apiListLeagueReactionsAtTarget(leagueId, targetUserId) {
    const data = await request(`/leagues/${encodeURIComponent(leagueId)}/reactions?targetUserId=${encodeURIComponent(String(targetUserId))}`, {
        method: "GET"
    });
    return (data.reactions ?? []).map((row)=>{
        if (!(0, _leagueReactions.isLeagueReactionEmoji)(row.emoji)) return null;
        const reactionId = String(row.reactionId ?? "").trim();
        const fromUserId = Number(row.fromUserId) || 0;
        if (!reactionId || fromUserId <= 0) return null;
        return {
            reactionId,
            fromUserId,
            fromPlayerName: String(row.fromPlayerName ?? "").trim() || `Player ${fromUserId}`,
            emoji: row.emoji,
            createdAt: typeof row.createdAt === "string" ? row.createdAt : null
        };
    }).filter((row)=>row != null);
}
async function apiEnterBullionBattle(leagueId, slip) {
    const data = await request(`/leagues/${encodeURIComponent(leagueId)}/bullion-battle/plays`, {
        method: "POST",
        body: JSON.stringify({
            slip
        })
    });
    return {
        playId: String(data.playId ?? ""),
        league: data.league ?? null,
        battle: data.battle ?? null
    };
}
async function apiCreateLeagueResultsShare(snapshot, leagueId, /** Optional JPEG data URL of the 1200×630 preview card (served as og:image). */ ogImageDataUrl) {
    const data = await request("/leagues/results-share", {
        method: "POST",
        body: JSON.stringify({
            snapshot,
            ...leagueId ? {
                leagueId
            } : {},
            ...ogImageDataUrl ? {
                ogImage: ogImageDataUrl
            } : {}
        })
    });
    const code = String(data.code ?? "").trim();
    if (!code) throw new LeagueApiError("Could not create share link.", "no_code", 500);
    return code;
}
async function apiGetLeagueResultsShare(code) {
    const data = await request(`/leagues/results-share/${encodeURIComponent(code)}`, {
        method: "GET"
    });
    return data.snapshot ?? null;
}
async function apiGetPublicLeagueResults(leagueId) {
    try {
        const data = await request(`/leagues/${encodeURIComponent(leagueId)}/public-results`, {
            method: "GET"
        });
        return data.snapshot ?? null;
    } catch (error) {
        if (error instanceof LeagueApiError && (error.status === 404 || error.code === "not_found")) return null;
        throw error;
    }
}

},{"../../../utils/authHeaders":"5Rczo","./leagueReactions":"eP1Fb","./leagueWire":"keY4u","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"keY4u":[function(require,module,exports,__globalThis) {
/**
 * Client side of the compact league wire form (`backend/db/leagues/leagueWire.js`).
 *
 * The server names plays / settlements chunks, row order, members and the Bullion battle by a
 * content hash and skips whatever this client already holds; `hydrateWireLeague` rebuilds the
 * `League` from the response plus the values kept here. Values are kept for the current and the
 * previous response per league, so a poll that raced another fetch can still resolve them.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWireLeague", ()=>isWireLeague);
/** `{ [leagueId]: hashes }` for `POST /leagues/feed`. */ parcelHelpers.export(exports, "leagueWireHave", ()=>leagueWireHave);
parcelHelpers.export(exports, "resetLeagueWire", ()=>resetLeagueWire);
/** Complete wire form of `league` when it is the one last hydrated here (for the persisted cache). */ parcelHelpers.export(exports, "completeWireLeague", ()=>completeWireLeague);
/**
 * Rebuild a `League` from its wire form, or null when a value it references is no longer held
 * (the caller should refetch without `have`). Leagues without `feed` pass through unchanged.
 * Returns the previously built object when nothing changed, so callers can compare by identity.
 */ parcelHelpers.export(exports, "hydrateWireLeague", ()=>hydrateWireLeague);
const memory = new Map();
function isWireLeague(row) {
    const feed = row?.feed;
    return Boolean(feed && typeof feed === "object" && Array.isArray(feed.plays?.chunks));
}
function leagueWireHave() {
    const out = {};
    for (const [leagueId, mem] of memory)if (mem.values.size > 0) out[leagueId] = [
        ...mem.values.keys()
    ];
    return out;
}
function resetLeagueWire(leagueId) {
    if (leagueId) memory.delete(leagueId);
    else memory.clear();
}
function completeWireLeague(league) {
    const mem = memory.get(league.id);
    return mem && mem.league === league ? mem.complete : null;
}
function expandMarketDetails(ref, playMd) {
    const md = {
        ...playMd ?? {}
    };
    for (const key of ref.drop ?? [])delete md[key];
    return {
        ...md,
        ...ref.set ?? {}
    };
}
function hydrateWireLeague(row) {
    if (!isWireLeague(row)) return row;
    const { feed, ...rest } = row;
    const mem = memory.get(row.id);
    const keep = new Map();
    const hashes = [];
    let missing = false;
    const take = (part, value)=>{
        hashes.push(part.h);
        const resolved = value ?? mem?.values.get(part.h) ?? mem?.previous.get(part.h);
        if (resolved === undefined) missing = true;
        else keep.set(part.h, resolved);
        return resolved;
    };
    const rowsOf = (wire)=>{
        const order = take(wire.order, wire.order.value);
        const chunks = wire.chunks.map((c)=>({
                h: c.h,
                rows: take(c, c.rows)
            }));
        return {
            order,
            chunks
        };
    };
    const plays = rowsOf(feed.plays);
    const settlements = rowsOf(feed.settlements);
    const members = take(feed.members, feed.members.value);
    const bullion = feed.bullion ? take(feed.bullion, feed.bullion.value) : undefined;
    if (missing) return null;
    const signature = `${JSON.stringify(rest)}|${hashes.join(",")}`;
    const complete = {
        ...rest,
        feed: {
            v: feed.v,
            plays: {
                order: {
                    h: feed.plays.order.h,
                    value: plays.order
                },
                chunks: plays.chunks
            },
            settlements: {
                order: {
                    h: feed.settlements.order.h,
                    value: settlements.order
                },
                chunks: settlements.chunks
            },
            members: {
                h: feed.members.h,
                value: members
            },
            ...feed.bullion ? {
                bullion: {
                    h: feed.bullion.h,
                    value: bullion
                }
            } : {}
        }
    };
    if (mem && mem.signature === signature) {
        memory.set(row.id, {
            ...mem,
            values: keep,
            previous: mem.values,
            complete
        });
        return mem.league;
    }
    const assemble = ({ order, chunks })=>{
        const byId = new Map();
        for (const chunk of chunks)for (const r of chunk.rows ?? [])byId.set(String(r.id), r);
        const out = [];
        for (const id of order ?? []){
            const r = byId.get(id);
            if (!r) return null;
            out.push(r);
        }
        return out;
    };
    const playRows = assemble(plays);
    const settlementRows = assemble(settlements);
    if (!playRows || !settlementRows) return null;
    const playsById = new Map(playRows.map((p)=>[
            String(p.id),
            p
        ]));
    const settlementList = settlementRows.map((s)=>{
        const { mdRef, ...settlement } = s;
        if (!mdRef) return s;
        const play = playsById.get(String(settlement.playId));
        return {
            ...settlement,
            marketDetails: expandMarketDetails(mdRef, play?.marketDetails)
        };
    });
    const league = {
        ...rest,
        members,
        plays: playRows,
        settlements: settlementList,
        ...bullion ? {
            bullionBattle: bullion
        } : !feed.bullion && mem?.league.bullionBattle ? {
            bullionBattle: mem.league.bullionBattle
        } : {}
    };
    memory.set(row.id, {
        values: keep,
        previous: mem?.values ?? new Map(),
        signature,
        league,
        complete
    });
    return league;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l25FL":[function(require,module,exports,__globalThis) {
/**
 * Finalized / cancelled leagues never change, so the list poll tells the server which ones this
 * client already holds (as one fingerprint) and gets `{ id, unchanged: true }` stubs back for them.
 * Must stay byte-identical to `leagueFinalMarker` / `finalLeaguesFingerprint` in
 * `backend/db/leagues/leagueFeed.js`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUnchangedLeagueStub", ()=>isUnchangedLeagueStub);
parcelHelpers.export(exports, "leagueFinalMarker", ()=>leagueFinalMarker);
/**
 * Hub feed is card-only (`listSlim`, empty plays/settlements + `hubCard`). Keep richer
 * detail/cache feeds when the list omits them; take hubCard from the list, and keep
 * member bankroll fields paired with any held open plays.
 */ parcelHelpers.export(exports, "mergeListSlimLeague", ()=>mergeListSlimLeague);
/**
 * Full-detail poll: take the server snapshot, but keep optimistic emoji rows the live
 * throw path already prepended that this response has not caught up to yet.
 */ parcelHelpers.export(exports, "mergePolledLeagueDetail", ()=>mergePolledLeagueDetail);
parcelHelpers.export(exports, "finalLeaguesFingerprint", ()=>finalLeaguesFingerprint);
var _leagueReactionsTs = require("./leagueReactions.ts");
function isUnchangedLeagueStub(row) {
    return row.unchanged === true;
}
function leagueFinalMarker(league) {
    if (league.cancelledAt) return `${league.id}:c:${league.cancelledAt}`;
    if (league.settledAt) return `${league.id}:s:${league.settledAt}`;
    return null;
}
/**
 * When the list poll refreshes `members.coins` after a settlement but this merge keeps
 * stale open plays from a prior detail hydrate, available chips become
 * `newCoins − oldOpenStake` (often 0) while the server still has the real free balance.
 * Keep bankroll fields paired with any held open plays until a full detail refetch.
 */ function mergeListSlimMembers(held, incomingMembers) {
    const openUserIds = new Set((held.plays || []).filter((play)=>play.status === "open").map((play)=>play.userId));
    if (openUserIds.size === 0) return incomingMembers;
    const heldByUser = new Map(held.members.map((row)=>[
            row.userId,
            row
        ]));
    return incomingMembers.map((row)=>{
        if (!openUserIds.has(row.userId)) return row;
        const prev = heldByUser.get(row.userId);
        if (!prev) return row;
        return {
            ...row,
            coins: prev.coins,
            startingCoins: prev.startingCoins
        };
    });
}
function mergeListSlimLeague(held, incoming) {
    const listSlim = Boolean(incoming.listSlim);
    const { listSlim: _drop, ...rest } = incoming;
    if (!listSlim || !held) return rest;
    return {
        ...rest,
        hubCard: rest.hubCard ?? held.hubCard,
        members: mergeListSlimMembers(held, rest.members),
        // List is card-only — never replace a detail hydrate with empty/partial feeds.
        plays: held.plays,
        settlements: held.settlements,
        seatTopUps: held.seatTopUps ?? rest.seatTopUps,
        reactionEvents: held.reactionEvents ?? rest.reactionEvents,
        bullionBattle: rest.bullionBattle ?? held.bullionBattle
    };
}
function mergePolledLeagueDetail(held, incoming) {
    if (!held) return incoming;
    const incomingEvents = incoming.reactionEvents ?? [];
    const seen = new Set(incomingEvents.map((row)=>row.id));
    const extra = (held.reactionEvents ?? []).filter((row)=>row.id && !seen.has(row.id));
    if (extra.length === 0) return incoming;
    const merged = [
        ...incomingEvents,
        ...extra
    ].sort((a, b)=>{
        const delta = new Date(b.at).getTime() - new Date(a.at).getTime();
        return delta !== 0 ? delta : String(b.id).localeCompare(String(a.id));
    });
    // Keep the same window as `LEAGUE_REACTION_ACTIVITY_CAP`.
    return {
        ...incoming,
        reactionEvents: merged.slice(0, (0, _leagueReactionsTs.LEAGUE_REACTION_ACTIVITY_CAP))
    };
}
function fnv1a32(str, seed) {
    let h = seed >>> 0;
    for(let i = 0; i < str.length; i += 1){
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h.toString(16).padStart(8, "0");
}
function finalLeaguesFingerprint(markers) {
    const joined = [
        ...markers
    ].sort().join("|");
    return `${markers.length}-${fnv1a32(joined, 0x811c9dc5)}${fnv1a32(joined, 0x2166136b)}`;
}

},{"./leagueReactions.ts":"eP1Fb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hvV1t":[function(require,module,exports,__globalThis) {
/**
 * Data-source seam for Leagues.
 *
 * The UI reads league state and dispatches actions through a single
 * `LeaguesDataSource` interface instead of importing a specific store. Two
 * adapters implement it:
 *   - `apiDataSource` (this file) — the real backend (leagueApiStore.ts + leagueApi.ts).
 *   - `prototypeDataSource` (leaguePrototypeDataSource.ts) — the client-side
 *     simulation, used for the always-on demo at /leaguesdemo.
 *
 * The app root provides `apiDataSource` globally; the demo route nests a
 * provider with `prototypeDataSource`. Keeping the prototype adapter in its own
 * module means the heavy demo seed data only loads with the demo chunk.
 *
 * `useLeaguesDataSource()` returns the active adapter.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiDataSource", ()=>apiDataSource);
parcelHelpers.export(exports, "LeaguesDataSourceProvider", ()=>LeaguesDataSourceProvider);
parcelHelpers.export(exports, "useLeaguesDataSource", ()=>useLeaguesDataSource);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _leagueApiStore = require("./leagueApiStore");
var _leagueApi = require("./leagueApi");
function apiErrorMessage(e, fallback) {
    return e instanceof (0, _leagueApi.LeagueApiError) && e.message ? e.message : fallback;
}
function apiErrorCode(e) {
    return e instanceof (0, _leagueApi.LeagueApiError) ? e.code : undefined;
}
const apiDataSource = {
    mode: "api",
    subscribe: (0, _leagueApiStore.subscribeToLeaguesApi),
    getSnapshot: (0, _leagueApiStore.getLeaguesApiSnapshot),
    refresh: ()=>(0, _leagueApiStore.refreshLeagues)(),
    findLeague: (leagueId)=>(0, _leagueApiStore.findLeagueApi)(leagueId),
    findLeagueByCode: (code)=>(0, _leagueApiStore.findLeagueByCodeApi)(code),
    loadLeagueDetail: (leagueId, opts)=>(0, _leagueApiStore.loadLeagueDetail)(leagueId, opts),
    loadLeagueByCode: (code)=>(0, _leagueApiStore.loadLeagueByCode)(code),
    createLeague: async (input)=>(0, _leagueApiStore.createLeagueApi)(input),
    joinLeague: async (target)=>{
        try {
            const league = await (0, _leagueApiStore.joinLeagueApi)(target);
            return {
                ok: true,
                league
            };
        } catch (e) {
            return {
                ok: false,
                error: apiErrorMessage(e, "Could not join the league."),
                errorCode: apiErrorCode(e)
            };
        }
    },
    topUpSeat: async (leagueId)=>{
        try {
            const league = await (0, _leagueApiStore.topUpLeagueSeatApi)(leagueId);
            return {
                ok: true,
                league
            };
        } catch (e) {
            return {
                ok: false,
                error: apiErrorMessage(e, "Could not top up league balls."),
                errorCode: apiErrorCode(e)
            };
        }
    },
    declineInvite: (leagueId)=>(0, _leagueApiStore.declineLeagueApi)(leagueId),
    inviteFriends: async (leagueId, userIds)=>{
        await (0, _leagueApiStore.inviteFriendsApi)(leagueId, userIds);
    },
    placePlay: async (leagueId, input)=>{
        try {
            const playId = await (0, _leagueApiStore.placeLeaguePlayApi)(leagueId, {
                game: input.game,
                stake: input.stake,
                multiplier: input.multiplier,
                selection: input.selection,
                matchId: input.matchId,
                marketId: input.marketId,
                marketLineId: input.marketLineId,
                selectionKey: input.selectionKey,
                settlesAt: input.settlesAt,
                marketDetails: input.marketDetails
            });
            return {
                ok: true,
                playId
            };
        } catch (e) {
            return {
                ok: false,
                error: apiErrorMessage(e, "Could not place the play.")
            };
        }
    },
    getBullionBattle: (leagueId)=>(0, _leagueApiStore.loadBullionBattleApi)(leagueId),
    enterBullionBattle: async (leagueId, slip)=>{
        try {
            await (0, _leagueApiStore.enterBullionBattleApi)(leagueId, slip);
            return {
                ok: true
            };
        } catch (e) {
            return {
                ok: false,
                error: apiErrorMessage(e, "Could not enter the Bullion battle.")
            };
        }
    }
};
const LeaguesDataSourceContext = /*#__PURE__*/ (0, _react.createContext)(apiDataSource);
const LeaguesDataSourceProvider = ({ source, children })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeaguesDataSourceContext.Provider, {
        value: source,
        children: children
    });
};
function useLeaguesDataSource() {
    return (0, _react.useContext)(LeaguesDataSourceContext);
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./leagueApiStore":"ju6aY","./leagueApi":"bcswU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kpdfK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLeaguesState", ()=>useLeaguesState);
/**
 * Base path for league links. The demo lives under /leaguesdemo so its hub,
 * detail and join links stay inside the demo island; everything else is /leagues.
 * Derived from the URL (and active prototype league) so it also works for league-mode
 * surfaces rendered outside the Leagues route subtree (Layout overlays, game pages).
 */ parcelHelpers.export(exports, "useLeagueBasePath", ()=>useLeagueBasePath);
/**
 * Resolve a league from the active data source, falling back to the prototype store.
 * Needed when demo leagues deep-link into `/squares` / `/trader` / etc. and leave the
 * `/leaguesdemo` provider — League mode header + wallet override still need the seat.
 */ parcelHelpers.export(exports, "useLeague", ()=>useLeague);
parcelHelpers.export(exports, "useLeagueByCode", ()=>useLeagueByCode);
/**
 * The viewer's display identity. Real leagues use the logged-in account id so coin
 * lookups match `members[].isViewer`. The `/leaguesdemo` island (and demo leagues
 * opened on game routes) keep the prototype id.
 */ parcelHelpers.export(exports, "useLeagueViewer", ()=>useLeagueViewer);
/** Re-renders on an interval so countdowns and "2m ago" labels stay honest. */ parcelHelpers.export(exports, "useNowTicker", ()=>useNowTicker);
parcelHelpers.export(exports, "useLeagueStatus", ()=>useLeagueStatus);
/** Share URL for the copy-link action — carries `invitedBy` so previews name the sender. */ parcelHelpers.export(exports, "useLeagueShareLink", ()=>useLeagueShareLink);
/** Copy-to-clipboard with a short-lived "Copied" confirmation. */ parcelHelpers.export(exports, "useCopyToClipboard", ()=>useCopyToClipboard);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _userContext = require("../../../Data/UserContext");
var _constants = require("../lib/constants");
var _leaguesDataSource = require("../lib/LeaguesDataSource");
var _leagueFormat = require("../lib/leagueFormat");
var _leagueGamePlayUrl = require("../lib/leagueGamePlayUrl");
var _leagueModeStore = require("../lib/leagueModeStore");
var _leagueStore = require("../lib/leagueStore");
function useLeaguesState() {
    const dataSource = (0, _leaguesDataSource.useLeaguesDataSource)();
    return (0, _react.useSyncExternalStore)(dataSource.subscribe, dataSource.getSnapshot, dataSource.getSnapshot);
}
function useLeagueBasePath() {
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const activeId = (0, _leagueModeStore.useActiveLeagueMode)();
    if ((0, _leagueGamePlayUrl.isLeaguesDemoPath)(pathname)) return 0, _leagueGamePlayUrl.LEAGUES_DEMO_PATH;
    if (activeId && (0, _leagueStore.findLeague)(activeId)) return 0, _leagueGamePlayUrl.LEAGUES_DEMO_PATH;
    return "/leagues";
}
function useLeague(leagueId) {
    const { leagues } = useLeaguesState();
    // Always subscribe: outside /leaguesdemo the active source is API-only.
    const protoSnap = (0, _react.useSyncExternalStore)((0, _leagueStore.subscribeToLeagues), (0, _leagueStore.getLeaguesSnapshot), (0, _leagueStore.getLeaguesSnapshot));
    return (0, _react.useMemo)(()=>{
        if (!leagueId) return null;
        return leagues.find((league)=>league.id === leagueId) ?? protoSnap.leagues.find((league)=>league.id === leagueId) ?? null;
    }, [
        leagues,
        protoSnap,
        leagueId
    ]);
}
function useLeagueByCode(code) {
    const { leagues } = useLeaguesState();
    return (0, _react.useMemo)(()=>{
        const needle = String(code ?? "").trim().toUpperCase();
        if (!needle) return null;
        return leagues.find((league)=>league.code.toUpperCase() === needle) ?? null;
    }, [
        leagues,
        code
    ]);
}
function liveViewerUserId(userId) {
    const parsed = Number(userId);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}
function useLeagueViewer() {
    const { user } = (0, _userContext.useUser)();
    const dataSource = (0, _leaguesDataSource.useLeaguesDataSource)();
    const activeId = (0, _leagueModeStore.useActiveLeagueMode)();
    return (0, _react.useMemo)(()=>{
        const name = String(user?.player_name ?? user?.username ?? "").trim() || "Player";
        const liveId = liveViewerUserId(user?.userId);
        const prototypeSeat = dataSource.mode === "prototype" || Boolean(activeId && (0, _leagueStore.findLeague)(activeId));
        return {
            name,
            avatar: user?.avatar ?? null,
            xpWeekCrown: user?.xp_week_crown ?? null,
            userId: prototypeSeat || liveId == null ? (0, _constants.LEAGUE_VIEWER_USER_ID) : liveId
        };
    }, [
        dataSource.mode,
        activeId,
        user?.player_name,
        user?.username,
        user?.avatar,
        user?.xp_week_crown,
        user?.userId
    ]);
}
function useNowTicker(intervalMs = 1000) {
    const [now, setNow] = (0, _react.useState)(()=>Date.now());
    (0, _react.useEffect)(()=>{
        const id = setInterval(()=>setNow(Date.now()), intervalMs);
        return ()=>clearInterval(id);
    }, [
        intervalMs
    ]);
    return now;
}
function useLeagueStatus(league) {
    const now = useNowTicker(5000);
    return (0, _react.useMemo)(()=>league ? (0, _leagueFormat.leagueStatus)(league, now) : null, [
        league,
        now
    ]);
}
function useLeagueShareLink(league) {
    const basePath = useLeagueBasePath();
    const { user } = (0, _userContext.useUser)();
    const inviterPlayerId = String(user?.playerId ?? user?.player_id ?? "").trim();
    return (0, _react.useMemo)(()=>{
        if (!league) return "";
        const origin = typeof window !== "undefined" ? window.location.origin : "https://cricket8.com";
        return `${origin}${(0, _leagueGamePlayUrl.leagueJoinPath)(league.code, basePath, inviterPlayerId)}`;
    }, [
        league?.code,
        basePath,
        inviterPlayerId
    ]);
}
function useCopyToClipboard(resetMs = 2200) {
    const [copied, setCopied] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (!copied) return;
        const id = setTimeout(()=>setCopied(false), resetMs);
        return ()=>clearTimeout(id);
    }, [
        copied,
        resetMs
    ]);
    const copy = (0, _react.useCallback)((value)=>{
        if (!value) return;
        const fallback = ()=>{
            const el = document.createElement("textarea");
            el.value = value;
            el.setAttribute("readonly", "");
            el.style.position = "fixed";
            el.style.opacity = "0";
            document.body.appendChild(el);
            el.select();
            try {
                document.execCommand("copy");
            } catch  {
            /* Nothing else to try. */ }
            document.body.removeChild(el);
        };
        if (navigator?.clipboard?.writeText) navigator.clipboard.writeText(value).catch(fallback);
        else fallback();
        setCopied(true);
    }, []);
    return {
        copied,
        copy
    };
}

},{"react":"6uln9","react-router-dom":"l6ORY","../../../Data/UserContext":"aqd8b","../lib/constants":"dZVub","../lib/LeaguesDataSource":"hvV1t","../lib/leagueFormat":"jKCIi","../lib/leagueGamePlayUrl":"5EJnb","../lib/leagueModeStore":"kZgkv","../lib/leagueStore":"dMpsE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jAJlP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AvatarFramesShop);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _userContext = require("../../Data/UserContext");
var _authHeaders = require("../../utils/authHeaders");
var _sessionUser = require("../../utils/sessionUser");
const CURRENCY_ICON = {
    CR8_RBY: "/assets/currency-ruby.png",
    COINS: "/assets/currency-coin.png"
};
const CURRENCY_NAME = {
    CR8_RBY: "rubies",
    COINS: "coins"
};
const EMPTY_STATE = {
    buyable: [],
    owned: [],
    activeFrameId: null
};
function priced(list) {
    if (!Array.isArray(list)) return [];
    return list.filter((f)=>f.priceAmount != null && f.priceCurrency != null);
}
function parseShopState(data) {
    const d = data ?? {};
    return {
        buyable: priced(d.shopFrames),
        owned: priced(d.ownedShopFrames),
        activeFrameId: typeof d.activeFrameId === "number" ? d.activeFrameId : null
    };
}
function AvatarFramesShop({ rubies, coins }) {
    const { user, setUser } = (0, _userContext.useUser)();
    const [shop, setShop] = (0, _react.useState)(EMPTY_STATE);
    const [buyingId, setBuyingId] = (0, _react.useState)(null);
    const [message, setMessage] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (!user?.userId) {
            setShop(EMPTY_STATE);
            return undefined;
        }
        let cancelled = false;
        fetch(`${"https://cricket8.com/api"}/account/avatar-frames`, {
            headers: (0, _authHeaders.getAuthHeaders)()
        }).then((res)=>res.ok ? res.json() : null).then((data)=>{
            if (!cancelled) setShop(parseShopState(data));
        }).catch(()=>{});
        return ()=>{
            cancelled = true;
        };
    }, [
        user?.userId
    ]);
    if (!shop.buyable.length && !shop.owned.length && !message) return null;
    async function refreshSession() {
        const verify = await fetch(`${"https://cricket8.com/api"}/verifysession`, {
            headers: (0, _authHeaders.getAuthHeaders)()
        });
        if (verify.status === 200 && setUser) setUser((0, _sessionUser.normalizeSessionPayload)(await verify.json()));
    }
    async function wear(frame) {
        if (buyingId != null) return;
        setBuyingId(frame.id);
        setMessage(null);
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/avatar-frame`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    choice: frame.id
                })
            });
            const data = await res.json().catch(()=>({}));
            if (!res.ok) {
                setMessage({
                    text: data?.message || "Could not change your frame.",
                    error: true
                });
                return;
            }
            setShop(parseShopState(data));
            setMessage({
                text: `${frame.name} is now on your avatar.`,
                error: false
            });
            await refreshSession();
        } catch  {
            setMessage({
                text: "Something went wrong. Please try again.",
                error: true
            });
        } finally{
            setBuyingId(null);
        }
    }
    async function buy(frame) {
        if (buyingId != null) return;
        setBuyingId(frame.id);
        setMessage(null);
        try {
            const res = await fetch(`${"https://cricket8.com/api"}/account/avatar-frames/${frame.id}/buy`, {
                method: "POST",
                headers: (0, _authHeaders.getAuthHeaders)()
            });
            const data = await res.json().catch(()=>({}));
            if (!res.ok) {
                setMessage({
                    text: data?.message || "Could not buy this frame.",
                    error: true
                });
                return;
            }
            setShop(parseShopState(data));
            setMessage({
                text: `${frame.name} is yours and now on your avatar.`,
                error: false
            });
            window.dispatchEvent(new CustomEvent("walletUpdate"));
            await refreshSession();
        } catch  {
            setMessage({
                text: "Something went wrong. Please try again.",
                error: true
            });
        } finally{
            setBuyingId(null);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex h-[30px] w-[100%] flex-row items-center justify-center gap-[8px] bg-[#401A6E] py-4 font-anton text-[14px] font-[400] leading-[15px] text-white",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "font-anton",
                    children: "AVATAR FRAMES"
                })
            }),
            message ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: `px-3 pb-2 text-center font-chakra text-[11px] normal-case ${message.error ? "text-[#f87171]" : "text-[#32F78D]"}`,
                children: message.text
            }) : null,
            shop.buyable.length || shop.owned.length ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex w-[100%] items-stretch justify-evenly gap-0.5 overflow-x-auto overflow-y-hidden bg-inherit px-[3px]",
                children: [
                    shop.buyable.map((frame)=>{
                        const currency = frame.priceCurrency;
                        const price = frame.priceAmount;
                        const canAfford = (currency === "CR8_RBY" ? rubies : coins) >= price;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FrameCard, {
                            frame: frame,
                            avatar: user?.avatar,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: ()=>void buy(frame),
                                disabled: buyingId != null || !canAfford,
                                "aria-label": `Buy ${frame.name} for ${price} ${CURRENCY_NAME[currency]}`,
                                className: `${BUTTON_CLASS} ${canAfford ? "bg-lime" : "bg-gray-300"}`,
                                children: buyingId === frame.id ? "\u2026" : canAfford ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        "Buy for ",
                                        price.toLocaleString(),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: CURRENCY_ICON[currency],
                                            alt: "",
                                            className: "inline-block h-4 w-4 object-contain",
                                            "aria-hidden": true
                                        })
                                    ]
                                }) : `Need ${price.toLocaleString()} ${CURRENCY_NAME[currency]}`
                            })
                        }, frame.id);
                    }),
                    shop.owned.map((frame)=>{
                        const wearing = shop.activeFrameId === frame.id;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FrameCard, {
                            frame: frame,
                            avatar: user?.avatar,
                            ownedLabel: frame.owned ? "Owned" : "Unlocked",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: ()=>void wear(frame),
                                disabled: buyingId != null || wearing,
                                "aria-label": wearing ? `${frame.name} is on your avatar` : `Wear ${frame.name}`,
                                className: `${BUTTON_CLASS} ${wearing ? "bg-[#401A6E] text-white" : "bg-lime"}`,
                                children: buyingId === frame.id ? "\u2026" : wearing ? "Wearing" : "Wear"
                            })
                        }, frame.id);
                    })
                ]
            }) : null
        ]
    });
}
const BUTTON_CLASS = "flex h-[40px] min-w-[100px] flex-row items-center justify-center gap-1 whitespace-nowrap px-2 text-center font-anton text-[14px] font-[400] uppercase text-[#1B062F] disabled:cursor-not-allowed";
function FrameCard({ frame, avatar, ownedLabel, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "relative flex w-full min-w-[140px] flex-col items-center justify-center gap-1 bg-white px-2 py-3",
        children: [
            ownedLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "absolute left-1.5 top-1.5 bg-[#32F78D] px-1.5 py-0.5 font-anton text-[10px] uppercase leading-none text-[#1B062F]",
                children: ownedLabel
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "relative block h-[72px] w-[72px] bg-[#2a2342]",
                children: [
                    avatar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: avatar,
                        alt: "",
                        className: "block h-full w-full object-cover",
                        decoding: "async"
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: frame.imageUrl,
                        alt: "",
                        className: "pointer-events-none absolute inset-0 block h-full w-full",
                        decoding: "async",
                        "aria-hidden": true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-center font-anton text-[14px] font-[400] leading-tight text-[#1B062F]",
                children: frame.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-center font-chakra text-[11px] normal-case text-[#1B062F]",
                children: "Avatar frame"
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../../Data/UserContext":"aqd8b","../../utils/authHeaders":"5Rczo","../../utils/sessionUser":"4xtMD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f0Qz7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Safari's default session for `HTMLAudioElement` is playback, which ignores the
 * iPhone Ring/Silent switch (same path as music and video). These clips are short
 * UI effects, so use ambient: WebKit maps that to the session the switch mutes,
 * and it mixes with other audio instead of pausing it.
 *
 * Chrome and Firefox have no equivalent. On Android, silent mode mutes the ringer
 * only; media volume is a separate control and web pages cannot read it.
 */ parcelHelpers.export(exports, "respectDeviceSilentSwitch", ()=>respectDeviceSilentSwitch);
function respectDeviceSilentSwitch() {
    const session = navigator.audioSession;
    if (!session || session.type === "ambient") return;
    try {
        session.type = "ambient";
    } catch  {
    // Unsupported type or a browser that exposes the object but rejects the write.
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9s8Yc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Refund);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactGoogleRecaptcha = require("react-google-recaptcha");
var _reactGoogleRecaptchaDefault = parcelHelpers.interopDefault(_reactGoogleRecaptcha);
var _reactRouterDom = require("react-router-dom");
var _authHeaders = require("../../utils/authHeaders");
function Refund() {
    const nameRef = (0, _react.useRef)(null);
    const emailRef = (0, _react.useRef)(null);
    const messageRef = (0, _react.useRef)(null);
    const [emailError, setEmailError] = (0, _react.useState)("");
    const [nameError, setNameError] = (0, _react.useState)("");
    const [messageError, setMessageError] = (0, _react.useState)("");
    const [recaptchaError, setRecaptchaError] = (0, _react.useState)("");
    const [captchaValue, setCaptchaValue] = (0, _react.useState)(null);
    const [sending, setSending] = (0, _react.useState)(false);
    const [success, setSuccess] = (0, _react.useState)(false);
    const { id } = (0, _reactRouterDom.useParams)();
    const validateEmail = (email)=>{
        return /\S+@\S+\.\S+/.test(email);
    };
    const handleMessage = async ()=>{
        setEmailError("");
        setMessageError("");
        setRecaptchaError("");
        setNameError("");
        const email = emailRef.current?.value || "";
        const name = nameRef.current?.value || "";
        const message = messageRef.current?.value || "";
        if (!validateEmail(email)) setEmailError("Please enter a valid email address.");
        if (name === "") setNameError("Please enter your name.");
        if (message === "") setMessageError("Please enter your message.");
        if (!captchaValue) setRecaptchaError("Error verifying reCaptcha.");
        if (validateEmail(email) && name !== "" && message !== "" && captchaValue) {
            setSending(true);
            const response = await fetch(`${"https://cricket8.com/api"}/register/message`, {
                method: "post",
                headers: (0, _authHeaders.getAuthHeaders)(),
                body: JSON.stringify({
                    name: name,
                    email: email,
                    message: message,
                    captchaValue: captchaValue
                })
            });
            if (response.status === 200) {
                const data = await response.json();
                if (data.success === true) setSuccess(true);
                else {
                    setSuccess(false);
                    setRecaptchaError("Message failed to send.");
                    setSending(false);
                }
            }
        }
    };
    (0, _react.useEffect)(()=>{
        const updatePageTitle = ()=>{
            document.title = "CONTACT US | Cricket8";
        };
        updatePageTitle();
        return ()=>{};
    }, []);
    function onChange(value) {
        setCaptchaValue(value);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "content",
        className: "min-h-[75vh] mt-[0px] md:mt-[20px] content-t",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "text-[14px] md:text-[20px]",
                children: "Cricket8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                className: "text-[30px] md:text-[55px]",
                children: id ? "Request a refund" : "CONTACT US"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mt-[60px] font-chakra font-[#fff] text-[16px] bg-[#452f5b] p-[20px] md:flex",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bg-[#d2ff00] flex flex-col justify-center items-center h-[120px] w-full md:w-[150px] text-[#1b062f] text-[60px] text-center pt-[20px]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "1em",
                                height: "1em",
                                viewBox: "0 0 24 24",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "currentColor",
                                    d: "M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-[16px] font-chakra",
                                children: "Address"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-[20px] md:mt-[0px] md:ml-[50px]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "bold mb-[6px]",
                                        children: "Pukka Cricket8 Entertainment India Private Limited"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            "Registered Address:",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "We Work Vaswani Chambers, 2nd Floor, 264-265, Dr Annie Beasant Road, Municipal Colony, Worli Shivaji Nagar, Mumbai, Maharashtra, 400025/30"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "India Company Number: U63910MH2024FTC428666"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "bold mb-[6px]",
                                        children: "Pukka Entertainment Limited (Trading as Cricket8)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            "Registered Address:",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "5th Floor, 167-169 Great Portland Street, London, W1W 5PF",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "Phone +44 (0) 208 135 9165"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "U.K. Registered Company Number: 14138673"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mt-[60px] pb-[40px] font-chakra font-[#fff] text-[16px] bg-[#452f5b] p-[20px] md:flex",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bg-[#d2ff00] flex flex-col justify-center items-center h-[120px] w-full md:w-[150px] text-[#1b062f] text-[60px] text-center pt-[20px]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "1em",
                                height: "1em",
                                viewBox: "0 0 24 24",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "currentColor",
                                    d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-[16px] font-chakra",
                                children: "Message"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-[20px] md:mt-[0px] md:ml-[50px] md:mr-[50px] flex-grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "w-full h-[40px] bg-white border border-solid border-[#fff] mb-[30px]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        ref: nameRef,
                                        className: "h-full w-full enteremail2",
                                        type: "text",
                                        placeholder: "your name"
                                    }),
                                    nameError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            color: "#f73261",
                                            paddingTop: "5px",
                                            paddingLeft: "20px"
                                        },
                                        children: nameError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "w-full bg-white h-[40px] border border-solid border-[#fff] mb-[30px]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        ref: emailRef,
                                        className: "h-full w-full enteremail2",
                                        type: "email",
                                        placeholder: "enter your email"
                                    }),
                                    emailError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            color: "#f73261",
                                            paddingTop: "5px",
                                            paddingLeft: "20px"
                                        },
                                        children: emailError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "w-full h-[100px] bg-white border border-solid border-[#fff] mb-[30px]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                        ref: messageRef,
                                        className: " w-full h-full enteremail2",
                                        placeholder: "your message",
                                        defaultValue: id ? `I\u{2019}m asking for a refund for transaction number ${id}` : ""
                                    }),
                                    messageError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            color: "#f73261",
                                            paddingTop: "5px",
                                            paddingLeft: "20px"
                                        },
                                        children: messageError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactGoogleRecaptchaDefault.default), {
                                        sitekey: "6LcNubcpAAAAADIenWKHvGywBH0hNAL55T9yrqL8",
                                        onChange: onChange
                                    }),
                                    recaptchaError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            color: "#f73261",
                                            paddingTop: "5px",
                                            paddingLeft: "20px"
                                        },
                                        children: recaptchaError
                                    })
                                ]
                            }),
                            success ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-[#32f78c] font-anton text-[24px] pt-[20px]",
                                children: "Message sent!"
                            }) : null,
                            !sending ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mt-[20px] h-[52px] w-[110px] flex flex-row justify-center items-center bg-[#d2ff00] font-anton text-[20px] text-[#1b062f] cursor-pointer",
                                onClick: handleMessage,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "SEND"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ml-[15px]",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "1em",
                                            height: "1em",
                                            viewBox: "-5 -5 24 24",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                fill: "currentColor",
                                                d: "m10.586 5.657l-3.95-3.95A1 1 0 0 1 8.05.293l5.657 5.657a.997.997 0 0 1 0 1.414L8.05 13.021a1 1 0 1 1-1.414-1.414l3.95-3.95H1a1 1 0 1 1 0-2z"
                                            })
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-google-recaptcha":"cyyj8","react-router-dom":"l6ORY","../../utils/authHeaders":"5Rczo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cyyj8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReCAPTCHA", ()=>(0, _recaptchaDefault.default));
var _recaptchaWrapper = require("./recaptcha-wrapper");
var _recaptchaWrapperDefault = parcelHelpers.interopDefault(_recaptchaWrapper);
var _recaptcha = require("./recaptcha");
var _recaptchaDefault = parcelHelpers.interopDefault(_recaptcha);
exports.default = (0, _recaptchaWrapperDefault.default);

},{"./recaptcha-wrapper":"7nkmc","./recaptcha":"rV3Tt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7nkmc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _recaptcha = require("./recaptcha");
var _recaptchaDefault = parcelHelpers.interopDefault(_recaptcha);
var _reactAsyncScript = require("react-async-script");
var _reactAsyncScriptDefault = parcelHelpers.interopDefault(_reactAsyncScript);
var callbackName = "onloadcallback";
var globalName = "grecaptcha";
function getOptions() {
    return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function getURL() {
    var dynamicOptions = getOptions();
    var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
    if (dynamicOptions.enterprise) return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + callbackName + "&render=explicit";
    return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}
exports.default = (0, _reactAsyncScriptDefault.default)(getURL, {
    callbackName: callbackName,
    globalName: globalName,
    attributes: getOptions().nonce ? {
        nonce: getOptions().nonce
    } : {}
})((0, _recaptchaDefault.default));

},{"./recaptcha":"rV3Tt","react-async-script":"lh4jg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"rV3Tt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReCAPTCHA);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _excluded = [
    "sitekey",
    "onChange",
    "theme",
    "type",
    "tabindex",
    "onExpired",
    "onErrored",
    "size",
    "stoken",
    "grecaptcha",
    "badge",
    "hl",
    "isolated"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var ReCAPTCHA = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ReCAPTCHA, _React$Component);
    function ReCAPTCHA() {
        var _this;
        _this = _React$Component.call(this) || this;
        _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
        _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
        _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = ReCAPTCHA.prototype;
    _proto.getCaptchaFunction = function getCaptchaFunction(fnName) {
        if (this.props.grecaptcha) {
            if (this.props.grecaptcha.enterprise) return this.props.grecaptcha.enterprise[fnName];
            return this.props.grecaptcha[fnName];
        }
        return null;
    };
    _proto.getValue = function getValue() {
        var getResponse = this.getCaptchaFunction("getResponse");
        if (getResponse && this._widgetId !== undefined) return getResponse(this._widgetId);
        return null;
    };
    _proto.getWidgetId = function getWidgetId() {
        if (this.props.grecaptcha && this._widgetId !== undefined) return this._widgetId;
        return null;
    };
    _proto.execute = function execute() {
        var execute = this.getCaptchaFunction("execute");
        if (execute && this._widgetId !== undefined) return execute(this._widgetId);
        else this._executeRequested = true;
    };
    _proto.executeAsync = function executeAsync() {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.executionResolve = resolve;
            _this2.executionReject = reject;
            _this2.execute();
        });
    };
    _proto.reset = function reset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter && this._widgetId !== undefined) resetter(this._widgetId);
    };
    _proto.forceReset = function forceReset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter) resetter();
    };
    _proto.handleExpired = function handleExpired() {
        if (this.props.onExpired) this.props.onExpired();
        else this.handleChange(null);
    };
    _proto.handleErrored = function handleErrored() {
        if (this.props.onErrored) this.props.onErrored();
        if (this.executionReject) {
            this.executionReject();
            delete this.executionResolve;
            delete this.executionReject;
        }
    };
    _proto.handleChange = function handleChange(token) {
        if (this.props.onChange) this.props.onChange(token);
        if (this.executionResolve) {
            this.executionResolve(token);
            delete this.executionReject;
            delete this.executionResolve;
        }
    };
    _proto.explicitRender = function explicitRender() {
        var render = this.getCaptchaFunction("render");
        if (render && this._widgetId === undefined) {
            var wrapper = document.createElement("div");
            this._widgetId = render(wrapper, {
                sitekey: this.props.sitekey,
                callback: this.handleChange,
                theme: this.props.theme,
                type: this.props.type,
                tabindex: this.props.tabindex,
                "expired-callback": this.handleExpired,
                "error-callback": this.handleErrored,
                size: this.props.size,
                stoken: this.props.stoken,
                hl: this.props.hl,
                badge: this.props.badge,
                isolated: this.props.isolated
            });
            this.captcha.appendChild(wrapper);
        }
        if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
            this._executeRequested = false;
            this.execute();
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        this.explicitRender();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        this.explicitRender();
    };
    _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
        this.captcha = elem;
    };
    _proto.render = function render() {
        // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
        /* eslint-disable no-unused-vars */ var _this$props = this.props, sitekey = _this$props.sitekey, onChange = _this$props.onChange, theme = _this$props.theme, type = _this$props.type, tabindex = _this$props.tabindex, onExpired = _this$props.onExpired, onErrored = _this$props.onErrored, size = _this$props.size, stoken = _this$props.stoken, grecaptcha = _this$props.grecaptcha, badge = _this$props.badge, hl = _this$props.hl, isolated = _this$props.isolated, childProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ _react.createElement("div", _extends({}, childProps, {
            ref: this.handleRecaptchaRef
        }));
    };
    return ReCAPTCHA;
}(_react.Component);
ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
    sitekey: (0, _propTypesDefault.default).string.isRequired,
    onChange: (0, _propTypesDefault.default).func,
    grecaptcha: (0, _propTypesDefault.default).object,
    theme: (0, _propTypesDefault.default).oneOf([
        "dark",
        "light"
    ]),
    type: (0, _propTypesDefault.default).oneOf([
        "image",
        "audio"
    ]),
    tabindex: (0, _propTypesDefault.default).number,
    onExpired: (0, _propTypesDefault.default).func,
    onErrored: (0, _propTypesDefault.default).func,
    size: (0, _propTypesDefault.default).oneOf([
        "compact",
        "normal",
        "invisible"
    ]),
    stoken: (0, _propTypesDefault.default).string,
    hl: (0, _propTypesDefault.default).string,
    badge: (0, _propTypesDefault.default).oneOf([
        "bottomright",
        "bottomleft",
        "inline"
    ]),
    isolated: (0, _propTypesDefault.default).bool
};
ReCAPTCHA.defaultProps = {
    onChange: function onChange() {},
    theme: "light",
    type: "image",
    tabindex: 0,
    size: "normal",
    badge: "bottomright"
};

},{"react":"6uln9","prop-types":"6FKs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lh4jg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>makeAsyncScript);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            _inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if (SCRIPT_MAP[scriptURL]) {
                    var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if (SCRIPT_MAP[scriptURL]) {
                        var mapEntry = SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = _objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, _react.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, _react.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, _react.forwardRef)(function(props, ref) {
            return (0, _react.createElement)(AsyncScriptLoader, _extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, _propTypesDefault.default).func
        };
        return (0, _hoistNonReactStaticsDefault.default)(ForwardedComponent, WrappedComponent);
    };
}

},{"react":"6uln9","prop-types":"6FKs7","hoist-non-react-statics":"3bvdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3bvdc":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"aUAsc"}],"aUAsc":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"1Qg5l"}],"1Qg5l":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"bZTyw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RefundPolicy);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
function RefundPolicy() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { id } = (0, _reactRouterDom.useParams)();
    function handleTransactionId() {
        navigate(id === undefined ? '/refund' : `/refund/${id}`);
        window.scrollTo(0, 0);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "content",
        className: "min-h-[100vh] w-full",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full flex flex-col justify-center items-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-full bg-bgAlternate px-[10px] lg:px-[40px] py-[20px] lg:py-[30px] overflow-x-hidden",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-full flex flex-row items-center mb-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "text-white font-anton font-normal uppercase text-[30px] md:text-[40px] lg:text-[48px] leading-tight ml-[10px] lg:ml-[20px]",
                            children: "REFUND POLICY"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-full lg:pt-0 lg:pb-8",
                style: {
                    background: "linear-gradient(to right, #1B062F 0%, #4e2581 100%)"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-full px-[10px] lg:px-[40px] pt-0 pb-[20px] lg:pt-0 lg:pb-[30px]",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bg-header p-[20px] lg:p-[30px]",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "font-chakra text-white text-[14px] md:text-[16px] leading-relaxed space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-white font-bold",
                                    children: "PUKKA CRICKET8 ENTERTAINMENT INDIA PRIVATE LIMITED"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-white font-bold",
                                    children: "(Platform Cricket8)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-white font-bold",
                                    children: "REFUND POLICY"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-white",
                                    children: 'This Policy is a legally binding document between you ("Visitor"/ "User") and Pukka Cricket8 Entertainment India Private Limited & its platform Cricket8 ("Company", "Platform", "we", "us", and "our").'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "ABOUT CRICKET8"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "Cricket8 is a community built by cricket fans, for cricket fans. With a growing base of 800,000 passionate cricket enthusiasts, we are more than just a sports platform. Our mission is to bring fans closer to the game they love through high-quality gaming, real-time engagement, and interactive experiences."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "OUR PRODUCTS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "Cricket8 offers a premium, real-time experience for cricket lovers, including:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                            className: "text-white",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Live Gaming: Ball by ball, over by over, and match by match, covering every market."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Live Sports Data: Instant updates, scores, and in-depth statistics."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Live Streaming Commentary: Bringing the action to life, ball by ball."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Exclusive Videos & Podcasts: Expert insights, match analysis, and behind-the-scenes content."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "PLAY. COMPETE. WIN (BRAGGING RIGHTS)."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "Our games capture the thrill of picking outcomes using virtual coins only \u2014 free social games for entertainment:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                            className: "text-white",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Play for fun: Compete, strategize, and challenge your friends using virtual coins only."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Virtual Coins, Real Excitement: Players can get Rubies, convert them into virtual coins, and climb leaderboards for ultimate bragging rights."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "CANCELLATION AND REFUND POLICY FOR Cricket8.com"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "1. PAYMENT AND BILLING"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "1.1 PAYMENT OVERVIEW"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "Our platform offers services that can be purchased using Stripe. By completing a payment, you confirm that you are authorized to use the selected payment method and that all payment details provided are accurate."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "1.2 TRANSACTION PROCESSING"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "Payments made through Stripe are processed in accordance with their terms of service. Please refer to these terms for more details about the transaction process and any associated requirements."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "1.3 PRICING"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "All prices displayed on our platform are inclusive of applicable taxes unless stated otherwise. Prices are subject to change at any time without prior notice."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "2. REFUNDS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "2.1 ELIGIBILITY FOR REFUNDS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "Refund requests must comply with this policy and Stripe's refund policies. Refunds will only be issued to the original payment method used at the time of purchase. Refunds for ruby pack purchases only apply to packs that have not yet been spent in full or in part (spent on play coins). We cannot offer part refunds for unspent rubies. No cash refunds will be issued under any circumstances, as our platform does not involve monetary or tangible rewards."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "2.2 HOW TO REQUEST A REFUND"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "To request a refund, please send us the following information via our customer contact form:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                            className: "text-white",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Order ID"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Payment reference number (Stripe Payment / Transaction ID)"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Reason for refund"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Supporting documents (if applicable)"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Our team will review your request and respond within 3\u20135 business days."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "2.3 REFUND TIMELINES"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "If your refund is approved, Stripe will initiate the refund to the original payment method. Refunds are usually credited within 5\u201310 business days, depending on your bank or card issuer. You will be notified when the refund is processed."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "2.4 NON-REFUNDABLE ITEMS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "Refunds will not be issued for the following:"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                                            className: "text-white",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Digital goods or services that have been accessed, used, or downloaded."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: 'Items marked as "final sale" or otherwise non-refundable at the time of purchase.'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Issues caused by user error or misuse of the product or service."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                    children: "Virtual coins (converted from rubies) that have been used in any capacity within our games."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "3. VIRTUAL CURRENCY ONLY \u2014 NO CASH REWARDS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "3.1 NATURE OF OUR GAMES"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "text-white",
                                            children: [
                                                "All games on Cricket8 are casual, social, and skill-based, designed for entertainment and competition among fans.",
                                                ' ',
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-bold",
                                                    children: "They are intended purely for entertainment and do not offer cash prizes, monetary rewards, or tangible items as incentives."
                                                }),
                                                ' ',
                                                "Cricket8 complies with applicable Indian online gaming regulations. See our",
                                                ' ',
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    className: "underline font-bold text-white",
                                                    to: "/compliance",
                                                    children: "Compliance page"
                                                }),
                                                ' ',
                                                "for details."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "3.2 VIRTUAL CURRENCY POLICY"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "Virtual coins obtained through the purchase of rubies are purely for in-game use and cannot be redeemed for cash, monetary rewards, or tangible goods. These virtual coins are non-transferable, non-redeemable, and cannot be exchanged for any form of real-world value. They can only be used within the Cricket8 platform for in-game activities such as accessing premium features, unlocking additional content, or enhancing gameplay."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "3.3 NO CASH OR MONETARY REWARDS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "No cash prizes or rewards of monetary or tangible value are provided to players, regardless of game outcomes or performance. Players earn only virtual coins, which have no cash value and cannot be withdrawn or converted into real money."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "4. UNAUTHORIZED TRANSACTIONS"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "If you believe a transaction was unauthorized, immediately report it to Stripe via their customer support team. We will work with Stripe to resolve the issue."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "5. CHANGES TO THIS POLICY"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-white",
                                            children: "We may update this Refund Policy from time to time. Updates will be posted on our website, and significant changes will be communicated to you via email or other means. Continued use of our website after updates constitutes acceptance of the revised policy."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "text-start font-anton font-normal text-[18px] md:text-[20px] lg:text-[24px] mt-4 mb-3 text-white uppercase",
                                            children: "6. CONTACT INFORMATION"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "text-white",
                                            children: [
                                                "If you have any questions, concerns, or refund requests, please contact us through our customer",
                                                ' ',
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    className: "underline font-bold text-white",
                                                    to: "/contact",
                                                    children: "support form"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d3tQO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseAllowedEmails", ()=>parseAllowedEmails);
/** When the dev domain gate is on, allow @domain plus exact extra emails. No email (SMS) is allowed. */ parcelHelpers.export(exports, "isEmailAllowedForDevGate", ()=>isEmailAllowedForDevGate);
function parseAllowedEmails(raw) {
    return String(raw || "").split(",").map((e)=>e.trim().toLowerCase()).filter(Boolean);
}
function isEmailAllowedForDevGate(email, allowedDomain, allowedEmailsRaw) {
    const normalized = String(email || "").trim().toLowerCase();
    if (!normalized) return true;
    const domain = (allowedDomain || "").trim().toLowerCase();
    const emailDomain = normalized.split("@")[1] || "";
    if (domain && emailDomain === domain) return true;
    return parseAllowedEmails(allowedEmailsRaw).includes(normalized);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"daFbR":[function(require,module,exports,__globalThis) {
/**
 * When user lands with ?bfe=1 but is not logged in, we store this so that after
 * they log in we can append bfe=1 to the redirect URL and claim the bonus.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBfePending", ()=>setBfePending);
/**
 * If the user had bfe=1 pending (arrived from email link while logged out),
 * returns the query string to append to the redirect URL (?bfe=1 or &bfe=1)
 * and clears the pending flag. Otherwise returns "".
 */ parcelHelpers.export(exports, "consumeBfePendingParam", ()=>consumeBfePendingParam);
const BFE_PENDING_KEY = "c8_bfe_pending";
function setBfePending() {
    try {
        sessionStorage.setItem(BFE_PENDING_KEY, "1");
    } catch  {
    // ignore
    }
}
function consumeBfePendingParam(redirectUrl) {
    try {
        const pending = sessionStorage.getItem(BFE_PENDING_KEY) === "1";
        if (pending) {
            sessionStorage.removeItem(BFE_PENDING_KEY);
            return redirectUrl.includes("?") ? "&bfe=1" : "?bfe=1";
        }
    } catch  {
    // ignore
    }
    return "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lajMf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isChunkLoadError", ()=>isChunkLoadError);
parcelHelpers.export(exports, "reloadForFreshChunks", ()=>reloadForFreshChunks);
/** Cleared only after the app has been stable — not on first paint (that caused infinite `_cb` reload loops). */ parcelHelpers.export(exports, "clearChunkReloadSessionFlags", ()=>clearChunkReloadSessionFlags);
/** Drop Parcel cache-bust param so invite / routing logic does not see a changing `search` every reload. */ parcelHelpers.export(exports, "stripChunkCacheBustSearchParam", ()=>stripChunkCacheBustSearchParam);
/** Catch lazy-import failures that escape React error boundaries. */ parcelHelpers.export(exports, "registerChunkLoadRecovery", ()=>registerChunkLoadRecovery);
parcelHelpers.export(exports, "retryLazyImport", ()=>retryLazyImport);
var _react = require("react");
const CHUNK_RELOAD_COUNT_KEY = "chunk_reload_count";
const LEGACY_CHUNK_RELOADED_KEY = "chunk_reloaded";
const MAX_CHUNK_RELOADS = 2;
const isChunkLoadError = (error)=>{
    const message = error instanceof Error ? error.message : String(error ?? "");
    if (!message) return false;
    return message.includes("Failed to fetch dynamically imported module") || message.includes("Loading chunk") || message.includes("Importing a module script failed") || message.includes("Loading module") || message.includes("Failed to load module") || message.includes("dynamically imported module") || message.includes("Cannot find module") || /Cannot find module\s+['"][^'"]+['"]/i.test(message) || error instanceof Error && error.name === "ChunkLoadError" || typeof error === "object" && error != null && "code" in error && error.code === "CSS_CHUNK_LOAD_FAILED";
};
const reloadForFreshChunks = ()=>{
    if (typeof window === "undefined") return false;
    const count = parseInt(sessionStorage.getItem(CHUNK_RELOAD_COUNT_KEY) || "0", 10);
    if (count >= MAX_CHUNK_RELOADS) return false;
    sessionStorage.setItem(CHUNK_RELOAD_COUNT_KEY, String(count + 1));
    sessionStorage.removeItem(LEGACY_CHUNK_RELOADED_KEY);
    const url = new URL(window.location.href);
    stripChunkCacheBustSearchParam(url.searchParams);
    url.searchParams.set("_cb", String(Date.now()));
    window.location.replace(url.toString());
    return true;
};
function clearChunkReloadSessionFlags() {
    if (typeof window === "undefined") return;
    sessionStorage.removeItem(CHUNK_RELOAD_COUNT_KEY);
    sessionStorage.removeItem(LEGACY_CHUNK_RELOADED_KEY);
}
function stripChunkCacheBustSearchParam(params) {
    params.delete("_cb");
}
/**
 * Try a hard reload for fresh chunks. If the reload budget is exhausted, rethrow so Suspense
 * can exit (a never-resolving promise left the app stuck on a purple shell until manual refresh).
 */ const handleChunkError = (error)=>{
    if (reloadForFreshChunks()) // Navigation in progress — park until the document unloads.
    return new Promise(()=>{});
    return Promise.reject(error instanceof Error ? error : new Error(String(error ?? "Chunk load failed")));
};
function registerChunkLoadRecovery() {
    if (typeof window === "undefined") return ()=>{};
    const onRejection = (event)=>{
        if (!isChunkLoadError(event.reason)) return;
        event.preventDefault();
        if (!reloadForFreshChunks()) // Budget exhausted — let the rejection surface so the UI can recover.
        return;
    };
    window.addEventListener("unhandledrejection", onRejection);
    return ()=>window.removeEventListener("unhandledrejection", onRejection);
}
const retryLazyImport = (importFn)=>{
    return (0, _react.lazy)(()=>{
        return importFn().catch((error)=>{
            if (isChunkLoadError(error) && typeof window !== "undefined") return handleChunkError(error);
            throw error;
        });
    });
};

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jZjp4":[function(require,module,exports,__globalThis) {
/**
 * Cold-start loading skeleton. Structure and class names must match index.html
 * so there’s no flash when React replaces the static shell (header + pink ticker + main placeholders).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppLoadingSkeleton", ()=>AppLoadingSkeleton);
var _jsxRuntime = require("react/jsx-runtime");
const AppLoadingSkeleton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "app-loading-skeleton",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                className: "app-skeleton-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "app-skeleton-logo app-skeleton-shimmer"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "app-skeleton-nav",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "app-skeleton-nav-pill app-skeleton-shimmer"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "app-skeleton-nav-pill app-skeleton-shimmer"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "app-skeleton-nav-pill app-skeleton-shimmer"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "app-skeleton-ticker",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "app-skeleton-main",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "app-skeleton-title app-skeleton-shimmer"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "app-skeleton-cards",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "app-skeleton-card app-skeleton-shimmer"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "app-skeleton-card app-skeleton-shimmer"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "app-skeleton-card app-skeleton-shimmer"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "app-skeleton-card app-skeleton-shimmer"
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lC2rN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Dev-only: player SPA has no /admin bundle — reload so Parcel's /admin proxy can serve admin. */ parcelHelpers.export(exports, "AdminDevProxyReload", ()=>AdminDevProxyReload);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const RELOAD_FLAG = "c8-admin-proxy-reload";
function AdminDevProxyReload() {
    const [showHelp, setShowHelp] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        return;
    }, []);
    if (showHelp) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex min-h-screen flex-col items-center justify-center gap-4 bg-main px-6 text-center font-chakra text-white",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                className: "font-anton text-2xl uppercase",
                children: "Admin dev server"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "max-w-md text-white/70",
                children: [
                    "Could not load the admin panel through the dev proxy. Start both apps from",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                        className: "text-lime",
                        children: "frontend/"
                    }),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                className: "rounded bg-mainB px-4 py-3 text-left text-sm text-white/90",
                children: "yarn dev"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "max-w-md text-sm text-white/55",
                children: [
                    "Then open",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "text-lime underline",
                        href: "http://localhost:1234/admin/",
                        children: "http://localhost:1234/admin/"
                    }),
                    " ",
                    "(admin runs on :1235 and is proxied through :1234 for login cookies)."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex min-h-screen items-center justify-center bg-main font-chakra text-white/60",
        children: "Loading admin\u2026"
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k8w2i":[function(require,module,exports,__globalThis) {
module.exports = require("83892d7167cc1c1")(require("a3facc50252fbfcd").resolve("3Fvrf")).then(()=>module.bundle.root('aQYA9'));

},{"83892d7167cc1c1":"hpx0h","a3facc50252fbfcd":"fyJL2"}],"1MA4K":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("e0df2e40eb51719c")(require("3ada66bce004b2b6").resolve("6xQSK")),
    require("7110dc423941ed6f")(require("3ada66bce004b2b6").resolve("7WJAg"))
]).then(()=>module.bundle.root('8jkxY'));

},{"e0df2e40eb51719c":"bpdkb","3ada66bce004b2b6":"fyJL2","7110dc423941ed6f":"hpx0h"}],"bpdkb":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"1uYxD"}],"8xodj":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("f66cd43006670045")(require("c7a0311bda6f77ba").resolve("IlTi6")),
    require("f66cd43006670045")(require("c7a0311bda6f77ba").resolve("9U5o7"))
]).then(()=>module.bundle.root('86ihP'));

},{"f66cd43006670045":"hpx0h","c7a0311bda6f77ba":"fyJL2"}],"69FDC":[function(require,module,exports,__globalThis) {
module.exports = require("eef69bd722a79d0b")(require("b72b1d107876b73e").resolve("5RA2i")).then(()=>module.bundle.root('9dcbO'));

},{"eef69bd722a79d0b":"hpx0h","b72b1d107876b73e":"fyJL2"}],"33vSW":[function(require,module,exports,__globalThis) {
module.exports = require("eaa54036952f58b8")(require("9ef4b4cd9b9bb1b").resolve("8Q4iq")).then(()=>module.bundle.root('kfI7f'));

},{"eaa54036952f58b8":"hpx0h","9ef4b4cd9b9bb1b":"fyJL2"}],"dopEU":[function(require,module,exports,__globalThis) {
module.exports = require("3fd7afd552bc0823")(require("734bbdb82a2e1da6").resolve("bBg8X")).then(()=>module.bundle.root('dShIg'));

},{"3fd7afd552bc0823":"hpx0h","734bbdb82a2e1da6":"fyJL2"}],"aYw3M":[function(require,module,exports,__globalThis) {
module.exports = require("ad1e234617f4c3a1")(require("948bb63268c61c97").resolve("1rmf8")).then(()=>module.bundle.root('1O2eK'));

},{"ad1e234617f4c3a1":"hpx0h","948bb63268c61c97":"fyJL2"}],"1WxWM":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("ddfef66cbe619b15")(require("cf839456fe67c093").resolve("zaTzk")),
    require("ddfef66cbe619b15")(require("cf839456fe67c093").resolve("evLCa"))
]).then(()=>module.bundle.root('dOQS3'));

},{"ddfef66cbe619b15":"hpx0h","cf839456fe67c093":"fyJL2"}],"3WfaG":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("ce8fa5e9a34bceed")(require("45a1179c6cc4eebe").resolve("1Fc9F")),
    require("ce8fa5e9a34bceed")(require("45a1179c6cc4eebe").resolve("lQrcL")),
    require("ce8fa5e9a34bceed")(require("45a1179c6cc4eebe").resolve("19Acq")),
    require("ce8fa5e9a34bceed")(require("45a1179c6cc4eebe").resolve("50WiO")),
    require("ce8fa5e9a34bceed")(require("45a1179c6cc4eebe").resolve("cEEh7")),
    require("ce8fa5e9a34bceed")(require("45a1179c6cc4eebe").resolve("2Zxu2"))
]).then(()=>module.bundle.root('jWThf'));

},{"ce8fa5e9a34bceed":"hpx0h","45a1179c6cc4eebe":"fyJL2"}],"ien4R":[function(require,module,exports,__globalThis) {
module.exports = require("da26b072fee97bcd")(require("f7f184b131c1cff5").resolve("egz4d")).then(()=>module.bundle.root('3s1ZW'));

},{"da26b072fee97bcd":"hpx0h","f7f184b131c1cff5":"fyJL2"}],"1KuRp":[function(require,module,exports,__globalThis) {
module.exports = require("dfce435027e8700")(require("86be5e5df35d4744").resolve("jEPgp")).then(()=>module.bundle.root('bal7t'));

},{"dfce435027e8700":"hpx0h","86be5e5df35d4744":"fyJL2"}],"7EwsK":[function(require,module,exports,__globalThis) {
module.exports = require("c1260ab0bead60d6")(require("590ccb2e136bf48e").resolve("lNXf2")).then(()=>module.bundle.root('5CREP'));

},{"c1260ab0bead60d6":"hpx0h","590ccb2e136bf48e":"fyJL2"}],"kXeTg":[function(require,module,exports,__globalThis) {
module.exports = require("211fdea9ce5ffc4a")(require("ed5ea0ddc85f8a3").resolve("hMyWk")).then(()=>module.bundle.root('lmhBt'));

},{"211fdea9ce5ffc4a":"hpx0h","ed5ea0ddc85f8a3":"fyJL2"}],"jJplv":[function(require,module,exports,__globalThis) {
module.exports = require("94a6f6bccb1aa71b")(require("50aa5d3c51feeba2").resolve("41t7U")).then(()=>module.bundle.root('chxwZ'));

},{"94a6f6bccb1aa71b":"hpx0h","50aa5d3c51feeba2":"fyJL2"}],"fE99G":[function(require,module,exports,__globalThis) {
module.exports = require("882ad0243a3d187")(require("4f75e25d819030bb").resolve("gfRQ5")).then(()=>module.bundle.root('kvCBq'));

},{"882ad0243a3d187":"hpx0h","4f75e25d819030bb":"fyJL2"}],"a2nm2":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("4ynOl")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("exNnS")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("6GkiA")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("fdsB2")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("7y3t5")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("GmIEL")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("50WiO")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("bFWwa")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("cEEh7")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("zaTzk")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("4PGNR")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("2ztyD")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("didjk")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("2eZaA")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("6VRsE")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("fjfdE")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("6uHCl")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("dUnev")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("hodz5")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("18aVi")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("lQrcL")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("4UE0S")),
    require("51ed41442ea69038")(require("b573c5128b0191bb").resolve("fsBnZ"))
]).then(()=>module.bundle.root('3powT'));

},{"51ed41442ea69038":"hpx0h","b573c5128b0191bb":"fyJL2"}],"7wbjD":[function(require,module,exports,__globalThis) {
module.exports = require("f1f352c113585040")(require("f8a5d4a368e7baf0").resolve("cBSd4")).then(()=>module.bundle.root('jV81X'));

},{"f1f352c113585040":"hpx0h","f8a5d4a368e7baf0":"fyJL2"}],"6glxD":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("4ynOl")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("F0jhH")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("didjk")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("GmIEL")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("2eZaA")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("6VRsE")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("fjfdE")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("6uHCl")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("dUnev")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("iSndf")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("hodz5")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("18aVi")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("lQrcL")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("50WiO")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("cEEh7")),
    require("f053cdfe825069ae")(require("64bb96abacf83f70").resolve("pmXJl"))
]).then(()=>module.bundle.root('cmhmj'));

},{"f053cdfe825069ae":"hpx0h","64bb96abacf83f70":"fyJL2"}],"39yEE":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("4ynOl")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("didjk")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("GmIEL")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("2eZaA")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("6VRsE")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("fjfdE")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("6uHCl")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("dUnev")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("hodz5")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("18aVi")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("lQrcL")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("50WiO")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("cEEh7")),
    require("89201bbac4565b4c")(require("482beb38d52e21f4").resolve("bjkIv"))
]).then(()=>module.bundle.root('ft82J'));

},{"89201bbac4565b4c":"hpx0h","482beb38d52e21f4":"fyJL2"}],"cdlgV":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("4ynOl")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("didjk")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("GmIEL")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("2eZaA")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("6VRsE")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("fjfdE")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("6uHCl")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("dUnev")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("hodz5")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("18aVi")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("lQrcL")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("50WiO")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("cEEh7")),
    require("11fc7ee016967c4f")(require("a2715658318c4125").resolve("Hqz3K"))
]).then(()=>module.bundle.root('lC20q'));

},{"11fc7ee016967c4f":"hpx0h","a2715658318c4125":"fyJL2"}],"f7Rg5":[function(require,module,exports,__globalThis) {
module.exports = require("ab58e1f191d9dce2")(require("91296aa4d1cdc3cd").resolve("KfX98")).then(()=>module.bundle.root('dD5P4'));

},{"ab58e1f191d9dce2":"hpx0h","91296aa4d1cdc3cd":"fyJL2"}],"3QSzp":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("5e728f8ef15a4267")(require("ce63c353addd396c").resolve("zaTzk")),
    require("5e728f8ef15a4267")(require("ce63c353addd396c").resolve("evLCa")),
    require("5e728f8ef15a4267")(require("ce63c353addd396c").resolve("dMTnK"))
]).then(()=>module.bundle.root('2JRY7'));

},{"5e728f8ef15a4267":"hpx0h","ce63c353addd396c":"fyJL2"}],"hRziw":[function(require,module,exports,__globalThis) {
module.exports = require("17b572ce6f860aa8")(require("4d2d4af3e8eca35b").resolve("7dgdp")).then(()=>module.bundle.root('898n8'));

},{"17b572ce6f860aa8":"hpx0h","4d2d4af3e8eca35b":"fyJL2"}],"j7VaE":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("didjk")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("GmIEL")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("2eZaA")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("6VRsE")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("2NikL")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("dUnev")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("2or5O")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("1Lhnr")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("hodz5")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("18aVi")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("lQrcL")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("fjfdE")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("6uHCl")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("4cLhF")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("50WiO")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("cEEh7")),
    require("5c8617f0ccf7c84f")(require("775415632aff3cae").resolve("27bOy"))
]).then(()=>module.bundle.root('hW2Hg'));

},{"5c8617f0ccf7c84f":"hpx0h","775415632aff3cae":"fyJL2"}],"lpBtb":[function(require,module,exports,__globalThis) {
module.exports = require("e66b5c241afac83a")(require("fe2838ffbbdd3b85").resolve("fSNkU")).then(()=>module.bundle.root('gz2rA'));

},{"e66b5c241afac83a":"hpx0h","fe2838ffbbdd3b85":"fyJL2"}],"jJv2E":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("ef0137c70a609e4b")(require("59b7220022139669").resolve("7y3t5")),
    require("ef0137c70a609e4b")(require("59b7220022139669").resolve("GmIEL")),
    require("ef0137c70a609e4b")(require("59b7220022139669").resolve("50WiO")),
    require("ef0137c70a609e4b")(require("59b7220022139669").resolve("bFWwa")),
    require("ef0137c70a609e4b")(require("59b7220022139669").resolve("bF1S6")),
    require("ef0137c70a609e4b")(require("59b7220022139669").resolve("cEEh7")),
    require("ef0137c70a609e4b")(require("59b7220022139669").resolve("zaTzk")),
    require("ef0137c70a609e4b")(require("59b7220022139669").resolve("49DXe"))
]).then(()=>module.bundle.root('cev31'));

},{"ef0137c70a609e4b":"hpx0h","59b7220022139669":"fyJL2"}],"kBEv9":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("3QmJp")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("iSndf")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("hodz5")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("hMhuS")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("hRdS6")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("1Fc9F")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("lQrcL")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("19Acq")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("50WiO")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("cEEh7")),
    require("6b6ee4635ff2245c")(require("1718ee497c32ffd5").resolve("faTDX"))
]).then(()=>module.bundle.root('cp9nU'));

},{"6b6ee4635ff2245c":"hpx0h","1718ee497c32ffd5":"fyJL2"}],"dYtgX":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("3QmJp")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("fXz9C")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("2eZaA")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("iSndf")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("hodz5")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("hMhuS")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("hRdS6")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("1Fc9F")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("lQrcL")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("cEEh7")),
    require("406ca9344c9a5eaf")(require("3e052ba8572a8749").resolve("fl9uQ"))
]).then(()=>module.bundle.root('7MXdY'));

},{"406ca9344c9a5eaf":"hpx0h","3e052ba8572a8749":"fyJL2"}],"i7G8q":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("94bcb970d4ef61d7")(require("8287aa217af23d66").resolve("iSndf")),
    require("94bcb970d4ef61d7")(require("8287aa217af23d66").resolve("hodz5")),
    require("94bcb970d4ef61d7")(require("8287aa217af23d66").resolve("hMhuS")),
    require("94bcb970d4ef61d7")(require("8287aa217af23d66").resolve("hRdS6")),
    require("94bcb970d4ef61d7")(require("8287aa217af23d66").resolve("lQrcL")),
    require("94bcb970d4ef61d7")(require("8287aa217af23d66").resolve("cEEh7")),
    require("94bcb970d4ef61d7")(require("8287aa217af23d66").resolve("h361M"))
]).then(()=>module.bundle.root('eFE1d'));

},{"94bcb970d4ef61d7":"hpx0h","8287aa217af23d66":"fyJL2"}],"j3pva":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("145dc4e6fc843d4a")(require("f4d36caa7a72da7b").resolve("iSndf")),
    require("145dc4e6fc843d4a")(require("f4d36caa7a72da7b").resolve("hodz5")),
    require("145dc4e6fc843d4a")(require("f4d36caa7a72da7b").resolve("hMhuS")),
    require("145dc4e6fc843d4a")(require("f4d36caa7a72da7b").resolve("hRdS6")),
    require("145dc4e6fc843d4a")(require("f4d36caa7a72da7b").resolve("lQrcL")),
    require("145dc4e6fc843d4a")(require("f4d36caa7a72da7b").resolve("cEEh7")),
    require("145dc4e6fc843d4a")(require("f4d36caa7a72da7b").resolve("9nHCs"))
]).then(()=>module.bundle.root('5waYk'));

},{"145dc4e6fc843d4a":"hpx0h","f4d36caa7a72da7b":"fyJL2"}],"lAUi4":[function(require,module,exports,__globalThis) {
module.exports = require("33c033523ce3085a")(require("e180663d22e25846").resolve("cIYTI")).then(()=>module.bundle.root('6cTWS'));

},{"33c033523ce3085a":"hpx0h","e180663d22e25846":"fyJL2"}],"dH7w8":[function(require,module,exports,__globalThis) {
/**
 * Presses on a drawer/modal scrim must dismiss it and must not fall through
 * to the page once the scrim unmounts (the delayed "ghost click").
 *
 * Installed once. Existing scrims keep their own onClick close handlers;
 * this cancels the pointer and replays a click on the scrim only.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** True when this node is the dimmed (or full-screen empty) layer behind a panel. */ parcelHelpers.export(exports, "isOverlayDismissScrim", ()=>isOverlayDismissScrim);
parcelHelpers.export(exports, "installOverlayDismissGuard", ()=>installOverlayDismissGuard);
function backgroundAlpha(color) {
    const match = color.match(/rgba?\(\s*[\d.]+\s*,\s*[\d.]+\s*,\s*[\d.]+\s*(?:,\s*([\d.]+)\s*)?\)/);
    if (!match) return color === "transparent" ? 0 : 1;
    if (match[1] == null) return 1;
    const alpha = Number(match[1]);
    return Number.isFinite(alpha) ? alpha : 1;
}
function isOverlayDismissScrim(el) {
    if (el.getAttribute("data-c8-overlay-dismiss") === "true") return true;
    if (el.classList.contains("ReactModal__Overlay")) return true;
    if (el.getAttribute("role") === "dialog" || el.getAttribute("aria-modal") === "true") return false;
    const style = window.getComputedStyle(el);
    if (style.pointerEvents === "none" || style.display === "none" || style.visibility === "hidden") return false;
    if (style.position !== "fixed" && style.position !== "absolute") return false;
    const rect = el.getBoundingClientRect();
    if (rect.width < window.innerWidth * 0.85) return false;
    if (rect.height < window.innerHeight * 0.35) return false;
    const alpha = backgroundAlpha(style.backgroundColor);
    const translucentScrim = alpha > 0.04 && alpha < 0.96;
    const emptyCatcher = el.childElementCount === 0 && !(el.textContent || "").trim();
    const z = Number.parseInt(style.zIndex, 10);
    const elevated = Number.isFinite(z) && z >= 1000;
    if (translucentScrim && (elevated || el.childElementCount === 0)) return true;
    if (emptyCatcher && elevated) return true;
    return false;
}
function installOverlayDismissGuard() {
    if (typeof document === "undefined") return;
    const doc = document;
    if (doc.__c8OverlayDismissGuard) return;
    doc.__c8OverlayDismissGuard = true;
    document.addEventListener("pointerdown", (event)=>{
        if (event.button !== 0) return;
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (!isOverlayDismissScrim(target)) return;
        event.preventDefault();
        event.stopPropagation();
        if (target instanceof HTMLElement) target.click();
    }, true);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gJOPk":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("didjk")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("GmIEL")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("2eZaA")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("6VRsE")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("2NikL")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("dUnev")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("iSndf")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("2or5O")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("1Lhnr")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("hodz5")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("hMhuS")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("hRdS6")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("18aVi")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("1Fc9F")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("lQrcL")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("19Acq")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("fjfdE")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("6uHCl")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("4cLhF")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("50WiO")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("cEEh7")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("6ekQ7")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("4xsNa")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("IlTi6")),
    require("384945f279ce8ed1")(require("6fe6030bbcf19bf2").resolve("2yTRz"))
]).then(()=>module.bundle.root('j9WOY'));

},{"384945f279ce8ed1":"hpx0h","6fe6030bbcf19bf2":"fyJL2"}]},["e9qDg","4zTVb"], "4zTVb", "parcelRequire94c2")

//# sourceMappingURL=index.eb157454.js.map
